import { r as yd, j as En } from "./jsx-runtime-3tyXYecC.mjs";
import rf, { useRef as Yi, useEffect as of, useState as sf } from "react";
import { l as df } from "./lodash-5ofSKtz3.mjs";
import { P as uf } from "./popover-DAJRG9vG.mjs";
import { m as ff, u as lf } from "./tss-DN0acMKN.mjs";
import { L as cf, r as mf, i as kd, aa as vf, q as hf, b as At, h as gf, o as pf, d as Ce, D as wd, y as bf, A as _d, g as $d, B as yf, p as Pd, O as kf, f as Vt, k as Ht } from "./keys-CQjWNUL0.mjs";
import { i as bn } from "./correct-is-regexp-logic-DUuS52mu.mjs";
import { n as wf, W as _f, a as $f, A as Pf, l as Mf, c as Md, g as jf, i as jd, L as Sf, e as zf } from "./_arrayPush-DUvcoEi5.mjs";
import { a as te, c as w } from "./_commonjsHelpers-BkfeUUK-.mjs";
import { h as Of, f as Wf, g as Df, d as Ut } from "./compact-CN4wKJco.mjs";
import { M as Cf, g as If, N as Tf, O as Sd, P as Nf, Q as xf, t as Ff, R as Ef, B as Rf, C as Lf, z as qf, S as Zf, T as zd } from "./index-isgVnOkQ.mjs";
import { r as Af, a as Vf, b as Hf, c as Uf, d as Bf, u as Xf } from "./index-DFOMnLtx.mjs";
import { r as Od, i as I, j as $, k as le, l as P, t as Vn, m as Ne, n as Gf, o as Kf, p as Yf, q as Jf, s as Hn, u as Cn, v as In, w as Tn, x as Wd, y as Qf, z as Dd, A as Cd, b as It, g as el, f as nl, e as il, h as al, c as tl, a as rl, d as ol } from "./index-jSUZvN72.mjs";
import { s as sl } from "./index-DDl_rLOB.mjs";
import { h as Id } from "./index-Dj1VNACs.mjs";
import { a as dl } from "./index-DH8DM7A9.mjs";
import { I as ul } from "./icon-button-BxDvkq_l.mjs";
const fl = [
  {
    id: "people",
    emojis: [
      "grinning",
      "smiley",
      "smile",
      "grin",
      "laughing",
      "sweat_smile",
      "rolling_on_the_floor_laughing",
      "joy",
      "slightly_smiling_face",
      "upside_down_face",
      "melting_face",
      "wink",
      "blush",
      "innocent",
      "smiling_face_with_3_hearts",
      "heart_eyes",
      "star-struck",
      "kissing_heart",
      "kissing",
      "relaxed",
      "kissing_closed_eyes",
      "kissing_smiling_eyes",
      "smiling_face_with_tear",
      "yum",
      "stuck_out_tongue",
      "stuck_out_tongue_winking_eye",
      "zany_face",
      "stuck_out_tongue_closed_eyes",
      "money_mouth_face",
      "hugging_face",
      "face_with_hand_over_mouth",
      "face_with_open_eyes_and_hand_over_mouth",
      "face_with_peeking_eye",
      "shushing_face",
      "thinking_face",
      "saluting_face",
      "zipper_mouth_face",
      "face_with_raised_eyebrow",
      "neutral_face",
      "expressionless",
      "no_mouth",
      "dotted_line_face",
      "face_in_clouds",
      "smirk",
      "unamused",
      "face_with_rolling_eyes",
      "grimacing",
      "face_exhaling",
      "lying_face",
      "shaking_face",
      "relieved",
      "pensive",
      "sleepy",
      "drooling_face",
      "sleeping",
      "mask",
      "face_with_thermometer",
      "face_with_head_bandage",
      "nauseated_face",
      "face_vomiting",
      "sneezing_face",
      "hot_face",
      "cold_face",
      "woozy_face",
      "dizzy_face",
      "face_with_spiral_eyes",
      "exploding_head",
      "face_with_cowboy_hat",
      "partying_face",
      "disguised_face",
      "sunglasses",
      "nerd_face",
      "face_with_monocle",
      "confused",
      "face_with_diagonal_mouth",
      "worried",
      "slightly_frowning_face",
      "white_frowning_face",
      "open_mouth",
      "hushed",
      "astonished",
      "flushed",
      "pleading_face",
      "face_holding_back_tears",
      "frowning",
      "anguished",
      "fearful",
      "cold_sweat",
      "disappointed_relieved",
      "cry",
      "sob",
      "scream",
      "confounded",
      "persevere",
      "disappointed",
      "sweat",
      "weary",
      "tired_face",
      "yawning_face",
      "triumph",
      "rage",
      "angry",
      "face_with_symbols_on_mouth",
      "smiling_imp",
      "imp",
      "skull",
      "skull_and_crossbones",
      "hankey",
      "clown_face",
      "japanese_ogre",
      "japanese_goblin",
      "ghost",
      "alien",
      "space_invader",
      "wave",
      "raised_back_of_hand",
      "raised_hand_with_fingers_splayed",
      "hand",
      "spock-hand",
      "rightwards_hand",
      "leftwards_hand",
      "palm_down_hand",
      "palm_up_hand",
      "leftwards_pushing_hand",
      "rightwards_pushing_hand",
      "ok_hand",
      "pinched_fingers",
      "pinching_hand",
      "v",
      "crossed_fingers",
      "hand_with_index_finger_and_thumb_crossed",
      "i_love_you_hand_sign",
      "the_horns",
      "call_me_hand",
      "point_left",
      "point_right",
      "point_up_2",
      "middle_finger",
      "point_down",
      "point_up",
      "index_pointing_at_the_viewer",
      "+1",
      "-1",
      "fist",
      "facepunch",
      "left-facing_fist",
      "right-facing_fist",
      "clap",
      "raised_hands",
      "heart_hands",
      "open_hands",
      "palms_up_together",
      "handshake",
      "pray",
      "writing_hand",
      "nail_care",
      "selfie",
      "muscle",
      "mechanical_arm",
      "mechanical_leg",
      "leg",
      "foot",
      "ear",
      "ear_with_hearing_aid",
      "nose",
      "brain",
      "anatomical_heart",
      "lungs",
      "tooth",
      "bone",
      "eyes",
      "eye",
      "tongue",
      "lips",
      "biting_lip",
      "baby",
      "child",
      "boy",
      "girl",
      "adult",
      "person_with_blond_hair",
      "man",
      "bearded_person",
      "man_with_beard",
      "woman_with_beard",
      "red_haired_man",
      "curly_haired_man",
      "white_haired_man",
      "bald_man",
      "woman",
      "red_haired_woman",
      "red_haired_person",
      "curly_haired_woman",
      "curly_haired_person",
      "white_haired_woman",
      "white_haired_person",
      "bald_woman",
      "bald_person",
      "blond-haired-woman",
      "blond-haired-man",
      "older_adult",
      "older_man",
      "older_woman",
      "person_frowning",
      "man-frowning",
      "woman-frowning",
      "person_with_pouting_face",
      "man-pouting",
      "woman-pouting",
      "no_good",
      "man-gesturing-no",
      "woman-gesturing-no",
      "ok_woman",
      "man-gesturing-ok",
      "woman-gesturing-ok",
      "information_desk_person",
      "man-tipping-hand",
      "woman-tipping-hand",
      "raising_hand",
      "man-raising-hand",
      "woman-raising-hand",
      "deaf_person",
      "deaf_man",
      "deaf_woman",
      "bow",
      "man-bowing",
      "woman-bowing",
      "face_palm",
      "man-facepalming",
      "woman-facepalming",
      "shrug",
      "man-shrugging",
      "woman-shrugging",
      "health_worker",
      "male-doctor",
      "female-doctor",
      "student",
      "male-student",
      "female-student",
      "teacher",
      "male-teacher",
      "female-teacher",
      "judge",
      "male-judge",
      "female-judge",
      "farmer",
      "male-farmer",
      "female-farmer",
      "cook",
      "male-cook",
      "female-cook",
      "mechanic",
      "male-mechanic",
      "female-mechanic",
      "factory_worker",
      "male-factory-worker",
      "female-factory-worker",
      "office_worker",
      "male-office-worker",
      "female-office-worker",
      "scientist",
      "male-scientist",
      "female-scientist",
      "technologist",
      "male-technologist",
      "female-technologist",
      "singer",
      "male-singer",
      "female-singer",
      "artist",
      "male-artist",
      "female-artist",
      "pilot",
      "male-pilot",
      "female-pilot",
      "astronaut",
      "male-astronaut",
      "female-astronaut",
      "firefighter",
      "male-firefighter",
      "female-firefighter",
      "cop",
      "male-police-officer",
      "female-police-officer",
      "sleuth_or_spy",
      "male-detective",
      "female-detective",
      "guardsman",
      "male-guard",
      "female-guard",
      "ninja",
      "construction_worker",
      "male-construction-worker",
      "female-construction-worker",
      "person_with_crown",
      "prince",
      "princess",
      "man_with_turban",
      "man-wearing-turban",
      "woman-wearing-turban",
      "man_with_gua_pi_mao",
      "person_with_headscarf",
      "person_in_tuxedo",
      "man_in_tuxedo",
      "woman_in_tuxedo",
      "bride_with_veil",
      "man_with_veil",
      "woman_with_veil",
      "pregnant_woman",
      "pregnant_man",
      "pregnant_person",
      "breast-feeding",
      "woman_feeding_baby",
      "man_feeding_baby",
      "person_feeding_baby",
      "angel",
      "santa",
      "mrs_claus",
      "mx_claus",
      "superhero",
      "male_superhero",
      "female_superhero",
      "supervillain",
      "male_supervillain",
      "female_supervillain",
      "mage",
      "male_mage",
      "female_mage",
      "fairy",
      "male_fairy",
      "female_fairy",
      "vampire",
      "male_vampire",
      "female_vampire",
      "merperson",
      "merman",
      "mermaid",
      "elf",
      "male_elf",
      "female_elf",
      "genie",
      "male_genie",
      "female_genie",
      "zombie",
      "male_zombie",
      "female_zombie",
      "troll",
      "massage",
      "man-getting-massage",
      "woman-getting-massage",
      "haircut",
      "man-getting-haircut",
      "woman-getting-haircut",
      "walking",
      "man-walking",
      "woman-walking",
      "standing_person",
      "man_standing",
      "woman_standing",
      "kneeling_person",
      "man_kneeling",
      "woman_kneeling",
      "person_with_probing_cane",
      "man_with_probing_cane",
      "woman_with_probing_cane",
      "person_in_motorized_wheelchair",
      "man_in_motorized_wheelchair",
      "woman_in_motorized_wheelchair",
      "person_in_manual_wheelchair",
      "man_in_manual_wheelchair",
      "woman_in_manual_wheelchair",
      "runner",
      "man-running",
      "woman-running",
      "dancer",
      "man_dancing",
      "man_in_business_suit_levitating",
      "dancers",
      "men-with-bunny-ears-partying",
      "women-with-bunny-ears-partying",
      "person_in_steamy_room",
      "man_in_steamy_room",
      "woman_in_steamy_room",
      "person_climbing",
      "man_climbing",
      "woman_climbing",
      "fencer",
      "horse_racing",
      "skier",
      "snowboarder",
      "golfer",
      "man-golfing",
      "woman-golfing",
      "surfer",
      "man-surfing",
      "woman-surfing",
      "rowboat",
      "man-rowing-boat",
      "woman-rowing-boat",
      "swimmer",
      "man-swimming",
      "woman-swimming",
      "person_with_ball",
      "man-bouncing-ball",
      "woman-bouncing-ball",
      "weight_lifter",
      "man-lifting-weights",
      "woman-lifting-weights",
      "bicyclist",
      "man-biking",
      "woman-biking",
      "mountain_bicyclist",
      "man-mountain-biking",
      "woman-mountain-biking",
      "person_doing_cartwheel",
      "man-cartwheeling",
      "woman-cartwheeling",
      "wrestlers",
      "man-wrestling",
      "woman-wrestling",
      "water_polo",
      "man-playing-water-polo",
      "woman-playing-water-polo",
      "handball",
      "man-playing-handball",
      "woman-playing-handball",
      "juggling",
      "man-juggling",
      "woman-juggling",
      "person_in_lotus_position",
      "man_in_lotus_position",
      "woman_in_lotus_position",
      "bath",
      "sleeping_accommodation",
      "people_holding_hands",
      "two_women_holding_hands",
      "man_and_woman_holding_hands",
      "two_men_holding_hands",
      "couplekiss",
      "woman-kiss-man",
      "man-kiss-man",
      "woman-kiss-woman",
      "couple_with_heart",
      "woman-heart-man",
      "man-heart-man",
      "woman-heart-woman",
      "family",
      "man-woman-boy",
      "man-woman-girl",
      "man-woman-girl-boy",
      "man-woman-boy-boy",
      "man-woman-girl-girl",
      "man-man-boy",
      "man-man-girl",
      "man-man-girl-boy",
      "man-man-boy-boy",
      "man-man-girl-girl",
      "woman-woman-boy",
      "woman-woman-girl",
      "woman-woman-girl-boy",
      "woman-woman-boy-boy",
      "woman-woman-girl-girl",
      "man-boy",
      "man-boy-boy",
      "man-girl",
      "man-girl-boy",
      "man-girl-girl",
      "woman-boy",
      "woman-boy-boy",
      "woman-girl",
      "woman-girl-boy",
      "woman-girl-girl",
      "speaking_head_in_silhouette",
      "bust_in_silhouette",
      "busts_in_silhouette",
      "people_hugging",
      "footprints",
      "robot_face",
      "smiley_cat",
      "smile_cat",
      "joy_cat",
      "heart_eyes_cat",
      "smirk_cat",
      "kissing_cat",
      "scream_cat",
      "crying_cat_face",
      "pouting_cat",
      "see_no_evil",
      "hear_no_evil",
      "speak_no_evil",
      "love_letter",
      "cupid",
      "gift_heart",
      "sparkling_heart",
      "heartpulse",
      "heartbeat",
      "revolving_hearts",
      "two_hearts",
      "heart_decoration",
      "heavy_heart_exclamation_mark_ornament",
      "broken_heart",
      "heart_on_fire",
      "mending_heart",
      "heart",
      "pink_heart",
      "orange_heart",
      "yellow_heart",
      "green_heart",
      "blue_heart",
      "light_blue_heart",
      "purple_heart",
      "brown_heart",
      "black_heart",
      "grey_heart",
      "white_heart",
      "kiss",
      "100",
      "anger",
      "boom",
      "dizzy",
      "sweat_drops",
      "dash",
      "hole",
      "speech_balloon",
      "eye-in-speech-bubble",
      "left_speech_bubble",
      "right_anger_bubble",
      "thought_balloon",
      "zzz"
    ]
  },
  {
    id: "nature",
    emojis: [
      "monkey_face",
      "monkey",
      "gorilla",
      "orangutan",
      "dog",
      "dog2",
      "guide_dog",
      "service_dog",
      "poodle",
      "wolf",
      "fox_face",
      "raccoon",
      "cat",
      "cat2",
      "black_cat",
      "lion_face",
      "tiger",
      "tiger2",
      "leopard",
      "horse",
      "moose",
      "donkey",
      "racehorse",
      "unicorn_face",
      "zebra_face",
      "deer",
      "bison",
      "cow",
      "ox",
      "water_buffalo",
      "cow2",
      "pig",
      "pig2",
      "boar",
      "pig_nose",
      "ram",
      "sheep",
      "goat",
      "dromedary_camel",
      "camel",
      "llama",
      "giraffe_face",
      "elephant",
      "mammoth",
      "rhinoceros",
      "hippopotamus",
      "mouse",
      "mouse2",
      "rat",
      "hamster",
      "rabbit",
      "rabbit2",
      "chipmunk",
      "beaver",
      "hedgehog",
      "bat",
      "bear",
      "polar_bear",
      "koala",
      "panda_face",
      "sloth",
      "otter",
      "skunk",
      "kangaroo",
      "badger",
      "feet",
      "turkey",
      "chicken",
      "rooster",
      "hatching_chick",
      "baby_chick",
      "hatched_chick",
      "bird",
      "penguin",
      "dove_of_peace",
      "eagle",
      "duck",
      "swan",
      "owl",
      "dodo",
      "feather",
      "flamingo",
      "peacock",
      "parrot",
      "wing",
      "black_bird",
      "goose",
      "frog",
      "crocodile",
      "turtle",
      "lizard",
      "snake",
      "dragon_face",
      "dragon",
      "sauropod",
      "t-rex",
      "whale",
      "whale2",
      "dolphin",
      "seal",
      "fish",
      "tropical_fish",
      "blowfish",
      "shark",
      "octopus",
      "shell",
      "coral",
      "jellyfish",
      "snail",
      "butterfly",
      "bug",
      "ant",
      "bee",
      "beetle",
      "ladybug",
      "cricket",
      "cockroach",
      "spider",
      "spider_web",
      "scorpion",
      "mosquito",
      "fly",
      "worm",
      "microbe",
      "bouquet",
      "cherry_blossom",
      "white_flower",
      "lotus",
      "rosette",
      "rose",
      "wilted_flower",
      "hibiscus",
      "sunflower",
      "blossom",
      "tulip",
      "hyacinth",
      "seedling",
      "potted_plant",
      "evergreen_tree",
      "deciduous_tree",
      "palm_tree",
      "cactus",
      "ear_of_rice",
      "herb",
      "shamrock",
      "four_leaf_clover",
      "maple_leaf",
      "fallen_leaf",
      "leaves",
      "empty_nest",
      "nest_with_eggs",
      "mushroom"
    ]
  },
  {
    id: "foods",
    emojis: [
      "grapes",
      "melon",
      "watermelon",
      "tangerine",
      "lemon",
      "banana",
      "pineapple",
      "mango",
      "apple",
      "green_apple",
      "pear",
      "peach",
      "cherries",
      "strawberry",
      "blueberries",
      "kiwifruit",
      "tomato",
      "olive",
      "coconut",
      "avocado",
      "eggplant",
      "potato",
      "carrot",
      "corn",
      "hot_pepper",
      "bell_pepper",
      "cucumber",
      "leafy_green",
      "broccoli",
      "garlic",
      "onion",
      "peanuts",
      "beans",
      "chestnut",
      "ginger_root",
      "pea_pod",
      "bread",
      "croissant",
      "baguette_bread",
      "flatbread",
      "pretzel",
      "bagel",
      "pancakes",
      "waffle",
      "cheese_wedge",
      "meat_on_bone",
      "poultry_leg",
      "cut_of_meat",
      "bacon",
      "hamburger",
      "fries",
      "pizza",
      "hotdog",
      "sandwich",
      "taco",
      "burrito",
      "tamale",
      "stuffed_flatbread",
      "falafel",
      "egg",
      "fried_egg",
      "shallow_pan_of_food",
      "stew",
      "fondue",
      "bowl_with_spoon",
      "green_salad",
      "popcorn",
      "butter",
      "salt",
      "canned_food",
      "bento",
      "rice_cracker",
      "rice_ball",
      "rice",
      "curry",
      "ramen",
      "spaghetti",
      "sweet_potato",
      "oden",
      "sushi",
      "fried_shrimp",
      "fish_cake",
      "moon_cake",
      "dango",
      "dumpling",
      "fortune_cookie",
      "takeout_box",
      "crab",
      "lobster",
      "shrimp",
      "squid",
      "oyster",
      "icecream",
      "shaved_ice",
      "ice_cream",
      "doughnut",
      "cookie",
      "birthday",
      "cake",
      "cupcake",
      "pie",
      "chocolate_bar",
      "candy",
      "lollipop",
      "custard",
      "honey_pot",
      "baby_bottle",
      "glass_of_milk",
      "coffee",
      "teapot",
      "tea",
      "sake",
      "champagne",
      "wine_glass",
      "cocktail",
      "tropical_drink",
      "beer",
      "beers",
      "clinking_glasses",
      "tumbler_glass",
      "pouring_liquid",
      "cup_with_straw",
      "bubble_tea",
      "beverage_box",
      "mate_drink",
      "ice_cube",
      "chopsticks",
      "knife_fork_plate",
      "fork_and_knife",
      "spoon",
      "hocho",
      "jar",
      "amphora"
    ]
  },
  {
    id: "activity",
    emojis: [
      "jack_o_lantern",
      "christmas_tree",
      "fireworks",
      "sparkler",
      "firecracker",
      "sparkles",
      "balloon",
      "tada",
      "confetti_ball",
      "tanabata_tree",
      "bamboo",
      "dolls",
      "flags",
      "wind_chime",
      "rice_scene",
      "red_envelope",
      "ribbon",
      "gift",
      "reminder_ribbon",
      "admission_tickets",
      "ticket",
      "medal",
      "trophy",
      "sports_medal",
      "first_place_medal",
      "second_place_medal",
      "third_place_medal",
      "soccer",
      "baseball",
      "softball",
      "basketball",
      "volleyball",
      "football",
      "rugby_football",
      "tennis",
      "flying_disc",
      "bowling",
      "cricket_bat_and_ball",
      "field_hockey_stick_and_ball",
      "ice_hockey_stick_and_puck",
      "lacrosse",
      "table_tennis_paddle_and_ball",
      "badminton_racquet_and_shuttlecock",
      "boxing_glove",
      "martial_arts_uniform",
      "goal_net",
      "golf",
      "ice_skate",
      "fishing_pole_and_fish",
      "diving_mask",
      "running_shirt_with_sash",
      "ski",
      "sled",
      "curling_stone",
      "dart",
      "yo-yo",
      "kite",
      "gun",
      "8ball",
      "crystal_ball",
      "magic_wand",
      "video_game",
      "joystick",
      "slot_machine",
      "game_die",
      "jigsaw",
      "teddy_bear",
      "pinata",
      "mirror_ball",
      "nesting_dolls",
      "spades",
      "hearts",
      "diamonds",
      "clubs",
      "chess_pawn",
      "black_joker",
      "mahjong",
      "flower_playing_cards",
      "performing_arts",
      "frame_with_picture",
      "art",
      "thread",
      "sewing_needle",
      "yarn",
      "knot"
    ]
  },
  {
    id: "places",
    emojis: [
      "earth_africa",
      "earth_americas",
      "earth_asia",
      "globe_with_meridians",
      "world_map",
      "japan",
      "compass",
      "snow_capped_mountain",
      "mountain",
      "volcano",
      "mount_fuji",
      "camping",
      "beach_with_umbrella",
      "desert",
      "desert_island",
      "national_park",
      "stadium",
      "classical_building",
      "building_construction",
      "bricks",
      "rock",
      "wood",
      "hut",
      "house_buildings",
      "derelict_house_building",
      "house",
      "house_with_garden",
      "office",
      "post_office",
      "european_post_office",
      "hospital",
      "bank",
      "hotel",
      "love_hotel",
      "convenience_store",
      "school",
      "department_store",
      "factory",
      "japanese_castle",
      "european_castle",
      "wedding",
      "tokyo_tower",
      "statue_of_liberty",
      "church",
      "mosque",
      "hindu_temple",
      "synagogue",
      "shinto_shrine",
      "kaaba",
      "fountain",
      "tent",
      "foggy",
      "night_with_stars",
      "cityscape",
      "sunrise_over_mountains",
      "sunrise",
      "city_sunset",
      "city_sunrise",
      "bridge_at_night",
      "hotsprings",
      "carousel_horse",
      "playground_slide",
      "ferris_wheel",
      "roller_coaster",
      "barber",
      "circus_tent",
      "steam_locomotive",
      "railway_car",
      "bullettrain_side",
      "bullettrain_front",
      "train2",
      "metro",
      "light_rail",
      "station",
      "tram",
      "monorail",
      "mountain_railway",
      "train",
      "bus",
      "oncoming_bus",
      "trolleybus",
      "minibus",
      "ambulance",
      "fire_engine",
      "police_car",
      "oncoming_police_car",
      "taxi",
      "oncoming_taxi",
      "car",
      "oncoming_automobile",
      "blue_car",
      "pickup_truck",
      "truck",
      "articulated_lorry",
      "tractor",
      "racing_car",
      "racing_motorcycle",
      "motor_scooter",
      "manual_wheelchair",
      "motorized_wheelchair",
      "auto_rickshaw",
      "bike",
      "scooter",
      "skateboard",
      "roller_skate",
      "busstop",
      "motorway",
      "railway_track",
      "oil_drum",
      "fuelpump",
      "wheel",
      "rotating_light",
      "traffic_light",
      "vertical_traffic_light",
      "octagonal_sign",
      "construction",
      "anchor",
      "ring_buoy",
      "boat",
      "canoe",
      "speedboat",
      "passenger_ship",
      "ferry",
      "motor_boat",
      "ship",
      "airplane",
      "small_airplane",
      "airplane_departure",
      "airplane_arriving",
      "parachute",
      "seat",
      "helicopter",
      "suspension_railway",
      "mountain_cableway",
      "aerial_tramway",
      "satellite",
      "rocket",
      "flying_saucer",
      "bellhop_bell",
      "luggage",
      "hourglass",
      "hourglass_flowing_sand",
      "watch",
      "alarm_clock",
      "stopwatch",
      "timer_clock",
      "mantelpiece_clock",
      "clock12",
      "clock1230",
      "clock1",
      "clock130",
      "clock2",
      "clock230",
      "clock3",
      "clock330",
      "clock4",
      "clock430",
      "clock5",
      "clock530",
      "clock6",
      "clock630",
      "clock7",
      "clock730",
      "clock8",
      "clock830",
      "clock9",
      "clock930",
      "clock10",
      "clock1030",
      "clock11",
      "clock1130",
      "new_moon",
      "waxing_crescent_moon",
      "first_quarter_moon",
      "moon",
      "full_moon",
      "waning_gibbous_moon",
      "last_quarter_moon",
      "waning_crescent_moon",
      "crescent_moon",
      "new_moon_with_face",
      "first_quarter_moon_with_face",
      "last_quarter_moon_with_face",
      "thermometer",
      "sunny",
      "full_moon_with_face",
      "sun_with_face",
      "ringed_planet",
      "star",
      "star2",
      "stars",
      "milky_way",
      "cloud",
      "partly_sunny",
      "thunder_cloud_and_rain",
      "mostly_sunny",
      "barely_sunny",
      "partly_sunny_rain",
      "rain_cloud",
      "snow_cloud",
      "lightning",
      "tornado",
      "fog",
      "wind_blowing_face",
      "cyclone",
      "rainbow",
      "closed_umbrella",
      "umbrella",
      "umbrella_with_rain_drops",
      "umbrella_on_ground",
      "zap",
      "snowflake",
      "snowman",
      "snowman_without_snow",
      "comet",
      "fire",
      "droplet",
      "ocean"
    ]
  },
  {
    id: "objects",
    emojis: [
      "eyeglasses",
      "dark_sunglasses",
      "goggles",
      "lab_coat",
      "safety_vest",
      "necktie",
      "shirt",
      "jeans",
      "scarf",
      "gloves",
      "coat",
      "socks",
      "dress",
      "kimono",
      "sari",
      "one-piece_swimsuit",
      "briefs",
      "shorts",
      "bikini",
      "womans_clothes",
      "folding_hand_fan",
      "purse",
      "handbag",
      "pouch",
      "shopping_bags",
      "school_satchel",
      "thong_sandal",
      "mans_shoe",
      "athletic_shoe",
      "hiking_boot",
      "womans_flat_shoe",
      "high_heel",
      "sandal",
      "ballet_shoes",
      "boot",
      "hair_pick",
      "crown",
      "womans_hat",
      "tophat",
      "mortar_board",
      "billed_cap",
      "military_helmet",
      "helmet_with_white_cross",
      "prayer_beads",
      "lipstick",
      "ring",
      "gem",
      "mute",
      "speaker",
      "sound",
      "loud_sound",
      "loudspeaker",
      "mega",
      "postal_horn",
      "bell",
      "no_bell",
      "musical_score",
      "musical_note",
      "notes",
      "studio_microphone",
      "level_slider",
      "control_knobs",
      "microphone",
      "headphones",
      "radio",
      "saxophone",
      "accordion",
      "guitar",
      "musical_keyboard",
      "trumpet",
      "violin",
      "banjo",
      "drum_with_drumsticks",
      "long_drum",
      "maracas",
      "flute",
      "iphone",
      "calling",
      "phone",
      "telephone_receiver",
      "pager",
      "fax",
      "battery",
      "low_battery",
      "electric_plug",
      "computer",
      "desktop_computer",
      "printer",
      "keyboard",
      "three_button_mouse",
      "trackball",
      "minidisc",
      "floppy_disk",
      "cd",
      "dvd",
      "abacus",
      "movie_camera",
      "film_frames",
      "film_projector",
      "clapper",
      "tv",
      "camera",
      "camera_with_flash",
      "video_camera",
      "vhs",
      "mag",
      "mag_right",
      "candle",
      "bulb",
      "flashlight",
      "izakaya_lantern",
      "diya_lamp",
      "notebook_with_decorative_cover",
      "closed_book",
      "book",
      "green_book",
      "blue_book",
      "orange_book",
      "books",
      "notebook",
      "ledger",
      "page_with_curl",
      "scroll",
      "page_facing_up",
      "newspaper",
      "rolled_up_newspaper",
      "bookmark_tabs",
      "bookmark",
      "label",
      "moneybag",
      "coin",
      "yen",
      "dollar",
      "euro",
      "pound",
      "money_with_wings",
      "credit_card",
      "receipt",
      "chart",
      "email",
      "e-mail",
      "incoming_envelope",
      "envelope_with_arrow",
      "outbox_tray",
      "inbox_tray",
      "package",
      "mailbox",
      "mailbox_closed",
      "mailbox_with_mail",
      "mailbox_with_no_mail",
      "postbox",
      "ballot_box_with_ballot",
      "pencil2",
      "black_nib",
      "lower_left_fountain_pen",
      "lower_left_ballpoint_pen",
      "lower_left_paintbrush",
      "lower_left_crayon",
      "memo",
      "briefcase",
      "file_folder",
      "open_file_folder",
      "card_index_dividers",
      "date",
      "calendar",
      "spiral_note_pad",
      "spiral_calendar_pad",
      "card_index",
      "chart_with_upwards_trend",
      "chart_with_downwards_trend",
      "bar_chart",
      "clipboard",
      "pushpin",
      "round_pushpin",
      "paperclip",
      "linked_paperclips",
      "straight_ruler",
      "triangular_ruler",
      "scissors",
      "card_file_box",
      "file_cabinet",
      "wastebasket",
      "lock",
      "unlock",
      "lock_with_ink_pen",
      "closed_lock_with_key",
      "key",
      "old_key",
      "hammer",
      "axe",
      "pick",
      "hammer_and_pick",
      "hammer_and_wrench",
      "dagger_knife",
      "crossed_swords",
      "bomb",
      "boomerang",
      "bow_and_arrow",
      "shield",
      "carpentry_saw",
      "wrench",
      "screwdriver",
      "nut_and_bolt",
      "gear",
      "compression",
      "scales",
      "probing_cane",
      "link",
      "chains",
      "hook",
      "toolbox",
      "magnet",
      "ladder",
      "alembic",
      "test_tube",
      "petri_dish",
      "dna",
      "microscope",
      "telescope",
      "satellite_antenna",
      "syringe",
      "drop_of_blood",
      "pill",
      "adhesive_bandage",
      "crutch",
      "stethoscope",
      "x-ray",
      "door",
      "elevator",
      "mirror",
      "window",
      "bed",
      "couch_and_lamp",
      "chair",
      "toilet",
      "plunger",
      "shower",
      "bathtub",
      "mouse_trap",
      "razor",
      "lotion_bottle",
      "safety_pin",
      "broom",
      "basket",
      "roll_of_paper",
      "bucket",
      "soap",
      "bubbles",
      "toothbrush",
      "sponge",
      "fire_extinguisher",
      "shopping_trolley",
      "smoking",
      "coffin",
      "headstone",
      "funeral_urn",
      "nazar_amulet",
      "hamsa",
      "moyai",
      "placard",
      "identification_card"
    ]
  },
  {
    id: "symbols",
    emojis: [
      "atm",
      "put_litter_in_its_place",
      "potable_water",
      "wheelchair",
      "mens",
      "womens",
      "restroom",
      "baby_symbol",
      "wc",
      "passport_control",
      "customs",
      "baggage_claim",
      "left_luggage",
      "warning",
      "children_crossing",
      "no_entry",
      "no_entry_sign",
      "no_bicycles",
      "no_smoking",
      "do_not_litter",
      "non-potable_water",
      "no_pedestrians",
      "no_mobile_phones",
      "underage",
      "radioactive_sign",
      "biohazard_sign",
      "arrow_up",
      "arrow_upper_right",
      "arrow_right",
      "arrow_lower_right",
      "arrow_down",
      "arrow_lower_left",
      "arrow_left",
      "arrow_upper_left",
      "arrow_up_down",
      "left_right_arrow",
      "leftwards_arrow_with_hook",
      "arrow_right_hook",
      "arrow_heading_up",
      "arrow_heading_down",
      "arrows_clockwise",
      "arrows_counterclockwise",
      "back",
      "end",
      "on",
      "soon",
      "top",
      "place_of_worship",
      "atom_symbol",
      "om_symbol",
      "star_of_david",
      "wheel_of_dharma",
      "yin_yang",
      "latin_cross",
      "orthodox_cross",
      "star_and_crescent",
      "peace_symbol",
      "menorah_with_nine_branches",
      "six_pointed_star",
      "khanda",
      "aries",
      "taurus",
      "gemini",
      "cancer",
      "leo",
      "virgo",
      "libra",
      "scorpius",
      "sagittarius",
      "capricorn",
      "aquarius",
      "pisces",
      "ophiuchus",
      "twisted_rightwards_arrows",
      "repeat",
      "repeat_one",
      "arrow_forward",
      "fast_forward",
      "black_right_pointing_double_triangle_with_vertical_bar",
      "black_right_pointing_triangle_with_double_vertical_bar",
      "arrow_backward",
      "rewind",
      "black_left_pointing_double_triangle_with_vertical_bar",
      "arrow_up_small",
      "arrow_double_up",
      "arrow_down_small",
      "arrow_double_down",
      "double_vertical_bar",
      "black_square_for_stop",
      "black_circle_for_record",
      "eject",
      "cinema",
      "low_brightness",
      "high_brightness",
      "signal_strength",
      "wireless",
      "vibration_mode",
      "mobile_phone_off",
      "female_sign",
      "male_sign",
      "transgender_symbol",
      "heavy_multiplication_x",
      "heavy_plus_sign",
      "heavy_minus_sign",
      "heavy_division_sign",
      "heavy_equals_sign",
      "infinity",
      "bangbang",
      "interrobang",
      "question",
      "grey_question",
      "grey_exclamation",
      "exclamation",
      "wavy_dash",
      "currency_exchange",
      "heavy_dollar_sign",
      "medical_symbol",
      "recycle",
      "fleur_de_lis",
      "trident",
      "name_badge",
      "beginner",
      "o",
      "white_check_mark",
      "ballot_box_with_check",
      "heavy_check_mark",
      "x",
      "negative_squared_cross_mark",
      "curly_loop",
      "loop",
      "part_alternation_mark",
      "eight_spoked_asterisk",
      "eight_pointed_black_star",
      "sparkle",
      "copyright",
      "registered",
      "tm",
      "hash",
      "keycap_star",
      "zero",
      "one",
      "two",
      "three",
      "four",
      "five",
      "six",
      "seven",
      "eight",
      "nine",
      "keycap_ten",
      "capital_abcd",
      "abcd",
      "1234",
      "symbols",
      "abc",
      "a",
      "ab",
      "b",
      "cl",
      "cool",
      "free",
      "information_source",
      "id",
      "m",
      "new",
      "ng",
      "o2",
      "ok",
      "parking",
      "sos",
      "up",
      "vs",
      "koko",
      "sa",
      "u6708",
      "u6709",
      "u6307",
      "ideograph_advantage",
      "u5272",
      "u7121",
      "u7981",
      "accept",
      "u7533",
      "u5408",
      "u7a7a",
      "congratulations",
      "secret",
      "u55b6",
      "u6e80",
      "red_circle",
      "large_orange_circle",
      "large_yellow_circle",
      "large_green_circle",
      "large_blue_circle",
      "large_purple_circle",
      "large_brown_circle",
      "black_circle",
      "white_circle",
      "large_red_square",
      "large_orange_square",
      "large_yellow_square",
      "large_green_square",
      "large_blue_square",
      "large_purple_square",
      "large_brown_square",
      "black_large_square",
      "white_large_square",
      "black_medium_square",
      "white_medium_square",
      "black_medium_small_square",
      "white_medium_small_square",
      "black_small_square",
      "white_small_square",
      "large_orange_diamond",
      "large_blue_diamond",
      "small_orange_diamond",
      "small_blue_diamond",
      "small_red_triangle",
      "small_red_triangle_down",
      "diamond_shape_with_a_dot_inside",
      "radio_button",
      "white_square_button",
      "black_square_button"
    ]
  },
  {
    id: "flags",
    emojis: [
      "checkered_flag",
      "cn",
      "crossed_flags",
      "de",
      "es",
      "flag-ac",
      "flag-ad",
      "flag-ae",
      "flag-af",
      "flag-ag",
      "flag-ai",
      "flag-al",
      "flag-am",
      "flag-ao",
      "flag-aq",
      "flag-ar",
      "flag-as",
      "flag-at",
      "flag-au",
      "flag-aw",
      "flag-ax",
      "flag-az",
      "flag-ba",
      "flag-bb",
      "flag-bd",
      "flag-be",
      "flag-bf",
      "flag-bg",
      "flag-bh",
      "flag-bi",
      "flag-bj",
      "flag-bl",
      "flag-bm",
      "flag-bn",
      "flag-bo",
      "flag-bq",
      "flag-br",
      "flag-bs",
      "flag-bt",
      "flag-bv",
      "flag-bw",
      "flag-by",
      "flag-bz",
      "flag-ca",
      "flag-cc",
      "flag-cd",
      "flag-cf",
      "flag-cg",
      "flag-ch",
      "flag-ci",
      "flag-ck",
      "flag-cl",
      "flag-cm",
      "flag-co",
      "flag-cp",
      "flag-cr",
      "flag-cu",
      "flag-cv",
      "flag-cw",
      "flag-cx",
      "flag-cy",
      "flag-cz",
      "flag-dg",
      "flag-dj",
      "flag-dk",
      "flag-dm",
      "flag-do",
      "flag-dz",
      "flag-ea",
      "flag-ec",
      "flag-ee",
      "flag-eg",
      "flag-eh",
      "flag-england",
      "flag-er",
      "flag-et",
      "flag-eu",
      "flag-fi",
      "flag-fj",
      "flag-fk",
      "flag-fm",
      "flag-fo",
      "flag-ga",
      "flag-gd",
      "flag-ge",
      "flag-gf",
      "flag-gg",
      "flag-gh",
      "flag-gi",
      "flag-gl",
      "flag-gm",
      "flag-gn",
      "flag-gp",
      "flag-gq",
      "flag-gr",
      "flag-gs",
      "flag-gt",
      "flag-gu",
      "flag-gw",
      "flag-gy",
      "flag-hk",
      "flag-hm",
      "flag-hn",
      "flag-hr",
      "flag-ht",
      "flag-hu",
      "flag-ic",
      "flag-id",
      "flag-ie",
      "flag-il",
      "flag-im",
      "flag-in",
      "flag-io",
      "flag-iq",
      "flag-ir",
      "flag-is",
      "flag-je",
      "flag-jm",
      "flag-jo",
      "flag-ke",
      "flag-kg",
      "flag-kh",
      "flag-ki",
      "flag-km",
      "flag-kn",
      "flag-kp",
      "flag-kw",
      "flag-ky",
      "flag-kz",
      "flag-la",
      "flag-lb",
      "flag-lc",
      "flag-li",
      "flag-lk",
      "flag-lr",
      "flag-ls",
      "flag-lt",
      "flag-lu",
      "flag-lv",
      "flag-ly",
      "flag-ma",
      "flag-mc",
      "flag-md",
      "flag-me",
      "flag-mf",
      "flag-mg",
      "flag-mh",
      "flag-mk",
      "flag-ml",
      "flag-mm",
      "flag-mn",
      "flag-mo",
      "flag-mp",
      "flag-mq",
      "flag-mr",
      "flag-ms",
      "flag-mt",
      "flag-mu",
      "flag-mv",
      "flag-mw",
      "flag-mx",
      "flag-my",
      "flag-mz",
      "flag-na",
      "flag-nc",
      "flag-ne",
      "flag-nf",
      "flag-ng",
      "flag-ni",
      "flag-nl",
      "flag-no",
      "flag-np",
      "flag-nr",
      "flag-nu",
      "flag-nz",
      "flag-om",
      "flag-pa",
      "flag-pe",
      "flag-pf",
      "flag-pg",
      "flag-ph",
      "flag-pk",
      "flag-pl",
      "flag-pm",
      "flag-pn",
      "flag-pr",
      "flag-ps",
      "flag-pt",
      "flag-pw",
      "flag-py",
      "flag-qa",
      "flag-re",
      "flag-ro",
      "flag-rs",
      "flag-rw",
      "flag-sa",
      "flag-sb",
      "flag-sc",
      "flag-scotland",
      "flag-sd",
      "flag-se",
      "flag-sg",
      "flag-sh",
      "flag-si",
      "flag-sj",
      "flag-sk",
      "flag-sl",
      "flag-sm",
      "flag-sn",
      "flag-so",
      "flag-sr",
      "flag-ss",
      "flag-st",
      "flag-sv",
      "flag-sx",
      "flag-sy",
      "flag-sz",
      "flag-ta",
      "flag-tc",
      "flag-td",
      "flag-tf",
      "flag-tg",
      "flag-th",
      "flag-tj",
      "flag-tk",
      "flag-tl",
      "flag-tm",
      "flag-tn",
      "flag-to",
      "flag-tr",
      "flag-tt",
      "flag-tv",
      "flag-tw",
      "flag-tz",
      "flag-ua",
      "flag-ug",
      "flag-um",
      "flag-un",
      "flag-uy",
      "flag-uz",
      "flag-va",
      "flag-vc",
      "flag-ve",
      "flag-vg",
      "flag-vi",
      "flag-vn",
      "flag-vu",
      "flag-wales",
      "flag-wf",
      "flag-ws",
      "flag-xk",
      "flag-ye",
      "flag-yt",
      "flag-za",
      "flag-zm",
      "flag-zw",
      "fr",
      "gb",
      "it",
      "jp",
      "kr",
      "pirate_flag",
      "rainbow-flag",
      "ru",
      "transgender_flag",
      "triangular_flag_on_post",
      "us",
      "waving_black_flag",
      "waving_white_flag"
    ]
  }
], ll = {
  100: {
    id: "100",
    name: "Hundred Points",
    keywords: [
      "100",
      "score",
      "perfect",
      "numbers",
      "century",
      "exam",
      "quiz",
      "test",
      "pass"
    ],
    skins: [
      {
        unified: "1f4af",
        native: "💯"
      }
    ],
    version: 1
  },
  1234: {
    id: "1234",
    name: "Input Numbers",
    keywords: [
      "1234",
      "blue",
      "square",
      "1",
      "2",
      "3",
      "4"
    ],
    skins: [
      {
        unified: "1f522",
        native: "🔢"
      }
    ],
    version: 1
  },
  grinning: {
    id: "grinning",
    name: "Grinning Face",
    emoticons: [
      ":D"
    ],
    keywords: [
      "smile",
      "happy",
      "joy",
      ":D",
      "grin"
    ],
    skins: [
      {
        unified: "1f600",
        native: "😀"
      }
    ],
    version: 1
  },
  smiley: {
    id: "smiley",
    name: "Grinning Face with Big Eyes",
    emoticons: [
      ":)",
      "=)",
      "=-)"
    ],
    keywords: [
      "smiley",
      "happy",
      "joy",
      "haha",
      ":D",
      ":)",
      "smile",
      "funny"
    ],
    skins: [
      {
        unified: "1f603",
        native: "😃"
      }
    ],
    version: 1
  },
  smile: {
    id: "smile",
    name: "Grinning Face with Smiling Eyes",
    emoticons: [
      ":)",
      "C:",
      "c:",
      ":D",
      ":-D"
    ],
    keywords: [
      "smile",
      "happy",
      "joy",
      "funny",
      "haha",
      "laugh",
      "like",
      ":D",
      ":)"
    ],
    skins: [
      {
        unified: "1f604",
        native: "😄"
      }
    ],
    version: 1
  },
  grin: {
    id: "grin",
    name: "Beaming Face with Smiling Eyes",
    keywords: [
      "grin",
      "happy",
      "smile",
      "joy",
      "kawaii"
    ],
    skins: [
      {
        unified: "1f601",
        native: "😁"
      }
    ],
    version: 1
  },
  laughing: {
    id: "laughing",
    name: "Grinning Squinting Face",
    emoticons: [
      ":>",
      ":->"
    ],
    keywords: [
      "laughing",
      "satisfied",
      "happy",
      "joy",
      "lol",
      "haha",
      "glad",
      "XD",
      "laugh"
    ],
    skins: [
      {
        unified: "1f606",
        native: "😆"
      }
    ],
    version: 1
  },
  sweat_smile: {
    id: "sweat_smile",
    name: "Grinning Face with Sweat",
    keywords: [
      "smile",
      "hot",
      "happy",
      "laugh",
      "relief"
    ],
    skins: [
      {
        unified: "1f605",
        native: "😅"
      }
    ],
    version: 1
  },
  rolling_on_the_floor_laughing: {
    id: "rolling_on_the_floor_laughing",
    name: "Rolling on the Floor Laughing",
    keywords: [
      "face",
      "lol",
      "haha",
      "rofl"
    ],
    skins: [
      {
        unified: "1f923",
        native: "🤣"
      }
    ],
    version: 3
  },
  joy: {
    id: "joy",
    name: "Face with Tears of Joy",
    keywords: [
      "cry",
      "weep",
      "happy",
      "happytears",
      "haha"
    ],
    skins: [
      {
        unified: "1f602",
        native: "😂"
      }
    ],
    version: 1
  },
  slightly_smiling_face: {
    id: "slightly_smiling_face",
    name: "Slightly Smiling Face",
    emoticons: [
      ":)",
      "(:",
      ":-)"
    ],
    keywords: [
      "smile"
    ],
    skins: [
      {
        unified: "1f642",
        native: "🙂"
      }
    ],
    version: 1
  },
  upside_down_face: {
    id: "upside_down_face",
    name: "Upside-Down Face",
    keywords: [
      "upside",
      "down",
      "flipped",
      "silly",
      "smile"
    ],
    skins: [
      {
        unified: "1f643",
        native: "🙃"
      }
    ],
    version: 1
  },
  melting_face: {
    id: "melting_face",
    name: "Melting Face",
    keywords: [
      "hot",
      "heat"
    ],
    skins: [
      {
        unified: "1fae0",
        native: "🫠"
      }
    ],
    version: 14
  },
  wink: {
    id: "wink",
    name: "Winking Face",
    emoticons: [
      ";)",
      ";-)"
    ],
    keywords: [
      "wink",
      "happy",
      "mischievous",
      "secret",
      ";)",
      "smile",
      "eye"
    ],
    skins: [
      {
        unified: "1f609",
        native: "😉"
      }
    ],
    version: 1
  },
  blush: {
    id: "blush",
    name: "Smiling Face with Smiling Eyes",
    emoticons: [
      ":)"
    ],
    keywords: [
      "blush",
      "smile",
      "happy",
      "flushed",
      "crush",
      "embarrassed",
      "shy",
      "joy"
    ],
    skins: [
      {
        unified: "1f60a",
        native: "😊"
      }
    ],
    version: 1
  },
  innocent: {
    id: "innocent",
    name: "Smiling Face with Halo",
    keywords: [
      "innocent",
      "angel",
      "heaven"
    ],
    skins: [
      {
        unified: "1f607",
        native: "😇"
      }
    ],
    version: 1
  },
  smiling_face_with_3_hearts: {
    id: "smiling_face_with_3_hearts",
    name: "Smiling Face with Hearts",
    keywords: [
      "3",
      "love",
      "like",
      "affection",
      "valentines",
      "infatuation",
      "crush",
      "adore"
    ],
    skins: [
      {
        unified: "1f970",
        native: "🥰"
      }
    ],
    version: 11
  },
  heart_eyes: {
    id: "heart_eyes",
    name: "Smiling Face with Heart-Eyes",
    keywords: [
      "heart",
      "eyes",
      "love",
      "like",
      "affection",
      "valentines",
      "infatuation",
      "crush"
    ],
    skins: [
      {
        unified: "1f60d",
        native: "😍"
      }
    ],
    version: 1
  },
  "star-struck": {
    id: "star-struck",
    name: "Star-Struck",
    keywords: [
      "star",
      "struck",
      "grinning",
      "face",
      "with",
      "eyes",
      "smile",
      "starry"
    ],
    skins: [
      {
        unified: "1f929",
        native: "🤩"
      }
    ],
    version: 5
  },
  kissing_heart: {
    id: "kissing_heart",
    name: "Face Blowing a Kiss",
    emoticons: [
      ":*",
      ":-*"
    ],
    keywords: [
      "kissing",
      "heart",
      "love",
      "like",
      "affection",
      "valentines",
      "infatuation"
    ],
    skins: [
      {
        unified: "1f618",
        native: "😘"
      }
    ],
    version: 1
  },
  kissing: {
    id: "kissing",
    name: "Kissing Face",
    keywords: [
      "love",
      "like",
      "3",
      "valentines",
      "infatuation",
      "kiss"
    ],
    skins: [
      {
        unified: "1f617",
        native: "😗"
      }
    ],
    version: 1
  },
  relaxed: {
    id: "relaxed",
    name: "Smiling Face",
    keywords: [
      "relaxed",
      "blush",
      "massage",
      "happiness"
    ],
    skins: [
      {
        unified: "263a-fe0f",
        native: "☺️"
      }
    ],
    version: 1
  },
  kissing_closed_eyes: {
    id: "kissing_closed_eyes",
    name: "Kissing Face with Closed Eyes",
    keywords: [
      "love",
      "like",
      "affection",
      "valentines",
      "infatuation",
      "kiss"
    ],
    skins: [
      {
        unified: "1f61a",
        native: "😚"
      }
    ],
    version: 1
  },
  kissing_smiling_eyes: {
    id: "kissing_smiling_eyes",
    name: "Kissing Face with Smiling Eyes",
    keywords: [
      "affection",
      "valentines",
      "infatuation",
      "kiss"
    ],
    skins: [
      {
        unified: "1f619",
        native: "😙"
      }
    ],
    version: 1
  },
  smiling_face_with_tear: {
    id: "smiling_face_with_tear",
    name: "Smiling Face with Tear",
    keywords: [
      "sad",
      "cry",
      "pretend"
    ],
    skins: [
      {
        unified: "1f972",
        native: "🥲"
      }
    ],
    version: 13
  },
  yum: {
    id: "yum",
    name: "Face Savoring Food",
    keywords: [
      "yum",
      "happy",
      "joy",
      "tongue",
      "smile",
      "silly",
      "yummy",
      "nom",
      "delicious",
      "savouring"
    ],
    skins: [
      {
        unified: "1f60b",
        native: "😋"
      }
    ],
    version: 1
  },
  stuck_out_tongue: {
    id: "stuck_out_tongue",
    name: "Face with Tongue",
    emoticons: [
      ":p",
      ":-p",
      ":P",
      ":-P",
      ":b",
      ":-b"
    ],
    keywords: [
      "stuck",
      "out",
      "prank",
      "childish",
      "playful",
      "mischievous",
      "smile"
    ],
    skins: [
      {
        unified: "1f61b",
        native: "😛"
      }
    ],
    version: 1
  },
  stuck_out_tongue_winking_eye: {
    id: "stuck_out_tongue_winking_eye",
    name: "Winking Face with Tongue",
    emoticons: [
      ";p",
      ";-p",
      ";b",
      ";-b",
      ";P",
      ";-P"
    ],
    keywords: [
      "stuck",
      "out",
      "eye",
      "prank",
      "childish",
      "playful",
      "mischievous",
      "smile",
      "wink"
    ],
    skins: [
      {
        unified: "1f61c",
        native: "😜"
      }
    ],
    version: 1
  },
  zany_face: {
    id: "zany_face",
    name: "Zany Face",
    keywords: [
      "grinning",
      "with",
      "one",
      "large",
      "and",
      "small",
      "eye",
      "goofy",
      "crazy"
    ],
    skins: [
      {
        unified: "1f92a",
        native: "🤪"
      }
    ],
    version: 5
  },
  stuck_out_tongue_closed_eyes: {
    id: "stuck_out_tongue_closed_eyes",
    name: "Squinting Face with Tongue",
    keywords: [
      "stuck",
      "out",
      "closed",
      "eyes",
      "prank",
      "playful",
      "mischievous",
      "smile"
    ],
    skins: [
      {
        unified: "1f61d",
        native: "😝"
      }
    ],
    version: 1
  },
  money_mouth_face: {
    id: "money_mouth_face",
    name: "Money-Mouth Face",
    keywords: [
      "money",
      "mouth",
      "rich",
      "dollar"
    ],
    skins: [
      {
        unified: "1f911",
        native: "🤑"
      }
    ],
    version: 1
  },
  hugging_face: {
    id: "hugging_face",
    name: "Hugging Face",
    keywords: [
      "smile",
      "hug"
    ],
    skins: [
      {
        unified: "1f917",
        native: "🤗"
      }
    ],
    version: 1
  },
  face_with_hand_over_mouth: {
    id: "face_with_hand_over_mouth",
    name: "Face with Hand over Mouth",
    keywords: [
      "smiling",
      "eyes",
      "and",
      "covering",
      "whoops",
      "shock",
      "surprise"
    ],
    skins: [
      {
        unified: "1f92d",
        native: "🤭"
      }
    ],
    version: 5
  },
  face_with_open_eyes_and_hand_over_mouth: {
    id: "face_with_open_eyes_and_hand_over_mouth",
    name: "Face with Open Eyes and Hand over Mouth",
    keywords: [
      "silence",
      "secret",
      "shock",
      "surprise"
    ],
    skins: [
      {
        unified: "1fae2",
        native: "🫢"
      }
    ],
    version: 14
  },
  face_with_peeking_eye: {
    id: "face_with_peeking_eye",
    name: "Face with Peeking Eye",
    keywords: [
      "scared",
      "frightening",
      "embarrassing",
      "shy"
    ],
    skins: [
      {
        unified: "1fae3",
        native: "🫣"
      }
    ],
    version: 14
  },
  shushing_face: {
    id: "shushing_face",
    name: "Shushing Face",
    keywords: [
      "with",
      "finger",
      "covering",
      "closed",
      "lips",
      "quiet",
      "shhh"
    ],
    skins: [
      {
        unified: "1f92b",
        native: "🤫"
      }
    ],
    version: 5
  },
  thinking_face: {
    id: "thinking_face",
    name: "Thinking Face",
    keywords: [
      "hmmm",
      "think",
      "consider"
    ],
    skins: [
      {
        unified: "1f914",
        native: "🤔"
      }
    ],
    version: 1
  },
  saluting_face: {
    id: "saluting_face",
    name: "Saluting Face",
    keywords: [
      "respect",
      "salute"
    ],
    skins: [
      {
        unified: "1fae1",
        native: "🫡"
      }
    ],
    version: 14
  },
  zipper_mouth_face: {
    id: "zipper_mouth_face",
    name: "Zipper-Mouth Face",
    keywords: [
      "zipper",
      "mouth",
      "sealed",
      "secret"
    ],
    skins: [
      {
        unified: "1f910",
        native: "🤐"
      }
    ],
    version: 1
  },
  face_with_raised_eyebrow: {
    id: "face_with_raised_eyebrow",
    name: "Face with Raised Eyebrow",
    keywords: [
      "one",
      "distrust",
      "scepticism",
      "disapproval",
      "disbelief",
      "surprise"
    ],
    skins: [
      {
        unified: "1f928",
        native: "🤨"
      }
    ],
    version: 5
  },
  neutral_face: {
    id: "neutral_face",
    name: "Neutral Face",
    emoticons: [
      ":|",
      ":-|"
    ],
    keywords: [
      "indifference",
      "meh",
      ":",
      ""
    ],
    skins: [
      {
        unified: "1f610",
        native: "😐"
      }
    ],
    version: 1
  },
  expressionless: {
    id: "expressionless",
    name: "Expressionless Face",
    emoticons: [
      "-_-"
    ],
    keywords: [
      "indifferent",
      "-",
      "",
      "meh",
      "deadpan"
    ],
    skins: [
      {
        unified: "1f611",
        native: "😑"
      }
    ],
    version: 1
  },
  no_mouth: {
    id: "no_mouth",
    name: "Face Without Mouth",
    keywords: [
      "no",
      "hellokitty"
    ],
    skins: [
      {
        unified: "1f636",
        native: "😶"
      }
    ],
    version: 1
  },
  dotted_line_face: {
    id: "dotted_line_face",
    name: "Dotted Line Face",
    keywords: [
      "invisible",
      "lonely",
      "isolation",
      "depression"
    ],
    skins: [
      {
        unified: "1fae5",
        native: "🫥"
      }
    ],
    version: 14
  },
  face_in_clouds: {
    id: "face_in_clouds",
    name: "Face in Clouds",
    keywords: [
      "shower",
      "steam",
      "dream"
    ],
    skins: [
      {
        unified: "1f636-200d-1f32b-fe0f",
        native: "😶‍🌫️"
      }
    ],
    version: 13.1
  },
  smirk: {
    id: "smirk",
    name: "Smirking Face",
    keywords: [
      "smirk",
      "smile",
      "mean",
      "prank",
      "smug",
      "sarcasm"
    ],
    skins: [
      {
        unified: "1f60f",
        native: "😏"
      }
    ],
    version: 1
  },
  unamused: {
    id: "unamused",
    name: "Unamused Face",
    emoticons: [
      ":("
    ],
    keywords: [
      "indifference",
      "bored",
      "straight",
      "serious",
      "sarcasm",
      "unimpressed",
      "skeptical",
      "dubious",
      "side",
      "eye"
    ],
    skins: [
      {
        unified: "1f612",
        native: "😒"
      }
    ],
    version: 1
  },
  face_with_rolling_eyes: {
    id: "face_with_rolling_eyes",
    name: "Face with Rolling Eyes",
    keywords: [
      "eyeroll",
      "frustrated"
    ],
    skins: [
      {
        unified: "1f644",
        native: "🙄"
      }
    ],
    version: 1
  },
  grimacing: {
    id: "grimacing",
    name: "Grimacing Face",
    keywords: [
      "grimace",
      "teeth"
    ],
    skins: [
      {
        unified: "1f62c",
        native: "😬"
      }
    ],
    version: 1
  },
  face_exhaling: {
    id: "face_exhaling",
    name: "Face Exhaling",
    keywords: [
      "relieve",
      "relief",
      "tired",
      "sigh"
    ],
    skins: [
      {
        unified: "1f62e-200d-1f4a8",
        native: "😮‍💨"
      }
    ],
    version: 13.1
  },
  lying_face: {
    id: "lying_face",
    name: "Lying Face",
    keywords: [
      "lie",
      "pinocchio"
    ],
    skins: [
      {
        unified: "1f925",
        native: "🤥"
      }
    ],
    version: 3
  },
  shaking_face: {
    id: "shaking_face",
    name: "Shaking Face",
    keywords: [
      "dizzy",
      "shock",
      "blurry",
      "earthquake"
    ],
    skins: [
      {
        unified: "1fae8",
        native: "🫨"
      }
    ],
    version: 15
  },
  relieved: {
    id: "relieved",
    name: "Relieved Face",
    keywords: [
      "relaxed",
      "phew",
      "massage",
      "happiness"
    ],
    skins: [
      {
        unified: "1f60c",
        native: "😌"
      }
    ],
    version: 1
  },
  pensive: {
    id: "pensive",
    name: "Pensive Face",
    keywords: [
      "sad",
      "depressed",
      "upset"
    ],
    skins: [
      {
        unified: "1f614",
        native: "😔"
      }
    ],
    version: 1
  },
  sleepy: {
    id: "sleepy",
    name: "Sleepy Face",
    keywords: [
      "tired",
      "rest",
      "nap"
    ],
    skins: [
      {
        unified: "1f62a",
        native: "😪"
      }
    ],
    version: 1
  },
  drooling_face: {
    id: "drooling_face",
    name: "Drooling Face",
    keywords: [],
    skins: [
      {
        unified: "1f924",
        native: "🤤"
      }
    ],
    version: 3
  },
  sleeping: {
    id: "sleeping",
    name: "Sleeping Face",
    keywords: [
      "tired",
      "sleepy",
      "night",
      "zzz"
    ],
    skins: [
      {
        unified: "1f634",
        native: "😴"
      }
    ],
    version: 1
  },
  mask: {
    id: "mask",
    name: "Face with Medical Mask",
    keywords: [
      "sick",
      "ill",
      "disease",
      "covid"
    ],
    skins: [
      {
        unified: "1f637",
        native: "😷"
      }
    ],
    version: 1
  },
  face_with_thermometer: {
    id: "face_with_thermometer",
    name: "Face with Thermometer",
    keywords: [
      "sick",
      "temperature",
      "cold",
      "fever",
      "covid"
    ],
    skins: [
      {
        unified: "1f912",
        native: "🤒"
      }
    ],
    version: 1
  },
  face_with_head_bandage: {
    id: "face_with_head_bandage",
    name: "Face with Head-Bandage",
    keywords: [
      "head",
      "bandage",
      "injured",
      "clumsy",
      "hurt"
    ],
    skins: [
      {
        unified: "1f915",
        native: "🤕"
      }
    ],
    version: 1
  },
  nauseated_face: {
    id: "nauseated_face",
    name: "Nauseated Face",
    keywords: [
      "vomit",
      "gross",
      "green",
      "sick",
      "throw",
      "up",
      "ill"
    ],
    skins: [
      {
        unified: "1f922",
        native: "🤢"
      }
    ],
    version: 3
  },
  face_vomiting: {
    id: "face_vomiting",
    name: "Face Vomiting",
    keywords: [
      "with",
      "open",
      "mouth",
      "sick"
    ],
    skins: [
      {
        unified: "1f92e",
        native: "🤮"
      }
    ],
    version: 5
  },
  sneezing_face: {
    id: "sneezing_face",
    name: "Sneezing Face",
    keywords: [
      "gesundheit",
      "sneeze",
      "sick",
      "allergy"
    ],
    skins: [
      {
        unified: "1f927",
        native: "🤧"
      }
    ],
    version: 3
  },
  hot_face: {
    id: "hot_face",
    name: "Hot Face",
    keywords: [
      "feverish",
      "heat",
      "red",
      "sweating"
    ],
    skins: [
      {
        unified: "1f975",
        native: "🥵"
      }
    ],
    version: 11
  },
  cold_face: {
    id: "cold_face",
    name: "Cold Face",
    keywords: [
      "blue",
      "freezing",
      "frozen",
      "frostbite",
      "icicles"
    ],
    skins: [
      {
        unified: "1f976",
        native: "🥶"
      }
    ],
    version: 11
  },
  woozy_face: {
    id: "woozy_face",
    name: "Woozy Face",
    keywords: [
      "dizzy",
      "intoxicated",
      "tipsy",
      "wavy"
    ],
    skins: [
      {
        unified: "1f974",
        native: "🥴"
      }
    ],
    version: 11
  },
  dizzy_face: {
    id: "dizzy_face",
    name: "Dizzy Face",
    keywords: [
      "spent",
      "unconscious",
      "xox"
    ],
    skins: [
      {
        unified: "1f635",
        native: "😵"
      }
    ],
    version: 1
  },
  face_with_spiral_eyes: {
    id: "face_with_spiral_eyes",
    name: "Face with Spiral Eyes",
    keywords: [
      "sick",
      "ill",
      "confused",
      "nauseous",
      "nausea"
    ],
    skins: [
      {
        unified: "1f635-200d-1f4ab",
        native: "😵‍💫"
      }
    ],
    version: 13.1
  },
  exploding_head: {
    id: "exploding_head",
    name: "Exploding Head",
    keywords: [
      "shocked",
      "face",
      "with",
      "mind",
      "blown"
    ],
    skins: [
      {
        unified: "1f92f",
        native: "🤯"
      }
    ],
    version: 5
  },
  face_with_cowboy_hat: {
    id: "face_with_cowboy_hat",
    name: "Cowboy Hat Face",
    keywords: [
      "with",
      "cowgirl"
    ],
    skins: [
      {
        unified: "1f920",
        native: "🤠"
      }
    ],
    version: 3
  },
  partying_face: {
    id: "partying_face",
    name: "Partying Face",
    keywords: [
      "celebration",
      "woohoo"
    ],
    skins: [
      {
        unified: "1f973",
        native: "🥳"
      }
    ],
    version: 11
  },
  disguised_face: {
    id: "disguised_face",
    name: "Disguised Face",
    keywords: [
      "pretent",
      "brows",
      "glasses",
      "moustache"
    ],
    skins: [
      {
        unified: "1f978",
        native: "🥸"
      }
    ],
    version: 13
  },
  sunglasses: {
    id: "sunglasses",
    name: "Smiling Face with Sunglasses",
    emoticons: [
      "8)"
    ],
    keywords: [
      "cool",
      "smile",
      "summer",
      "beach",
      "sunglass"
    ],
    skins: [
      {
        unified: "1f60e",
        native: "😎"
      }
    ],
    version: 1
  },
  nerd_face: {
    id: "nerd_face",
    name: "Nerd Face",
    keywords: [
      "nerdy",
      "geek",
      "dork"
    ],
    skins: [
      {
        unified: "1f913",
        native: "🤓"
      }
    ],
    version: 1
  },
  face_with_monocle: {
    id: "face_with_monocle",
    name: "Face with Monocle",
    keywords: [
      "stuffy",
      "wealthy"
    ],
    skins: [
      {
        unified: "1f9d0",
        native: "🧐"
      }
    ],
    version: 5
  },
  confused: {
    id: "confused",
    name: "Confused Face",
    emoticons: [
      ":\\",
      ":-\\",
      ":/",
      ":-/"
    ],
    keywords: [
      "indifference",
      "huh",
      "weird",
      "hmmm",
      ":/"
    ],
    skins: [
      {
        unified: "1f615",
        native: "😕"
      }
    ],
    version: 1
  },
  face_with_diagonal_mouth: {
    id: "face_with_diagonal_mouth",
    name: "Face with Diagonal Mouth",
    keywords: [
      "skeptic",
      "confuse",
      "frustrated",
      "indifferent"
    ],
    skins: [
      {
        unified: "1fae4",
        native: "🫤"
      }
    ],
    version: 14
  },
  worried: {
    id: "worried",
    name: "Worried Face",
    keywords: [
      "concern",
      "nervous",
      ":("
    ],
    skins: [
      {
        unified: "1f61f",
        native: "😟"
      }
    ],
    version: 1
  },
  slightly_frowning_face: {
    id: "slightly_frowning_face",
    name: "Slightly Frowning Face",
    keywords: [
      "disappointed",
      "sad",
      "upset"
    ],
    skins: [
      {
        unified: "1f641",
        native: "🙁"
      }
    ],
    version: 1
  },
  white_frowning_face: {
    id: "white_frowning_face",
    name: "Frowning Face",
    keywords: [
      "white",
      "sad",
      "upset",
      "frown"
    ],
    skins: [
      {
        unified: "2639-fe0f",
        native: "☹️"
      }
    ],
    version: 1
  },
  open_mouth: {
    id: "open_mouth",
    name: "Face with Open Mouth",
    emoticons: [
      ":o",
      ":-o",
      ":O",
      ":-O"
    ],
    keywords: [
      "surprise",
      "impressed",
      "wow",
      "whoa",
      ":O"
    ],
    skins: [
      {
        unified: "1f62e",
        native: "😮"
      }
    ],
    version: 1
  },
  hushed: {
    id: "hushed",
    name: "Hushed Face",
    keywords: [
      "woo",
      "shh"
    ],
    skins: [
      {
        unified: "1f62f",
        native: "😯"
      }
    ],
    version: 1
  },
  astonished: {
    id: "astonished",
    name: "Astonished Face",
    keywords: [
      "xox",
      "surprised",
      "poisoned"
    ],
    skins: [
      {
        unified: "1f632",
        native: "😲"
      }
    ],
    version: 1
  },
  flushed: {
    id: "flushed",
    name: "Flushed Face",
    keywords: [
      "blush",
      "shy",
      "flattered"
    ],
    skins: [
      {
        unified: "1f633",
        native: "😳"
      }
    ],
    version: 1
  },
  pleading_face: {
    id: "pleading_face",
    name: "Pleading Face",
    keywords: [
      "begging",
      "mercy",
      "cry",
      "tears",
      "sad",
      "grievance"
    ],
    skins: [
      {
        unified: "1f97a",
        native: "🥺"
      }
    ],
    version: 11
  },
  face_holding_back_tears: {
    id: "face_holding_back_tears",
    name: "Face Holding Back Tears",
    keywords: [
      "touched",
      "gratitude",
      "cry"
    ],
    skins: [
      {
        unified: "1f979",
        native: "🥹"
      }
    ],
    version: 14
  },
  frowning: {
    id: "frowning",
    name: "Frowning Face with Open Mouth",
    keywords: [
      "aw",
      "what"
    ],
    skins: [
      {
        unified: "1f626",
        native: "😦"
      }
    ],
    version: 1
  },
  anguished: {
    id: "anguished",
    name: "Anguished Face",
    emoticons: [
      "D:"
    ],
    keywords: [
      "stunned",
      "nervous"
    ],
    skins: [
      {
        unified: "1f627",
        native: "😧"
      }
    ],
    version: 1
  },
  fearful: {
    id: "fearful",
    name: "Fearful Face",
    keywords: [
      "scared",
      "terrified",
      "nervous"
    ],
    skins: [
      {
        unified: "1f628",
        native: "😨"
      }
    ],
    version: 1
  },
  cold_sweat: {
    id: "cold_sweat",
    name: "Anxious Face with Sweat",
    keywords: [
      "cold",
      "nervous"
    ],
    skins: [
      {
        unified: "1f630",
        native: "😰"
      }
    ],
    version: 1
  },
  disappointed_relieved: {
    id: "disappointed_relieved",
    name: "Sad but Relieved Face",
    keywords: [
      "disappointed",
      "phew",
      "sweat",
      "nervous"
    ],
    skins: [
      {
        unified: "1f625",
        native: "😥"
      }
    ],
    version: 1
  },
  cry: {
    id: "cry",
    name: "Crying Face",
    emoticons: [
      ":'("
    ],
    keywords: [
      "cry",
      "tears",
      "sad",
      "depressed",
      "upset",
      ":'("
    ],
    skins: [
      {
        unified: "1f622",
        native: "😢"
      }
    ],
    version: 1
  },
  sob: {
    id: "sob",
    name: "Loudly Crying Face",
    emoticons: [
      ":'("
    ],
    keywords: [
      "sob",
      "cry",
      "tears",
      "sad",
      "upset",
      "depressed"
    ],
    skins: [
      {
        unified: "1f62d",
        native: "😭"
      }
    ],
    version: 1
  },
  scream: {
    id: "scream",
    name: "Face Screaming in Fear",
    keywords: [
      "scream",
      "munch",
      "scared",
      "omg"
    ],
    skins: [
      {
        unified: "1f631",
        native: "😱"
      }
    ],
    version: 1
  },
  confounded: {
    id: "confounded",
    name: "Confounded Face",
    keywords: [
      "confused",
      "sick",
      "unwell",
      "oops",
      ":S"
    ],
    skins: [
      {
        unified: "1f616",
        native: "😖"
      }
    ],
    version: 1
  },
  persevere: {
    id: "persevere",
    name: "Persevering Face",
    keywords: [
      "persevere",
      "sick",
      "no",
      "upset",
      "oops"
    ],
    skins: [
      {
        unified: "1f623",
        native: "😣"
      }
    ],
    version: 1
  },
  disappointed: {
    id: "disappointed",
    name: "Disappointed Face",
    emoticons: [
      "):",
      ":(",
      ":-("
    ],
    keywords: [
      "sad",
      "upset",
      "depressed",
      ":("
    ],
    skins: [
      {
        unified: "1f61e",
        native: "😞"
      }
    ],
    version: 1
  },
  sweat: {
    id: "sweat",
    name: "Face with Cold Sweat",
    keywords: [
      "downcast",
      "hot",
      "sad",
      "tired",
      "exercise"
    ],
    skins: [
      {
        unified: "1f613",
        native: "😓"
      }
    ],
    version: 1
  },
  weary: {
    id: "weary",
    name: "Weary Face",
    keywords: [
      "tired",
      "sleepy",
      "sad",
      "frustrated",
      "upset"
    ],
    skins: [
      {
        unified: "1f629",
        native: "😩"
      }
    ],
    version: 1
  },
  tired_face: {
    id: "tired_face",
    name: "Tired Face",
    keywords: [
      "sick",
      "whine",
      "upset",
      "frustrated"
    ],
    skins: [
      {
        unified: "1f62b",
        native: "😫"
      }
    ],
    version: 1
  },
  yawning_face: {
    id: "yawning_face",
    name: "Yawning Face",
    keywords: [
      "tired",
      "sleepy"
    ],
    skins: [
      {
        unified: "1f971",
        native: "🥱"
      }
    ],
    version: 12
  },
  triumph: {
    id: "triumph",
    name: "Face with Look of Triumph",
    keywords: [
      "steam",
      "from",
      "nose",
      "gas",
      "phew",
      "proud",
      "pride"
    ],
    skins: [
      {
        unified: "1f624",
        native: "😤"
      }
    ],
    version: 1
  },
  rage: {
    id: "rage",
    name: "Pouting Face",
    keywords: [
      "rage",
      "angry",
      "mad",
      "hate",
      "despise"
    ],
    skins: [
      {
        unified: "1f621",
        native: "😡"
      }
    ],
    version: 1
  },
  angry: {
    id: "angry",
    name: "Angry Face",
    emoticons: [
      ">:(",
      ">:-("
    ],
    keywords: [
      "mad",
      "annoyed",
      "frustrated"
    ],
    skins: [
      {
        unified: "1f620",
        native: "😠"
      }
    ],
    version: 1
  },
  face_with_symbols_on_mouth: {
    id: "face_with_symbols_on_mouth",
    name: "Face with Symbols on Mouth",
    keywords: [
      "serious",
      "covering",
      "swearing",
      "cursing",
      "cussing",
      "profanity",
      "expletive"
    ],
    skins: [
      {
        unified: "1f92c",
        native: "🤬"
      }
    ],
    version: 5
  },
  smiling_imp: {
    id: "smiling_imp",
    name: "Smiling Face with Horns",
    keywords: [
      "imp",
      "devil"
    ],
    skins: [
      {
        unified: "1f608",
        native: "😈"
      }
    ],
    version: 1
  },
  imp: {
    id: "imp",
    name: "Imp",
    keywords: [
      "angry",
      "face",
      "with",
      "horns",
      "devil"
    ],
    skins: [
      {
        unified: "1f47f",
        native: "👿"
      }
    ],
    version: 1
  },
  skull: {
    id: "skull",
    name: "Skull",
    keywords: [
      "dead",
      "skeleton",
      "creepy",
      "death"
    ],
    skins: [
      {
        unified: "1f480",
        native: "💀"
      }
    ],
    version: 1
  },
  skull_and_crossbones: {
    id: "skull_and_crossbones",
    name: "Skull and Crossbones",
    keywords: [
      "poison",
      "danger",
      "deadly",
      "scary",
      "death",
      "pirate",
      "evil"
    ],
    skins: [
      {
        unified: "2620-fe0f",
        native: "☠️"
      }
    ],
    version: 1
  },
  hankey: {
    id: "hankey",
    name: "Pile of Poo",
    keywords: [
      "hankey",
      "poop",
      "shit",
      "shitface",
      "fail",
      "turd"
    ],
    skins: [
      {
        unified: "1f4a9",
        native: "💩"
      }
    ],
    version: 1
  },
  clown_face: {
    id: "clown_face",
    name: "Clown Face",
    keywords: [],
    skins: [
      {
        unified: "1f921",
        native: "🤡"
      }
    ],
    version: 3
  },
  japanese_ogre: {
    id: "japanese_ogre",
    name: "Ogre",
    keywords: [
      "japanese",
      "monster",
      "red",
      "mask",
      "halloween",
      "scary",
      "creepy",
      "devil",
      "demon"
    ],
    skins: [
      {
        unified: "1f479",
        native: "👹"
      }
    ],
    version: 1
  },
  japanese_goblin: {
    id: "japanese_goblin",
    name: "Goblin",
    keywords: [
      "japanese",
      "red",
      "evil",
      "mask",
      "monster",
      "scary",
      "creepy"
    ],
    skins: [
      {
        unified: "1f47a",
        native: "👺"
      }
    ],
    version: 1
  },
  ghost: {
    id: "ghost",
    name: "Ghost",
    keywords: [
      "halloween",
      "spooky",
      "scary"
    ],
    skins: [
      {
        unified: "1f47b",
        native: "👻"
      }
    ],
    version: 1
  },
  alien: {
    id: "alien",
    name: "Alien",
    keywords: [
      "UFO",
      "paul",
      "weird",
      "outer",
      "space"
    ],
    skins: [
      {
        unified: "1f47d",
        native: "👽"
      }
    ],
    version: 1
  },
  space_invader: {
    id: "space_invader",
    name: "Alien Monster",
    keywords: [
      "space",
      "invader",
      "game",
      "arcade",
      "play"
    ],
    skins: [
      {
        unified: "1f47e",
        native: "👾"
      }
    ],
    version: 1
  },
  robot_face: {
    id: "robot_face",
    name: "Robot",
    keywords: [
      "face",
      "computer",
      "machine",
      "bot"
    ],
    skins: [
      {
        unified: "1f916",
        native: "🤖"
      }
    ],
    version: 1
  },
  smiley_cat: {
    id: "smiley_cat",
    name: "Grinning Cat",
    keywords: [
      "smiley",
      "animal",
      "cats",
      "happy",
      "smile"
    ],
    skins: [
      {
        unified: "1f63a",
        native: "😺"
      }
    ],
    version: 1
  },
  smile_cat: {
    id: "smile_cat",
    name: "Grinning Cat with Smiling Eyes",
    keywords: [
      "smile",
      "animal",
      "cats"
    ],
    skins: [
      {
        unified: "1f638",
        native: "😸"
      }
    ],
    version: 1
  },
  joy_cat: {
    id: "joy_cat",
    name: "Cat with Tears of Joy",
    keywords: [
      "animal",
      "cats",
      "haha",
      "happy"
    ],
    skins: [
      {
        unified: "1f639",
        native: "😹"
      }
    ],
    version: 1
  },
  heart_eyes_cat: {
    id: "heart_eyes_cat",
    name: "Smiling Cat with Heart-Eyes",
    keywords: [
      "heart",
      "eyes",
      "animal",
      "love",
      "like",
      "affection",
      "cats",
      "valentines"
    ],
    skins: [
      {
        unified: "1f63b",
        native: "😻"
      }
    ],
    version: 1
  },
  smirk_cat: {
    id: "smirk_cat",
    name: "Cat with Wry Smile",
    keywords: [
      "smirk",
      "animal",
      "cats"
    ],
    skins: [
      {
        unified: "1f63c",
        native: "😼"
      }
    ],
    version: 1
  },
  kissing_cat: {
    id: "kissing_cat",
    name: "Kissing Cat",
    keywords: [
      "animal",
      "cats",
      "kiss"
    ],
    skins: [
      {
        unified: "1f63d",
        native: "😽"
      }
    ],
    version: 1
  },
  scream_cat: {
    id: "scream_cat",
    name: "Weary Cat",
    keywords: [
      "scream",
      "animal",
      "cats",
      "munch",
      "scared"
    ],
    skins: [
      {
        unified: "1f640",
        native: "🙀"
      }
    ],
    version: 1
  },
  crying_cat_face: {
    id: "crying_cat_face",
    name: "Crying Cat",
    keywords: [
      "face",
      "animal",
      "tears",
      "weep",
      "sad",
      "cats",
      "upset",
      "cry"
    ],
    skins: [
      {
        unified: "1f63f",
        native: "😿"
      }
    ],
    version: 1
  },
  pouting_cat: {
    id: "pouting_cat",
    name: "Pouting Cat",
    keywords: [
      "animal",
      "cats"
    ],
    skins: [
      {
        unified: "1f63e",
        native: "😾"
      }
    ],
    version: 1
  },
  see_no_evil: {
    id: "see_no_evil",
    name: "See-No-Evil Monkey",
    keywords: [
      "see",
      "no",
      "evil",
      "animal",
      "nature",
      "haha"
    ],
    skins: [
      {
        unified: "1f648",
        native: "🙈"
      }
    ],
    version: 1
  },
  hear_no_evil: {
    id: "hear_no_evil",
    name: "Hear-No-Evil Monkey",
    keywords: [
      "hear",
      "no",
      "evil",
      "animal",
      "nature"
    ],
    skins: [
      {
        unified: "1f649",
        native: "🙉"
      }
    ],
    version: 1
  },
  speak_no_evil: {
    id: "speak_no_evil",
    name: "Speak-No-Evil Monkey",
    keywords: [
      "speak",
      "no",
      "evil",
      "animal",
      "nature",
      "omg"
    ],
    skins: [
      {
        unified: "1f64a",
        native: "🙊"
      }
    ],
    version: 1
  },
  love_letter: {
    id: "love_letter",
    name: "Love Letter",
    keywords: [
      "email",
      "like",
      "affection",
      "envelope",
      "valentines"
    ],
    skins: [
      {
        unified: "1f48c",
        native: "💌"
      }
    ],
    version: 1
  },
  cupid: {
    id: "cupid",
    name: "Heart with Arrow",
    keywords: [
      "cupid",
      "love",
      "like",
      "affection",
      "valentines"
    ],
    skins: [
      {
        unified: "1f498",
        native: "💘"
      }
    ],
    version: 1
  },
  gift_heart: {
    id: "gift_heart",
    name: "Heart with Ribbon",
    keywords: [
      "gift",
      "love",
      "valentines"
    ],
    skins: [
      {
        unified: "1f49d",
        native: "💝"
      }
    ],
    version: 1
  },
  sparkling_heart: {
    id: "sparkling_heart",
    name: "Sparkling Heart",
    keywords: [
      "love",
      "like",
      "affection",
      "valentines"
    ],
    skins: [
      {
        unified: "1f496",
        native: "💖"
      }
    ],
    version: 1
  },
  heartpulse: {
    id: "heartpulse",
    name: "Growing Heart",
    keywords: [
      "heartpulse",
      "like",
      "love",
      "affection",
      "valentines",
      "pink"
    ],
    skins: [
      {
        unified: "1f497",
        native: "💗"
      }
    ],
    version: 1
  },
  heartbeat: {
    id: "heartbeat",
    name: "Beating Heart",
    keywords: [
      "heartbeat",
      "love",
      "like",
      "affection",
      "valentines",
      "pink"
    ],
    skins: [
      {
        unified: "1f493",
        native: "💓"
      }
    ],
    version: 1
  },
  revolving_hearts: {
    id: "revolving_hearts",
    name: "Revolving Hearts",
    keywords: [
      "love",
      "like",
      "affection",
      "valentines"
    ],
    skins: [
      {
        unified: "1f49e",
        native: "💞"
      }
    ],
    version: 1
  },
  two_hearts: {
    id: "two_hearts",
    name: "Two Hearts",
    keywords: [
      "love",
      "like",
      "affection",
      "valentines",
      "heart"
    ],
    skins: [
      {
        unified: "1f495",
        native: "💕"
      }
    ],
    version: 1
  },
  heart_decoration: {
    id: "heart_decoration",
    name: "Heart Decoration",
    keywords: [
      "purple",
      "square",
      "love",
      "like"
    ],
    skins: [
      {
        unified: "1f49f",
        native: "💟"
      }
    ],
    version: 1
  },
  heavy_heart_exclamation_mark_ornament: {
    id: "heavy_heart_exclamation_mark_ornament",
    name: "Heart Exclamation",
    keywords: [
      "heavy",
      "mark",
      "ornament",
      "decoration",
      "love"
    ],
    skins: [
      {
        unified: "2763-fe0f",
        native: "❣️"
      }
    ],
    version: 1
  },
  broken_heart: {
    id: "broken_heart",
    name: "Broken Heart",
    emoticons: [
      "</3"
    ],
    keywords: [
      "sad",
      "sorry",
      "break",
      "heartbreak"
    ],
    skins: [
      {
        unified: "1f494",
        native: "💔"
      }
    ],
    version: 1
  },
  heart_on_fire: {
    id: "heart_on_fire",
    name: "Heart on Fire",
    keywords: [
      "passionate",
      "enthusiastic"
    ],
    skins: [
      {
        unified: "2764-fe0f-200d-1f525",
        native: "❤️‍🔥"
      }
    ],
    version: 13.1
  },
  mending_heart: {
    id: "mending_heart",
    name: "Mending Heart",
    keywords: [
      "broken",
      "bandage",
      "wounded"
    ],
    skins: [
      {
        unified: "2764-fe0f-200d-1fa79",
        native: "❤️‍🩹"
      }
    ],
    version: 13.1
  },
  heart: {
    id: "heart",
    name: "Red Heart",
    emoticons: [
      "<3"
    ],
    keywords: [
      "love",
      "like",
      "valentines"
    ],
    skins: [
      {
        unified: "2764-fe0f",
        native: "❤️"
      }
    ],
    version: 1
  },
  pink_heart: {
    id: "pink_heart",
    name: "Pink Heart",
    keywords: [
      "valentines"
    ],
    skins: [
      {
        unified: "1fa77",
        native: "🩷"
      }
    ],
    version: 15
  },
  orange_heart: {
    id: "orange_heart",
    name: "Orange Heart",
    keywords: [
      "love",
      "like",
      "affection",
      "valentines"
    ],
    skins: [
      {
        unified: "1f9e1",
        native: "🧡"
      }
    ],
    version: 5
  },
  yellow_heart: {
    id: "yellow_heart",
    name: "Yellow Heart",
    emoticons: [
      "<3"
    ],
    keywords: [
      "love",
      "like",
      "affection",
      "valentines"
    ],
    skins: [
      {
        unified: "1f49b",
        native: "💛"
      }
    ],
    version: 1
  },
  green_heart: {
    id: "green_heart",
    name: "Green Heart",
    emoticons: [
      "<3"
    ],
    keywords: [
      "love",
      "like",
      "affection",
      "valentines"
    ],
    skins: [
      {
        unified: "1f49a",
        native: "💚"
      }
    ],
    version: 1
  },
  blue_heart: {
    id: "blue_heart",
    name: "Blue Heart",
    emoticons: [
      "<3"
    ],
    keywords: [
      "love",
      "like",
      "affection",
      "valentines"
    ],
    skins: [
      {
        unified: "1f499",
        native: "💙"
      }
    ],
    version: 1
  },
  light_blue_heart: {
    id: "light_blue_heart",
    name: "Light Blue Heart",
    keywords: [
      "ice",
      "baby"
    ],
    skins: [
      {
        unified: "1fa75",
        native: "🩵"
      }
    ],
    version: 15
  },
  purple_heart: {
    id: "purple_heart",
    name: "Purple Heart",
    emoticons: [
      "<3"
    ],
    keywords: [
      "love",
      "like",
      "affection",
      "valentines"
    ],
    skins: [
      {
        unified: "1f49c",
        native: "💜"
      }
    ],
    version: 1
  },
  brown_heart: {
    id: "brown_heart",
    name: "Brown Heart",
    keywords: [
      "coffee"
    ],
    skins: [
      {
        unified: "1f90e",
        native: "🤎"
      }
    ],
    version: 12
  },
  black_heart: {
    id: "black_heart",
    name: "Black Heart",
    keywords: [
      "evil"
    ],
    skins: [
      {
        unified: "1f5a4",
        native: "🖤"
      }
    ],
    version: 3
  },
  grey_heart: {
    id: "grey_heart",
    name: "Grey Heart",
    keywords: [
      "silver",
      "monochrome"
    ],
    skins: [
      {
        unified: "1fa76",
        native: "🩶"
      }
    ],
    version: 15
  },
  white_heart: {
    id: "white_heart",
    name: "White Heart",
    keywords: [
      "pure"
    ],
    skins: [
      {
        unified: "1f90d",
        native: "🤍"
      }
    ],
    version: 12
  },
  kiss: {
    id: "kiss",
    name: "Kiss Mark",
    keywords: [
      "face",
      "lips",
      "love",
      "like",
      "affection",
      "valentines"
    ],
    skins: [
      {
        unified: "1f48b",
        native: "💋"
      }
    ],
    version: 1
  },
  anger: {
    id: "anger",
    name: "Anger Symbol",
    keywords: [
      "angry",
      "mad"
    ],
    skins: [
      {
        unified: "1f4a2",
        native: "💢"
      }
    ],
    version: 1
  },
  boom: {
    id: "boom",
    name: "Collision",
    keywords: [
      "boom",
      "bomb",
      "explode",
      "explosion",
      "blown"
    ],
    skins: [
      {
        unified: "1f4a5",
        native: "💥"
      }
    ],
    version: 1
  },
  dizzy: {
    id: "dizzy",
    name: "Dizzy",
    keywords: [
      "star",
      "sparkle",
      "shoot",
      "magic"
    ],
    skins: [
      {
        unified: "1f4ab",
        native: "💫"
      }
    ],
    version: 1
  },
  sweat_drops: {
    id: "sweat_drops",
    name: "Sweat Droplets",
    keywords: [
      "drops",
      "water",
      "drip",
      "oops"
    ],
    skins: [
      {
        unified: "1f4a6",
        native: "💦"
      }
    ],
    version: 1
  },
  dash: {
    id: "dash",
    name: "Dash Symbol",
    keywords: [
      "dashing",
      "away",
      "wind",
      "air",
      "fast",
      "shoo",
      "fart",
      "smoke",
      "puff"
    ],
    skins: [
      {
        unified: "1f4a8",
        native: "💨"
      }
    ],
    version: 1
  },
  hole: {
    id: "hole",
    name: "Hole",
    keywords: [
      "embarrassing"
    ],
    skins: [
      {
        unified: "1f573-fe0f",
        native: "🕳️"
      }
    ],
    version: 1
  },
  speech_balloon: {
    id: "speech_balloon",
    name: "Speech Balloon",
    keywords: [
      "bubble",
      "words",
      "message",
      "talk",
      "chatting"
    ],
    skins: [
      {
        unified: "1f4ac",
        native: "💬"
      }
    ],
    version: 1
  },
  "eye-in-speech-bubble": {
    id: "eye-in-speech-bubble",
    name: "Eye in Speech Bubble",
    keywords: [
      "in-speech-bubble",
      "info"
    ],
    skins: [
      {
        unified: "1f441-fe0f-200d-1f5e8-fe0f",
        native: "👁️‍🗨️"
      }
    ],
    version: 2
  },
  left_speech_bubble: {
    id: "left_speech_bubble",
    name: "Left Speech Bubble",
    keywords: [
      "words",
      "message",
      "talk",
      "chatting"
    ],
    skins: [
      {
        unified: "1f5e8-fe0f",
        native: "🗨️"
      }
    ],
    version: 2
  },
  right_anger_bubble: {
    id: "right_anger_bubble",
    name: "Right Anger Bubble",
    keywords: [
      "caption",
      "speech",
      "thinking",
      "mad"
    ],
    skins: [
      {
        unified: "1f5ef-fe0f",
        native: "🗯️"
      }
    ],
    version: 1
  },
  thought_balloon: {
    id: "thought_balloon",
    name: "Thought Balloon",
    keywords: [
      "bubble",
      "cloud",
      "speech",
      "thinking",
      "dream"
    ],
    skins: [
      {
        unified: "1f4ad",
        native: "💭"
      }
    ],
    version: 1
  },
  zzz: {
    id: "zzz",
    name: "Zzz",
    keywords: [
      "sleepy",
      "tired",
      "dream"
    ],
    skins: [
      {
        unified: "1f4a4",
        native: "💤"
      }
    ],
    version: 1
  },
  wave: {
    id: "wave",
    name: "Waving Hand",
    keywords: [
      "wave",
      "hands",
      "gesture",
      "goodbye",
      "solong",
      "farewell",
      "hello",
      "hi",
      "palm"
    ],
    skins: [
      {
        unified: "1f44b",
        native: "👋"
      },
      {
        unified: "1f44b-1f3fb",
        native: "👋🏻"
      },
      {
        unified: "1f44b-1f3fc",
        native: "👋🏼"
      },
      {
        unified: "1f44b-1f3fd",
        native: "👋🏽"
      },
      {
        unified: "1f44b-1f3fe",
        native: "👋🏾"
      },
      {
        unified: "1f44b-1f3ff",
        native: "👋🏿"
      }
    ],
    version: 1
  },
  raised_back_of_hand: {
    id: "raised_back_of_hand",
    name: "Raised Back of Hand",
    keywords: [
      "fingers",
      "backhand"
    ],
    skins: [
      {
        unified: "1f91a",
        native: "🤚"
      },
      {
        unified: "1f91a-1f3fb",
        native: "🤚🏻"
      },
      {
        unified: "1f91a-1f3fc",
        native: "🤚🏼"
      },
      {
        unified: "1f91a-1f3fd",
        native: "🤚🏽"
      },
      {
        unified: "1f91a-1f3fe",
        native: "🤚🏾"
      },
      {
        unified: "1f91a-1f3ff",
        native: "🤚🏿"
      }
    ],
    version: 3
  },
  raised_hand_with_fingers_splayed: {
    id: "raised_hand_with_fingers_splayed",
    name: "Hand with Fingers Splayed",
    keywords: [
      "raised",
      "palm"
    ],
    skins: [
      {
        unified: "1f590-fe0f",
        native: "🖐️"
      },
      {
        unified: "1f590-1f3fb",
        native: "🖐🏻"
      },
      {
        unified: "1f590-1f3fc",
        native: "🖐🏼"
      },
      {
        unified: "1f590-1f3fd",
        native: "🖐🏽"
      },
      {
        unified: "1f590-1f3fe",
        native: "🖐🏾"
      },
      {
        unified: "1f590-1f3ff",
        native: "🖐🏿"
      }
    ],
    version: 1
  },
  hand: {
    id: "hand",
    name: "Raised Hand",
    keywords: [
      "fingers",
      "stop",
      "highfive",
      "high",
      "five",
      "palm",
      "ban"
    ],
    skins: [
      {
        unified: "270b",
        native: "✋"
      },
      {
        unified: "270b-1f3fb",
        native: "✋🏻"
      },
      {
        unified: "270b-1f3fc",
        native: "✋🏼"
      },
      {
        unified: "270b-1f3fd",
        native: "✋🏽"
      },
      {
        unified: "270b-1f3fe",
        native: "✋🏾"
      },
      {
        unified: "270b-1f3ff",
        native: "✋🏿"
      }
    ],
    version: 1
  },
  "spock-hand": {
    id: "spock-hand",
    name: "Vulcan Salute",
    keywords: [
      "spock",
      "hand",
      "fingers",
      "star",
      "trek"
    ],
    skins: [
      {
        unified: "1f596",
        native: "🖖"
      },
      {
        unified: "1f596-1f3fb",
        native: "🖖🏻"
      },
      {
        unified: "1f596-1f3fc",
        native: "🖖🏼"
      },
      {
        unified: "1f596-1f3fd",
        native: "🖖🏽"
      },
      {
        unified: "1f596-1f3fe",
        native: "🖖🏾"
      },
      {
        unified: "1f596-1f3ff",
        native: "🖖🏿"
      }
    ],
    version: 1
  },
  rightwards_hand: {
    id: "rightwards_hand",
    name: "Rightwards Hand",
    keywords: [
      "palm",
      "offer"
    ],
    skins: [
      {
        unified: "1faf1",
        native: "🫱"
      },
      {
        unified: "1faf1-1f3fb",
        native: "🫱🏻"
      },
      {
        unified: "1faf1-1f3fc",
        native: "🫱🏼"
      },
      {
        unified: "1faf1-1f3fd",
        native: "🫱🏽"
      },
      {
        unified: "1faf1-1f3fe",
        native: "🫱🏾"
      },
      {
        unified: "1faf1-1f3ff",
        native: "🫱🏿"
      }
    ],
    version: 14
  },
  leftwards_hand: {
    id: "leftwards_hand",
    name: "Leftwards Hand",
    keywords: [
      "palm",
      "offer"
    ],
    skins: [
      {
        unified: "1faf2",
        native: "🫲"
      },
      {
        unified: "1faf2-1f3fb",
        native: "🫲🏻"
      },
      {
        unified: "1faf2-1f3fc",
        native: "🫲🏼"
      },
      {
        unified: "1faf2-1f3fd",
        native: "🫲🏽"
      },
      {
        unified: "1faf2-1f3fe",
        native: "🫲🏾"
      },
      {
        unified: "1faf2-1f3ff",
        native: "🫲🏿"
      }
    ],
    version: 14
  },
  palm_down_hand: {
    id: "palm_down_hand",
    name: "Palm Down Hand",
    keywords: [
      "drop"
    ],
    skins: [
      {
        unified: "1faf3",
        native: "🫳"
      },
      {
        unified: "1faf3-1f3fb",
        native: "🫳🏻"
      },
      {
        unified: "1faf3-1f3fc",
        native: "🫳🏼"
      },
      {
        unified: "1faf3-1f3fd",
        native: "🫳🏽"
      },
      {
        unified: "1faf3-1f3fe",
        native: "🫳🏾"
      },
      {
        unified: "1faf3-1f3ff",
        native: "🫳🏿"
      }
    ],
    version: 14
  },
  palm_up_hand: {
    id: "palm_up_hand",
    name: "Palm Up Hand",
    keywords: [
      "lift",
      "offer",
      "demand"
    ],
    skins: [
      {
        unified: "1faf4",
        native: "🫴"
      },
      {
        unified: "1faf4-1f3fb",
        native: "🫴🏻"
      },
      {
        unified: "1faf4-1f3fc",
        native: "🫴🏼"
      },
      {
        unified: "1faf4-1f3fd",
        native: "🫴🏽"
      },
      {
        unified: "1faf4-1f3fe",
        native: "🫴🏾"
      },
      {
        unified: "1faf4-1f3ff",
        native: "🫴🏿"
      }
    ],
    version: 14
  },
  leftwards_pushing_hand: {
    id: "leftwards_pushing_hand",
    name: "Leftwards Pushing Hand",
    keywords: [
      "highfive",
      "high",
      "five",
      "pressing",
      "stop"
    ],
    skins: [
      {
        unified: "1faf7",
        native: "🫷"
      },
      {
        unified: "1faf7-1f3fb",
        native: "🫷🏻"
      },
      {
        unified: "1faf7-1f3fc",
        native: "🫷🏼"
      },
      {
        unified: "1faf7-1f3fd",
        native: "🫷🏽"
      },
      {
        unified: "1faf7-1f3fe",
        native: "🫷🏾"
      },
      {
        unified: "1faf7-1f3ff",
        native: "🫷🏿"
      }
    ],
    version: 15
  },
  rightwards_pushing_hand: {
    id: "rightwards_pushing_hand",
    name: "Rightwards Pushing Hand",
    keywords: [
      "highfive",
      "high",
      "five",
      "pressing",
      "stop"
    ],
    skins: [
      {
        unified: "1faf8",
        native: "🫸"
      },
      {
        unified: "1faf8-1f3fb",
        native: "🫸🏻"
      },
      {
        unified: "1faf8-1f3fc",
        native: "🫸🏼"
      },
      {
        unified: "1faf8-1f3fd",
        native: "🫸🏽"
      },
      {
        unified: "1faf8-1f3fe",
        native: "🫸🏾"
      },
      {
        unified: "1faf8-1f3ff",
        native: "🫸🏿"
      }
    ],
    version: 15
  },
  ok_hand: {
    id: "ok_hand",
    name: "Ok Hand",
    keywords: [
      "fingers",
      "limbs",
      "perfect",
      "okay"
    ],
    skins: [
      {
        unified: "1f44c",
        native: "👌"
      },
      {
        unified: "1f44c-1f3fb",
        native: "👌🏻"
      },
      {
        unified: "1f44c-1f3fc",
        native: "👌🏼"
      },
      {
        unified: "1f44c-1f3fd",
        native: "👌🏽"
      },
      {
        unified: "1f44c-1f3fe",
        native: "👌🏾"
      },
      {
        unified: "1f44c-1f3ff",
        native: "👌🏿"
      }
    ],
    version: 1
  },
  pinched_fingers: {
    id: "pinched_fingers",
    name: "Pinched Fingers",
    keywords: [
      "size",
      "tiny",
      "small"
    ],
    skins: [
      {
        unified: "1f90c",
        native: "🤌"
      },
      {
        unified: "1f90c-1f3fb",
        native: "🤌🏻"
      },
      {
        unified: "1f90c-1f3fc",
        native: "🤌🏼"
      },
      {
        unified: "1f90c-1f3fd",
        native: "🤌🏽"
      },
      {
        unified: "1f90c-1f3fe",
        native: "🤌🏾"
      },
      {
        unified: "1f90c-1f3ff",
        native: "🤌🏿"
      }
    ],
    version: 13
  },
  pinching_hand: {
    id: "pinching_hand",
    name: "Pinching Hand",
    keywords: [
      "tiny",
      "small",
      "size"
    ],
    skins: [
      {
        unified: "1f90f",
        native: "🤏"
      },
      {
        unified: "1f90f-1f3fb",
        native: "🤏🏻"
      },
      {
        unified: "1f90f-1f3fc",
        native: "🤏🏼"
      },
      {
        unified: "1f90f-1f3fd",
        native: "🤏🏽"
      },
      {
        unified: "1f90f-1f3fe",
        native: "🤏🏾"
      },
      {
        unified: "1f90f-1f3ff",
        native: "🤏🏿"
      }
    ],
    version: 12
  },
  v: {
    id: "v",
    name: "Victory Hand",
    keywords: [
      "v",
      "fingers",
      "ohyeah",
      "peace",
      "two"
    ],
    skins: [
      {
        unified: "270c-fe0f",
        native: "✌️"
      },
      {
        unified: "270c-1f3fb",
        native: "✌🏻"
      },
      {
        unified: "270c-1f3fc",
        native: "✌🏼"
      },
      {
        unified: "270c-1f3fd",
        native: "✌🏽"
      },
      {
        unified: "270c-1f3fe",
        native: "✌🏾"
      },
      {
        unified: "270c-1f3ff",
        native: "✌🏿"
      }
    ],
    version: 1
  },
  crossed_fingers: {
    id: "crossed_fingers",
    name: "Crossed Fingers",
    keywords: [
      "hand",
      "with",
      "index",
      "and",
      "middle",
      "good",
      "lucky"
    ],
    skins: [
      {
        unified: "1f91e",
        native: "🤞"
      },
      {
        unified: "1f91e-1f3fb",
        native: "🤞🏻"
      },
      {
        unified: "1f91e-1f3fc",
        native: "🤞🏼"
      },
      {
        unified: "1f91e-1f3fd",
        native: "🤞🏽"
      },
      {
        unified: "1f91e-1f3fe",
        native: "🤞🏾"
      },
      {
        unified: "1f91e-1f3ff",
        native: "🤞🏿"
      }
    ],
    version: 3
  },
  hand_with_index_finger_and_thumb_crossed: {
    id: "hand_with_index_finger_and_thumb_crossed",
    name: "Hand with Index Finger and Thumb Crossed",
    keywords: [
      "heart",
      "love",
      "money",
      "expensive"
    ],
    skins: [
      {
        unified: "1faf0",
        native: "🫰"
      },
      {
        unified: "1faf0-1f3fb",
        native: "🫰🏻"
      },
      {
        unified: "1faf0-1f3fc",
        native: "🫰🏼"
      },
      {
        unified: "1faf0-1f3fd",
        native: "🫰🏽"
      },
      {
        unified: "1faf0-1f3fe",
        native: "🫰🏾"
      },
      {
        unified: "1faf0-1f3ff",
        native: "🫰🏿"
      }
    ],
    version: 14
  },
  i_love_you_hand_sign: {
    id: "i_love_you_hand_sign",
    name: "Love-You Gesture",
    keywords: [
      "i",
      "love",
      "you",
      "hand",
      "sign",
      "fingers"
    ],
    skins: [
      {
        unified: "1f91f",
        native: "🤟"
      },
      {
        unified: "1f91f-1f3fb",
        native: "🤟🏻"
      },
      {
        unified: "1f91f-1f3fc",
        native: "🤟🏼"
      },
      {
        unified: "1f91f-1f3fd",
        native: "🤟🏽"
      },
      {
        unified: "1f91f-1f3fe",
        native: "🤟🏾"
      },
      {
        unified: "1f91f-1f3ff",
        native: "🤟🏿"
      }
    ],
    version: 5
  },
  the_horns: {
    id: "the_horns",
    name: "Sign of the Horns",
    keywords: [
      "hand",
      "fingers",
      "evil",
      "eye",
      "rock",
      "on"
    ],
    skins: [
      {
        unified: "1f918",
        native: "🤘"
      },
      {
        unified: "1f918-1f3fb",
        native: "🤘🏻"
      },
      {
        unified: "1f918-1f3fc",
        native: "🤘🏼"
      },
      {
        unified: "1f918-1f3fd",
        native: "🤘🏽"
      },
      {
        unified: "1f918-1f3fe",
        native: "🤘🏾"
      },
      {
        unified: "1f918-1f3ff",
        native: "🤘🏿"
      }
    ],
    version: 1
  },
  call_me_hand: {
    id: "call_me_hand",
    name: "Call Me Hand",
    keywords: [
      "hands",
      "gesture",
      "shaka"
    ],
    skins: [
      {
        unified: "1f919",
        native: "🤙"
      },
      {
        unified: "1f919-1f3fb",
        native: "🤙🏻"
      },
      {
        unified: "1f919-1f3fc",
        native: "🤙🏼"
      },
      {
        unified: "1f919-1f3fd",
        native: "🤙🏽"
      },
      {
        unified: "1f919-1f3fe",
        native: "🤙🏾"
      },
      {
        unified: "1f919-1f3ff",
        native: "🤙🏿"
      }
    ],
    version: 3
  },
  point_left: {
    id: "point_left",
    name: "Backhand Index Pointing Left",
    keywords: [
      "point",
      "direction",
      "fingers",
      "hand"
    ],
    skins: [
      {
        unified: "1f448",
        native: "👈"
      },
      {
        unified: "1f448-1f3fb",
        native: "👈🏻"
      },
      {
        unified: "1f448-1f3fc",
        native: "👈🏼"
      },
      {
        unified: "1f448-1f3fd",
        native: "👈🏽"
      },
      {
        unified: "1f448-1f3fe",
        native: "👈🏾"
      },
      {
        unified: "1f448-1f3ff",
        native: "👈🏿"
      }
    ],
    version: 1
  },
  point_right: {
    id: "point_right",
    name: "Backhand Index Pointing Right",
    keywords: [
      "point",
      "fingers",
      "hand",
      "direction"
    ],
    skins: [
      {
        unified: "1f449",
        native: "👉"
      },
      {
        unified: "1f449-1f3fb",
        native: "👉🏻"
      },
      {
        unified: "1f449-1f3fc",
        native: "👉🏼"
      },
      {
        unified: "1f449-1f3fd",
        native: "👉🏽"
      },
      {
        unified: "1f449-1f3fe",
        native: "👉🏾"
      },
      {
        unified: "1f449-1f3ff",
        native: "👉🏿"
      }
    ],
    version: 1
  },
  point_up_2: {
    id: "point_up_2",
    name: "Backhand Index Pointing Up",
    keywords: [
      "point",
      "2",
      "fingers",
      "hand",
      "direction"
    ],
    skins: [
      {
        unified: "1f446",
        native: "👆"
      },
      {
        unified: "1f446-1f3fb",
        native: "👆🏻"
      },
      {
        unified: "1f446-1f3fc",
        native: "👆🏼"
      },
      {
        unified: "1f446-1f3fd",
        native: "👆🏽"
      },
      {
        unified: "1f446-1f3fe",
        native: "👆🏾"
      },
      {
        unified: "1f446-1f3ff",
        native: "👆🏿"
      }
    ],
    version: 1
  },
  middle_finger: {
    id: "middle_finger",
    name: "Middle Finger",
    keywords: [
      "reversed",
      "hand",
      "with",
      "extended",
      "fingers",
      "rude",
      "flipping"
    ],
    skins: [
      {
        unified: "1f595",
        native: "🖕"
      },
      {
        unified: "1f595-1f3fb",
        native: "🖕🏻"
      },
      {
        unified: "1f595-1f3fc",
        native: "🖕🏼"
      },
      {
        unified: "1f595-1f3fd",
        native: "🖕🏽"
      },
      {
        unified: "1f595-1f3fe",
        native: "🖕🏾"
      },
      {
        unified: "1f595-1f3ff",
        native: "🖕🏿"
      }
    ],
    version: 1
  },
  point_down: {
    id: "point_down",
    name: "Backhand Index Pointing Down",
    keywords: [
      "point",
      "fingers",
      "hand",
      "direction"
    ],
    skins: [
      {
        unified: "1f447",
        native: "👇"
      },
      {
        unified: "1f447-1f3fb",
        native: "👇🏻"
      },
      {
        unified: "1f447-1f3fc",
        native: "👇🏼"
      },
      {
        unified: "1f447-1f3fd",
        native: "👇🏽"
      },
      {
        unified: "1f447-1f3fe",
        native: "👇🏾"
      },
      {
        unified: "1f447-1f3ff",
        native: "👇🏿"
      }
    ],
    version: 1
  },
  point_up: {
    id: "point_up",
    name: "Index Pointing Up",
    keywords: [
      "point",
      "hand",
      "fingers",
      "direction"
    ],
    skins: [
      {
        unified: "261d-fe0f",
        native: "☝️"
      },
      {
        unified: "261d-1f3fb",
        native: "☝🏻"
      },
      {
        unified: "261d-1f3fc",
        native: "☝🏼"
      },
      {
        unified: "261d-1f3fd",
        native: "☝🏽"
      },
      {
        unified: "261d-1f3fe",
        native: "☝🏾"
      },
      {
        unified: "261d-1f3ff",
        native: "☝🏿"
      }
    ],
    version: 1
  },
  index_pointing_at_the_viewer: {
    id: "index_pointing_at_the_viewer",
    name: "Index Pointing at the Viewer",
    keywords: [
      "you",
      "recruit"
    ],
    skins: [
      {
        unified: "1faf5",
        native: "🫵"
      },
      {
        unified: "1faf5-1f3fb",
        native: "🫵🏻"
      },
      {
        unified: "1faf5-1f3fc",
        native: "🫵🏼"
      },
      {
        unified: "1faf5-1f3fd",
        native: "🫵🏽"
      },
      {
        unified: "1faf5-1f3fe",
        native: "🫵🏾"
      },
      {
        unified: "1faf5-1f3ff",
        native: "🫵🏿"
      }
    ],
    version: 14
  },
  "+1": {
    id: "+1",
    name: "Thumbs Up",
    keywords: [
      "+1",
      "thumbsup",
      "yes",
      "awesome",
      "good",
      "agree",
      "accept",
      "cool",
      "hand",
      "like"
    ],
    skins: [
      {
        unified: "1f44d",
        native: "👍"
      },
      {
        unified: "1f44d-1f3fb",
        native: "👍🏻"
      },
      {
        unified: "1f44d-1f3fc",
        native: "👍🏼"
      },
      {
        unified: "1f44d-1f3fd",
        native: "👍🏽"
      },
      {
        unified: "1f44d-1f3fe",
        native: "👍🏾"
      },
      {
        unified: "1f44d-1f3ff",
        native: "👍🏿"
      }
    ],
    version: 1
  },
  "-1": {
    id: "-1",
    name: "Thumbs Down",
    keywords: [
      "-1",
      "thumbsdown",
      "no",
      "dislike",
      "hand"
    ],
    skins: [
      {
        unified: "1f44e",
        native: "👎"
      },
      {
        unified: "1f44e-1f3fb",
        native: "👎🏻"
      },
      {
        unified: "1f44e-1f3fc",
        native: "👎🏼"
      },
      {
        unified: "1f44e-1f3fd",
        native: "👎🏽"
      },
      {
        unified: "1f44e-1f3fe",
        native: "👎🏾"
      },
      {
        unified: "1f44e-1f3ff",
        native: "👎🏿"
      }
    ],
    version: 1
  },
  fist: {
    id: "fist",
    name: "Raised Fist",
    keywords: [
      "fingers",
      "hand",
      "grasp"
    ],
    skins: [
      {
        unified: "270a",
        native: "✊"
      },
      {
        unified: "270a-1f3fb",
        native: "✊🏻"
      },
      {
        unified: "270a-1f3fc",
        native: "✊🏼"
      },
      {
        unified: "270a-1f3fd",
        native: "✊🏽"
      },
      {
        unified: "270a-1f3fe",
        native: "✊🏾"
      },
      {
        unified: "270a-1f3ff",
        native: "✊🏿"
      }
    ],
    version: 1
  },
  facepunch: {
    id: "facepunch",
    name: "Oncoming Fist",
    keywords: [
      "facepunch",
      "punch",
      "angry",
      "violence",
      "hit",
      "attack",
      "hand"
    ],
    skins: [
      {
        unified: "1f44a",
        native: "👊"
      },
      {
        unified: "1f44a-1f3fb",
        native: "👊🏻"
      },
      {
        unified: "1f44a-1f3fc",
        native: "👊🏼"
      },
      {
        unified: "1f44a-1f3fd",
        native: "👊🏽"
      },
      {
        unified: "1f44a-1f3fe",
        native: "👊🏾"
      },
      {
        unified: "1f44a-1f3ff",
        native: "👊🏿"
      }
    ],
    version: 1
  },
  "left-facing_fist": {
    id: "left-facing_fist",
    name: "Left-Facing Fist",
    keywords: [
      "left",
      "facing",
      "hand",
      "fistbump"
    ],
    skins: [
      {
        unified: "1f91b",
        native: "🤛"
      },
      {
        unified: "1f91b-1f3fb",
        native: "🤛🏻"
      },
      {
        unified: "1f91b-1f3fc",
        native: "🤛🏼"
      },
      {
        unified: "1f91b-1f3fd",
        native: "🤛🏽"
      },
      {
        unified: "1f91b-1f3fe",
        native: "🤛🏾"
      },
      {
        unified: "1f91b-1f3ff",
        native: "🤛🏿"
      }
    ],
    version: 3
  },
  "right-facing_fist": {
    id: "right-facing_fist",
    name: "Right-Facing Fist",
    keywords: [
      "right",
      "facing",
      "hand",
      "fistbump"
    ],
    skins: [
      {
        unified: "1f91c",
        native: "🤜"
      },
      {
        unified: "1f91c-1f3fb",
        native: "🤜🏻"
      },
      {
        unified: "1f91c-1f3fc",
        native: "🤜🏼"
      },
      {
        unified: "1f91c-1f3fd",
        native: "🤜🏽"
      },
      {
        unified: "1f91c-1f3fe",
        native: "🤜🏾"
      },
      {
        unified: "1f91c-1f3ff",
        native: "🤜🏿"
      }
    ],
    version: 3
  },
  clap: {
    id: "clap",
    name: "Clapping Hands",
    keywords: [
      "clap",
      "praise",
      "applause",
      "congrats",
      "yay"
    ],
    skins: [
      {
        unified: "1f44f",
        native: "👏"
      },
      {
        unified: "1f44f-1f3fb",
        native: "👏🏻"
      },
      {
        unified: "1f44f-1f3fc",
        native: "👏🏼"
      },
      {
        unified: "1f44f-1f3fd",
        native: "👏🏽"
      },
      {
        unified: "1f44f-1f3fe",
        native: "👏🏾"
      },
      {
        unified: "1f44f-1f3ff",
        native: "👏🏿"
      }
    ],
    version: 1
  },
  raised_hands: {
    id: "raised_hands",
    name: "Raising Hands",
    keywords: [
      "raised",
      "gesture",
      "hooray",
      "yea",
      "celebration"
    ],
    skins: [
      {
        unified: "1f64c",
        native: "🙌"
      },
      {
        unified: "1f64c-1f3fb",
        native: "🙌🏻"
      },
      {
        unified: "1f64c-1f3fc",
        native: "🙌🏼"
      },
      {
        unified: "1f64c-1f3fd",
        native: "🙌🏽"
      },
      {
        unified: "1f64c-1f3fe",
        native: "🙌🏾"
      },
      {
        unified: "1f64c-1f3ff",
        native: "🙌🏿"
      }
    ],
    version: 1
  },
  heart_hands: {
    id: "heart_hands",
    name: "Heart Hands",
    keywords: [
      "love",
      "appreciation",
      "support"
    ],
    skins: [
      {
        unified: "1faf6",
        native: "🫶"
      },
      {
        unified: "1faf6-1f3fb",
        native: "🫶🏻"
      },
      {
        unified: "1faf6-1f3fc",
        native: "🫶🏼"
      },
      {
        unified: "1faf6-1f3fd",
        native: "🫶🏽"
      },
      {
        unified: "1faf6-1f3fe",
        native: "🫶🏾"
      },
      {
        unified: "1faf6-1f3ff",
        native: "🫶🏿"
      }
    ],
    version: 14
  },
  open_hands: {
    id: "open_hands",
    name: "Open Hands",
    keywords: [
      "fingers",
      "butterfly"
    ],
    skins: [
      {
        unified: "1f450",
        native: "👐"
      },
      {
        unified: "1f450-1f3fb",
        native: "👐🏻"
      },
      {
        unified: "1f450-1f3fc",
        native: "👐🏼"
      },
      {
        unified: "1f450-1f3fd",
        native: "👐🏽"
      },
      {
        unified: "1f450-1f3fe",
        native: "👐🏾"
      },
      {
        unified: "1f450-1f3ff",
        native: "👐🏿"
      }
    ],
    version: 1
  },
  palms_up_together: {
    id: "palms_up_together",
    name: "Palms Up Together",
    keywords: [
      "hands",
      "gesture",
      "cupped",
      "prayer"
    ],
    skins: [
      {
        unified: "1f932",
        native: "🤲"
      },
      {
        unified: "1f932-1f3fb",
        native: "🤲🏻"
      },
      {
        unified: "1f932-1f3fc",
        native: "🤲🏼"
      },
      {
        unified: "1f932-1f3fd",
        native: "🤲🏽"
      },
      {
        unified: "1f932-1f3fe",
        native: "🤲🏾"
      },
      {
        unified: "1f932-1f3ff",
        native: "🤲🏿"
      }
    ],
    version: 5
  },
  handshake: {
    id: "handshake",
    name: "Handshake",
    keywords: [
      "agreement",
      "shake"
    ],
    skins: [
      {
        unified: "1f91d",
        native: "🤝"
      },
      {
        unified: "1f91d-1f3fb",
        native: "🤝🏻"
      },
      {
        unified: "1f91d-1f3fc",
        native: "🤝🏼"
      },
      {
        unified: "1f91d-1f3fd",
        native: "🤝🏽"
      },
      {
        unified: "1f91d-1f3fe",
        native: "🤝🏾"
      },
      {
        unified: "1f91d-1f3ff",
        native: "🤝🏿"
      }
    ],
    version: 3
  },
  pray: {
    id: "pray",
    name: "Folded Hands",
    keywords: [
      "pray",
      "please",
      "hope",
      "wish",
      "namaste",
      "highfive",
      "high",
      "five",
      "thank",
      "you",
      "thanks",
      "appreciate"
    ],
    skins: [
      {
        unified: "1f64f",
        native: "🙏"
      },
      {
        unified: "1f64f-1f3fb",
        native: "🙏🏻"
      },
      {
        unified: "1f64f-1f3fc",
        native: "🙏🏼"
      },
      {
        unified: "1f64f-1f3fd",
        native: "🙏🏽"
      },
      {
        unified: "1f64f-1f3fe",
        native: "🙏🏾"
      },
      {
        unified: "1f64f-1f3ff",
        native: "🙏🏿"
      }
    ],
    version: 1
  },
  writing_hand: {
    id: "writing_hand",
    name: "Writing Hand",
    keywords: [
      "lower",
      "left",
      "ballpoint",
      "pen",
      "stationery",
      "write",
      "compose"
    ],
    skins: [
      {
        unified: "270d-fe0f",
        native: "✍️"
      },
      {
        unified: "270d-1f3fb",
        native: "✍🏻"
      },
      {
        unified: "270d-1f3fc",
        native: "✍🏼"
      },
      {
        unified: "270d-1f3fd",
        native: "✍🏽"
      },
      {
        unified: "270d-1f3fe",
        native: "✍🏾"
      },
      {
        unified: "270d-1f3ff",
        native: "✍🏿"
      }
    ],
    version: 1
  },
  nail_care: {
    id: "nail_care",
    name: "Nail Polish",
    keywords: [
      "care",
      "beauty",
      "manicure",
      "finger",
      "fashion"
    ],
    skins: [
      {
        unified: "1f485",
        native: "💅"
      },
      {
        unified: "1f485-1f3fb",
        native: "💅🏻"
      },
      {
        unified: "1f485-1f3fc",
        native: "💅🏼"
      },
      {
        unified: "1f485-1f3fd",
        native: "💅🏽"
      },
      {
        unified: "1f485-1f3fe",
        native: "💅🏾"
      },
      {
        unified: "1f485-1f3ff",
        native: "💅🏿"
      }
    ],
    version: 1
  },
  selfie: {
    id: "selfie",
    name: "Selfie",
    keywords: [
      "camera",
      "phone"
    ],
    skins: [
      {
        unified: "1f933",
        native: "🤳"
      },
      {
        unified: "1f933-1f3fb",
        native: "🤳🏻"
      },
      {
        unified: "1f933-1f3fc",
        native: "🤳🏼"
      },
      {
        unified: "1f933-1f3fd",
        native: "🤳🏽"
      },
      {
        unified: "1f933-1f3fe",
        native: "🤳🏾"
      },
      {
        unified: "1f933-1f3ff",
        native: "🤳🏿"
      }
    ],
    version: 3
  },
  muscle: {
    id: "muscle",
    name: "Flexed Biceps",
    keywords: [
      "muscle",
      "arm",
      "flex",
      "hand",
      "summer",
      "strong"
    ],
    skins: [
      {
        unified: "1f4aa",
        native: "💪"
      },
      {
        unified: "1f4aa-1f3fb",
        native: "💪🏻"
      },
      {
        unified: "1f4aa-1f3fc",
        native: "💪🏼"
      },
      {
        unified: "1f4aa-1f3fd",
        native: "💪🏽"
      },
      {
        unified: "1f4aa-1f3fe",
        native: "💪🏾"
      },
      {
        unified: "1f4aa-1f3ff",
        native: "💪🏿"
      }
    ],
    version: 1
  },
  mechanical_arm: {
    id: "mechanical_arm",
    name: "Mechanical Arm",
    keywords: [
      "accessibility"
    ],
    skins: [
      {
        unified: "1f9be",
        native: "🦾"
      }
    ],
    version: 12
  },
  mechanical_leg: {
    id: "mechanical_leg",
    name: "Mechanical Leg",
    keywords: [
      "accessibility"
    ],
    skins: [
      {
        unified: "1f9bf",
        native: "🦿"
      }
    ],
    version: 12
  },
  leg: {
    id: "leg",
    name: "Leg",
    keywords: [
      "kick",
      "limb"
    ],
    skins: [
      {
        unified: "1f9b5",
        native: "🦵"
      },
      {
        unified: "1f9b5-1f3fb",
        native: "🦵🏻"
      },
      {
        unified: "1f9b5-1f3fc",
        native: "🦵🏼"
      },
      {
        unified: "1f9b5-1f3fd",
        native: "🦵🏽"
      },
      {
        unified: "1f9b5-1f3fe",
        native: "🦵🏾"
      },
      {
        unified: "1f9b5-1f3ff",
        native: "🦵🏿"
      }
    ],
    version: 11
  },
  foot: {
    id: "foot",
    name: "Foot",
    keywords: [
      "kick",
      "stomp"
    ],
    skins: [
      {
        unified: "1f9b6",
        native: "🦶"
      },
      {
        unified: "1f9b6-1f3fb",
        native: "🦶🏻"
      },
      {
        unified: "1f9b6-1f3fc",
        native: "🦶🏼"
      },
      {
        unified: "1f9b6-1f3fd",
        native: "🦶🏽"
      },
      {
        unified: "1f9b6-1f3fe",
        native: "🦶🏾"
      },
      {
        unified: "1f9b6-1f3ff",
        native: "🦶🏿"
      }
    ],
    version: 11
  },
  ear: {
    id: "ear",
    name: "Ear",
    keywords: [
      "face",
      "hear",
      "sound",
      "listen"
    ],
    skins: [
      {
        unified: "1f442",
        native: "👂"
      },
      {
        unified: "1f442-1f3fb",
        native: "👂🏻"
      },
      {
        unified: "1f442-1f3fc",
        native: "👂🏼"
      },
      {
        unified: "1f442-1f3fd",
        native: "👂🏽"
      },
      {
        unified: "1f442-1f3fe",
        native: "👂🏾"
      },
      {
        unified: "1f442-1f3ff",
        native: "👂🏿"
      }
    ],
    version: 1
  },
  ear_with_hearing_aid: {
    id: "ear_with_hearing_aid",
    name: "Ear with Hearing Aid",
    keywords: [
      "accessibility"
    ],
    skins: [
      {
        unified: "1f9bb",
        native: "🦻"
      },
      {
        unified: "1f9bb-1f3fb",
        native: "🦻🏻"
      },
      {
        unified: "1f9bb-1f3fc",
        native: "🦻🏼"
      },
      {
        unified: "1f9bb-1f3fd",
        native: "🦻🏽"
      },
      {
        unified: "1f9bb-1f3fe",
        native: "🦻🏾"
      },
      {
        unified: "1f9bb-1f3ff",
        native: "🦻🏿"
      }
    ],
    version: 12
  },
  nose: {
    id: "nose",
    name: "Nose",
    keywords: [
      "smell",
      "sniff"
    ],
    skins: [
      {
        unified: "1f443",
        native: "👃"
      },
      {
        unified: "1f443-1f3fb",
        native: "👃🏻"
      },
      {
        unified: "1f443-1f3fc",
        native: "👃🏼"
      },
      {
        unified: "1f443-1f3fd",
        native: "👃🏽"
      },
      {
        unified: "1f443-1f3fe",
        native: "👃🏾"
      },
      {
        unified: "1f443-1f3ff",
        native: "👃🏿"
      }
    ],
    version: 1
  },
  brain: {
    id: "brain",
    name: "Brain",
    keywords: [
      "smart",
      "intelligent"
    ],
    skins: [
      {
        unified: "1f9e0",
        native: "🧠"
      }
    ],
    version: 5
  },
  anatomical_heart: {
    id: "anatomical_heart",
    name: "Anatomical Heart",
    keywords: [
      "health",
      "heartbeat"
    ],
    skins: [
      {
        unified: "1fac0",
        native: "🫀"
      }
    ],
    version: 13
  },
  lungs: {
    id: "lungs",
    name: "Lungs",
    keywords: [
      "breathe"
    ],
    skins: [
      {
        unified: "1fac1",
        native: "🫁"
      }
    ],
    version: 13
  },
  tooth: {
    id: "tooth",
    name: "Tooth",
    keywords: [
      "teeth",
      "dentist"
    ],
    skins: [
      {
        unified: "1f9b7",
        native: "🦷"
      }
    ],
    version: 11
  },
  bone: {
    id: "bone",
    name: "Bone",
    keywords: [
      "skeleton"
    ],
    skins: [
      {
        unified: "1f9b4",
        native: "🦴"
      }
    ],
    version: 11
  },
  eyes: {
    id: "eyes",
    name: "Eyes",
    keywords: [
      "look",
      "watch",
      "stalk",
      "peek",
      "see"
    ],
    skins: [
      {
        unified: "1f440",
        native: "👀"
      }
    ],
    version: 1
  },
  eye: {
    id: "eye",
    name: "Eye",
    keywords: [
      "face",
      "look",
      "see",
      "watch",
      "stare"
    ],
    skins: [
      {
        unified: "1f441-fe0f",
        native: "👁️"
      }
    ],
    version: 1
  },
  tongue: {
    id: "tongue",
    name: "Tongue",
    keywords: [
      "mouth",
      "playful"
    ],
    skins: [
      {
        unified: "1f445",
        native: "👅"
      }
    ],
    version: 1
  },
  lips: {
    id: "lips",
    name: "Mouth",
    keywords: [
      "lips",
      "kiss"
    ],
    skins: [
      {
        unified: "1f444",
        native: "👄"
      }
    ],
    version: 1
  },
  biting_lip: {
    id: "biting_lip",
    name: "Biting Lip",
    keywords: [
      "flirt",
      "sexy",
      "pain",
      "worry"
    ],
    skins: [
      {
        unified: "1fae6",
        native: "🫦"
      }
    ],
    version: 14
  },
  baby: {
    id: "baby",
    name: "Baby",
    keywords: [
      "child",
      "boy",
      "girl",
      "toddler"
    ],
    skins: [
      {
        unified: "1f476",
        native: "👶"
      },
      {
        unified: "1f476-1f3fb",
        native: "👶🏻"
      },
      {
        unified: "1f476-1f3fc",
        native: "👶🏼"
      },
      {
        unified: "1f476-1f3fd",
        native: "👶🏽"
      },
      {
        unified: "1f476-1f3fe",
        native: "👶🏾"
      },
      {
        unified: "1f476-1f3ff",
        native: "👶🏿"
      }
    ],
    version: 1
  },
  child: {
    id: "child",
    name: "Child",
    keywords: [
      "gender",
      "neutral",
      "young"
    ],
    skins: [
      {
        unified: "1f9d2",
        native: "🧒"
      },
      {
        unified: "1f9d2-1f3fb",
        native: "🧒🏻"
      },
      {
        unified: "1f9d2-1f3fc",
        native: "🧒🏼"
      },
      {
        unified: "1f9d2-1f3fd",
        native: "🧒🏽"
      },
      {
        unified: "1f9d2-1f3fe",
        native: "🧒🏾"
      },
      {
        unified: "1f9d2-1f3ff",
        native: "🧒🏿"
      }
    ],
    version: 5
  },
  boy: {
    id: "boy",
    name: "Boy",
    keywords: [
      "man",
      "male",
      "guy",
      "teenager"
    ],
    skins: [
      {
        unified: "1f466",
        native: "👦"
      },
      {
        unified: "1f466-1f3fb",
        native: "👦🏻"
      },
      {
        unified: "1f466-1f3fc",
        native: "👦🏼"
      },
      {
        unified: "1f466-1f3fd",
        native: "👦🏽"
      },
      {
        unified: "1f466-1f3fe",
        native: "👦🏾"
      },
      {
        unified: "1f466-1f3ff",
        native: "👦🏿"
      }
    ],
    version: 1
  },
  girl: {
    id: "girl",
    name: "Girl",
    keywords: [
      "female",
      "woman",
      "teenager"
    ],
    skins: [
      {
        unified: "1f467",
        native: "👧"
      },
      {
        unified: "1f467-1f3fb",
        native: "👧🏻"
      },
      {
        unified: "1f467-1f3fc",
        native: "👧🏼"
      },
      {
        unified: "1f467-1f3fd",
        native: "👧🏽"
      },
      {
        unified: "1f467-1f3fe",
        native: "👧🏾"
      },
      {
        unified: "1f467-1f3ff",
        native: "👧🏿"
      }
    ],
    version: 1
  },
  adult: {
    id: "adult",
    name: "Adult",
    keywords: [
      "person",
      "gender",
      "neutral"
    ],
    skins: [
      {
        unified: "1f9d1",
        native: "🧑"
      },
      {
        unified: "1f9d1-1f3fb",
        native: "🧑🏻"
      },
      {
        unified: "1f9d1-1f3fc",
        native: "🧑🏼"
      },
      {
        unified: "1f9d1-1f3fd",
        native: "🧑🏽"
      },
      {
        unified: "1f9d1-1f3fe",
        native: "🧑🏾"
      },
      {
        unified: "1f9d1-1f3ff",
        native: "🧑🏿"
      }
    ],
    version: 5
  },
  person_with_blond_hair: {
    id: "person_with_blond_hair",
    name: "Person Blond Hair",
    keywords: [
      "with",
      "hairstyle"
    ],
    skins: [
      {
        unified: "1f471",
        native: "👱"
      },
      {
        unified: "1f471-1f3fb",
        native: "👱🏻"
      },
      {
        unified: "1f471-1f3fc",
        native: "👱🏼"
      },
      {
        unified: "1f471-1f3fd",
        native: "👱🏽"
      },
      {
        unified: "1f471-1f3fe",
        native: "👱🏾"
      },
      {
        unified: "1f471-1f3ff",
        native: "👱🏿"
      }
    ],
    version: 1
  },
  man: {
    id: "man",
    name: "Man",
    keywords: [
      "mustache",
      "father",
      "dad",
      "guy",
      "classy",
      "sir",
      "moustache"
    ],
    skins: [
      {
        unified: "1f468",
        native: "👨"
      },
      {
        unified: "1f468-1f3fb",
        native: "👨🏻"
      },
      {
        unified: "1f468-1f3fc",
        native: "👨🏼"
      },
      {
        unified: "1f468-1f3fd",
        native: "👨🏽"
      },
      {
        unified: "1f468-1f3fe",
        native: "👨🏾"
      },
      {
        unified: "1f468-1f3ff",
        native: "👨🏿"
      }
    ],
    version: 1
  },
  bearded_person: {
    id: "bearded_person",
    name: "Person Beard",
    keywords: [
      "bearded",
      "man",
      "bewhiskered"
    ],
    skins: [
      {
        unified: "1f9d4",
        native: "🧔"
      },
      {
        unified: "1f9d4-1f3fb",
        native: "🧔🏻"
      },
      {
        unified: "1f9d4-1f3fc",
        native: "🧔🏼"
      },
      {
        unified: "1f9d4-1f3fd",
        native: "🧔🏽"
      },
      {
        unified: "1f9d4-1f3fe",
        native: "🧔🏾"
      },
      {
        unified: "1f9d4-1f3ff",
        native: "🧔🏿"
      }
    ],
    version: 5
  },
  man_with_beard: {
    id: "man_with_beard",
    name: "Man: Beard",
    keywords: [
      "man",
      "with",
      "facial",
      "hair"
    ],
    skins: [
      {
        unified: "1f9d4-200d-2642-fe0f",
        native: "🧔‍♂️"
      },
      {
        unified: "1f9d4-1f3fb-200d-2642-fe0f",
        native: "🧔🏻‍♂️"
      },
      {
        unified: "1f9d4-1f3fc-200d-2642-fe0f",
        native: "🧔🏼‍♂️"
      },
      {
        unified: "1f9d4-1f3fd-200d-2642-fe0f",
        native: "🧔🏽‍♂️"
      },
      {
        unified: "1f9d4-1f3fe-200d-2642-fe0f",
        native: "🧔🏾‍♂️"
      },
      {
        unified: "1f9d4-1f3ff-200d-2642-fe0f",
        native: "🧔🏿‍♂️"
      }
    ],
    version: 13.1
  },
  woman_with_beard: {
    id: "woman_with_beard",
    name: "Woman: Beard",
    keywords: [
      "woman",
      "with",
      "facial",
      "hair"
    ],
    skins: [
      {
        unified: "1f9d4-200d-2640-fe0f",
        native: "🧔‍♀️"
      },
      {
        unified: "1f9d4-1f3fb-200d-2640-fe0f",
        native: "🧔🏻‍♀️"
      },
      {
        unified: "1f9d4-1f3fc-200d-2640-fe0f",
        native: "🧔🏼‍♀️"
      },
      {
        unified: "1f9d4-1f3fd-200d-2640-fe0f",
        native: "🧔🏽‍♀️"
      },
      {
        unified: "1f9d4-1f3fe-200d-2640-fe0f",
        native: "🧔🏾‍♀️"
      },
      {
        unified: "1f9d4-1f3ff-200d-2640-fe0f",
        native: "🧔🏿‍♀️"
      }
    ],
    version: 13.1
  },
  red_haired_man: {
    id: "red_haired_man",
    name: "Man: Red Hair",
    keywords: [
      "haired",
      "man",
      "hairstyle"
    ],
    skins: [
      {
        unified: "1f468-200d-1f9b0",
        native: "👨‍🦰"
      },
      {
        unified: "1f468-1f3fb-200d-1f9b0",
        native: "👨🏻‍🦰"
      },
      {
        unified: "1f468-1f3fc-200d-1f9b0",
        native: "👨🏼‍🦰"
      },
      {
        unified: "1f468-1f3fd-200d-1f9b0",
        native: "👨🏽‍🦰"
      },
      {
        unified: "1f468-1f3fe-200d-1f9b0",
        native: "👨🏾‍🦰"
      },
      {
        unified: "1f468-1f3ff-200d-1f9b0",
        native: "👨🏿‍🦰"
      }
    ],
    version: 11
  },
  curly_haired_man: {
    id: "curly_haired_man",
    name: "Man: Curly Hair",
    keywords: [
      "haired",
      "man",
      "hairstyle"
    ],
    skins: [
      {
        unified: "1f468-200d-1f9b1",
        native: "👨‍🦱"
      },
      {
        unified: "1f468-1f3fb-200d-1f9b1",
        native: "👨🏻‍🦱"
      },
      {
        unified: "1f468-1f3fc-200d-1f9b1",
        native: "👨🏼‍🦱"
      },
      {
        unified: "1f468-1f3fd-200d-1f9b1",
        native: "👨🏽‍🦱"
      },
      {
        unified: "1f468-1f3fe-200d-1f9b1",
        native: "👨🏾‍🦱"
      },
      {
        unified: "1f468-1f3ff-200d-1f9b1",
        native: "👨🏿‍🦱"
      }
    ],
    version: 11
  },
  white_haired_man: {
    id: "white_haired_man",
    name: "Man: White Hair",
    keywords: [
      "haired",
      "man",
      "old",
      "elder"
    ],
    skins: [
      {
        unified: "1f468-200d-1f9b3",
        native: "👨‍🦳"
      },
      {
        unified: "1f468-1f3fb-200d-1f9b3",
        native: "👨🏻‍🦳"
      },
      {
        unified: "1f468-1f3fc-200d-1f9b3",
        native: "👨🏼‍🦳"
      },
      {
        unified: "1f468-1f3fd-200d-1f9b3",
        native: "👨🏽‍🦳"
      },
      {
        unified: "1f468-1f3fe-200d-1f9b3",
        native: "👨🏾‍🦳"
      },
      {
        unified: "1f468-1f3ff-200d-1f9b3",
        native: "👨🏿‍🦳"
      }
    ],
    version: 11
  },
  bald_man: {
    id: "bald_man",
    name: "Man: Bald",
    keywords: [
      "man",
      "hairless"
    ],
    skins: [
      {
        unified: "1f468-200d-1f9b2",
        native: "👨‍🦲"
      },
      {
        unified: "1f468-1f3fb-200d-1f9b2",
        native: "👨🏻‍🦲"
      },
      {
        unified: "1f468-1f3fc-200d-1f9b2",
        native: "👨🏼‍🦲"
      },
      {
        unified: "1f468-1f3fd-200d-1f9b2",
        native: "👨🏽‍🦲"
      },
      {
        unified: "1f468-1f3fe-200d-1f9b2",
        native: "👨🏾‍🦲"
      },
      {
        unified: "1f468-1f3ff-200d-1f9b2",
        native: "👨🏿‍🦲"
      }
    ],
    version: 11
  },
  woman: {
    id: "woman",
    name: "Woman",
    keywords: [
      "female",
      "girls",
      "lady"
    ],
    skins: [
      {
        unified: "1f469",
        native: "👩"
      },
      {
        unified: "1f469-1f3fb",
        native: "👩🏻"
      },
      {
        unified: "1f469-1f3fc",
        native: "👩🏼"
      },
      {
        unified: "1f469-1f3fd",
        native: "👩🏽"
      },
      {
        unified: "1f469-1f3fe",
        native: "👩🏾"
      },
      {
        unified: "1f469-1f3ff",
        native: "👩🏿"
      }
    ],
    version: 1
  },
  red_haired_woman: {
    id: "red_haired_woman",
    name: "Woman: Red Hair",
    keywords: [
      "haired",
      "woman",
      "hairstyle"
    ],
    skins: [
      {
        unified: "1f469-200d-1f9b0",
        native: "👩‍🦰"
      },
      {
        unified: "1f469-1f3fb-200d-1f9b0",
        native: "👩🏻‍🦰"
      },
      {
        unified: "1f469-1f3fc-200d-1f9b0",
        native: "👩🏼‍🦰"
      },
      {
        unified: "1f469-1f3fd-200d-1f9b0",
        native: "👩🏽‍🦰"
      },
      {
        unified: "1f469-1f3fe-200d-1f9b0",
        native: "👩🏾‍🦰"
      },
      {
        unified: "1f469-1f3ff-200d-1f9b0",
        native: "👩🏿‍🦰"
      }
    ],
    version: 11
  },
  red_haired_person: {
    id: "red_haired_person",
    name: "Person: Red Hair",
    keywords: [
      "haired",
      "person",
      "hairstyle"
    ],
    skins: [
      {
        unified: "1f9d1-200d-1f9b0",
        native: "🧑‍🦰"
      },
      {
        unified: "1f9d1-1f3fb-200d-1f9b0",
        native: "🧑🏻‍🦰"
      },
      {
        unified: "1f9d1-1f3fc-200d-1f9b0",
        native: "🧑🏼‍🦰"
      },
      {
        unified: "1f9d1-1f3fd-200d-1f9b0",
        native: "🧑🏽‍🦰"
      },
      {
        unified: "1f9d1-1f3fe-200d-1f9b0",
        native: "🧑🏾‍🦰"
      },
      {
        unified: "1f9d1-1f3ff-200d-1f9b0",
        native: "🧑🏿‍🦰"
      }
    ],
    version: 12.1
  },
  curly_haired_woman: {
    id: "curly_haired_woman",
    name: "Woman: Curly Hair",
    keywords: [
      "haired",
      "woman",
      "hairstyle"
    ],
    skins: [
      {
        unified: "1f469-200d-1f9b1",
        native: "👩‍🦱"
      },
      {
        unified: "1f469-1f3fb-200d-1f9b1",
        native: "👩🏻‍🦱"
      },
      {
        unified: "1f469-1f3fc-200d-1f9b1",
        native: "👩🏼‍🦱"
      },
      {
        unified: "1f469-1f3fd-200d-1f9b1",
        native: "👩🏽‍🦱"
      },
      {
        unified: "1f469-1f3fe-200d-1f9b1",
        native: "👩🏾‍🦱"
      },
      {
        unified: "1f469-1f3ff-200d-1f9b1",
        native: "👩🏿‍🦱"
      }
    ],
    version: 11
  },
  curly_haired_person: {
    id: "curly_haired_person",
    name: "Person: Curly Hair",
    keywords: [
      "haired",
      "person",
      "hairstyle"
    ],
    skins: [
      {
        unified: "1f9d1-200d-1f9b1",
        native: "🧑‍🦱"
      },
      {
        unified: "1f9d1-1f3fb-200d-1f9b1",
        native: "🧑🏻‍🦱"
      },
      {
        unified: "1f9d1-1f3fc-200d-1f9b1",
        native: "🧑🏼‍🦱"
      },
      {
        unified: "1f9d1-1f3fd-200d-1f9b1",
        native: "🧑🏽‍🦱"
      },
      {
        unified: "1f9d1-1f3fe-200d-1f9b1",
        native: "🧑🏾‍🦱"
      },
      {
        unified: "1f9d1-1f3ff-200d-1f9b1",
        native: "🧑🏿‍🦱"
      }
    ],
    version: 12.1
  },
  white_haired_woman: {
    id: "white_haired_woman",
    name: "Woman: White Hair",
    keywords: [
      "haired",
      "woman",
      "old",
      "elder"
    ],
    skins: [
      {
        unified: "1f469-200d-1f9b3",
        native: "👩‍🦳"
      },
      {
        unified: "1f469-1f3fb-200d-1f9b3",
        native: "👩🏻‍🦳"
      },
      {
        unified: "1f469-1f3fc-200d-1f9b3",
        native: "👩🏼‍🦳"
      },
      {
        unified: "1f469-1f3fd-200d-1f9b3",
        native: "👩🏽‍🦳"
      },
      {
        unified: "1f469-1f3fe-200d-1f9b3",
        native: "👩🏾‍🦳"
      },
      {
        unified: "1f469-1f3ff-200d-1f9b3",
        native: "👩🏿‍🦳"
      }
    ],
    version: 11
  },
  white_haired_person: {
    id: "white_haired_person",
    name: "Person: White Hair",
    keywords: [
      "haired",
      "person",
      "elder",
      "old"
    ],
    skins: [
      {
        unified: "1f9d1-200d-1f9b3",
        native: "🧑‍🦳"
      },
      {
        unified: "1f9d1-1f3fb-200d-1f9b3",
        native: "🧑🏻‍🦳"
      },
      {
        unified: "1f9d1-1f3fc-200d-1f9b3",
        native: "🧑🏼‍🦳"
      },
      {
        unified: "1f9d1-1f3fd-200d-1f9b3",
        native: "🧑🏽‍🦳"
      },
      {
        unified: "1f9d1-1f3fe-200d-1f9b3",
        native: "🧑🏾‍🦳"
      },
      {
        unified: "1f9d1-1f3ff-200d-1f9b3",
        native: "🧑🏿‍🦳"
      }
    ],
    version: 12.1
  },
  bald_woman: {
    id: "bald_woman",
    name: "Woman: Bald",
    keywords: [
      "woman",
      "hairless"
    ],
    skins: [
      {
        unified: "1f469-200d-1f9b2",
        native: "👩‍🦲"
      },
      {
        unified: "1f469-1f3fb-200d-1f9b2",
        native: "👩🏻‍🦲"
      },
      {
        unified: "1f469-1f3fc-200d-1f9b2",
        native: "👩🏼‍🦲"
      },
      {
        unified: "1f469-1f3fd-200d-1f9b2",
        native: "👩🏽‍🦲"
      },
      {
        unified: "1f469-1f3fe-200d-1f9b2",
        native: "👩🏾‍🦲"
      },
      {
        unified: "1f469-1f3ff-200d-1f9b2",
        native: "👩🏿‍🦲"
      }
    ],
    version: 11
  },
  bald_person: {
    id: "bald_person",
    name: "Person: Bald",
    keywords: [
      "person",
      "hairless"
    ],
    skins: [
      {
        unified: "1f9d1-200d-1f9b2",
        native: "🧑‍🦲"
      },
      {
        unified: "1f9d1-1f3fb-200d-1f9b2",
        native: "🧑🏻‍🦲"
      },
      {
        unified: "1f9d1-1f3fc-200d-1f9b2",
        native: "🧑🏼‍🦲"
      },
      {
        unified: "1f9d1-1f3fd-200d-1f9b2",
        native: "🧑🏽‍🦲"
      },
      {
        unified: "1f9d1-1f3fe-200d-1f9b2",
        native: "🧑🏾‍🦲"
      },
      {
        unified: "1f9d1-1f3ff-200d-1f9b2",
        native: "🧑🏿‍🦲"
      }
    ],
    version: 12.1
  },
  "blond-haired-woman": {
    id: "blond-haired-woman",
    name: "Woman: Blond Hair",
    keywords: [
      "haired-woman",
      "woman",
      "female",
      "girl",
      "blonde",
      "person"
    ],
    skins: [
      {
        unified: "1f471-200d-2640-fe0f",
        native: "👱‍♀️"
      },
      {
        unified: "1f471-1f3fb-200d-2640-fe0f",
        native: "👱🏻‍♀️"
      },
      {
        unified: "1f471-1f3fc-200d-2640-fe0f",
        native: "👱🏼‍♀️"
      },
      {
        unified: "1f471-1f3fd-200d-2640-fe0f",
        native: "👱🏽‍♀️"
      },
      {
        unified: "1f471-1f3fe-200d-2640-fe0f",
        native: "👱🏾‍♀️"
      },
      {
        unified: "1f471-1f3ff-200d-2640-fe0f",
        native: "👱🏿‍♀️"
      }
    ],
    version: 4
  },
  "blond-haired-man": {
    id: "blond-haired-man",
    name: "Man: Blond Hair",
    keywords: [
      "haired-man",
      "man",
      "male",
      "boy",
      "blonde",
      "guy",
      "person"
    ],
    skins: [
      {
        unified: "1f471-200d-2642-fe0f",
        native: "👱‍♂️"
      },
      {
        unified: "1f471-1f3fb-200d-2642-fe0f",
        native: "👱🏻‍♂️"
      },
      {
        unified: "1f471-1f3fc-200d-2642-fe0f",
        native: "👱🏼‍♂️"
      },
      {
        unified: "1f471-1f3fd-200d-2642-fe0f",
        native: "👱🏽‍♂️"
      },
      {
        unified: "1f471-1f3fe-200d-2642-fe0f",
        native: "👱🏾‍♂️"
      },
      {
        unified: "1f471-1f3ff-200d-2642-fe0f",
        native: "👱🏿‍♂️"
      }
    ],
    version: 4
  },
  older_adult: {
    id: "older_adult",
    name: "Older Adult",
    keywords: [
      "person",
      "human",
      "elder",
      "senior",
      "gender",
      "neutral"
    ],
    skins: [
      {
        unified: "1f9d3",
        native: "🧓"
      },
      {
        unified: "1f9d3-1f3fb",
        native: "🧓🏻"
      },
      {
        unified: "1f9d3-1f3fc",
        native: "🧓🏼"
      },
      {
        unified: "1f9d3-1f3fd",
        native: "🧓🏽"
      },
      {
        unified: "1f9d3-1f3fe",
        native: "🧓🏾"
      },
      {
        unified: "1f9d3-1f3ff",
        native: "🧓🏿"
      }
    ],
    version: 5
  },
  older_man: {
    id: "older_man",
    name: "Old Man",
    keywords: [
      "older",
      "human",
      "male",
      "men",
      "elder",
      "senior"
    ],
    skins: [
      {
        unified: "1f474",
        native: "👴"
      },
      {
        unified: "1f474-1f3fb",
        native: "👴🏻"
      },
      {
        unified: "1f474-1f3fc",
        native: "👴🏼"
      },
      {
        unified: "1f474-1f3fd",
        native: "👴🏽"
      },
      {
        unified: "1f474-1f3fe",
        native: "👴🏾"
      },
      {
        unified: "1f474-1f3ff",
        native: "👴🏿"
      }
    ],
    version: 1
  },
  older_woman: {
    id: "older_woman",
    name: "Old Woman",
    keywords: [
      "older",
      "human",
      "female",
      "women",
      "lady",
      "elder",
      "senior"
    ],
    skins: [
      {
        unified: "1f475",
        native: "👵"
      },
      {
        unified: "1f475-1f3fb",
        native: "👵🏻"
      },
      {
        unified: "1f475-1f3fc",
        native: "👵🏼"
      },
      {
        unified: "1f475-1f3fd",
        native: "👵🏽"
      },
      {
        unified: "1f475-1f3fe",
        native: "👵🏾"
      },
      {
        unified: "1f475-1f3ff",
        native: "👵🏿"
      }
    ],
    version: 1
  },
  person_frowning: {
    id: "person_frowning",
    name: "Person Frowning",
    keywords: [
      "worried"
    ],
    skins: [
      {
        unified: "1f64d",
        native: "🙍"
      },
      {
        unified: "1f64d-1f3fb",
        native: "🙍🏻"
      },
      {
        unified: "1f64d-1f3fc",
        native: "🙍🏼"
      },
      {
        unified: "1f64d-1f3fd",
        native: "🙍🏽"
      },
      {
        unified: "1f64d-1f3fe",
        native: "🙍🏾"
      },
      {
        unified: "1f64d-1f3ff",
        native: "🙍🏿"
      }
    ],
    version: 1
  },
  "man-frowning": {
    id: "man-frowning",
    name: "Man Frowning",
    keywords: [
      "male",
      "boy",
      "sad",
      "depressed",
      "discouraged",
      "unhappy"
    ],
    skins: [
      {
        unified: "1f64d-200d-2642-fe0f",
        native: "🙍‍♂️"
      },
      {
        unified: "1f64d-1f3fb-200d-2642-fe0f",
        native: "🙍🏻‍♂️"
      },
      {
        unified: "1f64d-1f3fc-200d-2642-fe0f",
        native: "🙍🏼‍♂️"
      },
      {
        unified: "1f64d-1f3fd-200d-2642-fe0f",
        native: "🙍🏽‍♂️"
      },
      {
        unified: "1f64d-1f3fe-200d-2642-fe0f",
        native: "🙍🏾‍♂️"
      },
      {
        unified: "1f64d-1f3ff-200d-2642-fe0f",
        native: "🙍🏿‍♂️"
      }
    ],
    version: 4
  },
  "woman-frowning": {
    id: "woman-frowning",
    name: "Woman Frowning",
    keywords: [
      "female",
      "girl",
      "sad",
      "depressed",
      "discouraged",
      "unhappy"
    ],
    skins: [
      {
        unified: "1f64d-200d-2640-fe0f",
        native: "🙍‍♀️"
      },
      {
        unified: "1f64d-1f3fb-200d-2640-fe0f",
        native: "🙍🏻‍♀️"
      },
      {
        unified: "1f64d-1f3fc-200d-2640-fe0f",
        native: "🙍🏼‍♀️"
      },
      {
        unified: "1f64d-1f3fd-200d-2640-fe0f",
        native: "🙍🏽‍♀️"
      },
      {
        unified: "1f64d-1f3fe-200d-2640-fe0f",
        native: "🙍🏾‍♀️"
      },
      {
        unified: "1f64d-1f3ff-200d-2640-fe0f",
        native: "🙍🏿‍♀️"
      }
    ],
    version: 4
  },
  person_with_pouting_face: {
    id: "person_with_pouting_face",
    name: "Person Pouting",
    keywords: [
      "with",
      "face",
      "upset"
    ],
    skins: [
      {
        unified: "1f64e",
        native: "🙎"
      },
      {
        unified: "1f64e-1f3fb",
        native: "🙎🏻"
      },
      {
        unified: "1f64e-1f3fc",
        native: "🙎🏼"
      },
      {
        unified: "1f64e-1f3fd",
        native: "🙎🏽"
      },
      {
        unified: "1f64e-1f3fe",
        native: "🙎🏾"
      },
      {
        unified: "1f64e-1f3ff",
        native: "🙎🏿"
      }
    ],
    version: 1
  },
  "man-pouting": {
    id: "man-pouting",
    name: "Man Pouting",
    keywords: [
      "male",
      "boy"
    ],
    skins: [
      {
        unified: "1f64e-200d-2642-fe0f",
        native: "🙎‍♂️"
      },
      {
        unified: "1f64e-1f3fb-200d-2642-fe0f",
        native: "🙎🏻‍♂️"
      },
      {
        unified: "1f64e-1f3fc-200d-2642-fe0f",
        native: "🙎🏼‍♂️"
      },
      {
        unified: "1f64e-1f3fd-200d-2642-fe0f",
        native: "🙎🏽‍♂️"
      },
      {
        unified: "1f64e-1f3fe-200d-2642-fe0f",
        native: "🙎🏾‍♂️"
      },
      {
        unified: "1f64e-1f3ff-200d-2642-fe0f",
        native: "🙎🏿‍♂️"
      }
    ],
    version: 4
  },
  "woman-pouting": {
    id: "woman-pouting",
    name: "Woman Pouting",
    keywords: [
      "female",
      "girl"
    ],
    skins: [
      {
        unified: "1f64e-200d-2640-fe0f",
        native: "🙎‍♀️"
      },
      {
        unified: "1f64e-1f3fb-200d-2640-fe0f",
        native: "🙎🏻‍♀️"
      },
      {
        unified: "1f64e-1f3fc-200d-2640-fe0f",
        native: "🙎🏼‍♀️"
      },
      {
        unified: "1f64e-1f3fd-200d-2640-fe0f",
        native: "🙎🏽‍♀️"
      },
      {
        unified: "1f64e-1f3fe-200d-2640-fe0f",
        native: "🙎🏾‍♀️"
      },
      {
        unified: "1f64e-1f3ff-200d-2640-fe0f",
        native: "🙎🏿‍♀️"
      }
    ],
    version: 4
  },
  no_good: {
    id: "no_good",
    name: "Person Gesturing No",
    keywords: [
      "good",
      "decline"
    ],
    skins: [
      {
        unified: "1f645",
        native: "🙅"
      },
      {
        unified: "1f645-1f3fb",
        native: "🙅🏻"
      },
      {
        unified: "1f645-1f3fc",
        native: "🙅🏼"
      },
      {
        unified: "1f645-1f3fd",
        native: "🙅🏽"
      },
      {
        unified: "1f645-1f3fe",
        native: "🙅🏾"
      },
      {
        unified: "1f645-1f3ff",
        native: "🙅🏿"
      }
    ],
    version: 1
  },
  "man-gesturing-no": {
    id: "man-gesturing-no",
    name: "Man Gesturing No",
    keywords: [
      "gesturing-no",
      "male",
      "boy",
      "nope"
    ],
    skins: [
      {
        unified: "1f645-200d-2642-fe0f",
        native: "🙅‍♂️"
      },
      {
        unified: "1f645-1f3fb-200d-2642-fe0f",
        native: "🙅🏻‍♂️"
      },
      {
        unified: "1f645-1f3fc-200d-2642-fe0f",
        native: "🙅🏼‍♂️"
      },
      {
        unified: "1f645-1f3fd-200d-2642-fe0f",
        native: "🙅🏽‍♂️"
      },
      {
        unified: "1f645-1f3fe-200d-2642-fe0f",
        native: "🙅🏾‍♂️"
      },
      {
        unified: "1f645-1f3ff-200d-2642-fe0f",
        native: "🙅🏿‍♂️"
      }
    ],
    version: 4
  },
  "woman-gesturing-no": {
    id: "woman-gesturing-no",
    name: "Woman Gesturing No",
    keywords: [
      "gesturing-no",
      "female",
      "girl",
      "nope"
    ],
    skins: [
      {
        unified: "1f645-200d-2640-fe0f",
        native: "🙅‍♀️"
      },
      {
        unified: "1f645-1f3fb-200d-2640-fe0f",
        native: "🙅🏻‍♀️"
      },
      {
        unified: "1f645-1f3fc-200d-2640-fe0f",
        native: "🙅🏼‍♀️"
      },
      {
        unified: "1f645-1f3fd-200d-2640-fe0f",
        native: "🙅🏽‍♀️"
      },
      {
        unified: "1f645-1f3fe-200d-2640-fe0f",
        native: "🙅🏾‍♀️"
      },
      {
        unified: "1f645-1f3ff-200d-2640-fe0f",
        native: "🙅🏿‍♀️"
      }
    ],
    version: 4
  },
  ok_woman: {
    id: "ok_woman",
    name: "Person Gesturing Ok",
    keywords: [
      "woman",
      "agree"
    ],
    skins: [
      {
        unified: "1f646",
        native: "🙆"
      },
      {
        unified: "1f646-1f3fb",
        native: "🙆🏻"
      },
      {
        unified: "1f646-1f3fc",
        native: "🙆🏼"
      },
      {
        unified: "1f646-1f3fd",
        native: "🙆🏽"
      },
      {
        unified: "1f646-1f3fe",
        native: "🙆🏾"
      },
      {
        unified: "1f646-1f3ff",
        native: "🙆🏿"
      }
    ],
    version: 1
  },
  "man-gesturing-ok": {
    id: "man-gesturing-ok",
    name: "Man Gesturing Ok",
    keywords: [
      "gesturing-ok",
      "men",
      "boy",
      "male",
      "blue",
      "human"
    ],
    skins: [
      {
        unified: "1f646-200d-2642-fe0f",
        native: "🙆‍♂️"
      },
      {
        unified: "1f646-1f3fb-200d-2642-fe0f",
        native: "🙆🏻‍♂️"
      },
      {
        unified: "1f646-1f3fc-200d-2642-fe0f",
        native: "🙆🏼‍♂️"
      },
      {
        unified: "1f646-1f3fd-200d-2642-fe0f",
        native: "🙆🏽‍♂️"
      },
      {
        unified: "1f646-1f3fe-200d-2642-fe0f",
        native: "🙆🏾‍♂️"
      },
      {
        unified: "1f646-1f3ff-200d-2642-fe0f",
        native: "🙆🏿‍♂️"
      }
    ],
    version: 4
  },
  "woman-gesturing-ok": {
    id: "woman-gesturing-ok",
    name: "Woman Gesturing Ok",
    keywords: [
      "gesturing-ok",
      "women",
      "girl",
      "female",
      "pink",
      "human"
    ],
    skins: [
      {
        unified: "1f646-200d-2640-fe0f",
        native: "🙆‍♀️"
      },
      {
        unified: "1f646-1f3fb-200d-2640-fe0f",
        native: "🙆🏻‍♀️"
      },
      {
        unified: "1f646-1f3fc-200d-2640-fe0f",
        native: "🙆🏼‍♀️"
      },
      {
        unified: "1f646-1f3fd-200d-2640-fe0f",
        native: "🙆🏽‍♀️"
      },
      {
        unified: "1f646-1f3fe-200d-2640-fe0f",
        native: "🙆🏾‍♀️"
      },
      {
        unified: "1f646-1f3ff-200d-2640-fe0f",
        native: "🙆🏿‍♀️"
      }
    ],
    version: 4
  },
  information_desk_person: {
    id: "information_desk_person",
    name: "Person Tipping Hand",
    keywords: [
      "information",
      "desk"
    ],
    skins: [
      {
        unified: "1f481",
        native: "💁"
      },
      {
        unified: "1f481-1f3fb",
        native: "💁🏻"
      },
      {
        unified: "1f481-1f3fc",
        native: "💁🏼"
      },
      {
        unified: "1f481-1f3fd",
        native: "💁🏽"
      },
      {
        unified: "1f481-1f3fe",
        native: "💁🏾"
      },
      {
        unified: "1f481-1f3ff",
        native: "💁🏿"
      }
    ],
    version: 1
  },
  "man-tipping-hand": {
    id: "man-tipping-hand",
    name: "Man Tipping Hand",
    keywords: [
      "tipping-hand",
      "male",
      "boy",
      "human",
      "information"
    ],
    skins: [
      {
        unified: "1f481-200d-2642-fe0f",
        native: "💁‍♂️"
      },
      {
        unified: "1f481-1f3fb-200d-2642-fe0f",
        native: "💁🏻‍♂️"
      },
      {
        unified: "1f481-1f3fc-200d-2642-fe0f",
        native: "💁🏼‍♂️"
      },
      {
        unified: "1f481-1f3fd-200d-2642-fe0f",
        native: "💁🏽‍♂️"
      },
      {
        unified: "1f481-1f3fe-200d-2642-fe0f",
        native: "💁🏾‍♂️"
      },
      {
        unified: "1f481-1f3ff-200d-2642-fe0f",
        native: "💁🏿‍♂️"
      }
    ],
    version: 4
  },
  "woman-tipping-hand": {
    id: "woman-tipping-hand",
    name: "Woman Tipping Hand",
    keywords: [
      "tipping-hand",
      "female",
      "girl",
      "human",
      "information"
    ],
    skins: [
      {
        unified: "1f481-200d-2640-fe0f",
        native: "💁‍♀️"
      },
      {
        unified: "1f481-1f3fb-200d-2640-fe0f",
        native: "💁🏻‍♀️"
      },
      {
        unified: "1f481-1f3fc-200d-2640-fe0f",
        native: "💁🏼‍♀️"
      },
      {
        unified: "1f481-1f3fd-200d-2640-fe0f",
        native: "💁🏽‍♀️"
      },
      {
        unified: "1f481-1f3fe-200d-2640-fe0f",
        native: "💁🏾‍♀️"
      },
      {
        unified: "1f481-1f3ff-200d-2640-fe0f",
        native: "💁🏿‍♀️"
      }
    ],
    version: 4
  },
  raising_hand: {
    id: "raising_hand",
    name: "Person Raising Hand",
    keywords: [
      "question"
    ],
    skins: [
      {
        unified: "1f64b",
        native: "🙋"
      },
      {
        unified: "1f64b-1f3fb",
        native: "🙋🏻"
      },
      {
        unified: "1f64b-1f3fc",
        native: "🙋🏼"
      },
      {
        unified: "1f64b-1f3fd",
        native: "🙋🏽"
      },
      {
        unified: "1f64b-1f3fe",
        native: "🙋🏾"
      },
      {
        unified: "1f64b-1f3ff",
        native: "🙋🏿"
      }
    ],
    version: 1
  },
  "man-raising-hand": {
    id: "man-raising-hand",
    name: "Man Raising Hand",
    keywords: [
      "raising-hand",
      "male",
      "boy"
    ],
    skins: [
      {
        unified: "1f64b-200d-2642-fe0f",
        native: "🙋‍♂️"
      },
      {
        unified: "1f64b-1f3fb-200d-2642-fe0f",
        native: "🙋🏻‍♂️"
      },
      {
        unified: "1f64b-1f3fc-200d-2642-fe0f",
        native: "🙋🏼‍♂️"
      },
      {
        unified: "1f64b-1f3fd-200d-2642-fe0f",
        native: "🙋🏽‍♂️"
      },
      {
        unified: "1f64b-1f3fe-200d-2642-fe0f",
        native: "🙋🏾‍♂️"
      },
      {
        unified: "1f64b-1f3ff-200d-2642-fe0f",
        native: "🙋🏿‍♂️"
      }
    ],
    version: 4
  },
  "woman-raising-hand": {
    id: "woman-raising-hand",
    name: "Woman Raising Hand",
    keywords: [
      "raising-hand",
      "female",
      "girl"
    ],
    skins: [
      {
        unified: "1f64b-200d-2640-fe0f",
        native: "🙋‍♀️"
      },
      {
        unified: "1f64b-1f3fb-200d-2640-fe0f",
        native: "🙋🏻‍♀️"
      },
      {
        unified: "1f64b-1f3fc-200d-2640-fe0f",
        native: "🙋🏼‍♀️"
      },
      {
        unified: "1f64b-1f3fd-200d-2640-fe0f",
        native: "🙋🏽‍♀️"
      },
      {
        unified: "1f64b-1f3fe-200d-2640-fe0f",
        native: "🙋🏾‍♀️"
      },
      {
        unified: "1f64b-1f3ff-200d-2640-fe0f",
        native: "🙋🏿‍♀️"
      }
    ],
    version: 4
  },
  deaf_person: {
    id: "deaf_person",
    name: "Deaf Person",
    keywords: [
      "accessibility"
    ],
    skins: [
      {
        unified: "1f9cf",
        native: "🧏"
      },
      {
        unified: "1f9cf-1f3fb",
        native: "🧏🏻"
      },
      {
        unified: "1f9cf-1f3fc",
        native: "🧏🏼"
      },
      {
        unified: "1f9cf-1f3fd",
        native: "🧏🏽"
      },
      {
        unified: "1f9cf-1f3fe",
        native: "🧏🏾"
      },
      {
        unified: "1f9cf-1f3ff",
        native: "🧏🏿"
      }
    ],
    version: 12
  },
  deaf_man: {
    id: "deaf_man",
    name: "Deaf Man",
    keywords: [
      "accessibility"
    ],
    skins: [
      {
        unified: "1f9cf-200d-2642-fe0f",
        native: "🧏‍♂️"
      },
      {
        unified: "1f9cf-1f3fb-200d-2642-fe0f",
        native: "🧏🏻‍♂️"
      },
      {
        unified: "1f9cf-1f3fc-200d-2642-fe0f",
        native: "🧏🏼‍♂️"
      },
      {
        unified: "1f9cf-1f3fd-200d-2642-fe0f",
        native: "🧏🏽‍♂️"
      },
      {
        unified: "1f9cf-1f3fe-200d-2642-fe0f",
        native: "🧏🏾‍♂️"
      },
      {
        unified: "1f9cf-1f3ff-200d-2642-fe0f",
        native: "🧏🏿‍♂️"
      }
    ],
    version: 12
  },
  deaf_woman: {
    id: "deaf_woman",
    name: "Deaf Woman",
    keywords: [
      "accessibility"
    ],
    skins: [
      {
        unified: "1f9cf-200d-2640-fe0f",
        native: "🧏‍♀️"
      },
      {
        unified: "1f9cf-1f3fb-200d-2640-fe0f",
        native: "🧏🏻‍♀️"
      },
      {
        unified: "1f9cf-1f3fc-200d-2640-fe0f",
        native: "🧏🏼‍♀️"
      },
      {
        unified: "1f9cf-1f3fd-200d-2640-fe0f",
        native: "🧏🏽‍♀️"
      },
      {
        unified: "1f9cf-1f3fe-200d-2640-fe0f",
        native: "🧏🏾‍♀️"
      },
      {
        unified: "1f9cf-1f3ff-200d-2640-fe0f",
        native: "🧏🏿‍♀️"
      }
    ],
    version: 12
  },
  bow: {
    id: "bow",
    name: "Person Bowing",
    keywords: [
      "bow",
      "respectiful"
    ],
    skins: [
      {
        unified: "1f647",
        native: "🙇"
      },
      {
        unified: "1f647-1f3fb",
        native: "🙇🏻"
      },
      {
        unified: "1f647-1f3fc",
        native: "🙇🏼"
      },
      {
        unified: "1f647-1f3fd",
        native: "🙇🏽"
      },
      {
        unified: "1f647-1f3fe",
        native: "🙇🏾"
      },
      {
        unified: "1f647-1f3ff",
        native: "🙇🏿"
      }
    ],
    version: 1
  },
  "man-bowing": {
    id: "man-bowing",
    name: "Man Bowing",
    keywords: [
      "male",
      "boy"
    ],
    skins: [
      {
        unified: "1f647-200d-2642-fe0f",
        native: "🙇‍♂️"
      },
      {
        unified: "1f647-1f3fb-200d-2642-fe0f",
        native: "🙇🏻‍♂️"
      },
      {
        unified: "1f647-1f3fc-200d-2642-fe0f",
        native: "🙇🏼‍♂️"
      },
      {
        unified: "1f647-1f3fd-200d-2642-fe0f",
        native: "🙇🏽‍♂️"
      },
      {
        unified: "1f647-1f3fe-200d-2642-fe0f",
        native: "🙇🏾‍♂️"
      },
      {
        unified: "1f647-1f3ff-200d-2642-fe0f",
        native: "🙇🏿‍♂️"
      }
    ],
    version: 4
  },
  "woman-bowing": {
    id: "woman-bowing",
    name: "Woman Bowing",
    keywords: [
      "female",
      "girl"
    ],
    skins: [
      {
        unified: "1f647-200d-2640-fe0f",
        native: "🙇‍♀️"
      },
      {
        unified: "1f647-1f3fb-200d-2640-fe0f",
        native: "🙇🏻‍♀️"
      },
      {
        unified: "1f647-1f3fc-200d-2640-fe0f",
        native: "🙇🏼‍♀️"
      },
      {
        unified: "1f647-1f3fd-200d-2640-fe0f",
        native: "🙇🏽‍♀️"
      },
      {
        unified: "1f647-1f3fe-200d-2640-fe0f",
        native: "🙇🏾‍♀️"
      },
      {
        unified: "1f647-1f3ff-200d-2640-fe0f",
        native: "🙇🏿‍♀️"
      }
    ],
    version: 4
  },
  face_palm: {
    id: "face_palm",
    name: "Face Palm",
    keywords: [
      "person",
      "facepalming",
      "disappointed"
    ],
    skins: [
      {
        unified: "1f926",
        native: "🤦"
      },
      {
        unified: "1f926-1f3fb",
        native: "🤦🏻"
      },
      {
        unified: "1f926-1f3fc",
        native: "🤦🏼"
      },
      {
        unified: "1f926-1f3fd",
        native: "🤦🏽"
      },
      {
        unified: "1f926-1f3fe",
        native: "🤦🏾"
      },
      {
        unified: "1f926-1f3ff",
        native: "🤦🏿"
      }
    ],
    version: 3
  },
  "man-facepalming": {
    id: "man-facepalming",
    name: "Man Facepalming",
    keywords: [
      "male",
      "boy",
      "disbelief"
    ],
    skins: [
      {
        unified: "1f926-200d-2642-fe0f",
        native: "🤦‍♂️"
      },
      {
        unified: "1f926-1f3fb-200d-2642-fe0f",
        native: "🤦🏻‍♂️"
      },
      {
        unified: "1f926-1f3fc-200d-2642-fe0f",
        native: "🤦🏼‍♂️"
      },
      {
        unified: "1f926-1f3fd-200d-2642-fe0f",
        native: "🤦🏽‍♂️"
      },
      {
        unified: "1f926-1f3fe-200d-2642-fe0f",
        native: "🤦🏾‍♂️"
      },
      {
        unified: "1f926-1f3ff-200d-2642-fe0f",
        native: "🤦🏿‍♂️"
      }
    ],
    version: 4
  },
  "woman-facepalming": {
    id: "woman-facepalming",
    name: "Woman Facepalming",
    keywords: [
      "female",
      "girl",
      "disbelief"
    ],
    skins: [
      {
        unified: "1f926-200d-2640-fe0f",
        native: "🤦‍♀️"
      },
      {
        unified: "1f926-1f3fb-200d-2640-fe0f",
        native: "🤦🏻‍♀️"
      },
      {
        unified: "1f926-1f3fc-200d-2640-fe0f",
        native: "🤦🏼‍♀️"
      },
      {
        unified: "1f926-1f3fd-200d-2640-fe0f",
        native: "🤦🏽‍♀️"
      },
      {
        unified: "1f926-1f3fe-200d-2640-fe0f",
        native: "🤦🏾‍♀️"
      },
      {
        unified: "1f926-1f3ff-200d-2640-fe0f",
        native: "🤦🏿‍♀️"
      }
    ],
    version: 4
  },
  shrug: {
    id: "shrug",
    name: "Shrug",
    keywords: [
      "person",
      "shrugging",
      "regardless"
    ],
    skins: [
      {
        unified: "1f937",
        native: "🤷"
      },
      {
        unified: "1f937-1f3fb",
        native: "🤷🏻"
      },
      {
        unified: "1f937-1f3fc",
        native: "🤷🏼"
      },
      {
        unified: "1f937-1f3fd",
        native: "🤷🏽"
      },
      {
        unified: "1f937-1f3fe",
        native: "🤷🏾"
      },
      {
        unified: "1f937-1f3ff",
        native: "🤷🏿"
      }
    ],
    version: 3
  },
  "man-shrugging": {
    id: "man-shrugging",
    name: "Man Shrugging",
    keywords: [
      "male",
      "boy",
      "confused",
      "indifferent",
      "doubt"
    ],
    skins: [
      {
        unified: "1f937-200d-2642-fe0f",
        native: "🤷‍♂️"
      },
      {
        unified: "1f937-1f3fb-200d-2642-fe0f",
        native: "🤷🏻‍♂️"
      },
      {
        unified: "1f937-1f3fc-200d-2642-fe0f",
        native: "🤷🏼‍♂️"
      },
      {
        unified: "1f937-1f3fd-200d-2642-fe0f",
        native: "🤷🏽‍♂️"
      },
      {
        unified: "1f937-1f3fe-200d-2642-fe0f",
        native: "🤷🏾‍♂️"
      },
      {
        unified: "1f937-1f3ff-200d-2642-fe0f",
        native: "🤷🏿‍♂️"
      }
    ],
    version: 4
  },
  "woman-shrugging": {
    id: "woman-shrugging",
    name: "Woman Shrugging",
    keywords: [
      "female",
      "girl",
      "confused",
      "indifferent",
      "doubt"
    ],
    skins: [
      {
        unified: "1f937-200d-2640-fe0f",
        native: "🤷‍♀️"
      },
      {
        unified: "1f937-1f3fb-200d-2640-fe0f",
        native: "🤷🏻‍♀️"
      },
      {
        unified: "1f937-1f3fc-200d-2640-fe0f",
        native: "🤷🏼‍♀️"
      },
      {
        unified: "1f937-1f3fd-200d-2640-fe0f",
        native: "🤷🏽‍♀️"
      },
      {
        unified: "1f937-1f3fe-200d-2640-fe0f",
        native: "🤷🏾‍♀️"
      },
      {
        unified: "1f937-1f3ff-200d-2640-fe0f",
        native: "🤷🏿‍♀️"
      }
    ],
    version: 4
  },
  health_worker: {
    id: "health_worker",
    name: "Health Worker",
    keywords: [
      "hospital"
    ],
    skins: [
      {
        unified: "1f9d1-200d-2695-fe0f",
        native: "🧑‍⚕️"
      },
      {
        unified: "1f9d1-1f3fb-200d-2695-fe0f",
        native: "🧑🏻‍⚕️"
      },
      {
        unified: "1f9d1-1f3fc-200d-2695-fe0f",
        native: "🧑🏼‍⚕️"
      },
      {
        unified: "1f9d1-1f3fd-200d-2695-fe0f",
        native: "🧑🏽‍⚕️"
      },
      {
        unified: "1f9d1-1f3fe-200d-2695-fe0f",
        native: "🧑🏾‍⚕️"
      },
      {
        unified: "1f9d1-1f3ff-200d-2695-fe0f",
        native: "🧑🏿‍⚕️"
      }
    ],
    version: 12.1
  },
  "male-doctor": {
    id: "male-doctor",
    name: "Man Health Worker",
    keywords: [
      "male",
      "doctor",
      "nurse",
      "therapist",
      "healthcare",
      "human"
    ],
    skins: [
      {
        unified: "1f468-200d-2695-fe0f",
        native: "👨‍⚕️"
      },
      {
        unified: "1f468-1f3fb-200d-2695-fe0f",
        native: "👨🏻‍⚕️"
      },
      {
        unified: "1f468-1f3fc-200d-2695-fe0f",
        native: "👨🏼‍⚕️"
      },
      {
        unified: "1f468-1f3fd-200d-2695-fe0f",
        native: "👨🏽‍⚕️"
      },
      {
        unified: "1f468-1f3fe-200d-2695-fe0f",
        native: "👨🏾‍⚕️"
      },
      {
        unified: "1f468-1f3ff-200d-2695-fe0f",
        native: "👨🏿‍⚕️"
      }
    ],
    version: 4
  },
  "female-doctor": {
    id: "female-doctor",
    name: "Woman Health Worker",
    keywords: [
      "female",
      "doctor",
      "nurse",
      "therapist",
      "healthcare",
      "human"
    ],
    skins: [
      {
        unified: "1f469-200d-2695-fe0f",
        native: "👩‍⚕️"
      },
      {
        unified: "1f469-1f3fb-200d-2695-fe0f",
        native: "👩🏻‍⚕️"
      },
      {
        unified: "1f469-1f3fc-200d-2695-fe0f",
        native: "👩🏼‍⚕️"
      },
      {
        unified: "1f469-1f3fd-200d-2695-fe0f",
        native: "👩🏽‍⚕️"
      },
      {
        unified: "1f469-1f3fe-200d-2695-fe0f",
        native: "👩🏾‍⚕️"
      },
      {
        unified: "1f469-1f3ff-200d-2695-fe0f",
        native: "👩🏿‍⚕️"
      }
    ],
    version: 4
  },
  student: {
    id: "student",
    name: "Student",
    keywords: [
      "learn"
    ],
    skins: [
      {
        unified: "1f9d1-200d-1f393",
        native: "🧑‍🎓"
      },
      {
        unified: "1f9d1-1f3fb-200d-1f393",
        native: "🧑🏻‍🎓"
      },
      {
        unified: "1f9d1-1f3fc-200d-1f393",
        native: "🧑🏼‍🎓"
      },
      {
        unified: "1f9d1-1f3fd-200d-1f393",
        native: "🧑🏽‍🎓"
      },
      {
        unified: "1f9d1-1f3fe-200d-1f393",
        native: "🧑🏾‍🎓"
      },
      {
        unified: "1f9d1-1f3ff-200d-1f393",
        native: "🧑🏿‍🎓"
      }
    ],
    version: 12.1
  },
  "male-student": {
    id: "male-student",
    name: "Man Student",
    keywords: [
      "male",
      "graduate",
      "human"
    ],
    skins: [
      {
        unified: "1f468-200d-1f393",
        native: "👨‍🎓"
      },
      {
        unified: "1f468-1f3fb-200d-1f393",
        native: "👨🏻‍🎓"
      },
      {
        unified: "1f468-1f3fc-200d-1f393",
        native: "👨🏼‍🎓"
      },
      {
        unified: "1f468-1f3fd-200d-1f393",
        native: "👨🏽‍🎓"
      },
      {
        unified: "1f468-1f3fe-200d-1f393",
        native: "👨🏾‍🎓"
      },
      {
        unified: "1f468-1f3ff-200d-1f393",
        native: "👨🏿‍🎓"
      }
    ],
    version: 4
  },
  "female-student": {
    id: "female-student",
    name: "Woman Student",
    keywords: [
      "female",
      "graduate",
      "human"
    ],
    skins: [
      {
        unified: "1f469-200d-1f393",
        native: "👩‍🎓"
      },
      {
        unified: "1f469-1f3fb-200d-1f393",
        native: "👩🏻‍🎓"
      },
      {
        unified: "1f469-1f3fc-200d-1f393",
        native: "👩🏼‍🎓"
      },
      {
        unified: "1f469-1f3fd-200d-1f393",
        native: "👩🏽‍🎓"
      },
      {
        unified: "1f469-1f3fe-200d-1f393",
        native: "👩🏾‍🎓"
      },
      {
        unified: "1f469-1f3ff-200d-1f393",
        native: "👩🏿‍🎓"
      }
    ],
    version: 4
  },
  teacher: {
    id: "teacher",
    name: "Teacher",
    keywords: [
      "professor"
    ],
    skins: [
      {
        unified: "1f9d1-200d-1f3eb",
        native: "🧑‍🏫"
      },
      {
        unified: "1f9d1-1f3fb-200d-1f3eb",
        native: "🧑🏻‍🏫"
      },
      {
        unified: "1f9d1-1f3fc-200d-1f3eb",
        native: "🧑🏼‍🏫"
      },
      {
        unified: "1f9d1-1f3fd-200d-1f3eb",
        native: "🧑🏽‍🏫"
      },
      {
        unified: "1f9d1-1f3fe-200d-1f3eb",
        native: "🧑🏾‍🏫"
      },
      {
        unified: "1f9d1-1f3ff-200d-1f3eb",
        native: "🧑🏿‍🏫"
      }
    ],
    version: 12.1
  },
  "male-teacher": {
    id: "male-teacher",
    name: "Man Teacher",
    keywords: [
      "male",
      "instructor",
      "professor",
      "human"
    ],
    skins: [
      {
        unified: "1f468-200d-1f3eb",
        native: "👨‍🏫"
      },
      {
        unified: "1f468-1f3fb-200d-1f3eb",
        native: "👨🏻‍🏫"
      },
      {
        unified: "1f468-1f3fc-200d-1f3eb",
        native: "👨🏼‍🏫"
      },
      {
        unified: "1f468-1f3fd-200d-1f3eb",
        native: "👨🏽‍🏫"
      },
      {
        unified: "1f468-1f3fe-200d-1f3eb",
        native: "👨🏾‍🏫"
      },
      {
        unified: "1f468-1f3ff-200d-1f3eb",
        native: "👨🏿‍🏫"
      }
    ],
    version: 4
  },
  "female-teacher": {
    id: "female-teacher",
    name: "Woman Teacher",
    keywords: [
      "female",
      "instructor",
      "professor",
      "human"
    ],
    skins: [
      {
        unified: "1f469-200d-1f3eb",
        native: "👩‍🏫"
      },
      {
        unified: "1f469-1f3fb-200d-1f3eb",
        native: "👩🏻‍🏫"
      },
      {
        unified: "1f469-1f3fc-200d-1f3eb",
        native: "👩🏼‍🏫"
      },
      {
        unified: "1f469-1f3fd-200d-1f3eb",
        native: "👩🏽‍🏫"
      },
      {
        unified: "1f469-1f3fe-200d-1f3eb",
        native: "👩🏾‍🏫"
      },
      {
        unified: "1f469-1f3ff-200d-1f3eb",
        native: "👩🏿‍🏫"
      }
    ],
    version: 4
  },
  judge: {
    id: "judge",
    name: "Judge",
    keywords: [
      "law"
    ],
    skins: [
      {
        unified: "1f9d1-200d-2696-fe0f",
        native: "🧑‍⚖️"
      },
      {
        unified: "1f9d1-1f3fb-200d-2696-fe0f",
        native: "🧑🏻‍⚖️"
      },
      {
        unified: "1f9d1-1f3fc-200d-2696-fe0f",
        native: "🧑🏼‍⚖️"
      },
      {
        unified: "1f9d1-1f3fd-200d-2696-fe0f",
        native: "🧑🏽‍⚖️"
      },
      {
        unified: "1f9d1-1f3fe-200d-2696-fe0f",
        native: "🧑🏾‍⚖️"
      },
      {
        unified: "1f9d1-1f3ff-200d-2696-fe0f",
        native: "🧑🏿‍⚖️"
      }
    ],
    version: 12.1
  },
  "male-judge": {
    id: "male-judge",
    name: "Man Judge",
    keywords: [
      "male",
      "justice",
      "court",
      "human"
    ],
    skins: [
      {
        unified: "1f468-200d-2696-fe0f",
        native: "👨‍⚖️"
      },
      {
        unified: "1f468-1f3fb-200d-2696-fe0f",
        native: "👨🏻‍⚖️"
      },
      {
        unified: "1f468-1f3fc-200d-2696-fe0f",
        native: "👨🏼‍⚖️"
      },
      {
        unified: "1f468-1f3fd-200d-2696-fe0f",
        native: "👨🏽‍⚖️"
      },
      {
        unified: "1f468-1f3fe-200d-2696-fe0f",
        native: "👨🏾‍⚖️"
      },
      {
        unified: "1f468-1f3ff-200d-2696-fe0f",
        native: "👨🏿‍⚖️"
      }
    ],
    version: 4
  },
  "female-judge": {
    id: "female-judge",
    name: "Woman Judge",
    keywords: [
      "female",
      "justice",
      "court",
      "human"
    ],
    skins: [
      {
        unified: "1f469-200d-2696-fe0f",
        native: "👩‍⚖️"
      },
      {
        unified: "1f469-1f3fb-200d-2696-fe0f",
        native: "👩🏻‍⚖️"
      },
      {
        unified: "1f469-1f3fc-200d-2696-fe0f",
        native: "👩🏼‍⚖️"
      },
      {
        unified: "1f469-1f3fd-200d-2696-fe0f",
        native: "👩🏽‍⚖️"
      },
      {
        unified: "1f469-1f3fe-200d-2696-fe0f",
        native: "👩🏾‍⚖️"
      },
      {
        unified: "1f469-1f3ff-200d-2696-fe0f",
        native: "👩🏿‍⚖️"
      }
    ],
    version: 4
  },
  farmer: {
    id: "farmer",
    name: "Farmer",
    keywords: [
      "crops"
    ],
    skins: [
      {
        unified: "1f9d1-200d-1f33e",
        native: "🧑‍🌾"
      },
      {
        unified: "1f9d1-1f3fb-200d-1f33e",
        native: "🧑🏻‍🌾"
      },
      {
        unified: "1f9d1-1f3fc-200d-1f33e",
        native: "🧑🏼‍🌾"
      },
      {
        unified: "1f9d1-1f3fd-200d-1f33e",
        native: "🧑🏽‍🌾"
      },
      {
        unified: "1f9d1-1f3fe-200d-1f33e",
        native: "🧑🏾‍🌾"
      },
      {
        unified: "1f9d1-1f3ff-200d-1f33e",
        native: "🧑🏿‍🌾"
      }
    ],
    version: 12.1
  },
  "male-farmer": {
    id: "male-farmer",
    name: "Man Farmer",
    keywords: [
      "male",
      "rancher",
      "gardener",
      "human"
    ],
    skins: [
      {
        unified: "1f468-200d-1f33e",
        native: "👨‍🌾"
      },
      {
        unified: "1f468-1f3fb-200d-1f33e",
        native: "👨🏻‍🌾"
      },
      {
        unified: "1f468-1f3fc-200d-1f33e",
        native: "👨🏼‍🌾"
      },
      {
        unified: "1f468-1f3fd-200d-1f33e",
        native: "👨🏽‍🌾"
      },
      {
        unified: "1f468-1f3fe-200d-1f33e",
        native: "👨🏾‍🌾"
      },
      {
        unified: "1f468-1f3ff-200d-1f33e",
        native: "👨🏿‍🌾"
      }
    ],
    version: 4
  },
  "female-farmer": {
    id: "female-farmer",
    name: "Woman Farmer",
    keywords: [
      "female",
      "rancher",
      "gardener",
      "human"
    ],
    skins: [
      {
        unified: "1f469-200d-1f33e",
        native: "👩‍🌾"
      },
      {
        unified: "1f469-1f3fb-200d-1f33e",
        native: "👩🏻‍🌾"
      },
      {
        unified: "1f469-1f3fc-200d-1f33e",
        native: "👩🏼‍🌾"
      },
      {
        unified: "1f469-1f3fd-200d-1f33e",
        native: "👩🏽‍🌾"
      },
      {
        unified: "1f469-1f3fe-200d-1f33e",
        native: "👩🏾‍🌾"
      },
      {
        unified: "1f469-1f3ff-200d-1f33e",
        native: "👩🏿‍🌾"
      }
    ],
    version: 4
  },
  cook: {
    id: "cook",
    name: "Cook",
    keywords: [
      "food",
      "kitchen",
      "culinary"
    ],
    skins: [
      {
        unified: "1f9d1-200d-1f373",
        native: "🧑‍🍳"
      },
      {
        unified: "1f9d1-1f3fb-200d-1f373",
        native: "🧑🏻‍🍳"
      },
      {
        unified: "1f9d1-1f3fc-200d-1f373",
        native: "🧑🏼‍🍳"
      },
      {
        unified: "1f9d1-1f3fd-200d-1f373",
        native: "🧑🏽‍🍳"
      },
      {
        unified: "1f9d1-1f3fe-200d-1f373",
        native: "🧑🏾‍🍳"
      },
      {
        unified: "1f9d1-1f3ff-200d-1f373",
        native: "🧑🏿‍🍳"
      }
    ],
    version: 12.1
  },
  "male-cook": {
    id: "male-cook",
    name: "Man Cook",
    keywords: [
      "male",
      "chef",
      "human"
    ],
    skins: [
      {
        unified: "1f468-200d-1f373",
        native: "👨‍🍳"
      },
      {
        unified: "1f468-1f3fb-200d-1f373",
        native: "👨🏻‍🍳"
      },
      {
        unified: "1f468-1f3fc-200d-1f373",
        native: "👨🏼‍🍳"
      },
      {
        unified: "1f468-1f3fd-200d-1f373",
        native: "👨🏽‍🍳"
      },
      {
        unified: "1f468-1f3fe-200d-1f373",
        native: "👨🏾‍🍳"
      },
      {
        unified: "1f468-1f3ff-200d-1f373",
        native: "👨🏿‍🍳"
      }
    ],
    version: 4
  },
  "female-cook": {
    id: "female-cook",
    name: "Woman Cook",
    keywords: [
      "female",
      "chef",
      "human"
    ],
    skins: [
      {
        unified: "1f469-200d-1f373",
        native: "👩‍🍳"
      },
      {
        unified: "1f469-1f3fb-200d-1f373",
        native: "👩🏻‍🍳"
      },
      {
        unified: "1f469-1f3fc-200d-1f373",
        native: "👩🏼‍🍳"
      },
      {
        unified: "1f469-1f3fd-200d-1f373",
        native: "👩🏽‍🍳"
      },
      {
        unified: "1f469-1f3fe-200d-1f373",
        native: "👩🏾‍🍳"
      },
      {
        unified: "1f469-1f3ff-200d-1f373",
        native: "👩🏿‍🍳"
      }
    ],
    version: 4
  },
  mechanic: {
    id: "mechanic",
    name: "Mechanic",
    keywords: [
      "worker",
      "technician"
    ],
    skins: [
      {
        unified: "1f9d1-200d-1f527",
        native: "🧑‍🔧"
      },
      {
        unified: "1f9d1-1f3fb-200d-1f527",
        native: "🧑🏻‍🔧"
      },
      {
        unified: "1f9d1-1f3fc-200d-1f527",
        native: "🧑🏼‍🔧"
      },
      {
        unified: "1f9d1-1f3fd-200d-1f527",
        native: "🧑🏽‍🔧"
      },
      {
        unified: "1f9d1-1f3fe-200d-1f527",
        native: "🧑🏾‍🔧"
      },
      {
        unified: "1f9d1-1f3ff-200d-1f527",
        native: "🧑🏿‍🔧"
      }
    ],
    version: 12.1
  },
  "male-mechanic": {
    id: "male-mechanic",
    name: "Man Mechanic",
    keywords: [
      "male",
      "plumber",
      "human",
      "wrench"
    ],
    skins: [
      {
        unified: "1f468-200d-1f527",
        native: "👨‍🔧"
      },
      {
        unified: "1f468-1f3fb-200d-1f527",
        native: "👨🏻‍🔧"
      },
      {
        unified: "1f468-1f3fc-200d-1f527",
        native: "👨🏼‍🔧"
      },
      {
        unified: "1f468-1f3fd-200d-1f527",
        native: "👨🏽‍🔧"
      },
      {
        unified: "1f468-1f3fe-200d-1f527",
        native: "👨🏾‍🔧"
      },
      {
        unified: "1f468-1f3ff-200d-1f527",
        native: "👨🏿‍🔧"
      }
    ],
    version: 4
  },
  "female-mechanic": {
    id: "female-mechanic",
    name: "Woman Mechanic",
    keywords: [
      "female",
      "plumber",
      "human",
      "wrench"
    ],
    skins: [
      {
        unified: "1f469-200d-1f527",
        native: "👩‍🔧"
      },
      {
        unified: "1f469-1f3fb-200d-1f527",
        native: "👩🏻‍🔧"
      },
      {
        unified: "1f469-1f3fc-200d-1f527",
        native: "👩🏼‍🔧"
      },
      {
        unified: "1f469-1f3fd-200d-1f527",
        native: "👩🏽‍🔧"
      },
      {
        unified: "1f469-1f3fe-200d-1f527",
        native: "👩🏾‍🔧"
      },
      {
        unified: "1f469-1f3ff-200d-1f527",
        native: "👩🏿‍🔧"
      }
    ],
    version: 4
  },
  factory_worker: {
    id: "factory_worker",
    name: "Factory Worker",
    keywords: [
      "labor"
    ],
    skins: [
      {
        unified: "1f9d1-200d-1f3ed",
        native: "🧑‍🏭"
      },
      {
        unified: "1f9d1-1f3fb-200d-1f3ed",
        native: "🧑🏻‍🏭"
      },
      {
        unified: "1f9d1-1f3fc-200d-1f3ed",
        native: "🧑🏼‍🏭"
      },
      {
        unified: "1f9d1-1f3fd-200d-1f3ed",
        native: "🧑🏽‍🏭"
      },
      {
        unified: "1f9d1-1f3fe-200d-1f3ed",
        native: "🧑🏾‍🏭"
      },
      {
        unified: "1f9d1-1f3ff-200d-1f3ed",
        native: "🧑🏿‍🏭"
      }
    ],
    version: 12.1
  },
  "male-factory-worker": {
    id: "male-factory-worker",
    name: "Man Factory Worker",
    keywords: [
      "male",
      "factory-worker",
      "assembly",
      "industrial",
      "human"
    ],
    skins: [
      {
        unified: "1f468-200d-1f3ed",
        native: "👨‍🏭"
      },
      {
        unified: "1f468-1f3fb-200d-1f3ed",
        native: "👨🏻‍🏭"
      },
      {
        unified: "1f468-1f3fc-200d-1f3ed",
        native: "👨🏼‍🏭"
      },
      {
        unified: "1f468-1f3fd-200d-1f3ed",
        native: "👨🏽‍🏭"
      },
      {
        unified: "1f468-1f3fe-200d-1f3ed",
        native: "👨🏾‍🏭"
      },
      {
        unified: "1f468-1f3ff-200d-1f3ed",
        native: "👨🏿‍🏭"
      }
    ],
    version: 4
  },
  "female-factory-worker": {
    id: "female-factory-worker",
    name: "Woman Factory Worker",
    keywords: [
      "female",
      "factory-worker",
      "assembly",
      "industrial",
      "human"
    ],
    skins: [
      {
        unified: "1f469-200d-1f3ed",
        native: "👩‍🏭"
      },
      {
        unified: "1f469-1f3fb-200d-1f3ed",
        native: "👩🏻‍🏭"
      },
      {
        unified: "1f469-1f3fc-200d-1f3ed",
        native: "👩🏼‍🏭"
      },
      {
        unified: "1f469-1f3fd-200d-1f3ed",
        native: "👩🏽‍🏭"
      },
      {
        unified: "1f469-1f3fe-200d-1f3ed",
        native: "👩🏾‍🏭"
      },
      {
        unified: "1f469-1f3ff-200d-1f3ed",
        native: "👩🏿‍🏭"
      }
    ],
    version: 4
  },
  office_worker: {
    id: "office_worker",
    name: "Office Worker",
    keywords: [
      "business"
    ],
    skins: [
      {
        unified: "1f9d1-200d-1f4bc",
        native: "🧑‍💼"
      },
      {
        unified: "1f9d1-1f3fb-200d-1f4bc",
        native: "🧑🏻‍💼"
      },
      {
        unified: "1f9d1-1f3fc-200d-1f4bc",
        native: "🧑🏼‍💼"
      },
      {
        unified: "1f9d1-1f3fd-200d-1f4bc",
        native: "🧑🏽‍💼"
      },
      {
        unified: "1f9d1-1f3fe-200d-1f4bc",
        native: "🧑🏾‍💼"
      },
      {
        unified: "1f9d1-1f3ff-200d-1f4bc",
        native: "🧑🏿‍💼"
      }
    ],
    version: 12.1
  },
  "male-office-worker": {
    id: "male-office-worker",
    name: "Man Office Worker",
    keywords: [
      "male",
      "office-worker",
      "business",
      "manager",
      "human"
    ],
    skins: [
      {
        unified: "1f468-200d-1f4bc",
        native: "👨‍💼"
      },
      {
        unified: "1f468-1f3fb-200d-1f4bc",
        native: "👨🏻‍💼"
      },
      {
        unified: "1f468-1f3fc-200d-1f4bc",
        native: "👨🏼‍💼"
      },
      {
        unified: "1f468-1f3fd-200d-1f4bc",
        native: "👨🏽‍💼"
      },
      {
        unified: "1f468-1f3fe-200d-1f4bc",
        native: "👨🏾‍💼"
      },
      {
        unified: "1f468-1f3ff-200d-1f4bc",
        native: "👨🏿‍💼"
      }
    ],
    version: 4
  },
  "female-office-worker": {
    id: "female-office-worker",
    name: "Woman Office Worker",
    keywords: [
      "female",
      "office-worker",
      "business",
      "manager",
      "human"
    ],
    skins: [
      {
        unified: "1f469-200d-1f4bc",
        native: "👩‍💼"
      },
      {
        unified: "1f469-1f3fb-200d-1f4bc",
        native: "👩🏻‍💼"
      },
      {
        unified: "1f469-1f3fc-200d-1f4bc",
        native: "👩🏼‍💼"
      },
      {
        unified: "1f469-1f3fd-200d-1f4bc",
        native: "👩🏽‍💼"
      },
      {
        unified: "1f469-1f3fe-200d-1f4bc",
        native: "👩🏾‍💼"
      },
      {
        unified: "1f469-1f3ff-200d-1f4bc",
        native: "👩🏿‍💼"
      }
    ],
    version: 4
  },
  scientist: {
    id: "scientist",
    name: "Scientist",
    keywords: [
      "chemistry"
    ],
    skins: [
      {
        unified: "1f9d1-200d-1f52c",
        native: "🧑‍🔬"
      },
      {
        unified: "1f9d1-1f3fb-200d-1f52c",
        native: "🧑🏻‍🔬"
      },
      {
        unified: "1f9d1-1f3fc-200d-1f52c",
        native: "🧑🏼‍🔬"
      },
      {
        unified: "1f9d1-1f3fd-200d-1f52c",
        native: "🧑🏽‍🔬"
      },
      {
        unified: "1f9d1-1f3fe-200d-1f52c",
        native: "🧑🏾‍🔬"
      },
      {
        unified: "1f9d1-1f3ff-200d-1f52c",
        native: "🧑🏿‍🔬"
      }
    ],
    version: 12.1
  },
  "male-scientist": {
    id: "male-scientist",
    name: "Man Scientist",
    keywords: [
      "male",
      "biologist",
      "chemist",
      "engineer",
      "physicist",
      "human"
    ],
    skins: [
      {
        unified: "1f468-200d-1f52c",
        native: "👨‍🔬"
      },
      {
        unified: "1f468-1f3fb-200d-1f52c",
        native: "👨🏻‍🔬"
      },
      {
        unified: "1f468-1f3fc-200d-1f52c",
        native: "👨🏼‍🔬"
      },
      {
        unified: "1f468-1f3fd-200d-1f52c",
        native: "👨🏽‍🔬"
      },
      {
        unified: "1f468-1f3fe-200d-1f52c",
        native: "👨🏾‍🔬"
      },
      {
        unified: "1f468-1f3ff-200d-1f52c",
        native: "👨🏿‍🔬"
      }
    ],
    version: 4
  },
  "female-scientist": {
    id: "female-scientist",
    name: "Woman Scientist",
    keywords: [
      "female",
      "biologist",
      "chemist",
      "engineer",
      "physicist",
      "human"
    ],
    skins: [
      {
        unified: "1f469-200d-1f52c",
        native: "👩‍🔬"
      },
      {
        unified: "1f469-1f3fb-200d-1f52c",
        native: "👩🏻‍🔬"
      },
      {
        unified: "1f469-1f3fc-200d-1f52c",
        native: "👩🏼‍🔬"
      },
      {
        unified: "1f469-1f3fd-200d-1f52c",
        native: "👩🏽‍🔬"
      },
      {
        unified: "1f469-1f3fe-200d-1f52c",
        native: "👩🏾‍🔬"
      },
      {
        unified: "1f469-1f3ff-200d-1f52c",
        native: "👩🏿‍🔬"
      }
    ],
    version: 4
  },
  technologist: {
    id: "technologist",
    name: "Technologist",
    keywords: [
      "computer"
    ],
    skins: [
      {
        unified: "1f9d1-200d-1f4bb",
        native: "🧑‍💻"
      },
      {
        unified: "1f9d1-1f3fb-200d-1f4bb",
        native: "🧑🏻‍💻"
      },
      {
        unified: "1f9d1-1f3fc-200d-1f4bb",
        native: "🧑🏼‍💻"
      },
      {
        unified: "1f9d1-1f3fd-200d-1f4bb",
        native: "🧑🏽‍💻"
      },
      {
        unified: "1f9d1-1f3fe-200d-1f4bb",
        native: "🧑🏾‍💻"
      },
      {
        unified: "1f9d1-1f3ff-200d-1f4bb",
        native: "🧑🏿‍💻"
      }
    ],
    version: 12.1
  },
  "male-technologist": {
    id: "male-technologist",
    name: "Man Technologist",
    keywords: [
      "male",
      "coder",
      "developer",
      "engineer",
      "programmer",
      "software",
      "human",
      "laptop",
      "computer"
    ],
    skins: [
      {
        unified: "1f468-200d-1f4bb",
        native: "👨‍💻"
      },
      {
        unified: "1f468-1f3fb-200d-1f4bb",
        native: "👨🏻‍💻"
      },
      {
        unified: "1f468-1f3fc-200d-1f4bb",
        native: "👨🏼‍💻"
      },
      {
        unified: "1f468-1f3fd-200d-1f4bb",
        native: "👨🏽‍💻"
      },
      {
        unified: "1f468-1f3fe-200d-1f4bb",
        native: "👨🏾‍💻"
      },
      {
        unified: "1f468-1f3ff-200d-1f4bb",
        native: "👨🏿‍💻"
      }
    ],
    version: 4
  },
  "female-technologist": {
    id: "female-technologist",
    name: "Woman Technologist",
    keywords: [
      "female",
      "coder",
      "developer",
      "engineer",
      "programmer",
      "software",
      "human",
      "laptop",
      "computer"
    ],
    skins: [
      {
        unified: "1f469-200d-1f4bb",
        native: "👩‍💻"
      },
      {
        unified: "1f469-1f3fb-200d-1f4bb",
        native: "👩🏻‍💻"
      },
      {
        unified: "1f469-1f3fc-200d-1f4bb",
        native: "👩🏼‍💻"
      },
      {
        unified: "1f469-1f3fd-200d-1f4bb",
        native: "👩🏽‍💻"
      },
      {
        unified: "1f469-1f3fe-200d-1f4bb",
        native: "👩🏾‍💻"
      },
      {
        unified: "1f469-1f3ff-200d-1f4bb",
        native: "👩🏿‍💻"
      }
    ],
    version: 4
  },
  singer: {
    id: "singer",
    name: "Singer",
    keywords: [
      "song",
      "artist",
      "performer"
    ],
    skins: [
      {
        unified: "1f9d1-200d-1f3a4",
        native: "🧑‍🎤"
      },
      {
        unified: "1f9d1-1f3fb-200d-1f3a4",
        native: "🧑🏻‍🎤"
      },
      {
        unified: "1f9d1-1f3fc-200d-1f3a4",
        native: "🧑🏼‍🎤"
      },
      {
        unified: "1f9d1-1f3fd-200d-1f3a4",
        native: "🧑🏽‍🎤"
      },
      {
        unified: "1f9d1-1f3fe-200d-1f3a4",
        native: "🧑🏾‍🎤"
      },
      {
        unified: "1f9d1-1f3ff-200d-1f3a4",
        native: "🧑🏿‍🎤"
      }
    ],
    version: 12.1
  },
  "male-singer": {
    id: "male-singer",
    name: "Man Singer",
    keywords: [
      "male",
      "rockstar",
      "entertainer",
      "human"
    ],
    skins: [
      {
        unified: "1f468-200d-1f3a4",
        native: "👨‍🎤"
      },
      {
        unified: "1f468-1f3fb-200d-1f3a4",
        native: "👨🏻‍🎤"
      },
      {
        unified: "1f468-1f3fc-200d-1f3a4",
        native: "👨🏼‍🎤"
      },
      {
        unified: "1f468-1f3fd-200d-1f3a4",
        native: "👨🏽‍🎤"
      },
      {
        unified: "1f468-1f3fe-200d-1f3a4",
        native: "👨🏾‍🎤"
      },
      {
        unified: "1f468-1f3ff-200d-1f3a4",
        native: "👨🏿‍🎤"
      }
    ],
    version: 4
  },
  "female-singer": {
    id: "female-singer",
    name: "Woman Singer",
    keywords: [
      "female",
      "rockstar",
      "entertainer",
      "human"
    ],
    skins: [
      {
        unified: "1f469-200d-1f3a4",
        native: "👩‍🎤"
      },
      {
        unified: "1f469-1f3fb-200d-1f3a4",
        native: "👩🏻‍🎤"
      },
      {
        unified: "1f469-1f3fc-200d-1f3a4",
        native: "👩🏼‍🎤"
      },
      {
        unified: "1f469-1f3fd-200d-1f3a4",
        native: "👩🏽‍🎤"
      },
      {
        unified: "1f469-1f3fe-200d-1f3a4",
        native: "👩🏾‍🎤"
      },
      {
        unified: "1f469-1f3ff-200d-1f3a4",
        native: "👩🏿‍🎤"
      }
    ],
    version: 4
  },
  artist: {
    id: "artist",
    name: "Artist",
    keywords: [
      "painting",
      "draw",
      "creativity"
    ],
    skins: [
      {
        unified: "1f9d1-200d-1f3a8",
        native: "🧑‍🎨"
      },
      {
        unified: "1f9d1-1f3fb-200d-1f3a8",
        native: "🧑🏻‍🎨"
      },
      {
        unified: "1f9d1-1f3fc-200d-1f3a8",
        native: "🧑🏼‍🎨"
      },
      {
        unified: "1f9d1-1f3fd-200d-1f3a8",
        native: "🧑🏽‍🎨"
      },
      {
        unified: "1f9d1-1f3fe-200d-1f3a8",
        native: "🧑🏾‍🎨"
      },
      {
        unified: "1f9d1-1f3ff-200d-1f3a8",
        native: "🧑🏿‍🎨"
      }
    ],
    version: 12.1
  },
  "male-artist": {
    id: "male-artist",
    name: "Man Artist",
    keywords: [
      "male",
      "painter",
      "human"
    ],
    skins: [
      {
        unified: "1f468-200d-1f3a8",
        native: "👨‍🎨"
      },
      {
        unified: "1f468-1f3fb-200d-1f3a8",
        native: "👨🏻‍🎨"
      },
      {
        unified: "1f468-1f3fc-200d-1f3a8",
        native: "👨🏼‍🎨"
      },
      {
        unified: "1f468-1f3fd-200d-1f3a8",
        native: "👨🏽‍🎨"
      },
      {
        unified: "1f468-1f3fe-200d-1f3a8",
        native: "👨🏾‍🎨"
      },
      {
        unified: "1f468-1f3ff-200d-1f3a8",
        native: "👨🏿‍🎨"
      }
    ],
    version: 4
  },
  "female-artist": {
    id: "female-artist",
    name: "Woman Artist",
    keywords: [
      "female",
      "painter",
      "human"
    ],
    skins: [
      {
        unified: "1f469-200d-1f3a8",
        native: "👩‍🎨"
      },
      {
        unified: "1f469-1f3fb-200d-1f3a8",
        native: "👩🏻‍🎨"
      },
      {
        unified: "1f469-1f3fc-200d-1f3a8",
        native: "👩🏼‍🎨"
      },
      {
        unified: "1f469-1f3fd-200d-1f3a8",
        native: "👩🏽‍🎨"
      },
      {
        unified: "1f469-1f3fe-200d-1f3a8",
        native: "👩🏾‍🎨"
      },
      {
        unified: "1f469-1f3ff-200d-1f3a8",
        native: "👩🏿‍🎨"
      }
    ],
    version: 4
  },
  pilot: {
    id: "pilot",
    name: "Pilot",
    keywords: [
      "fly",
      "plane",
      "airplane"
    ],
    skins: [
      {
        unified: "1f9d1-200d-2708-fe0f",
        native: "🧑‍✈️"
      },
      {
        unified: "1f9d1-1f3fb-200d-2708-fe0f",
        native: "🧑🏻‍✈️"
      },
      {
        unified: "1f9d1-1f3fc-200d-2708-fe0f",
        native: "🧑🏼‍✈️"
      },
      {
        unified: "1f9d1-1f3fd-200d-2708-fe0f",
        native: "🧑🏽‍✈️"
      },
      {
        unified: "1f9d1-1f3fe-200d-2708-fe0f",
        native: "🧑🏾‍✈️"
      },
      {
        unified: "1f9d1-1f3ff-200d-2708-fe0f",
        native: "🧑🏿‍✈️"
      }
    ],
    version: 12.1
  },
  "male-pilot": {
    id: "male-pilot",
    name: "Man Pilot",
    keywords: [
      "male",
      "aviator",
      "plane",
      "human"
    ],
    skins: [
      {
        unified: "1f468-200d-2708-fe0f",
        native: "👨‍✈️"
      },
      {
        unified: "1f468-1f3fb-200d-2708-fe0f",
        native: "👨🏻‍✈️"
      },
      {
        unified: "1f468-1f3fc-200d-2708-fe0f",
        native: "👨🏼‍✈️"
      },
      {
        unified: "1f468-1f3fd-200d-2708-fe0f",
        native: "👨🏽‍✈️"
      },
      {
        unified: "1f468-1f3fe-200d-2708-fe0f",
        native: "👨🏾‍✈️"
      },
      {
        unified: "1f468-1f3ff-200d-2708-fe0f",
        native: "👨🏿‍✈️"
      }
    ],
    version: 4
  },
  "female-pilot": {
    id: "female-pilot",
    name: "Woman Pilot",
    keywords: [
      "female",
      "aviator",
      "plane",
      "human"
    ],
    skins: [
      {
        unified: "1f469-200d-2708-fe0f",
        native: "👩‍✈️"
      },
      {
        unified: "1f469-1f3fb-200d-2708-fe0f",
        native: "👩🏻‍✈️"
      },
      {
        unified: "1f469-1f3fc-200d-2708-fe0f",
        native: "👩🏼‍✈️"
      },
      {
        unified: "1f469-1f3fd-200d-2708-fe0f",
        native: "👩🏽‍✈️"
      },
      {
        unified: "1f469-1f3fe-200d-2708-fe0f",
        native: "👩🏾‍✈️"
      },
      {
        unified: "1f469-1f3ff-200d-2708-fe0f",
        native: "👩🏿‍✈️"
      }
    ],
    version: 4
  },
  astronaut: {
    id: "astronaut",
    name: "Astronaut",
    keywords: [
      "outerspace"
    ],
    skins: [
      {
        unified: "1f9d1-200d-1f680",
        native: "🧑‍🚀"
      },
      {
        unified: "1f9d1-1f3fb-200d-1f680",
        native: "🧑🏻‍🚀"
      },
      {
        unified: "1f9d1-1f3fc-200d-1f680",
        native: "🧑🏼‍🚀"
      },
      {
        unified: "1f9d1-1f3fd-200d-1f680",
        native: "🧑🏽‍🚀"
      },
      {
        unified: "1f9d1-1f3fe-200d-1f680",
        native: "🧑🏾‍🚀"
      },
      {
        unified: "1f9d1-1f3ff-200d-1f680",
        native: "🧑🏿‍🚀"
      }
    ],
    version: 12.1
  },
  "male-astronaut": {
    id: "male-astronaut",
    name: "Man Astronaut",
    keywords: [
      "male",
      "space",
      "rocket",
      "human"
    ],
    skins: [
      {
        unified: "1f468-200d-1f680",
        native: "👨‍🚀"
      },
      {
        unified: "1f468-1f3fb-200d-1f680",
        native: "👨🏻‍🚀"
      },
      {
        unified: "1f468-1f3fc-200d-1f680",
        native: "👨🏼‍🚀"
      },
      {
        unified: "1f468-1f3fd-200d-1f680",
        native: "👨🏽‍🚀"
      },
      {
        unified: "1f468-1f3fe-200d-1f680",
        native: "👨🏾‍🚀"
      },
      {
        unified: "1f468-1f3ff-200d-1f680",
        native: "👨🏿‍🚀"
      }
    ],
    version: 4
  },
  "female-astronaut": {
    id: "female-astronaut",
    name: "Woman Astronaut",
    keywords: [
      "female",
      "space",
      "rocket",
      "human"
    ],
    skins: [
      {
        unified: "1f469-200d-1f680",
        native: "👩‍🚀"
      },
      {
        unified: "1f469-1f3fb-200d-1f680",
        native: "👩🏻‍🚀"
      },
      {
        unified: "1f469-1f3fc-200d-1f680",
        native: "👩🏼‍🚀"
      },
      {
        unified: "1f469-1f3fd-200d-1f680",
        native: "👩🏽‍🚀"
      },
      {
        unified: "1f469-1f3fe-200d-1f680",
        native: "👩🏾‍🚀"
      },
      {
        unified: "1f469-1f3ff-200d-1f680",
        native: "👩🏿‍🚀"
      }
    ],
    version: 4
  },
  firefighter: {
    id: "firefighter",
    name: "Firefighter",
    keywords: [
      "fire"
    ],
    skins: [
      {
        unified: "1f9d1-200d-1f692",
        native: "🧑‍🚒"
      },
      {
        unified: "1f9d1-1f3fb-200d-1f692",
        native: "🧑🏻‍🚒"
      },
      {
        unified: "1f9d1-1f3fc-200d-1f692",
        native: "🧑🏼‍🚒"
      },
      {
        unified: "1f9d1-1f3fd-200d-1f692",
        native: "🧑🏽‍🚒"
      },
      {
        unified: "1f9d1-1f3fe-200d-1f692",
        native: "🧑🏾‍🚒"
      },
      {
        unified: "1f9d1-1f3ff-200d-1f692",
        native: "🧑🏿‍🚒"
      }
    ],
    version: 12.1
  },
  "male-firefighter": {
    id: "male-firefighter",
    name: "Man Firefighter",
    keywords: [
      "male",
      "fireman",
      "human"
    ],
    skins: [
      {
        unified: "1f468-200d-1f692",
        native: "👨‍🚒"
      },
      {
        unified: "1f468-1f3fb-200d-1f692",
        native: "👨🏻‍🚒"
      },
      {
        unified: "1f468-1f3fc-200d-1f692",
        native: "👨🏼‍🚒"
      },
      {
        unified: "1f468-1f3fd-200d-1f692",
        native: "👨🏽‍🚒"
      },
      {
        unified: "1f468-1f3fe-200d-1f692",
        native: "👨🏾‍🚒"
      },
      {
        unified: "1f468-1f3ff-200d-1f692",
        native: "👨🏿‍🚒"
      }
    ],
    version: 4
  },
  "female-firefighter": {
    id: "female-firefighter",
    name: "Woman Firefighter",
    keywords: [
      "female",
      "fireman",
      "human"
    ],
    skins: [
      {
        unified: "1f469-200d-1f692",
        native: "👩‍🚒"
      },
      {
        unified: "1f469-1f3fb-200d-1f692",
        native: "👩🏻‍🚒"
      },
      {
        unified: "1f469-1f3fc-200d-1f692",
        native: "👩🏼‍🚒"
      },
      {
        unified: "1f469-1f3fd-200d-1f692",
        native: "👩🏽‍🚒"
      },
      {
        unified: "1f469-1f3fe-200d-1f692",
        native: "👩🏾‍🚒"
      },
      {
        unified: "1f469-1f3ff-200d-1f692",
        native: "👩🏿‍🚒"
      }
    ],
    version: 4
  },
  cop: {
    id: "cop",
    name: "Police Officer",
    keywords: [
      "cop"
    ],
    skins: [
      {
        unified: "1f46e",
        native: "👮"
      },
      {
        unified: "1f46e-1f3fb",
        native: "👮🏻"
      },
      {
        unified: "1f46e-1f3fc",
        native: "👮🏼"
      },
      {
        unified: "1f46e-1f3fd",
        native: "👮🏽"
      },
      {
        unified: "1f46e-1f3fe",
        native: "👮🏾"
      },
      {
        unified: "1f46e-1f3ff",
        native: "👮🏿"
      }
    ],
    version: 1
  },
  "male-police-officer": {
    id: "male-police-officer",
    name: "Man Police Officer",
    keywords: [
      "male",
      "police-officer",
      "law",
      "legal",
      "enforcement",
      "arrest",
      "911"
    ],
    skins: [
      {
        unified: "1f46e-200d-2642-fe0f",
        native: "👮‍♂️"
      },
      {
        unified: "1f46e-1f3fb-200d-2642-fe0f",
        native: "👮🏻‍♂️"
      },
      {
        unified: "1f46e-1f3fc-200d-2642-fe0f",
        native: "👮🏼‍♂️"
      },
      {
        unified: "1f46e-1f3fd-200d-2642-fe0f",
        native: "👮🏽‍♂️"
      },
      {
        unified: "1f46e-1f3fe-200d-2642-fe0f",
        native: "👮🏾‍♂️"
      },
      {
        unified: "1f46e-1f3ff-200d-2642-fe0f",
        native: "👮🏿‍♂️"
      }
    ],
    version: 4
  },
  "female-police-officer": {
    id: "female-police-officer",
    name: "Woman Police Officer",
    keywords: [
      "female",
      "police-officer",
      "law",
      "legal",
      "enforcement",
      "arrest",
      "911"
    ],
    skins: [
      {
        unified: "1f46e-200d-2640-fe0f",
        native: "👮‍♀️"
      },
      {
        unified: "1f46e-1f3fb-200d-2640-fe0f",
        native: "👮🏻‍♀️"
      },
      {
        unified: "1f46e-1f3fc-200d-2640-fe0f",
        native: "👮🏼‍♀️"
      },
      {
        unified: "1f46e-1f3fd-200d-2640-fe0f",
        native: "👮🏽‍♀️"
      },
      {
        unified: "1f46e-1f3fe-200d-2640-fe0f",
        native: "👮🏾‍♀️"
      },
      {
        unified: "1f46e-1f3ff-200d-2640-fe0f",
        native: "👮🏿‍♀️"
      }
    ],
    version: 4
  },
  sleuth_or_spy: {
    id: "sleuth_or_spy",
    name: "Detective",
    keywords: [
      "sleuth",
      "or",
      "spy",
      "human"
    ],
    skins: [
      {
        unified: "1f575-fe0f",
        native: "🕵️"
      },
      {
        unified: "1f575-1f3fb",
        native: "🕵🏻"
      },
      {
        unified: "1f575-1f3fc",
        native: "🕵🏼"
      },
      {
        unified: "1f575-1f3fd",
        native: "🕵🏽"
      },
      {
        unified: "1f575-1f3fe",
        native: "🕵🏾"
      },
      {
        unified: "1f575-1f3ff",
        native: "🕵🏿"
      }
    ],
    version: 1
  },
  "male-detective": {
    id: "male-detective",
    name: "Man Detective",
    keywords: [
      "male",
      "crime"
    ],
    skins: [
      {
        unified: "1f575-fe0f-200d-2642-fe0f",
        native: "🕵️‍♂️"
      },
      {
        unified: "1f575-1f3fb-200d-2642-fe0f",
        native: "🕵🏻‍♂️"
      },
      {
        unified: "1f575-1f3fc-200d-2642-fe0f",
        native: "🕵🏼‍♂️"
      },
      {
        unified: "1f575-1f3fd-200d-2642-fe0f",
        native: "🕵🏽‍♂️"
      },
      {
        unified: "1f575-1f3fe-200d-2642-fe0f",
        native: "🕵🏾‍♂️"
      },
      {
        unified: "1f575-1f3ff-200d-2642-fe0f",
        native: "🕵🏿‍♂️"
      }
    ],
    version: 4
  },
  "female-detective": {
    id: "female-detective",
    name: "Woman Detective",
    keywords: [
      "female",
      "human",
      "spy"
    ],
    skins: [
      {
        unified: "1f575-fe0f-200d-2640-fe0f",
        native: "🕵️‍♀️"
      },
      {
        unified: "1f575-1f3fb-200d-2640-fe0f",
        native: "🕵🏻‍♀️"
      },
      {
        unified: "1f575-1f3fc-200d-2640-fe0f",
        native: "🕵🏼‍♀️"
      },
      {
        unified: "1f575-1f3fd-200d-2640-fe0f",
        native: "🕵🏽‍♀️"
      },
      {
        unified: "1f575-1f3fe-200d-2640-fe0f",
        native: "🕵🏾‍♀️"
      },
      {
        unified: "1f575-1f3ff-200d-2640-fe0f",
        native: "🕵🏿‍♀️"
      }
    ],
    version: 4
  },
  guardsman: {
    id: "guardsman",
    name: "Guard",
    keywords: [
      "guardsman",
      "protect"
    ],
    skins: [
      {
        unified: "1f482",
        native: "💂"
      },
      {
        unified: "1f482-1f3fb",
        native: "💂🏻"
      },
      {
        unified: "1f482-1f3fc",
        native: "💂🏼"
      },
      {
        unified: "1f482-1f3fd",
        native: "💂🏽"
      },
      {
        unified: "1f482-1f3fe",
        native: "💂🏾"
      },
      {
        unified: "1f482-1f3ff",
        native: "💂🏿"
      }
    ],
    version: 1
  },
  "male-guard": {
    id: "male-guard",
    name: "Man Guard",
    keywords: [
      "male",
      "uk",
      "gb",
      "british",
      "guy",
      "royal"
    ],
    skins: [
      {
        unified: "1f482-200d-2642-fe0f",
        native: "💂‍♂️"
      },
      {
        unified: "1f482-1f3fb-200d-2642-fe0f",
        native: "💂🏻‍♂️"
      },
      {
        unified: "1f482-1f3fc-200d-2642-fe0f",
        native: "💂🏼‍♂️"
      },
      {
        unified: "1f482-1f3fd-200d-2642-fe0f",
        native: "💂🏽‍♂️"
      },
      {
        unified: "1f482-1f3fe-200d-2642-fe0f",
        native: "💂🏾‍♂️"
      },
      {
        unified: "1f482-1f3ff-200d-2642-fe0f",
        native: "💂🏿‍♂️"
      }
    ],
    version: 4
  },
  "female-guard": {
    id: "female-guard",
    name: "Woman Guard",
    keywords: [
      "female",
      "uk",
      "gb",
      "british",
      "royal"
    ],
    skins: [
      {
        unified: "1f482-200d-2640-fe0f",
        native: "💂‍♀️"
      },
      {
        unified: "1f482-1f3fb-200d-2640-fe0f",
        native: "💂🏻‍♀️"
      },
      {
        unified: "1f482-1f3fc-200d-2640-fe0f",
        native: "💂🏼‍♀️"
      },
      {
        unified: "1f482-1f3fd-200d-2640-fe0f",
        native: "💂🏽‍♀️"
      },
      {
        unified: "1f482-1f3fe-200d-2640-fe0f",
        native: "💂🏾‍♀️"
      },
      {
        unified: "1f482-1f3ff-200d-2640-fe0f",
        native: "💂🏿‍♀️"
      }
    ],
    version: 4
  },
  ninja: {
    id: "ninja",
    name: "Ninja",
    keywords: [
      "ninjutsu",
      "skills",
      "japanese"
    ],
    skins: [
      {
        unified: "1f977",
        native: "🥷"
      },
      {
        unified: "1f977-1f3fb",
        native: "🥷🏻"
      },
      {
        unified: "1f977-1f3fc",
        native: "🥷🏼"
      },
      {
        unified: "1f977-1f3fd",
        native: "🥷🏽"
      },
      {
        unified: "1f977-1f3fe",
        native: "🥷🏾"
      },
      {
        unified: "1f977-1f3ff",
        native: "🥷🏿"
      }
    ],
    version: 13
  },
  construction_worker: {
    id: "construction_worker",
    name: "Construction Worker",
    keywords: [
      "labor",
      "build"
    ],
    skins: [
      {
        unified: "1f477",
        native: "👷"
      },
      {
        unified: "1f477-1f3fb",
        native: "👷🏻"
      },
      {
        unified: "1f477-1f3fc",
        native: "👷🏼"
      },
      {
        unified: "1f477-1f3fd",
        native: "👷🏽"
      },
      {
        unified: "1f477-1f3fe",
        native: "👷🏾"
      },
      {
        unified: "1f477-1f3ff",
        native: "👷🏿"
      }
    ],
    version: 1
  },
  "male-construction-worker": {
    id: "male-construction-worker",
    name: "Man Construction Worker",
    keywords: [
      "male",
      "construction-worker",
      "human",
      "wip",
      "guy",
      "build",
      "labor"
    ],
    skins: [
      {
        unified: "1f477-200d-2642-fe0f",
        native: "👷‍♂️"
      },
      {
        unified: "1f477-1f3fb-200d-2642-fe0f",
        native: "👷🏻‍♂️"
      },
      {
        unified: "1f477-1f3fc-200d-2642-fe0f",
        native: "👷🏼‍♂️"
      },
      {
        unified: "1f477-1f3fd-200d-2642-fe0f",
        native: "👷🏽‍♂️"
      },
      {
        unified: "1f477-1f3fe-200d-2642-fe0f",
        native: "👷🏾‍♂️"
      },
      {
        unified: "1f477-1f3ff-200d-2642-fe0f",
        native: "👷🏿‍♂️"
      }
    ],
    version: 4
  },
  "female-construction-worker": {
    id: "female-construction-worker",
    name: "Woman Construction Worker",
    keywords: [
      "female",
      "construction-worker",
      "human",
      "wip",
      "build",
      "labor"
    ],
    skins: [
      {
        unified: "1f477-200d-2640-fe0f",
        native: "👷‍♀️"
      },
      {
        unified: "1f477-1f3fb-200d-2640-fe0f",
        native: "👷🏻‍♀️"
      },
      {
        unified: "1f477-1f3fc-200d-2640-fe0f",
        native: "👷🏼‍♀️"
      },
      {
        unified: "1f477-1f3fd-200d-2640-fe0f",
        native: "👷🏽‍♀️"
      },
      {
        unified: "1f477-1f3fe-200d-2640-fe0f",
        native: "👷🏾‍♀️"
      },
      {
        unified: "1f477-1f3ff-200d-2640-fe0f",
        native: "👷🏿‍♀️"
      }
    ],
    version: 4
  },
  person_with_crown: {
    id: "person_with_crown",
    name: "Person with Crown",
    keywords: [
      "royalty",
      "power"
    ],
    skins: [
      {
        unified: "1fac5",
        native: "🫅"
      },
      {
        unified: "1fac5-1f3fb",
        native: "🫅🏻"
      },
      {
        unified: "1fac5-1f3fc",
        native: "🫅🏼"
      },
      {
        unified: "1fac5-1f3fd",
        native: "🫅🏽"
      },
      {
        unified: "1fac5-1f3fe",
        native: "🫅🏾"
      },
      {
        unified: "1fac5-1f3ff",
        native: "🫅🏿"
      }
    ],
    version: 14
  },
  prince: {
    id: "prince",
    name: "Prince",
    keywords: [
      "boy",
      "man",
      "male",
      "crown",
      "royal",
      "king"
    ],
    skins: [
      {
        unified: "1f934",
        native: "🤴"
      },
      {
        unified: "1f934-1f3fb",
        native: "🤴🏻"
      },
      {
        unified: "1f934-1f3fc",
        native: "🤴🏼"
      },
      {
        unified: "1f934-1f3fd",
        native: "🤴🏽"
      },
      {
        unified: "1f934-1f3fe",
        native: "🤴🏾"
      },
      {
        unified: "1f934-1f3ff",
        native: "🤴🏿"
      }
    ],
    version: 3
  },
  princess: {
    id: "princess",
    name: "Princess",
    keywords: [
      "girl",
      "woman",
      "female",
      "blond",
      "crown",
      "royal",
      "queen"
    ],
    skins: [
      {
        unified: "1f478",
        native: "👸"
      },
      {
        unified: "1f478-1f3fb",
        native: "👸🏻"
      },
      {
        unified: "1f478-1f3fc",
        native: "👸🏼"
      },
      {
        unified: "1f478-1f3fd",
        native: "👸🏽"
      },
      {
        unified: "1f478-1f3fe",
        native: "👸🏾"
      },
      {
        unified: "1f478-1f3ff",
        native: "👸🏿"
      }
    ],
    version: 1
  },
  man_with_turban: {
    id: "man_with_turban",
    name: "Man with Turban",
    keywords: [
      "person",
      "wearing",
      "headdress"
    ],
    skins: [
      {
        unified: "1f473",
        native: "👳"
      },
      {
        unified: "1f473-1f3fb",
        native: "👳🏻"
      },
      {
        unified: "1f473-1f3fc",
        native: "👳🏼"
      },
      {
        unified: "1f473-1f3fd",
        native: "👳🏽"
      },
      {
        unified: "1f473-1f3fe",
        native: "👳🏾"
      },
      {
        unified: "1f473-1f3ff",
        native: "👳🏿"
      }
    ],
    version: 1
  },
  "man-wearing-turban": {
    id: "man-wearing-turban",
    name: "Man Wearing Turban",
    keywords: [
      "wearing-turban",
      "male",
      "indian",
      "hinduism",
      "arabs"
    ],
    skins: [
      {
        unified: "1f473-200d-2642-fe0f",
        native: "👳‍♂️"
      },
      {
        unified: "1f473-1f3fb-200d-2642-fe0f",
        native: "👳🏻‍♂️"
      },
      {
        unified: "1f473-1f3fc-200d-2642-fe0f",
        native: "👳🏼‍♂️"
      },
      {
        unified: "1f473-1f3fd-200d-2642-fe0f",
        native: "👳🏽‍♂️"
      },
      {
        unified: "1f473-1f3fe-200d-2642-fe0f",
        native: "👳🏾‍♂️"
      },
      {
        unified: "1f473-1f3ff-200d-2642-fe0f",
        native: "👳🏿‍♂️"
      }
    ],
    version: 4
  },
  "woman-wearing-turban": {
    id: "woman-wearing-turban",
    name: "Woman Wearing Turban",
    keywords: [
      "wearing-turban",
      "female",
      "indian",
      "hinduism",
      "arabs"
    ],
    skins: [
      {
        unified: "1f473-200d-2640-fe0f",
        native: "👳‍♀️"
      },
      {
        unified: "1f473-1f3fb-200d-2640-fe0f",
        native: "👳🏻‍♀️"
      },
      {
        unified: "1f473-1f3fc-200d-2640-fe0f",
        native: "👳🏼‍♀️"
      },
      {
        unified: "1f473-1f3fd-200d-2640-fe0f",
        native: "👳🏽‍♀️"
      },
      {
        unified: "1f473-1f3fe-200d-2640-fe0f",
        native: "👳🏾‍♀️"
      },
      {
        unified: "1f473-1f3ff-200d-2640-fe0f",
        native: "👳🏿‍♀️"
      }
    ],
    version: 4
  },
  man_with_gua_pi_mao: {
    id: "man_with_gua_pi_mao",
    name: "Man with Gua Pi Mao",
    keywords: [
      "skullcap",
      "male",
      "boy",
      "chinese"
    ],
    skins: [
      {
        unified: "1f472",
        native: "👲"
      },
      {
        unified: "1f472-1f3fb",
        native: "👲🏻"
      },
      {
        unified: "1f472-1f3fc",
        native: "👲🏼"
      },
      {
        unified: "1f472-1f3fd",
        native: "👲🏽"
      },
      {
        unified: "1f472-1f3fe",
        native: "👲🏾"
      },
      {
        unified: "1f472-1f3ff",
        native: "👲🏿"
      }
    ],
    version: 1
  },
  person_with_headscarf: {
    id: "person_with_headscarf",
    name: "Woman with Headscarf",
    keywords: [
      "person",
      "female",
      "hijab",
      "mantilla",
      "tichel"
    ],
    skins: [
      {
        unified: "1f9d5",
        native: "🧕"
      },
      {
        unified: "1f9d5-1f3fb",
        native: "🧕🏻"
      },
      {
        unified: "1f9d5-1f3fc",
        native: "🧕🏼"
      },
      {
        unified: "1f9d5-1f3fd",
        native: "🧕🏽"
      },
      {
        unified: "1f9d5-1f3fe",
        native: "🧕🏾"
      },
      {
        unified: "1f9d5-1f3ff",
        native: "🧕🏿"
      }
    ],
    version: 5
  },
  person_in_tuxedo: {
    id: "person_in_tuxedo",
    name: "Man in Tuxedo",
    keywords: [
      "person",
      "couple",
      "marriage",
      "wedding",
      "groom"
    ],
    skins: [
      {
        unified: "1f935",
        native: "🤵"
      },
      {
        unified: "1f935-1f3fb",
        native: "🤵🏻"
      },
      {
        unified: "1f935-1f3fc",
        native: "🤵🏼"
      },
      {
        unified: "1f935-1f3fd",
        native: "🤵🏽"
      },
      {
        unified: "1f935-1f3fe",
        native: "🤵🏾"
      },
      {
        unified: "1f935-1f3ff",
        native: "🤵🏿"
      }
    ],
    version: 3
  },
  man_in_tuxedo: {
    id: "man_in_tuxedo",
    name: "Man in Tuxedo",
    keywords: [
      "formal",
      "fashion"
    ],
    skins: [
      {
        unified: "1f935-200d-2642-fe0f",
        native: "🤵‍♂️"
      },
      {
        unified: "1f935-1f3fb-200d-2642-fe0f",
        native: "🤵🏻‍♂️"
      },
      {
        unified: "1f935-1f3fc-200d-2642-fe0f",
        native: "🤵🏼‍♂️"
      },
      {
        unified: "1f935-1f3fd-200d-2642-fe0f",
        native: "🤵🏽‍♂️"
      },
      {
        unified: "1f935-1f3fe-200d-2642-fe0f",
        native: "🤵🏾‍♂️"
      },
      {
        unified: "1f935-1f3ff-200d-2642-fe0f",
        native: "🤵🏿‍♂️"
      }
    ],
    version: 13
  },
  woman_in_tuxedo: {
    id: "woman_in_tuxedo",
    name: "Woman in Tuxedo",
    keywords: [
      "formal",
      "fashion"
    ],
    skins: [
      {
        unified: "1f935-200d-2640-fe0f",
        native: "🤵‍♀️"
      },
      {
        unified: "1f935-1f3fb-200d-2640-fe0f",
        native: "🤵🏻‍♀️"
      },
      {
        unified: "1f935-1f3fc-200d-2640-fe0f",
        native: "🤵🏼‍♀️"
      },
      {
        unified: "1f935-1f3fd-200d-2640-fe0f",
        native: "🤵🏽‍♀️"
      },
      {
        unified: "1f935-1f3fe-200d-2640-fe0f",
        native: "🤵🏾‍♀️"
      },
      {
        unified: "1f935-1f3ff-200d-2640-fe0f",
        native: "🤵🏿‍♀️"
      }
    ],
    version: 13
  },
  bride_with_veil: {
    id: "bride_with_veil",
    name: "Bride with Veil",
    keywords: [
      "couple",
      "marriage",
      "wedding",
      "woman"
    ],
    skins: [
      {
        unified: "1f470",
        native: "👰"
      },
      {
        unified: "1f470-1f3fb",
        native: "👰🏻"
      },
      {
        unified: "1f470-1f3fc",
        native: "👰🏼"
      },
      {
        unified: "1f470-1f3fd",
        native: "👰🏽"
      },
      {
        unified: "1f470-1f3fe",
        native: "👰🏾"
      },
      {
        unified: "1f470-1f3ff",
        native: "👰🏿"
      }
    ],
    version: 1
  },
  man_with_veil: {
    id: "man_with_veil",
    name: "Man with Veil",
    keywords: [
      "wedding",
      "marriage"
    ],
    skins: [
      {
        unified: "1f470-200d-2642-fe0f",
        native: "👰‍♂️"
      },
      {
        unified: "1f470-1f3fb-200d-2642-fe0f",
        native: "👰🏻‍♂️"
      },
      {
        unified: "1f470-1f3fc-200d-2642-fe0f",
        native: "👰🏼‍♂️"
      },
      {
        unified: "1f470-1f3fd-200d-2642-fe0f",
        native: "👰🏽‍♂️"
      },
      {
        unified: "1f470-1f3fe-200d-2642-fe0f",
        native: "👰🏾‍♂️"
      },
      {
        unified: "1f470-1f3ff-200d-2642-fe0f",
        native: "👰🏿‍♂️"
      }
    ],
    version: 13
  },
  woman_with_veil: {
    id: "woman_with_veil",
    name: "Woman with Veil",
    keywords: [
      "wedding",
      "marriage"
    ],
    skins: [
      {
        unified: "1f470-200d-2640-fe0f",
        native: "👰‍♀️"
      },
      {
        unified: "1f470-1f3fb-200d-2640-fe0f",
        native: "👰🏻‍♀️"
      },
      {
        unified: "1f470-1f3fc-200d-2640-fe0f",
        native: "👰🏼‍♀️"
      },
      {
        unified: "1f470-1f3fd-200d-2640-fe0f",
        native: "👰🏽‍♀️"
      },
      {
        unified: "1f470-1f3fe-200d-2640-fe0f",
        native: "👰🏾‍♀️"
      },
      {
        unified: "1f470-1f3ff-200d-2640-fe0f",
        native: "👰🏿‍♀️"
      }
    ],
    version: 13
  },
  pregnant_woman: {
    id: "pregnant_woman",
    name: "Pregnant Woman",
    keywords: [
      "baby"
    ],
    skins: [
      {
        unified: "1f930",
        native: "🤰"
      },
      {
        unified: "1f930-1f3fb",
        native: "🤰🏻"
      },
      {
        unified: "1f930-1f3fc",
        native: "🤰🏼"
      },
      {
        unified: "1f930-1f3fd",
        native: "🤰🏽"
      },
      {
        unified: "1f930-1f3fe",
        native: "🤰🏾"
      },
      {
        unified: "1f930-1f3ff",
        native: "🤰🏿"
      }
    ],
    version: 3
  },
  pregnant_man: {
    id: "pregnant_man",
    name: "Pregnant Man",
    keywords: [
      "baby",
      "belly"
    ],
    skins: [
      {
        unified: "1fac3",
        native: "🫃"
      },
      {
        unified: "1fac3-1f3fb",
        native: "🫃🏻"
      },
      {
        unified: "1fac3-1f3fc",
        native: "🫃🏼"
      },
      {
        unified: "1fac3-1f3fd",
        native: "🫃🏽"
      },
      {
        unified: "1fac3-1f3fe",
        native: "🫃🏾"
      },
      {
        unified: "1fac3-1f3ff",
        native: "🫃🏿"
      }
    ],
    version: 14
  },
  pregnant_person: {
    id: "pregnant_person",
    name: "Pregnant Person",
    keywords: [
      "baby",
      "belly"
    ],
    skins: [
      {
        unified: "1fac4",
        native: "🫄"
      },
      {
        unified: "1fac4-1f3fb",
        native: "🫄🏻"
      },
      {
        unified: "1fac4-1f3fc",
        native: "🫄🏼"
      },
      {
        unified: "1fac4-1f3fd",
        native: "🫄🏽"
      },
      {
        unified: "1fac4-1f3fe",
        native: "🫄🏾"
      },
      {
        unified: "1fac4-1f3ff",
        native: "🫄🏿"
      }
    ],
    version: 14
  },
  "breast-feeding": {
    id: "breast-feeding",
    name: "Breast-Feeding",
    keywords: [
      "breast",
      "feeding",
      "nursing",
      "baby"
    ],
    skins: [
      {
        unified: "1f931",
        native: "🤱"
      },
      {
        unified: "1f931-1f3fb",
        native: "🤱🏻"
      },
      {
        unified: "1f931-1f3fc",
        native: "🤱🏼"
      },
      {
        unified: "1f931-1f3fd",
        native: "🤱🏽"
      },
      {
        unified: "1f931-1f3fe",
        native: "🤱🏾"
      },
      {
        unified: "1f931-1f3ff",
        native: "🤱🏿"
      }
    ],
    version: 5
  },
  woman_feeding_baby: {
    id: "woman_feeding_baby",
    name: "Woman Feeding Baby",
    keywords: [
      "birth",
      "food"
    ],
    skins: [
      {
        unified: "1f469-200d-1f37c",
        native: "👩‍🍼"
      },
      {
        unified: "1f469-1f3fb-200d-1f37c",
        native: "👩🏻‍🍼"
      },
      {
        unified: "1f469-1f3fc-200d-1f37c",
        native: "👩🏼‍🍼"
      },
      {
        unified: "1f469-1f3fd-200d-1f37c",
        native: "👩🏽‍🍼"
      },
      {
        unified: "1f469-1f3fe-200d-1f37c",
        native: "👩🏾‍🍼"
      },
      {
        unified: "1f469-1f3ff-200d-1f37c",
        native: "👩🏿‍🍼"
      }
    ],
    version: 13
  },
  man_feeding_baby: {
    id: "man_feeding_baby",
    name: "Man Feeding Baby",
    keywords: [
      "birth",
      "food"
    ],
    skins: [
      {
        unified: "1f468-200d-1f37c",
        native: "👨‍🍼"
      },
      {
        unified: "1f468-1f3fb-200d-1f37c",
        native: "👨🏻‍🍼"
      },
      {
        unified: "1f468-1f3fc-200d-1f37c",
        native: "👨🏼‍🍼"
      },
      {
        unified: "1f468-1f3fd-200d-1f37c",
        native: "👨🏽‍🍼"
      },
      {
        unified: "1f468-1f3fe-200d-1f37c",
        native: "👨🏾‍🍼"
      },
      {
        unified: "1f468-1f3ff-200d-1f37c",
        native: "👨🏿‍🍼"
      }
    ],
    version: 13
  },
  person_feeding_baby: {
    id: "person_feeding_baby",
    name: "Person Feeding Baby",
    keywords: [
      "birth",
      "food"
    ],
    skins: [
      {
        unified: "1f9d1-200d-1f37c",
        native: "🧑‍🍼"
      },
      {
        unified: "1f9d1-1f3fb-200d-1f37c",
        native: "🧑🏻‍🍼"
      },
      {
        unified: "1f9d1-1f3fc-200d-1f37c",
        native: "🧑🏼‍🍼"
      },
      {
        unified: "1f9d1-1f3fd-200d-1f37c",
        native: "🧑🏽‍🍼"
      },
      {
        unified: "1f9d1-1f3fe-200d-1f37c",
        native: "🧑🏾‍🍼"
      },
      {
        unified: "1f9d1-1f3ff-200d-1f37c",
        native: "🧑🏿‍🍼"
      }
    ],
    version: 13
  },
  angel: {
    id: "angel",
    name: "Baby Angel",
    keywords: [
      "heaven",
      "wings",
      "halo"
    ],
    skins: [
      {
        unified: "1f47c",
        native: "👼"
      },
      {
        unified: "1f47c-1f3fb",
        native: "👼🏻"
      },
      {
        unified: "1f47c-1f3fc",
        native: "👼🏼"
      },
      {
        unified: "1f47c-1f3fd",
        native: "👼🏽"
      },
      {
        unified: "1f47c-1f3fe",
        native: "👼🏾"
      },
      {
        unified: "1f47c-1f3ff",
        native: "👼🏿"
      }
    ],
    version: 1
  },
  santa: {
    id: "santa",
    name: "Santa Claus",
    keywords: [
      "festival",
      "man",
      "male",
      "xmas",
      "father",
      "christmas"
    ],
    skins: [
      {
        unified: "1f385",
        native: "🎅"
      },
      {
        unified: "1f385-1f3fb",
        native: "🎅🏻"
      },
      {
        unified: "1f385-1f3fc",
        native: "🎅🏼"
      },
      {
        unified: "1f385-1f3fd",
        native: "🎅🏽"
      },
      {
        unified: "1f385-1f3fe",
        native: "🎅🏾"
      },
      {
        unified: "1f385-1f3ff",
        native: "🎅🏿"
      }
    ],
    version: 1
  },
  mrs_claus: {
    id: "mrs_claus",
    name: "Mrs. Claus",
    keywords: [
      "mrs",
      "mother",
      "christmas",
      "woman",
      "female",
      "xmas"
    ],
    skins: [
      {
        unified: "1f936",
        native: "🤶"
      },
      {
        unified: "1f936-1f3fb",
        native: "🤶🏻"
      },
      {
        unified: "1f936-1f3fc",
        native: "🤶🏼"
      },
      {
        unified: "1f936-1f3fd",
        native: "🤶🏽"
      },
      {
        unified: "1f936-1f3fe",
        native: "🤶🏾"
      },
      {
        unified: "1f936-1f3ff",
        native: "🤶🏿"
      }
    ],
    version: 3
  },
  mx_claus: {
    id: "mx_claus",
    name: "Mx Claus",
    keywords: [
      "christmas"
    ],
    skins: [
      {
        unified: "1f9d1-200d-1f384",
        native: "🧑‍🎄"
      },
      {
        unified: "1f9d1-1f3fb-200d-1f384",
        native: "🧑🏻‍🎄"
      },
      {
        unified: "1f9d1-1f3fc-200d-1f384",
        native: "🧑🏼‍🎄"
      },
      {
        unified: "1f9d1-1f3fd-200d-1f384",
        native: "🧑🏽‍🎄"
      },
      {
        unified: "1f9d1-1f3fe-200d-1f384",
        native: "🧑🏾‍🎄"
      },
      {
        unified: "1f9d1-1f3ff-200d-1f384",
        native: "🧑🏿‍🎄"
      }
    ],
    version: 13
  },
  superhero: {
    id: "superhero",
    name: "Superhero",
    keywords: [
      "marvel"
    ],
    skins: [
      {
        unified: "1f9b8",
        native: "🦸"
      },
      {
        unified: "1f9b8-1f3fb",
        native: "🦸🏻"
      },
      {
        unified: "1f9b8-1f3fc",
        native: "🦸🏼"
      },
      {
        unified: "1f9b8-1f3fd",
        native: "🦸🏽"
      },
      {
        unified: "1f9b8-1f3fe",
        native: "🦸🏾"
      },
      {
        unified: "1f9b8-1f3ff",
        native: "🦸🏿"
      }
    ],
    version: 11
  },
  male_superhero: {
    id: "male_superhero",
    name: "Man Superhero",
    keywords: [
      "male",
      "good",
      "hero",
      "superpowers"
    ],
    skins: [
      {
        unified: "1f9b8-200d-2642-fe0f",
        native: "🦸‍♂️"
      },
      {
        unified: "1f9b8-1f3fb-200d-2642-fe0f",
        native: "🦸🏻‍♂️"
      },
      {
        unified: "1f9b8-1f3fc-200d-2642-fe0f",
        native: "🦸🏼‍♂️"
      },
      {
        unified: "1f9b8-1f3fd-200d-2642-fe0f",
        native: "🦸🏽‍♂️"
      },
      {
        unified: "1f9b8-1f3fe-200d-2642-fe0f",
        native: "🦸🏾‍♂️"
      },
      {
        unified: "1f9b8-1f3ff-200d-2642-fe0f",
        native: "🦸🏿‍♂️"
      }
    ],
    version: 11
  },
  female_superhero: {
    id: "female_superhero",
    name: "Woman Superhero",
    keywords: [
      "female",
      "good",
      "heroine",
      "superpowers"
    ],
    skins: [
      {
        unified: "1f9b8-200d-2640-fe0f",
        native: "🦸‍♀️"
      },
      {
        unified: "1f9b8-1f3fb-200d-2640-fe0f",
        native: "🦸🏻‍♀️"
      },
      {
        unified: "1f9b8-1f3fc-200d-2640-fe0f",
        native: "🦸🏼‍♀️"
      },
      {
        unified: "1f9b8-1f3fd-200d-2640-fe0f",
        native: "🦸🏽‍♀️"
      },
      {
        unified: "1f9b8-1f3fe-200d-2640-fe0f",
        native: "🦸🏾‍♀️"
      },
      {
        unified: "1f9b8-1f3ff-200d-2640-fe0f",
        native: "🦸🏿‍♀️"
      }
    ],
    version: 11
  },
  supervillain: {
    id: "supervillain",
    name: "Supervillain",
    keywords: [
      "marvel"
    ],
    skins: [
      {
        unified: "1f9b9",
        native: "🦹"
      },
      {
        unified: "1f9b9-1f3fb",
        native: "🦹🏻"
      },
      {
        unified: "1f9b9-1f3fc",
        native: "🦹🏼"
      },
      {
        unified: "1f9b9-1f3fd",
        native: "🦹🏽"
      },
      {
        unified: "1f9b9-1f3fe",
        native: "🦹🏾"
      },
      {
        unified: "1f9b9-1f3ff",
        native: "🦹🏿"
      }
    ],
    version: 11
  },
  male_supervillain: {
    id: "male_supervillain",
    name: "Man Supervillain",
    keywords: [
      "male",
      "evil",
      "bad",
      "criminal",
      "hero",
      "superpowers"
    ],
    skins: [
      {
        unified: "1f9b9-200d-2642-fe0f",
        native: "🦹‍♂️"
      },
      {
        unified: "1f9b9-1f3fb-200d-2642-fe0f",
        native: "🦹🏻‍♂️"
      },
      {
        unified: "1f9b9-1f3fc-200d-2642-fe0f",
        native: "🦹🏼‍♂️"
      },
      {
        unified: "1f9b9-1f3fd-200d-2642-fe0f",
        native: "🦹🏽‍♂️"
      },
      {
        unified: "1f9b9-1f3fe-200d-2642-fe0f",
        native: "🦹🏾‍♂️"
      },
      {
        unified: "1f9b9-1f3ff-200d-2642-fe0f",
        native: "🦹🏿‍♂️"
      }
    ],
    version: 11
  },
  female_supervillain: {
    id: "female_supervillain",
    name: "Woman Supervillain",
    keywords: [
      "female",
      "evil",
      "bad",
      "criminal",
      "heroine",
      "superpowers"
    ],
    skins: [
      {
        unified: "1f9b9-200d-2640-fe0f",
        native: "🦹‍♀️"
      },
      {
        unified: "1f9b9-1f3fb-200d-2640-fe0f",
        native: "🦹🏻‍♀️"
      },
      {
        unified: "1f9b9-1f3fc-200d-2640-fe0f",
        native: "🦹🏼‍♀️"
      },
      {
        unified: "1f9b9-1f3fd-200d-2640-fe0f",
        native: "🦹🏽‍♀️"
      },
      {
        unified: "1f9b9-1f3fe-200d-2640-fe0f",
        native: "🦹🏾‍♀️"
      },
      {
        unified: "1f9b9-1f3ff-200d-2640-fe0f",
        native: "🦹🏿‍♀️"
      }
    ],
    version: 11
  },
  mage: {
    id: "mage",
    name: "Mage",
    keywords: [
      "magic"
    ],
    skins: [
      {
        unified: "1f9d9",
        native: "🧙"
      },
      {
        unified: "1f9d9-1f3fb",
        native: "🧙🏻"
      },
      {
        unified: "1f9d9-1f3fc",
        native: "🧙🏼"
      },
      {
        unified: "1f9d9-1f3fd",
        native: "🧙🏽"
      },
      {
        unified: "1f9d9-1f3fe",
        native: "🧙🏾"
      },
      {
        unified: "1f9d9-1f3ff",
        native: "🧙🏿"
      }
    ],
    version: 5
  },
  male_mage: {
    id: "male_mage",
    name: "Man Mage",
    keywords: [
      "male",
      "sorcerer"
    ],
    skins: [
      {
        unified: "1f9d9-200d-2642-fe0f",
        native: "🧙‍♂️"
      },
      {
        unified: "1f9d9-1f3fb-200d-2642-fe0f",
        native: "🧙🏻‍♂️"
      },
      {
        unified: "1f9d9-1f3fc-200d-2642-fe0f",
        native: "🧙🏼‍♂️"
      },
      {
        unified: "1f9d9-1f3fd-200d-2642-fe0f",
        native: "🧙🏽‍♂️"
      },
      {
        unified: "1f9d9-1f3fe-200d-2642-fe0f",
        native: "🧙🏾‍♂️"
      },
      {
        unified: "1f9d9-1f3ff-200d-2642-fe0f",
        native: "🧙🏿‍♂️"
      }
    ],
    version: 5
  },
  female_mage: {
    id: "female_mage",
    name: "Woman Mage",
    keywords: [
      "female",
      "witch"
    ],
    skins: [
      {
        unified: "1f9d9-200d-2640-fe0f",
        native: "🧙‍♀️"
      },
      {
        unified: "1f9d9-1f3fb-200d-2640-fe0f",
        native: "🧙🏻‍♀️"
      },
      {
        unified: "1f9d9-1f3fc-200d-2640-fe0f",
        native: "🧙🏼‍♀️"
      },
      {
        unified: "1f9d9-1f3fd-200d-2640-fe0f",
        native: "🧙🏽‍♀️"
      },
      {
        unified: "1f9d9-1f3fe-200d-2640-fe0f",
        native: "🧙🏾‍♀️"
      },
      {
        unified: "1f9d9-1f3ff-200d-2640-fe0f",
        native: "🧙🏿‍♀️"
      }
    ],
    version: 5
  },
  fairy: {
    id: "fairy",
    name: "Fairy",
    keywords: [
      "wings",
      "magical"
    ],
    skins: [
      {
        unified: "1f9da",
        native: "🧚"
      },
      {
        unified: "1f9da-1f3fb",
        native: "🧚🏻"
      },
      {
        unified: "1f9da-1f3fc",
        native: "🧚🏼"
      },
      {
        unified: "1f9da-1f3fd",
        native: "🧚🏽"
      },
      {
        unified: "1f9da-1f3fe",
        native: "🧚🏾"
      },
      {
        unified: "1f9da-1f3ff",
        native: "🧚🏿"
      }
    ],
    version: 5
  },
  male_fairy: {
    id: "male_fairy",
    name: "Man Fairy",
    keywords: [
      "male"
    ],
    skins: [
      {
        unified: "1f9da-200d-2642-fe0f",
        native: "🧚‍♂️"
      },
      {
        unified: "1f9da-1f3fb-200d-2642-fe0f",
        native: "🧚🏻‍♂️"
      },
      {
        unified: "1f9da-1f3fc-200d-2642-fe0f",
        native: "🧚🏼‍♂️"
      },
      {
        unified: "1f9da-1f3fd-200d-2642-fe0f",
        native: "🧚🏽‍♂️"
      },
      {
        unified: "1f9da-1f3fe-200d-2642-fe0f",
        native: "🧚🏾‍♂️"
      },
      {
        unified: "1f9da-1f3ff-200d-2642-fe0f",
        native: "🧚🏿‍♂️"
      }
    ],
    version: 5
  },
  female_fairy: {
    id: "female_fairy",
    name: "Woman Fairy",
    keywords: [
      "female"
    ],
    skins: [
      {
        unified: "1f9da-200d-2640-fe0f",
        native: "🧚‍♀️"
      },
      {
        unified: "1f9da-1f3fb-200d-2640-fe0f",
        native: "🧚🏻‍♀️"
      },
      {
        unified: "1f9da-1f3fc-200d-2640-fe0f",
        native: "🧚🏼‍♀️"
      },
      {
        unified: "1f9da-1f3fd-200d-2640-fe0f",
        native: "🧚🏽‍♀️"
      },
      {
        unified: "1f9da-1f3fe-200d-2640-fe0f",
        native: "🧚🏾‍♀️"
      },
      {
        unified: "1f9da-1f3ff-200d-2640-fe0f",
        native: "🧚🏿‍♀️"
      }
    ],
    version: 5
  },
  vampire: {
    id: "vampire",
    name: "Vampire",
    keywords: [
      "blood",
      "twilight"
    ],
    skins: [
      {
        unified: "1f9db",
        native: "🧛"
      },
      {
        unified: "1f9db-1f3fb",
        native: "🧛🏻"
      },
      {
        unified: "1f9db-1f3fc",
        native: "🧛🏼"
      },
      {
        unified: "1f9db-1f3fd",
        native: "🧛🏽"
      },
      {
        unified: "1f9db-1f3fe",
        native: "🧛🏾"
      },
      {
        unified: "1f9db-1f3ff",
        native: "🧛🏿"
      }
    ],
    version: 5
  },
  male_vampire: {
    id: "male_vampire",
    name: "Man Vampire",
    keywords: [
      "male",
      "dracula"
    ],
    skins: [
      {
        unified: "1f9db-200d-2642-fe0f",
        native: "🧛‍♂️"
      },
      {
        unified: "1f9db-1f3fb-200d-2642-fe0f",
        native: "🧛🏻‍♂️"
      },
      {
        unified: "1f9db-1f3fc-200d-2642-fe0f",
        native: "🧛🏼‍♂️"
      },
      {
        unified: "1f9db-1f3fd-200d-2642-fe0f",
        native: "🧛🏽‍♂️"
      },
      {
        unified: "1f9db-1f3fe-200d-2642-fe0f",
        native: "🧛🏾‍♂️"
      },
      {
        unified: "1f9db-1f3ff-200d-2642-fe0f",
        native: "🧛🏿‍♂️"
      }
    ],
    version: 5
  },
  female_vampire: {
    id: "female_vampire",
    name: "Woman Vampire",
    keywords: [
      "female"
    ],
    skins: [
      {
        unified: "1f9db-200d-2640-fe0f",
        native: "🧛‍♀️"
      },
      {
        unified: "1f9db-1f3fb-200d-2640-fe0f",
        native: "🧛🏻‍♀️"
      },
      {
        unified: "1f9db-1f3fc-200d-2640-fe0f",
        native: "🧛🏼‍♀️"
      },
      {
        unified: "1f9db-1f3fd-200d-2640-fe0f",
        native: "🧛🏽‍♀️"
      },
      {
        unified: "1f9db-1f3fe-200d-2640-fe0f",
        native: "🧛🏾‍♀️"
      },
      {
        unified: "1f9db-1f3ff-200d-2640-fe0f",
        native: "🧛🏿‍♀️"
      }
    ],
    version: 5
  },
  merperson: {
    id: "merperson",
    name: "Merperson",
    keywords: [
      "sea"
    ],
    skins: [
      {
        unified: "1f9dc",
        native: "🧜"
      },
      {
        unified: "1f9dc-1f3fb",
        native: "🧜🏻"
      },
      {
        unified: "1f9dc-1f3fc",
        native: "🧜🏼"
      },
      {
        unified: "1f9dc-1f3fd",
        native: "🧜🏽"
      },
      {
        unified: "1f9dc-1f3fe",
        native: "🧜🏾"
      },
      {
        unified: "1f9dc-1f3ff",
        native: "🧜🏿"
      }
    ],
    version: 5
  },
  merman: {
    id: "merman",
    name: "Merman",
    keywords: [
      "man",
      "male",
      "triton"
    ],
    skins: [
      {
        unified: "1f9dc-200d-2642-fe0f",
        native: "🧜‍♂️"
      },
      {
        unified: "1f9dc-1f3fb-200d-2642-fe0f",
        native: "🧜🏻‍♂️"
      },
      {
        unified: "1f9dc-1f3fc-200d-2642-fe0f",
        native: "🧜🏼‍♂️"
      },
      {
        unified: "1f9dc-1f3fd-200d-2642-fe0f",
        native: "🧜🏽‍♂️"
      },
      {
        unified: "1f9dc-1f3fe-200d-2642-fe0f",
        native: "🧜🏾‍♂️"
      },
      {
        unified: "1f9dc-1f3ff-200d-2642-fe0f",
        native: "🧜🏿‍♂️"
      }
    ],
    version: 5
  },
  mermaid: {
    id: "mermaid",
    name: "Mermaid",
    keywords: [
      "woman",
      "female",
      "merwoman",
      "ariel"
    ],
    skins: [
      {
        unified: "1f9dc-200d-2640-fe0f",
        native: "🧜‍♀️"
      },
      {
        unified: "1f9dc-1f3fb-200d-2640-fe0f",
        native: "🧜🏻‍♀️"
      },
      {
        unified: "1f9dc-1f3fc-200d-2640-fe0f",
        native: "🧜🏼‍♀️"
      },
      {
        unified: "1f9dc-1f3fd-200d-2640-fe0f",
        native: "🧜🏽‍♀️"
      },
      {
        unified: "1f9dc-1f3fe-200d-2640-fe0f",
        native: "🧜🏾‍♀️"
      },
      {
        unified: "1f9dc-1f3ff-200d-2640-fe0f",
        native: "🧜🏿‍♀️"
      }
    ],
    version: 5
  },
  elf: {
    id: "elf",
    name: "Elf",
    keywords: [
      "magical"
    ],
    skins: [
      {
        unified: "1f9dd",
        native: "🧝"
      },
      {
        unified: "1f9dd-1f3fb",
        native: "🧝🏻"
      },
      {
        unified: "1f9dd-1f3fc",
        native: "🧝🏼"
      },
      {
        unified: "1f9dd-1f3fd",
        native: "🧝🏽"
      },
      {
        unified: "1f9dd-1f3fe",
        native: "🧝🏾"
      },
      {
        unified: "1f9dd-1f3ff",
        native: "🧝🏿"
      }
    ],
    version: 5
  },
  male_elf: {
    id: "male_elf",
    name: "Man Elf",
    keywords: [
      "male"
    ],
    skins: [
      {
        unified: "1f9dd-200d-2642-fe0f",
        native: "🧝‍♂️"
      },
      {
        unified: "1f9dd-1f3fb-200d-2642-fe0f",
        native: "🧝🏻‍♂️"
      },
      {
        unified: "1f9dd-1f3fc-200d-2642-fe0f",
        native: "🧝🏼‍♂️"
      },
      {
        unified: "1f9dd-1f3fd-200d-2642-fe0f",
        native: "🧝🏽‍♂️"
      },
      {
        unified: "1f9dd-1f3fe-200d-2642-fe0f",
        native: "🧝🏾‍♂️"
      },
      {
        unified: "1f9dd-1f3ff-200d-2642-fe0f",
        native: "🧝🏿‍♂️"
      }
    ],
    version: 5
  },
  female_elf: {
    id: "female_elf",
    name: "Woman Elf",
    keywords: [
      "female"
    ],
    skins: [
      {
        unified: "1f9dd-200d-2640-fe0f",
        native: "🧝‍♀️"
      },
      {
        unified: "1f9dd-1f3fb-200d-2640-fe0f",
        native: "🧝🏻‍♀️"
      },
      {
        unified: "1f9dd-1f3fc-200d-2640-fe0f",
        native: "🧝🏼‍♀️"
      },
      {
        unified: "1f9dd-1f3fd-200d-2640-fe0f",
        native: "🧝🏽‍♀️"
      },
      {
        unified: "1f9dd-1f3fe-200d-2640-fe0f",
        native: "🧝🏾‍♀️"
      },
      {
        unified: "1f9dd-1f3ff-200d-2640-fe0f",
        native: "🧝🏿‍♀️"
      }
    ],
    version: 5
  },
  genie: {
    id: "genie",
    name: "Genie",
    keywords: [
      "magical",
      "wishes"
    ],
    skins: [
      {
        unified: "1f9de",
        native: "🧞"
      }
    ],
    version: 5
  },
  male_genie: {
    id: "male_genie",
    name: "Man Genie",
    keywords: [
      "male"
    ],
    skins: [
      {
        unified: "1f9de-200d-2642-fe0f",
        native: "🧞‍♂️"
      }
    ],
    version: 5
  },
  female_genie: {
    id: "female_genie",
    name: "Woman Genie",
    keywords: [
      "female"
    ],
    skins: [
      {
        unified: "1f9de-200d-2640-fe0f",
        native: "🧞‍♀️"
      }
    ],
    version: 5
  },
  zombie: {
    id: "zombie",
    name: "Zombie",
    keywords: [
      "dead"
    ],
    skins: [
      {
        unified: "1f9df",
        native: "🧟"
      }
    ],
    version: 5
  },
  male_zombie: {
    id: "male_zombie",
    name: "Man Zombie",
    keywords: [
      "male",
      "dracula",
      "undead",
      "walking",
      "dead"
    ],
    skins: [
      {
        unified: "1f9df-200d-2642-fe0f",
        native: "🧟‍♂️"
      }
    ],
    version: 5
  },
  female_zombie: {
    id: "female_zombie",
    name: "Woman Zombie",
    keywords: [
      "female",
      "undead",
      "walking",
      "dead"
    ],
    skins: [
      {
        unified: "1f9df-200d-2640-fe0f",
        native: "🧟‍♀️"
      }
    ],
    version: 5
  },
  troll: {
    id: "troll",
    name: "Troll",
    keywords: [
      "mystical",
      "monster"
    ],
    skins: [
      {
        unified: "1f9cc",
        native: "🧌"
      }
    ],
    version: 14
  },
  massage: {
    id: "massage",
    name: "Face Massage",
    keywords: [
      "person",
      "getting",
      "relax"
    ],
    skins: [
      {
        unified: "1f486",
        native: "💆"
      },
      {
        unified: "1f486-1f3fb",
        native: "💆🏻"
      },
      {
        unified: "1f486-1f3fc",
        native: "💆🏼"
      },
      {
        unified: "1f486-1f3fd",
        native: "💆🏽"
      },
      {
        unified: "1f486-1f3fe",
        native: "💆🏾"
      },
      {
        unified: "1f486-1f3ff",
        native: "💆🏿"
      }
    ],
    version: 1
  },
  "man-getting-massage": {
    id: "man-getting-massage",
    name: "Man Getting Massage",
    keywords: [
      "getting-massage",
      "male",
      "boy",
      "head"
    ],
    skins: [
      {
        unified: "1f486-200d-2642-fe0f",
        native: "💆‍♂️"
      },
      {
        unified: "1f486-1f3fb-200d-2642-fe0f",
        native: "💆🏻‍♂️"
      },
      {
        unified: "1f486-1f3fc-200d-2642-fe0f",
        native: "💆🏼‍♂️"
      },
      {
        unified: "1f486-1f3fd-200d-2642-fe0f",
        native: "💆🏽‍♂️"
      },
      {
        unified: "1f486-1f3fe-200d-2642-fe0f",
        native: "💆🏾‍♂️"
      },
      {
        unified: "1f486-1f3ff-200d-2642-fe0f",
        native: "💆🏿‍♂️"
      }
    ],
    version: 4
  },
  "woman-getting-massage": {
    id: "woman-getting-massage",
    name: "Woman Getting Massage",
    keywords: [
      "getting-massage",
      "female",
      "girl",
      "head"
    ],
    skins: [
      {
        unified: "1f486-200d-2640-fe0f",
        native: "💆‍♀️"
      },
      {
        unified: "1f486-1f3fb-200d-2640-fe0f",
        native: "💆🏻‍♀️"
      },
      {
        unified: "1f486-1f3fc-200d-2640-fe0f",
        native: "💆🏼‍♀️"
      },
      {
        unified: "1f486-1f3fd-200d-2640-fe0f",
        native: "💆🏽‍♀️"
      },
      {
        unified: "1f486-1f3fe-200d-2640-fe0f",
        native: "💆🏾‍♀️"
      },
      {
        unified: "1f486-1f3ff-200d-2640-fe0f",
        native: "💆🏿‍♀️"
      }
    ],
    version: 4
  },
  haircut: {
    id: "haircut",
    name: "Haircut",
    keywords: [
      "person",
      "getting",
      "hairstyle"
    ],
    skins: [
      {
        unified: "1f487",
        native: "💇"
      },
      {
        unified: "1f487-1f3fb",
        native: "💇🏻"
      },
      {
        unified: "1f487-1f3fc",
        native: "💇🏼"
      },
      {
        unified: "1f487-1f3fd",
        native: "💇🏽"
      },
      {
        unified: "1f487-1f3fe",
        native: "💇🏾"
      },
      {
        unified: "1f487-1f3ff",
        native: "💇🏿"
      }
    ],
    version: 1
  },
  "man-getting-haircut": {
    id: "man-getting-haircut",
    name: "Man Getting Haircut",
    keywords: [
      "getting-haircut",
      "male",
      "boy"
    ],
    skins: [
      {
        unified: "1f487-200d-2642-fe0f",
        native: "💇‍♂️"
      },
      {
        unified: "1f487-1f3fb-200d-2642-fe0f",
        native: "💇🏻‍♂️"
      },
      {
        unified: "1f487-1f3fc-200d-2642-fe0f",
        native: "💇🏼‍♂️"
      },
      {
        unified: "1f487-1f3fd-200d-2642-fe0f",
        native: "💇🏽‍♂️"
      },
      {
        unified: "1f487-1f3fe-200d-2642-fe0f",
        native: "💇🏾‍♂️"
      },
      {
        unified: "1f487-1f3ff-200d-2642-fe0f",
        native: "💇🏿‍♂️"
      }
    ],
    version: 4
  },
  "woman-getting-haircut": {
    id: "woman-getting-haircut",
    name: "Woman Getting Haircut",
    keywords: [
      "getting-haircut",
      "female",
      "girl"
    ],
    skins: [
      {
        unified: "1f487-200d-2640-fe0f",
        native: "💇‍♀️"
      },
      {
        unified: "1f487-1f3fb-200d-2640-fe0f",
        native: "💇🏻‍♀️"
      },
      {
        unified: "1f487-1f3fc-200d-2640-fe0f",
        native: "💇🏼‍♀️"
      },
      {
        unified: "1f487-1f3fd-200d-2640-fe0f",
        native: "💇🏽‍♀️"
      },
      {
        unified: "1f487-1f3fe-200d-2640-fe0f",
        native: "💇🏾‍♀️"
      },
      {
        unified: "1f487-1f3ff-200d-2640-fe0f",
        native: "💇🏿‍♀️"
      }
    ],
    version: 4
  },
  walking: {
    id: "walking",
    name: "Pedestrian",
    keywords: [
      "walking",
      "person",
      "move"
    ],
    skins: [
      {
        unified: "1f6b6",
        native: "🚶"
      },
      {
        unified: "1f6b6-1f3fb",
        native: "🚶🏻"
      },
      {
        unified: "1f6b6-1f3fc",
        native: "🚶🏼"
      },
      {
        unified: "1f6b6-1f3fd",
        native: "🚶🏽"
      },
      {
        unified: "1f6b6-1f3fe",
        native: "🚶🏾"
      },
      {
        unified: "1f6b6-1f3ff",
        native: "🚶🏿"
      }
    ],
    version: 1
  },
  "man-walking": {
    id: "man-walking",
    name: "Man Walking",
    keywords: [
      "human",
      "feet",
      "steps"
    ],
    skins: [
      {
        unified: "1f6b6-200d-2642-fe0f",
        native: "🚶‍♂️"
      },
      {
        unified: "1f6b6-1f3fb-200d-2642-fe0f",
        native: "🚶🏻‍♂️"
      },
      {
        unified: "1f6b6-1f3fc-200d-2642-fe0f",
        native: "🚶🏼‍♂️"
      },
      {
        unified: "1f6b6-1f3fd-200d-2642-fe0f",
        native: "🚶🏽‍♂️"
      },
      {
        unified: "1f6b6-1f3fe-200d-2642-fe0f",
        native: "🚶🏾‍♂️"
      },
      {
        unified: "1f6b6-1f3ff-200d-2642-fe0f",
        native: "🚶🏿‍♂️"
      }
    ],
    version: 4
  },
  "woman-walking": {
    id: "woman-walking",
    name: "Woman Walking",
    keywords: [
      "human",
      "feet",
      "steps",
      "female"
    ],
    skins: [
      {
        unified: "1f6b6-200d-2640-fe0f",
        native: "🚶‍♀️"
      },
      {
        unified: "1f6b6-1f3fb-200d-2640-fe0f",
        native: "🚶🏻‍♀️"
      },
      {
        unified: "1f6b6-1f3fc-200d-2640-fe0f",
        native: "🚶🏼‍♀️"
      },
      {
        unified: "1f6b6-1f3fd-200d-2640-fe0f",
        native: "🚶🏽‍♀️"
      },
      {
        unified: "1f6b6-1f3fe-200d-2640-fe0f",
        native: "🚶🏾‍♀️"
      },
      {
        unified: "1f6b6-1f3ff-200d-2640-fe0f",
        native: "🚶🏿‍♀️"
      }
    ],
    version: 4
  },
  standing_person: {
    id: "standing_person",
    name: "Standing Person",
    keywords: [
      "still"
    ],
    skins: [
      {
        unified: "1f9cd",
        native: "🧍"
      },
      {
        unified: "1f9cd-1f3fb",
        native: "🧍🏻"
      },
      {
        unified: "1f9cd-1f3fc",
        native: "🧍🏼"
      },
      {
        unified: "1f9cd-1f3fd",
        native: "🧍🏽"
      },
      {
        unified: "1f9cd-1f3fe",
        native: "🧍🏾"
      },
      {
        unified: "1f9cd-1f3ff",
        native: "🧍🏿"
      }
    ],
    version: 12
  },
  man_standing: {
    id: "man_standing",
    name: "Man Standing",
    keywords: [
      "still"
    ],
    skins: [
      {
        unified: "1f9cd-200d-2642-fe0f",
        native: "🧍‍♂️"
      },
      {
        unified: "1f9cd-1f3fb-200d-2642-fe0f",
        native: "🧍🏻‍♂️"
      },
      {
        unified: "1f9cd-1f3fc-200d-2642-fe0f",
        native: "🧍🏼‍♂️"
      },
      {
        unified: "1f9cd-1f3fd-200d-2642-fe0f",
        native: "🧍🏽‍♂️"
      },
      {
        unified: "1f9cd-1f3fe-200d-2642-fe0f",
        native: "🧍🏾‍♂️"
      },
      {
        unified: "1f9cd-1f3ff-200d-2642-fe0f",
        native: "🧍🏿‍♂️"
      }
    ],
    version: 12
  },
  woman_standing: {
    id: "woman_standing",
    name: "Woman Standing",
    keywords: [
      "still"
    ],
    skins: [
      {
        unified: "1f9cd-200d-2640-fe0f",
        native: "🧍‍♀️"
      },
      {
        unified: "1f9cd-1f3fb-200d-2640-fe0f",
        native: "🧍🏻‍♀️"
      },
      {
        unified: "1f9cd-1f3fc-200d-2640-fe0f",
        native: "🧍🏼‍♀️"
      },
      {
        unified: "1f9cd-1f3fd-200d-2640-fe0f",
        native: "🧍🏽‍♀️"
      },
      {
        unified: "1f9cd-1f3fe-200d-2640-fe0f",
        native: "🧍🏾‍♀️"
      },
      {
        unified: "1f9cd-1f3ff-200d-2640-fe0f",
        native: "🧍🏿‍♀️"
      }
    ],
    version: 12
  },
  kneeling_person: {
    id: "kneeling_person",
    name: "Kneeling Person",
    keywords: [
      "pray",
      "respectful"
    ],
    skins: [
      {
        unified: "1f9ce",
        native: "🧎"
      },
      {
        unified: "1f9ce-1f3fb",
        native: "🧎🏻"
      },
      {
        unified: "1f9ce-1f3fc",
        native: "🧎🏼"
      },
      {
        unified: "1f9ce-1f3fd",
        native: "🧎🏽"
      },
      {
        unified: "1f9ce-1f3fe",
        native: "🧎🏾"
      },
      {
        unified: "1f9ce-1f3ff",
        native: "🧎🏿"
      }
    ],
    version: 12
  },
  man_kneeling: {
    id: "man_kneeling",
    name: "Man Kneeling",
    keywords: [
      "pray",
      "respectful"
    ],
    skins: [
      {
        unified: "1f9ce-200d-2642-fe0f",
        native: "🧎‍♂️"
      },
      {
        unified: "1f9ce-1f3fb-200d-2642-fe0f",
        native: "🧎🏻‍♂️"
      },
      {
        unified: "1f9ce-1f3fc-200d-2642-fe0f",
        native: "🧎🏼‍♂️"
      },
      {
        unified: "1f9ce-1f3fd-200d-2642-fe0f",
        native: "🧎🏽‍♂️"
      },
      {
        unified: "1f9ce-1f3fe-200d-2642-fe0f",
        native: "🧎🏾‍♂️"
      },
      {
        unified: "1f9ce-1f3ff-200d-2642-fe0f",
        native: "🧎🏿‍♂️"
      }
    ],
    version: 12
  },
  woman_kneeling: {
    id: "woman_kneeling",
    name: "Woman Kneeling",
    keywords: [
      "respectful",
      "pray"
    ],
    skins: [
      {
        unified: "1f9ce-200d-2640-fe0f",
        native: "🧎‍♀️"
      },
      {
        unified: "1f9ce-1f3fb-200d-2640-fe0f",
        native: "🧎🏻‍♀️"
      },
      {
        unified: "1f9ce-1f3fc-200d-2640-fe0f",
        native: "🧎🏼‍♀️"
      },
      {
        unified: "1f9ce-1f3fd-200d-2640-fe0f",
        native: "🧎🏽‍♀️"
      },
      {
        unified: "1f9ce-1f3fe-200d-2640-fe0f",
        native: "🧎🏾‍♀️"
      },
      {
        unified: "1f9ce-1f3ff-200d-2640-fe0f",
        native: "🧎🏿‍♀️"
      }
    ],
    version: 12
  },
  person_with_probing_cane: {
    id: "person_with_probing_cane",
    name: "Person with White Cane",
    keywords: [
      "probing",
      "blind"
    ],
    skins: [
      {
        unified: "1f9d1-200d-1f9af",
        native: "🧑‍🦯"
      },
      {
        unified: "1f9d1-1f3fb-200d-1f9af",
        native: "🧑🏻‍🦯"
      },
      {
        unified: "1f9d1-1f3fc-200d-1f9af",
        native: "🧑🏼‍🦯"
      },
      {
        unified: "1f9d1-1f3fd-200d-1f9af",
        native: "🧑🏽‍🦯"
      },
      {
        unified: "1f9d1-1f3fe-200d-1f9af",
        native: "🧑🏾‍🦯"
      },
      {
        unified: "1f9d1-1f3ff-200d-1f9af",
        native: "🧑🏿‍🦯"
      }
    ],
    version: 12.1
  },
  man_with_probing_cane: {
    id: "man_with_probing_cane",
    name: "Man with White Cane",
    keywords: [
      "probing",
      "blind"
    ],
    skins: [
      {
        unified: "1f468-200d-1f9af",
        native: "👨‍🦯"
      },
      {
        unified: "1f468-1f3fb-200d-1f9af",
        native: "👨🏻‍🦯"
      },
      {
        unified: "1f468-1f3fc-200d-1f9af",
        native: "👨🏼‍🦯"
      },
      {
        unified: "1f468-1f3fd-200d-1f9af",
        native: "👨🏽‍🦯"
      },
      {
        unified: "1f468-1f3fe-200d-1f9af",
        native: "👨🏾‍🦯"
      },
      {
        unified: "1f468-1f3ff-200d-1f9af",
        native: "👨🏿‍🦯"
      }
    ],
    version: 12
  },
  woman_with_probing_cane: {
    id: "woman_with_probing_cane",
    name: "Woman with White Cane",
    keywords: [
      "probing",
      "blind"
    ],
    skins: [
      {
        unified: "1f469-200d-1f9af",
        native: "👩‍🦯"
      },
      {
        unified: "1f469-1f3fb-200d-1f9af",
        native: "👩🏻‍🦯"
      },
      {
        unified: "1f469-1f3fc-200d-1f9af",
        native: "👩🏼‍🦯"
      },
      {
        unified: "1f469-1f3fd-200d-1f9af",
        native: "👩🏽‍🦯"
      },
      {
        unified: "1f469-1f3fe-200d-1f9af",
        native: "👩🏾‍🦯"
      },
      {
        unified: "1f469-1f3ff-200d-1f9af",
        native: "👩🏿‍🦯"
      }
    ],
    version: 12
  },
  person_in_motorized_wheelchair: {
    id: "person_in_motorized_wheelchair",
    name: "Person in Motorized Wheelchair",
    keywords: [
      "disability",
      "accessibility"
    ],
    skins: [
      {
        unified: "1f9d1-200d-1f9bc",
        native: "🧑‍🦼"
      },
      {
        unified: "1f9d1-1f3fb-200d-1f9bc",
        native: "🧑🏻‍🦼"
      },
      {
        unified: "1f9d1-1f3fc-200d-1f9bc",
        native: "🧑🏼‍🦼"
      },
      {
        unified: "1f9d1-1f3fd-200d-1f9bc",
        native: "🧑🏽‍🦼"
      },
      {
        unified: "1f9d1-1f3fe-200d-1f9bc",
        native: "🧑🏾‍🦼"
      },
      {
        unified: "1f9d1-1f3ff-200d-1f9bc",
        native: "🧑🏿‍🦼"
      }
    ],
    version: 12.1
  },
  man_in_motorized_wheelchair: {
    id: "man_in_motorized_wheelchair",
    name: "Man in Motorized Wheelchair",
    keywords: [
      "disability",
      "accessibility"
    ],
    skins: [
      {
        unified: "1f468-200d-1f9bc",
        native: "👨‍🦼"
      },
      {
        unified: "1f468-1f3fb-200d-1f9bc",
        native: "👨🏻‍🦼"
      },
      {
        unified: "1f468-1f3fc-200d-1f9bc",
        native: "👨🏼‍🦼"
      },
      {
        unified: "1f468-1f3fd-200d-1f9bc",
        native: "👨🏽‍🦼"
      },
      {
        unified: "1f468-1f3fe-200d-1f9bc",
        native: "👨🏾‍🦼"
      },
      {
        unified: "1f468-1f3ff-200d-1f9bc",
        native: "👨🏿‍🦼"
      }
    ],
    version: 12
  },
  woman_in_motorized_wheelchair: {
    id: "woman_in_motorized_wheelchair",
    name: "Woman in Motorized Wheelchair",
    keywords: [
      "disability",
      "accessibility"
    ],
    skins: [
      {
        unified: "1f469-200d-1f9bc",
        native: "👩‍🦼"
      },
      {
        unified: "1f469-1f3fb-200d-1f9bc",
        native: "👩🏻‍🦼"
      },
      {
        unified: "1f469-1f3fc-200d-1f9bc",
        native: "👩🏼‍🦼"
      },
      {
        unified: "1f469-1f3fd-200d-1f9bc",
        native: "👩🏽‍🦼"
      },
      {
        unified: "1f469-1f3fe-200d-1f9bc",
        native: "👩🏾‍🦼"
      },
      {
        unified: "1f469-1f3ff-200d-1f9bc",
        native: "👩🏿‍🦼"
      }
    ],
    version: 12
  },
  person_in_manual_wheelchair: {
    id: "person_in_manual_wheelchair",
    name: "Person in Manual Wheelchair",
    keywords: [
      "disability",
      "accessibility"
    ],
    skins: [
      {
        unified: "1f9d1-200d-1f9bd",
        native: "🧑‍🦽"
      },
      {
        unified: "1f9d1-1f3fb-200d-1f9bd",
        native: "🧑🏻‍🦽"
      },
      {
        unified: "1f9d1-1f3fc-200d-1f9bd",
        native: "🧑🏼‍🦽"
      },
      {
        unified: "1f9d1-1f3fd-200d-1f9bd",
        native: "🧑🏽‍🦽"
      },
      {
        unified: "1f9d1-1f3fe-200d-1f9bd",
        native: "🧑🏾‍🦽"
      },
      {
        unified: "1f9d1-1f3ff-200d-1f9bd",
        native: "🧑🏿‍🦽"
      }
    ],
    version: 12.1
  },
  man_in_manual_wheelchair: {
    id: "man_in_manual_wheelchair",
    name: "Man in Manual Wheelchair",
    keywords: [
      "disability",
      "accessibility"
    ],
    skins: [
      {
        unified: "1f468-200d-1f9bd",
        native: "👨‍🦽"
      },
      {
        unified: "1f468-1f3fb-200d-1f9bd",
        native: "👨🏻‍🦽"
      },
      {
        unified: "1f468-1f3fc-200d-1f9bd",
        native: "👨🏼‍🦽"
      },
      {
        unified: "1f468-1f3fd-200d-1f9bd",
        native: "👨🏽‍🦽"
      },
      {
        unified: "1f468-1f3fe-200d-1f9bd",
        native: "👨🏾‍🦽"
      },
      {
        unified: "1f468-1f3ff-200d-1f9bd",
        native: "👨🏿‍🦽"
      }
    ],
    version: 12
  },
  woman_in_manual_wheelchair: {
    id: "woman_in_manual_wheelchair",
    name: "Woman in Manual Wheelchair",
    keywords: [
      "disability",
      "accessibility"
    ],
    skins: [
      {
        unified: "1f469-200d-1f9bd",
        native: "👩‍🦽"
      },
      {
        unified: "1f469-1f3fb-200d-1f9bd",
        native: "👩🏻‍🦽"
      },
      {
        unified: "1f469-1f3fc-200d-1f9bd",
        native: "👩🏼‍🦽"
      },
      {
        unified: "1f469-1f3fd-200d-1f9bd",
        native: "👩🏽‍🦽"
      },
      {
        unified: "1f469-1f3fe-200d-1f9bd",
        native: "👩🏾‍🦽"
      },
      {
        unified: "1f469-1f3ff-200d-1f9bd",
        native: "👩🏿‍🦽"
      }
    ],
    version: 12
  },
  runner: {
    id: "runner",
    name: "Runner",
    keywords: [
      "running",
      "person",
      "move"
    ],
    skins: [
      {
        unified: "1f3c3",
        native: "🏃"
      },
      {
        unified: "1f3c3-1f3fb",
        native: "🏃🏻"
      },
      {
        unified: "1f3c3-1f3fc",
        native: "🏃🏼"
      },
      {
        unified: "1f3c3-1f3fd",
        native: "🏃🏽"
      },
      {
        unified: "1f3c3-1f3fe",
        native: "🏃🏾"
      },
      {
        unified: "1f3c3-1f3ff",
        native: "🏃🏿"
      }
    ],
    version: 1
  },
  "man-running": {
    id: "man-running",
    name: "Man Running",
    keywords: [
      "walking",
      "exercise",
      "race"
    ],
    skins: [
      {
        unified: "1f3c3-200d-2642-fe0f",
        native: "🏃‍♂️"
      },
      {
        unified: "1f3c3-1f3fb-200d-2642-fe0f",
        native: "🏃🏻‍♂️"
      },
      {
        unified: "1f3c3-1f3fc-200d-2642-fe0f",
        native: "🏃🏼‍♂️"
      },
      {
        unified: "1f3c3-1f3fd-200d-2642-fe0f",
        native: "🏃🏽‍♂️"
      },
      {
        unified: "1f3c3-1f3fe-200d-2642-fe0f",
        native: "🏃🏾‍♂️"
      },
      {
        unified: "1f3c3-1f3ff-200d-2642-fe0f",
        native: "🏃🏿‍♂️"
      }
    ],
    version: 4
  },
  "woman-running": {
    id: "woman-running",
    name: "Woman Running",
    keywords: [
      "walking",
      "exercise",
      "race",
      "female"
    ],
    skins: [
      {
        unified: "1f3c3-200d-2640-fe0f",
        native: "🏃‍♀️"
      },
      {
        unified: "1f3c3-1f3fb-200d-2640-fe0f",
        native: "🏃🏻‍♀️"
      },
      {
        unified: "1f3c3-1f3fc-200d-2640-fe0f",
        native: "🏃🏼‍♀️"
      },
      {
        unified: "1f3c3-1f3fd-200d-2640-fe0f",
        native: "🏃🏽‍♀️"
      },
      {
        unified: "1f3c3-1f3fe-200d-2640-fe0f",
        native: "🏃🏾‍♀️"
      },
      {
        unified: "1f3c3-1f3ff-200d-2640-fe0f",
        native: "🏃🏿‍♀️"
      }
    ],
    version: 4
  },
  dancer: {
    id: "dancer",
    name: "Dancer",
    keywords: [
      "woman",
      "dancing",
      "female",
      "girl",
      "fun"
    ],
    skins: [
      {
        unified: "1f483",
        native: "💃"
      },
      {
        unified: "1f483-1f3fb",
        native: "💃🏻"
      },
      {
        unified: "1f483-1f3fc",
        native: "💃🏼"
      },
      {
        unified: "1f483-1f3fd",
        native: "💃🏽"
      },
      {
        unified: "1f483-1f3fe",
        native: "💃🏾"
      },
      {
        unified: "1f483-1f3ff",
        native: "💃🏿"
      }
    ],
    version: 1
  },
  man_dancing: {
    id: "man_dancing",
    name: "Man Dancing",
    keywords: [
      "male",
      "boy",
      "fun",
      "dancer"
    ],
    skins: [
      {
        unified: "1f57a",
        native: "🕺"
      },
      {
        unified: "1f57a-1f3fb",
        native: "🕺🏻"
      },
      {
        unified: "1f57a-1f3fc",
        native: "🕺🏼"
      },
      {
        unified: "1f57a-1f3fd",
        native: "🕺🏽"
      },
      {
        unified: "1f57a-1f3fe",
        native: "🕺🏾"
      },
      {
        unified: "1f57a-1f3ff",
        native: "🕺🏿"
      }
    ],
    version: 3
  },
  man_in_business_suit_levitating: {
    id: "man_in_business_suit_levitating",
    name: "Person in Suit Levitating",
    keywords: [
      "man",
      "business",
      "levitate",
      "hover",
      "jump"
    ],
    skins: [
      {
        unified: "1f574-fe0f",
        native: "🕴️"
      },
      {
        unified: "1f574-1f3fb",
        native: "🕴🏻"
      },
      {
        unified: "1f574-1f3fc",
        native: "🕴🏼"
      },
      {
        unified: "1f574-1f3fd",
        native: "🕴🏽"
      },
      {
        unified: "1f574-1f3fe",
        native: "🕴🏾"
      },
      {
        unified: "1f574-1f3ff",
        native: "🕴🏿"
      }
    ],
    version: 1
  },
  dancers: {
    id: "dancers",
    name: "Woman with Bunny Ears",
    keywords: [
      "dancers",
      "people",
      "perform",
      "costume"
    ],
    skins: [
      {
        unified: "1f46f",
        native: "👯"
      }
    ],
    version: 1
  },
  "men-with-bunny-ears-partying": {
    id: "men-with-bunny-ears-partying",
    name: "Men with Bunny Ears",
    keywords: [
      "with-bunny-ears-partying",
      "man",
      "male",
      "boys"
    ],
    skins: [
      {
        unified: "1f46f-200d-2642-fe0f",
        native: "👯‍♂️"
      }
    ],
    version: 4
  },
  "women-with-bunny-ears-partying": {
    id: "women-with-bunny-ears-partying",
    name: "Women with Bunny Ears",
    keywords: [
      "with-bunny-ears-partying",
      "woman",
      "female",
      "girls"
    ],
    skins: [
      {
        unified: "1f46f-200d-2640-fe0f",
        native: "👯‍♀️"
      }
    ],
    version: 4
  },
  person_in_steamy_room: {
    id: "person_in_steamy_room",
    name: "Person in Steamy Room",
    keywords: [
      "relax",
      "spa"
    ],
    skins: [
      {
        unified: "1f9d6",
        native: "🧖"
      },
      {
        unified: "1f9d6-1f3fb",
        native: "🧖🏻"
      },
      {
        unified: "1f9d6-1f3fc",
        native: "🧖🏼"
      },
      {
        unified: "1f9d6-1f3fd",
        native: "🧖🏽"
      },
      {
        unified: "1f9d6-1f3fe",
        native: "🧖🏾"
      },
      {
        unified: "1f9d6-1f3ff",
        native: "🧖🏿"
      }
    ],
    version: 5
  },
  man_in_steamy_room: {
    id: "man_in_steamy_room",
    name: "Man in Steamy Room",
    keywords: [
      "male",
      "spa",
      "steamroom",
      "sauna"
    ],
    skins: [
      {
        unified: "1f9d6-200d-2642-fe0f",
        native: "🧖‍♂️"
      },
      {
        unified: "1f9d6-1f3fb-200d-2642-fe0f",
        native: "🧖🏻‍♂️"
      },
      {
        unified: "1f9d6-1f3fc-200d-2642-fe0f",
        native: "🧖🏼‍♂️"
      },
      {
        unified: "1f9d6-1f3fd-200d-2642-fe0f",
        native: "🧖🏽‍♂️"
      },
      {
        unified: "1f9d6-1f3fe-200d-2642-fe0f",
        native: "🧖🏾‍♂️"
      },
      {
        unified: "1f9d6-1f3ff-200d-2642-fe0f",
        native: "🧖🏿‍♂️"
      }
    ],
    version: 5
  },
  woman_in_steamy_room: {
    id: "woman_in_steamy_room",
    name: "Woman in Steamy Room",
    keywords: [
      "female",
      "spa",
      "steamroom",
      "sauna"
    ],
    skins: [
      {
        unified: "1f9d6-200d-2640-fe0f",
        native: "🧖‍♀️"
      },
      {
        unified: "1f9d6-1f3fb-200d-2640-fe0f",
        native: "🧖🏻‍♀️"
      },
      {
        unified: "1f9d6-1f3fc-200d-2640-fe0f",
        native: "🧖🏼‍♀️"
      },
      {
        unified: "1f9d6-1f3fd-200d-2640-fe0f",
        native: "🧖🏽‍♀️"
      },
      {
        unified: "1f9d6-1f3fe-200d-2640-fe0f",
        native: "🧖🏾‍♀️"
      },
      {
        unified: "1f9d6-1f3ff-200d-2640-fe0f",
        native: "🧖🏿‍♀️"
      }
    ],
    version: 5
  },
  person_climbing: {
    id: "person_climbing",
    name: "Person Climbing",
    keywords: [
      "sport"
    ],
    skins: [
      {
        unified: "1f9d7",
        native: "🧗"
      },
      {
        unified: "1f9d7-1f3fb",
        native: "🧗🏻"
      },
      {
        unified: "1f9d7-1f3fc",
        native: "🧗🏼"
      },
      {
        unified: "1f9d7-1f3fd",
        native: "🧗🏽"
      },
      {
        unified: "1f9d7-1f3fe",
        native: "🧗🏾"
      },
      {
        unified: "1f9d7-1f3ff",
        native: "🧗🏿"
      }
    ],
    version: 5
  },
  man_climbing: {
    id: "man_climbing",
    name: "Man Climbing",
    keywords: [
      "sports",
      "hobby",
      "male",
      "rock"
    ],
    skins: [
      {
        unified: "1f9d7-200d-2642-fe0f",
        native: "🧗‍♂️"
      },
      {
        unified: "1f9d7-1f3fb-200d-2642-fe0f",
        native: "🧗🏻‍♂️"
      },
      {
        unified: "1f9d7-1f3fc-200d-2642-fe0f",
        native: "🧗🏼‍♂️"
      },
      {
        unified: "1f9d7-1f3fd-200d-2642-fe0f",
        native: "🧗🏽‍♂️"
      },
      {
        unified: "1f9d7-1f3fe-200d-2642-fe0f",
        native: "🧗🏾‍♂️"
      },
      {
        unified: "1f9d7-1f3ff-200d-2642-fe0f",
        native: "🧗🏿‍♂️"
      }
    ],
    version: 5
  },
  woman_climbing: {
    id: "woman_climbing",
    name: "Woman Climbing",
    keywords: [
      "sports",
      "hobby",
      "female",
      "rock"
    ],
    skins: [
      {
        unified: "1f9d7-200d-2640-fe0f",
        native: "🧗‍♀️"
      },
      {
        unified: "1f9d7-1f3fb-200d-2640-fe0f",
        native: "🧗🏻‍♀️"
      },
      {
        unified: "1f9d7-1f3fc-200d-2640-fe0f",
        native: "🧗🏼‍♀️"
      },
      {
        unified: "1f9d7-1f3fd-200d-2640-fe0f",
        native: "🧗🏽‍♀️"
      },
      {
        unified: "1f9d7-1f3fe-200d-2640-fe0f",
        native: "🧗🏾‍♀️"
      },
      {
        unified: "1f9d7-1f3ff-200d-2640-fe0f",
        native: "🧗🏿‍♀️"
      }
    ],
    version: 5
  },
  fencer: {
    id: "fencer",
    name: "Fencer",
    keywords: [
      "person",
      "fencing",
      "sports",
      "sword"
    ],
    skins: [
      {
        unified: "1f93a",
        native: "🤺"
      }
    ],
    version: 3
  },
  horse_racing: {
    id: "horse_racing",
    name: "Horse Racing",
    keywords: [
      "animal",
      "betting",
      "competition",
      "gambling",
      "luck"
    ],
    skins: [
      {
        unified: "1f3c7",
        native: "🏇"
      },
      {
        unified: "1f3c7-1f3fb",
        native: "🏇🏻"
      },
      {
        unified: "1f3c7-1f3fc",
        native: "🏇🏼"
      },
      {
        unified: "1f3c7-1f3fd",
        native: "🏇🏽"
      },
      {
        unified: "1f3c7-1f3fe",
        native: "🏇🏾"
      },
      {
        unified: "1f3c7-1f3ff",
        native: "🏇🏿"
      }
    ],
    version: 1
  },
  skier: {
    id: "skier",
    name: "Skier",
    keywords: [
      "sports",
      "winter",
      "snow"
    ],
    skins: [
      {
        unified: "26f7-fe0f",
        native: "⛷️"
      }
    ],
    version: 1
  },
  snowboarder: {
    id: "snowboarder",
    name: "Snowboarder",
    keywords: [
      "sports",
      "winter"
    ],
    skins: [
      {
        unified: "1f3c2",
        native: "🏂"
      },
      {
        unified: "1f3c2-1f3fb",
        native: "🏂🏻"
      },
      {
        unified: "1f3c2-1f3fc",
        native: "🏂🏼"
      },
      {
        unified: "1f3c2-1f3fd",
        native: "🏂🏽"
      },
      {
        unified: "1f3c2-1f3fe",
        native: "🏂🏾"
      },
      {
        unified: "1f3c2-1f3ff",
        native: "🏂🏿"
      }
    ],
    version: 1
  },
  golfer: {
    id: "golfer",
    name: "Person Golfing",
    keywords: [
      "golfer",
      "sports",
      "business"
    ],
    skins: [
      {
        unified: "1f3cc-fe0f",
        native: "🏌️"
      },
      {
        unified: "1f3cc-1f3fb",
        native: "🏌🏻"
      },
      {
        unified: "1f3cc-1f3fc",
        native: "🏌🏼"
      },
      {
        unified: "1f3cc-1f3fd",
        native: "🏌🏽"
      },
      {
        unified: "1f3cc-1f3fe",
        native: "🏌🏾"
      },
      {
        unified: "1f3cc-1f3ff",
        native: "🏌🏿"
      }
    ],
    version: 1
  },
  "man-golfing": {
    id: "man-golfing",
    name: "Man Golfing",
    keywords: [
      "sport"
    ],
    skins: [
      {
        unified: "1f3cc-fe0f-200d-2642-fe0f",
        native: "🏌️‍♂️"
      },
      {
        unified: "1f3cc-1f3fb-200d-2642-fe0f",
        native: "🏌🏻‍♂️"
      },
      {
        unified: "1f3cc-1f3fc-200d-2642-fe0f",
        native: "🏌🏼‍♂️"
      },
      {
        unified: "1f3cc-1f3fd-200d-2642-fe0f",
        native: "🏌🏽‍♂️"
      },
      {
        unified: "1f3cc-1f3fe-200d-2642-fe0f",
        native: "🏌🏾‍♂️"
      },
      {
        unified: "1f3cc-1f3ff-200d-2642-fe0f",
        native: "🏌🏿‍♂️"
      }
    ],
    version: 4
  },
  "woman-golfing": {
    id: "woman-golfing",
    name: "Woman Golfing",
    keywords: [
      "sports",
      "business",
      "female"
    ],
    skins: [
      {
        unified: "1f3cc-fe0f-200d-2640-fe0f",
        native: "🏌️‍♀️"
      },
      {
        unified: "1f3cc-1f3fb-200d-2640-fe0f",
        native: "🏌🏻‍♀️"
      },
      {
        unified: "1f3cc-1f3fc-200d-2640-fe0f",
        native: "🏌🏼‍♀️"
      },
      {
        unified: "1f3cc-1f3fd-200d-2640-fe0f",
        native: "🏌🏽‍♀️"
      },
      {
        unified: "1f3cc-1f3fe-200d-2640-fe0f",
        native: "🏌🏾‍♀️"
      },
      {
        unified: "1f3cc-1f3ff-200d-2640-fe0f",
        native: "🏌🏿‍♀️"
      }
    ],
    version: 4
  },
  surfer: {
    id: "surfer",
    name: "Surfer",
    keywords: [
      "person",
      "surfing",
      "sport",
      "sea"
    ],
    skins: [
      {
        unified: "1f3c4",
        native: "🏄"
      },
      {
        unified: "1f3c4-1f3fb",
        native: "🏄🏻"
      },
      {
        unified: "1f3c4-1f3fc",
        native: "🏄🏼"
      },
      {
        unified: "1f3c4-1f3fd",
        native: "🏄🏽"
      },
      {
        unified: "1f3c4-1f3fe",
        native: "🏄🏾"
      },
      {
        unified: "1f3c4-1f3ff",
        native: "🏄🏿"
      }
    ],
    version: 1
  },
  "man-surfing": {
    id: "man-surfing",
    name: "Man Surfing",
    keywords: [
      "sports",
      "ocean",
      "sea",
      "summer",
      "beach"
    ],
    skins: [
      {
        unified: "1f3c4-200d-2642-fe0f",
        native: "🏄‍♂️"
      },
      {
        unified: "1f3c4-1f3fb-200d-2642-fe0f",
        native: "🏄🏻‍♂️"
      },
      {
        unified: "1f3c4-1f3fc-200d-2642-fe0f",
        native: "🏄🏼‍♂️"
      },
      {
        unified: "1f3c4-1f3fd-200d-2642-fe0f",
        native: "🏄🏽‍♂️"
      },
      {
        unified: "1f3c4-1f3fe-200d-2642-fe0f",
        native: "🏄🏾‍♂️"
      },
      {
        unified: "1f3c4-1f3ff-200d-2642-fe0f",
        native: "🏄🏿‍♂️"
      }
    ],
    version: 4
  },
  "woman-surfing": {
    id: "woman-surfing",
    name: "Woman Surfing",
    keywords: [
      "sports",
      "ocean",
      "sea",
      "summer",
      "beach",
      "female"
    ],
    skins: [
      {
        unified: "1f3c4-200d-2640-fe0f",
        native: "🏄‍♀️"
      },
      {
        unified: "1f3c4-1f3fb-200d-2640-fe0f",
        native: "🏄🏻‍♀️"
      },
      {
        unified: "1f3c4-1f3fc-200d-2640-fe0f",
        native: "🏄🏼‍♀️"
      },
      {
        unified: "1f3c4-1f3fd-200d-2640-fe0f",
        native: "🏄🏽‍♀️"
      },
      {
        unified: "1f3c4-1f3fe-200d-2640-fe0f",
        native: "🏄🏾‍♀️"
      },
      {
        unified: "1f3c4-1f3ff-200d-2640-fe0f",
        native: "🏄🏿‍♀️"
      }
    ],
    version: 4
  },
  rowboat: {
    id: "rowboat",
    name: "Rowboat",
    keywords: [
      "person",
      "rowing",
      "boat",
      "sport",
      "move"
    ],
    skins: [
      {
        unified: "1f6a3",
        native: "🚣"
      },
      {
        unified: "1f6a3-1f3fb",
        native: "🚣🏻"
      },
      {
        unified: "1f6a3-1f3fc",
        native: "🚣🏼"
      },
      {
        unified: "1f6a3-1f3fd",
        native: "🚣🏽"
      },
      {
        unified: "1f6a3-1f3fe",
        native: "🚣🏾"
      },
      {
        unified: "1f6a3-1f3ff",
        native: "🚣🏿"
      }
    ],
    version: 1
  },
  "man-rowing-boat": {
    id: "man-rowing-boat",
    name: "Man Rowing Boat",
    keywords: [
      "rowing-boat",
      "sports",
      "hobby",
      "water",
      "ship"
    ],
    skins: [
      {
        unified: "1f6a3-200d-2642-fe0f",
        native: "🚣‍♂️"
      },
      {
        unified: "1f6a3-1f3fb-200d-2642-fe0f",
        native: "🚣🏻‍♂️"
      },
      {
        unified: "1f6a3-1f3fc-200d-2642-fe0f",
        native: "🚣🏼‍♂️"
      },
      {
        unified: "1f6a3-1f3fd-200d-2642-fe0f",
        native: "🚣🏽‍♂️"
      },
      {
        unified: "1f6a3-1f3fe-200d-2642-fe0f",
        native: "🚣🏾‍♂️"
      },
      {
        unified: "1f6a3-1f3ff-200d-2642-fe0f",
        native: "🚣🏿‍♂️"
      }
    ],
    version: 4
  },
  "woman-rowing-boat": {
    id: "woman-rowing-boat",
    name: "Woman Rowing Boat",
    keywords: [
      "rowing-boat",
      "sports",
      "hobby",
      "water",
      "ship",
      "female"
    ],
    skins: [
      {
        unified: "1f6a3-200d-2640-fe0f",
        native: "🚣‍♀️"
      },
      {
        unified: "1f6a3-1f3fb-200d-2640-fe0f",
        native: "🚣🏻‍♀️"
      },
      {
        unified: "1f6a3-1f3fc-200d-2640-fe0f",
        native: "🚣🏼‍♀️"
      },
      {
        unified: "1f6a3-1f3fd-200d-2640-fe0f",
        native: "🚣🏽‍♀️"
      },
      {
        unified: "1f6a3-1f3fe-200d-2640-fe0f",
        native: "🚣🏾‍♀️"
      },
      {
        unified: "1f6a3-1f3ff-200d-2640-fe0f",
        native: "🚣🏿‍♀️"
      }
    ],
    version: 4
  },
  swimmer: {
    id: "swimmer",
    name: "Swimmer",
    keywords: [
      "person",
      "swimming",
      "sport",
      "pool"
    ],
    skins: [
      {
        unified: "1f3ca",
        native: "🏊"
      },
      {
        unified: "1f3ca-1f3fb",
        native: "🏊🏻"
      },
      {
        unified: "1f3ca-1f3fc",
        native: "🏊🏼"
      },
      {
        unified: "1f3ca-1f3fd",
        native: "🏊🏽"
      },
      {
        unified: "1f3ca-1f3fe",
        native: "🏊🏾"
      },
      {
        unified: "1f3ca-1f3ff",
        native: "🏊🏿"
      }
    ],
    version: 1
  },
  "man-swimming": {
    id: "man-swimming",
    name: "Man Swimming",
    keywords: [
      "sports",
      "exercise",
      "human",
      "athlete",
      "water",
      "summer"
    ],
    skins: [
      {
        unified: "1f3ca-200d-2642-fe0f",
        native: "🏊‍♂️"
      },
      {
        unified: "1f3ca-1f3fb-200d-2642-fe0f",
        native: "🏊🏻‍♂️"
      },
      {
        unified: "1f3ca-1f3fc-200d-2642-fe0f",
        native: "🏊🏼‍♂️"
      },
      {
        unified: "1f3ca-1f3fd-200d-2642-fe0f",
        native: "🏊🏽‍♂️"
      },
      {
        unified: "1f3ca-1f3fe-200d-2642-fe0f",
        native: "🏊🏾‍♂️"
      },
      {
        unified: "1f3ca-1f3ff-200d-2642-fe0f",
        native: "🏊🏿‍♂️"
      }
    ],
    version: 4
  },
  "woman-swimming": {
    id: "woman-swimming",
    name: "Woman Swimming",
    keywords: [
      "sports",
      "exercise",
      "human",
      "athlete",
      "water",
      "summer",
      "female"
    ],
    skins: [
      {
        unified: "1f3ca-200d-2640-fe0f",
        native: "🏊‍♀️"
      },
      {
        unified: "1f3ca-1f3fb-200d-2640-fe0f",
        native: "🏊🏻‍♀️"
      },
      {
        unified: "1f3ca-1f3fc-200d-2640-fe0f",
        native: "🏊🏼‍♀️"
      },
      {
        unified: "1f3ca-1f3fd-200d-2640-fe0f",
        native: "🏊🏽‍♀️"
      },
      {
        unified: "1f3ca-1f3fe-200d-2640-fe0f",
        native: "🏊🏾‍♀️"
      },
      {
        unified: "1f3ca-1f3ff-200d-2640-fe0f",
        native: "🏊🏿‍♀️"
      }
    ],
    version: 4
  },
  person_with_ball: {
    id: "person_with_ball",
    name: "Person Bouncing Ball",
    keywords: [
      "with",
      "sports",
      "human"
    ],
    skins: [
      {
        unified: "26f9-fe0f",
        native: "⛹️"
      },
      {
        unified: "26f9-1f3fb",
        native: "⛹🏻"
      },
      {
        unified: "26f9-1f3fc",
        native: "⛹🏼"
      },
      {
        unified: "26f9-1f3fd",
        native: "⛹🏽"
      },
      {
        unified: "26f9-1f3fe",
        native: "⛹🏾"
      },
      {
        unified: "26f9-1f3ff",
        native: "⛹🏿"
      }
    ],
    version: 1
  },
  "man-bouncing-ball": {
    id: "man-bouncing-ball",
    name: "Man Bouncing Ball",
    keywords: [
      "bouncing-ball",
      "sport"
    ],
    skins: [
      {
        unified: "26f9-fe0f-200d-2642-fe0f",
        native: "⛹️‍♂️"
      },
      {
        unified: "26f9-1f3fb-200d-2642-fe0f",
        native: "⛹🏻‍♂️"
      },
      {
        unified: "26f9-1f3fc-200d-2642-fe0f",
        native: "⛹🏼‍♂️"
      },
      {
        unified: "26f9-1f3fd-200d-2642-fe0f",
        native: "⛹🏽‍♂️"
      },
      {
        unified: "26f9-1f3fe-200d-2642-fe0f",
        native: "⛹🏾‍♂️"
      },
      {
        unified: "26f9-1f3ff-200d-2642-fe0f",
        native: "⛹🏿‍♂️"
      }
    ],
    version: 4
  },
  "woman-bouncing-ball": {
    id: "woman-bouncing-ball",
    name: "Woman Bouncing Ball",
    keywords: [
      "bouncing-ball",
      "sports",
      "human",
      "female"
    ],
    skins: [
      {
        unified: "26f9-fe0f-200d-2640-fe0f",
        native: "⛹️‍♀️"
      },
      {
        unified: "26f9-1f3fb-200d-2640-fe0f",
        native: "⛹🏻‍♀️"
      },
      {
        unified: "26f9-1f3fc-200d-2640-fe0f",
        native: "⛹🏼‍♀️"
      },
      {
        unified: "26f9-1f3fd-200d-2640-fe0f",
        native: "⛹🏽‍♀️"
      },
      {
        unified: "26f9-1f3fe-200d-2640-fe0f",
        native: "⛹🏾‍♀️"
      },
      {
        unified: "26f9-1f3ff-200d-2640-fe0f",
        native: "⛹🏿‍♀️"
      }
    ],
    version: 4
  },
  weight_lifter: {
    id: "weight_lifter",
    name: "Person Lifting Weights",
    keywords: [
      "weight",
      "lifter",
      "sports",
      "training",
      "exercise"
    ],
    skins: [
      {
        unified: "1f3cb-fe0f",
        native: "🏋️"
      },
      {
        unified: "1f3cb-1f3fb",
        native: "🏋🏻"
      },
      {
        unified: "1f3cb-1f3fc",
        native: "🏋🏼"
      },
      {
        unified: "1f3cb-1f3fd",
        native: "🏋🏽"
      },
      {
        unified: "1f3cb-1f3fe",
        native: "🏋🏾"
      },
      {
        unified: "1f3cb-1f3ff",
        native: "🏋🏿"
      }
    ],
    version: 1
  },
  "man-lifting-weights": {
    id: "man-lifting-weights",
    name: "Man Lifting Weights",
    keywords: [
      "lifting-weights",
      "sport"
    ],
    skins: [
      {
        unified: "1f3cb-fe0f-200d-2642-fe0f",
        native: "🏋️‍♂️"
      },
      {
        unified: "1f3cb-1f3fb-200d-2642-fe0f",
        native: "🏋🏻‍♂️"
      },
      {
        unified: "1f3cb-1f3fc-200d-2642-fe0f",
        native: "🏋🏼‍♂️"
      },
      {
        unified: "1f3cb-1f3fd-200d-2642-fe0f",
        native: "🏋🏽‍♂️"
      },
      {
        unified: "1f3cb-1f3fe-200d-2642-fe0f",
        native: "🏋🏾‍♂️"
      },
      {
        unified: "1f3cb-1f3ff-200d-2642-fe0f",
        native: "🏋🏿‍♂️"
      }
    ],
    version: 4
  },
  "woman-lifting-weights": {
    id: "woman-lifting-weights",
    name: "Woman Lifting Weights",
    keywords: [
      "lifting-weights",
      "sports",
      "training",
      "exercise",
      "female"
    ],
    skins: [
      {
        unified: "1f3cb-fe0f-200d-2640-fe0f",
        native: "🏋️‍♀️"
      },
      {
        unified: "1f3cb-1f3fb-200d-2640-fe0f",
        native: "🏋🏻‍♀️"
      },
      {
        unified: "1f3cb-1f3fc-200d-2640-fe0f",
        native: "🏋🏼‍♀️"
      },
      {
        unified: "1f3cb-1f3fd-200d-2640-fe0f",
        native: "🏋🏽‍♀️"
      },
      {
        unified: "1f3cb-1f3fe-200d-2640-fe0f",
        native: "🏋🏾‍♀️"
      },
      {
        unified: "1f3cb-1f3ff-200d-2640-fe0f",
        native: "🏋🏿‍♀️"
      }
    ],
    version: 4
  },
  bicyclist: {
    id: "bicyclist",
    name: "Bicyclist",
    keywords: [
      "person",
      "biking",
      "sport",
      "move"
    ],
    skins: [
      {
        unified: "1f6b4",
        native: "🚴"
      },
      {
        unified: "1f6b4-1f3fb",
        native: "🚴🏻"
      },
      {
        unified: "1f6b4-1f3fc",
        native: "🚴🏼"
      },
      {
        unified: "1f6b4-1f3fd",
        native: "🚴🏽"
      },
      {
        unified: "1f6b4-1f3fe",
        native: "🚴🏾"
      },
      {
        unified: "1f6b4-1f3ff",
        native: "🚴🏿"
      }
    ],
    version: 1
  },
  "man-biking": {
    id: "man-biking",
    name: "Man Biking",
    keywords: [
      "sports",
      "bike",
      "exercise",
      "hipster"
    ],
    skins: [
      {
        unified: "1f6b4-200d-2642-fe0f",
        native: "🚴‍♂️"
      },
      {
        unified: "1f6b4-1f3fb-200d-2642-fe0f",
        native: "🚴🏻‍♂️"
      },
      {
        unified: "1f6b4-1f3fc-200d-2642-fe0f",
        native: "🚴🏼‍♂️"
      },
      {
        unified: "1f6b4-1f3fd-200d-2642-fe0f",
        native: "🚴🏽‍♂️"
      },
      {
        unified: "1f6b4-1f3fe-200d-2642-fe0f",
        native: "🚴🏾‍♂️"
      },
      {
        unified: "1f6b4-1f3ff-200d-2642-fe0f",
        native: "🚴🏿‍♂️"
      }
    ],
    version: 4
  },
  "woman-biking": {
    id: "woman-biking",
    name: "Woman Biking",
    keywords: [
      "sports",
      "bike",
      "exercise",
      "hipster",
      "female"
    ],
    skins: [
      {
        unified: "1f6b4-200d-2640-fe0f",
        native: "🚴‍♀️"
      },
      {
        unified: "1f6b4-1f3fb-200d-2640-fe0f",
        native: "🚴🏻‍♀️"
      },
      {
        unified: "1f6b4-1f3fc-200d-2640-fe0f",
        native: "🚴🏼‍♀️"
      },
      {
        unified: "1f6b4-1f3fd-200d-2640-fe0f",
        native: "🚴🏽‍♀️"
      },
      {
        unified: "1f6b4-1f3fe-200d-2640-fe0f",
        native: "🚴🏾‍♀️"
      },
      {
        unified: "1f6b4-1f3ff-200d-2640-fe0f",
        native: "🚴🏿‍♀️"
      }
    ],
    version: 4
  },
  mountain_bicyclist: {
    id: "mountain_bicyclist",
    name: "Mountain Bicyclist",
    keywords: [
      "person",
      "biking",
      "sport",
      "move"
    ],
    skins: [
      {
        unified: "1f6b5",
        native: "🚵"
      },
      {
        unified: "1f6b5-1f3fb",
        native: "🚵🏻"
      },
      {
        unified: "1f6b5-1f3fc",
        native: "🚵🏼"
      },
      {
        unified: "1f6b5-1f3fd",
        native: "🚵🏽"
      },
      {
        unified: "1f6b5-1f3fe",
        native: "🚵🏾"
      },
      {
        unified: "1f6b5-1f3ff",
        native: "🚵🏿"
      }
    ],
    version: 1
  },
  "man-mountain-biking": {
    id: "man-mountain-biking",
    name: "Man Mountain Biking",
    keywords: [
      "mountain-biking",
      "transportation",
      "sports",
      "human",
      "race",
      "bike"
    ],
    skins: [
      {
        unified: "1f6b5-200d-2642-fe0f",
        native: "🚵‍♂️"
      },
      {
        unified: "1f6b5-1f3fb-200d-2642-fe0f",
        native: "🚵🏻‍♂️"
      },
      {
        unified: "1f6b5-1f3fc-200d-2642-fe0f",
        native: "🚵🏼‍♂️"
      },
      {
        unified: "1f6b5-1f3fd-200d-2642-fe0f",
        native: "🚵🏽‍♂️"
      },
      {
        unified: "1f6b5-1f3fe-200d-2642-fe0f",
        native: "🚵🏾‍♂️"
      },
      {
        unified: "1f6b5-1f3ff-200d-2642-fe0f",
        native: "🚵🏿‍♂️"
      }
    ],
    version: 4
  },
  "woman-mountain-biking": {
    id: "woman-mountain-biking",
    name: "Woman Mountain Biking",
    keywords: [
      "mountain-biking",
      "transportation",
      "sports",
      "human",
      "race",
      "bike",
      "female"
    ],
    skins: [
      {
        unified: "1f6b5-200d-2640-fe0f",
        native: "🚵‍♀️"
      },
      {
        unified: "1f6b5-1f3fb-200d-2640-fe0f",
        native: "🚵🏻‍♀️"
      },
      {
        unified: "1f6b5-1f3fc-200d-2640-fe0f",
        native: "🚵🏼‍♀️"
      },
      {
        unified: "1f6b5-1f3fd-200d-2640-fe0f",
        native: "🚵🏽‍♀️"
      },
      {
        unified: "1f6b5-1f3fe-200d-2640-fe0f",
        native: "🚵🏾‍♀️"
      },
      {
        unified: "1f6b5-1f3ff-200d-2640-fe0f",
        native: "🚵🏿‍♀️"
      }
    ],
    version: 4
  },
  person_doing_cartwheel: {
    id: "person_doing_cartwheel",
    name: "Person Cartwheeling",
    keywords: [
      "doing",
      "cartwheel",
      "sport",
      "gymnastic"
    ],
    skins: [
      {
        unified: "1f938",
        native: "🤸"
      },
      {
        unified: "1f938-1f3fb",
        native: "🤸🏻"
      },
      {
        unified: "1f938-1f3fc",
        native: "🤸🏼"
      },
      {
        unified: "1f938-1f3fd",
        native: "🤸🏽"
      },
      {
        unified: "1f938-1f3fe",
        native: "🤸🏾"
      },
      {
        unified: "1f938-1f3ff",
        native: "🤸🏿"
      }
    ],
    version: 3
  },
  "man-cartwheeling": {
    id: "man-cartwheeling",
    name: "Man Cartwheeling",
    keywords: [
      "gymnastics"
    ],
    skins: [
      {
        unified: "1f938-200d-2642-fe0f",
        native: "🤸‍♂️"
      },
      {
        unified: "1f938-1f3fb-200d-2642-fe0f",
        native: "🤸🏻‍♂️"
      },
      {
        unified: "1f938-1f3fc-200d-2642-fe0f",
        native: "🤸🏼‍♂️"
      },
      {
        unified: "1f938-1f3fd-200d-2642-fe0f",
        native: "🤸🏽‍♂️"
      },
      {
        unified: "1f938-1f3fe-200d-2642-fe0f",
        native: "🤸🏾‍♂️"
      },
      {
        unified: "1f938-1f3ff-200d-2642-fe0f",
        native: "🤸🏿‍♂️"
      }
    ],
    version: 4
  },
  "woman-cartwheeling": {
    id: "woman-cartwheeling",
    name: "Woman Cartwheeling",
    keywords: [
      "gymnastics"
    ],
    skins: [
      {
        unified: "1f938-200d-2640-fe0f",
        native: "🤸‍♀️"
      },
      {
        unified: "1f938-1f3fb-200d-2640-fe0f",
        native: "🤸🏻‍♀️"
      },
      {
        unified: "1f938-1f3fc-200d-2640-fe0f",
        native: "🤸🏼‍♀️"
      },
      {
        unified: "1f938-1f3fd-200d-2640-fe0f",
        native: "🤸🏽‍♀️"
      },
      {
        unified: "1f938-1f3fe-200d-2640-fe0f",
        native: "🤸🏾‍♀️"
      },
      {
        unified: "1f938-1f3ff-200d-2640-fe0f",
        native: "🤸🏿‍♀️"
      }
    ],
    version: 4
  },
  wrestlers: {
    id: "wrestlers",
    name: "Wrestlers",
    keywords: [
      "people",
      "wrestling",
      "sport"
    ],
    skins: [
      {
        unified: "1f93c",
        native: "🤼"
      }
    ],
    version: 3
  },
  "man-wrestling": {
    id: "man-wrestling",
    name: "Men Wrestling",
    keywords: [
      "man",
      "sports",
      "wrestlers"
    ],
    skins: [
      {
        unified: "1f93c-200d-2642-fe0f",
        native: "🤼‍♂️"
      }
    ],
    version: 4
  },
  "woman-wrestling": {
    id: "woman-wrestling",
    name: "Women Wrestling",
    keywords: [
      "woman",
      "sports",
      "wrestlers"
    ],
    skins: [
      {
        unified: "1f93c-200d-2640-fe0f",
        native: "🤼‍♀️"
      }
    ],
    version: 4
  },
  water_polo: {
    id: "water_polo",
    name: "Water Polo",
    keywords: [
      "person",
      "playing",
      "sport"
    ],
    skins: [
      {
        unified: "1f93d",
        native: "🤽"
      },
      {
        unified: "1f93d-1f3fb",
        native: "🤽🏻"
      },
      {
        unified: "1f93d-1f3fc",
        native: "🤽🏼"
      },
      {
        unified: "1f93d-1f3fd",
        native: "🤽🏽"
      },
      {
        unified: "1f93d-1f3fe",
        native: "🤽🏾"
      },
      {
        unified: "1f93d-1f3ff",
        native: "🤽🏿"
      }
    ],
    version: 3
  },
  "man-playing-water-polo": {
    id: "man-playing-water-polo",
    name: "Man Playing Water Polo",
    keywords: [
      "playing-water-polo",
      "sports",
      "pool"
    ],
    skins: [
      {
        unified: "1f93d-200d-2642-fe0f",
        native: "🤽‍♂️"
      },
      {
        unified: "1f93d-1f3fb-200d-2642-fe0f",
        native: "🤽🏻‍♂️"
      },
      {
        unified: "1f93d-1f3fc-200d-2642-fe0f",
        native: "🤽🏼‍♂️"
      },
      {
        unified: "1f93d-1f3fd-200d-2642-fe0f",
        native: "🤽🏽‍♂️"
      },
      {
        unified: "1f93d-1f3fe-200d-2642-fe0f",
        native: "🤽🏾‍♂️"
      },
      {
        unified: "1f93d-1f3ff-200d-2642-fe0f",
        native: "🤽🏿‍♂️"
      }
    ],
    version: 4
  },
  "woman-playing-water-polo": {
    id: "woman-playing-water-polo",
    name: "Woman Playing Water Polo",
    keywords: [
      "playing-water-polo",
      "sports",
      "pool"
    ],
    skins: [
      {
        unified: "1f93d-200d-2640-fe0f",
        native: "🤽‍♀️"
      },
      {
        unified: "1f93d-1f3fb-200d-2640-fe0f",
        native: "🤽🏻‍♀️"
      },
      {
        unified: "1f93d-1f3fc-200d-2640-fe0f",
        native: "🤽🏼‍♀️"
      },
      {
        unified: "1f93d-1f3fd-200d-2640-fe0f",
        native: "🤽🏽‍♀️"
      },
      {
        unified: "1f93d-1f3fe-200d-2640-fe0f",
        native: "🤽🏾‍♀️"
      },
      {
        unified: "1f93d-1f3ff-200d-2640-fe0f",
        native: "🤽🏿‍♀️"
      }
    ],
    version: 4
  },
  handball: {
    id: "handball",
    name: "Handball",
    keywords: [
      "person",
      "playing",
      "sport"
    ],
    skins: [
      {
        unified: "1f93e",
        native: "🤾"
      },
      {
        unified: "1f93e-1f3fb",
        native: "🤾🏻"
      },
      {
        unified: "1f93e-1f3fc",
        native: "🤾🏼"
      },
      {
        unified: "1f93e-1f3fd",
        native: "🤾🏽"
      },
      {
        unified: "1f93e-1f3fe",
        native: "🤾🏾"
      },
      {
        unified: "1f93e-1f3ff",
        native: "🤾🏿"
      }
    ],
    version: 3
  },
  "man-playing-handball": {
    id: "man-playing-handball",
    name: "Man Playing Handball",
    keywords: [
      "playing-handball",
      "sports"
    ],
    skins: [
      {
        unified: "1f93e-200d-2642-fe0f",
        native: "🤾‍♂️"
      },
      {
        unified: "1f93e-1f3fb-200d-2642-fe0f",
        native: "🤾🏻‍♂️"
      },
      {
        unified: "1f93e-1f3fc-200d-2642-fe0f",
        native: "🤾🏼‍♂️"
      },
      {
        unified: "1f93e-1f3fd-200d-2642-fe0f",
        native: "🤾🏽‍♂️"
      },
      {
        unified: "1f93e-1f3fe-200d-2642-fe0f",
        native: "🤾🏾‍♂️"
      },
      {
        unified: "1f93e-1f3ff-200d-2642-fe0f",
        native: "🤾🏿‍♂️"
      }
    ],
    version: 4
  },
  "woman-playing-handball": {
    id: "woman-playing-handball",
    name: "Woman Playing Handball",
    keywords: [
      "playing-handball",
      "sports"
    ],
    skins: [
      {
        unified: "1f93e-200d-2640-fe0f",
        native: "🤾‍♀️"
      },
      {
        unified: "1f93e-1f3fb-200d-2640-fe0f",
        native: "🤾🏻‍♀️"
      },
      {
        unified: "1f93e-1f3fc-200d-2640-fe0f",
        native: "🤾🏼‍♀️"
      },
      {
        unified: "1f93e-1f3fd-200d-2640-fe0f",
        native: "🤾🏽‍♀️"
      },
      {
        unified: "1f93e-1f3fe-200d-2640-fe0f",
        native: "🤾🏾‍♀️"
      },
      {
        unified: "1f93e-1f3ff-200d-2640-fe0f",
        native: "🤾🏿‍♀️"
      }
    ],
    version: 4
  },
  juggling: {
    id: "juggling",
    name: "Juggling",
    keywords: [
      "person",
      "performance",
      "balance"
    ],
    skins: [
      {
        unified: "1f939",
        native: "🤹"
      },
      {
        unified: "1f939-1f3fb",
        native: "🤹🏻"
      },
      {
        unified: "1f939-1f3fc",
        native: "🤹🏼"
      },
      {
        unified: "1f939-1f3fd",
        native: "🤹🏽"
      },
      {
        unified: "1f939-1f3fe",
        native: "🤹🏾"
      },
      {
        unified: "1f939-1f3ff",
        native: "🤹🏿"
      }
    ],
    version: 3
  },
  "man-juggling": {
    id: "man-juggling",
    name: "Man Juggling",
    keywords: [
      "juggle",
      "balance",
      "skill",
      "multitask"
    ],
    skins: [
      {
        unified: "1f939-200d-2642-fe0f",
        native: "🤹‍♂️"
      },
      {
        unified: "1f939-1f3fb-200d-2642-fe0f",
        native: "🤹🏻‍♂️"
      },
      {
        unified: "1f939-1f3fc-200d-2642-fe0f",
        native: "🤹🏼‍♂️"
      },
      {
        unified: "1f939-1f3fd-200d-2642-fe0f",
        native: "🤹🏽‍♂️"
      },
      {
        unified: "1f939-1f3fe-200d-2642-fe0f",
        native: "🤹🏾‍♂️"
      },
      {
        unified: "1f939-1f3ff-200d-2642-fe0f",
        native: "🤹🏿‍♂️"
      }
    ],
    version: 4
  },
  "woman-juggling": {
    id: "woman-juggling",
    name: "Woman Juggling",
    keywords: [
      "juggle",
      "balance",
      "skill",
      "multitask"
    ],
    skins: [
      {
        unified: "1f939-200d-2640-fe0f",
        native: "🤹‍♀️"
      },
      {
        unified: "1f939-1f3fb-200d-2640-fe0f",
        native: "🤹🏻‍♀️"
      },
      {
        unified: "1f939-1f3fc-200d-2640-fe0f",
        native: "🤹🏼‍♀️"
      },
      {
        unified: "1f939-1f3fd-200d-2640-fe0f",
        native: "🤹🏽‍♀️"
      },
      {
        unified: "1f939-1f3fe-200d-2640-fe0f",
        native: "🤹🏾‍♀️"
      },
      {
        unified: "1f939-1f3ff-200d-2640-fe0f",
        native: "🤹🏿‍♀️"
      }
    ],
    version: 4
  },
  person_in_lotus_position: {
    id: "person_in_lotus_position",
    name: "Person in Lotus Position",
    keywords: [
      "meditate"
    ],
    skins: [
      {
        unified: "1f9d8",
        native: "🧘"
      },
      {
        unified: "1f9d8-1f3fb",
        native: "🧘🏻"
      },
      {
        unified: "1f9d8-1f3fc",
        native: "🧘🏼"
      },
      {
        unified: "1f9d8-1f3fd",
        native: "🧘🏽"
      },
      {
        unified: "1f9d8-1f3fe",
        native: "🧘🏾"
      },
      {
        unified: "1f9d8-1f3ff",
        native: "🧘🏿"
      }
    ],
    version: 5
  },
  man_in_lotus_position: {
    id: "man_in_lotus_position",
    name: "Man in Lotus Position",
    keywords: [
      "male",
      "meditation",
      "yoga",
      "serenity",
      "zen",
      "mindfulness"
    ],
    skins: [
      {
        unified: "1f9d8-200d-2642-fe0f",
        native: "🧘‍♂️"
      },
      {
        unified: "1f9d8-1f3fb-200d-2642-fe0f",
        native: "🧘🏻‍♂️"
      },
      {
        unified: "1f9d8-1f3fc-200d-2642-fe0f",
        native: "🧘🏼‍♂️"
      },
      {
        unified: "1f9d8-1f3fd-200d-2642-fe0f",
        native: "🧘🏽‍♂️"
      },
      {
        unified: "1f9d8-1f3fe-200d-2642-fe0f",
        native: "🧘🏾‍♂️"
      },
      {
        unified: "1f9d8-1f3ff-200d-2642-fe0f",
        native: "🧘🏿‍♂️"
      }
    ],
    version: 5
  },
  woman_in_lotus_position: {
    id: "woman_in_lotus_position",
    name: "Woman in Lotus Position",
    keywords: [
      "female",
      "meditation",
      "yoga",
      "serenity",
      "zen",
      "mindfulness"
    ],
    skins: [
      {
        unified: "1f9d8-200d-2640-fe0f",
        native: "🧘‍♀️"
      },
      {
        unified: "1f9d8-1f3fb-200d-2640-fe0f",
        native: "🧘🏻‍♀️"
      },
      {
        unified: "1f9d8-1f3fc-200d-2640-fe0f",
        native: "🧘🏼‍♀️"
      },
      {
        unified: "1f9d8-1f3fd-200d-2640-fe0f",
        native: "🧘🏽‍♀️"
      },
      {
        unified: "1f9d8-1f3fe-200d-2640-fe0f",
        native: "🧘🏾‍♀️"
      },
      {
        unified: "1f9d8-1f3ff-200d-2640-fe0f",
        native: "🧘🏿‍♀️"
      }
    ],
    version: 5
  },
  bath: {
    id: "bath",
    name: "Bath",
    keywords: [
      "person",
      "taking",
      "clean",
      "shower",
      "bathroom"
    ],
    skins: [
      {
        unified: "1f6c0",
        native: "🛀"
      },
      {
        unified: "1f6c0-1f3fb",
        native: "🛀🏻"
      },
      {
        unified: "1f6c0-1f3fc",
        native: "🛀🏼"
      },
      {
        unified: "1f6c0-1f3fd",
        native: "🛀🏽"
      },
      {
        unified: "1f6c0-1f3fe",
        native: "🛀🏾"
      },
      {
        unified: "1f6c0-1f3ff",
        native: "🛀🏿"
      }
    ],
    version: 1
  },
  sleeping_accommodation: {
    id: "sleeping_accommodation",
    name: "Person in Bed",
    keywords: [
      "sleeping",
      "accommodation",
      "rest"
    ],
    skins: [
      {
        unified: "1f6cc",
        native: "🛌"
      },
      {
        unified: "1f6cc-1f3fb",
        native: "🛌🏻"
      },
      {
        unified: "1f6cc-1f3fc",
        native: "🛌🏼"
      },
      {
        unified: "1f6cc-1f3fd",
        native: "🛌🏽"
      },
      {
        unified: "1f6cc-1f3fe",
        native: "🛌🏾"
      },
      {
        unified: "1f6cc-1f3ff",
        native: "🛌🏿"
      }
    ],
    version: 1
  },
  people_holding_hands: {
    id: "people_holding_hands",
    name: "People Holding Hands",
    keywords: [
      "friendship"
    ],
    skins: [
      {
        unified: "1f9d1-200d-1f91d-200d-1f9d1",
        native: "🧑‍🤝‍🧑"
      },
      {
        unified: "1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fb",
        native: "🧑🏻‍🤝‍🧑🏻"
      },
      {
        unified: "1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fc",
        native: "🧑🏼‍🤝‍🧑🏼"
      },
      {
        unified: "1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fd",
        native: "🧑🏽‍🤝‍🧑🏽"
      },
      {
        unified: "1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fe",
        native: "🧑🏾‍🤝‍🧑🏾"
      },
      {
        unified: "1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3ff",
        native: "🧑🏿‍🤝‍🧑🏿"
      }
    ],
    version: 12
  },
  two_women_holding_hands: {
    id: "two_women_holding_hands",
    name: "Women Holding Hands",
    keywords: [
      "two",
      "pair",
      "friendship",
      "couple",
      "love",
      "like",
      "female",
      "people",
      "human"
    ],
    skins: [
      {
        unified: "1f46d",
        native: "👭"
      },
      {
        unified: "1f46d-1f3fb",
        native: "👭🏻"
      },
      {
        unified: "1f46d-1f3fc",
        native: "👭🏼"
      },
      {
        unified: "1f46d-1f3fd",
        native: "👭🏽"
      },
      {
        unified: "1f46d-1f3fe",
        native: "👭🏾"
      },
      {
        unified: "1f46d-1f3ff",
        native: "👭🏿"
      }
    ],
    version: 1
  },
  man_and_woman_holding_hands: {
    id: "man_and_woman_holding_hands",
    name: "Man and Woman Holding Hands",
    keywords: [
      "couple",
      "pair",
      "people",
      "human",
      "love",
      "date",
      "dating",
      "like",
      "affection",
      "valentines",
      "marriage"
    ],
    skins: [
      {
        unified: "1f46b",
        native: "👫"
      },
      {
        unified: "1f46b-1f3fb",
        native: "👫🏻"
      },
      {
        unified: "1f46b-1f3fc",
        native: "👫🏼"
      },
      {
        unified: "1f46b-1f3fd",
        native: "👫🏽"
      },
      {
        unified: "1f46b-1f3fe",
        native: "👫🏾"
      },
      {
        unified: "1f46b-1f3ff",
        native: "👫🏿"
      }
    ],
    version: 1
  },
  two_men_holding_hands: {
    id: "two_men_holding_hands",
    name: "Men Holding Hands",
    keywords: [
      "two",
      "pair",
      "couple",
      "love",
      "like",
      "bromance",
      "friendship",
      "people",
      "human"
    ],
    skins: [
      {
        unified: "1f46c",
        native: "👬"
      },
      {
        unified: "1f46c-1f3fb",
        native: "👬🏻"
      },
      {
        unified: "1f46c-1f3fc",
        native: "👬🏼"
      },
      {
        unified: "1f46c-1f3fd",
        native: "👬🏽"
      },
      {
        unified: "1f46c-1f3fe",
        native: "👬🏾"
      },
      {
        unified: "1f46c-1f3ff",
        native: "👬🏿"
      }
    ],
    version: 1
  },
  couplekiss: {
    id: "couplekiss",
    name: "Kiss",
    keywords: [
      "couplekiss",
      "pair",
      "valentines",
      "love",
      "like",
      "dating",
      "marriage"
    ],
    skins: [
      {
        unified: "1f48f",
        native: "💏"
      },
      {
        unified: "1f48f-1f3fb",
        native: "💏🏻"
      },
      {
        unified: "1f48f-1f3fc",
        native: "💏🏼"
      },
      {
        unified: "1f48f-1f3fd",
        native: "💏🏽"
      },
      {
        unified: "1f48f-1f3fe",
        native: "💏🏾"
      },
      {
        unified: "1f48f-1f3ff",
        native: "💏🏿"
      }
    ],
    version: 1
  },
  "woman-kiss-man": {
    id: "woman-kiss-man",
    name: "Kiss: Woman, Man",
    keywords: [
      "woman",
      "kiss-man",
      "kiss",
      "love"
    ],
    skins: [
      {
        unified: "1f469-200d-2764-fe0f-200d-1f48b-200d-1f468",
        native: "👩‍❤️‍💋‍👨"
      },
      {
        unified: "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
        native: "👩🏻‍❤️‍💋‍👨🏻"
      },
      {
        unified: "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
        native: "👩🏼‍❤️‍💋‍👨🏼"
      },
      {
        unified: "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
        native: "👩🏽‍❤️‍💋‍👨🏽"
      },
      {
        unified: "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
        native: "👩🏾‍❤️‍💋‍👨🏾"
      },
      {
        unified: "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",
        native: "👩🏿‍❤️‍💋‍👨🏿"
      }
    ],
    version: 2
  },
  "man-kiss-man": {
    id: "man-kiss-man",
    name: "Kiss: Man, Man",
    keywords: [
      "kiss-man",
      "kiss",
      "pair",
      "valentines",
      "love",
      "like",
      "dating",
      "marriage"
    ],
    skins: [
      {
        unified: "1f468-200d-2764-fe0f-200d-1f48b-200d-1f468",
        native: "👨‍❤️‍💋‍👨"
      },
      {
        unified: "1f468-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
        native: "👨🏻‍❤️‍💋‍👨🏻"
      },
      {
        unified: "1f468-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
        native: "👨🏼‍❤️‍💋‍👨🏼"
      },
      {
        unified: "1f468-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
        native: "👨🏽‍❤️‍💋‍👨🏽"
      },
      {
        unified: "1f468-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
        native: "👨🏾‍❤️‍💋‍👨🏾"
      },
      {
        unified: "1f468-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",
        native: "👨🏿‍❤️‍💋‍👨🏿"
      }
    ],
    version: 2
  },
  "woman-kiss-woman": {
    id: "woman-kiss-woman",
    name: "Kiss: Woman, Woman",
    keywords: [
      "kiss-woman",
      "kiss",
      "pair",
      "valentines",
      "love",
      "like",
      "dating",
      "marriage"
    ],
    skins: [
      {
        unified: "1f469-200d-2764-fe0f-200d-1f48b-200d-1f469",
        native: "👩‍❤️‍💋‍👩"
      },
      {
        unified: "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fb",
        native: "👩🏻‍❤️‍💋‍👩🏻"
      },
      {
        unified: "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fc",
        native: "👩🏼‍❤️‍💋‍👩🏼"
      },
      {
        unified: "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fd",
        native: "👩🏽‍❤️‍💋‍👩🏽"
      },
      {
        unified: "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fe",
        native: "👩🏾‍❤️‍💋‍👩🏾"
      },
      {
        unified: "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3ff",
        native: "👩🏿‍❤️‍💋‍👩🏿"
      }
    ],
    version: 2
  },
  couple_with_heart: {
    id: "couple_with_heart",
    name: "Couple with Heart",
    keywords: [
      "pair",
      "love",
      "like",
      "affection",
      "human",
      "dating",
      "valentines",
      "marriage"
    ],
    skins: [
      {
        unified: "1f491",
        native: "💑"
      },
      {
        unified: "1f491-1f3fb",
        native: "💑🏻"
      },
      {
        unified: "1f491-1f3fc",
        native: "💑🏼"
      },
      {
        unified: "1f491-1f3fd",
        native: "💑🏽"
      },
      {
        unified: "1f491-1f3fe",
        native: "💑🏾"
      },
      {
        unified: "1f491-1f3ff",
        native: "💑🏿"
      }
    ],
    version: 1
  },
  "woman-heart-man": {
    id: "woman-heart-man",
    name: "Couple with Heart: Woman, Man",
    keywords: [
      "woman",
      "heart-man",
      "heart",
      "love"
    ],
    skins: [
      {
        unified: "1f469-200d-2764-fe0f-200d-1f468",
        native: "👩‍❤️‍👨"
      },
      {
        unified: "1f469-1f3fb-200d-2764-fe0f-200d-1f468-1f3fb",
        native: "👩🏻‍❤️‍👨🏻"
      },
      {
        unified: "1f469-1f3fc-200d-2764-fe0f-200d-1f468-1f3fc",
        native: "👩🏼‍❤️‍👨🏼"
      },
      {
        unified: "1f469-1f3fd-200d-2764-fe0f-200d-1f468-1f3fd",
        native: "👩🏽‍❤️‍👨🏽"
      },
      {
        unified: "1f469-1f3fe-200d-2764-fe0f-200d-1f468-1f3fe",
        native: "👩🏾‍❤️‍👨🏾"
      },
      {
        unified: "1f469-1f3ff-200d-2764-fe0f-200d-1f468-1f3ff",
        native: "👩🏿‍❤️‍👨🏿"
      }
    ],
    version: 2
  },
  "man-heart-man": {
    id: "man-heart-man",
    name: "Couple with Heart: Man, Man",
    keywords: [
      "heart-man",
      "heart",
      "pair",
      "love",
      "like",
      "affection",
      "human",
      "dating",
      "valentines",
      "marriage"
    ],
    skins: [
      {
        unified: "1f468-200d-2764-fe0f-200d-1f468",
        native: "👨‍❤️‍👨"
      },
      {
        unified: "1f468-1f3fb-200d-2764-fe0f-200d-1f468-1f3fb",
        native: "👨🏻‍❤️‍👨🏻"
      },
      {
        unified: "1f468-1f3fc-200d-2764-fe0f-200d-1f468-1f3fc",
        native: "👨🏼‍❤️‍👨🏼"
      },
      {
        unified: "1f468-1f3fd-200d-2764-fe0f-200d-1f468-1f3fd",
        native: "👨🏽‍❤️‍👨🏽"
      },
      {
        unified: "1f468-1f3fe-200d-2764-fe0f-200d-1f468-1f3fe",
        native: "👨🏾‍❤️‍👨🏾"
      },
      {
        unified: "1f468-1f3ff-200d-2764-fe0f-200d-1f468-1f3ff",
        native: "👨🏿‍❤️‍👨🏿"
      }
    ],
    version: 2
  },
  "woman-heart-woman": {
    id: "woman-heart-woman",
    name: "Couple with Heart: Woman, Woman",
    keywords: [
      "heart-woman",
      "heart",
      "pair",
      "love",
      "like",
      "affection",
      "human",
      "dating",
      "valentines",
      "marriage"
    ],
    skins: [
      {
        unified: "1f469-200d-2764-fe0f-200d-1f469",
        native: "👩‍❤️‍👩"
      },
      {
        unified: "1f469-1f3fb-200d-2764-fe0f-200d-1f469-1f3fb",
        native: "👩🏻‍❤️‍👩🏻"
      },
      {
        unified: "1f469-1f3fc-200d-2764-fe0f-200d-1f469-1f3fc",
        native: "👩🏼‍❤️‍👩🏼"
      },
      {
        unified: "1f469-1f3fd-200d-2764-fe0f-200d-1f469-1f3fd",
        native: "👩🏽‍❤️‍👩🏽"
      },
      {
        unified: "1f469-1f3fe-200d-2764-fe0f-200d-1f469-1f3fe",
        native: "👩🏾‍❤️‍👩🏾"
      },
      {
        unified: "1f469-1f3ff-200d-2764-fe0f-200d-1f469-1f3ff",
        native: "👩🏿‍❤️‍👩🏿"
      }
    ],
    version: 2
  },
  family: {
    id: "family",
    name: "Family",
    keywords: [
      "home",
      "parents",
      "child",
      "mom",
      "dad",
      "father",
      "mother",
      "people",
      "human"
    ],
    skins: [
      {
        unified: "1f46a",
        native: "👪"
      }
    ],
    version: 1
  },
  "man-woman-boy": {
    id: "man-woman-boy",
    name: "Family: Man, Woman, Boy",
    keywords: [
      "man",
      "woman-boy",
      "family",
      "woman",
      "love"
    ],
    skins: [
      {
        unified: "1f468-200d-1f469-200d-1f466",
        native: "👨‍👩‍👦"
      }
    ],
    version: 2
  },
  "man-woman-girl": {
    id: "man-woman-girl",
    name: "Family: Man, Woman, Girl",
    keywords: [
      "man",
      "woman-girl",
      "family",
      "woman",
      "home",
      "parents",
      "people",
      "human",
      "child"
    ],
    skins: [
      {
        unified: "1f468-200d-1f469-200d-1f467",
        native: "👨‍👩‍👧"
      }
    ],
    version: 2
  },
  "man-woman-girl-boy": {
    id: "man-woman-girl-boy",
    name: "Family: Man, Woman, Girl, Boy",
    keywords: [
      "man",
      "woman-girl-boy",
      "family",
      "woman",
      "girl",
      "home",
      "parents",
      "people",
      "human",
      "children"
    ],
    skins: [
      {
        unified: "1f468-200d-1f469-200d-1f467-200d-1f466",
        native: "👨‍👩‍👧‍👦"
      }
    ],
    version: 2
  },
  "man-woman-boy-boy": {
    id: "man-woman-boy-boy",
    name: "Family: Man, Woman, Boy, Boy",
    keywords: [
      "man",
      "woman-boy-boy",
      "family",
      "woman",
      "home",
      "parents",
      "people",
      "human",
      "children"
    ],
    skins: [
      {
        unified: "1f468-200d-1f469-200d-1f466-200d-1f466",
        native: "👨‍👩‍👦‍👦"
      }
    ],
    version: 2
  },
  "man-woman-girl-girl": {
    id: "man-woman-girl-girl",
    name: "Family: Man, Woman, Girl, Girl",
    keywords: [
      "man",
      "woman-girl-girl",
      "family",
      "woman",
      "home",
      "parents",
      "people",
      "human",
      "children"
    ],
    skins: [
      {
        unified: "1f468-200d-1f469-200d-1f467-200d-1f467",
        native: "👨‍👩‍👧‍👧"
      }
    ],
    version: 2
  },
  "man-man-boy": {
    id: "man-man-boy",
    name: "Family: Man, Man, Boy",
    keywords: [
      "man",
      "man-boy",
      "family",
      "home",
      "parents",
      "people",
      "human",
      "children"
    ],
    skins: [
      {
        unified: "1f468-200d-1f468-200d-1f466",
        native: "👨‍👨‍👦"
      }
    ],
    version: 2
  },
  "man-man-girl": {
    id: "man-man-girl",
    name: "Family: Man, Man, Girl",
    keywords: [
      "man",
      "man-girl",
      "family",
      "home",
      "parents",
      "people",
      "human",
      "children"
    ],
    skins: [
      {
        unified: "1f468-200d-1f468-200d-1f467",
        native: "👨‍👨‍👧"
      }
    ],
    version: 2
  },
  "man-man-girl-boy": {
    id: "man-man-girl-boy",
    name: "Family: Man, Man, Girl, Boy",
    keywords: [
      "man",
      "man-girl-boy",
      "family",
      "girl",
      "home",
      "parents",
      "people",
      "human",
      "children"
    ],
    skins: [
      {
        unified: "1f468-200d-1f468-200d-1f467-200d-1f466",
        native: "👨‍👨‍👧‍👦"
      }
    ],
    version: 2
  },
  "man-man-boy-boy": {
    id: "man-man-boy-boy",
    name: "Family: Man, Man, Boy, Boy",
    keywords: [
      "man",
      "man-boy-boy",
      "family",
      "home",
      "parents",
      "people",
      "human",
      "children"
    ],
    skins: [
      {
        unified: "1f468-200d-1f468-200d-1f466-200d-1f466",
        native: "👨‍👨‍👦‍👦"
      }
    ],
    version: 2
  },
  "man-man-girl-girl": {
    id: "man-man-girl-girl",
    name: "Family: Man, Man, Girl, Girl",
    keywords: [
      "man",
      "man-girl-girl",
      "family",
      "home",
      "parents",
      "people",
      "human",
      "children"
    ],
    skins: [
      {
        unified: "1f468-200d-1f468-200d-1f467-200d-1f467",
        native: "👨‍👨‍👧‍👧"
      }
    ],
    version: 2
  },
  "woman-woman-boy": {
    id: "woman-woman-boy",
    name: "Family: Woman, Woman, Boy",
    keywords: [
      "woman",
      "woman-boy",
      "family",
      "home",
      "parents",
      "people",
      "human",
      "children"
    ],
    skins: [
      {
        unified: "1f469-200d-1f469-200d-1f466",
        native: "👩‍👩‍👦"
      }
    ],
    version: 2
  },
  "woman-woman-girl": {
    id: "woman-woman-girl",
    name: "Family: Woman, Woman, Girl",
    keywords: [
      "woman",
      "woman-girl",
      "family",
      "home",
      "parents",
      "people",
      "human",
      "children"
    ],
    skins: [
      {
        unified: "1f469-200d-1f469-200d-1f467",
        native: "👩‍👩‍👧"
      }
    ],
    version: 2
  },
  "woman-woman-girl-boy": {
    id: "woman-woman-girl-boy",
    name: "Family: Woman, Woman, Girl, Boy",
    keywords: [
      "woman",
      "woman-girl-boy",
      "family",
      "girl",
      "home",
      "parents",
      "people",
      "human",
      "children"
    ],
    skins: [
      {
        unified: "1f469-200d-1f469-200d-1f467-200d-1f466",
        native: "👩‍👩‍👧‍👦"
      }
    ],
    version: 2
  },
  "woman-woman-boy-boy": {
    id: "woman-woman-boy-boy",
    name: "Family: Woman, Woman, Boy, Boy",
    keywords: [
      "woman",
      "woman-boy-boy",
      "family",
      "home",
      "parents",
      "people",
      "human",
      "children"
    ],
    skins: [
      {
        unified: "1f469-200d-1f469-200d-1f466-200d-1f466",
        native: "👩‍👩‍👦‍👦"
      }
    ],
    version: 2
  },
  "woman-woman-girl-girl": {
    id: "woman-woman-girl-girl",
    name: "Family: Woman, Woman, Girl, Girl",
    keywords: [
      "woman",
      "woman-girl-girl",
      "family",
      "home",
      "parents",
      "people",
      "human",
      "children"
    ],
    skins: [
      {
        unified: "1f469-200d-1f469-200d-1f467-200d-1f467",
        native: "👩‍👩‍👧‍👧"
      }
    ],
    version: 2
  },
  "man-boy": {
    id: "man-boy",
    name: "Family: Man, Boy",
    keywords: [
      "man",
      "family",
      "home",
      "parent",
      "people",
      "human",
      "child"
    ],
    skins: [
      {
        unified: "1f468-200d-1f466",
        native: "👨‍👦"
      }
    ],
    version: 4
  },
  "man-boy-boy": {
    id: "man-boy-boy",
    name: "Family: Man, Boy, Boy",
    keywords: [
      "man",
      "boy-boy",
      "family",
      "home",
      "parent",
      "people",
      "human",
      "children"
    ],
    skins: [
      {
        unified: "1f468-200d-1f466-200d-1f466",
        native: "👨‍👦‍👦"
      }
    ],
    version: 4
  },
  "man-girl": {
    id: "man-girl",
    name: "Family: Man, Girl",
    keywords: [
      "man",
      "family",
      "home",
      "parent",
      "people",
      "human",
      "child"
    ],
    skins: [
      {
        unified: "1f468-200d-1f467",
        native: "👨‍👧"
      }
    ],
    version: 4
  },
  "man-girl-boy": {
    id: "man-girl-boy",
    name: "Family: Man, Girl, Boy",
    keywords: [
      "man",
      "girl-boy",
      "family",
      "girl",
      "home",
      "parent",
      "people",
      "human",
      "children"
    ],
    skins: [
      {
        unified: "1f468-200d-1f467-200d-1f466",
        native: "👨‍👧‍👦"
      }
    ],
    version: 4
  },
  "man-girl-girl": {
    id: "man-girl-girl",
    name: "Family: Man, Girl, Girl",
    keywords: [
      "man",
      "girl-girl",
      "family",
      "home",
      "parent",
      "people",
      "human",
      "children"
    ],
    skins: [
      {
        unified: "1f468-200d-1f467-200d-1f467",
        native: "👨‍👧‍👧"
      }
    ],
    version: 4
  },
  "woman-boy": {
    id: "woman-boy",
    name: "Family: Woman, Boy",
    keywords: [
      "woman",
      "family",
      "home",
      "parent",
      "people",
      "human",
      "child"
    ],
    skins: [
      {
        unified: "1f469-200d-1f466",
        native: "👩‍👦"
      }
    ],
    version: 4
  },
  "woman-boy-boy": {
    id: "woman-boy-boy",
    name: "Family: Woman, Boy, Boy",
    keywords: [
      "woman",
      "boy-boy",
      "family",
      "home",
      "parent",
      "people",
      "human",
      "children"
    ],
    skins: [
      {
        unified: "1f469-200d-1f466-200d-1f466",
        native: "👩‍👦‍👦"
      }
    ],
    version: 4
  },
  "woman-girl": {
    id: "woman-girl",
    name: "Family: Woman, Girl",
    keywords: [
      "woman",
      "family",
      "home",
      "parent",
      "people",
      "human",
      "child"
    ],
    skins: [
      {
        unified: "1f469-200d-1f467",
        native: "👩‍👧"
      }
    ],
    version: 4
  },
  "woman-girl-boy": {
    id: "woman-girl-boy",
    name: "Family: Woman, Girl, Boy",
    keywords: [
      "woman",
      "girl-boy",
      "family",
      "girl",
      "home",
      "parent",
      "people",
      "human",
      "children"
    ],
    skins: [
      {
        unified: "1f469-200d-1f467-200d-1f466",
        native: "👩‍👧‍👦"
      }
    ],
    version: 4
  },
  "woman-girl-girl": {
    id: "woman-girl-girl",
    name: "Family: Woman, Girl, Girl",
    keywords: [
      "woman",
      "girl-girl",
      "family",
      "home",
      "parent",
      "people",
      "human",
      "children"
    ],
    skins: [
      {
        unified: "1f469-200d-1f467-200d-1f467",
        native: "👩‍👧‍👧"
      }
    ],
    version: 4
  },
  speaking_head_in_silhouette: {
    id: "speaking_head_in_silhouette",
    name: "Speaking Head",
    keywords: [
      "in",
      "silhouette",
      "user",
      "person",
      "human",
      "sing",
      "say",
      "talk"
    ],
    skins: [
      {
        unified: "1f5e3-fe0f",
        native: "🗣️"
      }
    ],
    version: 1
  },
  bust_in_silhouette: {
    id: "bust_in_silhouette",
    name: "Bust in Silhouette",
    keywords: [
      "user",
      "person",
      "human"
    ],
    skins: [
      {
        unified: "1f464",
        native: "👤"
      }
    ],
    version: 1
  },
  busts_in_silhouette: {
    id: "busts_in_silhouette",
    name: "Busts in Silhouette",
    keywords: [
      "user",
      "person",
      "human",
      "group",
      "team"
    ],
    skins: [
      {
        unified: "1f465",
        native: "👥"
      }
    ],
    version: 1
  },
  people_hugging: {
    id: "people_hugging",
    name: "People Hugging",
    keywords: [
      "care"
    ],
    skins: [
      {
        unified: "1fac2",
        native: "🫂"
      }
    ],
    version: 13
  },
  footprints: {
    id: "footprints",
    name: "Footprints",
    keywords: [
      "feet",
      "tracking",
      "walking",
      "beach"
    ],
    skins: [
      {
        unified: "1f463",
        native: "👣"
      }
    ],
    version: 1
  },
  monkey_face: {
    id: "monkey_face",
    name: "Monkey Face",
    emoticons: [
      ":o)"
    ],
    keywords: [
      "animal",
      "nature",
      "circus"
    ],
    skins: [
      {
        unified: "1f435",
        native: "🐵"
      }
    ],
    version: 1
  },
  monkey: {
    id: "monkey",
    name: "Monkey",
    keywords: [
      "animal",
      "nature",
      "banana",
      "circus"
    ],
    skins: [
      {
        unified: "1f412",
        native: "🐒"
      }
    ],
    version: 1
  },
  gorilla: {
    id: "gorilla",
    name: "Gorilla",
    keywords: [
      "animal",
      "nature",
      "circus"
    ],
    skins: [
      {
        unified: "1f98d",
        native: "🦍"
      }
    ],
    version: 3
  },
  orangutan: {
    id: "orangutan",
    name: "Orangutan",
    keywords: [
      "animal"
    ],
    skins: [
      {
        unified: "1f9a7",
        native: "🦧"
      }
    ],
    version: 12
  },
  dog: {
    id: "dog",
    name: "Dog Face",
    keywords: [
      "animal",
      "friend",
      "nature",
      "woof",
      "puppy",
      "pet",
      "faithful"
    ],
    skins: [
      {
        unified: "1f436",
        native: "🐶"
      }
    ],
    version: 1
  },
  dog2: {
    id: "dog2",
    name: "Dog",
    keywords: [
      "dog2",
      "animal",
      "nature",
      "friend",
      "doge",
      "pet",
      "faithful"
    ],
    skins: [
      {
        unified: "1f415",
        native: "🐕"
      }
    ],
    version: 1
  },
  guide_dog: {
    id: "guide_dog",
    name: "Guide Dog",
    keywords: [
      "animal",
      "blind"
    ],
    skins: [
      {
        unified: "1f9ae",
        native: "🦮"
      }
    ],
    version: 12
  },
  service_dog: {
    id: "service_dog",
    name: "Service Dog",
    keywords: [
      "blind",
      "animal"
    ],
    skins: [
      {
        unified: "1f415-200d-1f9ba",
        native: "🐕‍🦺"
      }
    ],
    version: 12
  },
  poodle: {
    id: "poodle",
    name: "Poodle",
    keywords: [
      "dog",
      "animal",
      "101",
      "nature",
      "pet"
    ],
    skins: [
      {
        unified: "1f429",
        native: "🐩"
      }
    ],
    version: 1
  },
  wolf: {
    id: "wolf",
    name: "Wolf",
    keywords: [
      "animal",
      "nature",
      "wild"
    ],
    skins: [
      {
        unified: "1f43a",
        native: "🐺"
      }
    ],
    version: 1
  },
  fox_face: {
    id: "fox_face",
    name: "Fox",
    keywords: [
      "face",
      "animal",
      "nature"
    ],
    skins: [
      {
        unified: "1f98a",
        native: "🦊"
      }
    ],
    version: 3
  },
  raccoon: {
    id: "raccoon",
    name: "Raccoon",
    keywords: [
      "animal",
      "nature"
    ],
    skins: [
      {
        unified: "1f99d",
        native: "🦝"
      }
    ],
    version: 11
  },
  cat: {
    id: "cat",
    name: "Cat Face",
    keywords: [
      "animal",
      "meow",
      "nature",
      "pet",
      "kitten"
    ],
    skins: [
      {
        unified: "1f431",
        native: "🐱"
      }
    ],
    version: 1
  },
  cat2: {
    id: "cat2",
    name: "Cat",
    keywords: [
      "cat2",
      "animal",
      "meow",
      "pet",
      "cats"
    ],
    skins: [
      {
        unified: "1f408",
        native: "🐈"
      }
    ],
    version: 1
  },
  black_cat: {
    id: "black_cat",
    name: "Black Cat",
    keywords: [
      "superstition",
      "luck"
    ],
    skins: [
      {
        unified: "1f408-200d-2b1b",
        native: "🐈‍⬛"
      }
    ],
    version: 13
  },
  lion_face: {
    id: "lion_face",
    name: "Lion",
    keywords: [
      "face",
      "animal",
      "nature"
    ],
    skins: [
      {
        unified: "1f981",
        native: "🦁"
      }
    ],
    version: 1
  },
  tiger: {
    id: "tiger",
    name: "Tiger Face",
    keywords: [
      "animal",
      "cat",
      "danger",
      "wild",
      "nature",
      "roar"
    ],
    skins: [
      {
        unified: "1f42f",
        native: "🐯"
      }
    ],
    version: 1
  },
  tiger2: {
    id: "tiger2",
    name: "Tiger",
    keywords: [
      "tiger2",
      "animal",
      "nature",
      "roar"
    ],
    skins: [
      {
        unified: "1f405",
        native: "🐅"
      }
    ],
    version: 1
  },
  leopard: {
    id: "leopard",
    name: "Leopard",
    keywords: [
      "animal",
      "nature"
    ],
    skins: [
      {
        unified: "1f406",
        native: "🐆"
      }
    ],
    version: 1
  },
  horse: {
    id: "horse",
    name: "Horse Face",
    keywords: [
      "animal",
      "brown",
      "nature"
    ],
    skins: [
      {
        unified: "1f434",
        native: "🐴"
      }
    ],
    version: 1
  },
  moose: {
    id: "moose",
    name: "Moose",
    keywords: [
      "shrek",
      "canada",
      "sweden",
      "sven",
      "cool"
    ],
    skins: [
      {
        unified: "1face",
        native: "🫎"
      }
    ],
    version: 15
  },
  donkey: {
    id: "donkey",
    name: "Donkey",
    keywords: [
      "eeyore",
      "mule"
    ],
    skins: [
      {
        unified: "1facf",
        native: "🫏"
      }
    ],
    version: 15
  },
  racehorse: {
    id: "racehorse",
    name: "Horse",
    keywords: [
      "racehorse",
      "animal",
      "gamble",
      "luck"
    ],
    skins: [
      {
        unified: "1f40e",
        native: "🐎"
      }
    ],
    version: 1
  },
  unicorn_face: {
    id: "unicorn_face",
    name: "Unicorn",
    keywords: [
      "face",
      "animal",
      "nature",
      "mystical"
    ],
    skins: [
      {
        unified: "1f984",
        native: "🦄"
      }
    ],
    version: 1
  },
  zebra_face: {
    id: "zebra_face",
    name: "Zebra",
    keywords: [
      "face",
      "animal",
      "nature",
      "stripes",
      "safari"
    ],
    skins: [
      {
        unified: "1f993",
        native: "🦓"
      }
    ],
    version: 5
  },
  deer: {
    id: "deer",
    name: "Deer",
    keywords: [
      "animal",
      "nature",
      "horns",
      "venison"
    ],
    skins: [
      {
        unified: "1f98c",
        native: "🦌"
      }
    ],
    version: 3
  },
  bison: {
    id: "bison",
    name: "Bison",
    keywords: [
      "ox"
    ],
    skins: [
      {
        unified: "1f9ac",
        native: "🦬"
      }
    ],
    version: 13
  },
  cow: {
    id: "cow",
    name: "Cow Face",
    keywords: [
      "beef",
      "ox",
      "animal",
      "nature",
      "moo",
      "milk"
    ],
    skins: [
      {
        unified: "1f42e",
        native: "🐮"
      }
    ],
    version: 1
  },
  ox: {
    id: "ox",
    name: "Ox",
    keywords: [
      "animal",
      "cow",
      "beef"
    ],
    skins: [
      {
        unified: "1f402",
        native: "🐂"
      }
    ],
    version: 1
  },
  water_buffalo: {
    id: "water_buffalo",
    name: "Water Buffalo",
    keywords: [
      "animal",
      "nature",
      "ox",
      "cow"
    ],
    skins: [
      {
        unified: "1f403",
        native: "🐃"
      }
    ],
    version: 1
  },
  cow2: {
    id: "cow2",
    name: "Cow",
    keywords: [
      "cow2",
      "beef",
      "ox",
      "animal",
      "nature",
      "moo",
      "milk"
    ],
    skins: [
      {
        unified: "1f404",
        native: "🐄"
      }
    ],
    version: 1
  },
  pig: {
    id: "pig",
    name: "Pig Face",
    keywords: [
      "animal",
      "oink",
      "nature"
    ],
    skins: [
      {
        unified: "1f437",
        native: "🐷"
      }
    ],
    version: 1
  },
  pig2: {
    id: "pig2",
    name: "Pig",
    keywords: [
      "pig2",
      "animal",
      "nature"
    ],
    skins: [
      {
        unified: "1f416",
        native: "🐖"
      }
    ],
    version: 1
  },
  boar: {
    id: "boar",
    name: "Boar",
    keywords: [
      "animal",
      "nature"
    ],
    skins: [
      {
        unified: "1f417",
        native: "🐗"
      }
    ],
    version: 1
  },
  pig_nose: {
    id: "pig_nose",
    name: "Pig Nose",
    keywords: [
      "animal",
      "oink"
    ],
    skins: [
      {
        unified: "1f43d",
        native: "🐽"
      }
    ],
    version: 1
  },
  ram: {
    id: "ram",
    name: "Ram",
    keywords: [
      "animal",
      "sheep",
      "nature"
    ],
    skins: [
      {
        unified: "1f40f",
        native: "🐏"
      }
    ],
    version: 1
  },
  sheep: {
    id: "sheep",
    name: "Ewe",
    keywords: [
      "sheep",
      "animal",
      "nature",
      "wool",
      "shipit"
    ],
    skins: [
      {
        unified: "1f411",
        native: "🐑"
      }
    ],
    version: 1
  },
  goat: {
    id: "goat",
    name: "Goat",
    keywords: [
      "animal",
      "nature"
    ],
    skins: [
      {
        unified: "1f410",
        native: "🐐"
      }
    ],
    version: 1
  },
  dromedary_camel: {
    id: "dromedary_camel",
    name: "Camel",
    keywords: [
      "dromedary",
      "animal",
      "hot",
      "desert",
      "hump"
    ],
    skins: [
      {
        unified: "1f42a",
        native: "🐪"
      }
    ],
    version: 1
  },
  camel: {
    id: "camel",
    name: "Bactrian Camel",
    keywords: [
      "two",
      "hump",
      "animal",
      "nature",
      "hot",
      "desert"
    ],
    skins: [
      {
        unified: "1f42b",
        native: "🐫"
      }
    ],
    version: 1
  },
  llama: {
    id: "llama",
    name: "Llama",
    keywords: [
      "animal",
      "nature",
      "alpaca"
    ],
    skins: [
      {
        unified: "1f999",
        native: "🦙"
      }
    ],
    version: 11
  },
  giraffe_face: {
    id: "giraffe_face",
    name: "Giraffe",
    keywords: [
      "face",
      "animal",
      "nature",
      "spots",
      "safari"
    ],
    skins: [
      {
        unified: "1f992",
        native: "🦒"
      }
    ],
    version: 5
  },
  elephant: {
    id: "elephant",
    name: "Elephant",
    keywords: [
      "animal",
      "nature",
      "nose",
      "th",
      "circus"
    ],
    skins: [
      {
        unified: "1f418",
        native: "🐘"
      }
    ],
    version: 1
  },
  mammoth: {
    id: "mammoth",
    name: "Mammoth",
    keywords: [
      "elephant",
      "tusks"
    ],
    skins: [
      {
        unified: "1f9a3",
        native: "🦣"
      }
    ],
    version: 13
  },
  rhinoceros: {
    id: "rhinoceros",
    name: "Rhinoceros",
    keywords: [
      "animal",
      "nature",
      "horn"
    ],
    skins: [
      {
        unified: "1f98f",
        native: "🦏"
      }
    ],
    version: 3
  },
  hippopotamus: {
    id: "hippopotamus",
    name: "Hippopotamus",
    keywords: [
      "animal",
      "nature"
    ],
    skins: [
      {
        unified: "1f99b",
        native: "🦛"
      }
    ],
    version: 11
  },
  mouse: {
    id: "mouse",
    name: "Mouse Face",
    keywords: [
      "animal",
      "nature",
      "cheese",
      "wedge",
      "rodent"
    ],
    skins: [
      {
        unified: "1f42d",
        native: "🐭"
      }
    ],
    version: 1
  },
  mouse2: {
    id: "mouse2",
    name: "Mouse",
    keywords: [
      "mouse2",
      "animal",
      "nature",
      "rodent"
    ],
    skins: [
      {
        unified: "1f401",
        native: "🐁"
      }
    ],
    version: 1
  },
  rat: {
    id: "rat",
    name: "Rat",
    keywords: [
      "animal",
      "mouse",
      "rodent"
    ],
    skins: [
      {
        unified: "1f400",
        native: "🐀"
      }
    ],
    version: 1
  },
  hamster: {
    id: "hamster",
    name: "Hamster",
    keywords: [
      "animal",
      "nature"
    ],
    skins: [
      {
        unified: "1f439",
        native: "🐹"
      }
    ],
    version: 1
  },
  rabbit: {
    id: "rabbit",
    name: "Rabbit Face",
    keywords: [
      "animal",
      "nature",
      "pet",
      "spring",
      "magic",
      "bunny"
    ],
    skins: [
      {
        unified: "1f430",
        native: "🐰"
      }
    ],
    version: 1
  },
  rabbit2: {
    id: "rabbit2",
    name: "Rabbit",
    keywords: [
      "rabbit2",
      "animal",
      "nature",
      "pet",
      "magic",
      "spring"
    ],
    skins: [
      {
        unified: "1f407",
        native: "🐇"
      }
    ],
    version: 1
  },
  chipmunk: {
    id: "chipmunk",
    name: "Chipmunk",
    keywords: [
      "animal",
      "nature",
      "rodent",
      "squirrel"
    ],
    skins: [
      {
        unified: "1f43f-fe0f",
        native: "🐿️"
      }
    ],
    version: 1
  },
  beaver: {
    id: "beaver",
    name: "Beaver",
    keywords: [
      "animal",
      "rodent"
    ],
    skins: [
      {
        unified: "1f9ab",
        native: "🦫"
      }
    ],
    version: 13
  },
  hedgehog: {
    id: "hedgehog",
    name: "Hedgehog",
    keywords: [
      "animal",
      "nature",
      "spiny"
    ],
    skins: [
      {
        unified: "1f994",
        native: "🦔"
      }
    ],
    version: 5
  },
  bat: {
    id: "bat",
    name: "Bat",
    keywords: [
      "animal",
      "nature",
      "blind",
      "vampire"
    ],
    skins: [
      {
        unified: "1f987",
        native: "🦇"
      }
    ],
    version: 3
  },
  bear: {
    id: "bear",
    name: "Bear",
    keywords: [
      "animal",
      "nature",
      "wild"
    ],
    skins: [
      {
        unified: "1f43b",
        native: "🐻"
      }
    ],
    version: 1
  },
  polar_bear: {
    id: "polar_bear",
    name: "Polar Bear",
    keywords: [
      "animal",
      "arctic"
    ],
    skins: [
      {
        unified: "1f43b-200d-2744-fe0f",
        native: "🐻‍❄️"
      }
    ],
    version: 13
  },
  koala: {
    id: "koala",
    name: "Koala",
    keywords: [
      "animal",
      "nature"
    ],
    skins: [
      {
        unified: "1f428",
        native: "🐨"
      }
    ],
    version: 1
  },
  panda_face: {
    id: "panda_face",
    name: "Panda",
    keywords: [
      "face",
      "animal",
      "nature"
    ],
    skins: [
      {
        unified: "1f43c",
        native: "🐼"
      }
    ],
    version: 1
  },
  sloth: {
    id: "sloth",
    name: "Sloth",
    keywords: [
      "animal"
    ],
    skins: [
      {
        unified: "1f9a5",
        native: "🦥"
      }
    ],
    version: 12
  },
  otter: {
    id: "otter",
    name: "Otter",
    keywords: [
      "animal"
    ],
    skins: [
      {
        unified: "1f9a6",
        native: "🦦"
      }
    ],
    version: 12
  },
  skunk: {
    id: "skunk",
    name: "Skunk",
    keywords: [
      "animal"
    ],
    skins: [
      {
        unified: "1f9a8",
        native: "🦨"
      }
    ],
    version: 12
  },
  kangaroo: {
    id: "kangaroo",
    name: "Kangaroo",
    keywords: [
      "animal",
      "nature",
      "australia",
      "joey",
      "hop",
      "marsupial"
    ],
    skins: [
      {
        unified: "1f998",
        native: "🦘"
      }
    ],
    version: 11
  },
  badger: {
    id: "badger",
    name: "Badger",
    keywords: [
      "animal",
      "nature",
      "honey"
    ],
    skins: [
      {
        unified: "1f9a1",
        native: "🦡"
      }
    ],
    version: 11
  },
  feet: {
    id: "feet",
    name: "Paw Prints",
    keywords: [
      "feet",
      "animal",
      "tracking",
      "footprints",
      "dog",
      "cat",
      "pet"
    ],
    skins: [
      {
        unified: "1f43e",
        native: "🐾"
      }
    ],
    version: 1
  },
  turkey: {
    id: "turkey",
    name: "Turkey",
    keywords: [
      "animal",
      "bird"
    ],
    skins: [
      {
        unified: "1f983",
        native: "🦃"
      }
    ],
    version: 1
  },
  chicken: {
    id: "chicken",
    name: "Chicken",
    keywords: [
      "animal",
      "cluck",
      "nature",
      "bird"
    ],
    skins: [
      {
        unified: "1f414",
        native: "🐔"
      }
    ],
    version: 1
  },
  rooster: {
    id: "rooster",
    name: "Rooster",
    keywords: [
      "animal",
      "nature",
      "chicken"
    ],
    skins: [
      {
        unified: "1f413",
        native: "🐓"
      }
    ],
    version: 1
  },
  hatching_chick: {
    id: "hatching_chick",
    name: "Hatching Chick",
    keywords: [
      "animal",
      "chicken",
      "egg",
      "born",
      "baby",
      "bird"
    ],
    skins: [
      {
        unified: "1f423",
        native: "🐣"
      }
    ],
    version: 1
  },
  baby_chick: {
    id: "baby_chick",
    name: "Baby Chick",
    keywords: [
      "animal",
      "chicken",
      "bird"
    ],
    skins: [
      {
        unified: "1f424",
        native: "🐤"
      }
    ],
    version: 1
  },
  hatched_chick: {
    id: "hatched_chick",
    name: "Front-Facing Baby Chick",
    keywords: [
      "hatched",
      "front",
      "facing",
      "animal",
      "chicken",
      "bird"
    ],
    skins: [
      {
        unified: "1f425",
        native: "🐥"
      }
    ],
    version: 1
  },
  bird: {
    id: "bird",
    name: "Bird",
    keywords: [
      "animal",
      "nature",
      "fly",
      "tweet",
      "spring"
    ],
    skins: [
      {
        unified: "1f426",
        native: "🐦"
      }
    ],
    version: 1
  },
  penguin: {
    id: "penguin",
    name: "Penguin",
    keywords: [
      "animal",
      "nature"
    ],
    skins: [
      {
        unified: "1f427",
        native: "🐧"
      }
    ],
    version: 1
  },
  dove_of_peace: {
    id: "dove_of_peace",
    name: "Dove",
    keywords: [
      "of",
      "peace",
      "animal",
      "bird"
    ],
    skins: [
      {
        unified: "1f54a-fe0f",
        native: "🕊️"
      }
    ],
    version: 1
  },
  eagle: {
    id: "eagle",
    name: "Eagle",
    keywords: [
      "animal",
      "nature",
      "bird"
    ],
    skins: [
      {
        unified: "1f985",
        native: "🦅"
      }
    ],
    version: 3
  },
  duck: {
    id: "duck",
    name: "Duck",
    keywords: [
      "animal",
      "nature",
      "bird",
      "mallard"
    ],
    skins: [
      {
        unified: "1f986",
        native: "🦆"
      }
    ],
    version: 3
  },
  swan: {
    id: "swan",
    name: "Swan",
    keywords: [
      "animal",
      "nature",
      "bird"
    ],
    skins: [
      {
        unified: "1f9a2",
        native: "🦢"
      }
    ],
    version: 11
  },
  owl: {
    id: "owl",
    name: "Owl",
    keywords: [
      "animal",
      "nature",
      "bird",
      "hoot"
    ],
    skins: [
      {
        unified: "1f989",
        native: "🦉"
      }
    ],
    version: 3
  },
  dodo: {
    id: "dodo",
    name: "Dodo",
    keywords: [
      "animal",
      "bird"
    ],
    skins: [
      {
        unified: "1f9a4",
        native: "🦤"
      }
    ],
    version: 13
  },
  feather: {
    id: "feather",
    name: "Feather",
    keywords: [
      "bird",
      "fly"
    ],
    skins: [
      {
        unified: "1fab6",
        native: "🪶"
      }
    ],
    version: 13
  },
  flamingo: {
    id: "flamingo",
    name: "Flamingo",
    keywords: [
      "animal"
    ],
    skins: [
      {
        unified: "1f9a9",
        native: "🦩"
      }
    ],
    version: 12
  },
  peacock: {
    id: "peacock",
    name: "Peacock",
    keywords: [
      "animal",
      "nature",
      "peahen",
      "bird"
    ],
    skins: [
      {
        unified: "1f99a",
        native: "🦚"
      }
    ],
    version: 11
  },
  parrot: {
    id: "parrot",
    name: "Parrot",
    keywords: [
      "animal",
      "nature",
      "bird",
      "pirate",
      "talk"
    ],
    skins: [
      {
        unified: "1f99c",
        native: "🦜"
      }
    ],
    version: 11
  },
  wing: {
    id: "wing",
    name: "Wing",
    keywords: [
      "angel",
      "birds",
      "flying"
    ],
    skins: [
      {
        unified: "1fabd",
        native: "🪽"
      }
    ],
    version: 15
  },
  black_bird: {
    id: "black_bird",
    name: "Black Bird",
    keywords: [
      "crow"
    ],
    skins: [
      {
        unified: "1f426-200d-2b1b",
        native: "🐦‍⬛"
      }
    ],
    version: 15
  },
  goose: {
    id: "goose",
    name: "Goose",
    keywords: [
      "silly",
      "jemima",
      "goosebumps"
    ],
    skins: [
      {
        unified: "1fabf",
        native: "🪿"
      }
    ],
    version: 15
  },
  frog: {
    id: "frog",
    name: "Frog",
    keywords: [
      "animal",
      "nature",
      "croak",
      "toad"
    ],
    skins: [
      {
        unified: "1f438",
        native: "🐸"
      }
    ],
    version: 1
  },
  crocodile: {
    id: "crocodile",
    name: "Crocodile",
    keywords: [
      "animal",
      "nature",
      "reptile",
      "lizard",
      "alligator"
    ],
    skins: [
      {
        unified: "1f40a",
        native: "🐊"
      }
    ],
    version: 1
  },
  turtle: {
    id: "turtle",
    name: "Turtle",
    keywords: [
      "animal",
      "slow",
      "nature",
      "tortoise"
    ],
    skins: [
      {
        unified: "1f422",
        native: "🐢"
      }
    ],
    version: 1
  },
  lizard: {
    id: "lizard",
    name: "Lizard",
    keywords: [
      "animal",
      "nature",
      "reptile"
    ],
    skins: [
      {
        unified: "1f98e",
        native: "🦎"
      }
    ],
    version: 3
  },
  snake: {
    id: "snake",
    name: "Snake",
    keywords: [
      "animal",
      "evil",
      "nature",
      "hiss",
      "python"
    ],
    skins: [
      {
        unified: "1f40d",
        native: "🐍"
      }
    ],
    version: 1
  },
  dragon_face: {
    id: "dragon_face",
    name: "Dragon Face",
    keywords: [
      "animal",
      "myth",
      "nature",
      "chinese",
      "green"
    ],
    skins: [
      {
        unified: "1f432",
        native: "🐲"
      }
    ],
    version: 1
  },
  dragon: {
    id: "dragon",
    name: "Dragon",
    keywords: [
      "animal",
      "myth",
      "nature",
      "chinese",
      "green"
    ],
    skins: [
      {
        unified: "1f409",
        native: "🐉"
      }
    ],
    version: 1
  },
  sauropod: {
    id: "sauropod",
    name: "Sauropod",
    keywords: [
      "animal",
      "nature",
      "dinosaur",
      "brachiosaurus",
      "brontosaurus",
      "diplodocus",
      "extinct"
    ],
    skins: [
      {
        unified: "1f995",
        native: "🦕"
      }
    ],
    version: 5
  },
  "t-rex": {
    id: "t-rex",
    name: "T-Rex",
    keywords: [
      "t",
      "rex",
      "animal",
      "nature",
      "dinosaur",
      "tyrannosaurus",
      "extinct"
    ],
    skins: [
      {
        unified: "1f996",
        native: "🦖"
      }
    ],
    version: 5
  },
  whale: {
    id: "whale",
    name: "Spouting Whale",
    keywords: [
      "animal",
      "nature",
      "sea",
      "ocean"
    ],
    skins: [
      {
        unified: "1f433",
        native: "🐳"
      }
    ],
    version: 1
  },
  whale2: {
    id: "whale2",
    name: "Whale",
    keywords: [
      "whale2",
      "animal",
      "nature",
      "sea",
      "ocean"
    ],
    skins: [
      {
        unified: "1f40b",
        native: "🐋"
      }
    ],
    version: 1
  },
  dolphin: {
    id: "dolphin",
    name: "Dolphin",
    keywords: [
      "flipper",
      "animal",
      "nature",
      "fish",
      "sea",
      "ocean",
      "fins",
      "beach"
    ],
    skins: [
      {
        unified: "1f42c",
        native: "🐬"
      }
    ],
    version: 1
  },
  seal: {
    id: "seal",
    name: "Seal",
    keywords: [
      "animal",
      "creature",
      "sea"
    ],
    skins: [
      {
        unified: "1f9ad",
        native: "🦭"
      }
    ],
    version: 13
  },
  fish: {
    id: "fish",
    name: "Fish",
    keywords: [
      "animal",
      "food",
      "nature"
    ],
    skins: [
      {
        unified: "1f41f",
        native: "🐟"
      }
    ],
    version: 1
  },
  tropical_fish: {
    id: "tropical_fish",
    name: "Tropical Fish",
    keywords: [
      "animal",
      "swim",
      "ocean",
      "beach",
      "nemo"
    ],
    skins: [
      {
        unified: "1f420",
        native: "🐠"
      }
    ],
    version: 1
  },
  blowfish: {
    id: "blowfish",
    name: "Blowfish",
    keywords: [
      "animal",
      "nature",
      "food",
      "sea",
      "ocean"
    ],
    skins: [
      {
        unified: "1f421",
        native: "🐡"
      }
    ],
    version: 1
  },
  shark: {
    id: "shark",
    name: "Shark",
    keywords: [
      "animal",
      "nature",
      "fish",
      "sea",
      "ocean",
      "jaws",
      "fins",
      "beach"
    ],
    skins: [
      {
        unified: "1f988",
        native: "🦈"
      }
    ],
    version: 3
  },
  octopus: {
    id: "octopus",
    name: "Octopus",
    keywords: [
      "animal",
      "creature",
      "ocean",
      "sea",
      "nature",
      "beach"
    ],
    skins: [
      {
        unified: "1f419",
        native: "🐙"
      }
    ],
    version: 1
  },
  shell: {
    id: "shell",
    name: "Spiral Shell",
    keywords: [
      "nature",
      "sea",
      "beach"
    ],
    skins: [
      {
        unified: "1f41a",
        native: "🐚"
      }
    ],
    version: 1
  },
  coral: {
    id: "coral",
    name: "Coral",
    keywords: [
      "ocean",
      "sea",
      "reef"
    ],
    skins: [
      {
        unified: "1fab8",
        native: "🪸"
      }
    ],
    version: 14
  },
  jellyfish: {
    id: "jellyfish",
    name: "Jellyfish",
    keywords: [
      "sting",
      "tentacles"
    ],
    skins: [
      {
        unified: "1fabc",
        native: "🪼"
      }
    ],
    version: 15
  },
  snail: {
    id: "snail",
    name: "Snail",
    keywords: [
      "slow",
      "animal",
      "shell"
    ],
    skins: [
      {
        unified: "1f40c",
        native: "🐌"
      }
    ],
    version: 1
  },
  butterfly: {
    id: "butterfly",
    name: "Butterfly",
    keywords: [
      "animal",
      "insect",
      "nature",
      "caterpillar"
    ],
    skins: [
      {
        unified: "1f98b",
        native: "🦋"
      }
    ],
    version: 3
  },
  bug: {
    id: "bug",
    name: "Bug",
    keywords: [
      "animal",
      "insect",
      "nature",
      "worm"
    ],
    skins: [
      {
        unified: "1f41b",
        native: "🐛"
      }
    ],
    version: 1
  },
  ant: {
    id: "ant",
    name: "Ant",
    keywords: [
      "animal",
      "insect",
      "nature",
      "bug"
    ],
    skins: [
      {
        unified: "1f41c",
        native: "🐜"
      }
    ],
    version: 1
  },
  bee: {
    id: "bee",
    name: "Honeybee",
    keywords: [
      "bee",
      "animal",
      "insect",
      "nature",
      "bug",
      "spring",
      "honey"
    ],
    skins: [
      {
        unified: "1f41d",
        native: "🐝"
      }
    ],
    version: 1
  },
  beetle: {
    id: "beetle",
    name: "Beetle",
    keywords: [
      "insect"
    ],
    skins: [
      {
        unified: "1fab2",
        native: "🪲"
      }
    ],
    version: 13
  },
  ladybug: {
    id: "ladybug",
    name: "Lady Beetle",
    keywords: [
      "ladybug",
      "animal",
      "insect",
      "nature"
    ],
    skins: [
      {
        unified: "1f41e",
        native: "🐞"
      }
    ],
    version: 1
  },
  cricket: {
    id: "cricket",
    name: "Cricket",
    keywords: [
      "animal",
      "chirp"
    ],
    skins: [
      {
        unified: "1f997",
        native: "🦗"
      }
    ],
    version: 5
  },
  cockroach: {
    id: "cockroach",
    name: "Cockroach",
    keywords: [
      "insect",
      "pests"
    ],
    skins: [
      {
        unified: "1fab3",
        native: "🪳"
      }
    ],
    version: 13
  },
  spider: {
    id: "spider",
    name: "Spider",
    keywords: [
      "animal",
      "arachnid"
    ],
    skins: [
      {
        unified: "1f577-fe0f",
        native: "🕷️"
      }
    ],
    version: 1
  },
  spider_web: {
    id: "spider_web",
    name: "Spider Web",
    keywords: [
      "animal",
      "insect",
      "arachnid",
      "silk"
    ],
    skins: [
      {
        unified: "1f578-fe0f",
        native: "🕸️"
      }
    ],
    version: 1
  },
  scorpion: {
    id: "scorpion",
    name: "Scorpion",
    keywords: [
      "animal",
      "arachnid"
    ],
    skins: [
      {
        unified: "1f982",
        native: "🦂"
      }
    ],
    version: 1
  },
  mosquito: {
    id: "mosquito",
    name: "Mosquito",
    keywords: [
      "animal",
      "nature",
      "insect",
      "malaria"
    ],
    skins: [
      {
        unified: "1f99f",
        native: "🦟"
      }
    ],
    version: 11
  },
  fly: {
    id: "fly",
    name: "Fly",
    keywords: [
      "insect"
    ],
    skins: [
      {
        unified: "1fab0",
        native: "🪰"
      }
    ],
    version: 13
  },
  worm: {
    id: "worm",
    name: "Worm",
    keywords: [
      "animal"
    ],
    skins: [
      {
        unified: "1fab1",
        native: "🪱"
      }
    ],
    version: 13
  },
  microbe: {
    id: "microbe",
    name: "Microbe",
    keywords: [
      "amoeba",
      "bacteria",
      "germs",
      "virus",
      "covid"
    ],
    skins: [
      {
        unified: "1f9a0",
        native: "🦠"
      }
    ],
    version: 11
  },
  bouquet: {
    id: "bouquet",
    name: "Bouquet",
    keywords: [
      "flowers",
      "nature",
      "spring"
    ],
    skins: [
      {
        unified: "1f490",
        native: "💐"
      }
    ],
    version: 1
  },
  cherry_blossom: {
    id: "cherry_blossom",
    name: "Cherry Blossom",
    keywords: [
      "nature",
      "plant",
      "spring",
      "flower"
    ],
    skins: [
      {
        unified: "1f338",
        native: "🌸"
      }
    ],
    version: 1
  },
  white_flower: {
    id: "white_flower",
    name: "White Flower",
    keywords: [
      "japanese",
      "spring"
    ],
    skins: [
      {
        unified: "1f4ae",
        native: "💮"
      }
    ],
    version: 1
  },
  lotus: {
    id: "lotus",
    name: "Lotus",
    keywords: [
      "flower",
      "calm",
      "meditation"
    ],
    skins: [
      {
        unified: "1fab7",
        native: "🪷"
      }
    ],
    version: 14
  },
  rosette: {
    id: "rosette",
    name: "Rosette",
    keywords: [
      "flower",
      "decoration",
      "military"
    ],
    skins: [
      {
        unified: "1f3f5-fe0f",
        native: "🏵️"
      }
    ],
    version: 1
  },
  rose: {
    id: "rose",
    name: "Rose",
    keywords: [
      "flowers",
      "valentines",
      "love",
      "spring"
    ],
    skins: [
      {
        unified: "1f339",
        native: "🌹"
      }
    ],
    version: 1
  },
  wilted_flower: {
    id: "wilted_flower",
    name: "Wilted Flower",
    keywords: [
      "plant",
      "nature",
      "rose"
    ],
    skins: [
      {
        unified: "1f940",
        native: "🥀"
      }
    ],
    version: 3
  },
  hibiscus: {
    id: "hibiscus",
    name: "Hibiscus",
    keywords: [
      "plant",
      "vegetable",
      "flowers",
      "beach"
    ],
    skins: [
      {
        unified: "1f33a",
        native: "🌺"
      }
    ],
    version: 1
  },
  sunflower: {
    id: "sunflower",
    name: "Sunflower",
    keywords: [
      "nature",
      "plant",
      "fall"
    ],
    skins: [
      {
        unified: "1f33b",
        native: "🌻"
      }
    ],
    version: 1
  },
  blossom: {
    id: "blossom",
    name: "Blossom",
    keywords: [
      "nature",
      "flowers",
      "yellow"
    ],
    skins: [
      {
        unified: "1f33c",
        native: "🌼"
      }
    ],
    version: 1
  },
  tulip: {
    id: "tulip",
    name: "Tulip",
    keywords: [
      "flowers",
      "plant",
      "nature",
      "summer",
      "spring"
    ],
    skins: [
      {
        unified: "1f337",
        native: "🌷"
      }
    ],
    version: 1
  },
  hyacinth: {
    id: "hyacinth",
    name: "Hyacinth",
    keywords: [
      "flower",
      "lavender"
    ],
    skins: [
      {
        unified: "1fabb",
        native: "🪻"
      }
    ],
    version: 15
  },
  seedling: {
    id: "seedling",
    name: "Seedling",
    keywords: [
      "plant",
      "nature",
      "grass",
      "lawn",
      "spring"
    ],
    skins: [
      {
        unified: "1f331",
        native: "🌱"
      }
    ],
    version: 1
  },
  potted_plant: {
    id: "potted_plant",
    name: "Potted Plant",
    keywords: [
      "greenery",
      "house"
    ],
    skins: [
      {
        unified: "1fab4",
        native: "🪴"
      }
    ],
    version: 13
  },
  evergreen_tree: {
    id: "evergreen_tree",
    name: "Evergreen Tree",
    keywords: [
      "plant",
      "nature"
    ],
    skins: [
      {
        unified: "1f332",
        native: "🌲"
      }
    ],
    version: 1
  },
  deciduous_tree: {
    id: "deciduous_tree",
    name: "Deciduous Tree",
    keywords: [
      "plant",
      "nature"
    ],
    skins: [
      {
        unified: "1f333",
        native: "🌳"
      }
    ],
    version: 1
  },
  palm_tree: {
    id: "palm_tree",
    name: "Palm Tree",
    keywords: [
      "plant",
      "vegetable",
      "nature",
      "summer",
      "beach",
      "mojito",
      "tropical"
    ],
    skins: [
      {
        unified: "1f334",
        native: "🌴"
      }
    ],
    version: 1
  },
  cactus: {
    id: "cactus",
    name: "Cactus",
    keywords: [
      "vegetable",
      "plant",
      "nature"
    ],
    skins: [
      {
        unified: "1f335",
        native: "🌵"
      }
    ],
    version: 1
  },
  ear_of_rice: {
    id: "ear_of_rice",
    name: "Ear of Rice",
    keywords: [
      "sheaf",
      "nature",
      "plant"
    ],
    skins: [
      {
        unified: "1f33e",
        native: "🌾"
      }
    ],
    version: 1
  },
  herb: {
    id: "herb",
    name: "Herb",
    keywords: [
      "vegetable",
      "plant",
      "medicine",
      "weed",
      "grass",
      "lawn"
    ],
    skins: [
      {
        unified: "1f33f",
        native: "🌿"
      }
    ],
    version: 1
  },
  shamrock: {
    id: "shamrock",
    name: "Shamrock",
    keywords: [
      "vegetable",
      "plant",
      "nature",
      "irish",
      "clover"
    ],
    skins: [
      {
        unified: "2618-fe0f",
        native: "☘️"
      }
    ],
    version: 1
  },
  four_leaf_clover: {
    id: "four_leaf_clover",
    name: "Four Leaf Clover",
    keywords: [
      "vegetable",
      "plant",
      "nature",
      "lucky",
      "irish"
    ],
    skins: [
      {
        unified: "1f340",
        native: "🍀"
      }
    ],
    version: 1
  },
  maple_leaf: {
    id: "maple_leaf",
    name: "Maple Leaf",
    keywords: [
      "nature",
      "plant",
      "vegetable",
      "ca",
      "fall"
    ],
    skins: [
      {
        unified: "1f341",
        native: "🍁"
      }
    ],
    version: 1
  },
  fallen_leaf: {
    id: "fallen_leaf",
    name: "Fallen Leaf",
    keywords: [
      "nature",
      "plant",
      "vegetable",
      "leaves"
    ],
    skins: [
      {
        unified: "1f342",
        native: "🍂"
      }
    ],
    version: 1
  },
  leaves: {
    id: "leaves",
    name: "Leaf Fluttering in Wind",
    keywords: [
      "leaves",
      "nature",
      "plant",
      "tree",
      "vegetable",
      "grass",
      "lawn",
      "spring"
    ],
    skins: [
      {
        unified: "1f343",
        native: "🍃"
      }
    ],
    version: 1
  },
  empty_nest: {
    id: "empty_nest",
    name: "Empty Nest",
    keywords: [
      "bird"
    ],
    skins: [
      {
        unified: "1fab9",
        native: "🪹"
      }
    ],
    version: 14
  },
  nest_with_eggs: {
    id: "nest_with_eggs",
    name: "Nest with Eggs",
    keywords: [
      "bird"
    ],
    skins: [
      {
        unified: "1faba",
        native: "🪺"
      }
    ],
    version: 14
  },
  mushroom: {
    id: "mushroom",
    name: "Mushroom",
    keywords: [
      "plant",
      "vegetable"
    ],
    skins: [
      {
        unified: "1f344",
        native: "🍄"
      }
    ],
    version: 1
  },
  grapes: {
    id: "grapes",
    name: "Grapes",
    keywords: [
      "fruit",
      "food",
      "wine"
    ],
    skins: [
      {
        unified: "1f347",
        native: "🍇"
      }
    ],
    version: 1
  },
  melon: {
    id: "melon",
    name: "Melon",
    keywords: [
      "fruit",
      "nature",
      "food"
    ],
    skins: [
      {
        unified: "1f348",
        native: "🍈"
      }
    ],
    version: 1
  },
  watermelon: {
    id: "watermelon",
    name: "Watermelon",
    keywords: [
      "fruit",
      "food",
      "picnic",
      "summer"
    ],
    skins: [
      {
        unified: "1f349",
        native: "🍉"
      }
    ],
    version: 1
  },
  tangerine: {
    id: "tangerine",
    name: "Tangerine",
    keywords: [
      "food",
      "fruit",
      "nature",
      "orange"
    ],
    skins: [
      {
        unified: "1f34a",
        native: "🍊"
      }
    ],
    version: 1
  },
  lemon: {
    id: "lemon",
    name: "Lemon",
    keywords: [
      "fruit",
      "nature"
    ],
    skins: [
      {
        unified: "1f34b",
        native: "🍋"
      }
    ],
    version: 1
  },
  banana: {
    id: "banana",
    name: "Banana",
    keywords: [
      "fruit",
      "food",
      "monkey"
    ],
    skins: [
      {
        unified: "1f34c",
        native: "🍌"
      }
    ],
    version: 1
  },
  pineapple: {
    id: "pineapple",
    name: "Pineapple",
    keywords: [
      "fruit",
      "nature",
      "food"
    ],
    skins: [
      {
        unified: "1f34d",
        native: "🍍"
      }
    ],
    version: 1
  },
  mango: {
    id: "mango",
    name: "Mango",
    keywords: [
      "fruit",
      "food",
      "tropical"
    ],
    skins: [
      {
        unified: "1f96d",
        native: "🥭"
      }
    ],
    version: 11
  },
  apple: {
    id: "apple",
    name: "Red Apple",
    keywords: [
      "fruit",
      "mac",
      "school"
    ],
    skins: [
      {
        unified: "1f34e",
        native: "🍎"
      }
    ],
    version: 1
  },
  green_apple: {
    id: "green_apple",
    name: "Green Apple",
    keywords: [
      "fruit",
      "nature"
    ],
    skins: [
      {
        unified: "1f34f",
        native: "🍏"
      }
    ],
    version: 1
  },
  pear: {
    id: "pear",
    name: "Pear",
    keywords: [
      "fruit",
      "nature",
      "food"
    ],
    skins: [
      {
        unified: "1f350",
        native: "🍐"
      }
    ],
    version: 1
  },
  peach: {
    id: "peach",
    name: "Peach",
    keywords: [
      "fruit",
      "nature",
      "food"
    ],
    skins: [
      {
        unified: "1f351",
        native: "🍑"
      }
    ],
    version: 1
  },
  cherries: {
    id: "cherries",
    name: "Cherries",
    keywords: [
      "food",
      "fruit"
    ],
    skins: [
      {
        unified: "1f352",
        native: "🍒"
      }
    ],
    version: 1
  },
  strawberry: {
    id: "strawberry",
    name: "Strawberry",
    keywords: [
      "fruit",
      "food",
      "nature"
    ],
    skins: [
      {
        unified: "1f353",
        native: "🍓"
      }
    ],
    version: 1
  },
  blueberries: {
    id: "blueberries",
    name: "Blueberries",
    keywords: [
      "fruit"
    ],
    skins: [
      {
        unified: "1fad0",
        native: "🫐"
      }
    ],
    version: 13
  },
  kiwifruit: {
    id: "kiwifruit",
    name: "Kiwifruit",
    keywords: [
      "kiwi",
      "fruit",
      "food"
    ],
    skins: [
      {
        unified: "1f95d",
        native: "🥝"
      }
    ],
    version: 3
  },
  tomato: {
    id: "tomato",
    name: "Tomato",
    keywords: [
      "fruit",
      "vegetable",
      "nature",
      "food"
    ],
    skins: [
      {
        unified: "1f345",
        native: "🍅"
      }
    ],
    version: 1
  },
  olive: {
    id: "olive",
    name: "Olive",
    keywords: [
      "fruit"
    ],
    skins: [
      {
        unified: "1fad2",
        native: "🫒"
      }
    ],
    version: 13
  },
  coconut: {
    id: "coconut",
    name: "Coconut",
    keywords: [
      "fruit",
      "nature",
      "food",
      "palm"
    ],
    skins: [
      {
        unified: "1f965",
        native: "🥥"
      }
    ],
    version: 5
  },
  avocado: {
    id: "avocado",
    name: "Avocado",
    keywords: [
      "fruit",
      "food"
    ],
    skins: [
      {
        unified: "1f951",
        native: "🥑"
      }
    ],
    version: 3
  },
  eggplant: {
    id: "eggplant",
    name: "Eggplant",
    keywords: [
      "vegetable",
      "nature",
      "food",
      "aubergine"
    ],
    skins: [
      {
        unified: "1f346",
        native: "🍆"
      }
    ],
    version: 1
  },
  potato: {
    id: "potato",
    name: "Potato",
    keywords: [
      "food",
      "tuber",
      "vegatable",
      "starch"
    ],
    skins: [
      {
        unified: "1f954",
        native: "🥔"
      }
    ],
    version: 3
  },
  carrot: {
    id: "carrot",
    name: "Carrot",
    keywords: [
      "vegetable",
      "food",
      "orange"
    ],
    skins: [
      {
        unified: "1f955",
        native: "🥕"
      }
    ],
    version: 3
  },
  corn: {
    id: "corn",
    name: "Ear of Corn",
    keywords: [
      "food",
      "vegetable",
      "plant"
    ],
    skins: [
      {
        unified: "1f33d",
        native: "🌽"
      }
    ],
    version: 1
  },
  hot_pepper: {
    id: "hot_pepper",
    name: "Hot Pepper",
    keywords: [
      "food",
      "spicy",
      "chilli",
      "chili"
    ],
    skins: [
      {
        unified: "1f336-fe0f",
        native: "🌶️"
      }
    ],
    version: 1
  },
  bell_pepper: {
    id: "bell_pepper",
    name: "Bell Pepper",
    keywords: [
      "fruit",
      "plant"
    ],
    skins: [
      {
        unified: "1fad1",
        native: "🫑"
      }
    ],
    version: 13
  },
  cucumber: {
    id: "cucumber",
    name: "Cucumber",
    keywords: [
      "fruit",
      "food",
      "pickle"
    ],
    skins: [
      {
        unified: "1f952",
        native: "🥒"
      }
    ],
    version: 3
  },
  leafy_green: {
    id: "leafy_green",
    name: "Leafy Green",
    keywords: [
      "food",
      "vegetable",
      "plant",
      "bok",
      "choy",
      "cabbage",
      "kale",
      "lettuce"
    ],
    skins: [
      {
        unified: "1f96c",
        native: "🥬"
      }
    ],
    version: 11
  },
  broccoli: {
    id: "broccoli",
    name: "Broccoli",
    keywords: [
      "fruit",
      "food",
      "vegetable"
    ],
    skins: [
      {
        unified: "1f966",
        native: "🥦"
      }
    ],
    version: 5
  },
  garlic: {
    id: "garlic",
    name: "Garlic",
    keywords: [
      "food",
      "spice",
      "cook"
    ],
    skins: [
      {
        unified: "1f9c4",
        native: "🧄"
      }
    ],
    version: 12
  },
  onion: {
    id: "onion",
    name: "Onion",
    keywords: [
      "cook",
      "food",
      "spice"
    ],
    skins: [
      {
        unified: "1f9c5",
        native: "🧅"
      }
    ],
    version: 12
  },
  peanuts: {
    id: "peanuts",
    name: "Peanuts",
    keywords: [
      "food",
      "nut"
    ],
    skins: [
      {
        unified: "1f95c",
        native: "🥜"
      }
    ],
    version: 3
  },
  beans: {
    id: "beans",
    name: "Beans",
    keywords: [
      "food"
    ],
    skins: [
      {
        unified: "1fad8",
        native: "🫘"
      }
    ],
    version: 14
  },
  chestnut: {
    id: "chestnut",
    name: "Chestnut",
    keywords: [
      "food",
      "squirrel"
    ],
    skins: [
      {
        unified: "1f330",
        native: "🌰"
      }
    ],
    version: 1
  },
  ginger_root: {
    id: "ginger_root",
    name: "Ginger Root",
    keywords: [
      "spice",
      "yellow",
      "cooking",
      "gingerbread"
    ],
    skins: [
      {
        unified: "1fada",
        native: "🫚"
      }
    ],
    version: 15
  },
  pea_pod: {
    id: "pea_pod",
    name: "Pea Pod",
    keywords: [
      "cozy",
      "green"
    ],
    skins: [
      {
        unified: "1fadb",
        native: "🫛"
      }
    ],
    version: 15
  },
  bread: {
    id: "bread",
    name: "Bread",
    keywords: [
      "food",
      "wheat",
      "breakfast",
      "toast"
    ],
    skins: [
      {
        unified: "1f35e",
        native: "🍞"
      }
    ],
    version: 1
  },
  croissant: {
    id: "croissant",
    name: "Croissant",
    keywords: [
      "food",
      "bread",
      "french"
    ],
    skins: [
      {
        unified: "1f950",
        native: "🥐"
      }
    ],
    version: 3
  },
  baguette_bread: {
    id: "baguette_bread",
    name: "Baguette Bread",
    keywords: [
      "food",
      "french",
      "france",
      "bakery"
    ],
    skins: [
      {
        unified: "1f956",
        native: "🥖"
      }
    ],
    version: 3
  },
  flatbread: {
    id: "flatbread",
    name: "Flatbread",
    keywords: [
      "flour",
      "food",
      "bakery"
    ],
    skins: [
      {
        unified: "1fad3",
        native: "🫓"
      }
    ],
    version: 13
  },
  pretzel: {
    id: "pretzel",
    name: "Pretzel",
    keywords: [
      "food",
      "bread",
      "twisted",
      "germany",
      "bakery"
    ],
    skins: [
      {
        unified: "1f968",
        native: "🥨"
      }
    ],
    version: 5
  },
  bagel: {
    id: "bagel",
    name: "Bagel",
    keywords: [
      "food",
      "bread",
      "bakery",
      "schmear",
      "jewish"
    ],
    skins: [
      {
        unified: "1f96f",
        native: "🥯"
      }
    ],
    version: 11
  },
  pancakes: {
    id: "pancakes",
    name: "Pancakes",
    keywords: [
      "food",
      "breakfast",
      "flapjacks",
      "hotcakes",
      "brunch"
    ],
    skins: [
      {
        unified: "1f95e",
        native: "🥞"
      }
    ],
    version: 3
  },
  waffle: {
    id: "waffle",
    name: "Waffle",
    keywords: [
      "food",
      "breakfast",
      "brunch"
    ],
    skins: [
      {
        unified: "1f9c7",
        native: "🧇"
      }
    ],
    version: 12
  },
  cheese_wedge: {
    id: "cheese_wedge",
    name: "Cheese Wedge",
    keywords: [
      "food",
      "chadder",
      "swiss"
    ],
    skins: [
      {
        unified: "1f9c0",
        native: "🧀"
      }
    ],
    version: 1
  },
  meat_on_bone: {
    id: "meat_on_bone",
    name: "Meat on Bone",
    keywords: [
      "good",
      "food",
      "drumstick"
    ],
    skins: [
      {
        unified: "1f356",
        native: "🍖"
      }
    ],
    version: 1
  },
  poultry_leg: {
    id: "poultry_leg",
    name: "Poultry Leg",
    keywords: [
      "food",
      "meat",
      "drumstick",
      "bird",
      "chicken",
      "turkey"
    ],
    skins: [
      {
        unified: "1f357",
        native: "🍗"
      }
    ],
    version: 1
  },
  cut_of_meat: {
    id: "cut_of_meat",
    name: "Cut of Meat",
    keywords: [
      "food",
      "cow",
      "chop",
      "lambchop",
      "porkchop"
    ],
    skins: [
      {
        unified: "1f969",
        native: "🥩"
      }
    ],
    version: 5
  },
  bacon: {
    id: "bacon",
    name: "Bacon",
    keywords: [
      "food",
      "breakfast",
      "pork",
      "pig",
      "meat",
      "brunch"
    ],
    skins: [
      {
        unified: "1f953",
        native: "🥓"
      }
    ],
    version: 3
  },
  hamburger: {
    id: "hamburger",
    name: "Hamburger",
    keywords: [
      "meat",
      "fast",
      "food",
      "beef",
      "cheeseburger",
      "mcdonalds",
      "burger",
      "king"
    ],
    skins: [
      {
        unified: "1f354",
        native: "🍔"
      }
    ],
    version: 1
  },
  fries: {
    id: "fries",
    name: "French Fries",
    keywords: [
      "chips",
      "snack",
      "fast",
      "food",
      "potato"
    ],
    skins: [
      {
        unified: "1f35f",
        native: "🍟"
      }
    ],
    version: 1
  },
  pizza: {
    id: "pizza",
    name: "Pizza",
    keywords: [
      "food",
      "party",
      "italy"
    ],
    skins: [
      {
        unified: "1f355",
        native: "🍕"
      }
    ],
    version: 1
  },
  hotdog: {
    id: "hotdog",
    name: "Hot Dog",
    keywords: [
      "hotdog",
      "food",
      "frankfurter",
      "america"
    ],
    skins: [
      {
        unified: "1f32d",
        native: "🌭"
      }
    ],
    version: 1
  },
  sandwich: {
    id: "sandwich",
    name: "Sandwich",
    keywords: [
      "food",
      "lunch",
      "bread",
      "toast",
      "bakery"
    ],
    skins: [
      {
        unified: "1f96a",
        native: "🥪"
      }
    ],
    version: 5
  },
  taco: {
    id: "taco",
    name: "Taco",
    keywords: [
      "food",
      "mexican"
    ],
    skins: [
      {
        unified: "1f32e",
        native: "🌮"
      }
    ],
    version: 1
  },
  burrito: {
    id: "burrito",
    name: "Burrito",
    keywords: [
      "food",
      "mexican"
    ],
    skins: [
      {
        unified: "1f32f",
        native: "🌯"
      }
    ],
    version: 1
  },
  tamale: {
    id: "tamale",
    name: "Tamale",
    keywords: [
      "food",
      "masa"
    ],
    skins: [
      {
        unified: "1fad4",
        native: "🫔"
      }
    ],
    version: 13
  },
  stuffed_flatbread: {
    id: "stuffed_flatbread",
    name: "Stuffed Flatbread",
    keywords: [
      "food",
      "gyro",
      "mediterranean"
    ],
    skins: [
      {
        unified: "1f959",
        native: "🥙"
      }
    ],
    version: 3
  },
  falafel: {
    id: "falafel",
    name: "Falafel",
    keywords: [
      "food",
      "mediterranean"
    ],
    skins: [
      {
        unified: "1f9c6",
        native: "🧆"
      }
    ],
    version: 12
  },
  egg: {
    id: "egg",
    name: "Egg",
    keywords: [
      "food",
      "chicken",
      "breakfast"
    ],
    skins: [
      {
        unified: "1f95a",
        native: "🥚"
      }
    ],
    version: 3
  },
  fried_egg: {
    id: "fried_egg",
    name: "Cooking",
    keywords: [
      "fried",
      "egg",
      "food",
      "breakfast",
      "kitchen",
      "skillet"
    ],
    skins: [
      {
        unified: "1f373",
        native: "🍳"
      }
    ],
    version: 1
  },
  shallow_pan_of_food: {
    id: "shallow_pan_of_food",
    name: "Shallow Pan of Food",
    keywords: [
      "cooking",
      "casserole",
      "paella",
      "skillet"
    ],
    skins: [
      {
        unified: "1f958",
        native: "🥘"
      }
    ],
    version: 3
  },
  stew: {
    id: "stew",
    name: "Pot of Food",
    keywords: [
      "stew",
      "meat",
      "soup",
      "hot"
    ],
    skins: [
      {
        unified: "1f372",
        native: "🍲"
      }
    ],
    version: 1
  },
  fondue: {
    id: "fondue",
    name: "Fondue",
    keywords: [
      "cheese",
      "pot",
      "food"
    ],
    skins: [
      {
        unified: "1fad5",
        native: "🫕"
      }
    ],
    version: 13
  },
  bowl_with_spoon: {
    id: "bowl_with_spoon",
    name: "Bowl with Spoon",
    keywords: [
      "food",
      "breakfast",
      "cereal",
      "oatmeal",
      "porridge"
    ],
    skins: [
      {
        unified: "1f963",
        native: "🥣"
      }
    ],
    version: 5
  },
  green_salad: {
    id: "green_salad",
    name: "Green Salad",
    keywords: [
      "food",
      "healthy",
      "lettuce",
      "vegetable"
    ],
    skins: [
      {
        unified: "1f957",
        native: "🥗"
      }
    ],
    version: 3
  },
  popcorn: {
    id: "popcorn",
    name: "Popcorn",
    keywords: [
      "food",
      "movie",
      "theater",
      "films",
      "snack",
      "drama"
    ],
    skins: [
      {
        unified: "1f37f",
        native: "🍿"
      }
    ],
    version: 1
  },
  butter: {
    id: "butter",
    name: "Butter",
    keywords: [
      "food",
      "cook"
    ],
    skins: [
      {
        unified: "1f9c8",
        native: "🧈"
      }
    ],
    version: 12
  },
  salt: {
    id: "salt",
    name: "Salt",
    keywords: [
      "condiment",
      "shaker"
    ],
    skins: [
      {
        unified: "1f9c2",
        native: "🧂"
      }
    ],
    version: 11
  },
  canned_food: {
    id: "canned_food",
    name: "Canned Food",
    keywords: [
      "soup",
      "tomatoes"
    ],
    skins: [
      {
        unified: "1f96b",
        native: "🥫"
      }
    ],
    version: 5
  },
  bento: {
    id: "bento",
    name: "Bento Box",
    keywords: [
      "food",
      "japanese",
      "lunch"
    ],
    skins: [
      {
        unified: "1f371",
        native: "🍱"
      }
    ],
    version: 1
  },
  rice_cracker: {
    id: "rice_cracker",
    name: "Rice Cracker",
    keywords: [
      "food",
      "japanese",
      "snack"
    ],
    skins: [
      {
        unified: "1f358",
        native: "🍘"
      }
    ],
    version: 1
  },
  rice_ball: {
    id: "rice_ball",
    name: "Rice Ball",
    keywords: [
      "food",
      "japanese"
    ],
    skins: [
      {
        unified: "1f359",
        native: "🍙"
      }
    ],
    version: 1
  },
  rice: {
    id: "rice",
    name: "Cooked Rice",
    keywords: [
      "food",
      "asian"
    ],
    skins: [
      {
        unified: "1f35a",
        native: "🍚"
      }
    ],
    version: 1
  },
  curry: {
    id: "curry",
    name: "Curry Rice",
    keywords: [
      "food",
      "spicy",
      "hot",
      "indian"
    ],
    skins: [
      {
        unified: "1f35b",
        native: "🍛"
      }
    ],
    version: 1
  },
  ramen: {
    id: "ramen",
    name: "Steaming Bowl",
    keywords: [
      "ramen",
      "food",
      "japanese",
      "noodle",
      "chopsticks"
    ],
    skins: [
      {
        unified: "1f35c",
        native: "🍜"
      }
    ],
    version: 1
  },
  spaghetti: {
    id: "spaghetti",
    name: "Spaghetti",
    keywords: [
      "food",
      "italian",
      "pasta",
      "noodle"
    ],
    skins: [
      {
        unified: "1f35d",
        native: "🍝"
      }
    ],
    version: 1
  },
  sweet_potato: {
    id: "sweet_potato",
    name: "Roasted Sweet Potato",
    keywords: [
      "food",
      "nature",
      "plant"
    ],
    skins: [
      {
        unified: "1f360",
        native: "🍠"
      }
    ],
    version: 1
  },
  oden: {
    id: "oden",
    name: "Oden",
    keywords: [
      "food",
      "japanese"
    ],
    skins: [
      {
        unified: "1f362",
        native: "🍢"
      }
    ],
    version: 1
  },
  sushi: {
    id: "sushi",
    name: "Sushi",
    keywords: [
      "food",
      "fish",
      "japanese",
      "rice"
    ],
    skins: [
      {
        unified: "1f363",
        native: "🍣"
      }
    ],
    version: 1
  },
  fried_shrimp: {
    id: "fried_shrimp",
    name: "Fried Shrimp",
    keywords: [
      "food",
      "animal",
      "appetizer",
      "summer"
    ],
    skins: [
      {
        unified: "1f364",
        native: "🍤"
      }
    ],
    version: 1
  },
  fish_cake: {
    id: "fish_cake",
    name: "Fish Cake with Swirl",
    keywords: [
      "food",
      "japan",
      "sea",
      "beach",
      "narutomaki",
      "pink",
      "kamaboko",
      "surimi",
      "ramen"
    ],
    skins: [
      {
        unified: "1f365",
        native: "🍥"
      }
    ],
    version: 1
  },
  moon_cake: {
    id: "moon_cake",
    name: "Moon Cake",
    keywords: [
      "food",
      "autumn",
      "dessert"
    ],
    skins: [
      {
        unified: "1f96e",
        native: "🥮"
      }
    ],
    version: 11
  },
  dango: {
    id: "dango",
    name: "Dango",
    keywords: [
      "food",
      "dessert",
      "sweet",
      "japanese",
      "barbecue",
      "meat"
    ],
    skins: [
      {
        unified: "1f361",
        native: "🍡"
      }
    ],
    version: 1
  },
  dumpling: {
    id: "dumpling",
    name: "Dumpling",
    keywords: [
      "food",
      "empanada",
      "pierogi",
      "potsticker",
      "gyoza"
    ],
    skins: [
      {
        unified: "1f95f",
        native: "🥟"
      }
    ],
    version: 5
  },
  fortune_cookie: {
    id: "fortune_cookie",
    name: "Fortune Cookie",
    keywords: [
      "food",
      "prophecy",
      "dessert"
    ],
    skins: [
      {
        unified: "1f960",
        native: "🥠"
      }
    ],
    version: 5
  },
  takeout_box: {
    id: "takeout_box",
    name: "Takeout Box",
    keywords: [
      "food",
      "leftovers"
    ],
    skins: [
      {
        unified: "1f961",
        native: "🥡"
      }
    ],
    version: 5
  },
  crab: {
    id: "crab",
    name: "Crab",
    keywords: [
      "animal",
      "crustacean"
    ],
    skins: [
      {
        unified: "1f980",
        native: "🦀"
      }
    ],
    version: 1
  },
  lobster: {
    id: "lobster",
    name: "Lobster",
    keywords: [
      "animal",
      "nature",
      "bisque",
      "claws",
      "seafood"
    ],
    skins: [
      {
        unified: "1f99e",
        native: "🦞"
      }
    ],
    version: 11
  },
  shrimp: {
    id: "shrimp",
    name: "Shrimp",
    keywords: [
      "animal",
      "ocean",
      "nature",
      "seafood"
    ],
    skins: [
      {
        unified: "1f990",
        native: "🦐"
      }
    ],
    version: 3
  },
  squid: {
    id: "squid",
    name: "Squid",
    keywords: [
      "animal",
      "nature",
      "ocean",
      "sea"
    ],
    skins: [
      {
        unified: "1f991",
        native: "🦑"
      }
    ],
    version: 3
  },
  oyster: {
    id: "oyster",
    name: "Oyster",
    keywords: [
      "food"
    ],
    skins: [
      {
        unified: "1f9aa",
        native: "🦪"
      }
    ],
    version: 12
  },
  icecream: {
    id: "icecream",
    name: "Soft Ice Cream",
    keywords: [
      "icecream",
      "food",
      "hot",
      "dessert",
      "summer"
    ],
    skins: [
      {
        unified: "1f366",
        native: "🍦"
      }
    ],
    version: 1
  },
  shaved_ice: {
    id: "shaved_ice",
    name: "Shaved Ice",
    keywords: [
      "hot",
      "dessert",
      "summer"
    ],
    skins: [
      {
        unified: "1f367",
        native: "🍧"
      }
    ],
    version: 1
  },
  ice_cream: {
    id: "ice_cream",
    name: "Ice Cream",
    keywords: [
      "food",
      "hot",
      "dessert"
    ],
    skins: [
      {
        unified: "1f368",
        native: "🍨"
      }
    ],
    version: 1
  },
  doughnut: {
    id: "doughnut",
    name: "Doughnut",
    keywords: [
      "food",
      "dessert",
      "snack",
      "sweet",
      "donut"
    ],
    skins: [
      {
        unified: "1f369",
        native: "🍩"
      }
    ],
    version: 1
  },
  cookie: {
    id: "cookie",
    name: "Cookie",
    keywords: [
      "food",
      "snack",
      "oreo",
      "chocolate",
      "sweet",
      "dessert"
    ],
    skins: [
      {
        unified: "1f36a",
        native: "🍪"
      }
    ],
    version: 1
  },
  birthday: {
    id: "birthday",
    name: "Birthday Cake",
    keywords: [
      "food",
      "dessert"
    ],
    skins: [
      {
        unified: "1f382",
        native: "🎂"
      }
    ],
    version: 1
  },
  cake: {
    id: "cake",
    name: "Shortcake",
    keywords: [
      "cake",
      "food",
      "dessert"
    ],
    skins: [
      {
        unified: "1f370",
        native: "🍰"
      }
    ],
    version: 1
  },
  cupcake: {
    id: "cupcake",
    name: "Cupcake",
    keywords: [
      "food",
      "dessert",
      "bakery",
      "sweet"
    ],
    skins: [
      {
        unified: "1f9c1",
        native: "🧁"
      }
    ],
    version: 11
  },
  pie: {
    id: "pie",
    name: "Pie",
    keywords: [
      "food",
      "dessert",
      "pastry"
    ],
    skins: [
      {
        unified: "1f967",
        native: "🥧"
      }
    ],
    version: 5
  },
  chocolate_bar: {
    id: "chocolate_bar",
    name: "Chocolate Bar",
    keywords: [
      "food",
      "snack",
      "dessert",
      "sweet"
    ],
    skins: [
      {
        unified: "1f36b",
        native: "🍫"
      }
    ],
    version: 1
  },
  candy: {
    id: "candy",
    name: "Candy",
    keywords: [
      "snack",
      "dessert",
      "sweet",
      "lolly"
    ],
    skins: [
      {
        unified: "1f36c",
        native: "🍬"
      }
    ],
    version: 1
  },
  lollipop: {
    id: "lollipop",
    name: "Lollipop",
    keywords: [
      "food",
      "snack",
      "candy",
      "sweet"
    ],
    skins: [
      {
        unified: "1f36d",
        native: "🍭"
      }
    ],
    version: 1
  },
  custard: {
    id: "custard",
    name: "Custard",
    keywords: [
      "dessert",
      "food"
    ],
    skins: [
      {
        unified: "1f36e",
        native: "🍮"
      }
    ],
    version: 1
  },
  honey_pot: {
    id: "honey_pot",
    name: "Honey Pot",
    keywords: [
      "bees",
      "sweet",
      "kitchen"
    ],
    skins: [
      {
        unified: "1f36f",
        native: "🍯"
      }
    ],
    version: 1
  },
  baby_bottle: {
    id: "baby_bottle",
    name: "Baby Bottle",
    keywords: [
      "food",
      "container",
      "milk"
    ],
    skins: [
      {
        unified: "1f37c",
        native: "🍼"
      }
    ],
    version: 1
  },
  glass_of_milk: {
    id: "glass_of_milk",
    name: "Glass of Milk",
    keywords: [
      "beverage",
      "drink",
      "cow"
    ],
    skins: [
      {
        unified: "1f95b",
        native: "🥛"
      }
    ],
    version: 3
  },
  coffee: {
    id: "coffee",
    name: "Hot Beverage",
    keywords: [
      "coffee",
      "caffeine",
      "latte",
      "espresso",
      "mug"
    ],
    skins: [
      {
        unified: "2615",
        native: "☕"
      }
    ],
    version: 1
  },
  teapot: {
    id: "teapot",
    name: "Teapot",
    keywords: [
      "drink",
      "hot"
    ],
    skins: [
      {
        unified: "1fad6",
        native: "🫖"
      }
    ],
    version: 13
  },
  tea: {
    id: "tea",
    name: "Teacup Without Handle",
    keywords: [
      "tea",
      "drink",
      "bowl",
      "breakfast",
      "green",
      "british"
    ],
    skins: [
      {
        unified: "1f375",
        native: "🍵"
      }
    ],
    version: 1
  },
  sake: {
    id: "sake",
    name: "Sake",
    keywords: [
      "wine",
      "drink",
      "drunk",
      "beverage",
      "japanese",
      "alcohol",
      "booze"
    ],
    skins: [
      {
        unified: "1f376",
        native: "🍶"
      }
    ],
    version: 1
  },
  champagne: {
    id: "champagne",
    name: "Bottle with Popping Cork",
    keywords: [
      "champagne",
      "drink",
      "wine",
      "celebration"
    ],
    skins: [
      {
        unified: "1f37e",
        native: "🍾"
      }
    ],
    version: 1
  },
  wine_glass: {
    id: "wine_glass",
    name: "Wine Glass",
    keywords: [
      "drink",
      "beverage",
      "drunk",
      "alcohol",
      "booze"
    ],
    skins: [
      {
        unified: "1f377",
        native: "🍷"
      }
    ],
    version: 1
  },
  cocktail: {
    id: "cocktail",
    name: "Cocktail Glass",
    keywords: [
      "drink",
      "drunk",
      "alcohol",
      "beverage",
      "booze",
      "mojito"
    ],
    skins: [
      {
        unified: "1f378",
        native: "🍸"
      }
    ],
    version: 1
  },
  tropical_drink: {
    id: "tropical_drink",
    name: "Tropical Drink",
    keywords: [
      "beverage",
      "cocktail",
      "summer",
      "beach",
      "alcohol",
      "booze",
      "mojito"
    ],
    skins: [
      {
        unified: "1f379",
        native: "🍹"
      }
    ],
    version: 1
  },
  beer: {
    id: "beer",
    name: "Beer Mug",
    keywords: [
      "relax",
      "beverage",
      "drink",
      "drunk",
      "party",
      "pub",
      "summer",
      "alcohol",
      "booze"
    ],
    skins: [
      {
        unified: "1f37a",
        native: "🍺"
      }
    ],
    version: 1
  },
  beers: {
    id: "beers",
    name: "Clinking Beer Mugs",
    keywords: [
      "beers",
      "relax",
      "beverage",
      "drink",
      "drunk",
      "party",
      "pub",
      "summer",
      "alcohol",
      "booze"
    ],
    skins: [
      {
        unified: "1f37b",
        native: "🍻"
      }
    ],
    version: 1
  },
  clinking_glasses: {
    id: "clinking_glasses",
    name: "Clinking Glasses",
    keywords: [
      "beverage",
      "drink",
      "party",
      "alcohol",
      "celebrate",
      "cheers",
      "wine",
      "champagne",
      "toast"
    ],
    skins: [
      {
        unified: "1f942",
        native: "🥂"
      }
    ],
    version: 3
  },
  tumbler_glass: {
    id: "tumbler_glass",
    name: "Tumbler Glass",
    keywords: [
      "drink",
      "beverage",
      "drunk",
      "alcohol",
      "liquor",
      "booze",
      "bourbon",
      "scotch",
      "whisky",
      "shot"
    ],
    skins: [
      {
        unified: "1f943",
        native: "🥃"
      }
    ],
    version: 3
  },
  pouring_liquid: {
    id: "pouring_liquid",
    name: "Pouring Liquid",
    keywords: [
      "cup",
      "water"
    ],
    skins: [
      {
        unified: "1fad7",
        native: "🫗"
      }
    ],
    version: 14
  },
  cup_with_straw: {
    id: "cup_with_straw",
    name: "Cup with Straw",
    keywords: [
      "drink",
      "soda"
    ],
    skins: [
      {
        unified: "1f964",
        native: "🥤"
      }
    ],
    version: 5
  },
  bubble_tea: {
    id: "bubble_tea",
    name: "Bubble Tea",
    keywords: [
      "taiwan",
      "boba",
      "milk",
      "straw"
    ],
    skins: [
      {
        unified: "1f9cb",
        native: "🧋"
      }
    ],
    version: 13
  },
  beverage_box: {
    id: "beverage_box",
    name: "Beverage Box",
    keywords: [
      "drink"
    ],
    skins: [
      {
        unified: "1f9c3",
        native: "🧃"
      }
    ],
    version: 12
  },
  mate_drink: {
    id: "mate_drink",
    name: "Mate",
    keywords: [
      "drink",
      "tea",
      "beverage"
    ],
    skins: [
      {
        unified: "1f9c9",
        native: "🧉"
      }
    ],
    version: 12
  },
  ice_cube: {
    id: "ice_cube",
    name: "Ice",
    keywords: [
      "cube",
      "water",
      "cold"
    ],
    skins: [
      {
        unified: "1f9ca",
        native: "🧊"
      }
    ],
    version: 12
  },
  chopsticks: {
    id: "chopsticks",
    name: "Chopsticks",
    keywords: [
      "food"
    ],
    skins: [
      {
        unified: "1f962",
        native: "🥢"
      }
    ],
    version: 5
  },
  knife_fork_plate: {
    id: "knife_fork_plate",
    name: "Fork and Knife with Plate",
    keywords: [
      "food",
      "eat",
      "meal",
      "lunch",
      "dinner",
      "restaurant"
    ],
    skins: [
      {
        unified: "1f37d-fe0f",
        native: "🍽️"
      }
    ],
    version: 1
  },
  fork_and_knife: {
    id: "fork_and_knife",
    name: "Fork and Knife",
    keywords: [
      "cutlery",
      "kitchen"
    ],
    skins: [
      {
        unified: "1f374",
        native: "🍴"
      }
    ],
    version: 1
  },
  spoon: {
    id: "spoon",
    name: "Spoon",
    keywords: [
      "cutlery",
      "kitchen",
      "tableware"
    ],
    skins: [
      {
        unified: "1f944",
        native: "🥄"
      }
    ],
    version: 3
  },
  hocho: {
    id: "hocho",
    name: "Hocho",
    keywords: [
      "knife",
      "kitchen",
      "blade",
      "cutlery",
      "weapon"
    ],
    skins: [
      {
        unified: "1f52a",
        native: "🔪"
      }
    ],
    version: 1
  },
  jar: {
    id: "jar",
    name: "Jar",
    keywords: [
      "container",
      "sauce"
    ],
    skins: [
      {
        unified: "1fad9",
        native: "🫙"
      }
    ],
    version: 14
  },
  amphora: {
    id: "amphora",
    name: "Amphora",
    keywords: [
      "vase",
      "jar"
    ],
    skins: [
      {
        unified: "1f3fa",
        native: "🏺"
      }
    ],
    version: 1
  },
  earth_africa: {
    id: "earth_africa",
    name: "Earth Globe Europe-Africa",
    keywords: [
      "africa",
      "showing",
      "europe",
      "world",
      "international"
    ],
    skins: [
      {
        unified: "1f30d",
        native: "🌍"
      }
    ],
    version: 1
  },
  earth_americas: {
    id: "earth_americas",
    name: "Earth Globe Americas",
    keywords: [
      "showing",
      "world",
      "USA",
      "international"
    ],
    skins: [
      {
        unified: "1f30e",
        native: "🌎"
      }
    ],
    version: 1
  },
  earth_asia: {
    id: "earth_asia",
    name: "Earth Globe Asia-Australia",
    keywords: [
      "asia",
      "showing",
      "australia",
      "world",
      "east",
      "international"
    ],
    skins: [
      {
        unified: "1f30f",
        native: "🌏"
      }
    ],
    version: 1
  },
  globe_with_meridians: {
    id: "globe_with_meridians",
    name: "Globe with Meridians",
    keywords: [
      "earth",
      "international",
      "world",
      "internet",
      "interweb",
      "i18n"
    ],
    skins: [
      {
        unified: "1f310",
        native: "🌐"
      }
    ],
    version: 1
  },
  world_map: {
    id: "world_map",
    name: "World Map",
    keywords: [
      "location",
      "direction"
    ],
    skins: [
      {
        unified: "1f5fa-fe0f",
        native: "🗺️"
      }
    ],
    version: 1
  },
  japan: {
    id: "japan",
    name: "Map of Japan",
    keywords: [
      "nation",
      "country",
      "japanese",
      "asia"
    ],
    skins: [
      {
        unified: "1f5fe",
        native: "🗾"
      }
    ],
    version: 1
  },
  compass: {
    id: "compass",
    name: "Compass",
    keywords: [
      "magnetic",
      "navigation",
      "orienteering"
    ],
    skins: [
      {
        unified: "1f9ed",
        native: "🧭"
      }
    ],
    version: 11
  },
  snow_capped_mountain: {
    id: "snow_capped_mountain",
    name: "Snow-Capped Mountain",
    keywords: [
      "snow",
      "capped",
      "photo",
      "nature",
      "environment",
      "winter",
      "cold"
    ],
    skins: [
      {
        unified: "1f3d4-fe0f",
        native: "🏔️"
      }
    ],
    version: 1
  },
  mountain: {
    id: "mountain",
    name: "Mountain",
    keywords: [
      "photo",
      "nature",
      "environment"
    ],
    skins: [
      {
        unified: "26f0-fe0f",
        native: "⛰️"
      }
    ],
    version: 1
  },
  volcano: {
    id: "volcano",
    name: "Volcano",
    keywords: [
      "photo",
      "nature",
      "disaster"
    ],
    skins: [
      {
        unified: "1f30b",
        native: "🌋"
      }
    ],
    version: 1
  },
  mount_fuji: {
    id: "mount_fuji",
    name: "Mount Fuji",
    keywords: [
      "photo",
      "mountain",
      "nature",
      "japanese"
    ],
    skins: [
      {
        unified: "1f5fb",
        native: "🗻"
      }
    ],
    version: 1
  },
  camping: {
    id: "camping",
    name: "Camping",
    keywords: [
      "photo",
      "outdoors",
      "tent"
    ],
    skins: [
      {
        unified: "1f3d5-fe0f",
        native: "🏕️"
      }
    ],
    version: 1
  },
  beach_with_umbrella: {
    id: "beach_with_umbrella",
    name: "Beach with Umbrella",
    keywords: [
      "weather",
      "summer",
      "sunny",
      "sand",
      "mojito"
    ],
    skins: [
      {
        unified: "1f3d6-fe0f",
        native: "🏖️"
      }
    ],
    version: 1
  },
  desert: {
    id: "desert",
    name: "Desert",
    keywords: [
      "photo",
      "warm",
      "saharah"
    ],
    skins: [
      {
        unified: "1f3dc-fe0f",
        native: "🏜️"
      }
    ],
    version: 1
  },
  desert_island: {
    id: "desert_island",
    name: "Desert Island",
    keywords: [
      "photo",
      "tropical",
      "mojito"
    ],
    skins: [
      {
        unified: "1f3dd-fe0f",
        native: "🏝️"
      }
    ],
    version: 1
  },
  national_park: {
    id: "national_park",
    name: "National Park",
    keywords: [
      "photo",
      "environment",
      "nature"
    ],
    skins: [
      {
        unified: "1f3de-fe0f",
        native: "🏞️"
      }
    ],
    version: 1
  },
  stadium: {
    id: "stadium",
    name: "Stadium",
    keywords: [
      "photo",
      "place",
      "sports",
      "concert",
      "venue"
    ],
    skins: [
      {
        unified: "1f3df-fe0f",
        native: "🏟️"
      }
    ],
    version: 1
  },
  classical_building: {
    id: "classical_building",
    name: "Classical Building",
    keywords: [
      "art",
      "culture",
      "history"
    ],
    skins: [
      {
        unified: "1f3db-fe0f",
        native: "🏛️"
      }
    ],
    version: 1
  },
  building_construction: {
    id: "building_construction",
    name: "Building Construction",
    keywords: [
      "wip",
      "working",
      "progress"
    ],
    skins: [
      {
        unified: "1f3d7-fe0f",
        native: "🏗️"
      }
    ],
    version: 1
  },
  bricks: {
    id: "bricks",
    name: "Brick",
    keywords: [
      "bricks"
    ],
    skins: [
      {
        unified: "1f9f1",
        native: "🧱"
      }
    ],
    version: 11
  },
  rock: {
    id: "rock",
    name: "Rock",
    keywords: [
      "stone"
    ],
    skins: [
      {
        unified: "1faa8",
        native: "🪨"
      }
    ],
    version: 13
  },
  wood: {
    id: "wood",
    name: "Wood",
    keywords: [
      "nature",
      "timber",
      "trunk"
    ],
    skins: [
      {
        unified: "1fab5",
        native: "🪵"
      }
    ],
    version: 13
  },
  hut: {
    id: "hut",
    name: "Hut",
    keywords: [
      "house",
      "structure"
    ],
    skins: [
      {
        unified: "1f6d6",
        native: "🛖"
      }
    ],
    version: 13
  },
  house_buildings: {
    id: "house_buildings",
    name: "Houses",
    keywords: [
      "house",
      "buildings",
      "photo"
    ],
    skins: [
      {
        unified: "1f3d8-fe0f",
        native: "🏘️"
      }
    ],
    version: 1
  },
  derelict_house_building: {
    id: "derelict_house_building",
    name: "Derelict House",
    keywords: [
      "building",
      "abandon",
      "evict",
      "broken"
    ],
    skins: [
      {
        unified: "1f3da-fe0f",
        native: "🏚️"
      }
    ],
    version: 1
  },
  house: {
    id: "house",
    name: "House",
    keywords: [
      "building",
      "home"
    ],
    skins: [
      {
        unified: "1f3e0",
        native: "🏠"
      }
    ],
    version: 1
  },
  house_with_garden: {
    id: "house_with_garden",
    name: "House with Garden",
    keywords: [
      "home",
      "plant",
      "nature"
    ],
    skins: [
      {
        unified: "1f3e1",
        native: "🏡"
      }
    ],
    version: 1
  },
  office: {
    id: "office",
    name: "Office Building",
    keywords: [
      "bureau",
      "work"
    ],
    skins: [
      {
        unified: "1f3e2",
        native: "🏢"
      }
    ],
    version: 1
  },
  post_office: {
    id: "post_office",
    name: "Japanese Post Office",
    keywords: [
      "building",
      "envelope",
      "communication"
    ],
    skins: [
      {
        unified: "1f3e3",
        native: "🏣"
      }
    ],
    version: 1
  },
  european_post_office: {
    id: "european_post_office",
    name: "Post Office",
    keywords: [
      "european",
      "building",
      "email"
    ],
    skins: [
      {
        unified: "1f3e4",
        native: "🏤"
      }
    ],
    version: 1
  },
  hospital: {
    id: "hospital",
    name: "Hospital",
    keywords: [
      "building",
      "health",
      "surgery",
      "doctor"
    ],
    skins: [
      {
        unified: "1f3e5",
        native: "🏥"
      }
    ],
    version: 1
  },
  bank: {
    id: "bank",
    name: "Bank",
    keywords: [
      "building",
      "money",
      "sales",
      "cash",
      "business",
      "enterprise"
    ],
    skins: [
      {
        unified: "1f3e6",
        native: "🏦"
      }
    ],
    version: 1
  },
  hotel: {
    id: "hotel",
    name: "Hotel",
    keywords: [
      "building",
      "accomodation",
      "checkin"
    ],
    skins: [
      {
        unified: "1f3e8",
        native: "🏨"
      }
    ],
    version: 1
  },
  love_hotel: {
    id: "love_hotel",
    name: "Love Hotel",
    keywords: [
      "like",
      "affection",
      "dating"
    ],
    skins: [
      {
        unified: "1f3e9",
        native: "🏩"
      }
    ],
    version: 1
  },
  convenience_store: {
    id: "convenience_store",
    name: "Convenience Store",
    keywords: [
      "building",
      "shopping",
      "groceries"
    ],
    skins: [
      {
        unified: "1f3ea",
        native: "🏪"
      }
    ],
    version: 1
  },
  school: {
    id: "school",
    name: "School",
    keywords: [
      "building",
      "student",
      "education",
      "learn",
      "teach"
    ],
    skins: [
      {
        unified: "1f3eb",
        native: "🏫"
      }
    ],
    version: 1
  },
  department_store: {
    id: "department_store",
    name: "Department Store",
    keywords: [
      "building",
      "shopping",
      "mall"
    ],
    skins: [
      {
        unified: "1f3ec",
        native: "🏬"
      }
    ],
    version: 1
  },
  factory: {
    id: "factory",
    name: "Factory",
    keywords: [
      "building",
      "industry",
      "pollution",
      "smoke"
    ],
    skins: [
      {
        unified: "1f3ed",
        native: "🏭"
      }
    ],
    version: 1
  },
  japanese_castle: {
    id: "japanese_castle",
    name: "Japanese Castle",
    keywords: [
      "photo",
      "building"
    ],
    skins: [
      {
        unified: "1f3ef",
        native: "🏯"
      }
    ],
    version: 1
  },
  european_castle: {
    id: "european_castle",
    name: "Castle",
    keywords: [
      "european",
      "building",
      "royalty",
      "history"
    ],
    skins: [
      {
        unified: "1f3f0",
        native: "🏰"
      }
    ],
    version: 1
  },
  wedding: {
    id: "wedding",
    name: "Wedding",
    keywords: [
      "love",
      "like",
      "affection",
      "couple",
      "marriage",
      "bride",
      "groom"
    ],
    skins: [
      {
        unified: "1f492",
        native: "💒"
      }
    ],
    version: 1
  },
  tokyo_tower: {
    id: "tokyo_tower",
    name: "Tokyo Tower",
    keywords: [
      "photo",
      "japanese"
    ],
    skins: [
      {
        unified: "1f5fc",
        native: "🗼"
      }
    ],
    version: 1
  },
  statue_of_liberty: {
    id: "statue_of_liberty",
    name: "Statue of Liberty",
    keywords: [
      "american",
      "newyork"
    ],
    skins: [
      {
        unified: "1f5fd",
        native: "🗽"
      }
    ],
    version: 1
  },
  church: {
    id: "church",
    name: "Church",
    keywords: [
      "building",
      "religion",
      "christ"
    ],
    skins: [
      {
        unified: "26ea",
        native: "⛪"
      }
    ],
    version: 1
  },
  mosque: {
    id: "mosque",
    name: "Mosque",
    keywords: [
      "islam",
      "worship",
      "minaret"
    ],
    skins: [
      {
        unified: "1f54c",
        native: "🕌"
      }
    ],
    version: 1
  },
  hindu_temple: {
    id: "hindu_temple",
    name: "Hindu Temple",
    keywords: [
      "religion"
    ],
    skins: [
      {
        unified: "1f6d5",
        native: "🛕"
      }
    ],
    version: 12
  },
  synagogue: {
    id: "synagogue",
    name: "Synagogue",
    keywords: [
      "judaism",
      "worship",
      "temple",
      "jewish"
    ],
    skins: [
      {
        unified: "1f54d",
        native: "🕍"
      }
    ],
    version: 1
  },
  shinto_shrine: {
    id: "shinto_shrine",
    name: "Shinto Shrine",
    keywords: [
      "temple",
      "japan",
      "kyoto"
    ],
    skins: [
      {
        unified: "26e9-fe0f",
        native: "⛩️"
      }
    ],
    version: 1
  },
  kaaba: {
    id: "kaaba",
    name: "Kaaba",
    keywords: [
      "mecca",
      "mosque",
      "islam"
    ],
    skins: [
      {
        unified: "1f54b",
        native: "🕋"
      }
    ],
    version: 1
  },
  fountain: {
    id: "fountain",
    name: "Fountain",
    keywords: [
      "photo",
      "summer",
      "water",
      "fresh"
    ],
    skins: [
      {
        unified: "26f2",
        native: "⛲"
      }
    ],
    version: 1
  },
  tent: {
    id: "tent",
    name: "Tent",
    keywords: [
      "photo",
      "camping",
      "outdoors"
    ],
    skins: [
      {
        unified: "26fa",
        native: "⛺"
      }
    ],
    version: 1
  },
  foggy: {
    id: "foggy",
    name: "Foggy",
    keywords: [
      "photo",
      "mountain"
    ],
    skins: [
      {
        unified: "1f301",
        native: "🌁"
      }
    ],
    version: 1
  },
  night_with_stars: {
    id: "night_with_stars",
    name: "Night with Stars",
    keywords: [
      "evening",
      "city",
      "downtown"
    ],
    skins: [
      {
        unified: "1f303",
        native: "🌃"
      }
    ],
    version: 1
  },
  cityscape: {
    id: "cityscape",
    name: "Cityscape",
    keywords: [
      "photo",
      "night",
      "life",
      "urban"
    ],
    skins: [
      {
        unified: "1f3d9-fe0f",
        native: "🏙️"
      }
    ],
    version: 1
  },
  sunrise_over_mountains: {
    id: "sunrise_over_mountains",
    name: "Sunrise over Mountains",
    keywords: [
      "view",
      "vacation",
      "photo"
    ],
    skins: [
      {
        unified: "1f304",
        native: "🌄"
      }
    ],
    version: 1
  },
  sunrise: {
    id: "sunrise",
    name: "Sunrise",
    keywords: [
      "morning",
      "view",
      "vacation",
      "photo"
    ],
    skins: [
      {
        unified: "1f305",
        native: "🌅"
      }
    ],
    version: 1
  },
  city_sunset: {
    id: "city_sunset",
    name: "Cityscape at Dusk",
    keywords: [
      "city",
      "sunset",
      "photo",
      "evening",
      "sky",
      "buildings"
    ],
    skins: [
      {
        unified: "1f306",
        native: "🌆"
      }
    ],
    version: 1
  },
  city_sunrise: {
    id: "city_sunrise",
    name: "Sunset",
    keywords: [
      "city",
      "sunrise",
      "photo",
      "good",
      "morning",
      "dawn"
    ],
    skins: [
      {
        unified: "1f307",
        native: "🌇"
      }
    ],
    version: 1
  },
  bridge_at_night: {
    id: "bridge_at_night",
    name: "Bridge at Night",
    keywords: [
      "photo",
      "sanfrancisco"
    ],
    skins: [
      {
        unified: "1f309",
        native: "🌉"
      }
    ],
    version: 1
  },
  hotsprings: {
    id: "hotsprings",
    name: "Hot Springs",
    keywords: [
      "hotsprings",
      "bath",
      "warm",
      "relax"
    ],
    skins: [
      {
        unified: "2668-fe0f",
        native: "♨️"
      }
    ],
    version: 1
  },
  carousel_horse: {
    id: "carousel_horse",
    name: "Carousel Horse",
    keywords: [
      "photo",
      "carnival"
    ],
    skins: [
      {
        unified: "1f3a0",
        native: "🎠"
      }
    ],
    version: 1
  },
  playground_slide: {
    id: "playground_slide",
    name: "Playground Slide",
    keywords: [
      "fun",
      "park"
    ],
    skins: [
      {
        unified: "1f6dd",
        native: "🛝"
      }
    ],
    version: 14
  },
  ferris_wheel: {
    id: "ferris_wheel",
    name: "Ferris Wheel",
    keywords: [
      "photo",
      "carnival",
      "londoneye"
    ],
    skins: [
      {
        unified: "1f3a1",
        native: "🎡"
      }
    ],
    version: 1
  },
  roller_coaster: {
    id: "roller_coaster",
    name: "Roller Coaster",
    keywords: [
      "carnival",
      "playground",
      "photo",
      "fun"
    ],
    skins: [
      {
        unified: "1f3a2",
        native: "🎢"
      }
    ],
    version: 1
  },
  barber: {
    id: "barber",
    name: "Barber Pole",
    keywords: [
      "hair",
      "salon",
      "style"
    ],
    skins: [
      {
        unified: "1f488",
        native: "💈"
      }
    ],
    version: 1
  },
  circus_tent: {
    id: "circus_tent",
    name: "Circus Tent",
    keywords: [
      "festival",
      "carnival",
      "party"
    ],
    skins: [
      {
        unified: "1f3aa",
        native: "🎪"
      }
    ],
    version: 1
  },
  steam_locomotive: {
    id: "steam_locomotive",
    name: "Locomotive",
    keywords: [
      "steam",
      "transportation",
      "vehicle",
      "train"
    ],
    skins: [
      {
        unified: "1f682",
        native: "🚂"
      }
    ],
    version: 1
  },
  railway_car: {
    id: "railway_car",
    name: "Railway Car",
    keywords: [
      "transportation",
      "vehicle"
    ],
    skins: [
      {
        unified: "1f683",
        native: "🚃"
      }
    ],
    version: 1
  },
  bullettrain_side: {
    id: "bullettrain_side",
    name: "High-Speed Train",
    keywords: [
      "bullettrain",
      "side",
      "high",
      "speed",
      "transportation",
      "vehicle"
    ],
    skins: [
      {
        unified: "1f684",
        native: "🚄"
      }
    ],
    version: 1
  },
  bullettrain_front: {
    id: "bullettrain_front",
    name: "Bullet Train",
    keywords: [
      "bullettrain",
      "front",
      "transportation",
      "vehicle",
      "speed",
      "fast",
      "public",
      "travel"
    ],
    skins: [
      {
        unified: "1f685",
        native: "🚅"
      }
    ],
    version: 1
  },
  train2: {
    id: "train2",
    name: "Train",
    keywords: [
      "train2",
      "transportation",
      "vehicle"
    ],
    skins: [
      {
        unified: "1f686",
        native: "🚆"
      }
    ],
    version: 1
  },
  metro: {
    id: "metro",
    name: "Metro",
    keywords: [
      "transportation",
      "blue",
      "square",
      "mrt",
      "underground",
      "tube"
    ],
    skins: [
      {
        unified: "1f687",
        native: "🚇"
      }
    ],
    version: 1
  },
  light_rail: {
    id: "light_rail",
    name: "Light Rail",
    keywords: [
      "transportation",
      "vehicle"
    ],
    skins: [
      {
        unified: "1f688",
        native: "🚈"
      }
    ],
    version: 1
  },
  station: {
    id: "station",
    name: "Station",
    keywords: [
      "transportation",
      "vehicle",
      "public"
    ],
    skins: [
      {
        unified: "1f689",
        native: "🚉"
      }
    ],
    version: 1
  },
  tram: {
    id: "tram",
    name: "Tram",
    keywords: [
      "transportation",
      "vehicle"
    ],
    skins: [
      {
        unified: "1f68a",
        native: "🚊"
      }
    ],
    version: 1
  },
  monorail: {
    id: "monorail",
    name: "Monorail",
    keywords: [
      "transportation",
      "vehicle"
    ],
    skins: [
      {
        unified: "1f69d",
        native: "🚝"
      }
    ],
    version: 1
  },
  mountain_railway: {
    id: "mountain_railway",
    name: "Mountain Railway",
    keywords: [
      "transportation",
      "vehicle"
    ],
    skins: [
      {
        unified: "1f69e",
        native: "🚞"
      }
    ],
    version: 1
  },
  train: {
    id: "train",
    name: "Tram Car",
    keywords: [
      "train",
      "transportation",
      "vehicle",
      "carriage",
      "public",
      "travel"
    ],
    skins: [
      {
        unified: "1f68b",
        native: "🚋"
      }
    ],
    version: 1
  },
  bus: {
    id: "bus",
    name: "Bus",
    keywords: [
      "car",
      "vehicle",
      "transportation"
    ],
    skins: [
      {
        unified: "1f68c",
        native: "🚌"
      }
    ],
    version: 1
  },
  oncoming_bus: {
    id: "oncoming_bus",
    name: "Oncoming Bus",
    keywords: [
      "vehicle",
      "transportation"
    ],
    skins: [
      {
        unified: "1f68d",
        native: "🚍"
      }
    ],
    version: 1
  },
  trolleybus: {
    id: "trolleybus",
    name: "Trolleybus",
    keywords: [
      "bart",
      "transportation",
      "vehicle"
    ],
    skins: [
      {
        unified: "1f68e",
        native: "🚎"
      }
    ],
    version: 1
  },
  minibus: {
    id: "minibus",
    name: "Minibus",
    keywords: [
      "vehicle",
      "car",
      "transportation"
    ],
    skins: [
      {
        unified: "1f690",
        native: "🚐"
      }
    ],
    version: 1
  },
  ambulance: {
    id: "ambulance",
    name: "Ambulance",
    keywords: [
      "health",
      "911",
      "hospital"
    ],
    skins: [
      {
        unified: "1f691",
        native: "🚑"
      }
    ],
    version: 1
  },
  fire_engine: {
    id: "fire_engine",
    name: "Fire Engine",
    keywords: [
      "transportation",
      "cars",
      "vehicle"
    ],
    skins: [
      {
        unified: "1f692",
        native: "🚒"
      }
    ],
    version: 1
  },
  police_car: {
    id: "police_car",
    name: "Police Car",
    keywords: [
      "vehicle",
      "cars",
      "transportation",
      "law",
      "legal",
      "enforcement"
    ],
    skins: [
      {
        unified: "1f693",
        native: "🚓"
      }
    ],
    version: 1
  },
  oncoming_police_car: {
    id: "oncoming_police_car",
    name: "Oncoming Police Car",
    keywords: [
      "vehicle",
      "law",
      "legal",
      "enforcement",
      "911"
    ],
    skins: [
      {
        unified: "1f694",
        native: "🚔"
      }
    ],
    version: 1
  },
  taxi: {
    id: "taxi",
    name: "Taxi",
    keywords: [
      "uber",
      "vehicle",
      "cars",
      "transportation"
    ],
    skins: [
      {
        unified: "1f695",
        native: "🚕"
      }
    ],
    version: 1
  },
  oncoming_taxi: {
    id: "oncoming_taxi",
    name: "Oncoming Taxi",
    keywords: [
      "vehicle",
      "cars",
      "uber"
    ],
    skins: [
      {
        unified: "1f696",
        native: "🚖"
      }
    ],
    version: 1
  },
  car: {
    id: "car",
    name: "Automobile",
    keywords: [
      "car",
      "red",
      "transportation",
      "vehicle"
    ],
    skins: [
      {
        unified: "1f697",
        native: "🚗"
      }
    ],
    version: 1
  },
  oncoming_automobile: {
    id: "oncoming_automobile",
    name: "Oncoming Automobile",
    keywords: [
      "car",
      "vehicle",
      "transportation"
    ],
    skins: [
      {
        unified: "1f698",
        native: "🚘"
      }
    ],
    version: 1
  },
  blue_car: {
    id: "blue_car",
    name: "Recreational Vehicle",
    keywords: [
      "blue",
      "car",
      "sport",
      "utility",
      "transportation"
    ],
    skins: [
      {
        unified: "1f699",
        native: "🚙"
      }
    ],
    version: 1
  },
  pickup_truck: {
    id: "pickup_truck",
    name: "Pickup Truck",
    keywords: [
      "car",
      "transportation"
    ],
    skins: [
      {
        unified: "1f6fb",
        native: "🛻"
      }
    ],
    version: 13
  },
  truck: {
    id: "truck",
    name: "Delivery Truck",
    keywords: [
      "cars",
      "transportation"
    ],
    skins: [
      {
        unified: "1f69a",
        native: "🚚"
      }
    ],
    version: 1
  },
  articulated_lorry: {
    id: "articulated_lorry",
    name: "Articulated Lorry",
    keywords: [
      "vehicle",
      "cars",
      "transportation",
      "express"
    ],
    skins: [
      {
        unified: "1f69b",
        native: "🚛"
      }
    ],
    version: 1
  },
  tractor: {
    id: "tractor",
    name: "Tractor",
    keywords: [
      "vehicle",
      "car",
      "farming",
      "agriculture"
    ],
    skins: [
      {
        unified: "1f69c",
        native: "🚜"
      }
    ],
    version: 1
  },
  racing_car: {
    id: "racing_car",
    name: "Racing Car",
    keywords: [
      "sports",
      "race",
      "fast",
      "formula",
      "f1"
    ],
    skins: [
      {
        unified: "1f3ce-fe0f",
        native: "🏎️"
      }
    ],
    version: 1
  },
  racing_motorcycle: {
    id: "racing_motorcycle",
    name: "Motorcycle",
    keywords: [
      "racing",
      "race",
      "sports",
      "fast"
    ],
    skins: [
      {
        unified: "1f3cd-fe0f",
        native: "🏍️"
      }
    ],
    version: 1
  },
  motor_scooter: {
    id: "motor_scooter",
    name: "Motor Scooter",
    keywords: [
      "vehicle",
      "vespa",
      "sasha"
    ],
    skins: [
      {
        unified: "1f6f5",
        native: "🛵"
      }
    ],
    version: 3
  },
  manual_wheelchair: {
    id: "manual_wheelchair",
    name: "Manual Wheelchair",
    keywords: [
      "accessibility"
    ],
    skins: [
      {
        unified: "1f9bd",
        native: "🦽"
      }
    ],
    version: 12
  },
  motorized_wheelchair: {
    id: "motorized_wheelchair",
    name: "Motorized Wheelchair",
    keywords: [
      "accessibility"
    ],
    skins: [
      {
        unified: "1f9bc",
        native: "🦼"
      }
    ],
    version: 12
  },
  auto_rickshaw: {
    id: "auto_rickshaw",
    name: "Auto Rickshaw",
    keywords: [
      "move",
      "transportation"
    ],
    skins: [
      {
        unified: "1f6fa",
        native: "🛺"
      }
    ],
    version: 12
  },
  bike: {
    id: "bike",
    name: "Bicycle",
    keywords: [
      "bike",
      "sports",
      "exercise",
      "hipster"
    ],
    skins: [
      {
        unified: "1f6b2",
        native: "🚲"
      }
    ],
    version: 1
  },
  scooter: {
    id: "scooter",
    name: "Scooter",
    keywords: [
      "kick",
      "vehicle",
      "razor"
    ],
    skins: [
      {
        unified: "1f6f4",
        native: "🛴"
      }
    ],
    version: 3
  },
  skateboard: {
    id: "skateboard",
    name: "Skateboard",
    keywords: [
      "board"
    ],
    skins: [
      {
        unified: "1f6f9",
        native: "🛹"
      }
    ],
    version: 11
  },
  roller_skate: {
    id: "roller_skate",
    name: "Roller Skate",
    keywords: [
      "footwear",
      "sports"
    ],
    skins: [
      {
        unified: "1f6fc",
        native: "🛼"
      }
    ],
    version: 13
  },
  busstop: {
    id: "busstop",
    name: "Bus Stop",
    keywords: [
      "busstop",
      "transportation",
      "wait"
    ],
    skins: [
      {
        unified: "1f68f",
        native: "🚏"
      }
    ],
    version: 1
  },
  motorway: {
    id: "motorway",
    name: "Motorway",
    keywords: [
      "road",
      "cupertino",
      "interstate",
      "highway"
    ],
    skins: [
      {
        unified: "1f6e3-fe0f",
        native: "🛣️"
      }
    ],
    version: 1
  },
  railway_track: {
    id: "railway_track",
    name: "Railway Track",
    keywords: [
      "train",
      "transportation"
    ],
    skins: [
      {
        unified: "1f6e4-fe0f",
        native: "🛤️"
      }
    ],
    version: 1
  },
  oil_drum: {
    id: "oil_drum",
    name: "Oil Drum",
    keywords: [
      "barrell"
    ],
    skins: [
      {
        unified: "1f6e2-fe0f",
        native: "🛢️"
      }
    ],
    version: 1
  },
  fuelpump: {
    id: "fuelpump",
    name: "Fuel Pump",
    keywords: [
      "fuelpump",
      "gas",
      "station",
      "petroleum"
    ],
    skins: [
      {
        unified: "26fd",
        native: "⛽"
      }
    ],
    version: 1
  },
  wheel: {
    id: "wheel",
    name: "Wheel",
    keywords: [
      "car",
      "transport"
    ],
    skins: [
      {
        unified: "1f6de",
        native: "🛞"
      }
    ],
    version: 14
  },
  rotating_light: {
    id: "rotating_light",
    name: "Police Car Light",
    keywords: [
      "rotating",
      "ambulance",
      "911",
      "emergency",
      "alert",
      "error",
      "pinged",
      "law",
      "legal"
    ],
    skins: [
      {
        unified: "1f6a8",
        native: "🚨"
      }
    ],
    version: 1
  },
  traffic_light: {
    id: "traffic_light",
    name: "Horizontal Traffic Light",
    keywords: [
      "transportation",
      "signal"
    ],
    skins: [
      {
        unified: "1f6a5",
        native: "🚥"
      }
    ],
    version: 1
  },
  vertical_traffic_light: {
    id: "vertical_traffic_light",
    name: "Vertical Traffic Light",
    keywords: [
      "transportation",
      "driving"
    ],
    skins: [
      {
        unified: "1f6a6",
        native: "🚦"
      }
    ],
    version: 1
  },
  octagonal_sign: {
    id: "octagonal_sign",
    name: "Stop Sign",
    keywords: [
      "octagonal"
    ],
    skins: [
      {
        unified: "1f6d1",
        native: "🛑"
      }
    ],
    version: 3
  },
  construction: {
    id: "construction",
    name: "Construction",
    keywords: [
      "wip",
      "progress",
      "caution",
      "warning"
    ],
    skins: [
      {
        unified: "1f6a7",
        native: "🚧"
      }
    ],
    version: 1
  },
  anchor: {
    id: "anchor",
    name: "Anchor",
    keywords: [
      "ship",
      "ferry",
      "sea",
      "boat"
    ],
    skins: [
      {
        unified: "2693",
        native: "⚓"
      }
    ],
    version: 1
  },
  ring_buoy: {
    id: "ring_buoy",
    name: "Ring Buoy",
    keywords: [
      "life",
      "saver",
      "preserver"
    ],
    skins: [
      {
        unified: "1f6df",
        native: "🛟"
      }
    ],
    version: 14
  },
  boat: {
    id: "boat",
    name: "Sailboat",
    keywords: [
      "boat",
      "ship",
      "summer",
      "transportation",
      "water",
      "sailing"
    ],
    skins: [
      {
        unified: "26f5",
        native: "⛵"
      }
    ],
    version: 1
  },
  canoe: {
    id: "canoe",
    name: "Canoe",
    keywords: [
      "boat",
      "paddle",
      "water",
      "ship"
    ],
    skins: [
      {
        unified: "1f6f6",
        native: "🛶"
      }
    ],
    version: 3
  },
  speedboat: {
    id: "speedboat",
    name: "Speedboat",
    keywords: [
      "ship",
      "transportation",
      "vehicle",
      "summer"
    ],
    skins: [
      {
        unified: "1f6a4",
        native: "🚤"
      }
    ],
    version: 1
  },
  passenger_ship: {
    id: "passenger_ship",
    name: "Passenger Ship",
    keywords: [
      "yacht",
      "cruise",
      "ferry"
    ],
    skins: [
      {
        unified: "1f6f3-fe0f",
        native: "🛳️"
      }
    ],
    version: 1
  },
  ferry: {
    id: "ferry",
    name: "Ferry",
    keywords: [
      "boat",
      "ship",
      "yacht"
    ],
    skins: [
      {
        unified: "26f4-fe0f",
        native: "⛴️"
      }
    ],
    version: 1
  },
  motor_boat: {
    id: "motor_boat",
    name: "Motor Boat",
    keywords: [
      "ship"
    ],
    skins: [
      {
        unified: "1f6e5-fe0f",
        native: "🛥️"
      }
    ],
    version: 1
  },
  ship: {
    id: "ship",
    name: "Ship",
    keywords: [
      "transportation",
      "titanic",
      "deploy"
    ],
    skins: [
      {
        unified: "1f6a2",
        native: "🚢"
      }
    ],
    version: 1
  },
  airplane: {
    id: "airplane",
    name: "Airplane",
    keywords: [
      "vehicle",
      "transportation",
      "flight",
      "fly"
    ],
    skins: [
      {
        unified: "2708-fe0f",
        native: "✈️"
      }
    ],
    version: 1
  },
  small_airplane: {
    id: "small_airplane",
    name: "Small Airplane",
    keywords: [
      "flight",
      "transportation",
      "fly",
      "vehicle"
    ],
    skins: [
      {
        unified: "1f6e9-fe0f",
        native: "🛩️"
      }
    ],
    version: 1
  },
  airplane_departure: {
    id: "airplane_departure",
    name: "Airplane Departure",
    keywords: [
      "airport",
      "flight",
      "landing"
    ],
    skins: [
      {
        unified: "1f6eb",
        native: "🛫"
      }
    ],
    version: 1
  },
  airplane_arriving: {
    id: "airplane_arriving",
    name: "Airplane Arrival",
    keywords: [
      "arriving",
      "airport",
      "flight",
      "boarding"
    ],
    skins: [
      {
        unified: "1f6ec",
        native: "🛬"
      }
    ],
    version: 1
  },
  parachute: {
    id: "parachute",
    name: "Parachute",
    keywords: [
      "fly",
      "glide"
    ],
    skins: [
      {
        unified: "1fa82",
        native: "🪂"
      }
    ],
    version: 12
  },
  seat: {
    id: "seat",
    name: "Seat",
    keywords: [
      "sit",
      "airplane",
      "transport",
      "bus",
      "flight",
      "fly"
    ],
    skins: [
      {
        unified: "1f4ba",
        native: "💺"
      }
    ],
    version: 1
  },
  helicopter: {
    id: "helicopter",
    name: "Helicopter",
    keywords: [
      "transportation",
      "vehicle",
      "fly"
    ],
    skins: [
      {
        unified: "1f681",
        native: "🚁"
      }
    ],
    version: 1
  },
  suspension_railway: {
    id: "suspension_railway",
    name: "Suspension Railway",
    keywords: [
      "vehicle",
      "transportation"
    ],
    skins: [
      {
        unified: "1f69f",
        native: "🚟"
      }
    ],
    version: 1
  },
  mountain_cableway: {
    id: "mountain_cableway",
    name: "Mountain Cableway",
    keywords: [
      "transportation",
      "vehicle",
      "ski"
    ],
    skins: [
      {
        unified: "1f6a0",
        native: "🚠"
      }
    ],
    version: 1
  },
  aerial_tramway: {
    id: "aerial_tramway",
    name: "Aerial Tramway",
    keywords: [
      "transportation",
      "vehicle",
      "ski"
    ],
    skins: [
      {
        unified: "1f6a1",
        native: "🚡"
      }
    ],
    version: 1
  },
  satellite: {
    id: "satellite",
    name: "Satellite",
    keywords: [
      "communication",
      "gps",
      "orbit",
      "spaceflight",
      "NASA",
      "ISS"
    ],
    skins: [
      {
        unified: "1f6f0-fe0f",
        native: "🛰️"
      }
    ],
    version: 1
  },
  rocket: {
    id: "rocket",
    name: "Rocket",
    keywords: [
      "launch",
      "ship",
      "staffmode",
      "NASA",
      "outer",
      "space",
      "fly"
    ],
    skins: [
      {
        unified: "1f680",
        native: "🚀"
      }
    ],
    version: 1
  },
  flying_saucer: {
    id: "flying_saucer",
    name: "Flying Saucer",
    keywords: [
      "transportation",
      "vehicle",
      "ufo"
    ],
    skins: [
      {
        unified: "1f6f8",
        native: "🛸"
      }
    ],
    version: 5
  },
  bellhop_bell: {
    id: "bellhop_bell",
    name: "Bellhop Bell",
    keywords: [
      "service"
    ],
    skins: [
      {
        unified: "1f6ce-fe0f",
        native: "🛎️"
      }
    ],
    version: 1
  },
  luggage: {
    id: "luggage",
    name: "Luggage",
    keywords: [
      "packing",
      "travel"
    ],
    skins: [
      {
        unified: "1f9f3",
        native: "🧳"
      }
    ],
    version: 11
  },
  hourglass: {
    id: "hourglass",
    name: "Hourglass",
    keywords: [
      "done",
      "time",
      "clock",
      "oldschool",
      "limit",
      "exam",
      "quiz",
      "test"
    ],
    skins: [
      {
        unified: "231b",
        native: "⌛"
      }
    ],
    version: 1
  },
  hourglass_flowing_sand: {
    id: "hourglass_flowing_sand",
    name: "Hourglass Not Done",
    keywords: [
      "flowing",
      "sand",
      "oldschool",
      "time",
      "countdown"
    ],
    skins: [
      {
        unified: "23f3",
        native: "⏳"
      }
    ],
    version: 1
  },
  watch: {
    id: "watch",
    name: "Watch",
    keywords: [
      "time",
      "accessories"
    ],
    skins: [
      {
        unified: "231a",
        native: "⌚"
      }
    ],
    version: 1
  },
  alarm_clock: {
    id: "alarm_clock",
    name: "Alarm Clock",
    keywords: [
      "time",
      "wake"
    ],
    skins: [
      {
        unified: "23f0",
        native: "⏰"
      }
    ],
    version: 1
  },
  stopwatch: {
    id: "stopwatch",
    name: "Stopwatch",
    keywords: [
      "time",
      "deadline"
    ],
    skins: [
      {
        unified: "23f1-fe0f",
        native: "⏱️"
      }
    ],
    version: 1
  },
  timer_clock: {
    id: "timer_clock",
    name: "Timer Clock",
    keywords: [
      "alarm"
    ],
    skins: [
      {
        unified: "23f2-fe0f",
        native: "⏲️"
      }
    ],
    version: 1
  },
  mantelpiece_clock: {
    id: "mantelpiece_clock",
    name: "Mantelpiece Clock",
    keywords: [
      "time"
    ],
    skins: [
      {
        unified: "1f570-fe0f",
        native: "🕰️"
      }
    ],
    version: 1
  },
  clock12: {
    id: "clock12",
    name: "Twelve O’clock",
    keywords: [
      "clock12",
      "o",
      "clock",
      "12",
      "00:00",
      "0000",
      "12:00",
      "1200",
      "time",
      "noon",
      "midnight",
      "midday",
      "late",
      "early",
      "schedule"
    ],
    skins: [
      {
        unified: "1f55b",
        native: "🕛"
      }
    ],
    version: 1
  },
  clock1230: {
    id: "clock1230",
    name: "Twelve-Thirty",
    keywords: [
      "clock1230",
      "twelve",
      "thirty",
      "00:30",
      "0030",
      "12:30",
      "1230",
      "time",
      "late",
      "early",
      "schedule"
    ],
    skins: [
      {
        unified: "1f567",
        native: "🕧"
      }
    ],
    version: 1
  },
  clock1: {
    id: "clock1",
    name: "One O’clock",
    keywords: [
      "clock1",
      "o",
      "clock",
      "1",
      "1:00",
      "100",
      "13:00",
      "1300",
      "time",
      "late",
      "early",
      "schedule"
    ],
    skins: [
      {
        unified: "1f550",
        native: "🕐"
      }
    ],
    version: 1
  },
  clock130: {
    id: "clock130",
    name: "One-Thirty",
    keywords: [
      "clock130",
      "one",
      "thirty",
      "1:30",
      "130",
      "13:30",
      "1330",
      "time",
      "late",
      "early",
      "schedule"
    ],
    skins: [
      {
        unified: "1f55c",
        native: "🕜"
      }
    ],
    version: 1
  },
  clock2: {
    id: "clock2",
    name: "Two O’clock",
    keywords: [
      "clock2",
      "o",
      "clock",
      "2",
      "2:00",
      "200",
      "14:00",
      "1400",
      "time",
      "late",
      "early",
      "schedule"
    ],
    skins: [
      {
        unified: "1f551",
        native: "🕑"
      }
    ],
    version: 1
  },
  clock230: {
    id: "clock230",
    name: "Two-Thirty",
    keywords: [
      "clock230",
      "two",
      "thirty",
      "2:30",
      "230",
      "14:30",
      "1430",
      "time",
      "late",
      "early",
      "schedule"
    ],
    skins: [
      {
        unified: "1f55d",
        native: "🕝"
      }
    ],
    version: 1
  },
  clock3: {
    id: "clock3",
    name: "Three O’clock",
    keywords: [
      "clock3",
      "o",
      "clock",
      "3",
      "3:00",
      "300",
      "15:00",
      "1500",
      "time",
      "late",
      "early",
      "schedule"
    ],
    skins: [
      {
        unified: "1f552",
        native: "🕒"
      }
    ],
    version: 1
  },
  clock330: {
    id: "clock330",
    name: "Three-Thirty",
    keywords: [
      "clock330",
      "three",
      "thirty",
      "3:30",
      "330",
      "15:30",
      "1530",
      "time",
      "late",
      "early",
      "schedule"
    ],
    skins: [
      {
        unified: "1f55e",
        native: "🕞"
      }
    ],
    version: 1
  },
  clock4: {
    id: "clock4",
    name: "Four O’clock",
    keywords: [
      "clock4",
      "o",
      "clock",
      "4",
      "4:00",
      "400",
      "16:00",
      "1600",
      "time",
      "late",
      "early",
      "schedule"
    ],
    skins: [
      {
        unified: "1f553",
        native: "🕓"
      }
    ],
    version: 1
  },
  clock430: {
    id: "clock430",
    name: "Four-Thirty",
    keywords: [
      "clock430",
      "four",
      "thirty",
      "4:30",
      "430",
      "16:30",
      "1630",
      "time",
      "late",
      "early",
      "schedule"
    ],
    skins: [
      {
        unified: "1f55f",
        native: "🕟"
      }
    ],
    version: 1
  },
  clock5: {
    id: "clock5",
    name: "Five O’clock",
    keywords: [
      "clock5",
      "o",
      "clock",
      "5",
      "5:00",
      "500",
      "17:00",
      "1700",
      "time",
      "late",
      "early",
      "schedule"
    ],
    skins: [
      {
        unified: "1f554",
        native: "🕔"
      }
    ],
    version: 1
  },
  clock530: {
    id: "clock530",
    name: "Five-Thirty",
    keywords: [
      "clock530",
      "five",
      "thirty",
      "5:30",
      "530",
      "17:30",
      "1730",
      "time",
      "late",
      "early",
      "schedule"
    ],
    skins: [
      {
        unified: "1f560",
        native: "🕠"
      }
    ],
    version: 1
  },
  clock6: {
    id: "clock6",
    name: "Six O’clock",
    keywords: [
      "clock6",
      "o",
      "clock",
      "6",
      "6:00",
      "600",
      "18:00",
      "1800",
      "time",
      "late",
      "early",
      "schedule",
      "dawn",
      "dusk"
    ],
    skins: [
      {
        unified: "1f555",
        native: "🕕"
      }
    ],
    version: 1
  },
  clock630: {
    id: "clock630",
    name: "Six-Thirty",
    keywords: [
      "clock630",
      "six",
      "thirty",
      "6:30",
      "630",
      "18:30",
      "1830",
      "time",
      "late",
      "early",
      "schedule"
    ],
    skins: [
      {
        unified: "1f561",
        native: "🕡"
      }
    ],
    version: 1
  },
  clock7: {
    id: "clock7",
    name: "Seven O’clock",
    keywords: [
      "clock7",
      "o",
      "clock",
      "7",
      "7:00",
      "700",
      "19:00",
      "1900",
      "time",
      "late",
      "early",
      "schedule"
    ],
    skins: [
      {
        unified: "1f556",
        native: "🕖"
      }
    ],
    version: 1
  },
  clock730: {
    id: "clock730",
    name: "Seven-Thirty",
    keywords: [
      "clock730",
      "seven",
      "thirty",
      "7:30",
      "730",
      "19:30",
      "1930",
      "time",
      "late",
      "early",
      "schedule"
    ],
    skins: [
      {
        unified: "1f562",
        native: "🕢"
      }
    ],
    version: 1
  },
  clock8: {
    id: "clock8",
    name: "Eight O’clock",
    keywords: [
      "clock8",
      "o",
      "clock",
      "8",
      "8:00",
      "800",
      "20:00",
      "2000",
      "time",
      "late",
      "early",
      "schedule"
    ],
    skins: [
      {
        unified: "1f557",
        native: "🕗"
      }
    ],
    version: 1
  },
  clock830: {
    id: "clock830",
    name: "Eight-Thirty",
    keywords: [
      "clock830",
      "eight",
      "thirty",
      "8:30",
      "830",
      "20:30",
      "2030",
      "time",
      "late",
      "early",
      "schedule"
    ],
    skins: [
      {
        unified: "1f563",
        native: "🕣"
      }
    ],
    version: 1
  },
  clock9: {
    id: "clock9",
    name: "Nine O’clock",
    keywords: [
      "clock9",
      "o",
      "clock",
      "9",
      "9:00",
      "900",
      "21:00",
      "2100",
      "time",
      "late",
      "early",
      "schedule"
    ],
    skins: [
      {
        unified: "1f558",
        native: "🕘"
      }
    ],
    version: 1
  },
  clock930: {
    id: "clock930",
    name: "Nine-Thirty",
    keywords: [
      "clock930",
      "nine",
      "thirty",
      "9:30",
      "930",
      "21:30",
      "2130",
      "time",
      "late",
      "early",
      "schedule"
    ],
    skins: [
      {
        unified: "1f564",
        native: "🕤"
      }
    ],
    version: 1
  },
  clock10: {
    id: "clock10",
    name: "Ten O’clock",
    keywords: [
      "clock10",
      "o",
      "clock",
      "10",
      "10:00",
      "1000",
      "22:00",
      "2200",
      "time",
      "late",
      "early",
      "schedule"
    ],
    skins: [
      {
        unified: "1f559",
        native: "🕙"
      }
    ],
    version: 1
  },
  clock1030: {
    id: "clock1030",
    name: "Ten-Thirty",
    keywords: [
      "clock1030",
      "ten",
      "thirty",
      "10:30",
      "1030",
      "22:30",
      "2230",
      "time",
      "late",
      "early",
      "schedule"
    ],
    skins: [
      {
        unified: "1f565",
        native: "🕥"
      }
    ],
    version: 1
  },
  clock11: {
    id: "clock11",
    name: "Eleven O’clock",
    keywords: [
      "clock11",
      "o",
      "clock",
      "11",
      "11:00",
      "1100",
      "23:00",
      "2300",
      "time",
      "late",
      "early",
      "schedule"
    ],
    skins: [
      {
        unified: "1f55a",
        native: "🕚"
      }
    ],
    version: 1
  },
  clock1130: {
    id: "clock1130",
    name: "Eleven-Thirty",
    keywords: [
      "clock1130",
      "eleven",
      "thirty",
      "11:30",
      "1130",
      "23:30",
      "2330",
      "time",
      "late",
      "early",
      "schedule"
    ],
    skins: [
      {
        unified: "1f566",
        native: "🕦"
      }
    ],
    version: 1
  },
  new_moon: {
    id: "new_moon",
    name: "New Moon",
    keywords: [
      "nature",
      "twilight",
      "planet",
      "space",
      "night",
      "evening",
      "sleep"
    ],
    skins: [
      {
        unified: "1f311",
        native: "🌑"
      }
    ],
    version: 1
  },
  waxing_crescent_moon: {
    id: "waxing_crescent_moon",
    name: "Waxing Crescent Moon",
    keywords: [
      "nature",
      "twilight",
      "planet",
      "space",
      "night",
      "evening",
      "sleep"
    ],
    skins: [
      {
        unified: "1f312",
        native: "🌒"
      }
    ],
    version: 1
  },
  first_quarter_moon: {
    id: "first_quarter_moon",
    name: "First Quarter Moon",
    keywords: [
      "nature",
      "twilight",
      "planet",
      "space",
      "night",
      "evening",
      "sleep"
    ],
    skins: [
      {
        unified: "1f313",
        native: "🌓"
      }
    ],
    version: 1
  },
  moon: {
    id: "moon",
    name: "Waxing Gibbous Moon",
    keywords: [
      "nature",
      "night",
      "sky",
      "gray",
      "twilight",
      "planet",
      "space",
      "evening",
      "sleep"
    ],
    skins: [
      {
        unified: "1f314",
        native: "🌔"
      }
    ],
    version: 1
  },
  full_moon: {
    id: "full_moon",
    name: "Full Moon",
    keywords: [
      "nature",
      "yellow",
      "twilight",
      "planet",
      "space",
      "night",
      "evening",
      "sleep"
    ],
    skins: [
      {
        unified: "1f315",
        native: "🌕"
      }
    ],
    version: 1
  },
  waning_gibbous_moon: {
    id: "waning_gibbous_moon",
    name: "Waning Gibbous Moon",
    keywords: [
      "nature",
      "twilight",
      "planet",
      "space",
      "night",
      "evening",
      "sleep",
      "waxing"
    ],
    skins: [
      {
        unified: "1f316",
        native: "🌖"
      }
    ],
    version: 1
  },
  last_quarter_moon: {
    id: "last_quarter_moon",
    name: "Last Quarter Moon",
    keywords: [
      "nature",
      "twilight",
      "planet",
      "space",
      "night",
      "evening",
      "sleep"
    ],
    skins: [
      {
        unified: "1f317",
        native: "🌗"
      }
    ],
    version: 1
  },
  waning_crescent_moon: {
    id: "waning_crescent_moon",
    name: "Waning Crescent Moon",
    keywords: [
      "nature",
      "twilight",
      "planet",
      "space",
      "night",
      "evening",
      "sleep"
    ],
    skins: [
      {
        unified: "1f318",
        native: "🌘"
      }
    ],
    version: 1
  },
  crescent_moon: {
    id: "crescent_moon",
    name: "Crescent Moon",
    keywords: [
      "night",
      "sleep",
      "sky",
      "evening",
      "magic"
    ],
    skins: [
      {
        unified: "1f319",
        native: "🌙"
      }
    ],
    version: 1
  },
  new_moon_with_face: {
    id: "new_moon_with_face",
    name: "New Moon Face",
    keywords: [
      "with",
      "nature",
      "twilight",
      "planet",
      "space",
      "night",
      "evening",
      "sleep"
    ],
    skins: [
      {
        unified: "1f31a",
        native: "🌚"
      }
    ],
    version: 1
  },
  first_quarter_moon_with_face: {
    id: "first_quarter_moon_with_face",
    name: "First Quarter Moon Face",
    keywords: [
      "with",
      "nature",
      "twilight",
      "planet",
      "space",
      "night",
      "evening",
      "sleep"
    ],
    skins: [
      {
        unified: "1f31b",
        native: "🌛"
      }
    ],
    version: 1
  },
  last_quarter_moon_with_face: {
    id: "last_quarter_moon_with_face",
    name: "Last Quarter Moon Face",
    keywords: [
      "with",
      "nature",
      "twilight",
      "planet",
      "space",
      "night",
      "evening",
      "sleep"
    ],
    skins: [
      {
        unified: "1f31c",
        native: "🌜"
      }
    ],
    version: 1
  },
  thermometer: {
    id: "thermometer",
    name: "Thermometer",
    keywords: [
      "weather",
      "temperature",
      "hot",
      "cold"
    ],
    skins: [
      {
        unified: "1f321-fe0f",
        native: "🌡️"
      }
    ],
    version: 1
  },
  sunny: {
    id: "sunny",
    name: "Sun",
    keywords: [
      "sunny",
      "weather",
      "nature",
      "brightness",
      "summer",
      "beach",
      "spring"
    ],
    skins: [
      {
        unified: "2600-fe0f",
        native: "☀️"
      }
    ],
    version: 1
  },
  full_moon_with_face: {
    id: "full_moon_with_face",
    name: "Full Moon Face",
    keywords: [
      "with",
      "nature",
      "twilight",
      "planet",
      "space",
      "night",
      "evening",
      "sleep"
    ],
    skins: [
      {
        unified: "1f31d",
        native: "🌝"
      }
    ],
    version: 1
  },
  sun_with_face: {
    id: "sun_with_face",
    name: "Sun with Face",
    keywords: [
      "nature",
      "morning",
      "sky"
    ],
    skins: [
      {
        unified: "1f31e",
        native: "🌞"
      }
    ],
    version: 1
  },
  ringed_planet: {
    id: "ringed_planet",
    name: "Ringed Planet",
    keywords: [
      "outerspace"
    ],
    skins: [
      {
        unified: "1fa90",
        native: "🪐"
      }
    ],
    version: 12
  },
  star: {
    id: "star",
    name: "Star",
    keywords: [
      "night",
      "yellow"
    ],
    skins: [
      {
        unified: "2b50",
        native: "⭐"
      }
    ],
    version: 1
  },
  star2: {
    id: "star2",
    name: "Glowing Star",
    keywords: [
      "star2",
      "night",
      "sparkle",
      "awesome",
      "good",
      "magic"
    ],
    skins: [
      {
        unified: "1f31f",
        native: "🌟"
      }
    ],
    version: 1
  },
  stars: {
    id: "stars",
    name: "Shooting Star",
    keywords: [
      "stars",
      "night",
      "photo"
    ],
    skins: [
      {
        unified: "1f320",
        native: "🌠"
      }
    ],
    version: 1
  },
  milky_way: {
    id: "milky_way",
    name: "Milky Way",
    keywords: [
      "photo",
      "space",
      "stars"
    ],
    skins: [
      {
        unified: "1f30c",
        native: "🌌"
      }
    ],
    version: 1
  },
  cloud: {
    id: "cloud",
    name: "Cloud",
    keywords: [
      "weather",
      "sky"
    ],
    skins: [
      {
        unified: "2601-fe0f",
        native: "☁️"
      }
    ],
    version: 1
  },
  partly_sunny: {
    id: "partly_sunny",
    name: "Sun Behind Cloud",
    keywords: [
      "partly",
      "sunny",
      "weather",
      "nature",
      "cloudy",
      "morning",
      "fall",
      "spring"
    ],
    skins: [
      {
        unified: "26c5",
        native: "⛅"
      }
    ],
    version: 1
  },
  thunder_cloud_and_rain: {
    id: "thunder_cloud_and_rain",
    name: "Cloud with Lightning and Rain",
    keywords: [
      "thunder",
      "weather"
    ],
    skins: [
      {
        unified: "26c8-fe0f",
        native: "⛈️"
      }
    ],
    version: 1
  },
  mostly_sunny: {
    id: "mostly_sunny",
    name: "Sun Behind Small Cloud",
    keywords: [
      "mostly",
      "sunny",
      "weather"
    ],
    skins: [
      {
        unified: "1f324-fe0f",
        native: "🌤️"
      }
    ],
    version: 1
  },
  barely_sunny: {
    id: "barely_sunny",
    name: "Sun Behind Large Cloud",
    keywords: [
      "barely",
      "sunny",
      "weather"
    ],
    skins: [
      {
        unified: "1f325-fe0f",
        native: "🌥️"
      }
    ],
    version: 1
  },
  partly_sunny_rain: {
    id: "partly_sunny_rain",
    name: "Sun Behind Rain Cloud",
    keywords: [
      "partly",
      "sunny",
      "weather"
    ],
    skins: [
      {
        unified: "1f326-fe0f",
        native: "🌦️"
      }
    ],
    version: 1
  },
  rain_cloud: {
    id: "rain_cloud",
    name: "Cloud with Rain",
    keywords: [
      "weather"
    ],
    skins: [
      {
        unified: "1f327-fe0f",
        native: "🌧️"
      }
    ],
    version: 1
  },
  snow_cloud: {
    id: "snow_cloud",
    name: "Cloud with Snow",
    keywords: [
      "weather"
    ],
    skins: [
      {
        unified: "1f328-fe0f",
        native: "🌨️"
      }
    ],
    version: 1
  },
  lightning: {
    id: "lightning",
    name: "Cloud with Lightning",
    keywords: [
      "weather",
      "thunder"
    ],
    skins: [
      {
        unified: "1f329-fe0f",
        native: "🌩️"
      }
    ],
    version: 1
  },
  tornado: {
    id: "tornado",
    name: "Tornado",
    keywords: [
      "cloud",
      "weather",
      "cyclone",
      "twister"
    ],
    skins: [
      {
        unified: "1f32a-fe0f",
        native: "🌪️"
      }
    ],
    version: 1
  },
  fog: {
    id: "fog",
    name: "Fog",
    keywords: [
      "weather"
    ],
    skins: [
      {
        unified: "1f32b-fe0f",
        native: "🌫️"
      }
    ],
    version: 1
  },
  wind_blowing_face: {
    id: "wind_blowing_face",
    name: "Wind Face",
    keywords: [
      "blowing",
      "gust",
      "air"
    ],
    skins: [
      {
        unified: "1f32c-fe0f",
        native: "🌬️"
      }
    ],
    version: 1
  },
  cyclone: {
    id: "cyclone",
    name: "Cyclone",
    keywords: [
      "weather",
      "swirl",
      "blue",
      "cloud",
      "vortex",
      "spiral",
      "whirlpool",
      "spin",
      "tornado",
      "hurricane",
      "typhoon"
    ],
    skins: [
      {
        unified: "1f300",
        native: "🌀"
      }
    ],
    version: 1
  },
  rainbow: {
    id: "rainbow",
    name: "Rainbow",
    keywords: [
      "nature",
      "happy",
      "unicorn",
      "face",
      "photo",
      "sky",
      "spring"
    ],
    skins: [
      {
        unified: "1f308",
        native: "🌈"
      }
    ],
    version: 1
  },
  closed_umbrella: {
    id: "closed_umbrella",
    name: "Closed Umbrella",
    keywords: [
      "weather",
      "rain",
      "drizzle"
    ],
    skins: [
      {
        unified: "1f302",
        native: "🌂"
      }
    ],
    version: 1
  },
  umbrella: {
    id: "umbrella",
    name: "Umbrella",
    keywords: [
      "weather",
      "spring"
    ],
    skins: [
      {
        unified: "2602-fe0f",
        native: "☂️"
      }
    ],
    version: 1
  },
  umbrella_with_rain_drops: {
    id: "umbrella_with_rain_drops",
    name: "Umbrella with Rain Drops",
    keywords: [
      "rainy",
      "weather",
      "spring"
    ],
    skins: [
      {
        unified: "2614",
        native: "☔"
      }
    ],
    version: 1
  },
  umbrella_on_ground: {
    id: "umbrella_on_ground",
    name: "Umbrella on Ground",
    keywords: [
      "weather",
      "summer"
    ],
    skins: [
      {
        unified: "26f1-fe0f",
        native: "⛱️"
      }
    ],
    version: 1
  },
  zap: {
    id: "zap",
    name: "High Voltage",
    keywords: [
      "zap",
      "thunder",
      "weather",
      "lightning",
      "bolt",
      "fast"
    ],
    skins: [
      {
        unified: "26a1",
        native: "⚡"
      }
    ],
    version: 1
  },
  snowflake: {
    id: "snowflake",
    name: "Snowflake",
    keywords: [
      "winter",
      "season",
      "cold",
      "weather",
      "christmas",
      "xmas"
    ],
    skins: [
      {
        unified: "2744-fe0f",
        native: "❄️"
      }
    ],
    version: 1
  },
  snowman: {
    id: "snowman",
    name: "Snowman",
    keywords: [
      "winter",
      "season",
      "cold",
      "weather",
      "christmas",
      "xmas",
      "frozen"
    ],
    skins: [
      {
        unified: "2603-fe0f",
        native: "☃️"
      }
    ],
    version: 1
  },
  snowman_without_snow: {
    id: "snowman_without_snow",
    name: "Snowman Without Snow",
    keywords: [
      "winter",
      "season",
      "cold",
      "weather",
      "christmas",
      "xmas",
      "frozen"
    ],
    skins: [
      {
        unified: "26c4",
        native: "⛄"
      }
    ],
    version: 1
  },
  comet: {
    id: "comet",
    name: "Comet",
    keywords: [
      "space"
    ],
    skins: [
      {
        unified: "2604-fe0f",
        native: "☄️"
      }
    ],
    version: 1
  },
  fire: {
    id: "fire",
    name: "Fire",
    keywords: [
      "hot",
      "cook",
      "flame"
    ],
    skins: [
      {
        unified: "1f525",
        native: "🔥"
      }
    ],
    version: 1
  },
  droplet: {
    id: "droplet",
    name: "Droplet",
    keywords: [
      "water",
      "drip",
      "faucet",
      "spring"
    ],
    skins: [
      {
        unified: "1f4a7",
        native: "💧"
      }
    ],
    version: 1
  },
  ocean: {
    id: "ocean",
    name: "Water Wave",
    keywords: [
      "ocean",
      "sea",
      "nature",
      "tsunami",
      "disaster"
    ],
    skins: [
      {
        unified: "1f30a",
        native: "🌊"
      }
    ],
    version: 1
  },
  jack_o_lantern: {
    id: "jack_o_lantern",
    name: "Jack-O-Lantern",
    keywords: [
      "jack",
      "o",
      "lantern",
      "halloween",
      "light",
      "pumpkin",
      "creepy",
      "fall"
    ],
    skins: [
      {
        unified: "1f383",
        native: "🎃"
      }
    ],
    version: 1
  },
  christmas_tree: {
    id: "christmas_tree",
    name: "Christmas Tree",
    keywords: [
      "festival",
      "vacation",
      "december",
      "xmas",
      "celebration"
    ],
    skins: [
      {
        unified: "1f384",
        native: "🎄"
      }
    ],
    version: 1
  },
  fireworks: {
    id: "fireworks",
    name: "Fireworks",
    keywords: [
      "photo",
      "festival",
      "carnival",
      "congratulations"
    ],
    skins: [
      {
        unified: "1f386",
        native: "🎆"
      }
    ],
    version: 1
  },
  sparkler: {
    id: "sparkler",
    name: "Sparkler",
    keywords: [
      "stars",
      "night",
      "shine"
    ],
    skins: [
      {
        unified: "1f387",
        native: "🎇"
      }
    ],
    version: 1
  },
  firecracker: {
    id: "firecracker",
    name: "Firecracker",
    keywords: [
      "dynamite",
      "boom",
      "explode",
      "explosion",
      "explosive"
    ],
    skins: [
      {
        unified: "1f9e8",
        native: "🧨"
      }
    ],
    version: 11
  },
  sparkles: {
    id: "sparkles",
    name: "Sparkles",
    keywords: [
      "stars",
      "shine",
      "shiny",
      "cool",
      "awesome",
      "good",
      "magic"
    ],
    skins: [
      {
        unified: "2728",
        native: "✨"
      }
    ],
    version: 1
  },
  balloon: {
    id: "balloon",
    name: "Balloon",
    keywords: [
      "party",
      "celebration",
      "birthday",
      "circus"
    ],
    skins: [
      {
        unified: "1f388",
        native: "🎈"
      }
    ],
    version: 1
  },
  tada: {
    id: "tada",
    name: "Party Popper",
    keywords: [
      "tada",
      "congratulations",
      "birthday",
      "magic",
      "circus",
      "celebration"
    ],
    skins: [
      {
        unified: "1f389",
        native: "🎉"
      }
    ],
    version: 1
  },
  confetti_ball: {
    id: "confetti_ball",
    name: "Confetti Ball",
    keywords: [
      "festival",
      "party",
      "birthday",
      "circus"
    ],
    skins: [
      {
        unified: "1f38a",
        native: "🎊"
      }
    ],
    version: 1
  },
  tanabata_tree: {
    id: "tanabata_tree",
    name: "Tanabata Tree",
    keywords: [
      "plant",
      "nature",
      "branch",
      "summer",
      "bamboo",
      "wish",
      "star",
      "festival",
      "tanzaku"
    ],
    skins: [
      {
        unified: "1f38b",
        native: "🎋"
      }
    ],
    version: 1
  },
  bamboo: {
    id: "bamboo",
    name: "Pine Decoration",
    keywords: [
      "bamboo",
      "japanese",
      "plant",
      "nature",
      "vegetable",
      "panda",
      "new",
      "years"
    ],
    skins: [
      {
        unified: "1f38d",
        native: "🎍"
      }
    ],
    version: 1
  },
  dolls: {
    id: "dolls",
    name: "Japanese Dolls",
    keywords: [
      "toy",
      "kimono"
    ],
    skins: [
      {
        unified: "1f38e",
        native: "🎎"
      }
    ],
    version: 1
  },
  flags: {
    id: "flags",
    name: "Carp Streamer",
    keywords: [
      "flags",
      "fish",
      "japanese",
      "koinobori",
      "banner"
    ],
    skins: [
      {
        unified: "1f38f",
        native: "🎏"
      }
    ],
    version: 1
  },
  wind_chime: {
    id: "wind_chime",
    name: "Wind Chime",
    keywords: [
      "nature",
      "ding",
      "spring",
      "bell"
    ],
    skins: [
      {
        unified: "1f390",
        native: "🎐"
      }
    ],
    version: 1
  },
  rice_scene: {
    id: "rice_scene",
    name: "Moon Viewing Ceremony",
    keywords: [
      "rice",
      "scene",
      "photo",
      "japan",
      "asia",
      "tsukimi"
    ],
    skins: [
      {
        unified: "1f391",
        native: "🎑"
      }
    ],
    version: 1
  },
  red_envelope: {
    id: "red_envelope",
    name: "Red Envelope",
    keywords: [
      "gift"
    ],
    skins: [
      {
        unified: "1f9e7",
        native: "🧧"
      }
    ],
    version: 11
  },
  ribbon: {
    id: "ribbon",
    name: "Ribbon",
    keywords: [
      "decoration",
      "pink",
      "girl",
      "bowtie"
    ],
    skins: [
      {
        unified: "1f380",
        native: "🎀"
      }
    ],
    version: 1
  },
  gift: {
    id: "gift",
    name: "Wrapped Gift",
    keywords: [
      "present",
      "birthday",
      "christmas",
      "xmas"
    ],
    skins: [
      {
        unified: "1f381",
        native: "🎁"
      }
    ],
    version: 1
  },
  reminder_ribbon: {
    id: "reminder_ribbon",
    name: "Reminder Ribbon",
    keywords: [
      "sports",
      "cause",
      "support",
      "awareness"
    ],
    skins: [
      {
        unified: "1f397-fe0f",
        native: "🎗️"
      }
    ],
    version: 1
  },
  admission_tickets: {
    id: "admission_tickets",
    name: "Admission Tickets",
    keywords: [
      "sports",
      "concert",
      "entrance"
    ],
    skins: [
      {
        unified: "1f39f-fe0f",
        native: "🎟️"
      }
    ],
    version: 1
  },
  ticket: {
    id: "ticket",
    name: "Ticket",
    keywords: [
      "event",
      "concert",
      "pass"
    ],
    skins: [
      {
        unified: "1f3ab",
        native: "🎫"
      }
    ],
    version: 1
  },
  medal: {
    id: "medal",
    name: "Military Medal",
    keywords: [
      "award",
      "winning",
      "army"
    ],
    skins: [
      {
        unified: "1f396-fe0f",
        native: "🎖️"
      }
    ],
    version: 1
  },
  trophy: {
    id: "trophy",
    name: "Trophy",
    keywords: [
      "win",
      "award",
      "contest",
      "place",
      "ftw",
      "ceremony"
    ],
    skins: [
      {
        unified: "1f3c6",
        native: "🏆"
      }
    ],
    version: 1
  },
  sports_medal: {
    id: "sports_medal",
    name: "Sports Medal",
    keywords: [
      "award",
      "winning"
    ],
    skins: [
      {
        unified: "1f3c5",
        native: "🏅"
      }
    ],
    version: 1
  },
  first_place_medal: {
    id: "first_place_medal",
    name: "1st Place Medal",
    keywords: [
      "first",
      "award",
      "winning"
    ],
    skins: [
      {
        unified: "1f947",
        native: "🥇"
      }
    ],
    version: 3
  },
  second_place_medal: {
    id: "second_place_medal",
    name: "2nd Place Medal",
    keywords: [
      "second",
      "award"
    ],
    skins: [
      {
        unified: "1f948",
        native: "🥈"
      }
    ],
    version: 3
  },
  third_place_medal: {
    id: "third_place_medal",
    name: "3rd Place Medal",
    keywords: [
      "third",
      "award"
    ],
    skins: [
      {
        unified: "1f949",
        native: "🥉"
      }
    ],
    version: 3
  },
  soccer: {
    id: "soccer",
    name: "Soccer Ball",
    keywords: [
      "sports",
      "football"
    ],
    skins: [
      {
        unified: "26bd",
        native: "⚽"
      }
    ],
    version: 1
  },
  baseball: {
    id: "baseball",
    name: "Baseball",
    keywords: [
      "sports",
      "balls"
    ],
    skins: [
      {
        unified: "26be",
        native: "⚾"
      }
    ],
    version: 1
  },
  softball: {
    id: "softball",
    name: "Softball",
    keywords: [
      "sports",
      "balls"
    ],
    skins: [
      {
        unified: "1f94e",
        native: "🥎"
      }
    ],
    version: 11
  },
  basketball: {
    id: "basketball",
    name: "Basketball",
    keywords: [
      "sports",
      "balls",
      "NBA"
    ],
    skins: [
      {
        unified: "1f3c0",
        native: "🏀"
      }
    ],
    version: 1
  },
  volleyball: {
    id: "volleyball",
    name: "Volleyball",
    keywords: [
      "sports",
      "balls"
    ],
    skins: [
      {
        unified: "1f3d0",
        native: "🏐"
      }
    ],
    version: 1
  },
  football: {
    id: "football",
    name: "American Football",
    keywords: [
      "sports",
      "balls",
      "NFL"
    ],
    skins: [
      {
        unified: "1f3c8",
        native: "🏈"
      }
    ],
    version: 1
  },
  rugby_football: {
    id: "rugby_football",
    name: "Rugby Football",
    keywords: [
      "sports",
      "team"
    ],
    skins: [
      {
        unified: "1f3c9",
        native: "🏉"
      }
    ],
    version: 1
  },
  tennis: {
    id: "tennis",
    name: "Tennis",
    keywords: [
      "sports",
      "balls",
      "green"
    ],
    skins: [
      {
        unified: "1f3be",
        native: "🎾"
      }
    ],
    version: 1
  },
  flying_disc: {
    id: "flying_disc",
    name: "Flying Disc",
    keywords: [
      "sports",
      "frisbee",
      "ultimate"
    ],
    skins: [
      {
        unified: "1f94f",
        native: "🥏"
      }
    ],
    version: 11
  },
  bowling: {
    id: "bowling",
    name: "Bowling",
    keywords: [
      "sports",
      "fun",
      "play"
    ],
    skins: [
      {
        unified: "1f3b3",
        native: "🎳"
      }
    ],
    version: 1
  },
  cricket_bat_and_ball: {
    id: "cricket_bat_and_ball",
    name: "Cricket Game",
    keywords: [
      "bat",
      "and",
      "ball",
      "sports"
    ],
    skins: [
      {
        unified: "1f3cf",
        native: "🏏"
      }
    ],
    version: 1
  },
  field_hockey_stick_and_ball: {
    id: "field_hockey_stick_and_ball",
    name: "Field Hockey",
    keywords: [
      "stick",
      "and",
      "ball",
      "sports"
    ],
    skins: [
      {
        unified: "1f3d1",
        native: "🏑"
      }
    ],
    version: 1
  },
  ice_hockey_stick_and_puck: {
    id: "ice_hockey_stick_and_puck",
    name: "Ice Hockey",
    keywords: [
      "stick",
      "and",
      "puck",
      "sports"
    ],
    skins: [
      {
        unified: "1f3d2",
        native: "🏒"
      }
    ],
    version: 1
  },
  lacrosse: {
    id: "lacrosse",
    name: "Lacrosse",
    keywords: [
      "sports",
      "ball",
      "stick"
    ],
    skins: [
      {
        unified: "1f94d",
        native: "🥍"
      }
    ],
    version: 11
  },
  table_tennis_paddle_and_ball: {
    id: "table_tennis_paddle_and_ball",
    name: "Ping Pong",
    keywords: [
      "table",
      "tennis",
      "paddle",
      "and",
      "ball",
      "sports",
      "pingpong"
    ],
    skins: [
      {
        unified: "1f3d3",
        native: "🏓"
      }
    ],
    version: 1
  },
  badminton_racquet_and_shuttlecock: {
    id: "badminton_racquet_and_shuttlecock",
    name: "Badminton",
    keywords: [
      "racquet",
      "and",
      "shuttlecock",
      "sports"
    ],
    skins: [
      {
        unified: "1f3f8",
        native: "🏸"
      }
    ],
    version: 1
  },
  boxing_glove: {
    id: "boxing_glove",
    name: "Boxing Glove",
    keywords: [
      "sports",
      "fighting"
    ],
    skins: [
      {
        unified: "1f94a",
        native: "🥊"
      }
    ],
    version: 3
  },
  martial_arts_uniform: {
    id: "martial_arts_uniform",
    name: "Martial Arts Uniform",
    keywords: [
      "judo",
      "karate",
      "taekwondo"
    ],
    skins: [
      {
        unified: "1f94b",
        native: "🥋"
      }
    ],
    version: 3
  },
  goal_net: {
    id: "goal_net",
    name: "Goal Net",
    keywords: [
      "sports"
    ],
    skins: [
      {
        unified: "1f945",
        native: "🥅"
      }
    ],
    version: 3
  },
  golf: {
    id: "golf",
    name: "Flag in Hole",
    keywords: [
      "golf",
      "sports",
      "business",
      "summer"
    ],
    skins: [
      {
        unified: "26f3",
        native: "⛳"
      }
    ],
    version: 1
  },
  ice_skate: {
    id: "ice_skate",
    name: "Ice Skate",
    keywords: [
      "sports"
    ],
    skins: [
      {
        unified: "26f8-fe0f",
        native: "⛸️"
      }
    ],
    version: 1
  },
  fishing_pole_and_fish: {
    id: "fishing_pole_and_fish",
    name: "Fishing Pole",
    keywords: [
      "and",
      "fish",
      "food",
      "hobby",
      "summer"
    ],
    skins: [
      {
        unified: "1f3a3",
        native: "🎣"
      }
    ],
    version: 1
  },
  diving_mask: {
    id: "diving_mask",
    name: "Diving Mask",
    keywords: [
      "sport",
      "ocean"
    ],
    skins: [
      {
        unified: "1f93f",
        native: "🤿"
      }
    ],
    version: 12
  },
  running_shirt_with_sash: {
    id: "running_shirt_with_sash",
    name: "Running Shirt",
    keywords: [
      "with",
      "sash",
      "play",
      "pageant"
    ],
    skins: [
      {
        unified: "1f3bd",
        native: "🎽"
      }
    ],
    version: 1
  },
  ski: {
    id: "ski",
    name: "Skis",
    keywords: [
      "ski",
      "sports",
      "winter",
      "cold",
      "snow"
    ],
    skins: [
      {
        unified: "1f3bf",
        native: "🎿"
      }
    ],
    version: 1
  },
  sled: {
    id: "sled",
    name: "Sled",
    keywords: [
      "sleigh",
      "luge",
      "toboggan"
    ],
    skins: [
      {
        unified: "1f6f7",
        native: "🛷"
      }
    ],
    version: 5
  },
  curling_stone: {
    id: "curling_stone",
    name: "Curling Stone",
    keywords: [
      "sports"
    ],
    skins: [
      {
        unified: "1f94c",
        native: "🥌"
      }
    ],
    version: 5
  },
  dart: {
    id: "dart",
    name: "Bullseye",
    keywords: [
      "dart",
      "direct",
      "hit",
      "game",
      "play",
      "bar",
      "target"
    ],
    skins: [
      {
        unified: "1f3af",
        native: "🎯"
      }
    ],
    version: 1
  },
  "yo-yo": {
    id: "yo-yo",
    name: "Yo-Yo",
    keywords: [
      "yo",
      "toy"
    ],
    skins: [
      {
        unified: "1fa80",
        native: "🪀"
      }
    ],
    version: 12
  },
  kite: {
    id: "kite",
    name: "Kite",
    keywords: [
      "wind",
      "fly"
    ],
    skins: [
      {
        unified: "1fa81",
        native: "🪁"
      }
    ],
    version: 12
  },
  gun: {
    id: "gun",
    name: "Pistol",
    keywords: [
      "gun",
      "violence",
      "weapon",
      "revolver"
    ],
    skins: [
      {
        unified: "1f52b",
        native: "🔫"
      }
    ],
    version: 1
  },
  "8ball": {
    id: "8ball",
    name: "Billiards",
    keywords: [
      "8ball",
      "pool",
      "8",
      "ball",
      "hobby",
      "game",
      "luck",
      "magic"
    ],
    skins: [
      {
        unified: "1f3b1",
        native: "🎱"
      }
    ],
    version: 1
  },
  crystal_ball: {
    id: "crystal_ball",
    name: "Crystal Ball",
    keywords: [
      "disco",
      "party",
      "magic",
      "circus",
      "fortune",
      "teller"
    ],
    skins: [
      {
        unified: "1f52e",
        native: "🔮"
      }
    ],
    version: 1
  },
  magic_wand: {
    id: "magic_wand",
    name: "Magic Wand",
    keywords: [
      "supernature",
      "power"
    ],
    skins: [
      {
        unified: "1fa84",
        native: "🪄"
      }
    ],
    version: 13
  },
  video_game: {
    id: "video_game",
    name: "Video Game",
    keywords: [
      "play",
      "console",
      "PS4",
      "controller"
    ],
    skins: [
      {
        unified: "1f3ae",
        native: "🎮"
      }
    ],
    version: 1
  },
  joystick: {
    id: "joystick",
    name: "Joystick",
    keywords: [
      "game",
      "play"
    ],
    skins: [
      {
        unified: "1f579-fe0f",
        native: "🕹️"
      }
    ],
    version: 1
  },
  slot_machine: {
    id: "slot_machine",
    name: "Slot Machine",
    keywords: [
      "bet",
      "gamble",
      "vegas",
      "fruit",
      "luck",
      "casino"
    ],
    skins: [
      {
        unified: "1f3b0",
        native: "🎰"
      }
    ],
    version: 1
  },
  game_die: {
    id: "game_die",
    name: "Game Die",
    keywords: [
      "dice",
      "random",
      "tabletop",
      "play",
      "luck"
    ],
    skins: [
      {
        unified: "1f3b2",
        native: "🎲"
      }
    ],
    version: 1
  },
  jigsaw: {
    id: "jigsaw",
    name: "Puzzle Piece",
    keywords: [
      "jigsaw",
      "interlocking"
    ],
    skins: [
      {
        unified: "1f9e9",
        native: "🧩"
      }
    ],
    version: 11
  },
  teddy_bear: {
    id: "teddy_bear",
    name: "Teddy Bear",
    keywords: [
      "plush",
      "stuffed"
    ],
    skins: [
      {
        unified: "1f9f8",
        native: "🧸"
      }
    ],
    version: 11
  },
  pinata: {
    id: "pinata",
    name: "Pinata",
    keywords: [
      "mexico",
      "candy",
      "celebration"
    ],
    skins: [
      {
        unified: "1fa85",
        native: "🪅"
      }
    ],
    version: 13
  },
  mirror_ball: {
    id: "mirror_ball",
    name: "Mirror Ball",
    keywords: [
      "disco",
      "dance",
      "party"
    ],
    skins: [
      {
        unified: "1faa9",
        native: "🪩"
      }
    ],
    version: 14
  },
  nesting_dolls: {
    id: "nesting_dolls",
    name: "Nesting Dolls",
    keywords: [
      "matryoshka",
      "toy"
    ],
    skins: [
      {
        unified: "1fa86",
        native: "🪆"
      }
    ],
    version: 13
  },
  spades: {
    id: "spades",
    name: "Spade Suit",
    keywords: [
      "spades",
      "poker",
      "cards",
      "suits",
      "magic"
    ],
    skins: [
      {
        unified: "2660-fe0f",
        native: "♠️"
      }
    ],
    version: 1
  },
  hearts: {
    id: "hearts",
    name: "Heart Suit",
    keywords: [
      "hearts",
      "poker",
      "cards",
      "magic",
      "suits"
    ],
    skins: [
      {
        unified: "2665-fe0f",
        native: "♥️"
      }
    ],
    version: 1
  },
  diamonds: {
    id: "diamonds",
    name: "Diamond Suit",
    keywords: [
      "diamonds",
      "poker",
      "cards",
      "magic",
      "suits"
    ],
    skins: [
      {
        unified: "2666-fe0f",
        native: "♦️"
      }
    ],
    version: 1
  },
  clubs: {
    id: "clubs",
    name: "Club Suit",
    keywords: [
      "clubs",
      "poker",
      "cards",
      "magic",
      "suits"
    ],
    skins: [
      {
        unified: "2663-fe0f",
        native: "♣️"
      }
    ],
    version: 1
  },
  chess_pawn: {
    id: "chess_pawn",
    name: "Chess Pawn",
    keywords: [
      "expendable"
    ],
    skins: [
      {
        unified: "265f-fe0f",
        native: "♟️"
      }
    ],
    version: 11
  },
  black_joker: {
    id: "black_joker",
    name: "Joker",
    keywords: [
      "black",
      "poker",
      "cards",
      "game",
      "play",
      "magic"
    ],
    skins: [
      {
        unified: "1f0cf",
        native: "🃏"
      }
    ],
    version: 1
  },
  mahjong: {
    id: "mahjong",
    name: "Mahjong Red Dragon",
    keywords: [
      "game",
      "play",
      "chinese",
      "kanji"
    ],
    skins: [
      {
        unified: "1f004",
        native: "🀄"
      }
    ],
    version: 1
  },
  flower_playing_cards: {
    id: "flower_playing_cards",
    name: "Flower Playing Cards",
    keywords: [
      "game",
      "sunset",
      "red"
    ],
    skins: [
      {
        unified: "1f3b4",
        native: "🎴"
      }
    ],
    version: 1
  },
  performing_arts: {
    id: "performing_arts",
    name: "Performing Arts",
    keywords: [
      "acting",
      "theater",
      "drama"
    ],
    skins: [
      {
        unified: "1f3ad",
        native: "🎭"
      }
    ],
    version: 1
  },
  frame_with_picture: {
    id: "frame_with_picture",
    name: "Framed Picture",
    keywords: [
      "frame",
      "with",
      "photography"
    ],
    skins: [
      {
        unified: "1f5bc-fe0f",
        native: "🖼️"
      }
    ],
    version: 1
  },
  art: {
    id: "art",
    name: "Artist Palette",
    keywords: [
      "art",
      "design",
      "paint",
      "draw",
      "colors"
    ],
    skins: [
      {
        unified: "1f3a8",
        native: "🎨"
      }
    ],
    version: 1
  },
  thread: {
    id: "thread",
    name: "Thread",
    keywords: [
      "needle",
      "sewing",
      "spool",
      "string"
    ],
    skins: [
      {
        unified: "1f9f5",
        native: "🧵"
      }
    ],
    version: 11
  },
  sewing_needle: {
    id: "sewing_needle",
    name: "Sewing Needle",
    keywords: [
      "stitches"
    ],
    skins: [
      {
        unified: "1faa1",
        native: "🪡"
      }
    ],
    version: 13
  },
  yarn: {
    id: "yarn",
    name: "Yarn",
    keywords: [
      "ball",
      "crochet",
      "knit"
    ],
    skins: [
      {
        unified: "1f9f6",
        native: "🧶"
      }
    ],
    version: 11
  },
  knot: {
    id: "knot",
    name: "Knot",
    keywords: [
      "rope",
      "scout"
    ],
    skins: [
      {
        unified: "1faa2",
        native: "🪢"
      }
    ],
    version: 13
  },
  eyeglasses: {
    id: "eyeglasses",
    name: "Glasses",
    keywords: [
      "eyeglasses",
      "fashion",
      "accessories",
      "eyesight",
      "nerdy",
      "dork",
      "geek"
    ],
    skins: [
      {
        unified: "1f453",
        native: "👓"
      }
    ],
    version: 1
  },
  dark_sunglasses: {
    id: "dark_sunglasses",
    name: "Sunglasses",
    keywords: [
      "dark",
      "face",
      "cool",
      "accessories"
    ],
    skins: [
      {
        unified: "1f576-fe0f",
        native: "🕶️"
      }
    ],
    version: 1
  },
  goggles: {
    id: "goggles",
    name: "Goggles",
    keywords: [
      "eyes",
      "protection",
      "safety"
    ],
    skins: [
      {
        unified: "1f97d",
        native: "🥽"
      }
    ],
    version: 11
  },
  lab_coat: {
    id: "lab_coat",
    name: "Lab Coat",
    keywords: [
      "doctor",
      "experiment",
      "scientist",
      "chemist"
    ],
    skins: [
      {
        unified: "1f97c",
        native: "🥼"
      }
    ],
    version: 11
  },
  safety_vest: {
    id: "safety_vest",
    name: "Safety Vest",
    keywords: [
      "protection"
    ],
    skins: [
      {
        unified: "1f9ba",
        native: "🦺"
      }
    ],
    version: 12
  },
  necktie: {
    id: "necktie",
    name: "Necktie",
    keywords: [
      "shirt",
      "suitup",
      "formal",
      "fashion",
      "cloth",
      "business"
    ],
    skins: [
      {
        unified: "1f454",
        native: "👔"
      }
    ],
    version: 1
  },
  shirt: {
    id: "shirt",
    name: "T-Shirt",
    keywords: [
      "shirt",
      "tshirt",
      "t",
      "fashion",
      "cloth",
      "casual",
      "tee"
    ],
    skins: [
      {
        unified: "1f455",
        native: "👕"
      }
    ],
    version: 1
  },
  jeans: {
    id: "jeans",
    name: "Jeans",
    keywords: [
      "fashion",
      "shopping"
    ],
    skins: [
      {
        unified: "1f456",
        native: "👖"
      }
    ],
    version: 1
  },
  scarf: {
    id: "scarf",
    name: "Scarf",
    keywords: [
      "neck",
      "winter",
      "clothes"
    ],
    skins: [
      {
        unified: "1f9e3",
        native: "🧣"
      }
    ],
    version: 5
  },
  gloves: {
    id: "gloves",
    name: "Gloves",
    keywords: [
      "hands",
      "winter",
      "clothes"
    ],
    skins: [
      {
        unified: "1f9e4",
        native: "🧤"
      }
    ],
    version: 5
  },
  coat: {
    id: "coat",
    name: "Coat",
    keywords: [
      "jacket"
    ],
    skins: [
      {
        unified: "1f9e5",
        native: "🧥"
      }
    ],
    version: 5
  },
  socks: {
    id: "socks",
    name: "Socks",
    keywords: [
      "stockings",
      "clothes"
    ],
    skins: [
      {
        unified: "1f9e6",
        native: "🧦"
      }
    ],
    version: 5
  },
  dress: {
    id: "dress",
    name: "Dress",
    keywords: [
      "clothes",
      "fashion",
      "shopping"
    ],
    skins: [
      {
        unified: "1f457",
        native: "👗"
      }
    ],
    version: 1
  },
  kimono: {
    id: "kimono",
    name: "Kimono",
    keywords: [
      "dress",
      "fashion",
      "women",
      "female",
      "japanese"
    ],
    skins: [
      {
        unified: "1f458",
        native: "👘"
      }
    ],
    version: 1
  },
  sari: {
    id: "sari",
    name: "Sari",
    keywords: [
      "dress"
    ],
    skins: [
      {
        unified: "1f97b",
        native: "🥻"
      }
    ],
    version: 12
  },
  "one-piece_swimsuit": {
    id: "one-piece_swimsuit",
    name: "One-Piece Swimsuit",
    keywords: [
      "one",
      "piece",
      "fashion"
    ],
    skins: [
      {
        unified: "1fa71",
        native: "🩱"
      }
    ],
    version: 12
  },
  briefs: {
    id: "briefs",
    name: "Briefs",
    keywords: [
      "clothing"
    ],
    skins: [
      {
        unified: "1fa72",
        native: "🩲"
      }
    ],
    version: 12
  },
  shorts: {
    id: "shorts",
    name: "Shorts",
    keywords: [
      "clothing"
    ],
    skins: [
      {
        unified: "1fa73",
        native: "🩳"
      }
    ],
    version: 12
  },
  bikini: {
    id: "bikini",
    name: "Bikini",
    keywords: [
      "swimming",
      "female",
      "woman",
      "girl",
      "fashion",
      "beach",
      "summer"
    ],
    skins: [
      {
        unified: "1f459",
        native: "👙"
      }
    ],
    version: 1
  },
  womans_clothes: {
    id: "womans_clothes",
    name: "Womans Clothes",
    keywords: [
      "woman",
      "s",
      "fashion",
      "shopping",
      "bags",
      "female"
    ],
    skins: [
      {
        unified: "1f45a",
        native: "👚"
      }
    ],
    version: 1
  },
  folding_hand_fan: {
    id: "folding_hand_fan",
    name: "Folding Hand Fan",
    keywords: [
      "flamenco",
      "hot"
    ],
    skins: [
      {
        unified: "1faad",
        native: "🪭"
      }
    ],
    version: 15
  },
  purse: {
    id: "purse",
    name: "Purse",
    keywords: [
      "fashion",
      "accessories",
      "money",
      "sales",
      "shopping"
    ],
    skins: [
      {
        unified: "1f45b",
        native: "👛"
      }
    ],
    version: 1
  },
  handbag: {
    id: "handbag",
    name: "Handbag",
    keywords: [
      "fashion",
      "accessory",
      "accessories",
      "shopping"
    ],
    skins: [
      {
        unified: "1f45c",
        native: "👜"
      }
    ],
    version: 1
  },
  pouch: {
    id: "pouch",
    name: "Pouch",
    keywords: [
      "clutch",
      "bag",
      "accessories",
      "shopping"
    ],
    skins: [
      {
        unified: "1f45d",
        native: "👝"
      }
    ],
    version: 1
  },
  shopping_bags: {
    id: "shopping_bags",
    name: "Shopping Bags",
    keywords: [
      "mall",
      "buy",
      "purchase"
    ],
    skins: [
      {
        unified: "1f6cd-fe0f",
        native: "🛍️"
      }
    ],
    version: 1
  },
  school_satchel: {
    id: "school_satchel",
    name: "Backpack",
    keywords: [
      "school",
      "satchel",
      "student",
      "education",
      "bag"
    ],
    skins: [
      {
        unified: "1f392",
        native: "🎒"
      }
    ],
    version: 1
  },
  thong_sandal: {
    id: "thong_sandal",
    name: "Thong Sandal",
    keywords: [
      "footwear",
      "summer"
    ],
    skins: [
      {
        unified: "1fa74",
        native: "🩴"
      }
    ],
    version: 13
  },
  mans_shoe: {
    id: "mans_shoe",
    name: "Mans Shoe",
    keywords: [
      "man",
      "s",
      "fashion",
      "male"
    ],
    skins: [
      {
        unified: "1f45e",
        native: "👞"
      }
    ],
    version: 1
  },
  athletic_shoe: {
    id: "athletic_shoe",
    name: "Running Shoe",
    keywords: [
      "athletic",
      "shoes",
      "sports",
      "sneakers"
    ],
    skins: [
      {
        unified: "1f45f",
        native: "👟"
      }
    ],
    version: 1
  },
  hiking_boot: {
    id: "hiking_boot",
    name: "Hiking Boot",
    keywords: [
      "backpacking",
      "camping"
    ],
    skins: [
      {
        unified: "1f97e",
        native: "🥾"
      }
    ],
    version: 11
  },
  womans_flat_shoe: {
    id: "womans_flat_shoe",
    name: "Flat Shoe",
    keywords: [
      "womans",
      "ballet",
      "slip",
      "on",
      "slipper"
    ],
    skins: [
      {
        unified: "1f97f",
        native: "🥿"
      }
    ],
    version: 11
  },
  high_heel: {
    id: "high_heel",
    name: "High-Heeled Shoe",
    keywords: [
      "high",
      "heel",
      "heeled",
      "fashion",
      "shoes",
      "female",
      "pumps",
      "stiletto"
    ],
    skins: [
      {
        unified: "1f460",
        native: "👠"
      }
    ],
    version: 1
  },
  sandal: {
    id: "sandal",
    name: "Womans Sandal",
    keywords: [
      "woman",
      "s",
      "shoes",
      "fashion",
      "flip",
      "flops"
    ],
    skins: [
      {
        unified: "1f461",
        native: "👡"
      }
    ],
    version: 1
  },
  ballet_shoes: {
    id: "ballet_shoes",
    name: "Ballet Shoes",
    keywords: [
      "dance"
    ],
    skins: [
      {
        unified: "1fa70",
        native: "🩰"
      }
    ],
    version: 12
  },
  boot: {
    id: "boot",
    name: "Womans Boots",
    keywords: [
      "boot",
      "woman",
      "s",
      "shoes",
      "fashion"
    ],
    skins: [
      {
        unified: "1f462",
        native: "👢"
      }
    ],
    version: 1
  },
  hair_pick: {
    id: "hair_pick",
    name: "Hair Pick",
    keywords: [
      "afro",
      "comb"
    ],
    skins: [
      {
        unified: "1faae",
        native: "🪮"
      }
    ],
    version: 15
  },
  crown: {
    id: "crown",
    name: "Crown",
    keywords: [
      "king",
      "kod",
      "leader",
      "royalty",
      "lord"
    ],
    skins: [
      {
        unified: "1f451",
        native: "👑"
      }
    ],
    version: 1
  },
  womans_hat: {
    id: "womans_hat",
    name: "Womans Hat",
    keywords: [
      "woman",
      "s",
      "fashion",
      "accessories",
      "female",
      "lady",
      "spring"
    ],
    skins: [
      {
        unified: "1f452",
        native: "👒"
      }
    ],
    version: 1
  },
  tophat: {
    id: "tophat",
    name: "Top Hat",
    keywords: [
      "tophat",
      "magic",
      "gentleman",
      "classy",
      "circus"
    ],
    skins: [
      {
        unified: "1f3a9",
        native: "🎩"
      }
    ],
    version: 1
  },
  mortar_board: {
    id: "mortar_board",
    name: "Graduation Cap",
    keywords: [
      "mortar",
      "board",
      "school",
      "college",
      "degree",
      "university",
      "hat",
      "legal",
      "learn",
      "education"
    ],
    skins: [
      {
        unified: "1f393",
        native: "🎓"
      }
    ],
    version: 1
  },
  billed_cap: {
    id: "billed_cap",
    name: "Billed Cap",
    keywords: [
      "baseball"
    ],
    skins: [
      {
        unified: "1f9e2",
        native: "🧢"
      }
    ],
    version: 5
  },
  military_helmet: {
    id: "military_helmet",
    name: "Military Helmet",
    keywords: [
      "army",
      "protection"
    ],
    skins: [
      {
        unified: "1fa96",
        native: "🪖"
      }
    ],
    version: 13
  },
  helmet_with_white_cross: {
    id: "helmet_with_white_cross",
    name: "Rescue Worker’s Helmet",
    keywords: [
      "with",
      "white",
      "cross",
      "worker",
      "s",
      "construction",
      "build"
    ],
    skins: [
      {
        unified: "26d1-fe0f",
        native: "⛑️"
      }
    ],
    version: 1
  },
  prayer_beads: {
    id: "prayer_beads",
    name: "Prayer Beads",
    keywords: [
      "dhikr",
      "religious"
    ],
    skins: [
      {
        unified: "1f4ff",
        native: "📿"
      }
    ],
    version: 1
  },
  lipstick: {
    id: "lipstick",
    name: "Lipstick",
    keywords: [
      "female",
      "girl",
      "fashion",
      "woman"
    ],
    skins: [
      {
        unified: "1f484",
        native: "💄"
      }
    ],
    version: 1
  },
  ring: {
    id: "ring",
    name: "Ring",
    keywords: [
      "wedding",
      "propose",
      "marriage",
      "valentines",
      "diamond",
      "fashion",
      "jewelry",
      "gem",
      "engagement"
    ],
    skins: [
      {
        unified: "1f48d",
        native: "💍"
      }
    ],
    version: 1
  },
  gem: {
    id: "gem",
    name: "Gem Stone",
    keywords: [
      "blue",
      "ruby",
      "diamond",
      "jewelry"
    ],
    skins: [
      {
        unified: "1f48e",
        native: "💎"
      }
    ],
    version: 1
  },
  mute: {
    id: "mute",
    name: "Muted Speaker",
    keywords: [
      "mute",
      "sound",
      "volume",
      "silence",
      "quiet"
    ],
    skins: [
      {
        unified: "1f507",
        native: "🔇"
      }
    ],
    version: 1
  },
  speaker: {
    id: "speaker",
    name: "Speaker",
    keywords: [
      "low",
      "volume",
      "sound",
      "silence",
      "broadcast"
    ],
    skins: [
      {
        unified: "1f508",
        native: "🔈"
      }
    ],
    version: 1
  },
  sound: {
    id: "sound",
    name: "Speaker Medium Volume",
    keywords: [
      "sound",
      "broadcast"
    ],
    skins: [
      {
        unified: "1f509",
        native: "🔉"
      }
    ],
    version: 1
  },
  loud_sound: {
    id: "loud_sound",
    name: "Speaker High Volume",
    keywords: [
      "loud",
      "sound",
      "noise",
      "noisy",
      "broadcast"
    ],
    skins: [
      {
        unified: "1f50a",
        native: "🔊"
      }
    ],
    version: 1
  },
  loudspeaker: {
    id: "loudspeaker",
    name: "Loudspeaker",
    keywords: [
      "volume",
      "sound"
    ],
    skins: [
      {
        unified: "1f4e2",
        native: "📢"
      }
    ],
    version: 1
  },
  mega: {
    id: "mega",
    name: "Megaphone",
    keywords: [
      "mega",
      "sound",
      "speaker",
      "volume"
    ],
    skins: [
      {
        unified: "1f4e3",
        native: "📣"
      }
    ],
    version: 1
  },
  postal_horn: {
    id: "postal_horn",
    name: "Postal Horn",
    keywords: [
      "instrument",
      "music"
    ],
    skins: [
      {
        unified: "1f4ef",
        native: "📯"
      }
    ],
    version: 1
  },
  bell: {
    id: "bell",
    name: "Bell",
    keywords: [
      "sound",
      "notification",
      "christmas",
      "xmas",
      "chime"
    ],
    skins: [
      {
        unified: "1f514",
        native: "🔔"
      }
    ],
    version: 1
  },
  no_bell: {
    id: "no_bell",
    name: "Bell with Slash",
    keywords: [
      "no",
      "sound",
      "volume",
      "mute",
      "quiet",
      "silent"
    ],
    skins: [
      {
        unified: "1f515",
        native: "🔕"
      }
    ],
    version: 1
  },
  musical_score: {
    id: "musical_score",
    name: "Musical Score",
    keywords: [
      "treble",
      "clef",
      "compose"
    ],
    skins: [
      {
        unified: "1f3bc",
        native: "🎼"
      }
    ],
    version: 1
  },
  musical_note: {
    id: "musical_note",
    name: "Musical Note",
    keywords: [
      "score",
      "tone",
      "sound"
    ],
    skins: [
      {
        unified: "1f3b5",
        native: "🎵"
      }
    ],
    version: 1
  },
  notes: {
    id: "notes",
    name: "Musical Notes",
    keywords: [
      "music",
      "score"
    ],
    skins: [
      {
        unified: "1f3b6",
        native: "🎶"
      }
    ],
    version: 1
  },
  studio_microphone: {
    id: "studio_microphone",
    name: "Studio Microphone",
    keywords: [
      "sing",
      "recording",
      "artist",
      "talkshow"
    ],
    skins: [
      {
        unified: "1f399-fe0f",
        native: "🎙️"
      }
    ],
    version: 1
  },
  level_slider: {
    id: "level_slider",
    name: "Level Slider",
    keywords: [
      "scale"
    ],
    skins: [
      {
        unified: "1f39a-fe0f",
        native: "🎚️"
      }
    ],
    version: 1
  },
  control_knobs: {
    id: "control_knobs",
    name: "Control Knobs",
    keywords: [
      "dial"
    ],
    skins: [
      {
        unified: "1f39b-fe0f",
        native: "🎛️"
      }
    ],
    version: 1
  },
  microphone: {
    id: "microphone",
    name: "Microphone",
    keywords: [
      "sound",
      "music",
      "PA",
      "sing",
      "talkshow"
    ],
    skins: [
      {
        unified: "1f3a4",
        native: "🎤"
      }
    ],
    version: 1
  },
  headphones: {
    id: "headphones",
    name: "Headphone",
    keywords: [
      "headphones",
      "music",
      "score",
      "gadgets"
    ],
    skins: [
      {
        unified: "1f3a7",
        native: "🎧"
      }
    ],
    version: 1
  },
  radio: {
    id: "radio",
    name: "Radio",
    keywords: [
      "communication",
      "music",
      "podcast",
      "program"
    ],
    skins: [
      {
        unified: "1f4fb",
        native: "📻"
      }
    ],
    version: 1
  },
  saxophone: {
    id: "saxophone",
    name: "Saxophone",
    keywords: [
      "music",
      "instrument",
      "jazz",
      "blues"
    ],
    skins: [
      {
        unified: "1f3b7",
        native: "🎷"
      }
    ],
    version: 1
  },
  accordion: {
    id: "accordion",
    name: "Accordion",
    keywords: [
      "music"
    ],
    skins: [
      {
        unified: "1fa97",
        native: "🪗"
      }
    ],
    version: 13
  },
  guitar: {
    id: "guitar",
    name: "Guitar",
    keywords: [
      "music",
      "instrument"
    ],
    skins: [
      {
        unified: "1f3b8",
        native: "🎸"
      }
    ],
    version: 1
  },
  musical_keyboard: {
    id: "musical_keyboard",
    name: "Musical Keyboard",
    keywords: [
      "piano",
      "instrument",
      "compose"
    ],
    skins: [
      {
        unified: "1f3b9",
        native: "🎹"
      }
    ],
    version: 1
  },
  trumpet: {
    id: "trumpet",
    name: "Trumpet",
    keywords: [
      "music",
      "brass"
    ],
    skins: [
      {
        unified: "1f3ba",
        native: "🎺"
      }
    ],
    version: 1
  },
  violin: {
    id: "violin",
    name: "Violin",
    keywords: [
      "music",
      "instrument",
      "orchestra",
      "symphony"
    ],
    skins: [
      {
        unified: "1f3bb",
        native: "🎻"
      }
    ],
    version: 1
  },
  banjo: {
    id: "banjo",
    name: "Banjo",
    keywords: [
      "music",
      "instructment"
    ],
    skins: [
      {
        unified: "1fa95",
        native: "🪕"
      }
    ],
    version: 12
  },
  drum_with_drumsticks: {
    id: "drum_with_drumsticks",
    name: "Drum",
    keywords: [
      "with",
      "drumsticks",
      "music",
      "instrument",
      "snare"
    ],
    skins: [
      {
        unified: "1f941",
        native: "🥁"
      }
    ],
    version: 3
  },
  long_drum: {
    id: "long_drum",
    name: "Long Drum",
    keywords: [
      "music"
    ],
    skins: [
      {
        unified: "1fa98",
        native: "🪘"
      }
    ],
    version: 13
  },
  maracas: {
    id: "maracas",
    name: "Maracas",
    keywords: [
      "music",
      "instrument",
      "percussion"
    ],
    skins: [
      {
        unified: "1fa87",
        native: "🪇"
      }
    ],
    version: 15
  },
  flute: {
    id: "flute",
    name: "Flute",
    keywords: [
      "bamboo",
      "music",
      "instrument",
      "pied",
      "piper"
    ],
    skins: [
      {
        unified: "1fa88",
        native: "🪈"
      }
    ],
    version: 15
  },
  iphone: {
    id: "iphone",
    name: "Mobile Phone",
    keywords: [
      "iphone",
      "technology",
      "apple",
      "gadgets",
      "dial"
    ],
    skins: [
      {
        unified: "1f4f1",
        native: "📱"
      }
    ],
    version: 1
  },
  calling: {
    id: "calling",
    name: "Mobile Phone with Arrow",
    keywords: [
      "calling",
      "iphone",
      "incoming"
    ],
    skins: [
      {
        unified: "1f4f2",
        native: "📲"
      }
    ],
    version: 1
  },
  phone: {
    id: "phone",
    name: "Telephone",
    keywords: [
      "phone",
      "technology",
      "communication",
      "dial"
    ],
    skins: [
      {
        unified: "260e-fe0f",
        native: "☎️"
      }
    ],
    version: 1
  },
  telephone_receiver: {
    id: "telephone_receiver",
    name: "Telephone Receiver",
    keywords: [
      "technology",
      "communication",
      "dial"
    ],
    skins: [
      {
        unified: "1f4de",
        native: "📞"
      }
    ],
    version: 1
  },
  pager: {
    id: "pager",
    name: "Pager",
    keywords: [
      "bbcall",
      "oldschool",
      "90s"
    ],
    skins: [
      {
        unified: "1f4df",
        native: "📟"
      }
    ],
    version: 1
  },
  fax: {
    id: "fax",
    name: "Fax Machine",
    keywords: [
      "communication",
      "technology"
    ],
    skins: [
      {
        unified: "1f4e0",
        native: "📠"
      }
    ],
    version: 1
  },
  battery: {
    id: "battery",
    name: "Battery",
    keywords: [
      "power",
      "energy",
      "sustain"
    ],
    skins: [
      {
        unified: "1f50b",
        native: "🔋"
      }
    ],
    version: 1
  },
  low_battery: {
    id: "low_battery",
    name: "Low Battery",
    keywords: [
      "drained",
      "dead"
    ],
    skins: [
      {
        unified: "1faab",
        native: "🪫"
      }
    ],
    version: 14
  },
  electric_plug: {
    id: "electric_plug",
    name: "Electric Plug",
    keywords: [
      "charger",
      "power"
    ],
    skins: [
      {
        unified: "1f50c",
        native: "🔌"
      }
    ],
    version: 1
  },
  computer: {
    id: "computer",
    name: "Laptop",
    keywords: [
      "computer",
      "technology",
      "screen",
      "display",
      "monitor"
    ],
    skins: [
      {
        unified: "1f4bb",
        native: "💻"
      }
    ],
    version: 1
  },
  desktop_computer: {
    id: "desktop_computer",
    name: "Desktop Computer",
    keywords: [
      "technology",
      "computing",
      "screen"
    ],
    skins: [
      {
        unified: "1f5a5-fe0f",
        native: "🖥️"
      }
    ],
    version: 1
  },
  printer: {
    id: "printer",
    name: "Printer",
    keywords: [
      "paper",
      "ink"
    ],
    skins: [
      {
        unified: "1f5a8-fe0f",
        native: "🖨️"
      }
    ],
    version: 1
  },
  keyboard: {
    id: "keyboard",
    name: "Keyboard",
    keywords: [
      "technology",
      "computer",
      "type",
      "input",
      "text"
    ],
    skins: [
      {
        unified: "2328-fe0f",
        native: "⌨️"
      }
    ],
    version: 1
  },
  three_button_mouse: {
    id: "three_button_mouse",
    name: "Computer Mouse",
    keywords: [
      "three",
      "button",
      "click"
    ],
    skins: [
      {
        unified: "1f5b1-fe0f",
        native: "🖱️"
      }
    ],
    version: 1
  },
  trackball: {
    id: "trackball",
    name: "Trackball",
    keywords: [
      "technology",
      "trackpad"
    ],
    skins: [
      {
        unified: "1f5b2-fe0f",
        native: "🖲️"
      }
    ],
    version: 1
  },
  minidisc: {
    id: "minidisc",
    name: "Minidisc",
    keywords: [
      "computer",
      "disk",
      "technology",
      "record",
      "data",
      "90s"
    ],
    skins: [
      {
        unified: "1f4bd",
        native: "💽"
      }
    ],
    version: 1
  },
  floppy_disk: {
    id: "floppy_disk",
    name: "Floppy Disk",
    keywords: [
      "oldschool",
      "technology",
      "save",
      "90s",
      "80s"
    ],
    skins: [
      {
        unified: "1f4be",
        native: "💾"
      }
    ],
    version: 1
  },
  cd: {
    id: "cd",
    name: "Optical Disc",
    keywords: [
      "cd",
      "disk",
      "technology",
      "dvd",
      "90s"
    ],
    skins: [
      {
        unified: "1f4bf",
        native: "💿"
      }
    ],
    version: 1
  },
  dvd: {
    id: "dvd",
    name: "Dvd",
    keywords: [
      "cd",
      "disk",
      "disc"
    ],
    skins: [
      {
        unified: "1f4c0",
        native: "📀"
      }
    ],
    version: 1
  },
  abacus: {
    id: "abacus",
    name: "Abacus",
    keywords: [
      "calculation"
    ],
    skins: [
      {
        unified: "1f9ee",
        native: "🧮"
      }
    ],
    version: 11
  },
  movie_camera: {
    id: "movie_camera",
    name: "Movie Camera",
    keywords: [
      "film",
      "record"
    ],
    skins: [
      {
        unified: "1f3a5",
        native: "🎥"
      }
    ],
    version: 1
  },
  film_frames: {
    id: "film_frames",
    name: "Film Frames",
    keywords: [
      "movie"
    ],
    skins: [
      {
        unified: "1f39e-fe0f",
        native: "🎞️"
      }
    ],
    version: 1
  },
  film_projector: {
    id: "film_projector",
    name: "Film Projector",
    keywords: [
      "video",
      "tape",
      "record",
      "movie"
    ],
    skins: [
      {
        unified: "1f4fd-fe0f",
        native: "📽️"
      }
    ],
    version: 1
  },
  clapper: {
    id: "clapper",
    name: "Clapper Board",
    keywords: [
      "movie",
      "film",
      "record"
    ],
    skins: [
      {
        unified: "1f3ac",
        native: "🎬"
      }
    ],
    version: 1
  },
  tv: {
    id: "tv",
    name: "Television",
    keywords: [
      "tv",
      "technology",
      "program",
      "oldschool",
      "show"
    ],
    skins: [
      {
        unified: "1f4fa",
        native: "📺"
      }
    ],
    version: 1
  },
  camera: {
    id: "camera",
    name: "Camera",
    keywords: [
      "gadgets",
      "photography"
    ],
    skins: [
      {
        unified: "1f4f7",
        native: "📷"
      }
    ],
    version: 1
  },
  camera_with_flash: {
    id: "camera_with_flash",
    name: "Camera with Flash",
    keywords: [
      "photography",
      "gadgets"
    ],
    skins: [
      {
        unified: "1f4f8",
        native: "📸"
      }
    ],
    version: 1
  },
  video_camera: {
    id: "video_camera",
    name: "Video Camera",
    keywords: [
      "film",
      "record"
    ],
    skins: [
      {
        unified: "1f4f9",
        native: "📹"
      }
    ],
    version: 1
  },
  vhs: {
    id: "vhs",
    name: "Videocassette",
    keywords: [
      "vhs",
      "record",
      "video",
      "oldschool",
      "90s",
      "80s"
    ],
    skins: [
      {
        unified: "1f4fc",
        native: "📼"
      }
    ],
    version: 1
  },
  mag: {
    id: "mag",
    name: "Magnifying Glass Tilted Left",
    keywords: [
      "mag",
      "search",
      "zoom",
      "find",
      "detective"
    ],
    skins: [
      {
        unified: "1f50d",
        native: "🔍"
      }
    ],
    version: 1
  },
  mag_right: {
    id: "mag_right",
    name: "Magnifying Glass Tilted Right",
    keywords: [
      "mag",
      "search",
      "zoom",
      "find",
      "detective"
    ],
    skins: [
      {
        unified: "1f50e",
        native: "🔎"
      }
    ],
    version: 1
  },
  candle: {
    id: "candle",
    name: "Candle",
    keywords: [
      "fire",
      "wax"
    ],
    skins: [
      {
        unified: "1f56f-fe0f",
        native: "🕯️"
      }
    ],
    version: 1
  },
  bulb: {
    id: "bulb",
    name: "Light Bulb",
    keywords: [
      "electricity",
      "idea"
    ],
    skins: [
      {
        unified: "1f4a1",
        native: "💡"
      }
    ],
    version: 1
  },
  flashlight: {
    id: "flashlight",
    name: "Flashlight",
    keywords: [
      "dark",
      "camping",
      "sight",
      "night"
    ],
    skins: [
      {
        unified: "1f526",
        native: "🔦"
      }
    ],
    version: 1
  },
  izakaya_lantern: {
    id: "izakaya_lantern",
    name: "Izakaya Lantern",
    keywords: [
      "red",
      "paper",
      "light",
      "halloween",
      "spooky"
    ],
    skins: [
      {
        unified: "1f3ee",
        native: "🏮"
      }
    ],
    version: 1
  },
  diya_lamp: {
    id: "diya_lamp",
    name: "Diya Lamp",
    keywords: [
      "lighting"
    ],
    skins: [
      {
        unified: "1fa94",
        native: "🪔"
      }
    ],
    version: 12
  },
  notebook_with_decorative_cover: {
    id: "notebook_with_decorative_cover",
    name: "Notebook with Decorative Cover",
    keywords: [
      "classroom",
      "notes",
      "record",
      "paper",
      "study"
    ],
    skins: [
      {
        unified: "1f4d4",
        native: "📔"
      }
    ],
    version: 1
  },
  closed_book: {
    id: "closed_book",
    name: "Closed Book",
    keywords: [
      "read",
      "library",
      "knowledge",
      "textbook",
      "learn"
    ],
    skins: [
      {
        unified: "1f4d5",
        native: "📕"
      }
    ],
    version: 1
  },
  book: {
    id: "book",
    name: "Open Book",
    keywords: [
      "read",
      "library",
      "knowledge",
      "literature",
      "learn",
      "study"
    ],
    skins: [
      {
        unified: "1f4d6",
        native: "📖"
      }
    ],
    version: 1
  },
  green_book: {
    id: "green_book",
    name: "Green Book",
    keywords: [
      "read",
      "library",
      "knowledge",
      "study"
    ],
    skins: [
      {
        unified: "1f4d7",
        native: "📗"
      }
    ],
    version: 1
  },
  blue_book: {
    id: "blue_book",
    name: "Blue Book",
    keywords: [
      "read",
      "library",
      "knowledge",
      "learn",
      "study"
    ],
    skins: [
      {
        unified: "1f4d8",
        native: "📘"
      }
    ],
    version: 1
  },
  orange_book: {
    id: "orange_book",
    name: "Orange Book",
    keywords: [
      "read",
      "library",
      "knowledge",
      "textbook",
      "study"
    ],
    skins: [
      {
        unified: "1f4d9",
        native: "📙"
      }
    ],
    version: 1
  },
  books: {
    id: "books",
    name: "Books",
    keywords: [
      "literature",
      "library",
      "study"
    ],
    skins: [
      {
        unified: "1f4da",
        native: "📚"
      }
    ],
    version: 1
  },
  notebook: {
    id: "notebook",
    name: "Notebook",
    keywords: [
      "stationery",
      "record",
      "notes",
      "paper",
      "study"
    ],
    skins: [
      {
        unified: "1f4d3",
        native: "📓"
      }
    ],
    version: 1
  },
  ledger: {
    id: "ledger",
    name: "Ledger",
    keywords: [
      "notes",
      "paper"
    ],
    skins: [
      {
        unified: "1f4d2",
        native: "📒"
      }
    ],
    version: 1
  },
  page_with_curl: {
    id: "page_with_curl",
    name: "Page with Curl",
    keywords: [
      "documents",
      "office",
      "paper"
    ],
    skins: [
      {
        unified: "1f4c3",
        native: "📃"
      }
    ],
    version: 1
  },
  scroll: {
    id: "scroll",
    name: "Scroll",
    keywords: [
      "documents",
      "ancient",
      "history",
      "paper"
    ],
    skins: [
      {
        unified: "1f4dc",
        native: "📜"
      }
    ],
    version: 1
  },
  page_facing_up: {
    id: "page_facing_up",
    name: "Page Facing Up",
    keywords: [
      "documents",
      "office",
      "paper",
      "information"
    ],
    skins: [
      {
        unified: "1f4c4",
        native: "📄"
      }
    ],
    version: 1
  },
  newspaper: {
    id: "newspaper",
    name: "Newspaper",
    keywords: [
      "press",
      "headline"
    ],
    skins: [
      {
        unified: "1f4f0",
        native: "📰"
      }
    ],
    version: 1
  },
  rolled_up_newspaper: {
    id: "rolled_up_newspaper",
    name: "Rolled-Up Newspaper",
    keywords: [
      "rolled",
      "up",
      "press",
      "headline"
    ],
    skins: [
      {
        unified: "1f5de-fe0f",
        native: "🗞️"
      }
    ],
    version: 1
  },
  bookmark_tabs: {
    id: "bookmark_tabs",
    name: "Bookmark Tabs",
    keywords: [
      "favorite",
      "save",
      "order",
      "tidy"
    ],
    skins: [
      {
        unified: "1f4d1",
        native: "📑"
      }
    ],
    version: 1
  },
  bookmark: {
    id: "bookmark",
    name: "Bookmark",
    keywords: [
      "favorite",
      "label",
      "save"
    ],
    skins: [
      {
        unified: "1f516",
        native: "🔖"
      }
    ],
    version: 1
  },
  label: {
    id: "label",
    name: "Label",
    keywords: [
      "sale",
      "tag"
    ],
    skins: [
      {
        unified: "1f3f7-fe0f",
        native: "🏷️"
      }
    ],
    version: 1
  },
  moneybag: {
    id: "moneybag",
    name: "Money Bag",
    keywords: [
      "moneybag",
      "dollar",
      "payment",
      "coins",
      "sale"
    ],
    skins: [
      {
        unified: "1f4b0",
        native: "💰"
      }
    ],
    version: 1
  },
  coin: {
    id: "coin",
    name: "Coin",
    keywords: [
      "money",
      "currency"
    ],
    skins: [
      {
        unified: "1fa99",
        native: "🪙"
      }
    ],
    version: 13
  },
  yen: {
    id: "yen",
    name: "Yen Banknote",
    keywords: [
      "money",
      "sales",
      "japanese",
      "dollar",
      "currency"
    ],
    skins: [
      {
        unified: "1f4b4",
        native: "💴"
      }
    ],
    version: 1
  },
  dollar: {
    id: "dollar",
    name: "Dollar Banknote",
    keywords: [
      "money",
      "sales",
      "bill",
      "currency"
    ],
    skins: [
      {
        unified: "1f4b5",
        native: "💵"
      }
    ],
    version: 1
  },
  euro: {
    id: "euro",
    name: "Euro Banknote",
    keywords: [
      "money",
      "sales",
      "dollar",
      "currency"
    ],
    skins: [
      {
        unified: "1f4b6",
        native: "💶"
      }
    ],
    version: 1
  },
  pound: {
    id: "pound",
    name: "Pound Banknote",
    keywords: [
      "british",
      "sterling",
      "money",
      "sales",
      "bills",
      "uk",
      "england",
      "currency"
    ],
    skins: [
      {
        unified: "1f4b7",
        native: "💷"
      }
    ],
    version: 1
  },
  money_with_wings: {
    id: "money_with_wings",
    name: "Money with Wings",
    keywords: [
      "dollar",
      "bills",
      "payment",
      "sale"
    ],
    skins: [
      {
        unified: "1f4b8",
        native: "💸"
      }
    ],
    version: 1
  },
  credit_card: {
    id: "credit_card",
    name: "Credit Card",
    keywords: [
      "money",
      "sales",
      "dollar",
      "bill",
      "payment",
      "shopping"
    ],
    skins: [
      {
        unified: "1f4b3",
        native: "💳"
      }
    ],
    version: 1
  },
  receipt: {
    id: "receipt",
    name: "Receipt",
    keywords: [
      "accounting",
      "expenses"
    ],
    skins: [
      {
        unified: "1f9fe",
        native: "🧾"
      }
    ],
    version: 11
  },
  chart: {
    id: "chart",
    name: "Chart Increasing with Yen",
    keywords: [
      "green",
      "square",
      "graph",
      "presentation",
      "stats"
    ],
    skins: [
      {
        unified: "1f4b9",
        native: "💹"
      }
    ],
    version: 1
  },
  email: {
    id: "email",
    name: "Envelope",
    keywords: [
      "email",
      "letter",
      "postal",
      "inbox",
      "communication"
    ],
    skins: [
      {
        unified: "2709-fe0f",
        native: "✉️"
      }
    ],
    version: 1
  },
  "e-mail": {
    id: "e-mail",
    name: "E-Mail",
    keywords: [
      "e",
      "mail",
      "communication",
      "inbox"
    ],
    skins: [
      {
        unified: "1f4e7",
        native: "📧"
      }
    ],
    version: 1
  },
  incoming_envelope: {
    id: "incoming_envelope",
    name: "Incoming Envelope",
    keywords: [
      "email",
      "inbox"
    ],
    skins: [
      {
        unified: "1f4e8",
        native: "📨"
      }
    ],
    version: 1
  },
  envelope_with_arrow: {
    id: "envelope_with_arrow",
    name: "Envelope with Arrow",
    keywords: [
      "email",
      "communication"
    ],
    skins: [
      {
        unified: "1f4e9",
        native: "📩"
      }
    ],
    version: 1
  },
  outbox_tray: {
    id: "outbox_tray",
    name: "Outbox Tray",
    keywords: [
      "inbox",
      "email"
    ],
    skins: [
      {
        unified: "1f4e4",
        native: "📤"
      }
    ],
    version: 1
  },
  inbox_tray: {
    id: "inbox_tray",
    name: "Inbox Tray",
    keywords: [
      "email",
      "documents"
    ],
    skins: [
      {
        unified: "1f4e5",
        native: "📥"
      }
    ],
    version: 1
  },
  package: {
    id: "package",
    name: "Package",
    keywords: [
      "mail",
      "gift",
      "cardboard",
      "box",
      "moving"
    ],
    skins: [
      {
        unified: "1f4e6",
        native: "📦"
      }
    ],
    version: 1
  },
  mailbox: {
    id: "mailbox",
    name: "Closed Mailbox with Raised Flag",
    keywords: [
      "email",
      "inbox",
      "communication"
    ],
    skins: [
      {
        unified: "1f4eb",
        native: "📫"
      }
    ],
    version: 1
  },
  mailbox_closed: {
    id: "mailbox_closed",
    name: "Closed Mailbox with Lowered Flag",
    keywords: [
      "email",
      "communication",
      "inbox"
    ],
    skins: [
      {
        unified: "1f4ea",
        native: "📪"
      }
    ],
    version: 1
  },
  mailbox_with_mail: {
    id: "mailbox_with_mail",
    name: "Open Mailbox with Raised Flag",
    keywords: [
      "mail",
      "email",
      "inbox",
      "communication"
    ],
    skins: [
      {
        unified: "1f4ec",
        native: "📬"
      }
    ],
    version: 1
  },
  mailbox_with_no_mail: {
    id: "mailbox_with_no_mail",
    name: "Open Mailbox with Lowered Flag",
    keywords: [
      "no",
      "mail",
      "email",
      "inbox"
    ],
    skins: [
      {
        unified: "1f4ed",
        native: "📭"
      }
    ],
    version: 1
  },
  postbox: {
    id: "postbox",
    name: "Postbox",
    keywords: [
      "email",
      "letter",
      "envelope"
    ],
    skins: [
      {
        unified: "1f4ee",
        native: "📮"
      }
    ],
    version: 1
  },
  ballot_box_with_ballot: {
    id: "ballot_box_with_ballot",
    name: "Ballot Box with Ballot",
    keywords: [
      "election",
      "vote"
    ],
    skins: [
      {
        unified: "1f5f3-fe0f",
        native: "🗳️"
      }
    ],
    version: 1
  },
  pencil2: {
    id: "pencil2",
    name: "Pencil",
    keywords: [
      "pencil2",
      "stationery",
      "write",
      "paper",
      "writing",
      "school",
      "study"
    ],
    skins: [
      {
        unified: "270f-fe0f",
        native: "✏️"
      }
    ],
    version: 1
  },
  black_nib: {
    id: "black_nib",
    name: "Black Nib",
    keywords: [
      "pen",
      "stationery",
      "writing",
      "write"
    ],
    skins: [
      {
        unified: "2712-fe0f",
        native: "✒️"
      }
    ],
    version: 1
  },
  lower_left_fountain_pen: {
    id: "lower_left_fountain_pen",
    name: "Fountain Pen",
    keywords: [
      "lower",
      "left",
      "stationery",
      "writing",
      "write"
    ],
    skins: [
      {
        unified: "1f58b-fe0f",
        native: "🖋️"
      }
    ],
    version: 1
  },
  lower_left_ballpoint_pen: {
    id: "lower_left_ballpoint_pen",
    name: "Pen",
    keywords: [
      "lower",
      "left",
      "ballpoint",
      "stationery",
      "writing",
      "write"
    ],
    skins: [
      {
        unified: "1f58a-fe0f",
        native: "🖊️"
      }
    ],
    version: 1
  },
  lower_left_paintbrush: {
    id: "lower_left_paintbrush",
    name: "Paintbrush",
    keywords: [
      "lower",
      "left",
      "drawing",
      "creativity",
      "art"
    ],
    skins: [
      {
        unified: "1f58c-fe0f",
        native: "🖌️"
      }
    ],
    version: 1
  },
  lower_left_crayon: {
    id: "lower_left_crayon",
    name: "Crayon",
    keywords: [
      "lower",
      "left",
      "drawing",
      "creativity"
    ],
    skins: [
      {
        unified: "1f58d-fe0f",
        native: "🖍️"
      }
    ],
    version: 1
  },
  memo: {
    id: "memo",
    name: "Memo",
    keywords: [
      "pencil",
      "write",
      "documents",
      "stationery",
      "paper",
      "writing",
      "legal",
      "exam",
      "quiz",
      "test",
      "study",
      "compose"
    ],
    skins: [
      {
        unified: "1f4dd",
        native: "📝"
      }
    ],
    version: 1
  },
  briefcase: {
    id: "briefcase",
    name: "Briefcase",
    keywords: [
      "business",
      "documents",
      "work",
      "law",
      "legal",
      "job",
      "career"
    ],
    skins: [
      {
        unified: "1f4bc",
        native: "💼"
      }
    ],
    version: 1
  },
  file_folder: {
    id: "file_folder",
    name: "File Folder",
    keywords: [
      "documents",
      "business",
      "office"
    ],
    skins: [
      {
        unified: "1f4c1",
        native: "📁"
      }
    ],
    version: 1
  },
  open_file_folder: {
    id: "open_file_folder",
    name: "Open File Folder",
    keywords: [
      "documents",
      "load"
    ],
    skins: [
      {
        unified: "1f4c2",
        native: "📂"
      }
    ],
    version: 1
  },
  card_index_dividers: {
    id: "card_index_dividers",
    name: "Card Index Dividers",
    keywords: [
      "organizing",
      "business",
      "stationery"
    ],
    skins: [
      {
        unified: "1f5c2-fe0f",
        native: "🗂️"
      }
    ],
    version: 1
  },
  date: {
    id: "date",
    name: "Calendar",
    keywords: [
      "date",
      "schedule"
    ],
    skins: [
      {
        unified: "1f4c5",
        native: "📅"
      }
    ],
    version: 1
  },
  calendar: {
    id: "calendar",
    name: "Tear-off Calendar",
    keywords: [
      "tear",
      "off",
      "schedule",
      "date",
      "planning"
    ],
    skins: [
      {
        unified: "1f4c6",
        native: "📆"
      }
    ],
    version: 1
  },
  spiral_note_pad: {
    id: "spiral_note_pad",
    name: "Spiral Notepad",
    keywords: [
      "note",
      "pad",
      "memo",
      "stationery"
    ],
    skins: [
      {
        unified: "1f5d2-fe0f",
        native: "🗒️"
      }
    ],
    version: 1
  },
  spiral_calendar_pad: {
    id: "spiral_calendar_pad",
    name: "Spiral Calendar",
    keywords: [
      "pad",
      "date",
      "schedule",
      "planning"
    ],
    skins: [
      {
        unified: "1f5d3-fe0f",
        native: "🗓️"
      }
    ],
    version: 1
  },
  card_index: {
    id: "card_index",
    name: "Card Index",
    keywords: [
      "business",
      "stationery"
    ],
    skins: [
      {
        unified: "1f4c7",
        native: "📇"
      }
    ],
    version: 1
  },
  chart_with_upwards_trend: {
    id: "chart_with_upwards_trend",
    name: "Chart Increasing",
    keywords: [
      "with",
      "upwards",
      "trend",
      "graph",
      "presentation",
      "stats",
      "recovery",
      "business",
      "economics",
      "money",
      "sales",
      "good",
      "success"
    ],
    skins: [
      {
        unified: "1f4c8",
        native: "📈"
      }
    ],
    version: 1
  },
  chart_with_downwards_trend: {
    id: "chart_with_downwards_trend",
    name: "Chart Decreasing",
    keywords: [
      "with",
      "downwards",
      "trend",
      "graph",
      "presentation",
      "stats",
      "recession",
      "business",
      "economics",
      "money",
      "sales",
      "bad",
      "failure"
    ],
    skins: [
      {
        unified: "1f4c9",
        native: "📉"
      }
    ],
    version: 1
  },
  bar_chart: {
    id: "bar_chart",
    name: "Bar Chart",
    keywords: [
      "graph",
      "presentation",
      "stats"
    ],
    skins: [
      {
        unified: "1f4ca",
        native: "📊"
      }
    ],
    version: 1
  },
  clipboard: {
    id: "clipboard",
    name: "Clipboard",
    keywords: [
      "stationery",
      "documents"
    ],
    skins: [
      {
        unified: "1f4cb",
        native: "📋"
      }
    ],
    version: 1
  },
  pushpin: {
    id: "pushpin",
    name: "Pushpin",
    keywords: [
      "stationery",
      "mark",
      "here"
    ],
    skins: [
      {
        unified: "1f4cc",
        native: "📌"
      }
    ],
    version: 1
  },
  round_pushpin: {
    id: "round_pushpin",
    name: "Round Pushpin",
    keywords: [
      "stationery",
      "location",
      "map",
      "here"
    ],
    skins: [
      {
        unified: "1f4cd",
        native: "📍"
      }
    ],
    version: 1
  },
  paperclip: {
    id: "paperclip",
    name: "Paperclip",
    keywords: [
      "documents",
      "stationery"
    ],
    skins: [
      {
        unified: "1f4ce",
        native: "📎"
      }
    ],
    version: 1
  },
  linked_paperclips: {
    id: "linked_paperclips",
    name: "Linked Paperclips",
    keywords: [
      "documents",
      "stationery"
    ],
    skins: [
      {
        unified: "1f587-fe0f",
        native: "🖇️"
      }
    ],
    version: 1
  },
  straight_ruler: {
    id: "straight_ruler",
    name: "Straight Ruler",
    keywords: [
      "stationery",
      "calculate",
      "length",
      "math",
      "school",
      "drawing",
      "architect",
      "sketch"
    ],
    skins: [
      {
        unified: "1f4cf",
        native: "📏"
      }
    ],
    version: 1
  },
  triangular_ruler: {
    id: "triangular_ruler",
    name: "Triangular Ruler",
    keywords: [
      "stationery",
      "math",
      "architect",
      "sketch"
    ],
    skins: [
      {
        unified: "1f4d0",
        native: "📐"
      }
    ],
    version: 1
  },
  scissors: {
    id: "scissors",
    name: "Scissors",
    keywords: [
      "stationery",
      "cut"
    ],
    skins: [
      {
        unified: "2702-fe0f",
        native: "✂️"
      }
    ],
    version: 1
  },
  card_file_box: {
    id: "card_file_box",
    name: "Card File Box",
    keywords: [
      "business",
      "stationery"
    ],
    skins: [
      {
        unified: "1f5c3-fe0f",
        native: "🗃️"
      }
    ],
    version: 1
  },
  file_cabinet: {
    id: "file_cabinet",
    name: "File Cabinet",
    keywords: [
      "filing",
      "organizing"
    ],
    skins: [
      {
        unified: "1f5c4-fe0f",
        native: "🗄️"
      }
    ],
    version: 1
  },
  wastebasket: {
    id: "wastebasket",
    name: "Wastebasket",
    keywords: [
      "bin",
      "trash",
      "rubbish",
      "garbage",
      "toss"
    ],
    skins: [
      {
        unified: "1f5d1-fe0f",
        native: "🗑️"
      }
    ],
    version: 1
  },
  lock: {
    id: "lock",
    name: "Lock",
    keywords: [
      "locked",
      "security",
      "password",
      "padlock"
    ],
    skins: [
      {
        unified: "1f512",
        native: "🔒"
      }
    ],
    version: 1
  },
  unlock: {
    id: "unlock",
    name: "Unlocked",
    keywords: [
      "unlock",
      "privacy",
      "security"
    ],
    skins: [
      {
        unified: "1f513",
        native: "🔓"
      }
    ],
    version: 1
  },
  lock_with_ink_pen: {
    id: "lock_with_ink_pen",
    name: "Locked with Pen",
    keywords: [
      "lock",
      "ink",
      "security",
      "secret"
    ],
    skins: [
      {
        unified: "1f50f",
        native: "🔏"
      }
    ],
    version: 1
  },
  closed_lock_with_key: {
    id: "closed_lock_with_key",
    name: "Locked with Key",
    keywords: [
      "closed",
      "lock",
      "security",
      "privacy"
    ],
    skins: [
      {
        unified: "1f510",
        native: "🔐"
      }
    ],
    version: 1
  },
  key: {
    id: "key",
    name: "Key",
    keywords: [
      "lock",
      "door",
      "password"
    ],
    skins: [
      {
        unified: "1f511",
        native: "🔑"
      }
    ],
    version: 1
  },
  old_key: {
    id: "old_key",
    name: "Old Key",
    keywords: [
      "lock",
      "door",
      "password"
    ],
    skins: [
      {
        unified: "1f5dd-fe0f",
        native: "🗝️"
      }
    ],
    version: 1
  },
  hammer: {
    id: "hammer",
    name: "Hammer",
    keywords: [
      "tools",
      "build",
      "create"
    ],
    skins: [
      {
        unified: "1f528",
        native: "🔨"
      }
    ],
    version: 1
  },
  axe: {
    id: "axe",
    name: "Axe",
    keywords: [
      "tool",
      "chop",
      "cut"
    ],
    skins: [
      {
        unified: "1fa93",
        native: "🪓"
      }
    ],
    version: 12
  },
  pick: {
    id: "pick",
    name: "Pick",
    keywords: [
      "tools",
      "dig"
    ],
    skins: [
      {
        unified: "26cf-fe0f",
        native: "⛏️"
      }
    ],
    version: 1
  },
  hammer_and_pick: {
    id: "hammer_and_pick",
    name: "Hammer and Pick",
    keywords: [
      "tools",
      "build",
      "create"
    ],
    skins: [
      {
        unified: "2692-fe0f",
        native: "⚒️"
      }
    ],
    version: 1
  },
  hammer_and_wrench: {
    id: "hammer_and_wrench",
    name: "Hammer and Wrench",
    keywords: [
      "tools",
      "build",
      "create"
    ],
    skins: [
      {
        unified: "1f6e0-fe0f",
        native: "🛠️"
      }
    ],
    version: 1
  },
  dagger_knife: {
    id: "dagger_knife",
    name: "Dagger",
    keywords: [
      "knife",
      "weapon"
    ],
    skins: [
      {
        unified: "1f5e1-fe0f",
        native: "🗡️"
      }
    ],
    version: 1
  },
  crossed_swords: {
    id: "crossed_swords",
    name: "Crossed Swords",
    keywords: [
      "weapon"
    ],
    skins: [
      {
        unified: "2694-fe0f",
        native: "⚔️"
      }
    ],
    version: 1
  },
  bomb: {
    id: "bomb",
    name: "Bomb",
    keywords: [
      "boom",
      "explode",
      "explosion",
      "terrorism"
    ],
    skins: [
      {
        unified: "1f4a3",
        native: "💣"
      }
    ],
    version: 1
  },
  boomerang: {
    id: "boomerang",
    name: "Boomerang",
    keywords: [
      "weapon"
    ],
    skins: [
      {
        unified: "1fa83",
        native: "🪃"
      }
    ],
    version: 13
  },
  bow_and_arrow: {
    id: "bow_and_arrow",
    name: "Bow and Arrow",
    keywords: [
      "sports"
    ],
    skins: [
      {
        unified: "1f3f9",
        native: "🏹"
      }
    ],
    version: 1
  },
  shield: {
    id: "shield",
    name: "Shield",
    keywords: [
      "protection",
      "security"
    ],
    skins: [
      {
        unified: "1f6e1-fe0f",
        native: "🛡️"
      }
    ],
    version: 1
  },
  carpentry_saw: {
    id: "carpentry_saw",
    name: "Carpentry Saw",
    keywords: [
      "cut",
      "chop"
    ],
    skins: [
      {
        unified: "1fa9a",
        native: "🪚"
      }
    ],
    version: 13
  },
  wrench: {
    id: "wrench",
    name: "Wrench",
    keywords: [
      "tools",
      "diy",
      "ikea",
      "fix",
      "maintainer"
    ],
    skins: [
      {
        unified: "1f527",
        native: "🔧"
      }
    ],
    version: 1
  },
  screwdriver: {
    id: "screwdriver",
    name: "Screwdriver",
    keywords: [
      "tools"
    ],
    skins: [
      {
        unified: "1fa9b",
        native: "🪛"
      }
    ],
    version: 13
  },
  nut_and_bolt: {
    id: "nut_and_bolt",
    name: "Nut and Bolt",
    keywords: [
      "handy",
      "tools",
      "fix"
    ],
    skins: [
      {
        unified: "1f529",
        native: "🔩"
      }
    ],
    version: 1
  },
  gear: {
    id: "gear",
    name: "Gear",
    keywords: [
      "cog"
    ],
    skins: [
      {
        unified: "2699-fe0f",
        native: "⚙️"
      }
    ],
    version: 1
  },
  compression: {
    id: "compression",
    name: "Clamp",
    keywords: [
      "compression",
      "tool"
    ],
    skins: [
      {
        unified: "1f5dc-fe0f",
        native: "🗜️"
      }
    ],
    version: 1
  },
  scales: {
    id: "scales",
    name: "Balance Scale",
    keywords: [
      "scales",
      "law",
      "fairness",
      "weight"
    ],
    skins: [
      {
        unified: "2696-fe0f",
        native: "⚖️"
      }
    ],
    version: 1
  },
  probing_cane: {
    id: "probing_cane",
    name: "White Cane",
    keywords: [
      "probing",
      "accessibility"
    ],
    skins: [
      {
        unified: "1f9af",
        native: "🦯"
      }
    ],
    version: 12
  },
  link: {
    id: "link",
    name: "Link",
    keywords: [
      "rings",
      "url"
    ],
    skins: [
      {
        unified: "1f517",
        native: "🔗"
      }
    ],
    version: 1
  },
  chains: {
    id: "chains",
    name: "Chains",
    keywords: [
      "lock",
      "arrest"
    ],
    skins: [
      {
        unified: "26d3-fe0f",
        native: "⛓️"
      }
    ],
    version: 1
  },
  hook: {
    id: "hook",
    name: "Hook",
    keywords: [
      "tools"
    ],
    skins: [
      {
        unified: "1fa9d",
        native: "🪝"
      }
    ],
    version: 13
  },
  toolbox: {
    id: "toolbox",
    name: "Toolbox",
    keywords: [
      "tools",
      "diy",
      "fix",
      "maintainer",
      "mechanic"
    ],
    skins: [
      {
        unified: "1f9f0",
        native: "🧰"
      }
    ],
    version: 11
  },
  magnet: {
    id: "magnet",
    name: "Magnet",
    keywords: [
      "attraction",
      "magnetic"
    ],
    skins: [
      {
        unified: "1f9f2",
        native: "🧲"
      }
    ],
    version: 11
  },
  ladder: {
    id: "ladder",
    name: "Ladder",
    keywords: [
      "tools"
    ],
    skins: [
      {
        unified: "1fa9c",
        native: "🪜"
      }
    ],
    version: 13
  },
  alembic: {
    id: "alembic",
    name: "Alembic",
    keywords: [
      "distilling",
      "science",
      "experiment",
      "chemistry"
    ],
    skins: [
      {
        unified: "2697-fe0f",
        native: "⚗️"
      }
    ],
    version: 1
  },
  test_tube: {
    id: "test_tube",
    name: "Test Tube",
    keywords: [
      "chemistry",
      "experiment",
      "lab",
      "science"
    ],
    skins: [
      {
        unified: "1f9ea",
        native: "🧪"
      }
    ],
    version: 11
  },
  petri_dish: {
    id: "petri_dish",
    name: "Petri Dish",
    keywords: [
      "bacteria",
      "biology",
      "culture",
      "lab"
    ],
    skins: [
      {
        unified: "1f9eb",
        native: "🧫"
      }
    ],
    version: 11
  },
  dna: {
    id: "dna",
    name: "Dna",
    keywords: [
      "biologist",
      "genetics",
      "life"
    ],
    skins: [
      {
        unified: "1f9ec",
        native: "🧬"
      }
    ],
    version: 11
  },
  microscope: {
    id: "microscope",
    name: "Microscope",
    keywords: [
      "laboratory",
      "experiment",
      "zoomin",
      "science",
      "study"
    ],
    skins: [
      {
        unified: "1f52c",
        native: "🔬"
      }
    ],
    version: 1
  },
  telescope: {
    id: "telescope",
    name: "Telescope",
    keywords: [
      "stars",
      "space",
      "zoom",
      "science",
      "astronomy"
    ],
    skins: [
      {
        unified: "1f52d",
        native: "🔭"
      }
    ],
    version: 1
  },
  satellite_antenna: {
    id: "satellite_antenna",
    name: "Satellite Antenna",
    keywords: [
      "communication",
      "future",
      "radio",
      "space"
    ],
    skins: [
      {
        unified: "1f4e1",
        native: "📡"
      }
    ],
    version: 1
  },
  syringe: {
    id: "syringe",
    name: "Syringe",
    keywords: [
      "health",
      "hospital",
      "drugs",
      "blood",
      "medicine",
      "needle",
      "doctor",
      "nurse"
    ],
    skins: [
      {
        unified: "1f489",
        native: "💉"
      }
    ],
    version: 1
  },
  drop_of_blood: {
    id: "drop_of_blood",
    name: "Drop of Blood",
    keywords: [
      "period",
      "hurt",
      "harm",
      "wound"
    ],
    skins: [
      {
        unified: "1fa78",
        native: "🩸"
      }
    ],
    version: 12
  },
  pill: {
    id: "pill",
    name: "Pill",
    keywords: [
      "health",
      "medicine",
      "doctor",
      "pharmacy",
      "drug"
    ],
    skins: [
      {
        unified: "1f48a",
        native: "💊"
      }
    ],
    version: 1
  },
  adhesive_bandage: {
    id: "adhesive_bandage",
    name: "Adhesive Bandage",
    keywords: [
      "heal"
    ],
    skins: [
      {
        unified: "1fa79",
        native: "🩹"
      }
    ],
    version: 12
  },
  crutch: {
    id: "crutch",
    name: "Crutch",
    keywords: [
      "accessibility",
      "assist"
    ],
    skins: [
      {
        unified: "1fa7c",
        native: "🩼"
      }
    ],
    version: 14
  },
  stethoscope: {
    id: "stethoscope",
    name: "Stethoscope",
    keywords: [
      "health"
    ],
    skins: [
      {
        unified: "1fa7a",
        native: "🩺"
      }
    ],
    version: 12
  },
  "x-ray": {
    id: "x-ray",
    name: "X-Ray",
    keywords: [
      "x",
      "ray",
      "skeleton",
      "medicine"
    ],
    skins: [
      {
        unified: "1fa7b",
        native: "🩻"
      }
    ],
    version: 14
  },
  door: {
    id: "door",
    name: "Door",
    keywords: [
      "house",
      "entry",
      "exit"
    ],
    skins: [
      {
        unified: "1f6aa",
        native: "🚪"
      }
    ],
    version: 1
  },
  elevator: {
    id: "elevator",
    name: "Elevator",
    keywords: [
      "lift"
    ],
    skins: [
      {
        unified: "1f6d7",
        native: "🛗"
      }
    ],
    version: 13
  },
  mirror: {
    id: "mirror",
    name: "Mirror",
    keywords: [
      "reflection"
    ],
    skins: [
      {
        unified: "1fa9e",
        native: "🪞"
      }
    ],
    version: 13
  },
  window: {
    id: "window",
    name: "Window",
    keywords: [
      "scenery"
    ],
    skins: [
      {
        unified: "1fa9f",
        native: "🪟"
      }
    ],
    version: 13
  },
  bed: {
    id: "bed",
    name: "Bed",
    keywords: [
      "sleep",
      "rest"
    ],
    skins: [
      {
        unified: "1f6cf-fe0f",
        native: "🛏️"
      }
    ],
    version: 1
  },
  couch_and_lamp: {
    id: "couch_and_lamp",
    name: "Couch and Lamp",
    keywords: [
      "read",
      "chill"
    ],
    skins: [
      {
        unified: "1f6cb-fe0f",
        native: "🛋️"
      }
    ],
    version: 1
  },
  chair: {
    id: "chair",
    name: "Chair",
    keywords: [
      "sit",
      "furniture"
    ],
    skins: [
      {
        unified: "1fa91",
        native: "🪑"
      }
    ],
    version: 12
  },
  toilet: {
    id: "toilet",
    name: "Toilet",
    keywords: [
      "restroom",
      "wc",
      "washroom",
      "bathroom",
      "potty"
    ],
    skins: [
      {
        unified: "1f6bd",
        native: "🚽"
      }
    ],
    version: 1
  },
  plunger: {
    id: "plunger",
    name: "Plunger",
    keywords: [
      "toilet"
    ],
    skins: [
      {
        unified: "1faa0",
        native: "🪠"
      }
    ],
    version: 13
  },
  shower: {
    id: "shower",
    name: "Shower",
    keywords: [
      "clean",
      "water",
      "bathroom"
    ],
    skins: [
      {
        unified: "1f6bf",
        native: "🚿"
      }
    ],
    version: 1
  },
  bathtub: {
    id: "bathtub",
    name: "Bathtub",
    keywords: [
      "clean",
      "shower",
      "bathroom"
    ],
    skins: [
      {
        unified: "1f6c1",
        native: "🛁"
      }
    ],
    version: 1
  },
  mouse_trap: {
    id: "mouse_trap",
    name: "Mouse Trap",
    keywords: [
      "cheese"
    ],
    skins: [
      {
        unified: "1faa4",
        native: "🪤"
      }
    ],
    version: 13
  },
  razor: {
    id: "razor",
    name: "Razor",
    keywords: [
      "cut"
    ],
    skins: [
      {
        unified: "1fa92",
        native: "🪒"
      }
    ],
    version: 12
  },
  lotion_bottle: {
    id: "lotion_bottle",
    name: "Lotion Bottle",
    keywords: [
      "moisturizer",
      "sunscreen"
    ],
    skins: [
      {
        unified: "1f9f4",
        native: "🧴"
      }
    ],
    version: 11
  },
  safety_pin: {
    id: "safety_pin",
    name: "Safety Pin",
    keywords: [
      "diaper"
    ],
    skins: [
      {
        unified: "1f9f7",
        native: "🧷"
      }
    ],
    version: 11
  },
  broom: {
    id: "broom",
    name: "Broom",
    keywords: [
      "cleaning",
      "sweeping",
      "witch"
    ],
    skins: [
      {
        unified: "1f9f9",
        native: "🧹"
      }
    ],
    version: 11
  },
  basket: {
    id: "basket",
    name: "Basket",
    keywords: [
      "laundry"
    ],
    skins: [
      {
        unified: "1f9fa",
        native: "🧺"
      }
    ],
    version: 11
  },
  roll_of_paper: {
    id: "roll_of_paper",
    name: "Roll of Paper",
    keywords: [],
    skins: [
      {
        unified: "1f9fb",
        native: "🧻"
      }
    ],
    version: 11
  },
  bucket: {
    id: "bucket",
    name: "Bucket",
    keywords: [
      "water",
      "container"
    ],
    skins: [
      {
        unified: "1faa3",
        native: "🪣"
      }
    ],
    version: 13
  },
  soap: {
    id: "soap",
    name: "Soap",
    keywords: [
      "bar",
      "bathing",
      "cleaning",
      "lather"
    ],
    skins: [
      {
        unified: "1f9fc",
        native: "🧼"
      }
    ],
    version: 11
  },
  bubbles: {
    id: "bubbles",
    name: "Bubbles",
    keywords: [
      "soap",
      "fun",
      "carbonation",
      "sparkling"
    ],
    skins: [
      {
        unified: "1fae7",
        native: "🫧"
      }
    ],
    version: 14
  },
  toothbrush: {
    id: "toothbrush",
    name: "Toothbrush",
    keywords: [
      "hygiene",
      "dental"
    ],
    skins: [
      {
        unified: "1faa5",
        native: "🪥"
      }
    ],
    version: 13
  },
  sponge: {
    id: "sponge",
    name: "Sponge",
    keywords: [
      "absorbing",
      "cleaning",
      "porous"
    ],
    skins: [
      {
        unified: "1f9fd",
        native: "🧽"
      }
    ],
    version: 11
  },
  fire_extinguisher: {
    id: "fire_extinguisher",
    name: "Fire Extinguisher",
    keywords: [
      "quench"
    ],
    skins: [
      {
        unified: "1f9ef",
        native: "🧯"
      }
    ],
    version: 11
  },
  shopping_trolley: {
    id: "shopping_trolley",
    name: "Shopping Cart",
    keywords: [
      "trolley"
    ],
    skins: [
      {
        unified: "1f6d2",
        native: "🛒"
      }
    ],
    version: 3
  },
  smoking: {
    id: "smoking",
    name: "Cigarette",
    keywords: [
      "smoking",
      "kills",
      "tobacco",
      "joint",
      "smoke"
    ],
    skins: [
      {
        unified: "1f6ac",
        native: "🚬"
      }
    ],
    version: 1
  },
  coffin: {
    id: "coffin",
    name: "Coffin",
    keywords: [
      "vampire",
      "dead",
      "die",
      "death",
      "rip",
      "graveyard",
      "cemetery",
      "casket",
      "funeral",
      "box"
    ],
    skins: [
      {
        unified: "26b0-fe0f",
        native: "⚰️"
      }
    ],
    version: 1
  },
  headstone: {
    id: "headstone",
    name: "Headstone",
    keywords: [
      "death",
      "rip",
      "grave"
    ],
    skins: [
      {
        unified: "1faa6",
        native: "🪦"
      }
    ],
    version: 13
  },
  funeral_urn: {
    id: "funeral_urn",
    name: "Funeral Urn",
    keywords: [
      "dead",
      "die",
      "death",
      "rip",
      "ashes"
    ],
    skins: [
      {
        unified: "26b1-fe0f",
        native: "⚱️"
      }
    ],
    version: 1
  },
  nazar_amulet: {
    id: "nazar_amulet",
    name: "Nazar Amulet",
    keywords: [
      "bead",
      "charm"
    ],
    skins: [
      {
        unified: "1f9ff",
        native: "🧿"
      }
    ],
    version: 11
  },
  hamsa: {
    id: "hamsa",
    name: "Hamsa",
    keywords: [
      "religion",
      "protection"
    ],
    skins: [
      {
        unified: "1faac",
        native: "🪬"
      }
    ],
    version: 14
  },
  moyai: {
    id: "moyai",
    name: "Moai",
    keywords: [
      "moyai",
      "rock",
      "easter",
      "island"
    ],
    skins: [
      {
        unified: "1f5ff",
        native: "🗿"
      }
    ],
    version: 1
  },
  placard: {
    id: "placard",
    name: "Placard",
    keywords: [
      "announcement"
    ],
    skins: [
      {
        unified: "1faa7",
        native: "🪧"
      }
    ],
    version: 13
  },
  identification_card: {
    id: "identification_card",
    name: "Identification Card",
    keywords: [
      "document"
    ],
    skins: [
      {
        unified: "1faaa",
        native: "🪪"
      }
    ],
    version: 14
  },
  atm: {
    id: "atm",
    name: "Atm Sign",
    keywords: [
      "money",
      "sales",
      "cash",
      "blue",
      "square",
      "payment",
      "bank"
    ],
    skins: [
      {
        unified: "1f3e7",
        native: "🏧"
      }
    ],
    version: 1
  },
  put_litter_in_its_place: {
    id: "put_litter_in_its_place",
    name: "Litter in Bin Sign",
    keywords: [
      "put",
      "its",
      "place",
      "blue",
      "square",
      "human",
      "info"
    ],
    skins: [
      {
        unified: "1f6ae",
        native: "🚮"
      }
    ],
    version: 1
  },
  potable_water: {
    id: "potable_water",
    name: "Potable Water",
    keywords: [
      "blue",
      "square",
      "liquid",
      "restroom",
      "cleaning",
      "faucet"
    ],
    skins: [
      {
        unified: "1f6b0",
        native: "🚰"
      }
    ],
    version: 1
  },
  wheelchair: {
    id: "wheelchair",
    name: "Wheelchair Symbol",
    keywords: [
      "blue",
      "square",
      "disabled",
      "accessibility"
    ],
    skins: [
      {
        unified: "267f",
        native: "♿"
      }
    ],
    version: 1
  },
  mens: {
    id: "mens",
    name: "Men’s Room",
    keywords: [
      "mens",
      "men",
      "s",
      "toilet",
      "restroom",
      "wc",
      "blue",
      "square",
      "gender",
      "male"
    ],
    skins: [
      {
        unified: "1f6b9",
        native: "🚹"
      }
    ],
    version: 1
  },
  womens: {
    id: "womens",
    name: "Women’s Room",
    keywords: [
      "womens",
      "women",
      "s",
      "purple",
      "square",
      "woman",
      "female",
      "toilet",
      "loo",
      "restroom",
      "gender"
    ],
    skins: [
      {
        unified: "1f6ba",
        native: "🚺"
      }
    ],
    version: 1
  },
  restroom: {
    id: "restroom",
    name: "Restroom",
    keywords: [
      "blue",
      "square",
      "toilet",
      "refresh",
      "wc",
      "gender"
    ],
    skins: [
      {
        unified: "1f6bb",
        native: "🚻"
      }
    ],
    version: 1
  },
  baby_symbol: {
    id: "baby_symbol",
    name: "Baby Symbol",
    keywords: [
      "orange",
      "square",
      "child"
    ],
    skins: [
      {
        unified: "1f6bc",
        native: "🚼"
      }
    ],
    version: 1
  },
  wc: {
    id: "wc",
    name: "Water Closet",
    keywords: [
      "wc",
      "toilet",
      "restroom",
      "blue",
      "square"
    ],
    skins: [
      {
        unified: "1f6be",
        native: "🚾"
      }
    ],
    version: 1
  },
  passport_control: {
    id: "passport_control",
    name: "Passport Control",
    keywords: [
      "custom",
      "blue",
      "square"
    ],
    skins: [
      {
        unified: "1f6c2",
        native: "🛂"
      }
    ],
    version: 1
  },
  customs: {
    id: "customs",
    name: "Customs",
    keywords: [
      "passport",
      "border",
      "blue",
      "square"
    ],
    skins: [
      {
        unified: "1f6c3",
        native: "🛃"
      }
    ],
    version: 1
  },
  baggage_claim: {
    id: "baggage_claim",
    name: "Baggage Claim",
    keywords: [
      "blue",
      "square",
      "airport",
      "transport"
    ],
    skins: [
      {
        unified: "1f6c4",
        native: "🛄"
      }
    ],
    version: 1
  },
  left_luggage: {
    id: "left_luggage",
    name: "Left Luggage",
    keywords: [
      "blue",
      "square",
      "travel"
    ],
    skins: [
      {
        unified: "1f6c5",
        native: "🛅"
      }
    ],
    version: 1
  },
  warning: {
    id: "warning",
    name: "Warning",
    keywords: [
      "exclamation",
      "wip",
      "alert",
      "error",
      "problem",
      "issue"
    ],
    skins: [
      {
        unified: "26a0-fe0f",
        native: "⚠️"
      }
    ],
    version: 1
  },
  children_crossing: {
    id: "children_crossing",
    name: "Children Crossing",
    keywords: [
      "school",
      "warning",
      "danger",
      "sign",
      "driving",
      "yellow",
      "diamond"
    ],
    skins: [
      {
        unified: "1f6b8",
        native: "🚸"
      }
    ],
    version: 1
  },
  no_entry: {
    id: "no_entry",
    name: "No Entry",
    keywords: [
      "limit",
      "security",
      "privacy",
      "bad",
      "denied",
      "stop",
      "circle"
    ],
    skins: [
      {
        unified: "26d4",
        native: "⛔"
      }
    ],
    version: 1
  },
  no_entry_sign: {
    id: "no_entry_sign",
    name: "Prohibited",
    keywords: [
      "no",
      "entry",
      "sign",
      "forbid",
      "stop",
      "limit",
      "denied",
      "disallow",
      "circle"
    ],
    skins: [
      {
        unified: "1f6ab",
        native: "🚫"
      }
    ],
    version: 1
  },
  no_bicycles: {
    id: "no_bicycles",
    name: "No Bicycles",
    keywords: [
      "cyclist",
      "prohibited",
      "circle"
    ],
    skins: [
      {
        unified: "1f6b3",
        native: "🚳"
      }
    ],
    version: 1
  },
  no_smoking: {
    id: "no_smoking",
    name: "No Smoking",
    keywords: [
      "cigarette",
      "blue",
      "square",
      "smell",
      "smoke"
    ],
    skins: [
      {
        unified: "1f6ad",
        native: "🚭"
      }
    ],
    version: 1
  },
  do_not_litter: {
    id: "do_not_litter",
    name: "No Littering",
    keywords: [
      "do",
      "not",
      "litter",
      "trash",
      "bin",
      "garbage",
      "circle"
    ],
    skins: [
      {
        unified: "1f6af",
        native: "🚯"
      }
    ],
    version: 1
  },
  "non-potable_water": {
    id: "non-potable_water",
    name: "Non-Potable Water",
    keywords: [
      "non",
      "potable",
      "drink",
      "faucet",
      "tap",
      "circle"
    ],
    skins: [
      {
        unified: "1f6b1",
        native: "🚱"
      }
    ],
    version: 1
  },
  no_pedestrians: {
    id: "no_pedestrians",
    name: "No Pedestrians",
    keywords: [
      "rules",
      "crossing",
      "walking",
      "circle"
    ],
    skins: [
      {
        unified: "1f6b7",
        native: "🚷"
      }
    ],
    version: 1
  },
  no_mobile_phones: {
    id: "no_mobile_phones",
    name: "No Mobile Phones",
    keywords: [
      "iphone",
      "mute",
      "circle"
    ],
    skins: [
      {
        unified: "1f4f5",
        native: "📵"
      }
    ],
    version: 1
  },
  underage: {
    id: "underage",
    name: "No One Under Eighteen",
    keywords: [
      "underage",
      "18",
      "drink",
      "pub",
      "night",
      "minor",
      "circle"
    ],
    skins: [
      {
        unified: "1f51e",
        native: "🔞"
      }
    ],
    version: 1
  },
  radioactive_sign: {
    id: "radioactive_sign",
    name: "Radioactive",
    keywords: [
      "sign",
      "nuclear",
      "danger"
    ],
    skins: [
      {
        unified: "2622-fe0f",
        native: "☢️"
      }
    ],
    version: 1
  },
  biohazard_sign: {
    id: "biohazard_sign",
    name: "Biohazard",
    keywords: [
      "sign",
      "danger"
    ],
    skins: [
      {
        unified: "2623-fe0f",
        native: "☣️"
      }
    ],
    version: 1
  },
  arrow_up: {
    id: "arrow_up",
    name: "Up Arrow",
    keywords: [
      "blue",
      "square",
      "continue",
      "top",
      "direction"
    ],
    skins: [
      {
        unified: "2b06-fe0f",
        native: "⬆️"
      }
    ],
    version: 1
  },
  arrow_upper_right: {
    id: "arrow_upper_right",
    name: "Up-Right Arrow",
    keywords: [
      "upper",
      "right",
      "up",
      "blue",
      "square",
      "point",
      "direction",
      "diagonal",
      "northeast"
    ],
    skins: [
      {
        unified: "2197-fe0f",
        native: "↗️"
      }
    ],
    version: 1
  },
  arrow_right: {
    id: "arrow_right",
    name: "Right Arrow",
    keywords: [
      "blue",
      "square",
      "next"
    ],
    skins: [
      {
        unified: "27a1-fe0f",
        native: "➡️"
      }
    ],
    version: 1
  },
  arrow_lower_right: {
    id: "arrow_lower_right",
    name: "South East Arrow",
    keywords: [
      "lower",
      "right",
      "down",
      "blue",
      "square",
      "direction",
      "diagonal",
      "southeast"
    ],
    skins: [
      {
        unified: "2198-fe0f",
        native: "↘️"
      }
    ],
    version: 1
  },
  arrow_down: {
    id: "arrow_down",
    name: "Down Arrow",
    keywords: [
      "blue",
      "square",
      "direction",
      "bottom"
    ],
    skins: [
      {
        unified: "2b07-fe0f",
        native: "⬇️"
      }
    ],
    version: 1
  },
  arrow_lower_left: {
    id: "arrow_lower_left",
    name: "Down-Left Arrow",
    keywords: [
      "lower",
      "left",
      "down",
      "blue",
      "square",
      "direction",
      "diagonal",
      "southwest"
    ],
    skins: [
      {
        unified: "2199-fe0f",
        native: "↙️"
      }
    ],
    version: 1
  },
  arrow_left: {
    id: "arrow_left",
    name: "Left Arrow",
    keywords: [
      "blue",
      "square",
      "previous",
      "back"
    ],
    skins: [
      {
        unified: "2b05-fe0f",
        native: "⬅️"
      }
    ],
    version: 1
  },
  arrow_upper_left: {
    id: "arrow_upper_left",
    name: "Up-Left Arrow",
    keywords: [
      "upper",
      "left",
      "up",
      "blue",
      "square",
      "point",
      "direction",
      "diagonal",
      "northwest"
    ],
    skins: [
      {
        unified: "2196-fe0f",
        native: "↖️"
      }
    ],
    version: 1
  },
  arrow_up_down: {
    id: "arrow_up_down",
    name: "Up Down Arrow",
    keywords: [
      "blue",
      "square",
      "direction",
      "way",
      "vertical"
    ],
    skins: [
      {
        unified: "2195-fe0f",
        native: "↕️"
      }
    ],
    version: 1
  },
  left_right_arrow: {
    id: "left_right_arrow",
    name: "Left Right Arrow",
    keywords: [
      "shape",
      "direction",
      "horizontal",
      "sideways"
    ],
    skins: [
      {
        unified: "2194-fe0f",
        native: "↔️"
      }
    ],
    version: 1
  },
  leftwards_arrow_with_hook: {
    id: "leftwards_arrow_with_hook",
    name: "Right Arrow Curving Left",
    keywords: [
      "leftwards",
      "with",
      "hook",
      "back",
      "return",
      "blue",
      "square",
      "undo",
      "enter"
    ],
    skins: [
      {
        unified: "21a9-fe0f",
        native: "↩️"
      }
    ],
    version: 1
  },
  arrow_right_hook: {
    id: "arrow_right_hook",
    name: "Left Arrow Curving Right",
    keywords: [
      "hook",
      "blue",
      "square",
      "return",
      "rotate",
      "direction"
    ],
    skins: [
      {
        unified: "21aa-fe0f",
        native: "↪️"
      }
    ],
    version: 1
  },
  arrow_heading_up: {
    id: "arrow_heading_up",
    name: "Right Arrow Curving Up",
    keywords: [
      "heading",
      "blue",
      "square",
      "direction",
      "top"
    ],
    skins: [
      {
        unified: "2934-fe0f",
        native: "⤴️"
      }
    ],
    version: 1
  },
  arrow_heading_down: {
    id: "arrow_heading_down",
    name: "Right Arrow Curving Down",
    keywords: [
      "heading",
      "blue",
      "square",
      "direction",
      "bottom"
    ],
    skins: [
      {
        unified: "2935-fe0f",
        native: "⤵️"
      }
    ],
    version: 1
  },
  arrows_clockwise: {
    id: "arrows_clockwise",
    name: "Clockwise Vertical Arrows",
    keywords: [
      "sync",
      "cycle",
      "round",
      "repeat"
    ],
    skins: [
      {
        unified: "1f503",
        native: "🔃"
      }
    ],
    version: 1
  },
  arrows_counterclockwise: {
    id: "arrows_counterclockwise",
    name: "Counterclockwise Arrows Button",
    keywords: [
      "blue",
      "square",
      "sync",
      "cycle"
    ],
    skins: [
      {
        unified: "1f504",
        native: "🔄"
      }
    ],
    version: 1
  },
  back: {
    id: "back",
    name: "Back Arrow",
    keywords: [
      "words",
      "return"
    ],
    skins: [
      {
        unified: "1f519",
        native: "🔙"
      }
    ],
    version: 1
  },
  end: {
    id: "end",
    name: "End Arrow",
    keywords: [
      "words"
    ],
    skins: [
      {
        unified: "1f51a",
        native: "🔚"
      }
    ],
    version: 1
  },
  on: {
    id: "on",
    name: "On! Arrow",
    keywords: [
      "on",
      "words"
    ],
    skins: [
      {
        unified: "1f51b",
        native: "🔛"
      }
    ],
    version: 1
  },
  soon: {
    id: "soon",
    name: "Soon Arrow",
    keywords: [
      "words"
    ],
    skins: [
      {
        unified: "1f51c",
        native: "🔜"
      }
    ],
    version: 1
  },
  top: {
    id: "top",
    name: "Top Arrow",
    keywords: [
      "words",
      "blue",
      "square"
    ],
    skins: [
      {
        unified: "1f51d",
        native: "🔝"
      }
    ],
    version: 1
  },
  place_of_worship: {
    id: "place_of_worship",
    name: "Place of Worship",
    keywords: [
      "religion",
      "church",
      "temple",
      "prayer"
    ],
    skins: [
      {
        unified: "1f6d0",
        native: "🛐"
      }
    ],
    version: 1
  },
  atom_symbol: {
    id: "atom_symbol",
    name: "Atom Symbol",
    keywords: [
      "science",
      "physics",
      "chemistry"
    ],
    skins: [
      {
        unified: "269b-fe0f",
        native: "⚛️"
      }
    ],
    version: 1
  },
  om_symbol: {
    id: "om_symbol",
    name: "Om",
    keywords: [
      "symbol",
      "hinduism",
      "buddhism",
      "sikhism",
      "jainism"
    ],
    skins: [
      {
        unified: "1f549-fe0f",
        native: "🕉️"
      }
    ],
    version: 1
  },
  star_of_david: {
    id: "star_of_david",
    name: "Star of David",
    keywords: [
      "judaism"
    ],
    skins: [
      {
        unified: "2721-fe0f",
        native: "✡️"
      }
    ],
    version: 1
  },
  wheel_of_dharma: {
    id: "wheel_of_dharma",
    name: "Wheel of Dharma",
    keywords: [
      "hinduism",
      "buddhism",
      "sikhism",
      "jainism"
    ],
    skins: [
      {
        unified: "2638-fe0f",
        native: "☸️"
      }
    ],
    version: 1
  },
  yin_yang: {
    id: "yin_yang",
    name: "Yin Yang",
    keywords: [
      "balance"
    ],
    skins: [
      {
        unified: "262f-fe0f",
        native: "☯️"
      }
    ],
    version: 1
  },
  latin_cross: {
    id: "latin_cross",
    name: "Latin Cross",
    keywords: [
      "christianity"
    ],
    skins: [
      {
        unified: "271d-fe0f",
        native: "✝️"
      }
    ],
    version: 1
  },
  orthodox_cross: {
    id: "orthodox_cross",
    name: "Orthodox Cross",
    keywords: [
      "suppedaneum",
      "religion"
    ],
    skins: [
      {
        unified: "2626-fe0f",
        native: "☦️"
      }
    ],
    version: 1
  },
  star_and_crescent: {
    id: "star_and_crescent",
    name: "Star and Crescent",
    keywords: [
      "islam"
    ],
    skins: [
      {
        unified: "262a-fe0f",
        native: "☪️"
      }
    ],
    version: 1
  },
  peace_symbol: {
    id: "peace_symbol",
    name: "Peace Symbol",
    keywords: [
      "hippie"
    ],
    skins: [
      {
        unified: "262e-fe0f",
        native: "☮️"
      }
    ],
    version: 1
  },
  menorah_with_nine_branches: {
    id: "menorah_with_nine_branches",
    name: "Menorah",
    keywords: [
      "with",
      "nine",
      "branches",
      "hanukkah",
      "candles",
      "jewish"
    ],
    skins: [
      {
        unified: "1f54e",
        native: "🕎"
      }
    ],
    version: 1
  },
  six_pointed_star: {
    id: "six_pointed_star",
    name: "Dotted Six-Pointed Star",
    keywords: [
      "six",
      "pointed",
      "purple",
      "square",
      "religion",
      "jewish",
      "hexagram"
    ],
    skins: [
      {
        unified: "1f52f",
        native: "🔯"
      }
    ],
    version: 1
  },
  khanda: {
    id: "khanda",
    name: "Khanda",
    keywords: [
      "Sikhism",
      "religion"
    ],
    skins: [
      {
        unified: "1faaf",
        native: "🪯"
      }
    ],
    version: 15
  },
  aries: {
    id: "aries",
    name: "Aries",
    keywords: [
      "sign",
      "purple",
      "square",
      "zodiac",
      "astrology"
    ],
    skins: [
      {
        unified: "2648",
        native: "♈"
      }
    ],
    version: 1
  },
  taurus: {
    id: "taurus",
    name: "Taurus",
    keywords: [
      "purple",
      "square",
      "sign",
      "zodiac",
      "astrology"
    ],
    skins: [
      {
        unified: "2649",
        native: "♉"
      }
    ],
    version: 1
  },
  gemini: {
    id: "gemini",
    name: "Gemini",
    keywords: [
      "sign",
      "zodiac",
      "purple",
      "square",
      "astrology"
    ],
    skins: [
      {
        unified: "264a",
        native: "♊"
      }
    ],
    version: 1
  },
  cancer: {
    id: "cancer",
    name: "Cancer",
    keywords: [
      "sign",
      "zodiac",
      "purple",
      "square",
      "astrology"
    ],
    skins: [
      {
        unified: "264b",
        native: "♋"
      }
    ],
    version: 1
  },
  leo: {
    id: "leo",
    name: "Leo",
    keywords: [
      "sign",
      "purple",
      "square",
      "zodiac",
      "astrology"
    ],
    skins: [
      {
        unified: "264c",
        native: "♌"
      }
    ],
    version: 1
  },
  virgo: {
    id: "virgo",
    name: "Virgo",
    keywords: [
      "sign",
      "zodiac",
      "purple",
      "square",
      "astrology"
    ],
    skins: [
      {
        unified: "264d",
        native: "♍"
      }
    ],
    version: 1
  },
  libra: {
    id: "libra",
    name: "Libra",
    keywords: [
      "sign",
      "purple",
      "square",
      "zodiac",
      "astrology"
    ],
    skins: [
      {
        unified: "264e",
        native: "♎"
      }
    ],
    version: 1
  },
  scorpius: {
    id: "scorpius",
    name: "Scorpio",
    keywords: [
      "scorpius",
      "sign",
      "zodiac",
      "purple",
      "square",
      "astrology"
    ],
    skins: [
      {
        unified: "264f",
        native: "♏"
      }
    ],
    version: 1
  },
  sagittarius: {
    id: "sagittarius",
    name: "Sagittarius",
    keywords: [
      "sign",
      "zodiac",
      "purple",
      "square",
      "astrology"
    ],
    skins: [
      {
        unified: "2650",
        native: "♐"
      }
    ],
    version: 1
  },
  capricorn: {
    id: "capricorn",
    name: "Capricorn",
    keywords: [
      "sign",
      "zodiac",
      "purple",
      "square",
      "astrology"
    ],
    skins: [
      {
        unified: "2651",
        native: "♑"
      }
    ],
    version: 1
  },
  aquarius: {
    id: "aquarius",
    name: "Aquarius",
    keywords: [
      "sign",
      "purple",
      "square",
      "zodiac",
      "astrology"
    ],
    skins: [
      {
        unified: "2652",
        native: "♒"
      }
    ],
    version: 1
  },
  pisces: {
    id: "pisces",
    name: "Pisces",
    keywords: [
      "purple",
      "square",
      "sign",
      "zodiac",
      "astrology"
    ],
    skins: [
      {
        unified: "2653",
        native: "♓"
      }
    ],
    version: 1
  },
  ophiuchus: {
    id: "ophiuchus",
    name: "Ophiuchus",
    keywords: [
      "sign",
      "purple",
      "square",
      "constellation",
      "astrology"
    ],
    skins: [
      {
        unified: "26ce",
        native: "⛎"
      }
    ],
    version: 1
  },
  twisted_rightwards_arrows: {
    id: "twisted_rightwards_arrows",
    name: "Shuffle Tracks Button",
    keywords: [
      "twisted",
      "rightwards",
      "arrows",
      "blue",
      "square",
      "music",
      "random"
    ],
    skins: [
      {
        unified: "1f500",
        native: "🔀"
      }
    ],
    version: 1
  },
  repeat: {
    id: "repeat",
    name: "Repeat Button",
    keywords: [
      "loop",
      "record"
    ],
    skins: [
      {
        unified: "1f501",
        native: "🔁"
      }
    ],
    version: 1
  },
  repeat_one: {
    id: "repeat_one",
    name: "Repeat Single Button",
    keywords: [
      "one",
      "blue",
      "square",
      "loop"
    ],
    skins: [
      {
        unified: "1f502",
        native: "🔂"
      }
    ],
    version: 1
  },
  arrow_forward: {
    id: "arrow_forward",
    name: "Play Button",
    keywords: [
      "arrow",
      "forward",
      "blue",
      "square",
      "right",
      "direction"
    ],
    skins: [
      {
        unified: "25b6-fe0f",
        native: "▶️"
      }
    ],
    version: 1
  },
  fast_forward: {
    id: "fast_forward",
    name: "Fast-Forward Button",
    keywords: [
      "fast",
      "forward",
      "blue",
      "square",
      "play",
      "speed",
      "continue"
    ],
    skins: [
      {
        unified: "23e9",
        native: "⏩"
      }
    ],
    version: 1
  },
  black_right_pointing_double_triangle_with_vertical_bar: {
    id: "black_right_pointing_double_triangle_with_vertical_bar",
    name: "Next Track Button",
    keywords: [
      "black",
      "right",
      "pointing",
      "double",
      "triangle",
      "with",
      "vertical",
      "bar",
      "forward",
      "blue",
      "square"
    ],
    skins: [
      {
        unified: "23ed-fe0f",
        native: "⏭️"
      }
    ],
    version: 1
  },
  black_right_pointing_triangle_with_double_vertical_bar: {
    id: "black_right_pointing_triangle_with_double_vertical_bar",
    name: "Play or Pause Button",
    keywords: [
      "black",
      "right",
      "pointing",
      "triangle",
      "with",
      "double",
      "vertical",
      "bar",
      "blue",
      "square"
    ],
    skins: [
      {
        unified: "23ef-fe0f",
        native: "⏯️"
      }
    ],
    version: 1
  },
  arrow_backward: {
    id: "arrow_backward",
    name: "Reverse Button",
    keywords: [
      "arrow",
      "backward",
      "blue",
      "square",
      "left",
      "direction"
    ],
    skins: [
      {
        unified: "25c0-fe0f",
        native: "◀️"
      }
    ],
    version: 1
  },
  rewind: {
    id: "rewind",
    name: "Fast Reverse Button",
    keywords: [
      "rewind",
      "play",
      "blue",
      "square"
    ],
    skins: [
      {
        unified: "23ea",
        native: "⏪"
      }
    ],
    version: 1
  },
  black_left_pointing_double_triangle_with_vertical_bar: {
    id: "black_left_pointing_double_triangle_with_vertical_bar",
    name: "Last Track Button",
    keywords: [
      "black",
      "left",
      "pointing",
      "double",
      "triangle",
      "with",
      "vertical",
      "bar",
      "backward"
    ],
    skins: [
      {
        unified: "23ee-fe0f",
        native: "⏮️"
      }
    ],
    version: 1
  },
  arrow_up_small: {
    id: "arrow_up_small",
    name: "Upwards Button",
    keywords: [
      "arrow",
      "up",
      "small",
      "blue",
      "square",
      "triangle",
      "direction",
      "point",
      "forward",
      "top"
    ],
    skins: [
      {
        unified: "1f53c",
        native: "🔼"
      }
    ],
    version: 1
  },
  arrow_double_up: {
    id: "arrow_double_up",
    name: "Fast Up Button",
    keywords: [
      "arrow",
      "double",
      "blue",
      "square",
      "direction",
      "top"
    ],
    skins: [
      {
        unified: "23eb",
        native: "⏫"
      }
    ],
    version: 1
  },
  arrow_down_small: {
    id: "arrow_down_small",
    name: "Downwards Button",
    keywords: [
      "arrow",
      "down",
      "small",
      "blue",
      "square",
      "direction",
      "bottom"
    ],
    skins: [
      {
        unified: "1f53d",
        native: "🔽"
      }
    ],
    version: 1
  },
  arrow_double_down: {
    id: "arrow_double_down",
    name: "Fast Down Button",
    keywords: [
      "arrow",
      "double",
      "blue",
      "square",
      "direction",
      "bottom"
    ],
    skins: [
      {
        unified: "23ec",
        native: "⏬"
      }
    ],
    version: 1
  },
  double_vertical_bar: {
    id: "double_vertical_bar",
    name: "Pause Button",
    keywords: [
      "double",
      "vertical",
      "bar",
      "blue",
      "square"
    ],
    skins: [
      {
        unified: "23f8-fe0f",
        native: "⏸️"
      }
    ],
    version: 1
  },
  black_square_for_stop: {
    id: "black_square_for_stop",
    name: "Stop Button",
    keywords: [
      "black",
      "square",
      "for",
      "blue"
    ],
    skins: [
      {
        unified: "23f9-fe0f",
        native: "⏹️"
      }
    ],
    version: 1
  },
  black_circle_for_record: {
    id: "black_circle_for_record",
    name: "Record Button",
    keywords: [
      "black",
      "circle",
      "for",
      "blue",
      "square"
    ],
    skins: [
      {
        unified: "23fa-fe0f",
        native: "⏺️"
      }
    ],
    version: 1
  },
  eject: {
    id: "eject",
    name: "Eject Button",
    keywords: [
      "blue",
      "square"
    ],
    skins: [
      {
        unified: "23cf-fe0f",
        native: "⏏️"
      }
    ],
    version: 1
  },
  cinema: {
    id: "cinema",
    name: "Cinema",
    keywords: [
      "blue",
      "square",
      "record",
      "film",
      "movie",
      "curtain",
      "stage",
      "theater"
    ],
    skins: [
      {
        unified: "1f3a6",
        native: "🎦"
      }
    ],
    version: 1
  },
  low_brightness: {
    id: "low_brightness",
    name: "Dim Button",
    keywords: [
      "low",
      "brightness",
      "sun",
      "afternoon",
      "warm",
      "summer"
    ],
    skins: [
      {
        unified: "1f505",
        native: "🔅"
      }
    ],
    version: 1
  },
  high_brightness: {
    id: "high_brightness",
    name: "Bright Button",
    keywords: [
      "high",
      "brightness",
      "sun",
      "light"
    ],
    skins: [
      {
        unified: "1f506",
        native: "🔆"
      }
    ],
    version: 1
  },
  signal_strength: {
    id: "signal_strength",
    name: "Antenna Bars",
    keywords: [
      "signal",
      "strength",
      "blue",
      "square",
      "reception",
      "phone",
      "internet",
      "connection",
      "wifi",
      "bluetooth"
    ],
    skins: [
      {
        unified: "1f4f6",
        native: "📶"
      }
    ],
    version: 1
  },
  wireless: {
    id: "wireless",
    name: "Wireless",
    keywords: [
      "wifi",
      "internet",
      "contactless",
      "signal"
    ],
    skins: [
      {
        unified: "1f6dc",
        native: "🛜"
      }
    ],
    version: 15
  },
  vibration_mode: {
    id: "vibration_mode",
    name: "Vibration Mode",
    keywords: [
      "orange",
      "square",
      "phone"
    ],
    skins: [
      {
        unified: "1f4f3",
        native: "📳"
      }
    ],
    version: 1
  },
  mobile_phone_off: {
    id: "mobile_phone_off",
    name: "Mobile Phone off",
    keywords: [
      "mute",
      "orange",
      "square",
      "silence",
      "quiet"
    ],
    skins: [
      {
        unified: "1f4f4",
        native: "📴"
      }
    ],
    version: 1
  },
  female_sign: {
    id: "female_sign",
    name: "Female Sign",
    keywords: [
      "woman",
      "women",
      "lady",
      "girl"
    ],
    skins: [
      {
        unified: "2640-fe0f",
        native: "♀️"
      }
    ],
    version: 4
  },
  male_sign: {
    id: "male_sign",
    name: "Male Sign",
    keywords: [
      "man",
      "boy",
      "men"
    ],
    skins: [
      {
        unified: "2642-fe0f",
        native: "♂️"
      }
    ],
    version: 4
  },
  transgender_symbol: {
    id: "transgender_symbol",
    name: "Transgender Symbol",
    keywords: [
      "lgbtq"
    ],
    skins: [
      {
        unified: "26a7-fe0f",
        native: "⚧️"
      }
    ],
    version: 13
  },
  heavy_multiplication_x: {
    id: "heavy_multiplication_x",
    name: "Multiply",
    keywords: [
      "heavy",
      "multiplication",
      "x",
      "sign",
      "math",
      "calculation"
    ],
    skins: [
      {
        unified: "2716-fe0f",
        native: "✖️"
      }
    ],
    version: 1
  },
  heavy_plus_sign: {
    id: "heavy_plus_sign",
    name: "Plus",
    keywords: [
      "heavy",
      "sign",
      "math",
      "calculation",
      "addition",
      "more",
      "increase"
    ],
    skins: [
      {
        unified: "2795",
        native: "➕"
      }
    ],
    version: 1
  },
  heavy_minus_sign: {
    id: "heavy_minus_sign",
    name: "Minus",
    keywords: [
      "heavy",
      "sign",
      "math",
      "calculation",
      "subtract",
      "less"
    ],
    skins: [
      {
        unified: "2796",
        native: "➖"
      }
    ],
    version: 1
  },
  heavy_division_sign: {
    id: "heavy_division_sign",
    name: "Divide",
    keywords: [
      "heavy",
      "division",
      "sign",
      "math",
      "calculation"
    ],
    skins: [
      {
        unified: "2797",
        native: "➗"
      }
    ],
    version: 1
  },
  heavy_equals_sign: {
    id: "heavy_equals_sign",
    name: "Heavy Equals Sign",
    keywords: [
      "math"
    ],
    skins: [
      {
        unified: "1f7f0",
        native: "🟰"
      }
    ],
    version: 14
  },
  infinity: {
    id: "infinity",
    name: "Infinity",
    keywords: [
      "forever"
    ],
    skins: [
      {
        unified: "267e-fe0f",
        native: "♾️"
      }
    ],
    version: 11
  },
  bangbang: {
    id: "bangbang",
    name: "Double Exclamation Mark",
    keywords: [
      "bangbang",
      "surprise"
    ],
    skins: [
      {
        unified: "203c-fe0f",
        native: "‼️"
      }
    ],
    version: 1
  },
  interrobang: {
    id: "interrobang",
    name: "Exclamation Question Mark",
    keywords: [
      "interrobang",
      "wat",
      "punctuation",
      "surprise"
    ],
    skins: [
      {
        unified: "2049-fe0f",
        native: "⁉️"
      }
    ],
    version: 1
  },
  question: {
    id: "question",
    name: "Red Question Mark",
    keywords: [
      "doubt",
      "confused"
    ],
    skins: [
      {
        unified: "2753",
        native: "❓"
      }
    ],
    version: 1
  },
  grey_question: {
    id: "grey_question",
    name: "White Question Mark",
    keywords: [
      "grey",
      "doubts",
      "gray",
      "huh",
      "confused"
    ],
    skins: [
      {
        unified: "2754",
        native: "❔"
      }
    ],
    version: 1
  },
  grey_exclamation: {
    id: "grey_exclamation",
    name: "White Exclamation Mark",
    keywords: [
      "grey",
      "surprise",
      "punctuation",
      "gray",
      "wow",
      "warning"
    ],
    skins: [
      {
        unified: "2755",
        native: "❕"
      }
    ],
    version: 1
  },
  exclamation: {
    id: "exclamation",
    name: "Red Exclamation Mark",
    keywords: [
      "heavy",
      "danger",
      "surprise",
      "punctuation",
      "wow",
      "warning"
    ],
    skins: [
      {
        unified: "2757",
        native: "❗"
      }
    ],
    version: 1
  },
  wavy_dash: {
    id: "wavy_dash",
    name: "Wavy Dash",
    keywords: [
      "draw",
      "line",
      "moustache",
      "mustache",
      "squiggle",
      "scribble"
    ],
    skins: [
      {
        unified: "3030-fe0f",
        native: "〰️"
      }
    ],
    version: 1
  },
  currency_exchange: {
    id: "currency_exchange",
    name: "Currency Exchange",
    keywords: [
      "money",
      "sales",
      "dollar",
      "travel"
    ],
    skins: [
      {
        unified: "1f4b1",
        native: "💱"
      }
    ],
    version: 1
  },
  heavy_dollar_sign: {
    id: "heavy_dollar_sign",
    name: "Heavy Dollar Sign",
    keywords: [
      "money",
      "sales",
      "payment",
      "currency",
      "buck"
    ],
    skins: [
      {
        unified: "1f4b2",
        native: "💲"
      }
    ],
    version: 1
  },
  medical_symbol: {
    id: "medical_symbol",
    name: "Medical Symbol",
    keywords: [
      "staff",
      "of",
      "aesculapius",
      "health",
      "hospital"
    ],
    skins: [
      {
        unified: "2695-fe0f",
        native: "⚕️"
      }
    ],
    version: 4
  },
  recycle: {
    id: "recycle",
    name: "Recycling Symbol",
    keywords: [
      "recycle",
      "arrow",
      "environment",
      "garbage",
      "trash"
    ],
    skins: [
      {
        unified: "267b-fe0f",
        native: "♻️"
      }
    ],
    version: 1
  },
  fleur_de_lis: {
    id: "fleur_de_lis",
    name: "Fleur-De-Lis",
    keywords: [
      "fleur",
      "de",
      "lis",
      "decorative",
      "scout"
    ],
    skins: [
      {
        unified: "269c-fe0f",
        native: "⚜️"
      }
    ],
    version: 1
  },
  trident: {
    id: "trident",
    name: "Trident Emblem",
    keywords: [
      "weapon",
      "spear"
    ],
    skins: [
      {
        unified: "1f531",
        native: "🔱"
      }
    ],
    version: 1
  },
  name_badge: {
    id: "name_badge",
    name: "Name Badge",
    keywords: [
      "fire",
      "forbid"
    ],
    skins: [
      {
        unified: "1f4db",
        native: "📛"
      }
    ],
    version: 1
  },
  beginner: {
    id: "beginner",
    name: "Japanese Symbol for Beginner",
    keywords: [
      "badge",
      "shield"
    ],
    skins: [
      {
        unified: "1f530",
        native: "🔰"
      }
    ],
    version: 1
  },
  o: {
    id: "o",
    name: "Hollow Red Circle",
    keywords: [
      "o",
      "round"
    ],
    skins: [
      {
        unified: "2b55",
        native: "⭕"
      }
    ],
    version: 1
  },
  white_check_mark: {
    id: "white_check_mark",
    name: "Check Mark Button",
    keywords: [
      "white",
      "green",
      "square",
      "ok",
      "agree",
      "vote",
      "election",
      "answer",
      "tick"
    ],
    skins: [
      {
        unified: "2705",
        native: "✅"
      }
    ],
    version: 1
  },
  ballot_box_with_check: {
    id: "ballot_box_with_check",
    name: "Check Box with Check",
    keywords: [
      "ballot",
      "ok",
      "agree",
      "confirm",
      "black",
      "square",
      "vote",
      "election",
      "yes",
      "tick"
    ],
    skins: [
      {
        unified: "2611-fe0f",
        native: "☑️"
      }
    ],
    version: 1
  },
  heavy_check_mark: {
    id: "heavy_check_mark",
    name: "Check Mark",
    keywords: [
      "heavy",
      "ok",
      "nike",
      "answer",
      "yes",
      "tick"
    ],
    skins: [
      {
        unified: "2714-fe0f",
        native: "✔️"
      }
    ],
    version: 1
  },
  x: {
    id: "x",
    name: "Cross Mark",
    keywords: [
      "x",
      "no",
      "delete",
      "remove",
      "cancel",
      "red"
    ],
    skins: [
      {
        unified: "274c",
        native: "❌"
      }
    ],
    version: 1
  },
  negative_squared_cross_mark: {
    id: "negative_squared_cross_mark",
    name: "Cross Mark Button",
    keywords: [
      "negative",
      "squared",
      "x",
      "green",
      "square",
      "no",
      "deny"
    ],
    skins: [
      {
        unified: "274e",
        native: "❎"
      }
    ],
    version: 1
  },
  curly_loop: {
    id: "curly_loop",
    name: "Curly Loop",
    keywords: [
      "scribble",
      "draw",
      "shape",
      "squiggle"
    ],
    skins: [
      {
        unified: "27b0",
        native: "➰"
      }
    ],
    version: 1
  },
  loop: {
    id: "loop",
    name: "Double Curly Loop",
    keywords: [
      "tape",
      "cassette"
    ],
    skins: [
      {
        unified: "27bf",
        native: "➿"
      }
    ],
    version: 1
  },
  part_alternation_mark: {
    id: "part_alternation_mark",
    name: "Part Alternation Mark",
    keywords: [
      "graph",
      "presentation",
      "stats",
      "business",
      "economics",
      "bad"
    ],
    skins: [
      {
        unified: "303d-fe0f",
        native: "〽️"
      }
    ],
    version: 1
  },
  eight_spoked_asterisk: {
    id: "eight_spoked_asterisk",
    name: "Eight Spoked Asterisk",
    keywords: [
      "star",
      "sparkle",
      "green",
      "square"
    ],
    skins: [
      {
        unified: "2733-fe0f",
        native: "✳️"
      }
    ],
    version: 1
  },
  eight_pointed_black_star: {
    id: "eight_pointed_black_star",
    name: "Eight-Pointed Star",
    keywords: [
      "eight",
      "pointed",
      "black",
      "orange",
      "square",
      "shape",
      "polygon"
    ],
    skins: [
      {
        unified: "2734-fe0f",
        native: "✴️"
      }
    ],
    version: 1
  },
  sparkle: {
    id: "sparkle",
    name: "Sparkle",
    keywords: [
      "stars",
      "green",
      "square",
      "awesome",
      "good",
      "fireworks"
    ],
    skins: [
      {
        unified: "2747-fe0f",
        native: "❇️"
      }
    ],
    version: 1
  },
  copyright: {
    id: "copyright",
    name: "Copyright",
    keywords: [
      "ip",
      "license",
      "circle",
      "law",
      "legal"
    ],
    skins: [
      {
        unified: "00a9-fe0f",
        native: "©️"
      }
    ],
    version: 1
  },
  registered: {
    id: "registered",
    name: "Registered",
    keywords: [
      "alphabet",
      "circle"
    ],
    skins: [
      {
        unified: "00ae-fe0f",
        native: "®️"
      }
    ],
    version: 1
  },
  tm: {
    id: "tm",
    name: "Trade Mark",
    keywords: [
      "tm",
      "trademark",
      "brand",
      "law",
      "legal"
    ],
    skins: [
      {
        unified: "2122-fe0f",
        native: "™️"
      }
    ],
    version: 1
  },
  hash: {
    id: "hash",
    name: "Hash Key",
    keywords: [
      "keycap",
      "",
      "symbol",
      "blue",
      "square",
      "twitter"
    ],
    skins: [
      {
        unified: "0023-fe0f-20e3",
        native: "#️⃣"
      }
    ],
    version: 1
  },
  keycap_star: {
    id: "keycap_star",
    name: "Keycap: *",
    keywords: [
      "keycap",
      "star",
      ""
    ],
    skins: [
      {
        unified: "002a-fe0f-20e3",
        native: "*️⃣"
      }
    ],
    version: 2
  },
  zero: {
    id: "zero",
    name: "Keycap 0",
    keywords: [
      "zero",
      "numbers",
      "blue",
      "square",
      "null"
    ],
    skins: [
      {
        unified: "0030-fe0f-20e3",
        native: "0️⃣"
      }
    ],
    version: 1
  },
  one: {
    id: "one",
    name: "Keycap 1",
    keywords: [
      "one",
      "blue",
      "square",
      "numbers"
    ],
    skins: [
      {
        unified: "0031-fe0f-20e3",
        native: "1️⃣"
      }
    ],
    version: 1
  },
  two: {
    id: "two",
    name: "Keycap 2",
    keywords: [
      "two",
      "numbers",
      "prime",
      "blue",
      "square"
    ],
    skins: [
      {
        unified: "0032-fe0f-20e3",
        native: "2️⃣"
      }
    ],
    version: 1
  },
  three: {
    id: "three",
    name: "Keycap 3",
    keywords: [
      "three",
      "numbers",
      "prime",
      "blue",
      "square"
    ],
    skins: [
      {
        unified: "0033-fe0f-20e3",
        native: "3️⃣"
      }
    ],
    version: 1
  },
  four: {
    id: "four",
    name: "Keycap 4",
    keywords: [
      "four",
      "numbers",
      "blue",
      "square"
    ],
    skins: [
      {
        unified: "0034-fe0f-20e3",
        native: "4️⃣"
      }
    ],
    version: 1
  },
  five: {
    id: "five",
    name: "Keycap 5",
    keywords: [
      "five",
      "numbers",
      "blue",
      "square",
      "prime"
    ],
    skins: [
      {
        unified: "0035-fe0f-20e3",
        native: "5️⃣"
      }
    ],
    version: 1
  },
  six: {
    id: "six",
    name: "Keycap 6",
    keywords: [
      "six",
      "numbers",
      "blue",
      "square"
    ],
    skins: [
      {
        unified: "0036-fe0f-20e3",
        native: "6️⃣"
      }
    ],
    version: 1
  },
  seven: {
    id: "seven",
    name: "Keycap 7",
    keywords: [
      "seven",
      "numbers",
      "blue",
      "square",
      "prime"
    ],
    skins: [
      {
        unified: "0037-fe0f-20e3",
        native: "7️⃣"
      }
    ],
    version: 1
  },
  eight: {
    id: "eight",
    name: "Keycap 8",
    keywords: [
      "eight",
      "blue",
      "square",
      "numbers"
    ],
    skins: [
      {
        unified: "0038-fe0f-20e3",
        native: "8️⃣"
      }
    ],
    version: 1
  },
  nine: {
    id: "nine",
    name: "Keycap 9",
    keywords: [
      "nine",
      "blue",
      "square",
      "numbers"
    ],
    skins: [
      {
        unified: "0039-fe0f-20e3",
        native: "9️⃣"
      }
    ],
    version: 1
  },
  keycap_ten: {
    id: "keycap_ten",
    name: "Keycap 10",
    keywords: [
      "ten",
      "numbers",
      "blue",
      "square"
    ],
    skins: [
      {
        unified: "1f51f",
        native: "🔟"
      }
    ],
    version: 1
  },
  capital_abcd: {
    id: "capital_abcd",
    name: "Input Latin Uppercase",
    keywords: [
      "capital",
      "abcd",
      "alphabet",
      "words",
      "blue",
      "square"
    ],
    skins: [
      {
        unified: "1f520",
        native: "🔠"
      }
    ],
    version: 1
  },
  abcd: {
    id: "abcd",
    name: "Input Latin Lowercase",
    keywords: [
      "abcd",
      "blue",
      "square",
      "alphabet"
    ],
    skins: [
      {
        unified: "1f521",
        native: "🔡"
      }
    ],
    version: 1
  },
  symbols: {
    id: "symbols",
    name: "Input Symbols",
    keywords: [
      "blue",
      "square",
      "music",
      "note",
      "ampersand",
      "percent",
      "glyphs",
      "characters"
    ],
    skins: [
      {
        unified: "1f523",
        native: "🔣"
      }
    ],
    version: 1
  },
  abc: {
    id: "abc",
    name: "Input Latin Letters",
    keywords: [
      "abc",
      "blue",
      "square",
      "alphabet"
    ],
    skins: [
      {
        unified: "1f524",
        native: "🔤"
      }
    ],
    version: 1
  },
  a: {
    id: "a",
    name: "A Button (blood Type)",
    keywords: [
      "red",
      "square",
      "alphabet",
      "letter"
    ],
    skins: [
      {
        unified: "1f170-fe0f",
        native: "🅰️"
      }
    ],
    version: 1
  },
  ab: {
    id: "ab",
    name: "Negative Squared Ab",
    keywords: [
      "button",
      "red",
      "square",
      "alphabet"
    ],
    skins: [
      {
        unified: "1f18e",
        native: "🆎"
      }
    ],
    version: 1
  },
  b: {
    id: "b",
    name: "B Button (blood Type)",
    keywords: [
      "red",
      "square",
      "alphabet",
      "letter"
    ],
    skins: [
      {
        unified: "1f171-fe0f",
        native: "🅱️"
      }
    ],
    version: 1
  },
  cl: {
    id: "cl",
    name: "Cl Button",
    keywords: [
      "alphabet",
      "words",
      "red",
      "square"
    ],
    skins: [
      {
        unified: "1f191",
        native: "🆑"
      }
    ],
    version: 1
  },
  cool: {
    id: "cool",
    name: "Cool Button",
    keywords: [
      "words",
      "blue",
      "square"
    ],
    skins: [
      {
        unified: "1f192",
        native: "🆒"
      }
    ],
    version: 1
  },
  free: {
    id: "free",
    name: "Free Button",
    keywords: [
      "blue",
      "square",
      "words"
    ],
    skins: [
      {
        unified: "1f193",
        native: "🆓"
      }
    ],
    version: 1
  },
  information_source: {
    id: "information_source",
    name: "Information",
    keywords: [
      "source",
      "blue",
      "square",
      "alphabet",
      "letter"
    ],
    skins: [
      {
        unified: "2139-fe0f",
        native: "ℹ️"
      }
    ],
    version: 1
  },
  id: {
    id: "id",
    name: "Id Button",
    keywords: [
      "purple",
      "square",
      "words"
    ],
    skins: [
      {
        unified: "1f194",
        native: "🆔"
      }
    ],
    version: 1
  },
  m: {
    id: "m",
    name: "Circled M",
    keywords: [
      "alphabet",
      "blue",
      "circle",
      "letter"
    ],
    skins: [
      {
        unified: "24c2-fe0f",
        native: "Ⓜ️"
      }
    ],
    version: 1
  },
  new: {
    id: "new",
    name: "New Button",
    keywords: [
      "blue",
      "square",
      "words",
      "start"
    ],
    skins: [
      {
        unified: "1f195",
        native: "🆕"
      }
    ],
    version: 1
  },
  ng: {
    id: "ng",
    name: "Ng Button",
    keywords: [
      "blue",
      "square",
      "words",
      "shape",
      "icon"
    ],
    skins: [
      {
        unified: "1f196",
        native: "🆖"
      }
    ],
    version: 1
  },
  o2: {
    id: "o2",
    name: "O Button (blood Type)",
    keywords: [
      "o2",
      "alphabet",
      "red",
      "square",
      "letter"
    ],
    skins: [
      {
        unified: "1f17e-fe0f",
        native: "🅾️"
      }
    ],
    version: 1
  },
  ok: {
    id: "ok",
    name: "Ok Button",
    keywords: [
      "good",
      "agree",
      "yes",
      "blue",
      "square"
    ],
    skins: [
      {
        unified: "1f197",
        native: "🆗"
      }
    ],
    version: 1
  },
  parking: {
    id: "parking",
    name: "P Button",
    keywords: [
      "parking",
      "cars",
      "blue",
      "square",
      "alphabet",
      "letter"
    ],
    skins: [
      {
        unified: "1f17f-fe0f",
        native: "🅿️"
      }
    ],
    version: 1
  },
  sos: {
    id: "sos",
    name: "Sos Button",
    keywords: [
      "help",
      "red",
      "square",
      "words",
      "emergency",
      "911"
    ],
    skins: [
      {
        unified: "1f198",
        native: "🆘"
      }
    ],
    version: 1
  },
  up: {
    id: "up",
    name: "Up! Button",
    keywords: [
      "up",
      "blue",
      "square",
      "above",
      "high"
    ],
    skins: [
      {
        unified: "1f199",
        native: "🆙"
      }
    ],
    version: 1
  },
  vs: {
    id: "vs",
    name: "Vs Button",
    keywords: [
      "words",
      "orange",
      "square"
    ],
    skins: [
      {
        unified: "1f19a",
        native: "🆚"
      }
    ],
    version: 1
  },
  koko: {
    id: "koko",
    name: "Squared Katakana Koko",
    keywords: [
      "japanese",
      "here",
      "button",
      "blue",
      "square",
      "destination"
    ],
    skins: [
      {
        unified: "1f201",
        native: "🈁"
      }
    ],
    version: 1
  },
  sa: {
    id: "sa",
    name: "Squared Katakana Sa",
    keywords: [
      "japanese",
      "service",
      "charge",
      "button",
      "blue",
      "square"
    ],
    skins: [
      {
        unified: "1f202-fe0f",
        native: "🈂️"
      }
    ],
    version: 1
  },
  u6708: {
    id: "u6708",
    name: "Japanese “monthly Amount” Button",
    keywords: [
      "u6708",
      "monthly",
      "amount",
      "chinese",
      "month",
      "moon",
      "orange",
      "square",
      "kanji"
    ],
    skins: [
      {
        unified: "1f237-fe0f",
        native: "🈷️"
      }
    ],
    version: 1
  },
  u6709: {
    id: "u6709",
    name: "Squared Cjk Unified Ideograph-6709",
    keywords: [
      "u6709",
      "japanese",
      "not",
      "free",
      "of",
      "charge",
      "button",
      "orange",
      "square",
      "chinese",
      "have",
      "kanji"
    ],
    skins: [
      {
        unified: "1f236",
        native: "🈶"
      }
    ],
    version: 1
  },
  u6307: {
    id: "u6307",
    name: "Japanese “reserved” Button",
    keywords: [
      "u6307",
      "reserved",
      "chinese",
      "point",
      "green",
      "square",
      "kanji"
    ],
    skins: [
      {
        unified: "1f22f",
        native: "🈯"
      }
    ],
    version: 1
  },
  ideograph_advantage: {
    id: "ideograph_advantage",
    name: "Japanese “bargain” Button",
    keywords: [
      "ideograph",
      "advantage",
      "bargain",
      "chinese",
      "kanji",
      "obtain",
      "get",
      "circle"
    ],
    skins: [
      {
        unified: "1f250",
        native: "🉐"
      }
    ],
    version: 1
  },
  u5272: {
    id: "u5272",
    name: "Japanese “discount” Button",
    keywords: [
      "u5272",
      "discount",
      "cut",
      "divide",
      "chinese",
      "kanji",
      "pink",
      "square"
    ],
    skins: [
      {
        unified: "1f239",
        native: "🈹"
      }
    ],
    version: 1
  },
  u7121: {
    id: "u7121",
    name: "Japanese “free of Charge” Button",
    keywords: [
      "u7121",
      "free",
      "charge",
      "nothing",
      "chinese",
      "kanji",
      "orange",
      "square"
    ],
    skins: [
      {
        unified: "1f21a",
        native: "🈚"
      }
    ],
    version: 1
  },
  u7981: {
    id: "u7981",
    name: "Japanese “prohibited” Button",
    keywords: [
      "u7981",
      "prohibited",
      "kanji",
      "chinese",
      "forbidden",
      "limit",
      "restricted",
      "red",
      "square"
    ],
    skins: [
      {
        unified: "1f232",
        native: "🈲"
      }
    ],
    version: 1
  },
  accept: {
    id: "accept",
    name: "Circled Ideograph Accept",
    keywords: [
      "japanese",
      "acceptable",
      "button",
      "ok",
      "good",
      "chinese",
      "kanji",
      "agree",
      "yes",
      "orange",
      "circle"
    ],
    skins: [
      {
        unified: "1f251",
        native: "🉑"
      }
    ],
    version: 1
  },
  u7533: {
    id: "u7533",
    name: "Japanese “application” Button",
    keywords: [
      "u7533",
      "application",
      "chinese",
      "kanji",
      "orange",
      "square"
    ],
    skins: [
      {
        unified: "1f238",
        native: "🈸"
      }
    ],
    version: 1
  },
  u5408: {
    id: "u5408",
    name: "Japanese “passing Grade” Button",
    keywords: [
      "u5408",
      "passing",
      "grade",
      "chinese",
      "join",
      "kanji",
      "red",
      "square"
    ],
    skins: [
      {
        unified: "1f234",
        native: "🈴"
      }
    ],
    version: 1
  },
  u7a7a: {
    id: "u7a7a",
    name: "Japanese “vacancy” Button",
    keywords: [
      "u7a7a",
      "vacancy",
      "kanji",
      "chinese",
      "empty",
      "sky",
      "blue",
      "square"
    ],
    skins: [
      {
        unified: "1f233",
        native: "🈳"
      }
    ],
    version: 1
  },
  congratulations: {
    id: "congratulations",
    name: "Circled Ideograph Congratulation",
    keywords: [
      "congratulations",
      "japanese",
      "button",
      "chinese",
      "kanji",
      "red",
      "circle"
    ],
    skins: [
      {
        unified: "3297-fe0f",
        native: "㊗️"
      }
    ],
    version: 1
  },
  secret: {
    id: "secret",
    name: "Circled Ideograph Secret",
    keywords: [
      "japanese",
      "button",
      "privacy",
      "chinese",
      "sshh",
      "kanji",
      "red",
      "circle"
    ],
    skins: [
      {
        unified: "3299-fe0f",
        native: "㊙️"
      }
    ],
    version: 1
  },
  u55b6: {
    id: "u55b6",
    name: "Squared Cjk Unified Ideograph-55b6",
    keywords: [
      "u55b6",
      "japanese",
      "open",
      "for",
      "business",
      "button",
      "opening",
      "hours",
      "orange",
      "square"
    ],
    skins: [
      {
        unified: "1f23a",
        native: "🈺"
      }
    ],
    version: 1
  },
  u6e80: {
    id: "u6e80",
    name: "Japanese “no Vacancy” Button",
    keywords: [
      "u6e80",
      "no",
      "vacancy",
      "full",
      "chinese",
      "red",
      "square",
      "kanji"
    ],
    skins: [
      {
        unified: "1f235",
        native: "🈵"
      }
    ],
    version: 1
  },
  red_circle: {
    id: "red_circle",
    name: "Red Circle",
    keywords: [
      "shape",
      "error",
      "danger"
    ],
    skins: [
      {
        unified: "1f534",
        native: "🔴"
      }
    ],
    version: 1
  },
  large_orange_circle: {
    id: "large_orange_circle",
    name: "Orange Circle",
    keywords: [
      "large",
      "round"
    ],
    skins: [
      {
        unified: "1f7e0",
        native: "🟠"
      }
    ],
    version: 12
  },
  large_yellow_circle: {
    id: "large_yellow_circle",
    name: "Yellow Circle",
    keywords: [
      "large",
      "round"
    ],
    skins: [
      {
        unified: "1f7e1",
        native: "🟡"
      }
    ],
    version: 12
  },
  large_green_circle: {
    id: "large_green_circle",
    name: "Green Circle",
    keywords: [
      "large",
      "round"
    ],
    skins: [
      {
        unified: "1f7e2",
        native: "🟢"
      }
    ],
    version: 12
  },
  large_blue_circle: {
    id: "large_blue_circle",
    name: "Blue Circle",
    keywords: [
      "large",
      "shape",
      "icon",
      "button"
    ],
    skins: [
      {
        unified: "1f535",
        native: "🔵"
      }
    ],
    version: 1
  },
  large_purple_circle: {
    id: "large_purple_circle",
    name: "Purple Circle",
    keywords: [
      "large",
      "round"
    ],
    skins: [
      {
        unified: "1f7e3",
        native: "🟣"
      }
    ],
    version: 12
  },
  large_brown_circle: {
    id: "large_brown_circle",
    name: "Brown Circle",
    keywords: [
      "large",
      "round"
    ],
    skins: [
      {
        unified: "1f7e4",
        native: "🟤"
      }
    ],
    version: 12
  },
  black_circle: {
    id: "black_circle",
    name: "Black Circle",
    keywords: [
      "shape",
      "button",
      "round"
    ],
    skins: [
      {
        unified: "26ab",
        native: "⚫"
      }
    ],
    version: 1
  },
  white_circle: {
    id: "white_circle",
    name: "White Circle",
    keywords: [
      "shape",
      "round"
    ],
    skins: [
      {
        unified: "26aa",
        native: "⚪"
      }
    ],
    version: 1
  },
  large_red_square: {
    id: "large_red_square",
    name: "Red Square",
    keywords: [
      "large"
    ],
    skins: [
      {
        unified: "1f7e5",
        native: "🟥"
      }
    ],
    version: 12
  },
  large_orange_square: {
    id: "large_orange_square",
    name: "Orange Square",
    keywords: [
      "large"
    ],
    skins: [
      {
        unified: "1f7e7",
        native: "🟧"
      }
    ],
    version: 12
  },
  large_yellow_square: {
    id: "large_yellow_square",
    name: "Yellow Square",
    keywords: [
      "large"
    ],
    skins: [
      {
        unified: "1f7e8",
        native: "🟨"
      }
    ],
    version: 12
  },
  large_green_square: {
    id: "large_green_square",
    name: "Green Square",
    keywords: [
      "large"
    ],
    skins: [
      {
        unified: "1f7e9",
        native: "🟩"
      }
    ],
    version: 12
  },
  large_blue_square: {
    id: "large_blue_square",
    name: "Blue Square",
    keywords: [
      "large"
    ],
    skins: [
      {
        unified: "1f7e6",
        native: "🟦"
      }
    ],
    version: 12
  },
  large_purple_square: {
    id: "large_purple_square",
    name: "Purple Square",
    keywords: [
      "large"
    ],
    skins: [
      {
        unified: "1f7ea",
        native: "🟪"
      }
    ],
    version: 12
  },
  large_brown_square: {
    id: "large_brown_square",
    name: "Brown Square",
    keywords: [
      "large"
    ],
    skins: [
      {
        unified: "1f7eb",
        native: "🟫"
      }
    ],
    version: 12
  },
  black_large_square: {
    id: "black_large_square",
    name: "Black Large Square",
    keywords: [
      "shape",
      "icon",
      "button"
    ],
    skins: [
      {
        unified: "2b1b",
        native: "⬛"
      }
    ],
    version: 1
  },
  white_large_square: {
    id: "white_large_square",
    name: "White Large Square",
    keywords: [
      "shape",
      "icon",
      "stone",
      "button"
    ],
    skins: [
      {
        unified: "2b1c",
        native: "⬜"
      }
    ],
    version: 1
  },
  black_medium_square: {
    id: "black_medium_square",
    name: "Black Medium Square",
    keywords: [
      "shape",
      "button",
      "icon"
    ],
    skins: [
      {
        unified: "25fc-fe0f",
        native: "◼️"
      }
    ],
    version: 1
  },
  white_medium_square: {
    id: "white_medium_square",
    name: "White Medium Square",
    keywords: [
      "shape",
      "stone",
      "icon"
    ],
    skins: [
      {
        unified: "25fb-fe0f",
        native: "◻️"
      }
    ],
    version: 1
  },
  black_medium_small_square: {
    id: "black_medium_small_square",
    name: "Black Medium Small Square",
    keywords: [
      "icon",
      "shape",
      "button"
    ],
    skins: [
      {
        unified: "25fe",
        native: "◾"
      }
    ],
    version: 1
  },
  white_medium_small_square: {
    id: "white_medium_small_square",
    name: "White Medium Small Square",
    keywords: [
      "shape",
      "stone",
      "icon",
      "button"
    ],
    skins: [
      {
        unified: "25fd",
        native: "◽"
      }
    ],
    version: 1
  },
  black_small_square: {
    id: "black_small_square",
    name: "Black Small Square",
    keywords: [
      "shape",
      "icon"
    ],
    skins: [
      {
        unified: "25aa-fe0f",
        native: "▪️"
      }
    ],
    version: 1
  },
  white_small_square: {
    id: "white_small_square",
    name: "White Small Square",
    keywords: [
      "shape",
      "icon"
    ],
    skins: [
      {
        unified: "25ab-fe0f",
        native: "▫️"
      }
    ],
    version: 1
  },
  large_orange_diamond: {
    id: "large_orange_diamond",
    name: "Large Orange Diamond",
    keywords: [
      "shape",
      "jewel",
      "gem"
    ],
    skins: [
      {
        unified: "1f536",
        native: "🔶"
      }
    ],
    version: 1
  },
  large_blue_diamond: {
    id: "large_blue_diamond",
    name: "Large Blue Diamond",
    keywords: [
      "shape",
      "jewel",
      "gem"
    ],
    skins: [
      {
        unified: "1f537",
        native: "🔷"
      }
    ],
    version: 1
  },
  small_orange_diamond: {
    id: "small_orange_diamond",
    name: "Small Orange Diamond",
    keywords: [
      "shape",
      "jewel",
      "gem"
    ],
    skins: [
      {
        unified: "1f538",
        native: "🔸"
      }
    ],
    version: 1
  },
  small_blue_diamond: {
    id: "small_blue_diamond",
    name: "Small Blue Diamond",
    keywords: [
      "shape",
      "jewel",
      "gem"
    ],
    skins: [
      {
        unified: "1f539",
        native: "🔹"
      }
    ],
    version: 1
  },
  small_red_triangle: {
    id: "small_red_triangle",
    name: "Red Triangle Pointed Up",
    keywords: [
      "small",
      "shape",
      "direction",
      "top"
    ],
    skins: [
      {
        unified: "1f53a",
        native: "🔺"
      }
    ],
    version: 1
  },
  small_red_triangle_down: {
    id: "small_red_triangle_down",
    name: "Red Triangle Pointed Down",
    keywords: [
      "small",
      "shape",
      "direction",
      "bottom"
    ],
    skins: [
      {
        unified: "1f53b",
        native: "🔻"
      }
    ],
    version: 1
  },
  diamond_shape_with_a_dot_inside: {
    id: "diamond_shape_with_a_dot_inside",
    name: "Diamond with a Dot",
    keywords: [
      "shape",
      "inside",
      "jewel",
      "blue",
      "gem",
      "crystal",
      "fancy"
    ],
    skins: [
      {
        unified: "1f4a0",
        native: "💠"
      }
    ],
    version: 1
  },
  radio_button: {
    id: "radio_button",
    name: "Radio Button",
    keywords: [
      "input",
      "old",
      "music",
      "circle"
    ],
    skins: [
      {
        unified: "1f518",
        native: "🔘"
      }
    ],
    version: 1
  },
  white_square_button: {
    id: "white_square_button",
    name: "White Square Button",
    keywords: [
      "shape",
      "input"
    ],
    skins: [
      {
        unified: "1f533",
        native: "🔳"
      }
    ],
    version: 1
  },
  black_square_button: {
    id: "black_square_button",
    name: "Black Square Button",
    keywords: [
      "shape",
      "input",
      "frame"
    ],
    skins: [
      {
        unified: "1f532",
        native: "🔲"
      }
    ],
    version: 1
  },
  checkered_flag: {
    id: "checkered_flag",
    name: "Chequered Flag",
    keywords: [
      "checkered",
      "contest",
      "finishline",
      "race",
      "gokart"
    ],
    skins: [
      {
        unified: "1f3c1",
        native: "🏁"
      }
    ],
    version: 1
  },
  triangular_flag_on_post: {
    id: "triangular_flag_on_post",
    name: "Triangular Flag",
    keywords: [
      "on",
      "post",
      "mark",
      "milestone",
      "place"
    ],
    skins: [
      {
        unified: "1f6a9",
        native: "🚩"
      }
    ],
    version: 1
  },
  crossed_flags: {
    id: "crossed_flags",
    name: "Crossed Flags",
    keywords: [
      "japanese",
      "nation",
      "country",
      "border"
    ],
    skins: [
      {
        unified: "1f38c",
        native: "🎌"
      }
    ],
    version: 1
  },
  waving_black_flag: {
    id: "waving_black_flag",
    name: "Black Flag",
    keywords: [
      "waving",
      "pirate"
    ],
    skins: [
      {
        unified: "1f3f4",
        native: "🏴"
      }
    ],
    version: 1
  },
  waving_white_flag: {
    id: "waving_white_flag",
    name: "White Flag",
    keywords: [
      "waving",
      "losing",
      "loser",
      "lost",
      "surrender",
      "give",
      "up",
      "fail"
    ],
    skins: [
      {
        unified: "1f3f3-fe0f",
        native: "🏳️"
      }
    ],
    version: 1
  },
  "rainbow-flag": {
    id: "rainbow-flag",
    name: "Rainbow Flag",
    keywords: [
      "pride",
      "gay",
      "lgbt",
      "glbt",
      "queer",
      "homosexual",
      "lesbian",
      "bisexual",
      "transgender"
    ],
    skins: [
      {
        unified: "1f3f3-fe0f-200d-1f308",
        native: "🏳️‍🌈"
      }
    ],
    version: 4
  },
  transgender_flag: {
    id: "transgender_flag",
    name: "Transgender Flag",
    keywords: [
      "lgbtq"
    ],
    skins: [
      {
        unified: "1f3f3-fe0f-200d-26a7-fe0f",
        native: "🏳️‍⚧️"
      }
    ],
    version: 13
  },
  pirate_flag: {
    id: "pirate_flag",
    name: "Pirate Flag",
    keywords: [
      "skull",
      "crossbones",
      "banner"
    ],
    skins: [
      {
        unified: "1f3f4-200d-2620-fe0f",
        native: "🏴‍☠️"
      }
    ],
    version: 11
  },
  "flag-ac": {
    id: "flag-ac",
    name: "Ascension Island Flag",
    keywords: [
      "ac"
    ],
    skins: [
      {
        unified: "1f1e6-1f1e8",
        native: "🇦🇨"
      }
    ],
    version: 2
  },
  "flag-ad": {
    id: "flag-ad",
    name: "Andorra Flag",
    keywords: [
      "ad",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e6-1f1e9",
        native: "🇦🇩"
      }
    ],
    version: 2
  },
  "flag-ae": {
    id: "flag-ae",
    name: "United Arab Emirates Flag",
    keywords: [
      "ae",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e6-1f1ea",
        native: "🇦🇪"
      }
    ],
    version: 2
  },
  "flag-af": {
    id: "flag-af",
    name: "Afghanistan Flag",
    keywords: [
      "af",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e6-1f1eb",
        native: "🇦🇫"
      }
    ],
    version: 2
  },
  "flag-ag": {
    id: "flag-ag",
    name: "Antigua & Barbuda Flag",
    keywords: [
      "ag",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e6-1f1ec",
        native: "🇦🇬"
      }
    ],
    version: 2
  },
  "flag-ai": {
    id: "flag-ai",
    name: "Anguilla Flag",
    keywords: [
      "ai",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e6-1f1ee",
        native: "🇦🇮"
      }
    ],
    version: 2
  },
  "flag-al": {
    id: "flag-al",
    name: "Albania Flag",
    keywords: [
      "al",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e6-1f1f1",
        native: "🇦🇱"
      }
    ],
    version: 2
  },
  "flag-am": {
    id: "flag-am",
    name: "Armenia Flag",
    keywords: [
      "am",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e6-1f1f2",
        native: "🇦🇲"
      }
    ],
    version: 2
  },
  "flag-ao": {
    id: "flag-ao",
    name: "Angola Flag",
    keywords: [
      "ao",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e6-1f1f4",
        native: "🇦🇴"
      }
    ],
    version: 2
  },
  "flag-aq": {
    id: "flag-aq",
    name: "Antarctica Flag",
    keywords: [
      "aq",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e6-1f1f6",
        native: "🇦🇶"
      }
    ],
    version: 2
  },
  "flag-ar": {
    id: "flag-ar",
    name: "Argentina Flag",
    keywords: [
      "ar",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e6-1f1f7",
        native: "🇦🇷"
      }
    ],
    version: 2
  },
  "flag-as": {
    id: "flag-as",
    name: "American Samoa Flag",
    keywords: [
      "as",
      "ws",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e6-1f1f8",
        native: "🇦🇸"
      }
    ],
    version: 2
  },
  "flag-at": {
    id: "flag-at",
    name: "Austria Flag",
    keywords: [
      "at",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e6-1f1f9",
        native: "🇦🇹"
      }
    ],
    version: 2
  },
  "flag-au": {
    id: "flag-au",
    name: "Australia Flag",
    keywords: [
      "au",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e6-1f1fa",
        native: "🇦🇺"
      }
    ],
    version: 2
  },
  "flag-aw": {
    id: "flag-aw",
    name: "Aruba Flag",
    keywords: [
      "aw",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e6-1f1fc",
        native: "🇦🇼"
      }
    ],
    version: 2
  },
  "flag-ax": {
    id: "flag-ax",
    name: "Åland Islands Flag",
    keywords: [
      "ax",
      "aland",
      "Aland",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e6-1f1fd",
        native: "🇦🇽"
      }
    ],
    version: 2
  },
  "flag-az": {
    id: "flag-az",
    name: "Azerbaijan Flag",
    keywords: [
      "az",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e6-1f1ff",
        native: "🇦🇿"
      }
    ],
    version: 2
  },
  "flag-ba": {
    id: "flag-ba",
    name: "Bosnia & Herzegovina Flag",
    keywords: [
      "ba",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e7-1f1e6",
        native: "🇧🇦"
      }
    ],
    version: 2
  },
  "flag-bb": {
    id: "flag-bb",
    name: "Barbados Flag",
    keywords: [
      "bb",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e7-1f1e7",
        native: "🇧🇧"
      }
    ],
    version: 2
  },
  "flag-bd": {
    id: "flag-bd",
    name: "Bangladesh Flag",
    keywords: [
      "bd",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e7-1f1e9",
        native: "🇧🇩"
      }
    ],
    version: 2
  },
  "flag-be": {
    id: "flag-be",
    name: "Belgium Flag",
    keywords: [
      "be",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e7-1f1ea",
        native: "🇧🇪"
      }
    ],
    version: 2
  },
  "flag-bf": {
    id: "flag-bf",
    name: "Burkina Faso Flag",
    keywords: [
      "bf",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e7-1f1eb",
        native: "🇧🇫"
      }
    ],
    version: 2
  },
  "flag-bg": {
    id: "flag-bg",
    name: "Bulgaria Flag",
    keywords: [
      "bg",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e7-1f1ec",
        native: "🇧🇬"
      }
    ],
    version: 2
  },
  "flag-bh": {
    id: "flag-bh",
    name: "Bahrain Flag",
    keywords: [
      "bh",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e7-1f1ed",
        native: "🇧🇭"
      }
    ],
    version: 2
  },
  "flag-bi": {
    id: "flag-bi",
    name: "Burundi Flag",
    keywords: [
      "bi",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e7-1f1ee",
        native: "🇧🇮"
      }
    ],
    version: 2
  },
  "flag-bj": {
    id: "flag-bj",
    name: "Benin Flag",
    keywords: [
      "bj",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e7-1f1ef",
        native: "🇧🇯"
      }
    ],
    version: 2
  },
  "flag-bl": {
    id: "flag-bl",
    name: "St. Barthélemy Flag",
    keywords: [
      "bl",
      "st",
      "barthelemy",
      "saint",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e7-1f1f1",
        native: "🇧🇱"
      }
    ],
    version: 2
  },
  "flag-bm": {
    id: "flag-bm",
    name: "Bermuda Flag",
    keywords: [
      "bm",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e7-1f1f2",
        native: "🇧🇲"
      }
    ],
    version: 2
  },
  "flag-bn": {
    id: "flag-bn",
    name: "Brunei Flag",
    keywords: [
      "bn",
      "darussalam",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e7-1f1f3",
        native: "🇧🇳"
      }
    ],
    version: 2
  },
  "flag-bo": {
    id: "flag-bo",
    name: "Bolivia Flag",
    keywords: [
      "bo",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e7-1f1f4",
        native: "🇧🇴"
      }
    ],
    version: 2
  },
  "flag-bq": {
    id: "flag-bq",
    name: "Caribbean Netherlands Flag",
    keywords: [
      "bq",
      "bonaire",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e7-1f1f6",
        native: "🇧🇶"
      }
    ],
    version: 2
  },
  "flag-br": {
    id: "flag-br",
    name: "Brazil Flag",
    keywords: [
      "br",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e7-1f1f7",
        native: "🇧🇷"
      }
    ],
    version: 2
  },
  "flag-bs": {
    id: "flag-bs",
    name: "Bahamas Flag",
    keywords: [
      "bs",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e7-1f1f8",
        native: "🇧🇸"
      }
    ],
    version: 2
  },
  "flag-bt": {
    id: "flag-bt",
    name: "Bhutan Flag",
    keywords: [
      "bt",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e7-1f1f9",
        native: "🇧🇹"
      }
    ],
    version: 2
  },
  "flag-bv": {
    id: "flag-bv",
    name: "Bouvet Island Flag",
    keywords: [
      "bv",
      "norway"
    ],
    skins: [
      {
        unified: "1f1e7-1f1fb",
        native: "🇧🇻"
      }
    ],
    version: 2
  },
  "flag-bw": {
    id: "flag-bw",
    name: "Botswana Flag",
    keywords: [
      "bw",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e7-1f1fc",
        native: "🇧🇼"
      }
    ],
    version: 2
  },
  "flag-by": {
    id: "flag-by",
    name: "Belarus Flag",
    keywords: [
      "by",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e7-1f1fe",
        native: "🇧🇾"
      }
    ],
    version: 2
  },
  "flag-bz": {
    id: "flag-bz",
    name: "Belize Flag",
    keywords: [
      "bz",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e7-1f1ff",
        native: "🇧🇿"
      }
    ],
    version: 2
  },
  "flag-ca": {
    id: "flag-ca",
    name: "Canada Flag",
    keywords: [
      "ca",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e8-1f1e6",
        native: "🇨🇦"
      }
    ],
    version: 2
  },
  "flag-cc": {
    id: "flag-cc",
    name: "Cocos (keeling) Islands Flag",
    keywords: [
      "cc",
      "keeling",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e8-1f1e8",
        native: "🇨🇨"
      }
    ],
    version: 2
  },
  "flag-cd": {
    id: "flag-cd",
    name: "Congo - Kinshasa Flag",
    keywords: [
      "cd",
      "democratic",
      "republic",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e8-1f1e9",
        native: "🇨🇩"
      }
    ],
    version: 2
  },
  "flag-cf": {
    id: "flag-cf",
    name: "Central African Republic Flag",
    keywords: [
      "cf",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e8-1f1eb",
        native: "🇨🇫"
      }
    ],
    version: 2
  },
  "flag-cg": {
    id: "flag-cg",
    name: "Congo - Brazzaville Flag",
    keywords: [
      "cg",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e8-1f1ec",
        native: "🇨🇬"
      }
    ],
    version: 2
  },
  "flag-ch": {
    id: "flag-ch",
    name: "Switzerland Flag",
    keywords: [
      "ch",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e8-1f1ed",
        native: "🇨🇭"
      }
    ],
    version: 2
  },
  "flag-ci": {
    id: "flag-ci",
    name: "Côte D’ivoire Flag",
    keywords: [
      "ci",
      "cote",
      "d",
      "ivoire",
      "ivory",
      "coast",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e8-1f1ee",
        native: "🇨🇮"
      }
    ],
    version: 2
  },
  "flag-ck": {
    id: "flag-ck",
    name: "Cook Islands Flag",
    keywords: [
      "ck",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e8-1f1f0",
        native: "🇨🇰"
      }
    ],
    version: 2
  },
  "flag-cl": {
    id: "flag-cl",
    name: "Chile Flag",
    keywords: [
      "cl",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e8-1f1f1",
        native: "🇨🇱"
      }
    ],
    version: 2
  },
  "flag-cm": {
    id: "flag-cm",
    name: "Cameroon Flag",
    keywords: [
      "cm",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e8-1f1f2",
        native: "🇨🇲"
      }
    ],
    version: 2
  },
  cn: {
    id: "cn",
    name: "China Flag",
    keywords: [
      "cn",
      "chinese",
      "prc",
      "country",
      "nation",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e8-1f1f3",
        native: "🇨🇳"
      }
    ],
    version: 1
  },
  "flag-co": {
    id: "flag-co",
    name: "Colombia Flag",
    keywords: [
      "co",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e8-1f1f4",
        native: "🇨🇴"
      }
    ],
    version: 2
  },
  "flag-cp": {
    id: "flag-cp",
    name: "Clipperton Island Flag",
    keywords: [
      "cp"
    ],
    skins: [
      {
        unified: "1f1e8-1f1f5",
        native: "🇨🇵"
      }
    ],
    version: 2
  },
  "flag-cr": {
    id: "flag-cr",
    name: "Costa Rica Flag",
    keywords: [
      "cr",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e8-1f1f7",
        native: "🇨🇷"
      }
    ],
    version: 2
  },
  "flag-cu": {
    id: "flag-cu",
    name: "Cuba Flag",
    keywords: [
      "cu",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e8-1f1fa",
        native: "🇨🇺"
      }
    ],
    version: 2
  },
  "flag-cv": {
    id: "flag-cv",
    name: "Cape Verde Flag",
    keywords: [
      "cv",
      "cabo",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e8-1f1fb",
        native: "🇨🇻"
      }
    ],
    version: 2
  },
  "flag-cw": {
    id: "flag-cw",
    name: "Curaçao Flag",
    keywords: [
      "cw",
      "curacao",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e8-1f1fc",
        native: "🇨🇼"
      }
    ],
    version: 2
  },
  "flag-cx": {
    id: "flag-cx",
    name: "Christmas Island Flag",
    keywords: [
      "cx",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e8-1f1fd",
        native: "🇨🇽"
      }
    ],
    version: 2
  },
  "flag-cy": {
    id: "flag-cy",
    name: "Cyprus Flag",
    keywords: [
      "cy",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e8-1f1fe",
        native: "🇨🇾"
      }
    ],
    version: 2
  },
  "flag-cz": {
    id: "flag-cz",
    name: "Czechia Flag",
    keywords: [
      "cz",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e8-1f1ff",
        native: "🇨🇿"
      }
    ],
    version: 2
  },
  de: {
    id: "de",
    name: "Germany Flag",
    keywords: [
      "de",
      "german",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e9-1f1ea",
        native: "🇩🇪"
      }
    ],
    version: 1
  },
  "flag-dg": {
    id: "flag-dg",
    name: "Diego Garcia Flag",
    keywords: [
      "dg"
    ],
    skins: [
      {
        unified: "1f1e9-1f1ec",
        native: "🇩🇬"
      }
    ],
    version: 2
  },
  "flag-dj": {
    id: "flag-dj",
    name: "Djibouti Flag",
    keywords: [
      "dj",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e9-1f1ef",
        native: "🇩🇯"
      }
    ],
    version: 2
  },
  "flag-dk": {
    id: "flag-dk",
    name: "Denmark Flag",
    keywords: [
      "dk",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e9-1f1f0",
        native: "🇩🇰"
      }
    ],
    version: 2
  },
  "flag-dm": {
    id: "flag-dm",
    name: "Dominica Flag",
    keywords: [
      "dm",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e9-1f1f2",
        native: "🇩🇲"
      }
    ],
    version: 2
  },
  "flag-do": {
    id: "flag-do",
    name: "Dominican Republic Flag",
    keywords: [
      "do",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e9-1f1f4",
        native: "🇩🇴"
      }
    ],
    version: 2
  },
  "flag-dz": {
    id: "flag-dz",
    name: "Algeria Flag",
    keywords: [
      "dz",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e9-1f1ff",
        native: "🇩🇿"
      }
    ],
    version: 2
  },
  "flag-ea": {
    id: "flag-ea",
    name: "Ceuta & Melilla Flag",
    keywords: [
      "ea"
    ],
    skins: [
      {
        unified: "1f1ea-1f1e6",
        native: "🇪🇦"
      }
    ],
    version: 2
  },
  "flag-ec": {
    id: "flag-ec",
    name: "Ecuador Flag",
    keywords: [
      "ec",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ea-1f1e8",
        native: "🇪🇨"
      }
    ],
    version: 2
  },
  "flag-ee": {
    id: "flag-ee",
    name: "Estonia Flag",
    keywords: [
      "ee",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ea-1f1ea",
        native: "🇪🇪"
      }
    ],
    version: 2
  },
  "flag-eg": {
    id: "flag-eg",
    name: "Egypt Flag",
    keywords: [
      "eg",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ea-1f1ec",
        native: "🇪🇬"
      }
    ],
    version: 2
  },
  "flag-eh": {
    id: "flag-eh",
    name: "Western Sahara Flag",
    keywords: [
      "eh",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ea-1f1ed",
        native: "🇪🇭"
      }
    ],
    version: 2
  },
  "flag-er": {
    id: "flag-er",
    name: "Eritrea Flag",
    keywords: [
      "er",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ea-1f1f7",
        native: "🇪🇷"
      }
    ],
    version: 2
  },
  es: {
    id: "es",
    name: "Spain Flag",
    keywords: [
      "es",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ea-1f1f8",
        native: "🇪🇸"
      }
    ],
    version: 1
  },
  "flag-et": {
    id: "flag-et",
    name: "Ethiopia Flag",
    keywords: [
      "et",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ea-1f1f9",
        native: "🇪🇹"
      }
    ],
    version: 2
  },
  "flag-eu": {
    id: "flag-eu",
    name: "European Union Flag",
    keywords: [
      "eu",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ea-1f1fa",
        native: "🇪🇺"
      }
    ],
    version: 2
  },
  "flag-fi": {
    id: "flag-fi",
    name: "Finland Flag",
    keywords: [
      "fi",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1eb-1f1ee",
        native: "🇫🇮"
      }
    ],
    version: 2
  },
  "flag-fj": {
    id: "flag-fj",
    name: "Fiji Flag",
    keywords: [
      "fj",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1eb-1f1ef",
        native: "🇫🇯"
      }
    ],
    version: 2
  },
  "flag-fk": {
    id: "flag-fk",
    name: "Falkland Islands Flag",
    keywords: [
      "fk",
      "malvinas",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1eb-1f1f0",
        native: "🇫🇰"
      }
    ],
    version: 2
  },
  "flag-fm": {
    id: "flag-fm",
    name: "Micronesia Flag",
    keywords: [
      "fm",
      "federated",
      "states",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1eb-1f1f2",
        native: "🇫🇲"
      }
    ],
    version: 2
  },
  "flag-fo": {
    id: "flag-fo",
    name: "Faroe Islands Flag",
    keywords: [
      "fo",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1eb-1f1f4",
        native: "🇫🇴"
      }
    ],
    version: 2
  },
  fr: {
    id: "fr",
    name: "France Flag",
    keywords: [
      "fr",
      "banner",
      "nation",
      "french",
      "country"
    ],
    skins: [
      {
        unified: "1f1eb-1f1f7",
        native: "🇫🇷"
      }
    ],
    version: 1
  },
  "flag-ga": {
    id: "flag-ga",
    name: "Gabon Flag",
    keywords: [
      "ga",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ec-1f1e6",
        native: "🇬🇦"
      }
    ],
    version: 2
  },
  gb: {
    id: "gb",
    name: "United Kingdom Flag",
    keywords: [
      "gb",
      "uk",
      "great",
      "britain",
      "northern",
      "ireland",
      "nation",
      "country",
      "banner",
      "british",
      "UK",
      "english",
      "england",
      "union",
      "jack"
    ],
    skins: [
      {
        unified: "1f1ec-1f1e7",
        native: "🇬🇧"
      }
    ],
    version: 1
  },
  "flag-gd": {
    id: "flag-gd",
    name: "Grenada Flag",
    keywords: [
      "gd",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ec-1f1e9",
        native: "🇬🇩"
      }
    ],
    version: 2
  },
  "flag-ge": {
    id: "flag-ge",
    name: "Georgia Flag",
    keywords: [
      "ge",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ec-1f1ea",
        native: "🇬🇪"
      }
    ],
    version: 2
  },
  "flag-gf": {
    id: "flag-gf",
    name: "French Guiana Flag",
    keywords: [
      "gf",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ec-1f1eb",
        native: "🇬🇫"
      }
    ],
    version: 2
  },
  "flag-gg": {
    id: "flag-gg",
    name: "Guernsey Flag",
    keywords: [
      "gg",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ec-1f1ec",
        native: "🇬🇬"
      }
    ],
    version: 2
  },
  "flag-gh": {
    id: "flag-gh",
    name: "Ghana Flag",
    keywords: [
      "gh",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ec-1f1ed",
        native: "🇬🇭"
      }
    ],
    version: 2
  },
  "flag-gi": {
    id: "flag-gi",
    name: "Gibraltar Flag",
    keywords: [
      "gi",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ec-1f1ee",
        native: "🇬🇮"
      }
    ],
    version: 2
  },
  "flag-gl": {
    id: "flag-gl",
    name: "Greenland Flag",
    keywords: [
      "gl",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ec-1f1f1",
        native: "🇬🇱"
      }
    ],
    version: 2
  },
  "flag-gm": {
    id: "flag-gm",
    name: "Gambia Flag",
    keywords: [
      "gm",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ec-1f1f2",
        native: "🇬🇲"
      }
    ],
    version: 2
  },
  "flag-gn": {
    id: "flag-gn",
    name: "Guinea Flag",
    keywords: [
      "gn",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ec-1f1f3",
        native: "🇬🇳"
      }
    ],
    version: 2
  },
  "flag-gp": {
    id: "flag-gp",
    name: "Guadeloupe Flag",
    keywords: [
      "gp",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ec-1f1f5",
        native: "🇬🇵"
      }
    ],
    version: 2
  },
  "flag-gq": {
    id: "flag-gq",
    name: "Equatorial Guinea Flag",
    keywords: [
      "gq",
      "gn",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ec-1f1f6",
        native: "🇬🇶"
      }
    ],
    version: 2
  },
  "flag-gr": {
    id: "flag-gr",
    name: "Greece Flag",
    keywords: [
      "gr",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ec-1f1f7",
        native: "🇬🇷"
      }
    ],
    version: 2
  },
  "flag-gs": {
    id: "flag-gs",
    name: "South Georgia & South Sandwich Islands Flag",
    keywords: [
      "gs",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ec-1f1f8",
        native: "🇬🇸"
      }
    ],
    version: 2
  },
  "flag-gt": {
    id: "flag-gt",
    name: "Guatemala Flag",
    keywords: [
      "gt",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ec-1f1f9",
        native: "🇬🇹"
      }
    ],
    version: 2
  },
  "flag-gu": {
    id: "flag-gu",
    name: "Guam Flag",
    keywords: [
      "gu",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ec-1f1fa",
        native: "🇬🇺"
      }
    ],
    version: 2
  },
  "flag-gw": {
    id: "flag-gw",
    name: "Guinea-Bissau Flag",
    keywords: [
      "gw",
      "guinea",
      "bissau",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ec-1f1fc",
        native: "🇬🇼"
      }
    ],
    version: 2
  },
  "flag-gy": {
    id: "flag-gy",
    name: "Guyana Flag",
    keywords: [
      "gy",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ec-1f1fe",
        native: "🇬🇾"
      }
    ],
    version: 2
  },
  "flag-hk": {
    id: "flag-hk",
    name: "Hong Kong Sar China Flag",
    keywords: [
      "hk",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ed-1f1f0",
        native: "🇭🇰"
      }
    ],
    version: 2
  },
  "flag-hm": {
    id: "flag-hm",
    name: "Heard & Mcdonald Islands Flag",
    keywords: [
      "hm"
    ],
    skins: [
      {
        unified: "1f1ed-1f1f2",
        native: "🇭🇲"
      }
    ],
    version: 2
  },
  "flag-hn": {
    id: "flag-hn",
    name: "Honduras Flag",
    keywords: [
      "hn",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ed-1f1f3",
        native: "🇭🇳"
      }
    ],
    version: 2
  },
  "flag-hr": {
    id: "flag-hr",
    name: "Croatia Flag",
    keywords: [
      "hr",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ed-1f1f7",
        native: "🇭🇷"
      }
    ],
    version: 2
  },
  "flag-ht": {
    id: "flag-ht",
    name: "Haiti Flag",
    keywords: [
      "ht",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ed-1f1f9",
        native: "🇭🇹"
      }
    ],
    version: 2
  },
  "flag-hu": {
    id: "flag-hu",
    name: "Hungary Flag",
    keywords: [
      "hu",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ed-1f1fa",
        native: "🇭🇺"
      }
    ],
    version: 2
  },
  "flag-ic": {
    id: "flag-ic",
    name: "Canary Islands Flag",
    keywords: [
      "ic",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ee-1f1e8",
        native: "🇮🇨"
      }
    ],
    version: 2
  },
  "flag-id": {
    id: "flag-id",
    name: "Indonesia Flag",
    keywords: [
      "id",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ee-1f1e9",
        native: "🇮🇩"
      }
    ],
    version: 2
  },
  "flag-ie": {
    id: "flag-ie",
    name: "Ireland Flag",
    keywords: [
      "ie",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ee-1f1ea",
        native: "🇮🇪"
      }
    ],
    version: 2
  },
  "flag-il": {
    id: "flag-il",
    name: "Israel Flag",
    keywords: [
      "il",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ee-1f1f1",
        native: "🇮🇱"
      }
    ],
    version: 2
  },
  "flag-im": {
    id: "flag-im",
    name: "Isle of Man Flag",
    keywords: [
      "im",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ee-1f1f2",
        native: "🇮🇲"
      }
    ],
    version: 2
  },
  "flag-in": {
    id: "flag-in",
    name: "India Flag",
    keywords: [
      "in",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ee-1f1f3",
        native: "🇮🇳"
      }
    ],
    version: 2
  },
  "flag-io": {
    id: "flag-io",
    name: "British Indian Ocean Territory Flag",
    keywords: [
      "io",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ee-1f1f4",
        native: "🇮🇴"
      }
    ],
    version: 2
  },
  "flag-iq": {
    id: "flag-iq",
    name: "Iraq Flag",
    keywords: [
      "iq",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ee-1f1f6",
        native: "🇮🇶"
      }
    ],
    version: 2
  },
  "flag-ir": {
    id: "flag-ir",
    name: "Iran Flag",
    keywords: [
      "ir",
      "islamic",
      "republic",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ee-1f1f7",
        native: "🇮🇷"
      }
    ],
    version: 2
  },
  "flag-is": {
    id: "flag-is",
    name: "Iceland Flag",
    keywords: [
      "is",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ee-1f1f8",
        native: "🇮🇸"
      }
    ],
    version: 2
  },
  it: {
    id: "it",
    name: "Italy Flag",
    keywords: [
      "it",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ee-1f1f9",
        native: "🇮🇹"
      }
    ],
    version: 1
  },
  "flag-je": {
    id: "flag-je",
    name: "Jersey Flag",
    keywords: [
      "je",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ef-1f1ea",
        native: "🇯🇪"
      }
    ],
    version: 2
  },
  "flag-jm": {
    id: "flag-jm",
    name: "Jamaica Flag",
    keywords: [
      "jm",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ef-1f1f2",
        native: "🇯🇲"
      }
    ],
    version: 2
  },
  "flag-jo": {
    id: "flag-jo",
    name: "Jordan Flag",
    keywords: [
      "jo",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ef-1f1f4",
        native: "🇯🇴"
      }
    ],
    version: 2
  },
  jp: {
    id: "jp",
    name: "Japan Flag",
    keywords: [
      "jp",
      "japanese",
      "nation",
      "country",
      "banner",
      "ja"
    ],
    skins: [
      {
        unified: "1f1ef-1f1f5",
        native: "🇯🇵"
      }
    ],
    version: 1
  },
  "flag-ke": {
    id: "flag-ke",
    name: "Kenya Flag",
    keywords: [
      "ke",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f0-1f1ea",
        native: "🇰🇪"
      }
    ],
    version: 2
  },
  "flag-kg": {
    id: "flag-kg",
    name: "Kyrgyzstan Flag",
    keywords: [
      "kg",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f0-1f1ec",
        native: "🇰🇬"
      }
    ],
    version: 2
  },
  "flag-kh": {
    id: "flag-kh",
    name: "Cambodia Flag",
    keywords: [
      "kh",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f0-1f1ed",
        native: "🇰🇭"
      }
    ],
    version: 2
  },
  "flag-ki": {
    id: "flag-ki",
    name: "Kiribati Flag",
    keywords: [
      "ki",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f0-1f1ee",
        native: "🇰🇮"
      }
    ],
    version: 2
  },
  "flag-km": {
    id: "flag-km",
    name: "Comoros Flag",
    keywords: [
      "km",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f0-1f1f2",
        native: "🇰🇲"
      }
    ],
    version: 2
  },
  "flag-kn": {
    id: "flag-kn",
    name: "St. Kitts & Nevis Flag",
    keywords: [
      "kn",
      "st",
      "saint",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f0-1f1f3",
        native: "🇰🇳"
      }
    ],
    version: 2
  },
  "flag-kp": {
    id: "flag-kp",
    name: "North Korea Flag",
    keywords: [
      "kp",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f0-1f1f5",
        native: "🇰🇵"
      }
    ],
    version: 2
  },
  kr: {
    id: "kr",
    name: "South Korea Flag",
    keywords: [
      "kr",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f0-1f1f7",
        native: "🇰🇷"
      }
    ],
    version: 1
  },
  "flag-kw": {
    id: "flag-kw",
    name: "Kuwait Flag",
    keywords: [
      "kw",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f0-1f1fc",
        native: "🇰🇼"
      }
    ],
    version: 2
  },
  "flag-ky": {
    id: "flag-ky",
    name: "Cayman Islands Flag",
    keywords: [
      "ky",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f0-1f1fe",
        native: "🇰🇾"
      }
    ],
    version: 2
  },
  "flag-kz": {
    id: "flag-kz",
    name: "Kazakhstan Flag",
    keywords: [
      "kz",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f0-1f1ff",
        native: "🇰🇿"
      }
    ],
    version: 2
  },
  "flag-la": {
    id: "flag-la",
    name: "Laos Flag",
    keywords: [
      "la",
      "lao",
      "democratic",
      "republic",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f1-1f1e6",
        native: "🇱🇦"
      }
    ],
    version: 2
  },
  "flag-lb": {
    id: "flag-lb",
    name: "Lebanon Flag",
    keywords: [
      "lb",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f1-1f1e7",
        native: "🇱🇧"
      }
    ],
    version: 2
  },
  "flag-lc": {
    id: "flag-lc",
    name: "St. Lucia Flag",
    keywords: [
      "lc",
      "st",
      "saint",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f1-1f1e8",
        native: "🇱🇨"
      }
    ],
    version: 2
  },
  "flag-li": {
    id: "flag-li",
    name: "Liechtenstein Flag",
    keywords: [
      "li",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f1-1f1ee",
        native: "🇱🇮"
      }
    ],
    version: 2
  },
  "flag-lk": {
    id: "flag-lk",
    name: "Sri Lanka Flag",
    keywords: [
      "lk",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f1-1f1f0",
        native: "🇱🇰"
      }
    ],
    version: 2
  },
  "flag-lr": {
    id: "flag-lr",
    name: "Liberia Flag",
    keywords: [
      "lr",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f1-1f1f7",
        native: "🇱🇷"
      }
    ],
    version: 2
  },
  "flag-ls": {
    id: "flag-ls",
    name: "Lesotho Flag",
    keywords: [
      "ls",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f1-1f1f8",
        native: "🇱🇸"
      }
    ],
    version: 2
  },
  "flag-lt": {
    id: "flag-lt",
    name: "Lithuania Flag",
    keywords: [
      "lt",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f1-1f1f9",
        native: "🇱🇹"
      }
    ],
    version: 2
  },
  "flag-lu": {
    id: "flag-lu",
    name: "Luxembourg Flag",
    keywords: [
      "lu",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f1-1f1fa",
        native: "🇱🇺"
      }
    ],
    version: 2
  },
  "flag-lv": {
    id: "flag-lv",
    name: "Latvia Flag",
    keywords: [
      "lv",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f1-1f1fb",
        native: "🇱🇻"
      }
    ],
    version: 2
  },
  "flag-ly": {
    id: "flag-ly",
    name: "Libya Flag",
    keywords: [
      "ly",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f1-1f1fe",
        native: "🇱🇾"
      }
    ],
    version: 2
  },
  "flag-ma": {
    id: "flag-ma",
    name: "Morocco Flag",
    keywords: [
      "ma",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f2-1f1e6",
        native: "🇲🇦"
      }
    ],
    version: 2
  },
  "flag-mc": {
    id: "flag-mc",
    name: "Monaco Flag",
    keywords: [
      "mc",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f2-1f1e8",
        native: "🇲🇨"
      }
    ],
    version: 2
  },
  "flag-md": {
    id: "flag-md",
    name: "Moldova Flag",
    keywords: [
      "md",
      "republic",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f2-1f1e9",
        native: "🇲🇩"
      }
    ],
    version: 2
  },
  "flag-me": {
    id: "flag-me",
    name: "Montenegro Flag",
    keywords: [
      "me",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f2-1f1ea",
        native: "🇲🇪"
      }
    ],
    version: 2
  },
  "flag-mf": {
    id: "flag-mf",
    name: "St. Martin Flag",
    keywords: [
      "mf",
      "st"
    ],
    skins: [
      {
        unified: "1f1f2-1f1eb",
        native: "🇲🇫"
      }
    ],
    version: 2
  },
  "flag-mg": {
    id: "flag-mg",
    name: "Madagascar Flag",
    keywords: [
      "mg",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f2-1f1ec",
        native: "🇲🇬"
      }
    ],
    version: 2
  },
  "flag-mh": {
    id: "flag-mh",
    name: "Marshall Islands Flag",
    keywords: [
      "mh",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f2-1f1ed",
        native: "🇲🇭"
      }
    ],
    version: 2
  },
  "flag-mk": {
    id: "flag-mk",
    name: "North Macedonia Flag",
    keywords: [
      "mk",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f2-1f1f0",
        native: "🇲🇰"
      }
    ],
    version: 2
  },
  "flag-ml": {
    id: "flag-ml",
    name: "Mali Flag",
    keywords: [
      "ml",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f2-1f1f1",
        native: "🇲🇱"
      }
    ],
    version: 2
  },
  "flag-mm": {
    id: "flag-mm",
    name: "Myanmar (burma) Flag",
    keywords: [
      "mm",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f2-1f1f2",
        native: "🇲🇲"
      }
    ],
    version: 2
  },
  "flag-mn": {
    id: "flag-mn",
    name: "Mongolia Flag",
    keywords: [
      "mn",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f2-1f1f3",
        native: "🇲🇳"
      }
    ],
    version: 2
  },
  "flag-mo": {
    id: "flag-mo",
    name: "Macao Sar China Flag",
    keywords: [
      "mo",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f2-1f1f4",
        native: "🇲🇴"
      }
    ],
    version: 2
  },
  "flag-mp": {
    id: "flag-mp",
    name: "Northern Mariana Islands Flag",
    keywords: [
      "mp",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f2-1f1f5",
        native: "🇲🇵"
      }
    ],
    version: 2
  },
  "flag-mq": {
    id: "flag-mq",
    name: "Martinique Flag",
    keywords: [
      "mq",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f2-1f1f6",
        native: "🇲🇶"
      }
    ],
    version: 2
  },
  "flag-mr": {
    id: "flag-mr",
    name: "Mauritania Flag",
    keywords: [
      "mr",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f2-1f1f7",
        native: "🇲🇷"
      }
    ],
    version: 2
  },
  "flag-ms": {
    id: "flag-ms",
    name: "Montserrat Flag",
    keywords: [
      "ms",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f2-1f1f8",
        native: "🇲🇸"
      }
    ],
    version: 2
  },
  "flag-mt": {
    id: "flag-mt",
    name: "Malta Flag",
    keywords: [
      "mt",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f2-1f1f9",
        native: "🇲🇹"
      }
    ],
    version: 2
  },
  "flag-mu": {
    id: "flag-mu",
    name: "Mauritius Flag",
    keywords: [
      "mu",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f2-1f1fa",
        native: "🇲🇺"
      }
    ],
    version: 2
  },
  "flag-mv": {
    id: "flag-mv",
    name: "Maldives Flag",
    keywords: [
      "mv",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f2-1f1fb",
        native: "🇲🇻"
      }
    ],
    version: 2
  },
  "flag-mw": {
    id: "flag-mw",
    name: "Malawi Flag",
    keywords: [
      "mw",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f2-1f1fc",
        native: "🇲🇼"
      }
    ],
    version: 2
  },
  "flag-mx": {
    id: "flag-mx",
    name: "Mexico Flag",
    keywords: [
      "mx",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f2-1f1fd",
        native: "🇲🇽"
      }
    ],
    version: 2
  },
  "flag-my": {
    id: "flag-my",
    name: "Malaysia Flag",
    keywords: [
      "my",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f2-1f1fe",
        native: "🇲🇾"
      }
    ],
    version: 2
  },
  "flag-mz": {
    id: "flag-mz",
    name: "Mozambique Flag",
    keywords: [
      "mz",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f2-1f1ff",
        native: "🇲🇿"
      }
    ],
    version: 2
  },
  "flag-na": {
    id: "flag-na",
    name: "Namibia Flag",
    keywords: [
      "na",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f3-1f1e6",
        native: "🇳🇦"
      }
    ],
    version: 2
  },
  "flag-nc": {
    id: "flag-nc",
    name: "New Caledonia Flag",
    keywords: [
      "nc",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f3-1f1e8",
        native: "🇳🇨"
      }
    ],
    version: 2
  },
  "flag-ne": {
    id: "flag-ne",
    name: "Niger Flag",
    keywords: [
      "ne",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f3-1f1ea",
        native: "🇳🇪"
      }
    ],
    version: 2
  },
  "flag-nf": {
    id: "flag-nf",
    name: "Norfolk Island Flag",
    keywords: [
      "nf",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f3-1f1eb",
        native: "🇳🇫"
      }
    ],
    version: 2
  },
  "flag-ng": {
    id: "flag-ng",
    name: "Nigeria Flag",
    keywords: [
      "ng",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f3-1f1ec",
        native: "🇳🇬"
      }
    ],
    version: 2
  },
  "flag-ni": {
    id: "flag-ni",
    name: "Nicaragua Flag",
    keywords: [
      "ni",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f3-1f1ee",
        native: "🇳🇮"
      }
    ],
    version: 2
  },
  "flag-nl": {
    id: "flag-nl",
    name: "Netherlands Flag",
    keywords: [
      "nl",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f3-1f1f1",
        native: "🇳🇱"
      }
    ],
    version: 2
  },
  "flag-no": {
    id: "flag-no",
    name: "Norway Flag",
    keywords: [
      "no",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f3-1f1f4",
        native: "🇳🇴"
      }
    ],
    version: 2
  },
  "flag-np": {
    id: "flag-np",
    name: "Nepal Flag",
    keywords: [
      "np",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f3-1f1f5",
        native: "🇳🇵"
      }
    ],
    version: 2
  },
  "flag-nr": {
    id: "flag-nr",
    name: "Nauru Flag",
    keywords: [
      "nr",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f3-1f1f7",
        native: "🇳🇷"
      }
    ],
    version: 2
  },
  "flag-nu": {
    id: "flag-nu",
    name: "Niue Flag",
    keywords: [
      "nu",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f3-1f1fa",
        native: "🇳🇺"
      }
    ],
    version: 2
  },
  "flag-nz": {
    id: "flag-nz",
    name: "New Zealand Flag",
    keywords: [
      "nz",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f3-1f1ff",
        native: "🇳🇿"
      }
    ],
    version: 2
  },
  "flag-om": {
    id: "flag-om",
    name: "Oman Flag",
    keywords: [
      "om",
      "symbol",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f4-1f1f2",
        native: "🇴🇲"
      }
    ],
    version: 2
  },
  "flag-pa": {
    id: "flag-pa",
    name: "Panama Flag",
    keywords: [
      "pa",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f5-1f1e6",
        native: "🇵🇦"
      }
    ],
    version: 2
  },
  "flag-pe": {
    id: "flag-pe",
    name: "Peru Flag",
    keywords: [
      "pe",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f5-1f1ea",
        native: "🇵🇪"
      }
    ],
    version: 2
  },
  "flag-pf": {
    id: "flag-pf",
    name: "French Polynesia Flag",
    keywords: [
      "pf",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f5-1f1eb",
        native: "🇵🇫"
      }
    ],
    version: 2
  },
  "flag-pg": {
    id: "flag-pg",
    name: "Papua New Guinea Flag",
    keywords: [
      "pg",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f5-1f1ec",
        native: "🇵🇬"
      }
    ],
    version: 2
  },
  "flag-ph": {
    id: "flag-ph",
    name: "Philippines Flag",
    keywords: [
      "ph",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f5-1f1ed",
        native: "🇵🇭"
      }
    ],
    version: 2
  },
  "flag-pk": {
    id: "flag-pk",
    name: "Pakistan Flag",
    keywords: [
      "pk",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f5-1f1f0",
        native: "🇵🇰"
      }
    ],
    version: 2
  },
  "flag-pl": {
    id: "flag-pl",
    name: "Poland Flag",
    keywords: [
      "pl",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f5-1f1f1",
        native: "🇵🇱"
      }
    ],
    version: 2
  },
  "flag-pm": {
    id: "flag-pm",
    name: "St. Pierre & Miquelon Flag",
    keywords: [
      "pm",
      "st",
      "saint",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f5-1f1f2",
        native: "🇵🇲"
      }
    ],
    version: 2
  },
  "flag-pn": {
    id: "flag-pn",
    name: "Pitcairn Islands Flag",
    keywords: [
      "pn",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f5-1f1f3",
        native: "🇵🇳"
      }
    ],
    version: 2
  },
  "flag-pr": {
    id: "flag-pr",
    name: "Puerto Rico Flag",
    keywords: [
      "pr",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f5-1f1f7",
        native: "🇵🇷"
      }
    ],
    version: 2
  },
  "flag-ps": {
    id: "flag-ps",
    name: "Palestinian Territories Flag",
    keywords: [
      "ps",
      "palestine",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f5-1f1f8",
        native: "🇵🇸"
      }
    ],
    version: 2
  },
  "flag-pt": {
    id: "flag-pt",
    name: "Portugal Flag",
    keywords: [
      "pt",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f5-1f1f9",
        native: "🇵🇹"
      }
    ],
    version: 2
  },
  "flag-pw": {
    id: "flag-pw",
    name: "Palau Flag",
    keywords: [
      "pw",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f5-1f1fc",
        native: "🇵🇼"
      }
    ],
    version: 2
  },
  "flag-py": {
    id: "flag-py",
    name: "Paraguay Flag",
    keywords: [
      "py",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f5-1f1fe",
        native: "🇵🇾"
      }
    ],
    version: 2
  },
  "flag-qa": {
    id: "flag-qa",
    name: "Qatar Flag",
    keywords: [
      "qa",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f6-1f1e6",
        native: "🇶🇦"
      }
    ],
    version: 2
  },
  "flag-re": {
    id: "flag-re",
    name: "Réunion Flag",
    keywords: [
      "re",
      "reunion",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f7-1f1ea",
        native: "🇷🇪"
      }
    ],
    version: 2
  },
  "flag-ro": {
    id: "flag-ro",
    name: "Romania Flag",
    keywords: [
      "ro",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f7-1f1f4",
        native: "🇷🇴"
      }
    ],
    version: 2
  },
  "flag-rs": {
    id: "flag-rs",
    name: "Serbia Flag",
    keywords: [
      "rs",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f7-1f1f8",
        native: "🇷🇸"
      }
    ],
    version: 2
  },
  ru: {
    id: "ru",
    name: "Russia Flag",
    keywords: [
      "ru",
      "russian",
      "federation",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f7-1f1fa",
        native: "🇷🇺"
      }
    ],
    version: 1
  },
  "flag-rw": {
    id: "flag-rw",
    name: "Rwanda Flag",
    keywords: [
      "rw",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f7-1f1fc",
        native: "🇷🇼"
      }
    ],
    version: 2
  },
  "flag-sa": {
    id: "flag-sa",
    name: "Saudi Arabia Flag",
    keywords: [
      "sa",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f8-1f1e6",
        native: "🇸🇦"
      }
    ],
    version: 2
  },
  "flag-sb": {
    id: "flag-sb",
    name: "Solomon Islands Flag",
    keywords: [
      "sb",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f8-1f1e7",
        native: "🇸🇧"
      }
    ],
    version: 2
  },
  "flag-sc": {
    id: "flag-sc",
    name: "Seychelles Flag",
    keywords: [
      "sc",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f8-1f1e8",
        native: "🇸🇨"
      }
    ],
    version: 2
  },
  "flag-sd": {
    id: "flag-sd",
    name: "Sudan Flag",
    keywords: [
      "sd",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f8-1f1e9",
        native: "🇸🇩"
      }
    ],
    version: 2
  },
  "flag-se": {
    id: "flag-se",
    name: "Sweden Flag",
    keywords: [
      "se",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f8-1f1ea",
        native: "🇸🇪"
      }
    ],
    version: 2
  },
  "flag-sg": {
    id: "flag-sg",
    name: "Singapore Flag",
    keywords: [
      "sg",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f8-1f1ec",
        native: "🇸🇬"
      }
    ],
    version: 2
  },
  "flag-sh": {
    id: "flag-sh",
    name: "St. Helena Flag",
    keywords: [
      "sh",
      "st",
      "saint",
      "ascension",
      "tristan",
      "cunha",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f8-1f1ed",
        native: "🇸🇭"
      }
    ],
    version: 2
  },
  "flag-si": {
    id: "flag-si",
    name: "Slovenia Flag",
    keywords: [
      "si",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f8-1f1ee",
        native: "🇸🇮"
      }
    ],
    version: 2
  },
  "flag-sj": {
    id: "flag-sj",
    name: "Svalbard & Jan Mayen Flag",
    keywords: [
      "sj"
    ],
    skins: [
      {
        unified: "1f1f8-1f1ef",
        native: "🇸🇯"
      }
    ],
    version: 2
  },
  "flag-sk": {
    id: "flag-sk",
    name: "Slovakia Flag",
    keywords: [
      "sk",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f8-1f1f0",
        native: "🇸🇰"
      }
    ],
    version: 2
  },
  "flag-sl": {
    id: "flag-sl",
    name: "Sierra Leone Flag",
    keywords: [
      "sl",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f8-1f1f1",
        native: "🇸🇱"
      }
    ],
    version: 2
  },
  "flag-sm": {
    id: "flag-sm",
    name: "San Marino Flag",
    keywords: [
      "sm",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f8-1f1f2",
        native: "🇸🇲"
      }
    ],
    version: 2
  },
  "flag-sn": {
    id: "flag-sn",
    name: "Senegal Flag",
    keywords: [
      "sn",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f8-1f1f3",
        native: "🇸🇳"
      }
    ],
    version: 2
  },
  "flag-so": {
    id: "flag-so",
    name: "Somalia Flag",
    keywords: [
      "so",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f8-1f1f4",
        native: "🇸🇴"
      }
    ],
    version: 2
  },
  "flag-sr": {
    id: "flag-sr",
    name: "Suriname Flag",
    keywords: [
      "sr",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f8-1f1f7",
        native: "🇸🇷"
      }
    ],
    version: 2
  },
  "flag-ss": {
    id: "flag-ss",
    name: "South Sudan Flag",
    keywords: [
      "ss",
      "sd",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f8-1f1f8",
        native: "🇸🇸"
      }
    ],
    version: 2
  },
  "flag-st": {
    id: "flag-st",
    name: "São Tomé & Príncipe Flag",
    keywords: [
      "st",
      "sao",
      "tome",
      "principe",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f8-1f1f9",
        native: "🇸🇹"
      }
    ],
    version: 2
  },
  "flag-sv": {
    id: "flag-sv",
    name: "El Salvador Flag",
    keywords: [
      "sv",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f8-1f1fb",
        native: "🇸🇻"
      }
    ],
    version: 2
  },
  "flag-sx": {
    id: "flag-sx",
    name: "Sint Maarten Flag",
    keywords: [
      "sx",
      "dutch",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f8-1f1fd",
        native: "🇸🇽"
      }
    ],
    version: 2
  },
  "flag-sy": {
    id: "flag-sy",
    name: "Syria Flag",
    keywords: [
      "sy",
      "syrian",
      "arab",
      "republic",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f8-1f1fe",
        native: "🇸🇾"
      }
    ],
    version: 2
  },
  "flag-sz": {
    id: "flag-sz",
    name: "Eswatini Flag",
    keywords: [
      "sz",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f8-1f1ff",
        native: "🇸🇿"
      }
    ],
    version: 2
  },
  "flag-ta": {
    id: "flag-ta",
    name: "Tristan Da Cunha Flag",
    keywords: [
      "ta"
    ],
    skins: [
      {
        unified: "1f1f9-1f1e6",
        native: "🇹🇦"
      }
    ],
    version: 2
  },
  "flag-tc": {
    id: "flag-tc",
    name: "Turks & Caicos Islands Flag",
    keywords: [
      "tc",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f9-1f1e8",
        native: "🇹🇨"
      }
    ],
    version: 2
  },
  "flag-td": {
    id: "flag-td",
    name: "Chad Flag",
    keywords: [
      "td",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f9-1f1e9",
        native: "🇹🇩"
      }
    ],
    version: 2
  },
  "flag-tf": {
    id: "flag-tf",
    name: "French Southern Territories Flag",
    keywords: [
      "tf",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f9-1f1eb",
        native: "🇹🇫"
      }
    ],
    version: 2
  },
  "flag-tg": {
    id: "flag-tg",
    name: "Togo Flag",
    keywords: [
      "tg",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f9-1f1ec",
        native: "🇹🇬"
      }
    ],
    version: 2
  },
  "flag-th": {
    id: "flag-th",
    name: "Thailand Flag",
    keywords: [
      "th",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f9-1f1ed",
        native: "🇹🇭"
      }
    ],
    version: 2
  },
  "flag-tj": {
    id: "flag-tj",
    name: "Tajikistan Flag",
    keywords: [
      "tj",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f9-1f1ef",
        native: "🇹🇯"
      }
    ],
    version: 2
  },
  "flag-tk": {
    id: "flag-tk",
    name: "Tokelau Flag",
    keywords: [
      "tk",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f9-1f1f0",
        native: "🇹🇰"
      }
    ],
    version: 2
  },
  "flag-tl": {
    id: "flag-tl",
    name: "Timor-Leste Flag",
    keywords: [
      "tl",
      "timor",
      "leste",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f9-1f1f1",
        native: "🇹🇱"
      }
    ],
    version: 2
  },
  "flag-tm": {
    id: "flag-tm",
    name: "Turkmenistan Flag",
    keywords: [
      "tm",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f9-1f1f2",
        native: "🇹🇲"
      }
    ],
    version: 2
  },
  "flag-tn": {
    id: "flag-tn",
    name: "Tunisia Flag",
    keywords: [
      "tn",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f9-1f1f3",
        native: "🇹🇳"
      }
    ],
    version: 2
  },
  "flag-to": {
    id: "flag-to",
    name: "Tonga Flag",
    keywords: [
      "to",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f9-1f1f4",
        native: "🇹🇴"
      }
    ],
    version: 2
  },
  "flag-tr": {
    id: "flag-tr",
    name: "Turkey Flag",
    keywords: [
      "tr",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f9-1f1f7",
        native: "🇹🇷"
      }
    ],
    version: 2
  },
  "flag-tt": {
    id: "flag-tt",
    name: "Trinidad & Tobago Flag",
    keywords: [
      "tt",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f9-1f1f9",
        native: "🇹🇹"
      }
    ],
    version: 2
  },
  "flag-tv": {
    id: "flag-tv",
    name: "Tuvalu Flag",
    keywords: [
      "tv",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f9-1f1fb",
        native: "🇹🇻"
      }
    ],
    version: 2
  },
  "flag-tw": {
    id: "flag-tw",
    name: "Taiwan Flag",
    keywords: [
      "tw",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f9-1f1fc",
        native: "🇹🇼"
      }
    ],
    version: 2
  },
  "flag-tz": {
    id: "flag-tz",
    name: "Tanzania Flag",
    keywords: [
      "tz",
      "united",
      "republic",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f9-1f1ff",
        native: "🇹🇿"
      }
    ],
    version: 2
  },
  "flag-ua": {
    id: "flag-ua",
    name: "Ukraine Flag",
    keywords: [
      "ua",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1fa-1f1e6",
        native: "🇺🇦"
      }
    ],
    version: 2
  },
  "flag-ug": {
    id: "flag-ug",
    name: "Uganda Flag",
    keywords: [
      "ug",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1fa-1f1ec",
        native: "🇺🇬"
      }
    ],
    version: 2
  },
  "flag-um": {
    id: "flag-um",
    name: "U.s. Outlying Islands Flag",
    keywords: [
      "um",
      "u",
      "s"
    ],
    skins: [
      {
        unified: "1f1fa-1f1f2",
        native: "🇺🇲"
      }
    ],
    version: 2
  },
  "flag-un": {
    id: "flag-un",
    name: "United Nations Flag",
    keywords: [
      "un",
      "banner"
    ],
    skins: [
      {
        unified: "1f1fa-1f1f3",
        native: "🇺🇳"
      }
    ],
    version: 4
  },
  us: {
    id: "us",
    name: "United States Flag",
    keywords: [
      "us",
      "america",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1fa-1f1f8",
        native: "🇺🇸"
      }
    ],
    version: 1
  },
  "flag-uy": {
    id: "flag-uy",
    name: "Uruguay Flag",
    keywords: [
      "uy",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1fa-1f1fe",
        native: "🇺🇾"
      }
    ],
    version: 2
  },
  "flag-uz": {
    id: "flag-uz",
    name: "Uzbekistan Flag",
    keywords: [
      "uz",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1fa-1f1ff",
        native: "🇺🇿"
      }
    ],
    version: 2
  },
  "flag-va": {
    id: "flag-va",
    name: "Vatican City Flag",
    keywords: [
      "va",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1fb-1f1e6",
        native: "🇻🇦"
      }
    ],
    version: 2
  },
  "flag-vc": {
    id: "flag-vc",
    name: "St. Vincent & Grenadines Flag",
    keywords: [
      "vc",
      "st",
      "saint",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1fb-1f1e8",
        native: "🇻🇨"
      }
    ],
    version: 2
  },
  "flag-ve": {
    id: "flag-ve",
    name: "Venezuela Flag",
    keywords: [
      "ve",
      "bolivarian",
      "republic",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1fb-1f1ea",
        native: "🇻🇪"
      }
    ],
    version: 2
  },
  "flag-vg": {
    id: "flag-vg",
    name: "British Virgin Islands Flag",
    keywords: [
      "vg",
      "bvi",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1fb-1f1ec",
        native: "🇻🇬"
      }
    ],
    version: 2
  },
  "flag-vi": {
    id: "flag-vi",
    name: "U.s. Virgin Islands Flag",
    keywords: [
      "vi",
      "u",
      "s",
      "us",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1fb-1f1ee",
        native: "🇻🇮"
      }
    ],
    version: 2
  },
  "flag-vn": {
    id: "flag-vn",
    name: "Vietnam Flag",
    keywords: [
      "vn",
      "viet",
      "nam",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1fb-1f1f3",
        native: "🇻🇳"
      }
    ],
    version: 2
  },
  "flag-vu": {
    id: "flag-vu",
    name: "Vanuatu Flag",
    keywords: [
      "vu",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1fb-1f1fa",
        native: "🇻🇺"
      }
    ],
    version: 2
  },
  "flag-wf": {
    id: "flag-wf",
    name: "Wallis & Futuna Flag",
    keywords: [
      "wf",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1fc-1f1eb",
        native: "🇼🇫"
      }
    ],
    version: 2
  },
  "flag-ws": {
    id: "flag-ws",
    name: "Samoa Flag",
    keywords: [
      "ws",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1fc-1f1f8",
        native: "🇼🇸"
      }
    ],
    version: 2
  },
  "flag-xk": {
    id: "flag-xk",
    name: "Kosovo Flag",
    keywords: [
      "xk",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1fd-1f1f0",
        native: "🇽🇰"
      }
    ],
    version: 2
  },
  "flag-ye": {
    id: "flag-ye",
    name: "Yemen Flag",
    keywords: [
      "ye",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1fe-1f1ea",
        native: "🇾🇪"
      }
    ],
    version: 2
  },
  "flag-yt": {
    id: "flag-yt",
    name: "Mayotte Flag",
    keywords: [
      "yt",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1fe-1f1f9",
        native: "🇾🇹"
      }
    ],
    version: 2
  },
  "flag-za": {
    id: "flag-za",
    name: "South Africa Flag",
    keywords: [
      "za",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ff-1f1e6",
        native: "🇿🇦"
      }
    ],
    version: 2
  },
  "flag-zm": {
    id: "flag-zm",
    name: "Zambia Flag",
    keywords: [
      "zm",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ff-1f1f2",
        native: "🇿🇲"
      }
    ],
    version: 2
  },
  "flag-zw": {
    id: "flag-zw",
    name: "Zimbabwe Flag",
    keywords: [
      "zw",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ff-1f1fc",
        native: "🇿🇼"
      }
    ],
    version: 2
  },
  "flag-england": {
    id: "flag-england",
    name: "England Flag",
    keywords: [
      "english"
    ],
    skins: [
      {
        unified: "1f3f4-e0067-e0062-e0065-e006e-e0067-e007f",
        native: "🏴󠁧󠁢󠁥󠁮󠁧󠁿"
      }
    ],
    version: 5
  },
  "flag-scotland": {
    id: "flag-scotland",
    name: "Scotland Flag",
    keywords: [
      "scottish"
    ],
    skins: [
      {
        unified: "1f3f4-e0067-e0062-e0073-e0063-e0074-e007f",
        native: "🏴󠁧󠁢󠁳󠁣󠁴󠁿"
      }
    ],
    version: 5
  },
  "flag-wales": {
    id: "flag-wales",
    name: "Wales Flag",
    keywords: [
      "welsh"
    ],
    skins: [
      {
        unified: "1f3f4-e0067-e0062-e0077-e006c-e0073-e007f",
        native: "🏴󠁧󠁢󠁷󠁬󠁳󠁿"
      }
    ],
    version: 5
  }
}, cl = {
  satisfied: "laughing",
  grinning_face_with_star_eyes: "star-struck",
  grinning_face_with_one_large_and_one_small_eye: "zany_face",
  smiling_face_with_smiling_eyes_and_hand_covering_mouth: "face_with_hand_over_mouth",
  face_with_finger_covering_closed_lips: "shushing_face",
  face_with_one_eyebrow_raised: "face_with_raised_eyebrow",
  face_with_open_mouth_vomiting: "face_vomiting",
  shocked_face_with_exploding_head: "exploding_head",
  serious_face_with_symbols_covering_mouth: "face_with_symbols_on_mouth",
  poop: "hankey",
  shit: "hankey",
  collision: "boom",
  raised_hand: "hand",
  hand_with_index_and_middle_fingers_crossed: "crossed_fingers",
  sign_of_the_horns: "the_horns",
  reversed_hand_with_middle_finger_extended: "middle_finger",
  thumbsup: "+1",
  thumbsdown: "-1",
  punch: "facepunch",
  mother_christmas: "mrs_claus",
  running: "runner",
  "man-with-bunny-ears-partying": "men-with-bunny-ears-partying",
  "woman-with-bunny-ears-partying": "women-with-bunny-ears-partying",
  women_holding_hands: "two_women_holding_hands",
  woman_and_man_holding_hands: "man_and_woman_holding_hands",
  couple: "man_and_woman_holding_hands",
  men_holding_hands: "two_men_holding_hands",
  paw_prints: "feet",
  flipper: "dolphin",
  honeybee: "bee",
  lady_beetle: "ladybug",
  cooking: "fried_egg",
  knife: "hocho",
  red_car: "car",
  sailboat: "boat",
  waxing_gibbous_moon: "moon",
  sun_small_cloud: "mostly_sunny",
  sun_behind_cloud: "barely_sunny",
  sun_behind_rain_cloud: "partly_sunny_rain",
  lightning_cloud: "lightning",
  tornado_cloud: "tornado",
  tshirt: "shirt",
  shoe: "mans_shoe",
  telephone: "phone",
  lantern: "izakaya_lantern",
  open_book: "book",
  envelope: "email",
  pencil: "memo",
  heavy_exclamation_mark: "exclamation",
  staff_of_aesculapius: "medical_symbol",
  "flag-cn": "cn",
  "flag-de": "de",
  "flag-es": "es",
  "flag-fr": "fr",
  uk: "gb",
  "flag-gb": "gb",
  "flag-it": "it",
  "flag-jp": "jp",
  "flag-kr": "kr",
  "flag-ru": "ru",
  "flag-us": "us"
}, ml = {
  cols: 61,
  rows: 61
}, vl = {
  categories: fl,
  emojis: ll,
  aliases: cl,
  sheet: ml
};
function Td(e) {
  return e && e.__esModule ? e.default : e;
}
function un(e, i, d) {
  return i in e ? Object.defineProperty(e, i, {
    value: d,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[i] = d, e;
}
var ra, ge, Nd, ei, xd, cr, Ji = {}, Fd = [], hl = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i;
function jn(e, i) {
  for (var d in i) e[d] = i[d];
  return e;
}
function Ed(e) {
  var i = e.parentNode;
  i && i.removeChild(e);
}
function Tt(e, i, d) {
  var a, t, o, m = {};
  for (o in i) o == "key" ? a = i[o] : o == "ref" ? t = i[o] : m[o] = i[o];
  if (arguments.length > 2 && (m.children = arguments.length > 3 ? ra.call(arguments, 2) : d), typeof e == "function" && e.defaultProps != null) for (o in e.defaultProps) m[o] === void 0 && (m[o] = e.defaultProps[o]);
  return Xi(e, m, a, t, null);
}
function Xi(e, i, d, a, t) {
  var o = {
    type: e,
    props: i,
    key: d,
    ref: a,
    __k: null,
    __: null,
    __b: 0,
    __e: null,
    __d: void 0,
    __c: null,
    __h: null,
    constructor: void 0,
    __v: t ?? ++Nd
  };
  return t == null && ge.vnode != null && ge.vnode(o), o;
}
function _n() {
  return {
    current: null
  };
}
function Zn(e) {
  return e.children;
}
function gn(e, i) {
  this.props = e, this.context = i;
}
function An(e, i) {
  if (i == null) return e.__ ? An(e.__, e.__.__k.indexOf(e) + 1) : null;
  for (var d; i < e.__k.length; i++) if ((d = e.__k[i]) != null && d.__e != null) return d.__e;
  return typeof e.type == "function" ? An(e) : null;
}
function Rd(e) {
  var i, d;
  if ((e = e.__) != null && e.__c != null) {
    for (e.__e = e.__c.base = null, i = 0; i < e.__k.length; i++) if ((d = e.__k[i]) != null && d.__e != null) {
      e.__e = e.__c.base = d.__e;
      break;
    }
    return Rd(e);
  }
}
function mr(e) {
  (!e.__d && (e.__d = !0) && ei.push(e) && !Qi.__r++ || cr !== ge.debounceRendering) && ((cr = ge.debounceRendering) || xd)(Qi);
}
function Qi() {
  for (var e; Qi.__r = ei.length; ) e = ei.sort(function(i, d) {
    return i.__v.__b - d.__v.__b;
  }), ei = [], e.some(function(i) {
    var d, a, t, o, m, p;
    i.__d && (m = (o = (d = i).__v).__e, (p = d.__P) && (a = [], (t = jn({}, o)).__v = o.__v + 1, Bt(p, o, t, d.__n, p.ownerSVGElement !== void 0, o.__h != null ? [
      m
    ] : null, a, m ?? An(o), o.__h), Ad(a, o), o.__e != m && Rd(o)));
  });
}
function Ld(e, i, d, a, t, o, m, p, s, r) {
  var u, l, n, f, v, D, F, A = a && a.__k || Fd, ae = A.length;
  for (d.__k = [], u = 0; u < i.length; u++) if ((f = d.__k[u] = (f = i[u]) == null || typeof f == "boolean" ? null : typeof f == "string" || typeof f == "number" || typeof f == "bigint" ? Xi(null, f, null, null, f) : Array.isArray(f) ? Xi(Zn, {
    children: f
  }, null, null, null) : f.__b > 0 ? Xi(f.type, f.props, f.key, null, f.__v) : f) != null) {
    if (f.__ = d, f.__b = d.__b + 1, (n = A[u]) === null || n && f.key == n.key && f.type === n.type) A[u] = void 0;
    else for (l = 0; l < ae; l++) {
      if ((n = A[l]) && f.key == n.key && f.type === n.type) {
        A[l] = void 0;
        break;
      }
      n = null;
    }
    Bt(e, f, n = n || Ji, t, o, m, p, s, r), v = f.__e, (l = f.ref) && n.ref != l && (F || (F = []), n.ref && F.push(n.ref, null, f), F.push(l, f.__c || v, f)), v != null ? (D == null && (D = v), typeof f.type == "function" && f.__k === n.__k ? f.__d = s = qd(f, s, e) : s = Zd(e, f, n, A, v, s), typeof d.type == "function" && (d.__d = s)) : s && n.__e == s && s.parentNode != e && (s = An(n));
  }
  for (d.__e = D, u = ae; u--; ) A[u] != null && (typeof d.type == "function" && A[u].__e != null && A[u].__e == d.__d && (d.__d = An(a, u + 1)), Hd(A[u], A[u]));
  if (F) for (u = 0; u < F.length; u++) Vd(F[u], F[++u], F[++u]);
}
function qd(e, i, d) {
  for (var a, t = e.__k, o = 0; t && o < t.length; o++) (a = t[o]) && (a.__ = e, i = typeof a.type == "function" ? qd(a, i, d) : Zd(d, a, a, t, a.__e, i));
  return i;
}
function ea(e, i) {
  return i = i || [], e == null || typeof e == "boolean" || (Array.isArray(e) ? e.some(function(d) {
    ea(d, i);
  }) : i.push(e)), i;
}
function Zd(e, i, d, a, t, o) {
  var m, p, s;
  if (i.__d !== void 0) m = i.__d, i.__d = void 0;
  else if (d == null || t != o || t.parentNode == null) e: if (o == null || o.parentNode !== e) e.appendChild(t), m = null;
  else {
    for (p = o, s = 0; (p = p.nextSibling) && s < a.length; s += 2) if (p == t) break e;
    e.insertBefore(t, o), m = o;
  }
  return m !== void 0 ? m : t.nextSibling;
}
function gl(e, i, d, a, t) {
  var o;
  for (o in d) o === "children" || o === "key" || o in i || na(e, o, null, d[o], a);
  for (o in i) t && typeof i[o] != "function" || o === "children" || o === "key" || o === "value" || o === "checked" || d[o] === i[o] || na(e, o, i[o], d[o], a);
}
function vr(e, i, d) {
  i[0] === "-" ? e.setProperty(i, d) : e[i] = d == null ? "" : typeof d != "number" || hl.test(i) ? d : d + "px";
}
function na(e, i, d, a, t) {
  var o;
  e: if (i === "style")
    if (typeof d == "string") e.style.cssText = d;
    else {
      if (typeof a == "string" && (e.style.cssText = a = ""), a) for (i in a) d && i in d || vr(e.style, i, "");
      if (d) for (i in d) a && d[i] === a[i] || vr(e.style, i, d[i]);
    }
  else if (i[0] === "o" && i[1] === "n") o = i !== (i = i.replace(/Capture$/, "")), i = i.toLowerCase() in e ? i.toLowerCase().slice(2) : i.slice(2), e.l || (e.l = {}), e.l[i + o] = d, d ? a || e.addEventListener(i, o ? gr : hr, o) : e.removeEventListener(i, o ? gr : hr, o);
  else if (i !== "dangerouslySetInnerHTML") {
    if (t) i = i.replace(/xlink[H:h]/, "h").replace(/sName$/, "s");
    else if (i !== "href" && i !== "list" && i !== "form" && i !== "tabIndex" && i !== "download" && i in e) try {
      e[i] = d ?? "";
      break e;
    } catch {
    }
    typeof d == "function" || (d != null && (d !== !1 || i[0] === "a" && i[1] === "r") ? e.setAttribute(i, d) : e.removeAttribute(i));
  }
}
function hr(e) {
  this.l[e.type + !1](ge.event ? ge.event(e) : e);
}
function gr(e) {
  this.l[e.type + !0](ge.event ? ge.event(e) : e);
}
function Bt(e, i, d, a, t, o, m, p, s) {
  var r, u, l, n, f, v, D, F, A, ae, ne, ce = i.type;
  if (i.constructor !== void 0) return null;
  d.__h != null && (s = d.__h, p = i.__e = d.__e, i.__h = null, o = [
    p
  ]), (r = ge.__b) && r(i);
  try {
    e: if (typeof ce == "function") {
      if (F = i.props, A = (r = ce.contextType) && a[r.__c], ae = r ? A ? A.props.value : r.__ : a, d.__c ? D = (u = i.__c = d.__c).__ = u.__E : ("prototype" in ce && ce.prototype.render ? i.__c = u = new ce(F, ae) : (i.__c = u = new gn(F, ae), u.constructor = ce, u.render = bl), A && A.sub(u), u.props = F, u.state || (u.state = {}), u.context = ae, u.__n = a, l = u.__d = !0, u.__h = []), u.__s == null && (u.__s = u.state), ce.getDerivedStateFromProps != null && (u.__s == u.state && (u.__s = jn({}, u.__s)), jn(u.__s, ce.getDerivedStateFromProps(F, u.__s))), n = u.props, f = u.state, l) ce.getDerivedStateFromProps == null && u.componentWillMount != null && u.componentWillMount(), u.componentDidMount != null && u.__h.push(u.componentDidMount);
      else {
        if (ce.getDerivedStateFromProps == null && F !== n && u.componentWillReceiveProps != null && u.componentWillReceiveProps(F, ae), !u.__e && u.shouldComponentUpdate != null && u.shouldComponentUpdate(F, u.__s, ae) === !1 || i.__v === d.__v) {
          u.props = F, u.state = u.__s, i.__v !== d.__v && (u.__d = !1), u.__v = i, i.__e = d.__e, i.__k = d.__k, i.__k.forEach(function(Q) {
            Q && (Q.__ = i);
          }), u.__h.length && m.push(u);
          break e;
        }
        u.componentWillUpdate != null && u.componentWillUpdate(F, u.__s, ae), u.componentDidUpdate != null && u.__h.push(function() {
          u.componentDidUpdate(n, f, v);
        });
      }
      u.context = ae, u.props = F, u.state = u.__s, (r = ge.__r) && r(i), u.__d = !1, u.__v = i, u.__P = e, r = u.render(u.props, u.state, u.context), u.state = u.__s, u.getChildContext != null && (a = jn(jn({}, a), u.getChildContext())), l || u.getSnapshotBeforeUpdate == null || (v = u.getSnapshotBeforeUpdate(n, f)), ne = r != null && r.type === Zn && r.key == null ? r.props.children : r, Ld(e, Array.isArray(ne) ? ne : [
        ne
      ], i, d, a, t, o, m, p, s), u.base = i.__e, i.__h = null, u.__h.length && m.push(u), D && (u.__E = u.__ = null), u.__e = !1;
    } else o == null && i.__v === d.__v ? (i.__k = d.__k, i.__e = d.__e) : i.__e = pl(d.__e, i, d, a, t, o, m, s);
    (r = ge.diffed) && r(i);
  } catch (Q) {
    i.__v = null, (s || o != null) && (i.__e = p, i.__h = !!s, o[o.indexOf(p)] = null), ge.__e(Q, i, d);
  }
}
function Ad(e, i) {
  ge.__c && ge.__c(i, e), e.some(function(d) {
    try {
      e = d.__h, d.__h = [], e.some(function(a) {
        a.call(d);
      });
    } catch (a) {
      ge.__e(a, d.__v);
    }
  });
}
function pl(e, i, d, a, t, o, m, p) {
  var s, r, u, l = d.props, n = i.props, f = i.type, v = 0;
  if (f === "svg" && (t = !0), o != null) {
    for (; v < o.length; v++) if ((s = o[v]) && "setAttribute" in s == !!f && (f ? s.localName === f : s.nodeType === 3)) {
      e = s, o[v] = null;
      break;
    }
  }
  if (e == null) {
    if (f === null) return document.createTextNode(n);
    e = t ? document.createElementNS("http://www.w3.org/2000/svg", f) : document.createElement(f, n.is && n), o = null, p = !1;
  }
  if (f === null) l === n || p && e.data === n || (e.data = n);
  else {
    if (o = o && ra.call(e.childNodes), r = (l = d.props || Ji).dangerouslySetInnerHTML, u = n.dangerouslySetInnerHTML, !p) {
      if (o != null) for (l = {}, v = 0; v < e.attributes.length; v++) l[e.attributes[v].name] = e.attributes[v].value;
      (u || r) && (u && (r && u.__html == r.__html || u.__html === e.innerHTML) || (e.innerHTML = u && u.__html || ""));
    }
    if (gl(e, n, l, t, p), u) i.__k = [];
    else if (v = i.props.children, Ld(e, Array.isArray(v) ? v : [
      v
    ], i, d, a, t && f !== "foreignObject", o, m, o ? o[0] : d.__k && An(d, 0), p), o != null) for (v = o.length; v--; ) o[v] != null && Ed(o[v]);
    p || ("value" in n && (v = n.value) !== void 0 && (v !== l.value || v !== e.value || f === "progress" && !v) && na(e, "value", v, l.value, !1), "checked" in n && (v = n.checked) !== void 0 && v !== e.checked && na(e, "checked", v, l.checked, !1));
  }
  return e;
}
function Vd(e, i, d) {
  try {
    typeof e == "function" ? e(i) : e.current = i;
  } catch (a) {
    ge.__e(a, d);
  }
}
function Hd(e, i, d) {
  var a, t;
  if (ge.unmount && ge.unmount(e), (a = e.ref) && (a.current && a.current !== e.__e || Vd(a, null, i)), (a = e.__c) != null) {
    if (a.componentWillUnmount) try {
      a.componentWillUnmount();
    } catch (o) {
      ge.__e(o, i);
    }
    a.base = a.__P = null;
  }
  if (a = e.__k) for (t = 0; t < a.length; t++) a[t] && Hd(a[t], i, typeof e.type != "function");
  d || e.__e == null || Ed(e.__e), e.__e = e.__d = void 0;
}
function bl(e, i, d) {
  return this.constructor(e, d);
}
function Ud(e, i, d) {
  var a, t, o;
  ge.__ && ge.__(e, i), t = (a = typeof d == "function") ? null : d && d.__k || i.__k, o = [], Bt(i, e = (!a && d || i).__k = Tt(Zn, null, [
    e
  ]), t || Ji, Ji, i.ownerSVGElement !== void 0, !a && d ? [
    d
  ] : t ? null : i.firstChild ? ra.call(i.childNodes) : null, o, !a && d ? d : t ? t.__e : i.firstChild, a), Ad(o, e);
}
ra = Fd.slice, ge = {
  __e: function(e, i) {
    for (var d, a, t; i = i.__; ) if ((d = i.__c) && !d.__) try {
      if ((a = d.constructor) && a.getDerivedStateFromError != null && (d.setState(a.getDerivedStateFromError(e)), t = d.__d), d.componentDidCatch != null && (d.componentDidCatch(e), t = d.__d), t) return d.__E = d;
    } catch (o) {
      e = o;
    }
    throw e;
  }
}, Nd = 0, gn.prototype.setState = function(e, i) {
  var d;
  d = this.__s != null && this.__s !== this.state ? this.__s : this.__s = jn({}, this.state), typeof e == "function" && (e = e(jn({}, d), this.props)), e && jn(d, e), e != null && this.__v && (i && this.__h.push(i), mr(this));
}, gn.prototype.forceUpdate = function(e) {
  this.__v && (this.__e = !0, e && this.__h.push(e), mr(this));
}, gn.prototype.render = Zn, ei = [], xd = typeof Promise == "function" ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, Qi.__r = 0;
var yl = 0;
function K(e, i, d, a, t) {
  var o, m, p = {};
  for (m in i) m == "ref" ? o = i[m] : p[m] = i[m];
  var s = {
    type: e,
    props: p,
    key: d,
    ref: o,
    __k: null,
    __: null,
    __b: 0,
    __e: null,
    __d: void 0,
    __c: null,
    __h: null,
    constructor: void 0,
    __v: --yl,
    __source: a,
    __self: t
  };
  if (typeof e == "function" && (o = e.defaultProps)) for (m in o) p[m] === void 0 && (p[m] = o[m]);
  return ge.vnode && ge.vnode(s), s;
}
function kl(e, i) {
  try {
    window.localStorage[`emoji-mart.${e}`] = JSON.stringify(i);
  } catch {
  }
}
function wl(e) {
  try {
    const i = window.localStorage[`emoji-mart.${e}`];
    if (i) return JSON.parse(i);
  } catch {
  }
}
var Sn = {
  set: kl,
  get: wl
};
const fa = /* @__PURE__ */ new Map(), _l = [
  {
    v: 15,
    emoji: "🫨"
  },
  {
    v: 14,
    emoji: "🫠"
  },
  {
    v: 13.1,
    emoji: "😶‍🌫️"
  },
  {
    v: 13,
    emoji: "🥸"
  },
  {
    v: 12.1,
    emoji: "🧑‍🦰"
  },
  {
    v: 12,
    emoji: "🥱"
  },
  {
    v: 11,
    emoji: "🥰"
  },
  {
    v: 5,
    emoji: "🤩"
  },
  {
    v: 4,
    emoji: "👱‍♀️"
  },
  {
    v: 3,
    emoji: "🤣"
  },
  {
    v: 2,
    emoji: "👋🏻"
  },
  {
    v: 1,
    emoji: "🙃"
  }
];
function $l() {
  for (const { v: e, emoji: i } of _l)
    if (Bd(i)) return e;
}
function Pl() {
  return !Bd("🇨🇦");
}
function Bd(e) {
  if (fa.has(e)) return fa.get(e);
  const i = Ml(e);
  return fa.set(e, i), i;
}
const Ml = (() => {
  let e = null;
  try {
    navigator.userAgent.includes("jsdom") || (e = document.createElement("canvas").getContext("2d", {
      willReadFrequently: !0
    }));
  } catch {
  }
  if (!e) return () => !1;
  const i = 25, d = 20, a = Math.floor(i / 2);
  return e.font = a + "px Arial, Sans-Serif", e.textBaseline = "top", e.canvas.width = d * 2, e.canvas.height = i, (t) => {
    e.clearRect(0, 0, d * 2, i), e.fillStyle = "#FF0000", e.fillText(t, 0, 22), e.fillStyle = "#0000FF", e.fillText(t, d, 22);
    const o = e.getImageData(0, 0, d, i).data, m = o.length;
    let p = 0;
    for (; p < m && !o[p + 3]; p += 4) ;
    if (p >= m) return !1;
    const s = d + p / 4 % d, r = Math.floor(p / 4 / d), u = e.getImageData(s, r, 1, 1).data;
    return !(o[p] !== u[0] || o[p + 2] !== u[2] || e.measureText(t).width >= d);
  };
})();
var pr = {
  latestVersion: $l,
  noCountryFlags: Pl
};
const Nt = [
  "+1",
  "grinning",
  "kissing_heart",
  "heart_eyes",
  "laughing",
  "stuck_out_tongue_winking_eye",
  "sweat_smile",
  "joy",
  "scream",
  "disappointed",
  "unamused",
  "weary",
  "sob",
  "sunglasses",
  "heart"
];
let Ve = null;
function jl(e) {
  Ve || (Ve = Sn.get("frequently") || {});
  const i = e.id || e;
  i && (Ve[i] || (Ve[i] = 0), Ve[i] += 1, Sn.set("last", i), Sn.set("frequently", Ve));
}
function Sl({ maxFrequentRows: e, perLine: i }) {
  if (!e) return [];
  Ve || (Ve = Sn.get("frequently"));
  let d = [];
  if (!Ve) {
    Ve = {};
    for (let o in Nt.slice(0, i)) {
      const m = Nt[o];
      Ve[m] = i - o, d.push(m);
    }
    return d;
  }
  const a = e * i, t = Sn.get("last");
  for (let o in Ve) d.push(o);
  if (d.sort((o, m) => {
    const p = Ve[m], s = Ve[o];
    return p == s ? o.localeCompare(m) : p - s;
  }), d.length > a) {
    const o = d.slice(a);
    d = d.slice(0, a);
    for (let m of o)
      m != t && delete Ve[m];
    t && d.indexOf(t) == -1 && (delete Ve[d[d.length - 1]], d.splice(-1, 1, t)), Sn.set("frequently", Ve);
  }
  return d;
}
var Xd = {
  add: jl,
  get: Sl,
  DEFAULTS: Nt
}, Gd = {};
Gd = JSON.parse('{"search":"Search","search_no_results_1":"Oh no!","search_no_results_2":"That emoji couldn’t be found","pick":"Pick an emoji…","add_custom":"Add custom emoji","categories":{"activity":"Activity","custom":"Custom","flags":"Flags","foods":"Food & Drink","frequent":"Frequently used","nature":"Animals & Nature","objects":"Objects","people":"Smileys & People","places":"Travel & Places","search":"Search Results","symbols":"Symbols"},"skins":{"1":"Default","2":"Light","3":"Medium-Light","4":"Medium","5":"Medium-Dark","6":"Dark","choose":"Choose default skin tone"}}');
var $n = {
  autoFocus: {
    value: !1
  },
  dynamicWidth: {
    value: !1
  },
  emojiButtonColors: {
    value: null
  },
  emojiButtonRadius: {
    value: "100%"
  },
  emojiButtonSize: {
    value: 36
  },
  emojiSize: {
    value: 24
  },
  emojiVersion: {
    value: 15,
    choices: [
      1,
      2,
      3,
      4,
      5,
      11,
      12,
      12.1,
      13,
      13.1,
      14,
      15
    ]
  },
  exceptEmojis: {
    value: []
  },
  icons: {
    value: "auto",
    choices: [
      "auto",
      "outline",
      "solid"
    ]
  },
  locale: {
    value: "en",
    choices: [
      "en",
      "ar",
      "be",
      "cs",
      "de",
      "es",
      "fa",
      "fi",
      "fr",
      "hi",
      "it",
      "ja",
      "ko",
      "nl",
      "pl",
      "pt",
      "ru",
      "sa",
      "tr",
      "uk",
      "vi",
      "zh"
    ]
  },
  maxFrequentRows: {
    value: 4
  },
  navPosition: {
    value: "top",
    choices: [
      "top",
      "bottom",
      "none"
    ]
  },
  noCountryFlags: {
    value: !1
  },
  noResultsEmoji: {
    value: null
  },
  perLine: {
    value: 9
  },
  previewEmoji: {
    value: null
  },
  previewPosition: {
    value: "bottom",
    choices: [
      "top",
      "bottom",
      "none"
    ]
  },
  searchPosition: {
    value: "sticky",
    choices: [
      "sticky",
      "static",
      "none"
    ]
  },
  set: {
    value: "native",
    choices: [
      "native",
      "apple",
      "facebook",
      "google",
      "twitter"
    ]
  },
  skin: {
    value: 1,
    choices: [
      1,
      2,
      3,
      4,
      5,
      6
    ]
  },
  skinTonePosition: {
    value: "preview",
    choices: [
      "preview",
      "search",
      "none"
    ]
  },
  theme: {
    value: "auto",
    choices: [
      "auto",
      "light",
      "dark"
    ]
  },
  // Data
  categories: null,
  categoryIcons: null,
  custom: null,
  data: null,
  i18n: null,
  // Callbacks
  getImageURL: null,
  getSpritesheetURL: null,
  onAddCustomEmoji: null,
  onClickOutside: null,
  onEmojiSelect: null,
  // Deprecated
  stickySearch: {
    deprecated: !0,
    value: !0
  }
};
let Ue = null, Me = null;
const la = {};
async function br(e) {
  if (la[e]) return la[e];
  const d = await (await fetch(e)).json();
  return la[e] = d, d;
}
let ca = null, Kd = null, Yd = !1;
function oa(e, { caller: i } = {}) {
  return ca || (ca = new Promise((d) => {
    Kd = d;
  })), e ? zl(e) : i && !Yd && console.warn(`\`${i}\` requires data to be initialized first. Promise will be pending until \`init\` is called.`), ca;
}
async function zl(e) {
  Yd = !0;
  let { emojiVersion: i, set: d, locale: a } = e;
  if (i || (i = $n.emojiVersion.value), d || (d = $n.set.value), a || (a = $n.locale.value), Me)
    Me.categories = Me.categories.filter((s) => !s.name);
  else {
    Me = (typeof e.data == "function" ? await e.data() : e.data) || await br(`https://cdn.jsdelivr.net/npm/@emoji-mart/data@latest/sets/${i}/${d}.json`), Me.emoticons = {}, Me.natives = {}, Me.categories.unshift({
      id: "frequent",
      emojis: []
    });
    for (const s in Me.aliases) {
      const r = Me.aliases[s], u = Me.emojis[r];
      u && (u.aliases || (u.aliases = []), u.aliases.push(s));
    }
    Me.originalCategories = Me.categories;
  }
  if (Ue = (typeof e.i18n == "function" ? await e.i18n() : e.i18n) || (a == "en" ? /* @__PURE__ */ Td(Gd) : await br(`https://cdn.jsdelivr.net/npm/@emoji-mart/data@latest/i18n/${a}.json`)), e.custom) for (let s in e.custom) {
    s = parseInt(s);
    const r = e.custom[s], u = e.custom[s - 1];
    if (!(!r.emojis || !r.emojis.length)) {
      r.id || (r.id = `custom_${s + 1}`), r.name || (r.name = Ue.categories.custom), u && !r.icon && (r.target = u.target || u), Me.categories.push(r);
      for (const l of r.emojis) Me.emojis[l.id] = l;
    }
  }
  e.categories && (Me.categories = Me.originalCategories.filter((s) => e.categories.indexOf(s.id) != -1).sort((s, r) => {
    const u = e.categories.indexOf(s.id), l = e.categories.indexOf(r.id);
    return u - l;
  }));
  let t = null, o = null;
  d == "native" && (t = pr.latestVersion(), o = e.noCountryFlags || pr.noCountryFlags());
  let m = Me.categories.length, p = !1;
  for (; m--; ) {
    const s = Me.categories[m];
    if (s.id == "frequent") {
      let { maxFrequentRows: l, perLine: n } = e;
      l = l >= 0 ? l : $n.maxFrequentRows.value, n || (n = $n.perLine.value), s.emojis = Xd.get({
        maxFrequentRows: l,
        perLine: n
      });
    }
    if (!s.emojis || !s.emojis.length) {
      Me.categories.splice(m, 1);
      continue;
    }
    const { categoryIcons: r } = e;
    if (r) {
      const l = r[s.id];
      l && !s.icon && (s.icon = l);
    }
    let u = s.emojis.length;
    for (; u--; ) {
      const l = s.emojis[u], n = l.id ? l : Me.emojis[l], f = () => {
        s.emojis.splice(u, 1);
      };
      if (!n || e.exceptEmojis && e.exceptEmojis.includes(n.id)) {
        f();
        continue;
      }
      if (t && n.version > t) {
        f();
        continue;
      }
      if (o && s.id == "flags" && !Il.includes(n.id)) {
        f();
        continue;
      }
      if (!n.search) {
        if (p = !0, n.search = "," + [
          [
            n.id,
            !1
          ],
          [
            n.name,
            !0
          ],
          [
            n.keywords,
            !1
          ],
          [
            n.emoticons,
            !1
          ]
        ].map(([D, F]) => {
          if (D)
            return (Array.isArray(D) ? D : [
              D
            ]).map((A) => (F ? A.split(/[-|_|\s]+/) : [
              A
            ]).map((ae) => ae.toLowerCase())).flat();
        }).flat().filter((D) => D && D.trim()).join(","), n.emoticons) for (const D of n.emoticons)
          Me.emoticons[D] || (Me.emoticons[D] = n.id);
        let v = 0;
        for (const D of n.skins) {
          if (!D) continue;
          v++;
          const { native: F } = D;
          F && (Me.natives[F] = n.id, n.search += `,${F}`);
          const A = v == 1 ? "" : `:skin-tone-${v}:`;
          D.shortcodes = `:${n.id}:${A}`;
        }
      }
    }
  }
  p && qn.reset(), Kd();
}
function Jd(e, i, d) {
  e || (e = {});
  const a = {};
  for (let t in i) a[t] = Qd(t, e, i, d);
  return a;
}
function Qd(e, i, d, a) {
  const t = d[e];
  let o = a && a.getAttribute(e) || (i[e] != null && i[e] != null ? i[e] : null);
  return t && (o != null && t.value && typeof t.value != typeof o && (typeof t.value == "boolean" ? o = o != "false" : o = t.value.constructor(o)), t.transform && o && (o = t.transform(o)), (o == null || t.choices && t.choices.indexOf(o) == -1) && (o = t.value)), o;
}
const Ol = /^(?:\:([^\:]+)\:)(?:\:skin-tone-(\d)\:)?$/;
let xt = null;
function Wl(e) {
  return e.id ? e : Me.emojis[e] || Me.emojis[Me.aliases[e]] || Me.emojis[Me.natives[e]];
}
function Dl() {
  xt = null;
}
async function Cl(e, { maxResults: i, caller: d } = {}) {
  if (!e || !e.trim().length) return null;
  i || (i = 90), await oa(null, {
    caller: d || "SearchIndex.search"
  });
  const a = e.toLowerCase().replace(/(\w)-/, "$1 ").split(/[\s|,]+/).filter((p, s, r) => p.trim() && r.indexOf(p) == s);
  if (!a.length) return;
  let t = xt || (xt = Object.values(Me.emojis)), o, m;
  for (const p of a) {
    if (!t.length) break;
    o = [], m = {};
    for (const s of t) {
      if (!s.search) continue;
      const r = s.search.indexOf(`,${p}`);
      r != -1 && (o.push(s), m[s.id] || (m[s.id] = 0), m[s.id] += s.id == p ? 0 : r + 1);
    }
    t = o;
  }
  return o.length < 2 || (o.sort((p, s) => {
    const r = m[p.id], u = m[s.id];
    return r == u ? p.id.localeCompare(s.id) : r - u;
  }), o.length > i && (o = o.slice(0, i))), o;
}
var qn = {
  search: Cl,
  get: Wl,
  reset: Dl,
  SHORTCODES_REGEX: Ol
};
const Il = [
  "checkered_flag",
  "crossed_flags",
  "pirate_flag",
  "rainbow-flag",
  "transgender_flag",
  "triangular_flag_on_post",
  "waving_black_flag",
  "waving_white_flag"
];
function Tl(e, i) {
  return Array.isArray(e) && Array.isArray(i) && e.length === i.length && e.every((d, a) => d == i[a]);
}
async function Nl(e = 1) {
  for (let i in [
    ...Array(e).keys()
  ]) await new Promise(requestAnimationFrame);
}
function xl(e, { skinIndex: i = 0 } = {}) {
  const d = e.skins[i] || (i = 0, e.skins[i]), a = {
    id: e.id,
    name: e.name,
    native: d.native,
    unified: d.unified,
    keywords: e.keywords,
    shortcodes: d.shortcodes || e.shortcodes
  };
  return e.skins.length > 1 && (a.skin = i + 1), d.src && (a.src = d.src), e.aliases && e.aliases.length && (a.aliases = e.aliases), e.emoticons && e.emoticons.length && (a.emoticons = e.emoticons), a;
}
const Fl = {
  activity: {
    outline: /* @__PURE__ */ K("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      children: /* @__PURE__ */ K("path", {
        d: "M12 0C5.373 0 0 5.372 0 12c0 6.627 5.373 12 12 12 6.628 0 12-5.373 12-12 0-6.628-5.372-12-12-12m9.949 11H17.05c.224-2.527 1.232-4.773 1.968-6.113A9.966 9.966 0 0 1 21.949 11M13 11V2.051a9.945 9.945 0 0 1 4.432 1.564c-.858 1.491-2.156 4.22-2.392 7.385H13zm-2 0H8.961c-.238-3.165-1.536-5.894-2.393-7.385A9.95 9.95 0 0 1 11 2.051V11zm0 2v8.949a9.937 9.937 0 0 1-4.432-1.564c.857-1.492 2.155-4.221 2.393-7.385H11zm4.04 0c.236 3.164 1.534 5.893 2.392 7.385A9.92 9.92 0 0 1 13 21.949V13h2.04zM4.982 4.887C5.718 6.227 6.726 8.473 6.951 11h-4.9a9.977 9.977 0 0 1 2.931-6.113M2.051 13h4.9c-.226 2.527-1.233 4.771-1.969 6.113A9.972 9.972 0 0 1 2.051 13m16.967 6.113c-.735-1.342-1.744-3.586-1.968-6.113h4.899a9.961 9.961 0 0 1-2.931 6.113"
      })
    }),
    solid: /* @__PURE__ */ K("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      children: /* @__PURE__ */ K("path", {
        d: "M16.17 337.5c0 44.98 7.565 83.54 13.98 107.9C35.22 464.3 50.46 496 174.9 496c9.566 0 19.59-.4707 29.84-1.271L17.33 307.3C16.53 317.6 16.17 327.7 16.17 337.5zM495.8 174.5c0-44.98-7.565-83.53-13.98-107.9c-4.688-17.54-18.34-31.23-36.04-35.95C435.5 27.91 392.9 16 337 16c-9.564 0-19.59 .4707-29.84 1.271l187.5 187.5C495.5 194.4 495.8 184.3 495.8 174.5zM26.77 248.8l236.3 236.3c142-36.1 203.9-150.4 222.2-221.1L248.9 26.87C106.9 62.96 45.07 177.2 26.77 248.8zM256 335.1c0 9.141-7.474 16-16 16c-4.094 0-8.188-1.564-11.31-4.689L164.7 283.3C161.6 280.2 160 276.1 160 271.1c0-8.529 6.865-16 16-16c4.095 0 8.189 1.562 11.31 4.688l64.01 64C254.4 327.8 256 331.9 256 335.1zM304 287.1c0 9.141-7.474 16-16 16c-4.094 0-8.188-1.564-11.31-4.689L212.7 235.3C209.6 232.2 208 228.1 208 223.1c0-9.141 7.473-16 16-16c4.094 0 8.188 1.562 11.31 4.688l64.01 64.01C302.5 279.8 304 283.9 304 287.1zM256 175.1c0-9.141 7.473-16 16-16c4.094 0 8.188 1.562 11.31 4.688l64.01 64.01c3.125 3.125 4.688 7.219 4.688 11.31c0 9.133-7.468 16-16 16c-4.094 0-8.189-1.562-11.31-4.688l-64.01-64.01C257.6 184.2 256 180.1 256 175.1z"
      })
    })
  },
  custom: /* @__PURE__ */ K("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    children: /* @__PURE__ */ K("path", {
      d: "M417.1 368c-5.937 10.27-16.69 16-27.75 16c-5.422 0-10.92-1.375-15.97-4.281L256 311.4V448c0 17.67-14.33 32-31.1 32S192 465.7 192 448V311.4l-118.3 68.29C68.67 382.6 63.17 384 57.75 384c-11.06 0-21.81-5.734-27.75-16c-8.828-15.31-3.594-34.88 11.72-43.72L159.1 256L41.72 187.7C26.41 178.9 21.17 159.3 29.1 144C36.63 132.5 49.26 126.7 61.65 128.2C65.78 128.7 69.88 130.1 73.72 132.3L192 200.6V64c0-17.67 14.33-32 32-32S256 46.33 256 64v136.6l118.3-68.29c3.838-2.213 7.939-3.539 12.07-4.051C398.7 126.7 411.4 132.5 417.1 144c8.828 15.31 3.594 34.88-11.72 43.72L288 256l118.3 68.28C421.6 333.1 426.8 352.7 417.1 368z"
    })
  }),
  flags: {
    outline: /* @__PURE__ */ K("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      children: /* @__PURE__ */ K("path", {
        d: "M0 0l6.084 24H8L1.916 0zM21 5h-4l-1-4H4l3 12h3l1 4h13L21 5zM6.563 3h7.875l2 8H8.563l-2-8zm8.832 10l-2.856 1.904L12.063 13h3.332zM19 13l-1.5-6h1.938l2 8H16l3-2z"
      })
    }),
    solid: /* @__PURE__ */ K("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      children: /* @__PURE__ */ K("path", {
        d: "M64 496C64 504.8 56.75 512 48 512h-32C7.25 512 0 504.8 0 496V32c0-17.75 14.25-32 32-32s32 14.25 32 32V496zM476.3 0c-6.365 0-13.01 1.35-19.34 4.233c-45.69 20.86-79.56 27.94-107.8 27.94c-59.96 0-94.81-31.86-163.9-31.87C160.9 .3055 131.6 4.867 96 15.75v350.5c32-9.984 59.87-14.1 84.85-14.1c73.63 0 124.9 31.78 198.6 31.78c31.91 0 68.02-5.971 111.1-23.09C504.1 355.9 512 344.4 512 332.1V30.73C512 11.1 495.3 0 476.3 0z"
      })
    })
  },
  foods: {
    outline: /* @__PURE__ */ K("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      children: /* @__PURE__ */ K("path", {
        d: "M17 4.978c-1.838 0-2.876.396-3.68.934.513-1.172 1.768-2.934 4.68-2.934a1 1 0 0 0 0-2c-2.921 0-4.629 1.365-5.547 2.512-.064.078-.119.162-.18.244C11.73 1.838 10.798.023 9.207.023 8.579.022 7.85.306 7 .978 5.027 2.54 5.329 3.902 6.492 4.999 3.609 5.222 0 7.352 0 12.969c0 4.582 4.961 11.009 9 11.009 1.975 0 2.371-.486 3-1 .629.514 1.025 1 3 1 4.039 0 9-6.418 9-11 0-5.953-4.055-8-7-8M8.242 2.546c.641-.508.943-.523.965-.523.426.169.975 1.405 1.357 3.055-1.527-.629-2.741-1.352-2.98-1.846.059-.112.241-.356.658-.686M15 21.978c-1.08 0-1.21-.109-1.559-.402l-.176-.146c-.367-.302-.816-.452-1.266-.452s-.898.15-1.266.452l-.176.146c-.347.292-.477.402-1.557.402-2.813 0-7-5.389-7-9.009 0-5.823 4.488-5.991 5-5.991 1.939 0 2.484.471 3.387 1.251l.323.276a1.995 1.995 0 0 0 2.58 0l.323-.276c.902-.78 1.447-1.251 3.387-1.251.512 0 5 .168 5 6 0 3.617-4.187 9-7 9"
      })
    }),
    solid: /* @__PURE__ */ K("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      children: /* @__PURE__ */ K("path", {
        d: "M481.9 270.1C490.9 279.1 496 291.3 496 304C496 316.7 490.9 328.9 481.9 337.9C472.9 346.9 460.7 352 448 352H64C51.27 352 39.06 346.9 30.06 337.9C21.06 328.9 16 316.7 16 304C16 291.3 21.06 279.1 30.06 270.1C39.06 261.1 51.27 256 64 256H448C460.7 256 472.9 261.1 481.9 270.1zM475.3 388.7C478.3 391.7 480 395.8 480 400V416C480 432.1 473.3 449.3 461.3 461.3C449.3 473.3 432.1 480 416 480H96C79.03 480 62.75 473.3 50.75 461.3C38.74 449.3 32 432.1 32 416V400C32 395.8 33.69 391.7 36.69 388.7C39.69 385.7 43.76 384 48 384H464C468.2 384 472.3 385.7 475.3 388.7zM50.39 220.8C45.93 218.6 42.03 215.5 38.97 211.6C35.91 207.7 33.79 203.2 32.75 198.4C31.71 193.5 31.8 188.5 32.99 183.7C54.98 97.02 146.5 32 256 32C365.5 32 457 97.02 479 183.7C480.2 188.5 480.3 193.5 479.2 198.4C478.2 203.2 476.1 207.7 473 211.6C469.1 215.5 466.1 218.6 461.6 220.8C457.2 222.9 452.3 224 447.3 224H64.67C59.73 224 54.84 222.9 50.39 220.8zM372.7 116.7C369.7 119.7 368 123.8 368 128C368 131.2 368.9 134.3 370.7 136.9C372.5 139.5 374.1 141.6 377.9 142.8C380.8 143.1 384 144.3 387.1 143.7C390.2 143.1 393.1 141.6 395.3 139.3C397.6 137.1 399.1 134.2 399.7 131.1C400.3 128 399.1 124.8 398.8 121.9C397.6 118.1 395.5 116.5 392.9 114.7C390.3 112.9 387.2 111.1 384 111.1C379.8 111.1 375.7 113.7 372.7 116.7V116.7zM244.7 84.69C241.7 87.69 240 91.76 240 96C240 99.16 240.9 102.3 242.7 104.9C244.5 107.5 246.1 109.6 249.9 110.8C252.8 111.1 256 112.3 259.1 111.7C262.2 111.1 265.1 109.6 267.3 107.3C269.6 105.1 271.1 102.2 271.7 99.12C272.3 96.02 271.1 92.8 270.8 89.88C269.6 86.95 267.5 84.45 264.9 82.7C262.3 80.94 259.2 79.1 256 79.1C251.8 79.1 247.7 81.69 244.7 84.69V84.69zM116.7 116.7C113.7 119.7 112 123.8 112 128C112 131.2 112.9 134.3 114.7 136.9C116.5 139.5 118.1 141.6 121.9 142.8C124.8 143.1 128 144.3 131.1 143.7C134.2 143.1 137.1 141.6 139.3 139.3C141.6 137.1 143.1 134.2 143.7 131.1C144.3 128 143.1 124.8 142.8 121.9C141.6 118.1 139.5 116.5 136.9 114.7C134.3 112.9 131.2 111.1 128 111.1C123.8 111.1 119.7 113.7 116.7 116.7L116.7 116.7z"
      })
    })
  },
  frequent: {
    outline: /* @__PURE__ */ K("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      children: [
        /* @__PURE__ */ K("path", {
          d: "M13 4h-2l-.001 7H9v2h2v2h2v-2h4v-2h-4z"
        }),
        /* @__PURE__ */ K("path", {
          d: "M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0m0 22C6.486 22 2 17.514 2 12S6.486 2 12 2s10 4.486 10 10-4.486 10-10 10"
        })
      ]
    }),
    solid: /* @__PURE__ */ K("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      children: /* @__PURE__ */ K("path", {
        d: "M256 512C114.6 512 0 397.4 0 256C0 114.6 114.6 0 256 0C397.4 0 512 114.6 512 256C512 397.4 397.4 512 256 512zM232 256C232 264 236 271.5 242.7 275.1L338.7 339.1C349.7 347.3 364.6 344.3 371.1 333.3C379.3 322.3 376.3 307.4 365.3 300L280 243.2V120C280 106.7 269.3 96 255.1 96C242.7 96 231.1 106.7 231.1 120L232 256z"
      })
    })
  },
  nature: {
    outline: /* @__PURE__ */ K("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      children: [
        /* @__PURE__ */ K("path", {
          d: "M15.5 8a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 15.5 8M8.5 8a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 8.5 8"
        }),
        /* @__PURE__ */ K("path", {
          d: "M18.933 0h-.027c-.97 0-2.138.787-3.018 1.497-1.274-.374-2.612-.51-3.887-.51-1.285 0-2.616.133-3.874.517C7.245.79 6.069 0 5.093 0h-.027C3.352 0 .07 2.67.002 7.026c-.039 2.479.276 4.238 1.04 5.013.254.258.882.677 1.295.882.191 3.177.922 5.238 2.536 6.38.897.637 2.187.949 3.2 1.102C8.04 20.6 8 20.795 8 21c0 1.773 2.35 3 4 3 1.648 0 4-1.227 4-3 0-.201-.038-.393-.072-.586 2.573-.385 5.435-1.877 5.925-7.587.396-.22.887-.568 1.104-.788.763-.774 1.079-2.534 1.04-5.013C23.929 2.67 20.646 0 18.933 0M3.223 9.135c-.237.281-.837 1.155-.884 1.238-.15-.41-.368-1.349-.337-3.291.051-3.281 2.478-4.972 3.091-5.031.256.015.731.27 1.265.646-1.11 1.171-2.275 2.915-2.352 5.125-.133.546-.398.858-.783 1.313M12 22c-.901 0-1.954-.693-2-1 0-.654.475-1.236 1-1.602V20a1 1 0 1 0 2 0v-.602c.524.365 1 .947 1 1.602-.046.307-1.099 1-2 1m3-3.48v.02a4.752 4.752 0 0 0-1.262-1.02c1.092-.516 2.239-1.334 2.239-2.217 0-1.842-1.781-2.195-3.977-2.195-2.196 0-3.978.354-3.978 2.195 0 .883 1.148 1.701 2.238 2.217A4.8 4.8 0 0 0 9 18.539v-.025c-1-.076-2.182-.281-2.973-.842-1.301-.92-1.838-3.045-1.853-6.478l.023-.041c.496-.826 1.49-1.45 1.804-3.102 0-2.047 1.357-3.631 2.362-4.522C9.37 3.178 10.555 3 11.948 3c1.447 0 2.685.192 3.733.57 1 .9 2.316 2.465 2.316 4.48.313 1.651 1.307 2.275 1.803 3.102.035.058.068.117.102.178-.059 5.967-1.949 7.01-4.902 7.19m6.628-8.202c-.037-.065-.074-.13-.113-.195a7.587 7.587 0 0 0-.739-.987c-.385-.455-.648-.768-.782-1.313-.076-2.209-1.241-3.954-2.353-5.124.531-.376 1.004-.63 1.261-.647.636.071 3.044 1.764 3.096 5.031.027 1.81-.347 3.218-.37 3.235"
        })
      ]
    }),
    solid: /* @__PURE__ */ K("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 576 512",
      children: /* @__PURE__ */ K("path", {
        d: "M332.7 19.85C334.6 8.395 344.5 0 356.1 0C363.6 0 370.6 3.52 375.1 9.502L392 32H444.1C456.8 32 469.1 37.06 478.1 46.06L496 64H552C565.3 64 576 74.75 576 88V112C576 156.2 540.2 192 496 192H426.7L421.6 222.5L309.6 158.5L332.7 19.85zM448 64C439.2 64 432 71.16 432 80C432 88.84 439.2 96 448 96C456.8 96 464 88.84 464 80C464 71.16 456.8 64 448 64zM416 256.1V480C416 497.7 401.7 512 384 512H352C334.3 512 320 497.7 320 480V364.8C295.1 377.1 268.8 384 240 384C211.2 384 184 377.1 160 364.8V480C160 497.7 145.7 512 128 512H96C78.33 512 64 497.7 64 480V249.8C35.23 238.9 12.64 214.5 4.836 183.3L.9558 167.8C-3.331 150.6 7.094 133.2 24.24 128.1C41.38 124.7 58.76 135.1 63.05 152.2L66.93 167.8C70.49 182 83.29 191.1 97.97 191.1H303.8L416 256.1z"
      })
    })
  },
  objects: {
    outline: /* @__PURE__ */ K("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      children: [
        /* @__PURE__ */ K("path", {
          d: "M12 0a9 9 0 0 0-5 16.482V21s2.035 3 5 3 5-3 5-3v-4.518A9 9 0 0 0 12 0zm0 2c3.86 0 7 3.141 7 7s-3.14 7-7 7-7-3.141-7-7 3.14-7 7-7zM9 17.477c.94.332 1.946.523 3 .523s2.06-.19 3-.523v.834c-.91.436-1.925.689-3 .689a6.924 6.924 0 0 1-3-.69v-.833zm.236 3.07A8.854 8.854 0 0 0 12 21c.965 0 1.888-.167 2.758-.451C14.155 21.173 13.153 22 12 22c-1.102 0-2.117-.789-2.764-1.453z"
        }),
        /* @__PURE__ */ K("path", {
          d: "M14.745 12.449h-.004c-.852-.024-1.188-.858-1.577-1.824-.421-1.061-.703-1.561-1.182-1.566h-.009c-.481 0-.783.497-1.235 1.537-.436.982-.801 1.811-1.636 1.791l-.276-.043c-.565-.171-.853-.691-1.284-1.794-.125-.313-.202-.632-.27-.913-.051-.213-.127-.53-.195-.634C7.067 9.004 7.039 9 6.99 9A1 1 0 0 1 7 7h.01c1.662.017 2.015 1.373 2.198 2.134.486-.981 1.304-2.058 2.797-2.075 1.531.018 2.28 1.153 2.731 2.141l.002-.008C14.944 8.424 15.327 7 16.979 7h.032A1 1 0 1 1 17 9h-.011c-.149.076-.256.474-.319.709a6.484 6.484 0 0 1-.311.951c-.429.973-.79 1.789-1.614 1.789"
        })
      ]
    }),
    solid: /* @__PURE__ */ K("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 384 512",
      children: /* @__PURE__ */ K("path", {
        d: "M112.1 454.3c0 6.297 1.816 12.44 5.284 17.69l17.14 25.69c5.25 7.875 17.17 14.28 26.64 14.28h61.67c9.438 0 21.36-6.401 26.61-14.28l17.08-25.68c2.938-4.438 5.348-12.37 5.348-17.7L272 415.1h-160L112.1 454.3zM191.4 .0132C89.44 .3257 16 82.97 16 175.1c0 44.38 16.44 84.84 43.56 115.8c16.53 18.84 42.34 58.23 52.22 91.45c.0313 .25 .0938 .5166 .125 .7823h160.2c.0313-.2656 .0938-.5166 .125-.7823c9.875-33.22 35.69-72.61 52.22-91.45C351.6 260.8 368 220.4 368 175.1C368 78.61 288.9-.2837 191.4 .0132zM192 96.01c-44.13 0-80 35.89-80 79.1C112 184.8 104.8 192 96 192S80 184.8 80 176c0-61.76 50.25-111.1 112-111.1c8.844 0 16 7.159 16 16S200.8 96.01 192 96.01z"
      })
    })
  },
  people: {
    outline: /* @__PURE__ */ K("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      children: [
        /* @__PURE__ */ K("path", {
          d: "M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0m0 22C6.486 22 2 17.514 2 12S6.486 2 12 2s10 4.486 10 10-4.486 10-10 10"
        }),
        /* @__PURE__ */ K("path", {
          d: "M8 7a2 2 0 1 0-.001 3.999A2 2 0 0 0 8 7M16 7a2 2 0 1 0-.001 3.999A2 2 0 0 0 16 7M15.232 15c-.693 1.195-1.87 2-3.349 2-1.477 0-2.655-.805-3.347-2H15m3-2H6a6 6 0 1 0 12 0"
        })
      ]
    }),
    solid: /* @__PURE__ */ K("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      children: /* @__PURE__ */ K("path", {
        d: "M0 256C0 114.6 114.6 0 256 0C397.4 0 512 114.6 512 256C512 397.4 397.4 512 256 512C114.6 512 0 397.4 0 256zM256 432C332.1 432 396.2 382 415.2 314.1C419.1 300.4 407.8 288 393.6 288H118.4C104.2 288 92.92 300.4 96.76 314.1C115.8 382 179.9 432 256 432V432zM176.4 160C158.7 160 144.4 174.3 144.4 192C144.4 209.7 158.7 224 176.4 224C194 224 208.4 209.7 208.4 192C208.4 174.3 194 160 176.4 160zM336.4 224C354 224 368.4 209.7 368.4 192C368.4 174.3 354 160 336.4 160C318.7 160 304.4 174.3 304.4 192C304.4 209.7 318.7 224 336.4 224z"
      })
    })
  },
  places: {
    outline: /* @__PURE__ */ K("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      children: [
        /* @__PURE__ */ K("path", {
          d: "M6.5 12C5.122 12 4 13.121 4 14.5S5.122 17 6.5 17 9 15.879 9 14.5 7.878 12 6.5 12m0 3c-.275 0-.5-.225-.5-.5s.225-.5.5-.5.5.225.5.5-.225.5-.5.5M17.5 12c-1.378 0-2.5 1.121-2.5 2.5s1.122 2.5 2.5 2.5 2.5-1.121 2.5-2.5-1.122-2.5-2.5-2.5m0 3c-.275 0-.5-.225-.5-.5s.225-.5.5-.5.5.225.5.5-.225.5-.5.5"
        }),
        /* @__PURE__ */ K("path", {
          d: "M22.482 9.494l-1.039-.346L21.4 9h.6c.552 0 1-.439 1-.992 0-.006-.003-.008-.003-.008H23c0-1-.889-2-1.984-2h-.642l-.731-1.717C19.262 3.012 18.091 2 16.764 2H7.236C5.909 2 4.738 3.012 4.357 4.283L3.626 6h-.642C1.889 6 1 7 1 8h.003S1 8.002 1 8.008C1 8.561 1.448 9 2 9h.6l-.043.148-1.039.346a2.001 2.001 0 0 0-1.359 2.097l.751 7.508a1 1 0 0 0 .994.901H3v1c0 1.103.896 2 2 2h2c1.104 0 2-.897 2-2v-1h6v1c0 1.103.896 2 2 2h2c1.104 0 2-.897 2-2v-1h1.096a.999.999 0 0 0 .994-.901l.751-7.508a2.001 2.001 0 0 0-1.359-2.097M6.273 4.857C6.402 4.43 6.788 4 7.236 4h9.527c.448 0 .834.43.963.857L19.313 9H4.688l1.585-4.143zM7 21H5v-1h2v1zm12 0h-2v-1h2v1zm2.189-3H2.811l-.662-6.607L3 11h18l.852.393L21.189 18z"
        })
      ]
    }),
    solid: /* @__PURE__ */ K("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      children: /* @__PURE__ */ K("path", {
        d: "M39.61 196.8L74.8 96.29C88.27 57.78 124.6 32 165.4 32H346.6C387.4 32 423.7 57.78 437.2 96.29L472.4 196.8C495.6 206.4 512 229.3 512 256V448C512 465.7 497.7 480 480 480H448C430.3 480 416 465.7 416 448V400H96V448C96 465.7 81.67 480 64 480H32C14.33 480 0 465.7 0 448V256C0 229.3 16.36 206.4 39.61 196.8V196.8zM109.1 192H402.9L376.8 117.4C372.3 104.6 360.2 96 346.6 96H165.4C151.8 96 139.7 104.6 135.2 117.4L109.1 192zM96 256C78.33 256 64 270.3 64 288C64 305.7 78.33 320 96 320C113.7 320 128 305.7 128 288C128 270.3 113.7 256 96 256zM416 320C433.7 320 448 305.7 448 288C448 270.3 433.7 256 416 256C398.3 256 384 270.3 384 288C384 305.7 398.3 320 416 320z"
      })
    })
  },
  symbols: {
    outline: /* @__PURE__ */ K("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      children: /* @__PURE__ */ K("path", {
        d: "M0 0h11v2H0zM4 11h3V6h4V4H0v2h4zM15.5 17c1.381 0 2.5-1.116 2.5-2.493s-1.119-2.493-2.5-2.493S13 13.13 13 14.507 14.119 17 15.5 17m0-2.986c.276 0 .5.222.5.493 0 .272-.224.493-.5.493s-.5-.221-.5-.493.224-.493.5-.493M21.5 19.014c-1.381 0-2.5 1.116-2.5 2.493S20.119 24 21.5 24s2.5-1.116 2.5-2.493-1.119-2.493-2.5-2.493m0 2.986a.497.497 0 0 1-.5-.493c0-.271.224-.493.5-.493s.5.222.5.493a.497.497 0 0 1-.5.493M22 13l-9 9 1.513 1.5 8.99-9.009zM17 11c2.209 0 4-1.119 4-2.5V2s.985-.161 1.498.949C23.01 4.055 23 6 23 6s1-1.119 1-3.135C24-.02 21 0 21 0h-2v6.347A5.853 5.853 0 0 0 17 6c-2.209 0-4 1.119-4 2.5s1.791 2.5 4 2.5M10.297 20.482l-1.475-1.585a47.54 47.54 0 0 1-1.442 1.129c-.307-.288-.989-1.016-2.045-2.183.902-.836 1.479-1.466 1.729-1.892s.376-.871.376-1.336c0-.592-.273-1.178-.818-1.759-.546-.581-1.329-.871-2.349-.871-1.008 0-1.79.293-2.344.879-.556.587-.832 1.181-.832 1.784 0 .813.419 1.748 1.256 2.805-.847.614-1.444 1.208-1.794 1.784a3.465 3.465 0 0 0-.523 1.833c0 .857.308 1.56.924 2.107.616.549 1.423.823 2.42.823 1.173 0 2.444-.379 3.813-1.137L8.235 24h2.819l-2.09-2.383 1.333-1.135zm-6.736-6.389a1.02 1.02 0 0 1 .73-.286c.31 0 .559.085.747.254a.849.849 0 0 1 .283.659c0 .518-.419 1.112-1.257 1.784-.536-.651-.805-1.231-.805-1.742a.901.901 0 0 1 .302-.669M3.74 22c-.427 0-.778-.116-1.057-.349-.279-.232-.418-.487-.418-.766 0-.594.509-1.288 1.527-2.083.968 1.134 1.717 1.946 2.248 2.438-.921.507-1.686.76-2.3.76"
      })
    }),
    solid: /* @__PURE__ */ K("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      children: /* @__PURE__ */ K("path", {
        d: "M500.3 7.251C507.7 13.33 512 22.41 512 31.1V175.1C512 202.5 483.3 223.1 447.1 223.1C412.7 223.1 383.1 202.5 383.1 175.1C383.1 149.5 412.7 127.1 447.1 127.1V71.03L351.1 90.23V207.1C351.1 234.5 323.3 255.1 287.1 255.1C252.7 255.1 223.1 234.5 223.1 207.1C223.1 181.5 252.7 159.1 287.1 159.1V63.1C287.1 48.74 298.8 35.61 313.7 32.62L473.7 .6198C483.1-1.261 492.9 1.173 500.3 7.251H500.3zM74.66 303.1L86.5 286.2C92.43 277.3 102.4 271.1 113.1 271.1H174.9C185.6 271.1 195.6 277.3 201.5 286.2L213.3 303.1H239.1C266.5 303.1 287.1 325.5 287.1 351.1V463.1C287.1 490.5 266.5 511.1 239.1 511.1H47.1C21.49 511.1-.0019 490.5-.0019 463.1V351.1C-.0019 325.5 21.49 303.1 47.1 303.1H74.66zM143.1 359.1C117.5 359.1 95.1 381.5 95.1 407.1C95.1 434.5 117.5 455.1 143.1 455.1C170.5 455.1 191.1 434.5 191.1 407.1C191.1 381.5 170.5 359.1 143.1 359.1zM440.3 367.1H496C502.7 367.1 508.6 372.1 510.1 378.4C513.3 384.6 511.6 391.7 506.5 396L378.5 508C372.9 512.1 364.6 513.3 358.6 508.9C352.6 504.6 350.3 496.6 353.3 489.7L391.7 399.1H336C329.3 399.1 323.4 395.9 321 389.6C318.7 383.4 320.4 376.3 325.5 371.1L453.5 259.1C459.1 255 467.4 254.7 473.4 259.1C479.4 263.4 481.6 271.4 478.7 278.3L440.3 367.1zM116.7 219.1L19.85 119.2C-8.112 90.26-6.614 42.31 24.85 15.34C51.82-8.137 93.26-3.642 118.2 21.83L128.2 32.32L137.7 21.83C162.7-3.642 203.6-8.137 231.6 15.34C262.6 42.31 264.1 90.26 236.1 119.2L139.7 219.1C133.2 225.6 122.7 225.6 116.7 219.1H116.7z"
      })
    })
  }
}, El = {
  loupe: /* @__PURE__ */ K("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    children: /* @__PURE__ */ K("path", {
      d: "M12.9 14.32a8 8 0 1 1 1.41-1.41l5.35 5.33-1.42 1.42-5.33-5.34zM8 14A6 6 0 1 0 8 2a6 6 0 0 0 0 12z"
    })
  }),
  delete: /* @__PURE__ */ K("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    children: /* @__PURE__ */ K("path", {
      d: "M10 8.586L2.929 1.515 1.515 2.929 8.586 10l-7.071 7.071 1.414 1.414L10 11.414l7.071 7.071 1.414-1.414L11.414 10l7.071-7.071-1.414-1.414L10 8.586z"
    })
  })
};
var ia = {
  categories: Fl,
  search: El
};
function Ft(e) {
  let { id: i, skin: d, emoji: a } = e;
  if (e.shortcodes) {
    const p = e.shortcodes.match(qn.SHORTCODES_REGEX);
    p && (i = p[1], p[2] && (d = p[2]));
  }
  if (a || (a = qn.get(i || e.native)), !a) return e.fallback;
  const t = a.skins[d - 1] || a.skins[0], o = t.src || (e.set != "native" && !e.spritesheet ? typeof e.getImageURL == "function" ? e.getImageURL(e.set, t.unified) : `https://cdn.jsdelivr.net/npm/emoji-datasource-${e.set}@15.0.1/img/${e.set}/64/${t.unified}.png` : void 0), m = typeof e.getSpritesheetURL == "function" ? e.getSpritesheetURL(e.set) : `https://cdn.jsdelivr.net/npm/emoji-datasource-${e.set}@15.0.1/img/${e.set}/sheets-256/64.png`;
  return /* @__PURE__ */ K("span", {
    class: "emoji-mart-emoji",
    "data-emoji-set": e.set,
    children: o ? /* @__PURE__ */ K("img", {
      style: {
        maxWidth: e.size || "1em",
        maxHeight: e.size || "1em",
        display: "inline-block"
      },
      alt: t.native || t.shortcodes,
      src: o
    }) : e.set == "native" ? /* @__PURE__ */ K("span", {
      style: {
        fontSize: e.size,
        fontFamily: '"EmojiMart", "Segoe UI Emoji", "Segoe UI Symbol", "Segoe UI", "Apple Color Emoji", "Twemoji Mozilla", "Noto Color Emoji", "Android Emoji"'
      },
      children: t.native
    }) : /* @__PURE__ */ K("span", {
      style: {
        display: "block",
        width: e.size,
        height: e.size,
        backgroundImage: `url(${m})`,
        backgroundSize: `${100 * Me.sheet.cols}% ${100 * Me.sheet.rows}%`,
        backgroundPosition: `${100 / (Me.sheet.cols - 1) * t.x}% ${100 / (Me.sheet.rows - 1) * t.y}%`
      }
    })
  });
}
const Rl = typeof window < "u" && window.HTMLElement ? window.HTMLElement : Object;
class eu extends Rl {
  static get observedAttributes() {
    return Object.keys(this.Props);
  }
  update(i = {}) {
    for (let d in i) this.attributeChangedCallback(d, null, i[d]);
  }
  attributeChangedCallback(i, d, a) {
    if (!this.component) return;
    const t = Qd(i, {
      [i]: a
    }, this.constructor.Props, this);
    this.component.componentWillReceiveProps ? this.component.componentWillReceiveProps({
      [i]: t
    }) : (this.component.props[i] = t, this.component.forceUpdate());
  }
  disconnectedCallback() {
    this.disconnected = !0, this.component && this.component.unregister && this.component.unregister();
  }
  constructor(i = {}) {
    if (super(), this.props = i, i.parent || i.ref) {
      let d = null;
      const a = i.parent || (d = i.ref && i.ref.current);
      d && (d.innerHTML = ""), a && a.appendChild(this);
    }
  }
}
class Ll extends eu {
  setShadow() {
    this.attachShadow({
      mode: "open"
    });
  }
  injectStyles(i) {
    if (!i) return;
    const d = document.createElement("style");
    d.textContent = i, this.shadowRoot.insertBefore(d, this.shadowRoot.firstChild);
  }
  constructor(i, { styles: d } = {}) {
    super(i), this.setShadow(), this.injectStyles(d);
  }
}
var nu = {
  fallback: "",
  id: "",
  native: "",
  shortcodes: "",
  size: {
    value: "",
    transform: (e) => /\D/.test(e) ? e : `${e}px`
  },
  // Shared
  set: $n.set,
  skin: $n.skin
};
class iu extends eu {
  async connectedCallback() {
    const i = Jd(this.props, nu, this);
    i.element = this, i.ref = (d) => {
      this.component = d;
    }, await oa(), !this.disconnected && Ud(/* @__PURE__ */ K(Ft, {
      ...i
    }), this);
  }
  constructor(i) {
    super(i);
  }
}
un(iu, "Props", nu);
typeof customElements < "u" && !customElements.get("em-emoji") && customElements.define("em-emoji", iu);
var yr, Et = [], kr = ge.__b, wr = ge.__r, _r = ge.diffed, $r = ge.__c, Pr = ge.unmount;
function ql() {
  var e;
  for (Et.sort(function(i, d) {
    return i.__v.__b - d.__v.__b;
  }); e = Et.pop(); ) if (e.__P) try {
    e.__H.__h.forEach(Gi), e.__H.__h.forEach(Rt), e.__H.__h = [];
  } catch (i) {
    e.__H.__h = [], ge.__e(i, e.__v);
  }
}
ge.__b = function(e) {
  kr && kr(e);
}, ge.__r = function(e) {
  wr && wr(e);
  var i = e.__c.__H;
  i && (i.__h.forEach(Gi), i.__h.forEach(Rt), i.__h = []);
}, ge.diffed = function(e) {
  _r && _r(e);
  var i = e.__c;
  i && i.__H && i.__H.__h.length && (Et.push(i) !== 1 && yr === ge.requestAnimationFrame || ((yr = ge.requestAnimationFrame) || function(d) {
    var a, t = function() {
      clearTimeout(o), Mr && cancelAnimationFrame(a), setTimeout(d);
    }, o = setTimeout(t, 100);
    Mr && (a = requestAnimationFrame(t));
  })(ql));
}, ge.__c = function(e, i) {
  i.some(function(d) {
    try {
      d.__h.forEach(Gi), d.__h = d.__h.filter(function(a) {
        return !a.__ || Rt(a);
      });
    } catch (a) {
      i.some(function(t) {
        t.__h && (t.__h = []);
      }), i = [], ge.__e(a, d.__v);
    }
  }), $r && $r(e, i);
}, ge.unmount = function(e) {
  Pr && Pr(e);
  var i, d = e.__c;
  d && d.__H && (d.__H.__.forEach(function(a) {
    try {
      Gi(a);
    } catch (t) {
      i = t;
    }
  }), i && ge.__e(i, d.__v));
};
var Mr = typeof requestAnimationFrame == "function";
function Gi(e) {
  var i = e.__c;
  typeof i == "function" && (e.__c = void 0, i());
}
function Rt(e) {
  e.__c = e.__();
}
function Zl(e, i) {
  for (var d in i) e[d] = i[d];
  return e;
}
function jr(e, i) {
  for (var d in e) if (d !== "__source" && !(d in i)) return !0;
  for (var a in i) if (a !== "__source" && e[a] !== i[a]) return !0;
  return !1;
}
function aa(e) {
  this.props = e;
}
(aa.prototype = new gn()).isPureReactComponent = !0, aa.prototype.shouldComponentUpdate = function(e, i) {
  return jr(this.props, e) || jr(this.state, i);
};
var Sr = ge.__b;
ge.__b = function(e) {
  e.type && e.type.__f && e.ref && (e.props.ref = e.ref, e.ref = null), Sr && Sr(e);
};
var Al = ge.__e;
ge.__e = function(e, i, d) {
  if (e.then) {
    for (var a, t = i; t = t.__; ) if ((a = t.__c) && a.__c) return i.__e == null && (i.__e = d.__e, i.__k = d.__k), a.__c(e, i);
  }
  Al(e, i, d);
};
var zr = ge.unmount;
function ma() {
  this.__u = 0, this.t = null, this.__b = null;
}
function au(e) {
  var i = e.__.__c;
  return i && i.__e && i.__e(e);
}
function oi() {
  this.u = null, this.o = null;
}
ge.unmount = function(e) {
  var i = e.__c;
  i && i.__R && i.__R(), i && e.__h === !0 && (e.type = null), zr && zr(e);
}, (ma.prototype = new gn()).__c = function(e, i) {
  var d = i.__c, a = this;
  a.t == null && (a.t = []), a.t.push(d);
  var t = au(a.__v), o = !1, m = function() {
    o || (o = !0, d.__R = null, t ? t(p) : p());
  };
  d.__R = m;
  var p = function() {
    if (!--a.__u) {
      if (a.state.__e) {
        var r = a.state.__e;
        a.__v.__k[0] = function l(n, f, v) {
          return n && (n.__v = null, n.__k = n.__k && n.__k.map(function(D) {
            return l(D, f, v);
          }), n.__c && n.__c.__P === f && (n.__e && v.insertBefore(n.__e, n.__d), n.__c.__e = !0, n.__c.__P = v)), n;
        }(r, r.__c.__P, r.__c.__O);
      }
      var u;
      for (a.setState({
        __e: a.__b = null
      }); u = a.t.pop(); ) u.forceUpdate();
    }
  }, s = i.__h === !0;
  a.__u++ || s || a.setState({
    __e: a.__b = a.__v.__k[0]
  }), e.then(m, m);
}, ma.prototype.componentWillUnmount = function() {
  this.t = [];
}, ma.prototype.render = function(e, i) {
  if (this.__b) {
    if (this.__v.__k) {
      var d = document.createElement("div"), a = this.__v.__k[0].__c;
      this.__v.__k[0] = function o(m, p, s) {
        return m && (m.__c && m.__c.__H && (m.__c.__H.__.forEach(function(r) {
          typeof r.__c == "function" && r.__c();
        }), m.__c.__H = null), (m = Zl({}, m)).__c != null && (m.__c.__P === s && (m.__c.__P = p), m.__c = null), m.__k = m.__k && m.__k.map(function(r) {
          return o(r, p, s);
        })), m;
      }(this.__b, d, a.__O = a.__P);
    }
    this.__b = null;
  }
  var t = i.__e && Tt(Zn, null, e.fallback);
  return t && (t.__h = null), [
    Tt(Zn, null, i.__e ? null : e.children),
    t
  ];
};
var Or = function(e, i, d) {
  if (++d[1] === d[0] && e.o.delete(i), e.props.revealOrder && (e.props.revealOrder[0] !== "t" || !e.o.size)) for (d = e.u; d; ) {
    for (; d.length > 3; ) d.pop()();
    if (d[1] < d[0]) break;
    e.u = d = d[2];
  }
};
(oi.prototype = new gn()).__e = function(e) {
  var i = this, d = au(i.__v), a = i.o.get(e);
  return a[0]++, function(t) {
    var o = function() {
      i.props.revealOrder ? (a.push(t), Or(i, e, a)) : t();
    };
    d ? d(o) : o();
  };
}, oi.prototype.render = function(e) {
  this.u = null, this.o = /* @__PURE__ */ new Map();
  var i = ea(e.children);
  e.revealOrder && e.revealOrder[0] === "b" && i.reverse();
  for (var d = i.length; d--; ) this.o.set(i[d], this.u = [
    1,
    0,
    this.u
  ]);
  return e.children;
}, oi.prototype.componentDidUpdate = oi.prototype.componentDidMount = function() {
  var e = this;
  this.o.forEach(function(i, d) {
    Or(e, d, i);
  });
};
var Vl = typeof Symbol < "u" && Symbol.for && Symbol.for("react.element") || 60103, Hl = /^(?:accent|alignment|arabic|baseline|cap|clip(?!PathU)|color|dominant|fill|flood|font|glyph(?!R)|horiz|marker(?!H|W|U)|overline|paint|stop|strikethrough|stroke|text(?!L)|underline|unicode|units|v|vector|vert|word|writing|x(?!C))[A-Z]/, Ul = typeof document < "u", Bl = function(e) {
  return (typeof Symbol < "u" && typeof Symbol() == "symbol" ? /fil|che|rad/i : /fil|che|ra/i).test(e);
};
gn.prototype.isReactComponent = {}, [
  "componentWillMount",
  "componentWillReceiveProps",
  "componentWillUpdate"
].forEach(function(e) {
  Object.defineProperty(gn.prototype, e, {
    configurable: !0,
    get: function() {
      return this["UNSAFE_" + e];
    },
    set: function(i) {
      Object.defineProperty(this, e, {
        configurable: !0,
        writable: !0,
        value: i
      });
    }
  });
});
var Wr = ge.event;
function Xl() {
}
function Gl() {
  return this.cancelBubble;
}
function Kl() {
  return this.defaultPrevented;
}
ge.event = function(e) {
  return Wr && (e = Wr(e)), e.persist = Xl, e.isPropagationStopped = Gl, e.isDefaultPrevented = Kl, e.nativeEvent = e;
};
var Dr = {
  configurable: !0,
  get: function() {
    return this.class;
  }
}, Cr = ge.vnode;
ge.vnode = function(e) {
  var i = e.type, d = e.props, a = d;
  if (typeof i == "string") {
    var t = i.indexOf("-") === -1;
    for (var o in a = {}, d) {
      var m = d[o];
      Ul && o === "children" && i === "noscript" || o === "value" && "defaultValue" in d && m == null || (o === "defaultValue" && "value" in d && d.value == null ? o = "value" : o === "download" && m === !0 ? m = "" : /ondoubleclick/i.test(o) ? o = "ondblclick" : /^onchange(textarea|input)/i.test(o + i) && !Bl(d.type) ? o = "oninput" : /^onfocus$/i.test(o) ? o = "onfocusin" : /^onblur$/i.test(o) ? o = "onfocusout" : /^on(Ani|Tra|Tou|BeforeInp)/.test(o) ? o = o.toLowerCase() : t && Hl.test(o) ? o = o.replace(/[A-Z0-9]/, "-$&").toLowerCase() : m === null && (m = void 0), a[o] = m);
    }
    i == "select" && a.multiple && Array.isArray(a.value) && (a.value = ea(d.children).forEach(function(p) {
      p.props.selected = a.value.indexOf(p.props.value) != -1;
    })), i == "select" && a.defaultValue != null && (a.value = ea(d.children).forEach(function(p) {
      p.props.selected = a.multiple ? a.defaultValue.indexOf(p.props.value) != -1 : a.defaultValue == p.props.value;
    })), e.props = a, d.class != d.className && (Dr.enumerable = "className" in d, d.className != null && (a.class = d.className), Object.defineProperty(a, "className", Dr));
  }
  e.$$typeof = Vl, Cr && Cr(e);
};
var Ir = ge.__r;
ge.__r = function(e) {
  Ir && Ir(e), e.__c;
};
const Yl = {
  light: "outline",
  dark: "solid"
};
class Jl extends aa {
  renderIcon(i) {
    const { icon: d } = i;
    if (d) {
      if (d.svg) return /* @__PURE__ */ K("span", {
        class: "flex",
        dangerouslySetInnerHTML: {
          __html: d.svg
        }
      });
      if (d.src) return /* @__PURE__ */ K("img", {
        src: d.src
      });
    }
    const a = ia.categories[i.id] || ia.categories.custom, t = this.props.icons == "auto" ? Yl[this.props.theme] : this.props.icons;
    return a[t] || a;
  }
  render() {
    let i = null;
    return /* @__PURE__ */ K("nav", {
      id: "nav",
      class: "padding",
      "data-position": this.props.position,
      dir: this.props.dir,
      children: /* @__PURE__ */ K("div", {
        class: "flex relative",
        children: [
          this.categories.map((d, a) => {
            const t = d.name || Ue.categories[d.id], o = !this.props.unfocused && d.id == this.state.categoryId;
            return o && (i = a), /* @__PURE__ */ K("button", {
              "aria-label": t,
              "aria-selected": o || void 0,
              title: t,
              type: "button",
              class: "flex flex-grow flex-center",
              onMouseDown: (m) => m.preventDefault(),
              onClick: () => {
                this.props.onClick({
                  category: d,
                  i: a
                });
              },
              children: this.renderIcon(d)
            });
          }),
          /* @__PURE__ */ K("div", {
            class: "bar",
            style: {
              width: `${100 / this.categories.length}%`,
              opacity: i == null ? 0 : 1,
              transform: this.props.dir === "rtl" ? `scaleX(-1) translateX(${i * 100}%)` : `translateX(${i * 100}%)`
            }
          })
        ]
      })
    });
  }
  constructor() {
    super(), this.categories = Me.categories.filter((i) => !i.target), this.state = {
      categoryId: this.categories[0].id
    };
  }
}
class Ql extends aa {
  shouldComponentUpdate(i) {
    for (let d in i)
      if (d != "children" && i[d] != this.props[d])
        return !0;
    return !1;
  }
  render() {
    return this.props.children;
  }
}
const si = {
  rowsPerRender: 10
};
class ec extends gn {
  getInitialState(i = this.props) {
    return {
      skin: Sn.get("skin") || i.skin,
      theme: this.initTheme(i.theme)
    };
  }
  componentWillMount() {
    this.dir = Ue.rtl ? "rtl" : "ltr", this.refs = {
      menu: _n(),
      navigation: _n(),
      scroll: _n(),
      search: _n(),
      searchInput: _n(),
      skinToneButton: _n(),
      skinToneRadio: _n()
    }, this.initGrid(), this.props.stickySearch == !1 && this.props.searchPosition == "sticky" && (console.warn("[EmojiMart] Deprecation warning: `stickySearch` has been renamed `searchPosition`."), this.props.searchPosition = "static");
  }
  componentDidMount() {
    if (this.register(), this.shadowRoot = this.base.parentNode, this.props.autoFocus) {
      const { searchInput: i } = this.refs;
      i.current && i.current.focus();
    }
  }
  componentWillReceiveProps(i) {
    this.nextState || (this.nextState = {});
    for (const d in i) this.nextState[d] = i[d];
    clearTimeout(this.nextStateTimer), this.nextStateTimer = setTimeout(() => {
      let d = !1;
      for (const t in this.nextState)
        this.props[t] = this.nextState[t], (t === "custom" || t === "categories") && (d = !0);
      delete this.nextState;
      const a = this.getInitialState();
      if (d) return this.reset(a);
      this.setState(a);
    });
  }
  componentWillUnmount() {
    this.unregister();
  }
  async reset(i = {}) {
    await oa(this.props), this.initGrid(), this.unobserve(), this.setState(i, () => {
      this.observeCategories(), this.observeRows();
    });
  }
  register() {
    document.addEventListener("click", this.handleClickOutside), this.observe();
  }
  unregister() {
    var i;
    document.removeEventListener("click", this.handleClickOutside), (i = this.darkMedia) == null || i.removeEventListener("change", this.darkMediaCallback), this.unobserve();
  }
  observe() {
    this.observeCategories(), this.observeRows();
  }
  unobserve({ except: i = [] } = {}) {
    Array.isArray(i) || (i = [
      i
    ]);
    for (const d of this.observers)
      i.includes(d) || d.disconnect();
    this.observers = [].concat(i);
  }
  initGrid() {
    const { categories: i } = Me;
    this.refs.categories = /* @__PURE__ */ new Map();
    const d = Me.categories.map((t) => t.id).join(",");
    this.navKey && this.navKey != d && this.refs.scroll.current && (this.refs.scroll.current.scrollTop = 0), this.navKey = d, this.grid = [], this.grid.setsize = 0;
    const a = (t, o) => {
      const m = [];
      m.__categoryId = o.id, m.__index = t.length, this.grid.push(m);
      const p = this.grid.length - 1, s = p % si.rowsPerRender ? {} : _n();
      return s.index = p, s.posinset = this.grid.setsize + 1, t.push(s), m;
    };
    for (let t of i) {
      const o = [];
      let m = a(o, t);
      for (let p of t.emojis)
        m.length == this.getPerLine() && (m = a(o, t)), this.grid.setsize += 1, m.push(p);
      this.refs.categories.set(t.id, {
        root: _n(),
        rows: o
      });
    }
  }
  initTheme(i) {
    if (i != "auto") return i;
    if (!this.darkMedia) {
      if (this.darkMedia = matchMedia("(prefers-color-scheme: dark)"), this.darkMedia.media.match(/^not/)) return "light";
      this.darkMedia.addEventListener("change", this.darkMediaCallback);
    }
    return this.darkMedia.matches ? "dark" : "light";
  }
  initDynamicPerLine(i = this.props) {
    if (!i.dynamicWidth) return;
    const { element: d, emojiButtonSize: a } = i, t = () => {
      const { width: m } = d.getBoundingClientRect();
      return Math.floor(m / a);
    }, o = new ResizeObserver(() => {
      this.unobserve({
        except: o
      }), this.setState({
        perLine: t()
      }, () => {
        this.initGrid(), this.forceUpdate(() => {
          this.observeCategories(), this.observeRows();
        });
      });
    });
    return o.observe(d), this.observers.push(o), t();
  }
  getPerLine() {
    return this.state.perLine || this.props.perLine;
  }
  getEmojiByPos([i, d]) {
    const a = this.state.searchResults || this.grid, t = a[i] && a[i][d];
    if (t)
      return qn.get(t);
  }
  observeCategories() {
    const i = this.refs.navigation.current;
    if (!i) return;
    const d = /* @__PURE__ */ new Map(), a = (m) => {
      m != i.state.categoryId && i.setState({
        categoryId: m
      });
    }, t = {
      root: this.refs.scroll.current,
      threshold: [
        0,
        1
      ]
    }, o = new IntersectionObserver((m) => {
      for (const s of m) {
        const r = s.target.dataset.id;
        d.set(r, s.intersectionRatio);
      }
      const p = [
        ...d
      ];
      for (const [s, r] of p) if (r) {
        a(s);
        break;
      }
    }, t);
    for (const { root: m } of this.refs.categories.values()) o.observe(m.current);
    this.observers.push(o);
  }
  observeRows() {
    const i = {
      ...this.state.visibleRows
    }, d = new IntersectionObserver((a) => {
      for (const t of a) {
        const o = parseInt(t.target.dataset.index);
        t.isIntersecting ? i[o] = !0 : delete i[o];
      }
      this.setState({
        visibleRows: i
      });
    }, {
      root: this.refs.scroll.current,
      rootMargin: `${this.props.emojiButtonSize * (si.rowsPerRender + 5)}px 0px ${this.props.emojiButtonSize * si.rowsPerRender}px`
    });
    for (const { rows: a } of this.refs.categories.values())
      for (const t of a) t.current && d.observe(t.current);
    this.observers.push(d);
  }
  preventDefault(i) {
    i.preventDefault();
  }
  unfocusSearch() {
    const i = this.refs.searchInput.current;
    i && i.blur();
  }
  navigate({ e: i, input: d, left: a, right: t, up: o, down: m }) {
    const p = this.state.searchResults || this.grid;
    if (!p.length) return;
    let [s, r] = this.state.pos;
    const u = (() => {
      if (s == 0 && r == 0 && !i.repeat && (a || o))
        return null;
      if (s == -1)
        return !i.repeat && (t || m) && d.selectionStart == d.value.length ? [
          0,
          0
        ] : null;
      if (a || t) {
        let l = p[s];
        const n = a ? -1 : 1;
        if (r += n, !l[r]) {
          if (s += n, l = p[s], !l)
            return s = a ? 0 : p.length - 1, r = a ? 0 : p[s].length - 1, [
              s,
              r
            ];
          r = a ? l.length - 1 : 0;
        }
        return [
          s,
          r
        ];
      }
      if (o || m) {
        s += o ? -1 : 1;
        const l = p[s];
        return l ? (l[r] || (r = l.length - 1), [
          s,
          r
        ]) : (s = o ? 0 : p.length - 1, r = o ? 0 : p[s].length - 1, [
          s,
          r
        ]);
      }
    })();
    if (u) i.preventDefault();
    else {
      this.state.pos[0] > -1 && this.setState({
        pos: [
          -1,
          -1
        ]
      });
      return;
    }
    this.setState({
      pos: u,
      keyboard: !0
    }, () => {
      this.scrollTo({
        row: u[0]
      });
    });
  }
  scrollTo({ categoryId: i, row: d }) {
    const a = this.state.searchResults || this.grid;
    if (!a.length) return;
    const t = this.refs.scroll.current, o = t.getBoundingClientRect();
    let m = 0;
    if (d >= 0 && (i = a[d].__categoryId), i && (m = (this.refs[i] || this.refs.categories.get(i).root).current.getBoundingClientRect().top - (o.top - t.scrollTop) + 1), d >= 0)
      if (!d) m = 0;
      else {
        const p = a[d].__index, s = m + p * this.props.emojiButtonSize, r = s + this.props.emojiButtonSize + this.props.emojiButtonSize * 0.88;
        if (s < t.scrollTop) m = s;
        else if (r > t.scrollTop + o.height) m = r - o.height;
        else return;
      }
    this.ignoreMouse(), t.scrollTop = m;
  }
  ignoreMouse() {
    this.mouseIsIgnored = !0, clearTimeout(this.ignoreMouseTimer), this.ignoreMouseTimer = setTimeout(() => {
      delete this.mouseIsIgnored;
    }, 100);
  }
  handleEmojiOver(i) {
    this.mouseIsIgnored || this.state.showSkins || this.setState({
      pos: i || [
        -1,
        -1
      ],
      keyboard: !1
    });
  }
  handleEmojiClick({ e: i, emoji: d, pos: a }) {
    if (this.props.onEmojiSelect && (!d && a && (d = this.getEmojiByPos(a)), d)) {
      const t = xl(d, {
        skinIndex: this.state.skin - 1
      });
      this.props.maxFrequentRows && Xd.add(t, this.props), this.props.onEmojiSelect(t, i);
    }
  }
  closeSkins() {
    this.state.showSkins && (this.setState({
      showSkins: null,
      tempSkin: null
    }), this.base.removeEventListener("click", this.handleBaseClick), this.base.removeEventListener("keydown", this.handleBaseKeydown));
  }
  handleSkinMouseOver(i) {
    this.setState({
      tempSkin: i
    });
  }
  handleSkinClick(i) {
    this.ignoreMouse(), this.closeSkins(), this.setState({
      skin: i,
      tempSkin: null
    }), Sn.set("skin", i);
  }
  renderNav() {
    return /* @__PURE__ */ K(Jl, {
      ref: this.refs.navigation,
      icons: this.props.icons,
      theme: this.state.theme,
      dir: this.dir,
      unfocused: !!this.state.searchResults,
      position: this.props.navPosition,
      onClick: this.handleCategoryClick
    }, this.navKey);
  }
  renderPreview() {
    const i = this.getEmojiByPos(this.state.pos), d = this.state.searchResults && !this.state.searchResults.length;
    return /* @__PURE__ */ K("div", {
      id: "preview",
      class: "flex flex-middle",
      dir: this.dir,
      "data-position": this.props.previewPosition,
      children: [
        /* @__PURE__ */ K("div", {
          class: "flex flex-middle flex-grow",
          children: [
            /* @__PURE__ */ K("div", {
              class: "flex flex-auto flex-middle flex-center",
              style: {
                height: this.props.emojiButtonSize,
                fontSize: this.props.emojiButtonSize
              },
              children: /* @__PURE__ */ K(Ft, {
                emoji: i,
                id: d ? this.props.noResultsEmoji || "cry" : this.props.previewEmoji || (this.props.previewPosition == "top" ? "point_down" : "point_up"),
                set: this.props.set,
                size: this.props.emojiButtonSize,
                skin: this.state.tempSkin || this.state.skin,
                spritesheet: !0,
                getSpritesheetURL: this.props.getSpritesheetURL
              })
            }),
            /* @__PURE__ */ K("div", {
              class: `margin-${this.dir[0]}`,
              children: i || d ? /* @__PURE__ */ K("div", {
                class: `padding-${this.dir[2]} align-${this.dir[0]}`,
                children: [
                  /* @__PURE__ */ K("div", {
                    class: "preview-title ellipsis",
                    children: i ? i.name : Ue.search_no_results_1
                  }),
                  /* @__PURE__ */ K("div", {
                    class: "preview-subtitle ellipsis color-c",
                    children: i ? i.skins[0].shortcodes : Ue.search_no_results_2
                  })
                ]
              }) : /* @__PURE__ */ K("div", {
                class: "preview-placeholder color-c",
                children: Ue.pick
              })
            })
          ]
        }),
        !i && this.props.skinTonePosition == "preview" && this.renderSkinToneButton()
      ]
    });
  }
  renderEmojiButton(i, { pos: d, posinset: a, grid: t }) {
    const o = this.props.emojiButtonSize, m = this.state.tempSkin || this.state.skin, s = (i.skins[m - 1] || i.skins[0]).native, r = Tl(this.state.pos, d), u = d.concat(i.id).join("");
    return /* @__PURE__ */ K(Ql, {
      selected: r,
      skin: m,
      size: o,
      children: /* @__PURE__ */ K("button", {
        "aria-label": s,
        "aria-selected": r || void 0,
        "aria-posinset": a,
        "aria-setsize": t.setsize,
        "data-keyboard": this.state.keyboard,
        title: this.props.previewPosition == "none" ? i.name : void 0,
        type: "button",
        class: "flex flex-center flex-middle",
        tabindex: "-1",
        onClick: (l) => this.handleEmojiClick({
          e: l,
          emoji: i
        }),
        onMouseEnter: () => this.handleEmojiOver(d),
        onMouseLeave: () => this.handleEmojiOver(),
        style: {
          width: this.props.emojiButtonSize,
          height: this.props.emojiButtonSize,
          fontSize: this.props.emojiSize,
          lineHeight: 0
        },
        children: [
          /* @__PURE__ */ K("div", {
            "aria-hidden": "true",
            class: "background",
            style: {
              borderRadius: this.props.emojiButtonRadius,
              backgroundColor: this.props.emojiButtonColors ? this.props.emojiButtonColors[(a - 1) % this.props.emojiButtonColors.length] : void 0
            }
          }),
          /* @__PURE__ */ K(Ft, {
            emoji: i,
            set: this.props.set,
            size: this.props.emojiSize,
            skin: m,
            spritesheet: !0,
            getSpritesheetURL: this.props.getSpritesheetURL
          })
        ]
      })
    }, u);
  }
  renderSearch() {
    const i = this.props.previewPosition == "none" || this.props.skinTonePosition == "search";
    return /* @__PURE__ */ K("div", {
      children: [
        /* @__PURE__ */ K("div", {
          class: "spacer"
        }),
        /* @__PURE__ */ K("div", {
          class: "flex flex-middle",
          children: [
            /* @__PURE__ */ K("div", {
              class: "search relative flex-grow",
              children: [
                /* @__PURE__ */ K("input", {
                  type: "search",
                  ref: this.refs.searchInput,
                  placeholder: Ue.search,
                  onClick: this.handleSearchClick,
                  onInput: this.handleSearchInput,
                  onKeyDown: this.handleSearchKeyDown,
                  autoComplete: "off"
                }),
                /* @__PURE__ */ K("span", {
                  class: "icon loupe flex",
                  children: ia.search.loupe
                }),
                this.state.searchResults && /* @__PURE__ */ K("button", {
                  title: "Clear",
                  "aria-label": "Clear",
                  type: "button",
                  class: "icon delete flex",
                  onClick: this.clearSearch,
                  onMouseDown: this.preventDefault,
                  children: ia.search.delete
                })
              ]
            }),
            i && this.renderSkinToneButton()
          ]
        })
      ]
    });
  }
  renderSearchResults() {
    const { searchResults: i } = this.state;
    return i ? /* @__PURE__ */ K("div", {
      class: "category",
      ref: this.refs.search,
      children: [
        /* @__PURE__ */ K("div", {
          class: `sticky padding-small align-${this.dir[0]}`,
          children: Ue.categories.search
        }),
        /* @__PURE__ */ K("div", {
          children: i.length ? i.map((d, a) => /* @__PURE__ */ K("div", {
            class: "flex",
            children: d.map((t, o) => this.renderEmojiButton(t, {
              pos: [
                a,
                o
              ],
              posinset: a * this.props.perLine + o + 1,
              grid: i
            }))
          })) : /* @__PURE__ */ K("div", {
            class: `padding-small align-${this.dir[0]}`,
            children: this.props.onAddCustomEmoji && /* @__PURE__ */ K("a", {
              onClick: this.props.onAddCustomEmoji,
              children: Ue.add_custom
            })
          })
        })
      ]
    }) : null;
  }
  renderCategories() {
    const { categories: i } = Me, d = !!this.state.searchResults, a = this.getPerLine();
    return /* @__PURE__ */ K("div", {
      style: {
        visibility: d ? "hidden" : void 0,
        display: d ? "none" : void 0,
        height: "100%"
      },
      children: i.map((t) => {
        const { root: o, rows: m } = this.refs.categories.get(t.id);
        return /* @__PURE__ */ K("div", {
          "data-id": t.target ? t.target.id : t.id,
          class: "category",
          ref: o,
          children: [
            /* @__PURE__ */ K("div", {
              class: `sticky padding-small align-${this.dir[0]}`,
              children: t.name || Ue.categories[t.id]
            }),
            /* @__PURE__ */ K("div", {
              class: "relative",
              style: {
                height: m.length * this.props.emojiButtonSize
              },
              children: m.map((p, s) => {
                const r = p.index - p.index % si.rowsPerRender, u = this.state.visibleRows[r], l = "current" in p ? p : void 0;
                if (!u && !l) return null;
                const n = s * a, f = n + a, v = t.emojis.slice(n, f);
                return v.length < a && v.push(...new Array(a - v.length)), /* @__PURE__ */ K("div", {
                  "data-index": p.index,
                  ref: l,
                  class: "flex row",
                  style: {
                    top: s * this.props.emojiButtonSize
                  },
                  children: u && v.map((D, F) => {
                    if (!D) return /* @__PURE__ */ K("div", {
                      style: {
                        width: this.props.emojiButtonSize,
                        height: this.props.emojiButtonSize
                      }
                    });
                    const A = qn.get(D);
                    return this.renderEmojiButton(A, {
                      pos: [
                        p.index,
                        F
                      ],
                      posinset: p.posinset + F,
                      grid: this.grid
                    });
                  })
                }, p.index);
              })
            })
          ]
        });
      })
    });
  }
  renderSkinToneButton() {
    return this.props.skinTonePosition == "none" ? null : /* @__PURE__ */ K("div", {
      class: "flex flex-auto flex-center flex-middle",
      style: {
        position: "relative",
        width: this.props.emojiButtonSize,
        height: this.props.emojiButtonSize
      },
      children: /* @__PURE__ */ K("button", {
        type: "button",
        ref: this.refs.skinToneButton,
        class: "skin-tone-button flex flex-auto flex-center flex-middle",
        "aria-selected": this.state.showSkins ? "" : void 0,
        "aria-label": Ue.skins.choose,
        title: Ue.skins.choose,
        onClick: this.openSkins,
        style: {
          width: this.props.emojiSize,
          height: this.props.emojiSize
        },
        children: /* @__PURE__ */ K("span", {
          class: `skin-tone skin-tone-${this.state.skin}`
        })
      })
    });
  }
  renderLiveRegion() {
    const i = this.getEmojiByPos(this.state.pos), d = i ? i.name : "";
    return /* @__PURE__ */ K("div", {
      "aria-live": "polite",
      class: "sr-only",
      children: d
    });
  }
  renderSkins() {
    const d = this.refs.skinToneButton.current.getBoundingClientRect(), a = this.base.getBoundingClientRect(), t = {};
    return this.dir == "ltr" ? t.right = a.right - d.right - 3 : t.left = d.left - a.left - 3, this.props.previewPosition == "bottom" && this.props.skinTonePosition == "preview" ? t.bottom = a.bottom - d.top + 6 : (t.top = d.bottom - a.top + 3, t.bottom = "auto"), /* @__PURE__ */ K("div", {
      ref: this.refs.menu,
      role: "radiogroup",
      dir: this.dir,
      "aria-label": Ue.skins.choose,
      class: "menu hidden",
      "data-position": t.top ? "top" : "bottom",
      style: t,
      children: [
        ...Array(6).keys()
      ].map((o) => {
        const m = o + 1, p = this.state.skin == m;
        return /* @__PURE__ */ K("div", {
          children: [
            /* @__PURE__ */ K("input", {
              type: "radio",
              name: "skin-tone",
              value: m,
              "aria-label": Ue.skins[m],
              ref: p ? this.refs.skinToneRadio : null,
              defaultChecked: p,
              onChange: () => this.handleSkinMouseOver(m),
              onKeyDown: (s) => {
                (s.code == "Enter" || s.code == "Space" || s.code == "Tab") && (s.preventDefault(), this.handleSkinClick(m));
              }
            }),
            /* @__PURE__ */ K("button", {
              "aria-hidden": "true",
              tabindex: "-1",
              onClick: () => this.handleSkinClick(m),
              onMouseEnter: () => this.handleSkinMouseOver(m),
              onMouseLeave: () => this.handleSkinMouseOver(),
              class: "option flex flex-grow flex-middle",
              children: [
                /* @__PURE__ */ K("span", {
                  class: `skin-tone skin-tone-${m}`
                }),
                /* @__PURE__ */ K("span", {
                  class: "margin-small-lr",
                  children: Ue.skins[m]
                })
              ]
            })
          ]
        });
      })
    });
  }
  render() {
    const i = this.props.perLine * this.props.emojiButtonSize;
    return /* @__PURE__ */ K("section", {
      id: "root",
      class: "flex flex-column",
      dir: this.dir,
      style: {
        width: this.props.dynamicWidth ? "100%" : `calc(${i}px + (var(--padding) + var(--sidebar-width)))`
      },
      "data-emoji-set": this.props.set,
      "data-theme": this.state.theme,
      "data-menu": this.state.showSkins ? "" : void 0,
      children: [
        this.props.previewPosition == "top" && this.renderPreview(),
        this.props.navPosition == "top" && this.renderNav(),
        this.props.searchPosition == "sticky" && /* @__PURE__ */ K("div", {
          class: "padding-lr",
          children: this.renderSearch()
        }),
        /* @__PURE__ */ K("div", {
          ref: this.refs.scroll,
          class: "scroll flex-grow padding-lr",
          children: /* @__PURE__ */ K("div", {
            style: {
              width: this.props.dynamicWidth ? "100%" : i,
              height: "100%"
            },
            children: [
              this.props.searchPosition == "static" && this.renderSearch(),
              this.renderSearchResults(),
              this.renderCategories()
            ]
          })
        }),
        this.props.navPosition == "bottom" && this.renderNav(),
        this.props.previewPosition == "bottom" && this.renderPreview(),
        this.state.showSkins && this.renderSkins(),
        this.renderLiveRegion()
      ]
    });
  }
  constructor(i) {
    super(), un(this, "darkMediaCallback", () => {
      this.props.theme == "auto" && this.setState({
        theme: this.darkMedia.matches ? "dark" : "light"
      });
    }), un(this, "handleClickOutside", (d) => {
      const { element: a } = this.props;
      d.target != a && (this.state.showSkins && this.closeSkins(), this.props.onClickOutside && this.props.onClickOutside(d));
    }), un(this, "handleBaseClick", (d) => {
      this.state.showSkins && (d.target.closest(".menu") || (d.preventDefault(), d.stopImmediatePropagation(), this.closeSkins()));
    }), un(this, "handleBaseKeydown", (d) => {
      this.state.showSkins && d.key == "Escape" && (d.preventDefault(), d.stopImmediatePropagation(), this.closeSkins());
    }), un(this, "handleSearchClick", () => {
      this.getEmojiByPos(this.state.pos) && this.setState({
        pos: [
          -1,
          -1
        ]
      });
    }), un(this, "handleSearchInput", async () => {
      const d = this.refs.searchInput.current;
      if (!d) return;
      const { value: a } = d, t = await qn.search(a), o = () => {
        this.refs.scroll.current && (this.refs.scroll.current.scrollTop = 0);
      };
      if (!t) return this.setState({
        searchResults: t,
        pos: [
          -1,
          -1
        ]
      }, o);
      const m = d.selectionStart == d.value.length ? [
        0,
        0
      ] : [
        -1,
        -1
      ], p = [];
      p.setsize = t.length;
      let s = null;
      for (let r of t)
        (!p.length || s.length == this.getPerLine()) && (s = [], s.__categoryId = "search", s.__index = p.length, p.push(s)), s.push(r);
      this.ignoreMouse(), this.setState({
        searchResults: p,
        pos: m
      }, o);
    }), un(this, "handleSearchKeyDown", (d) => {
      const a = d.currentTarget;
      switch (d.stopImmediatePropagation(), d.key) {
        case "ArrowLeft":
          this.navigate({
            e: d,
            input: a,
            left: !0
          });
          break;
        case "ArrowRight":
          this.navigate({
            e: d,
            input: a,
            right: !0
          });
          break;
        case "ArrowUp":
          this.navigate({
            e: d,
            input: a,
            up: !0
          });
          break;
        case "ArrowDown":
          this.navigate({
            e: d,
            input: a,
            down: !0
          });
          break;
        case "Enter":
          d.preventDefault(), this.handleEmojiClick({
            e: d,
            pos: this.state.pos
          });
          break;
        case "Escape":
          d.preventDefault(), this.state.searchResults ? this.clearSearch() : this.unfocusSearch();
          break;
      }
    }), un(this, "clearSearch", () => {
      const d = this.refs.searchInput.current;
      d && (d.value = "", d.focus(), this.handleSearchInput());
    }), un(this, "handleCategoryClick", ({ category: d, i: a }) => {
      this.scrollTo(a == 0 ? {
        row: -1
      } : {
        categoryId: d.id
      });
    }), un(this, "openSkins", (d) => {
      const { currentTarget: a } = d, t = a.getBoundingClientRect();
      this.setState({
        showSkins: t
      }, async () => {
        await Nl(2);
        const o = this.refs.menu.current;
        o && (o.classList.remove("hidden"), this.refs.skinToneRadio.current.focus(), this.base.addEventListener("click", this.handleBaseClick, !0), this.base.addEventListener("keydown", this.handleBaseKeydown, !0));
      });
    }), this.observers = [], this.state = {
      pos: [
        -1,
        -1
      ],
      perLine: this.initDynamicPerLine(i),
      visibleRows: {
        0: !0
      },
      ...this.getInitialState(i)
    };
  }
}
class Xt extends Ll {
  async connectedCallback() {
    const i = Jd(this.props, $n, this);
    i.element = this, i.ref = (d) => {
      this.component = d;
    }, await oa(i), !this.disconnected && Ud(/* @__PURE__ */ K(ec, {
      ...i
    }), this.shadowRoot);
  }
  constructor(i) {
    super(i, {
      styles: /* @__PURE__ */ Td(tu)
    });
  }
}
un(Xt, "Props", $n);
typeof customElements < "u" && !customElements.get("em-emoji-picker") && customElements.define("em-emoji-picker", Xt);
var tu = {};
tu = `:host {
  width: min-content;
  height: 435px;
  min-height: 230px;
  border-radius: var(--border-radius);
  box-shadow: var(--shadow);
  --border-radius: 10px;
  --category-icon-size: 18px;
  --font-family: -apple-system, BlinkMacSystemFont, "Helvetica Neue", sans-serif;
  --font-size: 15px;
  --preview-placeholder-size: 21px;
  --preview-title-size: 1.1em;
  --preview-subtitle-size: .9em;
  --shadow-color: 0deg 0% 0%;
  --shadow: .3px .5px 2.7px hsl(var(--shadow-color) / .14), .4px .8px 1px -3.2px hsl(var(--shadow-color) / .14), 1px 2px 2.5px -4.5px hsl(var(--shadow-color) / .14);
  display: flex;
}

[data-theme="light"] {
  --em-rgb-color: var(--rgb-color, 34, 36, 39);
  --em-rgb-accent: var(--rgb-accent, 34, 102, 237);
  --em-rgb-background: var(--rgb-background, 255, 255, 255);
  --em-rgb-input: var(--rgb-input, 255, 255, 255);
  --em-color-border: var(--color-border, rgba(0, 0, 0, .05));
  --em-color-border-over: var(--color-border-over, rgba(0, 0, 0, .1));
}

[data-theme="dark"] {
  --em-rgb-color: var(--rgb-color, 222, 222, 221);
  --em-rgb-accent: var(--rgb-accent, 58, 130, 247);
  --em-rgb-background: var(--rgb-background, 21, 22, 23);
  --em-rgb-input: var(--rgb-input, 0, 0, 0);
  --em-color-border: var(--color-border, rgba(255, 255, 255, .1));
  --em-color-border-over: var(--color-border-over, rgba(255, 255, 255, .2));
}

#root {
  --color-a: rgb(var(--em-rgb-color));
  --color-b: rgba(var(--em-rgb-color), .65);
  --color-c: rgba(var(--em-rgb-color), .45);
  --padding: 12px;
  --padding-small: calc(var(--padding) / 2);
  --sidebar-width: 16px;
  --duration: 225ms;
  --duration-fast: 125ms;
  --duration-instant: 50ms;
  --easing: cubic-bezier(.4, 0, .2, 1);
  width: 100%;
  text-align: left;
  border-radius: var(--border-radius);
  background-color: rgb(var(--em-rgb-background));
  position: relative;
}

@media (prefers-reduced-motion) {
  #root {
    --duration: 0;
    --duration-fast: 0;
    --duration-instant: 0;
  }
}

#root[data-menu] button {
  cursor: auto;
}

#root[data-menu] .menu button {
  cursor: pointer;
}

:host, #root, input, button {
  color: rgb(var(--em-rgb-color));
  font-family: var(--font-family);
  font-size: var(--font-size);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  line-height: normal;
}

*, :before, :after {
  box-sizing: border-box;
  min-width: 0;
  margin: 0;
  padding: 0;
}

.relative {
  position: relative;
}

.flex {
  display: flex;
}

.flex-auto {
  flex: none;
}

.flex-center {
  justify-content: center;
}

.flex-column {
  flex-direction: column;
}

.flex-grow {
  flex: auto;
}

.flex-middle {
  align-items: center;
}

.flex-wrap {
  flex-wrap: wrap;
}

.padding {
  padding: var(--padding);
}

.padding-t {
  padding-top: var(--padding);
}

.padding-lr {
  padding-left: var(--padding);
  padding-right: var(--padding);
}

.padding-r {
  padding-right: var(--padding);
}

.padding-small {
  padding: var(--padding-small);
}

.padding-small-b {
  padding-bottom: var(--padding-small);
}

.padding-small-lr {
  padding-left: var(--padding-small);
  padding-right: var(--padding-small);
}

.margin {
  margin: var(--padding);
}

.margin-r {
  margin-right: var(--padding);
}

.margin-l {
  margin-left: var(--padding);
}

.margin-small-l {
  margin-left: var(--padding-small);
}

.margin-small-lr {
  margin-left: var(--padding-small);
  margin-right: var(--padding-small);
}

.align-l {
  text-align: left;
}

.align-r {
  text-align: right;
}

.color-a {
  color: var(--color-a);
}

.color-b {
  color: var(--color-b);
}

.color-c {
  color: var(--color-c);
}

.ellipsis {
  white-space: nowrap;
  max-width: 100%;
  width: auto;
  text-overflow: ellipsis;
  overflow: hidden;
}

.sr-only {
  width: 1px;
  height: 1px;
  position: absolute;
  top: auto;
  left: -10000px;
  overflow: hidden;
}

a {
  cursor: pointer;
  color: rgb(var(--em-rgb-accent));
}

a:hover {
  text-decoration: underline;
}

.spacer {
  height: 10px;
}

[dir="rtl"] .scroll {
  padding-left: 0;
  padding-right: var(--padding);
}

.scroll {
  padding-right: 0;
  overflow-x: hidden;
  overflow-y: auto;
}

.scroll::-webkit-scrollbar {
  width: var(--sidebar-width);
  height: var(--sidebar-width);
}

.scroll::-webkit-scrollbar-track {
  border: 0;
}

.scroll::-webkit-scrollbar-button {
  width: 0;
  height: 0;
  display: none;
}

.scroll::-webkit-scrollbar-corner {
  background-color: rgba(0, 0, 0, 0);
}

.scroll::-webkit-scrollbar-thumb {
  min-height: 20%;
  min-height: 65px;
  border: 4px solid rgb(var(--em-rgb-background));
  border-radius: 8px;
}

.scroll::-webkit-scrollbar-thumb:hover {
  background-color: var(--em-color-border-over) !important;
}

.scroll:hover::-webkit-scrollbar-thumb {
  background-color: var(--em-color-border);
}

.sticky {
  z-index: 1;
  background-color: rgba(var(--em-rgb-background), .9);
  -webkit-backdrop-filter: blur(4px);
  backdrop-filter: blur(4px);
  font-weight: 500;
  position: sticky;
  top: -1px;
}

[dir="rtl"] .search input[type="search"] {
  padding: 10px 2.2em 10px 2em;
}

[dir="rtl"] .search .loupe {
  left: auto;
  right: .7em;
}

[dir="rtl"] .search .delete {
  left: .7em;
  right: auto;
}

.search {
  z-index: 2;
  position: relative;
}

.search input, .search button {
  font-size: calc(var(--font-size)  - 1px);
}

.search input[type="search"] {
  width: 100%;
  background-color: var(--em-color-border);
  transition-duration: var(--duration);
  transition-property: background-color, box-shadow;
  transition-timing-function: var(--easing);
  border: 0;
  border-radius: 10px;
  outline: 0;
  padding: 10px 2em 10px 2.2em;
  display: block;
}

.search input[type="search"]::-ms-input-placeholder {
  color: inherit;
  opacity: .6;
}

.search input[type="search"]::placeholder {
  color: inherit;
  opacity: .6;
}

.search input[type="search"], .search input[type="search"]::-webkit-search-decoration, .search input[type="search"]::-webkit-search-cancel-button, .search input[type="search"]::-webkit-search-results-button, .search input[type="search"]::-webkit-search-results-decoration {
  -webkit-appearance: none;
  -ms-appearance: none;
  appearance: none;
}

.search input[type="search"]:focus {
  background-color: rgb(var(--em-rgb-input));
  box-shadow: inset 0 0 0 1px rgb(var(--em-rgb-accent)), 0 1px 3px rgba(65, 69, 73, .2);
}

.search .icon {
  z-index: 1;
  color: rgba(var(--em-rgb-color), .7);
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}

.search .loupe {
  pointer-events: none;
  left: .7em;
}

.search .delete {
  right: .7em;
}

svg {
  fill: currentColor;
  width: 1em;
  height: 1em;
}

button {
  -webkit-appearance: none;
  -ms-appearance: none;
  appearance: none;
  cursor: pointer;
  color: currentColor;
  background-color: rgba(0, 0, 0, 0);
  border: 0;
}

#nav {
  z-index: 2;
  padding-top: 12px;
  padding-bottom: 12px;
  padding-right: var(--sidebar-width);
  position: relative;
}

#nav button {
  color: var(--color-b);
  transition: color var(--duration) var(--easing);
}

#nav button:hover {
  color: var(--color-a);
}

#nav svg, #nav img {
  width: var(--category-icon-size);
  height: var(--category-icon-size);
}

#nav[dir="rtl"] .bar {
  left: auto;
  right: 0;
}

#nav .bar {
  width: 100%;
  height: 3px;
  background-color: rgb(var(--em-rgb-accent));
  transition: transform var(--duration) var(--easing);
  border-radius: 3px 3px 0 0;
  position: absolute;
  bottom: -12px;
  left: 0;
}

#nav button[aria-selected] {
  color: rgb(var(--em-rgb-accent));
}

#preview {
  z-index: 2;
  padding: calc(var(--padding)  + 4px) var(--padding);
  padding-right: var(--sidebar-width);
  position: relative;
}

#preview .preview-placeholder {
  font-size: var(--preview-placeholder-size);
}

#preview .preview-title {
  font-size: var(--preview-title-size);
}

#preview .preview-subtitle {
  font-size: var(--preview-subtitle-size);
}

#nav:before, #preview:before {
  content: "";
  height: 2px;
  position: absolute;
  left: 0;
  right: 0;
}

#nav[data-position="top"]:before, #preview[data-position="top"]:before {
  background: linear-gradient(to bottom, var(--em-color-border), transparent);
  top: 100%;
}

#nav[data-position="bottom"]:before, #preview[data-position="bottom"]:before {
  background: linear-gradient(to top, var(--em-color-border), transparent);
  bottom: 100%;
}

.category:last-child {
  min-height: calc(100% + 1px);
}

.category button {
  font-family: -apple-system, BlinkMacSystemFont, Helvetica Neue, sans-serif;
  position: relative;
}

.category button > * {
  position: relative;
}

.category button .background {
  opacity: 0;
  background-color: var(--em-color-border);
  transition: opacity var(--duration-fast) var(--easing) var(--duration-instant);
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}

.category button:hover .background {
  transition-duration: var(--duration-instant);
  transition-delay: 0s;
}

.category button[aria-selected] .background {
  opacity: 1;
}

.category button[data-keyboard] .background {
  transition: none;
}

.row {
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
}

.skin-tone-button {
  border: 1px solid rgba(0, 0, 0, 0);
  border-radius: 100%;
}

.skin-tone-button:hover {
  border-color: var(--em-color-border);
}

.skin-tone-button:active .skin-tone {
  transform: scale(.85) !important;
}

.skin-tone-button .skin-tone {
  transition: transform var(--duration) var(--easing);
}

.skin-tone-button[aria-selected] {
  background-color: var(--em-color-border);
  border-top-color: rgba(0, 0, 0, .05);
  border-bottom-color: rgba(0, 0, 0, 0);
  border-left-width: 0;
  border-right-width: 0;
}

.skin-tone-button[aria-selected] .skin-tone {
  transform: scale(.9);
}

.menu {
  z-index: 2;
  white-space: nowrap;
  border: 1px solid var(--em-color-border);
  background-color: rgba(var(--em-rgb-background), .9);
  -webkit-backdrop-filter: blur(4px);
  backdrop-filter: blur(4px);
  transition-property: opacity, transform;
  transition-duration: var(--duration);
  transition-timing-function: var(--easing);
  border-radius: 10px;
  padding: 4px;
  position: absolute;
  box-shadow: 1px 1px 5px rgba(0, 0, 0, .05);
}

.menu.hidden {
  opacity: 0;
}

.menu[data-position="bottom"] {
  transform-origin: 100% 100%;
}

.menu[data-position="bottom"].hidden {
  transform: scale(.9)rotate(-3deg)translateY(5%);
}

.menu[data-position="top"] {
  transform-origin: 100% 0;
}

.menu[data-position="top"].hidden {
  transform: scale(.9)rotate(3deg)translateY(-5%);
}

.menu input[type="radio"] {
  clip: rect(0 0 0 0);
  width: 1px;
  height: 1px;
  border: 0;
  margin: 0;
  padding: 0;
  position: absolute;
  overflow: hidden;
}

.menu input[type="radio"]:checked + .option {
  box-shadow: 0 0 0 2px rgb(var(--em-rgb-accent));
}

.option {
  width: 100%;
  border-radius: 6px;
  padding: 4px 6px;
}

.option:hover {
  color: #fff;
  background-color: rgb(var(--em-rgb-accent));
}

.skin-tone {
  width: 16px;
  height: 16px;
  border-radius: 100%;
  display: inline-block;
  position: relative;
  overflow: hidden;
}

.skin-tone:after {
  content: "";
  mix-blend-mode: overlay;
  background: linear-gradient(rgba(255, 255, 255, .2), rgba(0, 0, 0, 0));
  border: 1px solid rgba(0, 0, 0, .8);
  border-radius: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  box-shadow: inset 0 -2px 3px #000, inset 0 1px 2px #fff;
}

.skin-tone-1 {
  background-color: #ffc93a;
}

.skin-tone-2 {
  background-color: #ffdab7;
}

.skin-tone-3 {
  background-color: #e7b98f;
}

.skin-tone-4 {
  background-color: #c88c61;
}

.skin-tone-5 {
  background-color: #a46134;
}

.skin-tone-6 {
  background-color: #5d4437;
}

[data-index] {
  justify-content: space-between;
}

[data-emoji-set="twitter"] .skin-tone:after {
  box-shadow: none;
  border-color: rgba(0, 0, 0, .5);
}

[data-emoji-set="twitter"] .skin-tone-1 {
  background-color: #fade72;
}

[data-emoji-set="twitter"] .skin-tone-2 {
  background-color: #f3dfd0;
}

[data-emoji-set="twitter"] .skin-tone-3 {
  background-color: #eed3a8;
}

[data-emoji-set="twitter"] .skin-tone-4 {
  background-color: #cfad8d;
}

[data-emoji-set="twitter"] .skin-tone-5 {
  background-color: #a8805d;
}

[data-emoji-set="twitter"] .skin-tone-6 {
  background-color: #765542;
}

[data-emoji-set="google"] .skin-tone:after {
  box-shadow: inset 0 0 2px 2px rgba(0, 0, 0, .4);
}

[data-emoji-set="google"] .skin-tone-1 {
  background-color: #f5c748;
}

[data-emoji-set="google"] .skin-tone-2 {
  background-color: #f1d5aa;
}

[data-emoji-set="google"] .skin-tone-3 {
  background-color: #d4b48d;
}

[data-emoji-set="google"] .skin-tone-4 {
  background-color: #aa876b;
}

[data-emoji-set="google"] .skin-tone-5 {
  background-color: #916544;
}

[data-emoji-set="google"] .skin-tone-6 {
  background-color: #61493f;
}

[data-emoji-set="facebook"] .skin-tone:after {
  border-color: rgba(0, 0, 0, .4);
  box-shadow: inset 0 -2px 3px #000, inset 0 1px 4px #fff;
}

[data-emoji-set="facebook"] .skin-tone-1 {
  background-color: #f5c748;
}

[data-emoji-set="facebook"] .skin-tone-2 {
  background-color: #f1d5aa;
}

[data-emoji-set="facebook"] .skin-tone-3 {
  background-color: #d4b48d;
}

[data-emoji-set="facebook"] .skin-tone-4 {
  background-color: #aa876b;
}

[data-emoji-set="facebook"] .skin-tone-5 {
  background-color: #916544;
}

[data-emoji-set="facebook"] .skin-tone-6 {
  background-color: #61493f;
}

`;
function nc(e) {
  const i = Yi(null), d = Yi(null);
  return d.current && d.current.update(e), of(() => (d.current = new Xt({
    ...e,
    ref: i
  }), () => {
    d.current = null;
  }), []), /* @__PURE__ */ rf.createElement("div", {
    ref: i
  });
}
const ic = {
  de: "de",
  enUS: "en",
  es: "es",
  frCA: "fr",
  ja: "ja",
  nl: "nl",
  ptBR: "pt",
  zhCN: "zh"
}, ac = ff()(({ palette: e, mixins: i }) => ({
  root: {
    "& em-emoji-picker": {
      /**
       * this will change the accent color of the emoji picker. tabs, search input, skin tone select, etc.
       */
      "--rgb-accent": i.hexToRgb(e.primary.main)
    }
  }
}));
var ru = {}, va = {}, ha = {}, Tr = {}, ga, Nr;
function tc() {
  if (Nr) return ga;
  Nr = 1;
  var e = kd, i = cf(), d = mf(), a = hf, t = wf(), o = vf, m = Function, p = e([].concat), s = e([].join), r = {}, u = function(l, n, f) {
    if (!a(r, n)) {
      for (var v = [], D = 0; D < n; D++) v[D] = "a[" + D + "]";
      r[n] = m("C,a", "return new C(" + s(v, ",") + ")");
    }
    return r[n](l, f);
  };
  return ga = o ? m.bind : function(n) {
    var f = i(this), v = f.prototype, D = t(arguments, 1), F = function() {
      var ae = p(D, t(arguments));
      return this instanceof F ? u(f, ae.length, ae) : f.apply(n, ae);
    };
    return d(v) && (F.prototype = v), F;
  }, ga;
}
var xr;
function rc() {
  if (xr) return Tr;
  xr = 1;
  var e = At(), i = tc();
  return e({ target: "Function", proto: !0, forced: Function.bind !== i }, {
    bind: i
  }), Tr;
}
var pa, Fr;
function oc() {
  if (Fr) return pa;
  Fr = 1, rc();
  var e = gf;
  return pa = e("Function", "bind"), pa;
}
var ba, Er;
function sc() {
  if (Er) return ba;
  Er = 1;
  var e = pf, i = oc(), d = Function.prototype;
  return ba = function(a) {
    var t = a.bind;
    return a === d || e(d, a) && t === d.bind ? i : t;
  }, ba;
}
var ya, Rr;
function dc() {
  if (Rr) return ya;
  Rr = 1;
  var e = sc();
  return ya = e, ya;
}
var ka, Lr;
function uc() {
  if (Lr) return ka;
  Lr = 1;
  var e = dc();
  return ka = e, ka;
}
var wa, qr;
function fc() {
  if (qr) return wa;
  qr = 1;
  var e = uc();
  return wa = e, wa;
}
var _a, Zr;
function lc() {
  return Zr || (Zr = 1, _a = fc()), _a;
}
var $a, Ar;
function cc() {
  return Ar || (Ar = 1, $a = lc()), $a;
}
var Pa, Vr;
function mc() {
  if (Vr) return Pa;
  Vr = 1;
  const e = (j) => typeof j == "string", i = () => {
    let j, h;
    const g = new Promise((k, S) => {
      j = k, h = S;
    });
    return g.resolve = j, g.reject = h, g;
  }, d = (j) => j == null ? "" : "" + j, a = (j, h, g) => {
    j.forEach((k) => {
      h[k] && (g[k] = h[k]);
    });
  }, t = /###/g, o = (j) => j && j.indexOf("###") > -1 ? j.replace(t, ".") : j, m = (j) => !j || e(j), p = (j, h, g) => {
    const k = e(h) ? h.split(".") : h;
    let S = 0;
    for (; S < k.length - 1; ) {
      if (m(j)) return {};
      const z = o(k[S]);
      !j[z] && g && (j[z] = new g()), Object.prototype.hasOwnProperty.call(j, z) ? j = j[z] : j = {}, ++S;
    }
    return m(j) ? {} : {
      obj: j,
      k: o(k[S])
    };
  }, s = (j, h, g) => {
    const {
      obj: k,
      k: S
    } = p(j, h, Object);
    if (k !== void 0 || h.length === 1) {
      k[S] = g;
      return;
    }
    let z = h[h.length - 1], E = h.slice(0, h.length - 1), q = p(j, E, Object);
    for (; q.obj === void 0 && E.length; )
      z = `${E[E.length - 1]}.${z}`, E = E.slice(0, E.length - 1), q = p(j, E, Object), q != null && q.obj && typeof q.obj[`${q.k}.${z}`] < "u" && (q.obj = void 0);
    q.obj[`${q.k}.${z}`] = g;
  }, r = (j, h, g, k) => {
    const {
      obj: S,
      k: z
    } = p(j, h, Object);
    S[z] = S[z] || [], S[z].push(g);
  }, u = (j, h) => {
    const {
      obj: g,
      k
    } = p(j, h);
    if (g && Object.prototype.hasOwnProperty.call(g, k))
      return g[k];
  }, l = (j, h, g) => {
    const k = u(j, g);
    return k !== void 0 ? k : u(h, g);
  }, n = (j, h, g) => {
    for (const k in h)
      k !== "__proto__" && k !== "constructor" && (k in j ? e(j[k]) || j[k] instanceof String || e(h[k]) || h[k] instanceof String ? g && (j[k] = h[k]) : n(j[k], h[k], g) : j[k] = h[k]);
    return j;
  }, f = (j) => j.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
  var v = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;",
    "/": "&#x2F;"
  };
  const D = (j) => e(j) ? j.replace(/[&<>"'\/]/g, (h) => v[h]) : j;
  class F {
    constructor(h) {
      this.capacity = h, this.regExpMap = /* @__PURE__ */ new Map(), this.regExpQueue = [];
    }
    getRegExp(h) {
      const g = this.regExpMap.get(h);
      if (g !== void 0)
        return g;
      const k = new RegExp(h);
      return this.regExpQueue.length === this.capacity && this.regExpMap.delete(this.regExpQueue.shift()), this.regExpMap.set(h, k), this.regExpQueue.push(h), k;
    }
  }
  const A = [" ", ",", "?", "!", ";"], ae = new F(20), ne = (j, h, g) => {
    h = h || "", g = g || "";
    const k = A.filter((E) => h.indexOf(E) < 0 && g.indexOf(E) < 0);
    if (k.length === 0) return !0;
    const S = ae.getRegExp(`(${k.map((E) => E === "?" ? "\\?" : E).join("|")})`);
    let z = !S.test(j);
    if (!z) {
      const E = j.indexOf(g);
      E > 0 && !S.test(j.substring(0, E)) && (z = !0);
    }
    return z;
  }, ce = function(j, h) {
    let g = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ".";
    if (!j) return;
    if (j[h])
      return Object.prototype.hasOwnProperty.call(j, h) ? j[h] : void 0;
    const k = h.split(g);
    let S = j;
    for (let z = 0; z < k.length; ) {
      if (!S || typeof S != "object")
        return;
      let E, q = "";
      for (let L = z; L < k.length; ++L)
        if (L !== z && (q += g), q += k[L], E = S[q], E !== void 0) {
          if (["string", "number", "boolean"].indexOf(typeof E) > -1 && L < k.length - 1)
            continue;
          z += L - z + 1;
          break;
        }
      S = E;
    }
    return S;
  }, Q = (j) => j == null ? void 0 : j.replace("_", "-"), N = {
    type: "logger",
    log(j) {
      this.output("log", j);
    },
    warn(j) {
      this.output("warn", j);
    },
    error(j) {
      this.output("error", j);
    },
    output(j, h) {
      var g, k;
      (k = (g = console == null ? void 0 : console[j]) == null ? void 0 : g.apply) == null || k.call(g, console, h);
    }
  };
  class B {
    constructor(h) {
      let g = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      this.init(h, g);
    }
    init(h) {
      let g = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      this.prefix = g.prefix || "i18next:", this.logger = h || N, this.options = g, this.debug = g.debug;
    }
    log() {
      for (var h = arguments.length, g = new Array(h), k = 0; k < h; k++)
        g[k] = arguments[k];
      return this.forward(g, "log", "", !0);
    }
    warn() {
      for (var h = arguments.length, g = new Array(h), k = 0; k < h; k++)
        g[k] = arguments[k];
      return this.forward(g, "warn", "", !0);
    }
    error() {
      for (var h = arguments.length, g = new Array(h), k = 0; k < h; k++)
        g[k] = arguments[k];
      return this.forward(g, "error", "");
    }
    deprecate() {
      for (var h = arguments.length, g = new Array(h), k = 0; k < h; k++)
        g[k] = arguments[k];
      return this.forward(g, "warn", "WARNING DEPRECATED: ", !0);
    }
    forward(h, g, k, S) {
      return S && !this.debug ? null : (e(h[0]) && (h[0] = `${k}${this.prefix} ${h[0]}`), this.logger[g](h));
    }
    create(h) {
      return new B(this.logger, {
        prefix: `${this.prefix}:${h}:`,
        ...this.options
      });
    }
    clone(h) {
      return h = h || this.options, h.prefix = h.prefix || this.prefix, new B(this.logger, h);
    }
  }
  var V = new B();
  class se {
    constructor() {
      this.observers = {};
    }
    on(h, g) {
      return h.split(" ").forEach((k) => {
        this.observers[k] || (this.observers[k] = /* @__PURE__ */ new Map());
        const S = this.observers[k].get(g) || 0;
        this.observers[k].set(g, S + 1);
      }), this;
    }
    off(h, g) {
      if (this.observers[h]) {
        if (!g) {
          delete this.observers[h];
          return;
        }
        this.observers[h].delete(g);
      }
    }
    emit(h) {
      for (var g = arguments.length, k = new Array(g > 1 ? g - 1 : 0), S = 1; S < g; S++)
        k[S - 1] = arguments[S];
      this.observers[h] && Array.from(this.observers[h].entries()).forEach((E) => {
        let [q, L] = E;
        for (let U = 0; U < L; U++)
          q(...k);
      }), this.observers["*"] && Array.from(this.observers["*"].entries()).forEach((E) => {
        let [q, L] = E;
        for (let U = 0; U < L; U++)
          q.apply(q, [h, ...k]);
      });
    }
  }
  class de extends se {
    constructor(h) {
      let g = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
        ns: ["translation"],
        defaultNS: "translation"
      };
      super(), this.data = h || {}, this.options = g, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.options.ignoreJSONStructure === void 0 && (this.options.ignoreJSONStructure = !0);
    }
    addNamespaces(h) {
      this.options.ns.indexOf(h) < 0 && this.options.ns.push(h);
    }
    removeNamespaces(h) {
      const g = this.options.ns.indexOf(h);
      g > -1 && this.options.ns.splice(g, 1);
    }
    getResource(h, g, k) {
      var U, Y;
      let S = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
      const z = S.keySeparator !== void 0 ? S.keySeparator : this.options.keySeparator, E = S.ignoreJSONStructure !== void 0 ? S.ignoreJSONStructure : this.options.ignoreJSONStructure;
      let q;
      h.indexOf(".") > -1 ? q = h.split(".") : (q = [h, g], k && (Array.isArray(k) ? q.push(...k) : e(k) && z ? q.push(...k.split(z)) : q.push(k)));
      const L = u(this.data, q);
      return !L && !g && !k && h.indexOf(".") > -1 && (h = q[0], g = q[1], k = q.slice(2).join(".")), L || !E || !e(k) ? L : ce((Y = (U = this.data) == null ? void 0 : U[h]) == null ? void 0 : Y[g], k, z);
    }
    addResource(h, g, k, S) {
      let z = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {
        silent: !1
      };
      const E = z.keySeparator !== void 0 ? z.keySeparator : this.options.keySeparator;
      let q = [h, g];
      k && (q = q.concat(E ? k.split(E) : k)), h.indexOf(".") > -1 && (q = h.split("."), S = g, g = q[1]), this.addNamespaces(g), s(this.data, q, S), z.silent || this.emit("added", h, g, k, S);
    }
    addResources(h, g, k) {
      let S = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {
        silent: !1
      };
      for (const z in k)
        (e(k[z]) || Array.isArray(k[z])) && this.addResource(h, g, z, k[z], {
          silent: !0
        });
      S.silent || this.emit("added", h, g, k);
    }
    addResourceBundle(h, g, k, S, z) {
      let E = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {
        silent: !1,
        skipCopy: !1
      }, q = [h, g];
      h.indexOf(".") > -1 && (q = h.split("."), S = k, k = g, g = q[1]), this.addNamespaces(g);
      let L = u(this.data, q) || {};
      E.skipCopy || (k = JSON.parse(JSON.stringify(k))), S ? n(L, k, z) : L = {
        ...L,
        ...k
      }, s(this.data, q, L), E.silent || this.emit("added", h, g, k);
    }
    removeResourceBundle(h, g) {
      this.hasResourceBundle(h, g) && delete this.data[h][g], this.removeNamespaces(g), this.emit("removed", h, g);
    }
    hasResourceBundle(h, g) {
      return this.getResource(h, g) !== void 0;
    }
    getResourceBundle(h, g) {
      return g || (g = this.options.defaultNS), this.getResource(h, g);
    }
    getDataByLanguage(h) {
      return this.data[h];
    }
    hasLanguageSomeTranslations(h) {
      const g = this.getDataByLanguage(h);
      return !!(g && Object.keys(g) || []).find((S) => g[S] && Object.keys(g[S]).length > 0);
    }
    toJSON() {
      return this.data;
    }
  }
  var he = {
    processors: {},
    addPostProcessor(j) {
      this.processors[j.name] = j;
    },
    handle(j, h, g, k, S) {
      return j.forEach((z) => {
        var E;
        h = ((E = this.processors[z]) == null ? void 0 : E.process(h, g, k, S)) ?? h;
      }), h;
    }
  };
  const be = {}, b = (j) => !e(j) && typeof j != "boolean" && typeof j != "number";
  class y extends se {
    constructor(h) {
      let g = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      super(), a(["resourceStore", "languageUtils", "pluralResolver", "interpolator", "backendConnector", "i18nFormat", "utils"], h, this), this.options = g, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.logger = V.create("translator");
    }
    changeLanguage(h) {
      h && (this.language = h);
    }
    exists(h) {
      let g = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
        interpolation: {}
      };
      if (h == null)
        return !1;
      const k = this.resolve(h, g);
      return (k == null ? void 0 : k.res) !== void 0;
    }
    extractFromKey(h, g) {
      let k = g.nsSeparator !== void 0 ? g.nsSeparator : this.options.nsSeparator;
      k === void 0 && (k = ":");
      const S = g.keySeparator !== void 0 ? g.keySeparator : this.options.keySeparator;
      let z = g.ns || this.options.defaultNS || [];
      const E = k && h.indexOf(k) > -1, q = !this.options.userDefinedKeySeparator && !g.keySeparator && !this.options.userDefinedNsSeparator && !g.nsSeparator && !ne(h, k, S);
      if (E && !q) {
        const L = h.match(this.interpolator.nestingRegexp);
        if (L && L.length > 0)
          return {
            key: h,
            namespaces: e(z) ? [z] : z
          };
        const U = h.split(k);
        (k !== S || k === S && this.options.ns.indexOf(U[0]) > -1) && (z = U.shift()), h = U.join(S);
      }
      return {
        key: h,
        namespaces: e(z) ? [z] : z
      };
    }
    translate(h, g, k) {
      if (typeof g != "object" && this.options.overloadTranslationOptionHandler && (g = this.options.overloadTranslationOptionHandler(arguments)), typeof options == "object" && (g = {
        ...g
      }), g || (g = {}), h == null) return "";
      Array.isArray(h) || (h = [String(h)]);
      const S = g.returnDetails !== void 0 ? g.returnDetails : this.options.returnDetails, z = g.keySeparator !== void 0 ? g.keySeparator : this.options.keySeparator, {
        key: E,
        namespaces: q
      } = this.extractFromKey(h[h.length - 1], g), L = q[q.length - 1], U = g.lng || this.language, Y = g.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
      if ((U == null ? void 0 : U.toLowerCase()) === "cimode") {
        if (Y) {
          const qe = g.nsSeparator || this.options.nsSeparator;
          return S ? {
            res: `${L}${qe}${E}`,
            usedKey: E,
            exactUsedKey: E,
            usedLng: U,
            usedNS: L,
            usedParams: this.getUsedParamsDetails(g)
          } : `${L}${qe}${E}`;
        }
        return S ? {
          res: E,
          usedKey: E,
          exactUsedKey: E,
          usedLng: U,
          usedNS: L,
          usedParams: this.getUsedParamsDetails(g)
        } : E;
      }
      const ee = this.resolve(h, g);
      let J = ee == null ? void 0 : ee.res;
      const ke = (ee == null ? void 0 : ee.usedKey) || E, me = (ee == null ? void 0 : ee.exactUsedKey) || E, _e = ["[object Number]", "[object Function]", "[object RegExp]"], Pe = g.joinArrays !== void 0 ? g.joinArrays : this.options.joinArrays, Ee = !this.i18nFormat || this.i18nFormat.handleAsObject, Re = g.count !== void 0 && !e(g.count), en = y.hasDefaultValue(g), Le = Re ? this.pluralResolver.getSuffix(U, g.count, g) : "", rn = g.ordinal && Re ? this.pluralResolver.getSuffix(U, g.count, {
        ordinal: !1
      }) : "", on = Re && !g.ordinal && g.count === 0, Ie = on && g[`defaultValue${this.options.pluralSeparator}zero`] || g[`defaultValue${Le}`] || g[`defaultValue${rn}`] || g.defaultValue;
      let xe = J;
      Ee && !J && en && (xe = Ie);
      const ln = b(xe), cn = Object.prototype.toString.apply(xe);
      if (Ee && xe && ln && _e.indexOf(cn) < 0 && !(e(Pe) && Array.isArray(xe))) {
        if (!g.returnObjects && !this.options.returnObjects) {
          this.options.returnedObjectHandler || this.logger.warn("accessing an object - but returnObjects options is not enabled!");
          const qe = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(ke, xe, {
            ...g,
            ns: q
          }) : `key '${E} (${this.language})' returned an object instead of string.`;
          return S ? (ee.res = qe, ee.usedParams = this.getUsedParamsDetails(g), ee) : qe;
        }
        if (z) {
          const qe = Array.isArray(xe), He = qe ? [] : {}, Nn = qe ? me : ke;
          for (const Ze in xe)
            if (Object.prototype.hasOwnProperty.call(xe, Ze)) {
              const Fe = `${Nn}${z}${Ze}`;
              en && !J ? He[Ze] = this.translate(Fe, {
                ...g,
                defaultValue: b(Ie) ? Ie[Ze] : void 0,
                joinArrays: !1,
                ns: q
              }) : He[Ze] = this.translate(Fe, {
                ...g,
                joinArrays: !1,
                ns: q
              }), He[Ze] === Fe && (He[Ze] = xe[Ze]);
            }
          J = He;
        }
      } else if (Ee && e(Pe) && Array.isArray(J))
        J = J.join(Pe), J && (J = this.extendTranslation(J, h, g, k));
      else {
        let qe = !1, He = !1;
        !this.isValidLookup(J) && en && (qe = !0, J = Ie), this.isValidLookup(J) || (He = !0, J = E);
        const Ze = (g.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey) && He ? void 0 : J, Fe = en && Ie !== J && this.options.updateMissing;
        if (He || qe || Fe) {
          if (this.logger.log(Fe ? "updateKey" : "missingKey", U, L, E, Fe ? Ie : J), z) {
            const Ae = this.resolve(E, {
              ...g,
              keySeparator: !1
            });
            Ae && Ae.res && this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
          }
          let yn = [];
          const kn = this.languageUtils.getFallbackCodes(this.options.fallbackLng, g.lng || this.language);
          if (this.options.saveMissingTo === "fallback" && kn && kn[0])
            for (let Ae = 0; Ae < kn.length; Ae++)
              yn.push(kn[Ae]);
          else this.options.saveMissingTo === "all" ? yn = this.languageUtils.toResolveHierarchy(g.lng || this.language) : yn.push(g.lng || this.language);
          const xn = (Ae, mn, hn) => {
            var Fn;
            const zn = en && hn !== J ? hn : Ze;
            this.options.missingKeyHandler ? this.options.missingKeyHandler(Ae, L, mn, zn, Fe, g) : (Fn = this.backendConnector) != null && Fn.saveMissing && this.backendConnector.saveMissing(Ae, L, mn, zn, Fe, g), this.emit("missingKey", Ae, L, mn, J);
          };
          this.options.saveMissing && (this.options.saveMissingPlurals && Re ? yn.forEach((Ae) => {
            const mn = this.pluralResolver.getSuffixes(Ae, g);
            on && g[`defaultValue${this.options.pluralSeparator}zero`] && mn.indexOf(`${this.options.pluralSeparator}zero`) < 0 && mn.push(`${this.options.pluralSeparator}zero`), mn.forEach((hn) => {
              xn([Ae], E + hn, g[`defaultValue${hn}`] || Ie);
            });
          }) : xn(yn, E, Ie));
        }
        J = this.extendTranslation(J, h, g, ee, k), He && J === E && this.options.appendNamespaceToMissingKey && (J = `${L}:${E}`), (He || qe) && this.options.parseMissingKeyHandler && (J = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${L}:${E}` : E, qe ? J : void 0));
      }
      return S ? (ee.res = J, ee.usedParams = this.getUsedParamsDetails(g), ee) : J;
    }
    extendTranslation(h, g, k, S, z) {
      var U, Y;
      var E = this;
      if ((U = this.i18nFormat) != null && U.parse)
        h = this.i18nFormat.parse(h, {
          ...this.options.interpolation.defaultVariables,
          ...k
        }, k.lng || this.language || S.usedLng, S.usedNS, S.usedKey, {
          resolved: S
        });
      else if (!k.skipInterpolation) {
        k.interpolation && this.interpolator.init({
          ...k,
          interpolation: {
            ...this.options.interpolation,
            ...k.interpolation
          }
        });
        const ee = e(h) && (((Y = k == null ? void 0 : k.interpolation) == null ? void 0 : Y.skipOnVariables) !== void 0 ? k.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
        let J;
        if (ee) {
          const me = h.match(this.interpolator.nestingRegexp);
          J = me && me.length;
        }
        let ke = k.replace && !e(k.replace) ? k.replace : k;
        if (this.options.interpolation.defaultVariables && (ke = {
          ...this.options.interpolation.defaultVariables,
          ...ke
        }), h = this.interpolator.interpolate(h, ke, k.lng || this.language || S.usedLng, k), ee) {
          const me = h.match(this.interpolator.nestingRegexp), _e = me && me.length;
          J < _e && (k.nest = !1);
        }
        !k.lng && S && S.res && (k.lng = this.language || S.usedLng), k.nest !== !1 && (h = this.interpolator.nest(h, function() {
          for (var me = arguments.length, _e = new Array(me), Pe = 0; Pe < me; Pe++)
            _e[Pe] = arguments[Pe];
          return (z == null ? void 0 : z[0]) === _e[0] && !k.context ? (E.logger.warn(`It seems you are nesting recursively key: ${_e[0]} in key: ${g[0]}`), null) : E.translate(..._e, g);
        }, k)), k.interpolation && this.interpolator.reset();
      }
      const q = k.postProcess || this.options.postProcess, L = e(q) ? [q] : q;
      return h != null && (L != null && L.length) && k.applyPostProcessor !== !1 && (h = he.handle(L, h, g, this.options && this.options.postProcessPassResolved ? {
        i18nResolved: {
          ...S,
          usedParams: this.getUsedParamsDetails(k)
        },
        ...k
      } : k, this)), h;
    }
    resolve(h) {
      let g = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, k, S, z, E, q;
      return e(h) && (h = [h]), h.forEach((L) => {
        if (this.isValidLookup(k)) return;
        const U = this.extractFromKey(L, g), Y = U.key;
        S = Y;
        let ee = U.namespaces;
        this.options.fallbackNS && (ee = ee.concat(this.options.fallbackNS));
        const J = g.count !== void 0 && !e(g.count), ke = J && !g.ordinal && g.count === 0, me = g.context !== void 0 && (e(g.context) || typeof g.context == "number") && g.context !== "", _e = g.lngs ? g.lngs : this.languageUtils.toResolveHierarchy(g.lng || this.language, g.fallbackLng);
        ee.forEach((Pe) => {
          var Ee, Re;
          this.isValidLookup(k) || (q = Pe, !be[`${_e[0]}-${Pe}`] && ((Ee = this.utils) != null && Ee.hasLoadedNamespace) && !((Re = this.utils) != null && Re.hasLoadedNamespace(q)) && (be[`${_e[0]}-${Pe}`] = !0, this.logger.warn(`key "${S}" for languages "${_e.join(", ")}" won't get resolved as namespace "${q}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!")), _e.forEach((en) => {
            var on;
            if (this.isValidLookup(k)) return;
            E = en;
            const Le = [Y];
            if ((on = this.i18nFormat) != null && on.addLookupKeys)
              this.i18nFormat.addLookupKeys(Le, Y, en, Pe, g);
            else {
              let Ie;
              J && (Ie = this.pluralResolver.getSuffix(en, g.count, g));
              const xe = `${this.options.pluralSeparator}zero`, ln = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
              if (J && (Le.push(Y + Ie), g.ordinal && Ie.indexOf(ln) === 0 && Le.push(Y + Ie.replace(ln, this.options.pluralSeparator)), ke && Le.push(Y + xe)), me) {
                const cn = `${Y}${this.options.contextSeparator}${g.context}`;
                Le.push(cn), J && (Le.push(cn + Ie), g.ordinal && Ie.indexOf(ln) === 0 && Le.push(cn + Ie.replace(ln, this.options.pluralSeparator)), ke && Le.push(cn + xe));
              }
            }
            let rn;
            for (; rn = Le.pop(); )
              this.isValidLookup(k) || (z = rn, k = this.getResource(en, Pe, rn, g));
          }));
        });
      }), {
        res: k,
        usedKey: S,
        exactUsedKey: z,
        usedLng: E,
        usedNS: q
      };
    }
    isValidLookup(h) {
      return h !== void 0 && !(!this.options.returnNull && h === null) && !(!this.options.returnEmptyString && h === "");
    }
    getResource(h, g, k) {
      var z;
      let S = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
      return (z = this.i18nFormat) != null && z.getResource ? this.i18nFormat.getResource(h, g, k, S) : this.resourceStore.getResource(h, g, k, S);
    }
    getUsedParamsDetails() {
      let h = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      const g = ["defaultValue", "ordinal", "context", "replace", "lng", "lngs", "fallbackLng", "ns", "keySeparator", "nsSeparator", "returnObjects", "returnDetails", "joinArrays", "postProcess", "interpolation"], k = h.replace && !e(h.replace);
      let S = k ? h.replace : h;
      if (k && typeof h.count < "u" && (S.count = h.count), this.options.interpolation.defaultVariables && (S = {
        ...this.options.interpolation.defaultVariables,
        ...S
      }), !k) {
        S = {
          ...S
        };
        for (const z of g)
          delete S[z];
      }
      return S;
    }
    static hasDefaultValue(h) {
      const g = "defaultValue";
      for (const k in h)
        if (Object.prototype.hasOwnProperty.call(h, k) && g === k.substring(0, g.length) && h[k] !== void 0)
          return !0;
      return !1;
    }
  }
  class _ {
    constructor(h) {
      this.options = h, this.supportedLngs = this.options.supportedLngs || !1, this.logger = V.create("languageUtils");
    }
    getScriptPartFromCode(h) {
      if (h = Q(h), !h || h.indexOf("-") < 0) return null;
      const g = h.split("-");
      return g.length === 2 || (g.pop(), g[g.length - 1].toLowerCase() === "x") ? null : this.formatLanguageCode(g.join("-"));
    }
    getLanguagePartFromCode(h) {
      if (h = Q(h), !h || h.indexOf("-") < 0) return h;
      const g = h.split("-");
      return this.formatLanguageCode(g[0]);
    }
    formatLanguageCode(h) {
      if (e(h) && h.indexOf("-") > -1) {
        let g;
        try {
          g = Intl.getCanonicalLocales(h)[0];
        } catch {
        }
        return g && this.options.lowerCaseLng && (g = g.toLowerCase()), g || (this.options.lowerCaseLng ? h.toLowerCase() : h);
      }
      return this.options.cleanCode || this.options.lowerCaseLng ? h.toLowerCase() : h;
    }
    isSupportedCode(h) {
      return (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) && (h = this.getLanguagePartFromCode(h)), !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(h) > -1;
    }
    getBestMatchFromCodes(h) {
      if (!h) return null;
      let g;
      return h.forEach((k) => {
        if (g) return;
        const S = this.formatLanguageCode(k);
        (!this.options.supportedLngs || this.isSupportedCode(S)) && (g = S);
      }), !g && this.options.supportedLngs && h.forEach((k) => {
        if (g) return;
        const S = this.getScriptPartFromCode(k);
        if (this.isSupportedCode(S)) return g = S;
        const z = this.getLanguagePartFromCode(k);
        if (this.isSupportedCode(z)) return g = z;
        g = this.options.supportedLngs.find((E) => {
          if (E === z) return E;
          if (!(E.indexOf("-") < 0 && z.indexOf("-") < 0) && (E.indexOf("-") > 0 && z.indexOf("-") < 0 && E.substring(0, E.indexOf("-")) === z || E.indexOf(z) === 0 && z.length > 1))
            return E;
        });
      }), g || (g = this.getFallbackCodes(this.options.fallbackLng)[0]), g;
    }
    getFallbackCodes(h, g) {
      if (!h) return [];
      if (typeof h == "function" && (h = h(g)), e(h) && (h = [h]), Array.isArray(h)) return h;
      if (!g) return h.default || [];
      let k = h[g];
      return k || (k = h[this.getScriptPartFromCode(g)]), k || (k = h[this.formatLanguageCode(g)]), k || (k = h[this.getLanguagePartFromCode(g)]), k || (k = h.default), k || [];
    }
    toResolveHierarchy(h, g) {
      const k = this.getFallbackCodes(g || this.options.fallbackLng || [], h), S = [], z = (E) => {
        E && (this.isSupportedCode(E) ? S.push(E) : this.logger.warn(`rejecting language code not found in supportedLngs: ${E}`));
      };
      return e(h) && (h.indexOf("-") > -1 || h.indexOf("_") > -1) ? (this.options.load !== "languageOnly" && z(this.formatLanguageCode(h)), this.options.load !== "languageOnly" && this.options.load !== "currentOnly" && z(this.getScriptPartFromCode(h)), this.options.load !== "currentOnly" && z(this.getLanguagePartFromCode(h))) : e(h) && z(this.formatLanguageCode(h)), k.forEach((E) => {
        S.indexOf(E) < 0 && z(this.formatLanguageCode(E));
      }), S;
    }
  }
  const R = {
    zero: 0,
    one: 1,
    two: 2,
    few: 3,
    many: 4,
    other: 5
  }, W = {
    select: (j) => j === 1 ? "one" : "other",
    resolvedOptions: () => ({
      pluralCategories: ["one", "other"]
    })
  };
  class X {
    constructor(h) {
      let g = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      this.languageUtils = h, this.options = g, this.logger = V.create("pluralResolver"), this.pluralRulesCache = {};
    }
    addRule(h, g) {
      this.rules[h] = g;
    }
    clearCache() {
      this.pluralRulesCache = {};
    }
    getRule(h) {
      let g = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      const k = Q(h === "dev" ? "en" : h), S = g.ordinal ? "ordinal" : "cardinal", z = JSON.stringify({
        cleanedCode: k,
        type: S
      });
      if (z in this.pluralRulesCache)
        return this.pluralRulesCache[z];
      let E;
      try {
        E = new Intl.PluralRules(k, {
          type: S
        });
      } catch {
        if (!Intl)
          return this.logger.error("No Intl support, please use an Intl polyfill!"), W;
        if (!h.match(/-|_/)) return W;
        const L = this.languageUtils.getLanguagePartFromCode(h);
        E = this.getRule(L, g);
      }
      return this.pluralRulesCache[z] = E, E;
    }
    needsPlural(h) {
      let g = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, k = this.getRule(h, g);
      return k || (k = this.getRule("dev", g)), (k == null ? void 0 : k.resolvedOptions().pluralCategories.length) > 1;
    }
    getPluralFormsOfKey(h, g) {
      let k = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      return this.getSuffixes(h, k).map((S) => `${g}${S}`);
    }
    getSuffixes(h) {
      let g = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, k = this.getRule(h, g);
      return k || (k = this.getRule("dev", g)), k ? k.resolvedOptions().pluralCategories.sort((S, z) => R[S] - R[z]).map((S) => `${this.options.prepend}${g.ordinal ? `ordinal${this.options.prepend}` : ""}${S}`) : [];
    }
    getSuffix(h, g) {
      let k = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      const S = this.getRule(h, k);
      return S ? `${this.options.prepend}${k.ordinal ? `ordinal${this.options.prepend}` : ""}${S.select(g)}` : (this.logger.warn(`no plural rule found for: ${h}`), this.getSuffix("dev", g, k));
    }
  }
  const G = function(j, h, g) {
    let k = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : ".", S = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !0, z = l(j, h, g);
    return !z && S && e(g) && (z = ce(j, g, k), z === void 0 && (z = ce(h, g, k))), z;
  }, re = (j) => j.replace(/\$/g, "$$$$");
  class oe {
    constructor() {
      var g;
      let h = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      this.logger = V.create("interpolator"), this.options = h, this.format = ((g = h == null ? void 0 : h.interpolation) == null ? void 0 : g.format) || ((k) => k), this.init(h);
    }
    init() {
      let h = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      h.interpolation || (h.interpolation = {
        escapeValue: !0
      });
      const {
        escape: g,
        escapeValue: k,
        useRawValueToEscape: S,
        prefix: z,
        prefixEscaped: E,
        suffix: q,
        suffixEscaped: L,
        formatSeparator: U,
        unescapeSuffix: Y,
        unescapePrefix: ee,
        nestingPrefix: J,
        nestingPrefixEscaped: ke,
        nestingSuffix: me,
        nestingSuffixEscaped: _e,
        nestingOptionsSeparator: Pe,
        maxReplaces: Ee,
        alwaysFormat: Re
      } = h.interpolation;
      this.escape = g !== void 0 ? g : D, this.escapeValue = k !== void 0 ? k : !0, this.useRawValueToEscape = S !== void 0 ? S : !1, this.prefix = z ? f(z) : E || "{{", this.suffix = q ? f(q) : L || "}}", this.formatSeparator = U || ",", this.unescapePrefix = Y ? "" : ee || "-", this.unescapeSuffix = this.unescapePrefix ? "" : Y || "", this.nestingPrefix = J ? f(J) : ke || f("$t("), this.nestingSuffix = me ? f(me) : _e || f(")"), this.nestingOptionsSeparator = Pe || ",", this.maxReplaces = Ee || 1e3, this.alwaysFormat = Re !== void 0 ? Re : !1, this.resetRegExp();
    }
    reset() {
      this.options && this.init(this.options);
    }
    resetRegExp() {
      const h = (g, k) => (g == null ? void 0 : g.source) === k ? (g.lastIndex = 0, g) : new RegExp(k, "g");
      this.regexp = h(this.regexp, `${this.prefix}(.+?)${this.suffix}`), this.regexpUnescape = h(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`), this.nestingRegexp = h(this.nestingRegexp, `${this.nestingPrefix}(.+?)${this.nestingSuffix}`);
    }
    interpolate(h, g, k, S) {
      var ke;
      let z, E, q;
      const L = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {}, U = (me) => {
        if (me.indexOf(this.formatSeparator) < 0) {
          const Re = G(g, L, me, this.options.keySeparator, this.options.ignoreJSONStructure);
          return this.alwaysFormat ? this.format(Re, void 0, k, {
            ...S,
            ...g,
            interpolationkey: me
          }) : Re;
        }
        const _e = me.split(this.formatSeparator), Pe = _e.shift().trim(), Ee = _e.join(this.formatSeparator).trim();
        return this.format(G(g, L, Pe, this.options.keySeparator, this.options.ignoreJSONStructure), Ee, k, {
          ...S,
          ...g,
          interpolationkey: Pe
        });
      };
      this.resetRegExp();
      const Y = (S == null ? void 0 : S.missingInterpolationHandler) || this.options.missingInterpolationHandler, ee = ((ke = S == null ? void 0 : S.interpolation) == null ? void 0 : ke.skipOnVariables) !== void 0 ? S.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
      return [{
        regex: this.regexpUnescape,
        safeValue: (me) => re(me)
      }, {
        regex: this.regexp,
        safeValue: (me) => this.escapeValue ? re(this.escape(me)) : re(me)
      }].forEach((me) => {
        for (q = 0; z = me.regex.exec(h); ) {
          const _e = z[1].trim();
          if (E = U(_e), E === void 0)
            if (typeof Y == "function") {
              const Ee = Y(h, z, S);
              E = e(Ee) ? Ee : "";
            } else if (S && Object.prototype.hasOwnProperty.call(S, _e))
              E = "";
            else if (ee) {
              E = z[0];
              continue;
            } else
              this.logger.warn(`missed to pass in variable ${_e} for interpolating ${h}`), E = "";
          else !e(E) && !this.useRawValueToEscape && (E = d(E));
          const Pe = me.safeValue(E);
          if (h = h.replace(z[0], Pe), ee ? (me.regex.lastIndex += E.length, me.regex.lastIndex -= z[0].length) : me.regex.lastIndex = 0, q++, q >= this.maxReplaces)
            break;
        }
      }), h;
    }
    nest(h, g) {
      let k = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, S, z, E;
      const q = (L, U) => {
        const Y = this.nestingOptionsSeparator;
        if (L.indexOf(Y) < 0) return L;
        const ee = L.split(new RegExp(`${Y}[ ]*{`));
        let J = `{${ee[1]}`;
        L = ee[0], J = this.interpolate(J, E);
        const ke = J.match(/'/g), me = J.match(/"/g);
        (((ke == null ? void 0 : ke.length) ?? 0) % 2 === 0 && !me || me.length % 2 !== 0) && (J = J.replace(/'/g, '"'));
        try {
          E = JSON.parse(J), U && (E = {
            ...U,
            ...E
          });
        } catch (_e) {
          return this.logger.warn(`failed parsing options string in nesting for key ${L}`, _e), `${L}${Y}${J}`;
        }
        return E.defaultValue && E.defaultValue.indexOf(this.prefix) > -1 && delete E.defaultValue, L;
      };
      for (; S = this.nestingRegexp.exec(h); ) {
        let L = [];
        E = {
          ...k
        }, E = E.replace && !e(E.replace) ? E.replace : E, E.applyPostProcessor = !1, delete E.defaultValue;
        let U = !1;
        if (S[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(S[1])) {
          const Y = S[1].split(this.formatSeparator).map((ee) => ee.trim());
          S[1] = Y.shift(), L = Y, U = !0;
        }
        if (z = g(q.call(this, S[1].trim(), E), E), z && S[0] === h && !e(z)) return z;
        e(z) || (z = d(z)), z || (this.logger.warn(`missed to resolve ${S[1]} for nesting ${h}`), z = ""), U && (z = L.reduce((Y, ee) => this.format(Y, ee, k.lng, {
          ...k,
          interpolationkey: S[1].trim()
        }), z.trim())), h = h.replace(S[0], z), this.regexp.lastIndex = 0;
      }
      return h;
    }
  }
  const fe = (j) => {
    let h = j.toLowerCase().trim();
    const g = {};
    if (j.indexOf("(") > -1) {
      const k = j.split("(");
      h = k[0].toLowerCase().trim();
      const S = k[1].substring(0, k[1].length - 1);
      h === "currency" && S.indexOf(":") < 0 ? g.currency || (g.currency = S.trim()) : h === "relativetime" && S.indexOf(":") < 0 ? g.range || (g.range = S.trim()) : S.split(";").forEach((E) => {
        if (E) {
          const [q, ...L] = E.split(":"), U = L.join(":").trim().replace(/^'+|'+$/g, ""), Y = q.trim();
          g[Y] || (g[Y] = U), U === "false" && (g[Y] = !1), U === "true" && (g[Y] = !0), isNaN(U) || (g[Y] = parseInt(U, 10));
        }
      });
    }
    return {
      formatName: h,
      formatOptions: g
    };
  }, $e = (j) => {
    const h = {};
    return (g, k, S) => {
      let z = S;
      S && S.interpolationkey && S.formatParams && S.formatParams[S.interpolationkey] && S[S.interpolationkey] && (z = {
        ...z,
        [S.interpolationkey]: void 0
      });
      const E = k + JSON.stringify(z);
      let q = h[E];
      return q || (q = j(Q(k), S), h[E] = q), q(g);
    };
  };
  class ye {
    constructor() {
      let h = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      this.logger = V.create("formatter"), this.options = h, this.formats = {
        number: $e((g, k) => {
          const S = new Intl.NumberFormat(g, {
            ...k
          });
          return (z) => S.format(z);
        }),
        currency: $e((g, k) => {
          const S = new Intl.NumberFormat(g, {
            ...k,
            style: "currency"
          });
          return (z) => S.format(z);
        }),
        datetime: $e((g, k) => {
          const S = new Intl.DateTimeFormat(g, {
            ...k
          });
          return (z) => S.format(z);
        }),
        relativetime: $e((g, k) => {
          const S = new Intl.RelativeTimeFormat(g, {
            ...k
          });
          return (z) => S.format(z, k.range || "day");
        }),
        list: $e((g, k) => {
          const S = new Intl.ListFormat(g, {
            ...k
          });
          return (z) => S.format(z);
        })
      }, this.init(h);
    }
    init(h) {
      let g = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
        interpolation: {}
      };
      this.formatSeparator = g.interpolation.formatSeparator || ",";
    }
    add(h, g) {
      this.formats[h.toLowerCase().trim()] = g;
    }
    addCached(h, g) {
      this.formats[h.toLowerCase().trim()] = $e(g);
    }
    format(h, g, k) {
      let S = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
      const z = g.split(this.formatSeparator);
      if (z.length > 1 && z[0].indexOf("(") > 1 && z[0].indexOf(")") < 0 && z.find((q) => q.indexOf(")") > -1)) {
        const q = z.findIndex((L) => L.indexOf(")") > -1);
        z[0] = [z[0], ...z.splice(1, q)].join(this.formatSeparator);
      }
      return z.reduce((q, L) => {
        var ee;
        const {
          formatName: U,
          formatOptions: Y
        } = fe(L);
        if (this.formats[U]) {
          let J = q;
          try {
            const ke = ((ee = S == null ? void 0 : S.formatParams) == null ? void 0 : ee[S.interpolationkey]) || {}, me = ke.locale || ke.lng || S.locale || S.lng || k;
            J = this.formats[U](q, me, {
              ...Y,
              ...S,
              ...ke
            });
          } catch (ke) {
            this.logger.warn(ke);
          }
          return J;
        } else
          this.logger.warn(`there was no format function for ${U}`);
        return q;
      }, h);
    }
  }
  const we = (j, h) => {
    j.pending[h] !== void 0 && (delete j.pending[h], j.pendingCount--);
  };
  class je extends se {
    constructor(h, g, k) {
      var z, E;
      let S = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
      super(), this.backend = h, this.store = g, this.services = k, this.languageUtils = k.languageUtils, this.options = S, this.logger = V.create("backendConnector"), this.waitingReads = [], this.maxParallelReads = S.maxParallelReads || 10, this.readingCalls = 0, this.maxRetries = S.maxRetries >= 0 ? S.maxRetries : 5, this.retryTimeout = S.retryTimeout >= 1 ? S.retryTimeout : 350, this.state = {}, this.queue = [], (E = (z = this.backend) == null ? void 0 : z.init) == null || E.call(z, k, S.backend, S);
    }
    queueLoad(h, g, k, S) {
      const z = {}, E = {}, q = {}, L = {};
      return h.forEach((U) => {
        let Y = !0;
        g.forEach((ee) => {
          const J = `${U}|${ee}`;
          !k.reload && this.store.hasResourceBundle(U, ee) ? this.state[J] = 2 : this.state[J] < 0 || (this.state[J] === 1 ? E[J] === void 0 && (E[J] = !0) : (this.state[J] = 1, Y = !1, E[J] === void 0 && (E[J] = !0), z[J] === void 0 && (z[J] = !0), L[ee] === void 0 && (L[ee] = !0)));
        }), Y || (q[U] = !0);
      }), (Object.keys(z).length || Object.keys(E).length) && this.queue.push({
        pending: E,
        pendingCount: Object.keys(E).length,
        loaded: {},
        errors: [],
        callback: S
      }), {
        toLoad: Object.keys(z),
        pending: Object.keys(E),
        toLoadLanguages: Object.keys(q),
        toLoadNamespaces: Object.keys(L)
      };
    }
    loaded(h, g, k) {
      const S = h.split("|"), z = S[0], E = S[1];
      g && this.emit("failedLoading", z, E, g), !g && k && this.store.addResourceBundle(z, E, k, void 0, void 0, {
        skipCopy: !0
      }), this.state[h] = g ? -1 : 2, g && k && (this.state[h] = 0);
      const q = {};
      this.queue.forEach((L) => {
        r(L.loaded, [z], E), we(L, h), g && L.errors.push(g), L.pendingCount === 0 && !L.done && (Object.keys(L.loaded).forEach((U) => {
          q[U] || (q[U] = {});
          const Y = L.loaded[U];
          Y.length && Y.forEach((ee) => {
            q[U][ee] === void 0 && (q[U][ee] = !0);
          });
        }), L.done = !0, L.errors.length ? L.callback(L.errors) : L.callback());
      }), this.emit("loaded", q), this.queue = this.queue.filter((L) => !L.done);
    }
    read(h, g, k) {
      let S = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, z = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : this.retryTimeout, E = arguments.length > 5 ? arguments[5] : void 0;
      if (!h.length) return E(null, {});
      if (this.readingCalls >= this.maxParallelReads) {
        this.waitingReads.push({
          lng: h,
          ns: g,
          fcName: k,
          tried: S,
          wait: z,
          callback: E
        });
        return;
      }
      this.readingCalls++;
      const q = (U, Y) => {
        if (this.readingCalls--, this.waitingReads.length > 0) {
          const ee = this.waitingReads.shift();
          this.read(ee.lng, ee.ns, ee.fcName, ee.tried, ee.wait, ee.callback);
        }
        if (U && Y && S < this.maxRetries) {
          setTimeout(() => {
            this.read.call(this, h, g, k, S + 1, z * 2, E);
          }, z);
          return;
        }
        E(U, Y);
      }, L = this.backend[k].bind(this.backend);
      if (L.length === 2) {
        try {
          const U = L(h, g);
          U && typeof U.then == "function" ? U.then((Y) => q(null, Y)).catch(q) : q(null, U);
        } catch (U) {
          q(U);
        }
        return;
      }
      return L(h, g, q);
    }
    prepareLoading(h, g) {
      let k = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, S = arguments.length > 3 ? arguments[3] : void 0;
      if (!this.backend)
        return this.logger.warn("No backend was added via i18next.use. Will not load resources."), S && S();
      e(h) && (h = this.languageUtils.toResolveHierarchy(h)), e(g) && (g = [g]);
      const z = this.queueLoad(h, g, k, S);
      if (!z.toLoad.length)
        return z.pending.length || S(), null;
      z.toLoad.forEach((E) => {
        this.loadOne(E);
      });
    }
    load(h, g, k) {
      this.prepareLoading(h, g, {}, k);
    }
    reload(h, g, k) {
      this.prepareLoading(h, g, {
        reload: !0
      }, k);
    }
    loadOne(h) {
      let g = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
      const k = h.split("|"), S = k[0], z = k[1];
      this.read(S, z, "read", void 0, void 0, (E, q) => {
        E && this.logger.warn(`${g}loading namespace ${z} for language ${S} failed`, E), !E && q && this.logger.log(`${g}loaded namespace ${z} for language ${S}`, q), this.loaded(h, E, q);
      });
    }
    saveMissing(h, g, k, S, z) {
      var L, U, Y, ee, J;
      let E = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {}, q = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : () => {
      };
      if ((U = (L = this.services) == null ? void 0 : L.utils) != null && U.hasLoadedNamespace && !((ee = (Y = this.services) == null ? void 0 : Y.utils) != null && ee.hasLoadedNamespace(g))) {
        this.logger.warn(`did not save key "${k}" as the namespace "${g}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
        return;
      }
      if (!(k == null || k === "")) {
        if ((J = this.backend) != null && J.create) {
          const ke = {
            ...E,
            isUpdate: z
          }, me = this.backend.create.bind(this.backend);
          if (me.length < 6)
            try {
              let _e;
              me.length === 5 ? _e = me(h, g, k, S, ke) : _e = me(h, g, k, S), _e && typeof _e.then == "function" ? _e.then((Pe) => q(null, Pe)).catch(q) : q(null, _e);
            } catch (_e) {
              q(_e);
            }
          else
            me(h, g, k, S, q, ke);
        }
        !h || !h[0] || this.store.addResource(h[0], g, k, S);
      }
    }
  }
  const Oe = () => ({
    debug: !1,
    initAsync: !0,
    ns: ["translation"],
    defaultNS: ["translation"],
    fallbackLng: ["dev"],
    fallbackNS: !1,
    supportedLngs: !1,
    nonExplicitSupportedLngs: !1,
    load: "all",
    preload: !1,
    simplifyPluralSuffix: !0,
    keySeparator: ".",
    nsSeparator: ":",
    pluralSeparator: "_",
    contextSeparator: "_",
    partialBundledLanguages: !1,
    saveMissing: !1,
    updateMissing: !1,
    saveMissingTo: "fallback",
    saveMissingPlurals: !0,
    missingKeyHandler: !1,
    missingInterpolationHandler: !1,
    postProcess: !1,
    postProcessPassResolved: !1,
    returnNull: !1,
    returnEmptyString: !0,
    returnObjects: !1,
    joinArrays: !1,
    returnedObjectHandler: !1,
    parseMissingKeyHandler: !1,
    appendNamespaceToMissingKey: !1,
    appendNamespaceToCIMode: !1,
    overloadTranslationOptionHandler: (j) => {
      let h = {};
      if (typeof j[1] == "object" && (h = j[1]), e(j[1]) && (h.defaultValue = j[1]), e(j[2]) && (h.tDescription = j[2]), typeof j[2] == "object" || typeof j[3] == "object") {
        const g = j[3] || j[2];
        Object.keys(g).forEach((k) => {
          h[k] = g[k];
        });
      }
      return h;
    },
    interpolation: {
      escapeValue: !0,
      format: (j) => j,
      prefix: "{{",
      suffix: "}}",
      formatSeparator: ",",
      unescapePrefix: "-",
      nestingPrefix: "$t(",
      nestingSuffix: ")",
      nestingOptionsSeparator: ",",
      maxReplaces: 1e3,
      skipOnVariables: !0
    }
  }), De = (j) => {
    var h, g;
    return e(j.ns) && (j.ns = [j.ns]), e(j.fallbackLng) && (j.fallbackLng = [j.fallbackLng]), e(j.fallbackNS) && (j.fallbackNS = [j.fallbackNS]), ((g = (h = j.supportedLngs) == null ? void 0 : h.indexOf) == null ? void 0 : g.call(h, "cimode")) < 0 && (j.supportedLngs = j.supportedLngs.concat(["cimode"])), typeof j.initImmediate == "boolean" && (j.initAsync = j.initImmediate), j;
  }, Qe = () => {
  }, an = (j) => {
    Object.getOwnPropertyNames(Object.getPrototypeOf(j)).forEach((g) => {
      typeof j[g] == "function" && (j[g] = j[g].bind(j));
    });
  };
  class We extends se {
    constructor() {
      let h = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, g = arguments.length > 1 ? arguments[1] : void 0;
      if (super(), this.options = De(h), this.services = {}, this.logger = V, this.modules = {
        external: []
      }, an(this), g && !this.isInitialized && !h.isClone) {
        if (!this.options.initAsync)
          return this.init(h, g), this;
        setTimeout(() => {
          this.init(h, g);
        }, 0);
      }
    }
    init() {
      var h = this;
      let g = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, k = arguments.length > 1 ? arguments[1] : void 0;
      this.isInitializing = !0, typeof g == "function" && (k = g, g = {}), g.defaultNS == null && g.ns && (e(g.ns) ? g.defaultNS = g.ns : g.ns.indexOf("translation") < 0 && (g.defaultNS = g.ns[0]));
      const S = Oe();
      this.options = {
        ...S,
        ...this.options,
        ...De(g)
      }, this.options.interpolation = {
        ...S.interpolation,
        ...this.options.interpolation
      }, g.keySeparator !== void 0 && (this.options.userDefinedKeySeparator = g.keySeparator), g.nsSeparator !== void 0 && (this.options.userDefinedNsSeparator = g.nsSeparator);
      const z = (Y) => Y ? typeof Y == "function" ? new Y() : Y : null;
      if (!this.options.isClone) {
        this.modules.logger ? V.init(z(this.modules.logger), this.options) : V.init(null, this.options);
        let Y;
        this.modules.formatter ? Y = this.modules.formatter : Y = ye;
        const ee = new _(this.options);
        this.store = new de(this.options.resources, this.options);
        const J = this.services;
        J.logger = V, J.resourceStore = this.store, J.languageUtils = ee, J.pluralResolver = new X(ee, {
          prepend: this.options.pluralSeparator,
          simplifyPluralSuffix: this.options.simplifyPluralSuffix
        }), Y && (!this.options.interpolation.format || this.options.interpolation.format === S.interpolation.format) && (J.formatter = z(Y), J.formatter.init(J, this.options), this.options.interpolation.format = J.formatter.format.bind(J.formatter)), J.interpolator = new oe(this.options), J.utils = {
          hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
        }, J.backendConnector = new je(z(this.modules.backend), J.resourceStore, J, this.options), J.backendConnector.on("*", function(ke) {
          for (var me = arguments.length, _e = new Array(me > 1 ? me - 1 : 0), Pe = 1; Pe < me; Pe++)
            _e[Pe - 1] = arguments[Pe];
          h.emit(ke, ..._e);
        }), this.modules.languageDetector && (J.languageDetector = z(this.modules.languageDetector), J.languageDetector.init && J.languageDetector.init(J, this.options.detection, this.options)), this.modules.i18nFormat && (J.i18nFormat = z(this.modules.i18nFormat), J.i18nFormat.init && J.i18nFormat.init(this)), this.translator = new y(this.services, this.options), this.translator.on("*", function(ke) {
          for (var me = arguments.length, _e = new Array(me > 1 ? me - 1 : 0), Pe = 1; Pe < me; Pe++)
            _e[Pe - 1] = arguments[Pe];
          h.emit(ke, ..._e);
        }), this.modules.external.forEach((ke) => {
          ke.init && ke.init(this);
        });
      }
      if (this.format = this.options.interpolation.format, k || (k = Qe), this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
        const Y = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
        Y.length > 0 && Y[0] !== "dev" && (this.options.lng = Y[0]);
      }
      !this.services.languageDetector && !this.options.lng && this.logger.warn("init: no languageDetector is used and no lng is defined"), ["getResource", "hasResourceBundle", "getResourceBundle", "getDataByLanguage"].forEach((Y) => {
        this[Y] = function() {
          return h.store[Y](...arguments);
        };
      }), ["addResource", "addResources", "addResourceBundle", "removeResourceBundle"].forEach((Y) => {
        this[Y] = function() {
          return h.store[Y](...arguments), h;
        };
      });
      const L = i(), U = () => {
        const Y = (ee, J) => {
          this.isInitializing = !1, this.isInitialized && !this.initializedStoreOnce && this.logger.warn("init: i18next is already initialized. You should call init just once!"), this.isInitialized = !0, this.options.isClone || this.logger.log("initialized", this.options), this.emit("initialized", this.options), L.resolve(J), k(ee, J);
        };
        if (this.languages && !this.isInitialized) return Y(null, this.t.bind(this));
        this.changeLanguage(this.options.lng, Y);
      };
      return this.options.resources || !this.options.initAsync ? U() : setTimeout(U, 0), L;
    }
    loadResources(h) {
      var z, E;
      let k = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Qe;
      const S = e(h) ? h : this.language;
      if (typeof h == "function" && (k = h), !this.options.resources || this.options.partialBundledLanguages) {
        if ((S == null ? void 0 : S.toLowerCase()) === "cimode" && (!this.options.preload || this.options.preload.length === 0)) return k();
        const q = [], L = (U) => {
          if (!U || U === "cimode") return;
          this.services.languageUtils.toResolveHierarchy(U).forEach((ee) => {
            ee !== "cimode" && q.indexOf(ee) < 0 && q.push(ee);
          });
        };
        S ? L(S) : this.services.languageUtils.getFallbackCodes(this.options.fallbackLng).forEach((Y) => L(Y)), (E = (z = this.options.preload) == null ? void 0 : z.forEach) == null || E.call(z, (U) => L(U)), this.services.backendConnector.load(q, this.options.ns, (U) => {
          !U && !this.resolvedLanguage && this.language && this.setResolvedLanguage(this.language), k(U);
        });
      } else
        k(null);
    }
    reloadResources(h, g, k) {
      const S = i();
      return typeof h == "function" && (k = h, h = void 0), typeof g == "function" && (k = g, g = void 0), h || (h = this.languages), g || (g = this.options.ns), k || (k = Qe), this.services.backendConnector.reload(h, g, (z) => {
        S.resolve(), k(z);
      }), S;
    }
    use(h) {
      if (!h) throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
      if (!h.type) throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
      return h.type === "backend" && (this.modules.backend = h), (h.type === "logger" || h.log && h.warn && h.error) && (this.modules.logger = h), h.type === "languageDetector" && (this.modules.languageDetector = h), h.type === "i18nFormat" && (this.modules.i18nFormat = h), h.type === "postProcessor" && he.addPostProcessor(h), h.type === "formatter" && (this.modules.formatter = h), h.type === "3rdParty" && this.modules.external.push(h), this;
    }
    setResolvedLanguage(h) {
      if (!(!h || !this.languages) && !(["cimode", "dev"].indexOf(h) > -1)) {
        for (let g = 0; g < this.languages.length; g++) {
          const k = this.languages[g];
          if (!(["cimode", "dev"].indexOf(k) > -1) && this.store.hasLanguageSomeTranslations(k)) {
            this.resolvedLanguage = k;
            break;
          }
        }
        !this.resolvedLanguage && this.languages.indexOf(h) < 0 && this.store.hasLanguageSomeTranslations(h) && (this.resolvedLanguage = h, this.languages.indexOf(h) < 0 && this.languages.unshift(h));
      }
    }
    changeLanguage(h, g) {
      var k = this;
      this.isLanguageChangingTo = h;
      const S = i();
      this.emit("languageChanging", h);
      const z = (L) => {
        this.language = L, this.languages = this.services.languageUtils.toResolveHierarchy(L), this.resolvedLanguage = void 0, this.setResolvedLanguage(L);
      }, E = (L, U) => {
        U ? this.isLanguageChangingTo === h && (z(U), this.translator.changeLanguage(U), this.isLanguageChangingTo = void 0, this.emit("languageChanged", U), this.logger.log("languageChanged", U)) : this.isLanguageChangingTo = void 0, S.resolve(function() {
          return k.t(...arguments);
        }), g && g(L, function() {
          return k.t(...arguments);
        });
      }, q = (L) => {
        var ee, J;
        !h && !L && this.services.languageDetector && (L = []);
        const U = e(L) ? L : L && L[0], Y = this.store.hasLanguageSomeTranslations(U) ? U : this.services.languageUtils.getBestMatchFromCodes(e(L) ? [L] : L);
        Y && (this.language || z(Y), this.translator.language || this.translator.changeLanguage(Y), (J = (ee = this.services.languageDetector) == null ? void 0 : ee.cacheUserLanguage) == null || J.call(ee, Y)), this.loadResources(Y, (ke) => {
          E(ke, Y);
        });
      };
      return !h && this.services.languageDetector && !this.services.languageDetector.async ? q(this.services.languageDetector.detect()) : !h && this.services.languageDetector && this.services.languageDetector.async ? this.services.languageDetector.detect.length === 0 ? this.services.languageDetector.detect().then(q) : this.services.languageDetector.detect(q) : q(h), S;
    }
    getFixedT(h, g, k) {
      var S = this;
      const z = function(E, q) {
        let L;
        if (typeof q != "object") {
          for (var U = arguments.length, Y = new Array(U > 2 ? U - 2 : 0), ee = 2; ee < U; ee++)
            Y[ee - 2] = arguments[ee];
          L = S.options.overloadTranslationOptionHandler([E, q].concat(Y));
        } else
          L = {
            ...q
          };
        L.lng = L.lng || z.lng, L.lngs = L.lngs || z.lngs, L.ns = L.ns || z.ns, L.keyPrefix !== "" && (L.keyPrefix = L.keyPrefix || k || z.keyPrefix);
        const J = S.options.keySeparator || ".";
        let ke;
        return L.keyPrefix && Array.isArray(E) ? ke = E.map((me) => `${L.keyPrefix}${J}${me}`) : ke = L.keyPrefix ? `${L.keyPrefix}${J}${E}` : E, S.t(ke, L);
      };
      return e(h) ? z.lng = h : z.lngs = h, z.ns = g, z.keyPrefix = k, z;
    }
    t() {
      var S;
      for (var h = arguments.length, g = new Array(h), k = 0; k < h; k++)
        g[k] = arguments[k];
      return (S = this.translator) == null ? void 0 : S.translate(...g);
    }
    exists() {
      var S;
      for (var h = arguments.length, g = new Array(h), k = 0; k < h; k++)
        g[k] = arguments[k];
      return (S = this.translator) == null ? void 0 : S.exists(...g);
    }
    setDefaultNamespace(h) {
      this.options.defaultNS = h;
    }
    hasLoadedNamespace(h) {
      let g = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      if (!this.isInitialized)
        return this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages), !1;
      if (!this.languages || !this.languages.length)
        return this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages), !1;
      const k = g.lng || this.resolvedLanguage || this.languages[0], S = this.options ? this.options.fallbackLng : !1, z = this.languages[this.languages.length - 1];
      if (k.toLowerCase() === "cimode") return !0;
      const E = (q, L) => {
        const U = this.services.backendConnector.state[`${q}|${L}`];
        return U === -1 || U === 0 || U === 2;
      };
      if (g.precheck) {
        const q = g.precheck(this, E);
        if (q !== void 0) return q;
      }
      return !!(this.hasResourceBundle(k, h) || !this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages || E(k, h) && (!S || E(z, h)));
    }
    loadNamespaces(h, g) {
      const k = i();
      return this.options.ns ? (e(h) && (h = [h]), h.forEach((S) => {
        this.options.ns.indexOf(S) < 0 && this.options.ns.push(S);
      }), this.loadResources((S) => {
        k.resolve(), g && g(S);
      }), k) : (g && g(), Promise.resolve());
    }
    loadLanguages(h, g) {
      const k = i();
      e(h) && (h = [h]);
      const S = this.options.preload || [], z = h.filter((E) => S.indexOf(E) < 0 && this.services.languageUtils.isSupportedCode(E));
      return z.length ? (this.options.preload = S.concat(z), this.loadResources((E) => {
        k.resolve(), g && g(E);
      }), k) : (g && g(), Promise.resolve());
    }
    dir(h) {
      var S, z;
      if (h || (h = this.resolvedLanguage || (((S = this.languages) == null ? void 0 : S.length) > 0 ? this.languages[0] : this.language)), !h) return "rtl";
      const g = ["ar", "shu", "sqr", "ssh", "xaa", "yhd", "yud", "aao", "abh", "abv", "acm", "acq", "acw", "acx", "acy", "adf", "ads", "aeb", "aec", "afb", "ajp", "apc", "apd", "arb", "arq", "ars", "ary", "arz", "auz", "avl", "ayh", "ayl", "ayn", "ayp", "bbz", "pga", "he", "iw", "ps", "pbt", "pbu", "pst", "prp", "prd", "ug", "ur", "ydd", "yds", "yih", "ji", "yi", "hbo", "men", "xmn", "fa", "jpr", "peo", "pes", "prs", "dv", "sam", "ckb"], k = ((z = this.services) == null ? void 0 : z.languageUtils) || new _(Oe());
      return g.indexOf(k.getLanguagePartFromCode(h)) > -1 || h.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
    }
    static createInstance() {
      let h = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, g = arguments.length > 1 ? arguments[1] : void 0;
      return new We(h, g);
    }
    cloneInstance() {
      let h = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, g = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Qe;
      const k = h.forkResourceStore;
      k && delete h.forkResourceStore;
      const S = {
        ...this.options,
        ...h,
        isClone: !0
      }, z = new We(S);
      if ((h.debug !== void 0 || h.prefix !== void 0) && (z.logger = z.logger.clone(h)), ["store", "services", "language"].forEach((q) => {
        z[q] = this[q];
      }), z.services = {
        ...this.services
      }, z.services.utils = {
        hasLoadedNamespace: z.hasLoadedNamespace.bind(z)
      }, k) {
        const q = Object.keys(this.store.data).reduce((L, U) => (L[U] = {
          ...this.store.data[U]
        }, Object.keys(L[U]).reduce((Y, ee) => (Y[ee] = {
          ...L[U][ee]
        }, Y), {})), {});
        z.store = new de(q, S), z.services.resourceStore = z.store;
      }
      return z.translator = new y(z.services, S), z.translator.on("*", function(q) {
        for (var L = arguments.length, U = new Array(L > 1 ? L - 1 : 0), Y = 1; Y < L; Y++)
          U[Y - 1] = arguments[Y];
        z.emit(q, ...U);
      }), z.init(S, g), z.translator.options = S, z.translator.backendConnector.services.utils = {
        hasLoadedNamespace: z.hasLoadedNamespace.bind(z)
      }, z;
    }
    toJSON() {
      return {
        options: this.options,
        store: this.store,
        language: this.language,
        languages: this.languages,
        resolvedLanguage: this.resolvedLanguage
      };
    }
  }
  const x = We.createInstance();
  return x.createInstance = We.createInstance, Pa = x, Pa;
}
function vc(e, i) {
  if (!(e instanceof i)) throw new TypeError("Cannot call a class as a function");
}
function ni(e) {
  "@babel/helpers - typeof";
  return ni = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(i) {
    return typeof i;
  } : function(i) {
    return i && typeof Symbol == "function" && i.constructor === Symbol && i !== Symbol.prototype ? "symbol" : typeof i;
  }, ni(e);
}
function hc(e, i) {
  if (ni(e) != "object" || !e) return e;
  var d = e[Symbol.toPrimitive];
  if (d !== void 0) {
    var a = d.call(e, i);
    if (ni(a) != "object") return a;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
function gc(e) {
  var i = hc(e, "string");
  return ni(i) == "symbol" ? i : i + "";
}
function pc(e, i) {
  for (var d = 0; d < i.length; d++) {
    var a = i[d];
    a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, gc(a.key), a);
  }
}
function bc(e, i, d) {
  return i && pc(e.prototype, i), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
var ou = [], yc = ou.forEach, kc = ou.slice;
function wc(e) {
  return yc.call(kc.call(arguments, 1), function(i) {
    if (i)
      for (var d in i)
        e[d] === void 0 && (e[d] = i[d]);
  }), e;
}
function _c(e) {
  return e ? typeof e == "function" ? new e() : e : null;
}
function $c() {
  return {
    handleEmptyResourcesAsFailed: !0,
    cacheHitMode: "none"
    // reloadInterval: typeof window !== 'undefined' ? false : 60 * 60 * 1000
    // refreshExpirationTime: 60 * 60 * 1000
  };
}
function Hr(e, i, d, a) {
  var t = e.read.bind(e);
  if (t.length === 2) {
    try {
      var o = t(i, d);
      o && typeof o.then == "function" ? o.then(function(m) {
        return a(null, m);
      }).catch(a) : a(null, o);
    } catch (m) {
      a(m);
    }
    return;
  }
  t(i, d, a);
}
var su = /* @__PURE__ */ function() {
  function e(i) {
    var d = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    vc(this, e), this.backends = [], this.type = "backend", this.allOptions = a, this.init(i, d);
  }
  return bc(e, [{
    key: "init",
    value: function(d) {
      var a = this, t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      this.services = d, this.options = wc(t, this.options || {}, $c()), this.allOptions = o, this.options.backends && this.options.backends.forEach(function(m, p) {
        a.backends[p] = a.backends[p] || _c(m), a.backends[p].init(d, a.options.backendOptions && a.options.backendOptions[p] || {}, o);
      }), this.services && this.options.reloadInterval && setInterval(function() {
        return a.reload();
      }, this.options.reloadInterval);
    }
  }, {
    key: "read",
    value: function(d, a, t) {
      var o = this, m = this.backends.length, p = function r(u) {
        if (u >= m) return t(new Error("non of the backend loaded data", !0));
        var l = u === m - 1, n = o.options.handleEmptyResourcesAsFailed && !l ? 0 : -1, f = o.backends[u];
        f.read ? Hr(f, d, a, function(v, D, F) {
          if (!v && D && Object.keys(D).length > n) {
            if (t(null, D, u), s(u - 1, D), f.save && o.options.cacheHitMode && ["refresh", "refreshAndUpdateStore"].indexOf(o.options.cacheHitMode) > -1) {
              if (F && o.options.refreshExpirationTime && F + o.options.refreshExpirationTime > Date.now()) return;
              var A = o.backends[u + 1];
              A && A.read && Hr(A, d, a, function(ae, ne) {
                ae || ne && (Object.keys(ne).length <= n || (s(u, ne), o.options.cacheHitMode === "refreshAndUpdateStore" && o.services && o.services.resourceStore && o.services.resourceStore.addResourceBundle(d, a, ne)));
              });
            }
          } else
            r(u + 1);
        }) : r(u + 1);
      }, s = function r(u, l) {
        if (!(u < 0)) {
          var n = o.backends[u];
          n.save && n.save(d, a, l), r(u - 1, l);
        }
      };
      p(0);
    }
  }, {
    key: "create",
    value: function(d, a, t, o) {
      var m = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : function() {
      }, p = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {};
      this.backends.forEach(function(s) {
        if (s.create) {
          var r = s.create.bind(s);
          if (r.length < 6) {
            try {
              var u;
              r.length === 5 ? u = r(d, a, t, o, p) : u = r(d, a, t, o), u && typeof u.then == "function" ? u.then(function(l) {
                return m(null, l);
              }).catch(m) : m(null, u);
            } catch (l) {
              m(l);
            }
            return;
          }
          r(d, a, t, o, m, p);
        }
      });
    }
  }, {
    key: "reload",
    value: function() {
      var d = this, a = this.services, t = a.backendConnector, o = a.languageUtils, m = a.logger, p = t.language;
      if (!(p && p.toLowerCase() === "cimode")) {
        var s = [], r = function(l) {
          var n = o.toResolveHierarchy(l);
          n.forEach(function(f) {
            s.indexOf(f) < 0 && s.push(f);
          });
        };
        r(p), this.allOptions.preload && this.allOptions.preload.forEach(function(u) {
          return r(u);
        }), s.forEach(function(u) {
          d.allOptions.ns.forEach(function(l) {
            t.read(u, l, "read", null, null, function(n, f) {
              n && m.warn("loading namespace ".concat(l, " for language ").concat(u, " failed"), n), !n && f && m.log("loaded namespace ".concat(l, " for language ").concat(u), f), t.loaded("".concat(u, "|").concat(l), n, f);
            });
          });
        });
      }
    }
  }]), e;
}();
su.type = "backend";
const Pc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: su
}, Symbol.toStringTag, { value: "Module" })), Mc = /* @__PURE__ */ te(Pc);
var fn = {
  not_string: /[^s]/,
  number: /[diefg]/,
  json: /[j]/,
  not_json: /[^j]/,
  text: /^[^\x25]+/,
  modulo: /^\x25{2}/,
  placeholder: /^\x25(?:([1-9]\d*)\$|\(([^\)]+)\))?(\+)?(0|'[^$])?(-)?(\d+)?(?:\.(\d+))?([b-gijosuxX])/,
  key: /^([a-z_][a-z_\d]*)/i,
  key_access: /^\.([a-z_][a-z_\d]*)/i,
  index_access: /^\[(\d+)\]/,
  sign: /^[\+\-]/
};
function pn() {
  var e = arguments[0], i = pn.cache;
  return i[e] && i.hasOwnProperty(e) || (i[e] = pn.parse(e)), pn.format.call(null, i[e], arguments);
}
pn.format = function(e, i) {
  var d = 1, a = e.length, t = "", o, m = [], p, s, r, u, l, n, f = !0, v = "";
  for (p = 0; p < a; p++)
    if (t = di(e[p]), t === "string")
      m[m.length] = e[p];
    else if (t === "array") {
      if (r = e[p], r[2])
        for (o = i[d], s = 0; s < r[2].length; s++) {
          if (!o.hasOwnProperty(r[2][s]))
            throw new Error(pn("[sprintf] property '%s' does not exist", r[2][s]));
          o = o[r[2][s]];
        }
      else r[1] ? o = i[r[1]] : o = i[d++];
      if (di(o) == "function" && (o = o()), fn.not_string.test(r[8]) && fn.not_json.test(r[8]) && di(o) != "number" && isNaN(o))
        throw new TypeError(pn("[sprintf] expecting number but found %s", di(o)));
      switch (fn.number.test(r[8]) && (f = o >= 0), r[8]) {
        case "b":
          o = o.toString(2);
          break;
        case "c":
          o = String.fromCharCode(o);
          break;
        case "d":
        case "i":
          o = parseInt(o, 10);
          break;
        case "j":
          o = JSON.stringify(o, null, r[6] ? parseInt(r[6]) : 0);
          break;
        case "e":
          o = r[7] ? o.toExponential(r[7]) : o.toExponential();
          break;
        case "f":
          o = r[7] ? parseFloat(o).toFixed(r[7]) : parseFloat(o);
          break;
        case "g":
          o = r[7] ? parseFloat(o).toPrecision(r[7]) : parseFloat(o);
          break;
        case "o":
          o = o.toString(8);
          break;
        case "s":
          o = (o = String(o)) && r[7] ? o.substring(0, r[7]) : o;
          break;
        case "u":
          o = o >>> 0;
          break;
        case "x":
          o = o.toString(16);
          break;
        case "X":
          o = o.toString(16).toUpperCase();
          break;
      }
      fn.json.test(r[8]) ? m[m.length] = o : (fn.number.test(r[8]) && (!f || r[3]) ? (v = f ? "+" : "-", o = o.toString().replace(fn.sign, "")) : v = "", l = r[4] ? r[4] === "0" ? "0" : r[4].charAt(1) : " ", n = r[6] - (v + o).length, u = r[6] && n > 0 ? Sc(l, n) : "", m[m.length] = r[5] ? v + o + u : l === "0" ? v + u + o : u + v + o);
    }
  return m.join("");
};
pn.cache = {};
pn.parse = function(e) {
  for (var i = e, d = [], a = [], t = 0; i; ) {
    if ((d = fn.text.exec(i)) !== null)
      a[a.length] = d[0];
    else if ((d = fn.modulo.exec(i)) !== null)
      a[a.length] = "%";
    else if ((d = fn.placeholder.exec(i)) !== null) {
      if (d[2]) {
        t |= 1;
        var o = [], m = d[2], p = [];
        if ((p = fn.key.exec(m)) !== null)
          for (o[o.length] = p[1]; (m = m.substring(p[0].length)) !== ""; )
            if ((p = fn.key_access.exec(m)) !== null)
              o[o.length] = p[1];
            else if ((p = fn.index_access.exec(m)) !== null)
              o[o.length] = p[1];
            else
              throw new SyntaxError("[sprintf] failed to parse named argument key");
        else
          throw new SyntaxError("[sprintf] failed to parse named argument key");
        d[2] = o;
      } else
        t |= 2;
      if (t === 3)
        throw new Error("[sprintf] mixing positional and named placeholders is not (yet) supported");
      a[a.length] = d;
    } else
      throw new SyntaxError("[sprintf] unexpected placeholder");
    i = i.substring(d[0].length);
  }
  return a;
};
function jc(e, i, d) {
  return d = (i || []).slice(0), d.splice(0, 0, e), pn.apply(null, d);
}
function di(e) {
  return Object.prototype.toString.call(e).slice(8, -1).toLowerCase();
}
function Sc(e, i) {
  return Array(i + 1).join(e);
}
var zc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
  return typeof e;
} : function(e) {
  return e && typeof Symbol == "function" && e.constructor === Symbol ? "symbol" : typeof e;
};
const Oc = {
  name: "sprintf",
  type: "postProcessor",
  process: function(i, d, a) {
    return a.sprintf ? Object.prototype.toString.apply(a.sprintf) === "[object Array]" ? jc(i, a.sprintf) : zc(a.sprintf) === "object" ? pn(i, a.sprintf) : i : i;
  },
  overloadTranslationOptionHandler: function(i) {
    for (var d = [], a = 1; a < i.length; a++)
      d.push(i[a]);
    return {
      postProcess: "sprintf",
      sprintf: d
    };
  }
}, Wc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Oc
}, Symbol.toStringTag, { value: "Module" })), Dc = /* @__PURE__ */ te(Wc);
var Ma = {}, ja, Ur;
function du() {
  if (Ur) return ja;
  Ur = 1;
  var e = Cf(), i = _f();
  function d(a, t, o) {
    (o !== void 0 && !i(a[t], o) || o === void 0 && !(t in a)) && e(a, t, o);
  }
  return ja = d, ja;
}
var Sa, Br;
function Cc() {
  if (Br) return Sa;
  Br = 1;
  var e = If(), i = $f();
  function d(a) {
    return i(a) && e(a);
  }
  return Sa = d, Sa;
}
var za, Xr;
function uu() {
  if (Xr) return za;
  Xr = 1;
  function e(i, d) {
    if (!(d === "constructor" && typeof i[d] == "function") && d != "__proto__")
      return i[d];
  }
  return za = e, za;
}
var Oa, Gr;
function Ic() {
  if (Gr) return Oa;
  Gr = 1;
  var e = Tf(), i = Sd();
  function d(a) {
    return e(a, i(a));
  }
  return Oa = d, Oa;
}
var Wa, Kr;
function Tc() {
  if (Kr) return Wa;
  Kr = 1;
  var e = du(), i = Nf(), d = xf(), a = Ff(), t = Ef(), o = Pf(), m = Mf(), p = Cc(), s = Rf(), r = Md(), u = jd, l = jf(), n = Lf(), f = uu(), v = Ic();
  function D(F, A, ae, ne, ce, Q, N) {
    var B = f(F, ae), V = f(A, ae), se = N.get(V);
    if (se) {
      e(F, ae, se);
      return;
    }
    var de = Q ? Q(B, V, ae + "", F, A, N) : void 0, he = de === void 0;
    if (he) {
      var be = m(V), b = !be && s(V), y = !be && !b && n(V);
      de = V, be || b || y ? m(B) ? de = B : p(B) ? de = a(B) : b ? (he = !1, de = i(V, !0)) : y ? (he = !1, de = d(V, !0)) : de = [] : l(V) || o(V) ? (de = B, o(B) ? de = v(B) : (!u(B) || r(B)) && (de = t(V))) : he = !1;
    }
    he && (N.set(V, de), ce(de, V, ne, Q, N), N.delete(V)), e(F, ae, de);
  }
  return Wa = D, Wa;
}
var Da, Yr;
function Nc() {
  if (Yr) return Da;
  Yr = 1;
  var e = qf(), i = du(), d = Af(), a = Tc(), t = jd, o = Sd(), m = uu();
  function p(s, r, u, l, n) {
    s !== r && d(r, function(f, v) {
      if (n || (n = new e()), t(f))
        a(s, r, v, u, p, l, n);
      else {
        var D = l ? l(m(s, v), f, v + "", s, r, n) : void 0;
        D === void 0 && (D = f), i(s, v, D);
      }
    }, o);
  }
  return Da = p, Da;
}
var Ca, Jr;
function xc() {
  if (Jr) return Ca;
  Jr = 1;
  var e = Hf(), i = Uf(), d = Vf();
  function a(t, o) {
    return d(i(t, o, e), t + "");
  }
  return Ca = a, Ca;
}
var Ia, Qr;
function Fc() {
  if (Qr) return Ia;
  Qr = 1;
  var e = xc(), i = Bf();
  function d(a) {
    return e(function(t, o) {
      var m = -1, p = o.length, s = p > 1 ? o[p - 1] : void 0, r = p > 2 ? o[2] : void 0;
      for (s = a.length > 3 && typeof s == "function" ? (p--, s) : void 0, r && i(o[0], o[1], r) && (s = p < 3 ? void 0 : s, p = 1), t = Object(t); ++m < p; ) {
        var u = o[m];
        u && a(t, u, m, s);
      }
      return t;
    });
  }
  return Ia = d, Ia;
}
var Ta, eo;
function Ec() {
  if (eo) return Ta;
  eo = 1;
  var e = Nc(), i = Fc(), d = i(function(a, t, o) {
    e(a, t, o);
  });
  return Ta = d, Ta;
}
var Na = {}, xa = {}, Fa = {}, no;
function Gt() {
  return no || (no = 1, function(e) {
    var i = Ce;
    i(e, "__esModule", {
      value: !0
    }), e.defaultLanguage = void 0, e.defaultLanguage = "en";
  }(Fa)), Fa;
}
var io;
function fu() {
  return io || (io = 1, function(e) {
    var i = Ce, d = bn;
    i(e, "__esModule", {
      value: !0
    }), e.convertLanguageCodeToRegionalCode = o;
    var a = d(Od()), t = Gt();
    function o(m) {
      let p = (0, a.default)(m).call(m, "_", "-");
      switch (m) {
        case "de-DE":
          p = "de";
          break;
        case "es":
        case "es-AR":
        case "es-419":
          p = "es-419";
          break;
        case "en":
        case "en-GB":
          p = t.defaultLanguage;
          break;
        case "fr":
        case "fr-CA":
          p = "fr-CA";
          break;
        case "ja-JP":
          p = "ja";
          break;
        case "pt-PT":
        case "pt":
          p = "pt-BR";
          break;
        case "zh":
          p = "zh-CN";
          break;
      }
      return p;
    }
  }(xa)), xa;
}
var Ea = {}, Ra = {}, ao;
function Rc() {
  return ao || (ao = 1, function(e) {
    var i = Ce;
    i(e, "__esModule", {
      value: !0
    }), e.getDocumentLocale = d;
    function d() {
      return document.documentElement.dataset.locale;
    }
  }(Ra)), Ra;
}
var to;
function Lc() {
  return to || (to = 1, function(e) {
    var i = Ce;
    i(e, "__esModule", {
      value: !0
    }), e.retrieveLanguageCode = m;
    var d = sl, a = Xf, t = Gt(), o = Rc();
    function m() {
      const p = (0, a.getParameterByName)("lang") || (0, o.getDocumentLocale)();
      return typeof p == "string" ? (0, d.htmlEntities)(p) : t.defaultLanguage;
    }
  }(Ea)), Ea;
}
var ro;
function lu() {
  return ro || (ro = 1, function(e) {
    var i = Ce, d = bn;
    i(e, "__esModule", {
      value: !0
    }), e.getSelectedLanguageCode = p;
    var a = d(Od()), t = fu(), o = Lc(), m = Gt();
    function p() {
      try {
        var s;
        const r = (0, a.default)(s = (0, o.retrieveLanguageCode)()).call(s, "_", "-");
        return (0, t.convertLanguageCodeToRegionalCode)(r);
      } catch {
        return m.defaultLanguage;
      }
    }
  }(Na)), Na;
}
function ii(e) {
  "@babel/helpers - typeof";
  return ii = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(i) {
    return typeof i;
  } : function(i) {
    return i && typeof Symbol == "function" && i.constructor === Symbol && i !== Symbol.prototype ? "symbol" : typeof i;
  }, ii(e);
}
function qc(e, i) {
  if (ii(e) != "object" || !e) return e;
  var d = e[Symbol.toPrimitive];
  if (d !== void 0) {
    var a = d.call(e, i);
    if (ii(a) != "object") return a;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
function cu(e) {
  var i = qc(e, "string");
  return ii(i) == "symbol" ? i : i + "";
}
function Zc(e, i, d) {
  return (i = cu(i)) in e ? Object.defineProperty(e, i, {
    value: d,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[i] = d, e;
}
function mu(e, i) {
  if (!(e instanceof i)) throw new TypeError("Cannot call a class as a function");
}
function Ac(e, i) {
  for (var d = 0; d < i.length; d++) {
    var a = i[d];
    a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, cu(a.key), a);
  }
}
function vu(e, i, d) {
  return i && Ac(e.prototype, i), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function oo(e, i) {
  var d = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    i && (a = a.filter(function(t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), d.push.apply(d, a);
  }
  return d;
}
function La(e) {
  for (var i = 1; i < arguments.length; i++) {
    var d = arguments[i] != null ? arguments[i] : {};
    i % 2 ? oo(Object(d), !0).forEach(function(a) {
      Zc(e, a, d[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(d)) : oo(Object(d)).forEach(function(a) {
      Object.defineProperty(e, a, Object.getOwnPropertyDescriptor(d, a));
    });
  }
  return e;
}
var Vc = /* @__PURE__ */ function() {
  function e(i) {
    mu(this, e), this.store = i.store;
  }
  return vu(e, [{
    key: "setItem",
    value: function(d, a) {
      if (this.store)
        try {
          this.store.setItem(d, a);
        } catch {
        }
    }
  }, {
    key: "getItem",
    value: function(d, a) {
      if (this.store)
        try {
          return this.store.getItem(d, a);
        } catch {
        }
    }
  }]), e;
}();
function Hc() {
  var e = null;
  try {
    e = window.localStorage;
  } catch (i) {
    typeof window < "u" && console.log("Failed to load local storage.", i);
  }
  return {
    prefix: "i18next_res_",
    expirationTime: 7 * 24 * 60 * 60 * 1e3,
    defaultVersion: void 0,
    versions: {},
    store: e
  };
}
var hu = /* @__PURE__ */ function() {
  function e(i) {
    var d = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    mu(this, e), this.init(i, d), this.type = "backend";
  }
  return vu(e, [{
    key: "init",
    value: function(d) {
      var a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      this.services = d, this.options = La(La(La({}, Hc()), this.options), a), this.storage = new Vc(this.options);
    }
  }, {
    key: "read",
    value: function(d, a, t) {
      var o = Date.now();
      if (!this.storage.store)
        return t(null, null);
      var m = this.storage.getItem("".concat(this.options.prefix).concat(d, "-").concat(a));
      if (m) {
        m = JSON.parse(m);
        var p = this.getVersion(d);
        if (
          // expiration field is mandatory, and should not be expired
          m.i18nStamp && m.i18nStamp + this.options.expirationTime > o && // there should be no language version set, or if it is, it should match the one in translation
          p === m.i18nVersion
        ) {
          var s = m.i18nStamp;
          return delete m.i18nVersion, delete m.i18nStamp, t(null, m, s);
        }
      }
      return t(null, null);
    }
  }, {
    key: "save",
    value: function(d, a, t) {
      if (this.storage.store) {
        t.i18nStamp = Date.now();
        var o = this.getVersion(d);
        o && (t.i18nVersion = o), this.storage.setItem("".concat(this.options.prefix).concat(d, "-").concat(a), JSON.stringify(t));
      }
    }
  }, {
    key: "getVersion",
    value: function(d) {
      return this.options.versions[d] || this.options.defaultVersion;
    }
  }]), e;
}();
hu.type = "backend";
const Uc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: hu
}, Symbol.toStringTag, { value: "Module" })), Bc = /* @__PURE__ */ te(Uc);
var Xc = function(i) {
  return {
    type: "backend",
    init: function(a, t, o) {
    },
    read: function(a, t, o) {
      if (typeof i == "function") {
        if (i.length < 3) {
          try {
            var m = i(a, t);
            m && typeof m.then == "function" ? m.then(function(p) {
              return o(null, p && p.default || p);
            }).catch(o) : o(null, m);
          } catch (p) {
            o(p);
          }
          return;
        }
        i(a, t, o);
        return;
      }
      o(null, i && i[a] && i[a][t]);
    }
  };
};
const Gc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Xc
}, Symbol.toStringTag, { value: "Module" })), Kc = /* @__PURE__ */ te(Gc);
var qa = {}, so = {}, Za, uo;
function Yc() {
  if (uo) return Za;
  uo = 1;
  var e = _d, i = $d, d = kd, a = Sf(), t = yf, o = wd(), m = bf().f, p = d(m), s = d([].push), r = e && i(function() {
    var l = /* @__PURE__ */ Object.create(null);
    return l[2] = 2, !p(l, 2);
  }), u = function(l) {
    return function(n) {
      for (var f = o(n), v = t(f), D = r && a(f) === null, F = v.length, A = 0, ae = [], ne; F > A; )
        ne = v[A++], (!e || (D ? ne in f : p(f, ne))) && s(ae, l ? [ne, f[ne]] : f[ne]);
      return ae;
    };
  };
  return Za = {
    // `Object.entries` method
    // https://tc39.es/ecma262/#sec-object.entries
    entries: u(!0),
    // `Object.values` method
    // https://tc39.es/ecma262/#sec-object.values
    values: u(!1)
  }, Za;
}
var fo;
function Jc() {
  if (fo) return so;
  fo = 1;
  var e = At(), i = Yc().entries;
  return e({ target: "Object", stat: !0 }, {
    entries: function(a) {
      return i(a);
    }
  }), so;
}
var Aa, lo;
function Qc() {
  if (lo) return Aa;
  lo = 1, Jc();
  var e = Pd;
  return Aa = e.Object.entries, Aa;
}
var Va, co;
function em() {
  if (co) return Va;
  co = 1;
  var e = Qc();
  return Va = e, Va;
}
var Ha, mo;
function nm() {
  if (mo) return Ha;
  mo = 1;
  var e = em();
  return Ha = e, Ha;
}
var Ua, vo;
function im() {
  if (vo) return Ua;
  vo = 1;
  var e = nm();
  return Ua = e, Ua;
}
var Ba, ho;
function am() {
  return ho || (ho = 1, Ba = im()), Ba;
}
var Xa, go;
function tm() {
  return go || (go = 1, Xa = am()), Xa;
}
var po;
function rm() {
  return po || (po = 1, function(e) {
    var i = Ce, d = bn;
    i(e, "__esModule", {
      value: !0
    }), e.flattenResource = m;
    var a = d(tm()), t = d(Zf()), o = Id;
    function m(s) {
      const r = {};
      if (!s || typeof s != "object")
        return (0, o.handleError)(`Expected object, got ${typeof s}`), {};
      for (const [u, l] of (0, a.default)(s))
        try {
          if (!p(l)) {
            (0, o.handleError)(`Invalid value for ${u}: ${(0, t.default)(l)}`);
            continue;
          }
          typeof l == "string" ? r[u] = l : typeof l.translation == "string" ? r[u] = l.translation : (r[`${u}_one`] = l.translation.one, r[`${u}_other`] = l.translation.other);
        } catch (n) {
          (0, o.handleError)(n);
          continue;
        }
      return r;
    }
    function p(s) {
      if (typeof s == "string")
        return !0;
      const r = s && typeof s == "object" && "translation" in s, u = r && typeof s.translation == "string", l = r && s.translation && typeof s.translation == "object" && "one" in s.translation && typeof s.translation.one == "string" && "other" in s.translation && typeof s.translation.other == "string";
      return !!(u || l);
    }
  }(qa)), qa;
}
var bo;
function om() {
  return bo || (bo = 1, function(e) {
    var i = Ce, d = bn;
    i(e, "__esModule", {
      value: !0
    }), e.getI18nInitOptions = void 0;
    var a = d(Of()), t = d(Ec()), o = lu(), m = d(Bc), p = d(Kc), s = rm(), r = Id;
    const u = {
      prefix: "bhr_i18n_",
      // avoid local cache in development
      store: window.ENV === "prod" ? localStorage : null
    };
    function l(f) {
      return (0, p.default)(async (v, D) => {
        try {
          const F = await f(v, D);
          return (0, a.default)(v).call(v, "en") ? (0, s.flattenResource)(F) : F;
        } catch (F) {
          throw (0, r.handleError)(F), F;
        }
      });
    }
    const n = (f = {}) => {
      const {
        backendLocalStorageOptions: v,
        getResources: D,
        ...F
      } = f, A = {
        backend: {
          backendOptions: [v]
        }
      };
      return (0, t.default)({
        // how we load translations (JSON files)
        backend: {
          // backends are checked in order
          backends: [m.default, ...D ? [l(D)] : []],
          // order corresponds to `backends`
          backendOptions: [u]
        },
        // if a translation is missing, use the template, which should always have the English translation, which is better than showing the key
        fallbackLng: "en",
        // default language
        lng: (0, o.getSelectedLanguageCode)(),
        // prevent loading additional translations
        load: "currentOnly",
        // support legacy sprintf placeholders
        postProcess: ["preSprintf", "sprintf"],
        // enable structured resources, e.g. { 'hello': { translation: 'Hello' } }
        returnObjects: !0
      }, A, F);
    };
    e.getI18nInitOptions = n;
  }(Ma)), Ma;
}
var Ga = {}, yo;
function sm() {
  return yo || (yo = 1, function(e) {
    var i = Ce;
    i(e, "__esModule", {
      value: !0
    }), e.preSprintf = void 0, e.preSprintf = {
      type: "postProcessor",
      name: "preSprintf",
      process: (d) => d.replace(/(%\d+)(\$\w)?/g, "$1$s")
    };
  }(Ga)), Ga;
}
var ko;
function gu() {
  return ko || (ko = 1, function(e) {
    var i = Ce, d = bn;
    i(e, "__esModule", {
      value: !0
    }), e.t = e.i18n = void 0;
    var a = d(cc()), t = d(mc()), o = d(Mc), m = d(Dc), p = om(), s = sm(), r;
    const u = e.i18n = t.default.createInstance();
    e.t = (0, a.default)(r = u.t).call(r, u), u.use(s.preSprintf).use(m.default).use(o.default);
    const l = u.init, n = (...f) => {
      const [v, D] = f;
      return typeof v == "function" ? l(v) : l((0, p.getI18nInitOptions)(v), D);
    };
    u.init = n;
  }(ha)), ha;
}
var Ka = {}, Ya = {}, Ja = { exports: {} }, wo = {}, _o;
function dm() {
  if (_o) return wo;
  _o = 1;
  var e = At(), i = $d, d = wd(), a = kf().f, t = _d, o = !t || i(function() {
    a(1);
  });
  return e({ target: "Object", stat: !0, forced: o, sham: !t }, {
    getOwnPropertyDescriptor: function(p, s) {
      return a(d(p), s);
    }
  }), wo;
}
var $o;
function um() {
  if ($o) return Ja.exports;
  $o = 1, dm();
  var e = Pd, i = e.Object, d = Ja.exports = function(t, o) {
    return i.getOwnPropertyDescriptor(t, o);
  };
  return i.getOwnPropertyDescriptor.sham && (d.sham = !0), Ja.exports;
}
var Qa, Po;
function fm() {
  if (Po) return Qa;
  Po = 1;
  var e = um();
  return Qa = e, Qa;
}
var et, Mo;
function lm() {
  if (Mo) return et;
  Mo = 1;
  var e = fm();
  return et = e, et;
}
var nt, jo;
function cm() {
  if (jo) return nt;
  jo = 1;
  var e = lm();
  return nt = e, nt;
}
var it, So;
function mm() {
  return So || (So = 1, it = cm()), it;
}
var at, zo;
function Kt() {
  return zo || (zo = 1, at = mm()), at;
}
var tt = {}, Oo;
function vm() {
  return Oo || (Oo = 1, function(e) {
    var i = Ce, d = bn;
    i(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var a = d(dl()), t = d(Wf()), o = d(Df());
    class m {
      constructor(s, r, u) {
        this.params = s, this.wraps = r, this.stringWrap = u;
      }
      getElements(s) {
        const r = [];
        let u = 0;
        for (; u < s.length; ) {
          const n = s.substring(u).match(/^[^[*_{]+/);
          n !== null && (r.push(this.stringWrap(n[0])), u += n[0].length);
          const f = s[u];
          if (f === "{")
            if (s[u + 1] >= "1" && s[u + 1] <= "9" && s[u + 2] === "}")
              r.push(this.stringWrap(this.params[(0, a.default)(s[u + 1]) - 1])), u += 3;
            else if (s[u + 1] === "{") {
              var l;
              const v = (0, t.default)(s).call(s, "}", u + 2), D = (0, o.default)(l = s.substring(u + 2, v)).call(l), F = this.params[D];
              r.push(this.stringWrap(F)), u = v + 2;
            } else
              r.push(this.stringWrap(s[u++]));
          else if (f === "[" || f === "_" || f === "*") {
            let v, D, F = f;
            s[u + 1] === f && f !== "[" ? (D = "strong", v = f + f, F += s[u + 1], u += 2) : (u += 1, D = f === "[" ? "link" : "em", v = f === "[" ? "]" : f);
            const A = (0, t.default)(s).call(s, v, u);
            if (A !== -1) {
              let ae = 0;
              v === "]" && s.length > A + 3 && s[A + 1] === "(" && s[A + 2] >= "1" && s[A + 2] <= "9" && s[A + 3] === ")" && (ae = 3, D = `link${s[A + 2]}`), r.push(this.wraps[D](this.getElements(s.substring(u, A)))), u = A + v.length + ae;
            } else
              r.push(this.stringWrap(F));
          }
        }
        return r;
      }
    }
    e.default = m;
  }(tt)), tt;
}
var Wo;
function hm() {
  return Wo || (Wo = 1, function(e) {
    var i = Ut(), d = Ce, a = Kt(), t = bn;
    d(e, "__esModule", {
      value: !0
    }), e.InternalLink = e.ExternalLink = e.Emphasis = void 0, e.Message = f, e.TagClass = e.Sup = e.Stronger = e.Strong = e.SpanClass = void 0;
    var o = t(zf()), m = t(Md()), p = u(yd), s = t(vm());
    function r(N) {
      if (typeof i != "function") return null;
      var B = new i(), V = new i();
      return (r = function(se) {
        return se ? V : B;
      })(N);
    }
    function u(N, B) {
      if (N && N.__esModule) return N;
      if (N === null || typeof N != "object" && typeof N != "function") return { default: N };
      var V = r(B);
      if (V && V.has(N)) return V.get(N);
      var se = { __proto__: null }, de = d && a;
      for (var he in N) if (he !== "default" && {}.hasOwnProperty.call(N, he)) {
        var be = de ? a(N, he) : null;
        be && (be.get || be.set) ? d(se, he, be) : se[he] = N[he];
      }
      return se.default = N, V && V.set(N, se), se;
    }
    function l(N) {
      let B = [], V = (N + "").split(`
`);
      for (let se = 0; se < V.length; ++se)
        se > 0 && B.push(/* @__PURE__ */ p.default.createElement("br", {
          key: `message-linebreak-${se}`
        })), B.push(V[se]);
      return B.length === 1 ? B[0] : B;
    }
    function n(N = {}, B) {
      if ((0, m.default)(N))
        return N;
      let V;
      for (V in B)
        N[V] = N[V] || B[V];
      let se = {};
      for (V in N)
        V === "extra" && N[V] === "externalLink" ? (se.rel = "noopener noreferrer", se.target = "_blank") : V !== "tag" && (se[V] = N[V]);
      return function(de) {
        return /* @__PURE__ */ (0, p.createElement)(N.tag, se, de);
      };
    }
    function f(N) {
      const {
        em: B,
        link: V,
        params: se,
        strong: de,
        text: he
      } = N;
      let be = {
        em: ne,
        strong: ce,
        link: (_) => /* @__PURE__ */ p.default.createElement(p.Fragment, null, "[", _, "]")
        // This is just a dummy wrapper that leaves [] unchanged.
      };
      be.em = n(B, {
        tag: "em"
      }), be.strong = n(de, {
        tag: "strong"
      }), be.link = n(V, {
        tag: "a"
      });
      for (let _ = 1; _ <= 9; ++_)
        be["link" + _] = n(N["link" + _], {
          tag: "a"
        });
      const y = new s.default(se, be, l).getElements(he);
      return (0, o.default)(y).call(y, (_, R) => /* @__PURE__ */ p.default.createElement(p.Fragment, null, _, R));
    }
    const v = (N) => /* @__PURE__ */ p.default.createElement("sup", null, N);
    e.Sup = v;
    const D = (N, B = {}) => (V) => /* @__PURE__ */ (0, p.createElement)(N, {
      className: B
    }, V);
    e.TagClass = D;
    const F = (N = {}) => (B) => /* @__PURE__ */ p.default.createElement("span", {
      className: N
    }, B);
    e.SpanClass = F;
    const A = (N, B = {}) => (V) => /* @__PURE__ */ p.default.createElement("a", {
      className: B,
      href: N,
      rel: "noopener noreferrer",
      target: "_blank"
    }, V);
    e.ExternalLink = A;
    const ae = (N, B = {}) => (V) => /* @__PURE__ */ p.default.createElement("a", {
      className: B,
      href: N
    }, V);
    e.InternalLink = ae;
    const ne = (N) => /* @__PURE__ */ p.default.createElement("em", null, N);
    e.Emphasis = ne;
    const ce = (N) => /* @__PURE__ */ p.default.createElement("strong", null, N);
    e.Strong = ce;
    const Q = (N) => /* @__PURE__ */ p.default.createElement("span", {
      style: {
        fontWeight: 700
      }
    }, N);
    e.Stronger = Q;
  }(Ya)), Ya;
}
var Do;
function gm() {
  return Do || (Do = 1, function(e) {
    var i = Ce, d = bn;
    i(e, "__esModule", {
      value: !0
    }), e.TranslatedMarkdown = m;
    var a = d(yd), t = gu(), o = hm();
    function m({
      i18nKey: p,
      components: s,
      count: r,
      defaults: u,
      values: l
    }) {
      const n = (0, t.t)(p, {
        count: r,
        defaultValue: u,
        skipInterpolation: !0
      });
      return n ? /* @__PURE__ */ a.default.createElement(o.Message, {
        em: s == null ? void 0 : s.em,
        link: s == null ? void 0 : s.link,
        params: {
          count: r,
          ...l
        },
        strong: s == null ? void 0 : s.strong,
        text: n
      }) : null;
    }
  }(Ka)), Ka;
}
var rt = {}, Co;
function pm() {
  return Co || (Co = 1, function(e) {
    var i = Ce;
    i(e, "__esModule", {
      value: !0
    });
  }(rt)), rt;
}
var ot = {}, st = {}, dt = {}, ut = {}, ft = {}, lt = {}, Io;
function ai() {
  return Io || (Io = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.globalConfig = e.$ZodAsyncError = e.$brand = e.NEVER = void 0, e.$constructor = i, e.config = a, e.NEVER = Object.freeze({
      status: "aborted"
    });
    function i(t, o, m) {
      function p(l, n) {
        var f;
        Object.defineProperty(l, "_zod", {
          value: l._zod ?? {},
          enumerable: !1
        }), (f = l._zod).traits ?? (f.traits = /* @__PURE__ */ new Set()), l._zod.traits.add(t), o(l, n);
        for (const v in u.prototype)
          v in l || Object.defineProperty(l, v, { value: u.prototype[v].bind(l) });
        l._zod.constr = u, l._zod.def = n;
      }
      const s = (m == null ? void 0 : m.Parent) ?? Object;
      class r extends s {
      }
      Object.defineProperty(r, "name", { value: t });
      function u(l) {
        var n;
        const f = m != null && m.Parent ? new r() : this;
        p(f, l), (n = f._zod).deferred ?? (n.deferred = []);
        for (const v of f._zod.deferred)
          v();
        return f;
      }
      return Object.defineProperty(u, "init", { value: p }), Object.defineProperty(u, Symbol.hasInstance, {
        value: (l) => {
          var n, f;
          return m != null && m.Parent && l instanceof m.Parent ? !0 : (f = (n = l == null ? void 0 : l._zod) == null ? void 0 : n.traits) == null ? void 0 : f.has(t);
        }
      }), Object.defineProperty(u, "name", { value: t }), u;
    }
    e.$brand = Symbol("zod_brand");
    class d extends Error {
      constructor() {
        super("Encountered Promise during synchronous parse. Use .parseAsync() instead.");
      }
    }
    e.$ZodAsyncError = d, e.globalConfig = {};
    function a(t) {
      return t && Object.assign(e.globalConfig, t), e.globalConfig;
    }
  }(lt)), lt;
}
var ct = {}, sn = {}, ue = {}, To;
function pe() {
  if (To) return ue;
  To = 1, Object.defineProperty(ue, "__esModule", { value: !0 }), ue.Class = ue.BIGINT_FORMAT_RANGES = ue.NUMBER_FORMAT_RANGES = ue.primitiveTypes = ue.propertyKeyTypes = ue.getParsedType = ue.allowsEval = ue.captureStackTrace = void 0, ue.assertEqual = e, ue.assertNotEqual = i, ue.assertIs = d, ue.assertNever = a, ue.assert = t, ue.getEnumValues = o, ue.joinValues = m, ue.jsonStringifyReplacer = p, ue.cached = s, ue.nullish = r, ue.cleanRegex = u, ue.floatSafeRemainder = l, ue.defineLazy = f, ue.objectClone = v, ue.assignProp = D, ue.mergeDefs = F, ue.cloneDef = A, ue.getElementAtPath = ae, ue.promiseAllObject = ne, ue.randomString = ce, ue.esc = Q, ue.isObject = N, ue.isPlainObject = B, ue.shallowClone = V, ue.numKeys = se, ue.escapeRegex = he, ue.clone = be, ue.normalizeParams = b, ue.createTransparentProxy = y, ue.stringifyPrimitive = _, ue.optionalKeys = R, ue.pick = W, ue.omit = X, ue.extend = G, ue.merge = re, ue.partial = oe, ue.required = fe, ue.aborted = $e, ue.prefixIssues = ye, ue.unwrapMessage = we, ue.finalizeIssue = je, ue.getSizableOrigin = Oe, ue.getLengthableOrigin = De, ue.issue = Qe, ue.cleanEnum = an;
  function e(x) {
    return x;
  }
  function i(x) {
    return x;
  }
  function d(x) {
  }
  function a(x) {
    throw new Error();
  }
  function t(x) {
  }
  function o(x) {
    const j = Object.values(x).filter((g) => typeof g == "number");
    return Object.entries(x).filter(([g, k]) => j.indexOf(+g) === -1).map(([g, k]) => k);
  }
  function m(x, j = "|") {
    return x.map((h) => _(h)).join(j);
  }
  function p(x, j) {
    return typeof j == "bigint" ? j.toString() : j;
  }
  function s(x) {
    return {
      get value() {
        {
          const j = x();
          return Object.defineProperty(this, "value", { value: j }), j;
        }
      }
    };
  }
  function r(x) {
    return x == null;
  }
  function u(x) {
    const j = x.startsWith("^") ? 1 : 0, h = x.endsWith("$") ? x.length - 1 : x.length;
    return x.slice(j, h);
  }
  function l(x, j) {
    const h = (x.toString().split(".")[1] || "").length, g = j.toString();
    let k = (g.split(".")[1] || "").length;
    if (k === 0 && /\d?e-\d?/.test(g)) {
      const q = g.match(/\d?e-(\d?)/);
      q != null && q[1] && (k = Number.parseInt(q[1]));
    }
    const S = h > k ? h : k, z = Number.parseInt(x.toFixed(S).replace(".", "")), E = Number.parseInt(j.toFixed(S).replace(".", ""));
    return z % E / 10 ** S;
  }
  const n = Symbol("evaluating");
  function f(x, j, h) {
    let g;
    Object.defineProperty(x, j, {
      get() {
        if (g !== n)
          return g === void 0 && (g = n, g = h()), g;
      },
      set(k) {
        Object.defineProperty(x, j, {
          value: k
          // configurable: true,
        });
      },
      configurable: !0
    });
  }
  function v(x) {
    return Object.create(Object.getPrototypeOf(x), Object.getOwnPropertyDescriptors(x));
  }
  function D(x, j, h) {
    Object.defineProperty(x, j, {
      value: h,
      writable: !0,
      enumerable: !0,
      configurable: !0
    });
  }
  function F(...x) {
    const j = {};
    for (const h of x) {
      const g = Object.getOwnPropertyDescriptors(h);
      Object.assign(j, g);
    }
    return Object.defineProperties({}, j);
  }
  function A(x) {
    return F(x._zod.def);
  }
  function ae(x, j) {
    return j ? j.reduce((h, g) => h == null ? void 0 : h[g], x) : x;
  }
  function ne(x) {
    const j = Object.keys(x), h = j.map((g) => x[g]);
    return Promise.all(h).then((g) => {
      const k = {};
      for (let S = 0; S < j.length; S++)
        k[j[S]] = g[S];
      return k;
    });
  }
  function ce(x = 10) {
    const j = "abcdefghijklmnopqrstuvwxyz";
    let h = "";
    for (let g = 0; g < x; g++)
      h += j[Math.floor(Math.random() * j.length)];
    return h;
  }
  function Q(x) {
    return JSON.stringify(x);
  }
  ue.captureStackTrace = "captureStackTrace" in Error ? Error.captureStackTrace : (...x) => {
  };
  function N(x) {
    return typeof x == "object" && x !== null && !Array.isArray(x);
  }
  ue.allowsEval = s(() => {
    var x;
    if (typeof navigator < "u" && ((x = navigator == null ? void 0 : navigator.userAgent) != null && x.includes("Cloudflare")))
      return !1;
    try {
      const j = Function;
      return new j(""), !0;
    } catch {
      return !1;
    }
  });
  function B(x) {
    if (N(x) === !1)
      return !1;
    const j = x.constructor;
    if (j === void 0)
      return !0;
    const h = j.prototype;
    return !(N(h) === !1 || Object.prototype.hasOwnProperty.call(h, "isPrototypeOf") === !1);
  }
  function V(x) {
    return B(x) ? { ...x } : x;
  }
  function se(x) {
    let j = 0;
    for (const h in x)
      Object.prototype.hasOwnProperty.call(x, h) && j++;
    return j;
  }
  const de = (x) => {
    const j = typeof x;
    switch (j) {
      case "undefined":
        return "undefined";
      case "string":
        return "string";
      case "number":
        return Number.isNaN(x) ? "nan" : "number";
      case "boolean":
        return "boolean";
      case "function":
        return "function";
      case "bigint":
        return "bigint";
      case "symbol":
        return "symbol";
      case "object":
        return Array.isArray(x) ? "array" : x === null ? "null" : x.then && typeof x.then == "function" && x.catch && typeof x.catch == "function" ? "promise" : typeof Map < "u" && x instanceof Map ? "map" : typeof Set < "u" && x instanceof Set ? "set" : typeof Date < "u" && x instanceof Date ? "date" : typeof File < "u" && x instanceof File ? "file" : "object";
      default:
        throw new Error(`Unknown data type: ${j}`);
    }
  };
  ue.getParsedType = de, ue.propertyKeyTypes = /* @__PURE__ */ new Set(["string", "number", "symbol"]), ue.primitiveTypes = /* @__PURE__ */ new Set(["string", "number", "bigint", "boolean", "symbol", "undefined"]);
  function he(x) {
    return x.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  }
  function be(x, j, h) {
    const g = new x._zod.constr(j ?? x._zod.def);
    return (!j || h != null && h.parent) && (g._zod.parent = x), g;
  }
  function b(x) {
    const j = x;
    if (!j)
      return {};
    if (typeof j == "string")
      return { error: () => j };
    if ((j == null ? void 0 : j.message) !== void 0) {
      if ((j == null ? void 0 : j.error) !== void 0)
        throw new Error("Cannot specify both `message` and `error` params");
      j.error = j.message;
    }
    return delete j.message, typeof j.error == "string" ? { ...j, error: () => j.error } : j;
  }
  function y(x) {
    let j;
    return new Proxy({}, {
      get(h, g, k) {
        return j ?? (j = x()), Reflect.get(j, g, k);
      },
      set(h, g, k, S) {
        return j ?? (j = x()), Reflect.set(j, g, k, S);
      },
      has(h, g) {
        return j ?? (j = x()), Reflect.has(j, g);
      },
      deleteProperty(h, g) {
        return j ?? (j = x()), Reflect.deleteProperty(j, g);
      },
      ownKeys(h) {
        return j ?? (j = x()), Reflect.ownKeys(j);
      },
      getOwnPropertyDescriptor(h, g) {
        return j ?? (j = x()), Reflect.getOwnPropertyDescriptor(j, g);
      },
      defineProperty(h, g, k) {
        return j ?? (j = x()), Reflect.defineProperty(j, g, k);
      }
    });
  }
  function _(x) {
    return typeof x == "bigint" ? x.toString() + "n" : typeof x == "string" ? `"${x}"` : `${x}`;
  }
  function R(x) {
    return Object.keys(x).filter((j) => x[j]._zod.optin === "optional" && x[j]._zod.optout === "optional");
  }
  ue.NUMBER_FORMAT_RANGES = {
    safeint: [Number.MIN_SAFE_INTEGER, Number.MAX_SAFE_INTEGER],
    int32: [-2147483648, 2147483647],
    uint32: [0, 4294967295],
    float32: [-34028234663852886e22, 34028234663852886e22],
    float64: [-Number.MAX_VALUE, Number.MAX_VALUE]
  }, ue.BIGINT_FORMAT_RANGES = {
    int64: [/* @__PURE__ */ BigInt("-9223372036854775808"), /* @__PURE__ */ BigInt("9223372036854775807")],
    uint64: [/* @__PURE__ */ BigInt(0), /* @__PURE__ */ BigInt("18446744073709551615")]
  };
  function W(x, j) {
    const h = x._zod.def, g = F(x._zod.def, {
      get shape() {
        const k = {};
        for (const S in j) {
          if (!(S in h.shape))
            throw new Error(`Unrecognized key: "${S}"`);
          j[S] && (k[S] = h.shape[S]);
        }
        return D(this, "shape", k), k;
      },
      checks: []
    });
    return be(x, g);
  }
  function X(x, j) {
    const h = x._zod.def, g = F(x._zod.def, {
      get shape() {
        const k = { ...x._zod.def.shape };
        for (const S in j) {
          if (!(S in h.shape))
            throw new Error(`Unrecognized key: "${S}"`);
          j[S] && delete k[S];
        }
        return D(this, "shape", k), k;
      },
      checks: []
    });
    return be(x, g);
  }
  function G(x, j) {
    if (!B(j))
      throw new Error("Invalid input to extend: expected a plain object");
    const h = F(x._zod.def, {
      get shape() {
        const g = { ...x._zod.def.shape, ...j };
        return D(this, "shape", g), g;
      },
      checks: []
    });
    return be(x, h);
  }
  function re(x, j) {
    const h = F(x._zod.def, {
      get shape() {
        const g = { ...x._zod.def.shape, ...j._zod.def.shape };
        return D(this, "shape", g), g;
      },
      get catchall() {
        return j._zod.def.catchall;
      },
      checks: []
      // delete existing checks
    });
    return be(x, h);
  }
  function oe(x, j, h) {
    const g = F(j._zod.def, {
      get shape() {
        const k = j._zod.def.shape, S = { ...k };
        if (h)
          for (const z in h) {
            if (!(z in k))
              throw new Error(`Unrecognized key: "${z}"`);
            h[z] && (S[z] = x ? new x({
              type: "optional",
              innerType: k[z]
            }) : k[z]);
          }
        else
          for (const z in k)
            S[z] = x ? new x({
              type: "optional",
              innerType: k[z]
            }) : k[z];
        return D(this, "shape", S), S;
      },
      checks: []
    });
    return be(j, g);
  }
  function fe(x, j, h) {
    const g = F(j._zod.def, {
      get shape() {
        const k = j._zod.def.shape, S = { ...k };
        if (h)
          for (const z in h) {
            if (!(z in S))
              throw new Error(`Unrecognized key: "${z}"`);
            h[z] && (S[z] = new x({
              type: "nonoptional",
              innerType: k[z]
            }));
          }
        else
          for (const z in k)
            S[z] = new x({
              type: "nonoptional",
              innerType: k[z]
            });
        return D(this, "shape", S), S;
      },
      checks: []
    });
    return be(j, g);
  }
  function $e(x, j = 0) {
    var h;
    for (let g = j; g < x.issues.length; g++)
      if (((h = x.issues[g]) == null ? void 0 : h.continue) !== !0)
        return !0;
    return !1;
  }
  function ye(x, j) {
    return j.map((h) => {
      var g;
      return (g = h).path ?? (g.path = []), h.path.unshift(x), h;
    });
  }
  function we(x) {
    return typeof x == "string" ? x : x == null ? void 0 : x.message;
  }
  function je(x, j, h) {
    var k, S, z, E, q, L;
    const g = { ...x, path: x.path ?? [] };
    if (!x.message) {
      const U = we((z = (S = (k = x.inst) == null ? void 0 : k._zod.def) == null ? void 0 : S.error) == null ? void 0 : z.call(S, x)) ?? we((E = j == null ? void 0 : j.error) == null ? void 0 : E.call(j, x)) ?? we((q = h.customError) == null ? void 0 : q.call(h, x)) ?? we((L = h.localeError) == null ? void 0 : L.call(h, x)) ?? "Invalid input";
      g.message = U;
    }
    return delete g.inst, delete g.continue, j != null && j.reportInput || delete g.input, g;
  }
  function Oe(x) {
    return x instanceof Set ? "set" : x instanceof Map ? "map" : x instanceof File ? "file" : "unknown";
  }
  function De(x) {
    return Array.isArray(x) ? "array" : typeof x == "string" ? "string" : "unknown";
  }
  function Qe(...x) {
    const [j, h, g] = x;
    return typeof j == "string" ? {
      message: j,
      code: "custom",
      input: h,
      inst: g
    } : { ...j };
  }
  function an(x) {
    return Object.entries(x).filter(([j, h]) => Number.isNaN(Number.parseInt(j, 10))).map((j) => j[1]);
  }
  class We {
    constructor(...j) {
    }
  }
  return ue.Class = We, ue;
}
var No;
function pu() {
  if (No) return sn;
  No = 1;
  var e = w && w.__createBinding || (Object.create ? function(l, n, f, v) {
    v === void 0 && (v = f);
    var D = Object.getOwnPropertyDescriptor(n, f);
    (!D || ("get" in D ? !n.__esModule : D.writable || D.configurable)) && (D = { enumerable: !0, get: function() {
      return n[f];
    } }), Object.defineProperty(l, v, D);
  } : function(l, n, f, v) {
    v === void 0 && (v = f), l[v] = n[f];
  }), i = w && w.__setModuleDefault || (Object.create ? function(l, n) {
    Object.defineProperty(l, "default", { enumerable: !0, value: n });
  } : function(l, n) {
    l.default = n;
  }), d = w && w.__importStar || function(l) {
    if (l && l.__esModule) return l;
    var n = {};
    if (l != null) for (var f in l) f !== "default" && Object.prototype.hasOwnProperty.call(l, f) && e(n, l, f);
    return i(n, l), n;
  };
  Object.defineProperty(sn, "__esModule", { value: !0 }), sn.$ZodRealError = sn.$ZodError = void 0, sn.flattenError = m, sn.formatError = p, sn.treeifyError = s, sn.toDotPath = r, sn.prettifyError = u;
  const a = ai(), t = d(pe()), o = (l, n) => {
    l.name = "$ZodError", Object.defineProperty(l, "_zod", {
      value: l._zod,
      enumerable: !1
    }), Object.defineProperty(l, "issues", {
      value: n,
      enumerable: !1
    }), l.message = JSON.stringify(n, t.jsonStringifyReplacer, 2), Object.defineProperty(l, "toString", {
      value: () => l.message,
      enumerable: !1
    });
  };
  sn.$ZodError = (0, a.$constructor)("$ZodError", o), sn.$ZodRealError = (0, a.$constructor)("$ZodError", o, { Parent: Error });
  function m(l, n = (f) => f.message) {
    const f = {}, v = [];
    for (const D of l.issues)
      D.path.length > 0 ? (f[D.path[0]] = f[D.path[0]] || [], f[D.path[0]].push(n(D))) : v.push(n(D));
    return { formErrors: v, fieldErrors: f };
  }
  function p(l, n) {
    const f = n || function(F) {
      return F.message;
    }, v = { _errors: [] }, D = (F) => {
      for (const A of F.issues)
        if (A.code === "invalid_union" && A.errors.length)
          A.errors.map((ae) => D({ issues: ae }));
        else if (A.code === "invalid_key")
          D({ issues: A.issues });
        else if (A.code === "invalid_element")
          D({ issues: A.issues });
        else if (A.path.length === 0)
          v._errors.push(f(A));
        else {
          let ae = v, ne = 0;
          for (; ne < A.path.length; ) {
            const ce = A.path[ne];
            ne === A.path.length - 1 ? (ae[ce] = ae[ce] || { _errors: [] }, ae[ce]._errors.push(f(A))) : ae[ce] = ae[ce] || { _errors: [] }, ae = ae[ce], ne++;
          }
        }
    };
    return D(l), v;
  }
  function s(l, n) {
    const f = n || function(F) {
      return F.message;
    }, v = { errors: [] }, D = (F, A = []) => {
      var ae, ne;
      for (const ce of F.issues)
        if (ce.code === "invalid_union" && ce.errors.length)
          ce.errors.map((Q) => D({ issues: Q }, ce.path));
        else if (ce.code === "invalid_key")
          D({ issues: ce.issues }, ce.path);
        else if (ce.code === "invalid_element")
          D({ issues: ce.issues }, ce.path);
        else {
          const Q = [...A, ...ce.path];
          if (Q.length === 0) {
            v.errors.push(f(ce));
            continue;
          }
          let N = v, B = 0;
          for (; B < Q.length; ) {
            const V = Q[B], se = B === Q.length - 1;
            typeof V == "string" ? (N.properties ?? (N.properties = {}), (ae = N.properties)[V] ?? (ae[V] = { errors: [] }), N = N.properties[V]) : (N.items ?? (N.items = []), (ne = N.items)[V] ?? (ne[V] = { errors: [] }), N = N.items[V]), se && N.errors.push(f(ce)), B++;
          }
        }
    };
    return D(l), v;
  }
  function r(l) {
    const n = [], f = l.map((v) => typeof v == "object" ? v.key : v);
    for (const v of f)
      typeof v == "number" ? n.push(`[${v}]`) : typeof v == "symbol" ? n.push(`[${JSON.stringify(String(v))}]`) : /[^\w$]/.test(v) ? n.push(`[${JSON.stringify(v)}]`) : (n.length && n.push("."), n.push(v));
    return n.join("");
  }
  function u(l) {
    var v;
    const n = [], f = [...l.issues].sort((D, F) => (D.path ?? []).length - (F.path ?? []).length);
    for (const D of f)
      n.push(`✖ ${D.message}`), (v = D.path) != null && v.length && n.push(`  → at ${r(D.path)}`);
    return n.join(`
`);
  }
  return sn;
}
var xo;
function Yt() {
  return xo || (xo = 1, function(e) {
    var i = w && w.__createBinding || (Object.create ? function(l, n, f, v) {
      v === void 0 && (v = f);
      var D = Object.getOwnPropertyDescriptor(n, f);
      (!D || ("get" in D ? !n.__esModule : D.writable || D.configurable)) && (D = { enumerable: !0, get: function() {
        return n[f];
      } }), Object.defineProperty(l, v, D);
    } : function(l, n, f, v) {
      v === void 0 && (v = f), l[v] = n[f];
    }), d = w && w.__setModuleDefault || (Object.create ? function(l, n) {
      Object.defineProperty(l, "default", { enumerable: !0, value: n });
    } : function(l, n) {
      l.default = n;
    }), a = w && w.__importStar || function(l) {
      if (l && l.__esModule) return l;
      var n = {};
      if (l != null) for (var f in l) f !== "default" && Object.prototype.hasOwnProperty.call(l, f) && i(n, l, f);
      return d(n, l), n;
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), e.safeParseAsync = e._safeParseAsync = e.safeParse = e._safeParse = e.parseAsync = e._parseAsync = e.parse = e._parse = void 0;
    const t = a(ai()), o = a(pu()), m = a(pe()), p = (l) => (n, f, v, D) => {
      const F = v ? Object.assign(v, { async: !1 }) : { async: !1 }, A = n._zod.run({ value: f, issues: [] }, F);
      if (A instanceof Promise)
        throw new t.$ZodAsyncError();
      if (A.issues.length) {
        const ae = new ((D == null ? void 0 : D.Err) ?? l)(A.issues.map((ne) => m.finalizeIssue(ne, F, t.config())));
        throw m.captureStackTrace(ae, D == null ? void 0 : D.callee), ae;
      }
      return A.value;
    };
    e._parse = p, e.parse = (0, e._parse)(o.$ZodRealError);
    const s = (l) => async (n, f, v, D) => {
      const F = v ? Object.assign(v, { async: !0 }) : { async: !0 };
      let A = n._zod.run({ value: f, issues: [] }, F);
      if (A instanceof Promise && (A = await A), A.issues.length) {
        const ae = new ((D == null ? void 0 : D.Err) ?? l)(A.issues.map((ne) => m.finalizeIssue(ne, F, t.config())));
        throw m.captureStackTrace(ae, D == null ? void 0 : D.callee), ae;
      }
      return A.value;
    };
    e._parseAsync = s, e.parseAsync = (0, e._parseAsync)(o.$ZodRealError);
    const r = (l) => (n, f, v) => {
      const D = v ? { ...v, async: !1 } : { async: !1 }, F = n._zod.run({ value: f, issues: [] }, D);
      if (F instanceof Promise)
        throw new t.$ZodAsyncError();
      return F.issues.length ? {
        success: !1,
        error: new (l ?? o.$ZodError)(F.issues.map((A) => m.finalizeIssue(A, D, t.config())))
      } : { success: !0, data: F.value };
    };
    e._safeParse = r, e.safeParse = (0, e._safeParse)(o.$ZodRealError);
    const u = (l) => async (n, f, v) => {
      const D = v ? Object.assign(v, { async: !0 }) : { async: !0 };
      let F = n._zod.run({ value: f, issues: [] }, D);
      return F instanceof Promise && (F = await F), F.issues.length ? {
        success: !1,
        error: new l(F.issues.map((A) => m.finalizeIssue(A, D, t.config())))
      } : { success: !0, data: F.value };
    };
    e._safeParseAsync = u, e.safeParseAsync = (0, e._safeParseAsync)(o.$ZodRealError);
  }(ct)), ct;
}
var mt = {}, vt = {}, ht = {}, Fo;
function Jt() {
  return Fo || (Fo = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.uppercase = e.lowercase = e.undefined = e.null = e.boolean = e.number = e.integer = e.bigint = e.string = e.date = e.e164 = e.domain = e.hostname = e.base64url = e.base64 = e.cidrv6 = e.cidrv4 = e.ipv6 = e.ipv4 = e.browserEmail = e.idnEmail = e.unicodeEmail = e.rfc5322Email = e.html5Email = e.email = e.uuid7 = e.uuid6 = e.uuid4 = e.uuid = e.guid = e.extendedDuration = e.duration = e.nanoid = e.ksuid = e.xid = e.ulid = e.cuid2 = e.cuid = void 0, e.emoji = a, e.time = m, e.datetime = p, e.cuid = /^[cC][^\s-]{8,}$/, e.cuid2 = /^[0-9a-z]+$/, e.ulid = /^[0-9A-HJKMNP-TV-Za-hjkmnp-tv-z]{26}$/, e.xid = /^[0-9a-vA-V]{20}$/, e.ksuid = /^[A-Za-z0-9]{27}$/, e.nanoid = /^[a-zA-Z0-9_-]{21}$/, e.duration = /^P(?:(\d+W)|(?!.*W)(?=\d|T\d)(\d+Y)?(\d+M)?(\d+D)?(T(?=\d)(\d+H)?(\d+M)?(\d+([.,]\d+)?S)?)?)$/, e.extendedDuration = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/, e.guid = /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})$/;
    const i = (l) => l ? new RegExp(`^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-${l}[0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12})$`) : /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000)$/;
    e.uuid = i, e.uuid4 = (0, e.uuid)(4), e.uuid6 = (0, e.uuid)(6), e.uuid7 = (0, e.uuid)(7), e.email = /^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/, e.html5Email = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/, e.rfc5322Email = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/, e.unicodeEmail = /^[^\s@"]{1,64}@[^\s@]{1,255}$/u, e.idnEmail = /^[^\s@"]{1,64}@[^\s@]{1,255}$/u, e.browserEmail = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
    const d = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
    function a() {
      return new RegExp(d, "u");
    }
    e.ipv4 = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, e.ipv6 = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|::|([0-9a-fA-F]{1,4})?::([0-9a-fA-F]{1,4}:?){0,6})$/, e.cidrv4 = /^((25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/([0-9]|[1-2][0-9]|3[0-2])$/, e.cidrv6 = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|::|([0-9a-fA-F]{1,4})?::([0-9a-fA-F]{1,4}:?){0,6})\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, e.base64 = /^$|^(?:[0-9a-zA-Z+/]{4})*(?:(?:[0-9a-zA-Z+/]{2}==)|(?:[0-9a-zA-Z+/]{3}=))?$/, e.base64url = /^[A-Za-z0-9_-]*$/, e.hostname = /^(?=.{1,253}\.?$)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[-0-9a-zA-Z]{0,61}[0-9a-zA-Z])?)*\.?$/, e.domain = /^([a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/, e.e164 = /^\+(?:[0-9]){6,14}[0-9]$/;
    const t = "(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))";
    e.date = new RegExp(`^${t}$`);
    function o(l) {
      const n = "(?:[01]\\d|2[0-3]):[0-5]\\d";
      return typeof l.precision == "number" ? l.precision === -1 ? `${n}` : l.precision === 0 ? `${n}:[0-5]\\d` : `${n}:[0-5]\\d\\.\\d{${l.precision}}` : `${n}(?::[0-5]\\d(?:\\.\\d+)?)?`;
    }
    function m(l) {
      return new RegExp(`^${o(l)}$`);
    }
    function p(l) {
      const n = o({ precision: l.precision }), f = ["Z"];
      l.local && f.push(""), l.offset && f.push("([+-](?:[01]\\d|2[0-3]):[0-5]\\d)");
      const v = `${n}(?:${f.join("|")})`;
      return new RegExp(`^${t}T(?:${v})$`);
    }
    const s = (l) => {
      const n = l ? `[\\s\\S]{${(l == null ? void 0 : l.minimum) ?? 0},${(l == null ? void 0 : l.maximum) ?? ""}}` : "[\\s\\S]*";
      return new RegExp(`^${n}$`);
    };
    e.string = s, e.bigint = /^\d+n?$/, e.integer = /^\d+$/, e.number = /^-?\d+(?:\.\d+)?/i, e.boolean = /true|false/i;
    const r = /null/i;
    e.null = r;
    const u = /undefined/i;
    e.undefined = u, e.lowercase = /^[^A-Z]*$/, e.uppercase = /^[^a-z]*$/;
  }(ht)), ht;
}
var Eo;
function Qt() {
  return Eo || (Eo = 1, function(e) {
    var i = w && w.__createBinding || (Object.create ? function(r, u, l, n) {
      n === void 0 && (n = l);
      var f = Object.getOwnPropertyDescriptor(u, l);
      (!f || ("get" in f ? !u.__esModule : f.writable || f.configurable)) && (f = { enumerable: !0, get: function() {
        return u[l];
      } }), Object.defineProperty(r, n, f);
    } : function(r, u, l, n) {
      n === void 0 && (n = l), r[n] = u[l];
    }), d = w && w.__setModuleDefault || (Object.create ? function(r, u) {
      Object.defineProperty(r, "default", { enumerable: !0, value: u });
    } : function(r, u) {
      r.default = u;
    }), a = w && w.__importStar || function(r) {
      if (r && r.__esModule) return r;
      var u = {};
      if (r != null) for (var l in r) l !== "default" && Object.prototype.hasOwnProperty.call(r, l) && i(u, r, l);
      return d(u, r), u;
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), e.$ZodCheckOverwrite = e.$ZodCheckMimeType = e.$ZodCheckProperty = e.$ZodCheckEndsWith = e.$ZodCheckStartsWith = e.$ZodCheckIncludes = e.$ZodCheckUpperCase = e.$ZodCheckLowerCase = e.$ZodCheckRegex = e.$ZodCheckStringFormat = e.$ZodCheckLengthEquals = e.$ZodCheckMinLength = e.$ZodCheckMaxLength = e.$ZodCheckSizeEquals = e.$ZodCheckMinSize = e.$ZodCheckMaxSize = e.$ZodCheckBigIntFormat = e.$ZodCheckNumberFormat = e.$ZodCheckMultipleOf = e.$ZodCheckGreaterThan = e.$ZodCheckLessThan = e.$ZodCheck = void 0;
    const t = a(ai()), o = a(Jt()), m = a(pe());
    e.$ZodCheck = t.$constructor("$ZodCheck", (r, u) => {
      var l;
      r._zod ?? (r._zod = {}), r._zod.def = u, (l = r._zod).onattach ?? (l.onattach = []);
    });
    const p = {
      number: "number",
      bigint: "bigint",
      object: "date"
    };
    e.$ZodCheckLessThan = t.$constructor("$ZodCheckLessThan", (r, u) => {
      e.$ZodCheck.init(r, u);
      const l = p[typeof u.value];
      r._zod.onattach.push((n) => {
        const f = n._zod.bag, v = (u.inclusive ? f.maximum : f.exclusiveMaximum) ?? Number.POSITIVE_INFINITY;
        u.value < v && (u.inclusive ? f.maximum = u.value : f.exclusiveMaximum = u.value);
      }), r._zod.check = (n) => {
        (u.inclusive ? n.value <= u.value : n.value < u.value) || n.issues.push({
          origin: l,
          code: "too_big",
          maximum: u.value,
          input: n.value,
          inclusive: u.inclusive,
          inst: r,
          continue: !u.abort
        });
      };
    }), e.$ZodCheckGreaterThan = t.$constructor("$ZodCheckGreaterThan", (r, u) => {
      e.$ZodCheck.init(r, u);
      const l = p[typeof u.value];
      r._zod.onattach.push((n) => {
        const f = n._zod.bag, v = (u.inclusive ? f.minimum : f.exclusiveMinimum) ?? Number.NEGATIVE_INFINITY;
        u.value > v && (u.inclusive ? f.minimum = u.value : f.exclusiveMinimum = u.value);
      }), r._zod.check = (n) => {
        (u.inclusive ? n.value >= u.value : n.value > u.value) || n.issues.push({
          origin: l,
          code: "too_small",
          minimum: u.value,
          input: n.value,
          inclusive: u.inclusive,
          inst: r,
          continue: !u.abort
        });
      };
    }), e.$ZodCheckMultipleOf = /* @__PURE__ */ t.$constructor("$ZodCheckMultipleOf", (r, u) => {
      e.$ZodCheck.init(r, u), r._zod.onattach.push((l) => {
        var n;
        (n = l._zod.bag).multipleOf ?? (n.multipleOf = u.value);
      }), r._zod.check = (l) => {
        if (typeof l.value != typeof u.value)
          throw new Error("Cannot mix number and bigint in multiple_of check.");
        (typeof l.value == "bigint" ? l.value % u.value === BigInt(0) : m.floatSafeRemainder(l.value, u.value) === 0) || l.issues.push({
          origin: typeof l.value,
          code: "not_multiple_of",
          divisor: u.value,
          input: l.value,
          inst: r,
          continue: !u.abort
        });
      };
    }), e.$ZodCheckNumberFormat = t.$constructor("$ZodCheckNumberFormat", (r, u) => {
      var D;
      e.$ZodCheck.init(r, u), u.format = u.format || "float64";
      const l = (D = u.format) == null ? void 0 : D.includes("int"), n = l ? "int" : "number", [f, v] = m.NUMBER_FORMAT_RANGES[u.format];
      r._zod.onattach.push((F) => {
        const A = F._zod.bag;
        A.format = u.format, A.minimum = f, A.maximum = v, l && (A.pattern = o.integer);
      }), r._zod.check = (F) => {
        const A = F.value;
        if (l) {
          if (!Number.isInteger(A)) {
            F.issues.push({
              expected: n,
              format: u.format,
              code: "invalid_type",
              continue: !1,
              input: A,
              inst: r
            });
            return;
          }
          if (!Number.isSafeInteger(A)) {
            A > 0 ? F.issues.push({
              input: A,
              code: "too_big",
              maximum: Number.MAX_SAFE_INTEGER,
              note: "Integers must be within the safe integer range.",
              inst: r,
              origin: n,
              continue: !u.abort
            }) : F.issues.push({
              input: A,
              code: "too_small",
              minimum: Number.MIN_SAFE_INTEGER,
              note: "Integers must be within the safe integer range.",
              inst: r,
              origin: n,
              continue: !u.abort
            });
            return;
          }
        }
        A < f && F.issues.push({
          origin: "number",
          input: A,
          code: "too_small",
          minimum: f,
          inclusive: !0,
          inst: r,
          continue: !u.abort
        }), A > v && F.issues.push({
          origin: "number",
          input: A,
          code: "too_big",
          maximum: v,
          inst: r
        });
      };
    }), e.$ZodCheckBigIntFormat = t.$constructor("$ZodCheckBigIntFormat", (r, u) => {
      e.$ZodCheck.init(r, u);
      const [l, n] = m.BIGINT_FORMAT_RANGES[u.format];
      r._zod.onattach.push((f) => {
        const v = f._zod.bag;
        v.format = u.format, v.minimum = l, v.maximum = n;
      }), r._zod.check = (f) => {
        const v = f.value;
        v < l && f.issues.push({
          origin: "bigint",
          input: v,
          code: "too_small",
          minimum: l,
          inclusive: !0,
          inst: r,
          continue: !u.abort
        }), v > n && f.issues.push({
          origin: "bigint",
          input: v,
          code: "too_big",
          maximum: n,
          inst: r
        });
      };
    }), e.$ZodCheckMaxSize = t.$constructor("$ZodCheckMaxSize", (r, u) => {
      var l;
      e.$ZodCheck.init(r, u), (l = r._zod.def).when ?? (l.when = (n) => {
        const f = n.value;
        return !m.nullish(f) && f.size !== void 0;
      }), r._zod.onattach.push((n) => {
        const f = n._zod.bag.maximum ?? Number.POSITIVE_INFINITY;
        u.maximum < f && (n._zod.bag.maximum = u.maximum);
      }), r._zod.check = (n) => {
        const f = n.value;
        f.size <= u.maximum || n.issues.push({
          origin: m.getSizableOrigin(f),
          code: "too_big",
          maximum: u.maximum,
          input: f,
          inst: r,
          continue: !u.abort
        });
      };
    }), e.$ZodCheckMinSize = t.$constructor("$ZodCheckMinSize", (r, u) => {
      var l;
      e.$ZodCheck.init(r, u), (l = r._zod.def).when ?? (l.when = (n) => {
        const f = n.value;
        return !m.nullish(f) && f.size !== void 0;
      }), r._zod.onattach.push((n) => {
        const f = n._zod.bag.minimum ?? Number.NEGATIVE_INFINITY;
        u.minimum > f && (n._zod.bag.minimum = u.minimum);
      }), r._zod.check = (n) => {
        const f = n.value;
        f.size >= u.minimum || n.issues.push({
          origin: m.getSizableOrigin(f),
          code: "too_small",
          minimum: u.minimum,
          input: f,
          inst: r,
          continue: !u.abort
        });
      };
    }), e.$ZodCheckSizeEquals = t.$constructor("$ZodCheckSizeEquals", (r, u) => {
      var l;
      e.$ZodCheck.init(r, u), (l = r._zod.def).when ?? (l.when = (n) => {
        const f = n.value;
        return !m.nullish(f) && f.size !== void 0;
      }), r._zod.onattach.push((n) => {
        const f = n._zod.bag;
        f.minimum = u.size, f.maximum = u.size, f.size = u.size;
      }), r._zod.check = (n) => {
        const f = n.value, v = f.size;
        if (v === u.size)
          return;
        const D = v > u.size;
        n.issues.push({
          origin: m.getSizableOrigin(f),
          ...D ? { code: "too_big", maximum: u.size } : { code: "too_small", minimum: u.size },
          inclusive: !0,
          exact: !0,
          input: n.value,
          inst: r,
          continue: !u.abort
        });
      };
    }), e.$ZodCheckMaxLength = t.$constructor("$ZodCheckMaxLength", (r, u) => {
      var l;
      e.$ZodCheck.init(r, u), (l = r._zod.def).when ?? (l.when = (n) => {
        const f = n.value;
        return !m.nullish(f) && f.length !== void 0;
      }), r._zod.onattach.push((n) => {
        const f = n._zod.bag.maximum ?? Number.POSITIVE_INFINITY;
        u.maximum < f && (n._zod.bag.maximum = u.maximum);
      }), r._zod.check = (n) => {
        const f = n.value;
        if (f.length <= u.maximum)
          return;
        const D = m.getLengthableOrigin(f);
        n.issues.push({
          origin: D,
          code: "too_big",
          maximum: u.maximum,
          inclusive: !0,
          input: f,
          inst: r,
          continue: !u.abort
        });
      };
    }), e.$ZodCheckMinLength = t.$constructor("$ZodCheckMinLength", (r, u) => {
      var l;
      e.$ZodCheck.init(r, u), (l = r._zod.def).when ?? (l.when = (n) => {
        const f = n.value;
        return !m.nullish(f) && f.length !== void 0;
      }), r._zod.onattach.push((n) => {
        const f = n._zod.bag.minimum ?? Number.NEGATIVE_INFINITY;
        u.minimum > f && (n._zod.bag.minimum = u.minimum);
      }), r._zod.check = (n) => {
        const f = n.value;
        if (f.length >= u.minimum)
          return;
        const D = m.getLengthableOrigin(f);
        n.issues.push({
          origin: D,
          code: "too_small",
          minimum: u.minimum,
          inclusive: !0,
          input: f,
          inst: r,
          continue: !u.abort
        });
      };
    }), e.$ZodCheckLengthEquals = t.$constructor("$ZodCheckLengthEquals", (r, u) => {
      var l;
      e.$ZodCheck.init(r, u), (l = r._zod.def).when ?? (l.when = (n) => {
        const f = n.value;
        return !m.nullish(f) && f.length !== void 0;
      }), r._zod.onattach.push((n) => {
        const f = n._zod.bag;
        f.minimum = u.length, f.maximum = u.length, f.length = u.length;
      }), r._zod.check = (n) => {
        const f = n.value, v = f.length;
        if (v === u.length)
          return;
        const D = m.getLengthableOrigin(f), F = v > u.length;
        n.issues.push({
          origin: D,
          ...F ? { code: "too_big", maximum: u.length } : { code: "too_small", minimum: u.length },
          inclusive: !0,
          exact: !0,
          input: n.value,
          inst: r,
          continue: !u.abort
        });
      };
    }), e.$ZodCheckStringFormat = t.$constructor("$ZodCheckStringFormat", (r, u) => {
      var l, n;
      e.$ZodCheck.init(r, u), r._zod.onattach.push((f) => {
        const v = f._zod.bag;
        v.format = u.format, u.pattern && (v.patterns ?? (v.patterns = /* @__PURE__ */ new Set()), v.patterns.add(u.pattern));
      }), u.pattern ? (l = r._zod).check ?? (l.check = (f) => {
        u.pattern.lastIndex = 0, !u.pattern.test(f.value) && f.issues.push({
          origin: "string",
          code: "invalid_format",
          format: u.format,
          input: f.value,
          ...u.pattern ? { pattern: u.pattern.toString() } : {},
          inst: r,
          continue: !u.abort
        });
      }) : (n = r._zod).check ?? (n.check = () => {
      });
    }), e.$ZodCheckRegex = t.$constructor("$ZodCheckRegex", (r, u) => {
      e.$ZodCheckStringFormat.init(r, u), r._zod.check = (l) => {
        u.pattern.lastIndex = 0, !u.pattern.test(l.value) && l.issues.push({
          origin: "string",
          code: "invalid_format",
          format: "regex",
          input: l.value,
          pattern: u.pattern.toString(),
          inst: r,
          continue: !u.abort
        });
      };
    }), e.$ZodCheckLowerCase = t.$constructor("$ZodCheckLowerCase", (r, u) => {
      u.pattern ?? (u.pattern = o.lowercase), e.$ZodCheckStringFormat.init(r, u);
    }), e.$ZodCheckUpperCase = t.$constructor("$ZodCheckUpperCase", (r, u) => {
      u.pattern ?? (u.pattern = o.uppercase), e.$ZodCheckStringFormat.init(r, u);
    }), e.$ZodCheckIncludes = t.$constructor("$ZodCheckIncludes", (r, u) => {
      e.$ZodCheck.init(r, u);
      const l = m.escapeRegex(u.includes), n = new RegExp(typeof u.position == "number" ? `^.{${u.position}}${l}` : l);
      u.pattern = n, r._zod.onattach.push((f) => {
        const v = f._zod.bag;
        v.patterns ?? (v.patterns = /* @__PURE__ */ new Set()), v.patterns.add(n);
      }), r._zod.check = (f) => {
        f.value.includes(u.includes, u.position) || f.issues.push({
          origin: "string",
          code: "invalid_format",
          format: "includes",
          includes: u.includes,
          input: f.value,
          inst: r,
          continue: !u.abort
        });
      };
    }), e.$ZodCheckStartsWith = t.$constructor("$ZodCheckStartsWith", (r, u) => {
      e.$ZodCheck.init(r, u);
      const l = new RegExp(`^${m.escapeRegex(u.prefix)}.*`);
      u.pattern ?? (u.pattern = l), r._zod.onattach.push((n) => {
        const f = n._zod.bag;
        f.patterns ?? (f.patterns = /* @__PURE__ */ new Set()), f.patterns.add(l);
      }), r._zod.check = (n) => {
        n.value.startsWith(u.prefix) || n.issues.push({
          origin: "string",
          code: "invalid_format",
          format: "starts_with",
          prefix: u.prefix,
          input: n.value,
          inst: r,
          continue: !u.abort
        });
      };
    }), e.$ZodCheckEndsWith = t.$constructor("$ZodCheckEndsWith", (r, u) => {
      e.$ZodCheck.init(r, u);
      const l = new RegExp(`.*${m.escapeRegex(u.suffix)}$`);
      u.pattern ?? (u.pattern = l), r._zod.onattach.push((n) => {
        const f = n._zod.bag;
        f.patterns ?? (f.patterns = /* @__PURE__ */ new Set()), f.patterns.add(l);
      }), r._zod.check = (n) => {
        n.value.endsWith(u.suffix) || n.issues.push({
          origin: "string",
          code: "invalid_format",
          format: "ends_with",
          suffix: u.suffix,
          input: n.value,
          inst: r,
          continue: !u.abort
        });
      };
    });
    function s(r, u, l) {
      r.issues.length && u.issues.push(...m.prefixIssues(l, r.issues));
    }
    e.$ZodCheckProperty = t.$constructor("$ZodCheckProperty", (r, u) => {
      e.$ZodCheck.init(r, u), r._zod.check = (l) => {
        const n = u.schema._zod.run({
          value: l.value[u.property],
          issues: []
        }, {});
        if (n instanceof Promise)
          return n.then((f) => s(f, l, u.property));
        s(n, l, u.property);
      };
    }), e.$ZodCheckMimeType = t.$constructor("$ZodCheckMimeType", (r, u) => {
      e.$ZodCheck.init(r, u);
      const l = new Set(u.mime);
      r._zod.onattach.push((n) => {
        n._zod.bag.mime = u.mime;
      }), r._zod.check = (n) => {
        l.has(n.value.type) || n.issues.push({
          code: "invalid_value",
          values: u.mime,
          input: n.value.type,
          inst: r,
          continue: !u.abort
        });
      };
    }), e.$ZodCheckOverwrite = t.$constructor("$ZodCheckOverwrite", (r, u) => {
      e.$ZodCheck.init(r, u), r._zod.check = (l) => {
        l.value = u.tx(l.value);
      };
    });
  }(vt)), vt;
}
var Bn = {}, Ro;
function bu() {
  if (Ro) return Bn;
  Ro = 1, Object.defineProperty(Bn, "__esModule", { value: !0 }), Bn.Doc = void 0;
  class e {
    constructor(d = []) {
      this.content = [], this.indent = 0, this && (this.args = d);
    }
    indented(d) {
      this.indent += 1, d(this), this.indent -= 1;
    }
    write(d) {
      if (typeof d == "function") {
        d(this, { execution: "sync" }), d(this, { execution: "async" });
        return;
      }
      const t = d.split(`
`).filter((p) => p), o = Math.min(...t.map((p) => p.length - p.trimStart().length)), m = t.map((p) => p.slice(o)).map((p) => " ".repeat(this.indent * 2) + p);
      for (const p of m)
        this.content.push(p);
    }
    compile() {
      const d = Function, a = this == null ? void 0 : this.args, o = [...((this == null ? void 0 : this.content) ?? [""]).map((m) => `  ${m}`)];
      return new d(...a, o.join(`
`));
    }
  }
  return Bn.Doc = e, Bn;
}
var Xn = {}, Lo;
function yu() {
  return Lo || (Lo = 1, Object.defineProperty(Xn, "__esModule", { value: !0 }), Xn.version = void 0, Xn.version = {
    major: 4,
    minor: 0,
    patch: 17
  }), Xn;
}
var qo;
function ta() {
  return qo || (qo = 1, function(e) {
    var i = w && w.__createBinding || (Object.create ? function(b, y, _, R) {
      R === void 0 && (R = _);
      var W = Object.getOwnPropertyDescriptor(y, _);
      (!W || ("get" in W ? !y.__esModule : W.writable || W.configurable)) && (W = { enumerable: !0, get: function() {
        return y[_];
      } }), Object.defineProperty(b, R, W);
    } : function(b, y, _, R) {
      R === void 0 && (R = _), b[R] = y[_];
    }), d = w && w.__setModuleDefault || (Object.create ? function(b, y) {
      Object.defineProperty(b, "default", { enumerable: !0, value: y });
    } : function(b, y) {
      b.default = y;
    }), a = w && w.__importStar || function(b) {
      if (b && b.__esModule) return b;
      var y = {};
      if (b != null) for (var _ in b) _ !== "default" && Object.prototype.hasOwnProperty.call(b, _) && i(y, b, _);
      return d(y, b), y;
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), e.$ZodSet = e.$ZodMap = e.$ZodRecord = e.$ZodTuple = e.$ZodIntersection = e.$ZodDiscriminatedUnion = e.$ZodUnion = e.$ZodObject = e.$ZodArray = e.$ZodDate = e.$ZodVoid = e.$ZodNever = e.$ZodUnknown = e.$ZodAny = e.$ZodNull = e.$ZodUndefined = e.$ZodSymbol = e.$ZodBigIntFormat = e.$ZodBigInt = e.$ZodBoolean = e.$ZodNumberFormat = e.$ZodNumber = e.$ZodCustomStringFormat = e.$ZodJWT = e.$ZodE164 = e.$ZodBase64URL = e.$ZodBase64 = e.$ZodCIDRv6 = e.$ZodCIDRv4 = e.$ZodIPv6 = e.$ZodIPv4 = e.$ZodISODuration = e.$ZodISOTime = e.$ZodISODate = e.$ZodISODateTime = e.$ZodKSUID = e.$ZodXID = e.$ZodULID = e.$ZodCUID2 = e.$ZodCUID = e.$ZodNanoID = e.$ZodEmoji = e.$ZodURL = e.$ZodEmail = e.$ZodUUID = e.$ZodGUID = e.$ZodStringFormat = e.$ZodString = e.clone = e.$ZodType = void 0, e.$ZodCustom = e.$ZodLazy = e.$ZodPromise = e.$ZodTemplateLiteral = e.$ZodReadonly = e.$ZodPipe = e.$ZodNaN = e.$ZodCatch = e.$ZodSuccess = e.$ZodNonOptional = e.$ZodPrefault = e.$ZodDefault = e.$ZodNullable = e.$ZodOptional = e.$ZodTransform = e.$ZodFile = e.$ZodLiteral = e.$ZodEnum = void 0, e.isValidBase64 = n, e.isValidBase64URL = f, e.isValidJWT = v;
    const t = a(Qt()), o = a(ai()), m = bu(), p = Yt(), s = a(Jt()), r = a(pe()), u = yu();
    e.$ZodType = o.$constructor("$ZodType", (b, y) => {
      var W;
      var _;
      b ?? (b = {}), b._zod.def = y, b._zod.bag = b._zod.bag || {}, b._zod.version = u.version;
      const R = [...b._zod.def.checks ?? []];
      b._zod.traits.has("$ZodCheck") && R.unshift(b);
      for (const X of R)
        for (const G of X._zod.onattach)
          G(b);
      if (R.length === 0)
        (_ = b._zod).deferred ?? (_.deferred = []), (W = b._zod.deferred) == null || W.push(() => {
          b._zod.run = b._zod.parse;
        });
      else {
        const X = (G, re, oe) => {
          let fe = r.aborted(G), $e;
          for (const ye of re) {
            if (ye._zod.def.when) {
              if (!ye._zod.def.when(G))
                continue;
            } else if (fe)
              continue;
            const we = G.issues.length, je = ye._zod.check(G);
            if (je instanceof Promise && (oe == null ? void 0 : oe.async) === !1)
              throw new o.$ZodAsyncError();
            if ($e || je instanceof Promise)
              $e = ($e ?? Promise.resolve()).then(async () => {
                await je, G.issues.length !== we && (fe || (fe = r.aborted(G, we)));
              });
            else {
              if (G.issues.length === we)
                continue;
              fe || (fe = r.aborted(G, we));
            }
          }
          return $e ? $e.then(() => G) : G;
        };
        b._zod.run = (G, re) => {
          const oe = b._zod.parse(G, re);
          if (oe instanceof Promise) {
            if (re.async === !1)
              throw new o.$ZodAsyncError();
            return oe.then((fe) => X(fe, R, re));
          }
          return X(oe, R, re);
        };
      }
      b["~standard"] = {
        validate: (X) => {
          var G;
          try {
            const re = (0, p.safeParse)(b, X);
            return re.success ? { value: re.data } : { issues: (G = re.error) == null ? void 0 : G.issues };
          } catch {
            return (0, p.safeParseAsync)(b, X).then((oe) => {
              var fe;
              return oe.success ? { value: oe.data } : { issues: (fe = oe.error) == null ? void 0 : fe.issues };
            });
          }
        },
        vendor: "zod",
        version: 1
      };
    });
    var l = pe();
    Object.defineProperty(e, "clone", { enumerable: !0, get: function() {
      return l.clone;
    } }), e.$ZodString = o.$constructor("$ZodString", (b, y) => {
      var _;
      e.$ZodType.init(b, y), b._zod.pattern = [...((_ = b == null ? void 0 : b._zod.bag) == null ? void 0 : _.patterns) ?? []].pop() ?? s.string(b._zod.bag), b._zod.parse = (R, W) => {
        if (y.coerce)
          try {
            R.value = String(R.value);
          } catch {
          }
        return typeof R.value == "string" || R.issues.push({
          expected: "string",
          code: "invalid_type",
          input: R.value,
          inst: b
        }), R;
      };
    }), e.$ZodStringFormat = o.$constructor("$ZodStringFormat", (b, y) => {
      t.$ZodCheckStringFormat.init(b, y), e.$ZodString.init(b, y);
    }), e.$ZodGUID = o.$constructor("$ZodGUID", (b, y) => {
      y.pattern ?? (y.pattern = s.guid), e.$ZodStringFormat.init(b, y);
    }), e.$ZodUUID = o.$constructor("$ZodUUID", (b, y) => {
      if (y.version) {
        const R = {
          v1: 1,
          v2: 2,
          v3: 3,
          v4: 4,
          v5: 5,
          v6: 6,
          v7: 7,
          v8: 8
        }[y.version];
        if (R === void 0)
          throw new Error(`Invalid UUID version: "${y.version}"`);
        y.pattern ?? (y.pattern = s.uuid(R));
      } else
        y.pattern ?? (y.pattern = s.uuid());
      e.$ZodStringFormat.init(b, y);
    }), e.$ZodEmail = o.$constructor("$ZodEmail", (b, y) => {
      y.pattern ?? (y.pattern = s.email), e.$ZodStringFormat.init(b, y);
    }), e.$ZodURL = o.$constructor("$ZodURL", (b, y) => {
      e.$ZodStringFormat.init(b, y), b._zod.check = (_) => {
        try {
          const R = _.value.trim(), W = new URL(R);
          y.hostname && (y.hostname.lastIndex = 0, y.hostname.test(W.hostname) || _.issues.push({
            code: "invalid_format",
            format: "url",
            note: "Invalid hostname",
            pattern: s.hostname.source,
            input: _.value,
            inst: b,
            continue: !y.abort
          })), y.protocol && (y.protocol.lastIndex = 0, y.protocol.test(W.protocol.endsWith(":") ? W.protocol.slice(0, -1) : W.protocol) || _.issues.push({
            code: "invalid_format",
            format: "url",
            note: "Invalid protocol",
            pattern: y.protocol.source,
            input: _.value,
            inst: b,
            continue: !y.abort
          })), y.normalize ? _.value = W.href : _.value = R;
          return;
        } catch {
          _.issues.push({
            code: "invalid_format",
            format: "url",
            input: _.value,
            inst: b,
            continue: !y.abort
          });
        }
      };
    }), e.$ZodEmoji = o.$constructor("$ZodEmoji", (b, y) => {
      y.pattern ?? (y.pattern = s.emoji()), e.$ZodStringFormat.init(b, y);
    }), e.$ZodNanoID = o.$constructor("$ZodNanoID", (b, y) => {
      y.pattern ?? (y.pattern = s.nanoid), e.$ZodStringFormat.init(b, y);
    }), e.$ZodCUID = o.$constructor("$ZodCUID", (b, y) => {
      y.pattern ?? (y.pattern = s.cuid), e.$ZodStringFormat.init(b, y);
    }), e.$ZodCUID2 = o.$constructor("$ZodCUID2", (b, y) => {
      y.pattern ?? (y.pattern = s.cuid2), e.$ZodStringFormat.init(b, y);
    }), e.$ZodULID = o.$constructor("$ZodULID", (b, y) => {
      y.pattern ?? (y.pattern = s.ulid), e.$ZodStringFormat.init(b, y);
    }), e.$ZodXID = o.$constructor("$ZodXID", (b, y) => {
      y.pattern ?? (y.pattern = s.xid), e.$ZodStringFormat.init(b, y);
    }), e.$ZodKSUID = o.$constructor("$ZodKSUID", (b, y) => {
      y.pattern ?? (y.pattern = s.ksuid), e.$ZodStringFormat.init(b, y);
    }), e.$ZodISODateTime = o.$constructor("$ZodISODateTime", (b, y) => {
      y.pattern ?? (y.pattern = s.datetime(y)), e.$ZodStringFormat.init(b, y);
    }), e.$ZodISODate = o.$constructor("$ZodISODate", (b, y) => {
      y.pattern ?? (y.pattern = s.date), e.$ZodStringFormat.init(b, y);
    }), e.$ZodISOTime = o.$constructor("$ZodISOTime", (b, y) => {
      y.pattern ?? (y.pattern = s.time(y)), e.$ZodStringFormat.init(b, y);
    }), e.$ZodISODuration = o.$constructor("$ZodISODuration", (b, y) => {
      y.pattern ?? (y.pattern = s.duration), e.$ZodStringFormat.init(b, y);
    }), e.$ZodIPv4 = o.$constructor("$ZodIPv4", (b, y) => {
      y.pattern ?? (y.pattern = s.ipv4), e.$ZodStringFormat.init(b, y), b._zod.onattach.push((_) => {
        const R = _._zod.bag;
        R.format = "ipv4";
      });
    }), e.$ZodIPv6 = o.$constructor("$ZodIPv6", (b, y) => {
      y.pattern ?? (y.pattern = s.ipv6), e.$ZodStringFormat.init(b, y), b._zod.onattach.push((_) => {
        const R = _._zod.bag;
        R.format = "ipv6";
      }), b._zod.check = (_) => {
        try {
          new URL(`http://[${_.value}]`);
        } catch {
          _.issues.push({
            code: "invalid_format",
            format: "ipv6",
            input: _.value,
            inst: b,
            continue: !y.abort
          });
        }
      };
    }), e.$ZodCIDRv4 = o.$constructor("$ZodCIDRv4", (b, y) => {
      y.pattern ?? (y.pattern = s.cidrv4), e.$ZodStringFormat.init(b, y);
    }), e.$ZodCIDRv6 = o.$constructor("$ZodCIDRv6", (b, y) => {
      y.pattern ?? (y.pattern = s.cidrv6), e.$ZodStringFormat.init(b, y), b._zod.check = (_) => {
        const [R, W] = _.value.split("/");
        try {
          if (!W)
            throw new Error();
          const X = Number(W);
          if (`${X}` !== W)
            throw new Error();
          if (X < 0 || X > 128)
            throw new Error();
          new URL(`http://[${R}]`);
        } catch {
          _.issues.push({
            code: "invalid_format",
            format: "cidrv6",
            input: _.value,
            inst: b,
            continue: !y.abort
          });
        }
      };
    });
    function n(b) {
      if (b === "")
        return !0;
      if (b.length % 4 !== 0)
        return !1;
      try {
        return atob(b), !0;
      } catch {
        return !1;
      }
    }
    e.$ZodBase64 = o.$constructor("$ZodBase64", (b, y) => {
      y.pattern ?? (y.pattern = s.base64), e.$ZodStringFormat.init(b, y), b._zod.onattach.push((_) => {
        _._zod.bag.contentEncoding = "base64";
      }), b._zod.check = (_) => {
        n(_.value) || _.issues.push({
          code: "invalid_format",
          format: "base64",
          input: _.value,
          inst: b,
          continue: !y.abort
        });
      };
    });
    function f(b) {
      if (!s.base64url.test(b))
        return !1;
      const y = b.replace(/[-_]/g, (R) => R === "-" ? "+" : "/"), _ = y.padEnd(Math.ceil(y.length / 4) * 4, "=");
      return n(_);
    }
    e.$ZodBase64URL = o.$constructor("$ZodBase64URL", (b, y) => {
      y.pattern ?? (y.pattern = s.base64url), e.$ZodStringFormat.init(b, y), b._zod.onattach.push((_) => {
        _._zod.bag.contentEncoding = "base64url";
      }), b._zod.check = (_) => {
        f(_.value) || _.issues.push({
          code: "invalid_format",
          format: "base64url",
          input: _.value,
          inst: b,
          continue: !y.abort
        });
      };
    }), e.$ZodE164 = o.$constructor("$ZodE164", (b, y) => {
      y.pattern ?? (y.pattern = s.e164), e.$ZodStringFormat.init(b, y);
    });
    function v(b, y = null) {
      try {
        const _ = b.split(".");
        if (_.length !== 3)
          return !1;
        const [R] = _;
        if (!R)
          return !1;
        const W = JSON.parse(atob(R));
        return !("typ" in W && (W == null ? void 0 : W.typ) !== "JWT" || !W.alg || y && (!("alg" in W) || W.alg !== y));
      } catch {
        return !1;
      }
    }
    e.$ZodJWT = o.$constructor("$ZodJWT", (b, y) => {
      e.$ZodStringFormat.init(b, y), b._zod.check = (_) => {
        v(_.value, y.alg) || _.issues.push({
          code: "invalid_format",
          format: "jwt",
          input: _.value,
          inst: b,
          continue: !y.abort
        });
      };
    }), e.$ZodCustomStringFormat = o.$constructor("$ZodCustomStringFormat", (b, y) => {
      e.$ZodStringFormat.init(b, y), b._zod.check = (_) => {
        y.fn(_.value) || _.issues.push({
          code: "invalid_format",
          format: y.format,
          input: _.value,
          inst: b,
          continue: !y.abort
        });
      };
    }), e.$ZodNumber = o.$constructor("$ZodNumber", (b, y) => {
      e.$ZodType.init(b, y), b._zod.pattern = b._zod.bag.pattern ?? s.number, b._zod.parse = (_, R) => {
        if (y.coerce)
          try {
            _.value = Number(_.value);
          } catch {
          }
        const W = _.value;
        if (typeof W == "number" && !Number.isNaN(W) && Number.isFinite(W))
          return _;
        const X = typeof W == "number" ? Number.isNaN(W) ? "NaN" : Number.isFinite(W) ? void 0 : "Infinity" : void 0;
        return _.issues.push({
          expected: "number",
          code: "invalid_type",
          input: W,
          inst: b,
          ...X ? { received: X } : {}
        }), _;
      };
    }), e.$ZodNumberFormat = o.$constructor("$ZodNumber", (b, y) => {
      t.$ZodCheckNumberFormat.init(b, y), e.$ZodNumber.init(b, y);
    }), e.$ZodBoolean = o.$constructor("$ZodBoolean", (b, y) => {
      e.$ZodType.init(b, y), b._zod.pattern = s.boolean, b._zod.parse = (_, R) => {
        if (y.coerce)
          try {
            _.value = !!_.value;
          } catch {
          }
        const W = _.value;
        return typeof W == "boolean" || _.issues.push({
          expected: "boolean",
          code: "invalid_type",
          input: W,
          inst: b
        }), _;
      };
    }), e.$ZodBigInt = o.$constructor("$ZodBigInt", (b, y) => {
      e.$ZodType.init(b, y), b._zod.pattern = s.bigint, b._zod.parse = (_, R) => {
        if (y.coerce)
          try {
            _.value = BigInt(_.value);
          } catch {
          }
        return typeof _.value == "bigint" || _.issues.push({
          expected: "bigint",
          code: "invalid_type",
          input: _.value,
          inst: b
        }), _;
      };
    }), e.$ZodBigIntFormat = o.$constructor("$ZodBigInt", (b, y) => {
      t.$ZodCheckBigIntFormat.init(b, y), e.$ZodBigInt.init(b, y);
    }), e.$ZodSymbol = o.$constructor("$ZodSymbol", (b, y) => {
      e.$ZodType.init(b, y), b._zod.parse = (_, R) => {
        const W = _.value;
        return typeof W == "symbol" || _.issues.push({
          expected: "symbol",
          code: "invalid_type",
          input: W,
          inst: b
        }), _;
      };
    }), e.$ZodUndefined = o.$constructor("$ZodUndefined", (b, y) => {
      e.$ZodType.init(b, y), b._zod.pattern = s.undefined, b._zod.values = /* @__PURE__ */ new Set([void 0]), b._zod.optin = "optional", b._zod.optout = "optional", b._zod.parse = (_, R) => {
        const W = _.value;
        return typeof W > "u" || _.issues.push({
          expected: "undefined",
          code: "invalid_type",
          input: W,
          inst: b
        }), _;
      };
    }), e.$ZodNull = o.$constructor("$ZodNull", (b, y) => {
      e.$ZodType.init(b, y), b._zod.pattern = s.null, b._zod.values = /* @__PURE__ */ new Set([null]), b._zod.parse = (_, R) => {
        const W = _.value;
        return W === null || _.issues.push({
          expected: "null",
          code: "invalid_type",
          input: W,
          inst: b
        }), _;
      };
    }), e.$ZodAny = o.$constructor("$ZodAny", (b, y) => {
      e.$ZodType.init(b, y), b._zod.parse = (_) => _;
    }), e.$ZodUnknown = o.$constructor("$ZodUnknown", (b, y) => {
      e.$ZodType.init(b, y), b._zod.parse = (_) => _;
    }), e.$ZodNever = o.$constructor("$ZodNever", (b, y) => {
      e.$ZodType.init(b, y), b._zod.parse = (_, R) => (_.issues.push({
        expected: "never",
        code: "invalid_type",
        input: _.value,
        inst: b
      }), _);
    }), e.$ZodVoid = o.$constructor("$ZodVoid", (b, y) => {
      e.$ZodType.init(b, y), b._zod.parse = (_, R) => {
        const W = _.value;
        return typeof W > "u" || _.issues.push({
          expected: "void",
          code: "invalid_type",
          input: W,
          inst: b
        }), _;
      };
    }), e.$ZodDate = o.$constructor("$ZodDate", (b, y) => {
      e.$ZodType.init(b, y), b._zod.parse = (_, R) => {
        if (y.coerce)
          try {
            _.value = new Date(_.value);
          } catch {
          }
        const W = _.value, X = W instanceof Date;
        return X && !Number.isNaN(W.getTime()) || _.issues.push({
          expected: "date",
          code: "invalid_type",
          input: W,
          ...X ? { received: "Invalid Date" } : {},
          inst: b
        }), _;
      };
    });
    function D(b, y, _) {
      b.issues.length && y.issues.push(...r.prefixIssues(_, b.issues)), y.value[_] = b.value;
    }
    e.$ZodArray = o.$constructor("$ZodArray", (b, y) => {
      e.$ZodType.init(b, y), b._zod.parse = (_, R) => {
        const W = _.value;
        if (!Array.isArray(W))
          return _.issues.push({
            expected: "array",
            code: "invalid_type",
            input: W,
            inst: b
          }), _;
        _.value = Array(W.length);
        const X = [];
        for (let G = 0; G < W.length; G++) {
          const re = W[G], oe = y.element._zod.run({
            value: re,
            issues: []
          }, R);
          oe instanceof Promise ? X.push(oe.then((fe) => D(fe, _, G))) : D(oe, _, G);
        }
        return X.length ? Promise.all(X).then(() => _) : _;
      };
    });
    function F(b, y, _, R) {
      b.issues.length && y.issues.push(...r.prefixIssues(_, b.issues)), b.value === void 0 ? _ in R && (y.value[_] = void 0) : y.value[_] = b.value;
    }
    e.$ZodObject = o.$constructor("$ZodObject", (b, y) => {
      e.$ZodType.init(b, y);
      const _ = r.cached(() => {
        const ye = Object.keys(y.shape);
        for (const je of ye)
          if (!y.shape[je]._zod.traits.has("$ZodType"))
            throw new Error(`Invalid element at key "${je}": expected a Zod schema`);
        const we = r.optionalKeys(y.shape);
        return {
          shape: y.shape,
          keys: ye,
          keySet: new Set(ye),
          numKeys: ye.length,
          optionalKeys: new Set(we)
        };
      });
      r.defineLazy(b._zod, "propValues", () => {
        const ye = y.shape, we = {};
        for (const je in ye) {
          const Oe = ye[je]._zod;
          if (Oe.values) {
            we[je] ?? (we[je] = /* @__PURE__ */ new Set());
            for (const De of Oe.values)
              we[je].add(De);
          }
        }
        return we;
      });
      const R = (ye) => {
        const we = new m.Doc(["shape", "payload", "ctx"]), je = _.value, Oe = (We) => {
          const x = r.esc(We);
          return `shape[${x}]._zod.run({ value: input[${x}], issues: [] }, ctx)`;
        };
        we.write("const input = payload.value;");
        const De = /* @__PURE__ */ Object.create(null);
        let Qe = 0;
        for (const We of je.keys)
          De[We] = `key_${Qe++}`;
        we.write("const newResult = {}");
        for (const We of je.keys) {
          const x = De[We], j = r.esc(We);
          we.write(`const ${x} = ${Oe(We)};`), we.write(`
        if (${x}.issues.length) {
          payload.issues = payload.issues.concat(${x}.issues.map(iss => ({
            ...iss,
            path: iss.path ? [${j}, ...iss.path] : [${j}]
          })));
        }
        
        if (${x}.value === undefined) {
          if (${j} in input) {
            newResult[${j}] = undefined;
          }
        } else {
          newResult[${j}] = ${x}.value;
        }
      `);
        }
        we.write("payload.value = newResult;"), we.write("return payload;");
        const an = we.compile();
        return (We, x) => an(ye, We, x);
      };
      let W;
      const X = r.isObject, G = !o.globalConfig.jitless, re = r.allowsEval, oe = G && re.value, fe = y.catchall;
      let $e;
      b._zod.parse = (ye, we) => {
        $e ?? ($e = _.value);
        const je = ye.value;
        if (!X(je))
          return ye.issues.push({
            expected: "object",
            code: "invalid_type",
            input: je,
            inst: b
          }), ye;
        const Oe = [];
        if (G && oe && (we == null ? void 0 : we.async) === !1 && we.jitless !== !0)
          W || (W = R(y.shape)), ye = W(ye, we);
        else {
          ye.value = {};
          const x = $e.shape;
          for (const j of $e.keys) {
            const g = x[j]._zod.run({ value: je[j], issues: [] }, we);
            g instanceof Promise ? Oe.push(g.then((k) => F(k, ye, j, je))) : F(g, ye, j, je);
          }
        }
        if (!fe)
          return Oe.length ? Promise.all(Oe).then(() => ye) : ye;
        const De = [], Qe = $e.keySet, an = fe._zod, We = an.def.type;
        for (const x of Object.keys(je)) {
          if (Qe.has(x))
            continue;
          if (We === "never") {
            De.push(x);
            continue;
          }
          const j = an.run({ value: je[x], issues: [] }, we);
          j instanceof Promise ? Oe.push(j.then((h) => F(h, ye, x, je))) : F(j, ye, x, je);
        }
        return De.length && ye.issues.push({
          code: "unrecognized_keys",
          keys: De,
          input: je,
          inst: b
        }), Oe.length ? Promise.all(Oe).then(() => ye) : ye;
      };
    });
    function A(b, y, _, R) {
      for (const X of b)
        if (X.issues.length === 0)
          return y.value = X.value, y;
      const W = b.filter((X) => !r.aborted(X));
      return W.length === 1 ? (y.value = W[0].value, W[0]) : (y.issues.push({
        code: "invalid_union",
        input: y.value,
        inst: _,
        errors: b.map((X) => X.issues.map((G) => r.finalizeIssue(G, R, o.config())))
      }), y);
    }
    e.$ZodUnion = o.$constructor("$ZodUnion", (b, y) => {
      e.$ZodType.init(b, y), r.defineLazy(b._zod, "optin", () => y.options.some((W) => W._zod.optin === "optional") ? "optional" : void 0), r.defineLazy(b._zod, "optout", () => y.options.some((W) => W._zod.optout === "optional") ? "optional" : void 0), r.defineLazy(b._zod, "values", () => {
        if (y.options.every((W) => W._zod.values))
          return new Set(y.options.flatMap((W) => Array.from(W._zod.values)));
      }), r.defineLazy(b._zod, "pattern", () => {
        if (y.options.every((W) => W._zod.pattern)) {
          const W = y.options.map((X) => X._zod.pattern);
          return new RegExp(`^(${W.map((X) => r.cleanRegex(X.source)).join("|")})$`);
        }
      });
      const _ = y.options.length === 1, R = y.options[0]._zod.run;
      b._zod.parse = (W, X) => {
        if (_)
          return R(W, X);
        let G = !1;
        const re = [];
        for (const oe of y.options) {
          const fe = oe._zod.run({
            value: W.value,
            issues: []
          }, X);
          if (fe instanceof Promise)
            re.push(fe), G = !0;
          else {
            if (fe.issues.length === 0)
              return fe;
            re.push(fe);
          }
        }
        return G ? Promise.all(re).then((oe) => A(oe, W, b, X)) : A(re, W, b, X);
      };
    }), e.$ZodDiscriminatedUnion = /* @__PURE__ */ o.$constructor("$ZodDiscriminatedUnion", (b, y) => {
      e.$ZodUnion.init(b, y);
      const _ = b._zod.parse;
      r.defineLazy(b._zod, "propValues", () => {
        const W = {};
        for (const X of y.options) {
          const G = X._zod.propValues;
          if (!G || Object.keys(G).length === 0)
            throw new Error(`Invalid discriminated union option at index "${y.options.indexOf(X)}"`);
          for (const [re, oe] of Object.entries(G)) {
            W[re] || (W[re] = /* @__PURE__ */ new Set());
            for (const fe of oe)
              W[re].add(fe);
          }
        }
        return W;
      });
      const R = r.cached(() => {
        var G;
        const W = y.options, X = /* @__PURE__ */ new Map();
        for (const re of W) {
          const oe = (G = re._zod.propValues) == null ? void 0 : G[y.discriminator];
          if (!oe || oe.size === 0)
            throw new Error(`Invalid discriminated union option at index "${y.options.indexOf(re)}"`);
          for (const fe of oe) {
            if (X.has(fe))
              throw new Error(`Duplicate discriminator value "${String(fe)}"`);
            X.set(fe, re);
          }
        }
        return X;
      });
      b._zod.parse = (W, X) => {
        const G = W.value;
        if (!r.isObject(G))
          return W.issues.push({
            code: "invalid_type",
            expected: "object",
            input: G,
            inst: b
          }), W;
        const re = R.value.get(G == null ? void 0 : G[y.discriminator]);
        return re ? re._zod.run(W, X) : y.unionFallback ? _(W, X) : (W.issues.push({
          code: "invalid_union",
          errors: [],
          note: "No matching discriminator",
          discriminator: y.discriminator,
          input: G,
          path: [y.discriminator],
          inst: b
        }), W);
      };
    }), e.$ZodIntersection = o.$constructor("$ZodIntersection", (b, y) => {
      e.$ZodType.init(b, y), b._zod.parse = (_, R) => {
        const W = _.value, X = y.left._zod.run({ value: W, issues: [] }, R), G = y.right._zod.run({ value: W, issues: [] }, R);
        return X instanceof Promise || G instanceof Promise ? Promise.all([X, G]).then(([oe, fe]) => ne(_, oe, fe)) : ne(_, X, G);
      };
    });
    function ae(b, y) {
      if (b === y)
        return { valid: !0, data: b };
      if (b instanceof Date && y instanceof Date && +b == +y)
        return { valid: !0, data: b };
      if (r.isPlainObject(b) && r.isPlainObject(y)) {
        const _ = Object.keys(y), R = Object.keys(b).filter((X) => _.indexOf(X) !== -1), W = { ...b, ...y };
        for (const X of R) {
          const G = ae(b[X], y[X]);
          if (!G.valid)
            return {
              valid: !1,
              mergeErrorPath: [X, ...G.mergeErrorPath]
            };
          W[X] = G.data;
        }
        return { valid: !0, data: W };
      }
      if (Array.isArray(b) && Array.isArray(y)) {
        if (b.length !== y.length)
          return { valid: !1, mergeErrorPath: [] };
        const _ = [];
        for (let R = 0; R < b.length; R++) {
          const W = b[R], X = y[R], G = ae(W, X);
          if (!G.valid)
            return {
              valid: !1,
              mergeErrorPath: [R, ...G.mergeErrorPath]
            };
          _.push(G.data);
        }
        return { valid: !0, data: _ };
      }
      return { valid: !1, mergeErrorPath: [] };
    }
    function ne(b, y, _) {
      if (y.issues.length && b.issues.push(...y.issues), _.issues.length && b.issues.push(..._.issues), r.aborted(b))
        return b;
      const R = ae(y.value, _.value);
      if (!R.valid)
        throw new Error(`Unmergable intersection. Error path: ${JSON.stringify(R.mergeErrorPath)}`);
      return b.value = R.data, b;
    }
    e.$ZodTuple = o.$constructor("$ZodTuple", (b, y) => {
      e.$ZodType.init(b, y);
      const _ = y.items, R = _.length - [..._].reverse().findIndex((W) => W._zod.optin !== "optional");
      b._zod.parse = (W, X) => {
        const G = W.value;
        if (!Array.isArray(G))
          return W.issues.push({
            input: G,
            inst: b,
            expected: "tuple",
            code: "invalid_type"
          }), W;
        W.value = [];
        const re = [];
        if (!y.rest) {
          const fe = G.length > _.length, $e = G.length < R - 1;
          if (fe || $e)
            return W.issues.push({
              ...fe ? { code: "too_big", maximum: _.length } : { code: "too_small", minimum: _.length },
              input: G,
              inst: b,
              origin: "array"
            }), W;
        }
        let oe = -1;
        for (const fe of _) {
          if (oe++, oe >= G.length && oe >= R)
            continue;
          const $e = fe._zod.run({
            value: G[oe],
            issues: []
          }, X);
          $e instanceof Promise ? re.push($e.then((ye) => ce(ye, W, oe))) : ce($e, W, oe);
        }
        if (y.rest) {
          const fe = G.slice(_.length);
          for (const $e of fe) {
            oe++;
            const ye = y.rest._zod.run({
              value: $e,
              issues: []
            }, X);
            ye instanceof Promise ? re.push(ye.then((we) => ce(we, W, oe))) : ce(ye, W, oe);
          }
        }
        return re.length ? Promise.all(re).then(() => W) : W;
      };
    });
    function ce(b, y, _) {
      b.issues.length && y.issues.push(...r.prefixIssues(_, b.issues)), y.value[_] = b.value;
    }
    e.$ZodRecord = o.$constructor("$ZodRecord", (b, y) => {
      e.$ZodType.init(b, y), b._zod.parse = (_, R) => {
        const W = _.value;
        if (!r.isPlainObject(W))
          return _.issues.push({
            expected: "record",
            code: "invalid_type",
            input: W,
            inst: b
          }), _;
        const X = [];
        if (y.keyType._zod.values) {
          const G = y.keyType._zod.values;
          _.value = {};
          for (const oe of G)
            if (typeof oe == "string" || typeof oe == "number" || typeof oe == "symbol") {
              const fe = y.valueType._zod.run({ value: W[oe], issues: [] }, R);
              fe instanceof Promise ? X.push(fe.then(($e) => {
                $e.issues.length && _.issues.push(...r.prefixIssues(oe, $e.issues)), _.value[oe] = $e.value;
              })) : (fe.issues.length && _.issues.push(...r.prefixIssues(oe, fe.issues)), _.value[oe] = fe.value);
            }
          let re;
          for (const oe in W)
            G.has(oe) || (re = re ?? [], re.push(oe));
          re && re.length > 0 && _.issues.push({
            code: "unrecognized_keys",
            input: W,
            inst: b,
            keys: re
          });
        } else {
          _.value = {};
          for (const G of Reflect.ownKeys(W)) {
            if (G === "__proto__")
              continue;
            const re = y.keyType._zod.run({ value: G, issues: [] }, R);
            if (re instanceof Promise)
              throw new Error("Async schemas not supported in object keys currently");
            if (re.issues.length) {
              _.issues.push({
                code: "invalid_key",
                origin: "record",
                issues: re.issues.map((fe) => r.finalizeIssue(fe, R, o.config())),
                input: G,
                path: [G],
                inst: b
              }), _.value[re.value] = re.value;
              continue;
            }
            const oe = y.valueType._zod.run({ value: W[G], issues: [] }, R);
            oe instanceof Promise ? X.push(oe.then((fe) => {
              fe.issues.length && _.issues.push(...r.prefixIssues(G, fe.issues)), _.value[re.value] = fe.value;
            })) : (oe.issues.length && _.issues.push(...r.prefixIssues(G, oe.issues)), _.value[re.value] = oe.value);
          }
        }
        return X.length ? Promise.all(X).then(() => _) : _;
      };
    }), e.$ZodMap = o.$constructor("$ZodMap", (b, y) => {
      e.$ZodType.init(b, y), b._zod.parse = (_, R) => {
        const W = _.value;
        if (!(W instanceof Map))
          return _.issues.push({
            expected: "map",
            code: "invalid_type",
            input: W,
            inst: b
          }), _;
        const X = [];
        _.value = /* @__PURE__ */ new Map();
        for (const [G, re] of W) {
          const oe = y.keyType._zod.run({ value: G, issues: [] }, R), fe = y.valueType._zod.run({ value: re, issues: [] }, R);
          oe instanceof Promise || fe instanceof Promise ? X.push(Promise.all([oe, fe]).then(([$e, ye]) => {
            Q($e, ye, _, G, W, b, R);
          })) : Q(oe, fe, _, G, W, b, R);
        }
        return X.length ? Promise.all(X).then(() => _) : _;
      };
    });
    function Q(b, y, _, R, W, X, G) {
      b.issues.length && (r.propertyKeyTypes.has(typeof R) ? _.issues.push(...r.prefixIssues(R, b.issues)) : _.issues.push({
        code: "invalid_key",
        origin: "map",
        input: W,
        inst: X,
        issues: b.issues.map((re) => r.finalizeIssue(re, G, o.config()))
      })), y.issues.length && (r.propertyKeyTypes.has(typeof R) ? _.issues.push(...r.prefixIssues(R, y.issues)) : _.issues.push({
        origin: "map",
        code: "invalid_element",
        input: W,
        inst: X,
        key: R,
        issues: y.issues.map((re) => r.finalizeIssue(re, G, o.config()))
      })), _.value.set(b.value, y.value);
    }
    e.$ZodSet = o.$constructor("$ZodSet", (b, y) => {
      e.$ZodType.init(b, y), b._zod.parse = (_, R) => {
        const W = _.value;
        if (!(W instanceof Set))
          return _.issues.push({
            input: W,
            inst: b,
            expected: "set",
            code: "invalid_type"
          }), _;
        const X = [];
        _.value = /* @__PURE__ */ new Set();
        for (const G of W) {
          const re = y.valueType._zod.run({ value: G, issues: [] }, R);
          re instanceof Promise ? X.push(re.then((oe) => N(oe, _))) : N(re, _);
        }
        return X.length ? Promise.all(X).then(() => _) : _;
      };
    });
    function N(b, y) {
      b.issues.length && y.issues.push(...b.issues), y.value.add(b.value);
    }
    e.$ZodEnum = o.$constructor("$ZodEnum", (b, y) => {
      e.$ZodType.init(b, y);
      const _ = r.getEnumValues(y.entries), R = new Set(_);
      b._zod.values = R, b._zod.pattern = new RegExp(`^(${_.filter((W) => r.propertyKeyTypes.has(typeof W)).map((W) => typeof W == "string" ? r.escapeRegex(W) : W.toString()).join("|")})$`), b._zod.parse = (W, X) => {
        const G = W.value;
        return R.has(G) || W.issues.push({
          code: "invalid_value",
          values: _,
          input: G,
          inst: b
        }), W;
      };
    }), e.$ZodLiteral = o.$constructor("$ZodLiteral", (b, y) => {
      if (e.$ZodType.init(b, y), y.values.length === 0)
        throw new Error("Cannot create literal schema with no valid values");
      b._zod.values = new Set(y.values), b._zod.pattern = new RegExp(`^(${y.values.map((_) => typeof _ == "string" ? r.escapeRegex(_) : _ ? r.escapeRegex(_.toString()) : String(_)).join("|")})$`), b._zod.parse = (_, R) => {
        const W = _.value;
        return b._zod.values.has(W) || _.issues.push({
          code: "invalid_value",
          values: y.values,
          input: W,
          inst: b
        }), _;
      };
    }), e.$ZodFile = o.$constructor("$ZodFile", (b, y) => {
      e.$ZodType.init(b, y), b._zod.parse = (_, R) => {
        const W = _.value;
        return W instanceof File || _.issues.push({
          expected: "file",
          code: "invalid_type",
          input: W,
          inst: b
        }), _;
      };
    }), e.$ZodTransform = o.$constructor("$ZodTransform", (b, y) => {
      e.$ZodType.init(b, y), b._zod.parse = (_, R) => {
        const W = y.transform(_.value, _);
        if (R.async)
          return (W instanceof Promise ? W : Promise.resolve(W)).then((G) => (_.value = G, _));
        if (W instanceof Promise)
          throw new o.$ZodAsyncError();
        return _.value = W, _;
      };
    });
    function B(b, y) {
      return b.issues.length && y === void 0 ? { issues: [], value: void 0 } : b;
    }
    e.$ZodOptional = o.$constructor("$ZodOptional", (b, y) => {
      e.$ZodType.init(b, y), b._zod.optin = "optional", b._zod.optout = "optional", r.defineLazy(b._zod, "values", () => y.innerType._zod.values ? /* @__PURE__ */ new Set([...y.innerType._zod.values, void 0]) : void 0), r.defineLazy(b._zod, "pattern", () => {
        const _ = y.innerType._zod.pattern;
        return _ ? new RegExp(`^(${r.cleanRegex(_.source)})?$`) : void 0;
      }), b._zod.parse = (_, R) => {
        if (y.innerType._zod.optin === "optional") {
          const W = y.innerType._zod.run(_, R);
          return W instanceof Promise ? W.then((X) => B(X, _.value)) : B(W, _.value);
        }
        return _.value === void 0 ? _ : y.innerType._zod.run(_, R);
      };
    }), e.$ZodNullable = o.$constructor("$ZodNullable", (b, y) => {
      e.$ZodType.init(b, y), r.defineLazy(b._zod, "optin", () => y.innerType._zod.optin), r.defineLazy(b._zod, "optout", () => y.innerType._zod.optout), r.defineLazy(b._zod, "pattern", () => {
        const _ = y.innerType._zod.pattern;
        return _ ? new RegExp(`^(${r.cleanRegex(_.source)}|null)$`) : void 0;
      }), r.defineLazy(b._zod, "values", () => y.innerType._zod.values ? /* @__PURE__ */ new Set([...y.innerType._zod.values, null]) : void 0), b._zod.parse = (_, R) => _.value === null ? _ : y.innerType._zod.run(_, R);
    }), e.$ZodDefault = o.$constructor("$ZodDefault", (b, y) => {
      e.$ZodType.init(b, y), b._zod.optin = "optional", r.defineLazy(b._zod, "values", () => y.innerType._zod.values), b._zod.parse = (_, R) => {
        if (_.value === void 0)
          return _.value = y.defaultValue, _;
        const W = y.innerType._zod.run(_, R);
        return W instanceof Promise ? W.then((X) => V(X, y)) : V(W, y);
      };
    });
    function V(b, y) {
      return b.value === void 0 && (b.value = y.defaultValue), b;
    }
    e.$ZodPrefault = o.$constructor("$ZodPrefault", (b, y) => {
      e.$ZodType.init(b, y), b._zod.optin = "optional", r.defineLazy(b._zod, "values", () => y.innerType._zod.values), b._zod.parse = (_, R) => (_.value === void 0 && (_.value = y.defaultValue), y.innerType._zod.run(_, R));
    }), e.$ZodNonOptional = o.$constructor("$ZodNonOptional", (b, y) => {
      e.$ZodType.init(b, y), r.defineLazy(b._zod, "values", () => {
        const _ = y.innerType._zod.values;
        return _ ? new Set([..._].filter((R) => R !== void 0)) : void 0;
      }), b._zod.parse = (_, R) => {
        const W = y.innerType._zod.run(_, R);
        return W instanceof Promise ? W.then((X) => se(X, b)) : se(W, b);
      };
    });
    function se(b, y) {
      return !b.issues.length && b.value === void 0 && b.issues.push({
        code: "invalid_type",
        expected: "nonoptional",
        input: b.value,
        inst: y
      }), b;
    }
    e.$ZodSuccess = o.$constructor("$ZodSuccess", (b, y) => {
      e.$ZodType.init(b, y), b._zod.parse = (_, R) => {
        const W = y.innerType._zod.run(_, R);
        return W instanceof Promise ? W.then((X) => (_.value = X.issues.length === 0, _)) : (_.value = W.issues.length === 0, _);
      };
    }), e.$ZodCatch = o.$constructor("$ZodCatch", (b, y) => {
      e.$ZodType.init(b, y), r.defineLazy(b._zod, "optin", () => y.innerType._zod.optin), r.defineLazy(b._zod, "optout", () => y.innerType._zod.optout), r.defineLazy(b._zod, "values", () => y.innerType._zod.values), b._zod.parse = (_, R) => {
        const W = y.innerType._zod.run(_, R);
        return W instanceof Promise ? W.then((X) => (_.value = X.value, X.issues.length && (_.value = y.catchValue({
          ..._,
          error: {
            issues: X.issues.map((G) => r.finalizeIssue(G, R, o.config()))
          },
          input: _.value
        }), _.issues = []), _)) : (_.value = W.value, W.issues.length && (_.value = y.catchValue({
          ..._,
          error: {
            issues: W.issues.map((X) => r.finalizeIssue(X, R, o.config()))
          },
          input: _.value
        }), _.issues = []), _);
      };
    }), e.$ZodNaN = o.$constructor("$ZodNaN", (b, y) => {
      e.$ZodType.init(b, y), b._zod.parse = (_, R) => ((typeof _.value != "number" || !Number.isNaN(_.value)) && _.issues.push({
        input: _.value,
        inst: b,
        expected: "nan",
        code: "invalid_type"
      }), _);
    }), e.$ZodPipe = o.$constructor("$ZodPipe", (b, y) => {
      e.$ZodType.init(b, y), r.defineLazy(b._zod, "values", () => y.in._zod.values), r.defineLazy(b._zod, "optin", () => y.in._zod.optin), r.defineLazy(b._zod, "optout", () => y.out._zod.optout), r.defineLazy(b._zod, "propValues", () => y.in._zod.propValues), b._zod.parse = (_, R) => {
        const W = y.in._zod.run(_, R);
        return W instanceof Promise ? W.then((X) => de(X, y, R)) : de(W, y, R);
      };
    });
    function de(b, y, _) {
      return b.issues.length ? b : y.out._zod.run({ value: b.value, issues: b.issues }, _);
    }
    e.$ZodReadonly = o.$constructor("$ZodReadonly", (b, y) => {
      e.$ZodType.init(b, y), r.defineLazy(b._zod, "propValues", () => y.innerType._zod.propValues), r.defineLazy(b._zod, "values", () => y.innerType._zod.values), r.defineLazy(b._zod, "optin", () => y.innerType._zod.optin), r.defineLazy(b._zod, "optout", () => y.innerType._zod.optout), b._zod.parse = (_, R) => {
        const W = y.innerType._zod.run(_, R);
        return W instanceof Promise ? W.then(he) : he(W);
      };
    });
    function he(b) {
      return b.value = Object.freeze(b.value), b;
    }
    e.$ZodTemplateLiteral = o.$constructor("$ZodTemplateLiteral", (b, y) => {
      e.$ZodType.init(b, y);
      const _ = [];
      for (const R of y.parts)
        if (typeof R == "object" && R !== null) {
          if (!R._zod.pattern)
            throw new Error(`Invalid template literal part, no pattern found: ${[...R._zod.traits].shift()}`);
          const W = R._zod.pattern instanceof RegExp ? R._zod.pattern.source : R._zod.pattern;
          if (!W)
            throw new Error(`Invalid template literal part: ${R._zod.traits}`);
          const X = W.startsWith("^") ? 1 : 0, G = W.endsWith("$") ? W.length - 1 : W.length;
          _.push(W.slice(X, G));
        } else if (R === null || r.primitiveTypes.has(typeof R))
          _.push(r.escapeRegex(`${R}`));
        else
          throw new Error(`Invalid template literal part: ${R}`);
      b._zod.pattern = new RegExp(`^${_.join("")}$`), b._zod.parse = (R, W) => typeof R.value != "string" ? (R.issues.push({
        input: R.value,
        inst: b,
        expected: "template_literal",
        code: "invalid_type"
      }), R) : (b._zod.pattern.lastIndex = 0, b._zod.pattern.test(R.value) || R.issues.push({
        input: R.value,
        inst: b,
        code: "invalid_format",
        format: y.format ?? "template_literal",
        pattern: b._zod.pattern.source
      }), R);
    }), e.$ZodPromise = o.$constructor("$ZodPromise", (b, y) => {
      e.$ZodType.init(b, y), b._zod.parse = (_, R) => Promise.resolve(_.value).then((W) => y.innerType._zod.run({ value: W, issues: [] }, R));
    }), e.$ZodLazy = o.$constructor("$ZodLazy", (b, y) => {
      e.$ZodType.init(b, y), r.defineLazy(b._zod, "innerType", () => y.getter()), r.defineLazy(b._zod, "pattern", () => b._zod.innerType._zod.pattern), r.defineLazy(b._zod, "propValues", () => b._zod.innerType._zod.propValues), r.defineLazy(b._zod, "optin", () => b._zod.innerType._zod.optin ?? void 0), r.defineLazy(b._zod, "optout", () => b._zod.innerType._zod.optout ?? void 0), b._zod.parse = (_, R) => b._zod.innerType._zod.run(_, R);
    }), e.$ZodCustom = o.$constructor("$ZodCustom", (b, y) => {
      t.$ZodCheck.init(b, y), e.$ZodType.init(b, y), b._zod.parse = (_, R) => _, b._zod.check = (_) => {
        const R = _.value, W = y.fn(R);
        if (W instanceof Promise)
          return W.then((X) => be(X, _, R, b));
        be(W, _, R, b);
      };
    });
    function be(b, y, _, R) {
      if (!b) {
        const W = {
          code: "custom",
          input: _,
          inst: R,
          // incorporates params.error into issue reporting
          path: [...R._zod.def.path ?? []],
          // incorporates params.error into issue reporting
          continue: !R._zod.def.abort
          // params: inst._zod.def.params,
        };
        R._zod.def.params && (W.params = R._zod.def.params), y.issues.push(r.issue(W));
      }
    }
  }(mt)), mt;
}
var gt = {}, ui = { exports: {} }, Zo;
function bm() {
  return Zo || (Zo = 1, function(e, i) {
    var d = w && w.__createBinding || (Object.create ? function(s, r, u, l) {
      l === void 0 && (l = u);
      var n = Object.getOwnPropertyDescriptor(r, u);
      (!n || ("get" in n ? !r.__esModule : n.writable || n.configurable)) && (n = { enumerable: !0, get: function() {
        return r[u];
      } }), Object.defineProperty(s, l, n);
    } : function(s, r, u, l) {
      l === void 0 && (l = u), s[l] = r[u];
    }), a = w && w.__setModuleDefault || (Object.create ? function(s, r) {
      Object.defineProperty(s, "default", { enumerable: !0, value: r });
    } : function(s, r) {
      s.default = r;
    }), t = w && w.__importStar || function(s) {
      if (s && s.__esModule) return s;
      var r = {};
      if (s != null) for (var u in s) u !== "default" && Object.prototype.hasOwnProperty.call(s, u) && d(r, s, u);
      return a(r, s), r;
    };
    Object.defineProperty(i, "__esModule", { value: !0 }), i.default = p;
    const o = t(pe()), m = () => {
      const s = {
        string: { unit: "حرف", verb: "أن يحوي" },
        file: { unit: "بايت", verb: "أن يحوي" },
        array: { unit: "عنصر", verb: "أن يحوي" },
        set: { unit: "عنصر", verb: "أن يحوي" }
      };
      function r(n) {
        return s[n] ?? null;
      }
      const u = (n) => {
        const f = typeof n;
        switch (f) {
          case "number":
            return Number.isNaN(n) ? "NaN" : "number";
          case "object": {
            if (Array.isArray(n))
              return "array";
            if (n === null)
              return "null";
            if (Object.getPrototypeOf(n) !== Object.prototype && n.constructor)
              return n.constructor.name;
          }
        }
        return f;
      }, l = {
        regex: "مدخل",
        email: "بريد إلكتروني",
        url: "رابط",
        emoji: "إيموجي",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "تاريخ ووقت بمعيار ISO",
        date: "تاريخ بمعيار ISO",
        time: "وقت بمعيار ISO",
        duration: "مدة بمعيار ISO",
        ipv4: "عنوان IPv4",
        ipv6: "عنوان IPv6",
        cidrv4: "مدى عناوين بصيغة IPv4",
        cidrv6: "مدى عناوين بصيغة IPv6",
        base64: "نَص بترميز base64-encoded",
        base64url: "نَص بترميز base64url-encoded",
        json_string: "نَص على هيئة JSON",
        e164: "رقم هاتف بمعيار E.164",
        jwt: "JWT",
        template_literal: "مدخل"
      };
      return (n) => {
        switch (n.code) {
          case "invalid_type":
            return `مدخلات غير مقبولة: يفترض إدخال ${n.expected}، ولكن تم إدخال ${u(n.input)}`;
          case "invalid_value":
            return n.values.length === 1 ? `مدخلات غير مقبولة: يفترض إدخال ${o.stringifyPrimitive(n.values[0])}` : `اختيار غير مقبول: يتوقع انتقاء أحد هذه الخيارات: ${o.joinValues(n.values, "|")}`;
          case "too_big": {
            const f = n.inclusive ? "<=" : "<", v = r(n.origin);
            return v ? ` أكبر من اللازم: يفترض أن تكون ${n.origin ?? "القيمة"} ${f} ${n.maximum.toString()} ${v.unit ?? "عنصر"}` : `أكبر من اللازم: يفترض أن تكون ${n.origin ?? "القيمة"} ${f} ${n.maximum.toString()}`;
          }
          case "too_small": {
            const f = n.inclusive ? ">=" : ">", v = r(n.origin);
            return v ? `أصغر من اللازم: يفترض لـ ${n.origin} أن يكون ${f} ${n.minimum.toString()} ${v.unit}` : `أصغر من اللازم: يفترض لـ ${n.origin} أن يكون ${f} ${n.minimum.toString()}`;
          }
          case "invalid_format": {
            const f = n;
            return f.format === "starts_with" ? `نَص غير مقبول: يجب أن يبدأ بـ "${n.prefix}"` : f.format === "ends_with" ? `نَص غير مقبول: يجب أن ينتهي بـ "${f.suffix}"` : f.format === "includes" ? `نَص غير مقبول: يجب أن يتضمَّن "${f.includes}"` : f.format === "regex" ? `نَص غير مقبول: يجب أن يطابق النمط ${f.pattern}` : `${l[f.format] ?? n.format} غير مقبول`;
          }
          case "not_multiple_of":
            return `رقم غير مقبول: يجب أن يكون من مضاعفات ${n.divisor}`;
          case "unrecognized_keys":
            return `معرف${n.keys.length > 1 ? "ات" : ""} غريب${n.keys.length > 1 ? "ة" : ""}: ${o.joinValues(n.keys, "، ")}`;
          case "invalid_key":
            return `معرف غير مقبول في ${n.origin}`;
          case "invalid_union":
            return "مدخل غير مقبول";
          case "invalid_element":
            return `مدخل غير مقبول في ${n.origin}`;
          default:
            return "مدخل غير مقبول";
        }
      };
    };
    function p() {
      return {
        localeError: m()
      };
    }
    e.exports = i.default;
  }(ui, ui.exports)), ui.exports;
}
var fi = { exports: {} }, Ao;
function ym() {
  return Ao || (Ao = 1, function(e, i) {
    var d = w && w.__createBinding || (Object.create ? function(s, r, u, l) {
      l === void 0 && (l = u);
      var n = Object.getOwnPropertyDescriptor(r, u);
      (!n || ("get" in n ? !r.__esModule : n.writable || n.configurable)) && (n = { enumerable: !0, get: function() {
        return r[u];
      } }), Object.defineProperty(s, l, n);
    } : function(s, r, u, l) {
      l === void 0 && (l = u), s[l] = r[u];
    }), a = w && w.__setModuleDefault || (Object.create ? function(s, r) {
      Object.defineProperty(s, "default", { enumerable: !0, value: r });
    } : function(s, r) {
      s.default = r;
    }), t = w && w.__importStar || function(s) {
      if (s && s.__esModule) return s;
      var r = {};
      if (s != null) for (var u in s) u !== "default" && Object.prototype.hasOwnProperty.call(s, u) && d(r, s, u);
      return a(r, s), r;
    };
    Object.defineProperty(i, "__esModule", { value: !0 }), i.default = p;
    const o = t(pe()), m = () => {
      const s = {
        string: { unit: "simvol", verb: "olmalıdır" },
        file: { unit: "bayt", verb: "olmalıdır" },
        array: { unit: "element", verb: "olmalıdır" },
        set: { unit: "element", verb: "olmalıdır" }
      };
      function r(n) {
        return s[n] ?? null;
      }
      const u = (n) => {
        const f = typeof n;
        switch (f) {
          case "number":
            return Number.isNaN(n) ? "NaN" : "number";
          case "object": {
            if (Array.isArray(n))
              return "array";
            if (n === null)
              return "null";
            if (Object.getPrototypeOf(n) !== Object.prototype && n.constructor)
              return n.constructor.name;
          }
        }
        return f;
      }, l = {
        regex: "input",
        email: "email address",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO datetime",
        date: "ISO date",
        time: "ISO time",
        duration: "ISO duration",
        ipv4: "IPv4 address",
        ipv6: "IPv6 address",
        cidrv4: "IPv4 range",
        cidrv6: "IPv6 range",
        base64: "base64-encoded string",
        base64url: "base64url-encoded string",
        json_string: "JSON string",
        e164: "E.164 number",
        jwt: "JWT",
        template_literal: "input"
      };
      return (n) => {
        switch (n.code) {
          case "invalid_type":
            return `Yanlış dəyər: gözlənilən ${n.expected}, daxil olan ${u(n.input)}`;
          case "invalid_value":
            return n.values.length === 1 ? `Yanlış dəyər: gözlənilən ${o.stringifyPrimitive(n.values[0])}` : `Yanlış seçim: aşağıdakılardan biri olmalıdır: ${o.joinValues(n.values, "|")}`;
          case "too_big": {
            const f = n.inclusive ? "<=" : "<", v = r(n.origin);
            return v ? `Çox böyük: gözlənilən ${n.origin ?? "dəyər"} ${f}${n.maximum.toString()} ${v.unit ?? "element"}` : `Çox böyük: gözlənilən ${n.origin ?? "dəyər"} ${f}${n.maximum.toString()}`;
          }
          case "too_small": {
            const f = n.inclusive ? ">=" : ">", v = r(n.origin);
            return v ? `Çox kiçik: gözlənilən ${n.origin} ${f}${n.minimum.toString()} ${v.unit}` : `Çox kiçik: gözlənilən ${n.origin} ${f}${n.minimum.toString()}`;
          }
          case "invalid_format": {
            const f = n;
            return f.format === "starts_with" ? `Yanlış mətn: "${f.prefix}" ilə başlamalıdır` : f.format === "ends_with" ? `Yanlış mətn: "${f.suffix}" ilə bitməlidir` : f.format === "includes" ? `Yanlış mətn: "${f.includes}" daxil olmalıdır` : f.format === "regex" ? `Yanlış mətn: ${f.pattern} şablonuna uyğun olmalıdır` : `Yanlış ${l[f.format] ?? n.format}`;
          }
          case "not_multiple_of":
            return `Yanlış ədəd: ${n.divisor} ilə bölünə bilən olmalıdır`;
          case "unrecognized_keys":
            return `Tanınmayan açar${n.keys.length > 1 ? "lar" : ""}: ${o.joinValues(n.keys, ", ")}`;
          case "invalid_key":
            return `${n.origin} daxilində yanlış açar`;
          case "invalid_union":
            return "Yanlış dəyər";
          case "invalid_element":
            return `${n.origin} daxilində yanlış dəyər`;
          default:
            return "Yanlış dəyər";
        }
      };
    };
    function p() {
      return {
        localeError: m()
      };
    }
    e.exports = i.default;
  }(fi, fi.exports)), fi.exports;
}
var li = { exports: {} }, Vo;
function km() {
  return Vo || (Vo = 1, function(e, i) {
    var d = w && w.__createBinding || (Object.create ? function(r, u, l, n) {
      n === void 0 && (n = l);
      var f = Object.getOwnPropertyDescriptor(u, l);
      (!f || ("get" in f ? !u.__esModule : f.writable || f.configurable)) && (f = { enumerable: !0, get: function() {
        return u[l];
      } }), Object.defineProperty(r, n, f);
    } : function(r, u, l, n) {
      n === void 0 && (n = l), r[n] = u[l];
    }), a = w && w.__setModuleDefault || (Object.create ? function(r, u) {
      Object.defineProperty(r, "default", { enumerable: !0, value: u });
    } : function(r, u) {
      r.default = u;
    }), t = w && w.__importStar || function(r) {
      if (r && r.__esModule) return r;
      var u = {};
      if (r != null) for (var l in r) l !== "default" && Object.prototype.hasOwnProperty.call(r, l) && d(u, r, l);
      return a(u, r), u;
    };
    Object.defineProperty(i, "__esModule", { value: !0 }), i.default = s;
    const o = t(pe());
    function m(r, u, l, n) {
      const f = Math.abs(r), v = f % 10, D = f % 100;
      return D >= 11 && D <= 19 ? n : v === 1 ? u : v >= 2 && v <= 4 ? l : n;
    }
    const p = () => {
      const r = {
        string: {
          unit: {
            one: "сімвал",
            few: "сімвалы",
            many: "сімвалаў"
          },
          verb: "мець"
        },
        array: {
          unit: {
            one: "элемент",
            few: "элементы",
            many: "элементаў"
          },
          verb: "мець"
        },
        set: {
          unit: {
            one: "элемент",
            few: "элементы",
            many: "элементаў"
          },
          verb: "мець"
        },
        file: {
          unit: {
            one: "байт",
            few: "байты",
            many: "байтаў"
          },
          verb: "мець"
        }
      };
      function u(f) {
        return r[f] ?? null;
      }
      const l = (f) => {
        const v = typeof f;
        switch (v) {
          case "number":
            return Number.isNaN(f) ? "NaN" : "лік";
          case "object": {
            if (Array.isArray(f))
              return "масіў";
            if (f === null)
              return "null";
            if (Object.getPrototypeOf(f) !== Object.prototype && f.constructor)
              return f.constructor.name;
          }
        }
        return v;
      }, n = {
        regex: "увод",
        email: "email адрас",
        url: "URL",
        emoji: "эмодзі",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO дата і час",
        date: "ISO дата",
        time: "ISO час",
        duration: "ISO працягласць",
        ipv4: "IPv4 адрас",
        ipv6: "IPv6 адрас",
        cidrv4: "IPv4 дыяпазон",
        cidrv6: "IPv6 дыяпазон",
        base64: "радок у фармаце base64",
        base64url: "радок у фармаце base64url",
        json_string: "JSON радок",
        e164: "нумар E.164",
        jwt: "JWT",
        template_literal: "увод"
      };
      return (f) => {
        switch (f.code) {
          case "invalid_type":
            return `Няправільны ўвод: чакаўся ${f.expected}, атрымана ${l(f.input)}`;
          case "invalid_value":
            return f.values.length === 1 ? `Няправільны ўвод: чакалася ${o.stringifyPrimitive(f.values[0])}` : `Няправільны варыянт: чакаўся адзін з ${o.joinValues(f.values, "|")}`;
          case "too_big": {
            const v = f.inclusive ? "<=" : "<", D = u(f.origin);
            if (D) {
              const F = Number(f.maximum), A = m(F, D.unit.one, D.unit.few, D.unit.many);
              return `Занадта вялікі: чакалася, што ${f.origin ?? "значэнне"} павінна ${D.verb} ${v}${f.maximum.toString()} ${A}`;
            }
            return `Занадта вялікі: чакалася, што ${f.origin ?? "значэнне"} павінна быць ${v}${f.maximum.toString()}`;
          }
          case "too_small": {
            const v = f.inclusive ? ">=" : ">", D = u(f.origin);
            if (D) {
              const F = Number(f.minimum), A = m(F, D.unit.one, D.unit.few, D.unit.many);
              return `Занадта малы: чакалася, што ${f.origin} павінна ${D.verb} ${v}${f.minimum.toString()} ${A}`;
            }
            return `Занадта малы: чакалася, што ${f.origin} павінна быць ${v}${f.minimum.toString()}`;
          }
          case "invalid_format": {
            const v = f;
            return v.format === "starts_with" ? `Няправільны радок: павінен пачынацца з "${v.prefix}"` : v.format === "ends_with" ? `Няправільны радок: павінен заканчвацца на "${v.suffix}"` : v.format === "includes" ? `Няправільны радок: павінен змяшчаць "${v.includes}"` : v.format === "regex" ? `Няправільны радок: павінен адпавядаць шаблону ${v.pattern}` : `Няправільны ${n[v.format] ?? f.format}`;
          }
          case "not_multiple_of":
            return `Няправільны лік: павінен быць кратным ${f.divisor}`;
          case "unrecognized_keys":
            return `Нераспазнаны ${f.keys.length > 1 ? "ключы" : "ключ"}: ${o.joinValues(f.keys, ", ")}`;
          case "invalid_key":
            return `Няправільны ключ у ${f.origin}`;
          case "invalid_union":
            return "Няправільны ўвод";
          case "invalid_element":
            return `Няправільнае значэнне ў ${f.origin}`;
          default:
            return "Няправільны ўвод";
        }
      };
    };
    function s() {
      return {
        localeError: p()
      };
    }
    e.exports = i.default;
  }(li, li.exports)), li.exports;
}
var ci = { exports: {} }, Ho;
function wm() {
  return Ho || (Ho = 1, function(e, i) {
    var d = w && w.__createBinding || (Object.create ? function(s, r, u, l) {
      l === void 0 && (l = u);
      var n = Object.getOwnPropertyDescriptor(r, u);
      (!n || ("get" in n ? !r.__esModule : n.writable || n.configurable)) && (n = { enumerable: !0, get: function() {
        return r[u];
      } }), Object.defineProperty(s, l, n);
    } : function(s, r, u, l) {
      l === void 0 && (l = u), s[l] = r[u];
    }), a = w && w.__setModuleDefault || (Object.create ? function(s, r) {
      Object.defineProperty(s, "default", { enumerable: !0, value: r });
    } : function(s, r) {
      s.default = r;
    }), t = w && w.__importStar || function(s) {
      if (s && s.__esModule) return s;
      var r = {};
      if (s != null) for (var u in s) u !== "default" && Object.prototype.hasOwnProperty.call(s, u) && d(r, s, u);
      return a(r, s), r;
    };
    Object.defineProperty(i, "__esModule", { value: !0 }), i.default = p;
    const o = t(pe()), m = () => {
      const s = {
        string: { unit: "caràcters", verb: "contenir" },
        file: { unit: "bytes", verb: "contenir" },
        array: { unit: "elements", verb: "contenir" },
        set: { unit: "elements", verb: "contenir" }
      };
      function r(n) {
        return s[n] ?? null;
      }
      const u = (n) => {
        const f = typeof n;
        switch (f) {
          case "number":
            return Number.isNaN(n) ? "NaN" : "number";
          case "object": {
            if (Array.isArray(n))
              return "array";
            if (n === null)
              return "null";
            if (Object.getPrototypeOf(n) !== Object.prototype && n.constructor)
              return n.constructor.name;
          }
        }
        return f;
      }, l = {
        regex: "entrada",
        email: "adreça electrònica",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "data i hora ISO",
        date: "data ISO",
        time: "hora ISO",
        duration: "durada ISO",
        ipv4: "adreça IPv4",
        ipv6: "adreça IPv6",
        cidrv4: "rang IPv4",
        cidrv6: "rang IPv6",
        base64: "cadena codificada en base64",
        base64url: "cadena codificada en base64url",
        json_string: "cadena JSON",
        e164: "número E.164",
        jwt: "JWT",
        template_literal: "entrada"
      };
      return (n) => {
        switch (n.code) {
          case "invalid_type":
            return `Tipus invàlid: s'esperava ${n.expected}, s'ha rebut ${u(n.input)}`;
          case "invalid_value":
            return n.values.length === 1 ? `Valor invàlid: s'esperava ${o.stringifyPrimitive(n.values[0])}` : `Opció invàlida: s'esperava una de ${o.joinValues(n.values, " o ")}`;
          case "too_big": {
            const f = n.inclusive ? "com a màxim" : "menys de", v = r(n.origin);
            return v ? `Massa gran: s'esperava que ${n.origin ?? "el valor"} contingués ${f} ${n.maximum.toString()} ${v.unit ?? "elements"}` : `Massa gran: s'esperava que ${n.origin ?? "el valor"} fos ${f} ${n.maximum.toString()}`;
          }
          case "too_small": {
            const f = n.inclusive ? "com a mínim" : "més de", v = r(n.origin);
            return v ? `Massa petit: s'esperava que ${n.origin} contingués ${f} ${n.minimum.toString()} ${v.unit}` : `Massa petit: s'esperava que ${n.origin} fos ${f} ${n.minimum.toString()}`;
          }
          case "invalid_format": {
            const f = n;
            return f.format === "starts_with" ? `Format invàlid: ha de començar amb "${f.prefix}"` : f.format === "ends_with" ? `Format invàlid: ha d'acabar amb "${f.suffix}"` : f.format === "includes" ? `Format invàlid: ha d'incloure "${f.includes}"` : f.format === "regex" ? `Format invàlid: ha de coincidir amb el patró ${f.pattern}` : `Format invàlid per a ${l[f.format] ?? n.format}`;
          }
          case "not_multiple_of":
            return `Número invàlid: ha de ser múltiple de ${n.divisor}`;
          case "unrecognized_keys":
            return `Clau${n.keys.length > 1 ? "s" : ""} no reconeguda${n.keys.length > 1 ? "s" : ""}: ${o.joinValues(n.keys, ", ")}`;
          case "invalid_key":
            return `Clau invàlida a ${n.origin}`;
          case "invalid_union":
            return "Entrada invàlida";
          case "invalid_element":
            return `Element invàlid a ${n.origin}`;
          default:
            return "Entrada invàlida";
        }
      };
    };
    function p() {
      return {
        localeError: m()
      };
    }
    e.exports = i.default;
  }(ci, ci.exports)), ci.exports;
}
var mi = { exports: {} }, Uo;
function _m() {
  return Uo || (Uo = 1, function(e, i) {
    var d = w && w.__createBinding || (Object.create ? function(s, r, u, l) {
      l === void 0 && (l = u);
      var n = Object.getOwnPropertyDescriptor(r, u);
      (!n || ("get" in n ? !r.__esModule : n.writable || n.configurable)) && (n = { enumerable: !0, get: function() {
        return r[u];
      } }), Object.defineProperty(s, l, n);
    } : function(s, r, u, l) {
      l === void 0 && (l = u), s[l] = r[u];
    }), a = w && w.__setModuleDefault || (Object.create ? function(s, r) {
      Object.defineProperty(s, "default", { enumerable: !0, value: r });
    } : function(s, r) {
      s.default = r;
    }), t = w && w.__importStar || function(s) {
      if (s && s.__esModule) return s;
      var r = {};
      if (s != null) for (var u in s) u !== "default" && Object.prototype.hasOwnProperty.call(s, u) && d(r, s, u);
      return a(r, s), r;
    };
    Object.defineProperty(i, "__esModule", { value: !0 }), i.default = p;
    const o = t(pe()), m = () => {
      const s = {
        string: { unit: "znaků", verb: "mít" },
        file: { unit: "bajtů", verb: "mít" },
        array: { unit: "prvků", verb: "mít" },
        set: { unit: "prvků", verb: "mít" }
      };
      function r(n) {
        return s[n] ?? null;
      }
      const u = (n) => {
        const f = typeof n;
        switch (f) {
          case "number":
            return Number.isNaN(n) ? "NaN" : "číslo";
          case "string":
            return "řetězec";
          case "boolean":
            return "boolean";
          case "bigint":
            return "bigint";
          case "function":
            return "funkce";
          case "symbol":
            return "symbol";
          case "undefined":
            return "undefined";
          case "object": {
            if (Array.isArray(n))
              return "pole";
            if (n === null)
              return "null";
            if (Object.getPrototypeOf(n) !== Object.prototype && n.constructor)
              return n.constructor.name;
          }
        }
        return f;
      }, l = {
        regex: "regulární výraz",
        email: "e-mailová adresa",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "datum a čas ve formátu ISO",
        date: "datum ve formátu ISO",
        time: "čas ve formátu ISO",
        duration: "doba trvání ISO",
        ipv4: "IPv4 adresa",
        ipv6: "IPv6 adresa",
        cidrv4: "rozsah IPv4",
        cidrv6: "rozsah IPv6",
        base64: "řetězec zakódovaný ve formátu base64",
        base64url: "řetězec zakódovaný ve formátu base64url",
        json_string: "řetězec ve formátu JSON",
        e164: "číslo E.164",
        jwt: "JWT",
        template_literal: "vstup"
      };
      return (n) => {
        switch (n.code) {
          case "invalid_type":
            return `Neplatný vstup: očekáváno ${n.expected}, obdrženo ${u(n.input)}`;
          case "invalid_value":
            return n.values.length === 1 ? `Neplatný vstup: očekáváno ${o.stringifyPrimitive(n.values[0])}` : `Neplatná možnost: očekávána jedna z hodnot ${o.joinValues(n.values, "|")}`;
          case "too_big": {
            const f = n.inclusive ? "<=" : "<", v = r(n.origin);
            return v ? `Hodnota je příliš velká: ${n.origin ?? "hodnota"} musí mít ${f}${n.maximum.toString()} ${v.unit ?? "prvků"}` : `Hodnota je příliš velká: ${n.origin ?? "hodnota"} musí být ${f}${n.maximum.toString()}`;
          }
          case "too_small": {
            const f = n.inclusive ? ">=" : ">", v = r(n.origin);
            return v ? `Hodnota je příliš malá: ${n.origin ?? "hodnota"} musí mít ${f}${n.minimum.toString()} ${v.unit ?? "prvků"}` : `Hodnota je příliš malá: ${n.origin ?? "hodnota"} musí být ${f}${n.minimum.toString()}`;
          }
          case "invalid_format": {
            const f = n;
            return f.format === "starts_with" ? `Neplatný řetězec: musí začínat na "${f.prefix}"` : f.format === "ends_with" ? `Neplatný řetězec: musí končit na "${f.suffix}"` : f.format === "includes" ? `Neplatný řetězec: musí obsahovat "${f.includes}"` : f.format === "regex" ? `Neplatný řetězec: musí odpovídat vzoru ${f.pattern}` : `Neplatný formát ${l[f.format] ?? n.format}`;
          }
          case "not_multiple_of":
            return `Neplatné číslo: musí být násobkem ${n.divisor}`;
          case "unrecognized_keys":
            return `Neznámé klíče: ${o.joinValues(n.keys, ", ")}`;
          case "invalid_key":
            return `Neplatný klíč v ${n.origin}`;
          case "invalid_union":
            return "Neplatný vstup";
          case "invalid_element":
            return `Neplatná hodnota v ${n.origin}`;
          default:
            return "Neplatný vstup";
        }
      };
    };
    function p() {
      return {
        localeError: m()
      };
    }
    e.exports = i.default;
  }(mi, mi.exports)), mi.exports;
}
var vi = { exports: {} }, Bo;
function $m() {
  return Bo || (Bo = 1, function(e, i) {
    var d = w && w.__createBinding || (Object.create ? function(s, r, u, l) {
      l === void 0 && (l = u);
      var n = Object.getOwnPropertyDescriptor(r, u);
      (!n || ("get" in n ? !r.__esModule : n.writable || n.configurable)) && (n = { enumerable: !0, get: function() {
        return r[u];
      } }), Object.defineProperty(s, l, n);
    } : function(s, r, u, l) {
      l === void 0 && (l = u), s[l] = r[u];
    }), a = w && w.__setModuleDefault || (Object.create ? function(s, r) {
      Object.defineProperty(s, "default", { enumerable: !0, value: r });
    } : function(s, r) {
      s.default = r;
    }), t = w && w.__importStar || function(s) {
      if (s && s.__esModule) return s;
      var r = {};
      if (s != null) for (var u in s) u !== "default" && Object.prototype.hasOwnProperty.call(s, u) && d(r, s, u);
      return a(r, s), r;
    };
    Object.defineProperty(i, "__esModule", { value: !0 }), i.default = p;
    const o = t(pe()), m = () => {
      const s = {
        string: { unit: "tegn", verb: "havde" },
        file: { unit: "bytes", verb: "havde" },
        array: { unit: "elementer", verb: "indeholdt" },
        set: { unit: "elementer", verb: "indeholdt" }
      }, r = {
        string: "streng",
        number: "tal",
        boolean: "boolean",
        array: "liste",
        object: "objekt",
        set: "sæt",
        file: "fil"
      };
      function u(v) {
        return s[v] ?? null;
      }
      function l(v) {
        return r[v] ?? v;
      }
      const n = (v) => {
        const D = typeof v;
        switch (D) {
          case "number":
            return Number.isNaN(v) ? "NaN" : "tal";
          case "object":
            return Array.isArray(v) ? "liste" : v === null ? "null" : Object.getPrototypeOf(v) !== Object.prototype && v.constructor ? v.constructor.name : "objekt";
        }
        return D;
      }, f = {
        regex: "input",
        email: "e-mailadresse",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO dato- og klokkeslæt",
        date: "ISO-dato",
        time: "ISO-klokkeslæt",
        duration: "ISO-varighed",
        ipv4: "IPv4-område",
        ipv6: "IPv6-område",
        cidrv4: "IPv4-spektrum",
        cidrv6: "IPv6-spektrum",
        base64: "base64-kodet streng",
        base64url: "base64url-kodet streng",
        json_string: "JSON-streng",
        e164: "E.164-nummer",
        jwt: "JWT",
        template_literal: "input"
      };
      return (v) => {
        switch (v.code) {
          case "invalid_type":
            return `Ugyldigt input: forventede ${l(v.expected)}, fik ${l(n(v.input))}`;
          case "invalid_value":
            return v.values.length === 1 ? `Ugyldig værdi: forventede ${o.stringifyPrimitive(v.values[0])}` : `Ugyldigt valg: forventede en af følgende ${o.joinValues(v.values, "|")}`;
          case "too_big": {
            const D = v.inclusive ? "<=" : "<", F = u(v.origin), A = l(v.origin);
            return F ? `For stor: forventede ${A ?? "value"} ${F.verb} ${D} ${v.maximum.toString()} ${F.unit ?? "elementer"}` : `For stor: forventede ${A ?? "value"} havde ${D} ${v.maximum.toString()}`;
          }
          case "too_small": {
            const D = v.inclusive ? ">=" : ">", F = u(v.origin), A = l(v.origin);
            return F ? `For lille: forventede ${A} ${F.verb} ${D} ${v.minimum.toString()} ${F.unit}` : `For lille: forventede ${A} havde ${D} ${v.minimum.toString()}`;
          }
          case "invalid_format": {
            const D = v;
            return D.format === "starts_with" ? `Ugyldig streng: skal starte med "${D.prefix}"` : D.format === "ends_with" ? `Ugyldig streng: skal ende med "${D.suffix}"` : D.format === "includes" ? `Ugyldig streng: skal indeholde "${D.includes}"` : D.format === "regex" ? `Ugyldig streng: skal matche mønsteret ${D.pattern}` : `Ugyldig ${f[D.format] ?? v.format}`;
          }
          case "not_multiple_of":
            return `Ugyldigt tal: skal være deleligt med ${v.divisor}`;
          case "unrecognized_keys":
            return `${v.keys.length > 1 ? "Ukendte nøgler" : "Ukendt nøgle"}: ${o.joinValues(v.keys, ", ")}`;
          case "invalid_key":
            return `Ugyldig nøgle i ${v.origin}`;
          case "invalid_union":
            return "Ugyldigt input: matcher ingen af de tilladte typer";
          case "invalid_element":
            return `Ugyldig værdi i ${v.origin}`;
          default:
            return "Ugyldigt input";
        }
      };
    };
    function p() {
      return {
        localeError: m()
      };
    }
    e.exports = i.default;
  }(vi, vi.exports)), vi.exports;
}
var hi = { exports: {} }, Xo;
function Pm() {
  return Xo || (Xo = 1, function(e, i) {
    var d = w && w.__createBinding || (Object.create ? function(s, r, u, l) {
      l === void 0 && (l = u);
      var n = Object.getOwnPropertyDescriptor(r, u);
      (!n || ("get" in n ? !r.__esModule : n.writable || n.configurable)) && (n = { enumerable: !0, get: function() {
        return r[u];
      } }), Object.defineProperty(s, l, n);
    } : function(s, r, u, l) {
      l === void 0 && (l = u), s[l] = r[u];
    }), a = w && w.__setModuleDefault || (Object.create ? function(s, r) {
      Object.defineProperty(s, "default", { enumerable: !0, value: r });
    } : function(s, r) {
      s.default = r;
    }), t = w && w.__importStar || function(s) {
      if (s && s.__esModule) return s;
      var r = {};
      if (s != null) for (var u in s) u !== "default" && Object.prototype.hasOwnProperty.call(s, u) && d(r, s, u);
      return a(r, s), r;
    };
    Object.defineProperty(i, "__esModule", { value: !0 }), i.default = p;
    const o = t(pe()), m = () => {
      const s = {
        string: { unit: "Zeichen", verb: "zu haben" },
        file: { unit: "Bytes", verb: "zu haben" },
        array: { unit: "Elemente", verb: "zu haben" },
        set: { unit: "Elemente", verb: "zu haben" }
      };
      function r(n) {
        return s[n] ?? null;
      }
      const u = (n) => {
        const f = typeof n;
        switch (f) {
          case "number":
            return Number.isNaN(n) ? "NaN" : "Zahl";
          case "object": {
            if (Array.isArray(n))
              return "Array";
            if (n === null)
              return "null";
            if (Object.getPrototypeOf(n) !== Object.prototype && n.constructor)
              return n.constructor.name;
          }
        }
        return f;
      }, l = {
        regex: "Eingabe",
        email: "E-Mail-Adresse",
        url: "URL",
        emoji: "Emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO-Datum und -Uhrzeit",
        date: "ISO-Datum",
        time: "ISO-Uhrzeit",
        duration: "ISO-Dauer",
        ipv4: "IPv4-Adresse",
        ipv6: "IPv6-Adresse",
        cidrv4: "IPv4-Bereich",
        cidrv6: "IPv6-Bereich",
        base64: "Base64-codierter String",
        base64url: "Base64-URL-codierter String",
        json_string: "JSON-String",
        e164: "E.164-Nummer",
        jwt: "JWT",
        template_literal: "Eingabe"
      };
      return (n) => {
        switch (n.code) {
          case "invalid_type":
            return `Ungültige Eingabe: erwartet ${n.expected}, erhalten ${u(n.input)}`;
          case "invalid_value":
            return n.values.length === 1 ? `Ungültige Eingabe: erwartet ${o.stringifyPrimitive(n.values[0])}` : `Ungültige Option: erwartet eine von ${o.joinValues(n.values, "|")}`;
          case "too_big": {
            const f = n.inclusive ? "<=" : "<", v = r(n.origin);
            return v ? `Zu groß: erwartet, dass ${n.origin ?? "Wert"} ${f}${n.maximum.toString()} ${v.unit ?? "Elemente"} hat` : `Zu groß: erwartet, dass ${n.origin ?? "Wert"} ${f}${n.maximum.toString()} ist`;
          }
          case "too_small": {
            const f = n.inclusive ? ">=" : ">", v = r(n.origin);
            return v ? `Zu klein: erwartet, dass ${n.origin} ${f}${n.minimum.toString()} ${v.unit} hat` : `Zu klein: erwartet, dass ${n.origin} ${f}${n.minimum.toString()} ist`;
          }
          case "invalid_format": {
            const f = n;
            return f.format === "starts_with" ? `Ungültiger String: muss mit "${f.prefix}" beginnen` : f.format === "ends_with" ? `Ungültiger String: muss mit "${f.suffix}" enden` : f.format === "includes" ? `Ungültiger String: muss "${f.includes}" enthalten` : f.format === "regex" ? `Ungültiger String: muss dem Muster ${f.pattern} entsprechen` : `Ungültig: ${l[f.format] ?? n.format}`;
          }
          case "not_multiple_of":
            return `Ungültige Zahl: muss ein Vielfaches von ${n.divisor} sein`;
          case "unrecognized_keys":
            return `${n.keys.length > 1 ? "Unbekannte Schlüssel" : "Unbekannter Schlüssel"}: ${o.joinValues(n.keys, ", ")}`;
          case "invalid_key":
            return `Ungültiger Schlüssel in ${n.origin}`;
          case "invalid_union":
            return "Ungültige Eingabe";
          case "invalid_element":
            return `Ungültiger Wert in ${n.origin}`;
          default:
            return "Ungültige Eingabe";
        }
      };
    };
    function p() {
      return {
        localeError: m()
      };
    }
    e.exports = i.default;
  }(hi, hi.exports)), hi.exports;
}
var pt = {}, Go;
function ku() {
  return Go || (Go = 1, function(e) {
    var i = w && w.__createBinding || (Object.create ? function(s, r, u, l) {
      l === void 0 && (l = u);
      var n = Object.getOwnPropertyDescriptor(r, u);
      (!n || ("get" in n ? !r.__esModule : n.writable || n.configurable)) && (n = { enumerable: !0, get: function() {
        return r[u];
      } }), Object.defineProperty(s, l, n);
    } : function(s, r, u, l) {
      l === void 0 && (l = u), s[l] = r[u];
    }), d = w && w.__setModuleDefault || (Object.create ? function(s, r) {
      Object.defineProperty(s, "default", { enumerable: !0, value: r });
    } : function(s, r) {
      s.default = r;
    }), a = w && w.__importStar || function(s) {
      if (s && s.__esModule) return s;
      var r = {};
      if (s != null) for (var u in s) u !== "default" && Object.prototype.hasOwnProperty.call(s, u) && i(r, s, u);
      return d(r, s), r;
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), e.parsedType = void 0, e.default = p;
    const t = a(pe()), o = (s) => {
      const r = typeof s;
      switch (r) {
        case "number":
          return Number.isNaN(s) ? "NaN" : "number";
        case "object": {
          if (Array.isArray(s))
            return "array";
          if (s === null)
            return "null";
          if (Object.getPrototypeOf(s) !== Object.prototype && s.constructor)
            return s.constructor.name;
        }
      }
      return r;
    };
    e.parsedType = o;
    const m = () => {
      const s = {
        string: { unit: "characters", verb: "to have" },
        file: { unit: "bytes", verb: "to have" },
        array: { unit: "items", verb: "to have" },
        set: { unit: "items", verb: "to have" }
      };
      function r(l) {
        return s[l] ?? null;
      }
      const u = {
        regex: "input",
        email: "email address",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO datetime",
        date: "ISO date",
        time: "ISO time",
        duration: "ISO duration",
        ipv4: "IPv4 address",
        ipv6: "IPv6 address",
        cidrv4: "IPv4 range",
        cidrv6: "IPv6 range",
        base64: "base64-encoded string",
        base64url: "base64url-encoded string",
        json_string: "JSON string",
        e164: "E.164 number",
        jwt: "JWT",
        template_literal: "input"
      };
      return (l) => {
        switch (l.code) {
          case "invalid_type":
            return `Invalid input: expected ${l.expected}, received ${(0, e.parsedType)(l.input)}`;
          case "invalid_value":
            return l.values.length === 1 ? `Invalid input: expected ${t.stringifyPrimitive(l.values[0])}` : `Invalid option: expected one of ${t.joinValues(l.values, "|")}`;
          case "too_big": {
            const n = l.inclusive ? "<=" : "<", f = r(l.origin);
            return f ? `Too big: expected ${l.origin ?? "value"} to have ${n}${l.maximum.toString()} ${f.unit ?? "elements"}` : `Too big: expected ${l.origin ?? "value"} to be ${n}${l.maximum.toString()}`;
          }
          case "too_small": {
            const n = l.inclusive ? ">=" : ">", f = r(l.origin);
            return f ? `Too small: expected ${l.origin} to have ${n}${l.minimum.toString()} ${f.unit}` : `Too small: expected ${l.origin} to be ${n}${l.minimum.toString()}`;
          }
          case "invalid_format": {
            const n = l;
            return n.format === "starts_with" ? `Invalid string: must start with "${n.prefix}"` : n.format === "ends_with" ? `Invalid string: must end with "${n.suffix}"` : n.format === "includes" ? `Invalid string: must include "${n.includes}"` : n.format === "regex" ? `Invalid string: must match pattern ${n.pattern}` : `Invalid ${u[n.format] ?? l.format}`;
          }
          case "not_multiple_of":
            return `Invalid number: must be a multiple of ${l.divisor}`;
          case "unrecognized_keys":
            return `Unrecognized key${l.keys.length > 1 ? "s" : ""}: ${t.joinValues(l.keys, ", ")}`;
          case "invalid_key":
            return `Invalid key in ${l.origin}`;
          case "invalid_union":
            return "Invalid input";
          case "invalid_element":
            return `Invalid value in ${l.origin}`;
          default:
            return "Invalid input";
        }
      };
    };
    function p() {
      return {
        localeError: m()
      };
    }
  }(pt)), pt;
}
var bt = {}, Ko;
function Mm() {
  return Ko || (Ko = 1, function(e) {
    var i = w && w.__createBinding || (Object.create ? function(s, r, u, l) {
      l === void 0 && (l = u);
      var n = Object.getOwnPropertyDescriptor(r, u);
      (!n || ("get" in n ? !r.__esModule : n.writable || n.configurable)) && (n = { enumerable: !0, get: function() {
        return r[u];
      } }), Object.defineProperty(s, l, n);
    } : function(s, r, u, l) {
      l === void 0 && (l = u), s[l] = r[u];
    }), d = w && w.__setModuleDefault || (Object.create ? function(s, r) {
      Object.defineProperty(s, "default", { enumerable: !0, value: r });
    } : function(s, r) {
      s.default = r;
    }), a = w && w.__importStar || function(s) {
      if (s && s.__esModule) return s;
      var r = {};
      if (s != null) for (var u in s) u !== "default" && Object.prototype.hasOwnProperty.call(s, u) && i(r, s, u);
      return d(r, s), r;
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), e.parsedType = void 0, e.default = p;
    const t = a(pe()), o = (s) => {
      const r = typeof s;
      switch (r) {
        case "number":
          return Number.isNaN(s) ? "NaN" : "nombro";
        case "object": {
          if (Array.isArray(s))
            return "tabelo";
          if (s === null)
            return "senvalora";
          if (Object.getPrototypeOf(s) !== Object.prototype && s.constructor)
            return s.constructor.name;
        }
      }
      return r;
    };
    e.parsedType = o;
    const m = () => {
      const s = {
        string: { unit: "karaktrojn", verb: "havi" },
        file: { unit: "bajtojn", verb: "havi" },
        array: { unit: "elementojn", verb: "havi" },
        set: { unit: "elementojn", verb: "havi" }
      };
      function r(l) {
        return s[l] ?? null;
      }
      const u = {
        regex: "enigo",
        email: "retadreso",
        url: "URL",
        emoji: "emoĝio",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO-datotempo",
        date: "ISO-dato",
        time: "ISO-tempo",
        duration: "ISO-daŭro",
        ipv4: "IPv4-adreso",
        ipv6: "IPv6-adreso",
        cidrv4: "IPv4-rango",
        cidrv6: "IPv6-rango",
        base64: "64-ume kodita karaktraro",
        base64url: "URL-64-ume kodita karaktraro",
        json_string: "JSON-karaktraro",
        e164: "E.164-nombro",
        jwt: "JWT",
        template_literal: "enigo"
      };
      return (l) => {
        switch (l.code) {
          case "invalid_type":
            return `Nevalida enigo: atendiĝis ${l.expected}, riceviĝis ${(0, e.parsedType)(l.input)}`;
          case "invalid_value":
            return l.values.length === 1 ? `Nevalida enigo: atendiĝis ${t.stringifyPrimitive(l.values[0])}` : `Nevalida opcio: atendiĝis unu el ${t.joinValues(l.values, "|")}`;
          case "too_big": {
            const n = l.inclusive ? "<=" : "<", f = r(l.origin);
            return f ? `Tro granda: atendiĝis ke ${l.origin ?? "valoro"} havu ${n}${l.maximum.toString()} ${f.unit ?? "elementojn"}` : `Tro granda: atendiĝis ke ${l.origin ?? "valoro"} havu ${n}${l.maximum.toString()}`;
          }
          case "too_small": {
            const n = l.inclusive ? ">=" : ">", f = r(l.origin);
            return f ? `Tro malgranda: atendiĝis ke ${l.origin} havu ${n}${l.minimum.toString()} ${f.unit}` : `Tro malgranda: atendiĝis ke ${l.origin} estu ${n}${l.minimum.toString()}`;
          }
          case "invalid_format": {
            const n = l;
            return n.format === "starts_with" ? `Nevalida karaktraro: devas komenciĝi per "${n.prefix}"` : n.format === "ends_with" ? `Nevalida karaktraro: devas finiĝi per "${n.suffix}"` : n.format === "includes" ? `Nevalida karaktraro: devas inkluzivi "${n.includes}"` : n.format === "regex" ? `Nevalida karaktraro: devas kongrui kun la modelo ${n.pattern}` : `Nevalida ${u[n.format] ?? l.format}`;
          }
          case "not_multiple_of":
            return `Nevalida nombro: devas esti oblo de ${l.divisor}`;
          case "unrecognized_keys":
            return `Nekonata${l.keys.length > 1 ? "j" : ""} ŝlosilo${l.keys.length > 1 ? "j" : ""}: ${t.joinValues(l.keys, ", ")}`;
          case "invalid_key":
            return `Nevalida ŝlosilo en ${l.origin}`;
          case "invalid_union":
            return "Nevalida enigo";
          case "invalid_element":
            return `Nevalida valoro en ${l.origin}`;
          default:
            return "Nevalida enigo";
        }
      };
    };
    function p() {
      return {
        localeError: m()
      };
    }
  }(bt)), bt;
}
var gi = { exports: {} }, Yo;
function jm() {
  return Yo || (Yo = 1, function(e, i) {
    var d = w && w.__createBinding || (Object.create ? function(s, r, u, l) {
      l === void 0 && (l = u);
      var n = Object.getOwnPropertyDescriptor(r, u);
      (!n || ("get" in n ? !r.__esModule : n.writable || n.configurable)) && (n = { enumerable: !0, get: function() {
        return r[u];
      } }), Object.defineProperty(s, l, n);
    } : function(s, r, u, l) {
      l === void 0 && (l = u), s[l] = r[u];
    }), a = w && w.__setModuleDefault || (Object.create ? function(s, r) {
      Object.defineProperty(s, "default", { enumerable: !0, value: r });
    } : function(s, r) {
      s.default = r;
    }), t = w && w.__importStar || function(s) {
      if (s && s.__esModule) return s;
      var r = {};
      if (s != null) for (var u in s) u !== "default" && Object.prototype.hasOwnProperty.call(s, u) && d(r, s, u);
      return a(r, s), r;
    };
    Object.defineProperty(i, "__esModule", { value: !0 }), i.default = p;
    const o = t(pe()), m = () => {
      const s = {
        string: { unit: "caracteres", verb: "tener" },
        file: { unit: "bytes", verb: "tener" },
        array: { unit: "elementos", verb: "tener" },
        set: { unit: "elementos", verb: "tener" }
      };
      function r(n) {
        return s[n] ?? null;
      }
      const u = (n) => {
        const f = typeof n;
        switch (f) {
          case "number":
            return Number.isNaN(n) ? "NaN" : "número";
          case "object": {
            if (Array.isArray(n))
              return "arreglo";
            if (n === null)
              return "nulo";
            if (Object.getPrototypeOf(n) !== Object.prototype)
              return n.constructor.name;
          }
        }
        return f;
      }, l = {
        regex: "entrada",
        email: "dirección de correo electrónico",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "fecha y hora ISO",
        date: "fecha ISO",
        time: "hora ISO",
        duration: "duración ISO",
        ipv4: "dirección IPv4",
        ipv6: "dirección IPv6",
        cidrv4: "rango IPv4",
        cidrv6: "rango IPv6",
        base64: "cadena codificada en base64",
        base64url: "URL codificada en base64",
        json_string: "cadena JSON",
        e164: "número E.164",
        jwt: "JWT",
        template_literal: "entrada"
      };
      return (n) => {
        switch (n.code) {
          case "invalid_type":
            return `Entrada inválida: se esperaba ${n.expected}, recibido ${u(n.input)}`;
          case "invalid_value":
            return n.values.length === 1 ? `Entrada inválida: se esperaba ${o.stringifyPrimitive(n.values[0])}` : `Opción inválida: se esperaba una de ${o.joinValues(n.values, "|")}`;
          case "too_big": {
            const f = n.inclusive ? "<=" : "<", v = r(n.origin);
            return v ? `Demasiado grande: se esperaba que ${n.origin ?? "valor"} tuviera ${f}${n.maximum.toString()} ${v.unit ?? "elementos"}` : `Demasiado grande: se esperaba que ${n.origin ?? "valor"} fuera ${f}${n.maximum.toString()}`;
          }
          case "too_small": {
            const f = n.inclusive ? ">=" : ">", v = r(n.origin);
            return v ? `Demasiado pequeño: se esperaba que ${n.origin} tuviera ${f}${n.minimum.toString()} ${v.unit}` : `Demasiado pequeño: se esperaba que ${n.origin} fuera ${f}${n.minimum.toString()}`;
          }
          case "invalid_format": {
            const f = n;
            return f.format === "starts_with" ? `Cadena inválida: debe comenzar con "${f.prefix}"` : f.format === "ends_with" ? `Cadena inválida: debe terminar en "${f.suffix}"` : f.format === "includes" ? `Cadena inválida: debe incluir "${f.includes}"` : f.format === "regex" ? `Cadena inválida: debe coincidir con el patrón ${f.pattern}` : `Inválido ${l[f.format] ?? n.format}`;
          }
          case "not_multiple_of":
            return `Número inválido: debe ser múltiplo de ${n.divisor}`;
          case "unrecognized_keys":
            return `Llave${n.keys.length > 1 ? "s" : ""} desconocida${n.keys.length > 1 ? "s" : ""}: ${o.joinValues(n.keys, ", ")}`;
          case "invalid_key":
            return `Llave inválida en ${n.origin}`;
          case "invalid_union":
            return "Entrada inválida";
          case "invalid_element":
            return `Valor inválido en ${n.origin}`;
          default:
            return "Entrada inválida";
        }
      };
    };
    function p() {
      return {
        localeError: m()
      };
    }
    e.exports = i.default;
  }(gi, gi.exports)), gi.exports;
}
var pi = { exports: {} }, Jo;
function Sm() {
  return Jo || (Jo = 1, function(e, i) {
    var d = w && w.__createBinding || (Object.create ? function(s, r, u, l) {
      l === void 0 && (l = u);
      var n = Object.getOwnPropertyDescriptor(r, u);
      (!n || ("get" in n ? !r.__esModule : n.writable || n.configurable)) && (n = { enumerable: !0, get: function() {
        return r[u];
      } }), Object.defineProperty(s, l, n);
    } : function(s, r, u, l) {
      l === void 0 && (l = u), s[l] = r[u];
    }), a = w && w.__setModuleDefault || (Object.create ? function(s, r) {
      Object.defineProperty(s, "default", { enumerable: !0, value: r });
    } : function(s, r) {
      s.default = r;
    }), t = w && w.__importStar || function(s) {
      if (s && s.__esModule) return s;
      var r = {};
      if (s != null) for (var u in s) u !== "default" && Object.prototype.hasOwnProperty.call(s, u) && d(r, s, u);
      return a(r, s), r;
    };
    Object.defineProperty(i, "__esModule", { value: !0 }), i.default = p;
    const o = t(pe()), m = () => {
      const s = {
        string: { unit: "کاراکتر", verb: "داشته باشد" },
        file: { unit: "بایت", verb: "داشته باشد" },
        array: { unit: "آیتم", verb: "داشته باشد" },
        set: { unit: "آیتم", verb: "داشته باشد" }
      };
      function r(n) {
        return s[n] ?? null;
      }
      const u = (n) => {
        const f = typeof n;
        switch (f) {
          case "number":
            return Number.isNaN(n) ? "NaN" : "عدد";
          case "object": {
            if (Array.isArray(n))
              return "آرایه";
            if (n === null)
              return "null";
            if (Object.getPrototypeOf(n) !== Object.prototype && n.constructor)
              return n.constructor.name;
          }
        }
        return f;
      }, l = {
        regex: "ورودی",
        email: "آدرس ایمیل",
        url: "URL",
        emoji: "ایموجی",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "تاریخ و زمان ایزو",
        date: "تاریخ ایزو",
        time: "زمان ایزو",
        duration: "مدت زمان ایزو",
        ipv4: "IPv4 آدرس",
        ipv6: "IPv6 آدرس",
        cidrv4: "IPv4 دامنه",
        cidrv6: "IPv6 دامنه",
        base64: "base64-encoded رشته",
        base64url: "base64url-encoded رشته",
        json_string: "JSON رشته",
        e164: "E.164 عدد",
        jwt: "JWT",
        template_literal: "ورودی"
      };
      return (n) => {
        switch (n.code) {
          case "invalid_type":
            return `ورودی نامعتبر: می‌بایست ${n.expected} می‌بود، ${u(n.input)} دریافت شد`;
          case "invalid_value":
            return n.values.length === 1 ? `ورودی نامعتبر: می‌بایست ${o.stringifyPrimitive(n.values[0])} می‌بود` : `گزینه نامعتبر: می‌بایست یکی از ${o.joinValues(n.values, "|")} می‌بود`;
          case "too_big": {
            const f = n.inclusive ? "<=" : "<", v = r(n.origin);
            return v ? `خیلی بزرگ: ${n.origin ?? "مقدار"} باید ${f}${n.maximum.toString()} ${v.unit ?? "عنصر"} باشد` : `خیلی بزرگ: ${n.origin ?? "مقدار"} باید ${f}${n.maximum.toString()} باشد`;
          }
          case "too_small": {
            const f = n.inclusive ? ">=" : ">", v = r(n.origin);
            return v ? `خیلی کوچک: ${n.origin} باید ${f}${n.minimum.toString()} ${v.unit} باشد` : `خیلی کوچک: ${n.origin} باید ${f}${n.minimum.toString()} باشد`;
          }
          case "invalid_format": {
            const f = n;
            return f.format === "starts_with" ? `رشته نامعتبر: باید با "${f.prefix}" شروع شود` : f.format === "ends_with" ? `رشته نامعتبر: باید با "${f.suffix}" تمام شود` : f.format === "includes" ? `رشته نامعتبر: باید شامل "${f.includes}" باشد` : f.format === "regex" ? `رشته نامعتبر: باید با الگوی ${f.pattern} مطابقت داشته باشد` : `${l[f.format] ?? n.format} نامعتبر`;
          }
          case "not_multiple_of":
            return `عدد نامعتبر: باید مضرب ${n.divisor} باشد`;
          case "unrecognized_keys":
            return `کلید${n.keys.length > 1 ? "های" : ""} ناشناس: ${o.joinValues(n.keys, ", ")}`;
          case "invalid_key":
            return `کلید ناشناس در ${n.origin}`;
          case "invalid_union":
            return "ورودی نامعتبر";
          case "invalid_element":
            return `مقدار نامعتبر در ${n.origin}`;
          default:
            return "ورودی نامعتبر";
        }
      };
    };
    function p() {
      return {
        localeError: m()
      };
    }
    e.exports = i.default;
  }(pi, pi.exports)), pi.exports;
}
var bi = { exports: {} }, Qo;
function zm() {
  return Qo || (Qo = 1, function(e, i) {
    var d = w && w.__createBinding || (Object.create ? function(s, r, u, l) {
      l === void 0 && (l = u);
      var n = Object.getOwnPropertyDescriptor(r, u);
      (!n || ("get" in n ? !r.__esModule : n.writable || n.configurable)) && (n = { enumerable: !0, get: function() {
        return r[u];
      } }), Object.defineProperty(s, l, n);
    } : function(s, r, u, l) {
      l === void 0 && (l = u), s[l] = r[u];
    }), a = w && w.__setModuleDefault || (Object.create ? function(s, r) {
      Object.defineProperty(s, "default", { enumerable: !0, value: r });
    } : function(s, r) {
      s.default = r;
    }), t = w && w.__importStar || function(s) {
      if (s && s.__esModule) return s;
      var r = {};
      if (s != null) for (var u in s) u !== "default" && Object.prototype.hasOwnProperty.call(s, u) && d(r, s, u);
      return a(r, s), r;
    };
    Object.defineProperty(i, "__esModule", { value: !0 }), i.default = p;
    const o = t(pe()), m = () => {
      const s = {
        string: { unit: "merkkiä", subject: "merkkijonon" },
        file: { unit: "tavua", subject: "tiedoston" },
        array: { unit: "alkiota", subject: "listan" },
        set: { unit: "alkiota", subject: "joukon" },
        number: { unit: "", subject: "luvun" },
        bigint: { unit: "", subject: "suuren kokonaisluvun" },
        int: { unit: "", subject: "kokonaisluvun" },
        date: { unit: "", subject: "päivämäärän" }
      };
      function r(n) {
        return s[n] ?? null;
      }
      const u = (n) => {
        const f = typeof n;
        switch (f) {
          case "number":
            return Number.isNaN(n) ? "NaN" : "number";
          case "object": {
            if (Array.isArray(n))
              return "array";
            if (n === null)
              return "null";
            if (Object.getPrototypeOf(n) !== Object.prototype && n.constructor)
              return n.constructor.name;
          }
        }
        return f;
      }, l = {
        regex: "säännöllinen lauseke",
        email: "sähköpostiosoite",
        url: "URL-osoite",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO-aikaleima",
        date: "ISO-päivämäärä",
        time: "ISO-aika",
        duration: "ISO-kesto",
        ipv4: "IPv4-osoite",
        ipv6: "IPv6-osoite",
        cidrv4: "IPv4-alue",
        cidrv6: "IPv6-alue",
        base64: "base64-koodattu merkkijono",
        base64url: "base64url-koodattu merkkijono",
        json_string: "JSON-merkkijono",
        e164: "E.164-luku",
        jwt: "JWT",
        template_literal: "templaattimerkkijono"
      };
      return (n) => {
        switch (n.code) {
          case "invalid_type":
            return `Virheellinen tyyppi: odotettiin ${n.expected}, oli ${u(n.input)}`;
          case "invalid_value":
            return n.values.length === 1 ? `Virheellinen syöte: täytyy olla ${o.stringifyPrimitive(n.values[0])}` : `Virheellinen valinta: täytyy olla yksi seuraavista: ${o.joinValues(n.values, "|")}`;
          case "too_big": {
            const f = n.inclusive ? "<=" : "<", v = r(n.origin);
            return v ? `Liian suuri: ${v.subject} täytyy olla ${f}${n.maximum.toString()} ${v.unit}`.trim() : `Liian suuri: arvon täytyy olla ${f}${n.maximum.toString()}`;
          }
          case "too_small": {
            const f = n.inclusive ? ">=" : ">", v = r(n.origin);
            return v ? `Liian pieni: ${v.subject} täytyy olla ${f}${n.minimum.toString()} ${v.unit}`.trim() : `Liian pieni: arvon täytyy olla ${f}${n.minimum.toString()}`;
          }
          case "invalid_format": {
            const f = n;
            return f.format === "starts_with" ? `Virheellinen syöte: täytyy alkaa "${f.prefix}"` : f.format === "ends_with" ? `Virheellinen syöte: täytyy loppua "${f.suffix}"` : f.format === "includes" ? `Virheellinen syöte: täytyy sisältää "${f.includes}"` : f.format === "regex" ? `Virheellinen syöte: täytyy vastata säännöllistä lauseketta ${f.pattern}` : `Virheellinen ${l[f.format] ?? n.format}`;
          }
          case "not_multiple_of":
            return `Virheellinen luku: täytyy olla luvun ${n.divisor} monikerta`;
          case "unrecognized_keys":
            return `${n.keys.length > 1 ? "Tuntemattomat avaimet" : "Tuntematon avain"}: ${o.joinValues(n.keys, ", ")}`;
          case "invalid_key":
            return "Virheellinen avain tietueessa";
          case "invalid_union":
            return "Virheellinen unioni";
          case "invalid_element":
            return "Virheellinen arvo joukossa";
          default:
            return "Virheellinen syöte";
        }
      };
    };
    function p() {
      return {
        localeError: m()
      };
    }
    e.exports = i.default;
  }(bi, bi.exports)), bi.exports;
}
var yi = { exports: {} }, es;
function Om() {
  return es || (es = 1, function(e, i) {
    var d = w && w.__createBinding || (Object.create ? function(s, r, u, l) {
      l === void 0 && (l = u);
      var n = Object.getOwnPropertyDescriptor(r, u);
      (!n || ("get" in n ? !r.__esModule : n.writable || n.configurable)) && (n = { enumerable: !0, get: function() {
        return r[u];
      } }), Object.defineProperty(s, l, n);
    } : function(s, r, u, l) {
      l === void 0 && (l = u), s[l] = r[u];
    }), a = w && w.__setModuleDefault || (Object.create ? function(s, r) {
      Object.defineProperty(s, "default", { enumerable: !0, value: r });
    } : function(s, r) {
      s.default = r;
    }), t = w && w.__importStar || function(s) {
      if (s && s.__esModule) return s;
      var r = {};
      if (s != null) for (var u in s) u !== "default" && Object.prototype.hasOwnProperty.call(s, u) && d(r, s, u);
      return a(r, s), r;
    };
    Object.defineProperty(i, "__esModule", { value: !0 }), i.default = p;
    const o = t(pe()), m = () => {
      const s = {
        string: { unit: "caractères", verb: "avoir" },
        file: { unit: "octets", verb: "avoir" },
        array: { unit: "éléments", verb: "avoir" },
        set: { unit: "éléments", verb: "avoir" }
      };
      function r(n) {
        return s[n] ?? null;
      }
      const u = (n) => {
        const f = typeof n;
        switch (f) {
          case "number":
            return Number.isNaN(n) ? "NaN" : "nombre";
          case "object": {
            if (Array.isArray(n))
              return "tableau";
            if (n === null)
              return "null";
            if (Object.getPrototypeOf(n) !== Object.prototype && n.constructor)
              return n.constructor.name;
          }
        }
        return f;
      }, l = {
        regex: "entrée",
        email: "adresse e-mail",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "date et heure ISO",
        date: "date ISO",
        time: "heure ISO",
        duration: "durée ISO",
        ipv4: "adresse IPv4",
        ipv6: "adresse IPv6",
        cidrv4: "plage IPv4",
        cidrv6: "plage IPv6",
        base64: "chaîne encodée en base64",
        base64url: "chaîne encodée en base64url",
        json_string: "chaîne JSON",
        e164: "numéro E.164",
        jwt: "JWT",
        template_literal: "entrée"
      };
      return (n) => {
        switch (n.code) {
          case "invalid_type":
            return `Entrée invalide : ${n.expected} attendu, ${u(n.input)} reçu`;
          case "invalid_value":
            return n.values.length === 1 ? `Entrée invalide : ${o.stringifyPrimitive(n.values[0])} attendu` : `Option invalide : une valeur parmi ${o.joinValues(n.values, "|")} attendue`;
          case "too_big": {
            const f = n.inclusive ? "<=" : "<", v = r(n.origin);
            return v ? `Trop grand : ${n.origin ?? "valeur"} doit ${v.verb} ${f}${n.maximum.toString()} ${v.unit ?? "élément(s)"}` : `Trop grand : ${n.origin ?? "valeur"} doit être ${f}${n.maximum.toString()}`;
          }
          case "too_small": {
            const f = n.inclusive ? ">=" : ">", v = r(n.origin);
            return v ? `Trop petit : ${n.origin} doit ${v.verb} ${f}${n.minimum.toString()} ${v.unit}` : `Trop petit : ${n.origin} doit être ${f}${n.minimum.toString()}`;
          }
          case "invalid_format": {
            const f = n;
            return f.format === "starts_with" ? `Chaîne invalide : doit commencer par "${f.prefix}"` : f.format === "ends_with" ? `Chaîne invalide : doit se terminer par "${f.suffix}"` : f.format === "includes" ? `Chaîne invalide : doit inclure "${f.includes}"` : f.format === "regex" ? `Chaîne invalide : doit correspondre au modèle ${f.pattern}` : `${l[f.format] ?? n.format} invalide`;
          }
          case "not_multiple_of":
            return `Nombre invalide : doit être un multiple de ${n.divisor}`;
          case "unrecognized_keys":
            return `Clé${n.keys.length > 1 ? "s" : ""} non reconnue${n.keys.length > 1 ? "s" : ""} : ${o.joinValues(n.keys, ", ")}`;
          case "invalid_key":
            return `Clé invalide dans ${n.origin}`;
          case "invalid_union":
            return "Entrée invalide";
          case "invalid_element":
            return `Valeur invalide dans ${n.origin}`;
          default:
            return "Entrée invalide";
        }
      };
    };
    function p() {
      return {
        localeError: m()
      };
    }
    e.exports = i.default;
  }(yi, yi.exports)), yi.exports;
}
var ki = { exports: {} }, ns;
function Wm() {
  return ns || (ns = 1, function(e, i) {
    var d = w && w.__createBinding || (Object.create ? function(s, r, u, l) {
      l === void 0 && (l = u);
      var n = Object.getOwnPropertyDescriptor(r, u);
      (!n || ("get" in n ? !r.__esModule : n.writable || n.configurable)) && (n = { enumerable: !0, get: function() {
        return r[u];
      } }), Object.defineProperty(s, l, n);
    } : function(s, r, u, l) {
      l === void 0 && (l = u), s[l] = r[u];
    }), a = w && w.__setModuleDefault || (Object.create ? function(s, r) {
      Object.defineProperty(s, "default", { enumerable: !0, value: r });
    } : function(s, r) {
      s.default = r;
    }), t = w && w.__importStar || function(s) {
      if (s && s.__esModule) return s;
      var r = {};
      if (s != null) for (var u in s) u !== "default" && Object.prototype.hasOwnProperty.call(s, u) && d(r, s, u);
      return a(r, s), r;
    };
    Object.defineProperty(i, "__esModule", { value: !0 }), i.default = p;
    const o = t(pe()), m = () => {
      const s = {
        string: { unit: "caractères", verb: "avoir" },
        file: { unit: "octets", verb: "avoir" },
        array: { unit: "éléments", verb: "avoir" },
        set: { unit: "éléments", verb: "avoir" }
      };
      function r(n) {
        return s[n] ?? null;
      }
      const u = (n) => {
        const f = typeof n;
        switch (f) {
          case "number":
            return Number.isNaN(n) ? "NaN" : "number";
          case "object": {
            if (Array.isArray(n))
              return "array";
            if (n === null)
              return "null";
            if (Object.getPrototypeOf(n) !== Object.prototype && n.constructor)
              return n.constructor.name;
          }
        }
        return f;
      }, l = {
        regex: "entrée",
        email: "adresse courriel",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "date-heure ISO",
        date: "date ISO",
        time: "heure ISO",
        duration: "durée ISO",
        ipv4: "adresse IPv4",
        ipv6: "adresse IPv6",
        cidrv4: "plage IPv4",
        cidrv6: "plage IPv6",
        base64: "chaîne encodée en base64",
        base64url: "chaîne encodée en base64url",
        json_string: "chaîne JSON",
        e164: "numéro E.164",
        jwt: "JWT",
        template_literal: "entrée"
      };
      return (n) => {
        switch (n.code) {
          case "invalid_type":
            return `Entrée invalide : attendu ${n.expected}, reçu ${u(n.input)}`;
          case "invalid_value":
            return n.values.length === 1 ? `Entrée invalide : attendu ${o.stringifyPrimitive(n.values[0])}` : `Option invalide : attendu l'une des valeurs suivantes ${o.joinValues(n.values, "|")}`;
          case "too_big": {
            const f = n.inclusive ? "≤" : "<", v = r(n.origin);
            return v ? `Trop grand : attendu que ${n.origin ?? "la valeur"} ait ${f}${n.maximum.toString()} ${v.unit}` : `Trop grand : attendu que ${n.origin ?? "la valeur"} soit ${f}${n.maximum.toString()}`;
          }
          case "too_small": {
            const f = n.inclusive ? "≥" : ">", v = r(n.origin);
            return v ? `Trop petit : attendu que ${n.origin} ait ${f}${n.minimum.toString()} ${v.unit}` : `Trop petit : attendu que ${n.origin} soit ${f}${n.minimum.toString()}`;
          }
          case "invalid_format": {
            const f = n;
            return f.format === "starts_with" ? `Chaîne invalide : doit commencer par "${f.prefix}"` : f.format === "ends_with" ? `Chaîne invalide : doit se terminer par "${f.suffix}"` : f.format === "includes" ? `Chaîne invalide : doit inclure "${f.includes}"` : f.format === "regex" ? `Chaîne invalide : doit correspondre au motif ${f.pattern}` : `${l[f.format] ?? n.format} invalide`;
          }
          case "not_multiple_of":
            return `Nombre invalide : doit être un multiple de ${n.divisor}`;
          case "unrecognized_keys":
            return `Clé${n.keys.length > 1 ? "s" : ""} non reconnue${n.keys.length > 1 ? "s" : ""} : ${o.joinValues(n.keys, ", ")}`;
          case "invalid_key":
            return `Clé invalide dans ${n.origin}`;
          case "invalid_union":
            return "Entrée invalide";
          case "invalid_element":
            return `Valeur invalide dans ${n.origin}`;
          default:
            return "Entrée invalide";
        }
      };
    };
    function p() {
      return {
        localeError: m()
      };
    }
    e.exports = i.default;
  }(ki, ki.exports)), ki.exports;
}
var wi = { exports: {} }, is;
function Dm() {
  return is || (is = 1, function(e, i) {
    var d = w && w.__createBinding || (Object.create ? function(s, r, u, l) {
      l === void 0 && (l = u);
      var n = Object.getOwnPropertyDescriptor(r, u);
      (!n || ("get" in n ? !r.__esModule : n.writable || n.configurable)) && (n = { enumerable: !0, get: function() {
        return r[u];
      } }), Object.defineProperty(s, l, n);
    } : function(s, r, u, l) {
      l === void 0 && (l = u), s[l] = r[u];
    }), a = w && w.__setModuleDefault || (Object.create ? function(s, r) {
      Object.defineProperty(s, "default", { enumerable: !0, value: r });
    } : function(s, r) {
      s.default = r;
    }), t = w && w.__importStar || function(s) {
      if (s && s.__esModule) return s;
      var r = {};
      if (s != null) for (var u in s) u !== "default" && Object.prototype.hasOwnProperty.call(s, u) && d(r, s, u);
      return a(r, s), r;
    };
    Object.defineProperty(i, "__esModule", { value: !0 }), i.default = p;
    const o = t(pe()), m = () => {
      const s = {
        string: { unit: "אותיות", verb: "לכלול" },
        file: { unit: "בייטים", verb: "לכלול" },
        array: { unit: "פריטים", verb: "לכלול" },
        set: { unit: "פריטים", verb: "לכלול" }
      };
      function r(n) {
        return s[n] ?? null;
      }
      const u = (n) => {
        const f = typeof n;
        switch (f) {
          case "number":
            return Number.isNaN(n) ? "NaN" : "number";
          case "object": {
            if (Array.isArray(n))
              return "array";
            if (n === null)
              return "null";
            if (Object.getPrototypeOf(n) !== Object.prototype && n.constructor)
              return n.constructor.name;
          }
        }
        return f;
      }, l = {
        regex: "קלט",
        email: "כתובת אימייל",
        url: "כתובת רשת",
        emoji: "אימוג'י",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "תאריך וזמן ISO",
        date: "תאריך ISO",
        time: "זמן ISO",
        duration: "משך זמן ISO",
        ipv4: "כתובת IPv4",
        ipv6: "כתובת IPv6",
        cidrv4: "טווח IPv4",
        cidrv6: "טווח IPv6",
        base64: "מחרוזת בבסיס 64",
        base64url: "מחרוזת בבסיס 64 לכתובות רשת",
        json_string: "מחרוזת JSON",
        e164: "מספר E.164",
        jwt: "JWT",
        template_literal: "קלט"
      };
      return (n) => {
        switch (n.code) {
          case "invalid_type":
            return `קלט לא תקין: צריך ${n.expected}, התקבל ${u(n.input)}`;
          case "invalid_value":
            return n.values.length === 1 ? `קלט לא תקין: צריך ${o.stringifyPrimitive(n.values[0])}` : `קלט לא תקין: צריך אחת מהאפשרויות  ${o.joinValues(n.values, "|")}`;
          case "too_big": {
            const f = n.inclusive ? "<=" : "<", v = r(n.origin);
            return v ? `גדול מדי: ${n.origin ?? "value"} צריך להיות ${f}${n.maximum.toString()} ${v.unit ?? "elements"}` : `גדול מדי: ${n.origin ?? "value"} צריך להיות ${f}${n.maximum.toString()}`;
          }
          case "too_small": {
            const f = n.inclusive ? ">=" : ">", v = r(n.origin);
            return v ? `קטן מדי: ${n.origin} צריך להיות ${f}${n.minimum.toString()} ${v.unit}` : `קטן מדי: ${n.origin} צריך להיות ${f}${n.minimum.toString()}`;
          }
          case "invalid_format": {
            const f = n;
            return f.format === "starts_with" ? `מחרוזת לא תקינה: חייבת להתחיל ב"${f.prefix}"` : f.format === "ends_with" ? `מחרוזת לא תקינה: חייבת להסתיים ב "${f.suffix}"` : f.format === "includes" ? `מחרוזת לא תקינה: חייבת לכלול "${f.includes}"` : f.format === "regex" ? `מחרוזת לא תקינה: חייבת להתאים לתבנית ${f.pattern}` : `${l[f.format] ?? n.format} לא תקין`;
          }
          case "not_multiple_of":
            return `מספר לא תקין: חייב להיות מכפלה של ${n.divisor}`;
          case "unrecognized_keys":
            return `מפתח${n.keys.length > 1 ? "ות" : ""} לא מזוה${n.keys.length > 1 ? "ים" : "ה"}: ${o.joinValues(n.keys, ", ")}`;
          case "invalid_key":
            return `מפתח לא תקין ב${n.origin}`;
          case "invalid_union":
            return "קלט לא תקין";
          case "invalid_element":
            return `ערך לא תקין ב${n.origin}`;
          default:
            return "קלט לא תקין";
        }
      };
    };
    function p() {
      return {
        localeError: m()
      };
    }
    e.exports = i.default;
  }(wi, wi.exports)), wi.exports;
}
var _i = { exports: {} }, as;
function Cm() {
  return as || (as = 1, function(e, i) {
    var d = w && w.__createBinding || (Object.create ? function(s, r, u, l) {
      l === void 0 && (l = u);
      var n = Object.getOwnPropertyDescriptor(r, u);
      (!n || ("get" in n ? !r.__esModule : n.writable || n.configurable)) && (n = { enumerable: !0, get: function() {
        return r[u];
      } }), Object.defineProperty(s, l, n);
    } : function(s, r, u, l) {
      l === void 0 && (l = u), s[l] = r[u];
    }), a = w && w.__setModuleDefault || (Object.create ? function(s, r) {
      Object.defineProperty(s, "default", { enumerable: !0, value: r });
    } : function(s, r) {
      s.default = r;
    }), t = w && w.__importStar || function(s) {
      if (s && s.__esModule) return s;
      var r = {};
      if (s != null) for (var u in s) u !== "default" && Object.prototype.hasOwnProperty.call(s, u) && d(r, s, u);
      return a(r, s), r;
    };
    Object.defineProperty(i, "__esModule", { value: !0 }), i.default = p;
    const o = t(pe()), m = () => {
      const s = {
        string: { unit: "karakter", verb: "legyen" },
        file: { unit: "byte", verb: "legyen" },
        array: { unit: "elem", verb: "legyen" },
        set: { unit: "elem", verb: "legyen" }
      };
      function r(n) {
        return s[n] ?? null;
      }
      const u = (n) => {
        const f = typeof n;
        switch (f) {
          case "number":
            return Number.isNaN(n) ? "NaN" : "szám";
          case "object": {
            if (Array.isArray(n))
              return "tömb";
            if (n === null)
              return "null";
            if (Object.getPrototypeOf(n) !== Object.prototype && n.constructor)
              return n.constructor.name;
          }
        }
        return f;
      }, l = {
        regex: "bemenet",
        email: "email cím",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO időbélyeg",
        date: "ISO dátum",
        time: "ISO idő",
        duration: "ISO időintervallum",
        ipv4: "IPv4 cím",
        ipv6: "IPv6 cím",
        cidrv4: "IPv4 tartomány",
        cidrv6: "IPv6 tartomány",
        base64: "base64-kódolt string",
        base64url: "base64url-kódolt string",
        json_string: "JSON string",
        e164: "E.164 szám",
        jwt: "JWT",
        template_literal: "bemenet"
      };
      return (n) => {
        switch (n.code) {
          case "invalid_type":
            return `Érvénytelen bemenet: a várt érték ${n.expected}, a kapott érték ${u(n.input)}`;
          case "invalid_value":
            return n.values.length === 1 ? `Érvénytelen bemenet: a várt érték ${o.stringifyPrimitive(n.values[0])}` : `Érvénytelen opció: valamelyik érték várt ${o.joinValues(n.values, "|")}`;
          case "too_big": {
            const f = n.inclusive ? "<=" : "<", v = r(n.origin);
            return v ? `Túl nagy: ${n.origin ?? "érték"} mérete túl nagy ${f}${n.maximum.toString()} ${v.unit ?? "elem"}` : `Túl nagy: a bemeneti érték ${n.origin ?? "érték"} túl nagy: ${f}${n.maximum.toString()}`;
          }
          case "too_small": {
            const f = n.inclusive ? ">=" : ">", v = r(n.origin);
            return v ? `Túl kicsi: a bemeneti érték ${n.origin} mérete túl kicsi ${f}${n.minimum.toString()} ${v.unit}` : `Túl kicsi: a bemeneti érték ${n.origin} túl kicsi ${f}${n.minimum.toString()}`;
          }
          case "invalid_format": {
            const f = n;
            return f.format === "starts_with" ? `Érvénytelen string: "${f.prefix}" értékkel kell kezdődnie` : f.format === "ends_with" ? `Érvénytelen string: "${f.suffix}" értékkel kell végződnie` : f.format === "includes" ? `Érvénytelen string: "${f.includes}" értéket kell tartalmaznia` : f.format === "regex" ? `Érvénytelen string: ${f.pattern} mintának kell megfelelnie` : `Érvénytelen ${l[f.format] ?? n.format}`;
          }
          case "not_multiple_of":
            return `Érvénytelen szám: ${n.divisor} többszörösének kell lennie`;
          case "unrecognized_keys":
            return `Ismeretlen kulcs${n.keys.length > 1 ? "s" : ""}: ${o.joinValues(n.keys, ", ")}`;
          case "invalid_key":
            return `Érvénytelen kulcs ${n.origin}`;
          case "invalid_union":
            return "Érvénytelen bemenet";
          case "invalid_element":
            return `Érvénytelen érték: ${n.origin}`;
          default:
            return "Érvénytelen bemenet";
        }
      };
    };
    function p() {
      return {
        localeError: m()
      };
    }
    e.exports = i.default;
  }(_i, _i.exports)), _i.exports;
}
var $i = { exports: {} }, ts;
function Im() {
  return ts || (ts = 1, function(e, i) {
    var d = w && w.__createBinding || (Object.create ? function(s, r, u, l) {
      l === void 0 && (l = u);
      var n = Object.getOwnPropertyDescriptor(r, u);
      (!n || ("get" in n ? !r.__esModule : n.writable || n.configurable)) && (n = { enumerable: !0, get: function() {
        return r[u];
      } }), Object.defineProperty(s, l, n);
    } : function(s, r, u, l) {
      l === void 0 && (l = u), s[l] = r[u];
    }), a = w && w.__setModuleDefault || (Object.create ? function(s, r) {
      Object.defineProperty(s, "default", { enumerable: !0, value: r });
    } : function(s, r) {
      s.default = r;
    }), t = w && w.__importStar || function(s) {
      if (s && s.__esModule) return s;
      var r = {};
      if (s != null) for (var u in s) u !== "default" && Object.prototype.hasOwnProperty.call(s, u) && d(r, s, u);
      return a(r, s), r;
    };
    Object.defineProperty(i, "__esModule", { value: !0 }), i.default = p;
    const o = t(pe()), m = () => {
      const s = {
        string: { unit: "karakter", verb: "memiliki" },
        file: { unit: "byte", verb: "memiliki" },
        array: { unit: "item", verb: "memiliki" },
        set: { unit: "item", verb: "memiliki" }
      };
      function r(n) {
        return s[n] ?? null;
      }
      const u = (n) => {
        const f = typeof n;
        switch (f) {
          case "number":
            return Number.isNaN(n) ? "NaN" : "number";
          case "object": {
            if (Array.isArray(n))
              return "array";
            if (n === null)
              return "null";
            if (Object.getPrototypeOf(n) !== Object.prototype && n.constructor)
              return n.constructor.name;
          }
        }
        return f;
      }, l = {
        regex: "input",
        email: "alamat email",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "tanggal dan waktu format ISO",
        date: "tanggal format ISO",
        time: "jam format ISO",
        duration: "durasi format ISO",
        ipv4: "alamat IPv4",
        ipv6: "alamat IPv6",
        cidrv4: "rentang alamat IPv4",
        cidrv6: "rentang alamat IPv6",
        base64: "string dengan enkode base64",
        base64url: "string dengan enkode base64url",
        json_string: "string JSON",
        e164: "angka E.164",
        jwt: "JWT",
        template_literal: "input"
      };
      return (n) => {
        switch (n.code) {
          case "invalid_type":
            return `Input tidak valid: diharapkan ${n.expected}, diterima ${u(n.input)}`;
          case "invalid_value":
            return n.values.length === 1 ? `Input tidak valid: diharapkan ${o.stringifyPrimitive(n.values[0])}` : `Pilihan tidak valid: diharapkan salah satu dari ${o.joinValues(n.values, "|")}`;
          case "too_big": {
            const f = n.inclusive ? "<=" : "<", v = r(n.origin);
            return v ? `Terlalu besar: diharapkan ${n.origin ?? "value"} memiliki ${f}${n.maximum.toString()} ${v.unit ?? "elemen"}` : `Terlalu besar: diharapkan ${n.origin ?? "value"} menjadi ${f}${n.maximum.toString()}`;
          }
          case "too_small": {
            const f = n.inclusive ? ">=" : ">", v = r(n.origin);
            return v ? `Terlalu kecil: diharapkan ${n.origin} memiliki ${f}${n.minimum.toString()} ${v.unit}` : `Terlalu kecil: diharapkan ${n.origin} menjadi ${f}${n.minimum.toString()}`;
          }
          case "invalid_format": {
            const f = n;
            return f.format === "starts_with" ? `String tidak valid: harus dimulai dengan "${f.prefix}"` : f.format === "ends_with" ? `String tidak valid: harus berakhir dengan "${f.suffix}"` : f.format === "includes" ? `String tidak valid: harus menyertakan "${f.includes}"` : f.format === "regex" ? `String tidak valid: harus sesuai pola ${f.pattern}` : `${l[f.format] ?? n.format} tidak valid`;
          }
          case "not_multiple_of":
            return `Angka tidak valid: harus kelipatan dari ${n.divisor}`;
          case "unrecognized_keys":
            return `Kunci tidak dikenali ${n.keys.length > 1 ? "s" : ""}: ${o.joinValues(n.keys, ", ")}`;
          case "invalid_key":
            return `Kunci tidak valid di ${n.origin}`;
          case "invalid_union":
            return "Input tidak valid";
          case "invalid_element":
            return `Nilai tidak valid di ${n.origin}`;
          default:
            return "Input tidak valid";
        }
      };
    };
    function p() {
      return {
        localeError: m()
      };
    }
    e.exports = i.default;
  }($i, $i.exports)), $i.exports;
}
var yt = {}, rs;
function Tm() {
  return rs || (rs = 1, function(e) {
    var i = w && w.__createBinding || (Object.create ? function(s, r, u, l) {
      l === void 0 && (l = u);
      var n = Object.getOwnPropertyDescriptor(r, u);
      (!n || ("get" in n ? !r.__esModule : n.writable || n.configurable)) && (n = { enumerable: !0, get: function() {
        return r[u];
      } }), Object.defineProperty(s, l, n);
    } : function(s, r, u, l) {
      l === void 0 && (l = u), s[l] = r[u];
    }), d = w && w.__setModuleDefault || (Object.create ? function(s, r) {
      Object.defineProperty(s, "default", { enumerable: !0, value: r });
    } : function(s, r) {
      s.default = r;
    }), a = w && w.__importStar || function(s) {
      if (s && s.__esModule) return s;
      var r = {};
      if (s != null) for (var u in s) u !== "default" && Object.prototype.hasOwnProperty.call(s, u) && i(r, s, u);
      return d(r, s), r;
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), e.parsedType = void 0, e.default = p;
    const t = a(pe()), o = (s) => {
      const r = typeof s;
      switch (r) {
        case "number":
          return Number.isNaN(s) ? "NaN" : "númer";
        case "object": {
          if (Array.isArray(s))
            return "fylki";
          if (s === null)
            return "null";
          if (Object.getPrototypeOf(s) !== Object.prototype && s.constructor)
            return s.constructor.name;
        }
      }
      return r;
    };
    e.parsedType = o;
    const m = () => {
      const s = {
        string: { unit: "stafi", verb: "að hafa" },
        file: { unit: "bæti", verb: "að hafa" },
        array: { unit: "hluti", verb: "að hafa" },
        set: { unit: "hluti", verb: "að hafa" }
      };
      function r(l) {
        return s[l] ?? null;
      }
      const u = {
        regex: "gildi",
        email: "netfang",
        url: "vefslóð",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO dagsetning og tími",
        date: "ISO dagsetning",
        time: "ISO tími",
        duration: "ISO tímalengd",
        ipv4: "IPv4 address",
        ipv6: "IPv6 address",
        cidrv4: "IPv4 range",
        cidrv6: "IPv6 range",
        base64: "base64-encoded strengur",
        base64url: "base64url-encoded strengur",
        json_string: "JSON strengur",
        e164: "E.164 tölugildi",
        jwt: "JWT",
        template_literal: "gildi"
      };
      return (l) => {
        switch (l.code) {
          case "invalid_type":
            return `Rangt gildi: Þú slóst inn ${(0, e.parsedType)(l.input)} þar sem á að vera ${l.expected}`;
          case "invalid_value":
            return l.values.length === 1 ? `Rangt gildi: gert ráð fyrir ${t.stringifyPrimitive(l.values[0])}` : `Ógilt val: má vera eitt af eftirfarandi ${t.joinValues(l.values, "|")}`;
          case "too_big": {
            const n = l.inclusive ? "<=" : "<", f = r(l.origin);
            return f ? `Of stórt: gert er ráð fyrir að ${l.origin ?? "gildi"} hafi ${n}${l.maximum.toString()} ${f.unit ?? "hluti"}` : `Of stórt: gert er ráð fyrir að ${l.origin ?? "gildi"} sé ${n}${l.maximum.toString()}`;
          }
          case "too_small": {
            const n = l.inclusive ? ">=" : ">", f = r(l.origin);
            return f ? `Of lítið: gert er ráð fyrir að ${l.origin} hafi ${n}${l.minimum.toString()} ${f.unit}` : `Of lítið: gert er ráð fyrir að ${l.origin} sé ${n}${l.minimum.toString()}`;
          }
          case "invalid_format": {
            const n = l;
            return n.format === "starts_with" ? `Ógildur strengur: verður að byrja á "${n.prefix}"` : n.format === "ends_with" ? `Ógildur strengur: verður að enda á "${n.suffix}"` : n.format === "includes" ? `Ógildur strengur: verður að innihalda "${n.includes}"` : n.format === "regex" ? `Ógildur strengur: verður að fylgja mynstri ${n.pattern}` : `Rangt ${u[n.format] ?? l.format}`;
          }
          case "not_multiple_of":
            return `Röng tala: verður að vera margfeldi af ${l.divisor}`;
          case "unrecognized_keys":
            return `Óþekkt ${l.keys.length > 1 ? "ir lyklar" : "ur lykill"}: ${t.joinValues(l.keys, ", ")}`;
          case "invalid_key":
            return `Rangur lykill í ${l.origin}`;
          case "invalid_union":
            return "Rangt gildi";
          case "invalid_element":
            return `Rangt gildi í ${l.origin}`;
          default:
            return "Rangt gildi";
        }
      };
    };
    function p() {
      return {
        localeError: m()
      };
    }
  }(yt)), yt;
}
var Pi = { exports: {} }, os;
function Nm() {
  return os || (os = 1, function(e, i) {
    var d = w && w.__createBinding || (Object.create ? function(s, r, u, l) {
      l === void 0 && (l = u);
      var n = Object.getOwnPropertyDescriptor(r, u);
      (!n || ("get" in n ? !r.__esModule : n.writable || n.configurable)) && (n = { enumerable: !0, get: function() {
        return r[u];
      } }), Object.defineProperty(s, l, n);
    } : function(s, r, u, l) {
      l === void 0 && (l = u), s[l] = r[u];
    }), a = w && w.__setModuleDefault || (Object.create ? function(s, r) {
      Object.defineProperty(s, "default", { enumerable: !0, value: r });
    } : function(s, r) {
      s.default = r;
    }), t = w && w.__importStar || function(s) {
      if (s && s.__esModule) return s;
      var r = {};
      if (s != null) for (var u in s) u !== "default" && Object.prototype.hasOwnProperty.call(s, u) && d(r, s, u);
      return a(r, s), r;
    };
    Object.defineProperty(i, "__esModule", { value: !0 }), i.default = p;
    const o = t(pe()), m = () => {
      const s = {
        string: { unit: "caratteri", verb: "avere" },
        file: { unit: "byte", verb: "avere" },
        array: { unit: "elementi", verb: "avere" },
        set: { unit: "elementi", verb: "avere" }
      };
      function r(n) {
        return s[n] ?? null;
      }
      const u = (n) => {
        const f = typeof n;
        switch (f) {
          case "number":
            return Number.isNaN(n) ? "NaN" : "numero";
          case "object": {
            if (Array.isArray(n))
              return "vettore";
            if (n === null)
              return "null";
            if (Object.getPrototypeOf(n) !== Object.prototype && n.constructor)
              return n.constructor.name;
          }
        }
        return f;
      }, l = {
        regex: "input",
        email: "indirizzo email",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "data e ora ISO",
        date: "data ISO",
        time: "ora ISO",
        duration: "durata ISO",
        ipv4: "indirizzo IPv4",
        ipv6: "indirizzo IPv6",
        cidrv4: "intervallo IPv4",
        cidrv6: "intervallo IPv6",
        base64: "stringa codificata in base64",
        base64url: "URL codificata in base64",
        json_string: "stringa JSON",
        e164: "numero E.164",
        jwt: "JWT",
        template_literal: "input"
      };
      return (n) => {
        switch (n.code) {
          case "invalid_type":
            return `Input non valido: atteso ${n.expected}, ricevuto ${u(n.input)}`;
          case "invalid_value":
            return n.values.length === 1 ? `Input non valido: atteso ${o.stringifyPrimitive(n.values[0])}` : `Opzione non valida: atteso uno tra ${o.joinValues(n.values, "|")}`;
          case "too_big": {
            const f = n.inclusive ? "<=" : "<", v = r(n.origin);
            return v ? `Troppo grande: ${n.origin ?? "valore"} deve avere ${f}${n.maximum.toString()} ${v.unit ?? "elementi"}` : `Troppo grande: ${n.origin ?? "valore"} deve essere ${f}${n.maximum.toString()}`;
          }
          case "too_small": {
            const f = n.inclusive ? ">=" : ">", v = r(n.origin);
            return v ? `Troppo piccolo: ${n.origin} deve avere ${f}${n.minimum.toString()} ${v.unit}` : `Troppo piccolo: ${n.origin} deve essere ${f}${n.minimum.toString()}`;
          }
          case "invalid_format": {
            const f = n;
            return f.format === "starts_with" ? `Stringa non valida: deve iniziare con "${f.prefix}"` : f.format === "ends_with" ? `Stringa non valida: deve terminare con "${f.suffix}"` : f.format === "includes" ? `Stringa non valida: deve includere "${f.includes}"` : f.format === "regex" ? `Stringa non valida: deve corrispondere al pattern ${f.pattern}` : `Invalid ${l[f.format] ?? n.format}`;
          }
          case "not_multiple_of":
            return `Numero non valido: deve essere un multiplo di ${n.divisor}`;
          case "unrecognized_keys":
            return `Chiav${n.keys.length > 1 ? "i" : "e"} non riconosciut${n.keys.length > 1 ? "e" : "a"}: ${o.joinValues(n.keys, ", ")}`;
          case "invalid_key":
            return `Chiave non valida in ${n.origin}`;
          case "invalid_union":
            return "Input non valido";
          case "invalid_element":
            return `Valore non valido in ${n.origin}`;
          default:
            return "Input non valido";
        }
      };
    };
    function p() {
      return {
        localeError: m()
      };
    }
    e.exports = i.default;
  }(Pi, Pi.exports)), Pi.exports;
}
var Mi = { exports: {} }, ss;
function xm() {
  return ss || (ss = 1, function(e, i) {
    var d = w && w.__createBinding || (Object.create ? function(s, r, u, l) {
      l === void 0 && (l = u);
      var n = Object.getOwnPropertyDescriptor(r, u);
      (!n || ("get" in n ? !r.__esModule : n.writable || n.configurable)) && (n = { enumerable: !0, get: function() {
        return r[u];
      } }), Object.defineProperty(s, l, n);
    } : function(s, r, u, l) {
      l === void 0 && (l = u), s[l] = r[u];
    }), a = w && w.__setModuleDefault || (Object.create ? function(s, r) {
      Object.defineProperty(s, "default", { enumerable: !0, value: r });
    } : function(s, r) {
      s.default = r;
    }), t = w && w.__importStar || function(s) {
      if (s && s.__esModule) return s;
      var r = {};
      if (s != null) for (var u in s) u !== "default" && Object.prototype.hasOwnProperty.call(s, u) && d(r, s, u);
      return a(r, s), r;
    };
    Object.defineProperty(i, "__esModule", { value: !0 }), i.default = p;
    const o = t(pe()), m = () => {
      const s = {
        string: { unit: "文字", verb: "である" },
        file: { unit: "バイト", verb: "である" },
        array: { unit: "要素", verb: "である" },
        set: { unit: "要素", verb: "である" }
      };
      function r(n) {
        return s[n] ?? null;
      }
      const u = (n) => {
        const f = typeof n;
        switch (f) {
          case "number":
            return Number.isNaN(n) ? "NaN" : "数値";
          case "object": {
            if (Array.isArray(n))
              return "配列";
            if (n === null)
              return "null";
            if (Object.getPrototypeOf(n) !== Object.prototype && n.constructor)
              return n.constructor.name;
          }
        }
        return f;
      }, l = {
        regex: "入力値",
        email: "メールアドレス",
        url: "URL",
        emoji: "絵文字",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO日時",
        date: "ISO日付",
        time: "ISO時刻",
        duration: "ISO期間",
        ipv4: "IPv4アドレス",
        ipv6: "IPv6アドレス",
        cidrv4: "IPv4範囲",
        cidrv6: "IPv6範囲",
        base64: "base64エンコード文字列",
        base64url: "base64urlエンコード文字列",
        json_string: "JSON文字列",
        e164: "E.164番号",
        jwt: "JWT",
        template_literal: "入力値"
      };
      return (n) => {
        switch (n.code) {
          case "invalid_type":
            return `無効な入力: ${n.expected}が期待されましたが、${u(n.input)}が入力されました`;
          case "invalid_value":
            return n.values.length === 1 ? `無効な入力: ${o.stringifyPrimitive(n.values[0])}が期待されました` : `無効な選択: ${o.joinValues(n.values, "、")}のいずれかである必要があります`;
          case "too_big": {
            const f = n.inclusive ? "以下である" : "より小さい", v = r(n.origin);
            return v ? `大きすぎる値: ${n.origin ?? "値"}は${n.maximum.toString()}${v.unit ?? "要素"}${f}必要があります` : `大きすぎる値: ${n.origin ?? "値"}は${n.maximum.toString()}${f}必要があります`;
          }
          case "too_small": {
            const f = n.inclusive ? "以上である" : "より大きい", v = r(n.origin);
            return v ? `小さすぎる値: ${n.origin}は${n.minimum.toString()}${v.unit}${f}必要があります` : `小さすぎる値: ${n.origin}は${n.minimum.toString()}${f}必要があります`;
          }
          case "invalid_format": {
            const f = n;
            return f.format === "starts_with" ? `無効な文字列: "${f.prefix}"で始まる必要があります` : f.format === "ends_with" ? `無効な文字列: "${f.suffix}"で終わる必要があります` : f.format === "includes" ? `無効な文字列: "${f.includes}"を含む必要があります` : f.format === "regex" ? `無効な文字列: パターン${f.pattern}に一致する必要があります` : `無効な${l[f.format] ?? n.format}`;
          }
          case "not_multiple_of":
            return `無効な数値: ${n.divisor}の倍数である必要があります`;
          case "unrecognized_keys":
            return `認識されていないキー${n.keys.length > 1 ? "群" : ""}: ${o.joinValues(n.keys, "、")}`;
          case "invalid_key":
            return `${n.origin}内の無効なキー`;
          case "invalid_union":
            return "無効な入力";
          case "invalid_element":
            return `${n.origin}内の無効な値`;
          default:
            return "無効な入力";
        }
      };
    };
    function p() {
      return {
        localeError: m()
      };
    }
    e.exports = i.default;
  }(Mi, Mi.exports)), Mi.exports;
}
var ji = { exports: {} }, ds;
function Fm() {
  return ds || (ds = 1, function(e, i) {
    var d = w && w.__createBinding || (Object.create ? function(s, r, u, l) {
      l === void 0 && (l = u);
      var n = Object.getOwnPropertyDescriptor(r, u);
      (!n || ("get" in n ? !r.__esModule : n.writable || n.configurable)) && (n = { enumerable: !0, get: function() {
        return r[u];
      } }), Object.defineProperty(s, l, n);
    } : function(s, r, u, l) {
      l === void 0 && (l = u), s[l] = r[u];
    }), a = w && w.__setModuleDefault || (Object.create ? function(s, r) {
      Object.defineProperty(s, "default", { enumerable: !0, value: r });
    } : function(s, r) {
      s.default = r;
    }), t = w && w.__importStar || function(s) {
      if (s && s.__esModule) return s;
      var r = {};
      if (s != null) for (var u in s) u !== "default" && Object.prototype.hasOwnProperty.call(s, u) && d(r, s, u);
      return a(r, s), r;
    };
    Object.defineProperty(i, "__esModule", { value: !0 }), i.default = p;
    const o = t(pe()), m = () => {
      const s = {
        string: { unit: "តួអក្សរ", verb: "គួរមាន" },
        file: { unit: "បៃ", verb: "គួរមាន" },
        array: { unit: "ធាតុ", verb: "គួរមាន" },
        set: { unit: "ធាតុ", verb: "គួរមាន" }
      };
      function r(n) {
        return s[n] ?? null;
      }
      const u = (n) => {
        const f = typeof n;
        switch (f) {
          case "number":
            return Number.isNaN(n) ? "មិនមែនជាលេខ (NaN)" : "លេខ";
          case "object": {
            if (Array.isArray(n))
              return "អារេ (Array)";
            if (n === null)
              return "គ្មានតម្លៃ (null)";
            if (Object.getPrototypeOf(n) !== Object.prototype && n.constructor)
              return n.constructor.name;
          }
        }
        return f;
      }, l = {
        regex: "ទិន្នន័យបញ្ចូល",
        email: "អាសយដ្ឋានអ៊ីមែល",
        url: "URL",
        emoji: "សញ្ញាអារម្មណ៍",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "កាលបរិច្ឆេទ និងម៉ោង ISO",
        date: "កាលបរិច្ឆេទ ISO",
        time: "ម៉ោង ISO",
        duration: "រយៈពេល ISO",
        ipv4: "អាសយដ្ឋាន IPv4",
        ipv6: "អាសយដ្ឋាន IPv6",
        cidrv4: "ដែនអាសយដ្ឋាន IPv4",
        cidrv6: "ដែនអាសយដ្ឋាន IPv6",
        base64: "ខ្សែអក្សរអ៊ិកូដ base64",
        base64url: "ខ្សែអក្សរអ៊ិកូដ base64url",
        json_string: "ខ្សែអក្សរ JSON",
        e164: "លេខ E.164",
        jwt: "JWT",
        template_literal: "ទិន្នន័យបញ្ចូល"
      };
      return (n) => {
        switch (n.code) {
          case "invalid_type":
            return `ទិន្នន័យបញ្ចូលមិនត្រឹមត្រូវ៖ ត្រូវការ ${n.expected} ប៉ុន្តែទទួលបាន ${u(n.input)}`;
          case "invalid_value":
            return n.values.length === 1 ? `ទិន្នន័យបញ្ចូលមិនត្រឹមត្រូវ៖ ត្រូវការ ${o.stringifyPrimitive(n.values[0])}` : `ជម្រើសមិនត្រឹមត្រូវ៖ ត្រូវជាមួយក្នុងចំណោម ${o.joinValues(n.values, "|")}`;
          case "too_big": {
            const f = n.inclusive ? "<=" : "<", v = r(n.origin);
            return v ? `ធំពេក៖ ត្រូវការ ${n.origin ?? "តម្លៃ"} ${f} ${n.maximum.toString()} ${v.unit ?? "ធាតុ"}` : `ធំពេក៖ ត្រូវការ ${n.origin ?? "តម្លៃ"} ${f} ${n.maximum.toString()}`;
          }
          case "too_small": {
            const f = n.inclusive ? ">=" : ">", v = r(n.origin);
            return v ? `តូចពេក៖ ត្រូវការ ${n.origin} ${f} ${n.minimum.toString()} ${v.unit}` : `តូចពេក៖ ត្រូវការ ${n.origin} ${f} ${n.minimum.toString()}`;
          }
          case "invalid_format": {
            const f = n;
            return f.format === "starts_with" ? `ខ្សែអក្សរមិនត្រឹមត្រូវ៖ ត្រូវចាប់ផ្តើមដោយ "${f.prefix}"` : f.format === "ends_with" ? `ខ្សែអក្សរមិនត្រឹមត្រូវ៖ ត្រូវបញ្ចប់ដោយ "${f.suffix}"` : f.format === "includes" ? `ខ្សែអក្សរមិនត្រឹមត្រូវ៖ ត្រូវមាន "${f.includes}"` : f.format === "regex" ? `ខ្សែអក្សរមិនត្រឹមត្រូវ៖ ត្រូវតែផ្គូផ្គងនឹងទម្រង់ដែលបានកំណត់ ${f.pattern}` : `មិនត្រឹមត្រូវ៖ ${l[f.format] ?? n.format}`;
          }
          case "not_multiple_of":
            return `លេខមិនត្រឹមត្រូវ៖ ត្រូវតែជាពហុគុណនៃ ${n.divisor}`;
          case "unrecognized_keys":
            return `រកឃើញសោមិនស្គាល់៖ ${o.joinValues(n.keys, ", ")}`;
          case "invalid_key":
            return `សោមិនត្រឹមត្រូវនៅក្នុង ${n.origin}`;
          case "invalid_union":
            return "ទិន្នន័យមិនត្រឹមត្រូវ";
          case "invalid_element":
            return `ទិន្នន័យមិនត្រឹមត្រូវនៅក្នុង ${n.origin}`;
          default:
            return "ទិន្នន័យមិនត្រឹមត្រូវ";
        }
      };
    };
    function p() {
      return {
        localeError: m()
      };
    }
    e.exports = i.default;
  }(ji, ji.exports)), ji.exports;
}
var Si = { exports: {} }, us;
function Em() {
  return us || (us = 1, function(e, i) {
    var d = w && w.__createBinding || (Object.create ? function(s, r, u, l) {
      l === void 0 && (l = u);
      var n = Object.getOwnPropertyDescriptor(r, u);
      (!n || ("get" in n ? !r.__esModule : n.writable || n.configurable)) && (n = { enumerable: !0, get: function() {
        return r[u];
      } }), Object.defineProperty(s, l, n);
    } : function(s, r, u, l) {
      l === void 0 && (l = u), s[l] = r[u];
    }), a = w && w.__setModuleDefault || (Object.create ? function(s, r) {
      Object.defineProperty(s, "default", { enumerable: !0, value: r });
    } : function(s, r) {
      s.default = r;
    }), t = w && w.__importStar || function(s) {
      if (s && s.__esModule) return s;
      var r = {};
      if (s != null) for (var u in s) u !== "default" && Object.prototype.hasOwnProperty.call(s, u) && d(r, s, u);
      return a(r, s), r;
    };
    Object.defineProperty(i, "__esModule", { value: !0 }), i.default = p;
    const o = t(pe()), m = () => {
      const s = {
        string: { unit: "문자", verb: "to have" },
        file: { unit: "바이트", verb: "to have" },
        array: { unit: "개", verb: "to have" },
        set: { unit: "개", verb: "to have" }
      };
      function r(n) {
        return s[n] ?? null;
      }
      const u = (n) => {
        const f = typeof n;
        switch (f) {
          case "number":
            return Number.isNaN(n) ? "NaN" : "number";
          case "object": {
            if (Array.isArray(n))
              return "array";
            if (n === null)
              return "null";
            if (Object.getPrototypeOf(n) !== Object.prototype && n.constructor)
              return n.constructor.name;
          }
        }
        return f;
      }, l = {
        regex: "입력",
        email: "이메일 주소",
        url: "URL",
        emoji: "이모지",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO 날짜시간",
        date: "ISO 날짜",
        time: "ISO 시간",
        duration: "ISO 기간",
        ipv4: "IPv4 주소",
        ipv6: "IPv6 주소",
        cidrv4: "IPv4 범위",
        cidrv6: "IPv6 범위",
        base64: "base64 인코딩 문자열",
        base64url: "base64url 인코딩 문자열",
        json_string: "JSON 문자열",
        e164: "E.164 번호",
        jwt: "JWT",
        template_literal: "입력"
      };
      return (n) => {
        switch (n.code) {
          case "invalid_type":
            return `잘못된 입력: 예상 타입은 ${n.expected}, 받은 타입은 ${u(n.input)}입니다`;
          case "invalid_value":
            return n.values.length === 1 ? `잘못된 입력: 값은 ${o.stringifyPrimitive(n.values[0])} 이어야 합니다` : `잘못된 옵션: ${o.joinValues(n.values, "또는 ")} 중 하나여야 합니다`;
          case "too_big": {
            const f = n.inclusive ? "이하" : "미만", v = f === "미만" ? "이어야 합니다" : "여야 합니다", D = r(n.origin), F = (D == null ? void 0 : D.unit) ?? "요소";
            return D ? `${n.origin ?? "값"}이 너무 큽니다: ${n.maximum.toString()}${F} ${f}${v}` : `${n.origin ?? "값"}이 너무 큽니다: ${n.maximum.toString()} ${f}${v}`;
          }
          case "too_small": {
            const f = n.inclusive ? "이상" : "초과", v = f === "이상" ? "이어야 합니다" : "여야 합니다", D = r(n.origin), F = (D == null ? void 0 : D.unit) ?? "요소";
            return D ? `${n.origin ?? "값"}이 너무 작습니다: ${n.minimum.toString()}${F} ${f}${v}` : `${n.origin ?? "값"}이 너무 작습니다: ${n.minimum.toString()} ${f}${v}`;
          }
          case "invalid_format": {
            const f = n;
            return f.format === "starts_with" ? `잘못된 문자열: "${f.prefix}"(으)로 시작해야 합니다` : f.format === "ends_with" ? `잘못된 문자열: "${f.suffix}"(으)로 끝나야 합니다` : f.format === "includes" ? `잘못된 문자열: "${f.includes}"을(를) 포함해야 합니다` : f.format === "regex" ? `잘못된 문자열: 정규식 ${f.pattern} 패턴과 일치해야 합니다` : `잘못된 ${l[f.format] ?? n.format}`;
          }
          case "not_multiple_of":
            return `잘못된 숫자: ${n.divisor}의 배수여야 합니다`;
          case "unrecognized_keys":
            return `인식할 수 없는 키: ${o.joinValues(n.keys, ", ")}`;
          case "invalid_key":
            return `잘못된 키: ${n.origin}`;
          case "invalid_union":
            return "잘못된 입력";
          case "invalid_element":
            return `잘못된 값: ${n.origin}`;
          default:
            return "잘못된 입력";
        }
      };
    };
    function p() {
      return {
        localeError: m()
      };
    }
    e.exports = i.default;
  }(Si, Si.exports)), Si.exports;
}
var zi = { exports: {} }, fs;
function Rm() {
  return fs || (fs = 1, function(e, i) {
    var d = w && w.__createBinding || (Object.create ? function(s, r, u, l) {
      l === void 0 && (l = u);
      var n = Object.getOwnPropertyDescriptor(r, u);
      (!n || ("get" in n ? !r.__esModule : n.writable || n.configurable)) && (n = { enumerable: !0, get: function() {
        return r[u];
      } }), Object.defineProperty(s, l, n);
    } : function(s, r, u, l) {
      l === void 0 && (l = u), s[l] = r[u];
    }), a = w && w.__setModuleDefault || (Object.create ? function(s, r) {
      Object.defineProperty(s, "default", { enumerable: !0, value: r });
    } : function(s, r) {
      s.default = r;
    }), t = w && w.__importStar || function(s) {
      if (s && s.__esModule) return s;
      var r = {};
      if (s != null) for (var u in s) u !== "default" && Object.prototype.hasOwnProperty.call(s, u) && d(r, s, u);
      return a(r, s), r;
    };
    Object.defineProperty(i, "__esModule", { value: !0 }), i.default = p;
    const o = t(pe()), m = () => {
      const s = {
        string: { unit: "знаци", verb: "да имаат" },
        file: { unit: "бајти", verb: "да имаат" },
        array: { unit: "ставки", verb: "да имаат" },
        set: { unit: "ставки", verb: "да имаат" }
      };
      function r(n) {
        return s[n] ?? null;
      }
      const u = (n) => {
        const f = typeof n;
        switch (f) {
          case "number":
            return Number.isNaN(n) ? "NaN" : "број";
          case "object": {
            if (Array.isArray(n))
              return "низа";
            if (n === null)
              return "null";
            if (Object.getPrototypeOf(n) !== Object.prototype && n.constructor)
              return n.constructor.name;
          }
        }
        return f;
      }, l = {
        regex: "внес",
        email: "адреса на е-пошта",
        url: "URL",
        emoji: "емоџи",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO датум и време",
        date: "ISO датум",
        time: "ISO време",
        duration: "ISO времетраење",
        ipv4: "IPv4 адреса",
        ipv6: "IPv6 адреса",
        cidrv4: "IPv4 опсег",
        cidrv6: "IPv6 опсег",
        base64: "base64-енкодирана низа",
        base64url: "base64url-енкодирана низа",
        json_string: "JSON низа",
        e164: "E.164 број",
        jwt: "JWT",
        template_literal: "внес"
      };
      return (n) => {
        switch (n.code) {
          case "invalid_type":
            return `Грешен внес: се очекува ${n.expected}, примено ${u(n.input)}`;
          case "invalid_value":
            return n.values.length === 1 ? `Invalid input: expected ${o.stringifyPrimitive(n.values[0])}` : `Грешана опција: се очекува една ${o.joinValues(n.values, "|")}`;
          case "too_big": {
            const f = n.inclusive ? "<=" : "<", v = r(n.origin);
            return v ? `Премногу голем: се очекува ${n.origin ?? "вредноста"} да има ${f}${n.maximum.toString()} ${v.unit ?? "елементи"}` : `Премногу голем: се очекува ${n.origin ?? "вредноста"} да биде ${f}${n.maximum.toString()}`;
          }
          case "too_small": {
            const f = n.inclusive ? ">=" : ">", v = r(n.origin);
            return v ? `Премногу мал: се очекува ${n.origin} да има ${f}${n.minimum.toString()} ${v.unit}` : `Премногу мал: се очекува ${n.origin} да биде ${f}${n.minimum.toString()}`;
          }
          case "invalid_format": {
            const f = n;
            return f.format === "starts_with" ? `Неважечка низа: мора да започнува со "${f.prefix}"` : f.format === "ends_with" ? `Неважечка низа: мора да завршува со "${f.suffix}"` : f.format === "includes" ? `Неважечка низа: мора да вклучува "${f.includes}"` : f.format === "regex" ? `Неважечка низа: мора да одгоара на патернот ${f.pattern}` : `Invalid ${l[f.format] ?? n.format}`;
          }
          case "not_multiple_of":
            return `Грешен број: мора да биде делив со ${n.divisor}`;
          case "unrecognized_keys":
            return `${n.keys.length > 1 ? "Непрепознаени клучеви" : "Непрепознаен клуч"}: ${o.joinValues(n.keys, ", ")}`;
          case "invalid_key":
            return `Грешен клуч во ${n.origin}`;
          case "invalid_union":
            return "Грешен внес";
          case "invalid_element":
            return `Грешна вредност во ${n.origin}`;
          default:
            return "Грешен внес";
        }
      };
    };
    function p() {
      return {
        localeError: m()
      };
    }
    e.exports = i.default;
  }(zi, zi.exports)), zi.exports;
}
var Oi = { exports: {} }, ls;
function Lm() {
  return ls || (ls = 1, function(e, i) {
    var d = w && w.__createBinding || (Object.create ? function(s, r, u, l) {
      l === void 0 && (l = u);
      var n = Object.getOwnPropertyDescriptor(r, u);
      (!n || ("get" in n ? !r.__esModule : n.writable || n.configurable)) && (n = { enumerable: !0, get: function() {
        return r[u];
      } }), Object.defineProperty(s, l, n);
    } : function(s, r, u, l) {
      l === void 0 && (l = u), s[l] = r[u];
    }), a = w && w.__setModuleDefault || (Object.create ? function(s, r) {
      Object.defineProperty(s, "default", { enumerable: !0, value: r });
    } : function(s, r) {
      s.default = r;
    }), t = w && w.__importStar || function(s) {
      if (s && s.__esModule) return s;
      var r = {};
      if (s != null) for (var u in s) u !== "default" && Object.prototype.hasOwnProperty.call(s, u) && d(r, s, u);
      return a(r, s), r;
    };
    Object.defineProperty(i, "__esModule", { value: !0 }), i.default = p;
    const o = t(pe()), m = () => {
      const s = {
        string: { unit: "aksara", verb: "mempunyai" },
        file: { unit: "bait", verb: "mempunyai" },
        array: { unit: "elemen", verb: "mempunyai" },
        set: { unit: "elemen", verb: "mempunyai" }
      };
      function r(n) {
        return s[n] ?? null;
      }
      const u = (n) => {
        const f = typeof n;
        switch (f) {
          case "number":
            return Number.isNaN(n) ? "NaN" : "nombor";
          case "object": {
            if (Array.isArray(n))
              return "array";
            if (n === null)
              return "null";
            if (Object.getPrototypeOf(n) !== Object.prototype && n.constructor)
              return n.constructor.name;
          }
        }
        return f;
      }, l = {
        regex: "input",
        email: "alamat e-mel",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "tarikh masa ISO",
        date: "tarikh ISO",
        time: "masa ISO",
        duration: "tempoh ISO",
        ipv4: "alamat IPv4",
        ipv6: "alamat IPv6",
        cidrv4: "julat IPv4",
        cidrv6: "julat IPv6",
        base64: "string dikodkan base64",
        base64url: "string dikodkan base64url",
        json_string: "string JSON",
        e164: "nombor E.164",
        jwt: "JWT",
        template_literal: "input"
      };
      return (n) => {
        switch (n.code) {
          case "invalid_type":
            return `Input tidak sah: dijangka ${n.expected}, diterima ${u(n.input)}`;
          case "invalid_value":
            return n.values.length === 1 ? `Input tidak sah: dijangka ${o.stringifyPrimitive(n.values[0])}` : `Pilihan tidak sah: dijangka salah satu daripada ${o.joinValues(n.values, "|")}`;
          case "too_big": {
            const f = n.inclusive ? "<=" : "<", v = r(n.origin);
            return v ? `Terlalu besar: dijangka ${n.origin ?? "nilai"} ${v.verb} ${f}${n.maximum.toString()} ${v.unit ?? "elemen"}` : `Terlalu besar: dijangka ${n.origin ?? "nilai"} adalah ${f}${n.maximum.toString()}`;
          }
          case "too_small": {
            const f = n.inclusive ? ">=" : ">", v = r(n.origin);
            return v ? `Terlalu kecil: dijangka ${n.origin} ${v.verb} ${f}${n.minimum.toString()} ${v.unit}` : `Terlalu kecil: dijangka ${n.origin} adalah ${f}${n.minimum.toString()}`;
          }
          case "invalid_format": {
            const f = n;
            return f.format === "starts_with" ? `String tidak sah: mesti bermula dengan "${f.prefix}"` : f.format === "ends_with" ? `String tidak sah: mesti berakhir dengan "${f.suffix}"` : f.format === "includes" ? `String tidak sah: mesti mengandungi "${f.includes}"` : f.format === "regex" ? `String tidak sah: mesti sepadan dengan corak ${f.pattern}` : `${l[f.format] ?? n.format} tidak sah`;
          }
          case "not_multiple_of":
            return `Nombor tidak sah: perlu gandaan ${n.divisor}`;
          case "unrecognized_keys":
            return `Kunci tidak dikenali: ${o.joinValues(n.keys, ", ")}`;
          case "invalid_key":
            return `Kunci tidak sah dalam ${n.origin}`;
          case "invalid_union":
            return "Input tidak sah";
          case "invalid_element":
            return `Nilai tidak sah dalam ${n.origin}`;
          default:
            return "Input tidak sah";
        }
      };
    };
    function p() {
      return {
        localeError: m()
      };
    }
    e.exports = i.default;
  }(Oi, Oi.exports)), Oi.exports;
}
var Wi = { exports: {} }, cs;
function qm() {
  return cs || (cs = 1, function(e, i) {
    var d = w && w.__createBinding || (Object.create ? function(s, r, u, l) {
      l === void 0 && (l = u);
      var n = Object.getOwnPropertyDescriptor(r, u);
      (!n || ("get" in n ? !r.__esModule : n.writable || n.configurable)) && (n = { enumerable: !0, get: function() {
        return r[u];
      } }), Object.defineProperty(s, l, n);
    } : function(s, r, u, l) {
      l === void 0 && (l = u), s[l] = r[u];
    }), a = w && w.__setModuleDefault || (Object.create ? function(s, r) {
      Object.defineProperty(s, "default", { enumerable: !0, value: r });
    } : function(s, r) {
      s.default = r;
    }), t = w && w.__importStar || function(s) {
      if (s && s.__esModule) return s;
      var r = {};
      if (s != null) for (var u in s) u !== "default" && Object.prototype.hasOwnProperty.call(s, u) && d(r, s, u);
      return a(r, s), r;
    };
    Object.defineProperty(i, "__esModule", { value: !0 }), i.default = p;
    const o = t(pe()), m = () => {
      const s = {
        string: { unit: "tekens" },
        file: { unit: "bytes" },
        array: { unit: "elementen" },
        set: { unit: "elementen" }
      };
      function r(n) {
        return s[n] ?? null;
      }
      const u = (n) => {
        const f = typeof n;
        switch (f) {
          case "number":
            return Number.isNaN(n) ? "NaN" : "getal";
          case "object": {
            if (Array.isArray(n))
              return "array";
            if (n === null)
              return "null";
            if (Object.getPrototypeOf(n) !== Object.prototype && n.constructor)
              return n.constructor.name;
          }
        }
        return f;
      }, l = {
        regex: "invoer",
        email: "emailadres",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO datum en tijd",
        date: "ISO datum",
        time: "ISO tijd",
        duration: "ISO duur",
        ipv4: "IPv4-adres",
        ipv6: "IPv6-adres",
        cidrv4: "IPv4-bereik",
        cidrv6: "IPv6-bereik",
        base64: "base64-gecodeerde tekst",
        base64url: "base64 URL-gecodeerde tekst",
        json_string: "JSON string",
        e164: "E.164-nummer",
        jwt: "JWT",
        template_literal: "invoer"
      };
      return (n) => {
        switch (n.code) {
          case "invalid_type":
            return `Ongeldige invoer: verwacht ${n.expected}, ontving ${u(n.input)}`;
          case "invalid_value":
            return n.values.length === 1 ? `Ongeldige invoer: verwacht ${o.stringifyPrimitive(n.values[0])}` : `Ongeldige optie: verwacht één van ${o.joinValues(n.values, "|")}`;
          case "too_big": {
            const f = n.inclusive ? "<=" : "<", v = r(n.origin);
            return v ? `Te lang: verwacht dat ${n.origin ?? "waarde"} ${f}${n.maximum.toString()} ${v.unit ?? "elementen"} bevat` : `Te lang: verwacht dat ${n.origin ?? "waarde"} ${f}${n.maximum.toString()} is`;
          }
          case "too_small": {
            const f = n.inclusive ? ">=" : ">", v = r(n.origin);
            return v ? `Te kort: verwacht dat ${n.origin} ${f}${n.minimum.toString()} ${v.unit} bevat` : `Te kort: verwacht dat ${n.origin} ${f}${n.minimum.toString()} is`;
          }
          case "invalid_format": {
            const f = n;
            return f.format === "starts_with" ? `Ongeldige tekst: moet met "${f.prefix}" beginnen` : f.format === "ends_with" ? `Ongeldige tekst: moet op "${f.suffix}" eindigen` : f.format === "includes" ? `Ongeldige tekst: moet "${f.includes}" bevatten` : f.format === "regex" ? `Ongeldige tekst: moet overeenkomen met patroon ${f.pattern}` : `Ongeldig: ${l[f.format] ?? n.format}`;
          }
          case "not_multiple_of":
            return `Ongeldig getal: moet een veelvoud van ${n.divisor} zijn`;
          case "unrecognized_keys":
            return `Onbekende key${n.keys.length > 1 ? "s" : ""}: ${o.joinValues(n.keys, ", ")}`;
          case "invalid_key":
            return `Ongeldige key in ${n.origin}`;
          case "invalid_union":
            return "Ongeldige invoer";
          case "invalid_element":
            return `Ongeldige waarde in ${n.origin}`;
          default:
            return "Ongeldige invoer";
        }
      };
    };
    function p() {
      return {
        localeError: m()
      };
    }
    e.exports = i.default;
  }(Wi, Wi.exports)), Wi.exports;
}
var Di = { exports: {} }, ms;
function Zm() {
  return ms || (ms = 1, function(e, i) {
    var d = w && w.__createBinding || (Object.create ? function(s, r, u, l) {
      l === void 0 && (l = u);
      var n = Object.getOwnPropertyDescriptor(r, u);
      (!n || ("get" in n ? !r.__esModule : n.writable || n.configurable)) && (n = { enumerable: !0, get: function() {
        return r[u];
      } }), Object.defineProperty(s, l, n);
    } : function(s, r, u, l) {
      l === void 0 && (l = u), s[l] = r[u];
    }), a = w && w.__setModuleDefault || (Object.create ? function(s, r) {
      Object.defineProperty(s, "default", { enumerable: !0, value: r });
    } : function(s, r) {
      s.default = r;
    }), t = w && w.__importStar || function(s) {
      if (s && s.__esModule) return s;
      var r = {};
      if (s != null) for (var u in s) u !== "default" && Object.prototype.hasOwnProperty.call(s, u) && d(r, s, u);
      return a(r, s), r;
    };
    Object.defineProperty(i, "__esModule", { value: !0 }), i.default = p;
    const o = t(pe()), m = () => {
      const s = {
        string: { unit: "tegn", verb: "å ha" },
        file: { unit: "bytes", verb: "å ha" },
        array: { unit: "elementer", verb: "å inneholde" },
        set: { unit: "elementer", verb: "å inneholde" }
      };
      function r(n) {
        return s[n] ?? null;
      }
      const u = (n) => {
        const f = typeof n;
        switch (f) {
          case "number":
            return Number.isNaN(n) ? "NaN" : "tall";
          case "object": {
            if (Array.isArray(n))
              return "liste";
            if (n === null)
              return "null";
            if (Object.getPrototypeOf(n) !== Object.prototype && n.constructor)
              return n.constructor.name;
          }
        }
        return f;
      }, l = {
        regex: "input",
        email: "e-postadresse",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO dato- og klokkeslett",
        date: "ISO-dato",
        time: "ISO-klokkeslett",
        duration: "ISO-varighet",
        ipv4: "IPv4-område",
        ipv6: "IPv6-område",
        cidrv4: "IPv4-spekter",
        cidrv6: "IPv6-spekter",
        base64: "base64-enkodet streng",
        base64url: "base64url-enkodet streng",
        json_string: "JSON-streng",
        e164: "E.164-nummer",
        jwt: "JWT",
        template_literal: "input"
      };
      return (n) => {
        switch (n.code) {
          case "invalid_type":
            return `Ugyldig input: forventet ${n.expected}, fikk ${u(n.input)}`;
          case "invalid_value":
            return n.values.length === 1 ? `Ugyldig verdi: forventet ${o.stringifyPrimitive(n.values[0])}` : `Ugyldig valg: forventet en av ${o.joinValues(n.values, "|")}`;
          case "too_big": {
            const f = n.inclusive ? "<=" : "<", v = r(n.origin);
            return v ? `For stor(t): forventet ${n.origin ?? "value"} til å ha ${f}${n.maximum.toString()} ${v.unit ?? "elementer"}` : `For stor(t): forventet ${n.origin ?? "value"} til å ha ${f}${n.maximum.toString()}`;
          }
          case "too_small": {
            const f = n.inclusive ? ">=" : ">", v = r(n.origin);
            return v ? `For lite(n): forventet ${n.origin} til å ha ${f}${n.minimum.toString()} ${v.unit}` : `For lite(n): forventet ${n.origin} til å ha ${f}${n.minimum.toString()}`;
          }
          case "invalid_format": {
            const f = n;
            return f.format === "starts_with" ? `Ugyldig streng: må starte med "${f.prefix}"` : f.format === "ends_with" ? `Ugyldig streng: må ende med "${f.suffix}"` : f.format === "includes" ? `Ugyldig streng: må inneholde "${f.includes}"` : f.format === "regex" ? `Ugyldig streng: må matche mønsteret ${f.pattern}` : `Ugyldig ${l[f.format] ?? n.format}`;
          }
          case "not_multiple_of":
            return `Ugyldig tall: må være et multiplum av ${n.divisor}`;
          case "unrecognized_keys":
            return `${n.keys.length > 1 ? "Ukjente nøkler" : "Ukjent nøkkel"}: ${o.joinValues(n.keys, ", ")}`;
          case "invalid_key":
            return `Ugyldig nøkkel i ${n.origin}`;
          case "invalid_union":
            return "Ugyldig input";
          case "invalid_element":
            return `Ugyldig verdi i ${n.origin}`;
          default:
            return "Ugyldig input";
        }
      };
    };
    function p() {
      return {
        localeError: m()
      };
    }
    e.exports = i.default;
  }(Di, Di.exports)), Di.exports;
}
var Ci = { exports: {} }, vs;
function Am() {
  return vs || (vs = 1, function(e, i) {
    var d = w && w.__createBinding || (Object.create ? function(s, r, u, l) {
      l === void 0 && (l = u);
      var n = Object.getOwnPropertyDescriptor(r, u);
      (!n || ("get" in n ? !r.__esModule : n.writable || n.configurable)) && (n = { enumerable: !0, get: function() {
        return r[u];
      } }), Object.defineProperty(s, l, n);
    } : function(s, r, u, l) {
      l === void 0 && (l = u), s[l] = r[u];
    }), a = w && w.__setModuleDefault || (Object.create ? function(s, r) {
      Object.defineProperty(s, "default", { enumerable: !0, value: r });
    } : function(s, r) {
      s.default = r;
    }), t = w && w.__importStar || function(s) {
      if (s && s.__esModule) return s;
      var r = {};
      if (s != null) for (var u in s) u !== "default" && Object.prototype.hasOwnProperty.call(s, u) && d(r, s, u);
      return a(r, s), r;
    };
    Object.defineProperty(i, "__esModule", { value: !0 }), i.default = p;
    const o = t(pe()), m = () => {
      const s = {
        string: { unit: "harf", verb: "olmalıdır" },
        file: { unit: "bayt", verb: "olmalıdır" },
        array: { unit: "unsur", verb: "olmalıdır" },
        set: { unit: "unsur", verb: "olmalıdır" }
      };
      function r(n) {
        return s[n] ?? null;
      }
      const u = (n) => {
        const f = typeof n;
        switch (f) {
          case "number":
            return Number.isNaN(n) ? "NaN" : "numara";
          case "object": {
            if (Array.isArray(n))
              return "saf";
            if (n === null)
              return "gayb";
            if (Object.getPrototypeOf(n) !== Object.prototype && n.constructor)
              return n.constructor.name;
          }
        }
        return f;
      }, l = {
        regex: "giren",
        email: "epostagâh",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO hengâmı",
        date: "ISO tarihi",
        time: "ISO zamanı",
        duration: "ISO müddeti",
        ipv4: "IPv4 nişânı",
        ipv6: "IPv6 nişânı",
        cidrv4: "IPv4 menzili",
        cidrv6: "IPv6 menzili",
        base64: "base64-şifreli metin",
        base64url: "base64url-şifreli metin",
        json_string: "JSON metin",
        e164: "E.164 sayısı",
        jwt: "JWT",
        template_literal: "giren"
      };
      return (n) => {
        switch (n.code) {
          case "invalid_type":
            return `Fâsit giren: umulan ${n.expected}, alınan ${u(n.input)}`;
          case "invalid_value":
            return n.values.length === 1 ? `Fâsit giren: umulan ${o.stringifyPrimitive(n.values[0])}` : `Fâsit tercih: mûteberler ${o.joinValues(n.values, "|")}`;
          case "too_big": {
            const f = n.inclusive ? "<=" : "<", v = r(n.origin);
            return v ? `Fazla büyük: ${n.origin ?? "value"}, ${f}${n.maximum.toString()} ${v.unit ?? "elements"} sahip olmalıydı.` : `Fazla büyük: ${n.origin ?? "value"}, ${f}${n.maximum.toString()} olmalıydı.`;
          }
          case "too_small": {
            const f = n.inclusive ? ">=" : ">", v = r(n.origin);
            return v ? `Fazla küçük: ${n.origin}, ${f}${n.minimum.toString()} ${v.unit} sahip olmalıydı.` : `Fazla küçük: ${n.origin}, ${f}${n.minimum.toString()} olmalıydı.`;
          }
          case "invalid_format": {
            const f = n;
            return f.format === "starts_with" ? `Fâsit metin: "${f.prefix}" ile başlamalı.` : f.format === "ends_with" ? `Fâsit metin: "${f.suffix}" ile bitmeli.` : f.format === "includes" ? `Fâsit metin: "${f.includes}" ihtivâ etmeli.` : f.format === "regex" ? `Fâsit metin: ${f.pattern} nakşına uymalı.` : `Fâsit ${l[f.format] ?? n.format}`;
          }
          case "not_multiple_of":
            return `Fâsit sayı: ${n.divisor} katı olmalıydı.`;
          case "unrecognized_keys":
            return `Tanınmayan anahtar ${n.keys.length > 1 ? "s" : ""}: ${o.joinValues(n.keys, ", ")}`;
          case "invalid_key":
            return `${n.origin} için tanınmayan anahtar var.`;
          case "invalid_union":
            return "Giren tanınamadı.";
          case "invalid_element":
            return `${n.origin} için tanınmayan kıymet var.`;
          default:
            return "Kıymet tanınamadı.";
        }
      };
    };
    function p() {
      return {
        localeError: m()
      };
    }
    e.exports = i.default;
  }(Ci, Ci.exports)), Ci.exports;
}
var Ii = { exports: {} }, hs;
function Vm() {
  return hs || (hs = 1, function(e, i) {
    var d = w && w.__createBinding || (Object.create ? function(s, r, u, l) {
      l === void 0 && (l = u);
      var n = Object.getOwnPropertyDescriptor(r, u);
      (!n || ("get" in n ? !r.__esModule : n.writable || n.configurable)) && (n = { enumerable: !0, get: function() {
        return r[u];
      } }), Object.defineProperty(s, l, n);
    } : function(s, r, u, l) {
      l === void 0 && (l = u), s[l] = r[u];
    }), a = w && w.__setModuleDefault || (Object.create ? function(s, r) {
      Object.defineProperty(s, "default", { enumerable: !0, value: r });
    } : function(s, r) {
      s.default = r;
    }), t = w && w.__importStar || function(s) {
      if (s && s.__esModule) return s;
      var r = {};
      if (s != null) for (var u in s) u !== "default" && Object.prototype.hasOwnProperty.call(s, u) && d(r, s, u);
      return a(r, s), r;
    };
    Object.defineProperty(i, "__esModule", { value: !0 }), i.default = p;
    const o = t(pe()), m = () => {
      const s = {
        string: { unit: "توکي", verb: "ولري" },
        file: { unit: "بایټس", verb: "ولري" },
        array: { unit: "توکي", verb: "ولري" },
        set: { unit: "توکي", verb: "ولري" }
      };
      function r(n) {
        return s[n] ?? null;
      }
      const u = (n) => {
        const f = typeof n;
        switch (f) {
          case "number":
            return Number.isNaN(n) ? "NaN" : "عدد";
          case "object": {
            if (Array.isArray(n))
              return "ارې";
            if (n === null)
              return "null";
            if (Object.getPrototypeOf(n) !== Object.prototype && n.constructor)
              return n.constructor.name;
          }
        }
        return f;
      }, l = {
        regex: "ورودي",
        email: "بریښنالیک",
        url: "یو آر ال",
        emoji: "ایموجي",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "نیټه او وخت",
        date: "نېټه",
        time: "وخت",
        duration: "موده",
        ipv4: "د IPv4 پته",
        ipv6: "د IPv6 پته",
        cidrv4: "د IPv4 ساحه",
        cidrv6: "د IPv6 ساحه",
        base64: "base64-encoded متن",
        base64url: "base64url-encoded متن",
        json_string: "JSON متن",
        e164: "د E.164 شمېره",
        jwt: "JWT",
        template_literal: "ورودي"
      };
      return (n) => {
        switch (n.code) {
          case "invalid_type":
            return `ناسم ورودي: باید ${n.expected} وای, مګر ${u(n.input)} ترلاسه شو`;
          case "invalid_value":
            return n.values.length === 1 ? `ناسم ورودي: باید ${o.stringifyPrimitive(n.values[0])} وای` : `ناسم انتخاب: باید یو له ${o.joinValues(n.values, "|")} څخه وای`;
          case "too_big": {
            const f = n.inclusive ? "<=" : "<", v = r(n.origin);
            return v ? `ډیر لوی: ${n.origin ?? "ارزښت"} باید ${f}${n.maximum.toString()} ${v.unit ?? "عنصرونه"} ولري` : `ډیر لوی: ${n.origin ?? "ارزښت"} باید ${f}${n.maximum.toString()} وي`;
          }
          case "too_small": {
            const f = n.inclusive ? ">=" : ">", v = r(n.origin);
            return v ? `ډیر کوچنی: ${n.origin} باید ${f}${n.minimum.toString()} ${v.unit} ولري` : `ډیر کوچنی: ${n.origin} باید ${f}${n.minimum.toString()} وي`;
          }
          case "invalid_format": {
            const f = n;
            return f.format === "starts_with" ? `ناسم متن: باید د "${f.prefix}" سره پیل شي` : f.format === "ends_with" ? `ناسم متن: باید د "${f.suffix}" سره پای ته ورسيږي` : f.format === "includes" ? `ناسم متن: باید "${f.includes}" ولري` : f.format === "regex" ? `ناسم متن: باید د ${f.pattern} سره مطابقت ولري` : `${l[f.format] ?? n.format} ناسم دی`;
          }
          case "not_multiple_of":
            return `ناسم عدد: باید د ${n.divisor} مضرب وي`;
          case "unrecognized_keys":
            return `ناسم ${n.keys.length > 1 ? "کلیډونه" : "کلیډ"}: ${o.joinValues(n.keys, ", ")}`;
          case "invalid_key":
            return `ناسم کلیډ په ${n.origin} کې`;
          case "invalid_union":
            return "ناسمه ورودي";
          case "invalid_element":
            return `ناسم عنصر په ${n.origin} کې`;
          default:
            return "ناسمه ورودي";
        }
      };
    };
    function p() {
      return {
        localeError: m()
      };
    }
    e.exports = i.default;
  }(Ii, Ii.exports)), Ii.exports;
}
var Ti = { exports: {} }, gs;
function Hm() {
  return gs || (gs = 1, function(e, i) {
    var d = w && w.__createBinding || (Object.create ? function(s, r, u, l) {
      l === void 0 && (l = u);
      var n = Object.getOwnPropertyDescriptor(r, u);
      (!n || ("get" in n ? !r.__esModule : n.writable || n.configurable)) && (n = { enumerable: !0, get: function() {
        return r[u];
      } }), Object.defineProperty(s, l, n);
    } : function(s, r, u, l) {
      l === void 0 && (l = u), s[l] = r[u];
    }), a = w && w.__setModuleDefault || (Object.create ? function(s, r) {
      Object.defineProperty(s, "default", { enumerable: !0, value: r });
    } : function(s, r) {
      s.default = r;
    }), t = w && w.__importStar || function(s) {
      if (s && s.__esModule) return s;
      var r = {};
      if (s != null) for (var u in s) u !== "default" && Object.prototype.hasOwnProperty.call(s, u) && d(r, s, u);
      return a(r, s), r;
    };
    Object.defineProperty(i, "__esModule", { value: !0 }), i.default = p;
    const o = t(pe()), m = () => {
      const s = {
        string: { unit: "znaków", verb: "mieć" },
        file: { unit: "bajtów", verb: "mieć" },
        array: { unit: "elementów", verb: "mieć" },
        set: { unit: "elementów", verb: "mieć" }
      };
      function r(n) {
        return s[n] ?? null;
      }
      const u = (n) => {
        const f = typeof n;
        switch (f) {
          case "number":
            return Number.isNaN(n) ? "NaN" : "liczba";
          case "object": {
            if (Array.isArray(n))
              return "tablica";
            if (n === null)
              return "null";
            if (Object.getPrototypeOf(n) !== Object.prototype && n.constructor)
              return n.constructor.name;
          }
        }
        return f;
      }, l = {
        regex: "wyrażenie",
        email: "adres email",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "data i godzina w formacie ISO",
        date: "data w formacie ISO",
        time: "godzina w formacie ISO",
        duration: "czas trwania ISO",
        ipv4: "adres IPv4",
        ipv6: "adres IPv6",
        cidrv4: "zakres IPv4",
        cidrv6: "zakres IPv6",
        base64: "ciąg znaków zakodowany w formacie base64",
        base64url: "ciąg znaków zakodowany w formacie base64url",
        json_string: "ciąg znaków w formacie JSON",
        e164: "liczba E.164",
        jwt: "JWT",
        template_literal: "wejście"
      };
      return (n) => {
        switch (n.code) {
          case "invalid_type":
            return `Nieprawidłowe dane wejściowe: oczekiwano ${n.expected}, otrzymano ${u(n.input)}`;
          case "invalid_value":
            return n.values.length === 1 ? `Nieprawidłowe dane wejściowe: oczekiwano ${o.stringifyPrimitive(n.values[0])}` : `Nieprawidłowa opcja: oczekiwano jednej z wartości ${o.joinValues(n.values, "|")}`;
          case "too_big": {
            const f = n.inclusive ? "<=" : "<", v = r(n.origin);
            return v ? `Za duża wartość: oczekiwano, że ${n.origin ?? "wartość"} będzie mieć ${f}${n.maximum.toString()} ${v.unit ?? "elementów"}` : `Zbyt duż(y/a/e): oczekiwano, że ${n.origin ?? "wartość"} będzie wynosić ${f}${n.maximum.toString()}`;
          }
          case "too_small": {
            const f = n.inclusive ? ">=" : ">", v = r(n.origin);
            return v ? `Za mała wartość: oczekiwano, że ${n.origin ?? "wartość"} będzie mieć ${f}${n.minimum.toString()} ${v.unit ?? "elementów"}` : `Zbyt mał(y/a/e): oczekiwano, że ${n.origin ?? "wartość"} będzie wynosić ${f}${n.minimum.toString()}`;
          }
          case "invalid_format": {
            const f = n;
            return f.format === "starts_with" ? `Nieprawidłowy ciąg znaków: musi zaczynać się od "${f.prefix}"` : f.format === "ends_with" ? `Nieprawidłowy ciąg znaków: musi kończyć się na "${f.suffix}"` : f.format === "includes" ? `Nieprawidłowy ciąg znaków: musi zawierać "${f.includes}"` : f.format === "regex" ? `Nieprawidłowy ciąg znaków: musi odpowiadać wzorcowi ${f.pattern}` : `Nieprawidłow(y/a/e) ${l[f.format] ?? n.format}`;
          }
          case "not_multiple_of":
            return `Nieprawidłowa liczba: musi być wielokrotnością ${n.divisor}`;
          case "unrecognized_keys":
            return `Nierozpoznane klucze${n.keys.length > 1 ? "s" : ""}: ${o.joinValues(n.keys, ", ")}`;
          case "invalid_key":
            return `Nieprawidłowy klucz w ${n.origin}`;
          case "invalid_union":
            return "Nieprawidłowe dane wejściowe";
          case "invalid_element":
            return `Nieprawidłowa wartość w ${n.origin}`;
          default:
            return "Nieprawidłowe dane wejściowe";
        }
      };
    };
    function p() {
      return {
        localeError: m()
      };
    }
    e.exports = i.default;
  }(Ti, Ti.exports)), Ti.exports;
}
var Ni = { exports: {} }, ps;
function Um() {
  return ps || (ps = 1, function(e, i) {
    var d = w && w.__createBinding || (Object.create ? function(s, r, u, l) {
      l === void 0 && (l = u);
      var n = Object.getOwnPropertyDescriptor(r, u);
      (!n || ("get" in n ? !r.__esModule : n.writable || n.configurable)) && (n = { enumerable: !0, get: function() {
        return r[u];
      } }), Object.defineProperty(s, l, n);
    } : function(s, r, u, l) {
      l === void 0 && (l = u), s[l] = r[u];
    }), a = w && w.__setModuleDefault || (Object.create ? function(s, r) {
      Object.defineProperty(s, "default", { enumerable: !0, value: r });
    } : function(s, r) {
      s.default = r;
    }), t = w && w.__importStar || function(s) {
      if (s && s.__esModule) return s;
      var r = {};
      if (s != null) for (var u in s) u !== "default" && Object.prototype.hasOwnProperty.call(s, u) && d(r, s, u);
      return a(r, s), r;
    };
    Object.defineProperty(i, "__esModule", { value: !0 }), i.default = p;
    const o = t(pe()), m = () => {
      const s = {
        string: { unit: "caracteres", verb: "ter" },
        file: { unit: "bytes", verb: "ter" },
        array: { unit: "itens", verb: "ter" },
        set: { unit: "itens", verb: "ter" }
      };
      function r(n) {
        return s[n] ?? null;
      }
      const u = (n) => {
        const f = typeof n;
        switch (f) {
          case "number":
            return Number.isNaN(n) ? "NaN" : "número";
          case "object": {
            if (Array.isArray(n))
              return "array";
            if (n === null)
              return "nulo";
            if (Object.getPrototypeOf(n) !== Object.prototype && n.constructor)
              return n.constructor.name;
          }
        }
        return f;
      }, l = {
        regex: "padrão",
        email: "endereço de e-mail",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "data e hora ISO",
        date: "data ISO",
        time: "hora ISO",
        duration: "duração ISO",
        ipv4: "endereço IPv4",
        ipv6: "endereço IPv6",
        cidrv4: "faixa de IPv4",
        cidrv6: "faixa de IPv6",
        base64: "texto codificado em base64",
        base64url: "URL codificada em base64",
        json_string: "texto JSON",
        e164: "número E.164",
        jwt: "JWT",
        template_literal: "entrada"
      };
      return (n) => {
        switch (n.code) {
          case "invalid_type":
            return `Tipo inválido: esperado ${n.expected}, recebido ${u(n.input)}`;
          case "invalid_value":
            return n.values.length === 1 ? `Entrada inválida: esperado ${o.stringifyPrimitive(n.values[0])}` : `Opção inválida: esperada uma das ${o.joinValues(n.values, "|")}`;
          case "too_big": {
            const f = n.inclusive ? "<=" : "<", v = r(n.origin);
            return v ? `Muito grande: esperado que ${n.origin ?? "valor"} tivesse ${f}${n.maximum.toString()} ${v.unit ?? "elementos"}` : `Muito grande: esperado que ${n.origin ?? "valor"} fosse ${f}${n.maximum.toString()}`;
          }
          case "too_small": {
            const f = n.inclusive ? ">=" : ">", v = r(n.origin);
            return v ? `Muito pequeno: esperado que ${n.origin} tivesse ${f}${n.minimum.toString()} ${v.unit}` : `Muito pequeno: esperado que ${n.origin} fosse ${f}${n.minimum.toString()}`;
          }
          case "invalid_format": {
            const f = n;
            return f.format === "starts_with" ? `Texto inválido: deve começar com "${f.prefix}"` : f.format === "ends_with" ? `Texto inválido: deve terminar com "${f.suffix}"` : f.format === "includes" ? `Texto inválido: deve incluir "${f.includes}"` : f.format === "regex" ? `Texto inválido: deve corresponder ao padrão ${f.pattern}` : `${l[f.format] ?? n.format} inválido`;
          }
          case "not_multiple_of":
            return `Número inválido: deve ser múltiplo de ${n.divisor}`;
          case "unrecognized_keys":
            return `Chave${n.keys.length > 1 ? "s" : ""} desconhecida${n.keys.length > 1 ? "s" : ""}: ${o.joinValues(n.keys, ", ")}`;
          case "invalid_key":
            return `Chave inválida em ${n.origin}`;
          case "invalid_union":
            return "Entrada inválida";
          case "invalid_element":
            return `Valor inválido em ${n.origin}`;
          default:
            return "Campo inválido";
        }
      };
    };
    function p() {
      return {
        localeError: m()
      };
    }
    e.exports = i.default;
  }(Ni, Ni.exports)), Ni.exports;
}
var xi = { exports: {} }, bs;
function Bm() {
  return bs || (bs = 1, function(e, i) {
    var d = w && w.__createBinding || (Object.create ? function(r, u, l, n) {
      n === void 0 && (n = l);
      var f = Object.getOwnPropertyDescriptor(u, l);
      (!f || ("get" in f ? !u.__esModule : f.writable || f.configurable)) && (f = { enumerable: !0, get: function() {
        return u[l];
      } }), Object.defineProperty(r, n, f);
    } : function(r, u, l, n) {
      n === void 0 && (n = l), r[n] = u[l];
    }), a = w && w.__setModuleDefault || (Object.create ? function(r, u) {
      Object.defineProperty(r, "default", { enumerable: !0, value: u });
    } : function(r, u) {
      r.default = u;
    }), t = w && w.__importStar || function(r) {
      if (r && r.__esModule) return r;
      var u = {};
      if (r != null) for (var l in r) l !== "default" && Object.prototype.hasOwnProperty.call(r, l) && d(u, r, l);
      return a(u, r), u;
    };
    Object.defineProperty(i, "__esModule", { value: !0 }), i.default = s;
    const o = t(pe());
    function m(r, u, l, n) {
      const f = Math.abs(r), v = f % 10, D = f % 100;
      return D >= 11 && D <= 19 ? n : v === 1 ? u : v >= 2 && v <= 4 ? l : n;
    }
    const p = () => {
      const r = {
        string: {
          unit: {
            one: "символ",
            few: "символа",
            many: "символов"
          },
          verb: "иметь"
        },
        file: {
          unit: {
            one: "байт",
            few: "байта",
            many: "байт"
          },
          verb: "иметь"
        },
        array: {
          unit: {
            one: "элемент",
            few: "элемента",
            many: "элементов"
          },
          verb: "иметь"
        },
        set: {
          unit: {
            one: "элемент",
            few: "элемента",
            many: "элементов"
          },
          verb: "иметь"
        }
      };
      function u(f) {
        return r[f] ?? null;
      }
      const l = (f) => {
        const v = typeof f;
        switch (v) {
          case "number":
            return Number.isNaN(f) ? "NaN" : "число";
          case "object": {
            if (Array.isArray(f))
              return "массив";
            if (f === null)
              return "null";
            if (Object.getPrototypeOf(f) !== Object.prototype && f.constructor)
              return f.constructor.name;
          }
        }
        return v;
      }, n = {
        regex: "ввод",
        email: "email адрес",
        url: "URL",
        emoji: "эмодзи",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO дата и время",
        date: "ISO дата",
        time: "ISO время",
        duration: "ISO длительность",
        ipv4: "IPv4 адрес",
        ipv6: "IPv6 адрес",
        cidrv4: "IPv4 диапазон",
        cidrv6: "IPv6 диапазон",
        base64: "строка в формате base64",
        base64url: "строка в формате base64url",
        json_string: "JSON строка",
        e164: "номер E.164",
        jwt: "JWT",
        template_literal: "ввод"
      };
      return (f) => {
        switch (f.code) {
          case "invalid_type":
            return `Неверный ввод: ожидалось ${f.expected}, получено ${l(f.input)}`;
          case "invalid_value":
            return f.values.length === 1 ? `Неверный ввод: ожидалось ${o.stringifyPrimitive(f.values[0])}` : `Неверный вариант: ожидалось одно из ${o.joinValues(f.values, "|")}`;
          case "too_big": {
            const v = f.inclusive ? "<=" : "<", D = u(f.origin);
            if (D) {
              const F = Number(f.maximum), A = m(F, D.unit.one, D.unit.few, D.unit.many);
              return `Слишком большое значение: ожидалось, что ${f.origin ?? "значение"} будет иметь ${v}${f.maximum.toString()} ${A}`;
            }
            return `Слишком большое значение: ожидалось, что ${f.origin ?? "значение"} будет ${v}${f.maximum.toString()}`;
          }
          case "too_small": {
            const v = f.inclusive ? ">=" : ">", D = u(f.origin);
            if (D) {
              const F = Number(f.minimum), A = m(F, D.unit.one, D.unit.few, D.unit.many);
              return `Слишком маленькое значение: ожидалось, что ${f.origin} будет иметь ${v}${f.minimum.toString()} ${A}`;
            }
            return `Слишком маленькое значение: ожидалось, что ${f.origin} будет ${v}${f.minimum.toString()}`;
          }
          case "invalid_format": {
            const v = f;
            return v.format === "starts_with" ? `Неверная строка: должна начинаться с "${v.prefix}"` : v.format === "ends_with" ? `Неверная строка: должна заканчиваться на "${v.suffix}"` : v.format === "includes" ? `Неверная строка: должна содержать "${v.includes}"` : v.format === "regex" ? `Неверная строка: должна соответствовать шаблону ${v.pattern}` : `Неверный ${n[v.format] ?? f.format}`;
          }
          case "not_multiple_of":
            return `Неверное число: должно быть кратным ${f.divisor}`;
          case "unrecognized_keys":
            return `Нераспознанн${f.keys.length > 1 ? "ые" : "ый"} ключ${f.keys.length > 1 ? "и" : ""}: ${o.joinValues(f.keys, ", ")}`;
          case "invalid_key":
            return `Неверный ключ в ${f.origin}`;
          case "invalid_union":
            return "Неверные входные данные";
          case "invalid_element":
            return `Неверное значение в ${f.origin}`;
          default:
            return "Неверные входные данные";
        }
      };
    };
    function s() {
      return {
        localeError: p()
      };
    }
    e.exports = i.default;
  }(xi, xi.exports)), xi.exports;
}
var Fi = { exports: {} }, ys;
function Xm() {
  return ys || (ys = 1, function(e, i) {
    var d = w && w.__createBinding || (Object.create ? function(s, r, u, l) {
      l === void 0 && (l = u);
      var n = Object.getOwnPropertyDescriptor(r, u);
      (!n || ("get" in n ? !r.__esModule : n.writable || n.configurable)) && (n = { enumerable: !0, get: function() {
        return r[u];
      } }), Object.defineProperty(s, l, n);
    } : function(s, r, u, l) {
      l === void 0 && (l = u), s[l] = r[u];
    }), a = w && w.__setModuleDefault || (Object.create ? function(s, r) {
      Object.defineProperty(s, "default", { enumerable: !0, value: r });
    } : function(s, r) {
      s.default = r;
    }), t = w && w.__importStar || function(s) {
      if (s && s.__esModule) return s;
      var r = {};
      if (s != null) for (var u in s) u !== "default" && Object.prototype.hasOwnProperty.call(s, u) && d(r, s, u);
      return a(r, s), r;
    };
    Object.defineProperty(i, "__esModule", { value: !0 }), i.default = p;
    const o = t(pe()), m = () => {
      const s = {
        string: { unit: "znakov", verb: "imeti" },
        file: { unit: "bajtov", verb: "imeti" },
        array: { unit: "elementov", verb: "imeti" },
        set: { unit: "elementov", verb: "imeti" }
      };
      function r(n) {
        return s[n] ?? null;
      }
      const u = (n) => {
        const f = typeof n;
        switch (f) {
          case "number":
            return Number.isNaN(n) ? "NaN" : "število";
          case "object": {
            if (Array.isArray(n))
              return "tabela";
            if (n === null)
              return "null";
            if (Object.getPrototypeOf(n) !== Object.prototype && n.constructor)
              return n.constructor.name;
          }
        }
        return f;
      }, l = {
        regex: "vnos",
        email: "e-poštni naslov",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO datum in čas",
        date: "ISO datum",
        time: "ISO čas",
        duration: "ISO trajanje",
        ipv4: "IPv4 naslov",
        ipv6: "IPv6 naslov",
        cidrv4: "obseg IPv4",
        cidrv6: "obseg IPv6",
        base64: "base64 kodiran niz",
        base64url: "base64url kodiran niz",
        json_string: "JSON niz",
        e164: "E.164 številka",
        jwt: "JWT",
        template_literal: "vnos"
      };
      return (n) => {
        switch (n.code) {
          case "invalid_type":
            return `Neveljaven vnos: pričakovano ${n.expected}, prejeto ${u(n.input)}`;
          case "invalid_value":
            return n.values.length === 1 ? `Neveljaven vnos: pričakovano ${o.stringifyPrimitive(n.values[0])}` : `Neveljavna možnost: pričakovano eno izmed ${o.joinValues(n.values, "|")}`;
          case "too_big": {
            const f = n.inclusive ? "<=" : "<", v = r(n.origin);
            return v ? `Preveliko: pričakovano, da bo ${n.origin ?? "vrednost"} imelo ${f}${n.maximum.toString()} ${v.unit ?? "elementov"}` : `Preveliko: pričakovano, da bo ${n.origin ?? "vrednost"} ${f}${n.maximum.toString()}`;
          }
          case "too_small": {
            const f = n.inclusive ? ">=" : ">", v = r(n.origin);
            return v ? `Premajhno: pričakovano, da bo ${n.origin} imelo ${f}${n.minimum.toString()} ${v.unit}` : `Premajhno: pričakovano, da bo ${n.origin} ${f}${n.minimum.toString()}`;
          }
          case "invalid_format": {
            const f = n;
            return f.format === "starts_with" ? `Neveljaven niz: mora se začeti z "${f.prefix}"` : f.format === "ends_with" ? `Neveljaven niz: mora se končati z "${f.suffix}"` : f.format === "includes" ? `Neveljaven niz: mora vsebovati "${f.includes}"` : f.format === "regex" ? `Neveljaven niz: mora ustrezati vzorcu ${f.pattern}` : `Neveljaven ${l[f.format] ?? n.format}`;
          }
          case "not_multiple_of":
            return `Neveljavno število: mora biti večkratnik ${n.divisor}`;
          case "unrecognized_keys":
            return `Neprepoznan${n.keys.length > 1 ? "i ključi" : " ključ"}: ${o.joinValues(n.keys, ", ")}`;
          case "invalid_key":
            return `Neveljaven ključ v ${n.origin}`;
          case "invalid_union":
            return "Neveljaven vnos";
          case "invalid_element":
            return `Neveljavna vrednost v ${n.origin}`;
          default:
            return "Neveljaven vnos";
        }
      };
    };
    function p() {
      return {
        localeError: m()
      };
    }
    e.exports = i.default;
  }(Fi, Fi.exports)), Fi.exports;
}
var Ei = { exports: {} }, ks;
function Gm() {
  return ks || (ks = 1, function(e, i) {
    var d = w && w.__createBinding || (Object.create ? function(s, r, u, l) {
      l === void 0 && (l = u);
      var n = Object.getOwnPropertyDescriptor(r, u);
      (!n || ("get" in n ? !r.__esModule : n.writable || n.configurable)) && (n = { enumerable: !0, get: function() {
        return r[u];
      } }), Object.defineProperty(s, l, n);
    } : function(s, r, u, l) {
      l === void 0 && (l = u), s[l] = r[u];
    }), a = w && w.__setModuleDefault || (Object.create ? function(s, r) {
      Object.defineProperty(s, "default", { enumerable: !0, value: r });
    } : function(s, r) {
      s.default = r;
    }), t = w && w.__importStar || function(s) {
      if (s && s.__esModule) return s;
      var r = {};
      if (s != null) for (var u in s) u !== "default" && Object.prototype.hasOwnProperty.call(s, u) && d(r, s, u);
      return a(r, s), r;
    };
    Object.defineProperty(i, "__esModule", { value: !0 }), i.default = p;
    const o = t(pe()), m = () => {
      const s = {
        string: { unit: "tecken", verb: "att ha" },
        file: { unit: "bytes", verb: "att ha" },
        array: { unit: "objekt", verb: "att innehålla" },
        set: { unit: "objekt", verb: "att innehålla" }
      };
      function r(n) {
        return s[n] ?? null;
      }
      const u = (n) => {
        const f = typeof n;
        switch (f) {
          case "number":
            return Number.isNaN(n) ? "NaN" : "antal";
          case "object": {
            if (Array.isArray(n))
              return "lista";
            if (n === null)
              return "null";
            if (Object.getPrototypeOf(n) !== Object.prototype && n.constructor)
              return n.constructor.name;
          }
        }
        return f;
      }, l = {
        regex: "reguljärt uttryck",
        email: "e-postadress",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO-datum och tid",
        date: "ISO-datum",
        time: "ISO-tid",
        duration: "ISO-varaktighet",
        ipv4: "IPv4-intervall",
        ipv6: "IPv6-intervall",
        cidrv4: "IPv4-spektrum",
        cidrv6: "IPv6-spektrum",
        base64: "base64-kodad sträng",
        base64url: "base64url-kodad sträng",
        json_string: "JSON-sträng",
        e164: "E.164-nummer",
        jwt: "JWT",
        template_literal: "mall-literal"
      };
      return (n) => {
        switch (n.code) {
          case "invalid_type":
            return `Ogiltig inmatning: förväntat ${n.expected}, fick ${u(n.input)}`;
          case "invalid_value":
            return n.values.length === 1 ? `Ogiltig inmatning: förväntat ${o.stringifyPrimitive(n.values[0])}` : `Ogiltigt val: förväntade en av ${o.joinValues(n.values, "|")}`;
          case "too_big": {
            const f = n.inclusive ? "<=" : "<", v = r(n.origin);
            return v ? `För stor(t): förväntade ${n.origin ?? "värdet"} att ha ${f}${n.maximum.toString()} ${v.unit ?? "element"}` : `För stor(t): förväntat ${n.origin ?? "värdet"} att ha ${f}${n.maximum.toString()}`;
          }
          case "too_small": {
            const f = n.inclusive ? ">=" : ">", v = r(n.origin);
            return v ? `För lite(t): förväntade ${n.origin ?? "värdet"} att ha ${f}${n.minimum.toString()} ${v.unit}` : `För lite(t): förväntade ${n.origin ?? "värdet"} att ha ${f}${n.minimum.toString()}`;
          }
          case "invalid_format": {
            const f = n;
            return f.format === "starts_with" ? `Ogiltig sträng: måste börja med "${f.prefix}"` : f.format === "ends_with" ? `Ogiltig sträng: måste sluta med "${f.suffix}"` : f.format === "includes" ? `Ogiltig sträng: måste innehålla "${f.includes}"` : f.format === "regex" ? `Ogiltig sträng: måste matcha mönstret "${f.pattern}"` : `Ogiltig(t) ${l[f.format] ?? n.format}`;
          }
          case "not_multiple_of":
            return `Ogiltigt tal: måste vara en multipel av ${n.divisor}`;
          case "unrecognized_keys":
            return `${n.keys.length > 1 ? "Okända nycklar" : "Okänd nyckel"}: ${o.joinValues(n.keys, ", ")}`;
          case "invalid_key":
            return `Ogiltig nyckel i ${n.origin ?? "värdet"}`;
          case "invalid_union":
            return "Ogiltig input";
          case "invalid_element":
            return `Ogiltigt värde i ${n.origin ?? "värdet"}`;
          default:
            return "Ogiltig input";
        }
      };
    };
    function p() {
      return {
        localeError: m()
      };
    }
    e.exports = i.default;
  }(Ei, Ei.exports)), Ei.exports;
}
var Ri = { exports: {} }, ws;
function Km() {
  return ws || (ws = 1, function(e, i) {
    var d = w && w.__createBinding || (Object.create ? function(s, r, u, l) {
      l === void 0 && (l = u);
      var n = Object.getOwnPropertyDescriptor(r, u);
      (!n || ("get" in n ? !r.__esModule : n.writable || n.configurable)) && (n = { enumerable: !0, get: function() {
        return r[u];
      } }), Object.defineProperty(s, l, n);
    } : function(s, r, u, l) {
      l === void 0 && (l = u), s[l] = r[u];
    }), a = w && w.__setModuleDefault || (Object.create ? function(s, r) {
      Object.defineProperty(s, "default", { enumerable: !0, value: r });
    } : function(s, r) {
      s.default = r;
    }), t = w && w.__importStar || function(s) {
      if (s && s.__esModule) return s;
      var r = {};
      if (s != null) for (var u in s) u !== "default" && Object.prototype.hasOwnProperty.call(s, u) && d(r, s, u);
      return a(r, s), r;
    };
    Object.defineProperty(i, "__esModule", { value: !0 }), i.default = p;
    const o = t(pe()), m = () => {
      const s = {
        string: { unit: "எழுத்துக்கள்", verb: "கொண்டிருக்க வேண்டும்" },
        file: { unit: "பைட்டுகள்", verb: "கொண்டிருக்க வேண்டும்" },
        array: { unit: "உறுப்புகள்", verb: "கொண்டிருக்க வேண்டும்" },
        set: { unit: "உறுப்புகள்", verb: "கொண்டிருக்க வேண்டும்" }
      };
      function r(n) {
        return s[n] ?? null;
      }
      const u = (n) => {
        const f = typeof n;
        switch (f) {
          case "number":
            return Number.isNaN(n) ? "எண் அல்லாதது" : "எண்";
          case "object": {
            if (Array.isArray(n))
              return "அணி";
            if (n === null)
              return "வெறுமை";
            if (Object.getPrototypeOf(n) !== Object.prototype && n.constructor)
              return n.constructor.name;
          }
        }
        return f;
      }, l = {
        regex: "உள்ளீடு",
        email: "மின்னஞ்சல் முகவரி",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO தேதி நேரம்",
        date: "ISO தேதி",
        time: "ISO நேரம்",
        duration: "ISO கால அளவு",
        ipv4: "IPv4 முகவரி",
        ipv6: "IPv6 முகவரி",
        cidrv4: "IPv4 வரம்பு",
        cidrv6: "IPv6 வரம்பு",
        base64: "base64-encoded சரம்",
        base64url: "base64url-encoded சரம்",
        json_string: "JSON சரம்",
        e164: "E.164 எண்",
        jwt: "JWT",
        template_literal: "input"
      };
      return (n) => {
        switch (n.code) {
          case "invalid_type":
            return `தவறான உள்ளீடு: எதிர்பார்க்கப்பட்டது ${n.expected}, பெறப்பட்டது ${u(n.input)}`;
          case "invalid_value":
            return n.values.length === 1 ? `தவறான உள்ளீடு: எதிர்பார்க்கப்பட்டது ${o.stringifyPrimitive(n.values[0])}` : `தவறான விருப்பம்: எதிர்பார்க்கப்பட்டது ${o.joinValues(n.values, "|")} இல் ஒன்று`;
          case "too_big": {
            const f = n.inclusive ? "<=" : "<", v = r(n.origin);
            return v ? `மிக பெரியது: எதிர்பார்க்கப்பட்டது ${n.origin ?? "மதிப்பு"} ${f}${n.maximum.toString()} ${v.unit ?? "உறுப்புகள்"} ஆக இருக்க வேண்டும்` : `மிக பெரியது: எதிர்பார்க்கப்பட்டது ${n.origin ?? "மதிப்பு"} ${f}${n.maximum.toString()} ஆக இருக்க வேண்டும்`;
          }
          case "too_small": {
            const f = n.inclusive ? ">=" : ">", v = r(n.origin);
            return v ? `மிகச் சிறியது: எதிர்பார்க்கப்பட்டது ${n.origin} ${f}${n.minimum.toString()} ${v.unit} ஆக இருக்க வேண்டும்` : `மிகச் சிறியது: எதிர்பார்க்கப்பட்டது ${n.origin} ${f}${n.minimum.toString()} ஆக இருக்க வேண்டும்`;
          }
          case "invalid_format": {
            const f = n;
            return f.format === "starts_with" ? `தவறான சரம்: "${f.prefix}" இல் தொடங்க வேண்டும்` : f.format === "ends_with" ? `தவறான சரம்: "${f.suffix}" இல் முடிவடைய வேண்டும்` : f.format === "includes" ? `தவறான சரம்: "${f.includes}" ஐ உள்ளடக்க வேண்டும்` : f.format === "regex" ? `தவறான சரம்: ${f.pattern} முறைபாட்டுடன் பொருந்த வேண்டும்` : `தவறான ${l[f.format] ?? n.format}`;
          }
          case "not_multiple_of":
            return `தவறான எண்: ${n.divisor} இன் பலமாக இருக்க வேண்டும்`;
          case "unrecognized_keys":
            return `அடையாளம் தெரியாத விசை${n.keys.length > 1 ? "கள்" : ""}: ${o.joinValues(n.keys, ", ")}`;
          case "invalid_key":
            return `${n.origin} இல் தவறான விசை`;
          case "invalid_union":
            return "தவறான உள்ளீடு";
          case "invalid_element":
            return `${n.origin} இல் தவறான மதிப்பு`;
          default:
            return "தவறான உள்ளீடு";
        }
      };
    };
    function p() {
      return {
        localeError: m()
      };
    }
    e.exports = i.default;
  }(Ri, Ri.exports)), Ri.exports;
}
var Li = { exports: {} }, _s;
function Ym() {
  return _s || (_s = 1, function(e, i) {
    var d = w && w.__createBinding || (Object.create ? function(s, r, u, l) {
      l === void 0 && (l = u);
      var n = Object.getOwnPropertyDescriptor(r, u);
      (!n || ("get" in n ? !r.__esModule : n.writable || n.configurable)) && (n = { enumerable: !0, get: function() {
        return r[u];
      } }), Object.defineProperty(s, l, n);
    } : function(s, r, u, l) {
      l === void 0 && (l = u), s[l] = r[u];
    }), a = w && w.__setModuleDefault || (Object.create ? function(s, r) {
      Object.defineProperty(s, "default", { enumerable: !0, value: r });
    } : function(s, r) {
      s.default = r;
    }), t = w && w.__importStar || function(s) {
      if (s && s.__esModule) return s;
      var r = {};
      if (s != null) for (var u in s) u !== "default" && Object.prototype.hasOwnProperty.call(s, u) && d(r, s, u);
      return a(r, s), r;
    };
    Object.defineProperty(i, "__esModule", { value: !0 }), i.default = p;
    const o = t(pe()), m = () => {
      const s = {
        string: { unit: "ตัวอักษร", verb: "ควรมี" },
        file: { unit: "ไบต์", verb: "ควรมี" },
        array: { unit: "รายการ", verb: "ควรมี" },
        set: { unit: "รายการ", verb: "ควรมี" }
      };
      function r(n) {
        return s[n] ?? null;
      }
      const u = (n) => {
        const f = typeof n;
        switch (f) {
          case "number":
            return Number.isNaN(n) ? "ไม่ใช่ตัวเลข (NaN)" : "ตัวเลข";
          case "object": {
            if (Array.isArray(n))
              return "อาร์เรย์ (Array)";
            if (n === null)
              return "ไม่มีค่า (null)";
            if (Object.getPrototypeOf(n) !== Object.prototype && n.constructor)
              return n.constructor.name;
          }
        }
        return f;
      }, l = {
        regex: "ข้อมูลที่ป้อน",
        email: "ที่อยู่อีเมล",
        url: "URL",
        emoji: "อิโมจิ",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "วันที่เวลาแบบ ISO",
        date: "วันที่แบบ ISO",
        time: "เวลาแบบ ISO",
        duration: "ช่วงเวลาแบบ ISO",
        ipv4: "ที่อยู่ IPv4",
        ipv6: "ที่อยู่ IPv6",
        cidrv4: "ช่วง IP แบบ IPv4",
        cidrv6: "ช่วง IP แบบ IPv6",
        base64: "ข้อความแบบ Base64",
        base64url: "ข้อความแบบ Base64 สำหรับ URL",
        json_string: "ข้อความแบบ JSON",
        e164: "เบอร์โทรศัพท์ระหว่างประเทศ (E.164)",
        jwt: "โทเคน JWT",
        template_literal: "ข้อมูลที่ป้อน"
      };
      return (n) => {
        switch (n.code) {
          case "invalid_type":
            return `ประเภทข้อมูลไม่ถูกต้อง: ควรเป็น ${n.expected} แต่ได้รับ ${u(n.input)}`;
          case "invalid_value":
            return n.values.length === 1 ? `ค่าไม่ถูกต้อง: ควรเป็น ${o.stringifyPrimitive(n.values[0])}` : `ตัวเลือกไม่ถูกต้อง: ควรเป็นหนึ่งใน ${o.joinValues(n.values, "|")}`;
          case "too_big": {
            const f = n.inclusive ? "ไม่เกิน" : "น้อยกว่า", v = r(n.origin);
            return v ? `เกินกำหนด: ${n.origin ?? "ค่า"} ควรมี${f} ${n.maximum.toString()} ${v.unit ?? "รายการ"}` : `เกินกำหนด: ${n.origin ?? "ค่า"} ควรมี${f} ${n.maximum.toString()}`;
          }
          case "too_small": {
            const f = n.inclusive ? "อย่างน้อย" : "มากกว่า", v = r(n.origin);
            return v ? `น้อยกว่ากำหนด: ${n.origin} ควรมี${f} ${n.minimum.toString()} ${v.unit}` : `น้อยกว่ากำหนด: ${n.origin} ควรมี${f} ${n.minimum.toString()}`;
          }
          case "invalid_format": {
            const f = n;
            return f.format === "starts_with" ? `รูปแบบไม่ถูกต้อง: ข้อความต้องขึ้นต้นด้วย "${f.prefix}"` : f.format === "ends_with" ? `รูปแบบไม่ถูกต้อง: ข้อความต้องลงท้ายด้วย "${f.suffix}"` : f.format === "includes" ? `รูปแบบไม่ถูกต้อง: ข้อความต้องมี "${f.includes}" อยู่ในข้อความ` : f.format === "regex" ? `รูปแบบไม่ถูกต้อง: ต้องตรงกับรูปแบบที่กำหนด ${f.pattern}` : `รูปแบบไม่ถูกต้อง: ${l[f.format] ?? n.format}`;
          }
          case "not_multiple_of":
            return `ตัวเลขไม่ถูกต้อง: ต้องเป็นจำนวนที่หารด้วย ${n.divisor} ได้ลงตัว`;
          case "unrecognized_keys":
            return `พบคีย์ที่ไม่รู้จัก: ${o.joinValues(n.keys, ", ")}`;
          case "invalid_key":
            return `คีย์ไม่ถูกต้องใน ${n.origin}`;
          case "invalid_union":
            return "ข้อมูลไม่ถูกต้อง: ไม่ตรงกับรูปแบบยูเนียนที่กำหนดไว้";
          case "invalid_element":
            return `ข้อมูลไม่ถูกต้องใน ${n.origin}`;
          default:
            return "ข้อมูลไม่ถูกต้อง";
        }
      };
    };
    function p() {
      return {
        localeError: m()
      };
    }
    e.exports = i.default;
  }(Li, Li.exports)), Li.exports;
}
var kt = {}, $s;
function Jm() {
  return $s || ($s = 1, function(e) {
    var i = w && w.__createBinding || (Object.create ? function(s, r, u, l) {
      l === void 0 && (l = u);
      var n = Object.getOwnPropertyDescriptor(r, u);
      (!n || ("get" in n ? !r.__esModule : n.writable || n.configurable)) && (n = { enumerable: !0, get: function() {
        return r[u];
      } }), Object.defineProperty(s, l, n);
    } : function(s, r, u, l) {
      l === void 0 && (l = u), s[l] = r[u];
    }), d = w && w.__setModuleDefault || (Object.create ? function(s, r) {
      Object.defineProperty(s, "default", { enumerable: !0, value: r });
    } : function(s, r) {
      s.default = r;
    }), a = w && w.__importStar || function(s) {
      if (s && s.__esModule) return s;
      var r = {};
      if (s != null) for (var u in s) u !== "default" && Object.prototype.hasOwnProperty.call(s, u) && i(r, s, u);
      return d(r, s), r;
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), e.parsedType = void 0, e.default = p;
    const t = a(pe()), o = (s) => {
      const r = typeof s;
      switch (r) {
        case "number":
          return Number.isNaN(s) ? "NaN" : "number";
        case "object": {
          if (Array.isArray(s))
            return "array";
          if (s === null)
            return "null";
          if (Object.getPrototypeOf(s) !== Object.prototype && s.constructor)
            return s.constructor.name;
        }
      }
      return r;
    };
    e.parsedType = o;
    const m = () => {
      const s = {
        string: { unit: "karakter", verb: "olmalı" },
        file: { unit: "bayt", verb: "olmalı" },
        array: { unit: "öğe", verb: "olmalı" },
        set: { unit: "öğe", verb: "olmalı" }
      };
      function r(l) {
        return s[l] ?? null;
      }
      const u = {
        regex: "girdi",
        email: "e-posta adresi",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO tarih ve saat",
        date: "ISO tarih",
        time: "ISO saat",
        duration: "ISO süre",
        ipv4: "IPv4 adresi",
        ipv6: "IPv6 adresi",
        cidrv4: "IPv4 aralığı",
        cidrv6: "IPv6 aralığı",
        base64: "base64 ile şifrelenmiş metin",
        base64url: "base64url ile şifrelenmiş metin",
        json_string: "JSON dizesi",
        e164: "E.164 sayısı",
        jwt: "JWT",
        template_literal: "Şablon dizesi"
      };
      return (l) => {
        switch (l.code) {
          case "invalid_type":
            return `Geçersiz değer: beklenen ${l.expected}, alınan ${(0, e.parsedType)(l.input)}`;
          case "invalid_value":
            return l.values.length === 1 ? `Geçersiz değer: beklenen ${t.stringifyPrimitive(l.values[0])}` : `Geçersiz seçenek: aşağıdakilerden biri olmalı: ${t.joinValues(l.values, "|")}`;
          case "too_big": {
            const n = l.inclusive ? "<=" : "<", f = r(l.origin);
            return f ? `Çok büyük: beklenen ${l.origin ?? "değer"} ${n}${l.maximum.toString()} ${f.unit ?? "öğe"}` : `Çok büyük: beklenen ${l.origin ?? "değer"} ${n}${l.maximum.toString()}`;
          }
          case "too_small": {
            const n = l.inclusive ? ">=" : ">", f = r(l.origin);
            return f ? `Çok küçük: beklenen ${l.origin} ${n}${l.minimum.toString()} ${f.unit}` : `Çok küçük: beklenen ${l.origin} ${n}${l.minimum.toString()}`;
          }
          case "invalid_format": {
            const n = l;
            return n.format === "starts_with" ? `Geçersiz metin: "${n.prefix}" ile başlamalı` : n.format === "ends_with" ? `Geçersiz metin: "${n.suffix}" ile bitmeli` : n.format === "includes" ? `Geçersiz metin: "${n.includes}" içermeli` : n.format === "regex" ? `Geçersiz metin: ${n.pattern} desenine uymalı` : `Geçersiz ${u[n.format] ?? l.format}`;
          }
          case "not_multiple_of":
            return `Geçersiz sayı: ${l.divisor} ile tam bölünebilmeli`;
          case "unrecognized_keys":
            return `Tanınmayan anahtar${l.keys.length > 1 ? "lar" : ""}: ${t.joinValues(l.keys, ", ")}`;
          case "invalid_key":
            return `${l.origin} içinde geçersiz anahtar`;
          case "invalid_union":
            return "Geçersiz değer";
          case "invalid_element":
            return `${l.origin} içinde geçersiz değer`;
          default:
            return "Geçersiz değer";
        }
      };
    };
    function p() {
      return {
        localeError: m()
      };
    }
  }(kt)), kt;
}
var qi = { exports: {} }, Ps;
function Qm() {
  return Ps || (Ps = 1, function(e, i) {
    var d = w && w.__createBinding || (Object.create ? function(s, r, u, l) {
      l === void 0 && (l = u);
      var n = Object.getOwnPropertyDescriptor(r, u);
      (!n || ("get" in n ? !r.__esModule : n.writable || n.configurable)) && (n = { enumerable: !0, get: function() {
        return r[u];
      } }), Object.defineProperty(s, l, n);
    } : function(s, r, u, l) {
      l === void 0 && (l = u), s[l] = r[u];
    }), a = w && w.__setModuleDefault || (Object.create ? function(s, r) {
      Object.defineProperty(s, "default", { enumerable: !0, value: r });
    } : function(s, r) {
      s.default = r;
    }), t = w && w.__importStar || function(s) {
      if (s && s.__esModule) return s;
      var r = {};
      if (s != null) for (var u in s) u !== "default" && Object.prototype.hasOwnProperty.call(s, u) && d(r, s, u);
      return a(r, s), r;
    };
    Object.defineProperty(i, "__esModule", { value: !0 }), i.default = p;
    const o = t(pe()), m = () => {
      const s = {
        string: { unit: "символів", verb: "матиме" },
        file: { unit: "байтів", verb: "матиме" },
        array: { unit: "елементів", verb: "матиме" },
        set: { unit: "елементів", verb: "матиме" }
      };
      function r(n) {
        return s[n] ?? null;
      }
      const u = (n) => {
        const f = typeof n;
        switch (f) {
          case "number":
            return Number.isNaN(n) ? "NaN" : "число";
          case "object": {
            if (Array.isArray(n))
              return "масив";
            if (n === null)
              return "null";
            if (Object.getPrototypeOf(n) !== Object.prototype && n.constructor)
              return n.constructor.name;
          }
        }
        return f;
      }, l = {
        regex: "вхідні дані",
        email: "адреса електронної пошти",
        url: "URL",
        emoji: "емодзі",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "дата та час ISO",
        date: "дата ISO",
        time: "час ISO",
        duration: "тривалість ISO",
        ipv4: "адреса IPv4",
        ipv6: "адреса IPv6",
        cidrv4: "діапазон IPv4",
        cidrv6: "діапазон IPv6",
        base64: "рядок у кодуванні base64",
        base64url: "рядок у кодуванні base64url",
        json_string: "рядок JSON",
        e164: "номер E.164",
        jwt: "JWT",
        template_literal: "вхідні дані"
      };
      return (n) => {
        switch (n.code) {
          case "invalid_type":
            return `Неправильні вхідні дані: очікується ${n.expected}, отримано ${u(n.input)}`;
          case "invalid_value":
            return n.values.length === 1 ? `Неправильні вхідні дані: очікується ${o.stringifyPrimitive(n.values[0])}` : `Неправильна опція: очікується одне з ${o.joinValues(n.values, "|")}`;
          case "too_big": {
            const f = n.inclusive ? "<=" : "<", v = r(n.origin);
            return v ? `Занадто велике: очікується, що ${n.origin ?? "значення"} ${v.verb} ${f}${n.maximum.toString()} ${v.unit ?? "елементів"}` : `Занадто велике: очікується, що ${n.origin ?? "значення"} буде ${f}${n.maximum.toString()}`;
          }
          case "too_small": {
            const f = n.inclusive ? ">=" : ">", v = r(n.origin);
            return v ? `Занадто мале: очікується, що ${n.origin} ${v.verb} ${f}${n.minimum.toString()} ${v.unit}` : `Занадто мале: очікується, що ${n.origin} буде ${f}${n.minimum.toString()}`;
          }
          case "invalid_format": {
            const f = n;
            return f.format === "starts_with" ? `Неправильний рядок: повинен починатися з "${f.prefix}"` : f.format === "ends_with" ? `Неправильний рядок: повинен закінчуватися на "${f.suffix}"` : f.format === "includes" ? `Неправильний рядок: повинен містити "${f.includes}"` : f.format === "regex" ? `Неправильний рядок: повинен відповідати шаблону ${f.pattern}` : `Неправильний ${l[f.format] ?? n.format}`;
          }
          case "not_multiple_of":
            return `Неправильне число: повинно бути кратним ${n.divisor}`;
          case "unrecognized_keys":
            return `Нерозпізнаний ключ${n.keys.length > 1 ? "і" : ""}: ${o.joinValues(n.keys, ", ")}`;
          case "invalid_key":
            return `Неправильний ключ у ${n.origin}`;
          case "invalid_union":
            return "Неправильні вхідні дані";
          case "invalid_element":
            return `Неправильне значення у ${n.origin}`;
          default:
            return "Неправильні вхідні дані";
        }
      };
    };
    function p() {
      return {
        localeError: m()
      };
    }
    e.exports = i.default;
  }(qi, qi.exports)), qi.exports;
}
var Zi = { exports: {} }, Ms;
function ev() {
  return Ms || (Ms = 1, function(e, i) {
    var d = w && w.__createBinding || (Object.create ? function(s, r, u, l) {
      l === void 0 && (l = u);
      var n = Object.getOwnPropertyDescriptor(r, u);
      (!n || ("get" in n ? !r.__esModule : n.writable || n.configurable)) && (n = { enumerable: !0, get: function() {
        return r[u];
      } }), Object.defineProperty(s, l, n);
    } : function(s, r, u, l) {
      l === void 0 && (l = u), s[l] = r[u];
    }), a = w && w.__setModuleDefault || (Object.create ? function(s, r) {
      Object.defineProperty(s, "default", { enumerable: !0, value: r });
    } : function(s, r) {
      s.default = r;
    }), t = w && w.__importStar || function(s) {
      if (s && s.__esModule) return s;
      var r = {};
      if (s != null) for (var u in s) u !== "default" && Object.prototype.hasOwnProperty.call(s, u) && d(r, s, u);
      return a(r, s), r;
    };
    Object.defineProperty(i, "__esModule", { value: !0 }), i.default = p;
    const o = t(pe()), m = () => {
      const s = {
        string: { unit: "حروف", verb: "ہونا" },
        file: { unit: "بائٹس", verb: "ہونا" },
        array: { unit: "آئٹمز", verb: "ہونا" },
        set: { unit: "آئٹمز", verb: "ہونا" }
      };
      function r(n) {
        return s[n] ?? null;
      }
      const u = (n) => {
        const f = typeof n;
        switch (f) {
          case "number":
            return Number.isNaN(n) ? "NaN" : "نمبر";
          case "object": {
            if (Array.isArray(n))
              return "آرے";
            if (n === null)
              return "نل";
            if (Object.getPrototypeOf(n) !== Object.prototype && n.constructor)
              return n.constructor.name;
          }
        }
        return f;
      }, l = {
        regex: "ان پٹ",
        email: "ای میل ایڈریس",
        url: "یو آر ایل",
        emoji: "ایموجی",
        uuid: "یو یو آئی ڈی",
        uuidv4: "یو یو آئی ڈی وی 4",
        uuidv6: "یو یو آئی ڈی وی 6",
        nanoid: "نینو آئی ڈی",
        guid: "جی یو آئی ڈی",
        cuid: "سی یو آئی ڈی",
        cuid2: "سی یو آئی ڈی 2",
        ulid: "یو ایل آئی ڈی",
        xid: "ایکس آئی ڈی",
        ksuid: "کے ایس یو آئی ڈی",
        datetime: "آئی ایس او ڈیٹ ٹائم",
        date: "آئی ایس او تاریخ",
        time: "آئی ایس او وقت",
        duration: "آئی ایس او مدت",
        ipv4: "آئی پی وی 4 ایڈریس",
        ipv6: "آئی پی وی 6 ایڈریس",
        cidrv4: "آئی پی وی 4 رینج",
        cidrv6: "آئی پی وی 6 رینج",
        base64: "بیس 64 ان کوڈڈ سٹرنگ",
        base64url: "بیس 64 یو آر ایل ان کوڈڈ سٹرنگ",
        json_string: "جے ایس او این سٹرنگ",
        e164: "ای 164 نمبر",
        jwt: "جے ڈبلیو ٹی",
        template_literal: "ان پٹ"
      };
      return (n) => {
        switch (n.code) {
          case "invalid_type":
            return `غلط ان پٹ: ${n.expected} متوقع تھا، ${u(n.input)} موصول ہوا`;
          case "invalid_value":
            return n.values.length === 1 ? `غلط ان پٹ: ${o.stringifyPrimitive(n.values[0])} متوقع تھا` : `غلط آپشن: ${o.joinValues(n.values, "|")} میں سے ایک متوقع تھا`;
          case "too_big": {
            const f = n.inclusive ? "<=" : "<", v = r(n.origin);
            return v ? `بہت بڑا: ${n.origin ?? "ویلیو"} کے ${f}${n.maximum.toString()} ${v.unit ?? "عناصر"} ہونے متوقع تھے` : `بہت بڑا: ${n.origin ?? "ویلیو"} کا ${f}${n.maximum.toString()} ہونا متوقع تھا`;
          }
          case "too_small": {
            const f = n.inclusive ? ">=" : ">", v = r(n.origin);
            return v ? `بہت چھوٹا: ${n.origin} کے ${f}${n.minimum.toString()} ${v.unit} ہونے متوقع تھے` : `بہت چھوٹا: ${n.origin} کا ${f}${n.minimum.toString()} ہونا متوقع تھا`;
          }
          case "invalid_format": {
            const f = n;
            return f.format === "starts_with" ? `غلط سٹرنگ: "${f.prefix}" سے شروع ہونا چاہیے` : f.format === "ends_with" ? `غلط سٹرنگ: "${f.suffix}" پر ختم ہونا چاہیے` : f.format === "includes" ? `غلط سٹرنگ: "${f.includes}" شامل ہونا چاہیے` : f.format === "regex" ? `غلط سٹرنگ: پیٹرن ${f.pattern} سے میچ ہونا چاہیے` : `غلط ${l[f.format] ?? n.format}`;
          }
          case "not_multiple_of":
            return `غلط نمبر: ${n.divisor} کا مضاعف ہونا چاہیے`;
          case "unrecognized_keys":
            return `غیر تسلیم شدہ کی${n.keys.length > 1 ? "ز" : ""}: ${o.joinValues(n.keys, "، ")}`;
          case "invalid_key":
            return `${n.origin} میں غلط کی`;
          case "invalid_union":
            return "غلط ان پٹ";
          case "invalid_element":
            return `${n.origin} میں غلط ویلیو`;
          default:
            return "غلط ان پٹ";
        }
      };
    };
    function p() {
      return {
        localeError: m()
      };
    }
    e.exports = i.default;
  }(Zi, Zi.exports)), Zi.exports;
}
var Ai = { exports: {} }, js;
function nv() {
  return js || (js = 1, function(e, i) {
    var d = w && w.__createBinding || (Object.create ? function(s, r, u, l) {
      l === void 0 && (l = u);
      var n = Object.getOwnPropertyDescriptor(r, u);
      (!n || ("get" in n ? !r.__esModule : n.writable || n.configurable)) && (n = { enumerable: !0, get: function() {
        return r[u];
      } }), Object.defineProperty(s, l, n);
    } : function(s, r, u, l) {
      l === void 0 && (l = u), s[l] = r[u];
    }), a = w && w.__setModuleDefault || (Object.create ? function(s, r) {
      Object.defineProperty(s, "default", { enumerable: !0, value: r });
    } : function(s, r) {
      s.default = r;
    }), t = w && w.__importStar || function(s) {
      if (s && s.__esModule) return s;
      var r = {};
      if (s != null) for (var u in s) u !== "default" && Object.prototype.hasOwnProperty.call(s, u) && d(r, s, u);
      return a(r, s), r;
    };
    Object.defineProperty(i, "__esModule", { value: !0 }), i.default = p;
    const o = t(pe()), m = () => {
      const s = {
        string: { unit: "ký tự", verb: "có" },
        file: { unit: "byte", verb: "có" },
        array: { unit: "phần tử", verb: "có" },
        set: { unit: "phần tử", verb: "có" }
      };
      function r(n) {
        return s[n] ?? null;
      }
      const u = (n) => {
        const f = typeof n;
        switch (f) {
          case "number":
            return Number.isNaN(n) ? "NaN" : "số";
          case "object": {
            if (Array.isArray(n))
              return "mảng";
            if (n === null)
              return "null";
            if (Object.getPrototypeOf(n) !== Object.prototype && n.constructor)
              return n.constructor.name;
          }
        }
        return f;
      }, l = {
        regex: "đầu vào",
        email: "địa chỉ email",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ngày giờ ISO",
        date: "ngày ISO",
        time: "giờ ISO",
        duration: "khoảng thời gian ISO",
        ipv4: "địa chỉ IPv4",
        ipv6: "địa chỉ IPv6",
        cidrv4: "dải IPv4",
        cidrv6: "dải IPv6",
        base64: "chuỗi mã hóa base64",
        base64url: "chuỗi mã hóa base64url",
        json_string: "chuỗi JSON",
        e164: "số E.164",
        jwt: "JWT",
        template_literal: "đầu vào"
      };
      return (n) => {
        switch (n.code) {
          case "invalid_type":
            return `Đầu vào không hợp lệ: mong đợi ${n.expected}, nhận được ${u(n.input)}`;
          case "invalid_value":
            return n.values.length === 1 ? `Đầu vào không hợp lệ: mong đợi ${o.stringifyPrimitive(n.values[0])}` : `Tùy chọn không hợp lệ: mong đợi một trong các giá trị ${o.joinValues(n.values, "|")}`;
          case "too_big": {
            const f = n.inclusive ? "<=" : "<", v = r(n.origin);
            return v ? `Quá lớn: mong đợi ${n.origin ?? "giá trị"} ${v.verb} ${f}${n.maximum.toString()} ${v.unit ?? "phần tử"}` : `Quá lớn: mong đợi ${n.origin ?? "giá trị"} ${f}${n.maximum.toString()}`;
          }
          case "too_small": {
            const f = n.inclusive ? ">=" : ">", v = r(n.origin);
            return v ? `Quá nhỏ: mong đợi ${n.origin} ${v.verb} ${f}${n.minimum.toString()} ${v.unit}` : `Quá nhỏ: mong đợi ${n.origin} ${f}${n.minimum.toString()}`;
          }
          case "invalid_format": {
            const f = n;
            return f.format === "starts_with" ? `Chuỗi không hợp lệ: phải bắt đầu bằng "${f.prefix}"` : f.format === "ends_with" ? `Chuỗi không hợp lệ: phải kết thúc bằng "${f.suffix}"` : f.format === "includes" ? `Chuỗi không hợp lệ: phải bao gồm "${f.includes}"` : f.format === "regex" ? `Chuỗi không hợp lệ: phải khớp với mẫu ${f.pattern}` : `${l[f.format] ?? n.format} không hợp lệ`;
          }
          case "not_multiple_of":
            return `Số không hợp lệ: phải là bội số của ${n.divisor}`;
          case "unrecognized_keys":
            return `Khóa không được nhận dạng: ${o.joinValues(n.keys, ", ")}`;
          case "invalid_key":
            return `Khóa không hợp lệ trong ${n.origin}`;
          case "invalid_union":
            return "Đầu vào không hợp lệ";
          case "invalid_element":
            return `Giá trị không hợp lệ trong ${n.origin}`;
          default:
            return "Đầu vào không hợp lệ";
        }
      };
    };
    function p() {
      return {
        localeError: m()
      };
    }
    e.exports = i.default;
  }(Ai, Ai.exports)), Ai.exports;
}
var Vi = { exports: {} }, Ss;
function iv() {
  return Ss || (Ss = 1, function(e, i) {
    var d = w && w.__createBinding || (Object.create ? function(s, r, u, l) {
      l === void 0 && (l = u);
      var n = Object.getOwnPropertyDescriptor(r, u);
      (!n || ("get" in n ? !r.__esModule : n.writable || n.configurable)) && (n = { enumerable: !0, get: function() {
        return r[u];
      } }), Object.defineProperty(s, l, n);
    } : function(s, r, u, l) {
      l === void 0 && (l = u), s[l] = r[u];
    }), a = w && w.__setModuleDefault || (Object.create ? function(s, r) {
      Object.defineProperty(s, "default", { enumerable: !0, value: r });
    } : function(s, r) {
      s.default = r;
    }), t = w && w.__importStar || function(s) {
      if (s && s.__esModule) return s;
      var r = {};
      if (s != null) for (var u in s) u !== "default" && Object.prototype.hasOwnProperty.call(s, u) && d(r, s, u);
      return a(r, s), r;
    };
    Object.defineProperty(i, "__esModule", { value: !0 }), i.default = p;
    const o = t(pe()), m = () => {
      const s = {
        string: { unit: "字符", verb: "包含" },
        file: { unit: "字节", verb: "包含" },
        array: { unit: "项", verb: "包含" },
        set: { unit: "项", verb: "包含" }
      };
      function r(n) {
        return s[n] ?? null;
      }
      const u = (n) => {
        const f = typeof n;
        switch (f) {
          case "number":
            return Number.isNaN(n) ? "非数字(NaN)" : "数字";
          case "object": {
            if (Array.isArray(n))
              return "数组";
            if (n === null)
              return "空值(null)";
            if (Object.getPrototypeOf(n) !== Object.prototype && n.constructor)
              return n.constructor.name;
          }
        }
        return f;
      }, l = {
        regex: "输入",
        email: "电子邮件",
        url: "URL",
        emoji: "表情符号",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO日期时间",
        date: "ISO日期",
        time: "ISO时间",
        duration: "ISO时长",
        ipv4: "IPv4地址",
        ipv6: "IPv6地址",
        cidrv4: "IPv4网段",
        cidrv6: "IPv6网段",
        base64: "base64编码字符串",
        base64url: "base64url编码字符串",
        json_string: "JSON字符串",
        e164: "E.164号码",
        jwt: "JWT",
        template_literal: "输入"
      };
      return (n) => {
        switch (n.code) {
          case "invalid_type":
            return `无效输入：期望 ${n.expected}，实际接收 ${u(n.input)}`;
          case "invalid_value":
            return n.values.length === 1 ? `无效输入：期望 ${o.stringifyPrimitive(n.values[0])}` : `无效选项：期望以下之一 ${o.joinValues(n.values, "|")}`;
          case "too_big": {
            const f = n.inclusive ? "<=" : "<", v = r(n.origin);
            return v ? `数值过大：期望 ${n.origin ?? "值"} ${f}${n.maximum.toString()} ${v.unit ?? "个元素"}` : `数值过大：期望 ${n.origin ?? "值"} ${f}${n.maximum.toString()}`;
          }
          case "too_small": {
            const f = n.inclusive ? ">=" : ">", v = r(n.origin);
            return v ? `数值过小：期望 ${n.origin} ${f}${n.minimum.toString()} ${v.unit}` : `数值过小：期望 ${n.origin} ${f}${n.minimum.toString()}`;
          }
          case "invalid_format": {
            const f = n;
            return f.format === "starts_with" ? `无效字符串：必须以 "${f.prefix}" 开头` : f.format === "ends_with" ? `无效字符串：必须以 "${f.suffix}" 结尾` : f.format === "includes" ? `无效字符串：必须包含 "${f.includes}"` : f.format === "regex" ? `无效字符串：必须满足正则表达式 ${f.pattern}` : `无效${l[f.format] ?? n.format}`;
          }
          case "not_multiple_of":
            return `无效数字：必须是 ${n.divisor} 的倍数`;
          case "unrecognized_keys":
            return `出现未知的键(key): ${o.joinValues(n.keys, ", ")}`;
          case "invalid_key":
            return `${n.origin} 中的键(key)无效`;
          case "invalid_union":
            return "无效输入";
          case "invalid_element":
            return `${n.origin} 中包含无效值(value)`;
          default:
            return "无效输入";
        }
      };
    };
    function p() {
      return {
        localeError: m()
      };
    }
    e.exports = i.default;
  }(Vi, Vi.exports)), Vi.exports;
}
var Hi = { exports: {} }, zs;
function av() {
  return zs || (zs = 1, function(e, i) {
    var d = w && w.__createBinding || (Object.create ? function(s, r, u, l) {
      l === void 0 && (l = u);
      var n = Object.getOwnPropertyDescriptor(r, u);
      (!n || ("get" in n ? !r.__esModule : n.writable || n.configurable)) && (n = { enumerable: !0, get: function() {
        return r[u];
      } }), Object.defineProperty(s, l, n);
    } : function(s, r, u, l) {
      l === void 0 && (l = u), s[l] = r[u];
    }), a = w && w.__setModuleDefault || (Object.create ? function(s, r) {
      Object.defineProperty(s, "default", { enumerable: !0, value: r });
    } : function(s, r) {
      s.default = r;
    }), t = w && w.__importStar || function(s) {
      if (s && s.__esModule) return s;
      var r = {};
      if (s != null) for (var u in s) u !== "default" && Object.prototype.hasOwnProperty.call(s, u) && d(r, s, u);
      return a(r, s), r;
    };
    Object.defineProperty(i, "__esModule", { value: !0 }), i.default = p;
    const o = t(pe()), m = () => {
      const s = {
        string: { unit: "字元", verb: "擁有" },
        file: { unit: "位元組", verb: "擁有" },
        array: { unit: "項目", verb: "擁有" },
        set: { unit: "項目", verb: "擁有" }
      };
      function r(n) {
        return s[n] ?? null;
      }
      const u = (n) => {
        const f = typeof n;
        switch (f) {
          case "number":
            return Number.isNaN(n) ? "NaN" : "number";
          case "object": {
            if (Array.isArray(n))
              return "array";
            if (n === null)
              return "null";
            if (Object.getPrototypeOf(n) !== Object.prototype && n.constructor)
              return n.constructor.name;
          }
        }
        return f;
      }, l = {
        regex: "輸入",
        email: "郵件地址",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO 日期時間",
        date: "ISO 日期",
        time: "ISO 時間",
        duration: "ISO 期間",
        ipv4: "IPv4 位址",
        ipv6: "IPv6 位址",
        cidrv4: "IPv4 範圍",
        cidrv6: "IPv6 範圍",
        base64: "base64 編碼字串",
        base64url: "base64url 編碼字串",
        json_string: "JSON 字串",
        e164: "E.164 數值",
        jwt: "JWT",
        template_literal: "輸入"
      };
      return (n) => {
        switch (n.code) {
          case "invalid_type":
            return `無效的輸入值：預期為 ${n.expected}，但收到 ${u(n.input)}`;
          case "invalid_value":
            return n.values.length === 1 ? `無效的輸入值：預期為 ${o.stringifyPrimitive(n.values[0])}` : `無效的選項：預期為以下其中之一 ${o.joinValues(n.values, "|")}`;
          case "too_big": {
            const f = n.inclusive ? "<=" : "<", v = r(n.origin);
            return v ? `數值過大：預期 ${n.origin ?? "值"} 應為 ${f}${n.maximum.toString()} ${v.unit ?? "個元素"}` : `數值過大：預期 ${n.origin ?? "值"} 應為 ${f}${n.maximum.toString()}`;
          }
          case "too_small": {
            const f = n.inclusive ? ">=" : ">", v = r(n.origin);
            return v ? `數值過小：預期 ${n.origin} 應為 ${f}${n.minimum.toString()} ${v.unit}` : `數值過小：預期 ${n.origin} 應為 ${f}${n.minimum.toString()}`;
          }
          case "invalid_format": {
            const f = n;
            return f.format === "starts_with" ? `無效的字串：必須以 "${f.prefix}" 開頭` : f.format === "ends_with" ? `無效的字串：必須以 "${f.suffix}" 結尾` : f.format === "includes" ? `無效的字串：必須包含 "${f.includes}"` : f.format === "regex" ? `無效的字串：必須符合格式 ${f.pattern}` : `無效的 ${l[f.format] ?? n.format}`;
          }
          case "not_multiple_of":
            return `無效的數字：必須為 ${n.divisor} 的倍數`;
          case "unrecognized_keys":
            return `無法識別的鍵值${n.keys.length > 1 ? "們" : ""}：${o.joinValues(n.keys, "、")}`;
          case "invalid_key":
            return `${n.origin} 中有無效的鍵值`;
          case "invalid_union":
            return "無效的輸入值";
          case "invalid_element":
            return `${n.origin} 中有無效的值`;
          default:
            return "無效的輸入值";
        }
      };
    };
    function p() {
      return {
        localeError: m()
      };
    }
    e.exports = i.default;
  }(Hi, Hi.exports)), Hi.exports;
}
var Ui = { exports: {} }, Os;
function tv() {
  return Os || (Os = 1, function(e, i) {
    var d = w && w.__createBinding || (Object.create ? function(s, r, u, l) {
      l === void 0 && (l = u);
      var n = Object.getOwnPropertyDescriptor(r, u);
      (!n || ("get" in n ? !r.__esModule : n.writable || n.configurable)) && (n = { enumerable: !0, get: function() {
        return r[u];
      } }), Object.defineProperty(s, l, n);
    } : function(s, r, u, l) {
      l === void 0 && (l = u), s[l] = r[u];
    }), a = w && w.__setModuleDefault || (Object.create ? function(s, r) {
      Object.defineProperty(s, "default", { enumerable: !0, value: r });
    } : function(s, r) {
      s.default = r;
    }), t = w && w.__importStar || function(s) {
      if (s && s.__esModule) return s;
      var r = {};
      if (s != null) for (var u in s) u !== "default" && Object.prototype.hasOwnProperty.call(s, u) && d(r, s, u);
      return a(r, s), r;
    };
    Object.defineProperty(i, "__esModule", { value: !0 }), i.default = p;
    const o = t(pe()), m = () => {
      const s = {
        string: { unit: "àmi", verb: "ní" },
        file: { unit: "bytes", verb: "ní" },
        array: { unit: "nkan", verb: "ní" },
        set: { unit: "nkan", verb: "ní" }
      };
      function r(n) {
        return s[n] ?? null;
      }
      const u = (n) => {
        const f = typeof n;
        switch (f) {
          case "number":
            return Number.isNaN(n) ? "NaN" : "nọ́mbà";
          case "object": {
            if (Array.isArray(n))
              return "akopọ";
            if (n === null)
              return "null";
            if (Object.getPrototypeOf(n) !== Object.prototype && n.constructor)
              return n.constructor.name;
          }
        }
        return f;
      }, l = {
        regex: "ẹ̀rọ ìbáwọlé",
        email: "àdírẹ́sì ìmẹ́lì",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "àkókò ISO",
        date: "ọjọ́ ISO",
        time: "àkókò ISO",
        duration: "àkókò tó pé ISO",
        ipv4: "àdírẹ́sì IPv4",
        ipv6: "àdírẹ́sì IPv6",
        cidrv4: "àgbègbè IPv4",
        cidrv6: "àgbègbè IPv6",
        base64: "ọ̀rọ̀ tí a kọ́ ní base64",
        base64url: "ọ̀rọ̀ base64url",
        json_string: "ọ̀rọ̀ JSON",
        e164: "nọ́mbà E.164",
        jwt: "JWT",
        template_literal: "ẹ̀rọ ìbáwọlé"
      };
      return (n) => {
        switch (n.code) {
          case "invalid_type":
            return `Ìbáwọlé aṣìṣe: a ní láti fi ${n.expected}, àmọ̀ a rí ${u(n.input)}`;
          case "invalid_value":
            return n.values.length === 1 ? `Ìbáwọlé aṣìṣe: a ní láti fi ${o.stringifyPrimitive(n.values[0])}` : `Àṣàyàn aṣìṣe: yan ọ̀kan lára ${o.joinValues(n.values, "|")}`;
          case "too_big": {
            const f = n.inclusive ? "<=" : "<", v = r(n.origin);
            return v ? `Tó pọ̀ jù: a ní láti jẹ́ pé ${n.origin ?? "iye"} ${v.verb} ${f}${n.maximum} ${v.unit}` : `Tó pọ̀ jù: a ní láti jẹ́ ${f}${n.maximum}`;
          }
          case "too_small": {
            const f = n.inclusive ? ">=" : ">", v = r(n.origin);
            return v ? `Kéré ju: a ní láti jẹ́ pé ${n.origin} ${v.verb} ${f}${n.minimum} ${v.unit}` : `Kéré ju: a ní láti jẹ́ ${f}${n.minimum}`;
          }
          case "invalid_format": {
            const f = n;
            return f.format === "starts_with" ? `Ọ̀rọ̀ aṣìṣe: gbọ́dọ̀ bẹ̀rẹ̀ pẹ̀lú "${f.prefix}"` : f.format === "ends_with" ? `Ọ̀rọ̀ aṣìṣe: gbọ́dọ̀ parí pẹ̀lú "${f.suffix}"` : f.format === "includes" ? `Ọ̀rọ̀ aṣìṣe: gbọ́dọ̀ ní "${f.includes}"` : f.format === "regex" ? `Ọ̀rọ̀ aṣìṣe: gbọ́dọ̀ bá àpẹẹrẹ mu ${f.pattern}` : `Aṣìṣe: ${l[f.format] ?? n.format}`;
          }
          case "not_multiple_of":
            return `Nọ́mbà aṣìṣe: gbọ́dọ̀ jẹ́ èyà pípín ti ${n.divisor}`;
          case "unrecognized_keys":
            return `Bọtìnì àìmọ̀: ${o.joinValues(n.keys, ", ")}`;
          case "invalid_key":
            return `Bọtìnì aṣìṣe nínú ${n.origin}`;
          case "invalid_union":
            return "Ìbáwọlé aṣìṣe";
          case "invalid_element":
            return `Iye aṣìṣe nínú ${n.origin}`;
          default:
            return "Ìbáwọlé aṣìṣe";
        }
      };
    };
    function p() {
      return {
        localeError: m()
      };
    }
    e.exports = i.default;
  }(Ui, Ui.exports)), Ui.exports;
}
var Ws;
function wu() {
  return Ws || (Ws = 1, function(e) {
    var i = w && w.__importDefault || function(De) {
      return De && De.__esModule ? De : { default: De };
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), e.yo = e.zhTW = e.zhCN = e.vi = e.ur = e.ua = e.tr = e.th = e.ta = e.sv = e.sl = e.ru = e.pt = e.pl = e.ps = e.ota = e.no = e.nl = e.ms = e.mk = e.ko = e.kh = e.ja = e.it = e.is = e.id = e.hu = e.he = e.frCA = e.fr = e.fi = e.fa = e.es = e.eo = e.en = e.de = e.da = e.cs = e.ca = e.be = e.az = e.ar = void 0;
    var d = bm();
    Object.defineProperty(e, "ar", { enumerable: !0, get: function() {
      return i(d).default;
    } });
    var a = ym();
    Object.defineProperty(e, "az", { enumerable: !0, get: function() {
      return i(a).default;
    } });
    var t = km();
    Object.defineProperty(e, "be", { enumerable: !0, get: function() {
      return i(t).default;
    } });
    var o = wm();
    Object.defineProperty(e, "ca", { enumerable: !0, get: function() {
      return i(o).default;
    } });
    var m = _m();
    Object.defineProperty(e, "cs", { enumerable: !0, get: function() {
      return i(m).default;
    } });
    var p = $m();
    Object.defineProperty(e, "da", { enumerable: !0, get: function() {
      return i(p).default;
    } });
    var s = Pm();
    Object.defineProperty(e, "de", { enumerable: !0, get: function() {
      return i(s).default;
    } });
    var r = ku();
    Object.defineProperty(e, "en", { enumerable: !0, get: function() {
      return i(r).default;
    } });
    var u = Mm();
    Object.defineProperty(e, "eo", { enumerable: !0, get: function() {
      return i(u).default;
    } });
    var l = jm();
    Object.defineProperty(e, "es", { enumerable: !0, get: function() {
      return i(l).default;
    } });
    var n = Sm();
    Object.defineProperty(e, "fa", { enumerable: !0, get: function() {
      return i(n).default;
    } });
    var f = zm();
    Object.defineProperty(e, "fi", { enumerable: !0, get: function() {
      return i(f).default;
    } });
    var v = Om();
    Object.defineProperty(e, "fr", { enumerable: !0, get: function() {
      return i(v).default;
    } });
    var D = Wm();
    Object.defineProperty(e, "frCA", { enumerable: !0, get: function() {
      return i(D).default;
    } });
    var F = Dm();
    Object.defineProperty(e, "he", { enumerable: !0, get: function() {
      return i(F).default;
    } });
    var A = Cm();
    Object.defineProperty(e, "hu", { enumerable: !0, get: function() {
      return i(A).default;
    } });
    var ae = Im();
    Object.defineProperty(e, "id", { enumerable: !0, get: function() {
      return i(ae).default;
    } });
    var ne = Tm();
    Object.defineProperty(e, "is", { enumerable: !0, get: function() {
      return i(ne).default;
    } });
    var ce = Nm();
    Object.defineProperty(e, "it", { enumerable: !0, get: function() {
      return i(ce).default;
    } });
    var Q = xm();
    Object.defineProperty(e, "ja", { enumerable: !0, get: function() {
      return i(Q).default;
    } });
    var N = Fm();
    Object.defineProperty(e, "kh", { enumerable: !0, get: function() {
      return i(N).default;
    } });
    var B = Em();
    Object.defineProperty(e, "ko", { enumerable: !0, get: function() {
      return i(B).default;
    } });
    var V = Rm();
    Object.defineProperty(e, "mk", { enumerable: !0, get: function() {
      return i(V).default;
    } });
    var se = Lm();
    Object.defineProperty(e, "ms", { enumerable: !0, get: function() {
      return i(se).default;
    } });
    var de = qm();
    Object.defineProperty(e, "nl", { enumerable: !0, get: function() {
      return i(de).default;
    } });
    var he = Zm();
    Object.defineProperty(e, "no", { enumerable: !0, get: function() {
      return i(he).default;
    } });
    var be = Am();
    Object.defineProperty(e, "ota", { enumerable: !0, get: function() {
      return i(be).default;
    } });
    var b = Vm();
    Object.defineProperty(e, "ps", { enumerable: !0, get: function() {
      return i(b).default;
    } });
    var y = Hm();
    Object.defineProperty(e, "pl", { enumerable: !0, get: function() {
      return i(y).default;
    } });
    var _ = Um();
    Object.defineProperty(e, "pt", { enumerable: !0, get: function() {
      return i(_).default;
    } });
    var R = Bm();
    Object.defineProperty(e, "ru", { enumerable: !0, get: function() {
      return i(R).default;
    } });
    var W = Xm();
    Object.defineProperty(e, "sl", { enumerable: !0, get: function() {
      return i(W).default;
    } });
    var X = Gm();
    Object.defineProperty(e, "sv", { enumerable: !0, get: function() {
      return i(X).default;
    } });
    var G = Km();
    Object.defineProperty(e, "ta", { enumerable: !0, get: function() {
      return i(G).default;
    } });
    var re = Ym();
    Object.defineProperty(e, "th", { enumerable: !0, get: function() {
      return i(re).default;
    } });
    var oe = Jm();
    Object.defineProperty(e, "tr", { enumerable: !0, get: function() {
      return i(oe).default;
    } });
    var fe = Qm();
    Object.defineProperty(e, "ua", { enumerable: !0, get: function() {
      return i(fe).default;
    } });
    var $e = ev();
    Object.defineProperty(e, "ur", { enumerable: !0, get: function() {
      return i($e).default;
    } });
    var ye = nv();
    Object.defineProperty(e, "vi", { enumerable: !0, get: function() {
      return i(ye).default;
    } });
    var we = iv();
    Object.defineProperty(e, "zhCN", { enumerable: !0, get: function() {
      return i(we).default;
    } });
    var je = av();
    Object.defineProperty(e, "zhTW", { enumerable: !0, get: function() {
      return i(je).default;
    } });
    var Oe = tv();
    Object.defineProperty(e, "yo", { enumerable: !0, get: function() {
      return i(Oe).default;
    } });
  }(gt)), gt;
}
var dn = {}, Ds;
function _u() {
  if (Ds) return dn;
  Ds = 1, Object.defineProperty(dn, "__esModule", { value: !0 }), dn.globalRegistry = dn.$ZodRegistry = dn.$input = dn.$output = void 0, dn.registry = i, dn.$output = Symbol("ZodOutput"), dn.$input = Symbol("ZodInput");
  class e {
    constructor() {
      this._map = /* @__PURE__ */ new Map(), this._idmap = /* @__PURE__ */ new Map();
    }
    add(a, ...t) {
      const o = t[0];
      if (this._map.set(a, o), o && typeof o == "object" && "id" in o) {
        if (this._idmap.has(o.id))
          throw new Error(`ID ${o.id} already exists in the registry`);
        this._idmap.set(o.id, a);
      }
      return this;
    }
    clear() {
      return this._map = /* @__PURE__ */ new Map(), this._idmap = /* @__PURE__ */ new Map(), this;
    }
    remove(a) {
      const t = this._map.get(a);
      return t && typeof t == "object" && "id" in t && this._idmap.delete(t.id), this._map.delete(a), this;
    }
    get(a) {
      const t = a._zod.parent;
      if (t) {
        const o = { ...this.get(t) ?? {} };
        delete o.id;
        const m = { ...o, ...this._map.get(a) };
        return Object.keys(m).length ? m : void 0;
      }
      return this._map.get(a);
    }
    has(a) {
      return this._map.has(a);
    }
  }
  dn.$ZodRegistry = e;
  function i() {
    return new e();
  }
  return dn.globalRegistry = i(), dn;
}
var Rn = {}, H = {}, Cs;
function $u() {
  if (Cs) return H;
  Cs = 1;
  var e = w && w.__createBinding || (Object.create ? function(O, C, ie, Se) {
    Se === void 0 && (Se = ie);
    var ze = Object.getOwnPropertyDescriptor(C, ie);
    (!ze || ("get" in ze ? !C.__esModule : ze.writable || ze.configurable)) && (ze = { enumerable: !0, get: function() {
      return C[ie];
    } }), Object.defineProperty(O, Se, ze);
  } : function(O, C, ie, Se) {
    Se === void 0 && (Se = ie), O[Se] = C[ie];
  }), i = w && w.__setModuleDefault || (Object.create ? function(O, C) {
    Object.defineProperty(O, "default", { enumerable: !0, value: C });
  } : function(O, C) {
    O.default = C;
  }), d = w && w.__importStar || function(O) {
    if (O && O.__esModule) return O;
    var C = {};
    if (O != null) for (var ie in O) ie !== "default" && Object.prototype.hasOwnProperty.call(O, ie) && e(C, O, ie);
    return i(C, O), C;
  };
  Object.defineProperty(H, "__esModule", { value: !0 }), H.TimePrecision = void 0, H._string = m, H._coercedString = p, H._email = s, H._guid = r, H._uuid = u, H._uuidv4 = l, H._uuidv6 = n, H._uuidv7 = f, H._url = v, H._emoji = D, H._nanoid = F, H._cuid = A, H._cuid2 = ae, H._ulid = ne, H._xid = ce, H._ksuid = Q, H._ipv4 = N, H._ipv6 = B, H._cidrv4 = V, H._cidrv6 = se, H._base64 = de, H._base64url = he, H._e164 = be, H._jwt = b, H._isoDateTime = y, H._isoDate = _, H._isoTime = R, H._isoDuration = W, H._number = X, H._coercedNumber = G, H._int = re, H._float32 = oe, H._float64 = fe, H._int32 = $e, H._uint32 = ye, H._boolean = we, H._coercedBoolean = je, H._bigint = Oe, H._coercedBigint = De, H._int64 = Qe, H._uint64 = an, H._symbol = We, H._undefined = x, H._null = j, H._any = h, H._unknown = g, H._never = k, H._void = S, H._date = z, H._coercedDate = E, H._nan = q, H._lt = L, H._lte = U, H._max = U, H._lte = U, H._max = U, H._gt = Y, H._gte = ee, H._min = ee, H._gte = ee, H._min = ee, H._positive = J, H._negative = ke, H._nonpositive = me, H._nonnegative = _e, H._multipleOf = Pe, H._maxSize = Ee, H._minSize = Re, H._size = en, H._maxLength = Le, H._minLength = rn, H._length = on, H._regex = Ie, H._lowercase = xe, H._uppercase = ln, H._includes = cn, H._startsWith = qe, H._endsWith = He, H._property = Nn, H._mime = Ze, H._overwrite = Fe, H._normalize = yn, H._trim = kn, H._toLowerCase = xn, H._toUpperCase = Ae, H._array = mn, H._union = hn, H._discriminatedUnion = zn, H._intersection = Fn, H._tuple = sa, H._record = da, H._map = ua, H._set = c, H._enum = M, H._nativeEnum = T, H._literal = Z, H._file = ve, H._transform = Be, H._optional = Te, H._nullable = Ru, H._default = Lu, H._nonoptional = qu, H._success = Zu, H._catch = Au, H._pipe = Vu, H._readonly = Hu, H._templateLiteral = Uu, H._lazy = Bu, H._promise = Xu, H._custom = Gu, H._refine = Ku, H._superRefine = Yu, H._check = ur, H._stringbool = Ju, H._stringFormat = Qu;
  const a = d(Qt()), t = d(ta()), o = d(pe());
  function m(O, C) {
    return new O({
      type: "string",
      ...o.normalizeParams(C)
    });
  }
  function p(O, C) {
    return new O({
      type: "string",
      coerce: !0,
      ...o.normalizeParams(C)
    });
  }
  function s(O, C) {
    return new O({
      type: "string",
      format: "email",
      check: "string_format",
      abort: !1,
      ...o.normalizeParams(C)
    });
  }
  function r(O, C) {
    return new O({
      type: "string",
      format: "guid",
      check: "string_format",
      abort: !1,
      ...o.normalizeParams(C)
    });
  }
  function u(O, C) {
    return new O({
      type: "string",
      format: "uuid",
      check: "string_format",
      abort: !1,
      ...o.normalizeParams(C)
    });
  }
  function l(O, C) {
    return new O({
      type: "string",
      format: "uuid",
      check: "string_format",
      abort: !1,
      version: "v4",
      ...o.normalizeParams(C)
    });
  }
  function n(O, C) {
    return new O({
      type: "string",
      format: "uuid",
      check: "string_format",
      abort: !1,
      version: "v6",
      ...o.normalizeParams(C)
    });
  }
  function f(O, C) {
    return new O({
      type: "string",
      format: "uuid",
      check: "string_format",
      abort: !1,
      version: "v7",
      ...o.normalizeParams(C)
    });
  }
  function v(O, C) {
    return new O({
      type: "string",
      format: "url",
      check: "string_format",
      abort: !1,
      ...o.normalizeParams(C)
    });
  }
  function D(O, C) {
    return new O({
      type: "string",
      format: "emoji",
      check: "string_format",
      abort: !1,
      ...o.normalizeParams(C)
    });
  }
  function F(O, C) {
    return new O({
      type: "string",
      format: "nanoid",
      check: "string_format",
      abort: !1,
      ...o.normalizeParams(C)
    });
  }
  function A(O, C) {
    return new O({
      type: "string",
      format: "cuid",
      check: "string_format",
      abort: !1,
      ...o.normalizeParams(C)
    });
  }
  function ae(O, C) {
    return new O({
      type: "string",
      format: "cuid2",
      check: "string_format",
      abort: !1,
      ...o.normalizeParams(C)
    });
  }
  function ne(O, C) {
    return new O({
      type: "string",
      format: "ulid",
      check: "string_format",
      abort: !1,
      ...o.normalizeParams(C)
    });
  }
  function ce(O, C) {
    return new O({
      type: "string",
      format: "xid",
      check: "string_format",
      abort: !1,
      ...o.normalizeParams(C)
    });
  }
  function Q(O, C) {
    return new O({
      type: "string",
      format: "ksuid",
      check: "string_format",
      abort: !1,
      ...o.normalizeParams(C)
    });
  }
  function N(O, C) {
    return new O({
      type: "string",
      format: "ipv4",
      check: "string_format",
      abort: !1,
      ...o.normalizeParams(C)
    });
  }
  function B(O, C) {
    return new O({
      type: "string",
      format: "ipv6",
      check: "string_format",
      abort: !1,
      ...o.normalizeParams(C)
    });
  }
  function V(O, C) {
    return new O({
      type: "string",
      format: "cidrv4",
      check: "string_format",
      abort: !1,
      ...o.normalizeParams(C)
    });
  }
  function se(O, C) {
    return new O({
      type: "string",
      format: "cidrv6",
      check: "string_format",
      abort: !1,
      ...o.normalizeParams(C)
    });
  }
  function de(O, C) {
    return new O({
      type: "string",
      format: "base64",
      check: "string_format",
      abort: !1,
      ...o.normalizeParams(C)
    });
  }
  function he(O, C) {
    return new O({
      type: "string",
      format: "base64url",
      check: "string_format",
      abort: !1,
      ...o.normalizeParams(C)
    });
  }
  function be(O, C) {
    return new O({
      type: "string",
      format: "e164",
      check: "string_format",
      abort: !1,
      ...o.normalizeParams(C)
    });
  }
  function b(O, C) {
    return new O({
      type: "string",
      format: "jwt",
      check: "string_format",
      abort: !1,
      ...o.normalizeParams(C)
    });
  }
  H.TimePrecision = {
    Any: null,
    Minute: -1,
    Second: 0,
    Millisecond: 3,
    Microsecond: 6
  };
  function y(O, C) {
    return new O({
      type: "string",
      format: "datetime",
      check: "string_format",
      offset: !1,
      local: !1,
      precision: null,
      ...o.normalizeParams(C)
    });
  }
  function _(O, C) {
    return new O({
      type: "string",
      format: "date",
      check: "string_format",
      ...o.normalizeParams(C)
    });
  }
  function R(O, C) {
    return new O({
      type: "string",
      format: "time",
      check: "string_format",
      precision: null,
      ...o.normalizeParams(C)
    });
  }
  function W(O, C) {
    return new O({
      type: "string",
      format: "duration",
      check: "string_format",
      ...o.normalizeParams(C)
    });
  }
  function X(O, C) {
    return new O({
      type: "number",
      checks: [],
      ...o.normalizeParams(C)
    });
  }
  function G(O, C) {
    return new O({
      type: "number",
      coerce: !0,
      checks: [],
      ...o.normalizeParams(C)
    });
  }
  function re(O, C) {
    return new O({
      type: "number",
      check: "number_format",
      abort: !1,
      format: "safeint",
      ...o.normalizeParams(C)
    });
  }
  function oe(O, C) {
    return new O({
      type: "number",
      check: "number_format",
      abort: !1,
      format: "float32",
      ...o.normalizeParams(C)
    });
  }
  function fe(O, C) {
    return new O({
      type: "number",
      check: "number_format",
      abort: !1,
      format: "float64",
      ...o.normalizeParams(C)
    });
  }
  function $e(O, C) {
    return new O({
      type: "number",
      check: "number_format",
      abort: !1,
      format: "int32",
      ...o.normalizeParams(C)
    });
  }
  function ye(O, C) {
    return new O({
      type: "number",
      check: "number_format",
      abort: !1,
      format: "uint32",
      ...o.normalizeParams(C)
    });
  }
  function we(O, C) {
    return new O({
      type: "boolean",
      ...o.normalizeParams(C)
    });
  }
  function je(O, C) {
    return new O({
      type: "boolean",
      coerce: !0,
      ...o.normalizeParams(C)
    });
  }
  function Oe(O, C) {
    return new O({
      type: "bigint",
      ...o.normalizeParams(C)
    });
  }
  function De(O, C) {
    return new O({
      type: "bigint",
      coerce: !0,
      ...o.normalizeParams(C)
    });
  }
  function Qe(O, C) {
    return new O({
      type: "bigint",
      check: "bigint_format",
      abort: !1,
      format: "int64",
      ...o.normalizeParams(C)
    });
  }
  function an(O, C) {
    return new O({
      type: "bigint",
      check: "bigint_format",
      abort: !1,
      format: "uint64",
      ...o.normalizeParams(C)
    });
  }
  function We(O, C) {
    return new O({
      type: "symbol",
      ...o.normalizeParams(C)
    });
  }
  function x(O, C) {
    return new O({
      type: "undefined",
      ...o.normalizeParams(C)
    });
  }
  function j(O, C) {
    return new O({
      type: "null",
      ...o.normalizeParams(C)
    });
  }
  function h(O) {
    return new O({
      type: "any"
    });
  }
  function g(O) {
    return new O({
      type: "unknown"
    });
  }
  function k(O, C) {
    return new O({
      type: "never",
      ...o.normalizeParams(C)
    });
  }
  function S(O, C) {
    return new O({
      type: "void",
      ...o.normalizeParams(C)
    });
  }
  function z(O, C) {
    return new O({
      type: "date",
      ...o.normalizeParams(C)
    });
  }
  function E(O, C) {
    return new O({
      type: "date",
      coerce: !0,
      ...o.normalizeParams(C)
    });
  }
  function q(O, C) {
    return new O({
      type: "nan",
      ...o.normalizeParams(C)
    });
  }
  function L(O, C) {
    return new a.$ZodCheckLessThan({
      check: "less_than",
      ...o.normalizeParams(C),
      value: O,
      inclusive: !1
    });
  }
  function U(O, C) {
    return new a.$ZodCheckLessThan({
      check: "less_than",
      ...o.normalizeParams(C),
      value: O,
      inclusive: !0
    });
  }
  function Y(O, C) {
    return new a.$ZodCheckGreaterThan({
      check: "greater_than",
      ...o.normalizeParams(C),
      value: O,
      inclusive: !1
    });
  }
  function ee(O, C) {
    return new a.$ZodCheckGreaterThan({
      check: "greater_than",
      ...o.normalizeParams(C),
      value: O,
      inclusive: !0
    });
  }
  function J(O) {
    return Y(0, O);
  }
  function ke(O) {
    return L(0, O);
  }
  function me(O) {
    return U(0, O);
  }
  function _e(O) {
    return ee(0, O);
  }
  function Pe(O, C) {
    return new a.$ZodCheckMultipleOf({
      check: "multiple_of",
      ...o.normalizeParams(C),
      value: O
    });
  }
  function Ee(O, C) {
    return new a.$ZodCheckMaxSize({
      check: "max_size",
      ...o.normalizeParams(C),
      maximum: O
    });
  }
  function Re(O, C) {
    return new a.$ZodCheckMinSize({
      check: "min_size",
      ...o.normalizeParams(C),
      minimum: O
    });
  }
  function en(O, C) {
    return new a.$ZodCheckSizeEquals({
      check: "size_equals",
      ...o.normalizeParams(C),
      size: O
    });
  }
  function Le(O, C) {
    return new a.$ZodCheckMaxLength({
      check: "max_length",
      ...o.normalizeParams(C),
      maximum: O
    });
  }
  function rn(O, C) {
    return new a.$ZodCheckMinLength({
      check: "min_length",
      ...o.normalizeParams(C),
      minimum: O
    });
  }
  function on(O, C) {
    return new a.$ZodCheckLengthEquals({
      check: "length_equals",
      ...o.normalizeParams(C),
      length: O
    });
  }
  function Ie(O, C) {
    return new a.$ZodCheckRegex({
      check: "string_format",
      format: "regex",
      ...o.normalizeParams(C),
      pattern: O
    });
  }
  function xe(O) {
    return new a.$ZodCheckLowerCase({
      check: "string_format",
      format: "lowercase",
      ...o.normalizeParams(O)
    });
  }
  function ln(O) {
    return new a.$ZodCheckUpperCase({
      check: "string_format",
      format: "uppercase",
      ...o.normalizeParams(O)
    });
  }
  function cn(O, C) {
    return new a.$ZodCheckIncludes({
      check: "string_format",
      format: "includes",
      ...o.normalizeParams(C),
      includes: O
    });
  }
  function qe(O, C) {
    return new a.$ZodCheckStartsWith({
      check: "string_format",
      format: "starts_with",
      ...o.normalizeParams(C),
      prefix: O
    });
  }
  function He(O, C) {
    return new a.$ZodCheckEndsWith({
      check: "string_format",
      format: "ends_with",
      ...o.normalizeParams(C),
      suffix: O
    });
  }
  function Nn(O, C, ie) {
    return new a.$ZodCheckProperty({
      check: "property",
      property: O,
      schema: C,
      ...o.normalizeParams(ie)
    });
  }
  function Ze(O, C) {
    return new a.$ZodCheckMimeType({
      check: "mime_type",
      mime: O,
      ...o.normalizeParams(C)
    });
  }
  function Fe(O) {
    return new a.$ZodCheckOverwrite({
      check: "overwrite",
      tx: O
    });
  }
  function yn(O) {
    return Fe((C) => C.normalize(O));
  }
  function kn() {
    return Fe((O) => O.trim());
  }
  function xn() {
    return Fe((O) => O.toLowerCase());
  }
  function Ae() {
    return Fe((O) => O.toUpperCase());
  }
  function mn(O, C, ie) {
    return new O({
      type: "array",
      element: C,
      // get element() {
      //   return element;
      // },
      ...o.normalizeParams(ie)
    });
  }
  function hn(O, C, ie) {
    return new O({
      type: "union",
      options: C,
      ...o.normalizeParams(ie)
    });
  }
  function zn(O, C, ie, Se) {
    return new O({
      type: "union",
      options: ie,
      discriminator: C,
      ...o.normalizeParams(Se)
    });
  }
  function Fn(O, C, ie) {
    return new O({
      type: "intersection",
      left: C,
      right: ie
    });
  }
  function sa(O, C, ie, Se) {
    const ze = ie instanceof t.$ZodType, On = ze ? Se : ie, Un = ze ? ie : null;
    return new O({
      type: "tuple",
      items: C,
      rest: Un,
      ...o.normalizeParams(On)
    });
  }
  function da(O, C, ie, Se) {
    return new O({
      type: "record",
      keyType: C,
      valueType: ie,
      ...o.normalizeParams(Se)
    });
  }
  function ua(O, C, ie, Se) {
    return new O({
      type: "map",
      keyType: C,
      valueType: ie,
      ...o.normalizeParams(Se)
    });
  }
  function c(O, C, ie) {
    return new O({
      type: "set",
      valueType: C,
      ...o.normalizeParams(ie)
    });
  }
  function M(O, C, ie) {
    const Se = Array.isArray(C) ? Object.fromEntries(C.map((ze) => [ze, ze])) : C;
    return new O({
      type: "enum",
      entries: Se,
      ...o.normalizeParams(ie)
    });
  }
  function T(O, C, ie) {
    return new O({
      type: "enum",
      entries: C,
      ...o.normalizeParams(ie)
    });
  }
  function Z(O, C, ie) {
    return new O({
      type: "literal",
      values: Array.isArray(C) ? C : [C],
      ...o.normalizeParams(ie)
    });
  }
  function ve(O, C) {
    return new O({
      type: "file",
      ...o.normalizeParams(C)
    });
  }
  function Be(O, C) {
    return new O({
      type: "transform",
      transform: C
    });
  }
  function Te(O, C) {
    return new O({
      type: "optional",
      innerType: C
    });
  }
  function Ru(O, C) {
    return new O({
      type: "nullable",
      innerType: C
    });
  }
  function Lu(O, C, ie) {
    return new O({
      type: "default",
      innerType: C,
      get defaultValue() {
        return typeof ie == "function" ? ie() : o.shallowClone(ie);
      }
    });
  }
  function qu(O, C, ie) {
    return new O({
      type: "nonoptional",
      innerType: C,
      ...o.normalizeParams(ie)
    });
  }
  function Zu(O, C) {
    return new O({
      type: "success",
      innerType: C
    });
  }
  function Au(O, C, ie) {
    return new O({
      type: "catch",
      innerType: C,
      catchValue: typeof ie == "function" ? ie : () => ie
    });
  }
  function Vu(O, C, ie) {
    return new O({
      type: "pipe",
      in: C,
      out: ie
    });
  }
  function Hu(O, C) {
    return new O({
      type: "readonly",
      innerType: C
    });
  }
  function Uu(O, C, ie) {
    return new O({
      type: "template_literal",
      parts: C,
      ...o.normalizeParams(ie)
    });
  }
  function Bu(O, C) {
    return new O({
      type: "lazy",
      getter: C
    });
  }
  function Xu(O, C) {
    return new O({
      type: "promise",
      innerType: C
    });
  }
  function Gu(O, C, ie) {
    const Se = o.normalizeParams(ie);
    return Se.abort ?? (Se.abort = !0), new O({
      type: "custom",
      check: "custom",
      fn: C,
      ...Se
    });
  }
  function Ku(O, C, ie) {
    return new O({
      type: "custom",
      check: "custom",
      fn: C,
      ...o.normalizeParams(ie)
    });
  }
  function Yu(O) {
    const C = ur((ie) => (ie.addIssue = (Se) => {
      if (typeof Se == "string")
        ie.issues.push(o.issue(Se, ie.value, C._zod.def));
      else {
        const ze = Se;
        ze.fatal && (ze.continue = !1), ze.code ?? (ze.code = "custom"), ze.input ?? (ze.input = ie.value), ze.inst ?? (ze.inst = C), ze.continue ?? (ze.continue = !C._zod.def.abort), ie.issues.push(o.issue(ze));
      }
    }, O(ie.value, ie)));
    return C;
  }
  function ur(O, C) {
    const ie = new a.$ZodCheck({
      check: "custom",
      ...o.normalizeParams(C)
    });
    return ie._zod.check = O, ie;
  }
  function Ju(O, C) {
    const ie = o.normalizeParams(C);
    let Se = ie.truthy ?? ["true", "1", "yes", "on", "y", "enabled"], ze = ie.falsy ?? ["false", "0", "no", "off", "n", "disabled"];
    ie.case !== "sensitive" && (Se = Se.map((wn) => typeof wn == "string" ? wn.toLowerCase() : wn), ze = ze.map((wn) => typeof wn == "string" ? wn.toLowerCase() : wn));
    const On = new Set(Se), Un = new Set(ze), ti = O.Pipe ?? t.$ZodPipe, ef = O.Boolean ?? t.$ZodBoolean, nf = O.String ?? t.$ZodString, af = O.Transform ?? t.$ZodTransform, fr = new af({
      type: "transform",
      transform: (wn, lr) => {
        let ri = wn;
        return ie.case !== "sensitive" && (ri = ri.toLowerCase()), On.has(ri) ? !0 : Un.has(ri) ? !1 : (lr.issues.push({
          code: "invalid_value",
          expected: "stringbool",
          values: [...On, ...Un],
          input: lr.value,
          inst: fr,
          continue: !1
        }), {});
      },
      error: ie.error
    }), tf = new ti({
      type: "pipe",
      in: new nf({ type: "string", error: ie.error }),
      out: fr,
      error: ie.error
    });
    return new ti({
      type: "pipe",
      in: tf,
      out: new ef({
        type: "boolean",
        error: ie.error
      }),
      error: ie.error
    });
  }
  function Qu(O, C, ie, Se = {}) {
    const ze = o.normalizeParams(Se), On = {
      ...o.normalizeParams(Se),
      check: "string_format",
      type: "string",
      format: C,
      fn: typeof ie == "function" ? ie : (ti) => ie.test(ti),
      ...ze
    };
    return ie instanceof RegExp && (On.pattern = ie), new O(On);
  }
  return H;
}
var Is;
function rv() {
  if (Is) return Rn;
  Is = 1;
  var e = w && w.__createBinding || (Object.create ? function(r, u, l, n) {
    n === void 0 && (n = l);
    var f = Object.getOwnPropertyDescriptor(u, l);
    (!f || ("get" in f ? !u.__esModule : f.writable || f.configurable)) && (f = { enumerable: !0, get: function() {
      return u[l];
    } }), Object.defineProperty(r, n, f);
  } : function(r, u, l, n) {
    n === void 0 && (n = l), r[n] = u[l];
  }), i = w && w.__setModuleDefault || (Object.create ? function(r, u) {
    Object.defineProperty(r, "default", { enumerable: !0, value: u });
  } : function(r, u) {
    r.default = u;
  }), d = w && w.__importStar || function(r) {
    if (r && r.__esModule) return r;
    var u = {};
    if (r != null) for (var l in r) l !== "default" && Object.prototype.hasOwnProperty.call(r, l) && e(u, r, l);
    return i(u, r), u;
  };
  Object.defineProperty(Rn, "__esModule", { value: !0 }), Rn.$ZodFunction = void 0, Rn.function = s;
  const a = $u(), t = Yt(), o = d(ta()), m = ta();
  class p {
    constructor(u) {
      this._def = u, this.def = u;
    }
    implement(u) {
      if (typeof u != "function")
        throw new Error("implement() must be called with a function");
      const l = (...n) => {
        const f = this._def.input ? (0, t.parse)(this._def.input, n, void 0, { callee: l }) : n;
        if (!Array.isArray(f))
          throw new Error("Invalid arguments schema: not an array or tuple schema.");
        const v = u(...f);
        return this._def.output ? (0, t.parse)(this._def.output, v, void 0, { callee: l }) : v;
      };
      return l;
    }
    implementAsync(u) {
      if (typeof u != "function")
        throw new Error("implement() must be called with a function");
      const l = async (...n) => {
        const f = this._def.input ? await (0, t.parseAsync)(this._def.input, n, void 0, { callee: l }) : n;
        if (!Array.isArray(f))
          throw new Error("Invalid arguments schema: not an array or tuple schema.");
        const v = await u(...f);
        return this._def.output ? (0, t.parseAsync)(this._def.output, v, void 0, { callee: l }) : v;
      };
      return l;
    }
    input(...u) {
      const l = this.constructor;
      return Array.isArray(u[0]) ? new l({
        type: "function",
        input: new m.$ZodTuple({
          type: "tuple",
          items: u[0],
          rest: u[1]
        }),
        output: this._def.output
      }) : new l({
        type: "function",
        input: u[0],
        output: this._def.output
      });
    }
    output(u) {
      const l = this.constructor;
      return new l({
        type: "function",
        input: this._def.input,
        output: u
      });
    }
  }
  Rn.$ZodFunction = p;
  function s(r) {
    return new p({
      type: "function",
      input: Array.isArray(r == null ? void 0 : r.input) ? (0, a._tuple)(o.$ZodTuple, r == null ? void 0 : r.input) : (r == null ? void 0 : r.input) ?? (0, a._array)(o.$ZodArray, (0, a._unknown)(o.$ZodUnknown)),
      output: (r == null ? void 0 : r.output) ?? (0, a._unknown)(o.$ZodUnknown)
    });
  }
  return Rn;
}
var Ln = {}, Ts;
function ov() {
  if (Ts) return Ln;
  Ts = 1, Object.defineProperty(Ln, "__esModule", { value: !0 }), Ln.JSONSchemaGenerator = void 0, Ln.toJSONSchema = a;
  const e = _u(), i = pe();
  class d {
    constructor(m) {
      this.counter = 0, this.metadataRegistry = (m == null ? void 0 : m.metadata) ?? e.globalRegistry, this.target = (m == null ? void 0 : m.target) ?? "draft-2020-12", this.unrepresentable = (m == null ? void 0 : m.unrepresentable) ?? "throw", this.override = (m == null ? void 0 : m.override) ?? (() => {
      }), this.io = (m == null ? void 0 : m.io) ?? "output", this.seen = /* @__PURE__ */ new Map();
    }
    process(m, p = { path: [], schemaPath: [] }) {
      var F, A, ae;
      var s;
      const r = m._zod.def, u = {
        guid: "uuid",
        url: "uri",
        datetime: "date-time",
        json_string: "json-string",
        regex: ""
        // do not set
      }, l = this.seen.get(m);
      if (l)
        return l.count++, p.schemaPath.includes(m) && (l.cycle = p.path), l.schema;
      const n = { schema: {}, count: 1, cycle: void 0, path: p.path };
      this.seen.set(m, n);
      const f = (A = (F = m._zod).toJSONSchema) == null ? void 0 : A.call(F);
      if (f)
        n.schema = f;
      else {
        const ne = {
          ...p,
          schemaPath: [...p.schemaPath, m],
          path: p.path
        }, ce = m._zod.parent;
        if (ce)
          n.ref = ce, this.process(ce, ne), this.seen.get(ce).isParent = !0;
        else {
          const Q = n.schema;
          switch (r.type) {
            case "string": {
              const N = Q;
              N.type = "string";
              const { minimum: B, maximum: V, format: se, patterns: de, contentEncoding: he } = m._zod.bag;
              if (typeof B == "number" && (N.minLength = B), typeof V == "number" && (N.maxLength = V), se && (N.format = u[se] ?? se, N.format === "" && delete N.format), he && (N.contentEncoding = he), de && de.size > 0) {
                const be = [...de];
                be.length === 1 ? N.pattern = be[0].source : be.length > 1 && (n.schema.allOf = [
                  ...be.map((b) => ({
                    ...this.target === "draft-7" || this.target === "draft-4" ? { type: "string" } : {},
                    pattern: b.source
                  }))
                ]);
              }
              break;
            }
            case "number": {
              const N = Q, { minimum: B, maximum: V, format: se, multipleOf: de, exclusiveMaximum: he, exclusiveMinimum: be } = m._zod.bag;
              typeof se == "string" && se.includes("int") ? N.type = "integer" : N.type = "number", typeof be == "number" && (this.target === "draft-4" ? (N.minimum = be, N.exclusiveMinimum = !0) : N.exclusiveMinimum = be), typeof B == "number" && (N.minimum = B, typeof be == "number" && this.target !== "draft-4" && (be >= B ? delete N.minimum : delete N.exclusiveMinimum)), typeof he == "number" && (this.target === "draft-4" ? (N.maximum = he, N.exclusiveMaximum = !0) : N.exclusiveMaximum = he), typeof V == "number" && (N.maximum = V, typeof he == "number" && this.target !== "draft-4" && (he <= V ? delete N.maximum : delete N.exclusiveMaximum)), typeof de == "number" && (N.multipleOf = de);
              break;
            }
            case "boolean": {
              const N = Q;
              N.type = "boolean";
              break;
            }
            case "bigint": {
              if (this.unrepresentable === "throw")
                throw new Error("BigInt cannot be represented in JSON Schema");
              break;
            }
            case "symbol": {
              if (this.unrepresentable === "throw")
                throw new Error("Symbols cannot be represented in JSON Schema");
              break;
            }
            case "null": {
              Q.type = "null";
              break;
            }
            case "any":
              break;
            case "unknown":
              break;
            case "undefined": {
              if (this.unrepresentable === "throw")
                throw new Error("Undefined cannot be represented in JSON Schema");
              break;
            }
            case "void": {
              if (this.unrepresentable === "throw")
                throw new Error("Void cannot be represented in JSON Schema");
              break;
            }
            case "never": {
              Q.not = {};
              break;
            }
            case "date": {
              if (this.unrepresentable === "throw")
                throw new Error("Date cannot be represented in JSON Schema");
              break;
            }
            case "array": {
              const N = Q, { minimum: B, maximum: V } = m._zod.bag;
              typeof B == "number" && (N.minItems = B), typeof V == "number" && (N.maxItems = V), N.type = "array", N.items = this.process(r.element, { ...ne, path: [...ne.path, "items"] });
              break;
            }
            case "object": {
              const N = Q;
              N.type = "object", N.properties = {};
              const B = r.shape;
              for (const de in B)
                N.properties[de] = this.process(B[de], {
                  ...ne,
                  path: [...ne.path, "properties", de]
                });
              const V = new Set(Object.keys(B)), se = new Set([...V].filter((de) => {
                const he = r.shape[de]._zod;
                return this.io === "input" ? he.optin === void 0 : he.optout === void 0;
              }));
              se.size > 0 && (N.required = Array.from(se)), ((ae = r.catchall) == null ? void 0 : ae._zod.def.type) === "never" ? N.additionalProperties = !1 : r.catchall ? r.catchall && (N.additionalProperties = this.process(r.catchall, {
                ...ne,
                path: [...ne.path, "additionalProperties"]
              })) : this.io === "output" && (N.additionalProperties = !1);
              break;
            }
            case "union": {
              const N = Q;
              N.anyOf = r.options.map((B, V) => this.process(B, {
                ...ne,
                path: [...ne.path, "anyOf", V]
              }));
              break;
            }
            case "intersection": {
              const N = Q, B = this.process(r.left, {
                ...ne,
                path: [...ne.path, "allOf", 0]
              }), V = this.process(r.right, {
                ...ne,
                path: [...ne.path, "allOf", 1]
              }), se = (he) => "allOf" in he && Object.keys(he).length === 1, de = [
                ...se(B) ? B.allOf : [B],
                ...se(V) ? V.allOf : [V]
              ];
              N.allOf = de;
              break;
            }
            case "tuple": {
              const N = Q;
              N.type = "array";
              const B = r.items.map((de, he) => this.process(de, { ...ne, path: [...ne.path, "prefixItems", he] }));
              if (this.target === "draft-2020-12" ? N.prefixItems = B : N.items = B, r.rest) {
                const de = this.process(r.rest, {
                  ...ne,
                  path: [...ne.path, "items"]
                });
                this.target === "draft-2020-12" ? N.items = de : N.additionalItems = de;
              }
              r.rest && (N.items = this.process(r.rest, {
                ...ne,
                path: [...ne.path, "items"]
              }));
              const { minimum: V, maximum: se } = m._zod.bag;
              typeof V == "number" && (N.minItems = V), typeof se == "number" && (N.maxItems = se);
              break;
            }
            case "record": {
              const N = Q;
              N.type = "object", this.target !== "draft-4" && (N.propertyNames = this.process(r.keyType, {
                ...ne,
                path: [...ne.path, "propertyNames"]
              })), N.additionalProperties = this.process(r.valueType, {
                ...ne,
                path: [...ne.path, "additionalProperties"]
              });
              break;
            }
            case "map": {
              if (this.unrepresentable === "throw")
                throw new Error("Map cannot be represented in JSON Schema");
              break;
            }
            case "set": {
              if (this.unrepresentable === "throw")
                throw new Error("Set cannot be represented in JSON Schema");
              break;
            }
            case "enum": {
              const N = Q, B = (0, i.getEnumValues)(r.entries);
              B.every((V) => typeof V == "number") && (N.type = "number"), B.every((V) => typeof V == "string") && (N.type = "string"), N.enum = B;
              break;
            }
            case "literal": {
              const N = Q, B = [];
              for (const V of r.values)
                if (V === void 0) {
                  if (this.unrepresentable === "throw")
                    throw new Error("Literal `undefined` cannot be represented in JSON Schema");
                } else if (typeof V == "bigint") {
                  if (this.unrepresentable === "throw")
                    throw new Error("BigInt literals cannot be represented in JSON Schema");
                  B.push(Number(V));
                } else
                  B.push(V);
              if (B.length !== 0) if (B.length === 1) {
                const V = B[0];
                N.type = V === null ? "null" : typeof V, this.target === "draft-4" ? N.enum = [V] : N.const = V;
              } else
                B.every((V) => typeof V == "number") && (N.type = "number"), B.every((V) => typeof V == "string") && (N.type = "string"), B.every((V) => typeof V == "boolean") && (N.type = "string"), B.every((V) => V === null) && (N.type = "null"), N.enum = B;
              break;
            }
            case "file": {
              const N = Q, B = {
                type: "string",
                format: "binary",
                contentEncoding: "binary"
              }, { minimum: V, maximum: se, mime: de } = m._zod.bag;
              V !== void 0 && (B.minLength = V), se !== void 0 && (B.maxLength = se), de ? de.length === 1 ? (B.contentMediaType = de[0], Object.assign(N, B)) : N.anyOf = de.map((he) => ({ ...B, contentMediaType: he })) : Object.assign(N, B);
              break;
            }
            case "transform": {
              if (this.unrepresentable === "throw")
                throw new Error("Transforms cannot be represented in JSON Schema");
              break;
            }
            case "nullable": {
              const N = this.process(r.innerType, ne);
              Q.anyOf = [N, { type: "null" }];
              break;
            }
            case "nonoptional": {
              this.process(r.innerType, ne), n.ref = r.innerType;
              break;
            }
            case "success": {
              const N = Q;
              N.type = "boolean";
              break;
            }
            case "default": {
              this.process(r.innerType, ne), n.ref = r.innerType, Q.default = JSON.parse(JSON.stringify(r.defaultValue));
              break;
            }
            case "prefault": {
              this.process(r.innerType, ne), n.ref = r.innerType, this.io === "input" && (Q._prefault = JSON.parse(JSON.stringify(r.defaultValue)));
              break;
            }
            case "catch": {
              this.process(r.innerType, ne), n.ref = r.innerType;
              let N;
              try {
                N = r.catchValue(void 0);
              } catch {
                throw new Error("Dynamic catch values are not supported in JSON Schema");
              }
              Q.default = N;
              break;
            }
            case "nan": {
              if (this.unrepresentable === "throw")
                throw new Error("NaN cannot be represented in JSON Schema");
              break;
            }
            case "template_literal": {
              const N = Q, B = m._zod.pattern;
              if (!B)
                throw new Error("Pattern not found in template literal");
              N.type = "string", N.pattern = B.source;
              break;
            }
            case "pipe": {
              const N = this.io === "input" ? r.in._zod.def.type === "transform" ? r.out : r.in : r.out;
              this.process(N, ne), n.ref = N;
              break;
            }
            case "readonly": {
              this.process(r.innerType, ne), n.ref = r.innerType, Q.readOnly = !0;
              break;
            }
            case "promise": {
              this.process(r.innerType, ne), n.ref = r.innerType;
              break;
            }
            case "optional": {
              this.process(r.innerType, ne), n.ref = r.innerType;
              break;
            }
            case "lazy": {
              const N = m._zod.innerType;
              this.process(N, ne), n.ref = N;
              break;
            }
            case "custom": {
              if (this.unrepresentable === "throw")
                throw new Error("Custom types cannot be represented in JSON Schema");
              break;
            }
          }
        }
      }
      const v = this.metadataRegistry.get(m);
      return v && Object.assign(n.schema, v), this.io === "input" && t(m) && (delete n.schema.examples, delete n.schema.default), this.io === "input" && n.schema._prefault && ((s = n.schema).default ?? (s.default = n.schema._prefault)), delete n.schema._prefault, this.seen.get(m).schema;
    }
    emit(m, p) {
      var D, F, A, ae, ne, ce;
      const s = {
        cycles: (p == null ? void 0 : p.cycles) ?? "ref",
        reused: (p == null ? void 0 : p.reused) ?? "inline",
        // unrepresentable: _params?.unrepresentable ?? "throw",
        // uri: _params?.uri ?? ((id) => `${id}`),
        external: (p == null ? void 0 : p.external) ?? void 0
      }, r = this.seen.get(m);
      if (!r)
        throw new Error("Unprocessed schema. This is a bug in Zod.");
      const u = (Q) => {
        var de;
        const N = this.target === "draft-2020-12" ? "$defs" : "definitions";
        if (s.external) {
          const he = (de = s.external.registry.get(Q[0])) == null ? void 0 : de.id, be = s.external.uri ?? ((y) => y);
          if (he)
            return { ref: be(he) };
          const b = Q[1].defId ?? Q[1].schema.id ?? `schema${this.counter++}`;
          return Q[1].defId = b, { defId: b, ref: `${be("__shared")}#/${N}/${b}` };
        }
        if (Q[1] === r)
          return { ref: "#" };
        const V = `#/${N}/`, se = Q[1].schema.id ?? `__schema${this.counter++}`;
        return { defId: se, ref: V + se };
      }, l = (Q) => {
        if (Q[1].schema.$ref)
          return;
        const N = Q[1], { ref: B, defId: V } = u(Q);
        N.def = { ...N.schema }, V && (N.defId = V);
        const se = N.schema;
        for (const de in se)
          delete se[de];
        se.$ref = B;
      };
      if (s.cycles === "throw")
        for (const Q of this.seen.entries()) {
          const N = Q[1];
          if (N.cycle)
            throw new Error(`Cycle detected: #/${(D = N.cycle) == null ? void 0 : D.join("/")}/<root>

Set the \`cycles\` parameter to \`"ref"\` to resolve cyclical schemas with defs.`);
        }
      for (const Q of this.seen.entries()) {
        const N = Q[1];
        if (m === Q[0]) {
          l(Q);
          continue;
        }
        if (s.external) {
          const V = (F = s.external.registry.get(Q[0])) == null ? void 0 : F.id;
          if (m !== Q[0] && V) {
            l(Q);
            continue;
          }
        }
        if ((A = this.metadataRegistry.get(Q[0])) == null ? void 0 : A.id) {
          l(Q);
          continue;
        }
        if (N.cycle) {
          l(Q);
          continue;
        }
        if (N.count > 1 && s.reused === "ref") {
          l(Q);
          continue;
        }
      }
      const n = (Q, N) => {
        const B = this.seen.get(Q), V = B.def ?? B.schema, se = { ...V };
        if (B.ref === null)
          return;
        const de = B.ref;
        if (B.ref = null, de) {
          n(de, N);
          const he = this.seen.get(de).schema;
          he.$ref && (N.target === "draft-7" || N.target === "draft-4") ? (V.allOf = V.allOf ?? [], V.allOf.push(he)) : (Object.assign(V, he), Object.assign(V, se));
        }
        B.isParent || this.override({
          zodSchema: Q,
          jsonSchema: V,
          path: B.path ?? []
        });
      };
      for (const Q of [...this.seen.entries()].reverse())
        n(Q[0], { target: this.target });
      const f = {};
      if (this.target === "draft-2020-12" ? f.$schema = "https://json-schema.org/draft/2020-12/schema" : this.target === "draft-7" ? f.$schema = "http://json-schema.org/draft-07/schema#" : this.target === "draft-4" ? f.$schema = "http://json-schema.org/draft-04/schema#" : console.warn(`Invalid target: ${this.target}`), (ae = s.external) != null && ae.uri) {
        const Q = (ne = s.external.registry.get(m)) == null ? void 0 : ne.id;
        if (!Q)
          throw new Error("Schema is missing an `id` property");
        f.$id = s.external.uri(Q);
      }
      Object.assign(f, r.def);
      const v = ((ce = s.external) == null ? void 0 : ce.defs) ?? {};
      for (const Q of this.seen.entries()) {
        const N = Q[1];
        N.def && N.defId && (v[N.defId] = N.def);
      }
      s.external || Object.keys(v).length > 0 && (this.target === "draft-2020-12" ? f.$defs = v : f.definitions = v);
      try {
        return JSON.parse(JSON.stringify(f));
      } catch {
        throw new Error("Error converting schema to JSON.");
      }
    }
  }
  Ln.JSONSchemaGenerator = d;
  function a(o, m) {
    if (o instanceof e.$ZodRegistry) {
      const s = new d(m), r = {};
      for (const n of o._idmap.entries()) {
        const [f, v] = n;
        s.process(v);
      }
      const u = {}, l = {
        registry: o,
        uri: m == null ? void 0 : m.uri,
        defs: r
      };
      for (const n of o._idmap.entries()) {
        const [f, v] = n;
        u[f] = s.emit(v, {
          ...m,
          external: l
        });
      }
      if (Object.keys(r).length > 0) {
        const n = s.target === "draft-2020-12" ? "$defs" : "definitions";
        u.__shared = {
          [n]: r
        };
      }
      return { schemas: u };
    }
    const p = new d(m);
    return p.process(o), p.emit(o, m);
  }
  function t(o, m) {
    const p = m ?? { seen: /* @__PURE__ */ new Set() };
    if (p.seen.has(o))
      return !1;
    p.seen.add(o);
    const r = o._zod.def;
    switch (r.type) {
      case "string":
      case "number":
      case "bigint":
      case "boolean":
      case "date":
      case "symbol":
      case "undefined":
      case "null":
      case "any":
      case "unknown":
      case "never":
      case "void":
      case "literal":
      case "enum":
      case "nan":
      case "file":
      case "template_literal":
        return !1;
      case "array":
        return t(r.element, p);
      case "object": {
        for (const u in r.shape)
          if (t(r.shape[u], p))
            return !0;
        return !1;
      }
      case "union": {
        for (const u of r.options)
          if (t(u, p))
            return !0;
        return !1;
      }
      case "intersection":
        return t(r.left, p) || t(r.right, p);
      case "tuple": {
        for (const u of r.items)
          if (t(u, p))
            return !0;
        return !!(r.rest && t(r.rest, p));
      }
      case "record":
        return t(r.keyType, p) || t(r.valueType, p);
      case "map":
        return t(r.keyType, p) || t(r.valueType, p);
      case "set":
        return t(r.valueType, p);
      case "promise":
      case "optional":
      case "nonoptional":
      case "nullable":
      case "readonly":
        return t(r.innerType, p);
      case "lazy":
        return t(r.getter(), p);
      case "default":
        return t(r.innerType, p);
      case "prefault":
        return t(r.innerType, p);
      case "custom":
        return !1;
      case "transform":
        return !0;
      case "pipe":
        return t(r.in, p) || t(r.out, p);
      case "success":
        return !1;
      case "catch":
        return !1;
    }
    throw new Error(`Unknown schema type: ${r.type}`);
  }
  return Ln;
}
var wt = {}, Ns;
function sv() {
  return Ns || (Ns = 1, Object.defineProperty(wt, "__esModule", { value: !0 })), wt;
}
var xs;
function tn() {
  return xs || (xs = 1, function(e) {
    var i = w && w.__createBinding || (Object.create ? function(o, m, p, s) {
      s === void 0 && (s = p);
      var r = Object.getOwnPropertyDescriptor(m, p);
      (!r || ("get" in r ? !m.__esModule : r.writable || r.configurable)) && (r = { enumerable: !0, get: function() {
        return m[p];
      } }), Object.defineProperty(o, s, r);
    } : function(o, m, p, s) {
      s === void 0 && (s = p), o[s] = m[p];
    }), d = w && w.__setModuleDefault || (Object.create ? function(o, m) {
      Object.defineProperty(o, "default", { enumerable: !0, value: m });
    } : function(o, m) {
      o.default = m;
    }), a = w && w.__exportStar || function(o, m) {
      for (var p in o) p !== "default" && !Object.prototype.hasOwnProperty.call(m, p) && i(m, o, p);
    }, t = w && w.__importStar || function(o) {
      if (o && o.__esModule) return o;
      var m = {};
      if (o != null) for (var p in o) p !== "default" && Object.prototype.hasOwnProperty.call(o, p) && i(m, o, p);
      return d(m, o), m;
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), e.JSONSchema = e.locales = e.regexes = e.util = void 0, a(ai(), e), a(Yt(), e), a(pu(), e), a(ta(), e), a(Qt(), e), a(yu(), e), e.util = t(pe()), e.regexes = t(Jt()), e.locales = t(wu()), a(_u(), e), a(bu(), e), a(rv(), e), a($u(), e), a(ov(), e), e.JSONSchema = t(sv());
  }(ft)), ft;
}
var _t = {}, $t = {}, Fs;
function Pu() {
  return Fs || (Fs = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.toUpperCase = e.toLowerCase = e.trim = e.normalize = e.overwrite = e.mime = e.property = e.endsWith = e.startsWith = e.includes = e.uppercase = e.lowercase = e.regex = e.length = e.minLength = e.maxLength = e.size = e.minSize = e.maxSize = e.multipleOf = e.nonnegative = e.nonpositive = e.negative = e.positive = e.gte = e.gt = e.lte = e.lt = void 0;
    var i = tn();
    Object.defineProperty(e, "lt", { enumerable: !0, get: function() {
      return i._lt;
    } }), Object.defineProperty(e, "lte", { enumerable: !0, get: function() {
      return i._lte;
    } }), Object.defineProperty(e, "gt", { enumerable: !0, get: function() {
      return i._gt;
    } }), Object.defineProperty(e, "gte", { enumerable: !0, get: function() {
      return i._gte;
    } }), Object.defineProperty(e, "positive", { enumerable: !0, get: function() {
      return i._positive;
    } }), Object.defineProperty(e, "negative", { enumerable: !0, get: function() {
      return i._negative;
    } }), Object.defineProperty(e, "nonpositive", { enumerable: !0, get: function() {
      return i._nonpositive;
    } }), Object.defineProperty(e, "nonnegative", { enumerable: !0, get: function() {
      return i._nonnegative;
    } }), Object.defineProperty(e, "multipleOf", { enumerable: !0, get: function() {
      return i._multipleOf;
    } }), Object.defineProperty(e, "maxSize", { enumerable: !0, get: function() {
      return i._maxSize;
    } }), Object.defineProperty(e, "minSize", { enumerable: !0, get: function() {
      return i._minSize;
    } }), Object.defineProperty(e, "size", { enumerable: !0, get: function() {
      return i._size;
    } }), Object.defineProperty(e, "maxLength", { enumerable: !0, get: function() {
      return i._maxLength;
    } }), Object.defineProperty(e, "minLength", { enumerable: !0, get: function() {
      return i._minLength;
    } }), Object.defineProperty(e, "length", { enumerable: !0, get: function() {
      return i._length;
    } }), Object.defineProperty(e, "regex", { enumerable: !0, get: function() {
      return i._regex;
    } }), Object.defineProperty(e, "lowercase", { enumerable: !0, get: function() {
      return i._lowercase;
    } }), Object.defineProperty(e, "uppercase", { enumerable: !0, get: function() {
      return i._uppercase;
    } }), Object.defineProperty(e, "includes", { enumerable: !0, get: function() {
      return i._includes;
    } }), Object.defineProperty(e, "startsWith", { enumerable: !0, get: function() {
      return i._startsWith;
    } }), Object.defineProperty(e, "endsWith", { enumerable: !0, get: function() {
      return i._endsWith;
    } }), Object.defineProperty(e, "property", { enumerable: !0, get: function() {
      return i._property;
    } }), Object.defineProperty(e, "mime", { enumerable: !0, get: function() {
      return i._mime;
    } }), Object.defineProperty(e, "overwrite", { enumerable: !0, get: function() {
      return i._overwrite;
    } }), Object.defineProperty(e, "normalize", { enumerable: !0, get: function() {
      return i._normalize;
    } }), Object.defineProperty(e, "trim", { enumerable: !0, get: function() {
      return i._trim;
    } }), Object.defineProperty(e, "toLowerCase", { enumerable: !0, get: function() {
      return i._toLowerCase;
    } }), Object.defineProperty(e, "toUpperCase", { enumerable: !0, get: function() {
      return i._toUpperCase;
    } });
  }($t)), $t;
}
var Pt = {}, Es;
function Lt() {
  return Es || (Es = 1, function(e) {
    var i = w && w.__createBinding || (Object.create ? function(u, l, n, f) {
      f === void 0 && (f = n);
      var v = Object.getOwnPropertyDescriptor(l, n);
      (!v || ("get" in v ? !l.__esModule : v.writable || v.configurable)) && (v = { enumerable: !0, get: function() {
        return l[n];
      } }), Object.defineProperty(u, f, v);
    } : function(u, l, n, f) {
      f === void 0 && (f = n), u[f] = l[n];
    }), d = w && w.__setModuleDefault || (Object.create ? function(u, l) {
      Object.defineProperty(u, "default", { enumerable: !0, value: l });
    } : function(u, l) {
      u.default = l;
    }), a = w && w.__importStar || function(u) {
      if (u && u.__esModule) return u;
      var l = {};
      if (u != null) for (var n in u) n !== "default" && Object.prototype.hasOwnProperty.call(u, n) && i(l, u, n);
      return d(l, u), l;
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), e.ZodISODuration = e.ZodISOTime = e.ZodISODate = e.ZodISODateTime = void 0, e.datetime = m, e.date = p, e.time = s, e.duration = r;
    const t = a(tn()), o = a(er());
    e.ZodISODateTime = t.$constructor("ZodISODateTime", (u, l) => {
      t.$ZodISODateTime.init(u, l), o.ZodStringFormat.init(u, l);
    });
    function m(u) {
      return t._isoDateTime(e.ZodISODateTime, u);
    }
    e.ZodISODate = t.$constructor("ZodISODate", (u, l) => {
      t.$ZodISODate.init(u, l), o.ZodStringFormat.init(u, l);
    });
    function p(u) {
      return t._isoDate(e.ZodISODate, u);
    }
    e.ZodISOTime = t.$constructor("ZodISOTime", (u, l) => {
      t.$ZodISOTime.init(u, l), o.ZodStringFormat.init(u, l);
    });
    function s(u) {
      return t._isoTime(e.ZodISOTime, u);
    }
    e.ZodISODuration = t.$constructor("ZodISODuration", (u, l) => {
      t.$ZodISODuration.init(u, l), o.ZodStringFormat.init(u, l);
    });
    function r(u) {
      return t._isoDuration(e.ZodISODuration, u);
    }
  }(Pt)), Pt;
}
var vn = {}, Wn = {}, Rs;
function Mu() {
  if (Rs) return Wn;
  Rs = 1;
  var e = w && w.__createBinding || (Object.create ? function(p, s, r, u) {
    u === void 0 && (u = r);
    var l = Object.getOwnPropertyDescriptor(s, r);
    (!l || ("get" in l ? !s.__esModule : l.writable || l.configurable)) && (l = { enumerable: !0, get: function() {
      return s[r];
    } }), Object.defineProperty(p, u, l);
  } : function(p, s, r, u) {
    u === void 0 && (u = r), p[u] = s[r];
  }), i = w && w.__setModuleDefault || (Object.create ? function(p, s) {
    Object.defineProperty(p, "default", { enumerable: !0, value: s });
  } : function(p, s) {
    p.default = s;
  }), d = w && w.__importStar || function(p) {
    if (p && p.__esModule) return p;
    var s = {};
    if (p != null) for (var r in p) r !== "default" && Object.prototype.hasOwnProperty.call(p, r) && e(s, p, r);
    return i(s, p), s;
  };
  Object.defineProperty(Wn, "__esModule", { value: !0 }), Wn.ZodRealError = Wn.ZodError = void 0;
  const a = d(tn()), t = tn(), o = d(pe()), m = (p, s) => {
    t.$ZodError.init(p, s), p.name = "ZodError", Object.defineProperties(p, {
      format: {
        value: (r) => a.formatError(p, r)
        // enumerable: false,
      },
      flatten: {
        value: (r) => a.flattenError(p, r)
        // enumerable: false,
      },
      addIssue: {
        value: (r) => {
          p.issues.push(r), p.message = JSON.stringify(p.issues, o.jsonStringifyReplacer, 2);
        }
        // enumerable: false,
      },
      addIssues: {
        value: (r) => {
          p.issues.push(...r), p.message = JSON.stringify(p.issues, o.jsonStringifyReplacer, 2);
        }
        // enumerable: false,
      },
      isEmpty: {
        get() {
          return p.issues.length === 0;
        }
        // enumerable: false,
      }
    });
  };
  return Wn.ZodError = a.$constructor("ZodError", m), Wn.ZodRealError = a.$constructor("ZodError", m, {
    Parent: Error
  }), Wn;
}
var Ls;
function ju() {
  if (Ls) return vn;
  Ls = 1;
  var e = w && w.__createBinding || (Object.create ? function(o, m, p, s) {
    s === void 0 && (s = p);
    var r = Object.getOwnPropertyDescriptor(m, p);
    (!r || ("get" in r ? !m.__esModule : r.writable || r.configurable)) && (r = { enumerable: !0, get: function() {
      return m[p];
    } }), Object.defineProperty(o, s, r);
  } : function(o, m, p, s) {
    s === void 0 && (s = p), o[s] = m[p];
  }), i = w && w.__setModuleDefault || (Object.create ? function(o, m) {
    Object.defineProperty(o, "default", { enumerable: !0, value: m });
  } : function(o, m) {
    o.default = m;
  }), d = w && w.__importStar || function(o) {
    if (o && o.__esModule) return o;
    var m = {};
    if (o != null) for (var p in o) p !== "default" && Object.prototype.hasOwnProperty.call(o, p) && e(m, o, p);
    return i(m, o), m;
  };
  Object.defineProperty(vn, "__esModule", { value: !0 }), vn.safeParseAsync = vn.safeParse = vn.parseAsync = vn.parse = void 0;
  const a = d(tn()), t = Mu();
  return vn.parse = a._parse(t.ZodRealError), vn.parseAsync = a._parseAsync(t.ZodRealError), vn.safeParse = a._safeParse(t.ZodRealError), vn.safeParseAsync = a._safeParseAsync(t.ZodRealError), vn;
}
var qs;
function er() {
  return qs || (qs = 1, function(e) {
    var i = w && w.__createBinding || (Object.create ? function(c, M, T, Z) {
      Z === void 0 && (Z = T);
      var ve = Object.getOwnPropertyDescriptor(M, T);
      (!ve || ("get" in ve ? !M.__esModule : ve.writable || ve.configurable)) && (ve = { enumerable: !0, get: function() {
        return M[T];
      } }), Object.defineProperty(c, Z, ve);
    } : function(c, M, T, Z) {
      Z === void 0 && (Z = T), c[Z] = M[T];
    }), d = w && w.__setModuleDefault || (Object.create ? function(c, M) {
      Object.defineProperty(c, "default", { enumerable: !0, value: M });
    } : function(c, M) {
      c.default = M;
    }), a = w && w.__importStar || function(c) {
      if (c && c.__esModule) return c;
      var M = {};
      if (c != null) for (var T in c) T !== "default" && Object.prototype.hasOwnProperty.call(c, T) && i(M, c, T);
      return d(M, c), M;
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), e.ZodTransform = e.ZodFile = e.ZodLiteral = e.ZodEnum = e.ZodSet = e.ZodMap = e.ZodRecord = e.ZodTuple = e.ZodIntersection = e.ZodDiscriminatedUnion = e.ZodUnion = e.ZodObject = e.ZodArray = e.ZodDate = e.ZodVoid = e.ZodNever = e.ZodUnknown = e.ZodAny = e.ZodNull = e.ZodUndefined = e.ZodSymbol = e.ZodBigIntFormat = e.ZodBigInt = e.ZodBoolean = e.ZodNumberFormat = e.ZodNumber = e.ZodCustomStringFormat = e.ZodJWT = e.ZodE164 = e.ZodBase64URL = e.ZodBase64 = e.ZodCIDRv6 = e.ZodCIDRv4 = e.ZodIPv6 = e.ZodIPv4 = e.ZodKSUID = e.ZodXID = e.ZodULID = e.ZodCUID2 = e.ZodCUID = e.ZodNanoID = e.ZodEmoji = e.ZodURL = e.ZodUUID = e.ZodGUID = e.ZodEmail = e.ZodStringFormat = e.ZodString = e._ZodString = e.ZodType = void 0, e.stringbool = e.ZodCustom = e.ZodPromise = e.ZodLazy = e.ZodTemplateLiteral = e.ZodReadonly = e.ZodPipe = e.ZodNaN = e.ZodCatch = e.ZodSuccess = e.ZodNonOptional = e.ZodPrefault = e.ZodDefault = e.ZodNullable = e.ZodOptional = void 0, e.string = r, e.email = u, e.guid = l, e.uuid = n, e.uuidv4 = f, e.uuidv6 = v, e.uuidv7 = D, e.url = F, e.emoji = A, e.nanoid = ae, e.cuid = ne, e.cuid2 = ce, e.ulid = Q, e.xid = N, e.ksuid = B, e.ipv4 = V, e.ipv6 = se, e.cidrv4 = de, e.cidrv6 = he, e.base64 = be, e.base64url = b, e.e164 = y, e.jwt = _, e.stringFormat = R, e.hostname = W, e.number = X, e.int = G, e.float32 = re, e.float64 = oe, e.int32 = fe, e.uint32 = $e, e.boolean = ye, e.bigint = we, e.int64 = je, e.uint64 = Oe, e.symbol = De, e.undefined = Qe, e.null = an, e.any = We, e.unknown = x, e.never = j, e.void = h, e.date = g, e.array = k, e.keyof = S, e.object = z, e.strictObject = E, e.looseObject = q, e.union = L, e.discriminatedUnion = U, e.intersection = Y, e.tuple = ee, e.record = J, e.partialRecord = ke, e.map = me, e.set = _e, e.enum = Pe, e.nativeEnum = Ee, e.literal = Re, e.file = en, e.transform = Le, e.optional = rn, e.nullable = on, e.nullish = Ie, e._default = xe, e.prefault = ln, e.nonoptional = cn, e.success = qe, e.catch = He, e.nan = Nn, e.pipe = Ze, e.readonly = Fe, e.templateLiteral = yn, e.lazy = kn, e.promise = xn, e.check = Ae, e.custom = mn, e.refine = hn, e.superRefine = zn, e.instanceof = Fn, e.json = da, e.preprocess = ua;
    const t = a(tn()), o = tn(), m = a(Pu()), p = a(Lt()), s = a(ju());
    e.ZodType = t.$constructor("ZodType", (c, M) => (t.$ZodType.init(c, M), c.def = M, Object.defineProperty(c, "_def", { value: M }), c.check = (...T) => c.clone(
      {
        ...M,
        checks: [
          ...M.checks ?? [],
          ...T.map((Z) => typeof Z == "function" ? { _zod: { check: Z, def: { check: "custom" }, onattach: [] } } : Z)
        ]
      }
      // { parent: true }
    ), c.clone = (T, Z) => t.clone(c, T, Z), c.brand = () => c, c.register = (T, Z) => (T.add(c, Z), c), c.parse = (T, Z) => s.parse(c, T, Z, { callee: c.parse }), c.safeParse = (T, Z) => s.safeParse(c, T, Z), c.parseAsync = async (T, Z) => s.parseAsync(c, T, Z, { callee: c.parseAsync }), c.safeParseAsync = async (T, Z) => s.safeParseAsync(c, T, Z), c.spa = c.safeParseAsync, c.refine = (T, Z) => c.check(hn(T, Z)), c.superRefine = (T) => c.check(zn(T)), c.overwrite = (T) => c.check(m.overwrite(T)), c.optional = () => rn(c), c.nullable = () => on(c), c.nullish = () => rn(on(c)), c.nonoptional = (T) => cn(c, T), c.array = () => k(c), c.or = (T) => L([c, T]), c.and = (T) => Y(c, T), c.transform = (T) => Ze(c, Le(T)), c.default = (T) => xe(c, T), c.prefault = (T) => ln(c, T), c.catch = (T) => He(c, T), c.pipe = (T) => Ze(c, T), c.readonly = () => Fe(c), c.describe = (T) => {
      const Z = c.clone();
      return t.globalRegistry.add(Z, { description: T }), Z;
    }, Object.defineProperty(c, "description", {
      get() {
        var T;
        return (T = t.globalRegistry.get(c)) == null ? void 0 : T.description;
      },
      configurable: !0
    }), c.meta = (...T) => {
      if (T.length === 0)
        return t.globalRegistry.get(c);
      const Z = c.clone();
      return t.globalRegistry.add(Z, T[0]), Z;
    }, c.isOptional = () => c.safeParse(void 0).success, c.isNullable = () => c.safeParse(null).success, c)), e._ZodString = t.$constructor("_ZodString", (c, M) => {
      t.$ZodString.init(c, M), e.ZodType.init(c, M);
      const T = c._zod.bag;
      c.format = T.format ?? null, c.minLength = T.minimum ?? null, c.maxLength = T.maximum ?? null, c.regex = (...Z) => c.check(m.regex(...Z)), c.includes = (...Z) => c.check(m.includes(...Z)), c.startsWith = (...Z) => c.check(m.startsWith(...Z)), c.endsWith = (...Z) => c.check(m.endsWith(...Z)), c.min = (...Z) => c.check(m.minLength(...Z)), c.max = (...Z) => c.check(m.maxLength(...Z)), c.length = (...Z) => c.check(m.length(...Z)), c.nonempty = (...Z) => c.check(m.minLength(1, ...Z)), c.lowercase = (Z) => c.check(m.lowercase(Z)), c.uppercase = (Z) => c.check(m.uppercase(Z)), c.trim = () => c.check(m.trim()), c.normalize = (...Z) => c.check(m.normalize(...Z)), c.toLowerCase = () => c.check(m.toLowerCase()), c.toUpperCase = () => c.check(m.toUpperCase());
    }), e.ZodString = t.$constructor("ZodString", (c, M) => {
      t.$ZodString.init(c, M), e._ZodString.init(c, M), c.email = (T) => c.check(t._email(e.ZodEmail, T)), c.url = (T) => c.check(t._url(e.ZodURL, T)), c.jwt = (T) => c.check(t._jwt(e.ZodJWT, T)), c.emoji = (T) => c.check(t._emoji(e.ZodEmoji, T)), c.guid = (T) => c.check(t._guid(e.ZodGUID, T)), c.uuid = (T) => c.check(t._uuid(e.ZodUUID, T)), c.uuidv4 = (T) => c.check(t._uuidv4(e.ZodUUID, T)), c.uuidv6 = (T) => c.check(t._uuidv6(e.ZodUUID, T)), c.uuidv7 = (T) => c.check(t._uuidv7(e.ZodUUID, T)), c.nanoid = (T) => c.check(t._nanoid(e.ZodNanoID, T)), c.guid = (T) => c.check(t._guid(e.ZodGUID, T)), c.cuid = (T) => c.check(t._cuid(e.ZodCUID, T)), c.cuid2 = (T) => c.check(t._cuid2(e.ZodCUID2, T)), c.ulid = (T) => c.check(t._ulid(e.ZodULID, T)), c.base64 = (T) => c.check(t._base64(e.ZodBase64, T)), c.base64url = (T) => c.check(t._base64url(e.ZodBase64URL, T)), c.xid = (T) => c.check(t._xid(e.ZodXID, T)), c.ksuid = (T) => c.check(t._ksuid(e.ZodKSUID, T)), c.ipv4 = (T) => c.check(t._ipv4(e.ZodIPv4, T)), c.ipv6 = (T) => c.check(t._ipv6(e.ZodIPv6, T)), c.cidrv4 = (T) => c.check(t._cidrv4(e.ZodCIDRv4, T)), c.cidrv6 = (T) => c.check(t._cidrv6(e.ZodCIDRv6, T)), c.e164 = (T) => c.check(t._e164(e.ZodE164, T)), c.datetime = (T) => c.check(p.datetime(T)), c.date = (T) => c.check(p.date(T)), c.time = (T) => c.check(p.time(T)), c.duration = (T) => c.check(p.duration(T));
    });
    function r(c) {
      return t._string(e.ZodString, c);
    }
    e.ZodStringFormat = t.$constructor("ZodStringFormat", (c, M) => {
      t.$ZodStringFormat.init(c, M), e._ZodString.init(c, M);
    }), e.ZodEmail = t.$constructor("ZodEmail", (c, M) => {
      t.$ZodEmail.init(c, M), e.ZodStringFormat.init(c, M);
    });
    function u(c) {
      return t._email(e.ZodEmail, c);
    }
    e.ZodGUID = t.$constructor("ZodGUID", (c, M) => {
      t.$ZodGUID.init(c, M), e.ZodStringFormat.init(c, M);
    });
    function l(c) {
      return t._guid(e.ZodGUID, c);
    }
    e.ZodUUID = t.$constructor("ZodUUID", (c, M) => {
      t.$ZodUUID.init(c, M), e.ZodStringFormat.init(c, M);
    });
    function n(c) {
      return t._uuid(e.ZodUUID, c);
    }
    function f(c) {
      return t._uuidv4(e.ZodUUID, c);
    }
    function v(c) {
      return t._uuidv6(e.ZodUUID, c);
    }
    function D(c) {
      return t._uuidv7(e.ZodUUID, c);
    }
    e.ZodURL = t.$constructor("ZodURL", (c, M) => {
      t.$ZodURL.init(c, M), e.ZodStringFormat.init(c, M);
    });
    function F(c) {
      return t._url(e.ZodURL, c);
    }
    e.ZodEmoji = t.$constructor("ZodEmoji", (c, M) => {
      t.$ZodEmoji.init(c, M), e.ZodStringFormat.init(c, M);
    });
    function A(c) {
      return t._emoji(e.ZodEmoji, c);
    }
    e.ZodNanoID = t.$constructor("ZodNanoID", (c, M) => {
      t.$ZodNanoID.init(c, M), e.ZodStringFormat.init(c, M);
    });
    function ae(c) {
      return t._nanoid(e.ZodNanoID, c);
    }
    e.ZodCUID = t.$constructor("ZodCUID", (c, M) => {
      t.$ZodCUID.init(c, M), e.ZodStringFormat.init(c, M);
    });
    function ne(c) {
      return t._cuid(e.ZodCUID, c);
    }
    e.ZodCUID2 = t.$constructor("ZodCUID2", (c, M) => {
      t.$ZodCUID2.init(c, M), e.ZodStringFormat.init(c, M);
    });
    function ce(c) {
      return t._cuid2(e.ZodCUID2, c);
    }
    e.ZodULID = t.$constructor("ZodULID", (c, M) => {
      t.$ZodULID.init(c, M), e.ZodStringFormat.init(c, M);
    });
    function Q(c) {
      return t._ulid(e.ZodULID, c);
    }
    e.ZodXID = t.$constructor("ZodXID", (c, M) => {
      t.$ZodXID.init(c, M), e.ZodStringFormat.init(c, M);
    });
    function N(c) {
      return t._xid(e.ZodXID, c);
    }
    e.ZodKSUID = t.$constructor("ZodKSUID", (c, M) => {
      t.$ZodKSUID.init(c, M), e.ZodStringFormat.init(c, M);
    });
    function B(c) {
      return t._ksuid(e.ZodKSUID, c);
    }
    e.ZodIPv4 = t.$constructor("ZodIPv4", (c, M) => {
      t.$ZodIPv4.init(c, M), e.ZodStringFormat.init(c, M);
    });
    function V(c) {
      return t._ipv4(e.ZodIPv4, c);
    }
    e.ZodIPv6 = t.$constructor("ZodIPv6", (c, M) => {
      t.$ZodIPv6.init(c, M), e.ZodStringFormat.init(c, M);
    });
    function se(c) {
      return t._ipv6(e.ZodIPv6, c);
    }
    e.ZodCIDRv4 = t.$constructor("ZodCIDRv4", (c, M) => {
      t.$ZodCIDRv4.init(c, M), e.ZodStringFormat.init(c, M);
    });
    function de(c) {
      return t._cidrv4(e.ZodCIDRv4, c);
    }
    e.ZodCIDRv6 = t.$constructor("ZodCIDRv6", (c, M) => {
      t.$ZodCIDRv6.init(c, M), e.ZodStringFormat.init(c, M);
    });
    function he(c) {
      return t._cidrv6(e.ZodCIDRv6, c);
    }
    e.ZodBase64 = t.$constructor("ZodBase64", (c, M) => {
      t.$ZodBase64.init(c, M), e.ZodStringFormat.init(c, M);
    });
    function be(c) {
      return t._base64(e.ZodBase64, c);
    }
    e.ZodBase64URL = t.$constructor("ZodBase64URL", (c, M) => {
      t.$ZodBase64URL.init(c, M), e.ZodStringFormat.init(c, M);
    });
    function b(c) {
      return t._base64url(e.ZodBase64URL, c);
    }
    e.ZodE164 = t.$constructor("ZodE164", (c, M) => {
      t.$ZodE164.init(c, M), e.ZodStringFormat.init(c, M);
    });
    function y(c) {
      return t._e164(e.ZodE164, c);
    }
    e.ZodJWT = t.$constructor("ZodJWT", (c, M) => {
      t.$ZodJWT.init(c, M), e.ZodStringFormat.init(c, M);
    });
    function _(c) {
      return t._jwt(e.ZodJWT, c);
    }
    e.ZodCustomStringFormat = t.$constructor("ZodCustomStringFormat", (c, M) => {
      t.$ZodCustomStringFormat.init(c, M), e.ZodStringFormat.init(c, M);
    });
    function R(c, M, T = {}) {
      return t._stringFormat(e.ZodCustomStringFormat, c, M, T);
    }
    function W(c) {
      return t._stringFormat(e.ZodCustomStringFormat, "hostname", t.regexes.hostname, c);
    }
    e.ZodNumber = t.$constructor("ZodNumber", (c, M) => {
      t.$ZodNumber.init(c, M), e.ZodType.init(c, M), c.gt = (Z, ve) => c.check(m.gt(Z, ve)), c.gte = (Z, ve) => c.check(m.gte(Z, ve)), c.min = (Z, ve) => c.check(m.gte(Z, ve)), c.lt = (Z, ve) => c.check(m.lt(Z, ve)), c.lte = (Z, ve) => c.check(m.lte(Z, ve)), c.max = (Z, ve) => c.check(m.lte(Z, ve)), c.int = (Z) => c.check(G(Z)), c.safe = (Z) => c.check(G(Z)), c.positive = (Z) => c.check(m.gt(0, Z)), c.nonnegative = (Z) => c.check(m.gte(0, Z)), c.negative = (Z) => c.check(m.lt(0, Z)), c.nonpositive = (Z) => c.check(m.lte(0, Z)), c.multipleOf = (Z, ve) => c.check(m.multipleOf(Z, ve)), c.step = (Z, ve) => c.check(m.multipleOf(Z, ve)), c.finite = () => c;
      const T = c._zod.bag;
      c.minValue = Math.max(T.minimum ?? Number.NEGATIVE_INFINITY, T.exclusiveMinimum ?? Number.NEGATIVE_INFINITY) ?? null, c.maxValue = Math.min(T.maximum ?? Number.POSITIVE_INFINITY, T.exclusiveMaximum ?? Number.POSITIVE_INFINITY) ?? null, c.isInt = (T.format ?? "").includes("int") || Number.isSafeInteger(T.multipleOf ?? 0.5), c.isFinite = !0, c.format = T.format ?? null;
    });
    function X(c) {
      return t._number(e.ZodNumber, c);
    }
    e.ZodNumberFormat = t.$constructor("ZodNumberFormat", (c, M) => {
      t.$ZodNumberFormat.init(c, M), e.ZodNumber.init(c, M);
    });
    function G(c) {
      return t._int(e.ZodNumberFormat, c);
    }
    function re(c) {
      return t._float32(e.ZodNumberFormat, c);
    }
    function oe(c) {
      return t._float64(e.ZodNumberFormat, c);
    }
    function fe(c) {
      return t._int32(e.ZodNumberFormat, c);
    }
    function $e(c) {
      return t._uint32(e.ZodNumberFormat, c);
    }
    e.ZodBoolean = t.$constructor("ZodBoolean", (c, M) => {
      t.$ZodBoolean.init(c, M), e.ZodType.init(c, M);
    });
    function ye(c) {
      return t._boolean(e.ZodBoolean, c);
    }
    e.ZodBigInt = t.$constructor("ZodBigInt", (c, M) => {
      t.$ZodBigInt.init(c, M), e.ZodType.init(c, M), c.gte = (Z, ve) => c.check(m.gte(Z, ve)), c.min = (Z, ve) => c.check(m.gte(Z, ve)), c.gt = (Z, ve) => c.check(m.gt(Z, ve)), c.gte = (Z, ve) => c.check(m.gte(Z, ve)), c.min = (Z, ve) => c.check(m.gte(Z, ve)), c.lt = (Z, ve) => c.check(m.lt(Z, ve)), c.lte = (Z, ve) => c.check(m.lte(Z, ve)), c.max = (Z, ve) => c.check(m.lte(Z, ve)), c.positive = (Z) => c.check(m.gt(BigInt(0), Z)), c.negative = (Z) => c.check(m.lt(BigInt(0), Z)), c.nonpositive = (Z) => c.check(m.lte(BigInt(0), Z)), c.nonnegative = (Z) => c.check(m.gte(BigInt(0), Z)), c.multipleOf = (Z, ve) => c.check(m.multipleOf(Z, ve));
      const T = c._zod.bag;
      c.minValue = T.minimum ?? null, c.maxValue = T.maximum ?? null, c.format = T.format ?? null;
    });
    function we(c) {
      return t._bigint(e.ZodBigInt, c);
    }
    e.ZodBigIntFormat = t.$constructor("ZodBigIntFormat", (c, M) => {
      t.$ZodBigIntFormat.init(c, M), e.ZodBigInt.init(c, M);
    });
    function je(c) {
      return t._int64(e.ZodBigIntFormat, c);
    }
    function Oe(c) {
      return t._uint64(e.ZodBigIntFormat, c);
    }
    e.ZodSymbol = t.$constructor("ZodSymbol", (c, M) => {
      t.$ZodSymbol.init(c, M), e.ZodType.init(c, M);
    });
    function De(c) {
      return t._symbol(e.ZodSymbol, c);
    }
    e.ZodUndefined = t.$constructor("ZodUndefined", (c, M) => {
      t.$ZodUndefined.init(c, M), e.ZodType.init(c, M);
    });
    function Qe(c) {
      return t._undefined(e.ZodUndefined, c);
    }
    e.ZodNull = t.$constructor("ZodNull", (c, M) => {
      t.$ZodNull.init(c, M), e.ZodType.init(c, M);
    });
    function an(c) {
      return t._null(e.ZodNull, c);
    }
    e.ZodAny = t.$constructor("ZodAny", (c, M) => {
      t.$ZodAny.init(c, M), e.ZodType.init(c, M);
    });
    function We() {
      return t._any(e.ZodAny);
    }
    e.ZodUnknown = t.$constructor("ZodUnknown", (c, M) => {
      t.$ZodUnknown.init(c, M), e.ZodType.init(c, M);
    });
    function x() {
      return t._unknown(e.ZodUnknown);
    }
    e.ZodNever = t.$constructor("ZodNever", (c, M) => {
      t.$ZodNever.init(c, M), e.ZodType.init(c, M);
    });
    function j(c) {
      return t._never(e.ZodNever, c);
    }
    e.ZodVoid = t.$constructor("ZodVoid", (c, M) => {
      t.$ZodVoid.init(c, M), e.ZodType.init(c, M);
    });
    function h(c) {
      return t._void(e.ZodVoid, c);
    }
    e.ZodDate = t.$constructor("ZodDate", (c, M) => {
      t.$ZodDate.init(c, M), e.ZodType.init(c, M), c.min = (Z, ve) => c.check(m.gte(Z, ve)), c.max = (Z, ve) => c.check(m.lte(Z, ve));
      const T = c._zod.bag;
      c.minDate = T.minimum ? new Date(T.minimum) : null, c.maxDate = T.maximum ? new Date(T.maximum) : null;
    });
    function g(c) {
      return t._date(e.ZodDate, c);
    }
    e.ZodArray = t.$constructor("ZodArray", (c, M) => {
      t.$ZodArray.init(c, M), e.ZodType.init(c, M), c.element = M.element, c.min = (T, Z) => c.check(m.minLength(T, Z)), c.nonempty = (T) => c.check(m.minLength(1, T)), c.max = (T, Z) => c.check(m.maxLength(T, Z)), c.length = (T, Z) => c.check(m.length(T, Z)), c.unwrap = () => c.element;
    });
    function k(c, M) {
      return t._array(e.ZodArray, c, M);
    }
    function S(c) {
      const M = c._zod.def.shape;
      return Pe(Object.keys(M));
    }
    e.ZodObject = t.$constructor("ZodObject", (c, M) => {
      t.$ZodObject.init(c, M), e.ZodType.init(c, M), o.util.defineLazy(c, "shape", () => M.shape), c.keyof = () => Pe(Object.keys(c._zod.def.shape)), c.catchall = (T) => c.clone({ ...c._zod.def, catchall: T }), c.passthrough = () => c.clone({ ...c._zod.def, catchall: x() }), c.loose = () => c.clone({ ...c._zod.def, catchall: x() }), c.strict = () => c.clone({ ...c._zod.def, catchall: j() }), c.strip = () => c.clone({ ...c._zod.def, catchall: void 0 }), c.extend = (T) => o.util.extend(c, T), c.merge = (T) => o.util.merge(c, T), c.pick = (T) => o.util.pick(c, T), c.omit = (T) => o.util.omit(c, T), c.partial = (...T) => o.util.partial(e.ZodOptional, c, T[0]), c.required = (...T) => o.util.required(e.ZodNonOptional, c, T[0]);
    });
    function z(c, M) {
      const T = {
        type: "object",
        get shape() {
          return o.util.assignProp(this, "shape", c ? o.util.objectClone(c) : {}), this.shape;
        },
        ...o.util.normalizeParams(M)
      };
      return new e.ZodObject(T);
    }
    function E(c, M) {
      return new e.ZodObject({
        type: "object",
        get shape() {
          return o.util.assignProp(this, "shape", o.util.objectClone(c)), this.shape;
        },
        catchall: j(),
        ...o.util.normalizeParams(M)
      });
    }
    function q(c, M) {
      return new e.ZodObject({
        type: "object",
        get shape() {
          return o.util.assignProp(this, "shape", o.util.objectClone(c)), this.shape;
        },
        catchall: x(),
        ...o.util.normalizeParams(M)
      });
    }
    e.ZodUnion = t.$constructor("ZodUnion", (c, M) => {
      t.$ZodUnion.init(c, M), e.ZodType.init(c, M), c.options = M.options;
    });
    function L(c, M) {
      return new e.ZodUnion({
        type: "union",
        options: c,
        ...o.util.normalizeParams(M)
      });
    }
    e.ZodDiscriminatedUnion = t.$constructor("ZodDiscriminatedUnion", (c, M) => {
      e.ZodUnion.init(c, M), t.$ZodDiscriminatedUnion.init(c, M);
    });
    function U(c, M, T) {
      return new e.ZodDiscriminatedUnion({
        type: "union",
        options: M,
        discriminator: c,
        ...o.util.normalizeParams(T)
      });
    }
    e.ZodIntersection = t.$constructor("ZodIntersection", (c, M) => {
      t.$ZodIntersection.init(c, M), e.ZodType.init(c, M);
    });
    function Y(c, M) {
      return new e.ZodIntersection({
        type: "intersection",
        left: c,
        right: M
      });
    }
    e.ZodTuple = t.$constructor("ZodTuple", (c, M) => {
      t.$ZodTuple.init(c, M), e.ZodType.init(c, M), c.rest = (T) => c.clone({
        ...c._zod.def,
        rest: T
      });
    });
    function ee(c, M, T) {
      const Z = M instanceof t.$ZodType, ve = Z ? T : M, Be = Z ? M : null;
      return new e.ZodTuple({
        type: "tuple",
        items: c,
        rest: Be,
        ...o.util.normalizeParams(ve)
      });
    }
    e.ZodRecord = t.$constructor("ZodRecord", (c, M) => {
      t.$ZodRecord.init(c, M), e.ZodType.init(c, M), c.keyType = M.keyType, c.valueType = M.valueType;
    });
    function J(c, M, T) {
      return new e.ZodRecord({
        type: "record",
        keyType: c,
        valueType: M,
        ...o.util.normalizeParams(T)
      });
    }
    function ke(c, M, T) {
      const Z = t.clone(c);
      return Z._zod.values = void 0, new e.ZodRecord({
        type: "record",
        keyType: Z,
        valueType: M,
        ...o.util.normalizeParams(T)
      });
    }
    e.ZodMap = t.$constructor("ZodMap", (c, M) => {
      t.$ZodMap.init(c, M), e.ZodType.init(c, M), c.keyType = M.keyType, c.valueType = M.valueType;
    });
    function me(c, M, T) {
      return new e.ZodMap({
        type: "map",
        keyType: c,
        valueType: M,
        ...o.util.normalizeParams(T)
      });
    }
    e.ZodSet = t.$constructor("ZodSet", (c, M) => {
      t.$ZodSet.init(c, M), e.ZodType.init(c, M), c.min = (...T) => c.check(t._minSize(...T)), c.nonempty = (T) => c.check(t._minSize(1, T)), c.max = (...T) => c.check(t._maxSize(...T)), c.size = (...T) => c.check(t._size(...T));
    });
    function _e(c, M) {
      return new e.ZodSet({
        type: "set",
        valueType: c,
        ...o.util.normalizeParams(M)
      });
    }
    e.ZodEnum = t.$constructor("ZodEnum", (c, M) => {
      t.$ZodEnum.init(c, M), e.ZodType.init(c, M), c.enum = M.entries, c.options = Object.values(M.entries);
      const T = new Set(Object.keys(M.entries));
      c.extract = (Z, ve) => {
        const Be = {};
        for (const Te of Z)
          if (T.has(Te))
            Be[Te] = M.entries[Te];
          else
            throw new Error(`Key ${Te} not found in enum`);
        return new e.ZodEnum({
          ...M,
          checks: [],
          ...o.util.normalizeParams(ve),
          entries: Be
        });
      }, c.exclude = (Z, ve) => {
        const Be = { ...M.entries };
        for (const Te of Z)
          if (T.has(Te))
            delete Be[Te];
          else
            throw new Error(`Key ${Te} not found in enum`);
        return new e.ZodEnum({
          ...M,
          checks: [],
          ...o.util.normalizeParams(ve),
          entries: Be
        });
      };
    });
    function Pe(c, M) {
      const T = Array.isArray(c) ? Object.fromEntries(c.map((Z) => [Z, Z])) : c;
      return new e.ZodEnum({
        type: "enum",
        entries: T,
        ...o.util.normalizeParams(M)
      });
    }
    function Ee(c, M) {
      return new e.ZodEnum({
        type: "enum",
        entries: c,
        ...o.util.normalizeParams(M)
      });
    }
    e.ZodLiteral = t.$constructor("ZodLiteral", (c, M) => {
      t.$ZodLiteral.init(c, M), e.ZodType.init(c, M), c.values = new Set(M.values), Object.defineProperty(c, "value", {
        get() {
          if (M.values.length > 1)
            throw new Error("This schema contains multiple valid literal values. Use `.values` instead.");
          return M.values[0];
        }
      });
    });
    function Re(c, M) {
      return new e.ZodLiteral({
        type: "literal",
        values: Array.isArray(c) ? c : [c],
        ...o.util.normalizeParams(M)
      });
    }
    e.ZodFile = t.$constructor("ZodFile", (c, M) => {
      t.$ZodFile.init(c, M), e.ZodType.init(c, M), c.min = (T, Z) => c.check(t._minSize(T, Z)), c.max = (T, Z) => c.check(t._maxSize(T, Z)), c.mime = (T, Z) => c.check(t._mime(Array.isArray(T) ? T : [T], Z));
    });
    function en(c) {
      return t._file(e.ZodFile, c);
    }
    e.ZodTransform = t.$constructor("ZodTransform", (c, M) => {
      t.$ZodTransform.init(c, M), e.ZodType.init(c, M), c._zod.parse = (T, Z) => {
        T.addIssue = (Be) => {
          if (typeof Be == "string")
            T.issues.push(o.util.issue(Be, T.value, M));
          else {
            const Te = Be;
            Te.fatal && (Te.continue = !1), Te.code ?? (Te.code = "custom"), Te.input ?? (Te.input = T.value), Te.inst ?? (Te.inst = c), T.issues.push(o.util.issue(Te));
          }
        };
        const ve = M.transform(T.value, T);
        return ve instanceof Promise ? ve.then((Be) => (T.value = Be, T)) : (T.value = ve, T);
      };
    });
    function Le(c) {
      return new e.ZodTransform({
        type: "transform",
        transform: c
      });
    }
    e.ZodOptional = t.$constructor("ZodOptional", (c, M) => {
      t.$ZodOptional.init(c, M), e.ZodType.init(c, M), c.unwrap = () => c._zod.def.innerType;
    });
    function rn(c) {
      return new e.ZodOptional({
        type: "optional",
        innerType: c
      });
    }
    e.ZodNullable = t.$constructor("ZodNullable", (c, M) => {
      t.$ZodNullable.init(c, M), e.ZodType.init(c, M), c.unwrap = () => c._zod.def.innerType;
    });
    function on(c) {
      return new e.ZodNullable({
        type: "nullable",
        innerType: c
      });
    }
    function Ie(c) {
      return rn(on(c));
    }
    e.ZodDefault = t.$constructor("ZodDefault", (c, M) => {
      t.$ZodDefault.init(c, M), e.ZodType.init(c, M), c.unwrap = () => c._zod.def.innerType, c.removeDefault = c.unwrap;
    });
    function xe(c, M) {
      return new e.ZodDefault({
        type: "default",
        innerType: c,
        get defaultValue() {
          return typeof M == "function" ? M() : o.util.shallowClone(M);
        }
      });
    }
    e.ZodPrefault = t.$constructor("ZodPrefault", (c, M) => {
      t.$ZodPrefault.init(c, M), e.ZodType.init(c, M), c.unwrap = () => c._zod.def.innerType;
    });
    function ln(c, M) {
      return new e.ZodPrefault({
        type: "prefault",
        innerType: c,
        get defaultValue() {
          return typeof M == "function" ? M() : o.util.shallowClone(M);
        }
      });
    }
    e.ZodNonOptional = t.$constructor("ZodNonOptional", (c, M) => {
      t.$ZodNonOptional.init(c, M), e.ZodType.init(c, M), c.unwrap = () => c._zod.def.innerType;
    });
    function cn(c, M) {
      return new e.ZodNonOptional({
        type: "nonoptional",
        innerType: c,
        ...o.util.normalizeParams(M)
      });
    }
    e.ZodSuccess = t.$constructor("ZodSuccess", (c, M) => {
      t.$ZodSuccess.init(c, M), e.ZodType.init(c, M), c.unwrap = () => c._zod.def.innerType;
    });
    function qe(c) {
      return new e.ZodSuccess({
        type: "success",
        innerType: c
      });
    }
    e.ZodCatch = t.$constructor("ZodCatch", (c, M) => {
      t.$ZodCatch.init(c, M), e.ZodType.init(c, M), c.unwrap = () => c._zod.def.innerType, c.removeCatch = c.unwrap;
    });
    function He(c, M) {
      return new e.ZodCatch({
        type: "catch",
        innerType: c,
        catchValue: typeof M == "function" ? M : () => M
      });
    }
    e.ZodNaN = t.$constructor("ZodNaN", (c, M) => {
      t.$ZodNaN.init(c, M), e.ZodType.init(c, M);
    });
    function Nn(c) {
      return t._nan(e.ZodNaN, c);
    }
    e.ZodPipe = t.$constructor("ZodPipe", (c, M) => {
      t.$ZodPipe.init(c, M), e.ZodType.init(c, M), c.in = M.in, c.out = M.out;
    });
    function Ze(c, M) {
      return new e.ZodPipe({
        type: "pipe",
        in: c,
        out: M
        // ...util.normalizeParams(params),
      });
    }
    e.ZodReadonly = t.$constructor("ZodReadonly", (c, M) => {
      t.$ZodReadonly.init(c, M), e.ZodType.init(c, M), c.unwrap = () => c._zod.def.innerType;
    });
    function Fe(c) {
      return new e.ZodReadonly({
        type: "readonly",
        innerType: c
      });
    }
    e.ZodTemplateLiteral = t.$constructor("ZodTemplateLiteral", (c, M) => {
      t.$ZodTemplateLiteral.init(c, M), e.ZodType.init(c, M);
    });
    function yn(c, M) {
      return new e.ZodTemplateLiteral({
        type: "template_literal",
        parts: c,
        ...o.util.normalizeParams(M)
      });
    }
    e.ZodLazy = t.$constructor("ZodLazy", (c, M) => {
      t.$ZodLazy.init(c, M), e.ZodType.init(c, M), c.unwrap = () => c._zod.def.getter();
    });
    function kn(c) {
      return new e.ZodLazy({
        type: "lazy",
        getter: c
      });
    }
    e.ZodPromise = t.$constructor("ZodPromise", (c, M) => {
      t.$ZodPromise.init(c, M), e.ZodType.init(c, M), c.unwrap = () => c._zod.def.innerType;
    });
    function xn(c) {
      return new e.ZodPromise({
        type: "promise",
        innerType: c
      });
    }
    e.ZodCustom = t.$constructor("ZodCustom", (c, M) => {
      t.$ZodCustom.init(c, M), e.ZodType.init(c, M);
    });
    function Ae(c) {
      const M = new t.$ZodCheck({
        check: "custom"
        // ...util.normalizeParams(params),
      });
      return M._zod.check = c, M;
    }
    function mn(c, M) {
      return t._custom(e.ZodCustom, c ?? (() => !0), M);
    }
    function hn(c, M = {}) {
      return t._refine(e.ZodCustom, c, M);
    }
    function zn(c) {
      return t._superRefine(c);
    }
    function Fn(c, M = {
      error: `Input not instance of ${c.name}`
    }) {
      const T = new e.ZodCustom({
        type: "custom",
        check: "custom",
        fn: (Z) => Z instanceof c,
        abort: !0,
        ...o.util.normalizeParams(M)
      });
      return T._zod.bag.Class = c, T;
    }
    const sa = (...c) => t._stringbool({
      Pipe: e.ZodPipe,
      Boolean: e.ZodBoolean,
      String: e.ZodString,
      Transform: e.ZodTransform
    }, ...c);
    e.stringbool = sa;
    function da(c) {
      const M = kn(() => L([r(c), X(), ye(), an(), k(M), J(r(), M)]));
      return M;
    }
    function ua(c, M) {
      return Ze(Le(c), M);
    }
  }(_t)), _t;
}
var Mt = {}, Zs;
function dv() {
  return Zs || (Zs = 1, function(e) {
    var i = w && w.__createBinding || (Object.create ? function(r, u, l, n) {
      n === void 0 && (n = l);
      var f = Object.getOwnPropertyDescriptor(u, l);
      (!f || ("get" in f ? !u.__esModule : f.writable || f.configurable)) && (f = { enumerable: !0, get: function() {
        return u[l];
      } }), Object.defineProperty(r, n, f);
    } : function(r, u, l, n) {
      n === void 0 && (n = l), r[n] = u[l];
    }), d = w && w.__setModuleDefault || (Object.create ? function(r, u) {
      Object.defineProperty(r, "default", { enumerable: !0, value: u });
    } : function(r, u) {
      r.default = u;
    }), a = w && w.__importStar || function(r) {
      if (r && r.__esModule) return r;
      var u = {};
      if (r != null) for (var l in r) l !== "default" && Object.prototype.hasOwnProperty.call(r, l) && i(u, r, l);
      return d(u, r), u;
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), e.ZodFirstPartyTypeKind = e.config = e.$brand = e.ZodIssueCode = void 0, e.setErrorMap = m, e.getErrorMap = p;
    const t = a(tn());
    e.ZodIssueCode = {
      invalid_type: "invalid_type",
      too_big: "too_big",
      too_small: "too_small",
      invalid_format: "invalid_format",
      not_multiple_of: "not_multiple_of",
      unrecognized_keys: "unrecognized_keys",
      invalid_union: "invalid_union",
      invalid_key: "invalid_key",
      invalid_element: "invalid_element",
      invalid_value: "invalid_value",
      custom: "custom"
    };
    var o = tn();
    Object.defineProperty(e, "$brand", { enumerable: !0, get: function() {
      return o.$brand;
    } }), Object.defineProperty(e, "config", { enumerable: !0, get: function() {
      return o.config;
    } });
    function m(r) {
      t.config({
        customError: r
      });
    }
    function p() {
      return t.config().customError;
    }
    var s;
    s || (e.ZodFirstPartyTypeKind = s = {});
  }(Mt)), Mt;
}
var Pn = {}, As;
function uv() {
  if (As) return Pn;
  As = 1;
  var e = w && w.__createBinding || (Object.create ? function(u, l, n, f) {
    f === void 0 && (f = n);
    var v = Object.getOwnPropertyDescriptor(l, n);
    (!v || ("get" in v ? !l.__esModule : v.writable || v.configurable)) && (v = { enumerable: !0, get: function() {
      return l[n];
    } }), Object.defineProperty(u, f, v);
  } : function(u, l, n, f) {
    f === void 0 && (f = n), u[f] = l[n];
  }), i = w && w.__setModuleDefault || (Object.create ? function(u, l) {
    Object.defineProperty(u, "default", { enumerable: !0, value: l });
  } : function(u, l) {
    u.default = l;
  }), d = w && w.__importStar || function(u) {
    if (u && u.__esModule) return u;
    var l = {};
    if (u != null) for (var n in u) n !== "default" && Object.prototype.hasOwnProperty.call(u, n) && e(l, u, n);
    return i(l, u), l;
  };
  Object.defineProperty(Pn, "__esModule", { value: !0 }), Pn.string = o, Pn.number = m, Pn.boolean = p, Pn.bigint = s, Pn.date = r;
  const a = d(tn()), t = d(er());
  function o(u) {
    return a._coercedString(t.ZodString, u);
  }
  function m(u) {
    return a._coercedNumber(t.ZodNumber, u);
  }
  function p(u) {
    return a._coercedBoolean(t.ZodBoolean, u);
  }
  function s(u) {
    return a._coercedBigint(t.ZodBigInt, u);
  }
  function r(u) {
    return a._coercedDate(t.ZodDate, u);
  }
  return Pn;
}
var Vs;
function Hs() {
  return Vs || (Vs = 1, function(e) {
    var i = w && w.__createBinding || (Object.create ? function(u, l, n, f) {
      f === void 0 && (f = n);
      var v = Object.getOwnPropertyDescriptor(l, n);
      (!v || ("get" in v ? !l.__esModule : v.writable || v.configurable)) && (v = { enumerable: !0, get: function() {
        return l[n];
      } }), Object.defineProperty(u, f, v);
    } : function(u, l, n, f) {
      f === void 0 && (f = n), u[f] = l[n];
    }), d = w && w.__setModuleDefault || (Object.create ? function(u, l) {
      Object.defineProperty(u, "default", { enumerable: !0, value: l });
    } : function(u, l) {
      u.default = l;
    }), a = w && w.__importStar || function(u) {
      if (u && u.__esModule) return u;
      var l = {};
      if (u != null) for (var n in u) n !== "default" && Object.prototype.hasOwnProperty.call(u, n) && i(l, u, n);
      return d(l, u), l;
    }, t = w && w.__exportStar || function(u, l) {
      for (var n in u) n !== "default" && !Object.prototype.hasOwnProperty.call(l, n) && i(l, u, n);
    }, o = w && w.__importDefault || function(u) {
      return u && u.__esModule ? u : { default: u };
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), e.coerce = e.iso = e.ZodISODuration = e.ZodISOTime = e.ZodISODate = e.ZodISODateTime = e.locales = e.NEVER = e.TimePrecision = e.toJSONSchema = e.flattenError = e.formatError = e.prettifyError = e.treeifyError = e.regexes = e.clone = e.$brand = e.$input = e.$output = e.function = e.config = e.registry = e.globalRegistry = e.core = void 0, e.core = a(tn()), t(er(), e), t(Pu(), e), t(Mu(), e), t(ju(), e), t(dv(), e);
    const m = tn(), p = o(ku());
    (0, m.config)((0, p.default)());
    var s = tn();
    Object.defineProperty(e, "globalRegistry", { enumerable: !0, get: function() {
      return s.globalRegistry;
    } }), Object.defineProperty(e, "registry", { enumerable: !0, get: function() {
      return s.registry;
    } }), Object.defineProperty(e, "config", { enumerable: !0, get: function() {
      return s.config;
    } }), Object.defineProperty(e, "function", { enumerable: !0, get: function() {
      return s.function;
    } }), Object.defineProperty(e, "$output", { enumerable: !0, get: function() {
      return s.$output;
    } }), Object.defineProperty(e, "$input", { enumerable: !0, get: function() {
      return s.$input;
    } }), Object.defineProperty(e, "$brand", { enumerable: !0, get: function() {
      return s.$brand;
    } }), Object.defineProperty(e, "clone", { enumerable: !0, get: function() {
      return s.clone;
    } }), Object.defineProperty(e, "regexes", { enumerable: !0, get: function() {
      return s.regexes;
    } }), Object.defineProperty(e, "treeifyError", { enumerable: !0, get: function() {
      return s.treeifyError;
    } }), Object.defineProperty(e, "prettifyError", { enumerable: !0, get: function() {
      return s.prettifyError;
    } }), Object.defineProperty(e, "formatError", { enumerable: !0, get: function() {
      return s.formatError;
    } }), Object.defineProperty(e, "flattenError", { enumerable: !0, get: function() {
      return s.flattenError;
    } }), Object.defineProperty(e, "toJSONSchema", { enumerable: !0, get: function() {
      return s.toJSONSchema;
    } }), Object.defineProperty(e, "TimePrecision", { enumerable: !0, get: function() {
      return s.TimePrecision;
    } }), Object.defineProperty(e, "NEVER", { enumerable: !0, get: function() {
      return s.NEVER;
    } }), e.locales = a(wu());
    var r = Lt();
    Object.defineProperty(e, "ZodISODateTime", { enumerable: !0, get: function() {
      return r.ZodISODateTime;
    } }), Object.defineProperty(e, "ZodISODate", { enumerable: !0, get: function() {
      return r.ZodISODate;
    } }), Object.defineProperty(e, "ZodISOTime", { enumerable: !0, get: function() {
      return r.ZodISOTime;
    } }), Object.defineProperty(e, "ZodISODuration", { enumerable: !0, get: function() {
      return r.ZodISODuration;
    } }), e.iso = a(Lt()), e.coerce = a(uv());
  }(ut)), ut;
}
var Us;
function fv() {
  return Us || (Us = 1, function(e) {
    var i = w && w.__createBinding || (Object.create ? function(m, p, s, r) {
      r === void 0 && (r = s);
      var u = Object.getOwnPropertyDescriptor(p, s);
      (!u || ("get" in u ? !p.__esModule : u.writable || u.configurable)) && (u = { enumerable: !0, get: function() {
        return p[s];
      } }), Object.defineProperty(m, r, u);
    } : function(m, p, s, r) {
      r === void 0 && (r = s), m[r] = p[s];
    }), d = w && w.__setModuleDefault || (Object.create ? function(m, p) {
      Object.defineProperty(m, "default", { enumerable: !0, value: p });
    } : function(m, p) {
      m.default = p;
    }), a = w && w.__importStar || function(m) {
      if (m && m.__esModule) return m;
      var p = {};
      if (m != null) for (var s in m) s !== "default" && Object.prototype.hasOwnProperty.call(m, s) && i(p, m, s);
      return d(p, m), p;
    }, t = w && w.__exportStar || function(m, p) {
      for (var s in m) s !== "default" && !Object.prototype.hasOwnProperty.call(p, s) && i(p, m, s);
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), e.z = void 0;
    const o = a(Hs());
    e.z = o, t(Hs(), e), e.default = o;
  }(dt)), dt;
}
var Bs;
function lv() {
  return Bs || (Bs = 1, function(e) {
    var i = Ce;
    i(e, "__esModule", {
      value: !0
    }), e.structuredResourceSchema = e.structuredResourceEntrySingularSchema = e.structuredResourceEntrySchema = e.structuredResourceEntryPluralSchema = void 0;
    var d = fv();
    const a = d.z.object({
      notes: d.z.string().optional().describe("Additional information for translators"),
      context: d.z.string().optional().describe("Context for translators, e.g. male/female; see https://lokalise.com/blog/the-3-pillars-of-context-that-will-improve-your-translations"),
      limit: d.z.number().optional().describe("Character limit"),
      tags: d.z.array(d.z.string()).optional().describe("See https://docs.lokalise.com/en/articles/1475552-tags")
    }), t = e.structuredResourceEntrySingularSchema = a.extend({
      translation: d.z.string().describe("Singular translation")
    }), o = e.structuredResourceEntryPluralSchema = a.extend({
      translation: d.z.object({
        one: d.z.string(),
        other: d.z.string()
      }).describe("Plural translation")
    }), m = e.structuredResourceEntrySchema = d.z.union([t, o]);
    e.structuredResourceSchema = d.z.record(d.z.string(), m);
  }(st)), st;
}
var Xs;
function cv() {
  return Xs || (Xs = 1, function(e) {
    var i, d = Ce, a = Vt, t = Ht;
    d(e, "__esModule", {
      value: !0
    });
    var o = lv();
    a(i = t(o)).call(i, function(m) {
      m === "default" || m === "__esModule" || m in e && e[m] === o[m] || d(e, m, {
        enumerable: !0,
        get: function() {
          return o[m];
        }
      });
    });
  }(ot)), ot;
}
var jt = {}, St = {}, mv = {
  lessThanXSeconds: {
    one: "minder as 'n sekonde",
    other: "minder as {{count}} sekondes"
  },
  xSeconds: {
    one: "1 sekonde",
    other: "{{count}} sekondes"
  },
  halfAMinute: "'n halwe minuut",
  lessThanXMinutes: {
    one: "minder as 'n minuut",
    other: "minder as {{count}} minute"
  },
  xMinutes: {
    one: "'n minuut",
    other: "{{count}} minute"
  },
  aboutXHours: {
    one: "ongeveer 1 uur",
    other: "ongeveer {{count}} ure"
  },
  xHours: {
    one: "1 uur",
    other: "{{count}} ure"
  },
  xDays: {
    one: "1 dag",
    other: "{{count}} dae"
  },
  aboutXWeeks: {
    one: "ongeveer 1 week",
    other: "ongeveer {{count}} weke"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weke"
  },
  aboutXMonths: {
    one: "ongeveer 1 maand",
    other: "ongeveer {{count}} maande"
  },
  xMonths: {
    one: "1 maand",
    other: "{{count}} maande"
  },
  aboutXYears: {
    one: "ongeveer 1 jaar",
    other: "ongeveer {{count}} jaar"
  },
  xYears: {
    one: "1 jaar",
    other: "{{count}} jaar"
  },
  overXYears: {
    one: "meer as 1 jaar",
    other: "meer as {{count}} jaar"
  },
  almostXYears: {
    one: "byna 1 jaar",
    other: "byna {{count}} jaar"
  }
}, vv = function(i, d, a) {
  var t, o = mv[i];
  return typeof o == "string" ? t = o : d === 1 ? t = o.one : t = o.other.replace("{{count}}", String(d)), a != null && a.addSuffix ? a.comparison && a.comparison > 0 ? "oor " + t : t + " gelede" : t;
}, hv = {
  full: "EEEE, d MMMM yyyy",
  long: "d MMMM yyyy",
  medium: "d MMM yyyy",
  short: "yyyy/MM/dd"
}, gv = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, pv = {
  full: "{{date}} 'om' {{time}}",
  long: "{{date}} 'om' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, bv = {
  date: I({
    formats: hv,
    defaultWidth: "full"
  }),
  time: I({
    formats: gv,
    defaultWidth: "full"
  }),
  dateTime: I({
    formats: pv,
    defaultWidth: "full"
  })
}, yv = {
  lastWeek: "'verlede' eeee 'om' p",
  yesterday: "'gister om' p",
  today: "'vandag om' p",
  tomorrow: "'môre om' p",
  nextWeek: "eeee 'om' p",
  other: "P"
}, kv = function(i, d, a, t) {
  return yv[i];
}, wv = {
  narrow: ["vC", "nC"],
  abbreviated: ["vC", "nC"],
  wide: ["voor Christus", "na Christus"]
}, _v = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["K1", "K2", "K3", "K4"],
  wide: ["1ste kwartaal", "2de kwartaal", "3de kwartaal", "4de kwartaal"]
}, $v = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mrt", "Apr", "Mei", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Des"],
  wide: ["Januarie", "Februarie", "Maart", "April", "Mei", "Junie", "Julie", "Augustus", "September", "Oktober", "November", "Desember"]
}, Pv = {
  narrow: ["S", "M", "D", "W", "D", "V", "S"],
  short: ["So", "Ma", "Di", "Wo", "Do", "Vr", "Sa"],
  abbreviated: ["Son", "Maa", "Din", "Woe", "Don", "Vry", "Sat"],
  wide: ["Sondag", "Maandag", "Dinsdag", "Woensdag", "Donderdag", "Vrydag", "Saterdag"]
}, Mv = {
  narrow: {
    am: "vm",
    pm: "nm",
    midnight: "middernag",
    noon: "middaguur",
    morning: "oggend",
    afternoon: "middag",
    evening: "laat middag",
    night: "aand"
  },
  abbreviated: {
    am: "vm",
    pm: "nm",
    midnight: "middernag",
    noon: "middaguur",
    morning: "oggend",
    afternoon: "middag",
    evening: "laat middag",
    night: "aand"
  },
  wide: {
    am: "vm",
    pm: "nm",
    midnight: "middernag",
    noon: "middaguur",
    morning: "oggend",
    afternoon: "middag",
    evening: "laat middag",
    night: "aand"
  }
}, jv = {
  narrow: {
    am: "vm",
    pm: "nm",
    midnight: "middernag",
    noon: "uur die middag",
    morning: "uur die oggend",
    afternoon: "uur die middag",
    evening: "uur die aand",
    night: "uur die aand"
  },
  abbreviated: {
    am: "vm",
    pm: "nm",
    midnight: "middernag",
    noon: "uur die middag",
    morning: "uur die oggend",
    afternoon: "uur die middag",
    evening: "uur die aand",
    night: "uur die aand"
  },
  wide: {
    am: "vm",
    pm: "nm",
    midnight: "middernag",
    noon: "uur die middag",
    morning: "uur die oggend",
    afternoon: "uur die middag",
    evening: "uur die aand",
    night: "uur die aand"
  }
}, Sv = function(i) {
  var d = Number(i), a = d % 100;
  if (a < 20)
    switch (a) {
      case 1:
      case 8:
        return d + "ste";
      default:
        return d + "de";
    }
  return d + "ste";
}, zv = {
  ordinalNumber: Sv,
  era: $({
    values: wv,
    defaultWidth: "wide"
  }),
  quarter: $({
    values: _v,
    defaultWidth: "wide",
    argumentCallback: function(i) {
      return i - 1;
    }
  }),
  month: $({
    values: $v,
    defaultWidth: "wide"
  }),
  day: $({
    values: Pv,
    defaultWidth: "wide"
  }),
  dayPeriod: $({
    values: Mv,
    defaultWidth: "wide",
    formattingValues: jv,
    defaultFormattingWidth: "wide"
  })
}, Ov = /^(\d+)(ste|de)?/i, Wv = /\d+/i, Dv = {
  narrow: /^([vn]\.? ?C\.?)/,
  abbreviated: /^([vn]\. ?C\.?)/,
  wide: /^((voor|na) Christus)/
}, Cv = {
  any: [/^v/, /^n/]
}, Iv = {
  narrow: /^[1234]/i,
  abbreviated: /^K[1234]/i,
  wide: /^[1234](st|d)e kwartaal/i
}, Tv = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Nv = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(Jan|Feb|Mrt|Apr|Mei|Jun|Jul|Aug|Sep|Okt|Nov|Dec)\.?/i,
  wide: /^(Januarie|Februarie|Maart|April|Mei|Junie|Julie|Augustus|September|Oktober|November|Desember)/i
}, xv = {
  narrow: [/^J/i, /^F/i, /^M/i, /^A/i, /^M/i, /^J/i, /^J/i, /^A/i, /^S/i, /^O/i, /^N/i, /^D/i],
  any: [/^Jan/i, /^Feb/i, /^Mrt/i, /^Apr/i, /^Mei/i, /^Jun/i, /^Jul/i, /^Aug/i, /^Sep/i, /^Okt/i, /^Nov/i, /^Dec/i]
}, Fv = {
  narrow: /^[smdwv]/i,
  short: /^(So|Ma|Di|Wo|Do|Vr|Sa)/i,
  abbreviated: /^(Son|Maa|Din|Woe|Don|Vry|Sat)/i,
  wide: /^(Sondag|Maandag|Dinsdag|Woensdag|Donderdag|Vrydag|Saterdag)/i
}, Ev = {
  narrow: [/^S/i, /^M/i, /^D/i, /^W/i, /^D/i, /^V/i, /^S/i],
  any: [/^So/i, /^Ma/i, /^Di/i, /^Wo/i, /^Do/i, /^Vr/i, /^Sa/i]
}, Rv = {
  any: /^(vm|nm|middernag|(?:uur )?die (oggend|middag|aand))/i
}, Lv = {
  any: {
    am: /^vm/i,
    pm: /^nm/i,
    midnight: /^middernag/i,
    noon: /^middaguur/i,
    morning: /oggend/i,
    afternoon: /middag/i,
    evening: /laat middag/i,
    night: /aand/i
  }
}, qv = {
  ordinalNumber: le({
    matchPattern: Ov,
    parsePattern: Wv,
    valueCallback: function(i) {
      return parseInt(i, 10);
    }
  }),
  era: P({
    matchPatterns: Dv,
    defaultMatchWidth: "wide",
    parsePatterns: Cv,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: Iv,
    defaultMatchWidth: "wide",
    parsePatterns: Tv,
    defaultParseWidth: "any",
    valueCallback: function(i) {
      return i + 1;
    }
  }),
  month: P({
    matchPatterns: Nv,
    defaultMatchWidth: "wide",
    parsePatterns: xv,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: Fv,
    defaultMatchWidth: "wide",
    parsePatterns: Ev,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: Rv,
    defaultMatchWidth: "any",
    parsePatterns: Lv,
    defaultParseWidth: "any"
  })
}, Zv = {
  code: "af",
  formatDistance: vv,
  formatLong: bv,
  formatRelative: kv,
  localize: zv,
  match: qv,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
const Av = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Zv
}, Symbol.toStringTag, { value: "Module" })), Vv = /* @__PURE__ */ te(Av);
var Hv = {
  lessThanXSeconds: {
    one: "أقل من ثانية واحدة",
    two: "أقل من ثانتين",
    threeToTen: "أقل من {{count}} ثواني",
    other: "أقل من {{count}} ثانية"
  },
  xSeconds: {
    one: "ثانية واحدة",
    two: "ثانتين",
    threeToTen: "{{count}} ثواني",
    other: "{{count}} ثانية"
  },
  halfAMinute: "نصف دقيقة",
  lessThanXMinutes: {
    one: "أقل من دقيقة",
    two: "أقل من دقيقتين",
    threeToTen: "أقل من {{count}} دقائق",
    other: "أقل من {{count}} دقيقة"
  },
  xMinutes: {
    one: "دقيقة واحدة",
    two: "دقيقتين",
    threeToTen: "{{count}} دقائق",
    other: "{{count}} دقيقة"
  },
  aboutXHours: {
    one: "ساعة واحدة تقريباً",
    two: "ساعتين تقريباً",
    threeToTen: "{{count}} ساعات تقريباً",
    other: "{{count}} ساعة تقريباً"
  },
  xHours: {
    one: "ساعة واحدة",
    two: "ساعتين",
    threeToTen: "{{count}} ساعات",
    other: "{{count}} ساعة"
  },
  xDays: {
    one: "يوم واحد",
    two: "يومين",
    threeToTen: "{{count}} أيام",
    other: "{{count}} يوم"
  },
  aboutXWeeks: {
    one: "أسبوع واحد تقريباً",
    two: "أسبوعين تقريباً",
    threeToTen: "{{count}} أسابيع تقريباً",
    other: "{{count}} أسبوع تقريباً"
  },
  xWeeks: {
    one: "أسبوع واحد",
    two: "أسبوعين",
    threeToTen: "{{count}} أسابيع",
    other: "{{count}} أسبوع"
  },
  aboutXMonths: {
    one: "شهر واحد تقريباً",
    two: "شهرين تقريباً",
    threeToTen: "{{count}} أشهر تقريباً",
    other: "{{count}} شهر تقريباً"
  },
  xMonths: {
    one: "شهر واحد",
    two: "شهرين",
    threeToTen: "{{count}} أشهر",
    other: "{{count}} شهر"
  },
  aboutXYears: {
    one: "عام واحد تقريباً",
    two: "عامين تقريباً",
    threeToTen: "{{count}} أعوام تقريباً",
    other: "{{count}} عام تقريباً"
  },
  xYears: {
    one: "عام واحد",
    two: "عامين",
    threeToTen: "{{count}} أعوام",
    other: "{{count}} عام"
  },
  overXYears: {
    one: "أكثر من عام",
    two: "أكثر من عامين",
    threeToTen: "أكثر من {{count}} أعوام",
    other: "أكثر من {{count}} عام"
  },
  almostXYears: {
    one: "عام واحد تقريباً",
    two: "عامين تقريباً",
    threeToTen: "{{count}} أعوام تقريباً",
    other: "{{count}} عام تقريباً"
  }
}, Uv = function(i, d, a) {
  var t, o = Hv[i];
  return typeof o == "string" ? t = o : d === 1 ? t = o.one : d === 2 ? t = o.two : d <= 10 ? t = o.threeToTen.replace("{{count}}", String(d)) : t = o.other.replace("{{count}}", String(d)), a != null && a.addSuffix ? a.comparison && a.comparison > 0 ? "في خلال " + t : "منذ " + t : t;
}, Bv = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, Xv = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, Gv = {
  full: "{{date}} 'عند' {{time}}",
  long: "{{date}} 'عند' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Kv = {
  date: I({
    formats: Bv,
    defaultWidth: "full"
  }),
  time: I({
    formats: Xv,
    defaultWidth: "full"
  }),
  dateTime: I({
    formats: Gv,
    defaultWidth: "full"
  })
}, Yv = {
  lastWeek: "'أخر' eeee 'عند' p",
  yesterday: "'أمس عند' p",
  today: "'اليوم عند' p",
  tomorrow: "'غداً عند' p",
  nextWeek: "eeee 'عند' p",
  other: "P"
}, Jv = function(i, d, a, t) {
  return Yv[i];
}, Qv = {
  narrow: ["ق", "ب"],
  abbreviated: ["ق.م.", "ب.م."],
  wide: ["قبل الميلاد", "بعد الميلاد"]
}, eh = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["ر1", "ر2", "ر3", "ر4"],
  wide: ["الربع الأول", "الربع الثاني", "الربع الثالث", "الربع الرابع"]
}, nh = {
  narrow: ["ي", "ف", "م", "أ", "م", "ي", "ي", "أ", "س", "أ", "ن", "د"],
  abbreviated: ["ينا", "فبر", "مارس", "أبريل", "مايو", "يونـ", "يولـ", "أغسـ", "سبتـ", "أكتـ", "نوفـ", "ديسـ"],
  wide: ["يناير", "فبراير", "مارس", "أبريل", "مايو", "يونيو", "يوليو", "أغسطس", "سبتمبر", "أكتوبر", "نوفمبر", "ديسمبر"]
}, ih = {
  narrow: ["ح", "ن", "ث", "ر", "خ", "ج", "س"],
  short: ["أحد", "اثنين", "ثلاثاء", "أربعاء", "خميس", "جمعة", "سبت"],
  abbreviated: ["أحد", "اثنـ", "ثلا", "أربـ", "خميـ", "جمعة", "سبت"],
  wide: ["الأحد", "الاثنين", "الثلاثاء", "الأربعاء", "الخميس", "الجمعة", "السبت"]
}, ah = {
  narrow: {
    am: "ص",
    pm: "م",
    midnight: "ن",
    noon: "ظ",
    morning: "صباحاً",
    afternoon: "بعد الظهر",
    evening: "مساءاً",
    night: "ليلاً"
  },
  abbreviated: {
    am: "ص",
    pm: "م",
    midnight: "نصف الليل",
    noon: "ظهر",
    morning: "صباحاً",
    afternoon: "بعد الظهر",
    evening: "مساءاً",
    night: "ليلاً"
  },
  wide: {
    am: "ص",
    pm: "م",
    midnight: "نصف الليل",
    noon: "ظهر",
    morning: "صباحاً",
    afternoon: "بعد الظهر",
    evening: "مساءاً",
    night: "ليلاً"
  }
}, th = {
  narrow: {
    am: "ص",
    pm: "م",
    midnight: "ن",
    noon: "ظ",
    morning: "في الصباح",
    afternoon: "بعد الظـهر",
    evening: "في المساء",
    night: "في الليل"
  },
  abbreviated: {
    am: "ص",
    pm: "م",
    midnight: "نصف الليل",
    noon: "ظهر",
    morning: "في الصباح",
    afternoon: "بعد الظهر",
    evening: "في المساء",
    night: "في الليل"
  },
  wide: {
    am: "ص",
    pm: "م",
    midnight: "نصف الليل",
    noon: "ظهر",
    morning: "صباحاً",
    afternoon: "بعد الظـهر",
    evening: "في المساء",
    night: "في الليل"
  }
}, rh = function(i) {
  return String(i);
}, oh = {
  ordinalNumber: rh,
  era: $({
    values: Qv,
    defaultWidth: "wide"
  }),
  quarter: $({
    values: eh,
    defaultWidth: "wide",
    argumentCallback: function(i) {
      return i - 1;
    }
  }),
  month: $({
    values: nh,
    defaultWidth: "wide"
  }),
  day: $({
    values: ih,
    defaultWidth: "wide"
  }),
  dayPeriod: $({
    values: ah,
    defaultWidth: "wide",
    formattingValues: th,
    defaultFormattingWidth: "wide"
  })
}, sh = /^(\d+)(th|st|nd|rd)?/i, dh = /\d+/i, uh = {
  narrow: /^(ق|ب)/i,
  abbreviated: /^(ق\.?\s?م\.?|ق\.?\s?م\.?\s?|a\.?\s?d\.?|c\.?\s?)/i,
  wide: /^(قبل الميلاد|قبل الميلاد|بعد الميلاد|بعد الميلاد)/i
}, fh = {
  any: [/^قبل/i, /^بعد/i]
}, lh = {
  narrow: /^[1234]/i,
  abbreviated: /^ر[1234]/i,
  wide: /^الربع [1234]/i
}, ch = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, mh = {
  narrow: /^[يفمأمسند]/i,
  abbreviated: /^(ين|ف|مار|أب|ماي|يون|يول|أغ|س|أك|ن|د)/i,
  wide: /^(ين|ف|مار|أب|ماي|يون|يول|أغ|س|أك|ن|د)/i
}, vh = {
  narrow: [/^ي/i, /^ف/i, /^م/i, /^أ/i, /^م/i, /^ي/i, /^ي/i, /^أ/i, /^س/i, /^أ/i, /^ن/i, /^د/i],
  any: [/^ين/i, /^ف/i, /^مار/i, /^أب/i, /^ماي/i, /^يون/i, /^يول/i, /^أغ/i, /^س/i, /^أك/i, /^ن/i, /^د/i]
}, hh = {
  narrow: /^[حنثرخجس]/i,
  short: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
  abbreviated: /^(أحد|اثن|ثلا|أرب|خمي|جمعة|سبت)/i,
  wide: /^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
}, gh = {
  narrow: [/^ح/i, /^ن/i, /^ث/i, /^ر/i, /^خ/i, /^ج/i, /^س/i],
  wide: [/^الأحد/i, /^الاثنين/i, /^الثلاثاء/i, /^الأربعاء/i, /^الخميس/i, /^الجمعة/i, /^السبت/i],
  any: [/^أح/i, /^اث/i, /^ث/i, /^أر/i, /^خ/i, /^ج/i, /^س/i]
}, ph = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, bh = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, yh = {
  ordinalNumber: le({
    matchPattern: sh,
    parsePattern: dh,
    valueCallback: function(i) {
      return parseInt(i, 10);
    }
  }),
  era: P({
    matchPatterns: uh,
    defaultMatchWidth: "wide",
    parsePatterns: fh,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: lh,
    defaultMatchWidth: "wide",
    parsePatterns: ch,
    defaultParseWidth: "any",
    valueCallback: function(i) {
      return i + 1;
    }
  }),
  month: P({
    matchPatterns: mh,
    defaultMatchWidth: "wide",
    parsePatterns: vh,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: hh,
    defaultMatchWidth: "wide",
    parsePatterns: gh,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: ph,
    defaultMatchWidth: "any",
    parsePatterns: bh,
    defaultParseWidth: "any"
  })
}, kh = {
  code: "ar-SA",
  formatDistance: Uv,
  formatLong: Kv,
  formatRelative: Jv,
  localize: oh,
  match: yh,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
const wh = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: kh
}, Symbol.toStringTag, { value: "Module" })), _h = /* @__PURE__ */ te(wh);
var $h = {
  lessThanXSeconds: {
    one: "أقل من ثانية واحدة",
    two: "أقل من ثانتين",
    threeToTen: "أقل من {{count}} ثواني",
    other: "أقل من {{count}} ثانية"
  },
  xSeconds: {
    one: "ثانية واحدة",
    two: "ثانتين",
    threeToTen: "{{count}} ثواني",
    other: "{{count}} ثانية"
  },
  halfAMinute: "نصف دقيقة",
  lessThanXMinutes: {
    one: "أقل من دقيقة",
    two: "أقل من دقيقتين",
    threeToTen: "أقل من {{count}} دقائق",
    other: "أقل من {{count}} دقيقة"
  },
  xMinutes: {
    one: "دقيقة واحدة",
    two: "دقيقتين",
    threeToTen: "{{count}} دقائق",
    other: "{{count}} دقيقة"
  },
  aboutXHours: {
    one: "ساعة واحدة تقريباً",
    two: "ساعتين تقريباً",
    threeToTen: "{{count}} ساعات تقريباً",
    other: "{{count}} ساعة تقريباً"
  },
  xHours: {
    one: "ساعة واحدة",
    two: "ساعتين",
    threeToTen: "{{count}} ساعات",
    other: "{{count}} ساعة"
  },
  xDays: {
    one: "يوم واحد",
    two: "يومين",
    threeToTen: "{{count}} أيام",
    other: "{{count}} يوم"
  },
  aboutXWeeks: {
    one: "أسبوع واحد تقريباً",
    two: "أسبوعين تقريباً",
    threeToTen: "{{count}} أسابيع تقريباً",
    other: "{{count}} أسبوع تقريباً"
  },
  xWeeks: {
    one: "أسبوع واحد",
    two: "أسبوعين",
    threeToTen: "{{count}} أسابيع",
    other: "{{count}} أسبوع"
  },
  aboutXMonths: {
    one: "شهر واحد تقريباً",
    two: "شهرين تقريباً",
    threeToTen: "{{count}} أشهر تقريباً",
    other: "{{count}} شهر تقريباً"
  },
  xMonths: {
    one: "شهر واحد",
    two: "شهرين",
    threeToTen: "{{count}} أشهر",
    other: "{{count}} شهر"
  },
  aboutXYears: {
    one: "عام واحد تقريباً",
    two: "عامين تقريباً",
    threeToTen: "{{count}} أعوام تقريباً",
    other: "{{count}} عام تقريباً"
  },
  xYears: {
    one: "عام واحد",
    two: "عامين",
    threeToTen: "{{count}} أعوام",
    other: "{{count}} عام"
  },
  overXYears: {
    one: "أكثر من عام",
    two: "أكثر من عامين",
    threeToTen: "أكثر من {{count}} أعوام",
    other: "أكثر من {{count}} عام"
  },
  almostXYears: {
    one: "عام واحد تقريباً",
    two: "عامين تقريباً",
    threeToTen: "{{count}} أعوام تقريباً",
    other: "{{count}} عام تقريباً"
  }
}, Ph = function(i, d, a) {
  a = a || {};
  var t = $h[i], o;
  return typeof t == "string" ? o = t : d === 1 ? o = t.one : d === 2 ? o = t.two : d <= 10 ? o = t.threeToTen.replace("{{count}}", String(d)) : o = t.other.replace("{{count}}", String(d)), a.addSuffix ? a.comparison && a.comparison > 0 ? "في خلال " + o : "منذ " + o : o;
}, Mh = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, jh = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, Sh = {
  full: "{{date}} 'عند' {{time}}",
  long: "{{date}} 'عند' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, zh = {
  date: I({
    formats: Mh,
    defaultWidth: "full"
  }),
  time: I({
    formats: jh,
    defaultWidth: "full"
  }),
  dateTime: I({
    formats: Sh,
    defaultWidth: "full"
  })
}, Oh = {
  lastWeek: "'أخر' eeee 'عند' p",
  yesterday: "'أمس عند' p",
  today: "'اليوم عند' p",
  tomorrow: "'غداً عند' p",
  nextWeek: "eeee 'عند' p",
  other: "P"
}, Wh = function(i, d, a, t) {
  return Oh[i];
}, Dh = {
  narrow: ["ق", "ب"],
  abbreviated: ["ق.م.", "ب.م."],
  wide: ["قبل الميلاد", "بعد الميلاد"]
}, Ch = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["ر1", "ر2", "ر3", "ر4"],
  wide: ["الربع الأول", "الربع الثاني", "الربع الثالث", "الربع الرابع"]
}, Ih = {
  narrow: ["ج", "ف", "م", "أ", "م", "ج", "ج", "أ", "س", "أ", "ن", "د"],
  abbreviated: ["جانـ", "فيفـ", "مارس", "أفريل", "مايـ", "جوانـ", "جويـ", "أوت", "سبتـ", "أكتـ", "نوفـ", "ديسـ"],
  wide: ["جانفي", "فيفري", "مارس", "أفريل", "ماي", "جوان", "جويلية", "أوت", "سبتمبر", "أكتوبر", "نوفمبر", "ديسمبر"]
}, Th = {
  narrow: ["ح", "ن", "ث", "ر", "خ", "ج", "س"],
  short: ["أحد", "اثنين", "ثلاثاء", "أربعاء", "خميس", "جمعة", "سبت"],
  abbreviated: ["أحد", "اثنـ", "ثلا", "أربـ", "خميـ", "جمعة", "سبت"],
  wide: ["الأحد", "الاثنين", "الثلاثاء", "الأربعاء", "الخميس", "الجمعة", "السبت"]
}, Nh = {
  narrow: {
    am: "ص",
    pm: "م",
    midnight: "ن",
    noon: "ظ",
    morning: "صباحاً",
    afternoon: "بعد الظهر",
    evening: "مساءاً",
    night: "ليلاً"
  },
  abbreviated: {
    am: "ص",
    pm: "م",
    midnight: "نصف الليل",
    noon: "ظهر",
    morning: "صباحاً",
    afternoon: "بعد الظهر",
    evening: "مساءاً",
    night: "ليلاً"
  },
  wide: {
    am: "ص",
    pm: "م",
    midnight: "نصف الليل",
    noon: "ظهر",
    morning: "صباحاً",
    afternoon: "بعد الظهر",
    evening: "مساءاً",
    night: "ليلاً"
  }
}, xh = {
  narrow: {
    am: "ص",
    pm: "م",
    midnight: "ن",
    noon: "ظ",
    morning: "في الصباح",
    afternoon: "بعد الظـهر",
    evening: "في المساء",
    night: "في الليل"
  },
  abbreviated: {
    am: "ص",
    pm: "م",
    midnight: "نصف الليل",
    noon: "ظهر",
    morning: "في الصباح",
    afternoon: "بعد الظهر",
    evening: "في المساء",
    night: "في الليل"
  },
  wide: {
    am: "ص",
    pm: "م",
    midnight: "نصف الليل",
    noon: "ظهر",
    morning: "صباحاً",
    afternoon: "بعد الظـهر",
    evening: "في المساء",
    night: "في الليل"
  }
}, Fh = function(i) {
  return String(i);
}, Eh = {
  ordinalNumber: Fh,
  era: $({
    values: Dh,
    defaultWidth: "wide"
  }),
  quarter: $({
    values: Ch,
    defaultWidth: "wide",
    argumentCallback: function(i) {
      return Number(i) - 1;
    }
  }),
  month: $({
    values: Ih,
    defaultWidth: "wide"
  }),
  day: $({
    values: Th,
    defaultWidth: "wide"
  }),
  dayPeriod: $({
    values: Nh,
    defaultWidth: "wide",
    formattingValues: xh,
    defaultFormattingWidth: "wide"
  })
}, Rh = /^(\d+)(th|st|nd|rd)?/i, Lh = /\d+/i, qh = {
  narrow: /^(ق|ب)/i,
  abbreviated: /^(ق\.?\s?م\.?|ق\.?\s?م\.?\s?|a\.?\s?d\.?|c\.?\s?)/i,
  wide: /^(قبل الميلاد|قبل الميلاد|بعد الميلاد|بعد الميلاد)/i
}, Zh = {
  any: [/^قبل/i, /^بعد/i]
}, Ah = {
  narrow: /^[1234]/i,
  abbreviated: /^ر[1234]/i,
  wide: /^الربع [1234]/i
}, Vh = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Hh = {
  narrow: /^[جفمأسند]/i,
  abbreviated: /^(جان|فيف|مار|أفر|ماي|جوا|جوي|أوت|سبت|أكت|نوف|ديس)/i,
  wide: /^(جانفي|فيفري|مارس|أفريل|ماي|جوان|جويلية|أوت|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/i
}, Uh = {
  narrow: [/^ج/i, /^ف/i, /^م/i, /^أ/i, /^م/i, /^ج/i, /^ج/i, /^أ/i, /^س/i, /^أ/i, /^ن/i, /^د/i],
  any: [/^جان/i, /^فيف/i, /^مار/i, /^أفر/i, /^ماي/i, /^جوا/i, /^جوي/i, /^أوت/i, /^سبت/i, /^أكت/i, /^نوف/i, /^ديس/i]
}, Bh = {
  narrow: /^[حنثرخجس]/i,
  short: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
  abbreviated: /^(أحد|اثن|ثلا|أرب|خمي|جمعة|سبت)/i,
  wide: /^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
}, Xh = {
  narrow: [/^ح/i, /^ن/i, /^ث/i, /^ر/i, /^خ/i, /^ج/i, /^س/i],
  wide: [/^الأحد/i, /^الاثنين/i, /^الثلاثاء/i, /^الأربعاء/i, /^الخميس/i, /^الجمعة/i, /^السبت/i],
  any: [/^أح/i, /^اث/i, /^ث/i, /^أر/i, /^خ/i, /^ج/i, /^س/i]
}, Gh = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, Kh = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, Yh = {
  ordinalNumber: le({
    matchPattern: Rh,
    parsePattern: Lh,
    valueCallback: function(i) {
      return parseInt(i, 10);
    }
  }),
  era: P({
    matchPatterns: qh,
    defaultMatchWidth: "wide",
    parsePatterns: Zh,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: Ah,
    defaultMatchWidth: "wide",
    parsePatterns: Vh,
    defaultParseWidth: "any",
    valueCallback: function(i) {
      return Number(i) + 1;
    }
  }),
  month: P({
    matchPatterns: Hh,
    defaultMatchWidth: "wide",
    parsePatterns: Uh,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: Bh,
    defaultMatchWidth: "wide",
    parsePatterns: Xh,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: Gh,
    defaultMatchWidth: "any",
    parsePatterns: Kh,
    defaultParseWidth: "any"
  })
}, Jh = {
  code: "ar-DZ",
  formatDistance: Ph,
  formatLong: zh,
  formatRelative: Wh,
  localize: Eh,
  match: Yh,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
const Qh = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Jh
}, Symbol.toStringTag, { value: "Module" })), eg = /* @__PURE__ */ te(Qh);
var ng = {
  lessThanXSeconds: {
    one: "أقل من ثانية واحدة",
    two: "أقل من ثانتين",
    threeToTen: "أقل من {{count}} ثواني",
    other: "أقل من {{count}} ثانية"
  },
  xSeconds: {
    one: "ثانية واحدة",
    two: "ثانتين",
    threeToTen: "{{count}} ثواني",
    other: "{{count}} ثانية"
  },
  halfAMinute: "نصف دقيقة",
  lessThanXMinutes: {
    one: "أقل من دقيقة",
    two: "أقل من دقيقتين",
    threeToTen: "أقل من {{count}} دقائق",
    other: "أقل من {{count}} دقيقة"
  },
  xMinutes: {
    one: "دقيقة واحدة",
    two: "دقيقتين",
    threeToTen: "{{count}} دقائق",
    other: "{{count}} دقيقة"
  },
  aboutXHours: {
    one: "ساعة واحدة تقريباً",
    two: "ساعتين تقريباً",
    threeToTen: "{{count}} ساعات تقريباً",
    other: "{{count}} ساعة تقريباً"
  },
  xHours: {
    one: "ساعة واحدة",
    two: "ساعتين",
    threeToTen: "{{count}} ساعات",
    other: "{{count}} ساعة"
  },
  xDays: {
    one: "يوم واحد",
    two: "يومين",
    threeToTen: "{{count}} أيام",
    other: "{{count}} يوم"
  },
  aboutXWeeks: {
    one: "أسبوع واحد تقريباً",
    two: "أسبوعين تقريباً",
    threeToTen: "{{count}} أسابيع تقريباً",
    other: "{{count}} أسبوع تقريباً"
  },
  xWeeks: {
    one: "أسبوع واحد",
    two: "أسبوعين",
    threeToTen: "{{count}} أسابيع",
    other: "{{count}} أسبوع"
  },
  aboutXMonths: {
    one: "شهر واحد تقريباً",
    two: "شهرين تقريباً",
    threeToTen: "{{count}} أشهر تقريباً",
    other: "{{count}} شهر تقريباً"
  },
  xMonths: {
    one: "شهر واحد",
    two: "شهرين",
    threeToTen: "{{count}} أشهر",
    other: "{{count}} شهر"
  },
  aboutXYears: {
    one: "عام واحد تقريباً",
    two: "عامين تقريباً",
    threeToTen: "{{count}} أعوام تقريباً",
    other: "{{count}} عام تقريباً"
  },
  xYears: {
    one: "عام واحد",
    two: "عامين",
    threeToTen: "{{count}} أعوام",
    other: "{{count}} عام"
  },
  overXYears: {
    one: "أكثر من عام",
    two: "أكثر من عامين",
    threeToTen: "أكثر من {{count}} أعوام",
    other: "أكثر من {{count}} عام"
  },
  almostXYears: {
    one: "عام واحد تقريباً",
    two: "عامين تقريباً",
    threeToTen: "{{count}} أعوام تقريباً",
    other: "{{count}} عام تقريباً"
  }
}, ig = function(i, d, a) {
  a = a || {};
  var t = ng[i], o;
  return typeof t == "string" ? o = t : d === 1 ? o = t.one : d === 2 ? o = t.two : d <= 10 ? o = t.threeToTen.replace("{{count}}", String(d)) : o = t.other.replace("{{count}}", String(d)), a.addSuffix ? a.comparison && a.comparison > 0 ? "في خلال " + o : "منذ " + o : o;
}, ag = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, tg = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, rg = {
  full: "{{date}} 'عند' {{time}}",
  long: "{{date}} 'عند' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, og = {
  date: I({
    formats: ag,
    defaultWidth: "full"
  }),
  time: I({
    formats: tg,
    defaultWidth: "full"
  }),
  dateTime: I({
    formats: rg,
    defaultWidth: "full"
  })
}, sg = {
  lastWeek: "'أخر' eeee 'عند' p",
  yesterday: "'أمس عند' p",
  today: "'اليوم عند' p",
  tomorrow: "'غداً عند' p",
  nextWeek: "eeee 'عند' p",
  other: "P"
}, dg = function(i, d, a, t) {
  return sg[i];
}, ug = {
  narrow: ["ق", "ب"],
  abbreviated: ["ق.م.", "ب.م."],
  wide: ["قبل الميلاد", "بعد الميلاد"]
}, fg = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["ر1", "ر2", "ر3", "ر4"],
  wide: ["الربع الأول", "الربع الثاني", "الربع الثالث", "الربع الرابع"]
}, lg = {
  narrow: ["ي", "ف", "م", "أ", "م", "ي", "ي", "غ", "ش", "أ", "ن", "د"],
  abbreviated: ["ينا", "فبر", "مارس", "أبريل", "ماي", "يونـ", "يولـ", "غشت", "شتنـ", "أكتـ", "نونـ", "دجنـ"],
  wide: ["يناير", "فبراير", "مارس", "أبريل", "ماي", "يونيو", "يوليوز", "غشت", "شتنبر", "أكتوبر", "نونبر", "دجنبر"]
}, cg = {
  narrow: ["ح", "ن", "ث", "ر", "خ", "ج", "س"],
  short: ["أحد", "اثنين", "ثلاثاء", "أربعاء", "خميس", "جمعة", "سبت"],
  abbreviated: ["أحد", "اثنـ", "ثلا", "أربـ", "خميـ", "جمعة", "سبت"],
  wide: ["الأحد", "الإثنين", "الثلاثاء", "الأربعاء", "الخميس", "الجمعة", "السبت"]
}, mg = {
  narrow: {
    am: "ص",
    pm: "م",
    midnight: "ن",
    noon: "ظ",
    morning: "صباحاً",
    afternoon: "بعد الظهر",
    evening: "مساءاً",
    night: "ليلاً"
  },
  abbreviated: {
    am: "ص",
    pm: "م",
    midnight: "نصف الليل",
    noon: "ظهر",
    morning: "صباحاً",
    afternoon: "بعد الظهر",
    evening: "مساءاً",
    night: "ليلاً"
  },
  wide: {
    am: "ص",
    pm: "م",
    midnight: "نصف الليل",
    noon: "ظهر",
    morning: "صباحاً",
    afternoon: "بعد الظهر",
    evening: "مساءاً",
    night: "ليلاً"
  }
}, vg = {
  narrow: {
    am: "ص",
    pm: "م",
    midnight: "ن",
    noon: "ظ",
    morning: "في الصباح",
    afternoon: "بعد الظـهر",
    evening: "في المساء",
    night: "في الليل"
  },
  abbreviated: {
    am: "ص",
    pm: "م",
    midnight: "نصف الليل",
    noon: "ظهر",
    morning: "في الصباح",
    afternoon: "بعد الظهر",
    evening: "في المساء",
    night: "في الليل"
  },
  wide: {
    am: "ص",
    pm: "م",
    midnight: "نصف الليل",
    noon: "ظهر",
    morning: "صباحاً",
    afternoon: "بعد الظـهر",
    evening: "في المساء",
    night: "في الليل"
  }
}, hg = function(i) {
  return String(i);
}, gg = {
  ordinalNumber: hg,
  era: $({
    values: ug,
    defaultWidth: "wide"
  }),
  quarter: $({
    values: fg,
    defaultWidth: "wide",
    argumentCallback: function(i) {
      return Number(i) - 1;
    }
  }),
  month: $({
    values: lg,
    defaultWidth: "wide"
  }),
  day: $({
    values: cg,
    defaultWidth: "wide"
  }),
  dayPeriod: $({
    values: mg,
    defaultWidth: "wide",
    formattingValues: vg,
    defaultFormattingWidth: "wide"
  })
}, pg = /^(\d+)(th|st|nd|rd)?/i, bg = /\d+/i, yg = {
  narrow: /^(ق|ب)/i,
  abbreviated: /^(ق\.?\s?م\.?|ق\.?\s?م\.?\s?|a\.?\s?d\.?|c\.?\s?)/i,
  wide: /^(قبل الميلاد|قبل الميلاد|بعد الميلاد|بعد الميلاد)/i
}, kg = {
  any: [/^قبل/i, /^بعد/i]
}, wg = {
  narrow: /^[1234]/i,
  abbreviated: /^ر[1234]/i,
  wide: /^الربع [1234]/i
}, _g = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, $g = {
  narrow: /^[يفمأمسند]/i,
  abbreviated: /^(ين|ف|مار|أب|ماي|يون|يول|غش|شت|أك|ن|د)/i,
  wide: /^(ين|ف|مار|أب|ماي|يون|يول|غش|شت|أك|ن|د)/i
}, Pg = {
  narrow: [/^ي/i, /^ف/i, /^م/i, /^أ/i, /^م/i, /^ي/i, /^ي/i, /^غ/i, /^ش/i, /^أ/i, /^ن/i, /^د/i],
  any: [/^ين/i, /^فب/i, /^مار/i, /^أب/i, /^ماي/i, /^يون/i, /^يول/i, /^غشت/i, /^ش/i, /^أك/i, /^ن/i, /^د/i]
}, Mg = {
  narrow: /^[حنثرخجس]/i,
  short: /^(أحد|إثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
  abbreviated: /^(أحد|إثن|ثلا|أرب|خمي|جمعة|سبت)/i,
  wide: /^(الأحد|الإثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
}, jg = {
  narrow: [/^ح/i, /^ن/i, /^ث/i, /^ر/i, /^خ/i, /^ج/i, /^س/i],
  wide: [/^الأحد/i, /^الإثنين/i, /^الثلاثاء/i, /^الأربعاء/i, /^الخميس/i, /^الجمعة/i, /^السبت/i],
  any: [/^أح/i, /^إث/i, /^ث/i, /^أر/i, /^خ/i, /^ج/i, /^س/i]
}, Sg = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, zg = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, Og = {
  ordinalNumber: le({
    matchPattern: pg,
    parsePattern: bg,
    valueCallback: function(i) {
      return parseInt(i, 10);
    }
  }),
  era: P({
    matchPatterns: yg,
    defaultMatchWidth: "wide",
    parsePatterns: kg,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: wg,
    defaultMatchWidth: "wide",
    parsePatterns: _g,
    defaultParseWidth: "any",
    valueCallback: function(i) {
      return Number(i) + 1;
    }
  }),
  month: P({
    matchPatterns: $g,
    defaultMatchWidth: "wide",
    parsePatterns: Pg,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: Mg,
    defaultMatchWidth: "wide",
    parsePatterns: jg,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: Sg,
    defaultMatchWidth: "any",
    parsePatterns: zg,
    defaultParseWidth: "any"
  })
}, Wg = {
  code: "ar-MA",
  formatDistance: ig,
  formatLong: og,
  formatRelative: dg,
  localize: gg,
  match: Og,
  options: {
    // Monday is 1
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
};
const Dg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Wg
}, Symbol.toStringTag, { value: "Module" })), Cg = /* @__PURE__ */ te(Dg);
var Ig = {
  lessThanXSeconds: {
    one: "bir saniyədən az",
    other: "{{count}} bir saniyədən az"
  },
  xSeconds: {
    one: "1 saniyə",
    other: "{{count}} saniyə"
  },
  halfAMinute: "yarım dəqiqə",
  lessThanXMinutes: {
    one: "bir dəqiqədən az",
    other: "{{count}} bir dəqiqədən az"
  },
  xMinutes: {
    one: "bir dəqiqə",
    other: "{{count}} dəqiqə"
  },
  aboutXHours: {
    one: "təxminən 1 saat",
    other: "təxminən {{count}} saat"
  },
  xHours: {
    one: "1 saat",
    other: "{{count}} saat"
  },
  xDays: {
    one: "1 gün",
    other: "{{count}} gün"
  },
  aboutXWeeks: {
    one: "təxminən 1 həftə",
    other: "təxminən {{count}} həftə"
  },
  xWeeks: {
    one: "1 həftə",
    other: "{{count}} həftə"
  },
  aboutXMonths: {
    one: "təxminən 1 ay",
    other: "təxminən {{count}} ay"
  },
  xMonths: {
    one: "1 ay",
    other: "{{count}} ay"
  },
  aboutXYears: {
    one: "təxminən 1 il",
    other: "təxminən {{count}} il"
  },
  xYears: {
    one: "1 il",
    other: "{{count}} il"
  },
  overXYears: {
    one: "1 ildən çox",
    other: "{{count}} ildən çox"
  },
  almostXYears: {
    one: "demək olar ki 1 il",
    other: "demək olar ki {{count}} il"
  }
}, Tg = function(i, d, a) {
  var t, o = Ig[i];
  return typeof o == "string" ? t = o : d === 1 ? t = o.one : t = o.other.replace("{{count}}", String(d)), a != null && a.addSuffix ? a.comparison && a.comparison > 0 ? t + " sonra" : t + " əvvəl" : t;
}, Ng = {
  full: "EEEE, do MMMM y 'il'",
  long: "do MMMM y 'il'",
  medium: "d MMM y 'il'",
  short: "dd.MM.yyyy"
}, xg = {
  full: "H:mm:ss zzzz",
  long: "H:mm:ss z",
  medium: "H:mm:ss",
  short: "H:mm"
}, Fg = {
  full: "{{date}} {{time}} - 'də'",
  long: "{{date}} {{time}} - 'də'",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Eg = {
  date: I({
    formats: Ng,
    defaultWidth: "full"
  }),
  time: I({
    formats: xg,
    defaultWidth: "full"
  }),
  dateTime: I({
    formats: Fg,
    defaultWidth: "full"
  })
}, Rg = {
  lastWeek: "'sonuncu' eeee p -'də'",
  yesterday: "'dünən' p -'də'",
  today: "'bugün' p -'də'",
  tomorrow: "'sabah' p -'də'",
  nextWeek: "eeee p -'də'",
  other: "P"
}, Lg = function(i, d, a, t) {
  return Rg[i];
}, qg = {
  narrow: ["e.ə", "b.e"],
  abbreviated: ["e.ə", "b.e"],
  wide: ["eramızdan əvvəl", "bizim era"]
}, Zg = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["K1", "K2", "K3", "K4"],
  wide: ["1ci kvartal", "2ci kvartal", "3cü kvartal", "4cü kvartal"]
}, Ag = {
  narrow: ["Y", "F", "M", "A", "M", "İ", "İ", "A", "S", "O", "N", "D"],
  abbreviated: ["Yan", "Fev", "Mar", "Apr", "May", "İyun", "İyul", "Avq", "Sen", "Okt", "Noy", "Dek"],
  wide: ["Yanvar", "Fevral", "Mart", "Aprel", "May", "İyun", "İyul", "Avqust", "Sentyabr", "Oktyabr", "Noyabr", "Dekabr"]
}, Vg = {
  narrow: ["B.", "B.e", "Ç.a", "Ç.", "C.a", "C.", "Ş."],
  short: ["B.", "B.e", "Ç.a", "Ç.", "C.a", "C.", "Ş."],
  abbreviated: ["Baz", "Baz.e", "Çər.a", "Çər", "Cüm.a", "Cüm", "Şə"],
  wide: ["Bazar", "Bazar ertəsi", "Çərşənbə axşamı", "Çərşənbə", "Cümə axşamı", "Cümə", "Şənbə"]
}, Hg = {
  narrow: {
    am: "am",
    pm: "pm",
    midnight: "gecəyarı",
    noon: "gün",
    morning: "səhər",
    afternoon: "gündüz",
    evening: "axşam",
    night: "gecə"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "gecəyarı",
    noon: "gün",
    morning: "səhər",
    afternoon: "gündüz",
    evening: "axşam",
    night: "gecə"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "gecəyarı",
    noon: "gün",
    morning: "səhər",
    afternoon: "gündüz",
    evening: "axşam",
    night: "gecə"
  }
}, Ug = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "gecəyarı",
    noon: "gün",
    morning: "səhər",
    afternoon: "gündüz",
    evening: "axşam",
    night: "gecə"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "gecəyarı",
    noon: "gün",
    morning: "səhər",
    afternoon: "gündüz",
    evening: "axşam",
    night: "gecə"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "gecəyarı",
    noon: "gün",
    morning: "səhər",
    afternoon: "gündüz",
    evening: "axşam",
    night: "gecə"
  }
}, Gn = {
  1: "-inci",
  5: "-inci",
  8: "-inci",
  70: "-inci",
  80: "-inci",
  2: "-nci",
  7: "-nci",
  20: "-nci",
  50: "-nci",
  3: "-üncü",
  4: "-üncü",
  100: "-üncü",
  6: "-ncı",
  9: "-uncu",
  10: "-uncu",
  30: "-uncu",
  60: "-ıncı",
  90: "-ıncı"
}, Bg = function(i) {
  if (i === 0)
    return i + "-ıncı";
  var d = i % 10, a = i % 100 - d, t = i >= 100 ? 100 : null;
  return Gn[d] ? Gn[d] : Gn[a] ? Gn[a] : t !== null ? Gn[t] : "";
}, Xg = function(i, d) {
  var a = Number(i), t = Bg(a);
  return a + t;
}, Gg = {
  ordinalNumber: Xg,
  era: $({
    values: qg,
    defaultWidth: "wide"
  }),
  quarter: $({
    values: Zg,
    defaultWidth: "wide",
    argumentCallback: function(i) {
      return i - 1;
    }
  }),
  month: $({
    values: Ag,
    defaultWidth: "wide"
  }),
  day: $({
    values: Vg,
    defaultWidth: "wide"
  }),
  dayPeriod: $({
    values: Hg,
    defaultWidth: "wide",
    formattingValues: Ug,
    defaultFormattingWidth: "wide"
  })
}, Kg = /^(\d+)(-?(ci|inci|nci|uncu|üncü|ncı))?/i, Yg = /\d+/i, Jg = {
  narrow: /^(b|a)$/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)$/i,
  wide: /^(bizim eradan əvvəl|bizim era)$/i
}, Qg = {
  any: [/^b$/i, /^(a|c)$/i]
}, e1 = {
  narrow: /^[1234]$/i,
  abbreviated: /^K[1234]$/i,
  wide: /^[1234](ci)? kvartal$/i
}, n1 = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, i1 = {
  narrow: /^[(?-i)yfmaisond]$/i,
  abbreviated: /^(Yan|Fev|Mar|Apr|May|İyun|İyul|Avq|Sen|Okt|Noy|Dek)$/i,
  wide: /^(Yanvar|Fevral|Mart|Aprel|May|İyun|İyul|Avgust|Sentyabr|Oktyabr|Noyabr|Dekabr)$/i
}, a1 = {
  narrow: [/^[(?-i)y]$/i, /^[(?-i)f]$/i, /^[(?-i)m]$/i, /^[(?-i)a]$/i, /^[(?-i)m]$/i, /^[(?-i)i]$/i, /^[(?-i)i]$/i, /^[(?-i)a]$/i, /^[(?-i)s]$/i, /^[(?-i)o]$/i, /^[(?-i)n]$/i, /^[(?-i)d]$/i],
  abbreviated: [/^Yan$/i, /^Fev$/i, /^Mar$/i, /^Apr$/i, /^May$/i, /^İyun$/i, /^İyul$/i, /^Avg$/i, /^Sen$/i, /^Okt$/i, /^Noy$/i, /^Dek$/i],
  wide: [/^Yanvar$/i, /^Fevral$/i, /^Mart$/i, /^Aprel$/i, /^May$/i, /^İyun$/i, /^İyul$/i, /^Avgust$/i, /^Sentyabr$/i, /^Oktyabr$/i, /^Noyabr$/i, /^Dekabr$/i]
}, t1 = {
  narrow: /^(B\.|B\.e|Ç\.a|Ç\.|C\.a|C\.|Ş\.)$/i,
  short: /^(B\.|B\.e|Ç\.a|Ç\.|C\.a|C\.|Ş\.)$/i,
  abbreviated: /^(Baz\.e|Çər|Çər\.a|Cüm|Cüm\.a|Şə)$/i,
  wide: /^(Bazar|Bazar ertəsi|Çərşənbə axşamı|Çərşənbə|Cümə axşamı|Cümə|Şənbə)$/i
}, r1 = {
  narrow: [/^B\.$/i, /^B\.e$/i, /^Ç\.a$/i, /^Ç\.$/i, /^C\.a$/i, /^C\.$/i, /^Ş\.$/i],
  abbreviated: [/^Baz$/i, /^Baz\.e$/i, /^Çər\.a$/i, /^Çər$/i, /^Cüm\.a$/i, /^Cüm$/i, /^Şə$/i],
  wide: [/^Bazar$/i, /^Bazar ertəsi$/i, /^Çərşənbə axşamı$/i, /^Çərşənbə$/i, /^Cümə axşamı$/i, /^Cümə$/i, /^Şənbə$/i],
  any: [/^B\.$/i, /^B\.e$/i, /^Ç\.a$/i, /^Ç\.$/i, /^C\.a$/i, /^C\.$/i, /^Ş\.$/i]
}, o1 = {
  narrow: /^(a|p|gecəyarı|gün|səhər|gündüz|axşam|gecə)$/i,
  any: /^(am|pm|a\.m\.|p\.m\.|AM|PM|gecəyarı|gün|səhər|gündüz|axşam|gecə)$/i
}, s1 = {
  any: {
    am: /^a$/i,
    pm: /^p$/i,
    midnight: /^gecəyarı$/i,
    noon: /^gün$/i,
    morning: /səhər$/i,
    afternoon: /gündüz$/i,
    evening: /axşam$/i,
    night: /gecə$/i
  }
}, d1 = {
  ordinalNumber: le({
    matchPattern: Kg,
    parsePattern: Yg,
    valueCallback: function(i) {
      return parseInt(i, 10);
    }
  }),
  era: P({
    matchPatterns: Jg,
    defaultMatchWidth: "wide",
    parsePatterns: Qg,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: e1,
    defaultMatchWidth: "wide",
    parsePatterns: n1,
    defaultParseWidth: "any",
    valueCallback: function(i) {
      return i + 1;
    }
  }),
  month: P({
    matchPatterns: i1,
    defaultMatchWidth: "wide",
    parsePatterns: a1,
    defaultParseWidth: "narrow"
  }),
  day: P({
    matchPatterns: t1,
    defaultMatchWidth: "wide",
    parsePatterns: r1,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: o1,
    defaultMatchWidth: "any",
    parsePatterns: s1,
    defaultParseWidth: "any"
  })
}, u1 = {
  code: "az",
  formatDistance: Tg,
  formatLong: Eg,
  formatRelative: Lg,
  localize: Gg,
  match: d1,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
};
const f1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: u1
}, Symbol.toStringTag, { value: "Module" })), l1 = /* @__PURE__ */ te(f1);
function Kn(e, i) {
  if (e.one !== void 0 && i === 1)
    return e.one;
  var d = i % 10, a = i % 100;
  return d === 1 && a !== 11 ? e.singularNominative.replace("{{count}}", String(i)) : d >= 2 && d <= 4 && (a < 10 || a > 20) ? e.singularGenitive.replace("{{count}}", String(i)) : e.pluralGenitive.replace("{{count}}", String(i));
}
function Xe(e) {
  return function(i, d) {
    return d && d.addSuffix ? d.comparison && d.comparison > 0 ? e.future ? Kn(e.future, i) : "праз " + Kn(e.regular, i) : e.past ? Kn(e.past, i) : Kn(e.regular, i) + " таму" : Kn(e.regular, i);
  };
}
var c1 = function(i, d) {
  return d && d.addSuffix ? d.comparison && d.comparison > 0 ? "праз паўхвіліны" : "паўхвіліны таму" : "паўхвіліны";
}, m1 = {
  lessThanXSeconds: Xe({
    regular: {
      one: "менш за секунду",
      singularNominative: "менш за {{count}} секунду",
      singularGenitive: "менш за {{count}} секунды",
      pluralGenitive: "менш за {{count}} секунд"
    },
    future: {
      one: "менш, чым праз секунду",
      singularNominative: "менш, чым праз {{count}} секунду",
      singularGenitive: "менш, чым праз {{count}} секунды",
      pluralGenitive: "менш, чым праз {{count}} секунд"
    }
  }),
  xSeconds: Xe({
    regular: {
      singularNominative: "{{count}} секунда",
      singularGenitive: "{{count}} секунды",
      pluralGenitive: "{{count}} секунд"
    },
    past: {
      singularNominative: "{{count}} секунду таму",
      singularGenitive: "{{count}} секунды таму",
      pluralGenitive: "{{count}} секунд таму"
    },
    future: {
      singularNominative: "праз {{count}} секунду",
      singularGenitive: "праз {{count}} секунды",
      pluralGenitive: "праз {{count}} секунд"
    }
  }),
  halfAMinute: c1,
  lessThanXMinutes: Xe({
    regular: {
      one: "менш за хвіліну",
      singularNominative: "менш за {{count}} хвіліну",
      singularGenitive: "менш за {{count}} хвіліны",
      pluralGenitive: "менш за {{count}} хвілін"
    },
    future: {
      one: "менш, чым праз хвіліну",
      singularNominative: "менш, чым праз {{count}} хвіліну",
      singularGenitive: "менш, чым праз {{count}} хвіліны",
      pluralGenitive: "менш, чым праз {{count}} хвілін"
    }
  }),
  xMinutes: Xe({
    regular: {
      singularNominative: "{{count}} хвіліна",
      singularGenitive: "{{count}} хвіліны",
      pluralGenitive: "{{count}} хвілін"
    },
    past: {
      singularNominative: "{{count}} хвіліну таму",
      singularGenitive: "{{count}} хвіліны таму",
      pluralGenitive: "{{count}} хвілін таму"
    },
    future: {
      singularNominative: "праз {{count}} хвіліну",
      singularGenitive: "праз {{count}} хвіліны",
      pluralGenitive: "праз {{count}} хвілін"
    }
  }),
  aboutXHours: Xe({
    regular: {
      singularNominative: "каля {{count}} гадзіны",
      singularGenitive: "каля {{count}} гадзін",
      pluralGenitive: "каля {{count}} гадзін"
    },
    future: {
      singularNominative: "прыблізна праз {{count}} гадзіну",
      singularGenitive: "прыблізна праз {{count}} гадзіны",
      pluralGenitive: "прыблізна праз {{count}} гадзін"
    }
  }),
  xHours: Xe({
    regular: {
      singularNominative: "{{count}} гадзіна",
      singularGenitive: "{{count}} гадзіны",
      pluralGenitive: "{{count}} гадзін"
    },
    past: {
      singularNominative: "{{count}} гадзіну таму",
      singularGenitive: "{{count}} гадзіны таму",
      pluralGenitive: "{{count}} гадзін таму"
    },
    future: {
      singularNominative: "праз {{count}} гадзіну",
      singularGenitive: "праз {{count}} гадзіны",
      pluralGenitive: "праз {{count}} гадзін"
    }
  }),
  xDays: Xe({
    regular: {
      singularNominative: "{{count}} дзень",
      singularGenitive: "{{count}} дні",
      pluralGenitive: "{{count}} дзён"
    }
  }),
  aboutXWeeks: Xe({
    regular: {
      singularNominative: "каля {{count}} месяца",
      // TODO
      singularGenitive: "каля {{count}} месяцаў",
      // TODO
      pluralGenitive: "каля {{count}} месяцаў"
      // TODO
    },
    future: {
      singularNominative: "прыблізна праз {{count}} месяц",
      // TODO
      singularGenitive: "прыблізна праз {{count}} месяцы",
      // TODO
      pluralGenitive: "прыблізна праз {{count}} месяцаў"
      // TODO
    }
  }),
  xWeeks: Xe({
    regular: {
      singularNominative: "{{count}} месяц",
      singularGenitive: "{{count}} месяцы",
      pluralGenitive: "{{count}} месяцаў"
    }
  }),
  aboutXMonths: Xe({
    regular: {
      singularNominative: "каля {{count}} месяца",
      singularGenitive: "каля {{count}} месяцаў",
      pluralGenitive: "каля {{count}} месяцаў"
    },
    future: {
      singularNominative: "прыблізна праз {{count}} месяц",
      singularGenitive: "прыблізна праз {{count}} месяцы",
      pluralGenitive: "прыблізна праз {{count}} месяцаў"
    }
  }),
  xMonths: Xe({
    regular: {
      singularNominative: "{{count}} месяц",
      singularGenitive: "{{count}} месяцы",
      pluralGenitive: "{{count}} месяцаў"
    }
  }),
  aboutXYears: Xe({
    regular: {
      singularNominative: "каля {{count}} года",
      singularGenitive: "каля {{count}} гадоў",
      pluralGenitive: "каля {{count}} гадоў"
    },
    future: {
      singularNominative: "прыблізна праз {{count}} год",
      singularGenitive: "прыблізна праз {{count}} гады",
      pluralGenitive: "прыблізна праз {{count}} гадоў"
    }
  }),
  xYears: Xe({
    regular: {
      singularNominative: "{{count}} год",
      singularGenitive: "{{count}} гады",
      pluralGenitive: "{{count}} гадоў"
    }
  }),
  overXYears: Xe({
    regular: {
      singularNominative: "больш за {{count}} год",
      singularGenitive: "больш за {{count}} гады",
      pluralGenitive: "больш за {{count}} гадоў"
    },
    future: {
      singularNominative: "больш, чым праз {{count}} год",
      singularGenitive: "больш, чым праз {{count}} гады",
      pluralGenitive: "больш, чым праз {{count}} гадоў"
    }
  }),
  almostXYears: Xe({
    regular: {
      singularNominative: "амаль {{count}} год",
      singularGenitive: "амаль {{count}} гады",
      pluralGenitive: "амаль {{count}} гадоў"
    },
    future: {
      singularNominative: "амаль праз {{count}} год",
      singularGenitive: "амаль праз {{count}} гады",
      pluralGenitive: "амаль праз {{count}} гадоў"
    }
  })
}, v1 = function(i, d, a) {
  return a = a || {}, m1[i](d, a);
}, h1 = {
  full: "EEEE, d MMMM y 'г.'",
  long: "d MMMM y 'г.'",
  medium: "d MMM y 'г.'",
  short: "dd.MM.y"
}, g1 = {
  full: "H:mm:ss zzzz",
  long: "H:mm:ss z",
  medium: "H:mm:ss",
  short: "H:mm"
}, p1 = {
  any: "{{date}}, {{time}}"
}, b1 = {
  date: I({
    formats: h1,
    defaultWidth: "full"
  }),
  time: I({
    formats: g1,
    defaultWidth: "full"
  }),
  dateTime: I({
    formats: p1,
    defaultWidth: "any"
  })
}, nr = ["нядзелю", "панядзелак", "аўторак", "сераду", "чацвер", "пятніцу", "суботу"];
function y1(e) {
  var i = nr[e];
  switch (e) {
    case 0:
    case 3:
    case 5:
    case 6:
      return "'у мінулую " + i + " а' p";
    case 1:
    case 2:
    case 4:
      return "'у мінулы " + i + " а' p";
  }
}
function Su(e) {
  var i = nr[e];
  return "'у " + i + " а' p";
}
function k1(e) {
  var i = nr[e];
  switch (e) {
    case 0:
    case 3:
    case 5:
    case 6:
      return "'у наступную " + i + " а' p";
    case 1:
    case 2:
    case 4:
      return "'у наступны " + i + " а' p";
  }
}
var w1 = function(i, d, a) {
  var t = Vn(i), o = t.getUTCDay();
  return Ne(t, d, a) ? Su(o) : y1(o);
}, _1 = function(i, d, a) {
  var t = Vn(i), o = t.getUTCDay();
  return Ne(t, d, a) ? Su(o) : k1(o);
}, $1 = {
  lastWeek: w1,
  yesterday: "'учора а' p",
  today: "'сёння а' p",
  tomorrow: "'заўтра а' p",
  nextWeek: _1,
  other: "P"
}, P1 = function(i, d, a, t) {
  var o = $1[i];
  return typeof o == "function" ? o(d, a, t) : o;
}, M1 = {
  narrow: ["да н.э.", "н.э."],
  abbreviated: ["да н. э.", "н. э."],
  wide: ["да нашай эры", "нашай эры"]
}, j1 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1-ы кв.", "2-і кв.", "3-і кв.", "4-ы кв."],
  wide: ["1-ы квартал", "2-і квартал", "3-і квартал", "4-ы квартал"]
}, S1 = {
  narrow: ["С", "Л", "С", "К", "М", "Ч", "Л", "Ж", "В", "К", "Л", "С"],
  abbreviated: ["студз.", "лют.", "сак.", "крас.", "май", "чэрв.", "ліп.", "жн.", "вер.", "кастр.", "ліст.", "снеж."],
  wide: ["студзень", "люты", "сакавік", "красавік", "май", "чэрвень", "ліпень", "жнівень", "верасень", "кастрычнік", "лістапад", "снежань"]
}, z1 = {
  narrow: ["С", "Л", "С", "К", "М", "Ч", "Л", "Ж", "В", "К", "Л", "С"],
  abbreviated: ["студз.", "лют.", "сак.", "крас.", "мая", "чэрв.", "ліп.", "жн.", "вер.", "кастр.", "ліст.", "снеж."],
  wide: ["студзеня", "лютага", "сакавіка", "красавіка", "мая", "чэрвеня", "ліпеня", "жніўня", "верасня", "кастрычніка", "лістапада", "снежня"]
}, O1 = {
  narrow: ["Н", "П", "А", "С", "Ч", "П", "С"],
  short: ["нд", "пн", "аў", "ср", "чц", "пт", "сб"],
  abbreviated: ["нядз", "пан", "аўт", "сер", "чац", "пят", "суб"],
  wide: ["нядзеля", "панядзелак", "аўторак", "серада", "чацвер", "пятніца", "субота"]
}, W1 = {
  narrow: {
    am: "ДП",
    pm: "ПП",
    midnight: "поўн.",
    noon: "поўд.",
    morning: "ран.",
    afternoon: "дзень",
    evening: "веч.",
    night: "ноч"
  },
  abbreviated: {
    am: "ДП",
    pm: "ПП",
    midnight: "поўн.",
    noon: "поўд.",
    morning: "ран.",
    afternoon: "дзень",
    evening: "веч.",
    night: "ноч"
  },
  wide: {
    am: "ДП",
    pm: "ПП",
    midnight: "поўнач",
    noon: "поўдзень",
    morning: "раніца",
    afternoon: "дзень",
    evening: "вечар",
    night: "ноч"
  }
}, D1 = {
  narrow: {
    am: "ДП",
    pm: "ПП",
    midnight: "поўн.",
    noon: "поўд.",
    morning: "ран.",
    afternoon: "дня",
    evening: "веч.",
    night: "ночы"
  },
  abbreviated: {
    am: "ДП",
    pm: "ПП",
    midnight: "поўн.",
    noon: "поўд.",
    morning: "ран.",
    afternoon: "дня",
    evening: "веч.",
    night: "ночы"
  },
  wide: {
    am: "ДП",
    pm: "ПП",
    midnight: "поўнач",
    noon: "поўдзень",
    morning: "раніцы",
    afternoon: "дня",
    evening: "вечара",
    night: "ночы"
  }
}, C1 = function(i, d) {
  var a = String(d == null ? void 0 : d.unit), t = Number(i), o;
  return a === "date" ? o = "-га" : a === "hour" || a === "minute" || a === "second" ? o = "-я" : o = (t % 10 === 2 || t % 10 === 3) && t % 100 !== 12 && t % 100 !== 13 ? "-і" : "-ы", t + o;
}, I1 = {
  ordinalNumber: C1,
  era: $({
    values: M1,
    defaultWidth: "wide"
  }),
  quarter: $({
    values: j1,
    defaultWidth: "wide",
    argumentCallback: function(i) {
      return i - 1;
    }
  }),
  month: $({
    values: S1,
    defaultWidth: "wide",
    formattingValues: z1,
    defaultFormattingWidth: "wide"
  }),
  day: $({
    values: O1,
    defaultWidth: "wide"
  }),
  dayPeriod: $({
    values: W1,
    defaultWidth: "any",
    formattingValues: D1,
    defaultFormattingWidth: "wide"
  })
}, T1 = /^(\d+)(-?(е|я|га|і|ы|ае|ая|яя|шы|гі|ці|ты|мы))?/i, N1 = /\d+/i, x1 = {
  narrow: /^((да )?н\.?\s?э\.?)/i,
  abbreviated: /^((да )?н\.?\s?э\.?)/i,
  wide: /^(да нашай эры|нашай эры|наша эра)/i
}, F1 = {
  any: [/^д/i, /^н/i]
}, E1 = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234](-?[ыі]?)? кв.?/i,
  wide: /^[1234](-?[ыі]?)? квартал/i
}, R1 = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, L1 = {
  narrow: /^[слкмчжв]/i,
  abbreviated: /^(студз|лют|сак|крас|ма[йя]|чэрв|ліп|жн|вер|кастр|ліст|снеж)\.?/i,
  wide: /^(студзен[ья]|лют(ы|ага)|сакавіка?|красавіка?|ма[йя]|чэрвен[ья]|ліпен[ья]|жні(вень|ўня)|верас(ень|ня)|кастрычніка?|лістапада?|снеж(ань|ня))/i
}, q1 = {
  narrow: [/^с/i, /^л/i, /^с/i, /^к/i, /^м/i, /^ч/i, /^л/i, /^ж/i, /^в/i, /^к/i, /^л/i, /^с/i],
  any: [/^ст/i, /^лю/i, /^са/i, /^кр/i, /^ма/i, /^ч/i, /^ліп/i, /^ж/i, /^в/i, /^ка/i, /^ліс/i, /^сн/i]
}, Z1 = {
  narrow: /^[нпасч]/i,
  short: /^(нд|ня|пн|па|аў|ат|ср|се|чц|ча|пт|пя|сб|су)\.?/i,
  abbreviated: /^(нядз?|ндз|пнд|пан|аўт|срд|сер|чцв|чац|птн|пят|суб).?/i,
  wide: /^(нядзел[яі]|панядзел(ак|ка)|аўтор(ак|ка)|серад[аы]|чацв(ер|ярга)|пятніц[аы]|субот[аы])/i
}, A1 = {
  narrow: [/^н/i, /^п/i, /^а/i, /^с/i, /^ч/i, /^п/i, /^с/i],
  any: [/^н/i, /^п[ан]/i, /^а/i, /^с[ер]/i, /^ч/i, /^п[ят]/i, /^с[уб]/i]
}, V1 = {
  narrow: /^([дп]п|поўн\.?|поўд\.?|ран\.?|дзень|дня|веч\.?|ночы?)/i,
  abbreviated: /^([дп]п|поўн\.?|поўд\.?|ран\.?|дзень|дня|веч\.?|ночы?)/i,
  wide: /^([дп]п|поўнач|поўдзень|раніц[аы]|дзень|дня|вечара?|ночы?)/i
}, H1 = {
  any: {
    am: /^дп/i,
    pm: /^пп/i,
    midnight: /^поўн/i,
    noon: /^поўд/i,
    morning: /^р/i,
    afternoon: /^д[зн]/i,
    evening: /^в/i,
    night: /^н/i
  }
}, U1 = {
  ordinalNumber: le({
    matchPattern: T1,
    parsePattern: N1,
    valueCallback: function(i) {
      return parseInt(i, 10);
    }
  }),
  era: P({
    matchPatterns: x1,
    defaultMatchWidth: "wide",
    parsePatterns: F1,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: E1,
    defaultMatchWidth: "wide",
    parsePatterns: R1,
    defaultParseWidth: "any",
    valueCallback: function(i) {
      return i + 1;
    }
  }),
  month: P({
    matchPatterns: L1,
    defaultMatchWidth: "wide",
    parsePatterns: q1,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: Z1,
    defaultMatchWidth: "wide",
    parsePatterns: A1,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: V1,
    defaultMatchWidth: "wide",
    parsePatterns: H1,
    defaultParseWidth: "any"
  })
}, B1 = {
  code: "be",
  formatDistance: v1,
  formatLong: b1,
  formatRelative: P1,
  localize: I1,
  match: U1,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
};
const X1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: B1
}, Symbol.toStringTag, { value: "Module" })), G1 = /* @__PURE__ */ te(X1);
var K1 = {
  lessThanXSeconds: {
    one: "по-малко от секунда",
    other: "по-малко от {{count}} секунди"
  },
  xSeconds: {
    one: "1 секунда",
    other: "{{count}} секунди"
  },
  halfAMinute: "половин минута",
  lessThanXMinutes: {
    one: "по-малко от минута",
    other: "по-малко от {{count}} минути"
  },
  xMinutes: {
    one: "1 минута",
    other: "{{count}} минути"
  },
  aboutXHours: {
    one: "около час",
    other: "около {{count}} часа"
  },
  xHours: {
    one: "1 час",
    other: "{{count}} часа"
  },
  xDays: {
    one: "1 ден",
    other: "{{count}} дни"
  },
  aboutXWeeks: {
    one: "около седмица",
    other: "около {{count}} седмици"
  },
  xWeeks: {
    one: "1 седмица",
    other: "{{count}} седмици"
  },
  aboutXMonths: {
    one: "около месец",
    other: "около {{count}} месеца"
  },
  xMonths: {
    one: "1 месец",
    other: "{{count}} месеца"
  },
  aboutXYears: {
    one: "около година",
    other: "около {{count}} години"
  },
  xYears: {
    one: "1 година",
    other: "{{count}} години"
  },
  overXYears: {
    one: "над година",
    other: "над {{count}} години"
  },
  almostXYears: {
    one: "почти година",
    other: "почти {{count}} години"
  }
}, Y1 = function(i, d, a) {
  var t, o = K1[i];
  return typeof o == "string" ? t = o : d === 1 ? t = o.one : t = o.other.replace("{{count}}", String(d)), a != null && a.addSuffix ? a.comparison && a.comparison > 0 ? "след " + t : "преди " + t : t;
}, J1 = {
  full: "EEEE, dd MMMM yyyy",
  long: "dd MMMM yyyy",
  medium: "dd MMM yyyy",
  short: "dd/MM/yyyy"
}, Q1 = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "H:mm"
}, ep = {
  any: "{{date}} {{time}}"
}, np = {
  date: I({
    formats: J1,
    defaultWidth: "full"
  }),
  time: I({
    formats: Q1,
    defaultWidth: "full"
  }),
  dateTime: I({
    formats: ep,
    defaultWidth: "any"
  })
}, ir = ["неделя", "понеделник", "вторник", "сряда", "четвъртък", "петък", "събота"];
function ip(e) {
  var i = ir[e];
  switch (e) {
    case 0:
    case 3:
    case 6:
      return "'миналата " + i + " в' p";
    case 1:
    case 2:
    case 4:
    case 5:
      return "'миналия " + i + " в' p";
  }
}
function zu(e) {
  var i = ir[e];
  return e === 2 ? "'във " + i + " в' p" : "'в " + i + " в' p";
}
function ap(e) {
  var i = ir[e];
  switch (e) {
    case 0:
    case 3:
    case 6:
      return "'следващата " + i + " в' p";
    case 1:
    case 2:
    case 4:
    case 5:
      return "'следващия " + i + " в' p";
  }
}
var tp = function(i, d, a) {
  var t = Vn(i), o = t.getUTCDay();
  return Ne(t, d, a) ? zu(o) : ip(o);
}, rp = function(i, d, a) {
  var t = Vn(i), o = t.getUTCDay();
  return Ne(t, d, a) ? zu(o) : ap(o);
}, op = {
  lastWeek: tp,
  yesterday: "'вчера в' p",
  today: "'днес в' p",
  tomorrow: "'утре в' p",
  nextWeek: rp,
  other: "P"
}, sp = function(i, d, a, t) {
  var o = op[i];
  return typeof o == "function" ? o(d, a, t) : o;
}, dp = {
  narrow: ["пр.н.е.", "н.е."],
  abbreviated: ["преди н. е.", "н. е."],
  wide: ["преди новата ера", "новата ера"]
}, up = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1-во тримес.", "2-ро тримес.", "3-то тримес.", "4-то тримес."],
  wide: ["1-во тримесечие", "2-ро тримесечие", "3-то тримесечие", "4-то тримесечие"]
}, fp = {
  abbreviated: ["яну", "фев", "мар", "апр", "май", "юни", "юли", "авг", "сеп", "окт", "ное", "дек"],
  wide: ["януари", "февруари", "март", "април", "май", "юни", "юли", "август", "септември", "октомври", "ноември", "декември"]
}, lp = {
  narrow: ["Н", "П", "В", "С", "Ч", "П", "С"],
  short: ["нд", "пн", "вт", "ср", "чт", "пт", "сб"],
  abbreviated: ["нед", "пон", "вто", "сря", "чет", "пет", "съб"],
  wide: ["неделя", "понеделник", "вторник", "сряда", "четвъртък", "петък", "събота"]
}, cp = {
  wide: {
    am: "преди обяд",
    pm: "след обяд",
    midnight: "в полунощ",
    noon: "на обяд",
    morning: "сутринта",
    afternoon: "следобед",
    evening: "вечерта",
    night: "през нощта"
  }
};
function mp(e) {
  return e === "year" || e === "week" || e === "minute" || e === "second";
}
function vp(e) {
  return e === "quarter";
}
function Dn(e, i, d, a, t) {
  var o = vp(i) ? t : mp(i) ? a : d;
  return e + "-" + o;
}
var hp = function(i, d) {
  var a = Number(i), t = d == null ? void 0 : d.unit;
  if (a === 0)
    return Dn(0, t, "ев", "ева", "ево");
  if (a % 1e3 === 0)
    return Dn(a, t, "ен", "на", "но");
  if (a % 100 === 0)
    return Dn(a, t, "тен", "тна", "тно");
  var o = a % 100;
  if (o > 20 || o < 10)
    switch (o % 10) {
      case 1:
        return Dn(a, t, "ви", "ва", "во");
      case 2:
        return Dn(a, t, "ри", "ра", "ро");
      case 7:
      case 8:
        return Dn(a, t, "ми", "ма", "мо");
    }
  return Dn(a, t, "ти", "та", "то");
}, gp = {
  ordinalNumber: hp,
  era: $({
    values: dp,
    defaultWidth: "wide"
  }),
  quarter: $({
    values: up,
    defaultWidth: "wide",
    argumentCallback: function(i) {
      return i - 1;
    }
  }),
  month: $({
    values: fp,
    defaultWidth: "wide"
  }),
  day: $({
    values: lp,
    defaultWidth: "wide"
  }),
  dayPeriod: $({
    values: cp,
    defaultWidth: "wide"
  })
}, pp = /^(\d+)(-?[врмт][аи]|-?т?(ен|на)|-?(ев|ева))?/i, bp = /\d+/i, yp = {
  narrow: /^((пр)?н\.?\s?е\.?)/i,
  abbreviated: /^((пр)?н\.?\s?е\.?)/i,
  wide: /^(преди новата ера|новата ера|нова ера)/i
}, kp = {
  any: [/^п/i, /^н/i]
}, wp = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234](-?[врт]?o?)? тримес.?/i,
  wide: /^[1234](-?[врт]?о?)? тримесечие/i
}, _p = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, $p = {
  narrow: /^[нпвсч]/i,
  short: /^(нд|пн|вт|ср|чт|пт|сб)/i,
  abbreviated: /^(нед|пон|вто|сря|чет|пет|съб)/i,
  wide: /^(неделя|понеделник|вторник|сряда|четвъртък|петък|събота)/i
}, Pp = {
  narrow: [/^н/i, /^п/i, /^в/i, /^с/i, /^ч/i, /^п/i, /^с/i],
  any: [/^н[ед]/i, /^п[он]/i, /^вт/i, /^ср/i, /^ч[ет]/i, /^п[ет]/i, /^с[ъб]/i]
}, Mp = {
  abbreviated: /^(яну|фев|мар|апр|май|юни|юли|авг|сеп|окт|ное|дек)/i,
  wide: /^(януари|февруари|март|април|май|юни|юли|август|септември|октомври|ноември|декември)/i
}, jp = {
  any: [/^я/i, /^ф/i, /^мар/i, /^ап/i, /^май/i, /^юн/i, /^юл/i, /^ав/i, /^се/i, /^окт/i, /^но/i, /^де/i]
}, Sp = {
  any: /^(преди о|след о|в по|на о|през|веч|сут|следо)/i
}, zp = {
  any: {
    am: /^преди о/i,
    pm: /^след о/i,
    midnight: /^в пол/i,
    noon: /^на об/i,
    morning: /^сут/i,
    afternoon: /^следо/i,
    evening: /^веч/i,
    night: /^през н/i
  }
}, Op = {
  ordinalNumber: le({
    matchPattern: pp,
    parsePattern: bp,
    valueCallback: function(i) {
      return parseInt(i, 10);
    }
  }),
  era: P({
    matchPatterns: yp,
    defaultMatchWidth: "wide",
    parsePatterns: kp,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: wp,
    defaultMatchWidth: "wide",
    parsePatterns: _p,
    defaultParseWidth: "any",
    valueCallback: function(i) {
      return i + 1;
    }
  }),
  month: P({
    matchPatterns: Mp,
    defaultMatchWidth: "wide",
    parsePatterns: jp,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: $p,
    defaultMatchWidth: "wide",
    parsePatterns: Pp,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: Sp,
    defaultMatchWidth: "any",
    parsePatterns: zp,
    defaultParseWidth: "any"
  })
}, Wp = {
  code: "bg",
  formatDistance: Y1,
  formatLong: np,
  formatRelative: sp,
  localize: gp,
  match: Op,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
};
const Dp = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Wp
}, Symbol.toStringTag, { value: "Module" })), Cp = /* @__PURE__ */ te(Dp);
var Ip = {
  locale: {
    1: "১",
    2: "২",
    3: "৩",
    4: "৪",
    5: "৫",
    6: "৬",
    7: "৭",
    8: "৮",
    9: "৯",
    0: "০"
  },
  number: {
    "১": "1",
    "২": "2",
    "৩": "3",
    "৪": "4",
    "৫": "5",
    "৬": "6",
    "৭": "7",
    "৮": "8",
    "৯": "9",
    "০": "0"
  }
}, Tp = {
  narrow: ["খ্রিঃপূঃ", "খ্রিঃ"],
  abbreviated: ["খ্রিঃপূর্ব", "খ্রিঃ"],
  wide: ["খ্রিস্টপূর্ব", "খ্রিস্টাব্দ"]
}, Np = {
  narrow: ["১", "২", "৩", "৪"],
  abbreviated: ["১ত্রৈ", "২ত্রৈ", "৩ত্রৈ", "৪ত্রৈ"],
  wide: ["১ম ত্রৈমাসিক", "২য় ত্রৈমাসিক", "৩য় ত্রৈমাসিক", "৪র্থ ত্রৈমাসিক"]
}, xp = {
  narrow: ["জানু", "ফেব্রু", "মার্চ", "এপ্রিল", "মে", "জুন", "জুলাই", "আগস্ট", "সেপ্ট", "অক্টো", "নভে", "ডিসে"],
  abbreviated: ["জানু", "ফেব্রু", "মার্চ", "এপ্রিল", "মে", "জুন", "জুলাই", "আগস্ট", "সেপ্ট", "অক্টো", "নভে", "ডিসে"],
  wide: ["জানুয়ারি", "ফেব্রুয়ারি", "মার্চ", "এপ্রিল", "মে", "জুন", "জুলাই", "আগস্ট", "সেপ্টেম্বর", "অক্টোবর", "নভেম্বর", "ডিসেম্বর"]
}, Fp = {
  narrow: ["র", "সো", "ম", "বু", "বৃ", "শু", "শ"],
  short: ["রবি", "সোম", "মঙ্গল", "বুধ", "বৃহ", "শুক্র", "শনি"],
  abbreviated: ["রবি", "সোম", "মঙ্গল", "বুধ", "বৃহ", "শুক্র", "শনি"],
  wide: ["রবিবার", "সোমবার", "মঙ্গলবার", "বুধবার", "বৃহস্পতিবার ", "শুক্রবার", "শনিবার"]
}, Ep = {
  narrow: {
    am: "পূ",
    pm: "অপ",
    midnight: "মধ্যরাত",
    noon: "মধ্যাহ্ন",
    morning: "সকাল",
    afternoon: "বিকাল",
    evening: "সন্ধ্যা",
    night: "রাত"
  },
  abbreviated: {
    am: "পূর্বাহ্ন",
    pm: "অপরাহ্ন",
    midnight: "মধ্যরাত",
    noon: "মধ্যাহ্ন",
    morning: "সকাল",
    afternoon: "বিকাল",
    evening: "সন্ধ্যা",
    night: "রাত"
  },
  wide: {
    am: "পূর্বাহ্ন",
    pm: "অপরাহ্ন",
    midnight: "মধ্যরাত",
    noon: "মধ্যাহ্ন",
    morning: "সকাল",
    afternoon: "বিকাল",
    evening: "সন্ধ্যা",
    night: "রাত"
  }
}, Rp = {
  narrow: {
    am: "পূ",
    pm: "অপ",
    midnight: "মধ্যরাত",
    noon: "মধ্যাহ্ন",
    morning: "সকাল",
    afternoon: "বিকাল",
    evening: "সন্ধ্যা",
    night: "রাত"
  },
  abbreviated: {
    am: "পূর্বাহ্ন",
    pm: "অপরাহ্ন",
    midnight: "মধ্যরাত",
    noon: "মধ্যাহ্ন",
    morning: "সকাল",
    afternoon: "বিকাল",
    evening: "সন্ধ্যা",
    night: "রাত"
  },
  wide: {
    am: "পূর্বাহ্ন",
    pm: "অপরাহ্ন",
    midnight: "মধ্যরাত",
    noon: "মধ্যাহ্ন",
    morning: "সকাল",
    afternoon: "বিকাল",
    evening: "সন্ধ্যা",
    night: "রাত"
  }
};
function Lp(e, i) {
  if (e > 18 && e <= 31)
    return i + "শে";
  switch (e) {
    case 1:
      return i + "লা";
    case 2:
    case 3:
      return i + "রা";
    case 4:
      return i + "ঠা";
    default:
      return i + "ই";
  }
}
var qp = function(i, d) {
  var a = Number(i), t = Ou(a), o = d == null ? void 0 : d.unit;
  if (o === "date")
    return Lp(a, t);
  if (a > 10 || a === 0) return t + "তম";
  var m = a % 10;
  switch (m) {
    case 2:
    case 3:
      return t + "য়";
    case 4:
      return t + "র্থ";
    case 6:
      return t + "ষ্ঠ";
    default:
      return t + "ম";
  }
};
function Ou(e) {
  return e.toString().replace(/\d/g, function(i) {
    return Ip.locale[i];
  });
}
var Zp = {
  ordinalNumber: qp,
  era: $({
    values: Tp,
    defaultWidth: "wide"
  }),
  quarter: $({
    values: Np,
    defaultWidth: "wide",
    argumentCallback: function(i) {
      return i - 1;
    }
  }),
  month: $({
    values: xp,
    defaultWidth: "wide"
  }),
  day: $({
    values: Fp,
    defaultWidth: "wide"
  }),
  dayPeriod: $({
    values: Ep,
    defaultWidth: "wide",
    formattingValues: Rp,
    defaultFormattingWidth: "wide"
  })
}, Ap = {
  lessThanXSeconds: {
    one: "প্রায় ১ সেকেন্ড",
    other: "প্রায় {{count}} সেকেন্ড"
  },
  xSeconds: {
    one: "১ সেকেন্ড",
    other: "{{count}} সেকেন্ড"
  },
  halfAMinute: "আধ মিনিট",
  lessThanXMinutes: {
    one: "প্রায় ১ মিনিট",
    other: "প্রায় {{count}} মিনিট"
  },
  xMinutes: {
    one: "১ মিনিট",
    other: "{{count}} মিনিট"
  },
  aboutXHours: {
    one: "প্রায় ১ ঘন্টা",
    other: "প্রায় {{count}} ঘন্টা"
  },
  xHours: {
    one: "১ ঘন্টা",
    other: "{{count}} ঘন্টা"
  },
  xDays: {
    one: "১ দিন",
    other: "{{count}} দিন"
  },
  aboutXWeeks: {
    one: "প্রায় ১ সপ্তাহ",
    other: "প্রায় {{count}} সপ্তাহ"
  },
  xWeeks: {
    one: "১ সপ্তাহ",
    other: "{{count}} সপ্তাহ"
  },
  aboutXMonths: {
    one: "প্রায় ১ মাস",
    other: "প্রায় {{count}} মাস"
  },
  xMonths: {
    one: "১ মাস",
    other: "{{count}} মাস"
  },
  aboutXYears: {
    one: "প্রায় ১ বছর",
    other: "প্রায় {{count}} বছর"
  },
  xYears: {
    one: "১ বছর",
    other: "{{count}} বছর"
  },
  overXYears: {
    one: "১ বছরের বেশি",
    other: "{{count}} বছরের বেশি"
  },
  almostXYears: {
    one: "প্রায় ১ বছর",
    other: "প্রায় {{count}} বছর"
  }
}, Vp = function(i, d, a) {
  var t, o = Ap[i];
  return typeof o == "string" ? t = o : d === 1 ? t = o.one : t = o.other.replace("{{count}}", Ou(d)), a != null && a.addSuffix ? a.comparison && a.comparison > 0 ? t + " এর মধ্যে" : t + " আগে" : t;
}, Hp = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, Up = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, Bp = {
  full: "{{date}} {{time}} 'সময়'",
  long: "{{date}} {{time}} 'সময়'",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Xp = {
  date: I({
    formats: Hp,
    defaultWidth: "full"
  }),
  time: I({
    formats: Up,
    defaultWidth: "full"
  }),
  dateTime: I({
    formats: Bp,
    defaultWidth: "full"
  })
}, Gp = {
  lastWeek: "'গত' eeee 'সময়' p",
  yesterday: "'গতকাল' 'সময়' p",
  today: "'আজ' 'সময়' p",
  tomorrow: "'আগামীকাল' 'সময়' p",
  nextWeek: "eeee 'সময়' p",
  other: "P"
}, Kp = function(i, d, a, t) {
  return Gp[i];
}, Yp = /^(\d+)(ম|য়|র্থ|ষ্ঠ|শে|ই|তম)?/i, Jp = /\d+/i, Qp = {
  narrow: /^(খ্রিঃপূঃ|খ্রিঃ)/i,
  abbreviated: /^(খ্রিঃপূর্ব|খ্রিঃ)/i,
  wide: /^(খ্রিস্টপূর্ব|খ্রিস্টাব্দ)/i
}, eb = {
  narrow: [/^খ্রিঃপূঃ/i, /^খ্রিঃ/i],
  abbreviated: [/^খ্রিঃপূর্ব/i, /^খ্রিঃ/i],
  wide: [/^খ্রিস্টপূর্ব/i, /^খ্রিস্টাব্দ/i]
}, nb = {
  narrow: /^[১২৩৪]/i,
  abbreviated: /^[১২৩৪]ত্রৈ/i,
  wide: /^[১২৩৪](ম|য়|র্থ)? ত্রৈমাসিক/i
}, ib = {
  any: [/১/i, /২/i, /৩/i, /৪/i]
}, ab = {
  narrow: /^(জানু|ফেব্রু|মার্চ|এপ্রিল|মে|জুন|জুলাই|আগস্ট|সেপ্ট|অক্টো|নভে|ডিসে)/i,
  abbreviated: /^(জানু|ফেব্রু|মার্চ|এপ্রিল|মে|জুন|জুলাই|আগস্ট|সেপ্ট|অক্টো|নভে|ডিসে)/i,
  wide: /^(জানুয়ারি|ফেব্রুয়ারি|মার্চ|এপ্রিল|মে|জুন|জুলাই|আগস্ট|সেপ্টেম্বর|অক্টোবর|নভেম্বর|ডিসেম্বর)/i
}, tb = {
  any: [/^জানু/i, /^ফেব্রু/i, /^মার্চ/i, /^এপ্রিল/i, /^মে/i, /^জুন/i, /^জুলাই/i, /^আগস্ট/i, /^সেপ্ট/i, /^অক্টো/i, /^নভে/i, /^ডিসে/i]
}, rb = {
  narrow: /^(র|সো|ম|বু|বৃ|শু|শ)+/i,
  short: /^(রবি|সোম|মঙ্গল|বুধ|বৃহ|শুক্র|শনি)+/i,
  abbreviated: /^(রবি|সোম|মঙ্গল|বুধ|বৃহ|শুক্র|শনি)+/i,
  wide: /^(রবিবার|সোমবার|মঙ্গলবার|বুধবার|বৃহস্পতিবার |শুক্রবার|শনিবার)+/i
}, ob = {
  narrow: [/^র/i, /^সো/i, /^ম/i, /^বু/i, /^বৃ/i, /^শু/i, /^শ/i],
  short: [/^রবি/i, /^সোম/i, /^মঙ্গল/i, /^বুধ/i, /^বৃহ/i, /^শুক্র/i, /^শনি/i],
  abbreviated: [/^রবি/i, /^সোম/i, /^মঙ্গল/i, /^বুধ/i, /^বৃহ/i, /^শুক্র/i, /^শনি/i],
  wide: [/^রবিবার/i, /^সোমবার/i, /^মঙ্গলবার/i, /^বুধবার/i, /^বৃহস্পতিবার /i, /^শুক্রবার/i, /^শনিবার/i]
}, sb = {
  narrow: /^(পূ|অপ|মধ্যরাত|মধ্যাহ্ন|সকাল|বিকাল|সন্ধ্যা|রাত)/i,
  abbreviated: /^(পূর্বাহ্ন|অপরাহ্ন|মধ্যরাত|মধ্যাহ্ন|সকাল|বিকাল|সন্ধ্যা|রাত)/i,
  wide: /^(পূর্বাহ্ন|অপরাহ্ন|মধ্যরাত|মধ্যাহ্ন|সকাল|বিকাল|সন্ধ্যা|রাত)/i
}, db = {
  any: {
    am: /^পূ/i,
    pm: /^অপ/i,
    midnight: /^মধ্যরাত/i,
    noon: /^মধ্যাহ্ন/i,
    morning: /সকাল/i,
    afternoon: /বিকাল/i,
    evening: /সন্ধ্যা/i,
    night: /রাত/i
  }
}, ub = {
  ordinalNumber: le({
    matchPattern: Yp,
    parsePattern: Jp,
    valueCallback: function(i) {
      return parseInt(i, 10);
    }
  }),
  era: P({
    matchPatterns: Qp,
    defaultMatchWidth: "wide",
    parsePatterns: eb,
    defaultParseWidth: "wide"
  }),
  quarter: P({
    matchPatterns: nb,
    defaultMatchWidth: "wide",
    parsePatterns: ib,
    defaultParseWidth: "any",
    valueCallback: function(i) {
      return i + 1;
    }
  }),
  month: P({
    matchPatterns: ab,
    defaultMatchWidth: "wide",
    parsePatterns: tb,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: rb,
    defaultMatchWidth: "wide",
    parsePatterns: ob,
    defaultParseWidth: "wide"
  }),
  dayPeriod: P({
    matchPatterns: sb,
    defaultMatchWidth: "wide",
    parsePatterns: db,
    defaultParseWidth: "any"
  })
}, fb = {
  code: "bn",
  formatDistance: Vp,
  formatLong: Xp,
  formatRelative: Kp,
  localize: Zp,
  match: ub,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
const lb = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: fb
}, Symbol.toStringTag, { value: "Module" })), cb = /* @__PURE__ */ te(lb);
var mb = {
  lessThanXSeconds: {
    one: {
      standalone: "manje od 1 sekunde",
      withPrepositionAgo: "manje od 1 sekunde",
      withPrepositionIn: "manje od 1 sekundu"
    },
    dual: "manje od {{count}} sekunde",
    other: "manje od {{count}} sekundi"
  },
  xSeconds: {
    one: {
      standalone: "1 sekunda",
      withPrepositionAgo: "1 sekunde",
      withPrepositionIn: "1 sekundu"
    },
    dual: "{{count}} sekunde",
    other: "{{count}} sekundi"
  },
  halfAMinute: "pola minute",
  lessThanXMinutes: {
    one: {
      standalone: "manje od 1 minute",
      withPrepositionAgo: "manje od 1 minute",
      withPrepositionIn: "manje od 1 minutu"
    },
    dual: "manje od {{count}} minute",
    other: "manje od {{count}} minuta"
  },
  xMinutes: {
    one: {
      standalone: "1 minuta",
      withPrepositionAgo: "1 minute",
      withPrepositionIn: "1 minutu"
    },
    dual: "{{count}} minute",
    other: "{{count}} minuta"
  },
  aboutXHours: {
    one: {
      standalone: "oko 1 sat",
      withPrepositionAgo: "oko 1 sat",
      withPrepositionIn: "oko 1 sat"
    },
    dual: "oko {{count}} sata",
    other: "oko {{count}} sati"
  },
  xHours: {
    one: {
      standalone: "1 sat",
      withPrepositionAgo: "1 sat",
      withPrepositionIn: "1 sat"
    },
    dual: "{{count}} sata",
    other: "{{count}} sati"
  },
  xDays: {
    one: {
      standalone: "1 dan",
      withPrepositionAgo: "1 dan",
      withPrepositionIn: "1 dan"
    },
    dual: "{{count}} dana",
    other: "{{count}} dana"
  },
  aboutXWeeks: {
    one: {
      standalone: "oko 1 sedmicu",
      withPrepositionAgo: "oko 1 sedmicu",
      withPrepositionIn: "oko 1 sedmicu"
    },
    dual: "oko {{count}} sedmice",
    other: "oko {{count}} sedmice"
  },
  xWeeks: {
    one: {
      standalone: "1 sedmicu",
      withPrepositionAgo: "1 sedmicu",
      withPrepositionIn: "1 sedmicu"
    },
    dual: "{{count}} sedmice",
    other: "{{count}} sedmice"
  },
  aboutXMonths: {
    one: {
      standalone: "oko 1 mjesec",
      withPrepositionAgo: "oko 1 mjesec",
      withPrepositionIn: "oko 1 mjesec"
    },
    dual: "oko {{count}} mjeseca",
    other: "oko {{count}} mjeseci"
  },
  xMonths: {
    one: {
      standalone: "1 mjesec",
      withPrepositionAgo: "1 mjesec",
      withPrepositionIn: "1 mjesec"
    },
    dual: "{{count}} mjeseca",
    other: "{{count}} mjeseci"
  },
  aboutXYears: {
    one: {
      standalone: "oko 1 godinu",
      withPrepositionAgo: "oko 1 godinu",
      withPrepositionIn: "oko 1 godinu"
    },
    dual: "oko {{count}} godine",
    other: "oko {{count}} godina"
  },
  xYears: {
    one: {
      standalone: "1 godina",
      withPrepositionAgo: "1 godine",
      withPrepositionIn: "1 godinu"
    },
    dual: "{{count}} godine",
    other: "{{count}} godina"
  },
  overXYears: {
    one: {
      standalone: "preko 1 godinu",
      withPrepositionAgo: "preko 1 godinu",
      withPrepositionIn: "preko 1 godinu"
    },
    dual: "preko {{count}} godine",
    other: "preko {{count}} godina"
  },
  almostXYears: {
    one: {
      standalone: "gotovo 1 godinu",
      withPrepositionAgo: "gotovo 1 godinu",
      withPrepositionIn: "gotovo 1 godinu"
    },
    dual: "gotovo {{count}} godine",
    other: "gotovo {{count}} godina"
  }
}, vb = function(i, d, a) {
  var t, o = mb[i];
  return typeof o == "string" ? t = o : d === 1 ? a != null && a.addSuffix ? a.comparison && a.comparison > 0 ? t = o.one.withPrepositionIn : t = o.one.withPrepositionAgo : t = o.one.standalone : d % 10 > 1 && d % 10 < 5 && // if last digit is between 2 and 4
  String(d).substr(-2, 1) !== "1" ? t = o.dual.replace("{{count}}", String(d)) : t = o.other.replace("{{count}}", String(d)), a != null && a.addSuffix ? a.comparison && a.comparison > 0 ? "za " + t : "prije " + t : t;
}, hb = {
  full: "EEEE, d. MMMM yyyy.",
  long: "d. MMMM yyyy.",
  medium: "d. MMM yy.",
  short: "dd. MM. yy."
}, gb = {
  full: "HH:mm:ss (zzzz)",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, pb = {
  full: "{{date}} 'u' {{time}}",
  long: "{{date}} 'u' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, bb = {
  date: I({
    formats: hb,
    defaultWidth: "full"
  }),
  time: I({
    formats: gb,
    defaultWidth: "full"
  }),
  dateTime: I({
    formats: pb,
    defaultWidth: "full"
  })
}, yb = {
  lastWeek: function(i) {
    switch (i.getUTCDay()) {
      case 0:
        return "'prošle nedjelje u' p";
      case 3:
        return "'prošle srijede u' p";
      case 6:
        return "'prošle subote u' p";
      default:
        return "'prošli' EEEE 'u' p";
    }
  },
  yesterday: "'juče u' p",
  today: "'danas u' p",
  tomorrow: "'sutra u' p",
  nextWeek: function(i) {
    switch (i.getUTCDay()) {
      case 0:
        return "'sljedeće nedjelje u' p";
      case 3:
        return "'sljedeću srijedu u' p";
      case 6:
        return "'sljedeću subotu u' p";
      default:
        return "'sljedeći' EEEE 'u' p";
    }
  },
  other: "P"
}, kb = function(i, d, a, t) {
  var o = yb[i];
  return typeof o == "function" ? o(d) : o;
}, wb = {
  narrow: ["pr.n.e.", "AD"],
  abbreviated: ["pr. Hr.", "po. Hr."],
  wide: ["Prije Hrista", "Poslije Hrista"]
}, _b = {
  narrow: ["1.", "2.", "3.", "4."],
  abbreviated: ["1. kv.", "2. kv.", "3. kv.", "4. kv."],
  wide: ["1. kvartal", "2. kvartal", "3. kvartal", "4. kvartal"]
}, $b = {
  narrow: ["1.", "2.", "3.", "4.", "5.", "6.", "7.", "8.", "9.", "10.", "11.", "12."],
  abbreviated: ["jan", "feb", "mar", "apr", "maj", "jun", "jul", "avg", "sep", "okt", "nov", "dec"],
  wide: ["januar", "februar", "mart", "april", "maj", "juni", "juli", "avgust", "septembar", "oktobar", "novembar", "decembar"]
}, Pb = {
  narrow: ["1.", "2.", "3.", "4.", "5.", "6.", "7.", "8.", "9.", "10.", "11.", "12."],
  abbreviated: ["jan", "feb", "mar", "apr", "maj", "jun", "jul", "avg", "sep", "okt", "nov", "dec"],
  wide: ["januar", "februar", "mart", "april", "maj", "juni", "juli", "avgust", "septembar", "oktobar", "novembar", "decembar"]
}, Mb = {
  narrow: ["N", "P", "U", "S", "Č", "P", "S"],
  short: ["ned", "pon", "uto", "sre", "čet", "pet", "sub"],
  abbreviated: ["ned", "pon", "uto", "sre", "čet", "pet", "sub"],
  wide: ["nedjelja", "ponedjeljak", "utorak", "srijeda", "četvrtak", "petak", "subota"]
}, jb = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "ponoć",
    noon: "podne",
    morning: "ujutru",
    afternoon: "popodne",
    evening: "uveče",
    night: "noću"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "ponoć",
    noon: "podne",
    morning: "ujutru",
    afternoon: "popodne",
    evening: "uveče",
    night: "noću"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "ponoć",
    noon: "podne",
    morning: "ujutru",
    afternoon: "poslije podne",
    evening: "uveče",
    night: "noću"
  }
}, Sb = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "ponoć",
    noon: "podne",
    morning: "ujutru",
    afternoon: "popodne",
    evening: "uveče",
    night: "noću"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "ponoć",
    noon: "podne",
    morning: "ujutru",
    afternoon: "popodne",
    evening: "uveče",
    night: "noću"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "ponoć",
    noon: "podne",
    morning: "ujutru",
    afternoon: "poslije podne",
    evening: "uveče",
    night: "noću"
  }
}, zb = function(i, d) {
  var a = Number(i);
  return String(a) + ".";
}, Ob = {
  ordinalNumber: zb,
  era: $({
    values: wb,
    defaultWidth: "wide"
  }),
  quarter: $({
    values: _b,
    defaultWidth: "wide",
    argumentCallback: function(i) {
      return i - 1;
    }
  }),
  month: $({
    values: $b,
    defaultWidth: "wide",
    formattingValues: Pb,
    defaultFormattingWidth: "wide"
  }),
  day: $({
    values: Mb,
    defaultWidth: "wide"
  }),
  dayPeriod: $({
    values: jb,
    defaultWidth: "wide",
    formattingValues: Sb,
    defaultFormattingWidth: "wide"
  })
}, Wb = /^(\d+)\./i, Db = /\d+/i, Cb = {
  narrow: /^(pr\.n\.e\.|AD)/i,
  abbreviated: /^(pr\.\s?Hr\.|po\.\s?Hr\.)/i,
  wide: /^(Prije Hrista|prije nove ere|Poslije Hrista|nova era)/i
}, Ib = {
  any: [/^pr/i, /^(po|nova)/i]
}, Tb = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234]\.\s?kv\.?/i,
  wide: /^[1234]\. kvartal/i
}, Nb = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, xb = {
  narrow: /^(10|11|12|[123456789])\./i,
  abbreviated: /^(jan|feb|mar|apr|maj|jun|jul|avg|sep|okt|nov|dec)/i,
  wide: /^((januar|januara)|(februar|februara)|(mart|marta)|(april|aprila)|(maj|maja)|(juni|juna)|(juli|jula)|(avgust|avgusta)|(septembar|septembra)|(oktobar|oktobra)|(novembar|novembra)|(decembar|decembra))/i
}, Fb = {
  narrow: [/^1/i, /^2/i, /^3/i, /^4/i, /^5/i, /^6/i, /^7/i, /^8/i, /^9/i, /^10/i, /^11/i, /^12/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^maj/i, /^jun/i, /^jul/i, /^avg/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, Eb = {
  narrow: /^[npusčc]/i,
  short: /^(ned|pon|uto|sre|(čet|cet)|pet|sub)/i,
  abbreviated: /^(ned|pon|uto|sre|(čet|cet)|pet|sub)/i,
  wide: /^(nedjelja|ponedjeljak|utorak|srijeda|(četvrtak|cetvrtak)|petak|subota)/i
}, Rb = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, Lb = {
  any: /^(am|pm|ponoc|ponoć|(po)?podne|uvece|uveče|noću|poslije podne|ujutru)/i
}, qb = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^pono/i,
    noon: /^pod/i,
    morning: /jutro/i,
    afternoon: /(poslije\s|po)+podne/i,
    evening: /(uvece|uveče)/i,
    night: /(nocu|noću)/i
  }
}, Zb = {
  ordinalNumber: le({
    matchPattern: Wb,
    parsePattern: Db,
    valueCallback: function(i) {
      return parseInt(i, 10);
    }
  }),
  era: P({
    matchPatterns: Cb,
    defaultMatchWidth: "wide",
    parsePatterns: Ib,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: Tb,
    defaultMatchWidth: "wide",
    parsePatterns: Nb,
    defaultParseWidth: "any",
    valueCallback: function(i) {
      return i + 1;
    }
  }),
  month: P({
    matchPatterns: xb,
    defaultMatchWidth: "wide",
    parsePatterns: Fb,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: Eb,
    defaultMatchWidth: "wide",
    parsePatterns: Rb,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: Lb,
    defaultMatchWidth: "any",
    parsePatterns: qb,
    defaultParseWidth: "any"
  })
}, Ab = {
  code: "bs",
  formatDistance: vb,
  formatLong: bb,
  formatRelative: kb,
  localize: Ob,
  match: Zb,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const Vb = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ab
}, Symbol.toStringTag, { value: "Module" })), Hb = /* @__PURE__ */ te(Vb);
var Ub = {
  lessThanXSeconds: {
    one: "menys d'un segon",
    eleven: "menys d'onze segons",
    other: "menys de {{count}} segons"
  },
  xSeconds: {
    one: "1 segon",
    other: "{{count}} segons"
  },
  halfAMinute: "mig minut",
  lessThanXMinutes: {
    one: "menys d'un minut",
    eleven: "menys d'onze minuts",
    other: "menys de {{count}} minuts"
  },
  xMinutes: {
    one: "1 minut",
    other: "{{count}} minuts"
  },
  aboutXHours: {
    one: "aproximadament una hora",
    other: "aproximadament {{count}} hores"
  },
  xHours: {
    one: "1 hora",
    other: "{{count}} hores"
  },
  xDays: {
    one: "1 dia",
    other: "{{count}} dies"
  },
  aboutXWeeks: {
    one: "aproximadament una setmana",
    other: "aproximadament {{count}} setmanes"
  },
  xWeeks: {
    one: "1 setmana",
    other: "{{count}} setmanes"
  },
  aboutXMonths: {
    one: "aproximadament un mes",
    other: "aproximadament {{count}} mesos"
  },
  xMonths: {
    one: "1 mes",
    other: "{{count}} mesos"
  },
  aboutXYears: {
    one: "aproximadament un any",
    other: "aproximadament {{count}} anys"
  },
  xYears: {
    one: "1 any",
    other: "{{count}} anys"
  },
  overXYears: {
    one: "més d'un any",
    eleven: "més d'onze anys",
    other: "més de {{count}} anys"
  },
  almostXYears: {
    one: "gairebé un any",
    other: "gairebé {{count}} anys"
  }
}, Bb = function(i, d, a) {
  var t, o = Ub[i];
  return typeof o == "string" ? t = o : d === 1 ? t = o.one : d === 11 && o.eleven ? t = o.eleven : t = o.other.replace("{{count}}", String(d)), a != null && a.addSuffix ? a.comparison && a.comparison > 0 ? "en " + t : "fa " + t : t;
}, Xb = {
  full: "EEEE, d 'de' MMMM y",
  long: "d 'de' MMMM y",
  medium: "d MMM y",
  short: "dd/MM/y"
}, Gb = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, Kb = {
  full: "{{date}} 'a les' {{time}}",
  long: "{{date}} 'a les' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Yb = {
  date: I({
    formats: Xb,
    defaultWidth: "full"
  }),
  time: I({
    formats: Gb,
    defaultWidth: "full"
  }),
  dateTime: I({
    formats: Kb,
    defaultWidth: "full"
  })
}, Jb = {
  lastWeek: "'el' eeee 'passat a la' LT",
  yesterday: "'ahir a la' p",
  today: "'avui a la' p",
  tomorrow: "'demà a la' p",
  nextWeek: "eeee 'a la' p",
  other: "P"
}, Qb = {
  lastWeek: "'el' eeee 'passat a les' p",
  yesterday: "'ahir a les' p",
  today: "'avui a les' p",
  tomorrow: "'demà a les' p",
  nextWeek: "eeee 'a les' p",
  other: "P"
}, ey = function(i, d, a, t) {
  return d.getUTCHours() !== 1 ? Qb[i] : Jb[i];
}, ny = {
  narrow: ["aC", "dC"],
  abbreviated: ["a. de C.", "d. de C."],
  wide: ["abans de Crist", "després de Crist"]
}, iy = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["T1", "T2", "T3", "T4"],
  wide: ["1r trimestre", "2n trimestre", "3r trimestre", "4t trimestre"]
}, ay = {
  narrow: ["GN", "FB", "MÇ", "AB", "MG", "JN", "JL", "AG", "ST", "OC", "NV", "DS"],
  /**
   * Les abreviatures dels mesos de l'any es formen seguint una de les normes generals de formació d'abreviatures.
   * S'escriu la primera síl·laba i les consonants de la síl·laba següent anteriors a la primera vocal.
   * Els mesos de març, maig i juny no s'abreugen perquè són paraules d'una sola síl·laba.
   */
  abbreviated: ["gen.", "febr.", "març", "abr.", "maig", "juny", "jul.", "ag.", "set.", "oct.", "nov.", "des."],
  wide: ["gener", "febrer", "març", "abril", "maig", "juny", "juliol", "agost", "setembre", "octubre", "novembre", "desembre"]
}, ty = {
  narrow: ["dg.", "dl.", "dt.", "dm.", "dj.", "dv.", "ds."],
  short: ["dg.", "dl.", "dt.", "dm.", "dj.", "dv.", "ds."],
  abbreviated: ["dg.", "dl.", "dt.", "dm.", "dj.", "dv.", "ds."],
  wide: ["diumenge", "dilluns", "dimarts", "dimecres", "dijous", "divendres", "dissabte"]
}, ry = {
  narrow: {
    am: "am",
    pm: "pm",
    midnight: "mitjanit",
    noon: "migdia",
    morning: "matí",
    afternoon: "tarda",
    evening: "vespre",
    night: "nit"
  },
  abbreviated: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "mitjanit",
    noon: "migdia",
    morning: "matí",
    afternoon: "tarda",
    evening: "vespre",
    night: "nit"
  },
  wide: {
    am: "ante meridiem",
    pm: "post meridiem",
    midnight: "mitjanit",
    noon: "migdia",
    morning: "matí",
    afternoon: "tarda",
    evening: "vespre",
    night: "nit"
  }
}, oy = {
  narrow: {
    am: "am",
    pm: "pm",
    midnight: "de la mitjanit",
    noon: "del migdia",
    morning: "del matí",
    afternoon: "de la tarda",
    evening: "del vespre",
    night: "de la nit"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "de la mitjanit",
    noon: "del migdia",
    morning: "del matí",
    afternoon: "de la tarda",
    evening: "del vespre",
    night: "de la nit"
  },
  wide: {
    am: "ante meridiem",
    pm: "post meridiem",
    midnight: "de la mitjanit",
    noon: "del migdia",
    morning: "del matí",
    afternoon: "de la tarda",
    evening: "del vespre",
    night: "de la nit"
  }
}, sy = function(i, d) {
  var a = Number(i), t = a % 100;
  if (t > 20 || t < 10)
    switch (t % 10) {
      case 1:
        return a + "r";
      case 2:
        return a + "n";
      case 3:
        return a + "r";
      case 4:
        return a + "t";
    }
  return a + "è";
}, dy = {
  ordinalNumber: sy,
  era: $({
    values: ny,
    defaultWidth: "wide"
  }),
  quarter: $({
    values: iy,
    defaultWidth: "wide",
    argumentCallback: function(i) {
      return i - 1;
    }
  }),
  month: $({
    values: ay,
    defaultWidth: "wide"
  }),
  day: $({
    values: ty,
    defaultWidth: "wide"
  }),
  dayPeriod: $({
    values: ry,
    defaultWidth: "wide",
    formattingValues: oy,
    defaultFormattingWidth: "wide"
  })
}, uy = /^(\d+)(è|r|n|r|t)?/i, fy = /\d+/i, ly = {
  narrow: /^(aC|dC)/i,
  abbreviated: /^(a. de C.|d. de C.)/i,
  wide: /^(abans de Crist|despr[eé]s de Crist)/i
}, cy = {
  narrow: [/^aC/i, /^dC/i],
  abbreviated: [/^(a. de C.)/i, /^(d. de C.)/i],
  wide: [/^(abans de Crist)/i, /^(despr[eé]s de Crist)/i]
}, my = {
  narrow: /^[1234]/i,
  abbreviated: /^T[1234]/i,
  wide: /^[1234](è|r|n|r|t)? trimestre/i
}, vy = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, hy = {
  narrow: /^(GN|FB|MÇ|AB|MG|JN|JL|AG|ST|OC|NV|DS)/i,
  abbreviated: /^(gen.|febr.|març|abr.|maig|juny|jul.|ag.|set.|oct.|nov.|des.)/i,
  wide: /^(gener|febrer|març|abril|maig|juny|juliol|agost|setembre|octubre|novembre|desembre)/i
}, gy = {
  narrow: [/^GN/i, /^FB/i, /^MÇ/i, /^AB/i, /^MG/i, /^JN/i, /^JL/i, /^AG/i, /^ST/i, /^OC/i, /^NV/i, /^DS/i],
  abbreviated: [/^gen./i, /^febr./i, /^març/i, /^abr./i, /^maig/i, /^juny/i, /^jul./i, /^ag./i, /^set./i, /^oct./i, /^nov./i, /^des./i],
  wide: [/^gener/i, /^febrer/i, /^març/i, /^abril/i, /^maig/i, /^juny/i, /^juliol/i, /^agost/i, /^setembre/i, /^octubre/i, /^novembre/i, /^desembre/i]
}, py = {
  narrow: /^(dg\.|dl\.|dt\.|dm\.|dj\.|dv\.|ds\.)/i,
  short: /^(dg\.|dl\.|dt\.|dm\.|dj\.|dv\.|ds\.)/i,
  abbreviated: /^(dg\.|dl\.|dt\.|dm\.|dj\.|dv\.|ds\.)/i,
  wide: /^(diumenge|dilluns|dimarts|dimecres|dijous|divendres|dissabte)/i
}, by = {
  narrow: [/^dg./i, /^dl./i, /^dt./i, /^dm./i, /^dj./i, /^dv./i, /^ds./i],
  abbreviated: [/^dg./i, /^dl./i, /^dt./i, /^dm./i, /^dj./i, /^dv./i, /^ds./i],
  wide: [/^diumenge/i, /^dilluns/i, /^dimarts/i, /^dimecres/i, /^dijous/i, /^divendres/i, /^disssabte/i]
}, yy = {
  narrow: /^(a|p|mn|md|(del|de la) (matí|tarda|vespre|nit))/i,
  abbreviated: /^([ap]\.?\s?m\.?|mitjanit|migdia|(del|de la) (matí|tarda|vespre|nit))/i,
  wide: /^(ante meridiem|post meridiem|mitjanit|migdia|(del|de la) (matí|tarda|vespre|nit))/i
}, ky = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mitjanit/i,
    noon: /^migdia/i,
    morning: /matí/i,
    afternoon: /tarda/i,
    evening: /vespre/i,
    night: /nit/i
  }
}, wy = {
  ordinalNumber: le({
    matchPattern: uy,
    parsePattern: fy,
    valueCallback: function(i) {
      return parseInt(i, 10);
    }
  }),
  era: P({
    matchPatterns: ly,
    defaultMatchWidth: "wide",
    parsePatterns: cy,
    defaultParseWidth: "wide"
  }),
  quarter: P({
    matchPatterns: my,
    defaultMatchWidth: "wide",
    parsePatterns: vy,
    defaultParseWidth: "any",
    valueCallback: function(i) {
      return i + 1;
    }
  }),
  month: P({
    matchPatterns: hy,
    defaultMatchWidth: "wide",
    parsePatterns: gy,
    defaultParseWidth: "wide"
  }),
  day: P({
    matchPatterns: py,
    defaultMatchWidth: "wide",
    parsePatterns: by,
    defaultParseWidth: "wide"
  }),
  dayPeriod: P({
    matchPatterns: yy,
    defaultMatchWidth: "wide",
    parsePatterns: ky,
    defaultParseWidth: "any"
  })
}, _y = {
  code: "ca",
  formatDistance: Bb,
  formatLong: Yb,
  formatRelative: ey,
  localize: dy,
  match: wy,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const $y = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: _y
}, Symbol.toStringTag, { value: "Module" })), Py = /* @__PURE__ */ te($y);
var My = {
  lessThanXSeconds: {
    one: {
      regular: "méně než sekunda",
      past: "před méně než sekundou",
      future: "za méně než sekundu"
    },
    few: {
      regular: "méně než {{count}} sekundy",
      past: "před méně než {{count}} sekundami",
      future: "za méně než {{count}} sekundy"
    },
    many: {
      regular: "méně než {{count}} sekund",
      past: "před méně než {{count}} sekundami",
      future: "za méně než {{count}} sekund"
    }
  },
  xSeconds: {
    one: {
      regular: "sekunda",
      past: "před sekundou",
      future: "za sekundu"
    },
    few: {
      regular: "{{count}} sekundy",
      past: "před {{count}} sekundami",
      future: "za {{count}} sekundy"
    },
    many: {
      regular: "{{count}} sekund",
      past: "před {{count}} sekundami",
      future: "za {{count}} sekund"
    }
  },
  halfAMinute: {
    type: "other",
    other: {
      regular: "půl minuty",
      past: "před půl minutou",
      future: "za půl minuty"
    }
  },
  lessThanXMinutes: {
    one: {
      regular: "méně než minuta",
      past: "před méně než minutou",
      future: "za méně než minutu"
    },
    few: {
      regular: "méně než {{count}} minuty",
      past: "před méně než {{count}} minutami",
      future: "za méně než {{count}} minuty"
    },
    many: {
      regular: "méně než {{count}} minut",
      past: "před méně než {{count}} minutami",
      future: "za méně než {{count}} minut"
    }
  },
  xMinutes: {
    one: {
      regular: "minuta",
      past: "před minutou",
      future: "za minutu"
    },
    few: {
      regular: "{{count}} minuty",
      past: "před {{count}} minutami",
      future: "za {{count}} minuty"
    },
    many: {
      regular: "{{count}} minut",
      past: "před {{count}} minutami",
      future: "za {{count}} minut"
    }
  },
  aboutXHours: {
    one: {
      regular: "přibližně hodina",
      past: "přibližně před hodinou",
      future: "přibližně za hodinu"
    },
    few: {
      regular: "přibližně {{count}} hodiny",
      past: "přibližně před {{count}} hodinami",
      future: "přibližně za {{count}} hodiny"
    },
    many: {
      regular: "přibližně {{count}} hodin",
      past: "přibližně před {{count}} hodinami",
      future: "přibližně za {{count}} hodin"
    }
  },
  xHours: {
    one: {
      regular: "hodina",
      past: "před hodinou",
      future: "za hodinu"
    },
    few: {
      regular: "{{count}} hodiny",
      past: "před {{count}} hodinami",
      future: "za {{count}} hodiny"
    },
    many: {
      regular: "{{count}} hodin",
      past: "před {{count}} hodinami",
      future: "za {{count}} hodin"
    }
  },
  xDays: {
    one: {
      regular: "den",
      past: "před dnem",
      future: "za den"
    },
    few: {
      regular: "{{count}} dny",
      past: "před {{count}} dny",
      future: "za {{count}} dny"
    },
    many: {
      regular: "{{count}} dní",
      past: "před {{count}} dny",
      future: "za {{count}} dní"
    }
  },
  aboutXWeeks: {
    one: {
      regular: "přibližně týden",
      past: "přibližně před týdnem",
      future: "přibližně za týden"
    },
    few: {
      regular: "přibližně {{count}} týdny",
      past: "přibližně před {{count}} týdny",
      future: "přibližně za {{count}} týdny"
    },
    many: {
      regular: "přibližně {{count}} týdnů",
      past: "přibližně před {{count}} týdny",
      future: "přibližně za {{count}} týdnů"
    }
  },
  xWeeks: {
    one: {
      regular: "týden",
      past: "před týdnem",
      future: "za týden"
    },
    few: {
      regular: "{{count}} týdny",
      past: "před {{count}} týdny",
      future: "za {{count}} týdny"
    },
    many: {
      regular: "{{count}} týdnů",
      past: "před {{count}} týdny",
      future: "za {{count}} týdnů"
    }
  },
  aboutXMonths: {
    one: {
      regular: "přibližně měsíc",
      past: "přibližně před měsícem",
      future: "přibližně za měsíc"
    },
    few: {
      regular: "přibližně {{count}} měsíce",
      past: "přibližně před {{count}} měsíci",
      future: "přibližně za {{count}} měsíce"
    },
    many: {
      regular: "přibližně {{count}} měsíců",
      past: "přibližně před {{count}} měsíci",
      future: "přibližně za {{count}} měsíců"
    }
  },
  xMonths: {
    one: {
      regular: "měsíc",
      past: "před měsícem",
      future: "za měsíc"
    },
    few: {
      regular: "{{count}} měsíce",
      past: "před {{count}} měsíci",
      future: "za {{count}} měsíce"
    },
    many: {
      regular: "{{count}} měsíců",
      past: "před {{count}} měsíci",
      future: "za {{count}} měsíců"
    }
  },
  aboutXYears: {
    one: {
      regular: "přibližně rok",
      past: "přibližně před rokem",
      future: "přibližně za rok"
    },
    few: {
      regular: "přibližně {{count}} roky",
      past: "přibližně před {{count}} roky",
      future: "přibližně za {{count}} roky"
    },
    many: {
      regular: "přibližně {{count}} roků",
      past: "přibližně před {{count}} roky",
      future: "přibližně za {{count}} roků"
    }
  },
  xYears: {
    one: {
      regular: "rok",
      past: "před rokem",
      future: "za rok"
    },
    few: {
      regular: "{{count}} roky",
      past: "před {{count}} roky",
      future: "za {{count}} roky"
    },
    many: {
      regular: "{{count}} roků",
      past: "před {{count}} roky",
      future: "za {{count}} roků"
    }
  },
  overXYears: {
    one: {
      regular: "více než rok",
      past: "před více než rokem",
      future: "za více než rok"
    },
    few: {
      regular: "více než {{count}} roky",
      past: "před více než {{count}} roky",
      future: "za více než {{count}} roky"
    },
    many: {
      regular: "více než {{count}} roků",
      past: "před více než {{count}} roky",
      future: "za více než {{count}} roků"
    }
  },
  almostXYears: {
    one: {
      regular: "skoro rok",
      past: "skoro před rokem",
      future: "skoro za rok"
    },
    few: {
      regular: "skoro {{count}} roky",
      past: "skoro před {{count}} roky",
      future: "skoro za {{count}} roky"
    },
    many: {
      regular: "skoro {{count}} roků",
      past: "skoro před {{count}} roky",
      future: "skoro za {{count}} roků"
    }
  }
}, jy = function(i, d, a) {
  var t, o = My[i];
  o.type === "other" ? t = o.other : d === 1 ? t = o.one : d > 1 && d < 5 ? t = o.few : t = o.many;
  var m = (a == null ? void 0 : a.addSuffix) === !0, p = a == null ? void 0 : a.comparison, s;
  return m && p === -1 ? s = t.past : m && p === 1 ? s = t.future : s = t.regular, s.replace("{{count}}", String(d));
}, Sy = {
  full: "EEEE, d. MMMM yyyy",
  long: "d. MMMM yyyy",
  medium: "d. M. yyyy",
  short: "dd.MM.yyyy"
}, zy = {
  full: "H:mm:ss zzzz",
  long: "H:mm:ss z",
  medium: "H:mm:ss",
  short: "H:mm"
}, Oy = {
  full: "{{date}} 'v' {{time}}",
  long: "{{date}} 'v' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Wy = {
  date: I({
    formats: Sy,
    defaultWidth: "full"
  }),
  time: I({
    formats: zy,
    defaultWidth: "full"
  }),
  dateTime: I({
    formats: Oy,
    defaultWidth: "full"
  })
}, Dy = ["neděli", "pondělí", "úterý", "středu", "čtvrtek", "pátek", "sobotu"], Cy = {
  lastWeek: "'poslední' eeee 've' p",
  yesterday: "'včera v' p",
  today: "'dnes v' p",
  tomorrow: "'zítra v' p",
  nextWeek: function(i) {
    var d = i.getUTCDay();
    return "'v " + Dy[d] + " o' p";
  },
  other: "P"
}, Iy = function(i, d) {
  var a = Cy[i];
  return typeof a == "function" ? a(d) : a;
}, Ty = {
  narrow: ["př. n. l.", "n. l."],
  abbreviated: ["př. n. l.", "n. l."],
  wide: ["před naším letopočtem", "našeho letopočtu"]
}, Ny = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1. čtvrtletí", "2. čtvrtletí", "3. čtvrtletí", "4. čtvrtletí"],
  wide: ["1. čtvrtletí", "2. čtvrtletí", "3. čtvrtletí", "4. čtvrtletí"]
}, xy = {
  narrow: ["L", "Ú", "B", "D", "K", "Č", "Č", "S", "Z", "Ř", "L", "P"],
  abbreviated: ["led", "úno", "bře", "dub", "kvě", "čvn", "čvc", "srp", "zář", "říj", "lis", "pro"],
  wide: ["leden", "únor", "březen", "duben", "květen", "červen", "červenec", "srpen", "září", "říjen", "listopad", "prosinec"]
}, Fy = {
  narrow: ["L", "Ú", "B", "D", "K", "Č", "Č", "S", "Z", "Ř", "L", "P"],
  abbreviated: ["led", "úno", "bře", "dub", "kvě", "čvn", "čvc", "srp", "zář", "říj", "lis", "pro"],
  wide: ["ledna", "února", "března", "dubna", "května", "června", "července", "srpna", "září", "října", "listopadu", "prosince"]
}, Ey = {
  narrow: ["ne", "po", "út", "st", "čt", "pá", "so"],
  short: ["ne", "po", "út", "st", "čt", "pá", "so"],
  abbreviated: ["ned", "pon", "úte", "stř", "čtv", "pát", "sob"],
  wide: ["neděle", "pondělí", "úterý", "středa", "čtvrtek", "pátek", "sobota"]
}, Ry = {
  narrow: {
    am: "dop.",
    pm: "odp.",
    midnight: "půlnoc",
    noon: "poledne",
    morning: "ráno",
    afternoon: "odpoledne",
    evening: "večer",
    night: "noc"
  },
  abbreviated: {
    am: "dop.",
    pm: "odp.",
    midnight: "půlnoc",
    noon: "poledne",
    morning: "ráno",
    afternoon: "odpoledne",
    evening: "večer",
    night: "noc"
  },
  wide: {
    am: "dopoledne",
    pm: "odpoledne",
    midnight: "půlnoc",
    noon: "poledne",
    morning: "ráno",
    afternoon: "odpoledne",
    evening: "večer",
    night: "noc"
  }
}, Ly = {
  narrow: {
    am: "dop.",
    pm: "odp.",
    midnight: "půlnoc",
    noon: "poledne",
    morning: "ráno",
    afternoon: "odpoledne",
    evening: "večer",
    night: "noc"
  },
  abbreviated: {
    am: "dop.",
    pm: "odp.",
    midnight: "půlnoc",
    noon: "poledne",
    morning: "ráno",
    afternoon: "odpoledne",
    evening: "večer",
    night: "noc"
  },
  wide: {
    am: "dopoledne",
    pm: "odpoledne",
    midnight: "půlnoc",
    noon: "poledne",
    morning: "ráno",
    afternoon: "odpoledne",
    evening: "večer",
    night: "noc"
  }
}, qy = function(i, d) {
  var a = Number(i);
  return a + ".";
}, Zy = {
  ordinalNumber: qy,
  era: $({
    values: Ty,
    defaultWidth: "wide"
  }),
  quarter: $({
    values: Ny,
    defaultWidth: "wide",
    argumentCallback: function(i) {
      return i - 1;
    }
  }),
  month: $({
    values: xy,
    defaultWidth: "wide",
    formattingValues: Fy,
    defaultFormattingWidth: "wide"
  }),
  day: $({
    values: Ey,
    defaultWidth: "wide"
  }),
  dayPeriod: $({
    values: Ry,
    defaultWidth: "wide",
    formattingValues: Ly,
    defaultFormattingWidth: "wide"
  })
}, Ay = /^(\d+)\.?/i, Vy = /\d+/i, Hy = {
  narrow: /^(p[řr](\.|ed) Kr\.|p[řr](\.|ed) n\. l\.|po Kr\.|n\. l\.)/i,
  abbreviated: /^(p[řr](\.|ed) Kr\.|p[řr](\.|ed) n\. l\.|po Kr\.|n\. l\.)/i,
  wide: /^(p[řr](\.|ed) Kristem|p[řr](\.|ed) na[šs][íi]m letopo[čc]tem|po Kristu|na[šs]eho letopo[čc]tu)/i
}, Uy = {
  any: [/^p[řr]/i, /^(po|n)/i]
}, By = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234]\. [čc]tvrtlet[íi]/i,
  wide: /^[1234]\. [čc]tvrtlet[íi]/i
}, Xy = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Gy = {
  narrow: /^[lúubdkčcszřrlp]/i,
  abbreviated: /^(led|[úu]no|b[řr]e|dub|kv[ěe]|[čc]vn|[čc]vc|srp|z[áa][řr]|[řr][íi]j|lis|pro)/i,
  wide: /^(leden|ledna|[úu]nora?|b[řr]ezen|b[řr]ezna|duben|dubna|kv[ěe]ten|kv[ěe]tna|[čc]erven(ec|ce)?|[čc]ervna|srpen|srpna|z[áa][řr][íi]|[řr][íi]jen|[řr][íi]jna|listopad(a|u)?|prosinec|prosince)/i
}, Ky = {
  narrow: [/^l/i, /^[úu]/i, /^b/i, /^d/i, /^k/i, /^[čc]/i, /^[čc]/i, /^s/i, /^z/i, /^[řr]/i, /^l/i, /^p/i],
  any: [/^led/i, /^[úu]n/i, /^b[řr]e/i, /^dub/i, /^kv[ěe]/i, /^[čc]vn|[čc]erven(?!\w)|[čc]ervna/i, /^[čc]vc|[čc]erven(ec|ce)/i, /^srp/i, /^z[áa][řr]/i, /^[řr][íi]j/i, /^lis/i, /^pro/i]
}, Yy = {
  narrow: /^[npuúsčps]/i,
  short: /^(ne|po|[úu]t|st|[čc]t|p[áa]|so)/i,
  abbreviated: /^(ned|pon|[úu]te|st[rř]|[čc]tv|p[áa]t|sob)/i,
  wide: /^(ned[ěe]le|pond[ěe]l[íi]|[úu]ter[ýy]|st[řr]eda|[čc]tvrtek|p[áa]tek|sobota)/i
}, Jy = {
  narrow: [/^n/i, /^p/i, /^[úu]/i, /^s/i, /^[čc]/i, /^p/i, /^s/i],
  any: [/^ne/i, /^po/i, /^[úu]t/i, /^st/i, /^[čc]t/i, /^p[áa]/i, /^so/i]
}, Qy = {
  any: /^dopoledne|dop\.?|odpoledne|odp\.?|p[ůu]lnoc|poledne|r[áa]no|odpoledne|ve[čc]er|(v )?noci?/i
}, ek = {
  any: {
    am: /^dop/i,
    pm: /^odp/i,
    midnight: /^p[ůu]lnoc/i,
    noon: /^poledne/i,
    morning: /r[áa]no/i,
    afternoon: /odpoledne/i,
    evening: /ve[čc]er/i,
    night: /noc/i
  }
}, nk = {
  ordinalNumber: le({
    matchPattern: Ay,
    parsePattern: Vy,
    valueCallback: function(i) {
      return parseInt(i, 10);
    }
  }),
  era: P({
    matchPatterns: Hy,
    defaultMatchWidth: "wide",
    parsePatterns: Uy,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: By,
    defaultMatchWidth: "wide",
    parsePatterns: Xy,
    defaultParseWidth: "any",
    valueCallback: function(i) {
      return i + 1;
    }
  }),
  month: P({
    matchPatterns: Gy,
    defaultMatchWidth: "wide",
    parsePatterns: Ky,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: Yy,
    defaultMatchWidth: "wide",
    parsePatterns: Jy,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: Qy,
    defaultMatchWidth: "any",
    parsePatterns: ek,
    defaultParseWidth: "any"
  })
}, ik = {
  code: "cs",
  formatDistance: jy,
  formatLong: Wy,
  formatRelative: Iy,
  localize: Zy,
  match: nk,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const ak = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ik
}, Symbol.toStringTag, { value: "Module" })), tk = /* @__PURE__ */ te(ak);
var rk = {
  lessThanXSeconds: {
    one: "llai na eiliad",
    other: "llai na {{count}} eiliad"
  },
  xSeconds: {
    one: "1 eiliad",
    other: "{{count}} eiliad"
  },
  halfAMinute: "hanner munud",
  lessThanXMinutes: {
    one: "llai na munud",
    two: "llai na 2 funud",
    other: "llai na {{count}} munud"
  },
  xMinutes: {
    one: "1 munud",
    two: "2 funud",
    other: "{{count}} munud"
  },
  aboutXHours: {
    one: "tua 1 awr",
    other: "tua {{count}} awr"
  },
  xHours: {
    one: "1 awr",
    other: "{{count}} awr"
  },
  xDays: {
    one: "1 diwrnod",
    two: "2 ddiwrnod",
    other: "{{count}} diwrnod"
  },
  aboutXWeeks: {
    one: "tua 1 wythnos",
    two: "tua pythefnos",
    other: "tua {{count}} wythnos"
  },
  xWeeks: {
    one: "1 wythnos",
    two: "pythefnos",
    other: "{{count}} wythnos"
  },
  aboutXMonths: {
    one: "tua 1 mis",
    two: "tua 2 fis",
    other: "tua {{count}} mis"
  },
  xMonths: {
    one: "1 mis",
    two: "2 fis",
    other: "{{count}} mis"
  },
  aboutXYears: {
    one: "tua 1 flwyddyn",
    two: "tua 2 flynedd",
    other: "tua {{count}} mlynedd"
  },
  xYears: {
    one: "1 flwyddyn",
    two: "2 flynedd",
    other: "{{count}} mlynedd"
  },
  overXYears: {
    one: "dros 1 flwyddyn",
    two: "dros 2 flynedd",
    other: "dros {{count}} mlynedd"
  },
  almostXYears: {
    one: "bron 1 flwyddyn",
    two: "bron 2 flynedd",
    other: "bron {{count}} mlynedd"
  }
}, ok = function(i, d, a) {
  var t, o = rk[i];
  return typeof o == "string" ? t = o : d === 1 ? t = o.one : d === 2 && o.two ? t = o.two : t = o.other.replace("{{count}}", String(d)), a != null && a.addSuffix ? a.comparison && a.comparison > 0 ? "mewn " + t : t + " yn ôl" : t;
}, sk = {
  full: "EEEE, d MMMM yyyy",
  long: "d MMMM yyyy",
  medium: "d MMM yyyy",
  short: "dd/MM/yyyy"
}, dk = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, uk = {
  full: "{{date}} 'am' {{time}}",
  long: "{{date}} 'am' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, fk = {
  date: I({
    formats: sk,
    defaultWidth: "full"
  }),
  time: I({
    formats: dk,
    defaultWidth: "full"
  }),
  dateTime: I({
    formats: uk,
    defaultWidth: "full"
  })
}, lk = {
  lastWeek: "eeee 'diwethaf am' p",
  yesterday: "'ddoe am' p",
  today: "'heddiw am' p",
  tomorrow: "'yfory am' p",
  nextWeek: "eeee 'am' p",
  other: "P"
}, ck = function(i, d, a, t) {
  return lk[i];
}, mk = {
  narrow: ["C", "O"],
  abbreviated: ["CC", "OC"],
  wide: ["Cyn Crist", "Ar ôl Crist"]
}, vk = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Ch1", "Ch2", "Ch3", "Ch4"],
  wide: ["Chwarter 1af", "2ail chwarter", "3ydd chwarter", "4ydd chwarter"]
}, hk = {
  narrow: ["I", "Ch", "Ma", "E", "Mi", "Me", "G", "A", "Md", "H", "T", "Rh"],
  abbreviated: ["Ion", "Chwe", "Maw", "Ebr", "Mai", "Meh", "Gor", "Aws", "Med", "Hyd", "Tach", "Rhag"],
  wide: ["Ionawr", "Chwefror", "Mawrth", "Ebrill", "Mai", "Mehefin", "Gorffennaf", "Awst", "Medi", "Hydref", "Tachwedd", "Rhagfyr"]
}, gk = {
  narrow: ["S", "Ll", "M", "M", "I", "G", "S"],
  short: ["Su", "Ll", "Ma", "Me", "Ia", "Gw", "Sa"],
  abbreviated: ["Sul", "Llun", "Maw", "Mer", "Iau", "Gwe", "Sad"],
  wide: ["dydd Sul", "dydd Llun", "dydd Mawrth", "dydd Mercher", "dydd Iau", "dydd Gwener", "dydd Sadwrn"]
}, pk = {
  narrow: {
    am: "b",
    pm: "h",
    midnight: "hn",
    noon: "hd",
    morning: "bore",
    afternoon: "prynhawn",
    evening: "gyda'r nos",
    night: "nos"
  },
  abbreviated: {
    am: "yb",
    pm: "yh",
    midnight: "hanner nos",
    noon: "hanner dydd",
    morning: "bore",
    afternoon: "prynhawn",
    evening: "gyda'r nos",
    night: "nos"
  },
  wide: {
    am: "y.b.",
    pm: "y.h.",
    midnight: "hanner nos",
    noon: "hanner dydd",
    morning: "bore",
    afternoon: "prynhawn",
    evening: "gyda'r nos",
    night: "nos"
  }
}, bk = {
  narrow: {
    am: "b",
    pm: "h",
    midnight: "hn",
    noon: "hd",
    morning: "yn y bore",
    afternoon: "yn y prynhawn",
    evening: "gyda'r nos",
    night: "yn y nos"
  },
  abbreviated: {
    am: "yb",
    pm: "yh",
    midnight: "hanner nos",
    noon: "hanner dydd",
    morning: "yn y bore",
    afternoon: "yn y prynhawn",
    evening: "gyda'r nos",
    night: "yn y nos"
  },
  wide: {
    am: "y.b.",
    pm: "y.h.",
    midnight: "hanner nos",
    noon: "hanner dydd",
    morning: "yn y bore",
    afternoon: "yn y prynhawn",
    evening: "gyda'r nos",
    night: "yn y nos"
  }
}, yk = function(i, d) {
  var a = Number(i);
  if (a < 20)
    switch (a) {
      case 0:
        return a + "fed";
      case 1:
        return a + "af";
      case 2:
        return a + "ail";
      case 3:
      case 4:
        return a + "ydd";
      case 5:
      case 6:
        return a + "ed";
      case 7:
      case 8:
      case 9:
      case 10:
      case 12:
      case 15:
      case 18:
        return a + "fed";
      case 11:
      case 13:
      case 14:
      case 16:
      case 17:
      case 19:
        return a + "eg";
    }
  else if (a >= 50 && a <= 60 || a === 80 || a >= 100)
    return a + "fed";
  return a + "ain";
}, kk = {
  ordinalNumber: yk,
  era: $({
    values: mk,
    defaultWidth: "wide"
  }),
  quarter: $({
    values: vk,
    defaultWidth: "wide",
    argumentCallback: function(i) {
      return i - 1;
    }
  }),
  month: $({
    values: hk,
    defaultWidth: "wide"
  }),
  day: $({
    values: gk,
    defaultWidth: "wide"
  }),
  dayPeriod: $({
    values: pk,
    defaultWidth: "wide",
    formattingValues: bk,
    defaultFormattingWidth: "wide"
  })
}, wk = /^(\d+)(af|ail|ydd|ed|fed|eg|ain)?/i, _k = /\d+/i, $k = {
  narrow: /^(c|o)/i,
  abbreviated: /^(c\.?\s?c\.?|o\.?\s?c\.?)/i,
  wide: /^(cyn christ|ar ôl crist|ar ol crist)/i
}, Pk = {
  wide: [/^c/i, /^(ar ôl crist|ar ol crist)/i],
  any: [/^c/i, /^o/i]
}, Mk = {
  narrow: /^[1234]/i,
  abbreviated: /^ch[1234]/i,
  wide: /^(chwarter 1af)|([234](ail|ydd)? chwarter)/i
}, jk = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Sk = {
  narrow: /^(i|ch|m|e|g|a|h|t|rh)/i,
  abbreviated: /^(ion|chwe|maw|ebr|mai|meh|gor|aws|med|hyd|tach|rhag)/i,
  wide: /^(ionawr|chwefror|mawrth|ebrill|mai|mehefin|gorffennaf|awst|medi|hydref|tachwedd|rhagfyr)/i
}, zk = {
  narrow: [/^i/i, /^ch/i, /^m/i, /^e/i, /^m/i, /^m/i, /^g/i, /^a/i, /^m/i, /^h/i, /^t/i, /^rh/i],
  any: [/^io/i, /^ch/i, /^maw/i, /^e/i, /^mai/i, /^meh/i, /^g/i, /^a/i, /^med/i, /^h/i, /^t/i, /^rh/i]
}, Ok = {
  narrow: /^(s|ll|m|i|g)/i,
  short: /^(su|ll|ma|me|ia|gw|sa)/i,
  abbreviated: /^(sul|llun|maw|mer|iau|gwe|sad)/i,
  wide: /^dydd (sul|llun|mawrth|mercher|iau|gwener|sadwrn)/i
}, Wk = {
  narrow: [/^s/i, /^ll/i, /^m/i, /^m/i, /^i/i, /^g/i, /^s/i],
  wide: [/^dydd su/i, /^dydd ll/i, /^dydd ma/i, /^dydd me/i, /^dydd i/i, /^dydd g/i, /^dydd sa/i],
  any: [/^su/i, /^ll/i, /^ma/i, /^me/i, /^i/i, /^g/i, /^sa/i]
}, Dk = {
  narrow: /^(b|h|hn|hd|(yn y|y|yr|gyda'r) (bore|prynhawn|nos|hwyr))/i,
  any: /^(y\.?\s?[bh]\.?|hanner nos|hanner dydd|(yn y|y|yr|gyda'r) (bore|prynhawn|nos|hwyr))/i
}, Ck = {
  any: {
    am: /^b|(y\.?\s?b\.?)/i,
    pm: /^h|(y\.?\s?h\.?)|(yr hwyr)/i,
    midnight: /^hn|hanner nos/i,
    noon: /^hd|hanner dydd/i,
    morning: /bore/i,
    afternoon: /prynhawn/i,
    evening: /^gyda'r nos$/i,
    night: /blah/i
  }
}, Ik = {
  ordinalNumber: le({
    matchPattern: wk,
    parsePattern: _k,
    valueCallback: function(i) {
      return parseInt(i, 10);
    }
  }),
  era: P({
    matchPatterns: $k,
    defaultMatchWidth: "wide",
    parsePatterns: Pk,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: Mk,
    defaultMatchWidth: "wide",
    parsePatterns: jk,
    defaultParseWidth: "any",
    valueCallback: function(i) {
      return i + 1;
    }
  }),
  month: P({
    matchPatterns: Sk,
    defaultMatchWidth: "wide",
    parsePatterns: zk,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: Ok,
    defaultMatchWidth: "wide",
    parsePatterns: Wk,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: Dk,
    defaultMatchWidth: "any",
    parsePatterns: Ck,
    defaultParseWidth: "any"
  })
}, Tk = {
  code: "cy",
  formatDistance: ok,
  formatLong: fk,
  formatRelative: ck,
  localize: kk,
  match: Ik,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
const Nk = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Tk
}, Symbol.toStringTag, { value: "Module" })), xk = /* @__PURE__ */ te(Nk);
var Fk = {
  lessThanXSeconds: {
    one: "mindre end ét sekund",
    other: "mindre end {{count}} sekunder"
  },
  xSeconds: {
    one: "1 sekund",
    other: "{{count}} sekunder"
  },
  halfAMinute: "ét halvt minut",
  lessThanXMinutes: {
    one: "mindre end ét minut",
    other: "mindre end {{count}} minutter"
  },
  xMinutes: {
    one: "1 minut",
    other: "{{count}} minutter"
  },
  aboutXHours: {
    one: "cirka 1 time",
    other: "cirka {{count}} timer"
  },
  xHours: {
    one: "1 time",
    other: "{{count}} timer"
  },
  xDays: {
    one: "1 dag",
    other: "{{count}} dage"
  },
  aboutXWeeks: {
    one: "cirka 1 uge",
    other: "cirka {{count}} uger"
  },
  xWeeks: {
    one: "1 uge",
    other: "{{count}} uger"
  },
  aboutXMonths: {
    one: "cirka 1 måned",
    other: "cirka {{count}} måneder"
  },
  xMonths: {
    one: "1 måned",
    other: "{{count}} måneder"
  },
  aboutXYears: {
    one: "cirka 1 år",
    other: "cirka {{count}} år"
  },
  xYears: {
    one: "1 år",
    other: "{{count}} år"
  },
  overXYears: {
    one: "over 1 år",
    other: "over {{count}} år"
  },
  almostXYears: {
    one: "næsten 1 år",
    other: "næsten {{count}} år"
  }
}, Ek = function(i, d, a) {
  var t, o = Fk[i];
  return typeof o == "string" ? t = o : d === 1 ? t = o.one : t = o.other.replace("{{count}}", String(d)), a != null && a.addSuffix ? a.comparison && a.comparison > 0 ? "om " + t : t + " siden" : t;
}, Rk = {
  full: "EEEE 'den' d. MMMM y",
  long: "d. MMMM y",
  medium: "d. MMM y",
  short: "dd/MM/y"
}, Lk = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, qk = {
  full: "{{date}} 'kl'. {{time}}",
  long: "{{date}} 'kl'. {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, Zk = {
  date: I({
    formats: Rk,
    defaultWidth: "full"
  }),
  time: I({
    formats: Lk,
    defaultWidth: "full"
  }),
  dateTime: I({
    formats: qk,
    defaultWidth: "full"
  })
}, Ak = {
  lastWeek: "'sidste' eeee 'kl.' p",
  yesterday: "'i går kl.' p",
  today: "'i dag kl.' p",
  tomorrow: "'i morgen kl.' p",
  nextWeek: "'på' eeee 'kl.' p",
  other: "P"
}, Vk = function(i, d, a, t) {
  return Ak[i];
}, Hk = {
  narrow: ["fvt", "vt"],
  abbreviated: ["f.v.t.", "v.t."],
  wide: ["før vesterlandsk tidsregning", "vesterlandsk tidsregning"]
}, Uk = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1. kvt.", "2. kvt.", "3. kvt.", "4. kvt."],
  wide: ["1. kvartal", "2. kvartal", "3. kvartal", "4. kvartal"]
}, Bk = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["jan.", "feb.", "mar.", "apr.", "maj", "jun.", "jul.", "aug.", "sep.", "okt.", "nov.", "dec."],
  wide: ["januar", "februar", "marts", "april", "maj", "juni", "juli", "august", "september", "oktober", "november", "december"]
}, Xk = {
  narrow: ["S", "M", "T", "O", "T", "F", "L"],
  short: ["sø", "ma", "ti", "on", "to", "fr", "lø"],
  abbreviated: ["søn.", "man.", "tir.", "ons.", "tor.", "fre.", "lør."],
  wide: ["søndag", "mandag", "tirsdag", "onsdag", "torsdag", "fredag", "lørdag"]
}, Gk = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "midnat",
    noon: "middag",
    morning: "morgen",
    afternoon: "eftermiddag",
    evening: "aften",
    night: "nat"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnat",
    noon: "middag",
    morning: "morgen",
    afternoon: "eftermiddag",
    evening: "aften",
    night: "nat"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnat",
    noon: "middag",
    morning: "morgen",
    afternoon: "eftermiddag",
    evening: "aften",
    night: "nat"
  }
}, Kk = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "midnat",
    noon: "middag",
    morning: "om morgenen",
    afternoon: "om eftermiddagen",
    evening: "om aftenen",
    night: "om natten"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnat",
    noon: "middag",
    morning: "om morgenen",
    afternoon: "om eftermiddagen",
    evening: "om aftenen",
    night: "om natten"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnat",
    noon: "middag",
    morning: "om morgenen",
    afternoon: "om eftermiddagen",
    evening: "om aftenen",
    night: "om natten"
  }
}, Yk = function(i, d) {
  var a = Number(i);
  return a + ".";
}, Jk = {
  ordinalNumber: Yk,
  era: $({
    values: Hk,
    defaultWidth: "wide"
  }),
  quarter: $({
    values: Uk,
    defaultWidth: "wide",
    argumentCallback: function(i) {
      return i - 1;
    }
  }),
  month: $({
    values: Bk,
    defaultWidth: "wide"
  }),
  day: $({
    values: Xk,
    defaultWidth: "wide"
  }),
  dayPeriod: $({
    values: Gk,
    defaultWidth: "wide",
    formattingValues: Kk,
    defaultFormattingWidth: "wide"
  })
}, Qk = /^(\d+)(\.)?/i, ew = /\d+/i, nw = {
  narrow: /^(fKr|fvt|eKr|vt)/i,
  abbreviated: /^(f\.Kr\.?|f\.v\.t\.?|e\.Kr\.?|v\.t\.)/i,
  wide: /^(f.Kr.|før vesterlandsk tidsregning|e.Kr.|vesterlandsk tidsregning)/i
}, iw = {
  any: [/^f/i, /^(v|e)/i]
}, aw = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234]. kvt\./i,
  wide: /^[1234]\.? kvartal/i
}, tw = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, rw = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan.|feb.|mar.|apr.|maj|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
  wide: /^(januar|februar|marts|april|maj|juni|juli|august|september|oktober|november|december)/i
}, ow = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^maj/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, sw = {
  narrow: /^[smtofl]/i,
  short: /^(søn.|man.|tir.|ons.|tor.|fre.|lør.)/i,
  abbreviated: /^(søn|man|tir|ons|tor|fre|lør)/i,
  wide: /^(søndag|mandag|tirsdag|onsdag|torsdag|fredag|lørdag)/i
}, dw = {
  narrow: [/^s/i, /^m/i, /^t/i, /^o/i, /^t/i, /^f/i, /^l/i],
  any: [/^s/i, /^m/i, /^ti/i, /^o/i, /^to/i, /^f/i, /^l/i]
}, uw = {
  narrow: /^(a|p|midnat|middag|(om) (morgenen|eftermiddagen|aftenen|natten))/i,
  any: /^([ap]\.?\s?m\.?|midnat|middag|(om) (morgenen|eftermiddagen|aftenen|natten))/i
}, fw = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /midnat/i,
    noon: /middag/i,
    morning: /morgen/i,
    afternoon: /eftermiddag/i,
    evening: /aften/i,
    night: /nat/i
  }
}, lw = {
  ordinalNumber: le({
    matchPattern: Qk,
    parsePattern: ew,
    valueCallback: function(i) {
      return parseInt(i, 10);
    }
  }),
  era: P({
    matchPatterns: nw,
    defaultMatchWidth: "wide",
    parsePatterns: iw,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: aw,
    defaultMatchWidth: "wide",
    parsePatterns: tw,
    defaultParseWidth: "any",
    valueCallback: function(i) {
      return i + 1;
    }
  }),
  month: P({
    matchPatterns: rw,
    defaultMatchWidth: "wide",
    parsePatterns: ow,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: sw,
    defaultMatchWidth: "wide",
    parsePatterns: dw,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: uw,
    defaultMatchWidth: "any",
    parsePatterns: fw,
    defaultParseWidth: "any"
  })
}, cw = {
  code: "da",
  formatDistance: Ek,
  formatLong: Zk,
  formatRelative: Vk,
  localize: Jk,
  match: lw,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const mw = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: cw
}, Symbol.toStringTag, { value: "Module" })), vw = /* @__PURE__ */ te(mw);
var hw = {
  narrow: ["v.Chr.", "n.Chr."],
  abbreviated: ["v.Chr.", "n.Chr."],
  wide: ["vor Christus", "nach Christus"]
}, gw = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1. Quartal", "2. Quartal", "3. Quartal", "4. Quartal"]
}, qt = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jän", "Feb", "Mär", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"],
  wide: ["Jänner", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"]
}, pw = {
  narrow: qt.narrow,
  abbreviated: ["Jän.", "Feb.", "März", "Apr.", "Mai", "Juni", "Juli", "Aug.", "Sep.", "Okt.", "Nov.", "Dez."],
  wide: qt.wide
}, bw = {
  narrow: ["S", "M", "D", "M", "D", "F", "S"],
  short: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
  abbreviated: ["So.", "Mo.", "Di.", "Mi.", "Do.", "Fr.", "Sa."],
  wide: ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"]
}, yw = {
  narrow: {
    am: "vm.",
    pm: "nm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "Morgen",
    afternoon: "Nachm.",
    evening: "Abend",
    night: "Nacht"
  },
  abbreviated: {
    am: "vorm.",
    pm: "nachm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "Morgen",
    afternoon: "Nachmittag",
    evening: "Abend",
    night: "Nacht"
  },
  wide: {
    am: "vormittags",
    pm: "nachmittags",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "Morgen",
    afternoon: "Nachmittag",
    evening: "Abend",
    night: "Nacht"
  }
}, kw = {
  narrow: {
    am: "vm.",
    pm: "nm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "morgens",
    afternoon: "nachm.",
    evening: "abends",
    night: "nachts"
  },
  abbreviated: {
    am: "vorm.",
    pm: "nachm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "morgens",
    afternoon: "nachmittags",
    evening: "abends",
    night: "nachts"
  },
  wide: {
    am: "vormittags",
    pm: "nachmittags",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "morgens",
    afternoon: "nachmittags",
    evening: "abends",
    night: "nachts"
  }
}, ww = function(i) {
  var d = Number(i);
  return d + ".";
}, _w = {
  ordinalNumber: ww,
  era: $({
    values: hw,
    defaultWidth: "wide"
  }),
  quarter: $({
    values: gw,
    defaultWidth: "wide",
    argumentCallback: function(i) {
      return i - 1;
    }
  }),
  month: $({
    values: qt,
    formattingValues: pw,
    defaultWidth: "wide"
  }),
  day: $({
    values: bw,
    defaultWidth: "wide"
  }),
  dayPeriod: $({
    values: yw,
    defaultWidth: "wide",
    formattingValues: kw,
    defaultFormattingWidth: "wide"
  })
}, $w = {
  code: "de-AT",
  formatDistance: Gf,
  formatLong: Kf,
  formatRelative: Yf,
  localize: _w,
  match: Jf,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const Pw = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: $w
}, Symbol.toStringTag, { value: "Module" })), Mw = /* @__PURE__ */ te(Pw);
var jw = {
  lessThanXSeconds: {
    one: "λιγότερο από ένα δευτερόλεπτο",
    other: "λιγότερο από {{count}} δευτερόλεπτα"
  },
  xSeconds: {
    one: "1 δευτερόλεπτο",
    other: "{{count}} δευτερόλεπτα"
  },
  halfAMinute: "μισό λεπτό",
  lessThanXMinutes: {
    one: "λιγότερο από ένα λεπτό",
    other: "λιγότερο από {{count}} λεπτά"
  },
  xMinutes: {
    one: "1 λεπτό",
    other: "{{count}} λεπτά"
  },
  aboutXHours: {
    one: "περίπου 1 ώρα",
    other: "περίπου {{count}} ώρες"
  },
  xHours: {
    one: "1 ώρα",
    other: "{{count}} ώρες"
  },
  xDays: {
    one: "1 ημέρα",
    other: "{{count}} ημέρες"
  },
  aboutXWeeks: {
    one: "περίπου 1 εβδομάδα",
    other: "περίπου {{count}} εβδομάδες"
  },
  xWeeks: {
    one: "1 εβδομάδα",
    other: "{{count}} εβδομάδες"
  },
  aboutXMonths: {
    one: "περίπου 1 μήνας",
    other: "περίπου {{count}} μήνες"
  },
  xMonths: {
    one: "1 μήνας",
    other: "{{count}} μήνες"
  },
  aboutXYears: {
    one: "περίπου 1 χρόνο",
    other: "περίπου {{count}} χρόνια"
  },
  xYears: {
    one: "1 χρόνο",
    other: "{{count}} χρόνια"
  },
  overXYears: {
    one: "πάνω από 1 χρόνο",
    other: "πάνω από {{count}} χρόνια"
  },
  almostXYears: {
    one: "περίπου 1 χρόνο",
    other: "περίπου {{count}} χρόνια"
  }
}, Sw = function(i, d, a) {
  var t, o = jw[i];
  return typeof o == "string" ? t = o : d === 1 ? t = o.one : t = o.other.replace("{{count}}", String(d)), a != null && a.addSuffix ? a.comparison && a.comparison > 0 ? "σε " + t : t + " πριν" : t;
}, zw = {
  full: "EEEE, d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "d/M/yy"
}, Ow = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, Ww = {
  full: "{{date}} - {{time}}",
  long: "{{date}} - {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Dw = {
  date: I({
    formats: zw,
    defaultWidth: "full"
  }),
  time: I({
    formats: Ow,
    defaultWidth: "full"
  }),
  dateTime: I({
    formats: Ww,
    defaultWidth: "full"
  })
}, Cw = {
  lastWeek: function(i) {
    switch (i.getUTCDay()) {
      case 6:
        return "'το προηγούμενο' eeee 'στις' p";
      default:
        return "'την προηγούμενη' eeee 'στις' p";
    }
  },
  yesterday: "'χθες στις' p",
  today: "'σήμερα στις' p",
  tomorrow: "'αύριο στις' p",
  nextWeek: "eeee 'στις' p",
  other: "P"
}, Iw = function(i, d) {
  var a = Cw[i];
  return typeof a == "function" ? a(d) : a;
}, Tw = {
  narrow: ["πΧ", "μΧ"],
  abbreviated: ["π.Χ.", "μ.Χ."],
  wide: ["προ Χριστού", "μετά Χριστόν"]
}, Nw = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Τ1", "Τ2", "Τ3", "Τ4"],
  wide: ["1ο τρίμηνο", "2ο τρίμηνο", "3ο τρίμηνο", "4ο τρίμηνο"]
}, xw = {
  narrow: ["Ι", "Φ", "Μ", "Α", "Μ", "Ι", "Ι", "Α", "Σ", "Ο", "Ν", "Δ"],
  abbreviated: ["Ιαν", "Φεβ", "Μάρ", "Απρ", "Μάι", "Ιούν", "Ιούλ", "Αύγ", "Σεπ", "Οκτ", "Νοέ", "Δεκ"],
  wide: ["Ιανουάριος", "Φεβρουάριος", "Μάρτιος", "Απρίλιος", "Μάιος", "Ιούνιος", "Ιούλιος", "Αύγουστος", "Σεπτέμβριος", "Οκτώβριος", "Νοέμβριος", "Δεκέμβριος"]
}, Fw = {
  narrow: ["Ι", "Φ", "Μ", "Α", "Μ", "Ι", "Ι", "Α", "Σ", "Ο", "Ν", "Δ"],
  abbreviated: ["Ιαν", "Φεβ", "Μαρ", "Απρ", "Μαΐ", "Ιουν", "Ιουλ", "Αυγ", "Σεπ", "Οκτ", "Νοε", "Δεκ"],
  wide: ["Ιανουαρίου", "Φεβρουαρίου", "Μαρτίου", "Απριλίου", "Μαΐου", "Ιουνίου", "Ιουλίου", "Αυγούστου", "Σεπτεμβρίου", "Οκτωβρίου", "Νοεμβρίου", "Δεκεμβρίου"]
}, Ew = {
  narrow: ["Κ", "Δ", "T", "Τ", "Π", "Π", "Σ"],
  short: ["Κυ", "Δε", "Τρ", "Τε", "Πέ", "Πα", "Σά"],
  abbreviated: ["Κυρ", "Δευ", "Τρί", "Τετ", "Πέμ", "Παρ", "Σάβ"],
  wide: ["Κυριακή", "Δευτέρα", "Τρίτη", "Τετάρτη", "Πέμπτη", "Παρασκευή", "Σάββατο"]
}, Rw = {
  narrow: {
    am: "πμ",
    pm: "μμ",
    midnight: "μεσάνυχτα",
    noon: "μεσημέρι",
    morning: "πρωί",
    afternoon: "απόγευμα",
    evening: "βράδυ",
    night: "νύχτα"
  },
  abbreviated: {
    am: "π.μ.",
    pm: "μ.μ.",
    midnight: "μεσάνυχτα",
    noon: "μεσημέρι",
    morning: "πρωί",
    afternoon: "απόγευμα",
    evening: "βράδυ",
    night: "νύχτα"
  },
  wide: {
    am: "π.μ.",
    pm: "μ.μ.",
    midnight: "μεσάνυχτα",
    noon: "μεσημέρι",
    morning: "πρωί",
    afternoon: "απόγευμα",
    evening: "βράδυ",
    night: "νύχτα"
  }
}, Lw = function(i, d) {
  var a = Number(i), t = d == null ? void 0 : d.unit, o;
  return t === "year" || t === "month" ? o = "ος" : t === "week" || t === "dayOfYear" || t === "day" || t === "hour" || t === "date" ? o = "η" : o = "ο", a + o;
}, qw = {
  ordinalNumber: Lw,
  era: $({
    values: Tw,
    defaultWidth: "wide"
  }),
  quarter: $({
    values: Nw,
    defaultWidth: "wide",
    argumentCallback: function(i) {
      return i - 1;
    }
  }),
  month: $({
    values: xw,
    defaultWidth: "wide",
    formattingValues: Fw,
    defaultFormattingWidth: "wide"
  }),
  day: $({
    values: Ew,
    defaultWidth: "wide"
  }),
  dayPeriod: $({
    values: Rw,
    defaultWidth: "wide"
  })
}, Zw = /^(\d+)(ος|η|ο)?/i, Aw = /\d+/i, Vw = {
  narrow: /^(πΧ|μΧ)/i,
  abbreviated: /^(π\.?\s?χ\.?|π\.?\s?κ\.?\s?χ\.?|μ\.?\s?χ\.?|κ\.?\s?χ\.?)/i,
  wide: /^(προ Χριστο(ύ|υ)|πριν απ(ό|ο) την Κοιν(ή|η) Χρονολογ(ί|ι)α|μετ(ά|α) Χριστ(ό|ο)ν|Κοιν(ή|η) Χρονολογ(ί|ι)α)/i
}, Hw = {
  any: [/^π/i, /^(μ|κ)/i]
}, Uw = {
  narrow: /^[1234]/i,
  abbreviated: /^τ[1234]/i,
  wide: /^[1234]ο? τρ(ί|ι)μηνο/i
}, Bw = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Xw = {
  narrow: /^[ιφμαμιιασονδ]/i,
  abbreviated: /^(ιαν|φεβ|μ[άα]ρ|απρ|μ[άα][ιΐ]|ιο[ύυ]ν|ιο[ύυ]λ|α[ύυ]γ|σεπ|οκτ|νο[έε]|δεκ)/i,
  wide: /^(μ[άα][ιΐ]|α[ύυ]γο[υύ]στ)(ος|ου)|(ιανου[άα]ρ|φεβρου[άα]ρ|μ[άα]ρτ|απρ[ίι]λ|ιο[ύυ]ν|ιο[ύυ]λ|σεπτ[έε]μβρ|οκτ[ώω]βρ|νο[έε]μβρ|δεκ[έε]μβρ)(ιος|ίου)/i
}, Gw = {
  narrow: [/^ι/i, /^φ/i, /^μ/i, /^α/i, /^μ/i, /^ι/i, /^ι/i, /^α/i, /^σ/i, /^ο/i, /^ν/i, /^δ/i],
  any: [/^ια/i, /^φ/i, /^μ[άα]ρ/i, /^απ/i, /^μ[άα][ιΐ]/i, /^ιο[ύυ]ν/i, /^ιο[ύυ]λ/i, /^α[ύυ]/i, /^σ/i, /^ο/i, /^ν/i, /^δ/i]
}, Kw = {
  narrow: /^[κδτπσ]/i,
  short: /^(κυ|δε|τρ|τε|π[εέ]|π[αά]|σ[αά])/i,
  abbreviated: /^(κυρ|δευ|τρι|τετ|πεμ|παρ|σαβ)/i,
  wide: /^(κυριακ(ή|η)|δευτ(έ|ε)ρα|τρ(ί|ι)τη|τετ(ά|α)ρτη|π(έ|ε)μπτη|παρασκευ(ή|η)|σ(ά|α)ββατο)/i
}, Yw = {
  narrow: [/^κ/i, /^δ/i, /^τ/i, /^τ/i, /^π/i, /^π/i, /^σ/i],
  any: [/^κ/i, /^δ/i, /^τρ/i, /^τε/i, /^π[εέ]/i, /^π[αά]/i, /^σ/i]
}, Jw = {
  narrow: /^(πμ|μμ|μεσ(ά|α)νυχτα|μεσημ(έ|ε)ρι|πρω(ί|ι)|απ(ό|ο)γευμα|βρ(ά|α)δυ|ν(ύ|υ)χτα)/i,
  any: /^([πμ]\.?\s?μ\.?|μεσ(ά|α)νυχτα|μεσημ(έ|ε)ρι|πρω(ί|ι)|απ(ό|ο)γευμα|βρ(ά|α)δυ|ν(ύ|υ)χτα)/i
}, Qw = {
  any: {
    am: /^πμ|π\.\s?μ\./i,
    pm: /^μμ|μ\.\s?μ\./i,
    midnight: /^μεσάν/i,
    noon: /^μεσημ(έ|ε)/i,
    morning: /πρω(ί|ι)/i,
    afternoon: /απ(ό|ο)γευμα/i,
    evening: /βρ(ά|α)δυ/i,
    night: /ν(ύ|υ)χτα/i
  }
}, e_ = {
  ordinalNumber: le({
    matchPattern: Zw,
    parsePattern: Aw,
    valueCallback: function(i) {
      return parseInt(i, 10);
    }
  }),
  era: P({
    matchPatterns: Vw,
    defaultMatchWidth: "wide",
    parsePatterns: Hw,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: Uw,
    defaultMatchWidth: "wide",
    parsePatterns: Bw,
    defaultParseWidth: "any",
    valueCallback: function(i) {
      return i + 1;
    }
  }),
  month: P({
    matchPatterns: Xw,
    defaultMatchWidth: "wide",
    parsePatterns: Gw,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: Kw,
    defaultMatchWidth: "wide",
    parsePatterns: Yw,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: Jw,
    defaultMatchWidth: "any",
    parsePatterns: Qw,
    defaultParseWidth: "any"
  })
}, n_ = {
  code: "el",
  formatDistance: Sw,
  formatLong: Dw,
  formatRelative: Iw,
  localize: qw,
  match: e_,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const i_ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: n_
}, Symbol.toStringTag, { value: "Module" })), a_ = /* @__PURE__ */ te(i_);
var t_ = {
  full: "EEEE, d MMMM yyyy",
  long: "d MMMM yyyy",
  medium: "d MMM yyyy",
  short: "dd/MM/yyyy"
}, r_ = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, o_ = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, s_ = {
  date: I({
    formats: t_,
    defaultWidth: "full"
  }),
  time: I({
    formats: r_,
    defaultWidth: "full"
  }),
  dateTime: I({
    formats: o_,
    defaultWidth: "full"
  })
}, d_ = {
  code: "en-AU",
  formatDistance: Hn,
  formatLong: s_,
  formatRelative: Cn,
  localize: In,
  match: Tn,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const u_ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: d_
}, Symbol.toStringTag, { value: "Module" })), f_ = /* @__PURE__ */ te(u_);
var l_ = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "a second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "a minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about an hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "an hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "a day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about a week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "a week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about a month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "a month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about a year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "a year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over a year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost a year",
    other: "almost {{count}} years"
  }
}, c_ = function(i, d, a) {
  var t, o = l_[i];
  return typeof o == "string" ? t = o : d === 1 ? t = o.one : t = o.other.replace("{{count}}", d.toString()), a != null && a.addSuffix ? a.comparison && a.comparison > 0 ? "in " + t : t + " ago" : t;
}, m_ = {
  full: "EEEE, MMMM do, yyyy",
  long: "MMMM do, yyyy",
  medium: "MMM d, yyyy",
  short: "yyyy-MM-dd"
}, v_ = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, h_ = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, g_ = {
  date: I({
    formats: m_,
    defaultWidth: "full"
  }),
  time: I({
    formats: v_,
    defaultWidth: "full"
  }),
  dateTime: I({
    formats: h_,
    defaultWidth: "full"
  })
}, p_ = {
  code: "en-CA",
  formatDistance: c_,
  formatLong: g_,
  formatRelative: Cn,
  localize: In,
  match: Tn,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
const b_ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: p_
}, Symbol.toStringTag, { value: "Module" })), y_ = /* @__PURE__ */ te(b_);
var k_ = {
  full: "EEEE, d MMMM yyyy",
  long: "d MMMM yyyy",
  medium: "d MMM yyyy",
  short: "dd/MM/yyyy"
}, w_ = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, __ = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Wu = {
  date: I({
    formats: k_,
    defaultWidth: "full"
  }),
  time: I({
    formats: w_,
    defaultWidth: "full"
  }),
  dateTime: I({
    formats: __,
    defaultWidth: "full"
  })
}, $_ = {
  code: "en-GB",
  formatDistance: Hn,
  formatLong: Wu,
  formatRelative: Cn,
  localize: In,
  match: Tn,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const P_ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: $_
}, Symbol.toStringTag, { value: "Module" })), M_ = /* @__PURE__ */ te(P_);
var j_ = {
  code: "en-IE",
  formatDistance: Hn,
  formatLong: Wu,
  formatRelative: Cn,
  localize: In,
  match: Tn,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const S_ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: j_
}, Symbol.toStringTag, { value: "Module" })), z_ = /* @__PURE__ */ te(S_);
var O_ = {
  full: "EEEE, d MMMM yyyy",
  long: "d MMMM, yyyy",
  medium: "d MMM, yyyy",
  short: "dd/MM/yyyy"
}, W_ = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, D_ = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, C_ = {
  date: I({
    formats: O_,
    defaultWidth: "full"
  }),
  time: I({
    formats: W_,
    defaultWidth: "full"
  }),
  dateTime: I({
    formats: D_,
    defaultWidth: "full"
  })
}, I_ = {
  code: "en-IN",
  formatDistance: Hn,
  formatLong: C_,
  formatRelative: Cn,
  localize: In,
  match: Tn,
  options: {
    weekStartsOn: 1,
    // Monday is the first day of the week.
    firstWeekContainsDate: 4
    // The week that contains Jan 4th is the first week of the year.
  }
};
const T_ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: I_
}, Symbol.toStringTag, { value: "Module" })), N_ = /* @__PURE__ */ te(T_);
var x_ = {
  full: "EEEE, d MMMM yyyy",
  long: "d MMMM yyyy",
  medium: "d MMM yyyy",
  short: "dd/MM/yyyy"
}, F_ = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, E_ = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, R_ = {
  date: I({
    formats: x_,
    defaultWidth: "full"
  }),
  time: I({
    formats: F_,
    defaultWidth: "full"
  }),
  dateTime: I({
    formats: E_,
    defaultWidth: "full"
  })
}, L_ = {
  code: "en-NZ",
  formatDistance: Hn,
  formatLong: R_,
  formatRelative: Cn,
  localize: In,
  match: Tn,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const q_ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: L_
}, Symbol.toStringTag, { value: "Module" })), Z_ = /* @__PURE__ */ te(q_);
var A_ = {
  full: "EEEE, dd MMMM yyyy",
  long: "dd MMMM yyyy",
  medium: "dd MMM yyyy",
  short: "yyyy/MM/dd"
}, V_ = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, H_ = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, U_ = {
  date: I({
    formats: A_,
    defaultWidth: "full"
  }),
  time: I({
    formats: V_,
    defaultWidth: "full"
  }),
  dateTime: I({
    formats: H_,
    defaultWidth: "full"
  })
}, B_ = {
  code: "en-ZA",
  formatDistance: Hn,
  formatLong: U_,
  formatRelative: Cn,
  localize: In,
  match: Tn,
  options: {
    weekStartsOn: 0,
    // Sunday is the first day of the week.
    firstWeekContainsDate: 1
    // The week that contains Jan 1st is the first week of the year.
  }
};
const X_ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: B_
}, Symbol.toStringTag, { value: "Module" })), G_ = /* @__PURE__ */ te(X_);
var K_ = {
  lessThanXSeconds: {
    one: "malpli ol sekundo",
    other: "malpli ol {{count}} sekundoj"
  },
  xSeconds: {
    one: "1 sekundo",
    other: "{{count}} sekundoj"
  },
  halfAMinute: "duonminuto",
  lessThanXMinutes: {
    one: "malpli ol minuto",
    other: "malpli ol {{count}} minutoj"
  },
  xMinutes: {
    one: "1 minuto",
    other: "{{count}} minutoj"
  },
  aboutXHours: {
    one: "proksimume 1 horo",
    other: "proksimume {{count}} horoj"
  },
  xHours: {
    one: "1 horo",
    other: "{{count}} horoj"
  },
  xDays: {
    one: "1 tago",
    other: "{{count}} tagoj"
  },
  aboutXMonths: {
    one: "proksimume 1 monato",
    other: "proksimume {{count}} monatoj"
  },
  xWeeks: {
    one: "1 semajno",
    other: "{{count}} semajnoj"
  },
  aboutXWeeks: {
    one: "proksimume 1 semajno",
    other: "proksimume {{count}} semajnoj"
  },
  xMonths: {
    one: "1 monato",
    other: "{{count}} monatoj"
  },
  aboutXYears: {
    one: "proksimume 1 jaro",
    other: "proksimume {{count}} jaroj"
  },
  xYears: {
    one: "1 jaro",
    other: "{{count}} jaroj"
  },
  overXYears: {
    one: "pli ol 1 jaro",
    other: "pli ol {{count}} jaroj"
  },
  almostXYears: {
    one: "preskaŭ 1 jaro",
    other: "preskaŭ {{count}} jaroj"
  }
}, Y_ = function(i, d, a) {
  var t, o = K_[i];
  return typeof o == "string" ? t = o : d === 1 ? t = o.one : t = o.other.replace("{{count}}", String(d)), a != null && a.addSuffix ? a != null && a.comparison && a.comparison > 0 ? "post " + t : "antaŭ " + t : t;
}, J_ = {
  full: "EEEE, do 'de' MMMM y",
  long: "y-MMMM-dd",
  medium: "y-MMM-dd",
  short: "yyyy-MM-dd"
}, Q_ = {
  full: "Ho 'horo kaj' m:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, e0 = {
  any: "{{date}} {{time}}"
}, n0 = {
  date: I({
    formats: J_,
    defaultWidth: "full"
  }),
  time: I({
    formats: Q_,
    defaultWidth: "full"
  }),
  dateTime: I({
    formats: e0,
    defaultWidth: "any"
  })
}, i0 = {
  lastWeek: "'pasinta' eeee 'je' p",
  yesterday: "'hieraŭ je' p",
  today: "'hodiaŭ je' p",
  tomorrow: "'morgaŭ je' p",
  nextWeek: "eeee 'je' p",
  other: "P"
}, a0 = function(i, d, a, t) {
  return i0[i];
}, t0 = {
  narrow: ["aK", "pK"],
  abbreviated: ["a.K.E.", "p.K.E."],
  wide: ["antaŭ Komuna Erao", "Komuna Erao"]
}, r0 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["K1", "K2", "K3", "K4"],
  wide: ["1-a kvaronjaro", "2-a kvaronjaro", "3-a kvaronjaro", "4-a kvaronjaro"]
}, o0 = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["jan", "feb", "mar", "apr", "maj", "jun", "jul", "aŭg", "sep", "okt", "nov", "dec"],
  wide: ["januaro", "februaro", "marto", "aprilo", "majo", "junio", "julio", "aŭgusto", "septembro", "oktobro", "novembro", "decembro"]
}, s0 = {
  narrow: ["D", "L", "M", "M", "Ĵ", "V", "S"],
  short: ["di", "lu", "ma", "me", "ĵa", "ve", "sa"],
  abbreviated: ["dim", "lun", "mar", "mer", "ĵaŭ", "ven", "sab"],
  wide: ["dimanĉo", "lundo", "mardo", "merkredo", "ĵaŭdo", "vendredo", "sabato"]
}, d0 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "noktomezo",
    noon: "tagmezo",
    morning: "matene",
    afternoon: "posttagmeze",
    evening: "vespere",
    night: "nokte"
  },
  abbreviated: {
    am: "a.t.m.",
    pm: "p.t.m.",
    midnight: "noktomezo",
    noon: "tagmezo",
    morning: "matene",
    afternoon: "posttagmeze",
    evening: "vespere",
    night: "nokte"
  },
  wide: {
    am: "antaŭtagmeze",
    pm: "posttagmeze",
    midnight: "noktomezo",
    noon: "tagmezo",
    morning: "matene",
    afternoon: "posttagmeze",
    evening: "vespere",
    night: "nokte"
  }
}, u0 = function(i) {
  var d = Number(i);
  return d + "-a";
}, f0 = {
  ordinalNumber: u0,
  era: $({
    values: t0,
    defaultWidth: "wide"
  }),
  quarter: $({
    values: r0,
    defaultWidth: "wide",
    argumentCallback: function(i) {
      return Number(i) - 1;
    }
  }),
  month: $({
    values: o0,
    defaultWidth: "wide"
  }),
  day: $({
    values: s0,
    defaultWidth: "wide"
  }),
  dayPeriod: $({
    values: d0,
    defaultWidth: "wide"
  })
}, l0 = /^(\d+)(-?a)?/i, c0 = /\d+/i, m0 = {
  narrow: /^([ap]k)/i,
  abbreviated: /^([ap]\.?\s?k\.?\s?e\.?)/i,
  wide: /^((antaǔ |post )?komuna erao)/i
}, v0 = {
  any: [/^a/i, /^[kp]/i]
}, h0 = {
  narrow: /^[1234]/i,
  abbreviated: /^k[1234]/i,
  wide: /^[1234](-?a)? kvaronjaro/i
}, g0 = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, p0 = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|maj|jun|jul|a(ŭ|ux|uh|u)g|sep|okt|nov|dec)/i,
  wide: /^(januaro|februaro|marto|aprilo|majo|junio|julio|a(ŭ|ux|uh|u)gusto|septembro|oktobro|novembro|decembro)/i
}, b0 = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^maj/i, /^jun/i, /^jul/i, /^a(u|ŭ)/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, y0 = {
  narrow: /^[dlmĵjvs]/i,
  short: /^(di|lu|ma|me|(ĵ|jx|jh|j)a|ve|sa)/i,
  abbreviated: /^(dim|lun|mar|mer|(ĵ|jx|jh|j)a(ŭ|ux|uh|u)|ven|sab)/i,
  wide: /^(diman(ĉ|cx|ch|c)o|lundo|mardo|merkredo|(ĵ|jx|jh|j)a(ŭ|ux|uh|u)do|vendredo|sabato)/i
}, k0 = {
  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^(j|ĵ)/i, /^v/i, /^s/i],
  any: [/^d/i, /^l/i, /^ma/i, /^me/i, /^(j|ĵ)/i, /^v/i, /^s/i]
}, w0 = {
  narrow: /^([ap]|(posttagmez|noktomez|tagmez|maten|vesper|nokt)[eo])/i,
  abbreviated: /^([ap][.\s]?t[.\s]?m[.\s]?|(posttagmez|noktomez|tagmez|maten|vesper|nokt)[eo])/i,
  wide: /^(anta(ŭ|ux)tagmez|posttagmez|noktomez|tagmez|maten|vesper|nokt)[eo]/i
}, _0 = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^noktom/i,
    noon: /^t/i,
    morning: /^m/i,
    afternoon: /^posttagmeze/i,
    evening: /^v/i,
    night: /^n/i
  }
}, $0 = {
  ordinalNumber: le({
    matchPattern: l0,
    parsePattern: c0,
    valueCallback: function(i) {
      return parseInt(i, 10);
    }
  }),
  era: P({
    matchPatterns: m0,
    defaultMatchWidth: "wide",
    parsePatterns: v0,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: h0,
    defaultMatchWidth: "wide",
    parsePatterns: g0,
    defaultParseWidth: "any",
    valueCallback: function(i) {
      return i + 1;
    }
  }),
  month: P({
    matchPatterns: p0,
    defaultMatchWidth: "wide",
    parsePatterns: b0,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: y0,
    defaultMatchWidth: "wide",
    parsePatterns: k0,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: w0,
    defaultMatchWidth: "wide",
    parsePatterns: _0,
    defaultParseWidth: "any"
  })
}, P0 = {
  code: "eo",
  formatDistance: Y_,
  formatLong: n0,
  formatRelative: a0,
  localize: f0,
  match: $0,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const M0 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: P0
}, Symbol.toStringTag, { value: "Module" })), j0 = /* @__PURE__ */ te(M0);
var Gs = {
  lessThanXSeconds: {
    standalone: {
      one: "vähem kui üks sekund",
      other: "vähem kui {{count}} sekundit"
    },
    withPreposition: {
      one: "vähem kui ühe sekundi",
      other: "vähem kui {{count}} sekundi"
    }
  },
  xSeconds: {
    standalone: {
      one: "üks sekund",
      other: "{{count}} sekundit"
    },
    withPreposition: {
      one: "ühe sekundi",
      other: "{{count}} sekundi"
    }
  },
  halfAMinute: {
    standalone: "pool minutit",
    withPreposition: "poole minuti"
  },
  lessThanXMinutes: {
    standalone: {
      one: "vähem kui üks minut",
      other: "vähem kui {{count}} minutit"
    },
    withPreposition: {
      one: "vähem kui ühe minuti",
      other: "vähem kui {{count}} minuti"
    }
  },
  xMinutes: {
    standalone: {
      one: "üks minut",
      other: "{{count}} minutit"
    },
    withPreposition: {
      one: "ühe minuti",
      other: "{{count}} minuti"
    }
  },
  aboutXHours: {
    standalone: {
      one: "umbes üks tund",
      other: "umbes {{count}} tundi"
    },
    withPreposition: {
      one: "umbes ühe tunni",
      other: "umbes {{count}} tunni"
    }
  },
  xHours: {
    standalone: {
      one: "üks tund",
      other: "{{count}} tundi"
    },
    withPreposition: {
      one: "ühe tunni",
      other: "{{count}} tunni"
    }
  },
  xDays: {
    standalone: {
      one: "üks päev",
      other: "{{count}} päeva"
    },
    withPreposition: {
      one: "ühe päeva",
      other: "{{count}} päeva"
    }
  },
  aboutXWeeks: {
    standalone: {
      one: "umbes üks nädal",
      other: "umbes {{count}} nädalat"
    },
    withPreposition: {
      one: "umbes ühe nädala",
      other: "umbes {{count}} nädala"
    }
  },
  xWeeks: {
    standalone: {
      one: "üks nädal",
      other: "{{count}} nädalat"
    },
    withPreposition: {
      one: "ühe nädala",
      other: "{{count}} nädala"
    }
  },
  aboutXMonths: {
    standalone: {
      one: "umbes üks kuu",
      other: "umbes {{count}} kuud"
    },
    withPreposition: {
      one: "umbes ühe kuu",
      other: "umbes {{count}} kuu"
    }
  },
  xMonths: {
    standalone: {
      one: "üks kuu",
      other: "{{count}} kuud"
    },
    withPreposition: {
      one: "ühe kuu",
      other: "{{count}} kuu"
    }
  },
  aboutXYears: {
    standalone: {
      one: "umbes üks aasta",
      other: "umbes {{count}} aastat"
    },
    withPreposition: {
      one: "umbes ühe aasta",
      other: "umbes {{count}} aasta"
    }
  },
  xYears: {
    standalone: {
      one: "üks aasta",
      other: "{{count}} aastat"
    },
    withPreposition: {
      one: "ühe aasta",
      other: "{{count}} aasta"
    }
  },
  overXYears: {
    standalone: {
      one: "rohkem kui üks aasta",
      other: "rohkem kui {{count}} aastat"
    },
    withPreposition: {
      one: "rohkem kui ühe aasta",
      other: "rohkem kui {{count}} aasta"
    }
  },
  almostXYears: {
    standalone: {
      one: "peaaegu üks aasta",
      other: "peaaegu {{count}} aastat"
    },
    withPreposition: {
      one: "peaaegu ühe aasta",
      other: "peaaegu {{count}} aasta"
    }
  }
}, S0 = function(i, d, a) {
  var t = a != null && a.addSuffix ? Gs[i].withPreposition : Gs[i].standalone, o;
  return typeof t == "string" ? o = t : d === 1 ? o = t.one : o = t.other.replace("{{count}}", String(d)), a != null && a.addSuffix ? a.comparison && a.comparison > 0 ? o + " pärast" : o + " eest" : o;
}, z0 = {
  full: "EEEE, d. MMMM y",
  long: "d. MMMM y",
  medium: "d. MMM y",
  short: "dd.MM.y"
}, O0 = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, W0 = {
  full: "{{date}} 'kell' {{time}}",
  long: "{{date}} 'kell' {{time}}",
  medium: "{{date}}. {{time}}",
  short: "{{date}}. {{time}}"
}, D0 = {
  date: I({
    formats: z0,
    defaultWidth: "full"
  }),
  time: I({
    formats: O0,
    defaultWidth: "full"
  }),
  dateTime: I({
    formats: W0,
    defaultWidth: "full"
  })
}, C0 = {
  lastWeek: "'eelmine' eeee 'kell' p",
  yesterday: "'eile kell' p",
  today: "'täna kell' p",
  tomorrow: "'homme kell' p",
  nextWeek: "'järgmine' eeee 'kell' p",
  other: "P"
}, I0 = function(i, d, a, t) {
  return C0[i];
}, T0 = {
  narrow: ["e.m.a", "m.a.j"],
  abbreviated: ["e.m.a", "m.a.j"],
  wide: ["enne meie ajaarvamist", "meie ajaarvamise järgi"]
}, N0 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["K1", "K2", "K3", "K4"],
  wide: ["1. kvartal", "2. kvartal", "3. kvartal", "4. kvartal"]
}, Ks = {
  narrow: ["J", "V", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["jaan", "veebr", "märts", "apr", "mai", "juuni", "juuli", "aug", "sept", "okt", "nov", "dets"],
  wide: ["jaanuar", "veebruar", "märts", "aprill", "mai", "juuni", "juuli", "august", "september", "oktoober", "november", "detsember"]
}, Ys = {
  narrow: ["P", "E", "T", "K", "N", "R", "L"],
  short: ["P", "E", "T", "K", "N", "R", "L"],
  abbreviated: ["pühap.", "esmasp.", "teisip.", "kolmap.", "neljap.", "reede.", "laup."],
  wide: ["pühapäev", "esmaspäev", "teisipäev", "kolmapäev", "neljapäev", "reede", "laupäev"]
}, x0 = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "kesköö",
    noon: "keskpäev",
    morning: "hommik",
    afternoon: "pärastlõuna",
    evening: "õhtu",
    night: "öö"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "kesköö",
    noon: "keskpäev",
    morning: "hommik",
    afternoon: "pärastlõuna",
    evening: "õhtu",
    night: "öö"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "kesköö",
    noon: "keskpäev",
    morning: "hommik",
    afternoon: "pärastlõuna",
    evening: "õhtu",
    night: "öö"
  }
}, F0 = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "keskööl",
    noon: "keskpäeval",
    morning: "hommikul",
    afternoon: "pärastlõunal",
    evening: "õhtul",
    night: "öösel"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "keskööl",
    noon: "keskpäeval",
    morning: "hommikul",
    afternoon: "pärastlõunal",
    evening: "õhtul",
    night: "öösel"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "keskööl",
    noon: "keskpäeval",
    morning: "hommikul",
    afternoon: "pärastlõunal",
    evening: "õhtul",
    night: "öösel"
  }
}, E0 = function(i, d) {
  var a = Number(i);
  return a + ".";
}, R0 = {
  ordinalNumber: E0,
  era: $({
    values: T0,
    defaultWidth: "wide"
  }),
  quarter: $({
    values: N0,
    defaultWidth: "wide",
    argumentCallback: function(i) {
      return i - 1;
    }
  }),
  month: $({
    values: Ks,
    defaultWidth: "wide",
    formattingValues: Ks,
    defaultFormattingWidth: "wide"
  }),
  day: $({
    values: Ys,
    defaultWidth: "wide",
    formattingValues: Ys,
    defaultFormattingWidth: "wide"
  }),
  dayPeriod: $({
    values: x0,
    defaultWidth: "wide",
    formattingValues: F0,
    defaultFormattingWidth: "wide"
  })
}, L0 = /^\d+\./i, q0 = /\d+/i, Z0 = {
  narrow: /^(e\.m\.a|m\.a\.j|eKr|pKr)/i,
  abbreviated: /^(e\.m\.a|m\.a\.j|eKr|pKr)/i,
  wide: /^(enne meie ajaarvamist|meie ajaarvamise järgi|enne Kristust|pärast Kristust)/i
}, A0 = {
  any: [/^e/i, /^(m|p)/i]
}, V0 = {
  narrow: /^[1234]/i,
  abbreviated: /^K[1234]/i,
  wide: /^[1234](\.)? kvartal/i
}, H0 = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, U0 = {
  narrow: /^[jvmasond]/i,
  abbreviated: /^(jaan|veebr|märts|apr|mai|juuni|juuli|aug|sept|okt|nov|dets)/i,
  wide: /^(jaanuar|veebruar|märts|aprill|mai|juuni|juuli|august|september|oktoober|november|detsember)/i
}, B0 = {
  narrow: [/^j/i, /^v/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^v/i, /^mär/i, /^ap/i, /^mai/i, /^juun/i, /^juul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, X0 = {
  narrow: /^[petknrl]/i,
  short: /^[petknrl]/i,
  abbreviated: /^(püh?|esm?|tei?|kolm?|nel?|ree?|laup?)\.?/i,
  wide: /^(pühapäev|esmaspäev|teisipäev|kolmapäev|neljapäev|reede|laupäev)/i
}, G0 = {
  any: [/^p/i, /^e/i, /^t/i, /^k/i, /^n/i, /^r/i, /^l/i]
}, K0 = {
  any: /^(am|pm|keskööl?|keskpäev(al)?|hommik(ul)?|pärastlõunal?|õhtul?|öö(sel)?)/i
}, Y0 = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^keskö/i,
    noon: /^keskp/i,
    morning: /hommik/i,
    afternoon: /pärastlõuna/i,
    evening: /õhtu/i,
    night: /öö/i
  }
}, J0 = {
  ordinalNumber: le({
    matchPattern: L0,
    parsePattern: q0,
    valueCallback: function(i) {
      return parseInt(i, 10);
    }
  }),
  era: P({
    matchPatterns: Z0,
    defaultMatchWidth: "wide",
    parsePatterns: A0,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: V0,
    defaultMatchWidth: "wide",
    parsePatterns: H0,
    defaultParseWidth: "any",
    valueCallback: function(i) {
      return i + 1;
    }
  }),
  month: P({
    matchPatterns: U0,
    defaultMatchWidth: "wide",
    parsePatterns: B0,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: X0,
    defaultMatchWidth: "wide",
    parsePatterns: G0,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: K0,
    defaultMatchWidth: "any",
    parsePatterns: Y0,
    defaultParseWidth: "any"
  })
}, Q0 = {
  code: "et",
  formatDistance: S0,
  formatLong: D0,
  formatRelative: I0,
  localize: R0,
  match: J0,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const e2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Q0
}, Symbol.toStringTag, { value: "Module" })), n2 = /* @__PURE__ */ te(e2);
var i2 = {
  lessThanXSeconds: {
    one: "segundo bat baino gutxiago",
    other: "{{count}} segundo baino gutxiago"
  },
  xSeconds: {
    one: "1 segundo",
    other: "{{count}} segundo"
  },
  halfAMinute: "minutu erdi",
  lessThanXMinutes: {
    one: "minutu bat baino gutxiago",
    other: "{{count}} minutu baino gutxiago"
  },
  xMinutes: {
    one: "1 minutu",
    other: "{{count}} minutu"
  },
  aboutXHours: {
    one: "1 ordu gutxi gorabehera",
    other: "{{count}} ordu gutxi gorabehera"
  },
  xHours: {
    one: "1 ordu",
    other: "{{count}} ordu"
  },
  xDays: {
    one: "1 egun",
    other: "{{count}} egun"
  },
  aboutXWeeks: {
    one: "aste 1 inguru",
    other: "{{count}} aste inguru"
  },
  xWeeks: {
    one: "1 aste",
    other: "{{count}} astean"
  },
  aboutXMonths: {
    one: "1 hilabete gutxi gorabehera",
    other: "{{count}} hilabete gutxi gorabehera"
  },
  xMonths: {
    one: "1 hilabete",
    other: "{{count}} hilabete"
  },
  aboutXYears: {
    one: "1 urte gutxi gorabehera",
    other: "{{count}} urte gutxi gorabehera"
  },
  xYears: {
    one: "1 urte",
    other: "{{count}} urte"
  },
  overXYears: {
    one: "1 urte baino gehiago",
    other: "{{count}} urte baino gehiago"
  },
  almostXYears: {
    one: "ia 1 urte",
    other: "ia {{count}} urte"
  }
}, a2 = function(i, d, a) {
  var t, o = i2[i];
  return typeof o == "string" ? t = o : d === 1 ? t = o.one : t = o.other.replace("{{count}}", String(d)), a != null && a.addSuffix ? a.comparison && a.comparison > 0 ? "en " + t : "duela " + t : t;
}, t2 = {
  full: "EEEE, y'ko' MMMM'ren' d'a' y'ren'",
  long: "y'ko' MMMM'ren' d'a'",
  medium: "y MMM d",
  short: "yy/MM/dd"
}, r2 = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, o2 = {
  full: "{{date}} 'tan' {{time}}",
  long: "{{date}} 'tan' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, s2 = {
  date: I({
    formats: t2,
    defaultWidth: "full"
  }),
  time: I({
    formats: r2,
    defaultWidth: "full"
  }),
  dateTime: I({
    formats: o2,
    defaultWidth: "full"
  })
}, d2 = {
  lastWeek: "'joan den' eeee, LT",
  yesterday: "'atzo,' p",
  today: "'gaur,' p",
  tomorrow: "'bihar,' p",
  nextWeek: "eeee, p",
  other: "P"
}, u2 = {
  lastWeek: "'joan den' eeee, p",
  yesterday: "'atzo,' p",
  today: "'gaur,' p",
  tomorrow: "'bihar,' p",
  nextWeek: "eeee, p",
  other: "P"
}, f2 = function(i, d) {
  return d.getUTCHours() !== 1 ? u2[i] : d2[i];
}, l2 = {
  narrow: ["k.a.", "k.o."],
  abbreviated: ["k.a.", "k.o."],
  wide: ["kristo aurretik", "kristo ondoren"]
}, c2 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1H", "2H", "3H", "4H"],
  wide: ["1. hiruhilekoa", "2. hiruhilekoa", "3. hiruhilekoa", "4. hiruhilekoa"]
}, m2 = {
  narrow: ["u", "o", "m", "a", "m", "e", "u", "a", "i", "u", "a", "a"],
  abbreviated: ["urt", "ots", "mar", "api", "mai", "eka", "uzt", "abu", "ira", "urr", "aza", "abe"],
  wide: ["urtarrila", "otsaila", "martxoa", "apirila", "maiatza", "ekaina", "uztaila", "abuztua", "iraila", "urria", "azaroa", "abendua"]
}, v2 = {
  narrow: ["i", "a", "a", "a", "o", "o", "l"],
  short: ["ig", "al", "as", "az", "og", "or", "lr"],
  abbreviated: ["iga", "ast", "ast", "ast", "ost", "ost", "lar"],
  wide: ["igandea", "astelehena", "asteartea", "asteazkena", "osteguna", "ostirala", "larunbata"]
}, h2 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "ge",
    noon: "eg",
    morning: "goiza",
    afternoon: "arratsaldea",
    evening: "arratsaldea",
    night: "gaua"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "gauerdia",
    noon: "eguerdia",
    morning: "goiza",
    afternoon: "arratsaldea",
    evening: "arratsaldea",
    night: "gaua"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "gauerdia",
    noon: "eguerdia",
    morning: "goiza",
    afternoon: "arratsaldea",
    evening: "arratsaldea",
    night: "gaua"
  }
}, g2 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "ge",
    noon: "eg",
    morning: "goizean",
    afternoon: "arratsaldean",
    evening: "arratsaldean",
    night: "gauean"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "gauerdia",
    noon: "eguerdia",
    morning: "goizean",
    afternoon: "arratsaldean",
    evening: "arratsaldean",
    night: "gauean"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "gauerdia",
    noon: "eguerdia",
    morning: "goizean",
    afternoon: "arratsaldean",
    evening: "arratsaldean",
    night: "gauean"
  }
}, p2 = function(i, d) {
  var a = Number(i);
  return a + ".";
}, b2 = {
  ordinalNumber: p2,
  era: $({
    values: l2,
    defaultWidth: "wide"
  }),
  quarter: $({
    values: c2,
    defaultWidth: "wide",
    argumentCallback: function(i) {
      return i - 1;
    }
  }),
  month: $({
    values: m2,
    defaultWidth: "wide"
  }),
  day: $({
    values: v2,
    defaultWidth: "wide"
  }),
  dayPeriod: $({
    values: h2,
    defaultWidth: "wide",
    formattingValues: g2,
    defaultFormattingWidth: "wide"
  })
}, y2 = /^(\d+)(.)?/i, k2 = /\d+/i, w2 = {
  narrow: /^(k.a.|k.o.)/i,
  abbreviated: /^(k.a.|k.o.)/i,
  wide: /^(kristo aurretik|kristo ondoren)/i
}, _2 = {
  narrow: [/^k.a./i, /^k.o./i],
  abbreviated: [/^(k.a.)/i, /^(k.o.)/i],
  wide: [/^(kristo aurretik)/i, /^(kristo ondoren)/i]
}, $2 = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234]H/i,
  wide: /^[1234](.)? hiruhilekoa/i
}, P2 = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, M2 = {
  narrow: /^[uomaei]/i,
  abbreviated: /^(urt|ots|mar|api|mai|eka|uzt|abu|ira|urr|aza|abe)/i,
  wide: /^(urtarrila|otsaila|martxoa|apirila|maiatza|ekaina|uztaila|abuztua|iraila|urria|azaroa|abendua)/i
}, j2 = {
  narrow: [/^u/i, /^o/i, /^m/i, /^a/i, /^m/i, /^e/i, /^u/i, /^a/i, /^i/i, /^u/i, /^a/i, /^a/i],
  any: [/^urt/i, /^ots/i, /^mar/i, /^api/i, /^mai/i, /^eka/i, /^uzt/i, /^abu/i, /^ira/i, /^urr/i, /^aza/i, /^abe/i]
}, S2 = {
  narrow: /^[iaol]/i,
  short: /^(ig|al|as|az|og|or|lr)/i,
  abbreviated: /^(iga|ast|ast|ast|ost|ost|lar)/i,
  wide: /^(igandea|astelehena|asteartea|asteazkena|osteguna|ostirala|larunbata)/i
}, z2 = {
  narrow: [/^i/i, /^a/i, /^a/i, /^a/i, /^o/i, /^o/i, /^l/i],
  short: [/^ig/i, /^al/i, /^as/i, /^az/i, /^og/i, /^or/i, /^lr/i],
  abbreviated: [/^iga/i, /^ast/i, /^ast/i, /^ast/i, /^ost/i, /^ost/i, /^lar/i],
  wide: [/^igandea/i, /^astelehena/i, /^asteartea/i, /^asteazkena/i, /^osteguna/i, /^ostirala/i, /^larunbata/i]
}, O2 = {
  narrow: /^(a|p|ge|eg|((goiza|goizean)|arratsaldea|(gaua|gauean)))/i,
  any: /^([ap]\.?\s?m\.?|gauerdia|eguerdia|((goiza|goizean)|arratsaldea|(gaua|gauean)))/i
}, W2 = {
  narrow: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^ge/i,
    noon: /^eg/i,
    morning: /goiz/i,
    afternoon: /arratsaldea/i,
    evening: /arratsaldea/i,
    night: /gau/i
  },
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^gauerdia/i,
    noon: /^eguerdia/i,
    morning: /goiz/i,
    afternoon: /arratsaldea/i,
    evening: /arratsaldea/i,
    night: /gau/i
  }
}, D2 = {
  ordinalNumber: le({
    matchPattern: y2,
    parsePattern: k2,
    valueCallback: function(i) {
      return parseInt(i, 10);
    }
  }),
  era: P({
    matchPatterns: w2,
    defaultMatchWidth: "wide",
    parsePatterns: _2,
    defaultParseWidth: "wide"
  }),
  quarter: P({
    matchPatterns: $2,
    defaultMatchWidth: "wide",
    parsePatterns: P2,
    defaultParseWidth: "any",
    valueCallback: function(i) {
      return i + 1;
    }
  }),
  month: P({
    matchPatterns: M2,
    defaultMatchWidth: "wide",
    parsePatterns: j2,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: S2,
    defaultMatchWidth: "wide",
    parsePatterns: z2,
    defaultParseWidth: "wide"
  }),
  dayPeriod: P({
    matchPatterns: O2,
    defaultMatchWidth: "any",
    parsePatterns: W2,
    defaultParseWidth: "any"
  })
}, C2 = {
  code: "eu",
  formatDistance: a2,
  formatLong: s2,
  formatRelative: f2,
  localize: b2,
  match: D2,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
};
const I2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: C2
}, Symbol.toStringTag, { value: "Module" })), T2 = /* @__PURE__ */ te(I2);
var N2 = {
  lessThanXSeconds: {
    one: "کمتر از یک ثانیه",
    other: "کمتر از {{count}} ثانیه"
  },
  xSeconds: {
    one: "1 ثانیه",
    other: "{{count}} ثانیه"
  },
  halfAMinute: "نیم دقیقه",
  lessThanXMinutes: {
    one: "کمتر از یک دقیقه",
    other: "کمتر از {{count}} دقیقه"
  },
  xMinutes: {
    one: "1 دقیقه",
    other: "{{count}} دقیقه"
  },
  aboutXHours: {
    one: "حدود 1 ساعت",
    other: "حدود {{count}} ساعت"
  },
  xHours: {
    one: "1 ساعت",
    other: "{{count}} ساعت"
  },
  xDays: {
    one: "1 روز",
    other: "{{count}} روز"
  },
  aboutXWeeks: {
    one: "حدود 1 هفته",
    other: "حدود {{count}} هفته"
  },
  xWeeks: {
    one: "1 هفته",
    other: "{{count}} هفته"
  },
  aboutXMonths: {
    one: "حدود 1 ماه",
    other: "حدود {{count}} ماه"
  },
  xMonths: {
    one: "1 ماه",
    other: "{{count}} ماه"
  },
  aboutXYears: {
    one: "حدود 1 سال",
    other: "حدود {{count}} سال"
  },
  xYears: {
    one: "1 سال",
    other: "{{count}} سال"
  },
  overXYears: {
    one: "بیشتر از 1 سال",
    other: "بیشتر از {{count}} سال"
  },
  almostXYears: {
    one: "نزدیک 1 سال",
    other: "نزدیک {{count}} سال"
  }
}, x2 = function(i, d, a) {
  var t, o = N2[i];
  return typeof o == "string" ? t = o : d === 1 ? t = o.one : t = o.other.replace("{{count}}", String(d)), a != null && a.addSuffix ? a.comparison && a.comparison > 0 ? "در " + t : t + " قبل" : t;
}, F2 = {
  full: "EEEE do MMMM y",
  long: "do MMMM y",
  medium: "d MMM y",
  short: "yyyy/MM/dd"
}, E2 = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, R2 = {
  full: "{{date}} 'در' {{time}}",
  long: "{{date}} 'در' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, L2 = {
  date: I({
    formats: F2,
    defaultWidth: "full"
  }),
  time: I({
    formats: E2,
    defaultWidth: "full"
  }),
  dateTime: I({
    formats: R2,
    defaultWidth: "full"
  })
}, q2 = {
  lastWeek: "eeee 'گذشته در' p",
  yesterday: "'دیروز در' p",
  today: "'امروز در' p",
  tomorrow: "'فردا در' p",
  nextWeek: "eeee 'در' p",
  other: "P"
}, Z2 = function(i, d, a, t) {
  return q2[i];
}, A2 = {
  narrow: ["ق", "ب"],
  abbreviated: ["ق.م.", "ب.م."],
  wide: ["قبل از میلاد", "بعد از میلاد"]
}, V2 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["س‌م1", "س‌م2", "س‌م3", "س‌م4"],
  wide: ["سه‌ماهه 1", "سه‌ماهه 2", "سه‌ماهه 3", "سه‌ماهه 4"]
}, H2 = {
  narrow: ["ژ", "ف", "م", "آ", "م", "ج", "ج", "آ", "س", "ا", "ن", "د"],
  abbreviated: ["ژانـ", "فور", "مارس", "آپر", "می", "جون", "جولـ", "آگو", "سپتـ", "اکتـ", "نوامـ", "دسامـ"],
  wide: ["ژانویه", "فوریه", "مارس", "آپریل", "می", "جون", "جولای", "آگوست", "سپتامبر", "اکتبر", "نوامبر", "دسامبر"]
}, U2 = {
  narrow: ["ی", "د", "س", "چ", "پ", "ج", "ش"],
  short: ["1ش", "2ش", "3ش", "4ش", "5ش", "ج", "ش"],
  abbreviated: ["یکشنبه", "دوشنبه", "سه‌شنبه", "چهارشنبه", "پنجشنبه", "جمعه", "شنبه"],
  wide: ["یکشنبه", "دوشنبه", "سه‌شنبه", "چهارشنبه", "پنجشنبه", "جمعه", "شنبه"]
}, B2 = {
  narrow: {
    am: "ق",
    pm: "ب",
    midnight: "ن",
    noon: "ظ",
    morning: "ص",
    afternoon: "ب.ظ.",
    evening: "ع",
    night: "ش"
  },
  abbreviated: {
    am: "ق.ظ.",
    pm: "ب.ظ.",
    midnight: "نیمه‌شب",
    noon: "ظهر",
    morning: "صبح",
    afternoon: "بعدازظهر",
    evening: "عصر",
    night: "شب"
  },
  wide: {
    am: "قبل‌ازظهر",
    pm: "بعدازظهر",
    midnight: "نیمه‌شب",
    noon: "ظهر",
    morning: "صبح",
    afternoon: "بعدازظهر",
    evening: "عصر",
    night: "شب"
  }
}, X2 = {
  narrow: {
    am: "ق",
    pm: "ب",
    midnight: "ن",
    noon: "ظ",
    morning: "ص",
    afternoon: "ب.ظ.",
    evening: "ع",
    night: "ش"
  },
  abbreviated: {
    am: "ق.ظ.",
    pm: "ب.ظ.",
    midnight: "نیمه‌شب",
    noon: "ظهر",
    morning: "صبح",
    afternoon: "بعدازظهر",
    evening: "عصر",
    night: "شب"
  },
  wide: {
    am: "قبل‌ازظهر",
    pm: "بعدازظهر",
    midnight: "نیمه‌شب",
    noon: "ظهر",
    morning: "صبح",
    afternoon: "بعدازظهر",
    evening: "عصر",
    night: "شب"
  }
}, G2 = function(i, d) {
  return String(i);
}, K2 = {
  ordinalNumber: G2,
  era: $({
    values: A2,
    defaultWidth: "wide"
  }),
  quarter: $({
    values: V2,
    defaultWidth: "wide",
    argumentCallback: function(i) {
      return i - 1;
    }
  }),
  month: $({
    values: H2,
    defaultWidth: "wide"
  }),
  day: $({
    values: U2,
    defaultWidth: "wide"
  }),
  dayPeriod: $({
    values: B2,
    defaultWidth: "wide",
    formattingValues: X2,
    defaultFormattingWidth: "wide"
  })
}, Y2 = /^(\d+)(th|st|nd|rd)?/i, J2 = /\d+/i, Q2 = {
  narrow: /^(ق|ب)/i,
  abbreviated: /^(ق\.?\s?م\.?|ق\.?\s?د\.?\s?م\.?|م\.?\s?|د\.?\s?م\.?)/i,
  wide: /^(قبل از میلاد|قبل از دوران مشترک|میلادی|دوران مشترک|بعد از میلاد)/i
}, e$ = {
  any: [/^قبل/i, /^بعد/i]
}, n$ = {
  narrow: /^[1234]/i,
  abbreviated: /^س‌م[1234]/i,
  wide: /^سه‌ماهه [1234]/i
}, i$ = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, a$ = {
  narrow: /^[جژفمآاماسند]/i,
  abbreviated: /^(جنو|ژانـ|ژانویه|فوریه|فور|مارس|آوریل|آپر|مه|می|ژوئن|جون|جول|جولـ|ژوئیه|اوت|آگو|سپتمبر|سپتامبر|اکتبر|اکتوبر|نوامبر|نوامـ|دسامبر|دسامـ|دسم)/i,
  wide: /^(ژانویه|جنوری|فبروری|فوریه|مارچ|مارس|آپریل|اپریل|ایپریل|آوریل|مه|می|ژوئن|جون|جولای|ژوئیه|آگست|اگست|آگوست|اوت|سپتمبر|سپتامبر|اکتبر|اکتوبر|نوامبر|نومبر|دسامبر|دسمبر)/i
}, t$ = {
  narrow: [/^(ژ|ج)/i, /^ف/i, /^م/i, /^(آ|ا)/i, /^م/i, /^(ژ|ج)/i, /^(ج|ژ)/i, /^(آ|ا)/i, /^س/i, /^ا/i, /^ن/i, /^د/i],
  any: [/^ژا/i, /^ف/i, /^ما/i, /^آپ/i, /^(می|مه)/i, /^(ژوئن|جون)/i, /^(ژوئی|جول)/i, /^(اوت|آگ)/i, /^س/i, /^(اوک|اک)/i, /^ن/i, /^د/i]
}, r$ = {
  narrow: /^[شیدسچپج]/i,
  short: /^(ش|ج|1ش|2ش|3ش|4ش|5ش)/i,
  abbreviated: /^(یکشنبه|دوشنبه|سه‌شنبه|چهارشنبه|پنج‌شنبه|جمعه|شنبه)/i,
  wide: /^(یکشنبه|دوشنبه|سه‌شنبه|چهارشنبه|پنج‌شنبه|جمعه|شنبه)/i
}, o$ = {
  narrow: [/^ی/i, /^دو/i, /^س/i, /^چ/i, /^پ/i, /^ج/i, /^ش/i],
  any: [/^(ی|1ش|یکشنبه)/i, /^(د|2ش|دوشنبه)/i, /^(س|3ش|سه‌شنبه)/i, /^(چ|4ش|چهارشنبه)/i, /^(پ|5ش|پنجشنبه)/i, /^(ج|جمعه)/i, /^(ش|شنبه)/i]
}, s$ = {
  narrow: /^(ب|ق|ن|ظ|ص|ب.ظ.|ع|ش)/i,
  abbreviated: /^(ق.ظ.|ب.ظ.|نیمه‌شب|ظهر|صبح|بعدازظهر|عصر|شب)/i,
  wide: /^(قبل‌ازظهر|نیمه‌شب|ظهر|صبح|بعدازظهر|عصر|شب)/i
}, d$ = {
  any: {
    am: /^(ق|ق.ظ.|قبل‌ازظهر)/i,
    pm: /^(ب|ب.ظ.|بعدازظهر)/i,
    midnight: /^(‌نیمه‌شب|ن)/i,
    noon: /^(ظ|ظهر)/i,
    morning: /(ص|صبح)/i,
    afternoon: /(ب|ب.ظ.|بعدازظهر)/i,
    evening: /(ع|عصر)/i,
    night: /(ش|شب)/i
  }
}, u$ = {
  ordinalNumber: le({
    matchPattern: Y2,
    parsePattern: J2,
    valueCallback: function(i) {
      return parseInt(i, 10);
    }
  }),
  era: P({
    matchPatterns: Q2,
    defaultMatchWidth: "wide",
    parsePatterns: e$,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: n$,
    defaultMatchWidth: "wide",
    parsePatterns: i$,
    defaultParseWidth: "any",
    valueCallback: function(i) {
      return i + 1;
    }
  }),
  month: P({
    matchPatterns: a$,
    defaultMatchWidth: "wide",
    parsePatterns: t$,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: r$,
    defaultMatchWidth: "wide",
    parsePatterns: o$,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: s$,
    defaultMatchWidth: "wide",
    parsePatterns: d$,
    defaultParseWidth: "any"
  })
}, f$ = {
  code: "fa-IR",
  formatDistance: x2,
  formatLong: L2,
  formatRelative: Z2,
  localize: K2,
  match: u$,
  options: {
    weekStartsOn: 6,
    firstWeekContainsDate: 1
  }
};
const l$ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: f$
}, Symbol.toStringTag, { value: "Module" })), c$ = /* @__PURE__ */ te(l$);
function Js(e) {
  return e.replace(/sekuntia?/, "sekunnin");
}
function Qs(e) {
  return e.replace(/minuuttia?/, "minuutin");
}
function ed(e) {
  return e.replace(/tuntia?/, "tunnin");
}
function m$(e) {
  return e.replace(/päivää?/, "päivän");
}
function nd(e) {
  return e.replace(/(viikko|viikkoa)/, "viikon");
}
function id(e) {
  return e.replace(/(kuukausi|kuukautta)/, "kuukauden");
}
function Bi(e) {
  return e.replace(/(vuosi|vuotta)/, "vuoden");
}
var v$ = {
  lessThanXSeconds: {
    one: "alle sekunti",
    other: "alle {{count}} sekuntia",
    futureTense: Js
  },
  xSeconds: {
    one: "sekunti",
    other: "{{count}} sekuntia",
    futureTense: Js
  },
  halfAMinute: {
    one: "puoli minuuttia",
    other: "puoli minuuttia",
    futureTense: function(i) {
      return "puolen minuutin";
    }
  },
  lessThanXMinutes: {
    one: "alle minuutti",
    other: "alle {{count}} minuuttia",
    futureTense: Qs
  },
  xMinutes: {
    one: "minuutti",
    other: "{{count}} minuuttia",
    futureTense: Qs
  },
  aboutXHours: {
    one: "noin tunti",
    other: "noin {{count}} tuntia",
    futureTense: ed
  },
  xHours: {
    one: "tunti",
    other: "{{count}} tuntia",
    futureTense: ed
  },
  xDays: {
    one: "päivä",
    other: "{{count}} päivää",
    futureTense: m$
  },
  aboutXWeeks: {
    one: "noin viikko",
    other: "noin {{count}} viikkoa",
    futureTense: nd
  },
  xWeeks: {
    one: "viikko",
    other: "{{count}} viikkoa",
    futureTense: nd
  },
  aboutXMonths: {
    one: "noin kuukausi",
    other: "noin {{count}} kuukautta",
    futureTense: id
  },
  xMonths: {
    one: "kuukausi",
    other: "{{count}} kuukautta",
    futureTense: id
  },
  aboutXYears: {
    one: "noin vuosi",
    other: "noin {{count}} vuotta",
    futureTense: Bi
  },
  xYears: {
    one: "vuosi",
    other: "{{count}} vuotta",
    futureTense: Bi
  },
  overXYears: {
    one: "yli vuosi",
    other: "yli {{count}} vuotta",
    futureTense: Bi
  },
  almostXYears: {
    one: "lähes vuosi",
    other: "lähes {{count}} vuotta",
    futureTense: Bi
  }
}, h$ = function(i, d, a) {
  var t = v$[i], o = d === 1 ? t.one : t.other.replace("{{count}}", String(d));
  return a != null && a.addSuffix ? a.comparison && a.comparison > 0 ? t.futureTense(o) + " kuluttua" : o + " sitten" : o;
}, g$ = {
  full: "eeee d. MMMM y",
  long: "d. MMMM y",
  medium: "d. MMM y",
  short: "d.M.y"
}, p$ = {
  full: "HH.mm.ss zzzz",
  long: "HH.mm.ss z",
  medium: "HH.mm.ss",
  short: "HH.mm"
}, b$ = {
  full: "{{date}} 'klo' {{time}}",
  long: "{{date}} 'klo' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, y$ = {
  date: I({
    formats: g$,
    defaultWidth: "full"
  }),
  time: I({
    formats: p$,
    defaultWidth: "full"
  }),
  dateTime: I({
    formats: b$,
    defaultWidth: "full"
  })
}, k$ = {
  lastWeek: "'viime' eeee 'klo' p",
  yesterday: "'eilen klo' p",
  today: "'tänään klo' p",
  tomorrow: "'huomenna klo' p",
  nextWeek: "'ensi' eeee 'klo' p",
  other: "P"
}, w$ = function(i, d, a, t) {
  return k$[i];
}, _$ = {
  narrow: ["eaa.", "jaa."],
  abbreviated: ["eaa.", "jaa."],
  wide: ["ennen ajanlaskun alkua", "jälkeen ajanlaskun alun"]
}, $$ = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1. kvartaali", "2. kvartaali", "3. kvartaali", "4. kvartaali"]
}, Zt = {
  narrow: ["T", "H", "M", "H", "T", "K", "H", "E", "S", "L", "M", "J"],
  abbreviated: ["tammi", "helmi", "maalis", "huhti", "touko", "kesä", "heinä", "elo", "syys", "loka", "marras", "joulu"],
  wide: ["tammikuu", "helmikuu", "maaliskuu", "huhtikuu", "toukokuu", "kesäkuu", "heinäkuu", "elokuu", "syyskuu", "lokakuu", "marraskuu", "joulukuu"]
}, P$ = {
  narrow: Zt.narrow,
  abbreviated: Zt.abbreviated,
  wide: ["tammikuuta", "helmikuuta", "maaliskuuta", "huhtikuuta", "toukokuuta", "kesäkuuta", "heinäkuuta", "elokuuta", "syyskuuta", "lokakuuta", "marraskuuta", "joulukuuta"]
}, Ki = {
  narrow: ["S", "M", "T", "K", "T", "P", "L"],
  short: ["su", "ma", "ti", "ke", "to", "pe", "la"],
  abbreviated: ["sunn.", "maan.", "tiis.", "kesk.", "torst.", "perj.", "la"],
  wide: ["sunnuntai", "maanantai", "tiistai", "keskiviikko", "torstai", "perjantai", "lauantai"]
}, M$ = {
  narrow: Ki.narrow,
  short: Ki.short,
  abbreviated: Ki.abbreviated,
  wide: ["sunnuntaina", "maanantaina", "tiistaina", "keskiviikkona", "torstaina", "perjantaina", "lauantaina"]
}, j$ = {
  narrow: {
    am: "ap",
    pm: "ip",
    midnight: "keskiyö",
    noon: "keskipäivä",
    morning: "ap",
    afternoon: "ip",
    evening: "illalla",
    night: "yöllä"
  },
  abbreviated: {
    am: "ap",
    pm: "ip",
    midnight: "keskiyö",
    noon: "keskipäivä",
    morning: "ap",
    afternoon: "ip",
    evening: "illalla",
    night: "yöllä"
  },
  wide: {
    am: "ap",
    pm: "ip",
    midnight: "keskiyöllä",
    noon: "keskipäivällä",
    morning: "aamupäivällä",
    afternoon: "iltapäivällä",
    evening: "illalla",
    night: "yöllä"
  }
}, S$ = function(i, d) {
  var a = Number(i);
  return a + ".";
}, z$ = {
  ordinalNumber: S$,
  era: $({
    values: _$,
    defaultWidth: "wide"
  }),
  quarter: $({
    values: $$,
    defaultWidth: "wide",
    argumentCallback: function(i) {
      return i - 1;
    }
  }),
  month: $({
    values: Zt,
    defaultWidth: "wide",
    formattingValues: P$,
    defaultFormattingWidth: "wide"
  }),
  day: $({
    values: Ki,
    defaultWidth: "wide",
    formattingValues: M$,
    defaultFormattingWidth: "wide"
  }),
  dayPeriod: $({
    values: j$,
    defaultWidth: "wide"
  })
}, O$ = /^(\d+)(\.)/i, W$ = /\d+/i, D$ = {
  narrow: /^(e|j)/i,
  abbreviated: /^(eaa.|jaa.)/i,
  wide: /^(ennen ajanlaskun alkua|jälkeen ajanlaskun alun)/i
}, C$ = {
  any: [/^e/i, /^j/i]
}, I$ = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234]\.? kvartaali/i
}, T$ = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, N$ = {
  narrow: /^[thmkeslj]/i,
  abbreviated: /^(tammi|helmi|maalis|huhti|touko|kesä|heinä|elo|syys|loka|marras|joulu)/i,
  wide: /^(tammikuu|helmikuu|maaliskuu|huhtikuu|toukokuu|kesäkuu|heinäkuu|elokuu|syyskuu|lokakuu|marraskuu|joulukuu)(ta)?/i
}, x$ = {
  narrow: [/^t/i, /^h/i, /^m/i, /^h/i, /^t/i, /^k/i, /^h/i, /^e/i, /^s/i, /^l/i, /^m/i, /^j/i],
  any: [/^ta/i, /^hel/i, /^maa/i, /^hu/i, /^to/i, /^k/i, /^hei/i, /^e/i, /^s/i, /^l/i, /^mar/i, /^j/i]
}, F$ = {
  narrow: /^[smtkpl]/i,
  short: /^(su|ma|ti|ke|to|pe|la)/i,
  abbreviated: /^(sunn.|maan.|tiis.|kesk.|torst.|perj.|la)/i,
  wide: /^(sunnuntai|maanantai|tiistai|keskiviikko|torstai|perjantai|lauantai)(na)?/i
}, E$ = {
  narrow: [/^s/i, /^m/i, /^t/i, /^k/i, /^t/i, /^p/i, /^l/i],
  any: [/^s/i, /^m/i, /^ti/i, /^k/i, /^to/i, /^p/i, /^l/i]
}, R$ = {
  narrow: /^(ap|ip|keskiyö|keskipäivä|aamupäivällä|iltapäivällä|illalla|yöllä)/i,
  any: /^(ap|ip|keskiyöllä|keskipäivällä|aamupäivällä|iltapäivällä|illalla|yöllä)/i
}, L$ = {
  any: {
    am: /^ap/i,
    pm: /^ip/i,
    midnight: /^keskiyö/i,
    noon: /^keskipäivä/i,
    morning: /aamupäivällä/i,
    afternoon: /iltapäivällä/i,
    evening: /illalla/i,
    night: /yöllä/i
  }
}, q$ = {
  ordinalNumber: le({
    matchPattern: O$,
    parsePattern: W$,
    valueCallback: function(i) {
      return parseInt(i, 10);
    }
  }),
  era: P({
    matchPatterns: D$,
    defaultMatchWidth: "wide",
    parsePatterns: C$,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: I$,
    defaultMatchWidth: "wide",
    parsePatterns: T$,
    defaultParseWidth: "any",
    valueCallback: function(i) {
      return i + 1;
    }
  }),
  month: P({
    matchPatterns: N$,
    defaultMatchWidth: "wide",
    parsePatterns: x$,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: F$,
    defaultMatchWidth: "wide",
    parsePatterns: E$,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: R$,
    defaultMatchWidth: "any",
    parsePatterns: L$,
    defaultParseWidth: "any"
  })
}, Z$ = {
  code: "fi",
  formatDistance: h$,
  formatLong: y$,
  formatRelative: w$,
  localize: z$,
  match: q$,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const A$ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Z$
}, Symbol.toStringTag, { value: "Module" })), V$ = /* @__PURE__ */ te(A$);
var H$ = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "dd/MM/y"
}, U$ = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, B$ = {
  full: "{{date}} 'à' {{time}}",
  long: "{{date}} 'à' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, X$ = {
  date: I({
    formats: H$,
    defaultWidth: "full"
  }),
  time: I({
    formats: U$,
    defaultWidth: "full"
  }),
  dateTime: I({
    formats: B$,
    defaultWidth: "full"
  })
}, G$ = {
  code: "fr",
  formatDistance: Wd,
  formatLong: X$,
  formatRelative: Qf,
  localize: Dd,
  match: Cd,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const K$ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: G$
}, Symbol.toStringTag, { value: "Module" })), Y$ = /* @__PURE__ */ te(K$);
var J$ = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "dd.MM.y"
}, Q$ = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, e3 = {
  full: "{{date}} 'à' {{time}}",
  long: "{{date}} 'à' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, n3 = {
  date: I({
    formats: J$,
    defaultWidth: "full"
  }),
  time: I({
    formats: Q$,
    defaultWidth: "full"
  }),
  dateTime: I({
    formats: e3,
    defaultWidth: "full"
  })
}, i3 = {
  lastWeek: "eeee 'la semaine dernière à' p",
  yesterday: "'hier à' p",
  today: "'aujourd’hui à' p",
  tomorrow: "'demain à' p'",
  nextWeek: "eeee 'la semaine prochaine à' p",
  other: "P"
}, a3 = function(i, d, a, t) {
  return i3[i];
}, t3 = {
  code: "fr-CH",
  formatDistance: Wd,
  formatLong: n3,
  formatRelative: a3,
  localize: Dd,
  match: Cd,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const r3 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: t3
}, Symbol.toStringTag, { value: "Module" })), o3 = /* @__PURE__ */ te(r3);
var s3 = {
  lessThanXSeconds: {
    one: "menos dun segundo",
    other: "menos de {{count}} segundos"
  },
  xSeconds: {
    one: "1 segundo",
    other: "{{count}} segundos"
  },
  halfAMinute: "medio minuto",
  lessThanXMinutes: {
    one: "menos dun minuto",
    other: "menos de {{count}} minutos"
  },
  xMinutes: {
    one: "1 minuto",
    other: "{{count}} minutos"
  },
  aboutXHours: {
    one: "arredor dunha hora",
    other: "arredor de {{count}} horas"
  },
  xHours: {
    one: "1 hora",
    other: "{{count}} horas"
  },
  xDays: {
    one: "1 día",
    other: "{{count}} días"
  },
  aboutXWeeks: {
    one: "arredor dunha semana",
    other: "arredor de {{count}} semanas"
  },
  xWeeks: {
    one: "1 semana",
    other: "{{count}} semanas"
  },
  aboutXMonths: {
    one: "arredor de 1 mes",
    other: "arredor de {{count}} meses"
  },
  xMonths: {
    one: "1 mes",
    other: "{{count}} meses"
  },
  aboutXYears: {
    one: "arredor dun ano",
    other: "arredor de {{count}} anos"
  },
  xYears: {
    one: "1 ano",
    other: "{{count}} anos"
  },
  overXYears: {
    one: "máis dun ano",
    other: "máis de {{count}} anos"
  },
  almostXYears: {
    one: "case un ano",
    other: "case {{count}} anos"
  }
}, d3 = function(i, d, a) {
  var t, o = s3[i];
  return typeof o == "string" ? t = o : d === 1 ? t = o.one : t = o.other.replace("{{count}}", String(d)), a != null && a.addSuffix ? a.comparison && a.comparison > 0 ? "en " + t : "hai " + t : t;
}, u3 = {
  full: "EEEE, d 'de' MMMM y",
  long: "d 'de' MMMM y",
  medium: "d MMM y",
  short: "dd/MM/y"
}, f3 = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, l3 = {
  full: "{{date}} 'ás' {{time}}",
  long: "{{date}} 'ás' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, c3 = {
  date: I({
    formats: u3,
    defaultWidth: "full"
  }),
  time: I({
    formats: f3,
    defaultWidth: "full"
  }),
  dateTime: I({
    formats: l3,
    defaultWidth: "full"
  })
}, m3 = {
  lastWeek: "'o' eeee 'pasado á' LT",
  yesterday: "'onte á' p",
  today: "'hoxe á' p",
  tomorrow: "'mañá á' p",
  nextWeek: "eeee 'á' p",
  other: "P"
}, v3 = {
  lastWeek: "'o' eeee 'pasado ás' p",
  yesterday: "'onte ás' p",
  today: "'hoxe ás' p",
  tomorrow: "'mañá ás' p",
  nextWeek: "eeee 'ás' p",
  other: "P"
}, h3 = function(i, d, a, t) {
  return d.getUTCHours() !== 1 ? v3[i] : m3[i];
}, g3 = {
  narrow: ["AC", "DC"],
  abbreviated: ["AC", "DC"],
  wide: ["antes de cristo", "despois de cristo"]
}, p3 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["T1", "T2", "T3", "T4"],
  wide: ["1º trimestre", "2º trimestre", "3º trimestre", "4º trimestre"]
}, b3 = {
  narrow: ["e", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
  abbreviated: ["xan", "feb", "mar", "abr", "mai", "xun", "xul", "ago", "set", "out", "nov", "dec"],
  wide: ["xaneiro", "febreiro", "marzo", "abril", "maio", "xuño", "xullo", "agosto", "setembro", "outubro", "novembro", "decembro"]
}, y3 = {
  narrow: ["d", "l", "m", "m", "j", "v", "s"],
  short: ["do", "lu", "ma", "me", "xo", "ve", "sa"],
  abbreviated: ["dom", "lun", "mar", "mer", "xov", "ven", "sab"],
  wide: ["domingo", "luns", "martes", "mércores", "xoves", "venres", "sábado"]
}, k3 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mn",
    noon: "md",
    morning: "mañá",
    afternoon: "tarde",
    evening: "tarde",
    night: "noite"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "medianoite",
    noon: "mediodía",
    morning: "mañá",
    afternoon: "tarde",
    evening: "tardiña",
    night: "noite"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "medianoite",
    noon: "mediodía",
    morning: "mañá",
    afternoon: "tarde",
    evening: "tardiña",
    night: "noite"
  }
}, w3 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mn",
    noon: "md",
    morning: "da mañá",
    afternoon: "da tarde",
    evening: "da tardiña",
    night: "da noite"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "medianoite",
    noon: "mediodía",
    morning: "da mañá",
    afternoon: "da tarde",
    evening: "da tardiña",
    night: "da noite"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "medianoite",
    noon: "mediodía",
    morning: "da mañá",
    afternoon: "da tarde",
    evening: "da tardiña",
    night: "da noite"
  }
}, _3 = function(i, d) {
  var a = Number(i);
  return a + "º";
}, $3 = {
  ordinalNumber: _3,
  era: $({
    values: g3,
    defaultWidth: "wide"
  }),
  quarter: $({
    values: p3,
    defaultWidth: "wide",
    argumentCallback: function(i) {
      return i - 1;
    }
  }),
  month: $({
    values: b3,
    defaultWidth: "wide"
  }),
  day: $({
    values: y3,
    defaultWidth: "wide"
  }),
  dayPeriod: $({
    values: k3,
    defaultWidth: "wide",
    formattingValues: w3,
    defaultFormattingWidth: "wide"
  })
}, P3 = /^(\d+)(º)?/i, M3 = /\d+/i, j3 = {
  narrow: /^(ac|dc|a|d)/i,
  abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
  wide: /^(antes de cristo|antes da era com[uú]n|despois de cristo|era com[uú]n)/i
}, S3 = {
  any: [/^ac/i, /^dc/i],
  wide: [/^(antes de cristo|antes da era com[uú]n)/i, /^(despois de cristo|era com[uú]n)/i]
}, z3 = {
  narrow: /^[1234]/i,
  abbreviated: /^T[1234]/i,
  wide: /^[1234](º)? trimestre/i
}, O3 = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, W3 = {
  narrow: /^[xfmasond]/i,
  abbreviated: /^(xan|feb|mar|abr|mai|xun|xul|ago|set|out|nov|dec)/i,
  wide: /^(xaneiro|febreiro|marzo|abril|maio|xuño|xullo|agosto|setembro|outubro|novembro|decembro)/i
}, D3 = {
  narrow: [/^x/i, /^f/i, /^m/i, /^a/i, /^m/i, /^x/i, /^x/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^xan/i, /^feb/i, /^mar/i, /^abr/i, /^mai/i, /^xun/i, /^xul/i, /^ago/i, /^set/i, /^out/i, /^nov/i, /^dec/i]
}, C3 = {
  narrow: /^[dlmxvs]/i,
  short: /^(do|lu|ma|me|xo|ve|sa)/i,
  abbreviated: /^(dom|lun|mar|mer|xov|ven|sab)/i,
  wide: /^(domingo|luns|martes|m[eé]rcores|xoves|venres|s[áa]bado)/i
}, I3 = {
  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^x/i, /^v/i, /^s/i],
  any: [/^do/i, /^lu/i, /^ma/i, /^me/i, /^xo/i, /^ve/i, /^sa/i]
}, T3 = {
  narrow: /^(a|p|mn|md|(da|[aá]s) (mañ[aá]|tarde|noite))/i,
  any: /^([ap]\.?\s?m\.?|medianoite|mediod[ií]a|(da|[aá]s) (mañ[aá]|tarde|noite))/i
}, N3 = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mn/i,
    noon: /^md/i,
    morning: /mañ[aá]/i,
    afternoon: /tarde/i,
    evening: /tardiña/i,
    night: /noite/i
  }
}, x3 = {
  ordinalNumber: le({
    matchPattern: P3,
    parsePattern: M3,
    valueCallback: function(i) {
      return parseInt(i, 10);
    }
  }),
  era: P({
    matchPatterns: j3,
    defaultMatchWidth: "wide",
    parsePatterns: S3,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: z3,
    defaultMatchWidth: "wide",
    parsePatterns: O3,
    defaultParseWidth: "any",
    valueCallback: function(i) {
      return i + 1;
    }
  }),
  month: P({
    matchPatterns: W3,
    defaultMatchWidth: "wide",
    parsePatterns: D3,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: C3,
    defaultMatchWidth: "wide",
    parsePatterns: I3,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: T3,
    defaultMatchWidth: "any",
    parsePatterns: N3,
    defaultParseWidth: "any"
  })
}, F3 = {
  code: "gl",
  formatDistance: d3,
  formatLong: c3,
  formatRelative: h3,
  localize: $3,
  match: x3,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
};
const E3 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: F3
}, Symbol.toStringTag, { value: "Module" })), R3 = /* @__PURE__ */ te(E3);
var L3 = {
  lessThanXSeconds: {
    one: "હમણાં",
    // CLDR #1461
    other: "​આશરે {{count}} સેકંડ"
  },
  xSeconds: {
    one: "1 સેકંડ",
    other: "{{count}} સેકંડ"
  },
  halfAMinute: "અડધી મિનિટ",
  lessThanXMinutes: {
    one: "આ મિનિટ",
    // CLDR #1448
    other: "​આશરે {{count}} મિનિટ"
  },
  xMinutes: {
    one: "1 મિનિટ",
    other: "{{count}} મિનિટ"
  },
  aboutXHours: {
    one: "​આશરે 1 કલાક",
    other: "​આશરે {{count}} કલાક"
  },
  xHours: {
    one: "1 કલાક",
    other: "{{count}} કલાક"
  },
  xDays: {
    one: "1 દિવસ",
    other: "{{count}} દિવસ"
  },
  aboutXWeeks: {
    one: "આશરે 1 અઠવાડિયું",
    other: "આશરે {{count}} અઠવાડિયા"
  },
  xWeeks: {
    one: "1 અઠવાડિયું",
    other: "{{count}} અઠવાડિયા"
  },
  aboutXMonths: {
    one: "આશરે 1 મહિનો",
    other: "આશરે {{count}} મહિના"
  },
  xMonths: {
    one: "1 મહિનો",
    other: "{{count}} મહિના"
  },
  aboutXYears: {
    one: "આશરે 1 વર્ષ",
    other: "આશરે {{count}} વર્ષ"
  },
  xYears: {
    one: "1 વર્ષ",
    other: "{{count}} વર્ષ"
  },
  overXYears: {
    one: "1 વર્ષથી વધુ",
    other: "{{count}} વર્ષથી વધુ"
  },
  almostXYears: {
    one: "લગભગ 1 વર્ષ",
    other: "લગભગ {{count}} વર્ષ"
  }
}, q3 = function(i, d, a) {
  var t, o = L3[i];
  return typeof o == "string" ? t = o : d === 1 ? t = o.one : t = o.other.replace("{{count}}", String(d)), a != null && a.addSuffix ? a.comparison && a.comparison > 0 ? t + "માં" : t + " પહેલાં" : t;
}, Z3 = {
  full: "EEEE, d MMMM, y",
  // CLDR #1825
  long: "d MMMM, y",
  // CLDR #1826
  medium: "d MMM, y",
  // CLDR #1827
  short: "d/M/yy"
  // CLDR #1828
}, A3 = {
  full: "hh:mm:ss a zzzz",
  // CLDR #1829
  long: "hh:mm:ss a z",
  // CLDR #1830
  medium: "hh:mm:ss a",
  // CLDR #1831
  short: "hh:mm a"
  // CLDR #1832
}, V3 = {
  full: "{{date}} {{time}}",
  // CLDR #1833
  long: "{{date}} {{time}}",
  // CLDR #1834
  medium: "{{date}} {{time}}",
  // CLDR #1835
  short: "{{date}} {{time}}"
  // CLDR #1836
}, H3 = {
  date: I({
    formats: Z3,
    defaultWidth: "full"
  }),
  time: I({
    formats: A3,
    defaultWidth: "full"
  }),
  dateTime: I({
    formats: V3,
    defaultWidth: "full"
  })
}, U3 = {
  lastWeek: "'પાછલા' eeee p",
  // CLDR #1384
  yesterday: "'ગઈકાલે' p",
  // CLDR #1409
  today: "'આજે' p",
  // CLDR #1410
  tomorrow: "'આવતીકાલે' p",
  // CLDR #1411
  nextWeek: "eeee p",
  // CLDR #1386
  other: "P"
}, B3 = function(i, d, a, t) {
  return U3[i];
}, X3 = {
  narrow: ["ઈસપૂ", "ઈસ"],
  abbreviated: ["ઈ.સ.પૂર્વે", "ઈ.સ."],
  wide: ["ઈસવીસન પૂર્વે", "ઈસવીસન"]
}, G3 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1લો ત્રિમાસ", "2જો ત્રિમાસ", "3જો ત્રિમાસ", "4થો ત્રિમાસ"]
}, K3 = {
  narrow: ["જા", "ફે", "મા", "એ", "મે", "જૂ", "જુ", "ઓ", "સ", "ઓ", "ન", "ડિ"],
  abbreviated: ["જાન્યુ", "ફેબ્રુ", "માર્ચ", "એપ્રિલ", "મે", "જૂન", "જુલાઈ", "ઑગસ્ટ", "સપ્ટે", "ઓક્ટો", "નવે", "ડિસે"],
  wide: ["જાન્યુઆરી", "ફેબ્રુઆરી", "માર્ચ", "એપ્રિલ", "મે", "જૂન", "જુલાઇ", "ઓગસ્ટ", "સપ્ટેમ્બર", "ઓક્ટોબર", "નવેમ્બર", "ડિસેમ્બર"]
}, Y3 = {
  narrow: ["ર", "સો", "મં", "બુ", "ગુ", "શુ", "શ"],
  short: ["ર", "સો", "મં", "બુ", "ગુ", "શુ", "શ"],
  abbreviated: ["રવિ", "સોમ", "મંગળ", "બુધ", "ગુરુ", "શુક્ર", "શનિ"],
  wide: [
    "રવિવાર",
    "સોમવાર",
    "મંગળવાર",
    "બુધવાર",
    "ગુરુવાર",
    "શુક્રવાર",
    "શનિવાર"
    /* Saturday */
  ]
}, J3 = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "મ.રાત્રિ",
    noon: "બ.",
    morning: "સવારે",
    afternoon: "બપોરે",
    evening: "સાંજે",
    night: "રાત્રે"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "​મધ્યરાત્રિ",
    noon: "બપોરે",
    morning: "સવારે",
    afternoon: "બપોરે",
    evening: "સાંજે",
    night: "રાત્રે"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "​મધ્યરાત્રિ",
    noon: "બપોરે",
    morning: "સવારે",
    afternoon: "બપોરે",
    evening: "સાંજે",
    night: "રાત્રે"
  }
}, Q3 = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "મ.રાત્રિ",
    noon: "બપોરે",
    morning: "સવારે",
    afternoon: "બપોરે",
    evening: "સાંજે",
    night: "રાત્રે"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "મધ્યરાત્રિ",
    noon: "બપોરે",
    morning: "સવારે",
    afternoon: "બપોરે",
    evening: "સાંજે",
    night: "રાત્રે"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "​મધ્યરાત્રિ",
    noon: "બપોરે",
    morning: "સવારે",
    afternoon: "બપોરે",
    evening: "સાંજે",
    night: "રાત્રે"
  }
}, e4 = function(i, d) {
  return String(i);
}, n4 = {
  ordinalNumber: e4,
  era: $({
    values: X3,
    defaultWidth: "wide"
  }),
  quarter: $({
    values: G3,
    defaultWidth: "wide",
    argumentCallback: function(i) {
      return i - 1;
    }
  }),
  month: $({
    values: K3,
    defaultWidth: "wide"
  }),
  day: $({
    values: Y3,
    defaultWidth: "wide"
  }),
  dayPeriod: $({
    values: J3,
    defaultWidth: "wide",
    formattingValues: Q3,
    defaultFormattingWidth: "wide"
  })
}, i4 = /^(\d+)(લ|જ|થ|ઠ્ઠ|મ)?/i, a4 = /\d+/i, t4 = {
  narrow: /^(ઈસપૂ|ઈસ)/i,
  abbreviated: /^(ઈ\.સ\.પૂર્વે|ઈ\.સ\.)/i,
  wide: /^(ઈસવીસન\sપૂર્વે|ઈસવીસન)/i
}, r4 = {
  any: [/^ઈસપૂ/i, /^ઈસ/i]
}, o4 = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](લો|જો|થો)? ત્રિમાસ/i
}, s4 = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, d4 = {
  // eslint-disable-next-line no-misleading-character-class
  narrow: /^[જાફેમાએમેજૂજુઓસઓનડિ]/i,
  abbreviated: /^(જાન્યુ|ફેબ્રુ|માર્ચ|એપ્રિલ|મે|જૂન|જુલાઈ|ઑગસ્ટ|સપ્ટે|ઓક્ટો|નવે|ડિસે)/i,
  wide: /^(જાન્યુઆરી|ફેબ્રુઆરી|માર્ચ|એપ્રિલ|મે|જૂન|જુલાઇ|ઓગસ્ટ|સપ્ટેમ્બર|ઓક્ટોબર|નવેમ્બર|ડિસેમ્બર)/i
}, u4 = {
  narrow: [/^જા/i, /^ફે/i, /^મા/i, /^એ/i, /^મે/i, /^જૂ/i, /^જુ/i, /^ઑગ/i, /^સ/i, /^ઓક્ટો/i, /^ન/i, /^ડિ/i],
  any: [/^જા/i, /^ફે/i, /^મા/i, /^એ/i, /^મે/i, /^જૂ/i, /^જુ/i, /^ઑગ/i, /^સ/i, /^ઓક્ટો/i, /^ન/i, /^ડિ/i]
}, f4 = {
  narrow: /^(ર|સો|મં|બુ|ગુ|શુ|શ)/i,
  short: /^(ર|સો|મં|બુ|ગુ|શુ|શ)/i,
  abbreviated: /^(રવિ|સોમ|મંગળ|બુધ|ગુરુ|શુક્ર|શનિ)/i,
  wide: /^(રવિવાર|સોમવાર|મંગળવાર|બુધવાર|ગુરુવાર|શુક્રવાર|શનિવાર)/i
}, l4 = {
  narrow: [/^ર/i, /^સો/i, /^મં/i, /^બુ/i, /^ગુ/i, /^શુ/i, /^શ/i],
  any: [/^ર/i, /^સો/i, /^મં/i, /^બુ/i, /^ગુ/i, /^શુ/i, /^શ/i]
}, c4 = {
  narrow: /^(a|p|મ\.?|સ|બ|સાં|રા)/i,
  any: /^(a|p|મ\.?|સ|બ|સાં|રા)/i
}, m4 = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^મ\.?/i,
    noon: /^બ/i,
    morning: /સ/i,
    afternoon: /બ/i,
    evening: /સાં/i,
    night: /રા/i
  }
}, v4 = {
  ordinalNumber: le({
    matchPattern: i4,
    parsePattern: a4,
    valueCallback: function(i) {
      return parseInt(i, 10);
    }
  }),
  era: P({
    matchPatterns: t4,
    defaultMatchWidth: "wide",
    parsePatterns: r4,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: o4,
    defaultMatchWidth: "wide",
    parsePatterns: s4,
    defaultParseWidth: "any",
    valueCallback: function(i) {
      return i + 1;
    }
  }),
  month: P({
    matchPatterns: d4,
    defaultMatchWidth: "wide",
    parsePatterns: u4,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: f4,
    defaultMatchWidth: "wide",
    parsePatterns: l4,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: c4,
    defaultMatchWidth: "any",
    parsePatterns: m4,
    defaultParseWidth: "any"
  })
}, h4 = {
  code: "gu",
  formatDistance: q3,
  formatLong: H3,
  formatRelative: B3,
  localize: n4,
  match: v4,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const g4 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: h4
}, Symbol.toStringTag, { value: "Module" })), p4 = /* @__PURE__ */ te(g4);
var b4 = {
  lessThanXSeconds: {
    one: "פחות משנייה",
    two: "פחות משתי שניות",
    other: "פחות מ־{{count}} שניות"
  },
  xSeconds: {
    one: "שנייה",
    two: "שתי שניות",
    other: "{{count}} שניות"
  },
  halfAMinute: "חצי דקה",
  lessThanXMinutes: {
    one: "פחות מדקה",
    two: "פחות משתי דקות",
    other: "פחות מ־{{count}} דקות"
  },
  xMinutes: {
    one: "דקה",
    two: "שתי דקות",
    other: "{{count}} דקות"
  },
  aboutXHours: {
    one: "כשעה",
    two: "כשעתיים",
    other: "כ־{{count}} שעות"
  },
  xHours: {
    one: "שעה",
    two: "שעתיים",
    other: "{{count}} שעות"
  },
  xDays: {
    one: "יום",
    two: "יומיים",
    other: "{{count}} ימים"
  },
  aboutXWeeks: {
    one: "כשבוע",
    two: "כשבועיים",
    other: "כ־{{count}} שבועות"
  },
  xWeeks: {
    one: "שבוע",
    two: "שבועיים",
    other: "{{count}} שבועות"
  },
  aboutXMonths: {
    one: "כחודש",
    two: "כחודשיים",
    other: "כ־{{count}} חודשים"
  },
  xMonths: {
    one: "חודש",
    two: "חודשיים",
    other: "{{count}} חודשים"
  },
  aboutXYears: {
    one: "כשנה",
    two: "כשנתיים",
    other: "כ־{{count}} שנים"
  },
  xYears: {
    one: "שנה",
    two: "שנתיים",
    other: "{{count}} שנים"
  },
  overXYears: {
    one: "יותר משנה",
    two: "יותר משנתיים",
    other: "יותר מ־{{count}} שנים"
  },
  almostXYears: {
    one: "כמעט שנה",
    two: "כמעט שנתיים",
    other: "כמעט {{count}} שנים"
  }
}, y4 = function(i, d, a) {
  if (i === "xDays" && a !== null && a !== void 0 && a.addSuffix && d <= 2)
    return a.comparison && a.comparison > 0 ? d === 1 ? "מחר" : "מחרתיים" : d === 1 ? "אתמול" : "שלשום";
  var t, o = b4[i];
  return typeof o == "string" ? t = o : d === 1 ? t = o.one : d === 2 ? t = o.two : t = o.other.replace("{{count}}", String(d)), a != null && a.addSuffix ? a.comparison && a.comparison > 0 ? "בעוד " + t : "לפני " + t : t;
}, k4 = {
  full: "EEEE, d בMMMM y",
  long: "d בMMMM y",
  medium: "d בMMM y",
  short: "d.M.y"
}, w4 = {
  full: "H:mm:ss zzzz",
  long: "H:mm:ss z",
  medium: "H:mm:ss",
  short: "H:mm"
}, _4 = {
  full: "{{date}} 'בשעה' {{time}}",
  long: "{{date}} 'בשעה' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, $4 = {
  date: I({
    formats: k4,
    defaultWidth: "full"
  }),
  time: I({
    formats: w4,
    defaultWidth: "full"
  }),
  dateTime: I({
    formats: _4,
    defaultWidth: "full"
  })
}, P4 = {
  lastWeek: "eeee 'שעבר בשעה' p",
  yesterday: "'אתמול בשעה' p",
  today: "'היום בשעה' p",
  tomorrow: "'מחר בשעה' p",
  nextWeek: "eeee 'בשעה' p",
  other: "P"
}, M4 = function(i, d, a, t) {
  return P4[i];
}, j4 = {
  narrow: ["לפנה״ס", "לספירה"],
  abbreviated: ["לפנה״ס", "לספירה"],
  wide: ["לפני הספירה", "לספירה"]
}, S4 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["רבעון 1", "רבעון 2", "רבעון 3", "רבעון 4"]
}, z4 = {
  narrow: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"],
  abbreviated: ["ינו׳", "פבר׳", "מרץ", "אפר׳", "מאי", "יוני", "יולי", "אוג׳", "ספט׳", "אוק׳", "נוב׳", "דצמ׳"],
  wide: ["ינואר", "פברואר", "מרץ", "אפריל", "מאי", "יוני", "יולי", "אוגוסט", "ספטמבר", "אוקטובר", "נובמבר", "דצמבר"]
}, O4 = {
  narrow: ["א׳", "ב׳", "ג׳", "ד׳", "ה׳", "ו׳", "ש׳"],
  short: ["א׳", "ב׳", "ג׳", "ד׳", "ה׳", "ו׳", "ש׳"],
  abbreviated: ["יום א׳", "יום ב׳", "יום ג׳", "יום ד׳", "יום ה׳", "יום ו׳", "שבת"],
  wide: ["יום ראשון", "יום שני", "יום שלישי", "יום רביעי", "יום חמישי", "יום שישי", "יום שבת"]
}, W4 = {
  narrow: {
    am: "לפנה״צ",
    pm: "אחה״צ",
    midnight: "חצות",
    noon: "צהריים",
    morning: "בוקר",
    afternoon: "אחר הצהריים",
    evening: "ערב",
    night: "לילה"
  },
  abbreviated: {
    am: "לפנה״צ",
    pm: "אחה״צ",
    midnight: "חצות",
    noon: "צהריים",
    morning: "בוקר",
    afternoon: "אחר הצהריים",
    evening: "ערב",
    night: "לילה"
  },
  wide: {
    am: "לפנה״צ",
    pm: "אחה״צ",
    midnight: "חצות",
    noon: "צהריים",
    morning: "בוקר",
    afternoon: "אחר הצהריים",
    evening: "ערב",
    night: "לילה"
  }
}, D4 = {
  narrow: {
    am: "לפנה״צ",
    pm: "אחה״צ",
    midnight: "חצות",
    noon: "צהריים",
    morning: "בבוקר",
    afternoon: "בצהריים",
    evening: "בערב",
    night: "בלילה"
  },
  abbreviated: {
    am: "לפנה״צ",
    pm: "אחה״צ",
    midnight: "חצות",
    noon: "צהריים",
    morning: "בבוקר",
    afternoon: "אחר הצהריים",
    evening: "בערב",
    night: "בלילה"
  },
  wide: {
    am: "לפנה״צ",
    pm: "אחה״צ",
    midnight: "חצות",
    noon: "צהריים",
    morning: "בבוקר",
    afternoon: "אחר הצהריים",
    evening: "בערב",
    night: "בלילה"
  }
}, C4 = function(i, d) {
  var a = Number(i);
  if (a <= 0 || a > 10) return String(a);
  var t = String(d == null ? void 0 : d.unit), o = ["year", "hour", "minute", "second"].indexOf(t) >= 0, m = ["ראשון", "שני", "שלישי", "רביעי", "חמישי", "שישי", "שביעי", "שמיני", "תשיעי", "עשירי"], p = ["ראשונה", "שנייה", "שלישית", "רביעית", "חמישית", "שישית", "שביעית", "שמינית", "תשיעית", "עשירית"], s = a - 1;
  return o ? p[s] : m[s];
}, I4 = {
  ordinalNumber: C4,
  era: $({
    values: j4,
    defaultWidth: "wide"
  }),
  quarter: $({
    values: S4,
    defaultWidth: "wide",
    argumentCallback: function(i) {
      return i - 1;
    }
  }),
  month: $({
    values: z4,
    defaultWidth: "wide"
  }),
  day: $({
    values: O4,
    defaultWidth: "wide"
  }),
  dayPeriod: $({
    values: W4,
    defaultWidth: "wide",
    formattingValues: D4,
    defaultFormattingWidth: "wide"
  })
}, T4 = /^(\d+|(ראשון|שני|שלישי|רביעי|חמישי|שישי|שביעי|שמיני|תשיעי|עשירי|ראשונה|שנייה|שלישית|רביעית|חמישית|שישית|שביעית|שמינית|תשיעית|עשירית))/i, N4 = /^(\d+|רא|שנ|של|רב|ח|שי|שב|שמ|ת|ע)/i, x4 = {
  narrow: /^ל(ספירה|פנה״ס)/i,
  abbreviated: /^ל(ספירה|פנה״ס)/i,
  wide: /^ל(פני ה)?ספירה/i
}, F4 = {
  any: [/^לפ/i, /^לס/i]
}, E4 = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^רבעון [1234]/i
}, R4 = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, L4 = {
  narrow: /^\d+/i,
  abbreviated: /^(ינו|פבר|מרץ|אפר|מאי|יוני|יולי|אוג|ספט|אוק|נוב|דצמ)׳?/i,
  wide: /^(ינואר|פברואר|מרץ|אפריל|מאי|יוני|יולי|אוגוסט|ספטמבר|אוקטובר|נובמבר|דצמבר)/i
}, q4 = {
  narrow: [/^1$/i, /^2/i, /^3/i, /^4/i, /^5/i, /^6/i, /^7/i, /^8/i, /^9/i, /^10/i, /^11/i, /^12/i],
  any: [/^ינ/i, /^פ/i, /^מר/i, /^אפ/i, /^מא/i, /^יונ/i, /^יול/i, /^אוג/i, /^ס/i, /^אוק/i, /^נ/i, /^ד/i]
}, Z4 = {
  narrow: /^[אבגדהוש]׳/i,
  short: /^[אבגדהוש]׳/i,
  abbreviated: /^(שבת|יום (א|ב|ג|ד|ה|ו)׳)/i,
  wide: /^יום (ראשון|שני|שלישי|רביעי|חמישי|שישי|שבת)/i
}, A4 = {
  abbreviated: [/א׳$/i, /ב׳$/i, /ג׳$/i, /ד׳$/i, /ה׳$/i, /ו׳$/i, /^ש/i],
  wide: [/ן$/i, /ני$/i, /לישי$/i, /עי$/i, /מישי$/i, /שישי$/i, /ת$/i],
  any: [/^א/i, /^ב/i, /^ג/i, /^ד/i, /^ה/i, /^ו/i, /^ש/i]
}, V4 = {
  any: /^(אחר ה|ב)?(חצות|צהריים|בוקר|ערב|לילה|אחה״צ|לפנה״צ)/i
}, H4 = {
  any: {
    am: /^לפ/i,
    pm: /^אחה/i,
    midnight: /^ח/i,
    noon: /^צ/i,
    morning: /בוקר/i,
    afternoon: /בצ|אחר/i,
    evening: /ערב/i,
    night: /לילה/i
  }
}, U4 = ["רא", "שנ", "של", "רב", "ח", "שי", "שב", "שמ", "ת", "ע"], B4 = {
  ordinalNumber: le({
    matchPattern: T4,
    parsePattern: N4,
    valueCallback: function(i) {
      var d = parseInt(i, 10);
      return isNaN(d) ? U4.indexOf(i) + 1 : d;
    }
  }),
  era: P({
    matchPatterns: x4,
    defaultMatchWidth: "wide",
    parsePatterns: F4,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: E4,
    defaultMatchWidth: "wide",
    parsePatterns: R4,
    defaultParseWidth: "any",
    valueCallback: function(i) {
      return i + 1;
    }
  }),
  month: P({
    matchPatterns: L4,
    defaultMatchWidth: "wide",
    parsePatterns: q4,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: Z4,
    defaultMatchWidth: "wide",
    parsePatterns: A4,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: V4,
    defaultMatchWidth: "any",
    parsePatterns: H4,
    defaultParseWidth: "any"
  })
}, X4 = {
  code: "he",
  formatDistance: y4,
  formatLong: $4,
  formatRelative: M4,
  localize: I4,
  match: B4,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
const G4 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: X4
}, Symbol.toStringTag, { value: "Module" })), K4 = /* @__PURE__ */ te(G4);
var Du = {
  locale: {
    1: "१",
    2: "२",
    3: "३",
    4: "४",
    5: "५",
    6: "६",
    7: "७",
    8: "८",
    9: "९",
    0: "०"
  },
  number: {
    "१": "1",
    "२": "2",
    "३": "3",
    "४": "4",
    "५": "5",
    "६": "6",
    "७": "7",
    "८": "8",
    "९": "9",
    "०": "0"
  }
}, Y4 = {
  narrow: ["ईसा-पूर्व", "ईस्वी"],
  abbreviated: ["ईसा-पूर्व", "ईस्वी"],
  wide: ["ईसा-पूर्व", "ईसवी सन"]
}, J4 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["ति1", "ति2", "ति3", "ति4"],
  wide: ["पहली तिमाही", "दूसरी तिमाही", "तीसरी तिमाही", "चौथी तिमाही"]
}, Q4 = {
  narrow: ["ज", "फ़", "मा", "अ", "मई", "जू", "जु", "अग", "सि", "अक्टू", "न", "दि"],
  abbreviated: ["जन", "फ़र", "मार्च", "अप्रैल", "मई", "जून", "जुल", "अग", "सित", "अक्टू", "नव", "दिस"],
  wide: ["जनवरी", "फ़रवरी", "मार्च", "अप्रैल", "मई", "जून", "जुलाई", "अगस्त", "सितंबर", "अक्टूबर", "नवंबर", "दिसंबर"]
}, eP = {
  narrow: ["र", "सो", "मं", "बु", "गु", "शु", "श"],
  short: ["र", "सो", "मं", "बु", "गु", "शु", "श"],
  abbreviated: ["रवि", "सोम", "मंगल", "बुध", "गुरु", "शुक्र", "शनि"],
  wide: ["रविवार", "सोमवार", "मंगलवार", "बुधवार", "गुरुवार", "शुक्रवार", "शनिवार"]
}, nP = {
  narrow: {
    am: "पूर्वाह्न",
    pm: "अपराह्न",
    midnight: "मध्यरात्रि",
    noon: "दोपहर",
    morning: "सुबह",
    afternoon: "दोपहर",
    evening: "शाम",
    night: "रात"
  },
  abbreviated: {
    am: "पूर्वाह्न",
    pm: "अपराह्न",
    midnight: "मध्यरात्रि",
    noon: "दोपहर",
    morning: "सुबह",
    afternoon: "दोपहर",
    evening: "शाम",
    night: "रात"
  },
  wide: {
    am: "पूर्वाह्न",
    pm: "अपराह्न",
    midnight: "मध्यरात्रि",
    noon: "दोपहर",
    morning: "सुबह",
    afternoon: "दोपहर",
    evening: "शाम",
    night: "रात"
  }
}, iP = {
  narrow: {
    am: "पूर्वाह्न",
    pm: "अपराह्न",
    midnight: "मध्यरात्रि",
    noon: "दोपहर",
    morning: "सुबह",
    afternoon: "दोपहर",
    evening: "शाम",
    night: "रात"
  },
  abbreviated: {
    am: "पूर्वाह्न",
    pm: "अपराह्न",
    midnight: "मध्यरात्रि",
    noon: "दोपहर",
    morning: "सुबह",
    afternoon: "दोपहर",
    evening: "शाम",
    night: "रात"
  },
  wide: {
    am: "पूर्वाह्न",
    pm: "अपराह्न",
    midnight: "मध्यरात्रि",
    noon: "दोपहर",
    morning: "सुबह",
    afternoon: "दोपहर",
    evening: "शाम",
    night: "रात"
  }
}, aP = function(i, d) {
  var a = Number(i);
  return Cu(a);
};
function tP(e) {
  var i = e.toString().replace(/[१२३४५६७८९०]/g, function(d) {
    return Du.number[d];
  });
  return Number(i);
}
function Cu(e) {
  return e.toString().replace(/\d/g, function(i) {
    return Du.locale[i];
  });
}
var rP = {
  ordinalNumber: aP,
  era: $({
    values: Y4,
    defaultWidth: "wide"
  }),
  quarter: $({
    values: J4,
    defaultWidth: "wide",
    argumentCallback: function(i) {
      return i - 1;
    }
  }),
  month: $({
    values: Q4,
    defaultWidth: "wide"
  }),
  day: $({
    values: eP,
    defaultWidth: "wide"
  }),
  dayPeriod: $({
    values: nP,
    defaultWidth: "wide",
    formattingValues: iP,
    defaultFormattingWidth: "wide"
  })
}, oP = {
  lessThanXSeconds: {
    one: "१ सेकंड से कम",
    // CLDR #1310
    other: "{{count}} सेकंड से कम"
  },
  xSeconds: {
    one: "१ सेकंड",
    other: "{{count}} सेकंड"
  },
  halfAMinute: "आधा मिनट",
  lessThanXMinutes: {
    one: "१ मिनट से कम",
    other: "{{count}} मिनट से कम"
  },
  xMinutes: {
    one: "१ मिनट",
    // CLDR #1307
    other: "{{count}} मिनट"
  },
  aboutXHours: {
    one: "लगभग १ घंटा",
    other: "लगभग {{count}} घंटे"
  },
  xHours: {
    one: "१ घंटा",
    // CLDR #1304
    other: "{{count}} घंटे"
    // CLDR #4467
  },
  xDays: {
    one: "१ दिन",
    // CLDR #1286
    other: "{{count}} दिन"
  },
  aboutXWeeks: {
    one: "लगभग १ सप्ताह",
    other: "लगभग {{count}} सप्ताह"
  },
  xWeeks: {
    one: "१ सप्ताह",
    other: "{{count}} सप्ताह"
  },
  aboutXMonths: {
    one: "लगभग १ महीना",
    other: "लगभग {{count}} महीने"
  },
  xMonths: {
    one: "१ महीना",
    other: "{{count}} महीने"
  },
  aboutXYears: {
    one: "लगभग १ वर्ष",
    other: "लगभग {{count}} वर्ष"
    // CLDR #4823
  },
  xYears: {
    one: "१ वर्ष",
    other: "{{count}} वर्ष"
  },
  overXYears: {
    one: "१ वर्ष से अधिक",
    other: "{{count}} वर्ष से अधिक"
  },
  almostXYears: {
    one: "लगभग १ वर्ष",
    other: "लगभग {{count}} वर्ष"
  }
}, sP = function(i, d, a) {
  var t, o = oP[i];
  return typeof o == "string" ? t = o : d === 1 ? t = o.one : t = o.other.replace("{{count}}", Cu(d)), a != null && a.addSuffix ? a.comparison && a.comparison > 0 ? t + "मे " : t + " पहले" : t;
}, dP = {
  full: "EEEE, do MMMM, y",
  // CLDR #1787
  long: "do MMMM, y",
  // CLDR #1788
  medium: "d MMM, y",
  // CLDR #1789
  short: "dd/MM/yyyy"
  // CLDR #1790
}, uP = {
  full: "h:mm:ss a zzzz",
  // CLDR #1791
  long: "h:mm:ss a z",
  // CLDR #1792
  medium: "h:mm:ss a",
  // CLDR #1793
  short: "h:mm a"
  // CLDR #1794
}, fP = {
  full: "{{date}} 'को' {{time}}",
  // CLDR #1795
  long: "{{date}} 'को' {{time}}",
  // CLDR #1796
  medium: "{{date}}, {{time}}",
  // CLDR #1797
  short: "{{date}}, {{time}}"
  // CLDR #1798
}, lP = {
  date: I({
    formats: dP,
    defaultWidth: "full"
  }),
  time: I({
    formats: uP,
    defaultWidth: "full"
  }),
  dateTime: I({
    formats: fP,
    defaultWidth: "full"
  })
}, cP = {
  lastWeek: "'पिछले' eeee p",
  yesterday: "'कल' p",
  today: "'आज' p",
  tomorrow: "'कल' p",
  nextWeek: "eeee 'को' p",
  other: "P"
}, mP = function(i, d, a, t) {
  return cP[i];
}, vP = /^[०१२३४५६७८९]+/i, hP = /^[०१२३४५६७८९]+/i, gP = {
  narrow: /^(ईसा-पूर्व|ईस्वी)/i,
  abbreviated: /^(ईसा\.?\s?पूर्व\.?|ईसा\.?)/i,
  wide: /^(ईसा-पूर्व|ईसवी पूर्व|ईसवी सन|ईसवी)/i
}, pP = {
  any: [/^b/i, /^(a|c)/i]
}, bP = {
  narrow: /^[1234]/i,
  abbreviated: /^ति[1234]/i,
  wide: /^[1234](पहली|दूसरी|तीसरी|चौथी)? तिमाही/i
}, yP = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, kP = {
  // eslint-disable-next-line no-misleading-character-class
  narrow: /^[जफ़माअप्मईजूनजुअगसिअक्तनदि]/i,
  abbreviated: /^(जन|फ़र|मार्च|अप्|मई|जून|जुल|अग|सित|अक्तू|नव|दिस)/i,
  wide: /^(जनवरी|फ़रवरी|मार्च|अप्रैल|मई|जून|जुलाई|अगस्त|सितंबर|अक्तूबर|नवंबर|दिसंबर)/i
}, wP = {
  narrow: [/^ज/i, /^फ़/i, /^मा/i, /^अप्/i, /^मई/i, /^जू/i, /^जु/i, /^अग/i, /^सि/i, /^अक्तू/i, /^न/i, /^दि/i],
  any: [/^जन/i, /^फ़/i, /^मा/i, /^अप्/i, /^मई/i, /^जू/i, /^जु/i, /^अग/i, /^सि/i, /^अक्तू/i, /^नव/i, /^दिस/i]
}, _P = {
  // eslint-disable-next-line no-misleading-character-class
  narrow: /^[रविसोममंगलबुधगुरुशुक्रशनि]/i,
  short: /^(रवि|सोम|मंगल|बुध|गुरु|शुक्र|शनि)/i,
  abbreviated: /^(रवि|सोम|मंगल|बुध|गुरु|शुक्र|शनि)/i,
  wide: /^(रविवार|सोमवार|मंगलवार|बुधवार|गुरुवार|शुक्रवार|शनिवार)/i
}, $P = {
  narrow: [/^रवि/i, /^सोम/i, /^मंगल/i, /^बुध/i, /^गुरु/i, /^शुक्र/i, /^शनि/i],
  any: [/^रवि/i, /^सोम/i, /^मंगल/i, /^बुध/i, /^गुरु/i, /^शुक्र/i, /^शनि/i]
}, PP = {
  narrow: /^(पू|अ|म|द.\?|सु|दो|शा|रा)/i,
  any: /^(पूर्वाह्न|अपराह्न|म|द.\?|सु|दो|शा|रा)/i
}, MP = {
  any: {
    am: /^पूर्वाह्न/i,
    pm: /^अपराह्न/i,
    midnight: /^मध्य/i,
    noon: /^दो/i,
    morning: /सु/i,
    afternoon: /दो/i,
    evening: /शा/i,
    night: /रा/i
  }
}, jP = {
  ordinalNumber: le({
    matchPattern: vP,
    parsePattern: hP,
    valueCallback: tP
  }),
  era: P({
    matchPatterns: gP,
    defaultMatchWidth: "wide",
    parsePatterns: pP,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: bP,
    defaultMatchWidth: "wide",
    parsePatterns: yP,
    defaultParseWidth: "any",
    valueCallback: function(i) {
      return i + 1;
    }
  }),
  month: P({
    matchPatterns: kP,
    defaultMatchWidth: "wide",
    parsePatterns: wP,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: _P,
    defaultMatchWidth: "wide",
    parsePatterns: $P,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: PP,
    defaultMatchWidth: "any",
    parsePatterns: MP,
    defaultParseWidth: "any"
  })
}, SP = {
  code: "hi",
  formatDistance: sP,
  formatLong: lP,
  formatRelative: mP,
  localize: rP,
  match: jP,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 4
  }
};
const zP = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: SP
}, Symbol.toStringTag, { value: "Module" })), OP = /* @__PURE__ */ te(zP);
var WP = {
  lessThanXSeconds: {
    one: {
      standalone: "manje od 1 sekunde",
      withPrepositionAgo: "manje od 1 sekunde",
      withPrepositionIn: "manje od 1 sekundu"
    },
    dual: "manje od {{count}} sekunde",
    other: "manje od {{count}} sekundi"
  },
  xSeconds: {
    one: {
      standalone: "1 sekunda",
      withPrepositionAgo: "1 sekunde",
      withPrepositionIn: "1 sekundu"
    },
    dual: "{{count}} sekunde",
    other: "{{count}} sekundi"
  },
  halfAMinute: "pola minute",
  lessThanXMinutes: {
    one: {
      standalone: "manje od 1 minute",
      withPrepositionAgo: "manje od 1 minute",
      withPrepositionIn: "manje od 1 minutu"
    },
    dual: "manje od {{count}} minute",
    other: "manje od {{count}} minuta"
  },
  xMinutes: {
    one: {
      standalone: "1 minuta",
      withPrepositionAgo: "1 minute",
      withPrepositionIn: "1 minutu"
    },
    dual: "{{count}} minute",
    other: "{{count}} minuta"
  },
  aboutXHours: {
    one: {
      standalone: "oko 1 sat",
      withPrepositionAgo: "oko 1 sat",
      withPrepositionIn: "oko 1 sat"
    },
    dual: "oko {{count}} sata",
    other: "oko {{count}} sati"
  },
  xHours: {
    one: {
      standalone: "1 sat",
      withPrepositionAgo: "1 sat",
      withPrepositionIn: "1 sat"
    },
    dual: "{{count}} sata",
    other: "{{count}} sati"
  },
  xDays: {
    one: {
      standalone: "1 dan",
      withPrepositionAgo: "1 dan",
      withPrepositionIn: "1 dan"
    },
    dual: "{{count}} dana",
    other: "{{count}} dana"
  },
  aboutXWeeks: {
    one: {
      standalone: "oko 1 tjedan",
      withPrepositionAgo: "oko 1 tjedan",
      withPrepositionIn: "oko 1 tjedan"
    },
    dual: "oko {{count}} tjedna",
    other: "oko {{count}} tjedana"
  },
  xWeeks: {
    one: {
      standalone: "1 tjedan",
      withPrepositionAgo: "1 tjedan",
      withPrepositionIn: "1 tjedan"
    },
    dual: "{{count}} tjedna",
    other: "{{count}} tjedana"
  },
  aboutXMonths: {
    one: {
      standalone: "oko 1 mjesec",
      withPrepositionAgo: "oko 1 mjesec",
      withPrepositionIn: "oko 1 mjesec"
    },
    dual: "oko {{count}} mjeseca",
    other: "oko {{count}} mjeseci"
  },
  xMonths: {
    one: {
      standalone: "1 mjesec",
      withPrepositionAgo: "1 mjesec",
      withPrepositionIn: "1 mjesec"
    },
    dual: "{{count}} mjeseca",
    other: "{{count}} mjeseci"
  },
  aboutXYears: {
    one: {
      standalone: "oko 1 godinu",
      withPrepositionAgo: "oko 1 godinu",
      withPrepositionIn: "oko 1 godinu"
    },
    dual: "oko {{count}} godine",
    other: "oko {{count}} godina"
  },
  xYears: {
    one: {
      standalone: "1 godina",
      withPrepositionAgo: "1 godine",
      withPrepositionIn: "1 godinu"
    },
    dual: "{{count}} godine",
    other: "{{count}} godina"
  },
  overXYears: {
    one: {
      standalone: "preko 1 godinu",
      withPrepositionAgo: "preko 1 godinu",
      withPrepositionIn: "preko 1 godinu"
    },
    dual: "preko {{count}} godine",
    other: "preko {{count}} godina"
  },
  almostXYears: {
    one: {
      standalone: "gotovo 1 godinu",
      withPrepositionAgo: "gotovo 1 godinu",
      withPrepositionIn: "gotovo 1 godinu"
    },
    dual: "gotovo {{count}} godine",
    other: "gotovo {{count}} godina"
  }
}, DP = function(i, d, a) {
  var t, o = WP[i];
  return typeof o == "string" ? t = o : d === 1 ? a != null && a.addSuffix ? a.comparison && a.comparison > 0 ? t = o.one.withPrepositionIn : t = o.one.withPrepositionAgo : t = o.one.standalone : d % 10 > 1 && d % 10 < 5 && // if last digit is between 2 and 4
  String(d).substr(-2, 1) !== "1" ? t = o.dual.replace("{{count}}", String(d)) : t = o.other.replace("{{count}}", String(d)), a != null && a.addSuffix ? a.comparison && a.comparison > 0 ? "za " + t : "prije " + t : t;
}, CP = {
  full: "EEEE, d. MMMM y.",
  long: "d. MMMM y.",
  medium: "d. MMM y.",
  short: "dd. MM. y."
}, IP = {
  full: "HH:mm:ss (zzzz)",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, TP = {
  full: "{{date}} 'u' {{time}}",
  long: "{{date}} 'u' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, NP = {
  date: I({
    formats: CP,
    defaultWidth: "full"
  }),
  time: I({
    formats: IP,
    defaultWidth: "full"
  }),
  dateTime: I({
    formats: TP,
    defaultWidth: "full"
  })
}, xP = {
  lastWeek: function(i) {
    switch (i.getUTCDay()) {
      case 0:
        return "'prošlu nedjelju u' p";
      case 3:
        return "'prošlu srijedu u' p";
      case 6:
        return "'prošlu subotu u' p";
      default:
        return "'prošli' EEEE 'u' p";
    }
  },
  yesterday: "'jučer u' p",
  today: "'danas u' p",
  tomorrow: "'sutra u' p",
  nextWeek: function(i) {
    switch (i.getUTCDay()) {
      case 0:
        return "'iduću nedjelju u' p";
      case 3:
        return "'iduću srijedu u' p";
      case 6:
        return "'iduću subotu u' p";
      default:
        return "'prošli' EEEE 'u' p";
    }
  },
  other: "P"
}, FP = function(i, d, a, t) {
  var o = xP[i];
  return typeof o == "function" ? o(d) : o;
}, EP = {
  narrow: ["pr.n.e.", "AD"],
  abbreviated: ["pr. Kr.", "po. Kr."],
  wide: ["Prije Krista", "Poslije Krista"]
}, RP = {
  narrow: ["1.", "2.", "3.", "4."],
  abbreviated: ["1. kv.", "2. kv.", "3. kv.", "4. kv."],
  wide: ["1. kvartal", "2. kvartal", "3. kvartal", "4. kvartal"]
}, LP = {
  narrow: ["1.", "2.", "3.", "4.", "5.", "6.", "7.", "8.", "9.", "10.", "11.", "12."],
  abbreviated: ["sij", "velj", "ožu", "tra", "svi", "lip", "srp", "kol", "ruj", "lis", "stu", "pro"],
  wide: ["siječanj", "veljača", "ožujak", "travanj", "svibanj", "lipanj", "srpanj", "kolovoz", "rujan", "listopad", "studeni", "prosinac"]
}, qP = {
  narrow: ["1.", "2.", "3.", "4.", "5.", "6.", "7.", "8.", "9.", "10.", "11.", "12."],
  abbreviated: ["sij", "velj", "ožu", "tra", "svi", "lip", "srp", "kol", "ruj", "lis", "stu", "pro"],
  wide: ["siječnja", "veljače", "ožujka", "travnja", "svibnja", "lipnja", "srpnja", "kolovoza", "rujna", "listopada", "studenog", "prosinca"]
}, ZP = {
  narrow: ["N", "P", "U", "S", "Č", "P", "S"],
  short: ["ned", "pon", "uto", "sri", "čet", "pet", "sub"],
  abbreviated: ["ned", "pon", "uto", "sri", "čet", "pet", "sub"],
  wide: ["nedjelja", "ponedjeljak", "utorak", "srijeda", "četvrtak", "petak", "subota"]
}, AP = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "ponoć",
    noon: "podne",
    morning: "ujutro",
    afternoon: "popodne",
    evening: "navečer",
    night: "noću"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "ponoć",
    noon: "podne",
    morning: "ujutro",
    afternoon: "popodne",
    evening: "navečer",
    night: "noću"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "ponoć",
    noon: "podne",
    morning: "ujutro",
    afternoon: "poslije podne",
    evening: "navečer",
    night: "noću"
  }
}, VP = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "ponoć",
    noon: "podne",
    morning: "ujutro",
    afternoon: "popodne",
    evening: "navečer",
    night: "noću"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "ponoć",
    noon: "podne",
    morning: "ujutro",
    afternoon: "popodne",
    evening: "navečer",
    night: "noću"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "ponoć",
    noon: "podne",
    morning: "ujutro",
    afternoon: "poslije podne",
    evening: "navečer",
    night: "noću"
  }
}, HP = function(i, d) {
  var a = Number(i);
  return a + ".";
}, UP = {
  ordinalNumber: HP,
  era: $({
    values: EP,
    defaultWidth: "wide"
  }),
  quarter: $({
    values: RP,
    defaultWidth: "wide",
    argumentCallback: function(i) {
      return i - 1;
    }
  }),
  month: $({
    values: LP,
    defaultWidth: "wide",
    formattingValues: qP,
    defaultFormattingWidth: "wide"
  }),
  day: $({
    values: ZP,
    defaultWidth: "wide"
  }),
  dayPeriod: $({
    values: VP,
    defaultWidth: "wide",
    formattingValues: AP,
    defaultFormattingWidth: "wide"
  })
}, BP = /^(\d+)\./i, XP = /\d+/i, GP = {
  narrow: /^(pr\.n\.e\.|AD)/i,
  abbreviated: /^(pr\.\s?Kr\.|po\.\s?Kr\.)/i,
  wide: /^(Prije Krista|prije nove ere|Poslije Krista|nova era)/i
}, KP = {
  any: [/^pr/i, /^(po|nova)/i]
}, YP = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234]\.\s?kv\.?/i,
  wide: /^[1234]\. kvartal/i
}, JP = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, QP = {
  narrow: /^(10|11|12|[123456789])\./i,
  abbreviated: /^(sij|velj|(ožu|ozu)|tra|svi|lip|srp|kol|ruj|lis|stu|pro)/i,
  wide: /^((siječanj|siječnja|sijecanj|sijecnja)|(veljača|veljače|veljaca|veljace)|(ožujak|ožujka|ozujak|ozujka)|(travanj|travnja)|(svibanj|svibnja)|(lipanj|lipnja)|(srpanj|srpnja)|(kolovoz|kolovoza)|(rujan|rujna)|(listopad|listopada)|(studeni|studenog)|(prosinac|prosinca))/i
}, e6 = {
  narrow: [/1/i, /2/i, /3/i, /4/i, /5/i, /6/i, /7/i, /8/i, /9/i, /10/i, /11/i, /12/i],
  abbreviated: [/^sij/i, /^velj/i, /^(ožu|ozu)/i, /^tra/i, /^svi/i, /^lip/i, /^srp/i, /^kol/i, /^ruj/i, /^lis/i, /^stu/i, /^pro/i],
  wide: [/^sij/i, /^velj/i, /^(ožu|ozu)/i, /^tra/i, /^svi/i, /^lip/i, /^srp/i, /^kol/i, /^ruj/i, /^lis/i, /^stu/i, /^pro/i]
}, n6 = {
  narrow: /^[npusčc]/i,
  short: /^(ned|pon|uto|sri|(čet|cet)|pet|sub)/i,
  abbreviated: /^(ned|pon|uto|sri|(čet|cet)|pet|sub)/i,
  wide: /^(nedjelja|ponedjeljak|utorak|srijeda|(četvrtak|cetvrtak)|petak|subota)/i
}, i6 = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, a6 = {
  any: /^(am|pm|ponoc|ponoć|(po)?podne|navecer|navečer|noću|poslije podne|ujutro)/i
}, t6 = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^pono/i,
    noon: /^pod/i,
    morning: /jutro/i,
    afternoon: /(poslije\s|po)+podne/i,
    evening: /(navece|naveče)/i,
    night: /(nocu|noću)/i
  }
}, r6 = {
  ordinalNumber: le({
    matchPattern: BP,
    parsePattern: XP,
    valueCallback: function(i) {
      return parseInt(i, 10);
    }
  }),
  era: P({
    matchPatterns: GP,
    defaultMatchWidth: "wide",
    parsePatterns: KP,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: YP,
    defaultMatchWidth: "wide",
    parsePatterns: JP,
    defaultParseWidth: "any",
    valueCallback: function(i) {
      return i + 1;
    }
  }),
  month: P({
    matchPatterns: QP,
    defaultMatchWidth: "wide",
    parsePatterns: e6,
    defaultParseWidth: "wide"
  }),
  day: P({
    matchPatterns: n6,
    defaultMatchWidth: "wide",
    parsePatterns: i6,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: a6,
    defaultMatchWidth: "any",
    parsePatterns: t6,
    defaultParseWidth: "any"
  })
}, o6 = {
  code: "hr",
  formatDistance: DP,
  formatLong: NP,
  formatRelative: FP,
  localize: UP,
  match: r6,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
};
const s6 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: o6
}, Symbol.toStringTag, { value: "Module" })), d6 = /* @__PURE__ */ te(s6);
var u6 = {
  about: "körülbelül",
  over: "több mint",
  almost: "majdnem",
  lessthan: "kevesebb mint"
}, f6 = {
  xseconds: " másodperc",
  halfaminute: "fél perc",
  xminutes: " perc",
  xhours: " óra",
  xdays: " nap",
  xweeks: " hét",
  xmonths: " hónap",
  xyears: " év"
}, l6 = {
  xseconds: {
    "-1": " másodperccel ezelőtt",
    1: " másodperc múlva",
    0: " másodperce"
  },
  halfaminute: {
    "-1": "fél perccel ezelőtt",
    1: "fél perc múlva",
    0: "fél perce"
  },
  xminutes: {
    "-1": " perccel ezelőtt",
    1: " perc múlva",
    0: " perce"
  },
  xhours: {
    "-1": " órával ezelőtt",
    1: " óra múlva",
    0: " órája"
  },
  xdays: {
    "-1": " nappal ezelőtt",
    1: " nap múlva",
    0: " napja"
  },
  xweeks: {
    "-1": " héttel ezelőtt",
    1: " hét múlva",
    0: " hete"
  },
  xmonths: {
    "-1": " hónappal ezelőtt",
    1: " hónap múlva",
    0: " hónapja"
  },
  xyears: {
    "-1": " évvel ezelőtt",
    1: " év múlva",
    0: " éve"
  }
}, c6 = function(i, d, a) {
  var t = i.match(/about|over|almost|lessthan/i), o = t ? i.replace(t[0], "") : i, m = (a == null ? void 0 : a.addSuffix) === !0, p = o.toLowerCase(), s = (a == null ? void 0 : a.comparison) || 0, r = m ? l6[p][s] : f6[p], u = p === "halfaminute" ? r : d + r;
  if (t) {
    var l = t[0].toLowerCase();
    u = u6[l] + " " + u;
  }
  return u;
}, m6 = {
  full: "y. MMMM d., EEEE",
  long: "y. MMMM d.",
  medium: "y. MMM d.",
  short: "y. MM. dd."
}, v6 = {
  full: "H:mm:ss zzzz",
  long: "H:mm:ss z",
  medium: "H:mm:ss",
  short: "H:mm"
}, h6 = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, g6 = {
  date: I({
    formats: m6,
    defaultWidth: "full"
  }),
  time: I({
    formats: v6,
    defaultWidth: "full"
  }),
  dateTime: I({
    formats: h6,
    defaultWidth: "full"
  })
}, p6 = ["vasárnap", "hétfőn", "kedden", "szerdán", "csütörtökön", "pénteken", "szombaton"];
function ad(e) {
  return function(i) {
    var d = p6[i.getUTCDay()], a = e ? "" : "'múlt' ";
    return "".concat(a, "'").concat(d, "' p'-kor'");
  };
}
var b6 = {
  lastWeek: ad(!1),
  yesterday: "'tegnap' p'-kor'",
  today: "'ma' p'-kor'",
  tomorrow: "'holnap' p'-kor'",
  nextWeek: ad(!0),
  other: "P"
}, y6 = function(i, d) {
  var a = b6[i];
  return typeof a == "function" ? a(d) : a;
}, k6 = {
  narrow: ["ie.", "isz."],
  abbreviated: ["i. e.", "i. sz."],
  wide: ["Krisztus előtt", "időszámításunk szerint"]
}, w6 = {
  narrow: ["1.", "2.", "3.", "4."],
  abbreviated: ["1. n.év", "2. n.év", "3. n.év", "4. n.év"],
  wide: ["1. negyedév", "2. negyedév", "3. negyedév", "4. negyedév"]
}, _6 = {
  narrow: ["I.", "II.", "III.", "IV."],
  abbreviated: ["I. n.év", "II. n.év", "III. n.év", "IV. n.év"],
  wide: ["I. negyedév", "II. negyedév", "III. negyedév", "IV. negyedév"]
}, $6 = {
  narrow: ["J", "F", "M", "Á", "M", "J", "J", "A", "Sz", "O", "N", "D"],
  abbreviated: ["jan.", "febr.", "márc.", "ápr.", "máj.", "jún.", "júl.", "aug.", "szept.", "okt.", "nov.", "dec."],
  wide: ["január", "február", "március", "április", "május", "június", "július", "augusztus", "szeptember", "október", "november", "december"]
}, P6 = {
  narrow: ["V", "H", "K", "Sz", "Cs", "P", "Sz"],
  short: ["V", "H", "K", "Sze", "Cs", "P", "Szo"],
  abbreviated: ["V", "H", "K", "Sze", "Cs", "P", "Szo"],
  wide: ["vasárnap", "hétfő", "kedd", "szerda", "csütörtök", "péntek", "szombat"]
}, M6 = {
  narrow: {
    am: "de.",
    pm: "du.",
    midnight: "éjfél",
    noon: "dél",
    morning: "reggel",
    afternoon: "du.",
    evening: "este",
    night: "éjjel"
  },
  abbreviated: {
    am: "de.",
    pm: "du.",
    midnight: "éjfél",
    noon: "dél",
    morning: "reggel",
    afternoon: "du.",
    evening: "este",
    night: "éjjel"
  },
  wide: {
    am: "de.",
    pm: "du.",
    midnight: "éjfél",
    noon: "dél",
    morning: "reggel",
    afternoon: "délután",
    evening: "este",
    night: "éjjel"
  }
}, j6 = function(i, d) {
  var a = Number(i);
  return a + ".";
}, S6 = {
  ordinalNumber: j6,
  era: $({
    values: k6,
    defaultWidth: "wide"
  }),
  quarter: $({
    values: w6,
    defaultWidth: "wide",
    argumentCallback: function(i) {
      return i - 1;
    },
    formattingValues: _6,
    defaultFormattingWidth: "wide"
  }),
  month: $({
    values: $6,
    defaultWidth: "wide"
  }),
  day: $({
    values: P6,
    defaultWidth: "wide"
  }),
  dayPeriod: $({
    values: M6,
    defaultWidth: "wide"
  })
}, z6 = /^(\d+)\.?/i, O6 = /\d+/i, W6 = {
  narrow: /^(ie\.|isz\.)/i,
  abbreviated: /^(i\.\s?e\.?|b?\s?c\s?e|i\.\s?sz\.?)/i,
  wide: /^(Krisztus előtt|időszámításunk előtt|időszámításunk szerint|i\. sz\.)/i
}, D6 = {
  narrow: [/ie/i, /isz/i],
  abbreviated: [/^(i\.?\s?e\.?|b\s?ce)/i, /^(i\.?\s?sz\.?|c\s?e)/i],
  any: [/előtt/i, /(szerint|i. sz.)/i]
}, C6 = {
  narrow: /^[1234]\.?/i,
  abbreviated: /^[1234]?\.?\s?n\.év/i,
  wide: /^([1234]|I|II|III|IV)?\.?\s?negyedév/i
}, I6 = {
  any: [/1|I$/i, /2|II$/i, /3|III/i, /4|IV/i]
}, T6 = {
  narrow: /^[jfmaásond]|sz/i,
  abbreviated: /^(jan\.?|febr\.?|márc\.?|ápr\.?|máj\.?|jún\.?|júl\.?|aug\.?|szept\.?|okt\.?|nov\.?|dec\.?)/i,
  wide: /^(január|február|március|április|május|június|július|augusztus|szeptember|október|november|december)/i
}, N6 = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a|á/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s|sz/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^már/i, /^áp/i, /^máj/i, /^jún/i, /^júl/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, x6 = {
  narrow: /^([vhkpc]|sz|cs|sz)/i,
  short: /^([vhkp]|sze|cs|szo)/i,
  abbreviated: /^([vhkp]|sze|cs|szo)/i,
  wide: /^(vasárnap|hétfő|kedd|szerda|csütörtök|péntek|szombat)/i
}, F6 = {
  narrow: [/^v/i, /^h/i, /^k/i, /^sz/i, /^c/i, /^p/i, /^sz/i],
  any: [/^v/i, /^h/i, /^k/i, /^sze/i, /^c/i, /^p/i, /^szo/i]
}, E6 = {
  any: /^((de|du)\.?|éjfél|délután|dél|reggel|este|éjjel)/i
}, R6 = {
  any: {
    am: /^de\.?/i,
    pm: /^du\.?/i,
    midnight: /^éjf/i,
    noon: /^dé/i,
    morning: /reg/i,
    afternoon: /^délu\.?/i,
    evening: /es/i,
    night: /éjj/i
  }
}, L6 = {
  ordinalNumber: le({
    matchPattern: z6,
    parsePattern: O6,
    valueCallback: function(i) {
      return parseInt(i, 10);
    }
  }),
  era: P({
    matchPatterns: W6,
    defaultMatchWidth: "wide",
    parsePatterns: D6,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: C6,
    defaultMatchWidth: "wide",
    parsePatterns: I6,
    defaultParseWidth: "any",
    valueCallback: function(i) {
      return i + 1;
    }
  }),
  month: P({
    matchPatterns: T6,
    defaultMatchWidth: "wide",
    parsePatterns: N6,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: x6,
    defaultMatchWidth: "wide",
    parsePatterns: F6,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: E6,
    defaultMatchWidth: "any",
    parsePatterns: R6,
    defaultParseWidth: "any"
  })
}, q6 = {
  code: "hu",
  formatDistance: c6,
  formatLong: g6,
  formatRelative: y6,
  localize: S6,
  match: L6,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const Z6 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: q6
}, Symbol.toStringTag, { value: "Module" })), A6 = /* @__PURE__ */ te(Z6);
var V6 = {
  lessThanXSeconds: {
    one: "ավելի քիչ քան 1 վայրկյան",
    other: "ավելի քիչ քան {{count}} վայրկյան"
  },
  xSeconds: {
    one: "1 վայրկյան",
    other: "{{count}} վայրկյան"
  },
  halfAMinute: "կես րոպե",
  lessThanXMinutes: {
    one: "ավելի քիչ քան 1 րոպե",
    other: "ավելի քիչ քան {{count}} րոպե"
  },
  xMinutes: {
    one: "1 րոպե",
    other: "{{count}} րոպե"
  },
  aboutXHours: {
    one: "մոտ 1 ժամ",
    other: "մոտ {{count}} ժամ"
  },
  xHours: {
    one: "1 ժամ",
    other: "{{count}} ժամ"
  },
  xDays: {
    one: "1 օր",
    other: "{{count}} օր"
  },
  aboutXWeeks: {
    one: "մոտ 1 շաբաթ",
    other: "մոտ {{count}} շաբաթ"
  },
  xWeeks: {
    one: "1 շաբաթ",
    other: "{{count}} շաբաթ"
  },
  aboutXMonths: {
    one: "մոտ 1 ամիս",
    other: "մոտ {{count}} ամիս"
  },
  xMonths: {
    one: "1 ամիս",
    other: "{{count}} ամիս"
  },
  aboutXYears: {
    one: "մոտ 1 տարի",
    other: "մոտ {{count}} տարի"
  },
  xYears: {
    one: "1 տարի",
    other: "{{count}} տարի"
  },
  overXYears: {
    one: "ավելի քան 1 տարի",
    other: "ավելի քան {{count}} տարի"
  },
  almostXYears: {
    one: "համարյա 1 տարի",
    other: "համարյա {{count}} տարի"
  }
}, H6 = function(i, d, a) {
  var t, o = V6[i];
  return typeof o == "string" ? t = o : d === 1 ? t = o.one : t = o.other.replace("{{count}}", String(d)), a != null && a.addSuffix ? a.comparison && a.comparison > 0 ? t + " հետո" : t + " առաջ" : t;
}, U6 = {
  full: "d MMMM, y, EEEE",
  long: "d MMMM, y",
  medium: "d MMM, y",
  short: "dd.MM.yyyy"
}, B6 = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, X6 = {
  full: "{{date}} 'ժ․'{{time}}",
  long: "{{date}} 'ժ․'{{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, G6 = {
  date: I({
    formats: U6,
    defaultWidth: "full"
  }),
  time: I({
    formats: B6,
    defaultWidth: "full"
  }),
  dateTime: I({
    formats: X6,
    defaultWidth: "full"
  })
}, K6 = {
  lastWeek: "'նախորդ' eeee p'֊ին'",
  yesterday: "'երեկ' p'֊ին'",
  today: "'այսօր' p'֊ին'",
  tomorrow: "'վաղը' p'֊ին'",
  nextWeek: "'հաջորդ' eeee p'֊ին'",
  other: "P"
}, Y6 = function(i, d, a, t) {
  return K6[i];
}, J6 = {
  narrow: ["Ք", "Մ"],
  abbreviated: ["ՔԱ", "ՄԹ"],
  wide: ["Քրիստոսից առաջ", "Մեր թվարկության"]
}, Q6 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Ք1", "Ք2", "Ք3", "Ք4"],
  wide: ["1֊ին քառորդ", "2֊րդ քառորդ", "3֊րդ քառորդ", "4֊րդ քառորդ"]
}, eM = {
  narrow: ["Հ", "Փ", "Մ", "Ա", "Մ", "Հ", "Հ", "Օ", "Ս", "Հ", "Ն", "Դ"],
  abbreviated: ["հուն", "փետ", "մար", "ապր", "մայ", "հուն", "հուլ", "օգս", "սեպ", "հոկ", "նոյ", "դեկ"],
  wide: ["հունվար", "փետրվար", "մարտ", "ապրիլ", "մայիս", "հունիս", "հուլիս", "օգոստոս", "սեպտեմբեր", "հոկտեմբեր", "նոյեմբեր", "դեկտեմբեր"]
}, nM = {
  narrow: ["Կ", "Ե", "Ե", "Չ", "Հ", "Ո", "Շ"],
  short: ["կր", "եր", "եք", "չք", "հգ", "ուր", "շբ"],
  abbreviated: ["կիր", "երկ", "երք", "չոր", "հնգ", "ուրբ", "շաբ"],
  wide: ["կիրակի", "երկուշաբթի", "երեքշաբթի", "չորեքշաբթի", "հինգշաբթի", "ուրբաթ", "շաբաթ"]
}, iM = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "կեսգշ",
    noon: "կեսօր",
    morning: "առավոտ",
    afternoon: "ցերեկ",
    evening: "երեկո",
    night: "գիշեր"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "կեսգիշեր",
    noon: "կեսօր",
    morning: "առավոտ",
    afternoon: "ցերեկ",
    evening: "երեկո",
    night: "գիշեր"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "կեսգիշեր",
    noon: "կեսօր",
    morning: "առավոտ",
    afternoon: "ցերեկ",
    evening: "երեկո",
    night: "գիշեր"
  }
}, aM = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "կեսգշ",
    noon: "կեսօր",
    morning: "առավոտը",
    afternoon: "ցերեկը",
    evening: "երեկոյան",
    night: "գիշերը"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "կեսգիշերին",
    noon: "կեսօրին",
    morning: "առավոտը",
    afternoon: "ցերեկը",
    evening: "երեկոյան",
    night: "գիշերը"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "կեսգիշերին",
    noon: "կեսօրին",
    morning: "առավոտը",
    afternoon: "ցերեկը",
    evening: "երեկոյան",
    night: "գիշերը"
  }
}, tM = function(i, d) {
  var a = Number(i), t = a % 100;
  return t < 10 && t % 10 === 1 ? a + "֊ին" : a + "֊րդ";
}, rM = {
  ordinalNumber: tM,
  era: $({
    values: J6,
    defaultWidth: "wide"
  }),
  quarter: $({
    values: Q6,
    defaultWidth: "wide",
    argumentCallback: function(i) {
      return i - 1;
    }
  }),
  month: $({
    values: eM,
    defaultWidth: "wide"
  }),
  day: $({
    values: nM,
    defaultWidth: "wide"
  }),
  dayPeriod: $({
    values: iM,
    defaultWidth: "wide",
    formattingValues: aM,
    defaultFormattingWidth: "wide"
  })
}, oM = /^(\d+)((-|֊)?(ին|րդ))?/i, sM = /\d+/i, dM = {
  narrow: /^(Ք|Մ)/i,
  abbreviated: /^(Ք\.?\s?Ա\.?|Մ\.?\s?Թ\.?\s?Ա\.?|Մ\.?\s?Թ\.?|Ք\.?\s?Հ\.?)/i,
  wide: /^(քրիստոսից առաջ|մեր թվարկությունից առաջ|մեր թվարկության|քրիստոսից հետո)/i
}, uM = {
  any: [/^ք/i, /^մ/i]
}, fM = {
  narrow: /^[1234]/i,
  abbreviated: /^ք[1234]/i,
  wide: /^[1234]((-|֊)?(ին|րդ)) քառորդ/i
}, lM = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, cM = {
  narrow: /^[հփմաօսնդ]/i,
  abbreviated: /^(հուն|փետ|մար|ապր|մայ|հուն|հուլ|օգս|սեպ|հոկ|նոյ|դեկ)/i,
  wide: /^(հունվար|փետրվար|մարտ|ապրիլ|մայիս|հունիս|հուլիս|օգոստոս|սեպտեմբեր|հոկտեմբեր|նոյեմբեր|դեկտեմբեր)/i
}, mM = {
  narrow: [/^հ/i, /^փ/i, /^մ/i, /^ա/i, /^մ/i, /^հ/i, /^հ/i, /^օ/i, /^ս/i, /^հ/i, /^ն/i, /^դ/i],
  any: [/^հու/i, /^փ/i, /^մար/i, /^ա/i, /^մայ/i, /^հուն/i, /^հուլ/i, /^օ/i, /^ս/i, /^հոկ/i, /^ն/i, /^դ/i]
}, vM = {
  narrow: /^[եչհոշկ]/i,
  short: /^(կր|եր|եք|չք|հգ|ուր|շբ)/i,
  abbreviated: /^(կիր|երկ|երք|չոր|հնգ|ուրբ|շաբ)/i,
  wide: /^(կիրակի|երկուշաբթի|երեքշաբթի|չորեքշաբթի|հինգշաբթի|ուրբաթ|շաբաթ)/i
}, hM = {
  narrow: [/^կ/i, /^ե/i, /^ե/i, /^չ/i, /^հ/i, /^(ո|Ո)/, /^շ/i],
  short: [/^կ/i, /^եր/i, /^եք/i, /^չ/i, /^հ/i, /^(ո|Ո)/, /^շ/i],
  abbreviated: [/^կ/i, /^երկ/i, /^երք/i, /^չ/i, /^հ/i, /^(ո|Ո)/, /^շ/i],
  wide: [/^կ/i, /^երկ/i, /^երե/i, /^չ/i, /^հ/i, /^(ո|Ո)/, /^շ/i]
}, gM = {
  narrow: /^([ap]|կեսգշ|կեսօր|(առավոտը?|ցերեկը?|երեկո(յան)?|գիշերը?))/i,
  any: /^([ap]\.?\s?m\.?|կեսգիշեր(ին)?|կեսօր(ին)?|(առավոտը?|ցերեկը?|երեկո(յան)?|գիշերը?))/i
}, pM = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /կեսգիշեր/i,
    noon: /կեսօր/i,
    morning: /առավոտ/i,
    afternoon: /ցերեկ/i,
    evening: /երեկո/i,
    night: /գիշեր/i
  }
}, bM = {
  ordinalNumber: le({
    matchPattern: oM,
    parsePattern: sM,
    valueCallback: function(i) {
      return parseInt(i, 10);
    }
  }),
  era: P({
    matchPatterns: dM,
    defaultMatchWidth: "wide",
    parsePatterns: uM,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: fM,
    defaultMatchWidth: "wide",
    parsePatterns: lM,
    defaultParseWidth: "any",
    valueCallback: function(i) {
      return i + 1;
    }
  }),
  month: P({
    matchPatterns: cM,
    defaultMatchWidth: "wide",
    parsePatterns: mM,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: vM,
    defaultMatchWidth: "wide",
    parsePatterns: hM,
    defaultParseWidth: "wide"
  }),
  dayPeriod: P({
    matchPatterns: gM,
    defaultMatchWidth: "any",
    parsePatterns: pM,
    defaultParseWidth: "any"
  })
}, yM = {
  code: "hy",
  formatDistance: H6,
  formatLong: G6,
  formatRelative: Y6,
  localize: rM,
  match: bM,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
};
const kM = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: yM
}, Symbol.toStringTag, { value: "Module" })), wM = /* @__PURE__ */ te(kM);
var _M = {
  lessThanXSeconds: {
    one: "kurang dari 1 detik",
    other: "kurang dari {{count}} detik"
  },
  xSeconds: {
    one: "1 detik",
    other: "{{count}} detik"
  },
  halfAMinute: "setengah menit",
  lessThanXMinutes: {
    one: "kurang dari 1 menit",
    other: "kurang dari {{count}} menit"
  },
  xMinutes: {
    one: "1 menit",
    other: "{{count}} menit"
  },
  aboutXHours: {
    one: "sekitar 1 jam",
    other: "sekitar {{count}} jam"
  },
  xHours: {
    one: "1 jam",
    other: "{{count}} jam"
  },
  xDays: {
    one: "1 hari",
    other: "{{count}} hari"
  },
  aboutXWeeks: {
    one: "sekitar 1 minggu",
    other: "sekitar {{count}} minggu"
  },
  xWeeks: {
    one: "1 minggu",
    other: "{{count}} minggu"
  },
  aboutXMonths: {
    one: "sekitar 1 bulan",
    other: "sekitar {{count}} bulan"
  },
  xMonths: {
    one: "1 bulan",
    other: "{{count}} bulan"
  },
  aboutXYears: {
    one: "sekitar 1 tahun",
    other: "sekitar {{count}} tahun"
  },
  xYears: {
    one: "1 tahun",
    other: "{{count}} tahun"
  },
  overXYears: {
    one: "lebih dari 1 tahun",
    other: "lebih dari {{count}} tahun"
  },
  almostXYears: {
    one: "hampir 1 tahun",
    other: "hampir {{count}} tahun"
  }
}, $M = function(i, d, a) {
  var t, o = _M[i];
  return typeof o == "string" ? t = o : d === 1 ? t = o.one : t = o.other.replace("{{count}}", d.toString()), a != null && a.addSuffix ? a.comparison && a.comparison > 0 ? "dalam waktu " + t : t + " yang lalu" : t;
}, PM = {
  full: "EEEE, d MMMM yyyy",
  long: "d MMMM yyyy",
  medium: "d MMM yyyy",
  short: "d/M/yyyy"
}, MM = {
  full: "HH.mm.ss",
  long: "HH.mm.ss",
  medium: "HH.mm",
  short: "HH.mm"
}, jM = {
  full: "{{date}} 'pukul' {{time}}",
  long: "{{date}} 'pukul' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, SM = {
  date: I({
    formats: PM,
    defaultWidth: "full"
  }),
  time: I({
    formats: MM,
    defaultWidth: "full"
  }),
  dateTime: I({
    formats: jM,
    defaultWidth: "full"
  })
}, zM = {
  lastWeek: "eeee 'lalu pukul' p",
  yesterday: "'Kemarin pukul' p",
  today: "'Hari ini pukul' p",
  tomorrow: "'Besok pukul' p",
  nextWeek: "eeee 'pukul' p",
  other: "P"
}, OM = function(i, d, a, t) {
  return zM[i];
}, WM = {
  narrow: ["SM", "M"],
  abbreviated: ["SM", "M"],
  wide: ["Sebelum Masehi", "Masehi"]
}, DM = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["K1", "K2", "K3", "K4"],
  wide: ["Kuartal ke-1", "Kuartal ke-2", "Kuartal ke-3", "Kuartal ke-4"]
}, CM = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mar", "Apr", "Mei", "Jun", "Jul", "Agt", "Sep", "Okt", "Nov", "Des"],
  wide: ["Januari", "Februari", "Maret", "April", "Mei", "Juni", "Juli", "Agustus", "September", "Oktober", "November", "Desember"]
}, IM = {
  narrow: ["M", "S", "S", "R", "K", "J", "S"],
  short: ["Min", "Sen", "Sel", "Rab", "Kam", "Jum", "Sab"],
  abbreviated: ["Min", "Sen", "Sel", "Rab", "Kam", "Jum", "Sab"],
  wide: ["Minggu", "Senin", "Selasa", "Rabu", "Kamis", "Jumat", "Sabtu"]
}, TM = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "tengah malam",
    noon: "tengah hari",
    morning: "pagi",
    afternoon: "siang",
    evening: "sore",
    night: "malam"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "tengah malam",
    noon: "tengah hari",
    morning: "pagi",
    afternoon: "siang",
    evening: "sore",
    night: "malam"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "tengah malam",
    noon: "tengah hari",
    morning: "pagi",
    afternoon: "siang",
    evening: "sore",
    night: "malam"
  }
}, NM = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "tengah malam",
    noon: "tengah hari",
    morning: "pagi",
    afternoon: "siang",
    evening: "sore",
    night: "malam"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "tengah malam",
    noon: "tengah hari",
    morning: "pagi",
    afternoon: "siang",
    evening: "sore",
    night: "malam"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "tengah malam",
    noon: "tengah hari",
    morning: "pagi",
    afternoon: "siang",
    evening: "sore",
    night: "malam"
  }
}, xM = function(i, d) {
  var a = Number(i);
  return "ke-" + a;
}, FM = {
  ordinalNumber: xM,
  era: $({
    values: WM,
    defaultWidth: "wide"
  }),
  quarter: $({
    values: DM,
    defaultWidth: "wide",
    argumentCallback: function(i) {
      return i - 1;
    }
  }),
  month: $({
    values: CM,
    defaultWidth: "wide"
  }),
  day: $({
    values: IM,
    defaultWidth: "wide"
  }),
  dayPeriod: $({
    values: TM,
    defaultWidth: "wide",
    formattingValues: NM,
    defaultFormattingWidth: "wide"
  })
}, EM = /^ke-(\d+)?/i, RM = /\d+/i, LM = {
  narrow: /^(sm|m)/i,
  abbreviated: /^(s\.?\s?m\.?|s\.?\s?e\.?\s?u\.?|m\.?|e\.?\s?u\.?)/i,
  wide: /^(sebelum masehi|sebelum era umum|masehi|era umum)/i
}, qM = {
  any: [/^s/i, /^(m|e)/i]
}, ZM = {
  narrow: /^[1234]/i,
  abbreviated: /^K-?\s[1234]/i,
  wide: /^Kuartal ke-?\s?[1234]/i
}, AM = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, VM = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|mei|jun|jul|agt|sep|okt|nov|des)/i,
  wide: /^(januari|februari|maret|april|mei|juni|juli|agustus|september|oktober|november|desember)/i
}, HM = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^ma/i, /^ap/i, /^me/i, /^jun/i, /^jul/i, /^ag/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, UM = {
  narrow: /^[srkjm]/i,
  short: /^(min|sen|sel|rab|kam|jum|sab)/i,
  abbreviated: /^(min|sen|sel|rab|kam|jum|sab)/i,
  wide: /^(minggu|senin|selasa|rabu|kamis|jumat|sabtu)/i
}, BM = {
  narrow: [/^m/i, /^s/i, /^s/i, /^r/i, /^k/i, /^j/i, /^s/i],
  any: [/^m/i, /^sen/i, /^sel/i, /^r/i, /^k/i, /^j/i, /^sa/i]
}, XM = {
  narrow: /^(a|p|tengah m|tengah h|(di(\swaktu)?) (pagi|siang|sore|malam))/i,
  any: /^([ap]\.?\s?m\.?|tengah malam|tengah hari|(di(\swaktu)?) (pagi|siang|sore|malam))/i
}, GM = {
  any: {
    am: /^a/i,
    pm: /^pm/i,
    midnight: /^tengah m/i,
    noon: /^tengah h/i,
    morning: /pagi/i,
    afternoon: /siang/i,
    evening: /sore/i,
    night: /malam/i
  }
}, KM = {
  ordinalNumber: le({
    matchPattern: EM,
    parsePattern: RM,
    valueCallback: function(i) {
      return parseInt(i, 10);
    }
  }),
  era: P({
    matchPatterns: LM,
    defaultMatchWidth: "wide",
    parsePatterns: qM,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: ZM,
    defaultMatchWidth: "wide",
    parsePatterns: AM,
    defaultParseWidth: "any",
    valueCallback: function(i) {
      return i + 1;
    }
  }),
  month: P({
    matchPatterns: VM,
    defaultMatchWidth: "wide",
    parsePatterns: HM,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: UM,
    defaultMatchWidth: "wide",
    parsePatterns: BM,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: XM,
    defaultMatchWidth: "any",
    parsePatterns: GM,
    defaultParseWidth: "any"
  })
}, YM = {
  code: "id",
  formatDistance: $M,
  formatLong: SM,
  formatRelative: OM,
  localize: FM,
  match: KM,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
};
const JM = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: YM
}, Symbol.toStringTag, { value: "Module" })), QM = /* @__PURE__ */ te(JM);
var ej = {
  lessThanXSeconds: {
    one: "minna en 1 sekúnda",
    other: "minna en {{count}} sekúndur"
  },
  xSeconds: {
    one: "1 sekúnda",
    other: "{{count}} sekúndur"
  },
  halfAMinute: "hálf mínúta",
  lessThanXMinutes: {
    one: "minna en 1 mínúta",
    other: "minna en {{count}} mínútur"
  },
  xMinutes: {
    one: "1 mínúta",
    other: "{{count}} mínútur"
  },
  aboutXHours: {
    one: "u.þ.b. 1 klukkustund",
    other: "u.þ.b. {{count}} klukkustundir"
  },
  xHours: {
    one: "1 klukkustund",
    other: "{{count}} klukkustundir"
  },
  xDays: {
    one: "1 dagur",
    other: "{{count}} dagar"
  },
  aboutXWeeks: {
    one: "um viku",
    other: "um {{count}} vikur"
  },
  xWeeks: {
    one: "1 viku",
    other: "{{count}} vikur"
  },
  aboutXMonths: {
    one: "u.þ.b. 1 mánuður",
    other: "u.þ.b. {{count}} mánuðir"
  },
  xMonths: {
    one: "1 mánuður",
    other: "{{count}} mánuðir"
  },
  aboutXYears: {
    one: "u.þ.b. 1 ár",
    other: "u.þ.b. {{count}} ár"
  },
  xYears: {
    one: "1 ár",
    other: "{{count}} ár"
  },
  overXYears: {
    one: "meira en 1 ár",
    other: "meira en {{count}} ár"
  },
  almostXYears: {
    one: "næstum 1 ár",
    other: "næstum {{count}} ár"
  }
}, nj = function(i, d, a) {
  var t, o = ej[i];
  return typeof o == "string" ? t = o : d === 1 ? t = o.one : t = o.other.replace("{{count}}", d.toString()), a != null && a.addSuffix ? a.comparison && a.comparison > 0 ? "í " + t : t + " síðan" : t;
}, ij = {
  full: "EEEE, do MMMM y",
  long: "do MMMM y",
  medium: "do MMM y",
  short: "d.MM.y"
}, aj = {
  full: "'kl'. HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, tj = {
  full: "{{date}} 'kl.' {{time}}",
  long: "{{date}} 'kl.' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, rj = {
  date: I({
    formats: ij,
    defaultWidth: "full"
  }),
  time: I({
    formats: aj,
    defaultWidth: "full"
  }),
  dateTime: I({
    formats: tj,
    defaultWidth: "full"
  })
}, oj = {
  lastWeek: "'síðasta' dddd 'kl.' p",
  yesterday: "'í gær kl.' p",
  today: "'í dag kl.' p",
  tomorrow: "'á morgun kl.' p",
  nextWeek: "dddd 'kl.' p",
  other: "P"
}, sj = function(i, d, a, t) {
  return oj[i];
}, dj = {
  narrow: ["f.Kr.", "e.Kr."],
  abbreviated: ["f.Kr.", "e.Kr."],
  wide: ["fyrir Krist", "eftir Krist"]
}, uj = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1F", "2F", "3F", "4F"],
  wide: ["1. fjórðungur", "2. fjórðungur", "3. fjórðungur", "4. fjórðungur"]
}, fj = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "Á", "S", "Ó", "N", "D"],
  abbreviated: ["jan.", "feb.", "mars", "apríl", "maí", "júní", "júlí", "ágúst", "sept.", "okt.", "nóv.", "des."],
  wide: ["janúar", "febrúar", "mars", "apríl", "maí", "júní", "júlí", "ágúst", "september", "október", "nóvember", "desember"]
}, lj = {
  narrow: ["S", "M", "Þ", "M", "F", "F", "L"],
  short: ["Su", "Má", "Þr", "Mi", "Fi", "Fö", "La"],
  abbreviated: ["sun.", "mán.", "þri.", "mið.", "fim.", "fös.", "lau."],
  wide: ["sunnudagur", "mánudagur", "þriðjudagur", "miðvikudagur", "fimmtudagur", "föstudagur", "laugardagur"]
}, cj = {
  narrow: {
    am: "f",
    pm: "e",
    midnight: "miðnætti",
    noon: "hádegi",
    morning: "morgunn",
    afternoon: "síðdegi",
    evening: "kvöld",
    night: "nótt"
  },
  abbreviated: {
    am: "f.h.",
    pm: "e.h.",
    midnight: "miðnætti",
    noon: "hádegi",
    morning: "morgunn",
    afternoon: "síðdegi",
    evening: "kvöld",
    night: "nótt"
  },
  wide: {
    am: "fyrir hádegi",
    pm: "eftir hádegi",
    midnight: "miðnætti",
    noon: "hádegi",
    morning: "morgunn",
    afternoon: "síðdegi",
    evening: "kvöld",
    night: "nótt"
  }
}, mj = {
  narrow: {
    am: "f",
    pm: "e",
    midnight: "á miðnætti",
    noon: "á hádegi",
    morning: "að morgni",
    afternoon: "síðdegis",
    evening: "um kvöld",
    night: "um nótt"
  },
  abbreviated: {
    am: "f.h.",
    pm: "e.h.",
    midnight: "á miðnætti",
    noon: "á hádegi",
    morning: "að morgni",
    afternoon: "síðdegis",
    evening: "um kvöld",
    night: "um nótt"
  },
  wide: {
    am: "fyrir hádegi",
    pm: "eftir hádegi",
    midnight: "á miðnætti",
    noon: "á hádegi",
    morning: "að morgni",
    afternoon: "síðdegis",
    evening: "um kvöld",
    night: "um nótt"
  }
}, vj = function(i, d) {
  var a = Number(i);
  return a + ".";
}, hj = {
  ordinalNumber: vj,
  era: $({
    values: dj,
    defaultWidth: "wide"
  }),
  quarter: $({
    values: uj,
    defaultWidth: "wide",
    argumentCallback: function(i) {
      return i - 1;
    }
  }),
  month: $({
    values: fj,
    defaultWidth: "wide"
  }),
  day: $({
    values: lj,
    defaultWidth: "wide"
  }),
  dayPeriod: $({
    values: cj,
    defaultWidth: "wide",
    formattingValues: mj,
    defaultFormattingWidth: "wide"
  })
}, gj = /^(\d+)(\.)?/i, pj = /\d+(\.)?/i, bj = {
  narrow: /^(f\.Kr\.|e\.Kr\.)/i,
  abbreviated: /^(f\.Kr\.|e\.Kr\.)/i,
  wide: /^(fyrir Krist|eftir Krist)/i
}, yj = {
  any: [/^(f\.Kr\.)/i, /^(e\.Kr\.)/i]
}, kj = {
  narrow: /^[1234]\.?/i,
  abbreviated: /^q[1234]\.?/i,
  wide: /^[1234]\.? fjórðungur/i
}, wj = {
  any: [/1\.?/i, /2\.?/i, /3\.?/i, /4\.?/i]
}, _j = {
  narrow: /^[jfmásónd]/i,
  abbreviated: /^(jan\.|feb\.|mars\.|apríl\.|maí|júní|júlí|águst|sep\.|oct\.|nov\.|dec\.)/i,
  wide: /^(januar|febrúar|mars|apríl|maí|júní|júlí|águst|september|október|nóvember|desember)/i
}, $j = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^á/i, /^s/i, /^ó/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^maí/i, /^jún/i, /^júl/i, /^áu/i, /^s/i, /^ó/i, /^n/i, /^d/i]
}, Pj = {
  narrow: /^[smtwf]/i,
  short: /^(su|má|þr|mi|fi|fö|la)/i,
  abbreviated: /^(sun|mán|þri|mið|fim|fös|lau)\.?/i,
  wide: /^(sunnudagur|mánudagur|þriðjudagur|miðvikudagur|fimmtudagur|föstudagur|laugardagur)/i
}, Mj = {
  narrow: [/^s/i, /^m/i, /^þ/i, /^m/i, /^f/i, /^f/i, /^l/i],
  any: [/^su/i, /^má/i, /^þr/i, /^mi/i, /^fi/i, /^fö/i, /^la/i]
}, jj = {
  narrow: /^(f|e|síðdegis|(á|að|um) (morgni|kvöld|nótt|miðnætti))/i,
  any: /^(fyrir hádegi|eftir hádegi|[ef]\.?h\.?|síðdegis|morgunn|(á|að|um) (morgni|kvöld|nótt|miðnætti))/i
}, Sj = {
  any: {
    am: /^f/i,
    pm: /^e/i,
    midnight: /^mi/i,
    noon: /^há/i,
    morning: /morgunn/i,
    afternoon: /síðdegi/i,
    evening: /kvöld/i,
    night: /nótt/i
  }
}, zj = {
  ordinalNumber: le({
    matchPattern: gj,
    parsePattern: pj,
    valueCallback: function(i) {
      return parseInt(i, 10);
    }
  }),
  era: P({
    matchPatterns: bj,
    defaultMatchWidth: "wide",
    parsePatterns: yj,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: kj,
    defaultMatchWidth: "wide",
    parsePatterns: wj,
    defaultParseWidth: "any",
    valueCallback: function(i) {
      return i + 1;
    }
  }),
  month: P({
    matchPatterns: _j,
    defaultMatchWidth: "wide",
    parsePatterns: $j,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: Pj,
    defaultMatchWidth: "wide",
    parsePatterns: Mj,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: jj,
    defaultMatchWidth: "any",
    parsePatterns: Sj,
    defaultParseWidth: "any"
  })
}, Oj = {
  code: "is",
  formatDistance: nj,
  formatLong: rj,
  formatRelative: sj,
  localize: hj,
  match: zj,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const Wj = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Oj
}, Symbol.toStringTag, { value: "Module" })), Dj = /* @__PURE__ */ te(Wj);
var Cj = {
  lessThanXSeconds: {
    one: "meno di un secondo",
    other: "meno di {{count}} secondi"
  },
  xSeconds: {
    one: "un secondo",
    other: "{{count}} secondi"
  },
  halfAMinute: "alcuni secondi",
  lessThanXMinutes: {
    one: "meno di un minuto",
    other: "meno di {{count}} minuti"
  },
  xMinutes: {
    one: "un minuto",
    other: "{{count}} minuti"
  },
  aboutXHours: {
    one: "circa un'ora",
    other: "circa {{count}} ore"
  },
  xHours: {
    one: "un'ora",
    other: "{{count}} ore"
  },
  xDays: {
    one: "un giorno",
    other: "{{count}} giorni"
  },
  aboutXWeeks: {
    one: "circa una settimana",
    other: "circa {{count}} settimane"
  },
  xWeeks: {
    one: "una settimana",
    other: "{{count}} settimane"
  },
  aboutXMonths: {
    one: "circa un mese",
    other: "circa {{count}} mesi"
  },
  xMonths: {
    one: "un mese",
    other: "{{count}} mesi"
  },
  aboutXYears: {
    one: "circa un anno",
    other: "circa {{count}} anni"
  },
  xYears: {
    one: "un anno",
    other: "{{count}} anni"
  },
  overXYears: {
    one: "più di un anno",
    other: "più di {{count}} anni"
  },
  almostXYears: {
    one: "quasi un anno",
    other: "quasi {{count}} anni"
  }
}, Iu = function(i, d, a) {
  var t, o = Cj[i];
  return typeof o == "string" ? t = o : d === 1 ? t = o.one : t = o.other.replace("{{count}}", d.toString()), a != null && a.addSuffix ? a.comparison && a.comparison > 0 ? "tra " + t : t + " fa" : t;
}, Ij = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "dd/MM/y"
}, Tj = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, Nj = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, xj = {
  date: I({
    formats: Ij,
    defaultWidth: "full"
  }),
  time: I({
    formats: Tj,
    defaultWidth: "full"
  }),
  dateTime: I({
    formats: Nj,
    defaultWidth: "full"
  })
}, ar = ["domenica", "lunedì", "martedì", "mercoledì", "giovedì", "venerdì", "sabato"];
function Fj(e) {
  switch (e) {
    case 0:
      return "'domenica scorsa alle' p";
    default:
      return "'" + ar[e] + " scorso alle' p";
  }
}
function td(e) {
  return "'" + ar[e] + " alle' p";
}
function Ej(e) {
  switch (e) {
    case 0:
      return "'domenica prossima alle' p";
    default:
      return "'" + ar[e] + " prossimo alle' p";
  }
}
var Rj = {
  lastWeek: function(i, d, a) {
    var t = i.getUTCDay();
    return Ne(i, d, a) ? td(t) : Fj(t);
  },
  yesterday: "'ieri alle' p",
  today: "'oggi alle' p",
  tomorrow: "'domani alle' p",
  nextWeek: function(i, d, a) {
    var t = i.getUTCDay();
    return Ne(i, d, a) ? td(t) : Ej(t);
  },
  other: "P"
}, Tu = function(i, d, a, t) {
  var o = Rj[i];
  return typeof o == "function" ? o(d, a, t) : o;
}, Lj = {
  narrow: ["aC", "dC"],
  abbreviated: ["a.C.", "d.C."],
  wide: ["avanti Cristo", "dopo Cristo"]
}, qj = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["T1", "T2", "T3", "T4"],
  wide: ["1º trimestre", "2º trimestre", "3º trimestre", "4º trimestre"]
}, Zj = {
  narrow: ["G", "F", "M", "A", "M", "G", "L", "A", "S", "O", "N", "D"],
  abbreviated: ["gen", "feb", "mar", "apr", "mag", "giu", "lug", "ago", "set", "ott", "nov", "dic"],
  wide: ["gennaio", "febbraio", "marzo", "aprile", "maggio", "giugno", "luglio", "agosto", "settembre", "ottobre", "novembre", "dicembre"]
}, Aj = {
  narrow: ["D", "L", "M", "M", "G", "V", "S"],
  short: ["dom", "lun", "mar", "mer", "gio", "ven", "sab"],
  abbreviated: ["dom", "lun", "mar", "mer", "gio", "ven", "sab"],
  wide: ["domenica", "lunedì", "martedì", "mercoledì", "giovedì", "venerdì", "sabato"]
}, Vj = {
  narrow: {
    am: "m.",
    pm: "p.",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "mattina",
    afternoon: "pomeriggio",
    evening: "sera",
    night: "notte"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "mattina",
    afternoon: "pomeriggio",
    evening: "sera",
    night: "notte"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "mattina",
    afternoon: "pomeriggio",
    evening: "sera",
    night: "notte"
  }
}, Hj = {
  narrow: {
    am: "m.",
    pm: "p.",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "di mattina",
    afternoon: "del pomeriggio",
    evening: "di sera",
    night: "di notte"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "di mattina",
    afternoon: "del pomeriggio",
    evening: "di sera",
    night: "di notte"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "di mattina",
    afternoon: "del pomeriggio",
    evening: "di sera",
    night: "di notte"
  }
}, Uj = function(i, d) {
  var a = Number(i);
  return String(a);
}, Nu = {
  ordinalNumber: Uj,
  era: $({
    values: Lj,
    defaultWidth: "wide"
  }),
  quarter: $({
    values: qj,
    defaultWidth: "wide",
    argumentCallback: function(i) {
      return i - 1;
    }
  }),
  month: $({
    values: Zj,
    defaultWidth: "wide"
  }),
  day: $({
    values: Aj,
    defaultWidth: "wide"
  }),
  dayPeriod: $({
    values: Vj,
    defaultWidth: "wide",
    formattingValues: Hj,
    defaultFormattingWidth: "wide"
  })
}, Bj = /^(\d+)(º)?/i, Xj = /\d+/i, Gj = {
  narrow: /^(aC|dC)/i,
  abbreviated: /^(a\.?\s?C\.?|a\.?\s?e\.?\s?v\.?|d\.?\s?C\.?|e\.?\s?v\.?)/i,
  wide: /^(avanti Cristo|avanti Era Volgare|dopo Cristo|Era Volgare)/i
}, Kj = {
  any: [/^a/i, /^(d|e)/i]
}, Yj = {
  narrow: /^[1234]/i,
  abbreviated: /^t[1234]/i,
  wide: /^[1234](º)? trimestre/i
}, Jj = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Qj = {
  narrow: /^[gfmalsond]/i,
  abbreviated: /^(gen|feb|mar|apr|mag|giu|lug|ago|set|ott|nov|dic)/i,
  wide: /^(gennaio|febbraio|marzo|aprile|maggio|giugno|luglio|agosto|settembre|ottobre|novembre|dicembre)/i
}, e9 = {
  narrow: [/^g/i, /^f/i, /^m/i, /^a/i, /^m/i, /^g/i, /^l/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ge/i, /^f/i, /^mar/i, /^ap/i, /^mag/i, /^gi/i, /^l/i, /^ag/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, n9 = {
  narrow: /^[dlmgvs]/i,
  short: /^(do|lu|ma|me|gi|ve|sa)/i,
  abbreviated: /^(dom|lun|mar|mer|gio|ven|sab)/i,
  wide: /^(domenica|luned[i|ì]|marted[i|ì]|mercoled[i|ì]|gioved[i|ì]|venerd[i|ì]|sabato)/i
}, i9 = {
  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^g/i, /^v/i, /^s/i],
  any: [/^d/i, /^l/i, /^ma/i, /^me/i, /^g/i, /^v/i, /^s/i]
}, a9 = {
  narrow: /^(a|m\.|p|mezzanotte|mezzogiorno|(di|del) (mattina|pomeriggio|sera|notte))/i,
  any: /^([ap]\.?\s?m\.?|mezzanotte|mezzogiorno|(di|del) (mattina|pomeriggio|sera|notte))/i
}, t9 = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mezza/i,
    noon: /^mezzo/i,
    morning: /mattina/i,
    afternoon: /pomeriggio/i,
    evening: /sera/i,
    night: /notte/i
  }
}, xu = {
  ordinalNumber: le({
    matchPattern: Bj,
    parsePattern: Xj,
    valueCallback: function(i) {
      return parseInt(i, 10);
    }
  }),
  era: P({
    matchPatterns: Gj,
    defaultMatchWidth: "wide",
    parsePatterns: Kj,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: Yj,
    defaultMatchWidth: "wide",
    parsePatterns: Jj,
    defaultParseWidth: "any",
    valueCallback: function(i) {
      return i + 1;
    }
  }),
  month: P({
    matchPatterns: Qj,
    defaultMatchWidth: "wide",
    parsePatterns: e9,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: n9,
    defaultMatchWidth: "wide",
    parsePatterns: i9,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: a9,
    defaultMatchWidth: "any",
    parsePatterns: t9,
    defaultParseWidth: "any"
  })
}, r9 = {
  code: "it",
  formatDistance: Iu,
  formatLong: xj,
  formatRelative: Tu,
  localize: Nu,
  match: xu,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const o9 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: r9
}, Symbol.toStringTag, { value: "Module" })), s9 = /* @__PURE__ */ te(o9);
var d9 = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "dd.MM.y"
}, u9 = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, f9 = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, l9 = {
  date: I({
    formats: d9,
    defaultWidth: "full"
  }),
  time: I({
    formats: u9,
    defaultWidth: "full"
  }),
  dateTime: I({
    formats: f9,
    defaultWidth: "full"
  })
}, c9 = {
  code: "it-CH",
  formatDistance: Iu,
  formatLong: l9,
  formatRelative: Tu,
  localize: Nu,
  match: xu,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const m9 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: c9
}, Symbol.toStringTag, { value: "Module" })), v9 = /* @__PURE__ */ te(m9);
var h9 = {
  lessThanXSeconds: {
    one: "1びょうみまん",
    other: "{{count}}びょうみまん",
    oneWithSuffix: "やく1びょう",
    otherWithSuffix: "やく{{count}}びょう"
  },
  xSeconds: {
    one: "1びょう",
    other: "{{count}}びょう"
  },
  halfAMinute: "30びょう",
  lessThanXMinutes: {
    one: "1ぷんみまん",
    other: "{{count}}ふんみまん",
    oneWithSuffix: "やく1ぷん",
    otherWithSuffix: "やく{{count}}ふん"
  },
  xMinutes: {
    one: "1ぷん",
    other: "{{count}}ふん"
  },
  aboutXHours: {
    one: "やく1じかん",
    other: "やく{{count}}じかん"
  },
  xHours: {
    one: "1じかん",
    other: "{{count}}じかん"
  },
  xDays: {
    one: "1にち",
    other: "{{count}}にち"
  },
  aboutXWeeks: {
    one: "やく1しゅうかん",
    other: "やく{{count}}しゅうかん"
  },
  xWeeks: {
    one: "1しゅうかん",
    other: "{{count}}しゅうかん"
  },
  aboutXMonths: {
    one: "やく1かげつ",
    other: "やく{{count}}かげつ"
  },
  xMonths: {
    one: "1かげつ",
    other: "{{count}}かげつ"
  },
  aboutXYears: {
    one: "やく1ねん",
    other: "やく{{count}}ねん"
  },
  xYears: {
    one: "1ねん",
    other: "{{count}}ねん"
  },
  overXYears: {
    one: "1ねんいじょう",
    other: "{{count}}ねんいじょう"
  },
  almostXYears: {
    one: "1ねんちかく",
    other: "{{count}}ねんちかく"
  }
}, g9 = function(i, d, a) {
  a = a || {};
  var t, o = h9[i];
  return typeof o == "string" ? t = o : d === 1 ? a.addSuffix && o.oneWithSuffix ? t = o.oneWithSuffix : t = o.one : a.addSuffix && o.otherWithSuffix ? t = o.otherWithSuffix.replace("{{count}}", String(d)) : t = o.other.replace("{{count}}", String(d)), a.addSuffix ? a.comparison && a.comparison > 0 ? t + "あと" : t + "まえ" : t;
}, p9 = {
  full: "yねんMがつdにちEEEE",
  long: "yねんMがつdにち",
  medium: "y/MM/dd",
  short: "y/MM/dd"
}, b9 = {
  full: "Hじmmふんssびょう zzzz",
  long: "H:mm:ss z",
  medium: "H:mm:ss",
  short: "H:mm"
}, y9 = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, k9 = {
  date: I({
    formats: p9,
    defaultWidth: "full"
  }),
  time: I({
    formats: b9,
    defaultWidth: "full"
  }),
  dateTime: I({
    formats: y9,
    defaultWidth: "full"
  })
}, w9 = {
  lastWeek: "せんしゅうのeeeeのp",
  yesterday: "きのうのp",
  today: "きょうのp",
  tomorrow: "あしたのp",
  nextWeek: "よくしゅうのeeeeのp",
  other: "P"
}, _9 = function(i, d, a, t) {
  return w9[i];
}, $9 = {
  narrow: ["BC", "AC"],
  abbreviated: ["きげんぜん", "せいれき"],
  wide: ["きげんぜん", "せいれき"]
}, P9 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["だい1しはんき", "だい2しはんき", "だい3しはんき", "だい4しはんき"]
}, M9 = {
  narrow: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"],
  abbreviated: ["1がつ", "2がつ", "3がつ", "4がつ", "5がつ", "6がつ", "7がつ", "8がつ", "9がつ", "10がつ", "11がつ", "12がつ"],
  wide: ["1がつ", "2がつ", "3がつ", "4がつ", "5がつ", "6がつ", "7がつ", "8がつ", "9がつ", "10がつ", "11がつ", "12がつ"]
}, j9 = {
  narrow: ["にち", "げつ", "か", "すい", "もく", "きん", "ど"],
  short: ["にち", "げつ", "か", "すい", "もく", "きん", "ど"],
  abbreviated: ["にち", "げつ", "か", "すい", "もく", "きん", "ど"],
  wide: ["にちようび", "げつようび", "かようび", "すいようび", "もくようび", "きんようび", "どようび"]
}, S9 = {
  narrow: {
    am: "ごぜん",
    pm: "ごご",
    midnight: "しんや",
    noon: "しょうご",
    morning: "あさ",
    afternoon: "ごご",
    evening: "よる",
    night: "しんや"
  },
  abbreviated: {
    am: "ごぜん",
    pm: "ごご",
    midnight: "しんや",
    noon: "しょうご",
    morning: "あさ",
    afternoon: "ごご",
    evening: "よる",
    night: "しんや"
  },
  wide: {
    am: "ごぜん",
    pm: "ごご",
    midnight: "しんや",
    noon: "しょうご",
    morning: "あさ",
    afternoon: "ごご",
    evening: "よる",
    night: "しんや"
  }
}, z9 = {
  narrow: {
    am: "ごぜん",
    pm: "ごご",
    midnight: "しんや",
    noon: "しょうご",
    morning: "あさ",
    afternoon: "ごご",
    evening: "よる",
    night: "しんや"
  },
  abbreviated: {
    am: "ごぜん",
    pm: "ごご",
    midnight: "しんや",
    noon: "しょうご",
    morning: "あさ",
    afternoon: "ごご",
    evening: "よる",
    night: "しんや"
  },
  wide: {
    am: "ごぜん",
    pm: "ごご",
    midnight: "しんや",
    noon: "しょうご",
    morning: "あさ",
    afternoon: "ごご",
    evening: "よる",
    night: "しんや"
  }
}, O9 = function(i, d) {
  var a = Number(i), t = String(d == null ? void 0 : d.unit);
  switch (t) {
    case "year":
      return "".concat(a, "ねん");
    case "quarter":
      return "だい".concat(a, "しはんき");
    case "month":
      return "".concat(a, "がつ");
    case "week":
      return "だい".concat(a, "しゅう");
    case "date":
      return "".concat(a, "にち");
    case "hour":
      return "".concat(a, "じ");
    case "minute":
      return "".concat(a, "ふん");
    case "second":
      return "".concat(a, "びょう");
    default:
      return "".concat(a);
  }
}, W9 = {
  ordinalNumber: O9,
  era: $({
    values: $9,
    defaultWidth: "wide"
  }),
  quarter: $({
    values: P9,
    defaultWidth: "wide",
    argumentCallback: function(i) {
      return Number(i) - 1;
    }
  }),
  month: $({
    values: M9,
    defaultWidth: "wide"
  }),
  day: $({
    values: j9,
    defaultWidth: "wide"
  }),
  dayPeriod: $({
    values: S9,
    defaultWidth: "wide",
    formattingValues: z9,
    defaultFormattingWidth: "wide"
  })
}, D9 = /^だ?い?\d+(ねん|しはんき|がつ|しゅう|にち|じ|ふん|びょう)?/i, C9 = /\d+/i, I9 = {
  narrow: /^(B\.?C\.?|A\.?D\.?)/i,
  abbreviated: /^(きげん[前後]|せいれき)/i,
  wide: /^(きげん[前後]|せいれき)/i
}, T9 = {
  narrow: [/^B/i, /^A/i],
  any: [/^(きげんぜん)/i, /^(せいれき|きげんご)/i]
}, N9 = {
  narrow: /^[1234]/i,
  abbreviated: /^Q[1234]/i,
  wide: /^だい[1234一二三四１２３４]しはんき/i
}, x9 = {
  any: [/(1|一|１)/i, /(2|二|２)/i, /(3|三|３)/i, /(4|四|４)/i]
}, F9 = {
  narrow: /^([123456789]|1[012])/,
  abbreviated: /^([123456789]|1[012])がつ/i,
  wide: /^([123456789]|1[012])がつ/i
}, E9 = {
  any: [/^1\D/, /^2/, /^3/, /^4/, /^5/, /^6/, /^7/, /^8/, /^9/, /^10/, /^11/, /^12/]
}, R9 = {
  narrow: /^(にち|げつ|か|すい|もく|きん|ど)/,
  short: /^(にち|げつ|か|すい|もく|きん|ど)/,
  abbreviated: /^(にち|げつ|か|すい|もく|きん|ど)/,
  wide: /^(にち|げつ|か|すい|もく|きん|ど)ようび/
}, L9 = {
  any: [/^にち/, /^げつ/, /^か/, /^すい/, /^もく/, /^きん/, /^ど/]
}, q9 = {
  any: /^(AM|PM|ごぜん|ごご|しょうご|しんや|まよなか|よる|あさ)/i
}, Z9 = {
  any: {
    am: /^(A|ごぜん)/i,
    pm: /^(P|ごご)/i,
    midnight: /^しんや|まよなか/i,
    noon: /^しょうご/i,
    morning: /^あさ/i,
    afternoon: /^ごご/i,
    evening: /^よる/i,
    night: /^しんや/i
  }
}, A9 = {
  ordinalNumber: le({
    matchPattern: D9,
    parsePattern: C9,
    valueCallback: function(i) {
      return parseInt(i, 10);
    }
  }),
  era: P({
    matchPatterns: I9,
    defaultMatchWidth: "wide",
    parsePatterns: T9,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: N9,
    defaultMatchWidth: "wide",
    parsePatterns: x9,
    defaultParseWidth: "any",
    valueCallback: function(i) {
      return i + 1;
    }
  }),
  month: P({
    matchPatterns: F9,
    defaultMatchWidth: "wide",
    parsePatterns: E9,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: R9,
    defaultMatchWidth: "wide",
    parsePatterns: L9,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: q9,
    defaultMatchWidth: "any",
    parsePatterns: Z9,
    defaultParseWidth: "any"
  })
}, V9 = {
  code: "ja-Hira",
  formatDistance: g9,
  formatLong: k9,
  formatRelative: _9,
  localize: W9,
  match: A9,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
const H9 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: V9
}, Symbol.toStringTag, { value: "Module" })), U9 = /* @__PURE__ */ te(H9);
var B9 = {
  lessThanXSeconds: {
    past: "{{count}} წამზე ნაკლები ხნის წინ",
    present: "{{count}} წამზე ნაკლები",
    future: "{{count}} წამზე ნაკლებში"
  },
  xSeconds: {
    past: "{{count}} წამის წინ",
    present: "{{count}} წამი",
    future: "{{count}} წამში"
  },
  halfAMinute: {
    past: "ნახევარი წუთის წინ",
    present: "ნახევარი წუთი",
    future: "ნახევარი წუთში"
  },
  lessThanXMinutes: {
    past: "{{count}} წუთზე ნაკლები ხნის წინ",
    present: "{{count}} წუთზე ნაკლები",
    future: "{{count}} წუთზე ნაკლებში"
  },
  xMinutes: {
    past: "{{count}} წუთის წინ",
    present: "{{count}} წუთი",
    future: "{{count}} წუთში"
  },
  aboutXHours: {
    past: "დაახლოებით {{count}} საათის წინ",
    present: "დაახლოებით {{count}} საათი",
    future: "დაახლოებით {{count}} საათში"
  },
  xHours: {
    past: "{{count}} საათის წინ",
    present: "{{count}} საათი",
    future: "{{count}} საათში"
  },
  xDays: {
    past: "{{count}} დღის წინ",
    present: "{{count}} დღე",
    future: "{{count}} დღეში"
  },
  aboutXWeeks: {
    past: "დაახლოებით {{count}} კვირას წინ",
    present: "დაახლოებით {{count}} კვირა",
    future: "დაახლოებით {{count}} კვირაში"
  },
  xWeeks: {
    past: "{{count}} კვირას კვირა",
    present: "{{count}} კვირა",
    future: "{{count}} კვირაში"
  },
  aboutXMonths: {
    past: "დაახლოებით {{count}} თვის წინ",
    present: "დაახლოებით {{count}} თვე",
    future: "დაახლოებით {{count}} თვეში"
  },
  xMonths: {
    past: "{{count}} თვის წინ",
    present: "{{count}} თვე",
    future: "{{count}} თვეში"
  },
  aboutXYears: {
    past: "დაახლოებით {{count}} წლის წინ",
    present: "დაახლოებით {{count}} წელი",
    future: "დაახლოებით {{count}} წელში"
  },
  xYears: {
    past: "{{count}} წლის წინ",
    present: "{{count}} წელი",
    future: "{{count}} წელში"
  },
  overXYears: {
    past: "{{count}} წელზე მეტი ხნის წინ",
    present: "{{count}} წელზე მეტი",
    future: "{{count}} წელზე მეტი ხნის შემდეგ"
  },
  almostXYears: {
    past: "თითქმის {{count}} წლის წინ",
    present: "თითქმის {{count}} წელი",
    future: "თითქმის {{count}} წელში"
  }
}, X9 = function(i, d, a) {
  var t, o = B9[i];
  return typeof o == "string" ? t = o : a != null && a.addSuffix && a.comparison && a.comparison > 0 ? t = o.future.replace("{{count}}", String(d)) : a != null && a.addSuffix ? t = o.past.replace("{{count}}", String(d)) : t = o.present.replace("{{count}}", String(d)), t;
}, G9 = {
  full: "EEEE, do MMMM, y",
  long: "do, MMMM, y",
  medium: "d, MMM, y",
  short: "dd/MM/yyyy"
}, K9 = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, Y9 = {
  full: "{{date}} {{time}}'-ზე'",
  long: "{{date}} {{time}}'-ზე'",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, J9 = {
  date: I({
    formats: G9,
    defaultWidth: "full"
  }),
  time: I({
    formats: K9,
    defaultWidth: "full"
  }),
  dateTime: I({
    formats: Y9,
    defaultWidth: "full"
  })
}, Q9 = {
  lastWeek: "'წინა' eeee p'-ზე'",
  yesterday: "'გუშინ' p'-ზე'",
  today: "'დღეს' p'-ზე'",
  tomorrow: "'ხვალ' p'-ზე'",
  nextWeek: "'შემდეგი' eeee p'-ზე'",
  other: "P"
}, eS = function(i, d, a, t) {
  return Q9[i];
}, nS = {
  narrow: ["ჩ.წ-მდე", "ჩ.წ"],
  abbreviated: ["ჩვ.წ-მდე", "ჩვ.წ"],
  wide: ["ჩვენს წელთაღრიცხვამდე", "ჩვენი წელთაღრიცხვით"]
}, iS = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1-ლი კვ", "2-ე კვ", "3-ე კვ", "4-ე კვ"],
  wide: ["1-ლი კვარტალი", "2-ე კვარტალი", "3-ე კვარტალი", "4-ე კვარტალი"]
}, aS = {
  narrow: ["ია", "თე", "მა", "აპ", "მს", "ვნ", "ვლ", "აგ", "სე", "ოქ", "ნო", "დე"],
  abbreviated: ["იან", "თებ", "მარ", "აპრ", "მაი", "ივნ", "ივლ", "აგვ", "სექ", "ოქტ", "ნოე", "დეკ"],
  wide: ["იანვარი", "თებერვალი", "მარტი", "აპრილი", "მაისი", "ივნისი", "ივლისი", "აგვისტო", "სექტემბერი", "ოქტომბერი", "ნოემბერი", "დეკემბერი"]
}, tS = {
  narrow: ["კვ", "ორ", "სა", "ოთ", "ხუ", "პა", "შა"],
  short: ["კვი", "ორშ", "სამ", "ოთხ", "ხუთ", "პარ", "შაბ"],
  abbreviated: ["კვი", "ორშ", "სამ", "ოთხ", "ხუთ", "პარ", "შაბ"],
  wide: ["კვირა", "ორშაბათი", "სამშაბათი", "ოთხშაბათი", "ხუთშაბათი", "პარასკევი", "შაბათი"]
}, rS = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "შუაღამე",
    noon: "შუადღე",
    morning: "დილა",
    afternoon: "საღამო",
    evening: "საღამო",
    night: "ღამე"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "შუაღამე",
    noon: "შუადღე",
    morning: "დილა",
    afternoon: "საღამო",
    evening: "საღამო",
    night: "ღამე"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "შუაღამე",
    noon: "შუადღე",
    morning: "დილა",
    afternoon: "საღამო",
    evening: "საღამო",
    night: "ღამე"
  }
}, oS = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "შუაღამით",
    noon: "შუადღისას",
    morning: "დილით",
    afternoon: "ნაშუადღევს",
    evening: "საღამოს",
    night: "ღამით"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "შუაღამით",
    noon: "შუადღისას",
    morning: "დილით",
    afternoon: "ნაშუადღევს",
    evening: "საღამოს",
    night: "ღამით"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "შუაღამით",
    noon: "შუადღისას",
    morning: "დილით",
    afternoon: "ნაშუადღევს",
    evening: "საღამოს",
    night: "ღამით"
  }
}, sS = function(i) {
  var d = Number(i);
  return d === 1 ? d + "-ლი" : d + "-ე";
}, dS = {
  ordinalNumber: sS,
  era: $({
    values: nS,
    defaultWidth: "wide"
  }),
  quarter: $({
    values: iS,
    defaultWidth: "wide",
    argumentCallback: function(i) {
      return i - 1;
    }
  }),
  month: $({
    values: aS,
    defaultWidth: "wide"
  }),
  day: $({
    values: tS,
    defaultWidth: "wide"
  }),
  dayPeriod: $({
    values: rS,
    defaultWidth: "wide",
    formattingValues: oS,
    defaultFormattingWidth: "wide"
  })
}, uS = /^(\d+)(-ლი|-ე)?/i, fS = /\d+/i, lS = {
  narrow: /^(ჩვ?\.წ)/i,
  abbreviated: /^(ჩვ?\.წ)/i,
  wide: /^(ჩვენს წელთაღრიცხვამდე|ქრისტეშობამდე|ჩვენი წელთაღრიცხვით|ქრისტეშობიდან)/i
}, cS = {
  any: [/^(ჩვენს წელთაღრიცხვამდე|ქრისტეშობამდე)/i, /^(ჩვენი წელთაღრიცხვით|ქრისტეშობიდან)/i]
}, mS = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234]-(ლი|ე)? კვ/i,
  wide: /^[1234]-(ლი|ე)? კვარტალი/i
}, vS = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, hS = {
  any: /^(ია|თე|მა|აპ|მს|ვნ|ვლ|აგ|სე|ოქ|ნო|დე)/i
}, gS = {
  any: [/^ია/i, /^თ/i, /^მარ/i, /^აპ/i, /^მაი/i, /^ი?ვნ/i, /^ი?ვლ/i, /^აგ/i, /^ს/i, /^ო/i, /^ნ/i, /^დ/i]
}, pS = {
  narrow: /^(კვ|ორ|სა|ოთ|ხუ|პა|შა)/i,
  short: /^(კვი|ორშ|სამ|ოთხ|ხუთ|პარ|შაბ)/i,
  wide: /^(კვირა|ორშაბათი|სამშაბათი|ოთხშაბათი|ხუთშაბათი|პარასკევი|შაბათი)/i
}, bS = {
  any: [/^კვ/i, /^ორ/i, /^სა/i, /^ოთ/i, /^ხუ/i, /^პა/i, /^შა/i]
}, yS = {
  any: /^([ap]\.?\s?m\.?|შუაღ|დილ)/i
}, kS = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^შუაღ/i,
    noon: /^შუადღ/i,
    morning: /^დილ/i,
    afternoon: /ნაშუადღევს/i,
    evening: /საღამო/i,
    night: /ღამ/i
  }
}, wS = {
  ordinalNumber: le({
    matchPattern: uS,
    parsePattern: fS,
    valueCallback: function(i) {
      return parseInt(i, 10);
    }
  }),
  era: P({
    matchPatterns: lS,
    defaultMatchWidth: "wide",
    parsePatterns: cS,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: mS,
    defaultMatchWidth: "wide",
    parsePatterns: vS,
    defaultParseWidth: "any",
    valueCallback: function(i) {
      return i + 1;
    }
  }),
  month: P({
    matchPatterns: hS,
    defaultMatchWidth: "any",
    parsePatterns: gS,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: pS,
    defaultMatchWidth: "wide",
    parsePatterns: bS,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: yS,
    defaultMatchWidth: "any",
    parsePatterns: kS,
    defaultParseWidth: "any"
  })
}, _S = {
  code: "ka",
  formatDistance: X9,
  formatLong: J9,
  formatRelative: eS,
  localize: dS,
  match: wS,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
};
const $S = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: _S
}, Symbol.toStringTag, { value: "Module" })), PS = /* @__PURE__ */ te($S);
var MS = {
  lessThanXSeconds: {
    regular: {
      one: "1 секундтан аз",
      singularNominative: "{{count}} секундтан аз",
      singularGenitive: "{{count}} секундтан аз",
      pluralGenitive: "{{count}} секундтан аз"
    },
    future: {
      one: "бір секундтан кейін",
      singularNominative: "{{count}} секундтан кейін",
      singularGenitive: "{{count}} секундтан кейін",
      pluralGenitive: "{{count}} секундтан кейін"
    }
  },
  xSeconds: {
    regular: {
      singularNominative: "{{count}} секунд",
      singularGenitive: "{{count}} секунд",
      pluralGenitive: "{{count}} секунд"
    },
    past: {
      singularNominative: "{{count}} секунд бұрын",
      singularGenitive: "{{count}} секунд бұрын",
      pluralGenitive: "{{count}} секунд бұрын"
    },
    future: {
      singularNominative: "{{count}} секундтан кейін",
      singularGenitive: "{{count}} секундтан кейін",
      pluralGenitive: "{{count}} секундтан кейін"
    }
  },
  halfAMinute: function(i) {
    return i != null && i.addSuffix ? i.comparison && i.comparison > 0 ? "жарты минут ішінде" : "жарты минут бұрын" : "жарты минут";
  },
  lessThanXMinutes: {
    regular: {
      one: "1 минуттан аз",
      singularNominative: "{{count}} минуттан аз",
      singularGenitive: "{{count}} минуттан аз",
      pluralGenitive: "{{count}} минуттан аз"
    },
    future: {
      one: "минуттан кем ",
      singularNominative: "{{count}} минуттан кем",
      singularGenitive: "{{count}} минуттан кем",
      pluralGenitive: "{{count}} минуттан кем"
    }
  },
  xMinutes: {
    regular: {
      singularNominative: "{{count}} минут",
      singularGenitive: "{{count}} минут",
      pluralGenitive: "{{count}} минут"
    },
    past: {
      singularNominative: "{{count}} минут бұрын",
      singularGenitive: "{{count}} минут бұрын",
      pluralGenitive: "{{count}} минут бұрын"
    },
    future: {
      singularNominative: "{{count}} минуттан кейін",
      singularGenitive: "{{count}} минуттан кейін",
      pluralGenitive: "{{count}} минуттан кейін"
    }
  },
  aboutXHours: {
    regular: {
      singularNominative: "шамамен {{count}} сағат",
      singularGenitive: "шамамен {{count}} сағат",
      pluralGenitive: "шамамен {{count}} сағат"
    },
    future: {
      singularNominative: "шамамен {{count}} сағаттан кейін",
      singularGenitive: "шамамен {{count}} сағаттан кейін",
      pluralGenitive: "шамамен {{count}} сағаттан кейін"
    }
  },
  xHours: {
    regular: {
      singularNominative: "{{count}} сағат",
      singularGenitive: "{{count}} сағат",
      pluralGenitive: "{{count}} сағат"
    }
  },
  xDays: {
    regular: {
      singularNominative: "{{count}} күн",
      singularGenitive: "{{count}} күн",
      pluralGenitive: "{{count}} күн"
    },
    future: {
      singularNominative: "{{count}} күннен кейін",
      singularGenitive: "{{count}} күннен кейін",
      pluralGenitive: "{{count}} күннен кейін"
    }
  },
  aboutXWeeks: {
    type: "weeks",
    one: "шамамен 1 апта",
    other: "шамамен {{count}} апта"
  },
  xWeeks: {
    type: "weeks",
    one: "1 апта",
    other: "{{count}} апта"
  },
  aboutXMonths: {
    regular: {
      singularNominative: "шамамен {{count}} ай",
      singularGenitive: "шамамен {{count}} ай",
      pluralGenitive: "шамамен {{count}} ай"
    },
    future: {
      singularNominative: "шамамен {{count}} айдан кейін",
      singularGenitive: "шамамен {{count}} айдан кейін",
      pluralGenitive: "шамамен {{count}} айдан кейін"
    }
  },
  xMonths: {
    regular: {
      singularNominative: "{{count}} ай",
      singularGenitive: "{{count}} ай",
      pluralGenitive: "{{count}} ай"
    }
  },
  aboutXYears: {
    regular: {
      singularNominative: "шамамен {{count}} жыл",
      singularGenitive: "шамамен {{count}} жыл",
      pluralGenitive: "шамамен {{count}} жыл"
    },
    future: {
      singularNominative: "шамамен {{count}} жылдан кейін",
      singularGenitive: "шамамен {{count}} жылдан кейін",
      pluralGenitive: "шамамен {{count}} жылдан кейін"
    }
  },
  xYears: {
    regular: {
      singularNominative: "{{count}} жыл",
      singularGenitive: "{{count}} жыл",
      pluralGenitive: "{{count}} жыл"
    },
    future: {
      singularNominative: "{{count}} жылдан кейін",
      singularGenitive: "{{count}} жылдан кейін",
      pluralGenitive: "{{count}} жылдан кейін"
    }
  },
  overXYears: {
    regular: {
      singularNominative: "{{count}} жылдан астам",
      singularGenitive: "{{count}} жылдан астам",
      pluralGenitive: "{{count}} жылдан астам"
    },
    future: {
      singularNominative: "{{count}} жылдан астам",
      singularGenitive: "{{count}} жылдан астам",
      pluralGenitive: "{{count}} жылдан астам"
    }
  },
  almostXYears: {
    regular: {
      singularNominative: "{{count}} жылға жақын",
      singularGenitive: "{{count}} жылға жақын",
      pluralGenitive: "{{count}} жылға жақын"
    },
    future: {
      singularNominative: "{{count}} жылдан кейін",
      singularGenitive: "{{count}} жылдан кейін",
      pluralGenitive: "{{count}} жылдан кейін"
    }
  }
};
function Yn(e, i) {
  if (e.one && i === 1) return e.one;
  var d = i % 10, a = i % 100;
  return d === 1 && a !== 11 ? e.singularNominative.replace("{{count}}", String(i)) : d >= 2 && d <= 4 && (a < 10 || a > 20) ? e.singularGenitive.replace("{{count}}", String(i)) : e.pluralGenitive.replace("{{count}}", String(i));
}
var jS = function(i, d, a) {
  var t = MS[i];
  return typeof t == "function" ? t(a) : t.type === "weeks" ? d === 1 ? t.one : t.other.replace("{{count}}", String(d)) : a != null && a.addSuffix ? a.comparison && a.comparison > 0 ? t.future ? Yn(t.future, d) : Yn(t.regular, d) + " кейін" : t.past ? Yn(t.past, d) : Yn(t.regular, d) + " бұрын" : Yn(t.regular, d);
}, SS = {
  full: "EEEE, do MMMM y 'ж.'",
  long: "do MMMM y 'ж.'",
  medium: "d MMM y 'ж.'",
  short: "dd.MM.yyyy"
}, zS = {
  full: "H:mm:ss zzzz",
  long: "H:mm:ss z",
  medium: "H:mm:ss",
  short: "H:mm"
}, OS = {
  any: "{{date}}, {{time}}"
}, WS = {
  date: I({
    formats: SS,
    defaultWidth: "full"
  }),
  time: I({
    formats: zS,
    defaultWidth: "full"
  }),
  dateTime: I({
    formats: OS,
    defaultWidth: "any"
  })
}, tr = ["жексенбіде", "дүйсенбіде", "сейсенбіде", "сәрсенбіде", "бейсенбіде", "жұмада", "сенбіде"];
function DS(e) {
  var i = tr[e];
  return "'өткен " + i + " сағат' p'-де'";
}
function rd(e) {
  var i = tr[e];
  return "'" + i + " сағат' p'-де'";
}
function CS(e) {
  var i = tr[e];
  return "'келесі " + i + " сағат' p'-де'";
}
var IS = {
  lastWeek: function(i, d, a) {
    var t = i.getUTCDay();
    return Ne(i, d, a) ? rd(t) : DS(t);
  },
  yesterday: "'кеше сағат' p'-де'",
  today: "'бүгін сағат' p'-де'",
  tomorrow: "'ертең сағат' p'-де'",
  nextWeek: function(i, d, a) {
    var t = i.getUTCDay();
    return Ne(i, d, a) ? rd(t) : CS(t);
  },
  other: "P"
}, TS = function(i, d, a, t) {
  var o = IS[i];
  return typeof o == "function" ? o(d, a, t) : o;
}, NS = {
  narrow: ["б.з.д.", "б.з."],
  abbreviated: ["б.з.д.", "б.з."],
  wide: ["біздің заманымызға дейін", "біздің заманымыз"]
}, xS = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1-ші тоқ.", "2-ші тоқ.", "3-ші тоқ.", "4-ші тоқ."],
  wide: ["1-ші тоқсан", "2-ші тоқсан", "3-ші тоқсан", "4-ші тоқсан"]
}, FS = {
  narrow: ["Қ", "А", "Н", "С", "М", "М", "Ш", "Т", "Қ", "Қ", "Қ", "Ж"],
  abbreviated: ["қаң", "ақп", "нау", "сәу", "мам", "мау", "шіл", "там", "қыр", "қаз", "қар", "жел"],
  wide: ["қаңтар", "ақпан", "наурыз", "сәуір", "мамыр", "маусым", "шілде", "тамыз", "қыркүйек", "қазан", "қараша", "желтоқсан"]
}, ES = {
  narrow: ["Қ", "А", "Н", "С", "М", "М", "Ш", "Т", "Қ", "Қ", "Қ", "Ж"],
  abbreviated: ["қаң", "ақп", "нау", "сәу", "мам", "мау", "шіл", "там", "қыр", "қаз", "қар", "жел"],
  wide: ["қаңтар", "ақпан", "наурыз", "сәуір", "мамыр", "маусым", "шілде", "тамыз", "қыркүйек", "қазан", "қараша", "желтоқсан"]
}, RS = {
  narrow: ["Ж", "Д", "С", "С", "Б", "Ж", "С"],
  short: ["жс", "дс", "сс", "ср", "бс", "жм", "сб"],
  abbreviated: ["жс", "дс", "сс", "ср", "бс", "жм", "сб"],
  wide: ["жексенбі", "дүйсенбі", "сейсенбі", "сәрсенбі", "бейсенбі", "жұма", "сенбі"]
}, LS = {
  narrow: {
    am: "ТД",
    pm: "ТК",
    midnight: "түн ортасы",
    noon: "түс",
    morning: "таң",
    afternoon: "күндіз",
    evening: "кеш",
    night: "түн"
  },
  wide: {
    am: "ТД",
    pm: "ТК",
    midnight: "түн ортасы",
    noon: "түс",
    morning: "таң",
    afternoon: "күндіз",
    evening: "кеш",
    night: "түн"
  }
}, qS = {
  narrow: {
    am: "ТД",
    pm: "ТК",
    midnight: "түн ортасында",
    noon: "түс",
    morning: "таң",
    afternoon: "күн",
    evening: "кеш",
    night: "түн"
  },
  wide: {
    am: "ТД",
    pm: "ТК",
    midnight: "түн ортасында",
    noon: "түсте",
    morning: "таңертең",
    afternoon: "күндіз",
    evening: "кеште",
    night: "түнде"
  }
}, zt = {
  0: "-ші",
  1: "-ші",
  2: "-ші",
  3: "-ші",
  4: "-ші",
  5: "-ші",
  6: "-шы",
  7: "-ші",
  8: "-ші",
  9: "-шы",
  10: "-шы",
  20: "-шы",
  30: "-шы",
  40: "-шы",
  50: "-ші",
  60: "-шы",
  70: "-ші",
  80: "-ші",
  90: "-шы",
  100: "-ші"
}, ZS = function(i, d) {
  var a = Number(i), t = a % 10, o = a >= 100 ? 100 : null, m = zt[a] || zt[t] || o && zt[o] || "";
  return a + m;
}, AS = {
  ordinalNumber: ZS,
  era: $({
    values: NS,
    defaultWidth: "wide"
  }),
  quarter: $({
    values: xS,
    defaultWidth: "wide",
    argumentCallback: function(i) {
      return i - 1;
    }
  }),
  month: $({
    values: FS,
    defaultWidth: "wide",
    formattingValues: ES,
    defaultFormattingWidth: "wide"
  }),
  day: $({
    values: RS,
    defaultWidth: "wide"
  }),
  dayPeriod: $({
    values: LS,
    defaultWidth: "any",
    formattingValues: qS,
    defaultFormattingWidth: "wide"
  })
}, VS = /^(\d+)(-?(ші|шы))?/i, HS = /\d+/i, US = {
  narrow: /^((б )?з\.?\s?д\.?)/i,
  abbreviated: /^((б )?з\.?\s?д\.?)/i,
  wide: /^(біздің заманымызға дейін|біздің заманымыз|біздің заманымыздан)/i
}, BS = {
  any: [/^б/i, /^з/i]
}, XS = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234](-?ші)? тоқ.?/i,
  wide: /^[1234](-?ші)? тоқсан/i
}, GS = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, KS = {
  narrow: /^(қ|а|н|с|м|мау|ш|т|қыр|қаз|қар|ж)/i,
  abbreviated: /^(қаң|ақп|нау|сәу|мам|мау|шіл|там|қыр|қаз|қар|жел)/i,
  wide: /^(қаңтар|ақпан|наурыз|сәуір|мамыр|маусым|шілде|тамыз|қыркүйек|қазан|қараша|желтоқсан)/i
}, YS = {
  narrow: [/^қ/i, /^а/i, /^н/i, /^с/i, /^м/i, /^м/i, /^ш/i, /^т/i, /^қ/i, /^қ/i, /^қ/i, /^ж/i],
  abbreviated: [/^қаң/i, /^ақп/i, /^нау/i, /^сәу/i, /^мам/i, /^мау/i, /^шіл/i, /^там/i, /^қыр/i, /^қаз/i, /^қар/i, /^жел/i],
  any: [/^қ/i, /^а/i, /^н/i, /^с/i, /^м/i, /^м/i, /^ш/i, /^т/i, /^қ/i, /^қ/i, /^қ/i, /^ж/i]
}, JS = {
  narrow: /^(ж|д|с|с|б|ж|с)/i,
  short: /^(жс|дс|сс|ср|бс|жм|сб)/i,
  wide: /^(жексенбі|дүйсенбі|сейсенбі|сәрсенбі|бейсенбі|жұма|сенбі)/i
}, QS = {
  narrow: [/^ж/i, /^д/i, /^с/i, /^с/i, /^б/i, /^ж/i, /^с/i],
  short: [/^жс/i, /^дс/i, /^сс/i, /^ср/i, /^бс/i, /^жм/i, /^сб/i],
  any: [/^ж[ек]/i, /^д[үй]/i, /^сe[й]/i, /^сә[р]/i, /^б[ей]/i, /^ж[ұм]/i, /^се[н]/i]
}, ez = {
  narrow: /^Т\.?\s?[ДК]\.?|түн ортасында|((түсте|таңертең|таңда|таңертең|таңмен|таң|күндіз|күн|кеште|кеш|түнде|түн)\.?)/i,
  wide: /^Т\.?\s?[ДК]\.?|түн ортасында|((түсте|таңертең|таңда|таңертең|таңмен|таң|күндіз|күн|кеште|кеш|түнде|түн)\.?)/i,
  any: /^Т\.?\s?[ДК]\.?|түн ортасында|((түсте|таңертең|таңда|таңертең|таңмен|таң|күндіз|күн|кеште|кеш|түнде|түн)\.?)/i
}, nz = {
  any: {
    am: /^ТД/i,
    pm: /^ТК/i,
    midnight: /^түн орта/i,
    noon: /^күндіз/i,
    morning: /таң/i,
    afternoon: /түс/i,
    evening: /кеш/i,
    night: /түн/i
  }
}, iz = {
  ordinalNumber: le({
    matchPattern: VS,
    parsePattern: HS,
    valueCallback: function(i) {
      return parseInt(i, 10);
    }
  }),
  era: P({
    matchPatterns: US,
    defaultMatchWidth: "wide",
    parsePatterns: BS,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: XS,
    defaultMatchWidth: "wide",
    parsePatterns: GS,
    defaultParseWidth: "any",
    valueCallback: function(i) {
      return i + 1;
    }
  }),
  month: P({
    matchPatterns: KS,
    defaultMatchWidth: "wide",
    parsePatterns: YS,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: JS,
    defaultMatchWidth: "wide",
    parsePatterns: QS,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: ez,
    defaultMatchWidth: "wide",
    parsePatterns: nz,
    defaultParseWidth: "any"
  })
}, az = {
  code: "kk",
  formatDistance: jS,
  formatLong: WS,
  formatRelative: TS,
  localize: AS,
  match: iz,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
};
const tz = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: az
}, Symbol.toStringTag, { value: "Module" })), rz = /* @__PURE__ */ te(tz);
var oz = {
  lessThanXSeconds: "តិចជាង {{count}} វិនាទី",
  xSeconds: "{{count}} វិនាទី",
  halfAMinute: "កន្លះនាទី",
  lessThanXMinutes: "តិចជាង {{count}} នាទី",
  xMinutes: "{{count}} នាទី",
  aboutXHours: "ប្រហែល {{count}} ម៉ោង",
  xHours: "{{count}} ម៉ោង",
  xDays: "{{count}} ថ្ងៃ",
  aboutXWeeks: "ប្រហែល {{count}} សប្តាហ៍",
  xWeeks: "{{count}} សប្តាហ៍",
  aboutXMonths: "ប្រហែល {{count}} ខែ",
  xMonths: "{{count}} ខែ",
  aboutXYears: "ប្រហែល {{count}} ឆ្នាំ",
  xYears: "{{count}} ឆ្នាំ",
  overXYears: "ជាង {{count}} ឆ្នាំ",
  almostXYears: "ជិត {{count}} ឆ្នាំ"
}, sz = function(i, d, a) {
  var t = oz[i], o = t;
  return typeof d == "number" && (o = o.replace("{{count}}", d.toString())), a != null && a.addSuffix ? a.comparison && a.comparison > 0 ? "ក្នុងរយៈពេល " + o : o + "មុន" : o;
}, dz = {
  full: "EEEE do MMMM y",
  long: "do MMMM y",
  medium: "d MMM y",
  short: "dd/MM/yyyy"
}, uz = {
  full: "h:mm:ss a",
  long: "h:mm:ss a",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, fz = {
  full: "{{date}} 'ម៉ោង' {{time}}",
  long: "{{date}} 'ម៉ោង' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, lz = {
  date: I({
    formats: dz,
    defaultWidth: "full"
  }),
  time: I({
    formats: uz,
    defaultWidth: "full"
  }),
  dateTime: I({
    formats: fz,
    defaultWidth: "full"
  })
}, cz = {
  lastWeek: "'ថ្ងៃ'eeee'ស​ប្តា​ហ៍​មុនម៉ោង' p",
  yesterday: "'ម្សិលមិញនៅម៉ោង' p",
  today: "'ថ្ងៃនេះម៉ោង' p",
  tomorrow: "'ថ្ងៃស្អែកម៉ោង' p",
  nextWeek: "'ថ្ងៃ'eeee'ស​ប្តា​ហ៍​ក្រោយម៉ោង' p",
  other: "P"
}, mz = function(i, d, a, t) {
  return cz[i];
}, vz = {
  narrow: ["ម.គស", "គស"],
  abbreviated: ["មុនគ.ស", "គ.ស"],
  wide: ["មុនគ្រិស្តសករាជ", "នៃគ្រិស្តសករាជ"]
}, hz = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["ត្រីមាសទី 1", "ត្រីមាសទី 2", "ត្រីមាសទី 3", "ត្រីមាសទី 4"]
}, gz = {
  narrow: ["ម.ក", "ក.ម", "មិ", "ម.ស", "ឧ.ស", "ម.ថ", "ក.ដ", "សី", "កញ", "តុ", "វិ", "ធ"],
  abbreviated: ["មករា", "កុម្ភៈ", "មីនា", "មេសា", "ឧសភា", "មិថុនា", "កក្កដា", "សីហា", "កញ្ញា", "តុលា", "វិច្ឆិកា", "ធ្នូ"],
  wide: ["មករា", "កុម្ភៈ", "មីនា", "មេសា", "ឧសភា", "មិថុនា", "កក្កដា", "សីហា", "កញ្ញា", "តុលា", "វិច្ឆិកា", "ធ្នូ"]
}, pz = {
  narrow: ["អា", "ច", "អ", "ព", "ព្រ", "សុ", "ស"],
  short: ["អា", "ច", "អ", "ព", "ព្រ", "សុ", "ស"],
  abbreviated: ["អា", "ច", "អ", "ព", "ព្រ", "សុ", "ស"],
  wide: ["អាទិត្យ", "ចន្ទ", "អង្គារ", "ពុធ", "ព្រហស្បតិ៍", "សុក្រ", "សៅរ៍"]
}, bz = {
  narrow: {
    am: "ព្រឹក",
    pm: "ល្ងាច",
    midnight: "​ពេលកណ្ដាលអធ្រាត្រ",
    noon: "ពេលថ្ងៃត្រង់",
    morning: "ពេលព្រឹក",
    afternoon: "ពេលរសៀល",
    evening: "ពេលល្ងាច",
    night: "ពេលយប់"
  },
  abbreviated: {
    am: "ព្រឹក",
    pm: "ល្ងាច",
    midnight: "​ពេលកណ្ដាលអធ្រាត្រ",
    noon: "ពេលថ្ងៃត្រង់",
    morning: "ពេលព្រឹក",
    afternoon: "ពេលរសៀល",
    evening: "ពេលល្ងាច",
    night: "ពេលយប់"
  },
  wide: {
    am: "ព្រឹក",
    pm: "ល្ងាច",
    midnight: "​ពេលកណ្ដាលអធ្រាត្រ",
    noon: "ពេលថ្ងៃត្រង់",
    morning: "ពេលព្រឹក",
    afternoon: "ពេលរសៀល",
    evening: "ពេលល្ងាច",
    night: "ពេលយប់"
  }
}, yz = {
  narrow: {
    am: "ព្រឹក",
    pm: "ល្ងាច",
    midnight: "​ពេលកណ្ដាលអធ្រាត្រ",
    noon: "ពេលថ្ងៃត្រង់",
    morning: "ពេលព្រឹក",
    afternoon: "ពេលរសៀល",
    evening: "ពេលល្ងាច",
    night: "ពេលយប់"
  },
  abbreviated: {
    am: "ព្រឹក",
    pm: "ល្ងាច",
    midnight: "​ពេលកណ្ដាលអធ្រាត្រ",
    noon: "ពេលថ្ងៃត្រង់",
    morning: "ពេលព្រឹក",
    afternoon: "ពេលរសៀល",
    evening: "ពេលល្ងាច",
    night: "ពេលយប់"
  },
  wide: {
    am: "ព្រឹក",
    pm: "ល្ងាច",
    midnight: "​ពេលកណ្ដាលអធ្រាត្រ",
    noon: "ពេលថ្ងៃត្រង់",
    morning: "ពេលព្រឹក",
    afternoon: "ពេលរសៀល",
    evening: "ពេលល្ងាច",
    night: "ពេលយប់"
  }
}, kz = function(i, d) {
  var a = Number(i);
  return a.toString();
}, wz = {
  ordinalNumber: kz,
  era: $({
    values: vz,
    defaultWidth: "wide"
  }),
  quarter: $({
    values: hz,
    defaultWidth: "wide",
    argumentCallback: function(i) {
      return i - 1;
    }
  }),
  month: $({
    values: gz,
    defaultWidth: "wide"
  }),
  day: $({
    values: pz,
    defaultWidth: "wide"
  }),
  dayPeriod: $({
    values: bz,
    defaultWidth: "wide",
    formattingValues: yz,
    defaultFormattingWidth: "wide"
  })
}, _z = /^(\d+)(th|st|nd|rd)?/i, $z = /\d+/i, Pz = {
  narrow: /^(ម\.)?គស/i,
  abbreviated: /^(មុន)?គ\.ស/i,
  wide: /^(មុន|នៃ)គ្រិស្តសករាជ/i
}, Mz = {
  any: [/^(ម|មុន)គ\.?ស/i, /^(នៃ)?គ\.?ស/i]
}, jz = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^(ត្រីមាស)(ទី)?\s?[1234]/i
}, Sz = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, zz = {
  narrow: /^(ម\.ក|ក\.ម|មិ|ម\.ស|ឧ\.ស|ម\.ថ|ក\.ដ|សី|កញ|តុ|វិ|ធ)/i,
  abbreviated: /^(មករា|កុម្ភៈ|មីនា|មេសា|ឧសភា|មិថុនា|កក្កដា|សីហា|កញ្ញា|តុលា|វិច្ឆិកា|ធ្នូ)/i,
  wide: /^(មករា|កុម្ភៈ|មីនា|មេសា|ឧសភា|មិថុនា|កក្កដា|សីហា|កញ្ញា|តុលា|វិច្ឆិកា|ធ្នូ)/i
}, Oz = {
  narrow: [/^ម\.ក/i, /^ក\.ម/i, /^មិ/i, /^ម\.ស/i, /^ឧ\.ស/i, /^ម\.ថ/i, /^ក\.ដ/i, /^សី/i, /^កញ/i, /^តុ/i, /^វិ/i, /^ធ/i],
  any: [/^មក/i, /^កុ/i, /^មីន/i, /^មេ/i, /^ឧស/i, /^មិថ/i, /^កក/i, /^សី/i, /^កញ/i, /^តុ/i, /^វិច/i, /^ធ/i]
}, Wz = {
  narrow: /^(អា|ច|អ|ព|ព្រ|សុ|ស)/i,
  short: /^(អា|ច|អ|ព|ព្រ|សុ|ស)/i,
  abbreviated: /^(អា|ច|អ|ព|ព្រ|សុ|ស)/i,
  wide: /^(អាទិត្យ|ចន្ទ|អង្គារ|ពុធ|ព្រហស្បតិ៍|សុក្រ|សៅរ៍)/i
}, Dz = {
  narrow: [/^អា/i, /^ច/i, /^អ/i, /^ព/i, /^ព្រ/i, /^សុ/i, /^ស/i],
  any: [/^អា/i, /^ច/i, /^អ/i, /^ព/i, /^ព្រ/i, /^សុ/i, /^សៅ/i]
}, Cz = {
  narrow: /^(ព្រឹក|ល្ងាច|ពេលព្រឹក|ពេលថ្ងៃត្រង់|ពេលល្ងាច|ពេលរសៀល|ពេលយប់|ពេលកណ្ដាលអធ្រាត្រ)/i,
  any: /^(ព្រឹក|ល្ងាច|ពេលព្រឹក|ពេលថ្ងៃត្រង់|ពេលល្ងាច|ពេលរសៀល|ពេលយប់|ពេលកណ្ដាលអធ្រាត្រ)/i
}, Iz = {
  any: {
    am: /^ព្រឹក/i,
    pm: /^ល្ងាច/i,
    midnight: /^ពេលកណ្ដាលអធ្រាត្រ/i,
    noon: /^ពេលថ្ងៃត្រង់/i,
    morning: /ពេលព្រឹក/i,
    afternoon: /ពេលរសៀល/i,
    evening: /ពេលល្ងាច/i,
    night: /ពេលយប់/i
  }
}, Tz = {
  ordinalNumber: le({
    matchPattern: _z,
    parsePattern: $z,
    valueCallback: function(i) {
      return parseInt(i, 10);
    }
  }),
  era: P({
    matchPatterns: Pz,
    defaultMatchWidth: "wide",
    parsePatterns: Mz,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: jz,
    defaultMatchWidth: "wide",
    parsePatterns: Sz,
    defaultParseWidth: "any",
    valueCallback: function(i) {
      return i + 1;
    }
  }),
  month: P({
    matchPatterns: zz,
    defaultMatchWidth: "wide",
    parsePatterns: Oz,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: Wz,
    defaultMatchWidth: "wide",
    parsePatterns: Dz,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: Cz,
    defaultMatchWidth: "any",
    parsePatterns: Iz,
    defaultParseWidth: "any"
  })
}, Nz = {
  code: "km",
  formatDistance: sz,
  formatLong: lz,
  formatRelative: mz,
  localize: wz,
  match: Tz,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
const xz = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Nz
}, Symbol.toStringTag, { value: "Module" })), Fz = /* @__PURE__ */ te(xz);
var Ez = {
  lessThanXSeconds: {
    one: {
      default: "1 ಸೆಕೆಂಡ್‌ಗಿಂತ ಕಡಿಮೆ",
      future: "1 ಸೆಕೆಂಡ್‌ಗಿಂತ ಕಡಿಮೆ",
      past: "1 ಸೆಕೆಂಡ್‌ಗಿಂತ ಕಡಿಮೆ"
    },
    other: {
      default: "{{count}} ಸೆಕೆಂಡ್‌ಗಿಂತ ಕಡಿಮೆ",
      future: "{{count}} ಸೆಕೆಂಡ್‌ಗಿಂತ ಕಡಿಮೆ",
      past: "{{count}} ಸೆಕೆಂಡ್‌ಗಿಂತ ಕಡಿಮೆ"
    }
  },
  xSeconds: {
    one: {
      default: "1 ಸೆಕೆಂಡ್",
      future: "1 ಸೆಕೆಂಡ್‌ನಲ್ಲಿ",
      past: "1 ಸೆಕೆಂಡ್ ಹಿಂದೆ"
    },
    other: {
      default: "{{count}} ಸೆಕೆಂಡುಗಳು",
      future: "{{count}} ಸೆಕೆಂಡ್‌ಗಳಲ್ಲಿ",
      past: "{{count}} ಸೆಕೆಂಡ್ ಹಿಂದೆ"
    }
  },
  halfAMinute: {
    other: {
      default: "ಅರ್ಧ ನಿಮಿಷ",
      future: "ಅರ್ಧ ನಿಮಿಷದಲ್ಲಿ",
      past: "ಅರ್ಧ ನಿಮಿಷದ ಹಿಂದೆ"
    }
  },
  lessThanXMinutes: {
    one: {
      default: "1 ನಿಮಿಷಕ್ಕಿಂತ ಕಡಿಮೆ",
      future: "1 ನಿಮಿಷಕ್ಕಿಂತ ಕಡಿಮೆ",
      past: "1 ನಿಮಿಷಕ್ಕಿಂತ ಕಡಿಮೆ"
    },
    other: {
      default: "{{count}} ನಿಮಿಷಕ್ಕಿಂತ ಕಡಿಮೆ",
      future: "{{count}} ನಿಮಿಷಕ್ಕಿಂತ ಕಡಿಮೆ",
      past: "{{count}} ನಿಮಿಷಕ್ಕಿಂತ ಕಡಿಮೆ"
    }
  },
  xMinutes: {
    one: {
      default: "1 ನಿಮಿಷ",
      future: "1 ನಿಮಿಷದಲ್ಲಿ",
      past: "1 ನಿಮಿಷದ ಹಿಂದೆ"
    },
    other: {
      default: "{{count}} ನಿಮಿಷಗಳು",
      future: "{{count}} ನಿಮಿಷಗಳಲ್ಲಿ",
      past: "{{count}} ನಿಮಿಷಗಳ ಹಿಂದೆ"
    }
  },
  aboutXHours: {
    one: {
      default: "ಸುಮಾರು 1 ಗಂಟೆ",
      future: "ಸುಮಾರು 1 ಗಂಟೆಯಲ್ಲಿ",
      past: "ಸುಮಾರು 1 ಗಂಟೆ ಹಿಂದೆ"
    },
    other: {
      default: "ಸುಮಾರು {{count}} ಗಂಟೆಗಳು",
      future: "ಸುಮಾರು {{count}} ಗಂಟೆಗಳಲ್ಲಿ",
      past: "ಸುಮಾರು {{count}} ಗಂಟೆಗಳ ಹಿಂದೆ"
    }
  },
  xHours: {
    one: {
      default: "1 ಗಂಟೆ",
      future: "1 ಗಂಟೆಯಲ್ಲಿ",
      past: "1 ಗಂಟೆ ಹಿಂದೆ"
    },
    other: {
      default: "{{count}} ಗಂಟೆಗಳು",
      future: "{{count}} ಗಂಟೆಗಳಲ್ಲಿ",
      past: "{{count}} ಗಂಟೆಗಳ ಹಿಂದೆ"
    }
  },
  xDays: {
    one: {
      default: "1 ದಿನ",
      future: "1 ದಿನದಲ್ಲಿ",
      past: "1 ದಿನದ ಹಿಂದೆ"
    },
    other: {
      default: "{{count}} ದಿನಗಳು",
      future: "{{count}} ದಿನಗಳಲ್ಲಿ",
      past: "{{count}} ದಿನಗಳ ಹಿಂದೆ"
    }
  },
  // TODO
  // aboutXWeeks: {},
  // TODO
  // xWeeks: {},
  aboutXMonths: {
    one: {
      default: "ಸುಮಾರು 1 ತಿಂಗಳು",
      future: "ಸುಮಾರು 1 ತಿಂಗಳಲ್ಲಿ",
      past: "ಸುಮಾರು 1 ತಿಂಗಳ ಹಿಂದೆ"
    },
    other: {
      default: "ಸುಮಾರು {{count}} ತಿಂಗಳು",
      future: "ಸುಮಾರು {{count}} ತಿಂಗಳುಗಳಲ್ಲಿ",
      past: "ಸುಮಾರು {{count}} ತಿಂಗಳುಗಳ ಹಿಂದೆ"
    }
  },
  xMonths: {
    one: {
      default: "1 ತಿಂಗಳು",
      future: "1 ತಿಂಗಳಲ್ಲಿ",
      past: "1 ತಿಂಗಳ ಹಿಂದೆ"
    },
    other: {
      default: "{{count}} ತಿಂಗಳು",
      future: "{{count}} ತಿಂಗಳುಗಳಲ್ಲಿ",
      past: "{{count}} ತಿಂಗಳುಗಳ ಹಿಂದೆ"
    }
  },
  aboutXYears: {
    one: {
      default: "ಸುಮಾರು 1 ವರ್ಷ",
      future: "ಸುಮಾರು 1 ವರ್ಷದಲ್ಲಿ",
      past: "ಸುಮಾರು 1 ವರ್ಷದ ಹಿಂದೆ"
    },
    other: {
      default: "ಸುಮಾರು {{count}} ವರ್ಷಗಳು",
      future: "ಸುಮಾರು {{count}} ವರ್ಷಗಳಲ್ಲಿ",
      past: "ಸುಮಾರು {{count}} ವರ್ಷಗಳ ಹಿಂದೆ"
    }
  },
  xYears: {
    one: {
      default: "1 ವರ್ಷ",
      future: "1 ವರ್ಷದಲ್ಲಿ",
      past: "1 ವರ್ಷದ ಹಿಂದೆ"
    },
    other: {
      default: "{{count}} ವರ್ಷಗಳು",
      future: "{{count}} ವರ್ಷಗಳಲ್ಲಿ",
      past: "{{count}} ವರ್ಷಗಳ ಹಿಂದೆ"
    }
  },
  overXYears: {
    one: {
      default: "1 ವರ್ಷದ ಮೇಲೆ",
      future: "1 ವರ್ಷದ ಮೇಲೆ",
      past: "1 ವರ್ಷದ ಮೇಲೆ"
    },
    other: {
      default: "{{count}} ವರ್ಷಗಳ ಮೇಲೆ",
      future: "{{count}} ವರ್ಷಗಳ ಮೇಲೆ",
      past: "{{count}} ವರ್ಷಗಳ ಮೇಲೆ"
    }
  },
  almostXYears: {
    one: {
      default: "ಬಹುತೇಕ 1 ವರ್ಷದಲ್ಲಿ",
      future: "ಬಹುತೇಕ 1 ವರ್ಷದಲ್ಲಿ",
      past: "ಬಹುತೇಕ 1 ವರ್ಷದಲ್ಲಿ"
    },
    other: {
      default: "ಬಹುತೇಕ {{count}} ವರ್ಷಗಳಲ್ಲಿ",
      future: "ಬಹುತೇಕ {{count}} ವರ್ಷಗಳಲ್ಲಿ",
      past: "ಬಹುತೇಕ {{count}} ವರ್ಷಗಳಲ್ಲಿ"
    }
  }
};
function od(e, i) {
  return i != null && i.addSuffix ? i.comparison && i.comparison > 0 ? e.future : e.past : e.default;
}
var Rz = function(i, d, a) {
  var t, o = Ez[i];
  return o.one && d === 1 ? t = od(o.one, a) : t = od(o.other, a), t.replace("{{count}}", String(d));
}, Lz = {
  full: "EEEE, MMMM d, y",
  // CLDR 1816
  long: "MMMM d, y",
  // CLDR 1817
  medium: "MMM d, y",
  // CLDR 1818
  short: "d/M/yy"
  // CLDR 1819
}, qz = {
  full: "hh:mm:ss a zzzz",
  // CLDR 1820
  long: "hh:mm:ss a z",
  // CLDR 1821
  medium: "hh:mm:ss a",
  // CLDR 1822
  short: "hh:mm a"
  // CLDR 1823
}, Zz = {
  full: "{{date}} {{time}}",
  // CLDR 1824
  long: "{{date}} {{time}}",
  // CLDR 1825
  medium: "{{date}} {{time}}",
  // CLDR 1826
  short: "{{date}} {{time}}"
  // CLDR 1827
}, Az = {
  date: I({
    formats: Lz,
    defaultWidth: "full"
  }),
  time: I({
    formats: qz,
    defaultWidth: "full"
  }),
  dateTime: I({
    formats: Zz,
    defaultWidth: "full"
  })
}, Vz = {
  lastWeek: "'ಕಳೆದ' eeee p 'ಕ್ಕೆ'",
  yesterday: "'ನಿನ್ನೆ' p 'ಕ್ಕೆ'",
  today: "'ಇಂದು' p 'ಕ್ಕೆ'",
  tomorrow: "'ನಾಳೆ' p 'ಕ್ಕೆ'",
  nextWeek: "eeee p 'ಕ್ಕೆ'",
  other: "P"
}, Hz = function(i, d, a, t) {
  return Vz[i];
}, Uz = {
  narrow: ["ಕ್ರಿ.ಪೂ", "ಕ್ರಿ.ಶ"],
  abbreviated: ["ಕ್ರಿ.ಪೂ", "ಕ್ರಿ.ಶ"],
  // CLDR #1618, #1620
  wide: ["ಕ್ರಿಸ್ತ ಪೂರ್ವ", "ಕ್ರಿಸ್ತ ಶಕ"]
  // CLDR #1614, #1616
}, Bz = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["ತ್ರೈ 1", "ತ್ರೈ 2", "ತ್ರೈ 3", "ತ್ರೈ 4"],
  // CLDR #1630 - #1638
  wide: ["1ನೇ ತ್ರೈಮಾಸಿಕ", "2ನೇ ತ್ರೈಮಾಸಿಕ", "3ನೇ ತ್ರೈಮಾಸಿಕ", "4ನೇ ತ್ರೈಮಾಸಿಕ"]
  // CLDR #1622 - #1629
}, Xz = {
  narrow: ["ಜ", "ಫೆ", "ಮಾ", "ಏ", "ಮೇ", "ಜೂ", "ಜು", "ಆ", "ಸೆ", "ಅ", "ನ", "ಡಿ"],
  abbreviated: ["ಜನ", "ಫೆಬ್ರ", "ಮಾರ್ಚ್", "ಏಪ್ರಿ", "ಮೇ", "ಜೂನ್", "ಜುಲೈ", "ಆಗ", "ಸೆಪ್ಟೆಂ", "ಅಕ್ಟೋ", "ನವೆಂ", "ಡಿಸೆಂ"],
  wide: ["ಜನವರಿ", "ಫೆಬ್ರವರಿ", "ಮಾರ್ಚ್", "ಏಪ್ರಿಲ್", "ಮೇ", "ಜೂನ್", "ಜುಲೈ", "ಆಗಸ್ಟ್", "ಸೆಪ್ಟೆಂಬರ್", "ಅಕ್ಟೋಬರ್", "ನವೆಂಬರ್", "ಡಿಸೆಂಬರ್"]
}, Gz = {
  narrow: ["ಭಾ", "ಸೋ", "ಮಂ", "ಬು", "ಗು", "ಶು", "ಶ"],
  short: ["ಭಾನು", "ಸೋಮ", "ಮಂಗಳ", "ಬುಧ", "ಗುರು", "ಶುಕ್ರ", "ಶನಿ"],
  abbreviated: ["ಭಾನು", "ಸೋಮ", "ಮಂಗಳ", "ಬುಧ", "ಗುರು", "ಶುಕ್ರ", "ಶನಿ"],
  wide: ["ಭಾನುವಾರ", "ಸೋಮವಾರ", "ಮಂಗಳವಾರ", "ಬುಧವಾರ", "ಗುರುವಾರ", "ಶುಕ್ರವಾರ", "ಶನಿವಾರ"]
}, Kz = {
  narrow: {
    am: "ಪೂರ್ವಾಹ್ನ",
    pm: "ಅಪರಾಹ್ನ",
    midnight: "ಮಧ್ಯರಾತ್ರಿ",
    noon: "ಮಧ್ಯಾಹ್ನ",
    morning: "ಬೆಳಗ್ಗೆ",
    afternoon: "ಮಧ್ಯಾಹ್ನ",
    evening: "ಸಂಜೆ",
    night: "ರಾತ್ರಿ"
  },
  abbreviated: {
    am: "ಪೂರ್ವಾಹ್ನ",
    pm: "ಅಪರಾಹ್ನ",
    midnight: "ಮಧ್ಯರಾತ್ರಿ",
    noon: "ಮಧ್ಯಾನ್ಹ",
    morning: "ಬೆಳಗ್ಗೆ",
    afternoon: "ಮಧ್ಯಾನ್ಹ",
    evening: "ಸಂಜೆ",
    night: "ರಾತ್ರಿ"
  },
  wide: {
    am: "ಪೂರ್ವಾಹ್ನ",
    pm: "ಅಪರಾಹ್ನ",
    midnight: "ಮಧ್ಯರಾತ್ರಿ",
    noon: "ಮಧ್ಯಾನ್ಹ",
    morning: "ಬೆಳಗ್ಗೆ",
    afternoon: "ಮಧ್ಯಾನ್ಹ",
    evening: "ಸಂಜೆ",
    night: "ರಾತ್ರಿ"
  }
}, Yz = {
  narrow: {
    am: "ಪೂ",
    pm: "ಅ",
    midnight: "ಮಧ್ಯರಾತ್ರಿ",
    noon: "ಮಧ್ಯಾನ್ಹ",
    morning: "ಬೆಳಗ್ಗೆ",
    afternoon: "ಮಧ್ಯಾನ್ಹ",
    evening: "ಸಂಜೆ",
    night: "ರಾತ್ರಿ"
  },
  abbreviated: {
    am: "ಪೂರ್ವಾಹ್ನ",
    pm: "ಅಪರಾಹ್ನ",
    midnight: "ಮಧ್ಯ ರಾತ್ರಿ",
    noon: "ಮಧ್ಯಾನ್ಹ",
    morning: "ಬೆಳಗ್ಗೆ",
    afternoon: "ಮಧ್ಯಾನ್ಹ",
    evening: "ಸಂಜೆ",
    night: "ರಾತ್ರಿ"
  },
  wide: {
    am: "ಪೂರ್ವಾಹ್ನ",
    pm: "ಅಪರಾಹ್ನ",
    midnight: "ಮಧ್ಯ ರಾತ್ರಿ",
    noon: "ಮಧ್ಯಾನ್ಹ",
    morning: "ಬೆಳಗ್ಗೆ",
    afternoon: "ಮಧ್ಯಾನ್ಹ",
    evening: "ಸಂಜೆ",
    night: "ರಾತ್ರಿ"
  }
}, Jz = function(i, d) {
  var a = Number(i);
  return a + "ನೇ";
}, Qz = {
  ordinalNumber: Jz,
  era: $({
    values: Uz,
    defaultWidth: "wide"
  }),
  quarter: $({
    values: Bz,
    defaultWidth: "wide",
    argumentCallback: function(i) {
      return i - 1;
    }
  }),
  month: $({
    values: Xz,
    defaultWidth: "wide"
  }),
  day: $({
    values: Gz,
    defaultWidth: "wide"
  }),
  dayPeriod: $({
    values: Kz,
    defaultWidth: "wide",
    formattingValues: Yz,
    defaultFormattingWidth: "wide"
  })
}, eO = /^(\d+)(ನೇ|ನೆ)?/i, nO = /\d+/i, iO = {
  narrow: /^(ಕ್ರಿ.ಪೂ|ಕ್ರಿ.ಶ)/i,
  abbreviated: /^(ಕ್ರಿ\.?\s?ಪೂ\.?|ಕ್ರಿ\.?\s?ಶ\.?|ಪ್ರ\.?\s?ಶ\.?)/i,
  wide: /^(ಕ್ರಿಸ್ತ ಪೂರ್ವ|ಕ್ರಿಸ್ತ ಶಕ|ಪ್ರಸಕ್ತ ಶಕ)/i
}, aO = {
  any: [/^ಪೂ/i, /^(ಶ|ಪ್ರ)/i]
}, tO = {
  narrow: /^[1234]/i,
  abbreviated: /^ತ್ರೈ[1234]|ತ್ರೈ [1234]| [1234]ತ್ರೈ/i,
  wide: /^[1234](ನೇ)? ತ್ರೈಮಾಸಿಕ/i
}, rO = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, oO = {
  narrow: /^(ಜೂ|ಜು|ಜ|ಫೆ|ಮಾ|ಏ|ಮೇ|ಆ|ಸೆ|ಅ|ನ|ಡಿ)/i,
  abbreviated: /^(ಜನ|ಫೆಬ್ರ|ಮಾರ್ಚ್|ಏಪ್ರಿ|ಮೇ|ಜೂನ್|ಜುಲೈ|ಆಗ|ಸೆಪ್ಟೆಂ|ಅಕ್ಟೋ|ನವೆಂ|ಡಿಸೆಂ)/i,
  wide: /^(ಜನವರಿ|ಫೆಬ್ರವರಿ|ಮಾರ್ಚ್|ಏಪ್ರಿಲ್|ಮೇ|ಜೂನ್|ಜುಲೈ|ಆಗಸ್ಟ್|ಸೆಪ್ಟೆಂಬರ್|ಅಕ್ಟೋಬರ್|ನವೆಂಬರ್|ಡಿಸೆಂಬರ್)/i
}, sO = {
  narrow: [/^ಜ$/i, /^ಫೆ/i, /^ಮಾ/i, /^ಏ/i, /^ಮೇ/i, /^ಜೂ/i, /^ಜು$/i, /^ಆ/i, /^ಸೆ/i, /^ಅ/i, /^ನ/i, /^ಡಿ/i],
  any: [/^ಜನ/i, /^ಫೆ/i, /^ಮಾ/i, /^ಏ/i, /^ಮೇ/i, /^ಜೂನ್/i, /^ಜುಲೈ/i, /^ಆ/i, /^ಸೆ/i, /^ಅ/i, /^ನ/i, /^ಡಿ/i]
}, dO = {
  narrow: /^(ಭಾ|ಸೋ|ಮ|ಬು|ಗು|ಶು|ಶ)/i,
  short: /^(ಭಾನು|ಸೋಮ|ಮಂಗಳ|ಬುಧ|ಗುರು|ಶುಕ್ರ|ಶನಿ)/i,
  abbreviated: /^(ಭಾನು|ಸೋಮ|ಮಂಗಳ|ಬುಧ|ಗುರು|ಶುಕ್ರ|ಶನಿ)/i,
  wide: /^(ಭಾನುವಾರ|ಸೋಮವಾರ|ಮಂಗಳವಾರ|ಬುಧವಾರ|ಗುರುವಾರ|ಶುಕ್ರವಾರ|ಶನಿವಾರ)/i
}, uO = {
  narrow: [/^ಭಾ/i, /^ಸೋ/i, /^ಮ/i, /^ಬು/i, /^ಗು/i, /^ಶು/i, /^ಶ/i],
  any: [/^ಭಾ/i, /^ಸೋ/i, /^ಮ/i, /^ಬು/i, /^ಗು/i, /^ಶು/i, /^ಶ/i]
}, fO = {
  narrow: /^(ಪೂ|ಅ|ಮಧ್ಯರಾತ್ರಿ|ಮಧ್ಯಾನ್ಹ|ಬೆಳಗ್ಗೆ|ಸಂಜೆ|ರಾತ್ರಿ)/i,
  any: /^(ಪೂರ್ವಾಹ್ನ|ಅಪರಾಹ್ನ|ಮಧ್ಯರಾತ್ರಿ|ಮಧ್ಯಾನ್ಹ|ಬೆಳಗ್ಗೆ|ಸಂಜೆ|ರಾತ್ರಿ)/i
}, lO = {
  any: {
    am: /^ಪೂ/i,
    pm: /^ಅ/i,
    midnight: /ಮಧ್ಯರಾತ್ರಿ/i,
    noon: /ಮಧ್ಯಾನ್ಹ/i,
    morning: /ಬೆಳಗ್ಗೆ/i,
    afternoon: /ಮಧ್ಯಾನ್ಹ/i,
    evening: /ಸಂಜೆ/i,
    night: /ರಾತ್ರಿ/i
  }
}, cO = {
  ordinalNumber: le({
    matchPattern: eO,
    parsePattern: nO,
    valueCallback: function(i) {
      return parseInt(i, 10);
    }
  }),
  era: P({
    matchPatterns: iO,
    defaultMatchWidth: "wide",
    parsePatterns: aO,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: tO,
    defaultMatchWidth: "wide",
    parsePatterns: rO,
    defaultParseWidth: "any",
    valueCallback: function(i) {
      return i + 1;
    }
  }),
  month: P({
    matchPatterns: oO,
    defaultMatchWidth: "wide",
    parsePatterns: sO,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: dO,
    defaultMatchWidth: "wide",
    parsePatterns: uO,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: fO,
    defaultMatchWidth: "any",
    parsePatterns: lO,
    defaultParseWidth: "any"
  })
}, mO = {
  code: "kn",
  formatDistance: Rz,
  formatLong: Az,
  formatRelative: Hz,
  localize: Qz,
  match: cO,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
};
const vO = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: mO
}, Symbol.toStringTag, { value: "Module" })), hO = /* @__PURE__ */ te(vO);
var gO = {
  lessThanXSeconds: {
    one: "1초 미만",
    other: "{{count}}초 미만"
  },
  xSeconds: {
    one: "1초",
    other: "{{count}}초"
  },
  halfAMinute: "30초",
  lessThanXMinutes: {
    one: "1분 미만",
    other: "{{count}}분 미만"
  },
  xMinutes: {
    one: "1분",
    other: "{{count}}분"
  },
  aboutXHours: {
    one: "약 1시간",
    other: "약 {{count}}시간"
  },
  xHours: {
    one: "1시간",
    other: "{{count}}시간"
  },
  xDays: {
    one: "1일",
    other: "{{count}}일"
  },
  aboutXWeeks: {
    one: "약 1주",
    other: "약 {{count}}주"
  },
  xWeeks: {
    one: "1주",
    other: "{{count}}주"
  },
  aboutXMonths: {
    one: "약 1개월",
    other: "약 {{count}}개월"
  },
  xMonths: {
    one: "1개월",
    other: "{{count}}개월"
  },
  aboutXYears: {
    one: "약 1년",
    other: "약 {{count}}년"
  },
  xYears: {
    one: "1년",
    other: "{{count}}년"
  },
  overXYears: {
    one: "1년 이상",
    other: "{{count}}년 이상"
  },
  almostXYears: {
    one: "거의 1년",
    other: "거의 {{count}}년"
  }
}, pO = function(i, d, a) {
  var t, o = gO[i];
  return typeof o == "string" ? t = o : d === 1 ? t = o.one : t = o.other.replace("{{count}}", d.toString()), a != null && a.addSuffix ? a.comparison && a.comparison > 0 ? t + " 후" : t + " 전" : t;
}, bO = {
  full: "y년 M월 d일 EEEE",
  long: "y년 M월 d일",
  medium: "y.MM.dd",
  short: "y.MM.dd"
}, yO = {
  full: "a H시 mm분 ss초 zzzz",
  long: "a H:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, kO = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, wO = {
  date: I({
    formats: bO,
    defaultWidth: "full"
  }),
  time: I({
    formats: yO,
    defaultWidth: "full"
  }),
  dateTime: I({
    formats: kO,
    defaultWidth: "full"
  })
}, _O = {
  lastWeek: "'지난' eeee p",
  yesterday: "'어제' p",
  today: "'오늘' p",
  tomorrow: "'내일' p",
  nextWeek: "'다음' eeee p",
  other: "P"
}, $O = function(i, d, a, t) {
  return _O[i];
}, PO = {
  narrow: ["BC", "AD"],
  abbreviated: ["BC", "AD"],
  wide: ["기원전", "서기"]
}, MO = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1분기", "2분기", "3분기", "4분기"]
}, jO = {
  narrow: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"],
  abbreviated: ["1월", "2월", "3월", "4월", "5월", "6월", "7월", "8월", "9월", "10월", "11월", "12월"],
  wide: ["1월", "2월", "3월", "4월", "5월", "6월", "7월", "8월", "9월", "10월", "11월", "12월"]
}, SO = {
  narrow: ["일", "월", "화", "수", "목", "금", "토"],
  short: ["일", "월", "화", "수", "목", "금", "토"],
  abbreviated: ["일", "월", "화", "수", "목", "금", "토"],
  wide: ["일요일", "월요일", "화요일", "수요일", "목요일", "금요일", "토요일"]
}, zO = {
  narrow: {
    am: "오전",
    pm: "오후",
    midnight: "자정",
    noon: "정오",
    morning: "아침",
    afternoon: "오후",
    evening: "저녁",
    night: "밤"
  },
  abbreviated: {
    am: "오전",
    pm: "오후",
    midnight: "자정",
    noon: "정오",
    morning: "아침",
    afternoon: "오후",
    evening: "저녁",
    night: "밤"
  },
  wide: {
    am: "오전",
    pm: "오후",
    midnight: "자정",
    noon: "정오",
    morning: "아침",
    afternoon: "오후",
    evening: "저녁",
    night: "밤"
  }
}, OO = {
  narrow: {
    am: "오전",
    pm: "오후",
    midnight: "자정",
    noon: "정오",
    morning: "아침",
    afternoon: "오후",
    evening: "저녁",
    night: "밤"
  },
  abbreviated: {
    am: "오전",
    pm: "오후",
    midnight: "자정",
    noon: "정오",
    morning: "아침",
    afternoon: "오후",
    evening: "저녁",
    night: "밤"
  },
  wide: {
    am: "오전",
    pm: "오후",
    midnight: "자정",
    noon: "정오",
    morning: "아침",
    afternoon: "오후",
    evening: "저녁",
    night: "밤"
  }
}, WO = function(i, d) {
  var a = Number(i), t = String(d == null ? void 0 : d.unit);
  switch (t) {
    case "minute":
    case "second":
      return String(a);
    case "date":
      return a + "일";
    default:
      return a + "번째";
  }
}, DO = {
  ordinalNumber: WO,
  era: $({
    values: PO,
    defaultWidth: "wide"
  }),
  quarter: $({
    values: MO,
    defaultWidth: "wide",
    argumentCallback: function(i) {
      return i - 1;
    }
  }),
  month: $({
    values: jO,
    defaultWidth: "wide"
  }),
  day: $({
    values: SO,
    defaultWidth: "wide"
  }),
  dayPeriod: $({
    values: zO,
    defaultWidth: "wide",
    formattingValues: OO,
    defaultFormattingWidth: "wide"
  })
}, CO = /^(\d+)(일|번째)?/i, IO = /\d+/i, TO = {
  narrow: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(기원전|서기)/i
}, NO = {
  any: [/^(bc|기원전)/i, /^(ad|서기)/i]
}, xO = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234]사?분기/i
}, FO = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, EO = {
  narrow: /^(1[012]|[123456789])/,
  abbreviated: /^(1[012]|[123456789])월/i,
  wide: /^(1[012]|[123456789])월/i
}, RO = {
  any: [/^1월?$/, /^2/, /^3/, /^4/, /^5/, /^6/, /^7/, /^8/, /^9/, /^10/, /^11/, /^12/]
}, LO = {
  narrow: /^[일월화수목금토]/,
  short: /^[일월화수목금토]/,
  abbreviated: /^[일월화수목금토]/,
  wide: /^[일월화수목금토]요일/
}, qO = {
  any: [/^일/, /^월/, /^화/, /^수/, /^목/, /^금/, /^토/]
}, ZO = {
  any: /^(am|pm|오전|오후|자정|정오|아침|저녁|밤)/i
}, AO = {
  any: {
    am: /^(am|오전)/i,
    pm: /^(pm|오후)/i,
    midnight: /^자정/i,
    noon: /^정오/i,
    morning: /^아침/i,
    afternoon: /^오후/i,
    evening: /^저녁/i,
    night: /^밤/i
  }
}, VO = {
  ordinalNumber: le({
    matchPattern: CO,
    parsePattern: IO,
    valueCallback: function(i) {
      return parseInt(i, 10);
    }
  }),
  era: P({
    matchPatterns: TO,
    defaultMatchWidth: "wide",
    parsePatterns: NO,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: xO,
    defaultMatchWidth: "wide",
    parsePatterns: FO,
    defaultParseWidth: "any",
    valueCallback: function(i) {
      return i + 1;
    }
  }),
  month: P({
    matchPatterns: EO,
    defaultMatchWidth: "wide",
    parsePatterns: RO,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: LO,
    defaultMatchWidth: "wide",
    parsePatterns: qO,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: ZO,
    defaultMatchWidth: "any",
    parsePatterns: AO,
    defaultParseWidth: "any"
  })
}, HO = {
  code: "ko",
  formatDistance: pO,
  formatLong: wO,
  formatRelative: $O,
  localize: DO,
  match: VO,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
const UO = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: HO
}, Symbol.toStringTag, { value: "Module" })), BO = /* @__PURE__ */ te(UO);
var Fu = {
  xseconds_other: "sekundė_sekundžių_sekundes",
  xminutes_one: "minutė_minutės_minutę",
  xminutes_other: "minutės_minučių_minutes",
  xhours_one: "valanda_valandos_valandą",
  xhours_other: "valandos_valandų_valandas",
  xdays_one: "diena_dienos_dieną",
  xdays_other: "dienos_dienų_dienas",
  xweeks_one: "savaitė_savaitės_savaitę",
  xweeks_other: "savaitės_savaičių_savaites",
  xmonths_one: "mėnuo_mėnesio_mėnesį",
  xmonths_other: "mėnesiai_mėnesių_mėnesius",
  xyears_one: "metai_metų_metus",
  xyears_other: "metai_metų_metus",
  about: "apie",
  over: "daugiau nei",
  almost: "beveik",
  lessthan: "mažiau nei"
}, sd = function(i, d, a, t) {
  return d ? t ? "kelių sekundžių" : "kelias sekundes" : "kelios sekundės";
}, nn = function(i, d, a, t) {
  return d ? t ? Mn(a)[1] : Mn(a)[2] : Mn(a)[0];
}, Ge = function(i, d, a, t) {
  var o = i + " ";
  return i === 1 ? o + nn(i, d, a, t) : d ? t ? o + Mn(a)[1] : o + (dd(i) ? Mn(a)[1] : Mn(a)[2]) : o + (dd(i) ? Mn(a)[1] : Mn(a)[0]);
};
function dd(e) {
  return e % 10 === 0 || e > 10 && e < 20;
}
function Mn(e) {
  return Fu[e].split("_");
}
var XO = {
  lessThanXSeconds: {
    one: sd,
    other: Ge
  },
  xSeconds: {
    one: sd,
    other: Ge
  },
  halfAMinute: "pusė minutės",
  lessThanXMinutes: {
    one: nn,
    other: Ge
  },
  xMinutes: {
    one: nn,
    other: Ge
  },
  aboutXHours: {
    one: nn,
    other: Ge
  },
  xHours: {
    one: nn,
    other: Ge
  },
  xDays: {
    one: nn,
    other: Ge
  },
  aboutXWeeks: {
    one: nn,
    other: Ge
  },
  xWeeks: {
    one: nn,
    other: Ge
  },
  aboutXMonths: {
    one: nn,
    other: Ge
  },
  xMonths: {
    one: nn,
    other: Ge
  },
  aboutXYears: {
    one: nn,
    other: Ge
  },
  xYears: {
    one: nn,
    other: Ge
  },
  overXYears: {
    one: nn,
    other: Ge
  },
  almostXYears: {
    one: nn,
    other: Ge
  }
}, GO = function(i, d, a) {
  var t = i.match(/about|over|almost|lessthan/i), o = t ? i.replace(t[0], "") : i, m = (a == null ? void 0 : a.comparison) !== void 0 && a.comparison > 0, p, s = XO[i];
  if (typeof s == "string" ? p = s : d === 1 ? p = s.one(d, (a == null ? void 0 : a.addSuffix) === !0, o.toLowerCase() + "_one", m) : p = s.other(d, (a == null ? void 0 : a.addSuffix) === !0, o.toLowerCase() + "_other", m), t) {
    var r = t[0].toLowerCase();
    p = Fu[r] + " " + p;
  }
  return a != null && a.addSuffix ? a.comparison && a.comparison > 0 ? "po " + p : "prieš " + p : p;
}, KO = {
  full: "y 'm'. MMMM d 'd'., EEEE",
  long: "y 'm'. MMMM d 'd'.",
  medium: "y-MM-dd",
  short: "y-MM-dd"
}, YO = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, JO = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, QO = {
  date: I({
    formats: KO,
    defaultWidth: "full"
  }),
  time: I({
    formats: YO,
    defaultWidth: "full"
  }),
  dateTime: I({
    formats: JO,
    defaultWidth: "full"
  })
}, eW = {
  lastWeek: "'Praėjusį' eeee p",
  yesterday: "'Vakar' p",
  today: "'Šiandien' p",
  tomorrow: "'Rytoj' p",
  nextWeek: "eeee p",
  other: "P"
}, nW = function(i, d, a, t) {
  return eW[i];
}, iW = {
  narrow: ["pr. Kr.", "po Kr."],
  abbreviated: ["pr. Kr.", "po Kr."],
  wide: ["prieš Kristų", "po Kristaus"]
}, aW = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["I ketv.", "II ketv.", "III ketv.", "IV ketv."],
  wide: ["I ketvirtis", "II ketvirtis", "III ketvirtis", "IV ketvirtis"]
}, tW = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["I k.", "II k.", "III k.", "IV k."],
  wide: ["I ketvirtis", "II ketvirtis", "III ketvirtis", "IV ketvirtis"]
}, rW = {
  narrow: ["S", "V", "K", "B", "G", "B", "L", "R", "R", "S", "L", "G"],
  abbreviated: ["saus.", "vas.", "kov.", "bal.", "geg.", "birž.", "liep.", "rugp.", "rugs.", "spal.", "lapkr.", "gruod."],
  wide: ["sausis", "vasaris", "kovas", "balandis", "gegužė", "birželis", "liepa", "rugpjūtis", "rugsėjis", "spalis", "lapkritis", "gruodis"]
}, oW = {
  narrow: ["S", "V", "K", "B", "G", "B", "L", "R", "R", "S", "L", "G"],
  abbreviated: ["saus.", "vas.", "kov.", "bal.", "geg.", "birž.", "liep.", "rugp.", "rugs.", "spal.", "lapkr.", "gruod."],
  wide: ["sausio", "vasario", "kovo", "balandžio", "gegužės", "birželio", "liepos", "rugpjūčio", "rugsėjo", "spalio", "lapkričio", "gruodžio"]
}, sW = {
  narrow: ["S", "P", "A", "T", "K", "P", "Š"],
  short: ["Sk", "Pr", "An", "Tr", "Kt", "Pn", "Št"],
  abbreviated: ["sk", "pr", "an", "tr", "kt", "pn", "št"],
  wide: ["sekmadienis", "pirmadienis", "antradienis", "trečiadienis", "ketvirtadienis", "penktadienis", "šeštadienis"]
}, dW = {
  narrow: ["S", "P", "A", "T", "K", "P", "Š"],
  short: ["Sk", "Pr", "An", "Tr", "Kt", "Pn", "Št"],
  abbreviated: ["sk", "pr", "an", "tr", "kt", "pn", "št"],
  wide: ["sekmadienį", "pirmadienį", "antradienį", "trečiadienį", "ketvirtadienį", "penktadienį", "šeštadienį"]
}, uW = {
  narrow: {
    am: "pr. p.",
    pm: "pop.",
    midnight: "vidurnaktis",
    noon: "vidurdienis",
    morning: "rytas",
    afternoon: "diena",
    evening: "vakaras",
    night: "naktis"
  },
  abbreviated: {
    am: "priešpiet",
    pm: "popiet",
    midnight: "vidurnaktis",
    noon: "vidurdienis",
    morning: "rytas",
    afternoon: "diena",
    evening: "vakaras",
    night: "naktis"
  },
  wide: {
    am: "priešpiet",
    pm: "popiet",
    midnight: "vidurnaktis",
    noon: "vidurdienis",
    morning: "rytas",
    afternoon: "diena",
    evening: "vakaras",
    night: "naktis"
  }
}, fW = {
  narrow: {
    am: "pr. p.",
    pm: "pop.",
    midnight: "vidurnaktis",
    noon: "perpiet",
    morning: "rytas",
    afternoon: "popietė",
    evening: "vakaras",
    night: "naktis"
  },
  abbreviated: {
    am: "priešpiet",
    pm: "popiet",
    midnight: "vidurnaktis",
    noon: "perpiet",
    morning: "rytas",
    afternoon: "popietė",
    evening: "vakaras",
    night: "naktis"
  },
  wide: {
    am: "priešpiet",
    pm: "popiet",
    midnight: "vidurnaktis",
    noon: "perpiet",
    morning: "rytas",
    afternoon: "popietė",
    evening: "vakaras",
    night: "naktis"
  }
}, lW = function(i, d) {
  var a = Number(i);
  return a + "-oji";
}, cW = {
  ordinalNumber: lW,
  era: $({
    values: iW,
    defaultWidth: "wide"
  }),
  quarter: $({
    values: aW,
    defaultWidth: "wide",
    formattingValues: tW,
    defaultFormattingWidth: "wide",
    argumentCallback: function(i) {
      return i - 1;
    }
  }),
  month: $({
    values: rW,
    defaultWidth: "wide",
    formattingValues: oW,
    defaultFormattingWidth: "wide"
  }),
  day: $({
    values: sW,
    defaultWidth: "wide",
    formattingValues: dW,
    defaultFormattingWidth: "wide"
  }),
  dayPeriod: $({
    values: uW,
    defaultWidth: "wide",
    formattingValues: fW,
    defaultFormattingWidth: "wide"
  })
}, mW = /^(\d+)(-oji)?/i, vW = /\d+/i, hW = {
  narrow: /^p(r|o)\.?\s?(kr\.?|me)/i,
  abbreviated: /^(pr\.\s?(kr\.|m\.\s?e\.)|po\s?kr\.|mūsų eroje)/i,
  wide: /^(prieš Kristų|prieš mūsų erą|po Kristaus|mūsų eroje)/i
}, gW = {
  wide: [/prieš/i, /(po|mūsų)/i],
  any: [/^pr/i, /^(po|m)/i]
}, pW = {
  narrow: /^([1234])/i,
  abbreviated: /^(I|II|III|IV)\s?ketv?\.?/i,
  wide: /^(I|II|III|IV)\s?ketvirtis/i
}, bW = {
  narrow: [/1/i, /2/i, /3/i, /4/i],
  any: [/I$/i, /II$/i, /III/i, /IV/i]
}, yW = {
  narrow: /^[svkbglr]/i,
  abbreviated: /^(saus\.|vas\.|kov\.|bal\.|geg\.|birž\.|liep\.|rugp\.|rugs\.|spal\.|lapkr\.|gruod\.)/i,
  wide: /^(sausi(s|o)|vasari(s|o)|kov(a|o)s|balandž?i(s|o)|gegužės?|birželi(s|o)|liep(a|os)|rugpjū(t|č)i(s|o)|rugsėj(is|o)|spali(s|o)|lapkri(t|č)i(s|o)|gruodž?i(s|o))/i
}, kW = {
  narrow: [/^s/i, /^v/i, /^k/i, /^b/i, /^g/i, /^b/i, /^l/i, /^r/i, /^r/i, /^s/i, /^l/i, /^g/i],
  any: [/^saus/i, /^vas/i, /^kov/i, /^bal/i, /^geg/i, /^birž/i, /^liep/i, /^rugp/i, /^rugs/i, /^spal/i, /^lapkr/i, /^gruod/i]
}, wW = {
  narrow: /^[spatkš]/i,
  short: /^(sk|pr|an|tr|kt|pn|št)/i,
  abbreviated: /^(sk|pr|an|tr|kt|pn|št)/i,
  wide: /^(sekmadien(is|į)|pirmadien(is|į)|antradien(is|į)|trečiadien(is|į)|ketvirtadien(is|į)|penktadien(is|į)|šeštadien(is|į))/i
}, _W = {
  narrow: [/^s/i, /^p/i, /^a/i, /^t/i, /^k/i, /^p/i, /^š/i],
  wide: [/^se/i, /^pi/i, /^an/i, /^tr/i, /^ke/i, /^pe/i, /^še/i],
  any: [/^sk/i, /^pr/i, /^an/i, /^tr/i, /^kt/i, /^pn/i, /^št/i]
}, $W = {
  narrow: /^(pr.\s?p.|pop.|vidurnaktis|(vidurdienis|perpiet)|rytas|(diena|popietė)|vakaras|naktis)/i,
  any: /^(priešpiet|popiet$|vidurnaktis|(vidurdienis|perpiet)|rytas|(diena|popietė)|vakaras|naktis)/i
}, PW = {
  narrow: {
    am: /^pr/i,
    pm: /^pop./i,
    midnight: /^vidurnaktis/i,
    noon: /^(vidurdienis|perp)/i,
    morning: /rytas/i,
    afternoon: /(die|popietė)/i,
    evening: /vakaras/i,
    night: /naktis/i
  },
  any: {
    am: /^pr/i,
    pm: /^popiet$/i,
    midnight: /^vidurnaktis/i,
    noon: /^(vidurdienis|perp)/i,
    morning: /rytas/i,
    afternoon: /(die|popietė)/i,
    evening: /vakaras/i,
    night: /naktis/i
  }
}, MW = {
  ordinalNumber: le({
    matchPattern: mW,
    parsePattern: vW,
    valueCallback: function(i) {
      return parseInt(i, 10);
    }
  }),
  era: P({
    matchPatterns: hW,
    defaultMatchWidth: "wide",
    parsePatterns: gW,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: pW,
    defaultMatchWidth: "wide",
    parsePatterns: bW,
    defaultParseWidth: "any",
    valueCallback: function(i) {
      return i + 1;
    }
  }),
  month: P({
    matchPatterns: yW,
    defaultMatchWidth: "wide",
    parsePatterns: kW,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: wW,
    defaultMatchWidth: "wide",
    parsePatterns: _W,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: $W,
    defaultMatchWidth: "any",
    parsePatterns: PW,
    defaultParseWidth: "any"
  })
}, jW = {
  code: "lt",
  formatDistance: GO,
  formatLong: QO,
  formatRelative: nW,
  localize: cW,
  match: MW,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const SW = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: jW
}, Symbol.toStringTag, { value: "Module" })), zW = /* @__PURE__ */ te(SW);
function Ke(e) {
  return function(i, d) {
    if (i === 1)
      return d != null && d.addSuffix ? e.one[0].replace("{{time}}", e.one[2]) : e.one[0].replace("{{time}}", e.one[1]);
    var a = i % 10 === 1 && i % 100 !== 11;
    return d != null && d.addSuffix ? e.other[0].replace("{{time}}", a ? e.other[3] : e.other[4]).replace("{{count}}", String(i)) : e.other[0].replace("{{time}}", a ? e.other[1] : e.other[2]).replace("{{count}}", String(i));
  };
}
var OW = {
  lessThanXSeconds: Ke({
    one: ["mazāk par {{time}}", "sekundi", "sekundi"],
    other: ["mazāk nekā {{count}} {{time}}", "sekunde", "sekundes", "sekundes", "sekundēm"]
  }),
  xSeconds: Ke({
    one: ["1 {{time}}", "sekunde", "sekundes"],
    other: ["{{count}} {{time}}", "sekunde", "sekundes", "sekundes", "sekundēm"]
  }),
  halfAMinute: function(i, d) {
    return d != null && d.addSuffix ? "pusminūtes" : "pusminūte";
  },
  lessThanXMinutes: Ke({
    one: ["mazāk par {{time}}", "minūti", "minūti"],
    other: ["mazāk nekā {{count}} {{time}}", "minūte", "minūtes", "minūtes", "minūtēm"]
  }),
  xMinutes: Ke({
    one: ["1 {{time}}", "minūte", "minūtes"],
    other: ["{{count}} {{time}}", "minūte", "minūtes", "minūtes", "minūtēm"]
  }),
  aboutXHours: Ke({
    one: ["apmēram 1 {{time}}", "stunda", "stundas"],
    other: ["apmēram {{count}} {{time}}", "stunda", "stundas", "stundas", "stundām"]
  }),
  xHours: Ke({
    one: ["1 {{time}}", "stunda", "stundas"],
    other: ["{{count}} {{time}}", "stunda", "stundas", "stundas", "stundām"]
  }),
  xDays: Ke({
    one: ["1 {{time}}", "diena", "dienas"],
    other: ["{{count}} {{time}}", "diena", "dienas", "dienas", "dienām"]
  }),
  aboutXWeeks: Ke({
    one: ["apmēram 1 {{time}}", "nedēļa", "nedēļas"],
    other: ["apmēram {{count}} {{time}}", "nedēļa", "nedēļu", "nedēļas", "nedēļām"]
  }),
  xWeeks: Ke({
    one: ["1 {{time}}", "nedēļa", "nedēļas"],
    other: [
      "{{count}} {{time}}",
      // TODO
      "nedēļa",
      "nedēļu",
      "nedēļas",
      "nedēļām"
    ]
  }),
  aboutXMonths: Ke({
    one: ["apmēram 1 {{time}}", "mēnesis", "mēneša"],
    other: ["apmēram {{count}} {{time}}", "mēnesis", "mēneši", "mēneša", "mēnešiem"]
  }),
  xMonths: Ke({
    one: ["1 {{time}}", "mēnesis", "mēneša"],
    other: ["{{count}} {{time}}", "mēnesis", "mēneši", "mēneša", "mēnešiem"]
  }),
  aboutXYears: Ke({
    one: ["apmēram 1 {{time}}", "gads", "gada"],
    other: ["apmēram {{count}} {{time}}", "gads", "gadi", "gada", "gadiem"]
  }),
  xYears: Ke({
    one: ["1 {{time}}", "gads", "gada"],
    other: ["{{count}} {{time}}", "gads", "gadi", "gada", "gadiem"]
  }),
  overXYears: Ke({
    one: ["ilgāk par 1 {{time}}", "gadu", "gadu"],
    other: ["vairāk nekā {{count}} {{time}}", "gads", "gadi", "gada", "gadiem"]
  }),
  almostXYears: Ke({
    one: ["gandrīz 1 {{time}}", "gads", "gada"],
    other: ["vairāk nekā {{count}} {{time}}", "gads", "gadi", "gada", "gadiem"]
  })
}, WW = function(i, d, a) {
  var t = OW[i](d, a);
  return a != null && a.addSuffix ? a.comparison && a.comparison > 0 ? "pēc " + t : "pirms " + t : t;
}, DW = {
  full: "EEEE, y. 'gada' d. MMMM",
  long: "y. 'gada' d. MMMM",
  medium: "dd.MM.y.",
  short: "dd.MM.y."
}, CW = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, IW = {
  full: "{{date}} 'plkst.' {{time}}",
  long: "{{date}} 'plkst.' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, TW = {
  date: I({
    formats: DW,
    defaultWidth: "full"
  }),
  time: I({
    formats: CW,
    defaultWidth: "full"
  }),
  dateTime: I({
    formats: IW,
    defaultWidth: "full"
  })
}, ud = ["svētdienā", "pirmdienā", "otrdienā", "trešdienā", "ceturtdienā", "piektdienā", "sestdienā"], NW = {
  lastWeek: function(i, d, a) {
    if (Ne(i, d, a))
      return "eeee 'plkst.' p";
    var t = ud[i.getUTCDay()];
    return "'Pagājušā " + t + " plkst.' p";
  },
  yesterday: "'Vakar plkst.' p",
  today: "'Šodien plkst.' p",
  tomorrow: "'Rīt plkst.' p",
  nextWeek: function(i, d, a) {
    if (Ne(i, d, a))
      return "eeee 'plkst.' p";
    var t = ud[i.getUTCDay()];
    return "'Nākamajā " + t + " plkst.' p";
  },
  other: "P"
}, xW = function(i, d, a, t) {
  var o = NW[i];
  return typeof o == "function" ? o(d, a, t) : o;
}, FW = {
  narrow: ["p.m.ē", "m.ē"],
  abbreviated: ["p. m. ē.", "m. ē."],
  wide: ["pirms mūsu ēras", "mūsu ērā"]
}, EW = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1. cet.", "2. cet.", "3. cet.", "4. cet."],
  wide: ["pirmais ceturksnis", "otrais ceturksnis", "trešais ceturksnis", "ceturtais ceturksnis"]
}, RW = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1. cet.", "2. cet.", "3. cet.", "4. cet."],
  wide: ["pirmajā ceturksnī", "otrajā ceturksnī", "trešajā ceturksnī", "ceturtajā ceturksnī"]
}, LW = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["janv.", "febr.", "marts", "apr.", "maijs", "jūn.", "jūl.", "aug.", "sept.", "okt.", "nov.", "dec."],
  wide: ["janvāris", "februāris", "marts", "aprīlis", "maijs", "jūnijs", "jūlijs", "augusts", "septembris", "oktobris", "novembris", "decembris"]
}, qW = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["janv.", "febr.", "martā", "apr.", "maijs", "jūn.", "jūl.", "aug.", "sept.", "okt.", "nov.", "dec."],
  wide: ["janvārī", "februārī", "martā", "aprīlī", "maijā", "jūnijā", "jūlijā", "augustā", "septembrī", "oktobrī", "novembrī", "decembrī"]
}, ZW = {
  narrow: ["S", "P", "O", "T", "C", "P", "S"],
  short: ["Sv", "P", "O", "T", "C", "Pk", "S"],
  abbreviated: ["svētd.", "pirmd.", "otrd.", "trešd.", "ceturtd.", "piektd.", "sestd."],
  wide: ["svētdiena", "pirmdiena", "otrdiena", "trešdiena", "ceturtdiena", "piektdiena", "sestdiena"]
}, AW = {
  narrow: ["S", "P", "O", "T", "C", "P", "S"],
  short: ["Sv", "P", "O", "T", "C", "Pk", "S"],
  abbreviated: ["svētd.", "pirmd.", "otrd.", "trešd.", "ceturtd.", "piektd.", "sestd."],
  wide: ["svētdienā", "pirmdienā", "otrdienā", "trešdienā", "ceturtdienā", "piektdienā", "sestdienā"]
}, VW = {
  narrow: {
    am: "am",
    pm: "pm",
    midnight: "pusn.",
    noon: "pusd.",
    morning: "rīts",
    afternoon: "diena",
    evening: "vakars",
    night: "nakts"
  },
  abbreviated: {
    am: "am",
    pm: "pm",
    midnight: "pusn.",
    noon: "pusd.",
    morning: "rīts",
    afternoon: "pēcpusd.",
    evening: "vakars",
    night: "nakts"
  },
  wide: {
    am: "am",
    pm: "pm",
    midnight: "pusnakts",
    noon: "pusdienlaiks",
    morning: "rīts",
    afternoon: "pēcpusdiena",
    evening: "vakars",
    night: "nakts"
  }
}, HW = {
  narrow: {
    am: "am",
    pm: "pm",
    midnight: "pusn.",
    noon: "pusd.",
    morning: "rītā",
    afternoon: "dienā",
    evening: "vakarā",
    night: "naktī"
  },
  abbreviated: {
    am: "am",
    pm: "pm",
    midnight: "pusn.",
    noon: "pusd.",
    morning: "rītā",
    afternoon: "pēcpusd.",
    evening: "vakarā",
    night: "naktī"
  },
  wide: {
    am: "am",
    pm: "pm",
    midnight: "pusnaktī",
    noon: "pusdienlaikā",
    morning: "rītā",
    afternoon: "pēcpusdienā",
    evening: "vakarā",
    night: "naktī"
  }
}, UW = function(i, d) {
  var a = Number(i);
  return a + ".";
}, BW = {
  ordinalNumber: UW,
  era: $({
    values: FW,
    defaultWidth: "wide"
  }),
  quarter: $({
    values: EW,
    defaultWidth: "wide",
    formattingValues: RW,
    defaultFormattingWidth: "wide",
    argumentCallback: function(i) {
      return i - 1;
    }
  }),
  month: $({
    values: LW,
    defaultWidth: "wide",
    formattingValues: qW,
    defaultFormattingWidth: "wide"
  }),
  day: $({
    values: ZW,
    defaultWidth: "wide",
    formattingValues: AW,
    defaultFormattingWidth: "wide"
  }),
  dayPeriod: $({
    values: VW,
    defaultWidth: "wide",
    formattingValues: HW,
    defaultFormattingWidth: "wide"
  })
}, XW = /^(\d+)\./i, GW = /\d+/i, KW = {
  narrow: /^(p\.m\.ē|m\.ē)/i,
  abbreviated: /^(p\. m\. ē\.|m\. ē\.)/i,
  wide: /^(pirms mūsu ēras|mūsu ērā)/i
}, YW = {
  any: [/^p/i, /^m/i]
}, JW = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234](\. cet\.)/i,
  wide: /^(pirma(is|jā)|otra(is|jā)|treša(is|jā)|ceturta(is|jā)) ceturksn(is|ī)/i
}, QW = {
  narrow: [/^1/i, /^2/i, /^3/i, /^4/i],
  abbreviated: [/^1/i, /^2/i, /^3/i, /^4/i],
  wide: [/^p/i, /^o/i, /^t/i, /^c/i]
}, eD = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(janv\.|febr\.|marts|apr\.|maijs|jūn\.|jūl\.|aug\.|sept\.|okt\.|nov\.|dec\.)/i,
  wide: /^(janvār(is|ī)|februār(is|ī)|mart[sā]|aprīl(is|ī)|maij[sā]|jūnij[sā]|jūlij[sā]|august[sā]|septembr(is|ī)|oktobr(is|ī)|novembr(is|ī)|decembr(is|ī))/i
}, nD = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^mai/i, /^jūn/i, /^jūl/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, iD = {
  narrow: /^[spotc]/i,
  short: /^(sv|pi|o|t|c|pk|s)/i,
  abbreviated: /^(svētd\.|pirmd\.|otrd.\|trešd\.|ceturtd\.|piektd\.|sestd\.)/i,
  wide: /^(svētdien(a|ā)|pirmdien(a|ā)|otrdien(a|ā)|trešdien(a|ā)|ceturtdien(a|ā)|piektdien(a|ā)|sestdien(a|ā))/i
}, aD = {
  narrow: [/^s/i, /^p/i, /^o/i, /^t/i, /^c/i, /^p/i, /^s/i],
  any: [/^sv/i, /^pi/i, /^o/i, /^t/i, /^c/i, /^p/i, /^se/i]
}, tD = {
  narrow: /^(am|pm|pusn\.|pusd\.|rīt(s|ā)|dien(a|ā)|vakar(s|ā)|nakt(s|ī))/,
  abbreviated: /^(am|pm|pusn\.|pusd\.|rīt(s|ā)|pēcpusd\.|vakar(s|ā)|nakt(s|ī))/,
  wide: /^(am|pm|pusnakt(s|ī)|pusdienlaik(s|ā)|rīt(s|ā)|pēcpusdien(a|ā)|vakar(s|ā)|nakt(s|ī))/i
}, rD = {
  any: {
    am: /^am/i,
    pm: /^pm/i,
    midnight: /^pusn/i,
    noon: /^pusd/i,
    morning: /^r/i,
    afternoon: /^(d|pēc)/i,
    evening: /^v/i,
    night: /^n/i
  }
}, oD = {
  ordinalNumber: le({
    matchPattern: XW,
    parsePattern: GW,
    valueCallback: function(i) {
      return parseInt(i, 10);
    }
  }),
  era: P({
    matchPatterns: KW,
    defaultMatchWidth: "wide",
    parsePatterns: YW,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: JW,
    defaultMatchWidth: "wide",
    parsePatterns: QW,
    defaultParseWidth: "wide",
    valueCallback: function(i) {
      return i + 1;
    }
  }),
  month: P({
    matchPatterns: eD,
    defaultMatchWidth: "wide",
    parsePatterns: nD,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: iD,
    defaultMatchWidth: "wide",
    parsePatterns: aD,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: tD,
    defaultMatchWidth: "wide",
    parsePatterns: rD,
    defaultParseWidth: "any"
  })
}, sD = {
  code: "lv",
  formatDistance: WW,
  formatLong: TW,
  formatRelative: xW,
  localize: BW,
  match: oD,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const dD = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: sD
}, Symbol.toStringTag, { value: "Module" })), uD = /* @__PURE__ */ te(dD);
var fD = {
  lessThanXSeconds: {
    one: "помалку од секунда",
    other: "помалку од {{count}} секунди"
  },
  xSeconds: {
    one: "1 секунда",
    other: "{{count}} секунди"
  },
  halfAMinute: "половина минута",
  lessThanXMinutes: {
    one: "помалку од минута",
    other: "помалку од {{count}} минути"
  },
  xMinutes: {
    one: "1 минута",
    other: "{{count}} минути"
  },
  aboutXHours: {
    one: "околу 1 час",
    other: "околу {{count}} часа"
  },
  xHours: {
    one: "1 час",
    other: "{{count}} часа"
  },
  xDays: {
    one: "1 ден",
    other: "{{count}} дена"
  },
  aboutXWeeks: {
    one: "околу 1 недела",
    other: "околу {{count}} месеци"
  },
  xWeeks: {
    one: "1 недела",
    other: "{{count}} недели"
  },
  aboutXMonths: {
    one: "околу 1 месец",
    other: "околу {{count}} недели"
  },
  xMonths: {
    one: "1 месец",
    other: "{{count}} месеци"
  },
  aboutXYears: {
    one: "околу 1 година",
    other: "околу {{count}} години"
  },
  xYears: {
    one: "1 година",
    other: "{{count}} години"
  },
  overXYears: {
    one: "повеќе од 1 година",
    other: "повеќе од {{count}} години"
  },
  almostXYears: {
    one: "безмалку 1 година",
    other: "безмалку {{count}} години"
  }
}, lD = function(i, d, a) {
  var t, o = fD[i];
  return typeof o == "string" ? t = o : d === 1 ? t = o.one : t = o.other.replace("{{count}}", String(d)), a != null && a.addSuffix ? a.comparison && a.comparison > 0 ? "за " + t : "пред " + t : t;
}, cD = {
  full: "EEEE, dd MMMM yyyy",
  long: "dd MMMM yyyy",
  medium: "dd MMM yyyy",
  short: "dd/MM/yyyy"
}, mD = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "H:mm"
}, vD = {
  any: "{{date}} {{time}}"
}, hD = {
  date: I({
    formats: cD,
    defaultWidth: "full"
  }),
  time: I({
    formats: mD,
    defaultWidth: "full"
  }),
  dateTime: I({
    formats: vD,
    defaultWidth: "any"
  })
}, rr = ["недела", "понеделник", "вторник", "среда", "четврток", "петок", "сабота"];
function gD(e) {
  var i = rr[e];
  switch (e) {
    case 0:
    case 3:
    case 6:
      return "'минатата " + i + " во' p";
    case 1:
    case 2:
    case 4:
    case 5:
      return "'минатиот " + i + " во' p";
  }
}
function fd(e) {
  var i = rr[e];
  switch (e) {
    case 0:
    case 3:
    case 6:
      return "'ова " + i + " вo' p";
    case 1:
    case 2:
    case 4:
    case 5:
      return "'овој " + i + " вo' p";
  }
}
function pD(e) {
  var i = rr[e];
  switch (e) {
    case 0:
    case 3:
    case 6:
      return "'следната " + i + " вo' p";
    case 1:
    case 2:
    case 4:
    case 5:
      return "'следниот " + i + " вo' p";
  }
}
var bD = {
  lastWeek: function(i, d, a) {
    var t = i.getUTCDay();
    return Ne(i, d, a) ? fd(t) : gD(t);
  },
  yesterday: "'вчера во' p",
  today: "'денес во' p",
  tomorrow: "'утре во' p",
  nextWeek: function(i, d, a) {
    var t = i.getUTCDay();
    return Ne(i, d, a) ? fd(t) : pD(t);
  },
  other: "P"
}, yD = function(i, d, a, t) {
  var o = bD[i];
  return typeof o == "function" ? o(d, a, t) : o;
}, kD = {
  narrow: ["пр.н.е.", "н.е."],
  abbreviated: ["пред н. е.", "н. е."],
  wide: ["пред нашата ера", "нашата ера"]
}, wD = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1-ви кв.", "2-ри кв.", "3-ти кв.", "4-ти кв."],
  wide: ["1-ви квартал", "2-ри квартал", "3-ти квартал", "4-ти квартал"]
}, _D = {
  abbreviated: ["јан", "фев", "мар", "апр", "мај", "јун", "јул", "авг", "септ", "окт", "ноем", "дек"],
  wide: ["јануари", "февруари", "март", "април", "мај", "јуни", "јули", "август", "септември", "октомври", "ноември", "декември"]
}, $D = {
  narrow: ["Н", "П", "В", "С", "Ч", "П", "С"],
  short: ["не", "по", "вт", "ср", "че", "пе", "са"],
  abbreviated: ["нед", "пон", "вто", "сре", "чет", "пет", "саб"],
  wide: ["недела", "понеделник", "вторник", "среда", "четврток", "петок", "сабота"]
}, PD = {
  wide: {
    am: "претпладне",
    pm: "попладне",
    midnight: "полноќ",
    noon: "напладне",
    morning: "наутро",
    afternoon: "попладне",
    evening: "навечер",
    night: "ноќе"
  }
}, MD = function(i, d) {
  var a = Number(i), t = a % 100;
  if (t > 20 || t < 10)
    switch (t % 10) {
      case 1:
        return a + "-ви";
      case 2:
        return a + "-ри";
      case 7:
      case 8:
        return a + "-ми";
    }
  return a + "-ти";
}, jD = {
  ordinalNumber: MD,
  era: $({
    values: kD,
    defaultWidth: "wide"
  }),
  quarter: $({
    values: wD,
    defaultWidth: "wide",
    argumentCallback: function(i) {
      return i - 1;
    }
  }),
  month: $({
    values: _D,
    defaultWidth: "wide"
  }),
  day: $({
    values: $D,
    defaultWidth: "wide"
  }),
  dayPeriod: $({
    values: PD,
    defaultWidth: "wide"
  })
}, SD = /^(\d+)(-?[врмт][и])?/i, zD = /\d+/i, OD = {
  narrow: /^((пр)?н\.?\s?е\.?)/i,
  abbreviated: /^((пр)?н\.?\s?е\.?)/i,
  wide: /^(пред нашата ера|нашата ера)/i
}, WD = {
  any: [/^п/i, /^н/i]
}, DD = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234](-?[врт]?и?)? кв.?/i,
  wide: /^[1234](-?[врт]?и?)? квартал/i
}, CD = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, ID = {
  narrow: /^[нпвсч]/i,
  short: /^(не|по|вт|ср|че|пе|са)/i,
  abbreviated: /^(нед|пон|вто|сре|чет|пет|саб)/i,
  wide: /^(недела|понеделник|вторник|среда|четврток|петок|сабота)/i
}, TD = {
  narrow: [/^н/i, /^п/i, /^в/i, /^с/i, /^ч/i, /^п/i, /^с/i],
  any: [/^н[ед]/i, /^п[он]/i, /^вт/i, /^ср/i, /^ч[ет]/i, /^п[ет]/i, /^с[аб]/i]
}, ND = {
  abbreviated: /^(јан|фев|мар|апр|мај|јун|јул|авг|сеп|окт|ноем|дек)/i,
  wide: /^(јануари|февруари|март|април|мај|јуни|јули|август|септември|октомври|ноември|декември)/i
}, xD = {
  any: [/^ја/i, /^Ф/i, /^мар/i, /^ап/i, /^мај/i, /^јун/i, /^јул/i, /^ав/i, /^се/i, /^окт/i, /^но/i, /^де/i]
}, FD = {
  any: /^(претп|попл|полноќ|утро|пладне|вечер|ноќ)/i
}, ED = {
  any: {
    am: /претпладне/i,
    pm: /попладне/i,
    midnight: /полноќ/i,
    noon: /напладне/i,
    morning: /наутро/i,
    afternoon: /попладне/i,
    evening: /навечер/i,
    night: /ноќе/i
  }
}, RD = {
  ordinalNumber: le({
    matchPattern: SD,
    parsePattern: zD,
    valueCallback: function(i) {
      return parseInt(i, 10);
    }
  }),
  era: P({
    matchPatterns: OD,
    defaultMatchWidth: "wide",
    parsePatterns: WD,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: DD,
    defaultMatchWidth: "wide",
    parsePatterns: CD,
    defaultParseWidth: "any",
    valueCallback: function(i) {
      return i + 1;
    }
  }),
  month: P({
    matchPatterns: ND,
    defaultMatchWidth: "wide",
    parsePatterns: xD,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: ID,
    defaultMatchWidth: "wide",
    parsePatterns: TD,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: FD,
    defaultMatchWidth: "any",
    parsePatterns: ED,
    defaultParseWidth: "any"
  })
}, LD = {
  code: "mk",
  formatDistance: lD,
  formatLong: hD,
  formatRelative: yD,
  localize: jD,
  match: RD,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const qD = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: LD
}, Symbol.toStringTag, { value: "Module" })), ZD = /* @__PURE__ */ te(qD);
var AD = {
  lessThanXSeconds: {
    one: "секунд хүрэхгүй",
    other: "{{count}} секунд хүрэхгүй"
  },
  xSeconds: {
    one: "1 секунд",
    other: "{{count}} секунд"
  },
  halfAMinute: "хагас минут",
  lessThanXMinutes: {
    one: "минут хүрэхгүй",
    other: "{{count}} минут хүрэхгүй"
  },
  xMinutes: {
    one: "1 минут",
    other: "{{count}} минут"
  },
  aboutXHours: {
    one: "ойролцоогоор 1 цаг",
    other: "ойролцоогоор {{count}} цаг"
  },
  xHours: {
    one: "1 цаг",
    other: "{{count}} цаг"
  },
  xDays: {
    one: "1 өдөр",
    other: "{{count}} өдөр"
  },
  aboutXWeeks: {
    one: "ойролцоогоор 1 долоо хоног",
    other: "ойролцоогоор {{count}} долоо хоног"
  },
  xWeeks: {
    one: "1 долоо хоног",
    other: "{{count}} долоо хоног"
  },
  aboutXMonths: {
    one: "ойролцоогоор 1 сар",
    other: "ойролцоогоор {{count}} сар"
  },
  xMonths: {
    one: "1 сар",
    other: "{{count}} сар"
  },
  aboutXYears: {
    one: "ойролцоогоор 1 жил",
    other: "ойролцоогоор {{count}} жил"
  },
  xYears: {
    one: "1 жил",
    other: "{{count}} жил"
  },
  overXYears: {
    one: "1 жил гаран",
    other: "{{count}} жил гаран"
  },
  almostXYears: {
    one: "бараг 1 жил",
    other: "бараг {{count}} жил"
  }
}, VD = function(i, d, a) {
  var t, o = AD[i];
  if (typeof o == "string" ? t = o : d === 1 ? t = o.one : t = o.other.replace("{{count}}", String(d)), a != null && a.addSuffix) {
    var m = t.split(" "), p = m.pop();
    switch (t = m.join(" "), p) {
      case "секунд":
        t += " секундийн";
        break;
      case "минут":
        t += " минутын";
        break;
      case "цаг":
        t += " цагийн";
        break;
      case "өдөр":
        t += " өдрийн";
        break;
      case "сар":
        t += " сарын";
        break;
      case "жил":
        t += " жилийн";
        break;
      case "хоног":
        t += " хоногийн";
        break;
      case "гаран":
        t += " гараны";
        break;
      case "хүрэхгүй":
        t += " хүрэхгүй хугацааны";
        break;
      default:
        t += p + "-н";
    }
    return a.comparison && a.comparison > 0 ? t + " дараа" : t + " өмнө";
  }
  return t;
}, HD = {
  full: "y 'оны' MMMM'ын' d, EEEE 'гараг'",
  long: "y 'оны' MMMM'ын' d",
  medium: "y 'оны' MMM'ын' d",
  short: "y.MM.dd"
}, UD = {
  full: "H:mm:ss zzzz",
  long: "H:mm:ss z",
  medium: "H:mm:ss",
  short: "H:mm"
}, BD = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, XD = {
  date: I({
    formats: HD,
    defaultWidth: "full"
  }),
  time: I({
    formats: UD,
    defaultWidth: "full"
  }),
  dateTime: I({
    formats: BD,
    defaultWidth: "full"
  })
}, GD = {
  lastWeek: "'өнгөрсөн' eeee 'гарагийн' p 'цагт'",
  yesterday: "'өчигдөр' p 'цагт'",
  today: "'өнөөдөр' p 'цагт'",
  tomorrow: "'маргааш' p 'цагт'",
  nextWeek: "'ирэх' eeee 'гарагийн' p 'цагт'",
  other: "P"
}, KD = function(i, d, a, t) {
  return GD[i];
}, YD = {
  narrow: ["НТӨ", "НТ"],
  abbreviated: ["НТӨ", "НТ"],
  wide: ["нийтийн тооллын өмнөх", "нийтийн тооллын"]
}, JD = {
  narrow: ["I", "II", "III", "IV"],
  abbreviated: ["I улирал", "II улирал", "III улирал", "IV улирал"],
  wide: ["1-р улирал", "2-р улирал", "3-р улирал", "4-р улирал"]
}, QD = {
  narrow: ["I", "II", "III", "IV", "V", "VI", "VII", "VIII", "IX", "X", "XI", "XII"],
  abbreviated: ["1-р сар", "2-р сар", "3-р сар", "4-р сар", "5-р сар", "6-р сар", "7-р сар", "8-р сар", "9-р сар", "10-р сар", "11-р сар", "12-р сар"],
  wide: ["Нэгдүгээр сар", "Хоёрдугаар сар", "Гуравдугаар сар", "Дөрөвдүгээр сар", "Тавдугаар сар", "Зургаадугаар сар", "Долоодугаар сар", "Наймдугаар сар", "Есдүгээр сар", "Аравдугаар сар", "Арваннэгдүгээр сар", "Арван хоёрдугаар сар"]
}, e5 = {
  narrow: ["I", "II", "III", "IV", "V", "VI", "VII", "VIII", "IX", "X", "XI", "XII"],
  abbreviated: ["1-р сар", "2-р сар", "3-р сар", "4-р сар", "5-р сар", "6-р сар", "7-р сар", "8-р сар", "9-р сар", "10-р сар", "11-р сар", "12-р сар"],
  wide: ["нэгдүгээр сар", "хоёрдугаар сар", "гуравдугаар сар", "дөрөвдүгээр сар", "тавдугаар сар", "зургаадугаар сар", "долоодугаар сар", "наймдугаар сар", "есдүгээр сар", "аравдугаар сар", "арваннэгдүгээр сар", "арван хоёрдугаар сар"]
}, n5 = {
  narrow: ["Н", "Д", "М", "Л", "П", "Б", "Б"],
  short: ["Ня", "Да", "Мя", "Лх", "Пү", "Ба", "Бя"],
  abbreviated: ["Ням", "Дав", "Мяг", "Лха", "Пүр", "Баа", "Бям"],
  wide: ["Ням", "Даваа", "Мягмар", "Лхагва", "Пүрэв", "Баасан", "Бямба"]
}, i5 = {
  narrow: ["Н", "Д", "М", "Л", "П", "Б", "Б"],
  short: ["Ня", "Да", "Мя", "Лх", "Пү", "Ба", "Бя"],
  abbreviated: ["Ням", "Дав", "Мяг", "Лха", "Пүр", "Баа", "Бям"],
  wide: ["ням", "даваа", "мягмар", "лхагва", "пүрэв", "баасан", "бямба"]
}, a5 = {
  narrow: {
    am: "ү.ө.",
    pm: "ү.х.",
    midnight: "шөнө дунд",
    noon: "үд дунд",
    morning: "өглөө",
    afternoon: "өдөр",
    evening: "орой",
    night: "шөнө"
  },
  abbreviated: {
    am: "ү.ө.",
    pm: "ү.х.",
    midnight: "шөнө дунд",
    noon: "үд дунд",
    morning: "өглөө",
    afternoon: "өдөр",
    evening: "орой",
    night: "шөнө"
  },
  wide: {
    am: "ү.ө.",
    pm: "ү.х.",
    midnight: "шөнө дунд",
    noon: "үд дунд",
    morning: "өглөө",
    afternoon: "өдөр",
    evening: "орой",
    night: "шөнө"
  }
}, t5 = function(i, d) {
  return String(i);
}, r5 = {
  ordinalNumber: t5,
  era: $({
    values: YD,
    defaultWidth: "wide"
  }),
  quarter: $({
    values: JD,
    defaultWidth: "wide",
    argumentCallback: function(i) {
      return i - 1;
    }
  }),
  month: $({
    values: QD,
    defaultWidth: "wide",
    formattingValues: e5,
    defaultFormattingWidth: "wide"
  }),
  day: $({
    values: n5,
    defaultWidth: "wide",
    formattingValues: i5,
    defaultFormattingWidth: "wide"
  }),
  dayPeriod: $({
    values: a5,
    defaultWidth: "wide"
  })
}, o5 = /\d+/i, s5 = /\d+/i, d5 = {
  narrow: /^(нтө|нт)/i,
  abbreviated: /^(нтө|нт)/i,
  wide: /^(нийтийн тооллын өмнө|нийтийн тооллын)/i
}, u5 = {
  any: [/^(нтө|нийтийн тооллын өмнө)/i, /^(нт|нийтийн тооллын)/i]
}, f5 = {
  narrow: /^(iv|iii|ii|i)/i,
  abbreviated: /^(iv|iii|ii|i) улирал/i,
  wide: /^[1-4]-р улирал/i
}, l5 = {
  any: [/^(i(\s|$)|1)/i, /^(ii(\s|$)|2)/i, /^(iii(\s|$)|3)/i, /^(iv(\s|$)|4)/i]
}, c5 = {
  narrow: /^(xii|xi|x|ix|viii|vii|vi|v|iv|iii|ii|i)/i,
  abbreviated: /^(1-р сар|2-р сар|3-р сар|4-р сар|5-р сар|6-р сар|7-р сар|8-р сар|9-р сар|10-р сар|11-р сар|12-р сар)/i,
  wide: /^(нэгдүгээр сар|хоёрдугаар сар|гуравдугаар сар|дөрөвдүгээр сар|тавдугаар сар|зургаадугаар сар|долоодугаар сар|наймдугаар сар|есдүгээр сар|аравдугаар сар|арван нэгдүгээр сар|арван хоёрдугаар сар)/i
}, m5 = {
  narrow: [/^i$/i, /^ii$/i, /^iii$/i, /^iv$/i, /^v$/i, /^vi$/i, /^vii$/i, /^viii$/i, /^ix$/i, /^x$/i, /^xi$/i, /^xii$/i],
  any: [/^(1|нэгдүгээр)/i, /^(2|хоёрдугаар)/i, /^(3|гуравдугаар)/i, /^(4|дөрөвдүгээр)/i, /^(5|тавдугаар)/i, /^(6|зургаадугаар)/i, /^(7|долоодугаар)/i, /^(8|наймдугаар)/i, /^(9|есдүгээр)/i, /^(10|аравдугаар)/i, /^(11|арван нэгдүгээр)/i, /^(12|арван хоёрдугаар)/i]
}, v5 = {
  narrow: /^[ндмлпбб]/i,
  short: /^(ня|да|мя|лх|пү|ба|бя)/i,
  abbreviated: /^(ням|дав|мяг|лха|пүр|баа|бям)/i,
  wide: /^(ням|даваа|мягмар|лхагва|пүрэв|баасан|бямба)/i
}, h5 = {
  narrow: [/^н/i, /^д/i, /^м/i, /^л/i, /^п/i, /^б/i, /^б/i],
  any: [/^ня/i, /^да/i, /^мя/i, /^лх/i, /^пү/i, /^ба/i, /^бя/i]
}, g5 = {
  narrow: /^(ү\.ө\.|ү\.х\.|шөнө дунд|үд дунд|өглөө|өдөр|орой|шөнө)/i,
  any: /^(ү\.ө\.|ү\.х\.|шөнө дунд|үд дунд|өглөө|өдөр|орой|шөнө)/i
}, p5 = {
  any: {
    am: /^ү\.ө\./i,
    pm: /^ү\.х\./i,
    midnight: /^шөнө дунд/i,
    noon: /^үд дунд/i,
    morning: /өглөө/i,
    afternoon: /өдөр/i,
    evening: /орой/i,
    night: /шөнө/i
  }
}, b5 = {
  ordinalNumber: le({
    matchPattern: o5,
    parsePattern: s5,
    valueCallback: function(i) {
      return parseInt(i, 10);
    }
  }),
  era: P({
    matchPatterns: d5,
    defaultMatchWidth: "wide",
    parsePatterns: u5,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: f5,
    defaultMatchWidth: "wide",
    parsePatterns: l5,
    defaultParseWidth: "any",
    valueCallback: function(i) {
      return i + 1;
    }
  }),
  month: P({
    matchPatterns: c5,
    defaultMatchWidth: "wide",
    parsePatterns: m5,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: v5,
    defaultMatchWidth: "wide",
    parsePatterns: h5,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: g5,
    defaultMatchWidth: "any",
    parsePatterns: p5,
    defaultParseWidth: "any"
  })
}, y5 = {
  code: "mn",
  formatDistance: VD,
  formatLong: XD,
  formatRelative: KD,
  localize: r5,
  match: b5,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
};
const k5 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: y5
}, Symbol.toStringTag, { value: "Module" })), w5 = /* @__PURE__ */ te(k5);
var _5 = {
  lessThanXSeconds: {
    one: "kurang dari 1 saat",
    other: "kurang dari {{count}} saat"
  },
  xSeconds: {
    one: "1 saat",
    other: "{{count}} saat"
  },
  halfAMinute: "setengah minit",
  lessThanXMinutes: {
    one: "kurang dari 1 minit",
    other: "kurang dari {{count}} minit"
  },
  xMinutes: {
    one: "1 minit",
    other: "{{count}} minit"
  },
  aboutXHours: {
    one: "sekitar 1 jam",
    other: "sekitar {{count}} jam"
  },
  xHours: {
    one: "1 jam",
    other: "{{count}} jam"
  },
  xDays: {
    one: "1 hari",
    other: "{{count}} hari"
  },
  aboutXWeeks: {
    one: "sekitar 1 minggu",
    other: "sekitar {{count}} minggu"
  },
  xWeeks: {
    one: "1 minggu",
    other: "{{count}} minggu"
  },
  aboutXMonths: {
    one: "sekitar 1 bulan",
    other: "sekitar {{count}} bulan"
  },
  xMonths: {
    one: "1 bulan",
    other: "{{count}} bulan"
  },
  aboutXYears: {
    one: "sekitar 1 tahun",
    other: "sekitar {{count}} tahun"
  },
  xYears: {
    one: "1 tahun",
    other: "{{count}} tahun"
  },
  overXYears: {
    one: "lebih dari 1 tahun",
    other: "lebih dari {{count}} tahun"
  },
  almostXYears: {
    one: "hampir 1 tahun",
    other: "hampir {{count}} tahun"
  }
}, $5 = function(i, d, a) {
  var t, o = _5[i];
  return typeof o == "string" ? t = o : d === 1 ? t = o.one : t = o.other.replace("{{count}}", String(d)), a != null && a.addSuffix ? a.comparison && a.comparison > 0 ? "dalam masa " + t : t + " yang lalu" : t;
}, P5 = {
  full: "EEEE, d MMMM yyyy",
  long: "d MMMM yyyy",
  medium: "d MMM yyyy",
  short: "d/M/yyyy"
}, M5 = {
  full: "HH.mm.ss",
  long: "HH.mm.ss",
  medium: "HH.mm",
  short: "HH.mm"
}, j5 = {
  full: "{{date}} 'pukul' {{time}}",
  long: "{{date}} 'pukul' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, S5 = {
  date: I({
    formats: P5,
    defaultWidth: "full"
  }),
  time: I({
    formats: M5,
    defaultWidth: "full"
  }),
  dateTime: I({
    formats: j5,
    defaultWidth: "full"
  })
}, z5 = {
  lastWeek: "eeee 'lepas pada jam' p",
  yesterday: "'Semalam pada jam' p",
  today: "'Hari ini pada jam' p",
  tomorrow: "'Esok pada jam' p",
  nextWeek: "eeee 'pada jam' p",
  other: "P"
}, O5 = function(i, d, a, t) {
  return z5[i];
}, W5 = {
  narrow: ["SM", "M"],
  abbreviated: ["SM", "M"],
  wide: ["Sebelum Masihi", "Masihi"]
}, D5 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["S1", "S2", "S3", "S4"],
  wide: ["Suku pertama", "Suku kedua", "Suku ketiga", "Suku keempat"]
}, C5 = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "O", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mac", "Apr", "Mei", "Jun", "Jul", "Ogo", "Sep", "Okt", "Nov", "Dis"],
  wide: ["Januari", "Februari", "Mac", "April", "Mei", "Jun", "Julai", "Ogos", "September", "Oktober", "November", "Disember"]
}, I5 = {
  narrow: ["A", "I", "S", "R", "K", "J", "S"],
  short: ["Ahd", "Isn", "Sel", "Rab", "Kha", "Jum", "Sab"],
  abbreviated: ["Ahd", "Isn", "Sel", "Rab", "Kha", "Jum", "Sab"],
  wide: ["Ahad", "Isnin", "Selasa", "Rabu", "Khamis", "Jumaat", "Sabtu"]
}, T5 = {
  narrow: {
    am: "am",
    pm: "pm",
    midnight: "tgh malam",
    noon: "tgh hari",
    morning: "pagi",
    afternoon: "tengah hari",
    evening: "petang",
    night: "malam"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "tengah malam",
    noon: "tengah hari",
    morning: "pagi",
    afternoon: "tengah hari",
    evening: "petang",
    night: "malam"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "tengah malam",
    noon: "tengah hari",
    morning: "pagi",
    afternoon: "tengah hari",
    evening: "petang",
    night: "malam"
  }
}, N5 = {
  narrow: {
    am: "am",
    pm: "pm",
    midnight: "tengah malam",
    noon: "tengah hari",
    morning: "pagi",
    afternoon: "tengah hari",
    evening: "petang",
    night: "malam"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "tengah malam",
    noon: "tengah hari",
    morning: "pagi",
    afternoon: "tengah hari",
    evening: "petang",
    night: "malam"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "tengah malam",
    noon: "tengah hari",
    morning: "pagi",
    afternoon: "tengah hari",
    evening: "petang",
    night: "malam"
  }
}, x5 = function(i, d) {
  return "ke-" + Number(i);
}, F5 = {
  ordinalNumber: x5,
  era: $({
    values: W5,
    defaultWidth: "wide"
  }),
  quarter: $({
    values: D5,
    defaultWidth: "wide",
    argumentCallback: function(i) {
      return i - 1;
    }
  }),
  month: $({
    values: C5,
    defaultWidth: "wide"
  }),
  day: $({
    values: I5,
    defaultWidth: "wide"
  }),
  dayPeriod: $({
    values: T5,
    defaultWidth: "wide",
    formattingValues: N5,
    defaultFormattingWidth: "wide"
  })
}, E5 = /^ke-(\d+)?/i, R5 = /petama|\d+/i, L5 = {
  narrow: /^(sm|m)/i,
  abbreviated: /^(s\.?\s?m\.?|m\.?)/i,
  wide: /^(sebelum masihi|masihi)/i
}, q5 = {
  any: [/^s/i, /^(m)/i]
}, Z5 = {
  narrow: /^[1234]/i,
  abbreviated: /^S[1234]/i,
  wide: /Suku (pertama|kedua|ketiga|keempat)/i
}, A5 = {
  any: [/pertama|1/i, /kedua|2/i, /ketiga|3/i, /keempat|4/i]
}, V5 = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mac|apr|mei|jun|jul|ogo|sep|okt|nov|dis)/i,
  wide: /^(januari|februari|mac|april|mei|jun|julai|ogos|september|oktober|november|disember)/i
}, H5 = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^o/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^ma/i, /^ap/i, /^me/i, /^jun/i, /^jul/i, /^og/i, /^s/i, /^ok/i, /^n/i, /^d/i]
}, U5 = {
  narrow: /^[aisrkj]/i,
  short: /^(ahd|isn|sel|rab|kha|jum|sab)/i,
  abbreviated: /^(ahd|isn|sel|rab|kha|jum|sab)/i,
  wide: /^(ahad|isnin|selasa|rabu|khamis|jumaat|sabtu)/i
}, B5 = {
  narrow: [/^a/i, /^i/i, /^s/i, /^r/i, /^k/i, /^j/i, /^s/i],
  any: [/^a/i, /^i/i, /^se/i, /^r/i, /^k/i, /^j/i, /^sa/i]
}, X5 = {
  narrow: /^(am|pm|tengah malam|tengah hari|pagi|petang|malam)/i,
  any: /^([ap]\.?\s?m\.?|tengah malam|tengah hari|pagi|petang|malam)/i
}, G5 = {
  any: {
    am: /^a/i,
    pm: /^pm/i,
    midnight: /^tengah m/i,
    noon: /^tengah h/i,
    morning: /pa/i,
    afternoon: /tengah h/i,
    evening: /pe/i,
    night: /m/i
  }
}, K5 = {
  ordinalNumber: le({
    matchPattern: E5,
    parsePattern: R5,
    valueCallback: function(i) {
      return parseInt(i, 10);
    }
  }),
  era: P({
    matchPatterns: L5,
    defaultMatchWidth: "wide",
    parsePatterns: q5,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: Z5,
    defaultMatchWidth: "wide",
    parsePatterns: A5,
    defaultParseWidth: "any",
    valueCallback: function(i) {
      return i + 1;
    }
  }),
  month: P({
    matchPatterns: V5,
    defaultMatchWidth: "wide",
    parsePatterns: H5,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: U5,
    defaultMatchWidth: "wide",
    parsePatterns: B5,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: X5,
    defaultMatchWidth: "any",
    parsePatterns: G5,
    defaultParseWidth: "any"
  })
}, Y5 = {
  code: "ms",
  formatDistance: $5,
  formatLong: S5,
  formatRelative: O5,
  localize: F5,
  match: K5,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
};
const J5 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Y5
}, Symbol.toStringTag, { value: "Module" })), Q5 = /* @__PURE__ */ te(J5);
var e8 = {
  lessThanXSeconds: {
    one: "minder dan een seconde",
    other: "minder dan {{count}} seconden"
  },
  xSeconds: {
    one: "1 seconde",
    other: "{{count}} seconden"
  },
  halfAMinute: "een halve minuut",
  lessThanXMinutes: {
    one: "minder dan een minuut",
    other: "minder dan {{count}} minuten"
  },
  xMinutes: {
    one: "een minuut",
    other: "{{count}} minuten"
  },
  aboutXHours: {
    one: "ongeveer 1 uur",
    other: "ongeveer {{count}} uur"
  },
  xHours: {
    one: "1 uur",
    other: "{{count}} uur"
  },
  xDays: {
    one: "1 dag",
    other: "{{count}} dagen"
  },
  aboutXWeeks: {
    one: "ongeveer 1 week",
    other: "ongeveer {{count}} weken"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weken"
  },
  aboutXMonths: {
    one: "ongeveer 1 maand",
    other: "ongeveer {{count}} maanden"
  },
  xMonths: {
    one: "1 maand",
    other: "{{count}} maanden"
  },
  aboutXYears: {
    one: "ongeveer 1 jaar",
    other: "ongeveer {{count}} jaar"
  },
  xYears: {
    one: "1 jaar",
    other: "{{count}} jaar"
  },
  overXYears: {
    one: "meer dan 1 jaar",
    other: "meer dan {{count}} jaar"
  },
  almostXYears: {
    one: "bijna 1 jaar",
    other: "bijna {{count}} jaar"
  }
}, n8 = function(i, d, a) {
  var t, o = e8[i];
  return typeof o == "string" ? t = o : d === 1 ? t = o.one : t = o.other.replace("{{count}}", String(d)), a != null && a.addSuffix ? a.comparison && a.comparison > 0 ? "over " + t : t + " geleden" : t;
}, i8 = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "dd.MM.y"
}, a8 = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, t8 = {
  full: "{{date}} 'om' {{time}}",
  long: "{{date}} 'om' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, r8 = {
  date: I({
    formats: i8,
    defaultWidth: "full"
  }),
  time: I({
    formats: a8,
    defaultWidth: "full"
  }),
  dateTime: I({
    formats: t8,
    defaultWidth: "full"
  })
}, o8 = {
  lastWeek: "'vorige' eeee 'om' p",
  yesterday: "'gisteren om' p",
  today: "'vandaag om' p",
  tomorrow: "'morgen om' p",
  nextWeek: "eeee 'om' p",
  other: "P"
}, s8 = function(i, d, a, t) {
  return o8[i];
}, d8 = {
  narrow: ["v.C.", "n.C."],
  abbreviated: ["v.Chr.", "n.Chr."],
  wide: ["voor Christus", "na Christus"]
}, u8 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["K1", "K2", "K3", "K4"],
  wide: ["1e kwartaal", "2e kwartaal", "3e kwartaal", "4e kwartaal"]
}, f8 = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["jan.", "feb.", "mrt.", "apr.", "mei", "jun.", "jul.", "aug.", "sep.", "okt.", "nov.", "dec."],
  wide: ["januari", "februari", "maart", "april", "mei", "juni", "juli", "augustus", "september", "oktober", "november", "december"]
}, l8 = {
  narrow: ["Z", "M", "D", "W", "D", "V", "Z"],
  short: ["zo", "ma", "di", "wo", "do", "vr", "za"],
  abbreviated: ["zon", "maa", "din", "woe", "don", "vri", "zat"],
  wide: ["zondag", "maandag", "dinsdag", "woensdag", "donderdag", "vrijdag", "zaterdag"]
}, c8 = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "middernacht",
    noon: "het middag",
    morning: "'s ochtends",
    afternoon: "'s namiddags",
    evening: "'s avonds",
    night: "'s nachts"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "middernacht",
    noon: "het middag",
    morning: "'s ochtends",
    afternoon: "'s namiddags",
    evening: "'s avonds",
    night: "'s nachts"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "middernacht",
    noon: "het middag",
    morning: "'s ochtends",
    afternoon: "'s namiddags",
    evening: "'s avonds",
    night: "'s nachts"
  }
}, m8 = function(i, d) {
  var a = Number(i);
  return a + "e";
}, v8 = {
  ordinalNumber: m8,
  era: $({
    values: d8,
    defaultWidth: "wide"
  }),
  quarter: $({
    values: u8,
    defaultWidth: "wide",
    argumentCallback: function(i) {
      return i - 1;
    }
  }),
  month: $({
    values: f8,
    defaultWidth: "wide"
  }),
  day: $({
    values: l8,
    defaultWidth: "wide"
  }),
  dayPeriod: $({
    values: c8,
    defaultWidth: "wide"
  })
}, h8 = /^(\d+)e?/i, g8 = /\d+/i, p8 = {
  narrow: /^([vn]\.? ?C\.?)/,
  abbreviated: /^([vn]\. ?Chr\.?)/,
  wide: /^((voor|na) Christus)/
}, b8 = {
  any: [/^v/, /^n/]
}, y8 = {
  narrow: /^[1234]/i,
  abbreviated: /^K[1234]/i,
  wide: /^[1234]e kwartaal/i
}, k8 = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, w8 = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan.|feb.|mrt.|apr.|mei|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
  wide: /^(januari|februari|maart|april|mei|juni|juli|augustus|september|oktober|november|december)/i
}, _8 = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^jan/i, /^feb/i, /^m(r|a)/i, /^apr/i, /^mei/i, /^jun/i, /^jul/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i]
}, $8 = {
  narrow: /^[zmdwv]/i,
  short: /^(zo|ma|di|wo|do|vr|za)/i,
  abbreviated: /^(zon|maa|din|woe|don|vri|zat)/i,
  wide: /^(zondag|maandag|dinsdag|woensdag|donderdag|vrijdag|zaterdag)/i
}, P8 = {
  narrow: [/^z/i, /^m/i, /^d/i, /^w/i, /^d/i, /^v/i, /^z/i],
  any: [/^zo/i, /^ma/i, /^di/i, /^wo/i, /^do/i, /^vr/i, /^za/i]
}, M8 = {
  any: /^(am|pm|middernacht|het middaguur|'s (ochtends|middags|avonds|nachts))/i
}, j8 = {
  any: {
    am: /^am/i,
    pm: /^pm/i,
    midnight: /^middernacht/i,
    noon: /^het middaguur/i,
    morning: /ochtend/i,
    afternoon: /middag/i,
    evening: /avond/i,
    night: /nacht/i
  }
}, S8 = {
  ordinalNumber: le({
    matchPattern: h8,
    parsePattern: g8,
    valueCallback: function(i) {
      return parseInt(i, 10);
    }
  }),
  era: P({
    matchPatterns: p8,
    defaultMatchWidth: "wide",
    parsePatterns: b8,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: y8,
    defaultMatchWidth: "wide",
    parsePatterns: k8,
    defaultParseWidth: "any",
    valueCallback: function(i) {
      return i + 1;
    }
  }),
  month: P({
    matchPatterns: w8,
    defaultMatchWidth: "wide",
    parsePatterns: _8,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: $8,
    defaultMatchWidth: "wide",
    parsePatterns: P8,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: M8,
    defaultMatchWidth: "any",
    parsePatterns: j8,
    defaultParseWidth: "any"
  })
}, z8 = {
  code: "nl-BE",
  formatDistance: n8,
  formatLong: r8,
  formatRelative: s8,
  localize: v8,
  match: S8,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const O8 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: z8
}, Symbol.toStringTag, { value: "Module" })), W8 = /* @__PURE__ */ te(O8);
var D8 = {
  lessThanXSeconds: {
    one: "mindre enn ett sekund",
    other: "mindre enn {{count}} sekunder"
  },
  xSeconds: {
    one: "ett sekund",
    other: "{{count}} sekunder"
  },
  halfAMinute: "et halvt minutt",
  lessThanXMinutes: {
    one: "mindre enn ett minutt",
    other: "mindre enn {{count}} minutter"
  },
  xMinutes: {
    one: "ett minutt",
    other: "{{count}} minutter"
  },
  aboutXHours: {
    one: "omtrent en time",
    other: "omtrent {{count}} timer"
  },
  xHours: {
    one: "en time",
    other: "{{count}} timer"
  },
  xDays: {
    one: "en dag",
    other: "{{count}} dager"
  },
  aboutXWeeks: {
    one: "omtrent en uke",
    other: "omtrent {{count}} uker"
  },
  xWeeks: {
    one: "en uke",
    other: "{{count}} uker"
  },
  aboutXMonths: {
    one: "omtrent en måned",
    other: "omtrent {{count}} måneder"
  },
  xMonths: {
    one: "en måned",
    other: "{{count}} måneder"
  },
  aboutXYears: {
    one: "omtrent ett år",
    other: "omtrent {{count}} år"
  },
  xYears: {
    one: "ett år",
    other: "{{count}} år"
  },
  overXYears: {
    one: "over ett år",
    other: "over {{count}} år"
  },
  almostXYears: {
    one: "nesten ett år",
    other: "nesten {{count}} år"
  }
}, C8 = function(i, d, a) {
  var t, o = D8[i];
  return typeof o == "string" ? t = o : d === 1 ? t = o.one : t = o.other.replace("{{count}}", String(d)), a != null && a.addSuffix ? a.comparison && a.comparison > 0 ? "om " + t : t + " siden" : t;
}, I8 = {
  full: "EEEE d. MMMM y",
  long: "d. MMMM y",
  medium: "d. MMM y",
  short: "dd.MM.y"
}, T8 = {
  full: "'kl'. HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, N8 = {
  full: "{{date}} 'kl.' {{time}}",
  long: "{{date}} 'kl.' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, x8 = {
  date: I({
    formats: I8,
    defaultWidth: "full"
  }),
  time: I({
    formats: T8,
    defaultWidth: "full"
  }),
  dateTime: I({
    formats: N8,
    defaultWidth: "full"
  })
}, F8 = {
  lastWeek: "'forrige' eeee 'kl.' p",
  yesterday: "'i går kl.' p",
  today: "'i dag kl.' p",
  tomorrow: "'i morgen kl.' p",
  nextWeek: "EEEE 'kl.' p",
  other: "P"
}, E8 = function(i, d, a, t) {
  return F8[i];
}, R8 = {
  narrow: ["f.Kr.", "e.Kr."],
  abbreviated: ["f.Kr.", "e.Kr."],
  wide: ["før Kristus", "etter Kristus"]
}, L8 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1. kvartal", "2. kvartal", "3. kvartal", "4. kvartal"]
}, q8 = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["jan.", "feb.", "mars", "apr.", "mai", "juni", "juli", "aug.", "sep.", "okt.", "nov.", "des."],
  wide: ["januar", "februar", "mars", "april", "mai", "juni", "juli", "august", "september", "oktober", "november", "desember"]
}, Z8 = {
  narrow: ["S", "M", "T", "O", "T", "F", "L"],
  short: ["sø", "ma", "ti", "on", "to", "fr", "lø"],
  abbreviated: ["søn", "man", "tir", "ons", "tor", "fre", "lør"],
  wide: ["søndag", "mandag", "tirsdag", "onsdag", "torsdag", "fredag", "lørdag"]
}, A8 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "midnatt",
    noon: "middag",
    morning: "på morg.",
    afternoon: "på etterm.",
    evening: "på kvelden",
    night: "på natten"
  },
  abbreviated: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnatt",
    noon: "middag",
    morning: "på morg.",
    afternoon: "på etterm.",
    evening: "på kvelden",
    night: "på natten"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnatt",
    noon: "middag",
    morning: "på morgenen",
    afternoon: "på ettermiddagen",
    evening: "på kvelden",
    night: "på natten"
  }
}, V8 = function(i, d) {
  var a = Number(i);
  return a + ".";
}, H8 = {
  ordinalNumber: V8,
  era: $({
    values: R8,
    defaultWidth: "wide"
  }),
  quarter: $({
    values: L8,
    defaultWidth: "wide",
    argumentCallback: function(i) {
      return i - 1;
    }
  }),
  month: $({
    values: q8,
    defaultWidth: "wide"
  }),
  day: $({
    values: Z8,
    defaultWidth: "wide"
  }),
  dayPeriod: $({
    values: A8,
    defaultWidth: "wide"
  })
}, U8 = /^(\d+)\.?/i, B8 = /\d+/i, X8 = {
  narrow: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
  abbreviated: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
  wide: /^(før Kristus|før vår tid|etter Kristus|vår tid)/i
}, G8 = {
  any: [/^f/i, /^e/i]
}, K8 = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](\.)? kvartal/i
}, Y8 = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, J8 = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mars?|apr|mai|juni?|juli?|aug|sep|okt|nov|des)\.?/i,
  wide: /^(januar|februar|mars|april|mai|juni|juli|august|september|oktober|november|desember)/i
}, Q8 = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^mai/i, /^jun/i, /^jul/i, /^aug/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, e7 = {
  narrow: /^[smtofl]/i,
  short: /^(sø|ma|ti|on|to|fr|lø)/i,
  abbreviated: /^(søn|man|tir|ons|tor|fre|lør)/i,
  wide: /^(søndag|mandag|tirsdag|onsdag|torsdag|fredag|lørdag)/i
}, n7 = {
  any: [/^s/i, /^m/i, /^ti/i, /^o/i, /^to/i, /^f/i, /^l/i]
}, i7 = {
  narrow: /^(midnatt|middag|(på) (morgenen|ettermiddagen|kvelden|natten)|[ap])/i,
  any: /^([ap]\.?\s?m\.?|midnatt|middag|(på) (morgenen|ettermiddagen|kvelden|natten))/i
}, a7 = {
  any: {
    am: /^a(\.?\s?m\.?)?$/i,
    pm: /^p(\.?\s?m\.?)?$/i,
    midnight: /^midn/i,
    noon: /^midd/i,
    morning: /morgen/i,
    afternoon: /ettermiddag/i,
    evening: /kveld/i,
    night: /natt/i
  }
}, t7 = {
  ordinalNumber: le({
    matchPattern: U8,
    parsePattern: B8,
    valueCallback: function(i) {
      return parseInt(i, 10);
    }
  }),
  era: P({
    matchPatterns: X8,
    defaultMatchWidth: "wide",
    parsePatterns: G8,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: K8,
    defaultMatchWidth: "wide",
    parsePatterns: Y8,
    defaultParseWidth: "any",
    valueCallback: function(i) {
      return i + 1;
    }
  }),
  month: P({
    matchPatterns: J8,
    defaultMatchWidth: "wide",
    parsePatterns: Q8,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: e7,
    defaultMatchWidth: "wide",
    parsePatterns: n7,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: i7,
    defaultMatchWidth: "any",
    parsePatterns: a7,
    defaultParseWidth: "any"
  })
}, r7 = {
  code: "nb",
  formatDistance: C8,
  formatLong: x8,
  formatRelative: E8,
  localize: H8,
  match: t7,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const o7 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: r7
}, Symbol.toStringTag, { value: "Module" })), s7 = /* @__PURE__ */ te(o7);
var d7 = {
  lessThanXSeconds: {
    one: "mindre enn eitt sekund",
    other: "mindre enn {{count}} sekund"
  },
  xSeconds: {
    one: "eitt sekund",
    other: "{{count}} sekund"
  },
  halfAMinute: "eit halvt minutt",
  lessThanXMinutes: {
    one: "mindre enn eitt minutt",
    other: "mindre enn {{count}} minutt"
  },
  xMinutes: {
    one: "eitt minutt",
    other: "{{count}} minutt"
  },
  aboutXHours: {
    one: "omtrent ein time",
    other: "omtrent {{count}} timar"
  },
  xHours: {
    one: "ein time",
    other: "{{count}} timar"
  },
  xDays: {
    one: "ein dag",
    other: "{{count}} dagar"
  },
  aboutXWeeks: {
    one: "omtrent ei veke",
    other: "omtrent {{count}} veker"
  },
  xWeeks: {
    one: "ei veke",
    other: "{{count}} veker"
  },
  aboutXMonths: {
    one: "omtrent ein månad",
    other: "omtrent {{count}} månader"
  },
  xMonths: {
    one: "ein månad",
    other: "{{count}} månader"
  },
  aboutXYears: {
    one: "omtrent eitt år",
    other: "omtrent {{count}} år"
  },
  xYears: {
    one: "eitt år",
    other: "{{count}} år"
  },
  overXYears: {
    one: "over eitt år",
    other: "over {{count}} år"
  },
  almostXYears: {
    one: "nesten eitt år",
    other: "nesten {{count}} år"
  }
}, u7 = ["null", "ein", "to", "tre", "fire", "fem", "seks", "sju", "åtte", "ni", "ti", "elleve", "tolv"], f7 = function(i, d, a) {
  var t, o = d7[i];
  return typeof o == "string" ? t = o : d === 1 ? t = o.one : a && a.onlyNumeric ? t = o.other.replace("{{count}}", String(d)) : t = o.other.replace("{{count}}", d < 13 ? u7[d] : String(d)), a != null && a.addSuffix ? a.comparison && a.comparison > 0 ? "om " + t : t + " sidan" : t;
}, l7 = {
  full: "EEEE d. MMMM y",
  long: "d. MMMM y",
  medium: "d. MMM y",
  short: "dd.MM.y"
}, c7 = {
  full: "'kl'. HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, m7 = {
  full: "{{date}} 'kl.' {{time}}",
  long: "{{date}} 'kl.' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, v7 = {
  date: I({
    formats: l7,
    defaultWidth: "full"
  }),
  time: I({
    formats: c7,
    defaultWidth: "full"
  }),
  dateTime: I({
    formats: m7,
    defaultWidth: "full"
  })
}, h7 = {
  lastWeek: "'førre' eeee 'kl.' p",
  yesterday: "'i går kl.' p",
  today: "'i dag kl.' p",
  tomorrow: "'i morgon kl.' p",
  nextWeek: "EEEE 'kl.' p",
  other: "P"
}, g7 = function(i, d, a, t) {
  return h7[i];
}, p7 = {
  narrow: ["f.Kr.", "e.Kr."],
  abbreviated: ["f.Kr.", "e.Kr."],
  wide: ["før Kristus", "etter Kristus"]
}, b7 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1. kvartal", "2. kvartal", "3. kvartal", "4. kvartal"]
}, y7 = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["jan.", "feb.", "mars", "apr.", "mai", "juni", "juli", "aug.", "sep.", "okt.", "nov.", "des."],
  wide: ["januar", "februar", "mars", "april", "mai", "juni", "juli", "august", "september", "oktober", "november", "desember"]
}, k7 = {
  narrow: ["S", "M", "T", "O", "T", "F", "L"],
  short: ["su", "må", "ty", "on", "to", "fr", "lau"],
  abbreviated: ["sun", "mån", "tys", "ons", "tor", "fre", "laur"],
  wide: ["sundag", "måndag", "tysdag", "onsdag", "torsdag", "fredag", "laurdag"]
}, w7 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "midnatt",
    noon: "middag",
    morning: "på morg.",
    afternoon: "på etterm.",
    evening: "på kvelden",
    night: "på natta"
  },
  abbreviated: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnatt",
    noon: "middag",
    morning: "på morg.",
    afternoon: "på etterm.",
    evening: "på kvelden",
    night: "på natta"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnatt",
    noon: "middag",
    morning: "på morgonen",
    afternoon: "på ettermiddagen",
    evening: "på kvelden",
    night: "på natta"
  }
}, _7 = function(i, d) {
  var a = Number(i);
  return a + ".";
}, $7 = {
  ordinalNumber: _7,
  era: $({
    values: p7,
    defaultWidth: "wide"
  }),
  quarter: $({
    values: b7,
    defaultWidth: "wide",
    argumentCallback: function(i) {
      return i - 1;
    }
  }),
  month: $({
    values: y7,
    defaultWidth: "wide"
  }),
  day: $({
    values: k7,
    defaultWidth: "wide"
  }),
  dayPeriod: $({
    values: w7,
    defaultWidth: "wide"
  })
}, P7 = /^(\d+)\.?/i, M7 = /\d+/i, j7 = {
  narrow: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
  abbreviated: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
  wide: /^(før Kristus|før vår tid|etter Kristus|vår tid)/i
}, S7 = {
  any: [/^f/i, /^e/i]
}, z7 = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](\.)? kvartal/i
}, O7 = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, W7 = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mars?|apr|mai|juni?|juli?|aug|sep|okt|nov|des)\.?/i,
  wide: /^(januar|februar|mars|april|mai|juni|juli|august|september|oktober|november|desember)/i
}, D7 = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^mai/i, /^jun/i, /^jul/i, /^aug/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, C7 = {
  narrow: /^[smtofl]/i,
  short: /^(su|må|ty|on|to|fr|la)/i,
  abbreviated: /^(sun|mån|tys|ons|tor|fre|laur)/i,
  wide: /^(sundag|måndag|tysdag|onsdag|torsdag|fredag|laurdag)/i
}, I7 = {
  any: [/^s/i, /^m/i, /^ty/i, /^o/i, /^to/i, /^f/i, /^l/i]
}, T7 = {
  narrow: /^(midnatt|middag|(på) (morgonen|ettermiddagen|kvelden|natta)|[ap])/i,
  any: /^([ap]\.?\s?m\.?|midnatt|middag|(på) (morgonen|ettermiddagen|kvelden|natta))/i
}, N7 = {
  any: {
    am: /^a(\.?\s?m\.?)?$/i,
    pm: /^p(\.?\s?m\.?)?$/i,
    midnight: /^midn/i,
    noon: /^midd/i,
    morning: /morgon/i,
    afternoon: /ettermiddag/i,
    evening: /kveld/i,
    night: /natt/i
  }
}, x7 = {
  ordinalNumber: le({
    matchPattern: P7,
    parsePattern: M7,
    valueCallback: function(i) {
      return parseInt(i, 10);
    }
  }),
  era: P({
    matchPatterns: j7,
    defaultMatchWidth: "wide",
    parsePatterns: S7,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: z7,
    defaultMatchWidth: "wide",
    parsePatterns: O7,
    defaultParseWidth: "any",
    valueCallback: function(i) {
      return i + 1;
    }
  }),
  month: P({
    matchPatterns: W7,
    defaultMatchWidth: "wide",
    parsePatterns: D7,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: C7,
    defaultMatchWidth: "wide",
    parsePatterns: I7,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: T7,
    defaultMatchWidth: "any",
    parsePatterns: N7,
    defaultParseWidth: "any"
  })
}, F7 = {
  code: "nn",
  formatDistance: f7,
  formatLong: v7,
  formatRelative: g7,
  localize: $7,
  match: x7,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const E7 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: F7
}, Symbol.toStringTag, { value: "Module" })), R7 = /* @__PURE__ */ te(E7);
var L7 = {
  lessThanXSeconds: {
    one: {
      regular: "mniej niż sekunda",
      past: "mniej niż sekundę",
      future: "mniej niż sekundę"
    },
    twoFour: "mniej niż {{count}} sekundy",
    other: "mniej niż {{count}} sekund"
  },
  xSeconds: {
    one: {
      regular: "sekunda",
      past: "sekundę",
      future: "sekundę"
    },
    twoFour: "{{count}} sekundy",
    other: "{{count}} sekund"
  },
  halfAMinute: {
    one: "pół minuty",
    twoFour: "pół minuty",
    other: "pół minuty"
  },
  lessThanXMinutes: {
    one: {
      regular: "mniej niż minuta",
      past: "mniej niż minutę",
      future: "mniej niż minutę"
    },
    twoFour: "mniej niż {{count}} minuty",
    other: "mniej niż {{count}} minut"
  },
  xMinutes: {
    one: {
      regular: "minuta",
      past: "minutę",
      future: "minutę"
    },
    twoFour: "{{count}} minuty",
    other: "{{count}} minut"
  },
  aboutXHours: {
    one: {
      regular: "około godziny",
      past: "około godziny",
      future: "około godzinę"
    },
    twoFour: "około {{count}} godziny",
    other: "około {{count}} godzin"
  },
  xHours: {
    one: {
      regular: "godzina",
      past: "godzinę",
      future: "godzinę"
    },
    twoFour: "{{count}} godziny",
    other: "{{count}} godzin"
  },
  xDays: {
    one: {
      regular: "dzień",
      past: "dzień",
      future: "1 dzień"
    },
    twoFour: "{{count}} dni",
    other: "{{count}} dni"
  },
  aboutXWeeks: {
    one: "około tygodnia",
    twoFour: "około {{count}} tygodni",
    other: "około {{count}} tygodni"
  },
  xWeeks: {
    one: "tydzień",
    twoFour: "{{count}} tygodnie",
    other: "{{count}} tygodni"
  },
  aboutXMonths: {
    one: "około miesiąc",
    twoFour: "około {{count}} miesiące",
    other: "około {{count}} miesięcy"
  },
  xMonths: {
    one: "miesiąc",
    twoFour: "{{count}} miesiące",
    other: "{{count}} miesięcy"
  },
  aboutXYears: {
    one: "około rok",
    twoFour: "około {{count}} lata",
    other: "około {{count}} lat"
  },
  xYears: {
    one: "rok",
    twoFour: "{{count}} lata",
    other: "{{count}} lat"
  },
  overXYears: {
    one: "ponad rok",
    twoFour: "ponad {{count}} lata",
    other: "ponad {{count}} lat"
  },
  almostXYears: {
    one: "prawie rok",
    twoFour: "prawie {{count}} lata",
    other: "prawie {{count}} lat"
  }
};
function q7(e, i) {
  if (i === 1)
    return e.one;
  var d = i % 100;
  if (d <= 20 && d > 10)
    return e.other;
  var a = d % 10;
  return a >= 2 && a <= 4 ? e.twoFour : e.other;
}
function Ot(e, i, d) {
  var a = q7(e, i), t = typeof a == "string" ? a : a[d];
  return t.replace("{{count}}", String(i));
}
var Z7 = function(i, d, a) {
  var t = L7[i];
  return a != null && a.addSuffix ? a.comparison && a.comparison > 0 ? "za " + Ot(t, d, "future") : Ot(t, d, "past") + " temu" : Ot(t, d, "regular");
}, A7 = {
  full: "EEEE, do MMMM y",
  long: "do MMMM y",
  medium: "do MMM y",
  short: "dd.MM.y"
}, V7 = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, H7 = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, U7 = {
  date: I({
    formats: A7,
    defaultWidth: "full"
  }),
  time: I({
    formats: V7,
    defaultWidth: "full"
  }),
  dateTime: I({
    formats: H7,
    defaultWidth: "full"
  })
}, B7 = {
  masculine: "ostatni",
  feminine: "ostatnia"
}, X7 = {
  masculine: "ten",
  feminine: "ta"
}, G7 = {
  masculine: "następny",
  feminine: "następna"
}, K7 = {
  0: "feminine",
  1: "masculine",
  2: "masculine",
  3: "feminine",
  4: "masculine",
  5: "masculine",
  6: "feminine"
};
function ld(e, i, d, a) {
  var t;
  if (Ne(i, d, a))
    t = X7;
  else if (e === "lastWeek")
    t = B7;
  else if (e === "nextWeek")
    t = G7;
  else
    throw new Error("Cannot determine adjectives for token ".concat(e));
  var o = i.getUTCDay(), m = K7[o], p = t[m];
  return "'".concat(p, "' eeee 'o' p");
}
var Y7 = {
  lastWeek: ld,
  yesterday: "'wczoraj o' p",
  today: "'dzisiaj o' p",
  tomorrow: "'jutro o' p",
  nextWeek: ld,
  other: "P"
}, J7 = function(i, d, a, t) {
  var o = Y7[i];
  return typeof o == "function" ? o(i, d, a, t) : o;
}, Q7 = {
  narrow: ["p.n.e.", "n.e."],
  abbreviated: ["p.n.e.", "n.e."],
  wide: ["przed naszą erą", "naszej ery"]
}, eC = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["I kw.", "II kw.", "III kw.", "IV kw."],
  wide: ["I kwartał", "II kwartał", "III kwartał", "IV kwartał"]
}, nC = {
  narrow: ["S", "L", "M", "K", "M", "C", "L", "S", "W", "P", "L", "G"],
  abbreviated: ["sty", "lut", "mar", "kwi", "maj", "cze", "lip", "sie", "wrz", "paź", "lis", "gru"],
  wide: ["styczeń", "luty", "marzec", "kwiecień", "maj", "czerwiec", "lipiec", "sierpień", "wrzesień", "październik", "listopad", "grudzień"]
}, iC = {
  narrow: ["s", "l", "m", "k", "m", "c", "l", "s", "w", "p", "l", "g"],
  abbreviated: ["sty", "lut", "mar", "kwi", "maj", "cze", "lip", "sie", "wrz", "paź", "lis", "gru"],
  wide: ["stycznia", "lutego", "marca", "kwietnia", "maja", "czerwca", "lipca", "sierpnia", "września", "października", "listopada", "grudnia"]
}, aC = {
  narrow: ["N", "P", "W", "Ś", "C", "P", "S"],
  short: ["nie", "pon", "wto", "śro", "czw", "pią", "sob"],
  abbreviated: ["niedz.", "pon.", "wt.", "śr.", "czw.", "pt.", "sob."],
  wide: ["niedziela", "poniedziałek", "wtorek", "środa", "czwartek", "piątek", "sobota"]
}, tC = {
  narrow: ["n", "p", "w", "ś", "c", "p", "s"],
  short: ["nie", "pon", "wto", "śro", "czw", "pią", "sob"],
  abbreviated: ["niedz.", "pon.", "wt.", "śr.", "czw.", "pt.", "sob."],
  wide: ["niedziela", "poniedziałek", "wtorek", "środa", "czwartek", "piątek", "sobota"]
}, rC = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "półn.",
    noon: "poł",
    morning: "rano",
    afternoon: "popoł.",
    evening: "wiecz.",
    night: "noc"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "północ",
    noon: "południe",
    morning: "rano",
    afternoon: "popołudnie",
    evening: "wieczór",
    night: "noc"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "północ",
    noon: "południe",
    morning: "rano",
    afternoon: "popołudnie",
    evening: "wieczór",
    night: "noc"
  }
}, oC = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "o półn.",
    noon: "w poł.",
    morning: "rano",
    afternoon: "po poł.",
    evening: "wiecz.",
    night: "w nocy"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "o północy",
    noon: "w południe",
    morning: "rano",
    afternoon: "po południu",
    evening: "wieczorem",
    night: "w nocy"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "o północy",
    noon: "w południe",
    morning: "rano",
    afternoon: "po południu",
    evening: "wieczorem",
    night: "w nocy"
  }
}, sC = function(i, d) {
  return String(i);
}, dC = {
  ordinalNumber: sC,
  era: $({
    values: Q7,
    defaultWidth: "wide"
  }),
  quarter: $({
    values: eC,
    defaultWidth: "wide",
    argumentCallback: function(i) {
      return i - 1;
    }
  }),
  month: $({
    values: nC,
    defaultWidth: "wide",
    formattingValues: iC,
    defaultFormattingWidth: "wide"
  }),
  day: $({
    values: aC,
    defaultWidth: "wide",
    formattingValues: tC,
    defaultFormattingWidth: "wide"
  }),
  dayPeriod: $({
    values: rC,
    defaultWidth: "wide",
    formattingValues: oC,
    defaultFormattingWidth: "wide"
  })
}, uC = /^(\d+)?/i, fC = /\d+/i, lC = {
  narrow: /^(p\.?\s*n\.?\s*e\.?\s*|n\.?\s*e\.?\s*)/i,
  abbreviated: /^(p\.?\s*n\.?\s*e\.?\s*|n\.?\s*e\.?\s*)/i,
  wide: /^(przed\s*nasz(ą|a)\s*er(ą|a)|naszej\s*ery)/i
}, cC = {
  any: [/^p/i, /^n/i]
}, mC = {
  narrow: /^[1234]/i,
  abbreviated: /^(I|II|III|IV)\s*kw\.?/i,
  wide: /^(I|II|III|IV)\s*kwarta(ł|l)/i
}, vC = {
  narrow: [/1/i, /2/i, /3/i, /4/i],
  any: [/^I kw/i, /^II kw/i, /^III kw/i, /^IV kw/i]
}, hC = {
  narrow: /^[slmkcwpg]/i,
  abbreviated: /^(sty|lut|mar|kwi|maj|cze|lip|sie|wrz|pa(ź|z)|lis|gru)/i,
  wide: /^(stycznia|stycze(ń|n)|lutego|luty|marca|marzec|kwietnia|kwiecie(ń|n)|maja|maj|czerwca|czerwiec|lipca|lipiec|sierpnia|sierpie(ń|n)|wrze(ś|s)nia|wrzesie(ń|n)|pa(ź|z)dziernika|pa(ź|z)dziernik|listopada|listopad|grudnia|grudzie(ń|n))/i
}, gC = {
  narrow: [/^s/i, /^l/i, /^m/i, /^k/i, /^m/i, /^c/i, /^l/i, /^s/i, /^w/i, /^p/i, /^l/i, /^g/i],
  any: [/^st/i, /^lu/i, /^mar/i, /^k/i, /^maj/i, /^c/i, /^lip/i, /^si/i, /^w/i, /^p/i, /^lis/i, /^g/i]
}, pC = {
  narrow: /^[npwścs]/i,
  short: /^(nie|pon|wto|(ś|s)ro|czw|pi(ą|a)|sob)/i,
  abbreviated: /^(niedz|pon|wt|(ś|s)r|czw|pt|sob)\.?/i,
  wide: /^(niedziela|poniedzia(ł|l)ek|wtorek|(ś|s)roda|czwartek|pi(ą|a)tek|sobota)/i
}, bC = {
  narrow: [/^n/i, /^p/i, /^w/i, /^ś/i, /^c/i, /^p/i, /^s/i],
  abbreviated: [/^n/i, /^po/i, /^w/i, /^(ś|s)r/i, /^c/i, /^pt/i, /^so/i],
  any: [/^n/i, /^po/i, /^w/i, /^(ś|s)r/i, /^c/i, /^pi/i, /^so/i]
}, yC = {
  narrow: /^(^a$|^p$|pó(ł|l)n\.?|o\s*pó(ł|l)n\.?|po(ł|l)\.?|w\s*po(ł|l)\.?|po\s*po(ł|l)\.?|rano|wiecz\.?|noc|w\s*nocy)/i,
  any: /^(am|pm|pó(ł|l)noc|o\s*pó(ł|l)nocy|po(ł|l)udnie|w\s*po(ł|l)udnie|popo(ł|l)udnie|po\s*po(ł|l)udniu|rano|wieczór|wieczorem|noc|w\s*nocy)/i
}, kC = {
  narrow: {
    am: /^a$/i,
    pm: /^p$/i,
    midnight: /pó(ł|l)n/i,
    noon: /po(ł|l)/i,
    morning: /rano/i,
    afternoon: /po\s*po(ł|l)/i,
    evening: /wiecz/i,
    night: /noc/i
  },
  any: {
    am: /^am/i,
    pm: /^pm/i,
    midnight: /pó(ł|l)n/i,
    noon: /po(ł|l)/i,
    morning: /rano/i,
    afternoon: /po\s*po(ł|l)/i,
    evening: /wiecz/i,
    night: /noc/i
  }
}, wC = {
  ordinalNumber: le({
    matchPattern: uC,
    parsePattern: fC,
    valueCallback: function(i) {
      return parseInt(i, 10);
    }
  }),
  era: P({
    matchPatterns: lC,
    defaultMatchWidth: "wide",
    parsePatterns: cC,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: mC,
    defaultMatchWidth: "wide",
    parsePatterns: vC,
    defaultParseWidth: "any",
    valueCallback: function(i) {
      return i + 1;
    }
  }),
  month: P({
    matchPatterns: hC,
    defaultMatchWidth: "wide",
    parsePatterns: gC,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: pC,
    defaultMatchWidth: "wide",
    parsePatterns: bC,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: yC,
    defaultMatchWidth: "any",
    parsePatterns: kC,
    defaultParseWidth: "any"
  })
}, _C = {
  code: "pl",
  formatDistance: Z7,
  formatLong: U7,
  formatRelative: J7,
  localize: dC,
  match: wC,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const $C = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: _C
}, Symbol.toStringTag, { value: "Module" })), PC = /* @__PURE__ */ te($C);
var MC = {
  lessThanXSeconds: {
    one: "menos de um segundo",
    other: "menos de {{count}} segundos"
  },
  xSeconds: {
    one: "1 segundo",
    other: "{{count}} segundos"
  },
  halfAMinute: "meio minuto",
  lessThanXMinutes: {
    one: "menos de um minuto",
    other: "menos de {{count}} minutos"
  },
  xMinutes: {
    one: "1 minuto",
    other: "{{count}} minutos"
  },
  aboutXHours: {
    one: "aproximadamente 1 hora",
    other: "aproximadamente {{count}} horas"
  },
  xHours: {
    one: "1 hora",
    other: "{{count}} horas"
  },
  xDays: {
    one: "1 dia",
    other: "{{count}} dias"
  },
  aboutXWeeks: {
    one: "aproximadamente 1 semana",
    other: "aproximadamente {{count}} semanas"
  },
  xWeeks: {
    one: "1 semana",
    other: "{{count}} semanas"
  },
  aboutXMonths: {
    one: "aproximadamente 1 mês",
    other: "aproximadamente {{count}} meses"
  },
  xMonths: {
    one: "1 mês",
    other: "{{count}} meses"
  },
  aboutXYears: {
    one: "aproximadamente 1 ano",
    other: "aproximadamente {{count}} anos"
  },
  xYears: {
    one: "1 ano",
    other: "{{count}} anos"
  },
  overXYears: {
    one: "mais de 1 ano",
    other: "mais de {{count}} anos"
  },
  almostXYears: {
    one: "quase 1 ano",
    other: "quase {{count}} anos"
  }
}, jC = function(i, d, a) {
  var t, o = MC[i];
  return typeof o == "string" ? t = o : d === 1 ? t = o.one : t = o.other.replace("{{count}}", String(d)), a != null && a.addSuffix ? a.comparison && a.comparison > 0 ? "daqui a " + t : "há " + t : t;
}, SC = {
  full: "EEEE, d 'de' MMMM 'de' y",
  long: "d 'de' MMMM 'de' y",
  medium: "d 'de' MMM 'de' y",
  short: "dd/MM/y"
}, zC = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, OC = {
  full: "{{date}} 'às' {{time}}",
  long: "{{date}} 'às' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, WC = {
  date: I({
    formats: SC,
    defaultWidth: "full"
  }),
  time: I({
    formats: zC,
    defaultWidth: "full"
  }),
  dateTime: I({
    formats: OC,
    defaultWidth: "full"
  })
}, DC = {
  lastWeek: function(i) {
    var d = i.getUTCDay(), a = d === 0 || d === 6 ? "último" : "última";
    return "'" + a + "' eeee 'às' p";
  },
  yesterday: "'ontem às' p",
  today: "'hoje às' p",
  tomorrow: "'amanhã às' p",
  nextWeek: "eeee 'às' p",
  other: "P"
}, CC = function(i, d, a, t) {
  var o = DC[i];
  return typeof o == "function" ? o(d) : o;
}, IC = {
  narrow: ["aC", "dC"],
  abbreviated: ["a.C.", "d.C."],
  wide: ["antes de Cristo", "depois de Cristo"]
}, TC = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["T1", "T2", "T3", "T4"],
  wide: ["1º trimestre", "2º trimestre", "3º trimestre", "4º trimestre"]
}, NC = {
  narrow: ["j", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
  abbreviated: ["jan", "fev", "mar", "abr", "mai", "jun", "jul", "ago", "set", "out", "nov", "dez"],
  wide: ["janeiro", "fevereiro", "março", "abril", "maio", "junho", "julho", "agosto", "setembro", "outubro", "novembro", "dezembro"]
}, xC = {
  narrow: ["d", "s", "t", "q", "q", "s", "s"],
  short: ["dom", "seg", "ter", "qua", "qui", "sex", "sáb"],
  abbreviated: ["dom", "seg", "ter", "qua", "qui", "sex", "sáb"],
  wide: ["domingo", "segunda-feira", "terça-feira", "quarta-feira", "quinta-feira", "sexta-feira", "sábado"]
}, FC = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "manhã",
    afternoon: "tarde",
    evening: "noite",
    night: "madrugada"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "manhã",
    afternoon: "tarde",
    evening: "noite",
    night: "madrugada"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "manhã",
    afternoon: "tarde",
    evening: "noite",
    night: "madrugada"
  }
}, EC = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "da manhã",
    afternoon: "da tarde",
    evening: "da noite",
    night: "da madrugada"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "da manhã",
    afternoon: "da tarde",
    evening: "da noite",
    night: "da madrugada"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "da manhã",
    afternoon: "da tarde",
    evening: "da noite",
    night: "da madrugada"
  }
}, RC = function(i, d) {
  var a = Number(i);
  return a + "º";
}, LC = {
  ordinalNumber: RC,
  era: $({
    values: IC,
    defaultWidth: "wide"
  }),
  quarter: $({
    values: TC,
    defaultWidth: "wide",
    argumentCallback: function(i) {
      return i - 1;
    }
  }),
  month: $({
    values: NC,
    defaultWidth: "wide"
  }),
  day: $({
    values: xC,
    defaultWidth: "wide"
  }),
  dayPeriod: $({
    values: FC,
    defaultWidth: "wide",
    formattingValues: EC,
    defaultFormattingWidth: "wide"
  })
}, qC = /^(\d+)(º|ª)?/i, ZC = /\d+/i, AC = {
  narrow: /^(ac|dc|a|d)/i,
  abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
  wide: /^(antes de cristo|antes da era comum|depois de cristo|era comum)/i
}, VC = {
  any: [/^ac/i, /^dc/i],
  wide: [/^(antes de cristo|antes da era comum)/i, /^(depois de cristo|era comum)/i]
}, HC = {
  narrow: /^[1234]/i,
  abbreviated: /^T[1234]/i,
  wide: /^[1234](º|ª)? trimestre/i
}, UC = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, BC = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|fev|mar|abr|mai|jun|jul|ago|set|out|nov|dez)/i,
  wide: /^(janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro)/i
}, XC = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ab/i, /^mai/i, /^jun/i, /^jul/i, /^ag/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, GC = {
  narrow: /^[dstq]/i,
  short: /^(dom|seg|ter|qua|qui|sex|s[áa]b)/i,
  abbreviated: /^(dom|seg|ter|qua|qui|sex|s[áa]b)/i,
  wide: /^(domingo|segunda-?\s?feira|terça-?\s?feira|quarta-?\s?feira|quinta-?\s?feira|sexta-?\s?feira|s[áa]bado)/i
}, KC = {
  narrow: [/^d/i, /^s/i, /^t/i, /^q/i, /^q/i, /^s/i, /^s/i],
  any: [/^d/i, /^seg/i, /^t/i, /^qua/i, /^qui/i, /^sex/i, /^s[áa]/i]
}, YC = {
  narrow: /^(a|p|meia-?\s?noite|meio-?\s?dia|(da) (manh[ãa]|tarde|noite|madrugada))/i,
  any: /^([ap]\.?\s?m\.?|meia-?\s?noite|meio-?\s?dia|(da) (manh[ãa]|tarde|noite|madrugada))/i
}, JC = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^meia/i,
    noon: /^meio/i,
    morning: /manh[ãa]/i,
    afternoon: /tarde/i,
    evening: /noite/i,
    night: /madrugada/i
  }
}, QC = {
  ordinalNumber: le({
    matchPattern: qC,
    parsePattern: ZC,
    valueCallback: function(i) {
      return parseInt(i, 10);
    }
  }),
  era: P({
    matchPatterns: AC,
    defaultMatchWidth: "wide",
    parsePatterns: VC,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: HC,
    defaultMatchWidth: "wide",
    parsePatterns: UC,
    defaultParseWidth: "any",
    valueCallback: function(i) {
      return i + 1;
    }
  }),
  month: P({
    matchPatterns: BC,
    defaultMatchWidth: "wide",
    parsePatterns: XC,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: GC,
    defaultMatchWidth: "wide",
    parsePatterns: KC,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: YC,
    defaultMatchWidth: "any",
    parsePatterns: JC,
    defaultParseWidth: "any"
  })
}, eI = {
  code: "pt",
  formatDistance: jC,
  formatLong: WC,
  formatRelative: CC,
  localize: LC,
  match: QC,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const nI = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: eI
}, Symbol.toStringTag, { value: "Module" })), iI = /* @__PURE__ */ te(nI);
var aI = {
  lessThanXSeconds: {
    one: "mai puțin de o secundă",
    other: "mai puțin de {{count}} secunde"
  },
  xSeconds: {
    one: "1 secundă",
    other: "{{count}} secunde"
  },
  halfAMinute: "jumătate de minut",
  lessThanXMinutes: {
    one: "mai puțin de un minut",
    other: "mai puțin de {{count}} minute"
  },
  xMinutes: {
    one: "1 minut",
    other: "{{count}} minute"
  },
  aboutXHours: {
    one: "circa 1 oră",
    other: "circa {{count}} ore"
  },
  xHours: {
    one: "1 oră",
    other: "{{count}} ore"
  },
  xDays: {
    one: "1 zi",
    other: "{{count}} zile"
  },
  aboutXWeeks: {
    one: "circa o săptămână",
    other: "circa {{count}} săptămâni"
  },
  xWeeks: {
    one: "1 săptămână",
    other: "{{count}} săptămâni"
  },
  aboutXMonths: {
    one: "circa 1 lună",
    other: "circa {{count}} luni"
  },
  xMonths: {
    one: "1 lună",
    other: "{{count}} luni"
  },
  aboutXYears: {
    one: "circa 1 an",
    other: "circa {{count}} ani"
  },
  xYears: {
    one: "1 an",
    other: "{{count}} ani"
  },
  overXYears: {
    one: "peste 1 an",
    other: "peste {{count}} ani"
  },
  almostXYears: {
    one: "aproape 1 an",
    other: "aproape {{count}} ani"
  }
}, tI = function(i, d, a) {
  var t, o = aI[i];
  return typeof o == "string" ? t = o : d === 1 ? t = o.one : t = o.other.replace("{{count}}", String(d)), a != null && a.addSuffix ? a.comparison && a.comparison > 0 ? "în " + t : t + " în urmă" : t;
}, rI = {
  full: "EEEE, d MMMM yyyy",
  long: "d MMMM yyyy",
  medium: "d MMM yyyy",
  short: "dd.MM.yyyy"
}, oI = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, sI = {
  full: "{{date}} 'la' {{time}}",
  long: "{{date}} 'la' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, dI = {
  date: I({
    formats: rI,
    defaultWidth: "full"
  }),
  time: I({
    formats: oI,
    defaultWidth: "full"
  }),
  dateTime: I({
    formats: sI,
    defaultWidth: "full"
  })
}, uI = {
  lastWeek: "eeee 'trecută la' p",
  yesterday: "'ieri la' p",
  today: "'astăzi la' p",
  tomorrow: "'mâine la' p",
  nextWeek: "eeee 'viitoare la' p",
  other: "P"
}, fI = function(i, d, a, t) {
  return uI[i];
}, lI = {
  narrow: ["Î", "D"],
  abbreviated: ["Î.d.C.", "D.C."],
  wide: ["Înainte de Cristos", "După Cristos"]
}, cI = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["T1", "T2", "T3", "T4"],
  wide: ["primul trimestru", "al doilea trimestru", "al treilea trimestru", "al patrulea trimestru"]
}, mI = {
  narrow: ["I", "F", "M", "A", "M", "I", "I", "A", "S", "O", "N", "D"],
  abbreviated: ["ian", "feb", "mar", "apr", "mai", "iun", "iul", "aug", "sep", "oct", "noi", "dec"],
  wide: ["ianuarie", "februarie", "martie", "aprilie", "mai", "iunie", "iulie", "august", "septembrie", "octombrie", "noiembrie", "decembrie"]
}, vI = {
  narrow: ["d", "l", "m", "m", "j", "v", "s"],
  short: ["du", "lu", "ma", "mi", "jo", "vi", "sâ"],
  abbreviated: ["dum", "lun", "mar", "mie", "joi", "vin", "sâm"],
  wide: ["duminică", "luni", "marți", "miercuri", "joi", "vineri", "sâmbătă"]
}, hI = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mn",
    noon: "ami",
    morning: "dim",
    afternoon: "da",
    evening: "s",
    night: "n"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "miezul nopții",
    noon: "amiază",
    morning: "dimineață",
    afternoon: "după-amiază",
    evening: "seară",
    night: "noapte"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "miezul nopții",
    noon: "amiază",
    morning: "dimineață",
    afternoon: "după-amiază",
    evening: "seară",
    night: "noapte"
  }
}, gI = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mn",
    noon: "amiază",
    morning: "dimineață",
    afternoon: "după-amiază",
    evening: "seară",
    night: "noapte"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "miezul nopții",
    noon: "amiază",
    morning: "dimineață",
    afternoon: "după-amiază",
    evening: "seară",
    night: "noapte"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "miezul nopții",
    noon: "amiază",
    morning: "dimineață",
    afternoon: "după-amiază",
    evening: "seară",
    night: "noapte"
  }
}, pI = function(i, d) {
  return String(i);
}, bI = {
  ordinalNumber: pI,
  era: $({
    values: lI,
    defaultWidth: "wide"
  }),
  quarter: $({
    values: cI,
    defaultWidth: "wide",
    argumentCallback: function(i) {
      return i - 1;
    }
  }),
  month: $({
    values: mI,
    defaultWidth: "wide"
  }),
  day: $({
    values: vI,
    defaultWidth: "wide"
  }),
  dayPeriod: $({
    values: hI,
    defaultWidth: "wide",
    formattingValues: gI,
    defaultFormattingWidth: "wide"
  })
}, yI = /^(\d+)?/i, kI = /\d+/i, wI = {
  narrow: /^(Î|D)/i,
  abbreviated: /^(Î\.?\s?d\.?\s?C\.?|Î\.?\s?e\.?\s?n\.?|D\.?\s?C\.?|e\.?\s?n\.?)/i,
  wide: /^(Înainte de Cristos|Înaintea erei noastre|După Cristos|Era noastră)/i
}, _I = {
  any: [/^ÎC/i, /^DC/i],
  wide: [/^(Înainte de Cristos|Înaintea erei noastre)/i, /^(După Cristos|Era noastră)/i]
}, $I = {
  narrow: /^[1234]/i,
  abbreviated: /^T[1234]/i,
  wide: /^trimestrul [1234]/i
}, PI = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, MI = {
  narrow: /^[ifmaasond]/i,
  abbreviated: /^(ian|feb|mar|apr|mai|iun|iul|aug|sep|oct|noi|dec)/i,
  wide: /^(ianuarie|februarie|martie|aprilie|mai|iunie|iulie|august|septembrie|octombrie|noiembrie|decembrie)/i
}, jI = {
  narrow: [/^i/i, /^f/i, /^m/i, /^a/i, /^m/i, /^i/i, /^i/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ia/i, /^f/i, /^mar/i, /^ap/i, /^mai/i, /^iun/i, /^iul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, SI = {
  narrow: /^[dlmjvs]/i,
  short: /^(d|l|ma|mi|j|v|s)/i,
  abbreviated: /^(dum|lun|mar|mie|jo|vi|sâ)/i,
  wide: /^(duminica|luni|marţi|miercuri|joi|vineri|sâmbătă)/i
}, zI = {
  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
  any: [/^d/i, /^l/i, /^ma/i, /^mi/i, /^j/i, /^v/i, /^s/i]
}, OI = {
  narrow: /^(a|p|mn|a|(dimineaţa|după-amiaza|seara|noaptea))/i,
  any: /^([ap]\.?\s?m\.?|miezul nopții|amiaza|(dimineaţa|după-amiaza|seara|noaptea))/i
}, WI = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mn/i,
    noon: /amiaza/i,
    morning: /dimineaţa/i,
    afternoon: /după-amiaza/i,
    evening: /seara/i,
    night: /noaptea/i
  }
}, DI = {
  ordinalNumber: le({
    matchPattern: yI,
    parsePattern: kI,
    valueCallback: function(i) {
      return parseInt(i, 10);
    }
  }),
  era: P({
    matchPatterns: wI,
    defaultMatchWidth: "wide",
    parsePatterns: _I,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: $I,
    defaultMatchWidth: "wide",
    parsePatterns: PI,
    defaultParseWidth: "any",
    valueCallback: function(i) {
      return i + 1;
    }
  }),
  month: P({
    matchPatterns: MI,
    defaultMatchWidth: "wide",
    parsePatterns: jI,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: SI,
    defaultMatchWidth: "wide",
    parsePatterns: zI,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: OI,
    defaultMatchWidth: "any",
    parsePatterns: WI,
    defaultParseWidth: "any"
  })
}, CI = {
  code: "ro",
  formatDistance: tI,
  formatLong: dI,
  formatRelative: fI,
  localize: bI,
  match: DI,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
};
const II = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: CI
}, Symbol.toStringTag, { value: "Module" })), TI = /* @__PURE__ */ te(II);
function Jn(e, i) {
  if (e.one !== void 0 && i === 1)
    return e.one;
  var d = i % 10, a = i % 100;
  return d === 1 && a !== 11 ? e.singularNominative.replace("{{count}}", String(i)) : d >= 2 && d <= 4 && (a < 10 || a > 20) ? e.singularGenitive.replace("{{count}}", String(i)) : e.pluralGenitive.replace("{{count}}", String(i));
}
function Ye(e) {
  return function(i, d) {
    return d != null && d.addSuffix ? d.comparison && d.comparison > 0 ? e.future ? Jn(e.future, i) : "через " + Jn(e.regular, i) : e.past ? Jn(e.past, i) : Jn(e.regular, i) + " назад" : Jn(e.regular, i);
  };
}
var NI = {
  lessThanXSeconds: Ye({
    regular: {
      one: "меньше секунды",
      singularNominative: "меньше {{count}} секунды",
      singularGenitive: "меньше {{count}} секунд",
      pluralGenitive: "меньше {{count}} секунд"
    },
    future: {
      one: "меньше, чем через секунду",
      singularNominative: "меньше, чем через {{count}} секунду",
      singularGenitive: "меньше, чем через {{count}} секунды",
      pluralGenitive: "меньше, чем через {{count}} секунд"
    }
  }),
  xSeconds: Ye({
    regular: {
      singularNominative: "{{count}} секунда",
      singularGenitive: "{{count}} секунды",
      pluralGenitive: "{{count}} секунд"
    },
    past: {
      singularNominative: "{{count}} секунду назад",
      singularGenitive: "{{count}} секунды назад",
      pluralGenitive: "{{count}} секунд назад"
    },
    future: {
      singularNominative: "через {{count}} секунду",
      singularGenitive: "через {{count}} секунды",
      pluralGenitive: "через {{count}} секунд"
    }
  }),
  halfAMinute: function(i, d) {
    return d != null && d.addSuffix ? d.comparison && d.comparison > 0 ? "через полминуты" : "полминуты назад" : "полминуты";
  },
  lessThanXMinutes: Ye({
    regular: {
      one: "меньше минуты",
      singularNominative: "меньше {{count}} минуты",
      singularGenitive: "меньше {{count}} минут",
      pluralGenitive: "меньше {{count}} минут"
    },
    future: {
      one: "меньше, чем через минуту",
      singularNominative: "меньше, чем через {{count}} минуту",
      singularGenitive: "меньше, чем через {{count}} минуты",
      pluralGenitive: "меньше, чем через {{count}} минут"
    }
  }),
  xMinutes: Ye({
    regular: {
      singularNominative: "{{count}} минута",
      singularGenitive: "{{count}} минуты",
      pluralGenitive: "{{count}} минут"
    },
    past: {
      singularNominative: "{{count}} минуту назад",
      singularGenitive: "{{count}} минуты назад",
      pluralGenitive: "{{count}} минут назад"
    },
    future: {
      singularNominative: "через {{count}} минуту",
      singularGenitive: "через {{count}} минуты",
      pluralGenitive: "через {{count}} минут"
    }
  }),
  aboutXHours: Ye({
    regular: {
      singularNominative: "около {{count}} часа",
      singularGenitive: "около {{count}} часов",
      pluralGenitive: "около {{count}} часов"
    },
    future: {
      singularNominative: "приблизительно через {{count}} час",
      singularGenitive: "приблизительно через {{count}} часа",
      pluralGenitive: "приблизительно через {{count}} часов"
    }
  }),
  xHours: Ye({
    regular: {
      singularNominative: "{{count}} час",
      singularGenitive: "{{count}} часа",
      pluralGenitive: "{{count}} часов"
    }
  }),
  xDays: Ye({
    regular: {
      singularNominative: "{{count}} день",
      singularGenitive: "{{count}} дня",
      pluralGenitive: "{{count}} дней"
    }
  }),
  aboutXWeeks: Ye({
    regular: {
      singularNominative: "около {{count}} недели",
      singularGenitive: "около {{count}} недель",
      pluralGenitive: "около {{count}} недель"
    },
    future: {
      singularNominative: "приблизительно через {{count}} неделю",
      singularGenitive: "приблизительно через {{count}} недели",
      pluralGenitive: "приблизительно через {{count}} недель"
    }
  }),
  xWeeks: Ye({
    regular: {
      singularNominative: "{{count}} неделя",
      singularGenitive: "{{count}} недели",
      pluralGenitive: "{{count}} недель"
    }
  }),
  aboutXMonths: Ye({
    regular: {
      singularNominative: "около {{count}} месяца",
      singularGenitive: "около {{count}} месяцев",
      pluralGenitive: "около {{count}} месяцев"
    },
    future: {
      singularNominative: "приблизительно через {{count}} месяц",
      singularGenitive: "приблизительно через {{count}} месяца",
      pluralGenitive: "приблизительно через {{count}} месяцев"
    }
  }),
  xMonths: Ye({
    regular: {
      singularNominative: "{{count}} месяц",
      singularGenitive: "{{count}} месяца",
      pluralGenitive: "{{count}} месяцев"
    }
  }),
  aboutXYears: Ye({
    regular: {
      singularNominative: "около {{count}} года",
      singularGenitive: "около {{count}} лет",
      pluralGenitive: "около {{count}} лет"
    },
    future: {
      singularNominative: "приблизительно через {{count}} год",
      singularGenitive: "приблизительно через {{count}} года",
      pluralGenitive: "приблизительно через {{count}} лет"
    }
  }),
  xYears: Ye({
    regular: {
      singularNominative: "{{count}} год",
      singularGenitive: "{{count}} года",
      pluralGenitive: "{{count}} лет"
    }
  }),
  overXYears: Ye({
    regular: {
      singularNominative: "больше {{count}} года",
      singularGenitive: "больше {{count}} лет",
      pluralGenitive: "больше {{count}} лет"
    },
    future: {
      singularNominative: "больше, чем через {{count}} год",
      singularGenitive: "больше, чем через {{count}} года",
      pluralGenitive: "больше, чем через {{count}} лет"
    }
  }),
  almostXYears: Ye({
    regular: {
      singularNominative: "почти {{count}} год",
      singularGenitive: "почти {{count}} года",
      pluralGenitive: "почти {{count}} лет"
    },
    future: {
      singularNominative: "почти через {{count}} год",
      singularGenitive: "почти через {{count}} года",
      pluralGenitive: "почти через {{count}} лет"
    }
  })
}, xI = function(i, d, a) {
  return NI[i](d, a);
}, FI = {
  full: "EEEE, d MMMM y 'г.'",
  long: "d MMMM y 'г.'",
  medium: "d MMM y 'г.'",
  short: "dd.MM.y"
}, EI = {
  full: "H:mm:ss zzzz",
  long: "H:mm:ss z",
  medium: "H:mm:ss",
  short: "H:mm"
}, RI = {
  any: "{{date}}, {{time}}"
}, LI = {
  date: I({
    formats: FI,
    defaultWidth: "full"
  }),
  time: I({
    formats: EI,
    defaultWidth: "full"
  }),
  dateTime: I({
    formats: RI,
    defaultWidth: "any"
  })
}, or = ["воскресенье", "понедельник", "вторник", "среду", "четверг", "пятницу", "субботу"];
function qI(e) {
  var i = or[e];
  switch (e) {
    case 0:
      return "'в прошлое " + i + " в' p";
    case 1:
    case 2:
    case 4:
      return "'в прошлый " + i + " в' p";
    case 3:
    case 5:
    case 6:
      return "'в прошлую " + i + " в' p";
  }
}
function cd(e) {
  var i = or[e];
  return e === 2 ? "'во " + i + " в' p" : "'в " + i + " в' p";
}
function ZI(e) {
  var i = or[e];
  switch (e) {
    case 0:
      return "'в следующее " + i + " в' p";
    case 1:
    case 2:
    case 4:
      return "'в следующий " + i + " в' p";
    case 3:
    case 5:
    case 6:
      return "'в следующую " + i + " в' p";
  }
}
var AI = {
  lastWeek: function(i, d, a) {
    var t = i.getUTCDay();
    return Ne(i, d, a) ? cd(t) : qI(t);
  },
  yesterday: "'вчера в' p",
  today: "'сегодня в' p",
  tomorrow: "'завтра в' p",
  nextWeek: function(i, d, a) {
    var t = i.getUTCDay();
    return Ne(i, d, a) ? cd(t) : ZI(t);
  },
  other: "P"
}, VI = function(i, d, a, t) {
  var o = AI[i];
  return typeof o == "function" ? o(d, a, t) : o;
}, HI = {
  narrow: ["до н.э.", "н.э."],
  abbreviated: ["до н. э.", "н. э."],
  wide: ["до нашей эры", "нашей эры"]
}, UI = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1-й кв.", "2-й кв.", "3-й кв.", "4-й кв."],
  wide: ["1-й квартал", "2-й квартал", "3-й квартал", "4-й квартал"]
}, BI = {
  narrow: ["Я", "Ф", "М", "А", "М", "И", "И", "А", "С", "О", "Н", "Д"],
  abbreviated: ["янв.", "фев.", "март", "апр.", "май", "июнь", "июль", "авг.", "сент.", "окт.", "нояб.", "дек."],
  wide: ["январь", "февраль", "март", "апрель", "май", "июнь", "июль", "август", "сентябрь", "октябрь", "ноябрь", "декабрь"]
}, XI = {
  narrow: ["Я", "Ф", "М", "А", "М", "И", "И", "А", "С", "О", "Н", "Д"],
  abbreviated: ["янв.", "фев.", "мар.", "апр.", "мая", "июн.", "июл.", "авг.", "сент.", "окт.", "нояб.", "дек."],
  wide: ["января", "февраля", "марта", "апреля", "мая", "июня", "июля", "августа", "сентября", "октября", "ноября", "декабря"]
}, GI = {
  narrow: ["В", "П", "В", "С", "Ч", "П", "С"],
  short: ["вс", "пн", "вт", "ср", "чт", "пт", "сб"],
  abbreviated: ["вск", "пнд", "втр", "срд", "чтв", "птн", "суб"],
  wide: ["воскресенье", "понедельник", "вторник", "среда", "четверг", "пятница", "суббота"]
}, KI = {
  narrow: {
    am: "ДП",
    pm: "ПП",
    midnight: "полн.",
    noon: "полд.",
    morning: "утро",
    afternoon: "день",
    evening: "веч.",
    night: "ночь"
  },
  abbreviated: {
    am: "ДП",
    pm: "ПП",
    midnight: "полн.",
    noon: "полд.",
    morning: "утро",
    afternoon: "день",
    evening: "веч.",
    night: "ночь"
  },
  wide: {
    am: "ДП",
    pm: "ПП",
    midnight: "полночь",
    noon: "полдень",
    morning: "утро",
    afternoon: "день",
    evening: "вечер",
    night: "ночь"
  }
}, YI = {
  narrow: {
    am: "ДП",
    pm: "ПП",
    midnight: "полн.",
    noon: "полд.",
    morning: "утра",
    afternoon: "дня",
    evening: "веч.",
    night: "ночи"
  },
  abbreviated: {
    am: "ДП",
    pm: "ПП",
    midnight: "полн.",
    noon: "полд.",
    morning: "утра",
    afternoon: "дня",
    evening: "веч.",
    night: "ночи"
  },
  wide: {
    am: "ДП",
    pm: "ПП",
    midnight: "полночь",
    noon: "полдень",
    morning: "утра",
    afternoon: "дня",
    evening: "вечера",
    night: "ночи"
  }
}, JI = function(i, d) {
  var a = Number(i), t = d == null ? void 0 : d.unit, o;
  return t === "date" ? o = "-е" : t === "week" || t === "minute" || t === "second" ? o = "-я" : o = "-й", a + o;
}, QI = {
  ordinalNumber: JI,
  era: $({
    values: HI,
    defaultWidth: "wide"
  }),
  quarter: $({
    values: UI,
    defaultWidth: "wide",
    argumentCallback: function(i) {
      return i - 1;
    }
  }),
  month: $({
    values: BI,
    defaultWidth: "wide",
    formattingValues: XI,
    defaultFormattingWidth: "wide"
  }),
  day: $({
    values: GI,
    defaultWidth: "wide"
  }),
  dayPeriod: $({
    values: KI,
    defaultWidth: "any",
    formattingValues: YI,
    defaultFormattingWidth: "wide"
  })
}, eT = /^(\d+)(-?(е|я|й|ое|ье|ая|ья|ый|ой|ий|ый))?/i, nT = /\d+/i, iT = {
  narrow: /^((до )?н\.?\s?э\.?)/i,
  abbreviated: /^((до )?н\.?\s?э\.?)/i,
  wide: /^(до нашей эры|нашей эры|наша эра)/i
}, aT = {
  any: [/^д/i, /^н/i]
}, tT = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234](-?[ыои]?й?)? кв.?/i,
  wide: /^[1234](-?[ыои]?й?)? квартал/i
}, rT = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, oT = {
  narrow: /^[яфмаисонд]/i,
  abbreviated: /^(янв|фев|март?|апр|ма[йя]|июн[ья]?|июл[ья]?|авг|сент?|окт|нояб?|дек)\.?/i,
  wide: /^(январ[ья]|феврал[ья]|марта?|апрел[ья]|ма[йя]|июн[ья]|июл[ья]|августа?|сентябр[ья]|октябр[ья]|октябр[ья]|ноябр[ья]|декабр[ья])/i
}, sT = {
  narrow: [/^я/i, /^ф/i, /^м/i, /^а/i, /^м/i, /^и/i, /^и/i, /^а/i, /^с/i, /^о/i, /^н/i, /^я/i],
  any: [/^я/i, /^ф/i, /^мар/i, /^ап/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^ав/i, /^с/i, /^о/i, /^н/i, /^д/i]
}, dT = {
  narrow: /^[впсч]/i,
  short: /^(вс|во|пн|по|вт|ср|чт|че|пт|пя|сб|су)\.?/i,
  abbreviated: /^(вск|вос|пнд|пон|втр|вто|срд|сре|чтв|чет|птн|пят|суб).?/i,
  wide: /^(воскресень[ея]|понедельника?|вторника?|сред[аы]|четверга?|пятниц[аы]|суббот[аы])/i
}, uT = {
  narrow: [/^в/i, /^п/i, /^в/i, /^с/i, /^ч/i, /^п/i, /^с/i],
  any: [/^в[ос]/i, /^п[он]/i, /^в/i, /^ср/i, /^ч/i, /^п[ят]/i, /^с[уб]/i]
}, fT = {
  narrow: /^([дп]п|полн\.?|полд\.?|утр[оа]|день|дня|веч\.?|ноч[ьи])/i,
  abbreviated: /^([дп]п|полн\.?|полд\.?|утр[оа]|день|дня|веч\.?|ноч[ьи])/i,
  wide: /^([дп]п|полночь|полдень|утр[оа]|день|дня|вечера?|ноч[ьи])/i
}, lT = {
  any: {
    am: /^дп/i,
    pm: /^пп/i,
    midnight: /^полн/i,
    noon: /^полд/i,
    morning: /^у/i,
    afternoon: /^д[ен]/i,
    evening: /^в/i,
    night: /^н/i
  }
}, cT = {
  ordinalNumber: le({
    matchPattern: eT,
    parsePattern: nT,
    valueCallback: function(i) {
      return parseInt(i, 10);
    }
  }),
  era: P({
    matchPatterns: iT,
    defaultMatchWidth: "wide",
    parsePatterns: aT,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: tT,
    defaultMatchWidth: "wide",
    parsePatterns: rT,
    defaultParseWidth: "any",
    valueCallback: function(i) {
      return i + 1;
    }
  }),
  month: P({
    matchPatterns: oT,
    defaultMatchWidth: "wide",
    parsePatterns: sT,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: dT,
    defaultMatchWidth: "wide",
    parsePatterns: uT,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: fT,
    defaultMatchWidth: "wide",
    parsePatterns: lT,
    defaultParseWidth: "any"
  })
}, mT = {
  code: "ru",
  formatDistance: xI,
  formatLong: LI,
  formatRelative: VI,
  localize: QI,
  match: cT,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
};
const vT = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: mT
}, Symbol.toStringTag, { value: "Module" })), hT = /* @__PURE__ */ te(vT);
function gT(e, i) {
  return i === 1 && e.one ? e.one : i >= 2 && i <= 4 && e.twoFour ? e.twoFour : e.other;
}
function Wt(e, i, d) {
  var a = gT(e, i), t = a[d];
  return t.replace("{{count}}", String(i));
}
function pT(e) {
  var i = ["lessThan", "about", "over", "almost"].filter(function(d) {
    return !!e.match(new RegExp("^" + d));
  });
  return i[0];
}
function Dt(e) {
  var i = "";
  return e === "almost" && (i = "takmer"), e === "about" && (i = "približne"), i.length > 0 ? i + " " : "";
}
function Ct(e) {
  var i = "";
  return e === "lessThan" && (i = "menej než"), e === "over" && (i = "viac než"), i.length > 0 ? i + " " : "";
}
function bT(e) {
  return e.charAt(0).toLowerCase() + e.slice(1);
}
var yT = {
  xSeconds: {
    one: {
      present: "sekunda",
      past: "sekundou",
      future: "sekundu"
    },
    twoFour: {
      present: "{{count}} sekundy",
      past: "{{count}} sekundami",
      future: "{{count}} sekundy"
    },
    other: {
      present: "{{count}} sekúnd",
      past: "{{count}} sekundami",
      future: "{{count}} sekúnd"
    }
  },
  halfAMinute: {
    other: {
      present: "pol minúty",
      past: "pol minútou",
      future: "pol minúty"
    }
  },
  xMinutes: {
    one: {
      present: "minúta",
      past: "minútou",
      future: "minútu"
    },
    twoFour: {
      present: "{{count}} minúty",
      past: "{{count}} minútami",
      future: "{{count}} minúty"
    },
    other: {
      present: "{{count}} minút",
      past: "{{count}} minútami",
      future: "{{count}} minút"
    }
  },
  xHours: {
    one: {
      present: "hodina",
      past: "hodinou",
      future: "hodinu"
    },
    twoFour: {
      present: "{{count}} hodiny",
      past: "{{count}} hodinami",
      future: "{{count}} hodiny"
    },
    other: {
      present: "{{count}} hodín",
      past: "{{count}} hodinami",
      future: "{{count}} hodín"
    }
  },
  xDays: {
    one: {
      present: "deň",
      past: "dňom",
      future: "deň"
    },
    twoFour: {
      present: "{{count}} dni",
      past: "{{count}} dňami",
      future: "{{count}} dni"
    },
    other: {
      present: "{{count}} dní",
      past: "{{count}} dňami",
      future: "{{count}} dní"
    }
  },
  xWeeks: {
    one: {
      present: "týždeň",
      past: "týždňom",
      future: "týždeň"
    },
    twoFour: {
      present: "{{count}} týždne",
      past: "{{count}} týždňami",
      future: "{{count}} týždne"
    },
    other: {
      present: "{{count}} týždňov",
      past: "{{count}} týždňami",
      future: "{{count}} týždňov"
    }
  },
  xMonths: {
    one: {
      present: "mesiac",
      past: "mesiacom",
      future: "mesiac"
    },
    twoFour: {
      present: "{{count}} mesiace",
      past: "{{count}} mesiacmi",
      future: "{{count}} mesiace"
    },
    other: {
      present: "{{count}} mesiacov",
      past: "{{count}} mesiacmi",
      future: "{{count}} mesiacov"
    }
  },
  xYears: {
    one: {
      present: "rok",
      past: "rokom",
      future: "rok"
    },
    twoFour: {
      present: "{{count}} roky",
      past: "{{count}} rokmi",
      future: "{{count}} roky"
    },
    other: {
      present: "{{count}} rokov",
      past: "{{count}} rokmi",
      future: "{{count}} rokov"
    }
  }
}, kT = function(i, d, a) {
  var t = pT(i) || "", o = bT(i.substring(t.length)), m = yT[o];
  return a != null && a.addSuffix ? a.comparison && a.comparison > 0 ? Dt(t) + "o " + Ct(t) + Wt(m, d, "future") : Dt(t) + "pred " + Ct(t) + Wt(m, d, "past") : Dt(t) + Ct(t) + Wt(m, d, "present");
}, wT = {
  full: "EEEE d. MMMM y",
  long: "d. MMMM y",
  medium: "d. M. y",
  short: "d. M. y"
}, _T = {
  full: "H:mm:ss zzzz",
  long: "H:mm:ss z",
  medium: "H:mm:ss",
  short: "H:mm"
}, $T = {
  full: "{{date}}, {{time}}",
  long: "{{date}}, {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}} {{time}}"
}, PT = {
  date: I({
    formats: wT,
    defaultWidth: "full"
  }),
  time: I({
    formats: _T,
    defaultWidth: "full"
  }),
  dateTime: I({
    formats: $T,
    defaultWidth: "full"
  })
}, sr = ["nedeľu", "pondelok", "utorok", "stredu", "štvrtok", "piatok", "sobotu"];
function MT(e) {
  var i = sr[e];
  switch (e) {
    case 0:
    case 3:
    case 6:
      return "'minulú " + i + " o' p";
    default:
      return "'minulý' eeee 'o' p";
  }
}
function md(e) {
  var i = sr[e];
  return e === 4 ? "'vo' eeee 'o' p" : "'v " + i + " o' p";
}
function jT(e) {
  var i = sr[e];
  switch (e) {
    case 0:
    case 4:
    case 6:
      return "'budúcu " + i + " o' p";
    default:
      return "'budúci' eeee 'o' p";
  }
}
var ST = {
  lastWeek: function(i, d, a) {
    var t = i.getUTCDay();
    return Ne(i, d, a) ? md(t) : MT(t);
  },
  yesterday: "'včera o' p",
  today: "'dnes o' p",
  tomorrow: "'zajtra o' p",
  nextWeek: function(i, d, a) {
    var t = i.getUTCDay();
    return Ne(i, d, a) ? md(t) : jT(t);
  },
  other: "P"
}, zT = function(i, d, a, t) {
  var o = ST[i];
  return typeof o == "function" ? o(d, a, t) : o;
}, OT = {
  narrow: ["pred Kr.", "po Kr."],
  abbreviated: ["pred Kr.", "po Kr."],
  wide: ["pred Kristom", "po Kristovi"]
}, WT = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1. štvrťrok", "2. štvrťrok", "3. štvrťrok", "4. štvrťrok"]
}, DT = {
  narrow: ["j", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
  abbreviated: ["jan", "feb", "mar", "apr", "máj", "jún", "júl", "aug", "sep", "okt", "nov", "dec"],
  wide: ["január", "február", "marec", "apríl", "máj", "jún", "júl", "august", "september", "október", "november", "december"]
}, CT = {
  narrow: ["j", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
  abbreviated: ["jan", "feb", "mar", "apr", "máj", "jún", "júl", "aug", "sep", "okt", "nov", "dec"],
  wide: ["januára", "februára", "marca", "apríla", "mája", "júna", "júla", "augusta", "septembra", "októbra", "novembra", "decembra"]
}, IT = {
  narrow: ["n", "p", "u", "s", "š", "p", "s"],
  short: ["ne", "po", "ut", "st", "št", "pi", "so"],
  abbreviated: ["ne", "po", "ut", "st", "št", "pi", "so"],
  wide: ["nedeľa", "pondelok", "utorok", "streda", "štvrtok", "piatok", "sobota"]
}, TT = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "poln.",
    noon: "pol.",
    morning: "ráno",
    afternoon: "pop.",
    evening: "več.",
    night: "noc"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "poln.",
    noon: "pol.",
    morning: "ráno",
    afternoon: "popol.",
    evening: "večer",
    night: "noc"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "polnoc",
    noon: "poludnie",
    morning: "ráno",
    afternoon: "popoludnie",
    evening: "večer",
    night: "noc"
  }
}, NT = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "o poln.",
    noon: "nap.",
    morning: "ráno",
    afternoon: "pop.",
    evening: "več.",
    night: "v n."
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "o poln.",
    noon: "napol.",
    morning: "ráno",
    afternoon: "popol.",
    evening: "večer",
    night: "v noci"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "o polnoci",
    noon: "napoludnie",
    morning: "ráno",
    afternoon: "popoludní",
    evening: "večer",
    night: "v noci"
  }
}, xT = function(i, d) {
  var a = Number(i);
  return a + ".";
}, FT = {
  ordinalNumber: xT,
  era: $({
    values: OT,
    defaultWidth: "wide"
  }),
  quarter: $({
    values: WT,
    defaultWidth: "wide",
    argumentCallback: function(i) {
      return i - 1;
    }
  }),
  month: $({
    values: DT,
    defaultWidth: "wide",
    formattingValues: CT,
    defaultFormattingWidth: "wide"
  }),
  day: $({
    values: IT,
    defaultWidth: "wide"
  }),
  dayPeriod: $({
    values: TT,
    defaultWidth: "wide",
    formattingValues: NT,
    defaultFormattingWidth: "wide"
  })
}, ET = /^(\d+)\.?/i, RT = /\d+/i, LT = {
  narrow: /^(pred Kr\.|pred n\. l\.|po Kr\.|n\. l\.)/i,
  abbreviated: /^(pred Kr\.|pred n\. l\.|po Kr\.|n\. l\.)/i,
  wide: /^(pred Kristom|pred na[šs][íi]m letopo[čc]tom|po Kristovi|n[áa][šs]ho letopo[čc]tu)/i
}, qT = {
  any: [/^pr/i, /^(po|n)/i]
}, ZT = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234]\. [šs]tvr[ťt]rok/i
}, AT = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, VT = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|m[áa]j|j[úu]n|j[úu]l|aug|sep|okt|nov|dec)/i,
  wide: /^(janu[áa]ra?|febru[áa]ra?|(marec|marca)|apr[íi]la?|m[áa]ja?|j[úu]na?|j[úu]la?|augusta?|(september|septembra)|(okt[óo]ber|okt[óo]bra)|(november|novembra)|(december|decembra))/i
}, HT = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^m[áa]j/i, /^j[úu]n/i, /^j[úu]l/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, UT = {
  narrow: /^[npusšp]/i,
  short: /^(ne|po|ut|st|št|pi|so)/i,
  abbreviated: /^(ne|po|ut|st|št|pi|so)/i,
  wide: /^(nede[ľl]a|pondelok|utorok|streda|[šs]tvrtok|piatok|sobota])/i
}, BT = {
  narrow: [/^n/i, /^p/i, /^u/i, /^s/i, /^š/i, /^p/i, /^s/i],
  any: [/^n/i, /^po/i, /^u/i, /^st/i, /^(št|stv)/i, /^pi/i, /^so/i]
}, XT = {
  narrow: /^(am|pm|(o )?poln\.?|(nap\.?|pol\.?)|r[áa]no|pop\.?|ve[čc]\.?|(v n\.?|noc))/i,
  abbreviated: /^(am|pm|(o )?poln\.?|(napol\.?|pol\.?)|r[áa]no|pop\.?|ve[čc]er|(v )?noci?)/i,
  any: /^(am|pm|(o )?polnoci?|(na)?poludnie|r[áa]no|popoludn(ie|í|i)|ve[čc]er|(v )?noci?)/i
}, GT = {
  any: {
    am: /^am/i,
    pm: /^pm/i,
    midnight: /poln/i,
    noon: /^(nap|(na)?pol(\.|u))/i,
    morning: /^r[áa]no/i,
    afternoon: /^pop/i,
    evening: /^ve[čc]/i,
    night: /^(noc|v n\.)/i
  }
}, KT = {
  ordinalNumber: le({
    matchPattern: ET,
    parsePattern: RT,
    valueCallback: function(i) {
      return parseInt(i, 10);
    }
  }),
  era: P({
    matchPatterns: LT,
    defaultMatchWidth: "wide",
    parsePatterns: qT,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: ZT,
    defaultMatchWidth: "wide",
    parsePatterns: AT,
    defaultParseWidth: "any",
    valueCallback: function(i) {
      return i + 1;
    }
  }),
  month: P({
    matchPatterns: VT,
    defaultMatchWidth: "wide",
    parsePatterns: HT,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: UT,
    defaultMatchWidth: "wide",
    parsePatterns: BT,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: XT,
    defaultMatchWidth: "any",
    parsePatterns: GT,
    defaultParseWidth: "any"
  })
}, YT = {
  code: "sk",
  formatDistance: kT,
  formatLong: PT,
  formatRelative: zT,
  localize: FT,
  match: KT,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const JT = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: YT
}, Symbol.toStringTag, { value: "Module" })), QT = /* @__PURE__ */ te(JT);
function eN(e) {
  return e.one !== void 0;
}
var nN = {
  lessThanXSeconds: {
    present: {
      one: "manj kot {{count}} sekunda",
      two: "manj kot {{count}} sekundi",
      few: "manj kot {{count}} sekunde",
      other: "manj kot {{count}} sekund"
    },
    past: {
      one: "manj kot {{count}} sekundo",
      two: "manj kot {{count}} sekundama",
      few: "manj kot {{count}} sekundami",
      other: "manj kot {{count}} sekundami"
    },
    future: {
      one: "manj kot {{count}} sekundo",
      two: "manj kot {{count}} sekundi",
      few: "manj kot {{count}} sekunde",
      other: "manj kot {{count}} sekund"
    }
  },
  xSeconds: {
    present: {
      one: "{{count}} sekunda",
      two: "{{count}} sekundi",
      few: "{{count}} sekunde",
      other: "{{count}} sekund"
    },
    past: {
      one: "{{count}} sekundo",
      two: "{{count}} sekundama",
      few: "{{count}} sekundami",
      other: "{{count}} sekundami"
    },
    future: {
      one: "{{count}} sekundo",
      two: "{{count}} sekundi",
      few: "{{count}} sekunde",
      other: "{{count}} sekund"
    }
  },
  halfAMinute: "pol minute",
  lessThanXMinutes: {
    present: {
      one: "manj kot {{count}} minuta",
      two: "manj kot {{count}} minuti",
      few: "manj kot {{count}} minute",
      other: "manj kot {{count}} minut"
    },
    past: {
      one: "manj kot {{count}} minuto",
      two: "manj kot {{count}} minutama",
      few: "manj kot {{count}} minutami",
      other: "manj kot {{count}} minutami"
    },
    future: {
      one: "manj kot {{count}} minuto",
      two: "manj kot {{count}} minuti",
      few: "manj kot {{count}} minute",
      other: "manj kot {{count}} minut"
    }
  },
  xMinutes: {
    present: {
      one: "{{count}} minuta",
      two: "{{count}} minuti",
      few: "{{count}} minute",
      other: "{{count}} minut"
    },
    past: {
      one: "{{count}} minuto",
      two: "{{count}} minutama",
      few: "{{count}} minutami",
      other: "{{count}} minutami"
    },
    future: {
      one: "{{count}} minuto",
      two: "{{count}} minuti",
      few: "{{count}} minute",
      other: "{{count}} minut"
    }
  },
  aboutXHours: {
    present: {
      one: "približno {{count}} ura",
      two: "približno {{count}} uri",
      few: "približno {{count}} ure",
      other: "približno {{count}} ur"
    },
    past: {
      one: "približno {{count}} uro",
      two: "približno {{count}} urama",
      few: "približno {{count}} urami",
      other: "približno {{count}} urami"
    },
    future: {
      one: "približno {{count}} uro",
      two: "približno {{count}} uri",
      few: "približno {{count}} ure",
      other: "približno {{count}} ur"
    }
  },
  xHours: {
    present: {
      one: "{{count}} ura",
      two: "{{count}} uri",
      few: "{{count}} ure",
      other: "{{count}} ur"
    },
    past: {
      one: "{{count}} uro",
      two: "{{count}} urama",
      few: "{{count}} urami",
      other: "{{count}} urami"
    },
    future: {
      one: "{{count}} uro",
      two: "{{count}} uri",
      few: "{{count}} ure",
      other: "{{count}} ur"
    }
  },
  xDays: {
    present: {
      one: "{{count}} dan",
      two: "{{count}} dni",
      few: "{{count}} dni",
      other: "{{count}} dni"
    },
    past: {
      one: "{{count}} dnem",
      two: "{{count}} dnevoma",
      few: "{{count}} dnevi",
      other: "{{count}} dnevi"
    },
    future: {
      one: "{{count}} dan",
      two: "{{count}} dni",
      few: "{{count}} dni",
      other: "{{count}} dni"
    }
  },
  // no tenses for weeks?
  aboutXWeeks: {
    one: "približno {{count}} teden",
    two: "približno {{count}} tedna",
    few: "približno {{count}} tedne",
    other: "približno {{count}} tednov"
  },
  // no tenses for weeks?
  xWeeks: {
    one: "{{count}} teden",
    two: "{{count}} tedna",
    few: "{{count}} tedne",
    other: "{{count}} tednov"
  },
  aboutXMonths: {
    present: {
      one: "približno {{count}} mesec",
      two: "približno {{count}} meseca",
      few: "približno {{count}} mesece",
      other: "približno {{count}} mesecev"
    },
    past: {
      one: "približno {{count}} mesecem",
      two: "približno {{count}} mesecema",
      few: "približno {{count}} meseci",
      other: "približno {{count}} meseci"
    },
    future: {
      one: "približno {{count}} mesec",
      two: "približno {{count}} meseca",
      few: "približno {{count}} mesece",
      other: "približno {{count}} mesecev"
    }
  },
  xMonths: {
    present: {
      one: "{{count}} mesec",
      two: "{{count}} meseca",
      few: "{{count}} meseci",
      other: "{{count}} mesecev"
    },
    past: {
      one: "{{count}} mesecem",
      two: "{{count}} mesecema",
      few: "{{count}} meseci",
      other: "{{count}} meseci"
    },
    future: {
      one: "{{count}} mesec",
      two: "{{count}} meseca",
      few: "{{count}} mesece",
      other: "{{count}} mesecev"
    }
  },
  aboutXYears: {
    present: {
      one: "približno {{count}} leto",
      two: "približno {{count}} leti",
      few: "približno {{count}} leta",
      other: "približno {{count}} let"
    },
    past: {
      one: "približno {{count}} letom",
      two: "približno {{count}} letoma",
      few: "približno {{count}} leti",
      other: "približno {{count}} leti"
    },
    future: {
      one: "približno {{count}} leto",
      two: "približno {{count}} leti",
      few: "približno {{count}} leta",
      other: "približno {{count}} let"
    }
  },
  xYears: {
    present: {
      one: "{{count}} leto",
      two: "{{count}} leti",
      few: "{{count}} leta",
      other: "{{count}} let"
    },
    past: {
      one: "{{count}} letom",
      two: "{{count}} letoma",
      few: "{{count}} leti",
      other: "{{count}} leti"
    },
    future: {
      one: "{{count}} leto",
      two: "{{count}} leti",
      few: "{{count}} leta",
      other: "{{count}} let"
    }
  },
  overXYears: {
    present: {
      one: "več kot {{count}} leto",
      two: "več kot {{count}} leti",
      few: "več kot {{count}} leta",
      other: "več kot {{count}} let"
    },
    past: {
      one: "več kot {{count}} letom",
      two: "več kot {{count}} letoma",
      few: "več kot {{count}} leti",
      other: "več kot {{count}} leti"
    },
    future: {
      one: "več kot {{count}} leto",
      two: "več kot {{count}} leti",
      few: "več kot {{count}} leta",
      other: "več kot {{count}} let"
    }
  },
  almostXYears: {
    present: {
      one: "skoraj {{count}} leto",
      two: "skoraj {{count}} leti",
      few: "skoraj {{count}} leta",
      other: "skoraj {{count}} let"
    },
    past: {
      one: "skoraj {{count}} letom",
      two: "skoraj {{count}} letoma",
      few: "skoraj {{count}} leti",
      other: "skoraj {{count}} leti"
    },
    future: {
      one: "skoraj {{count}} leto",
      two: "skoraj {{count}} leti",
      few: "skoraj {{count}} leta",
      other: "skoraj {{count}} let"
    }
  }
};
function iN(e) {
  switch (e % 100) {
    case 1:
      return "one";
    case 2:
      return "two";
    case 3:
    case 4:
      return "few";
    default:
      return "other";
  }
}
var aN = function(i, d, a) {
  var t = "", o = "present";
  a != null && a.addSuffix && (a.comparison && a.comparison > 0 ? (o = "future", t = "čez ") : (o = "past", t = "pred "));
  var m = nN[i];
  if (typeof m == "string")
    t += m;
  else {
    var p = iN(d);
    eN(m) ? t += m[p].replace("{{count}}", String(d)) : t += m[o][p].replace("{{count}}", String(d));
  }
  return t;
}, tN = {
  full: "EEEE, dd. MMMM y",
  long: "dd. MMMM y",
  medium: "d. MMM y",
  short: "d. MM. yy"
}, rN = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, oN = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, sN = {
  date: I({
    formats: tN,
    defaultWidth: "full"
  }),
  time: I({
    formats: rN,
    defaultWidth: "full"
  }),
  dateTime: I({
    formats: oN,
    defaultWidth: "full"
  })
}, dN = {
  lastWeek: function(i) {
    var d = i.getUTCDay();
    switch (d) {
      case 0:
        return "'prejšnjo nedeljo ob' p";
      case 3:
        return "'prejšnjo sredo ob' p";
      case 6:
        return "'prejšnjo soboto ob' p";
      default:
        return "'prejšnji' EEEE 'ob' p";
    }
  },
  yesterday: "'včeraj ob' p",
  today: "'danes ob' p",
  tomorrow: "'jutri ob' p",
  nextWeek: function(i) {
    var d = i.getUTCDay();
    switch (d) {
      case 0:
        return "'naslednjo nedeljo ob' p";
      case 3:
        return "'naslednjo sredo ob' p";
      case 6:
        return "'naslednjo soboto ob' p";
      default:
        return "'naslednji' EEEE 'ob' p";
    }
  },
  other: "P"
}, uN = function(i, d, a, t) {
  var o = dN[i];
  return typeof o == "function" ? o(d) : o;
}, fN = {
  narrow: ["pr. n. št.", "po n. št."],
  abbreviated: ["pr. n. št.", "po n. št."],
  wide: ["pred našim štetjem", "po našem štetju"]
}, lN = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1. čet.", "2. čet.", "3. čet.", "4. čet."],
  wide: ["1. četrtletje", "2. četrtletje", "3. četrtletje", "4. četrtletje"]
}, cN = {
  narrow: ["j", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
  abbreviated: ["jan.", "feb.", "mar.", "apr.", "maj", "jun.", "jul.", "avg.", "sep.", "okt.", "nov.", "dec."],
  wide: ["januar", "februar", "marec", "april", "maj", "junij", "julij", "avgust", "september", "oktober", "november", "december"]
}, mN = {
  narrow: ["n", "p", "t", "s", "č", "p", "s"],
  short: ["ned.", "pon.", "tor.", "sre.", "čet.", "pet.", "sob."],
  abbreviated: ["ned.", "pon.", "tor.", "sre.", "čet.", "pet.", "sob."],
  wide: ["nedelja", "ponedeljek", "torek", "sreda", "četrtek", "petek", "sobota"]
}, vN = {
  narrow: {
    am: "d",
    pm: "p",
    midnight: "24.00",
    noon: "12.00",
    morning: "j",
    afternoon: "p",
    evening: "v",
    night: "n"
  },
  abbreviated: {
    am: "dop.",
    pm: "pop.",
    midnight: "poln.",
    noon: "pold.",
    morning: "jut.",
    afternoon: "pop.",
    evening: "več.",
    night: "noč"
  },
  wide: {
    am: "dop.",
    pm: "pop.",
    midnight: "polnoč",
    noon: "poldne",
    morning: "jutro",
    afternoon: "popoldne",
    evening: "večer",
    night: "noč"
  }
}, hN = {
  narrow: {
    am: "d",
    pm: "p",
    midnight: "24.00",
    noon: "12.00",
    morning: "zj",
    afternoon: "p",
    evening: "zv",
    night: "po"
  },
  abbreviated: {
    am: "dop.",
    pm: "pop.",
    midnight: "opoln.",
    noon: "opold.",
    morning: "zjut.",
    afternoon: "pop.",
    evening: "zveč.",
    night: "ponoči"
  },
  wide: {
    am: "dop.",
    pm: "pop.",
    midnight: "opolnoči",
    noon: "opoldne",
    morning: "zjutraj",
    afternoon: "popoldan",
    evening: "zvečer",
    night: "ponoči"
  }
}, gN = function(i, d) {
  var a = Number(i);
  return a + ".";
}, pN = {
  ordinalNumber: gN,
  era: $({
    values: fN,
    defaultWidth: "wide"
  }),
  quarter: $({
    values: lN,
    defaultWidth: "wide",
    argumentCallback: function(i) {
      return i - 1;
    }
  }),
  month: $({
    values: cN,
    defaultWidth: "wide"
  }),
  day: $({
    values: mN,
    defaultWidth: "wide"
  }),
  dayPeriod: $({
    values: vN,
    defaultWidth: "wide",
    formattingValues: hN,
    defaultFormattingWidth: "wide"
  })
}, bN = /^(\d+)\./i, yN = /\d+/i, kN = {
  abbreviated: /^(pr\. n\. št\.|po n\. št\.)/i,
  wide: /^(pred Kristusom|pred na[sš]im [sš]tetjem|po Kristusu|po na[sš]em [sš]tetju|na[sš]ega [sš]tetja)/i
}, wN = {
  any: [/^pr/i, /^(po|na[sš]em)/i]
}, _N = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234]\.\s?[čc]et\.?/i,
  wide: /^[1234]\. [čc]etrtletje/i
}, $N = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, PN = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan\.|feb\.|mar\.|apr\.|maj|jun\.|jul\.|avg\.|sep\.|okt\.|nov\.|dec\.)/i,
  wide: /^(januar|februar|marec|april|maj|junij|julij|avgust|september|oktober|november|december)/i
}, MN = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  abbreviated: [/^ja/i, /^fe/i, /^mar/i, /^ap/i, /^maj/i, /^jun/i, /^jul/i, /^av/i, /^s/i, /^o/i, /^n/i, /^d/i],
  wide: [/^ja/i, /^fe/i, /^mar/i, /^ap/i, /^maj/i, /^jun/i, /^jul/i, /^av/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, jN = {
  narrow: /^[nptsčc]/i,
  short: /^(ned\.|pon\.|tor\.|sre\.|[cč]et\.|pet\.|sob\.)/i,
  abbreviated: /^(ned\.|pon\.|tor\.|sre\.|[cč]et\.|pet\.|sob\.)/i,
  wide: /^(nedelja|ponedeljek|torek|sreda|[cč]etrtek|petek|sobota)/i
}, SN = {
  narrow: [/^n/i, /^p/i, /^t/i, /^s/i, /^[cč]/i, /^p/i, /^s/i],
  any: [/^n/i, /^po/i, /^t/i, /^sr/i, /^[cč]/i, /^pe/i, /^so/i]
}, zN = {
  narrow: /^(d|po?|z?v|n|z?j|24\.00|12\.00)/i,
  any: /^(dop\.|pop\.|o?poln(\.|o[cč]i?)|o?pold(\.|ne)|z?ve[cč](\.|er)|(po)?no[cč]i?|popold(ne|an)|jut(\.|ro)|zjut(\.|raj))/i
}, ON = {
  narrow: {
    am: /^d/i,
    pm: /^p/i,
    midnight: /^24/i,
    noon: /^12/i,
    morning: /^(z?j)/i,
    afternoon: /^p/i,
    evening: /^(z?v)/i,
    night: /^(n|po)/i
  },
  any: {
    am: /^dop\./i,
    pm: /^pop\./i,
    midnight: /^o?poln/i,
    noon: /^o?pold/i,
    morning: /j/i,
    afternoon: /^pop\./i,
    evening: /^z?ve/i,
    night: /(po)?no/i
  }
}, WN = {
  ordinalNumber: le({
    matchPattern: bN,
    parsePattern: yN,
    valueCallback: function(i) {
      return parseInt(i, 10);
    }
  }),
  era: P({
    matchPatterns: kN,
    defaultMatchWidth: "wide",
    parsePatterns: wN,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: _N,
    defaultMatchWidth: "wide",
    parsePatterns: $N,
    defaultParseWidth: "any",
    valueCallback: function(i) {
      return i + 1;
    }
  }),
  month: P({
    matchPatterns: PN,
    defaultMatchWidth: "wide",
    parsePatterns: MN,
    defaultParseWidth: "wide"
  }),
  day: P({
    matchPatterns: jN,
    defaultMatchWidth: "wide",
    parsePatterns: SN,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: zN,
    defaultMatchWidth: "any",
    parsePatterns: ON,
    defaultParseWidth: "any"
  })
}, DN = {
  code: "sl",
  formatDistance: aN,
  formatLong: sN,
  formatRelative: uN,
  localize: pN,
  match: WN,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
};
const CN = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: DN
}, Symbol.toStringTag, { value: "Module" })), IN = /* @__PURE__ */ te(CN);
var TN = {
  lessThanXSeconds: {
    one: {
      standalone: "мање од 1 секунде",
      withPrepositionAgo: "мање од 1 секунде",
      withPrepositionIn: "мање од 1 секунду"
    },
    dual: "мање од {{count}} секунде",
    other: "мање од {{count}} секунди"
  },
  xSeconds: {
    one: {
      standalone: "1 секунда",
      withPrepositionAgo: "1 секунде",
      withPrepositionIn: "1 секунду"
    },
    dual: "{{count}} секунде",
    other: "{{count}} секунди"
  },
  halfAMinute: "пола минуте",
  lessThanXMinutes: {
    one: {
      standalone: "мање од 1 минуте",
      withPrepositionAgo: "мање од 1 минуте",
      withPrepositionIn: "мање од 1 минуту"
    },
    dual: "мање од {{count}} минуте",
    other: "мање од {{count}} минута"
  },
  xMinutes: {
    one: {
      standalone: "1 минута",
      withPrepositionAgo: "1 минуте",
      withPrepositionIn: "1 минуту"
    },
    dual: "{{count}} минуте",
    other: "{{count}} минута"
  },
  aboutXHours: {
    one: {
      standalone: "око 1 сат",
      withPrepositionAgo: "око 1 сат",
      withPrepositionIn: "око 1 сат"
    },
    dual: "око {{count}} сата",
    other: "око {{count}} сати"
  },
  xHours: {
    one: {
      standalone: "1 сат",
      withPrepositionAgo: "1 сат",
      withPrepositionIn: "1 сат"
    },
    dual: "{{count}} сата",
    other: "{{count}} сати"
  },
  xDays: {
    one: {
      standalone: "1 дан",
      withPrepositionAgo: "1 дан",
      withPrepositionIn: "1 дан"
    },
    dual: "{{count}} дана",
    other: "{{count}} дана"
  },
  aboutXWeeks: {
    one: {
      standalone: "око 1 недељу",
      withPrepositionAgo: "око 1 недељу",
      withPrepositionIn: "око 1 недељу"
    },
    dual: "око {{count}} недеље",
    other: "око {{count}} недеље"
  },
  xWeeks: {
    one: {
      standalone: "1 недељу",
      withPrepositionAgo: "1 недељу",
      withPrepositionIn: "1 недељу"
    },
    dual: "{{count}} недеље",
    other: "{{count}} недеље"
  },
  aboutXMonths: {
    one: {
      standalone: "око 1 месец",
      withPrepositionAgo: "око 1 месец",
      withPrepositionIn: "око 1 месец"
    },
    dual: "око {{count}} месеца",
    other: "око {{count}} месеци"
  },
  xMonths: {
    one: {
      standalone: "1 месец",
      withPrepositionAgo: "1 месец",
      withPrepositionIn: "1 месец"
    },
    dual: "{{count}} месеца",
    other: "{{count}} месеци"
  },
  aboutXYears: {
    one: {
      standalone: "око 1 годину",
      withPrepositionAgo: "око 1 годину",
      withPrepositionIn: "око 1 годину"
    },
    dual: "око {{count}} године",
    other: "око {{count}} година"
  },
  xYears: {
    one: {
      standalone: "1 година",
      withPrepositionAgo: "1 године",
      withPrepositionIn: "1 годину"
    },
    dual: "{{count}} године",
    other: "{{count}} година"
  },
  overXYears: {
    one: {
      standalone: "преко 1 годину",
      withPrepositionAgo: "преко 1 годину",
      withPrepositionIn: "преко 1 годину"
    },
    dual: "преко {{count}} године",
    other: "преко {{count}} година"
  },
  almostXYears: {
    one: {
      standalone: "готово 1 годину",
      withPrepositionAgo: "готово 1 годину",
      withPrepositionIn: "готово 1 годину"
    },
    dual: "готово {{count}} године",
    other: "готово {{count}} година"
  }
}, NN = function(i, d, a) {
  var t, o = TN[i];
  return typeof o == "string" ? t = o : d === 1 ? a != null && a.addSuffix ? a.comparison && a.comparison > 0 ? t = o.one.withPrepositionIn : t = o.one.withPrepositionAgo : t = o.one.standalone : d % 10 > 1 && d % 10 < 5 && // if last digit is between 2 and 4
  String(d).substr(-2, 1) !== "1" ? t = o.dual.replace("{{count}}", String(d)) : t = o.other.replace("{{count}}", String(d)), a != null && a.addSuffix ? a.comparison && a.comparison > 0 ? "за " + t : "пре " + t : t;
}, xN = {
  full: "EEEE, d. MMMM yyyy.",
  long: "d. MMMM yyyy.",
  medium: "d. MMM yy.",
  short: "dd. MM. yy."
}, FN = {
  full: "HH:mm:ss (zzzz)",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, EN = {
  full: "{{date}} 'у' {{time}}",
  long: "{{date}} 'у' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, RN = {
  date: I({
    formats: xN,
    defaultWidth: "full"
  }),
  time: I({
    formats: FN,
    defaultWidth: "full"
  }),
  dateTime: I({
    formats: EN,
    defaultWidth: "full"
  })
}, LN = {
  lastWeek: function(i) {
    var d = i.getUTCDay();
    switch (d) {
      case 0:
        return "'прошле недеље у' p";
      case 3:
        return "'прошле среде у' p";
      case 6:
        return "'прошле суботе у' p";
      default:
        return "'прошли' EEEE 'у' p";
    }
  },
  yesterday: "'јуче у' p",
  today: "'данас у' p",
  tomorrow: "'сутра у' p",
  nextWeek: function(i) {
    var d = i.getUTCDay();
    switch (d) {
      case 0:
        return "'следеће недеље у' p";
      case 3:
        return "'следећу среду у' p";
      case 6:
        return "'следећу суботу у' p";
      default:
        return "'следећи' EEEE 'у' p";
    }
  },
  other: "P"
}, qN = function(i, d, a, t) {
  var o = LN[i];
  return typeof o == "function" ? o(d) : o;
}, ZN = {
  narrow: ["пр.н.е.", "АД"],
  abbreviated: ["пр. Хр.", "по. Хр."],
  wide: ["Пре Христа", "После Христа"]
}, AN = {
  narrow: ["1.", "2.", "3.", "4."],
  abbreviated: ["1. кв.", "2. кв.", "3. кв.", "4. кв."],
  wide: ["1. квартал", "2. квартал", "3. квартал", "4. квартал"]
}, VN = {
  narrow: ["1.", "2.", "3.", "4.", "5.", "6.", "7.", "8.", "9.", "10.", "11.", "12."],
  abbreviated: ["јан", "феб", "мар", "апр", "мај", "јун", "јул", "авг", "сеп", "окт", "нов", "дец"],
  wide: ["јануар", "фебруар", "март", "април", "мај", "јун", "јул", "август", "септембар", "октобар", "новембар", "децембар"]
}, HN = {
  narrow: ["1.", "2.", "3.", "4.", "5.", "6.", "7.", "8.", "9.", "10.", "11.", "12."],
  abbreviated: ["јан", "феб", "мар", "апр", "мај", "јун", "јул", "авг", "сеп", "окт", "нов", "дец"],
  wide: ["јануар", "фебруар", "март", "април", "мај", "јун", "јул", "август", "септембар", "октобар", "новембар", "децембар"]
}, UN = {
  narrow: ["Н", "П", "У", "С", "Ч", "П", "С"],
  short: ["нед", "пон", "уто", "сре", "чет", "пет", "суб"],
  abbreviated: ["нед", "пон", "уто", "сре", "чет", "пет", "суб"],
  wide: ["недеља", "понедељак", "уторак", "среда", "четвртак", "петак", "субота"]
}, BN = {
  narrow: {
    am: "АМ",
    pm: "ПМ",
    midnight: "поноћ",
    noon: "подне",
    morning: "ујутру",
    afternoon: "поподне",
    evening: "увече",
    night: "ноћу"
  },
  abbreviated: {
    am: "АМ",
    pm: "ПМ",
    midnight: "поноћ",
    noon: "подне",
    morning: "ујутру",
    afternoon: "поподне",
    evening: "увече",
    night: "ноћу"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "поноћ",
    noon: "подне",
    morning: "ујутру",
    afternoon: "после подне",
    evening: "увече",
    night: "ноћу"
  }
}, XN = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "поноћ",
    noon: "подне",
    morning: "ујутру",
    afternoon: "поподне",
    evening: "увече",
    night: "ноћу"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "поноћ",
    noon: "подне",
    morning: "ујутру",
    afternoon: "поподне",
    evening: "увече",
    night: "ноћу"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "поноћ",
    noon: "подне",
    morning: "ујутру",
    afternoon: "после подне",
    evening: "увече",
    night: "ноћу"
  }
}, GN = function(i, d) {
  var a = Number(i);
  return a + ".";
}, KN = {
  ordinalNumber: GN,
  era: $({
    values: ZN,
    defaultWidth: "wide"
  }),
  quarter: $({
    values: AN,
    defaultWidth: "wide",
    argumentCallback: function(i) {
      return i - 1;
    }
  }),
  month: $({
    values: VN,
    defaultWidth: "wide",
    formattingValues: HN,
    defaultFormattingWidth: "wide"
  }),
  day: $({
    values: UN,
    defaultWidth: "wide"
  }),
  dayPeriod: $({
    values: XN,
    defaultWidth: "wide",
    formattingValues: BN,
    defaultFormattingWidth: "wide"
  })
}, YN = /^(\d+)\./i, JN = /\d+/i, QN = {
  narrow: /^(пр\.н\.е\.|АД)/i,
  abbreviated: /^(пр\.\s?Хр\.|по\.\s?Хр\.)/i,
  wide: /^(Пре Христа|пре нове ере|После Христа|нова ера)/i
}, ex = {
  any: [/^пр/i, /^(по|нова)/i]
}, nx = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234]\.\s?кв\.?/i,
  wide: /^[1234]\. квартал/i
}, ix = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, ax = {
  narrow: /^(10|11|12|[123456789])\./i,
  abbreviated: /^(јан|феб|мар|апр|мај|јун|јул|авг|сеп|окт|нов|дец)/i,
  wide: /^((јануар|јануара)|(фебруар|фебруара)|(март|марта)|(април|априла)|(мја|маја)|(јун|јуна)|(јул|јула)|(август|августа)|(септембар|септембра)|(октобар|октобра)|(новембар|новембра)|(децембар|децембра))/i
}, tx = {
  narrow: [/^1/i, /^2/i, /^3/i, /^4/i, /^5/i, /^6/i, /^7/i, /^8/i, /^9/i, /^10/i, /^11/i, /^12/i],
  any: [/^ја/i, /^ф/i, /^мар/i, /^ап/i, /^мај/i, /^јун/i, /^јул/i, /^авг/i, /^с/i, /^о/i, /^н/i, /^д/i]
}, rx = {
  narrow: /^[пусчн]/i,
  short: /^(нед|пон|уто|сре|чет|пет|суб)/i,
  abbreviated: /^(нед|пон|уто|сре|чет|пет|суб)/i,
  wide: /^(недеља|понедељак|уторак|среда|четвртак|петак|субота)/i
}, ox = {
  narrow: [/^п/i, /^у/i, /^с/i, /^ч/i, /^п/i, /^с/i, /^н/i],
  any: [/^нед/i, /^пон/i, /^уто/i, /^сре/i, /^чет/i, /^пет/i, /^суб/i]
}, sx = {
  any: /^(ам|пм|поноћ|(по)?подне|увече|ноћу|после подне|ујутру)/i
}, dx = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^поно/i,
    noon: /^под/i,
    morning: /ујутру/i,
    afternoon: /(после\s|по)+подне/i,
    evening: /(увече)/i,
    night: /(ноћу)/i
  }
}, ux = {
  ordinalNumber: le({
    matchPattern: YN,
    parsePattern: JN,
    valueCallback: function(i) {
      return parseInt(i, 10);
    }
  }),
  era: P({
    matchPatterns: QN,
    defaultMatchWidth: "wide",
    parsePatterns: ex,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: nx,
    defaultMatchWidth: "wide",
    parsePatterns: ix,
    defaultParseWidth: "any",
    valueCallback: function(i) {
      return i + 1;
    }
  }),
  month: P({
    matchPatterns: ax,
    defaultMatchWidth: "wide",
    parsePatterns: tx,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: rx,
    defaultMatchWidth: "wide",
    parsePatterns: ox,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: sx,
    defaultMatchWidth: "any",
    parsePatterns: dx,
    defaultParseWidth: "any"
  })
}, fx = {
  code: "sr",
  formatDistance: NN,
  formatLong: RN,
  formatRelative: qN,
  localize: KN,
  match: ux,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
};
const lx = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: fx
}, Symbol.toStringTag, { value: "Module" })), cx = /* @__PURE__ */ te(lx);
var mx = {
  lessThanXSeconds: {
    one: {
      standalone: "manje od 1 sekunde",
      withPrepositionAgo: "manje od 1 sekunde",
      withPrepositionIn: "manje od 1 sekundu"
    },
    dual: "manje od {{count}} sekunde",
    other: "manje od {{count}} sekundi"
  },
  xSeconds: {
    one: {
      standalone: "1 sekunda",
      withPrepositionAgo: "1 sekunde",
      withPrepositionIn: "1 sekundu"
    },
    dual: "{{count}} sekunde",
    other: "{{count}} sekundi"
  },
  halfAMinute: "pola minute",
  lessThanXMinutes: {
    one: {
      standalone: "manje od 1 minute",
      withPrepositionAgo: "manje od 1 minute",
      withPrepositionIn: "manje od 1 minutu"
    },
    dual: "manje od {{count}} minute",
    other: "manje od {{count}} minuta"
  },
  xMinutes: {
    one: {
      standalone: "1 minuta",
      withPrepositionAgo: "1 minute",
      withPrepositionIn: "1 minutu"
    },
    dual: "{{count}} minute",
    other: "{{count}} minuta"
  },
  aboutXHours: {
    one: {
      standalone: "oko 1 sat",
      withPrepositionAgo: "oko 1 sat",
      withPrepositionIn: "oko 1 sat"
    },
    dual: "oko {{count}} sata",
    other: "oko {{count}} sati"
  },
  xHours: {
    one: {
      standalone: "1 sat",
      withPrepositionAgo: "1 sat",
      withPrepositionIn: "1 sat"
    },
    dual: "{{count}} sata",
    other: "{{count}} sati"
  },
  xDays: {
    one: {
      standalone: "1 dan",
      withPrepositionAgo: "1 dan",
      withPrepositionIn: "1 dan"
    },
    dual: "{{count}} dana",
    other: "{{count}} dana"
  },
  aboutXWeeks: {
    one: {
      standalone: "oko 1 nedelju",
      withPrepositionAgo: "oko 1 nedelju",
      withPrepositionIn: "oko 1 nedelju"
    },
    dual: "oko {{count}} nedelje",
    other: "oko {{count}} nedelje"
  },
  xWeeks: {
    one: {
      standalone: "1 nedelju",
      withPrepositionAgo: "1 nedelju",
      withPrepositionIn: "1 nedelju"
    },
    dual: "{{count}} nedelje",
    other: "{{count}} nedelje"
  },
  aboutXMonths: {
    one: {
      standalone: "oko 1 mesec",
      withPrepositionAgo: "oko 1 mesec",
      withPrepositionIn: "oko 1 mesec"
    },
    dual: "oko {{count}} meseca",
    other: "oko {{count}} meseci"
  },
  xMonths: {
    one: {
      standalone: "1 mesec",
      withPrepositionAgo: "1 mesec",
      withPrepositionIn: "1 mesec"
    },
    dual: "{{count}} meseca",
    other: "{{count}} meseci"
  },
  aboutXYears: {
    one: {
      standalone: "oko 1 godinu",
      withPrepositionAgo: "oko 1 godinu",
      withPrepositionIn: "oko 1 godinu"
    },
    dual: "oko {{count}} godine",
    other: "oko {{count}} godina"
  },
  xYears: {
    one: {
      standalone: "1 godina",
      withPrepositionAgo: "1 godine",
      withPrepositionIn: "1 godinu"
    },
    dual: "{{count}} godine",
    other: "{{count}} godina"
  },
  overXYears: {
    one: {
      standalone: "preko 1 godinu",
      withPrepositionAgo: "preko 1 godinu",
      withPrepositionIn: "preko 1 godinu"
    },
    dual: "preko {{count}} godine",
    other: "preko {{count}} godina"
  },
  almostXYears: {
    one: {
      standalone: "gotovo 1 godinu",
      withPrepositionAgo: "gotovo 1 godinu",
      withPrepositionIn: "gotovo 1 godinu"
    },
    dual: "gotovo {{count}} godine",
    other: "gotovo {{count}} godina"
  }
}, vx = function(i, d, a) {
  var t, o = mx[i];
  return typeof o == "string" ? t = o : d === 1 ? a != null && a.addSuffix ? a.comparison && a.comparison > 0 ? t = o.one.withPrepositionIn : t = o.one.withPrepositionAgo : t = o.one.standalone : d % 10 > 1 && d % 10 < 5 && // if last digit is between 2 and 4
  String(d).substr(-2, 1) !== "1" ? t = o.dual.replace("{{count}}", String(d)) : t = o.other.replace("{{count}}", String(d)), a != null && a.addSuffix ? a.comparison && a.comparison > 0 ? "za " + t : "pre " + t : t;
}, hx = {
  full: "EEEE, d. MMMM yyyy.",
  long: "d. MMMM yyyy.",
  medium: "d. MMM yy.",
  short: "dd. MM. yy."
}, gx = {
  full: "HH:mm:ss (zzzz)",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, px = {
  full: "{{date}} 'u' {{time}}",
  long: "{{date}} 'u' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, bx = {
  date: I({
    formats: hx,
    defaultWidth: "full"
  }),
  time: I({
    formats: gx,
    defaultWidth: "full"
  }),
  dateTime: I({
    formats: px,
    defaultWidth: "full"
  })
}, yx = {
  lastWeek: function(i) {
    switch (i.getUTCDay()) {
      case 0:
        return "'prošle nedelje u' p";
      case 3:
        return "'prošle srede u' p";
      case 6:
        return "'prošle subote u' p";
      default:
        return "'prošli' EEEE 'u' p";
    }
  },
  yesterday: "'juče u' p",
  today: "'danas u' p",
  tomorrow: "'sutra u' p",
  nextWeek: function(i) {
    switch (i.getUTCDay()) {
      case 0:
        return "'sledeće nedelje u' p";
      case 3:
        return "'sledeću sredu u' p";
      case 6:
        return "'sledeću subotu u' p";
      default:
        return "'sledeći' EEEE 'u' p";
    }
  },
  other: "P"
}, kx = function(i, d, a, t) {
  var o = yx[i];
  return typeof o == "function" ? o(d) : o;
}, wx = {
  narrow: ["pr.n.e.", "AD"],
  abbreviated: ["pr. Hr.", "po. Hr."],
  wide: ["Pre Hrista", "Posle Hrista"]
}, _x = {
  narrow: ["1.", "2.", "3.", "4."],
  abbreviated: ["1. kv.", "2. kv.", "3. kv.", "4. kv."],
  wide: ["1. kvartal", "2. kvartal", "3. kvartal", "4. kvartal"]
}, $x = {
  narrow: ["1.", "2.", "3.", "4.", "5.", "6.", "7.", "8.", "9.", "10.", "11.", "12."],
  abbreviated: ["jan", "feb", "mar", "apr", "maj", "jun", "jul", "avg", "sep", "okt", "nov", "dec"],
  wide: ["januar", "februar", "mart", "april", "maj", "jun", "jul", "avgust", "septembar", "oktobar", "novembar", "decembar"]
}, Px = {
  narrow: ["1.", "2.", "3.", "4.", "5.", "6.", "7.", "8.", "9.", "10.", "11.", "12."],
  abbreviated: ["jan", "feb", "mar", "apr", "maj", "jun", "jul", "avg", "sep", "okt", "nov", "dec"],
  wide: ["januar", "februar", "mart", "april", "maj", "jun", "jul", "avgust", "septembar", "oktobar", "novembar", "decembar"]
}, Mx = {
  narrow: ["N", "P", "U", "S", "Č", "P", "S"],
  short: ["ned", "pon", "uto", "sre", "čet", "pet", "sub"],
  abbreviated: ["ned", "pon", "uto", "sre", "čet", "pet", "sub"],
  wide: ["nedelja", "ponedeljak", "utorak", "sreda", "četvrtak", "petak", "subota"]
}, jx = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "ponoć",
    noon: "podne",
    morning: "ujutru",
    afternoon: "popodne",
    evening: "uveče",
    night: "noću"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "ponoć",
    noon: "podne",
    morning: "ujutru",
    afternoon: "popodne",
    evening: "uveče",
    night: "noću"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "ponoć",
    noon: "podne",
    morning: "ujutru",
    afternoon: "posle podne",
    evening: "uveče",
    night: "noću"
  }
}, Sx = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "ponoć",
    noon: "podne",
    morning: "ujutru",
    afternoon: "popodne",
    evening: "uveče",
    night: "noću"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "ponoć",
    noon: "podne",
    morning: "ujutru",
    afternoon: "popodne",
    evening: "uveče",
    night: "noću"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "ponoć",
    noon: "podne",
    morning: "ujutru",
    afternoon: "posle podne",
    evening: "uveče",
    night: "noću"
  }
}, zx = function(i, d) {
  var a = Number(i);
  return a + ".";
}, Ox = {
  ordinalNumber: zx,
  era: $({
    values: wx,
    defaultWidth: "wide"
  }),
  quarter: $({
    values: _x,
    defaultWidth: "wide",
    argumentCallback: function(i) {
      return i - 1;
    }
  }),
  month: $({
    values: $x,
    defaultWidth: "wide",
    formattingValues: Px,
    defaultFormattingWidth: "wide"
  }),
  day: $({
    values: Mx,
    defaultWidth: "wide"
  }),
  dayPeriod: $({
    values: Sx,
    defaultWidth: "wide",
    formattingValues: jx,
    defaultFormattingWidth: "wide"
  })
}, Wx = /^(\d+)\./i, Dx = /\d+/i, Cx = {
  narrow: /^(pr\.n\.e\.|AD)/i,
  abbreviated: /^(pr\.\s?Hr\.|po\.\s?Hr\.)/i,
  wide: /^(Pre Hrista|pre nove ere|Posle Hrista|nova era)/i
}, Ix = {
  any: [/^pr/i, /^(po|nova)/i]
}, Tx = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234]\.\s?kv\.?/i,
  wide: /^[1234]\. kvartal/i
}, Nx = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, xx = {
  narrow: /^(10|11|12|[123456789])\./i,
  abbreviated: /^(jan|feb|mar|apr|maj|jun|jul|avg|sep|okt|nov|dec)/i,
  wide: /^((januar|januara)|(februar|februara)|(mart|marta)|(april|aprila)|(maj|maja)|(jun|juna)|(jul|jula)|(avgust|avgusta)|(septembar|septembra)|(oktobar|oktobra)|(novembar|novembra)|(decembar|decembra))/i
}, Fx = {
  narrow: [/^1/i, /^2/i, /^3/i, /^4/i, /^5/i, /^6/i, /^7/i, /^8/i, /^9/i, /^10/i, /^11/i, /^12/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^maj/i, /^jun/i, /^jul/i, /^avg/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, Ex = {
  narrow: /^[npusčc]/i,
  short: /^(ned|pon|uto|sre|(čet|cet)|pet|sub)/i,
  abbreviated: /^(ned|pon|uto|sre|(čet|cet)|pet|sub)/i,
  wide: /^(nedelja|ponedeljak|utorak|sreda|(četvrtak|cetvrtak)|petak|subota)/i
}, Rx = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, Lx = {
  any: /^(am|pm|ponoc|ponoć|(po)?podne|uvece|uveče|noću|posle podne|ujutru)/i
}, qx = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^pono/i,
    noon: /^pod/i,
    morning: /jutro/i,
    afternoon: /(posle\s|po)+podne/i,
    evening: /(uvece|uveče)/i,
    night: /(nocu|noću)/i
  }
}, Zx = {
  ordinalNumber: le({
    matchPattern: Wx,
    parsePattern: Dx,
    valueCallback: function(i) {
      return parseInt(i, 10);
    }
  }),
  era: P({
    matchPatterns: Cx,
    defaultMatchWidth: "wide",
    parsePatterns: Ix,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: Tx,
    defaultMatchWidth: "wide",
    parsePatterns: Nx,
    defaultParseWidth: "any",
    valueCallback: function(i) {
      return i + 1;
    }
  }),
  month: P({
    matchPatterns: xx,
    defaultMatchWidth: "wide",
    parsePatterns: Fx,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: Ex,
    defaultMatchWidth: "wide",
    parsePatterns: Rx,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: Lx,
    defaultMatchWidth: "any",
    parsePatterns: qx,
    defaultParseWidth: "any"
  })
}, Ax = {
  code: "sr-Latn",
  formatDistance: vx,
  formatLong: bx,
  formatRelative: kx,
  localize: Ox,
  match: Zx,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
};
const Vx = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ax
}, Symbol.toStringTag, { value: "Module" })), Hx = /* @__PURE__ */ te(Vx);
var Ux = {
  lessThanXSeconds: {
    one: "mindre än en sekund",
    other: "mindre än {{count}} sekunder"
  },
  xSeconds: {
    one: "en sekund",
    other: "{{count}} sekunder"
  },
  halfAMinute: "en halv minut",
  lessThanXMinutes: {
    one: "mindre än en minut",
    other: "mindre än {{count}} minuter"
  },
  xMinutes: {
    one: "en minut",
    other: "{{count}} minuter"
  },
  aboutXHours: {
    one: "ungefär en timme",
    other: "ungefär {{count}} timmar"
  },
  xHours: {
    one: "en timme",
    other: "{{count}} timmar"
  },
  xDays: {
    one: "en dag",
    other: "{{count}} dagar"
  },
  aboutXWeeks: {
    one: "ungefär en vecka",
    other: "ungefär {{count}} vecka"
  },
  xWeeks: {
    one: "en vecka",
    other: "{{count}} vecka"
  },
  aboutXMonths: {
    one: "ungefär en månad",
    other: "ungefär {{count}} månader"
  },
  xMonths: {
    one: "en månad",
    other: "{{count}} månader"
  },
  aboutXYears: {
    one: "ungefär ett år",
    other: "ungefär {{count}} år"
  },
  xYears: {
    one: "ett år",
    other: "{{count}} år"
  },
  overXYears: {
    one: "över ett år",
    other: "över {{count}} år"
  },
  almostXYears: {
    one: "nästan ett år",
    other: "nästan {{count}} år"
  }
}, Bx = ["noll", "en", "två", "tre", "fyra", "fem", "sex", "sju", "åtta", "nio", "tio", "elva", "tolv"], Xx = function(i, d, a) {
  var t, o = Ux[i];
  return typeof o == "string" ? t = o : d === 1 ? t = o.one : a && a.onlyNumeric ? t = o.other.replace("{{count}}", String(d)) : t = o.other.replace("{{count}}", d < 13 ? Bx[d] : String(d)), a != null && a.addSuffix ? a.comparison && a.comparison > 0 ? "om " + t : t + " sedan" : t;
}, Gx = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "y-MM-dd"
}, Kx = {
  full: "'kl'. HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, Yx = {
  full: "{{date}} 'kl.' {{time}}",
  long: "{{date}} 'kl.' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, Jx = {
  date: I({
    formats: Gx,
    defaultWidth: "full"
  }),
  time: I({
    formats: Kx,
    defaultWidth: "full"
  }),
  dateTime: I({
    formats: Yx,
    defaultWidth: "full"
  })
}, Qx = {
  lastWeek: "'i' EEEE's kl.' p",
  yesterday: "'igår kl.' p",
  today: "'idag kl.' p",
  tomorrow: "'imorgon kl.' p",
  nextWeek: "EEEE 'kl.' p",
  other: "P"
}, eF = function(i, d, a, t) {
  return Qx[i];
}, nF = {
  narrow: ["f.Kr.", "e.Kr."],
  abbreviated: ["f.Kr.", "e.Kr."],
  wide: ["före Kristus", "efter Kristus"]
}, iF = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1:a kvartalet", "2:a kvartalet", "3:e kvartalet", "4:e kvartalet"]
}, aF = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["jan.", "feb.", "mars", "apr.", "maj", "juni", "juli", "aug.", "sep.", "okt.", "nov.", "dec."],
  wide: ["januari", "februari", "mars", "april", "maj", "juni", "juli", "augusti", "september", "oktober", "november", "december"]
}, tF = {
  narrow: ["S", "M", "T", "O", "T", "F", "L"],
  short: ["sö", "må", "ti", "on", "to", "fr", "lö"],
  abbreviated: ["sön", "mån", "tis", "ons", "tors", "fre", "lör"],
  wide: ["söndag", "måndag", "tisdag", "onsdag", "torsdag", "fredag", "lördag"]
}, rF = {
  narrow: {
    am: "fm",
    pm: "em",
    midnight: "midnatt",
    noon: "middag",
    morning: "morg.",
    afternoon: "efterm.",
    evening: "kväll",
    night: "natt"
  },
  abbreviated: {
    am: "f.m.",
    pm: "e.m.",
    midnight: "midnatt",
    noon: "middag",
    morning: "morgon",
    afternoon: "efterm.",
    evening: "kväll",
    night: "natt"
  },
  wide: {
    am: "förmiddag",
    pm: "eftermiddag",
    midnight: "midnatt",
    noon: "middag",
    morning: "morgon",
    afternoon: "eftermiddag",
    evening: "kväll",
    night: "natt"
  }
}, oF = {
  narrow: {
    am: "fm",
    pm: "em",
    midnight: "midnatt",
    noon: "middag",
    morning: "på morg.",
    afternoon: "på efterm.",
    evening: "på kvällen",
    night: "på natten"
  },
  abbreviated: {
    am: "fm",
    pm: "em",
    midnight: "midnatt",
    noon: "middag",
    morning: "på morg.",
    afternoon: "på efterm.",
    evening: "på kvällen",
    night: "på natten"
  },
  wide: {
    am: "fm",
    pm: "em",
    midnight: "midnatt",
    noon: "middag",
    morning: "på morgonen",
    afternoon: "på eftermiddagen",
    evening: "på kvällen",
    night: "på natten"
  }
}, sF = function(i, d) {
  var a = Number(i), t = a % 100;
  if (t > 20 || t < 10)
    switch (t % 10) {
      case 1:
      case 2:
        return a + ":a";
    }
  return a + ":e";
}, dF = {
  ordinalNumber: sF,
  era: $({
    values: nF,
    defaultWidth: "wide"
  }),
  quarter: $({
    values: iF,
    defaultWidth: "wide",
    argumentCallback: function(i) {
      return i - 1;
    }
  }),
  month: $({
    values: aF,
    defaultWidth: "wide"
  }),
  day: $({
    values: tF,
    defaultWidth: "wide"
  }),
  dayPeriod: $({
    values: rF,
    defaultWidth: "wide",
    formattingValues: oF,
    defaultFormattingWidth: "wide"
  })
}, uF = /^(\d+)(:a|:e)?/i, fF = /\d+/i, lF = {
  narrow: /^(f\.? ?Kr\.?|f\.? ?v\.? ?t\.?|e\.? ?Kr\.?|v\.? ?t\.?)/i,
  abbreviated: /^(f\.? ?Kr\.?|f\.? ?v\.? ?t\.?|e\.? ?Kr\.?|v\.? ?t\.?)/i,
  wide: /^(före Kristus|före vår tid|efter Kristus|vår tid)/i
}, cF = {
  any: [/^f/i, /^[ev]/i]
}, mF = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](:a|:e)? kvartalet/i
}, vF = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, hF = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar[s]?|apr|maj|jun[i]?|jul[i]?|aug|sep|okt|nov|dec)\.?/i,
  wide: /^(januari|februari|mars|april|maj|juni|juli|augusti|september|oktober|november|december)/i
}, gF = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^maj/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, pF = {
  narrow: /^[smtofl]/i,
  short: /^(sö|må|ti|on|to|fr|lö)/i,
  abbreviated: /^(sön|mån|tis|ons|tors|fre|lör)/i,
  wide: /^(söndag|måndag|tisdag|onsdag|torsdag|fredag|lördag)/i
}, bF = {
  any: [/^s/i, /^m/i, /^ti/i, /^o/i, /^to/i, /^f/i, /^l/i]
}, yF = {
  any: /^([fe]\.?\s?m\.?|midn(att)?|midd(ag)?|(på) (morgonen|eftermiddagen|kvällen|natten))/i
}, kF = {
  any: {
    am: /^f/i,
    pm: /^e/i,
    midnight: /^midn/i,
    noon: /^midd/i,
    morning: /morgon/i,
    afternoon: /eftermiddag/i,
    evening: /kväll/i,
    night: /natt/i
  }
}, wF = {
  ordinalNumber: le({
    matchPattern: uF,
    parsePattern: fF,
    valueCallback: function(i) {
      return parseInt(i, 10);
    }
  }),
  era: P({
    matchPatterns: lF,
    defaultMatchWidth: "wide",
    parsePatterns: cF,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: mF,
    defaultMatchWidth: "wide",
    parsePatterns: vF,
    defaultParseWidth: "any",
    valueCallback: function(i) {
      return i + 1;
    }
  }),
  month: P({
    matchPatterns: hF,
    defaultMatchWidth: "wide",
    parsePatterns: gF,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: pF,
    defaultMatchWidth: "wide",
    parsePatterns: bF,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: yF,
    defaultMatchWidth: "any",
    parsePatterns: kF,
    defaultParseWidth: "any"
  })
}, _F = {
  code: "sv",
  formatDistance: Xx,
  formatLong: Jx,
  formatRelative: eF,
  localize: dF,
  match: wF,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const $F = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: _F
}, Symbol.toStringTag, { value: "Module" })), PF = /* @__PURE__ */ te($F);
function MF(e) {
  return e.one !== void 0;
}
var jF = {
  lessThanXSeconds: {
    one: {
      default: "ஒரு வினாடிக்கு குறைவாக",
      in: "ஒரு வினாடிக்குள்",
      ago: "ஒரு வினாடிக்கு முன்பு"
    },
    other: {
      default: "{{count}} வினாடிகளுக்கு குறைவாக",
      in: "{{count}} வினாடிகளுக்குள்",
      ago: "{{count}} வினாடிகளுக்கு முன்பு"
    }
  },
  xSeconds: {
    one: {
      default: "1 வினாடி",
      in: "1 வினாடியில்",
      ago: "1 வினாடி முன்பு"
    },
    other: {
      default: "{{count}} விநாடிகள்",
      in: "{{count}} வினாடிகளில்",
      ago: "{{count}} விநாடிகளுக்கு முன்பு"
    }
  },
  halfAMinute: {
    default: "அரை நிமிடம்",
    in: "அரை நிமிடத்தில்",
    ago: "அரை நிமிடம் முன்பு"
  },
  lessThanXMinutes: {
    one: {
      default: "ஒரு நிமிடத்திற்கும் குறைவாக",
      in: "ஒரு நிமிடத்திற்குள்",
      ago: "ஒரு நிமிடத்திற்கு முன்பு"
    },
    other: {
      default: "{{count}} நிமிடங்களுக்கும் குறைவாக",
      in: "{{count}} நிமிடங்களுக்குள்",
      ago: "{{count}} நிமிடங்களுக்கு முன்பு"
    }
  },
  xMinutes: {
    one: {
      default: "1 நிமிடம்",
      in: "1 நிமிடத்தில்",
      ago: "1 நிமிடம் முன்பு"
    },
    other: {
      default: "{{count}} நிமிடங்கள்",
      in: "{{count}} நிமிடங்களில்",
      ago: "{{count}} நிமிடங்களுக்கு முன்பு"
    }
  },
  aboutXHours: {
    one: {
      default: "சுமார் 1 மணி நேரம்",
      in: "சுமார் 1 மணி நேரத்தில்",
      ago: "சுமார் 1 மணி நேரத்திற்கு முன்பு"
    },
    other: {
      default: "சுமார் {{count}} மணி நேரம்",
      in: "சுமார் {{count}} மணி நேரத்திற்கு முன்பு",
      ago: "சுமார் {{count}} மணி நேரத்தில்"
    }
  },
  xHours: {
    one: {
      default: "1 மணி நேரம்",
      in: "1 மணி நேரத்தில்",
      ago: "1 மணி நேரத்திற்கு முன்பு"
    },
    other: {
      default: "{{count}} மணி நேரம்",
      in: "{{count}} மணி நேரத்தில்",
      ago: "{{count}} மணி நேரத்திற்கு முன்பு"
    }
  },
  xDays: {
    one: {
      default: "1 நாள்",
      in: "1 நாளில்",
      ago: "1 நாள் முன்பு"
    },
    other: {
      default: "{{count}} நாட்கள்",
      in: "{{count}} நாட்களில்",
      ago: "{{count}} நாட்களுக்கு முன்பு"
    }
  },
  aboutXWeeks: {
    one: {
      default: "சுமார் 1 வாரம்",
      in: "சுமார் 1 வாரத்தில்",
      ago: "சுமார் 1 வாரம் முன்பு"
    },
    other: {
      default: "சுமார் {{count}} வாரங்கள்",
      in: "சுமார் {{count}} வாரங்களில்",
      ago: "சுமார் {{count}} வாரங்களுக்கு முன்பு"
    }
  },
  xWeeks: {
    one: {
      default: "1 வாரம்",
      in: "1 வாரத்தில்",
      ago: "1 வாரம் முன்பு"
    },
    other: {
      default: "{{count}} வாரங்கள்",
      in: "{{count}} வாரங்களில்",
      ago: "{{count}} வாரங்களுக்கு முன்பு"
    }
  },
  aboutXMonths: {
    one: {
      default: "சுமார் 1 மாதம்",
      in: "சுமார் 1 மாதத்தில்",
      ago: "சுமார் 1 மாதத்திற்கு முன்பு"
    },
    other: {
      default: "சுமார் {{count}} மாதங்கள்",
      in: "சுமார் {{count}} மாதங்களில்",
      ago: "சுமார் {{count}} மாதங்களுக்கு முன்பு"
    }
  },
  xMonths: {
    one: {
      default: "1 மாதம்",
      in: "1 மாதத்தில்",
      ago: "1 மாதம் முன்பு"
    },
    other: {
      default: "{{count}} மாதங்கள்",
      in: "{{count}} மாதங்களில்",
      ago: "{{count}} மாதங்களுக்கு முன்பு"
    }
  },
  aboutXYears: {
    one: {
      default: "சுமார் 1 வருடம்",
      in: "சுமார் 1 ஆண்டில்",
      ago: "சுமார் 1 வருடம் முன்பு"
    },
    other: {
      default: "சுமார் {{count}} ஆண்டுகள்",
      in: "சுமார் {{count}} ஆண்டுகளில்",
      ago: "சுமார் {{count}} ஆண்டுகளுக்கு முன்பு"
    }
  },
  xYears: {
    one: {
      default: "1 வருடம்",
      in: "1 ஆண்டில்",
      ago: "1 வருடம் முன்பு"
    },
    other: {
      default: "{{count}} ஆண்டுகள்",
      in: "{{count}} ஆண்டுகளில்",
      ago: "{{count}} ஆண்டுகளுக்கு முன்பு"
    }
  },
  overXYears: {
    one: {
      default: "1 வருடத்திற்கு மேல்",
      in: "1 வருடத்திற்கும் மேலாக",
      ago: "1 வருடம் முன்பு"
    },
    other: {
      default: "{{count}} ஆண்டுகளுக்கும் மேலாக",
      in: "{{count}} ஆண்டுகளில்",
      ago: "{{count}} ஆண்டுகளுக்கு முன்பு"
    }
  },
  almostXYears: {
    one: {
      default: "கிட்டத்தட்ட 1 வருடம்",
      in: "கிட்டத்தட்ட 1 ஆண்டில்",
      ago: "கிட்டத்தட்ட 1 வருடம் முன்பு"
    },
    other: {
      default: "கிட்டத்தட்ட {{count}} ஆண்டுகள்",
      in: "கிட்டத்தட்ட {{count}} ஆண்டுகளில்",
      ago: "கிட்டத்தட்ட {{count}} ஆண்டுகளுக்கு முன்பு"
    }
  }
}, SF = function(i, d, a) {
  var t = a != null && a.addSuffix ? a.comparison && a.comparison > 0 ? "in" : "ago" : "default", o = jF[i];
  return MF(o) ? d === 1 ? o.one[t] : o.other[t].replace("{{count}}", String(d)) : o[t];
}, zF = {
  full: "EEEE, d MMMM, y",
  long: "d MMMM, y",
  medium: "d MMM, y",
  short: "d/M/yy"
}, OF = {
  full: "a h:mm:ss zzzz",
  long: "a h:mm:ss z",
  medium: "a h:mm:ss",
  short: "a h:mm"
}, WF = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, DF = {
  date: I({
    formats: zF,
    defaultWidth: "full"
  }),
  time: I({
    formats: OF,
    defaultWidth: "full"
  }),
  dateTime: I({
    formats: WF,
    defaultWidth: "full"
  })
}, CF = {
  lastWeek: "'கடந்த' eeee p 'மணிக்கு'",
  yesterday: "'நேற்று ' p 'மணிக்கு'",
  today: "'இன்று ' p 'மணிக்கு'",
  tomorrow: "'நாளை ' p 'மணிக்கு'",
  nextWeek: "eeee p 'மணிக்கு'",
  other: "P"
}, IF = function(i, d, a, t) {
  return CF[i];
}, TF = {
  narrow: ["கி.மு.", "கி.பி."],
  abbreviated: ["கி.மு.", "கி.பி."],
  // CLDR #1624, #1626
  wide: ["கிறிஸ்துவுக்கு முன்", "அன்னோ டோமினி"]
  // CLDR #1620, #1622
}, NF = {
  // CLDR #1644 - #1647
  narrow: ["1", "2", "3", "4"],
  // CLDR #1636 - #1639
  abbreviated: ["காலா.1", "காலா.2", "காலா.3", "காலா.4"],
  // CLDR #1628 - #1631
  wide: ["ஒன்றாம் காலாண்டு", "இரண்டாம் காலாண்டு", "மூன்றாம் காலாண்டு", "நான்காம் காலாண்டு"]
}, xF = {
  // CLDR #700 - #711
  narrow: ["ஜ", "பி", "மா", "ஏ", "மே", "ஜூ", "ஜூ", "ஆ", "செ", "அ", "ந", "டி"],
  // CLDR #1676 - #1687
  abbreviated: ["ஜன.", "பிப்.", "மார்.", "ஏப்.", "மே", "ஜூன்", "ஜூலை", "ஆக.", "செப்.", "அக்.", "நவ.", "டிச."],
  // CLDR #1652 - #1663
  wide: [
    "ஜனவரி",
    // January
    "பிப்ரவரி",
    // February
    "மார்ச்",
    // March
    "ஏப்ரல்",
    // April
    "மே",
    // May
    "ஜூன்",
    // June
    "ஜூலை",
    // July
    "ஆகஸ்ட்",
    // August
    "செப்டம்பர்",
    // September
    "அக்டோபர்",
    // October
    "நவம்பர்",
    // November
    "டிசம்பர்"
    // December
  ]
}, FF = {
  // CLDR #1766 - #1772
  narrow: ["ஞா", "தி", "செ", "பு", "வி", "வெ", "ச"],
  // CLDR #1752 - #1758
  short: ["ஞா", "தி", "செ", "பு", "வி", "வெ", "ச"],
  // CLDR #1738 - #1744
  abbreviated: ["ஞாயி.", "திங்.", "செவ்.", "புத.", "வியா.", "வெள்.", "சனி"],
  // CLDR #1724 - #1730
  wide: [
    "ஞாயிறு",
    // Sunday
    "திங்கள்",
    // Monday
    "செவ்வாய்",
    // Tuesday
    "புதன்",
    // Wednesday
    "வியாழன்",
    // Thursday
    "வெள்ளி",
    // Friday
    "சனி"
    // Saturday
  ]
}, EF = {
  narrow: {
    am: "மு.ப",
    pm: "பி.ப",
    midnight: "நள்.",
    noon: "நண்.",
    morning: "கா.",
    afternoon: "மதி.",
    evening: "மா.",
    night: "இர."
  },
  abbreviated: {
    am: "முற்பகல்",
    pm: "பிற்பகல்",
    midnight: "நள்ளிரவு",
    noon: "நண்பகல்",
    morning: "காலை",
    afternoon: "மதியம்",
    evening: "மாலை",
    night: "இரவு"
  },
  wide: {
    am: "முற்பகல்",
    pm: "பிற்பகல்",
    midnight: "நள்ளிரவு",
    noon: "நண்பகல்",
    morning: "காலை",
    afternoon: "மதியம்",
    evening: "மாலை",
    night: "இரவு"
  }
}, RF = {
  narrow: {
    am: "மு.ப",
    pm: "பி.ப",
    midnight: "நள்.",
    noon: "நண்.",
    morning: "கா.",
    afternoon: "மதி.",
    evening: "மா.",
    night: "இர."
  },
  abbreviated: {
    am: "முற்பகல்",
    pm: "பிற்பகல்",
    midnight: "நள்ளிரவு",
    noon: "நண்பகல்",
    morning: "காலை",
    afternoon: "மதியம்",
    evening: "மாலை",
    night: "இரவு"
  },
  wide: {
    am: "முற்பகல்",
    pm: "பிற்பகல்",
    midnight: "நள்ளிரவு",
    noon: "நண்பகல்",
    morning: "காலை",
    afternoon: "மதியம்",
    evening: "மாலை",
    night: "இரவு"
  }
}, LF = function(i, d) {
  return String(i);
}, qF = {
  ordinalNumber: LF,
  era: $({
    values: TF,
    defaultWidth: "wide"
  }),
  quarter: $({
    values: NF,
    defaultWidth: "wide",
    argumentCallback: function(i) {
      return i - 1;
    }
  }),
  month: $({
    values: xF,
    defaultWidth: "wide"
  }),
  day: $({
    values: FF,
    defaultWidth: "wide"
  }),
  dayPeriod: $({
    values: EF,
    defaultWidth: "wide",
    formattingValues: RF,
    defaultFormattingWidth: "wide"
  })
}, ZF = /^(\d+)(வது)?/i, AF = /\d+/i, VF = {
  narrow: /^(கி.மு.|கி.பி.)/i,
  abbreviated: /^(கி\.?\s?மு\.?|கி\.?\s?பி\.?)/,
  wide: /^(கிறிஸ்துவுக்கு\sமுன்|அன்னோ\sடோமினி)/i
}, HF = {
  any: [/கி\.?\s?மு\.?/, /கி\.?\s?பி\.?/]
}, UF = {
  narrow: /^[1234]/i,
  abbreviated: /^காலா.[1234]/i,
  wide: /^(ஒன்றாம்|இரண்டாம்|மூன்றாம்|நான்காம்) காலாண்டு/i
}, BF = {
  narrow: [/1/i, /2/i, /3/i, /4/i],
  any: [/(1|காலா.1|ஒன்றாம்)/i, /(2|காலா.2|இரண்டாம்)/i, /(3|காலா.3|மூன்றாம்)/i, /(4|காலா.4|நான்காம்)/i]
}, XF = {
  narrow: /^(ஜ|பி|மா|ஏ|மே|ஜூ|ஆ|செ|அ|ந|டி)$/i,
  abbreviated: /^(ஜன.|பிப்.|மார்.|ஏப்.|மே|ஜூன்|ஜூலை|ஆக.|செப்.|அக்.|நவ.|டிச.)/i,
  wide: /^(ஜனவரி|பிப்ரவரி|மார்ச்|ஏப்ரல்|மே|ஜூன்|ஜூலை|ஆகஸ்ட்|செப்டம்பர்|அக்டோபர்|நவம்பர்|டிசம்பர்)/i
}, GF = {
  narrow: [/^ஜ$/i, /^பி/i, /^மா/i, /^ஏ/i, /^மே/i, /^ஜூ/i, /^ஜூ/i, /^ஆ/i, /^செ/i, /^அ/i, /^ந/i, /^டி/i],
  any: [/^ஜன/i, /^பி/i, /^மா/i, /^ஏ/i, /^மே/i, /^ஜூன்/i, /^ஜூலை/i, /^ஆ/i, /^செ/i, /^அ/i, /^ந/i, /^டி/i]
}, KF = {
  narrow: /^(ஞா|தி|செ|பு|வி|வெ|ச)/i,
  short: /^(ஞா|தி|செ|பு|வி|வெ|ச)/i,
  abbreviated: /^(ஞாயி.|திங்.|செவ்.|புத.|வியா.|வெள்.|சனி)/i,
  wide: /^(ஞாயிறு|திங்கள்|செவ்வாய்|புதன்|வியாழன்|வெள்ளி|சனி)/i
}, YF = {
  narrow: [/^ஞா/i, /^தி/i, /^செ/i, /^பு/i, /^வி/i, /^வெ/i, /^ச/i],
  any: [/^ஞா/i, /^தி/i, /^செ/i, /^பு/i, /^வி/i, /^வெ/i, /^ச/i]
}, JF = {
  narrow: /^(மு.ப|பி.ப|நள்|நண்|காலை|மதியம்|மாலை|இரவு)/i,
  any: /^(மு.ப|பி.ப|முற்பகல்|பிற்பகல்|நள்ளிரவு|நண்பகல்|காலை|மதியம்|மாலை|இரவு)/i
}, QF = {
  any: {
    am: /^மு/i,
    pm: /^பி/i,
    midnight: /^நள்/i,
    noon: /^நண்/i,
    morning: /காலை/i,
    afternoon: /மதியம்/i,
    evening: /மாலை/i,
    night: /இரவு/i
  }
}, eE = {
  ordinalNumber: le({
    matchPattern: ZF,
    parsePattern: AF,
    valueCallback: function(i) {
      return parseInt(i, 10);
    }
  }),
  era: P({
    matchPatterns: VF,
    defaultMatchWidth: "wide",
    parsePatterns: HF,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: UF,
    defaultMatchWidth: "wide",
    parsePatterns: BF,
    defaultParseWidth: "any",
    valueCallback: function(i) {
      return i + 1;
    }
  }),
  month: P({
    matchPatterns: XF,
    defaultMatchWidth: "wide",
    parsePatterns: GF,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: KF,
    defaultMatchWidth: "wide",
    parsePatterns: YF,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: JF,
    defaultMatchWidth: "any",
    parsePatterns: QF,
    defaultParseWidth: "any"
  })
}, nE = {
  code: "ta",
  formatDistance: SF,
  formatLong: DF,
  formatRelative: IF,
  localize: qF,
  match: eE,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const iE = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: nE
}, Symbol.toStringTag, { value: "Module" })), aE = /* @__PURE__ */ te(iE);
var vd = {
  lessThanXSeconds: {
    standalone: {
      one: "సెకను కన్నా తక్కువ",
      other: "{{count}} సెకన్ల కన్నా తక్కువ"
    },
    withPreposition: {
      one: "సెకను",
      other: "{{count}} సెకన్ల"
    }
  },
  xSeconds: {
    standalone: {
      one: "ఒక సెకను",
      // CLDR #1314
      other: "{{count}} సెకన్ల"
    },
    withPreposition: {
      one: "ఒక సెకను",
      other: "{{count}} సెకన్ల"
    }
  },
  halfAMinute: {
    standalone: "అర నిమిషం",
    withPreposition: "అర నిమిషం"
  },
  lessThanXMinutes: {
    standalone: {
      one: "ఒక నిమిషం కన్నా తక్కువ",
      other: "{{count}} నిమిషాల కన్నా తక్కువ"
    },
    withPreposition: {
      one: "ఒక నిమిషం",
      other: "{{count}} నిమిషాల"
    }
  },
  xMinutes: {
    standalone: {
      one: "ఒక నిమిషం",
      // CLDR #1311
      other: "{{count}} నిమిషాలు"
    },
    withPreposition: {
      one: "ఒక నిమిషం",
      // CLDR #1311
      other: "{{count}} నిమిషాల"
    }
  },
  aboutXHours: {
    standalone: {
      one: "సుమారు ఒక గంట",
      other: "సుమారు {{count}} గంటలు"
    },
    withPreposition: {
      one: "సుమారు ఒక గంట",
      other: "సుమారు {{count}} గంటల"
    }
  },
  xHours: {
    standalone: {
      one: "ఒక గంట",
      // CLDR #1308
      other: "{{count}} గంటలు"
    },
    withPreposition: {
      one: "ఒక గంట",
      other: "{{count}} గంటల"
    }
  },
  xDays: {
    standalone: {
      one: "ఒక రోజు",
      // CLDR #1292
      other: "{{count}} రోజులు"
    },
    withPreposition: {
      one: "ఒక రోజు",
      other: "{{count}} రోజుల"
    }
  },
  aboutXWeeks: {
    standalone: {
      one: "సుమారు ఒక వారం",
      other: "సుమారు {{count}} వారాలు"
    },
    withPreposition: {
      one: "సుమారు ఒక వారం",
      other: "సుమారు {{count}} వారాలల"
    }
  },
  xWeeks: {
    standalone: {
      one: "ఒక వారం",
      other: "{{count}} వారాలు"
    },
    withPreposition: {
      one: "ఒక వారం",
      other: "{{count}} వారాలల"
    }
  },
  aboutXMonths: {
    standalone: {
      one: "సుమారు ఒక నెల",
      other: "సుమారు {{count}} నెలలు"
    },
    withPreposition: {
      one: "సుమారు ఒక నెల",
      other: "సుమారు {{count}} నెలల"
    }
  },
  xMonths: {
    standalone: {
      one: "ఒక నెల",
      // CLDR #1281
      other: "{{count}} నెలలు"
    },
    withPreposition: {
      one: "ఒక నెల",
      other: "{{count}} నెలల"
    }
  },
  aboutXYears: {
    standalone: {
      one: "సుమారు ఒక సంవత్సరం",
      other: "సుమారు {{count}} సంవత్సరాలు"
    },
    withPreposition: {
      one: "సుమారు ఒక సంవత్సరం",
      other: "సుమారు {{count}} సంవత్సరాల"
    }
  },
  xYears: {
    standalone: {
      one: "ఒక సంవత్సరం",
      // CLDR #1275
      other: "{{count}} సంవత్సరాలు"
    },
    withPreposition: {
      one: "ఒక సంవత్సరం",
      other: "{{count}} సంవత్సరాల"
    }
  },
  overXYears: {
    standalone: {
      one: "ఒక సంవత్సరం పైగా",
      other: "{{count}} సంవత్సరాలకు పైగా"
    },
    withPreposition: {
      one: "ఒక సంవత్సరం",
      other: "{{count}} సంవత్సరాల"
    }
  },
  almostXYears: {
    standalone: {
      one: "దాదాపు ఒక సంవత్సరం",
      other: "దాదాపు {{count}} సంవత్సరాలు"
    },
    withPreposition: {
      one: "దాదాపు ఒక సంవత్సరం",
      other: "దాదాపు {{count}} సంవత్సరాల"
    }
  }
}, tE = function(i, d, a) {
  var t, o = a != null && a.addSuffix ? vd[i].withPreposition : vd[i].standalone;
  return typeof o == "string" ? t = o : d === 1 ? t = o.one : t = o.other.replace("{{count}}", String(d)), a != null && a.addSuffix ? a.comparison && a.comparison > 0 ? t + "లో" : t + " క్రితం" : t;
}, rE = {
  full: "d, MMMM y, EEEE",
  long: "d MMMM, y",
  medium: "d MMM, y",
  short: "dd-MM-yy"
}, oE = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, sE = {
  full: "{{date}} {{time}}'కి'",
  long: "{{date}} {{time}}'కి'",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, dE = {
  date: I({
    formats: rE,
    defaultWidth: "full"
  }),
  time: I({
    formats: oE,
    defaultWidth: "full"
  }),
  dateTime: I({
    formats: sE,
    defaultWidth: "full"
  })
}, uE = {
  lastWeek: "'గత' eeee p",
  // CLDR #1384
  yesterday: "'నిన్న' p",
  // CLDR #1393
  today: "'ఈ రోజు' p",
  // CLDR #1394
  tomorrow: "'రేపు' p",
  // CLDR #1395
  nextWeek: "'తదుపరి' eeee p",
  // CLDR #1386
  other: "P"
}, fE = function(i, d, a, t) {
  return uE[i];
}, lE = {
  narrow: ["క్రీ.పూ.", "క్రీ.శ."],
  abbreviated: ["క్రీ.పూ.", "క్రీ.శ."],
  wide: ["క్రీస్తు పూర్వం", "క్రీస్తుశకం"]
}, cE = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["త్రై1", "త్రై2", "త్రై3", "త్రై4"],
  wide: ["1వ త్రైమాసికం", "2వ త్రైమాసికం", "3వ త్రైమాసికం", "4వ త్రైమాసికం"]
}, mE = {
  narrow: ["జ", "ఫి", "మా", "ఏ", "మే", "జూ", "జు", "ఆ", "సె", "అ", "న", "డి"],
  abbreviated: ["జన", "ఫిబ్ర", "మార్చి", "ఏప్రి", "మే", "జూన్", "జులై", "ఆగ", "సెప్టెం", "అక్టో", "నవం", "డిసెం"],
  wide: ["జనవరి", "ఫిబ్రవరి", "మార్చి", "ఏప్రిల్", "మే", "జూన్", "జులై", "ఆగస్టు", "సెప్టెంబర్", "అక్టోబర్", "నవంబర్", "డిసెంబర్"]
}, vE = {
  narrow: ["ఆ", "సో", "మ", "బు", "గు", "శు", "శ"],
  short: ["ఆది", "సోమ", "మంగళ", "బుధ", "గురు", "శుక్ర", "శని"],
  abbreviated: ["ఆది", "సోమ", "మంగళ", "బుధ", "గురు", "శుక్ర", "శని"],
  wide: ["ఆదివారం", "సోమవారం", "మంగళవారం", "బుధవారం", "గురువారం", "శుక్రవారం", "శనివారం"]
}, hE = {
  narrow: {
    am: "పూర్వాహ్నం",
    pm: "అపరాహ్నం",
    midnight: "అర్ధరాత్రి",
    noon: "మిట్టమధ్యాహ్నం",
    morning: "ఉదయం",
    afternoon: "మధ్యాహ్నం",
    evening: "సాయంత్రం",
    night: "రాత్రి"
  },
  abbreviated: {
    am: "పూర్వాహ్నం",
    pm: "అపరాహ్నం",
    midnight: "అర్ధరాత్రి",
    noon: "మిట్టమధ్యాహ్నం",
    morning: "ఉదయం",
    afternoon: "మధ్యాహ్నం",
    evening: "సాయంత్రం",
    night: "రాత్రి"
  },
  wide: {
    am: "పూర్వాహ్నం",
    pm: "అపరాహ్నం",
    midnight: "అర్ధరాత్రి",
    noon: "మిట్టమధ్యాహ్నం",
    morning: "ఉదయం",
    afternoon: "మధ్యాహ్నం",
    evening: "సాయంత్రం",
    night: "రాత్రి"
  }
}, gE = {
  narrow: {
    am: "పూర్వాహ్నం",
    pm: "అపరాహ్నం",
    midnight: "అర్ధరాత్రి",
    noon: "మిట్టమధ్యాహ్నం",
    morning: "ఉదయం",
    afternoon: "మధ్యాహ్నం",
    evening: "సాయంత్రం",
    night: "రాత్రి"
  },
  abbreviated: {
    am: "పూర్వాహ్నం",
    pm: "అపరాహ్నం",
    midnight: "అర్ధరాత్రి",
    noon: "మిట్టమధ్యాహ్నం",
    morning: "ఉదయం",
    afternoon: "మధ్యాహ్నం",
    evening: "సాయంత్రం",
    night: "రాత్రి"
  },
  wide: {
    am: "పూర్వాహ్నం",
    pm: "అపరాహ్నం",
    midnight: "అర్ధరాత్రి",
    noon: "మిట్టమధ్యాహ్నం",
    morning: "ఉదయం",
    afternoon: "మధ్యాహ్నం",
    evening: "సాయంత్రం",
    night: "రాత్రి"
  }
}, pE = function(i, d) {
  var a = Number(i);
  return a + "వ";
}, bE = {
  ordinalNumber: pE,
  era: $({
    values: lE,
    defaultWidth: "wide"
  }),
  quarter: $({
    values: cE,
    defaultWidth: "wide",
    argumentCallback: function(i) {
      return i - 1;
    }
  }),
  month: $({
    values: mE,
    defaultWidth: "wide"
  }),
  day: $({
    values: vE,
    defaultWidth: "wide"
  }),
  dayPeriod: $({
    values: hE,
    defaultWidth: "wide",
    formattingValues: gE,
    defaultFormattingWidth: "wide"
  })
}, yE = /^(\d+)(వ)?/i, kE = /\d+/i, wE = {
  narrow: /^(క్రీ\.పూ\.|క్రీ\.శ\.)/i,
  abbreviated: /^(క్రీ\.?\s?పూ\.?|ప్ర\.?\s?శ\.?\s?పూ\.?|క్రీ\.?\s?శ\.?|సా\.?\s?శ\.?)/i,
  wide: /^(క్రీస్తు పూర్వం|ప్రస్తుత శకానికి పూర్వం|క్రీస్తు శకం|ప్రస్తుత శకం)/i
}, _E = {
  any: [/^(పూ|శ)/i, /^సా/i]
}, $E = {
  narrow: /^[1234]/i,
  abbreviated: /^త్రై[1234]/i,
  wide: /^[1234](వ)? త్రైమాసికం/i
}, PE = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, ME = {
  narrow: /^(జూ|జు|జ|ఫి|మా|ఏ|మే|ఆ|సె|అ|న|డి)/i,
  abbreviated: /^(జన|ఫిబ్ర|మార్చి|ఏప్రి|మే|జూన్|జులై|ఆగ|సెప్|అక్టో|నవ|డిసె)/i,
  wide: /^(జనవరి|ఫిబ్రవరి|మార్చి|ఏప్రిల్|మే|జూన్|జులై|ఆగస్టు|సెప్టెంబర్|అక్టోబర్|నవంబర్|డిసెంబర్)/i
}, jE = {
  narrow: [/^జ/i, /^ఫి/i, /^మా/i, /^ఏ/i, /^మే/i, /^జూ/i, /^జు/i, /^ఆ/i, /^సె/i, /^అ/i, /^న/i, /^డి/i],
  any: [/^జన/i, /^ఫి/i, /^మా/i, /^ఏ/i, /^మే/i, /^జూన్/i, /^జులై/i, /^ఆగ/i, /^సె/i, /^అ/i, /^న/i, /^డి/i]
}, SE = {
  narrow: /^(ఆ|సో|మ|బు|గు|శు|శ)/i,
  short: /^(ఆది|సోమ|మం|బుధ|గురు|శుక్ర|శని)/i,
  abbreviated: /^(ఆది|సోమ|మం|బుధ|గురు|శుక్ర|శని)/i,
  wide: /^(ఆదివారం|సోమవారం|మంగళవారం|బుధవారం|గురువారం|శుక్రవారం|శనివారం)/i
}, zE = {
  narrow: [/^ఆ/i, /^సో/i, /^మ/i, /^బు/i, /^గు/i, /^శు/i, /^శ/i],
  any: [/^ఆది/i, /^సోమ/i, /^మం/i, /^బుధ/i, /^గురు/i, /^శుక్ర/i, /^శని/i]
}, OE = {
  narrow: /^(పూర్వాహ్నం|అపరాహ్నం|అర్ధరాత్రి|మిట్టమధ్యాహ్నం|ఉదయం|మధ్యాహ్నం|సాయంత్రం|రాత్రి)/i,
  any: /^(పూర్వాహ్నం|అపరాహ్నం|అర్ధరాత్రి|మిట్టమధ్యాహ్నం|ఉదయం|మధ్యాహ్నం|సాయంత్రం|రాత్రి)/i
}, WE = {
  any: {
    am: /^పూర్వాహ్నం/i,
    pm: /^అపరాహ్నం/i,
    midnight: /^అర్ధ/i,
    noon: /^మిట్ట/i,
    morning: /ఉదయం/i,
    afternoon: /మధ్యాహ్నం/i,
    evening: /సాయంత్రం/i,
    night: /రాత్రి/i
  }
}, DE = {
  ordinalNumber: le({
    matchPattern: yE,
    parsePattern: kE,
    valueCallback: function(i) {
      return parseInt(i, 10);
    }
  }),
  era: P({
    matchPatterns: wE,
    defaultMatchWidth: "wide",
    parsePatterns: _E,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: $E,
    defaultMatchWidth: "wide",
    parsePatterns: PE,
    defaultParseWidth: "any",
    valueCallback: function(i) {
      return i + 1;
    }
  }),
  month: P({
    matchPatterns: ME,
    defaultMatchWidth: "wide",
    parsePatterns: jE,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: SE,
    defaultMatchWidth: "wide",
    parsePatterns: zE,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: OE,
    defaultMatchWidth: "any",
    parsePatterns: WE,
    defaultParseWidth: "any"
  })
}, CE = {
  code: "te",
  formatDistance: tE,
  formatLong: dE,
  formatRelative: fE,
  localize: bE,
  match: DE,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
const IE = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: CE
}, Symbol.toStringTag, { value: "Module" })), TE = /* @__PURE__ */ te(IE);
var NE = {
  lessThanXSeconds: {
    one: "น้อยกว่า 1 วินาที",
    other: "น้อยกว่า {{count}} วินาที"
  },
  xSeconds: {
    one: "1 วินาที",
    other: "{{count}} วินาที"
  },
  halfAMinute: "ครึ่งนาที",
  lessThanXMinutes: {
    one: "น้อยกว่า 1 นาที",
    other: "น้อยกว่า {{count}} นาที"
  },
  xMinutes: {
    one: "1 นาที",
    other: "{{count}} นาที"
  },
  aboutXHours: {
    one: "ประมาณ 1 ชั่วโมง",
    other: "ประมาณ {{count}} ชั่วโมง"
  },
  xHours: {
    one: "1 ชั่วโมง",
    other: "{{count}} ชั่วโมง"
  },
  xDays: {
    one: "1 วัน",
    other: "{{count}} วัน"
  },
  aboutXWeeks: {
    one: "ประมาณ 1 สัปดาห์",
    other: "ประมาณ {{count}} สัปดาห์"
  },
  xWeeks: {
    one: "1 สัปดาห์",
    other: "{{count}} สัปดาห์"
  },
  aboutXMonths: {
    one: "ประมาณ 1 เดือน",
    other: "ประมาณ {{count}} เดือน"
  },
  xMonths: {
    one: "1 เดือน",
    other: "{{count}} เดือน"
  },
  aboutXYears: {
    one: "ประมาณ 1 ปี",
    other: "ประมาณ {{count}} ปี"
  },
  xYears: {
    one: "1 ปี",
    other: "{{count}} ปี"
  },
  overXYears: {
    one: "มากกว่า 1 ปี",
    other: "มากกว่า {{count}} ปี"
  },
  almostXYears: {
    one: "เกือบ 1 ปี",
    other: "เกือบ {{count}} ปี"
  }
}, xE = function(i, d, a) {
  var t, o = NE[i];
  return typeof o == "string" ? t = o : d === 1 ? t = o.one : t = o.other.replace("{{count}}", String(d)), a != null && a.addSuffix ? a.comparison && a.comparison > 0 ? i === "halfAMinute" ? "ใน" + t : "ใน " + t : t + "ที่ผ่านมา" : t;
}, FE = {
  full: "วันEEEEที่ do MMMM y",
  long: "do MMMM y",
  medium: "d MMM y",
  short: "dd/MM/yyyy"
}, EE = {
  full: "H:mm:ss น. zzzz",
  long: "H:mm:ss น. z",
  medium: "H:mm:ss น.",
  short: "H:mm น."
}, RE = {
  full: "{{date}} 'เวลา' {{time}}",
  long: "{{date}} 'เวลา' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, LE = {
  date: I({
    formats: FE,
    defaultWidth: "full"
  }),
  time: I({
    formats: EE,
    defaultWidth: "medium"
  }),
  dateTime: I({
    formats: RE,
    defaultWidth: "full"
  })
}, qE = {
  lastWeek: "eeee'ที่แล้วเวลา' p",
  yesterday: "'เมื่อวานนี้เวลา' p",
  today: "'วันนี้เวลา' p",
  tomorrow: "'พรุ่งนี้เวลา' p",
  nextWeek: "eeee 'เวลา' p",
  other: "P"
}, ZE = function(i, d, a, t) {
  return qE[i];
}, AE = {
  narrow: ["B", "คศ"],
  abbreviated: ["BC", "ค.ศ."],
  wide: ["ปีก่อนคริสตกาล", "คริสต์ศักราช"]
}, VE = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["ไตรมาสแรก", "ไตรมาสที่สอง", "ไตรมาสที่สาม", "ไตรมาสที่สี่"]
}, HE = {
  narrow: ["อา.", "จ.", "อ.", "พ.", "พฤ.", "ศ.", "ส."],
  short: ["อา.", "จ.", "อ.", "พ.", "พฤ.", "ศ.", "ส."],
  abbreviated: ["อา.", "จ.", "อ.", "พ.", "พฤ.", "ศ.", "ส."],
  wide: ["อาทิตย์", "จันทร์", "อังคาร", "พุธ", "พฤหัสบดี", "ศุกร์", "เสาร์"]
}, UE = {
  narrow: ["ม.ค.", "ก.พ.", "มี.ค.", "เม.ย.", "พ.ค.", "มิ.ย.", "ก.ค.", "ส.ค.", "ก.ย.", "ต.ค.", "พ.ย.", "ธ.ค."],
  abbreviated: ["ม.ค.", "ก.พ.", "มี.ค.", "เม.ย.", "พ.ค.", "มิ.ย.", "ก.ค.", "ส.ค.", "ก.ย.", "ต.ค.", "พ.ย.", "ธ.ค."],
  wide: ["มกราคม", "กุมภาพันธ์", "มีนาคม", "เมษายน", "พฤษภาคม", "มิถุนายน", "กรกฎาคม", "สิงหาคม", "กันยายน", "ตุลาคม", "พฤศจิกายน", "ธันวาคม"]
}, BE = {
  narrow: {
    am: "ก่อนเที่ยง",
    pm: "หลังเที่ยง",
    midnight: "เที่ยงคืน",
    noon: "เที่ยง",
    morning: "เช้า",
    afternoon: "บ่าย",
    evening: "เย็น",
    night: "กลางคืน"
  },
  abbreviated: {
    am: "ก่อนเที่ยง",
    pm: "หลังเที่ยง",
    midnight: "เที่ยงคืน",
    noon: "เที่ยง",
    morning: "เช้า",
    afternoon: "บ่าย",
    evening: "เย็น",
    night: "กลางคืน"
  },
  wide: {
    am: "ก่อนเที่ยง",
    pm: "หลังเที่ยง",
    midnight: "เที่ยงคืน",
    noon: "เที่ยง",
    morning: "เช้า",
    afternoon: "บ่าย",
    evening: "เย็น",
    night: "กลางคืน"
  }
}, XE = {
  narrow: {
    am: "ก่อนเที่ยง",
    pm: "หลังเที่ยง",
    midnight: "เที่ยงคืน",
    noon: "เที่ยง",
    morning: "ตอนเช้า",
    afternoon: "ตอนกลางวัน",
    evening: "ตอนเย็น",
    night: "ตอนกลางคืน"
  },
  abbreviated: {
    am: "ก่อนเที่ยง",
    pm: "หลังเที่ยง",
    midnight: "เที่ยงคืน",
    noon: "เที่ยง",
    morning: "ตอนเช้า",
    afternoon: "ตอนกลางวัน",
    evening: "ตอนเย็น",
    night: "ตอนกลางคืน"
  },
  wide: {
    am: "ก่อนเที่ยง",
    pm: "หลังเที่ยง",
    midnight: "เที่ยงคืน",
    noon: "เที่ยง",
    morning: "ตอนเช้า",
    afternoon: "ตอนกลางวัน",
    evening: "ตอนเย็น",
    night: "ตอนกลางคืน"
  }
}, GE = function(i, d) {
  return String(i);
}, KE = {
  ordinalNumber: GE,
  era: $({
    values: AE,
    defaultWidth: "wide"
  }),
  quarter: $({
    values: VE,
    defaultWidth: "wide",
    argumentCallback: function(i) {
      return i - 1;
    }
  }),
  month: $({
    values: UE,
    defaultWidth: "wide"
  }),
  day: $({
    values: HE,
    defaultWidth: "wide"
  }),
  dayPeriod: $({
    values: BE,
    defaultWidth: "wide",
    formattingValues: XE,
    defaultFormattingWidth: "wide"
  })
}, YE = /^\d+/i, JE = /\d+/i, QE = {
  narrow: /^([bB]|[aA]|คศ)/i,
  abbreviated: /^([bB]\.?\s?[cC]\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?|ค\.?ศ\.?)/i,
  wide: /^(ก่อนคริสตกาล|คริสต์ศักราช|คริสตกาล)/i
}, eR = {
  any: [/^[bB]/i, /^(^[aA]|ค\.?ศ\.?|คริสตกาล|คริสต์ศักราช|)/i]
}, nR = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^ไตรมาส(ที่)? ?[1234]/i
}, iR = {
  any: [/(1|แรก|หนึ่ง)/i, /(2|สอง)/i, /(3|สาม)/i, /(4|สี่)/i]
}, aR = {
  narrow: /^(ม\.?ค\.?|ก\.?พ\.?|มี\.?ค\.?|เม\.?ย\.?|พ\.?ค\.?|มิ\.?ย\.?|ก\.?ค\.?|ส\.?ค\.?|ก\.?ย\.?|ต\.?ค\.?|พ\.?ย\.?|ธ\.?ค\.?)/i,
  abbreviated: /^(ม\.?ค\.?|ก\.?พ\.?|มี\.?ค\.?|เม\.?ย\.?|พ\.?ค\.?|มิ\.?ย\.?|ก\.?ค\.?|ส\.?ค\.?|ก\.?ย\.?|ต\.?ค\.?|พ\.?ย\.?|ธ\.?ค\.?')/i,
  wide: /^(มกราคม|กุมภาพันธ์|มีนาคม|เมษายน|พฤษภาคม|มิถุนายน|กรกฎาคม|สิงหาคม|กันยายน|ตุลาคม|พฤศจิกายน|ธันวาคม)/i
}, tR = {
  wide: [/^มก/i, /^กุม/i, /^มี/i, /^เม/i, /^พฤษ/i, /^มิ/i, /^กรก/i, /^ส/i, /^กัน/i, /^ต/i, /^พฤศ/i, /^ธ/i],
  any: [/^ม\.?ค\.?/i, /^ก\.?พ\.?/i, /^มี\.?ค\.?/i, /^เม\.?ย\.?/i, /^พ\.?ค\.?/i, /^มิ\.?ย\.?/i, /^ก\.?ค\.?/i, /^ส\.?ค\.?/i, /^ก\.?ย\.?/i, /^ต\.?ค\.?/i, /^พ\.?ย\.?/i, /^ธ\.?ค\.?/i]
}, rR = {
  narrow: /^(อา\.?|จ\.?|อ\.?|พฤ\.?|พ\.?|ศ\.?|ส\.?)/i,
  short: /^(อา\.?|จ\.?|อ\.?|พฤ\.?|พ\.?|ศ\.?|ส\.?)/i,
  abbreviated: /^(อา\.?|จ\.?|อ\.?|พฤ\.?|พ\.?|ศ\.?|ส\.?)/i,
  wide: /^(อาทิตย์|จันทร์|อังคาร|พุธ|พฤหัสบดี|ศุกร์|เสาร์)/i
}, oR = {
  wide: [/^อา/i, /^จั/i, /^อั/i, /^พุธ/i, /^พฤ/i, /^ศ/i, /^เส/i],
  any: [/^อา/i, /^จ/i, /^อ/i, /^พ(?!ฤ)/i, /^พฤ/i, /^ศ/i, /^ส/i]
}, sR = {
  any: /^(ก่อนเที่ยง|หลังเที่ยง|เที่ยงคืน|เที่ยง|(ตอน.*?)?.*(เที่ยง|เช้า|บ่าย|เย็น|กลางคืน))/i
}, dR = {
  any: {
    am: /^ก่อนเที่ยง/i,
    pm: /^หลังเที่ยง/i,
    midnight: /^เที่ยงคืน/i,
    noon: /^เที่ยง/i,
    morning: /เช้า/i,
    afternoon: /บ่าย/i,
    evening: /เย็น/i,
    night: /กลางคืน/i
  }
}, uR = {
  ordinalNumber: le({
    matchPattern: YE,
    parsePattern: JE,
    valueCallback: function(i) {
      return parseInt(i, 10);
    }
  }),
  era: P({
    matchPatterns: QE,
    defaultMatchWidth: "wide",
    parsePatterns: eR,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: nR,
    defaultMatchWidth: "wide",
    parsePatterns: iR,
    defaultParseWidth: "any",
    valueCallback: function(i) {
      return i + 1;
    }
  }),
  month: P({
    matchPatterns: aR,
    defaultMatchWidth: "wide",
    parsePatterns: tR,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: rR,
    defaultMatchWidth: "wide",
    parsePatterns: oR,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: sR,
    defaultMatchWidth: "any",
    parsePatterns: dR,
    defaultParseWidth: "any"
  })
}, fR = {
  code: "th",
  formatDistance: xE,
  formatLong: LE,
  formatRelative: ZE,
  localize: KE,
  match: uR,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
const lR = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: fR
}, Symbol.toStringTag, { value: "Module" })), cR = /* @__PURE__ */ te(lR);
var mR = {
  lessThanXSeconds: {
    one: "bir saniyeden az",
    other: "{{count}} saniyeden az"
  },
  xSeconds: {
    one: "1 saniye",
    other: "{{count}} saniye"
  },
  halfAMinute: "yarım dakika",
  lessThanXMinutes: {
    one: "bir dakikadan az",
    other: "{{count}} dakikadan az"
  },
  xMinutes: {
    one: "1 dakika",
    other: "{{count}} dakika"
  },
  aboutXHours: {
    one: "yaklaşık 1 saat",
    other: "yaklaşık {{count}} saat"
  },
  xHours: {
    one: "1 saat",
    other: "{{count}} saat"
  },
  xDays: {
    one: "1 gün",
    other: "{{count}} gün"
  },
  aboutXWeeks: {
    one: "yaklaşık 1 hafta",
    other: "yaklaşık {{count}} hafta"
  },
  xWeeks: {
    one: "1 hafta",
    other: "{{count}} hafta"
  },
  aboutXMonths: {
    one: "yaklaşık 1 ay",
    other: "yaklaşık {{count}} ay"
  },
  xMonths: {
    one: "1 ay",
    other: "{{count}} ay"
  },
  aboutXYears: {
    one: "yaklaşık 1 yıl",
    other: "yaklaşık {{count}} yıl"
  },
  xYears: {
    one: "1 yıl",
    other: "{{count}} yıl"
  },
  overXYears: {
    one: "1 yıldan fazla",
    other: "{{count}} yıldan fazla"
  },
  almostXYears: {
    one: "neredeyse 1 yıl",
    other: "neredeyse {{count}} yıl"
  }
}, vR = function(i, d, a) {
  var t, o = mR[i];
  return typeof o == "string" ? t = o : d === 1 ? t = o.one : t = o.other.replace("{{count}}", d.toString()), a != null && a.addSuffix ? a.comparison && a.comparison > 0 ? t + " sonra" : t + " önce" : t;
}, hR = {
  full: "d MMMM y EEEE",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "dd.MM.yyyy"
}, gR = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, pR = {
  full: "{{date}} 'saat' {{time}}",
  long: "{{date}} 'saat' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, bR = {
  date: I({
    formats: hR,
    defaultWidth: "full"
  }),
  time: I({
    formats: gR,
    defaultWidth: "full"
  }),
  dateTime: I({
    formats: pR,
    defaultWidth: "full"
  })
}, yR = {
  lastWeek: "'geçen hafta' eeee 'saat' p",
  yesterday: "'dün saat' p",
  today: "'bugün saat' p",
  tomorrow: "'yarın saat' p",
  nextWeek: "eeee 'saat' p",
  other: "P"
}, kR = function(i, d, a, t) {
  return yR[i];
}, wR = {
  narrow: ["MÖ", "MS"],
  abbreviated: ["MÖ", "MS"],
  wide: ["Milattan Önce", "Milattan Sonra"]
}, _R = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1Ç", "2Ç", "3Ç", "4Ç"],
  wide: ["İlk çeyrek", "İkinci Çeyrek", "Üçüncü çeyrek", "Son çeyrek"]
}, $R = {
  narrow: ["O", "Ş", "M", "N", "M", "H", "T", "A", "E", "E", "K", "A"],
  abbreviated: ["Oca", "Şub", "Mar", "Nis", "May", "Haz", "Tem", "Ağu", "Eyl", "Eki", "Kas", "Ara"],
  wide: ["Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran", "Temmuz", "Ağustos", "Eylül", "Ekim", "Kasım", "Aralık"]
}, PR = {
  narrow: ["P", "P", "S", "Ç", "P", "C", "C"],
  short: ["Pz", "Pt", "Sa", "Ça", "Pe", "Cu", "Ct"],
  abbreviated: ["Paz", "Pzt", "Sal", "Çar", "Per", "Cum", "Cts"],
  wide: ["Pazar", "Pazartesi", "Salı", "Çarşamba", "Perşembe", "Cuma", "Cumartesi"]
}, MR = {
  narrow: {
    am: "öö",
    pm: "ös",
    midnight: "gy",
    noon: "ö",
    morning: "sa",
    afternoon: "ös",
    evening: "ak",
    night: "ge"
  },
  abbreviated: {
    am: "ÖÖ",
    pm: "ÖS",
    midnight: "gece yarısı",
    noon: "öğle",
    morning: "sabah",
    afternoon: "öğleden sonra",
    evening: "akşam",
    night: "gece"
  },
  wide: {
    am: "Ö.Ö.",
    pm: "Ö.S.",
    midnight: "gece yarısı",
    noon: "öğle",
    morning: "sabah",
    afternoon: "öğleden sonra",
    evening: "akşam",
    night: "gece"
  }
}, jR = {
  narrow: {
    am: "öö",
    pm: "ös",
    midnight: "gy",
    noon: "ö",
    morning: "sa",
    afternoon: "ös",
    evening: "ak",
    night: "ge"
  },
  abbreviated: {
    am: "ÖÖ",
    pm: "ÖS",
    midnight: "gece yarısı",
    noon: "öğlen",
    morning: "sabahleyin",
    afternoon: "öğleden sonra",
    evening: "akşamleyin",
    night: "geceleyin"
  },
  wide: {
    am: "ö.ö.",
    pm: "ö.s.",
    midnight: "gece yarısı",
    noon: "öğlen",
    morning: "sabahleyin",
    afternoon: "öğleden sonra",
    evening: "akşamleyin",
    night: "geceleyin"
  }
}, SR = function(i, d) {
  var a = Number(i);
  return a + ".";
}, zR = {
  ordinalNumber: SR,
  era: $({
    values: wR,
    defaultWidth: "wide"
  }),
  quarter: $({
    values: _R,
    defaultWidth: "wide",
    argumentCallback: function(i) {
      return Number(i) - 1;
    }
  }),
  month: $({
    values: $R,
    defaultWidth: "wide"
  }),
  day: $({
    values: PR,
    defaultWidth: "wide"
  }),
  dayPeriod: $({
    values: MR,
    defaultWidth: "wide",
    formattingValues: jR,
    defaultFormattingWidth: "wide"
  })
}, OR = /^(\d+)(\.)?/i, WR = /\d+/i, DR = {
  narrow: /^(mö|ms)/i,
  abbreviated: /^(mö|ms)/i,
  wide: /^(milattan önce|milattan sonra)/i
}, CR = {
  any: [/(^mö|^milattan önce)/i, /(^ms|^milattan sonra)/i]
}, IR = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234]ç/i,
  wide: /^((i|İ)lk|(i|İ)kinci|üçüncü|son) çeyrek/i
}, TR = {
  any: [/1/i, /2/i, /3/i, /4/i],
  abbreviated: [/1ç/i, /2ç/i, /3ç/i, /4ç/i],
  wide: [/^(i|İ)lk çeyrek/i, /(i|İ)kinci çeyrek/i, /üçüncü çeyrek/i, /son çeyrek/i]
}, NR = {
  narrow: /^[oşmnhtaek]/i,
  abbreviated: /^(oca|şub|mar|nis|may|haz|tem|ağu|eyl|eki|kas|ara)/i,
  wide: /^(ocak|şubat|mart|nisan|mayıs|haziran|temmuz|ağustos|eylül|ekim|kasım|aralık)/i
}, xR = {
  narrow: [/^o/i, /^ş/i, /^m/i, /^n/i, /^m/i, /^h/i, /^t/i, /^a/i, /^e/i, /^e/i, /^k/i, /^a/i],
  any: [/^o/i, /^ş/i, /^mar/i, /^n/i, /^may/i, /^h/i, /^t/i, /^ağ/i, /^ey/i, /^ek/i, /^k/i, /^ar/i]
}, FR = {
  narrow: /^[psçc]/i,
  short: /^(pz|pt|sa|ça|pe|cu|ct)/i,
  abbreviated: /^(paz|pzt|sal|çar|per|cum|cts)/i,
  wide: /^(pazar(?!tesi)|pazartesi|salı|çarşamba|perşembe|cuma(?!rtesi)|cumartesi)/i
}, ER = {
  narrow: [/^p/i, /^p/i, /^s/i, /^ç/i, /^p/i, /^c/i, /^c/i],
  any: [/^pz/i, /^pt/i, /^sa/i, /^ça/i, /^pe/i, /^cu/i, /^ct/i],
  wide: [/^pazar(?!tesi)/i, /^pazartesi/i, /^salı/i, /^çarşamba/i, /^perşembe/i, /^cuma(?!rtesi)/i, /^cumartesi/i]
}, RR = {
  narrow: /^(öö|ös|gy|ö|sa|ös|ak|ge)/i,
  any: /^(ö\.?\s?[ös]\.?|öğleden sonra|gece yarısı|öğle|(sabah|öğ|akşam|gece)(leyin))/i
}, LR = {
  any: {
    am: /^ö\.?ö\.?/i,
    pm: /^ö\.?s\.?/i,
    midnight: /^(gy|gece yarısı)/i,
    noon: /^öğ/i,
    morning: /^sa/i,
    afternoon: /^öğleden sonra/i,
    evening: /^ak/i,
    night: /^ge/i
  }
}, qR = {
  ordinalNumber: le({
    matchPattern: OR,
    parsePattern: WR,
    valueCallback: function(i) {
      return parseInt(i, 10);
    }
  }),
  era: P({
    matchPatterns: DR,
    defaultMatchWidth: "wide",
    parsePatterns: CR,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: IR,
    defaultMatchWidth: "wide",
    parsePatterns: TR,
    defaultParseWidth: "any",
    valueCallback: function(i) {
      return i + 1;
    }
  }),
  month: P({
    matchPatterns: NR,
    defaultMatchWidth: "wide",
    parsePatterns: xR,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: FR,
    defaultMatchWidth: "wide",
    parsePatterns: ER,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: RR,
    defaultMatchWidth: "any",
    parsePatterns: LR,
    defaultParseWidth: "any"
  })
}, ZR = {
  code: "tr",
  formatDistance: vR,
  formatLong: bR,
  formatRelative: kR,
  localize: zR,
  match: qR,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
};
const AR = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ZR
}, Symbol.toStringTag, { value: "Module" })), VR = /* @__PURE__ */ te(AR);
function Qn(e, i) {
  if (e.one !== void 0 && i === 1)
    return e.one;
  var d = i % 10, a = i % 100;
  return d === 1 && a !== 11 ? e.singularNominative.replace("{{count}}", String(i)) : d >= 2 && d <= 4 && (a < 10 || a > 20) ? e.singularGenitive.replace("{{count}}", String(i)) : e.pluralGenitive.replace("{{count}}", String(i));
}
function Je(e) {
  return function(i, d) {
    return d && d.addSuffix ? d.comparison && d.comparison > 0 ? e.future ? Qn(e.future, i) : "за " + Qn(e.regular, i) : e.past ? Qn(e.past, i) : Qn(e.regular, i) + " тому" : Qn(e.regular, i);
  };
}
var HR = function(i, d) {
  return d && d.addSuffix ? d.comparison && d.comparison > 0 ? "за півхвилини" : "півхвилини тому" : "півхвилини";
}, UR = {
  lessThanXSeconds: Je({
    regular: {
      one: "менше секунди",
      singularNominative: "менше {{count}} секунди",
      singularGenitive: "менше {{count}} секунд",
      pluralGenitive: "менше {{count}} секунд"
    },
    future: {
      one: "менше, ніж за секунду",
      singularNominative: "менше, ніж за {{count}} секунду",
      singularGenitive: "менше, ніж за {{count}} секунди",
      pluralGenitive: "менше, ніж за {{count}} секунд"
    }
  }),
  xSeconds: Je({
    regular: {
      singularNominative: "{{count}} секунда",
      singularGenitive: "{{count}} секунди",
      pluralGenitive: "{{count}} секунд"
    },
    past: {
      singularNominative: "{{count}} секунду тому",
      singularGenitive: "{{count}} секунди тому",
      pluralGenitive: "{{count}} секунд тому"
    },
    future: {
      singularNominative: "за {{count}} секунду",
      singularGenitive: "за {{count}} секунди",
      pluralGenitive: "за {{count}} секунд"
    }
  }),
  halfAMinute: HR,
  lessThanXMinutes: Je({
    regular: {
      one: "менше хвилини",
      singularNominative: "менше {{count}} хвилини",
      singularGenitive: "менше {{count}} хвилин",
      pluralGenitive: "менше {{count}} хвилин"
    },
    future: {
      one: "менше, ніж за хвилину",
      singularNominative: "менше, ніж за {{count}} хвилину",
      singularGenitive: "менше, ніж за {{count}} хвилини",
      pluralGenitive: "менше, ніж за {{count}} хвилин"
    }
  }),
  xMinutes: Je({
    regular: {
      singularNominative: "{{count}} хвилина",
      singularGenitive: "{{count}} хвилини",
      pluralGenitive: "{{count}} хвилин"
    },
    past: {
      singularNominative: "{{count}} хвилину тому",
      singularGenitive: "{{count}} хвилини тому",
      pluralGenitive: "{{count}} хвилин тому"
    },
    future: {
      singularNominative: "за {{count}} хвилину",
      singularGenitive: "за {{count}} хвилини",
      pluralGenitive: "за {{count}} хвилин"
    }
  }),
  aboutXHours: Je({
    regular: {
      singularNominative: "близько {{count}} години",
      singularGenitive: "близько {{count}} годин",
      pluralGenitive: "близько {{count}} годин"
    },
    future: {
      singularNominative: "приблизно за {{count}} годину",
      singularGenitive: "приблизно за {{count}} години",
      pluralGenitive: "приблизно за {{count}} годин"
    }
  }),
  xHours: Je({
    regular: {
      singularNominative: "{{count}} годину",
      singularGenitive: "{{count}} години",
      pluralGenitive: "{{count}} годин"
    }
  }),
  xDays: Je({
    regular: {
      singularNominative: "{{count}} день",
      singularGenitive: "{{count}} днi",
      pluralGenitive: "{{count}} днів"
    }
  }),
  aboutXWeeks: Je({
    regular: {
      singularNominative: "близько {{count}} тижня",
      singularGenitive: "близько {{count}} тижнів",
      pluralGenitive: "близько {{count}} тижнів"
    },
    future: {
      singularNominative: "приблизно за {{count}} тиждень",
      singularGenitive: "приблизно за {{count}} тижні",
      pluralGenitive: "приблизно за {{count}} тижнів"
    }
  }),
  xWeeks: Je({
    regular: {
      singularNominative: "{{count}} тиждень",
      singularGenitive: "{{count}} тижні",
      pluralGenitive: "{{count}} тижнів"
    }
  }),
  aboutXMonths: Je({
    regular: {
      singularNominative: "близько {{count}} місяця",
      singularGenitive: "близько {{count}} місяців",
      pluralGenitive: "близько {{count}} місяців"
    },
    future: {
      singularNominative: "приблизно за {{count}} місяць",
      singularGenitive: "приблизно за {{count}} місяці",
      pluralGenitive: "приблизно за {{count}} місяців"
    }
  }),
  xMonths: Je({
    regular: {
      singularNominative: "{{count}} місяць",
      singularGenitive: "{{count}} місяці",
      pluralGenitive: "{{count}} місяців"
    }
  }),
  aboutXYears: Je({
    regular: {
      singularNominative: "близько {{count}} року",
      singularGenitive: "близько {{count}} років",
      pluralGenitive: "близько {{count}} років"
    },
    future: {
      singularNominative: "приблизно за {{count}} рік",
      singularGenitive: "приблизно за {{count}} роки",
      pluralGenitive: "приблизно за {{count}} років"
    }
  }),
  xYears: Je({
    regular: {
      singularNominative: "{{count}} рік",
      singularGenitive: "{{count}} роки",
      pluralGenitive: "{{count}} років"
    }
  }),
  overXYears: Je({
    regular: {
      singularNominative: "більше {{count}} року",
      singularGenitive: "більше {{count}} років",
      pluralGenitive: "більше {{count}} років"
    },
    future: {
      singularNominative: "більше, ніж за {{count}} рік",
      singularGenitive: "більше, ніж за {{count}} роки",
      pluralGenitive: "більше, ніж за {{count}} років"
    }
  }),
  almostXYears: Je({
    regular: {
      singularNominative: "майже {{count}} рік",
      singularGenitive: "майже {{count}} роки",
      pluralGenitive: "майже {{count}} років"
    },
    future: {
      singularNominative: "майже за {{count}} рік",
      singularGenitive: "майже за {{count}} роки",
      pluralGenitive: "майже за {{count}} років"
    }
  })
}, BR = function(i, d, a) {
  return a = a || {}, UR[i](d, a);
}, XR = {
  full: "EEEE, do MMMM y 'р.'",
  long: "do MMMM y 'р.'",
  medium: "d MMM y 'р.'",
  short: "dd.MM.y"
}, GR = {
  full: "H:mm:ss zzzz",
  long: "H:mm:ss z",
  medium: "H:mm:ss",
  short: "H:mm"
}, KR = {
  full: "{{date}} 'о' {{time}}",
  long: "{{date}} 'о' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, YR = {
  date: I({
    formats: XR,
    defaultWidth: "full"
  }),
  time: I({
    formats: GR,
    defaultWidth: "full"
  }),
  dateTime: I({
    formats: KR,
    defaultWidth: "full"
  })
}, dr = ["неділю", "понеділок", "вівторок", "середу", "четвер", "п’ятницю", "суботу"];
function JR(e) {
  var i = dr[e];
  switch (e) {
    case 0:
    case 3:
    case 5:
    case 6:
      return "'у минулу " + i + " о' p";
    case 1:
    case 2:
    case 4:
      return "'у минулий " + i + " о' p";
  }
}
function Eu(e) {
  var i = dr[e];
  return "'у " + i + " о' p";
}
function QR(e) {
  var i = dr[e];
  switch (e) {
    case 0:
    case 3:
    case 5:
    case 6:
      return "'у наступну " + i + " о' p";
    case 1:
    case 2:
    case 4:
      return "'у наступний " + i + " о' p";
  }
}
var eL = function(i, d, a) {
  var t = Vn(i), o = t.getUTCDay();
  return Ne(t, d, a) ? Eu(o) : JR(o);
}, nL = function(i, d, a) {
  var t = Vn(i), o = t.getUTCDay();
  return Ne(t, d, a) ? Eu(o) : QR(o);
}, iL = {
  lastWeek: eL,
  yesterday: "'вчора о' p",
  today: "'сьогодні о' p",
  tomorrow: "'завтра о' p",
  nextWeek: nL,
  other: "P"
}, aL = function(i, d, a, t) {
  var o = iL[i];
  return typeof o == "function" ? o(d, a, t) : o;
}, tL = {
  narrow: ["до н.е.", "н.е."],
  abbreviated: ["до н. е.", "н. е."],
  wide: ["до нашої ери", "нашої ери"]
}, rL = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1-й кв.", "2-й кв.", "3-й кв.", "4-й кв."],
  wide: ["1-й квартал", "2-й квартал", "3-й квартал", "4-й квартал"]
}, oL = {
  // ДСТУ 3582:2013
  narrow: ["С", "Л", "Б", "К", "Т", "Ч", "Л", "С", "В", "Ж", "Л", "Г"],
  abbreviated: ["січ.", "лют.", "берез.", "квіт.", "трав.", "черв.", "лип.", "серп.", "верес.", "жовт.", "листоп.", "груд."],
  wide: ["січень", "лютий", "березень", "квітень", "травень", "червень", "липень", "серпень", "вересень", "жовтень", "листопад", "грудень"]
}, sL = {
  narrow: ["С", "Л", "Б", "К", "Т", "Ч", "Л", "С", "В", "Ж", "Л", "Г"],
  abbreviated: ["січ.", "лют.", "берез.", "квіт.", "трав.", "черв.", "лип.", "серп.", "верес.", "жовт.", "листоп.", "груд."],
  wide: ["січня", "лютого", "березня", "квітня", "травня", "червня", "липня", "серпня", "вересня", "жовтня", "листопада", "грудня"]
}, dL = {
  narrow: ["Н", "П", "В", "С", "Ч", "П", "С"],
  short: ["нд", "пн", "вт", "ср", "чт", "пт", "сб"],
  abbreviated: ["нед", "пон", "вів", "сер", "чтв", "птн", "суб"],
  wide: ["неділя", "понеділок", "вівторок", "середа", "четвер", "п’ятниця", "субота"]
}, uL = {
  narrow: {
    am: "ДП",
    pm: "ПП",
    midnight: "півн.",
    noon: "пол.",
    morning: "ранок",
    afternoon: "день",
    evening: "веч.",
    night: "ніч"
  },
  abbreviated: {
    am: "ДП",
    pm: "ПП",
    midnight: "півн.",
    noon: "пол.",
    morning: "ранок",
    afternoon: "день",
    evening: "веч.",
    night: "ніч"
  },
  wide: {
    am: "ДП",
    pm: "ПП",
    midnight: "північ",
    noon: "полудень",
    morning: "ранок",
    afternoon: "день",
    evening: "вечір",
    night: "ніч"
  }
}, fL = {
  narrow: {
    am: "ДП",
    pm: "ПП",
    midnight: "півн.",
    noon: "пол.",
    morning: "ранку",
    afternoon: "дня",
    evening: "веч.",
    night: "ночі"
  },
  abbreviated: {
    am: "ДП",
    pm: "ПП",
    midnight: "півн.",
    noon: "пол.",
    morning: "ранку",
    afternoon: "дня",
    evening: "веч.",
    night: "ночі"
  },
  wide: {
    am: "ДП",
    pm: "ПП",
    midnight: "північ",
    noon: "полудень",
    morning: "ранку",
    afternoon: "дня",
    evening: "веч.",
    night: "ночі"
  }
}, lL = function(i, d) {
  var a = String(d == null ? void 0 : d.unit), t = Number(i), o;
  return a === "date" ? t === 3 || t === 23 ? o = "-є" : o = "-е" : a === "minute" || a === "second" || a === "hour" ? o = "-а" : o = "-й", t + o;
}, cL = {
  ordinalNumber: lL,
  era: $({
    values: tL,
    defaultWidth: "wide"
  }),
  quarter: $({
    values: rL,
    defaultWidth: "wide",
    argumentCallback: function(i) {
      return i - 1;
    }
  }),
  month: $({
    values: oL,
    defaultWidth: "wide",
    formattingValues: sL,
    defaultFormattingWidth: "wide"
  }),
  day: $({
    values: dL,
    defaultWidth: "wide"
  }),
  dayPeriod: $({
    values: uL,
    defaultWidth: "any",
    formattingValues: fL,
    defaultFormattingWidth: "wide"
  })
}, mL = /^(\d+)(-?(е|й|є|а|я))?/i, vL = /\d+/i, hL = {
  narrow: /^((до )?н\.?\s?е\.?)/i,
  abbreviated: /^((до )?н\.?\s?е\.?)/i,
  wide: /^(до нашої ери|нашої ери|наша ера)/i
}, gL = {
  any: [/^д/i, /^н/i]
}, pL = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234](-?[иі]?й?)? кв.?/i,
  wide: /^[1234](-?[иі]?й?)? квартал/i
}, bL = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, yL = {
  narrow: /^[слбктчвжг]/i,
  abbreviated: /^(січ|лют|бер(ез)?|квіт|трав|черв|лип|серп|вер(ес)?|жовт|лис(топ)?|груд)\.?/i,
  wide: /^(січень|січня|лютий|лютого|березень|березня|квітень|квітня|травень|травня|червня|червень|липень|липня|серпень|серпня|вересень|вересня|жовтень|жовтня|листопад[а]?|грудень|грудня)/i
}, kL = {
  narrow: [/^с/i, /^л/i, /^б/i, /^к/i, /^т/i, /^ч/i, /^л/i, /^с/i, /^в/i, /^ж/i, /^л/i, /^г/i],
  any: [/^сі/i, /^лю/i, /^б/i, /^к/i, /^т/i, /^ч/i, /^лип/i, /^се/i, /^в/i, /^ж/i, /^лис/i, /^г/i]
}, wL = {
  narrow: /^[нпвсч]/i,
  short: /^(нд|пн|вт|ср|чт|пт|сб)\.?/i,
  abbreviated: /^(нед|пон|вів|сер|че?тв|птн?|суб)\.?/i,
  wide: /^(неділ[яі]|понеділ[ок][ка]|вівтор[ок][ка]|серед[аи]|четвер(га)?|п\W*?ятниц[яі]|субот[аи])/i
}, _L = {
  narrow: [/^н/i, /^п/i, /^в/i, /^с/i, /^ч/i, /^п/i, /^с/i],
  any: [/^н/i, /^п[он]/i, /^в/i, /^с[ер]/i, /^ч/i, /^п\W*?[ят]/i, /^с[уб]/i]
}, $L = {
  narrow: /^([дп]п|півн\.?|пол\.?|ранок|ранку|день|дня|веч\.?|ніч|ночі)/i,
  abbreviated: /^([дп]п|півн\.?|пол\.?|ранок|ранку|день|дня|веч\.?|ніч|ночі)/i,
  wide: /^([дп]п|північ|полудень|ранок|ранку|день|дня|вечір|вечора|ніч|ночі)/i
}, PL = {
  any: {
    am: /^дп/i,
    pm: /^пп/i,
    midnight: /^півн/i,
    noon: /^пол/i,
    morning: /^р/i,
    afternoon: /^д[ен]/i,
    evening: /^в/i,
    night: /^н/i
  }
}, ML = {
  ordinalNumber: le({
    matchPattern: mL,
    parsePattern: vL,
    valueCallback: function(i) {
      return parseInt(i, 10);
    }
  }),
  era: P({
    matchPatterns: hL,
    defaultMatchWidth: "wide",
    parsePatterns: gL,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: pL,
    defaultMatchWidth: "wide",
    parsePatterns: bL,
    defaultParseWidth: "any",
    valueCallback: function(i) {
      return i + 1;
    }
  }),
  month: P({
    matchPatterns: yL,
    defaultMatchWidth: "wide",
    parsePatterns: kL,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: wL,
    defaultMatchWidth: "wide",
    parsePatterns: _L,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: $L,
    defaultMatchWidth: "wide",
    parsePatterns: PL,
    defaultParseWidth: "any"
  })
}, jL = {
  code: "uk",
  formatDistance: BR,
  formatLong: YR,
  formatRelative: aL,
  localize: cL,
  match: ML,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
};
const SL = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: jL
}, Symbol.toStringTag, { value: "Module" })), zL = /* @__PURE__ */ te(SL);
var OL = {
  lessThanXSeconds: {
    one: "sekunddan kam",
    other: "{{count}} sekunddan kam"
  },
  xSeconds: {
    one: "1 sekund",
    other: "{{count}} sekund"
  },
  halfAMinute: "yarim minut",
  lessThanXMinutes: {
    one: "bir minutdan kam",
    other: "{{count}} minutdan kam"
  },
  xMinutes: {
    one: "1 minut",
    other: "{{count}} minut"
  },
  aboutXHours: {
    one: "tahminan 1 soat",
    other: "tahminan {{count}} soat"
  },
  xHours: {
    one: "1 soat",
    other: "{{count}} soat"
  },
  xDays: {
    one: "1 kun",
    other: "{{count}} kun"
  },
  aboutXWeeks: {
    one: "tahminan 1 hafta",
    other: "tahminan {{count}} hafta"
  },
  xWeeks: {
    one: "1 hafta",
    other: "{{count}} hafta"
  },
  aboutXMonths: {
    one: "tahminan 1 oy",
    other: "tahminan {{count}} oy"
  },
  xMonths: {
    one: "1 oy",
    other: "{{count}} oy"
  },
  aboutXYears: {
    one: "tahminan 1 yil",
    other: "tahminan {{count}} yil"
  },
  xYears: {
    one: "1 yil",
    other: "{{count}} yil"
  },
  overXYears: {
    one: "1 yildan ko'p",
    other: "{{count}} yildan ko'p"
  },
  almostXYears: {
    one: "deyarli 1 yil",
    other: "deyarli {{count}} yil"
  }
}, WL = function(i, d, a) {
  var t, o = OL[i];
  return typeof o == "string" ? t = o : d === 1 ? t = o.one : t = o.other.replace("{{count}}", String(d)), a != null && a.addSuffix ? a.comparison && a.comparison > 0 ? t + " dan keyin" : t + " oldin" : t;
}, DL = {
  full: "EEEE, do MMMM, y",
  long: "do MMMM, y",
  medium: "d MMM, y",
  short: "dd/MM/yyyy"
}, CL = {
  full: "h:mm:ss zzzz",
  long: "h:mm:ss z",
  medium: "h:mm:ss",
  short: "h:mm"
}, IL = {
  any: "{{date}}, {{time}}"
}, TL = {
  date: I({
    formats: DL,
    defaultWidth: "full"
  }),
  time: I({
    formats: CL,
    defaultWidth: "full"
  }),
  dateTime: I({
    formats: IL,
    defaultWidth: "any"
  })
}, NL = {
  lastWeek: "'oldingi' eeee p 'da'",
  yesterday: "'kecha' p 'da'",
  today: "'bugun' p 'da'",
  tomorrow: "'ertaga' p 'da'",
  nextWeek: "eeee p 'da'",
  other: "P"
}, xL = function(i, d, a, t) {
  return NL[i];
}, FL = {
  narrow: ["M.A", "M."],
  abbreviated: ["M.A", "M."],
  wide: ["Miloddan Avvalgi", "Milodiy"]
}, EL = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["CH.1", "CH.2", "CH.3", "CH.4"],
  wide: ["1-chi chorak", "2-chi chorak", "3-chi chorak", "4-chi chorak"]
}, RL = {
  narrow: ["Y", "F", "M", "A", "M", "I", "I", "A", "S", "O", "N", "D"],
  abbreviated: ["Yan", "Fev", "Mar", "Apr", "May", "Iyun", "Iyul", "Avg", "Sen", "Okt", "Noy", "Dek"],
  wide: ["Yanvar", "Fevral", "Mart", "Aprel", "May", "Iyun", "Iyul", "Avgust", "Sentabr", "Oktabr", "Noyabr", "Dekabr"]
}, LL = {
  narrow: ["Y", "D", "S", "CH", "P", "J", "SH"],
  short: ["Ya", "Du", "Se", "Cho", "Pa", "Ju", "Sha"],
  abbreviated: ["Yak", "Dush", "Sesh", "Chor", "Pay", "Jum", "Shan"],
  wide: ["Yakshanba", "Dushanba", "Seshanba", "Chorshanba", "Payshanba", "Juma", "Shanba"]
}, qL = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "y.t",
    noon: "p.",
    morning: "ertalab",
    afternoon: "tushdan keyin",
    evening: "kechqurun",
    night: "tun"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "yarim tun",
    noon: "peshin",
    morning: "ertalab",
    afternoon: "tushdan keyin",
    evening: "kechqurun",
    night: "tun"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "yarim tun",
    noon: "peshin",
    morning: "ertalab",
    afternoon: "tushdan keyin",
    evening: "kechqurun",
    night: "tun"
  }
}, ZL = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "y.t",
    noon: "p.",
    morning: "ertalab",
    afternoon: "tushdan keyin",
    evening: "kechqurun",
    night: "tun"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "yarim tun",
    noon: "peshin",
    morning: "ertalab",
    afternoon: "tushdan keyin",
    evening: "kechqurun",
    night: "tun"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "yarim tun",
    noon: "peshin",
    morning: "ertalab",
    afternoon: "tushdan keyin",
    evening: "kechqurun",
    night: "tun"
  }
}, AL = function(i, d) {
  return String(i);
}, VL = {
  ordinalNumber: AL,
  era: $({
    values: FL,
    defaultWidth: "wide"
  }),
  quarter: $({
    values: EL,
    defaultWidth: "wide",
    argumentCallback: function(i) {
      return i - 1;
    }
  }),
  month: $({
    values: RL,
    defaultWidth: "wide"
  }),
  day: $({
    values: LL,
    defaultWidth: "wide"
  }),
  dayPeriod: $({
    values: qL,
    defaultWidth: "wide",
    formattingValues: ZL,
    defaultFormattingWidth: "wide"
  })
}, HL = /^(\d+)(chi)?/i, UL = /\d+/i, BL = {
  narrow: /^(m\.a|m\.)/i,
  abbreviated: /^(m\.a\.?\s?m\.?)/i,
  wide: /^(miloddan avval|miloddan keyin)/i
}, XL = {
  any: [/^b/i, /^(a|c)/i]
}, GL = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](chi)? chorak/i
}, KL = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, YL = {
  narrow: /^[yfmasond]/i,
  abbreviated: /^(yan|fev|mar|apr|may|iyun|iyul|avg|sen|okt|noy|dek)/i,
  wide: /^(yanvar|fevral|mart|aprel|may|iyun|iyul|avgust|sentabr|oktabr|noyabr|dekabr)/i
}, JL = {
  narrow: [/^y/i, /^f/i, /^m/i, /^a/i, /^m/i, /^i/i, /^i/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ya/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^iyun/i, /^iyul/i, /^av/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, QL = {
  narrow: /^[ydschj]/i,
  short: /^(ya|du|se|cho|pa|ju|sha)/i,
  abbreviated: /^(yak|dush|sesh|chor|pay|jum|shan)/i,
  wide: /^(yakshanba|dushanba|seshanba|chorshanba|payshanba|juma|shanba)/i
}, eq = {
  narrow: [/^y/i, /^d/i, /^s/i, /^ch/i, /^p/i, /^j/i, /^sh/i],
  any: [/^ya/i, /^d/i, /^se/i, /^ch/i, /^p/i, /^j/i, /^sh/i]
}, nq = {
  narrow: /^(a|p|y\.t|p| (ertalab|tushdan keyin|kechqurun|tun))/i,
  any: /^([ap]\.?\s?m\.?|yarim tun|peshin| (ertalab|tushdan keyin|kechqurun|tun))/i
}, iq = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^y\.t/i,
    noon: /^pe/i,
    morning: /ertalab/i,
    afternoon: /tushdan keyin/i,
    evening: /kechqurun/i,
    night: /tun/i
  }
}, aq = {
  ordinalNumber: le({
    matchPattern: HL,
    parsePattern: UL,
    valueCallback: function(i) {
      return parseInt(i, 10);
    }
  }),
  era: P({
    matchPatterns: BL,
    defaultMatchWidth: "wide",
    parsePatterns: XL,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: GL,
    defaultMatchWidth: "wide",
    parsePatterns: KL,
    defaultParseWidth: "any",
    valueCallback: function(i) {
      return i + 1;
    }
  }),
  month: P({
    matchPatterns: YL,
    defaultMatchWidth: "wide",
    parsePatterns: JL,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: QL,
    defaultMatchWidth: "wide",
    parsePatterns: eq,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: nq,
    defaultMatchWidth: "any",
    parsePatterns: iq,
    defaultParseWidth: "any"
  })
}, tq = {
  code: "uz",
  formatDistance: WL,
  formatLong: TL,
  formatRelative: xL,
  localize: VL,
  match: aq,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
};
const rq = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: tq
}, Symbol.toStringTag, { value: "Module" })), oq = /* @__PURE__ */ te(rq);
var sq = {
  lessThanXSeconds: {
    one: "1 сониядан кам",
    other: "{{count}} сониядан кам"
  },
  xSeconds: {
    one: "1 сония",
    other: "{{count}} сония"
  },
  halfAMinute: "ярим дақиқа",
  lessThanXMinutes: {
    one: "1 дақиқадан кам",
    other: "{{count}} дақиқадан кам"
  },
  xMinutes: {
    one: "1 дақиқа",
    other: "{{count}} дақиқа"
  },
  aboutXHours: {
    one: "тахминан 1 соат",
    other: "тахминан {{count}} соат"
  },
  xHours: {
    one: "1 соат",
    other: "{{count}} соат"
  },
  xDays: {
    one: "1 кун",
    other: "{{count}} кун"
  },
  aboutXWeeks: {
    one: "тахминан 1 хафта",
    other: "тахминан {{count}} хафта"
  },
  xWeeks: {
    one: "1 хафта",
    other: "{{count}} хафта"
  },
  aboutXMonths: {
    one: "тахминан 1 ой",
    other: "тахминан {{count}} ой"
  },
  xMonths: {
    one: "1 ой",
    other: "{{count}} ой"
  },
  aboutXYears: {
    one: "тахминан 1 йил",
    other: "тахминан {{count}} йил"
  },
  xYears: {
    one: "1 йил",
    other: "{{count}} йил"
  },
  overXYears: {
    one: "1 йилдан кўп",
    other: "{{count}} йилдан кўп"
  },
  almostXYears: {
    one: "деярли 1 йил",
    other: "деярли {{count}} йил"
  }
}, dq = function(i, d, a) {
  var t, o = sq[i];
  return typeof o == "string" ? t = o : d === 1 ? t = o.one : t = o.other.replace("{{count}}", String(d)), a != null && a.addSuffix ? a.comparison && a.comparison > 0 ? t + "дан кейин" : t + " олдин" : t;
}, uq = {
  full: "EEEE, do MMMM, y",
  long: "do MMMM, y",
  medium: "d MMM, y",
  short: "dd/MM/yyyy"
}, fq = {
  full: "H:mm:ss zzzz",
  long: "H:mm:ss z",
  medium: "H:mm:ss",
  short: "H:mm"
}, lq = {
  any: "{{date}}, {{time}}"
}, cq = {
  date: I({
    formats: uq,
    defaultWidth: "full"
  }),
  time: I({
    formats: fq,
    defaultWidth: "full"
  }),
  dateTime: I({
    formats: lq,
    defaultWidth: "any"
  })
}, mq = {
  lastWeek: "'ўтган' eeee p 'да'",
  yesterday: "'кеча' p 'да'",
  today: "'бугун' p 'да'",
  tomorrow: "'эртага' p 'да'",
  nextWeek: "eeee p 'да'",
  other: "P"
}, vq = function(i, d, a, t) {
  return mq[i];
}, hq = {
  narrow: ["М.А", "М"],
  abbreviated: ["М.А", "М"],
  wide: ["Милоддан Аввалги", "Милодий"]
}, gq = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1-чор.", "2-чор.", "3-чор.", "4-чор."],
  wide: ["1-чорак", "2-чорак", "3-чорак", "4-чорак"]
}, pq = {
  narrow: ["Я", "Ф", "М", "А", "М", "И", "И", "А", "С", "О", "Н", "Д"],
  abbreviated: ["янв", "фев", "мар", "апр", "май", "июн", "июл", "авг", "сен", "окт", "ноя", "дек"],
  wide: ["январ", "феврал", "март", "апрел", "май", "июн", "июл", "август", "сентабр", "октабр", "ноябр", "декабр"]
}, bq = {
  narrow: ["Я", "Д", "С", "Ч", "П", "Ж", "Ш"],
  short: ["як", "ду", "се", "чо", "па", "жу", "ша"],
  abbreviated: ["якш", "душ", "сеш", "чор", "пай", "жум", "шан"],
  wide: ["якшанба", "душанба", "сешанба", "чоршанба", "пайшанба", "жума", "шанба"]
}, yq = {
  any: {
    am: "П.О.",
    pm: "П.К.",
    midnight: "ярим тун",
    noon: "пешин",
    morning: "эрталаб",
    afternoon: "пешиндан кейин",
    evening: "кечаси",
    night: "тун"
  }
}, kq = {
  any: {
    am: "П.О.",
    pm: "П.К.",
    midnight: "ярим тун",
    noon: "пешин",
    morning: "эрталаб",
    afternoon: "пешиндан кейин",
    evening: "кечаси",
    night: "тун"
  }
}, wq = function(i, d) {
  return String(i);
}, _q = {
  ordinalNumber: wq,
  era: $({
    values: hq,
    defaultWidth: "wide"
  }),
  quarter: $({
    values: gq,
    defaultWidth: "wide",
    argumentCallback: function(i) {
      return i - 1;
    }
  }),
  month: $({
    values: pq,
    defaultWidth: "wide"
  }),
  day: $({
    values: bq,
    defaultWidth: "wide"
  }),
  dayPeriod: $({
    values: yq,
    defaultWidth: "any",
    formattingValues: kq,
    defaultFormattingWidth: "any"
  })
}, $q = /^(\d+)(чи)?/i, Pq = /\d+/i, Mq = {
  narrow: /^(м\.а|м\.)/i,
  abbreviated: /^(м\.а|м\.)/i,
  wide: /^(милоддан аввал|милоддан кейин)/i
}, jq = {
  any: [/^м/i, /^а/i]
}, Sq = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234]-чор./i,
  wide: /^[1234]-чорак/i
}, zq = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Oq = {
  narrow: /^[яфмамииасонд]/i,
  abbreviated: /^(янв|фев|мар|апр|май|июн|июл|авг|сен|окт|ноя|дек)/i,
  wide: /^(январ|феврал|март|апрел|май|июн|июл|август|сентабр|октабр|ноябр|декабр)/i
}, Wq = {
  narrow: [/^я/i, /^ф/i, /^м/i, /^а/i, /^м/i, /^и/i, /^и/i, /^а/i, /^с/i, /^о/i, /^н/i, /^д/i],
  any: [/^я/i, /^ф/i, /^мар/i, /^ап/i, /^май/i, /^июн/i, /^июл/i, /^ав/i, /^с/i, /^о/i, /^н/i, /^д/i]
}, Dq = {
  narrow: /^[ядсчпжш]/i,
  short: /^(як|ду|се|чо|па|жу|ша)/i,
  abbreviated: /^(якш|душ|сеш|чор|пай|жум|шан)/i,
  wide: /^(якшанба|душанба|сешанба|чоршанба|пайшанба|жума|шанба)/i
}, Cq = {
  narrow: [/^я/i, /^д/i, /^с/i, /^ч/i, /^п/i, /^ж/i, /^ш/i],
  any: [/^як/i, /^ду/i, /^се/i, /^чор/i, /^пай/i, /^жу/i, /^шан/i]
}, Iq = {
  any: /^(п\.о\.|п\.к\.|ярим тун|пешиндан кейин|(эрталаб|пешиндан кейин|кечаси|тун))/i
}, Tq = {
  any: {
    am: /^п\.о\./i,
    pm: /^п\.к\./i,
    midnight: /^ярим тун/i,
    noon: /^пешиндан кейин/i,
    morning: /эрталаб/i,
    afternoon: /пешиндан кейин/i,
    evening: /кечаси/i,
    night: /тун/i
  }
}, Nq = {
  ordinalNumber: le({
    matchPattern: $q,
    parsePattern: Pq,
    valueCallback: function(i) {
      return parseInt(i, 10);
    }
  }),
  era: P({
    matchPatterns: Mq,
    defaultMatchWidth: "wide",
    parsePatterns: jq,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: Sq,
    defaultMatchWidth: "wide",
    parsePatterns: zq,
    defaultParseWidth: "any",
    valueCallback: function(i) {
      return i + 1;
    }
  }),
  month: P({
    matchPatterns: Oq,
    defaultMatchWidth: "wide",
    parsePatterns: Wq,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: Dq,
    defaultMatchWidth: "wide",
    parsePatterns: Cq,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: Iq,
    defaultMatchWidth: "any",
    parsePatterns: Tq,
    defaultParseWidth: "any"
  })
}, xq = {
  code: "uz-Cyrl",
  formatDistance: dq,
  formatLong: cq,
  formatRelative: vq,
  localize: _q,
  match: Nq,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
};
const Fq = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: xq
}, Symbol.toStringTag, { value: "Module" })), Eq = /* @__PURE__ */ te(Fq);
var Rq = {
  lessThanXSeconds: {
    one: "dưới 1 giây",
    other: "dưới {{count}} giây"
  },
  xSeconds: {
    one: "1 giây",
    other: "{{count}} giây"
  },
  halfAMinute: "nửa phút",
  lessThanXMinutes: {
    one: "dưới 1 phút",
    other: "dưới {{count}} phút"
  },
  xMinutes: {
    one: "1 phút",
    other: "{{count}} phút"
  },
  aboutXHours: {
    one: "khoảng 1 giờ",
    other: "khoảng {{count}} giờ"
  },
  xHours: {
    one: "1 giờ",
    other: "{{count}} giờ"
  },
  xDays: {
    one: "1 ngày",
    other: "{{count}} ngày"
  },
  aboutXWeeks: {
    one: "khoảng 1 tuần",
    other: "khoảng {{count}} tuần"
  },
  xWeeks: {
    one: "1 tuần",
    other: "{{count}} tuần"
  },
  aboutXMonths: {
    one: "khoảng 1 tháng",
    other: "khoảng {{count}} tháng"
  },
  xMonths: {
    one: "1 tháng",
    other: "{{count}} tháng"
  },
  aboutXYears: {
    one: "khoảng 1 năm",
    other: "khoảng {{count}} năm"
  },
  xYears: {
    one: "1 năm",
    other: "{{count}} năm"
  },
  overXYears: {
    one: "hơn 1 năm",
    other: "hơn {{count}} năm"
  },
  almostXYears: {
    one: "gần 1 năm",
    other: "gần {{count}} năm"
  }
}, Lq = function(i, d, a) {
  var t, o = Rq[i];
  return typeof o == "string" ? t = o : d === 1 ? t = o.one : t = o.other.replace("{{count}}", String(d)), a != null && a.addSuffix ? a.comparison && a.comparison > 0 ? t + " nữa" : t + " trước" : t;
}, qq = {
  // thứ Sáu, ngày 25 tháng 08 năm 2017
  full: "EEEE, 'ngày' d MMMM 'năm' y",
  // ngày 25 tháng 08 năm 2017
  long: "'ngày' d MMMM 'năm' y",
  // 25 thg 08 năm 2017
  medium: "d MMM 'năm' y",
  // 25/08/2017
  short: "dd/MM/y"
}, Zq = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, Aq = {
  // thứ Sáu, ngày 25 tháng 08 năm 2017 23:25:59
  full: "{{date}} {{time}}",
  // ngày 25 tháng 08 năm 2017 23:25
  long: "{{date}} {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, Vq = {
  date: I({
    formats: qq,
    defaultWidth: "full"
  }),
  time: I({
    formats: Zq,
    defaultWidth: "full"
  }),
  dateTime: I({
    formats: Aq,
    defaultWidth: "full"
  })
}, Hq = {
  lastWeek: "eeee 'tuần trước vào lúc' p",
  yesterday: "'hôm qua vào lúc' p",
  today: "'hôm nay vào lúc' p",
  tomorrow: "'ngày mai vào lúc' p",
  nextWeek: "eeee 'tới vào lúc' p",
  other: "P"
}, Uq = function(i, d, a, t) {
  return Hq[i];
}, Bq = {
  narrow: ["TCN", "SCN"],
  abbreviated: ["trước CN", "sau CN"],
  wide: ["trước Công Nguyên", "sau Công Nguyên"]
}, Xq = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["Quý 1", "Quý 2", "Quý 3", "Quý 4"]
}, Gq = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  // I notice many news outlet use this "quý II/2018"
  wide: ["quý I", "quý II", "quý III", "quý IV"]
}, Kq = {
  narrow: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"],
  abbreviated: ["Thg 1", "Thg 2", "Thg 3", "Thg 4", "Thg 5", "Thg 6", "Thg 7", "Thg 8", "Thg 9", "Thg 10", "Thg 11", "Thg 12"],
  wide: ["Tháng Một", "Tháng Hai", "Tháng Ba", "Tháng Tư", "Tháng Năm", "Tháng Sáu", "Tháng Bảy", "Tháng Tám", "Tháng Chín", "Tháng Mười", "Tháng Mười Một", "Tháng Mười Hai"]
}, Yq = {
  narrow: ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"],
  abbreviated: ["thg 1", "thg 2", "thg 3", "thg 4", "thg 5", "thg 6", "thg 7", "thg 8", "thg 9", "thg 10", "thg 11", "thg 12"],
  wide: ["tháng 01", "tháng 02", "tháng 03", "tháng 04", "tháng 05", "tháng 06", "tháng 07", "tháng 08", "tháng 09", "tháng 10", "tháng 11", "tháng 12"]
}, Jq = {
  narrow: ["CN", "T2", "T3", "T4", "T5", "T6", "T7"],
  short: ["CN", "Th 2", "Th 3", "Th 4", "Th 5", "Th 6", "Th 7"],
  abbreviated: ["CN", "Thứ 2", "Thứ 3", "Thứ 4", "Thứ 5", "Thứ 6", "Thứ 7"],
  wide: ["Chủ Nhật", "Thứ Hai", "Thứ Ba", "Thứ Tư", "Thứ Năm", "Thứ Sáu", "Thứ Bảy"]
}, Qq = {
  // narrow date period is extremely rare in Vietnamese
  // I used abbreviated form for noon, morning and afternoon
  // which are regconizable by Vietnamese, others cannot be any shorter
  narrow: {
    am: "am",
    pm: "pm",
    midnight: "nửa đêm",
    noon: "tr",
    morning: "sg",
    afternoon: "ch",
    evening: "tối",
    night: "đêm"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "nửa đêm",
    noon: "trưa",
    morning: "sáng",
    afternoon: "chiều",
    evening: "tối",
    night: "đêm"
  },
  wide: {
    am: "SA",
    pm: "CH",
    midnight: "nửa đêm",
    noon: "trưa",
    morning: "sáng",
    afternoon: "chiều",
    evening: "tối",
    night: "đêm"
  }
}, eZ = {
  narrow: {
    am: "am",
    pm: "pm",
    midnight: "nửa đêm",
    noon: "tr",
    morning: "sg",
    afternoon: "ch",
    evening: "tối",
    night: "đêm"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "nửa đêm",
    noon: "trưa",
    morning: "sáng",
    afternoon: "chiều",
    evening: "tối",
    night: "đêm"
  },
  wide: {
    am: "SA",
    pm: "CH",
    midnight: "nửa đêm",
    noon: "giữa trưa",
    morning: "vào buổi sáng",
    afternoon: "vào buổi chiều",
    evening: "vào buổi tối",
    night: "vào ban đêm"
  }
}, nZ = function(i, d) {
  var a = Number(i), t = d == null ? void 0 : d.unit;
  if (t === "quarter")
    switch (a) {
      case 1:
        return "I";
      case 2:
        return "II";
      case 3:
        return "III";
      case 4:
        return "IV";
    }
  else if (t === "day")
    switch (a) {
      case 1:
        return "thứ 2";
      case 2:
        return "thứ 3";
      case 3:
        return "thứ 4";
      case 4:
        return "thứ 5";
      case 5:
        return "thứ 6";
      case 6:
        return "thứ 7";
      case 7:
        return "chủ nhật";
    }
  else {
    if (t === "week")
      return a === 1 ? "thứ nhất" : "thứ " + a;
    if (t === "dayOfYear")
      return a === 1 ? "đầu tiên" : "thứ " + a;
  }
  return String(a);
}, iZ = {
  ordinalNumber: nZ,
  era: $({
    values: Bq,
    defaultWidth: "wide"
  }),
  quarter: $({
    values: Xq,
    defaultWidth: "wide",
    formattingValues: Gq,
    defaultFormattingWidth: "wide",
    argumentCallback: function(i) {
      return i - 1;
    }
  }),
  month: $({
    values: Kq,
    defaultWidth: "wide",
    formattingValues: Yq,
    defaultFormattingWidth: "wide"
  }),
  day: $({
    values: Jq,
    defaultWidth: "wide"
  }),
  dayPeriod: $({
    values: Qq,
    defaultWidth: "wide",
    formattingValues: eZ,
    defaultFormattingWidth: "wide"
  })
}, aZ = /^(\d+)/i, tZ = /\d+/i, rZ = {
  narrow: /^(tcn|scn)/i,
  abbreviated: /^(trước CN|sau CN)/i,
  wide: /^(trước Công Nguyên|sau Công Nguyên)/i
}, oZ = {
  any: [/^t/i, /^s/i]
}, sZ = {
  narrow: /^([1234]|i{1,3}v?)/i,
  abbreviated: /^q([1234]|i{1,3}v?)/i,
  wide: /^quý ([1234]|i{1,3}v?)/i
}, dZ = {
  any: [/(1|i)$/i, /(2|ii)$/i, /(3|iii)$/i, /(4|iv)$/i]
}, uZ = {
  // month number may contain leading 0, 'thg' prefix may have space, underscore or empty before number
  // note the order of '1' since it is a sub-string of '10', so must be lower priority
  narrow: /^(0?[2-9]|10|11|12|0?1)/i,
  // note the order of 'thg 1' since it is sub-string of 'thg 10', so must be lower priority
  abbreviated: /^thg[ _]?(0?[1-9](?!\d)|10|11|12)/i,
  // note the order of 'Mười' since it is sub-string of Mười Một, so must be lower priority
  wide: /^tháng ?(Một|Hai|Ba|Tư|Năm|Sáu|Bảy|Tám|Chín|Mười|Mười ?Một|Mười ?Hai|0?[1-9](?!\d)|10|11|12)/i
}, fZ = {
  narrow: [/0?1$/i, /0?2/i, /3/, /4/, /5/, /6/, /7/, /8/, /9/, /10/, /11/, /12/],
  abbreviated: [/^thg[ _]?0?1(?!\d)/i, /^thg[ _]?0?2/i, /^thg[ _]?0?3/i, /^thg[ _]?0?4/i, /^thg[ _]?0?5/i, /^thg[ _]?0?6/i, /^thg[ _]?0?7/i, /^thg[ _]?0?8/i, /^thg[ _]?0?9/i, /^thg[ _]?10/i, /^thg[ _]?11/i, /^thg[ _]?12/i],
  wide: [/^tháng ?(Một|0?1(?!\d))/i, /^tháng ?(Hai|0?2)/i, /^tháng ?(Ba|0?3)/i, /^tháng ?(Tư|0?4)/i, /^tháng ?(Năm|0?5)/i, /^tháng ?(Sáu|0?6)/i, /^tháng ?(Bảy|0?7)/i, /^tháng ?(Tám|0?8)/i, /^tháng ?(Chín|0?9)/i, /^tháng ?(Mười|10)/i, /^tháng ?(Mười ?Một|11)/i, /^tháng ?(Mười ?Hai|12)/i]
}, lZ = {
  narrow: /^(CN|T2|T3|T4|T5|T6|T7)/i,
  short: /^(CN|Th ?2|Th ?3|Th ?4|Th ?5|Th ?6|Th ?7)/i,
  abbreviated: /^(CN|Th ?2|Th ?3|Th ?4|Th ?5|Th ?6|Th ?7)/i,
  wide: /^(Chủ ?Nhật|Chúa ?Nhật|thứ ?Hai|thứ ?Ba|thứ ?Tư|thứ ?Năm|thứ ?Sáu|thứ ?Bảy)/i
}, cZ = {
  narrow: [/CN/i, /2/i, /3/i, /4/i, /5/i, /6/i, /7/i],
  short: [/CN/i, /2/i, /3/i, /4/i, /5/i, /6/i, /7/i],
  abbreviated: [/CN/i, /2/i, /3/i, /4/i, /5/i, /6/i, /7/i],
  wide: [/(Chủ|Chúa) ?Nhật/i, /Hai/i, /Ba/i, /Tư/i, /Năm/i, /Sáu/i, /Bảy/i]
}, mZ = {
  narrow: /^(a|p|nửa đêm|trưa|(giờ) (sáng|chiều|tối|đêm))/i,
  abbreviated: /^(am|pm|nửa đêm|trưa|(giờ) (sáng|chiều|tối|đêm))/i,
  wide: /^(ch[^i]*|sa|nửa đêm|trưa|(giờ) (sáng|chiều|tối|đêm))/i
}, vZ = {
  any: {
    am: /^(a|sa)/i,
    pm: /^(p|ch[^i]*)/i,
    midnight: /nửa đêm/i,
    noon: /trưa/i,
    morning: /sáng/i,
    afternoon: /chiều/i,
    evening: /tối/i,
    night: /^đêm/i
  }
}, hZ = {
  ordinalNumber: le({
    matchPattern: aZ,
    parsePattern: tZ,
    valueCallback: function(i) {
      return parseInt(i, 10);
    }
  }),
  era: P({
    matchPatterns: rZ,
    defaultMatchWidth: "wide",
    parsePatterns: oZ,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: sZ,
    defaultMatchWidth: "wide",
    parsePatterns: dZ,
    defaultParseWidth: "any",
    valueCallback: function(i) {
      return i + 1;
    }
  }),
  month: P({
    matchPatterns: uZ,
    defaultMatchWidth: "wide",
    parsePatterns: fZ,
    defaultParseWidth: "wide"
  }),
  day: P({
    matchPatterns: lZ,
    defaultMatchWidth: "wide",
    parsePatterns: cZ,
    defaultParseWidth: "wide"
  }),
  dayPeriod: P({
    matchPatterns: mZ,
    defaultMatchWidth: "wide",
    parsePatterns: vZ,
    defaultParseWidth: "any"
  })
}, gZ = {
  code: "vi",
  formatDistance: Lq,
  formatLong: Vq,
  formatRelative: Uq,
  localize: iZ,
  match: hZ,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
    /* First week of new year contains Jan 1st  */
  }
};
const pZ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: gZ
}, Symbol.toStringTag, { value: "Module" })), bZ = /* @__PURE__ */ te(pZ);
var yZ = {
  lessThanXSeconds: {
    one: "少於 1 秒",
    other: "少於 {{count}} 秒"
  },
  xSeconds: {
    one: "1 秒",
    other: "{{count}} 秒"
  },
  halfAMinute: "半分鐘",
  lessThanXMinutes: {
    one: "少於 1 分鐘",
    other: "少於 {{count}} 分鐘"
  },
  xMinutes: {
    one: "1 分鐘",
    other: "{{count}} 分鐘"
  },
  xHours: {
    one: "1 小時",
    other: "{{count}} 小時"
  },
  aboutXHours: {
    one: "大約 1 小時",
    other: "大約 {{count}} 小時"
  },
  xDays: {
    one: "1 天",
    other: "{{count}} 天"
  },
  aboutXWeeks: {
    one: "大約 1 個星期",
    other: "大約 {{count}} 個星期"
  },
  xWeeks: {
    one: "1 個星期",
    other: "{{count}} 個星期"
  },
  aboutXMonths: {
    one: "大約 1 個月",
    other: "大約 {{count}} 個月"
  },
  xMonths: {
    one: "1 個月",
    other: "{{count}} 個月"
  },
  aboutXYears: {
    one: "大約 1 年",
    other: "大約 {{count}} 年"
  },
  xYears: {
    one: "1 年",
    other: "{{count}} 年"
  },
  overXYears: {
    one: "超過 1 年",
    other: "超過 {{count}} 年"
  },
  almostXYears: {
    one: "將近 1 年",
    other: "將近 {{count}} 年"
  }
}, kZ = function(i, d, a) {
  var t, o = yZ[i];
  return typeof o == "string" ? t = o : d === 1 ? t = o.one : t = o.other.replace("{{count}}", String(d)), a != null && a.addSuffix ? a.comparison && a.comparison > 0 ? t + "內" : t + "前" : t;
}, wZ = {
  full: "y'年'M'月'd'日' EEEE",
  long: "y'年'M'月'd'日'",
  medium: "yyyy-MM-dd",
  short: "yy-MM-dd"
}, _Z = {
  full: "zzzz a h:mm:ss",
  long: "z a h:mm:ss",
  medium: "a h:mm:ss",
  short: "a h:mm"
}, $Z = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, PZ = {
  date: I({
    formats: wZ,
    defaultWidth: "full"
  }),
  time: I({
    formats: _Z,
    defaultWidth: "full"
  }),
  dateTime: I({
    formats: $Z,
    defaultWidth: "full"
  })
}, MZ = {
  lastWeek: "'上個'eeee p",
  yesterday: "'昨天' p",
  today: "'今天' p",
  tomorrow: "'明天' p",
  nextWeek: "'下個'eeee p",
  other: "P"
}, jZ = function(i, d, a, t) {
  return MZ[i];
}, SZ = {
  narrow: ["前", "公元"],
  abbreviated: ["前", "公元"],
  wide: ["公元前", "公元"]
}, zZ = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["第一季", "第二季", "第三季", "第四季"],
  wide: ["第一季度", "第二季度", "第三季度", "第四季度"]
}, OZ = {
  narrow: ["一", "二", "三", "四", "五", "六", "七", "八", "九", "十", "十一", "十二"],
  abbreviated: ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"],
  wide: ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"]
}, WZ = {
  narrow: ["日", "一", "二", "三", "四", "五", "六"],
  short: ["日", "一", "二", "三", "四", "五", "六"],
  abbreviated: ["週日", "週一", "週二", "週三", "週四", "週五", "週六"],
  wide: ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"]
}, DZ = {
  narrow: {
    am: "上",
    pm: "下",
    midnight: "午夜",
    noon: "晌",
    morning: "早",
    afternoon: "午",
    evening: "晚",
    night: "夜"
  },
  abbreviated: {
    am: "上午",
    pm: "下午",
    midnight: "午夜",
    noon: "中午",
    morning: "上午",
    afternoon: "下午",
    evening: "晚上",
    night: "夜晚"
  },
  wide: {
    am: "上午",
    pm: "下午",
    midnight: "午夜",
    noon: "中午",
    morning: "上午",
    afternoon: "下午",
    evening: "晚上",
    night: "夜晚"
  }
}, CZ = {
  narrow: {
    am: "上",
    pm: "下",
    midnight: "午夜",
    noon: "晌",
    morning: "早",
    afternoon: "午",
    evening: "晚",
    night: "夜"
  },
  abbreviated: {
    am: "上午",
    pm: "下午",
    midnight: "午夜",
    noon: "中午",
    morning: "上午",
    afternoon: "下午",
    evening: "晚上",
    night: "夜晚"
  },
  wide: {
    am: "上午",
    pm: "下午",
    midnight: "午夜",
    noon: "中午",
    morning: "上午",
    afternoon: "下午",
    evening: "晚上",
    night: "夜晚"
  }
}, IZ = function(i, d) {
  var a = Number(i);
  switch (d == null ? void 0 : d.unit) {
    case "date":
      return a + "日";
    case "hour":
      return a + "時";
    case "minute":
      return a + "分";
    case "second":
      return a + "秒";
    default:
      return "第 " + a;
  }
}, TZ = {
  ordinalNumber: IZ,
  era: $({
    values: SZ,
    defaultWidth: "wide"
  }),
  quarter: $({
    values: zZ,
    defaultWidth: "wide",
    argumentCallback: function(i) {
      return i - 1;
    }
  }),
  month: $({
    values: OZ,
    defaultWidth: "wide"
  }),
  day: $({
    values: WZ,
    defaultWidth: "wide"
  }),
  dayPeriod: $({
    values: DZ,
    defaultWidth: "wide",
    formattingValues: CZ,
    defaultFormattingWidth: "wide"
  })
}, NZ = /^(第\s*)?\d+(日|時|分|秒)?/i, xZ = /\d+/i, FZ = {
  narrow: /^(前)/i,
  abbreviated: /^(前)/i,
  wide: /^(公元前|公元)/i
}, EZ = {
  any: [/^(前)/i, /^(公元)/i]
}, RZ = {
  narrow: /^[1234]/i,
  abbreviated: /^第[一二三四]季/i,
  wide: /^第[一二三四]季度/i
}, LZ = {
  any: [/(1|一)/i, /(2|二)/i, /(3|三)/i, /(4|四)/i]
}, qZ = {
  narrow: /^(一|二|三|四|五|六|七|八|九|十[二一])/i,
  abbreviated: /^(一|二|三|四|五|六|七|八|九|十[二一]|\d|1[12])月/i,
  wide: /^(一|二|三|四|五|六|七|八|九|十[二一])月/i
}, ZZ = {
  narrow: [/^一/i, /^二/i, /^三/i, /^四/i, /^五/i, /^六/i, /^七/i, /^八/i, /^九/i, /^十(?!(一|二))/i, /^十一/i, /^十二/i],
  any: [/^一|1/i, /^二|2/i, /^三|3/i, /^四|4/i, /^五|5/i, /^六|6/i, /^七|7/i, /^八|8/i, /^九|9/i, /^十(?!(一|二))|10/i, /^十一|11/i, /^十二|12/i]
}, AZ = {
  narrow: /^[一二三四五六日]/i,
  short: /^[一二三四五六日]/i,
  abbreviated: /^週[一二三四五六日]/i,
  wide: /^星期[一二三四五六日]/i
}, VZ = {
  any: [/日/i, /一/i, /二/i, /三/i, /四/i, /五/i, /六/i]
}, HZ = {
  any: /^(上午?|下午?|午夜|[中正]午|早上?|下午|晚上?|凌晨)/i
}, UZ = {
  any: {
    am: /^上午?/i,
    pm: /^下午?/i,
    midnight: /^午夜/i,
    noon: /^[中正]午/i,
    morning: /^早上/i,
    afternoon: /^下午/i,
    evening: /^晚上?/i,
    night: /^凌晨/i
  }
}, BZ = {
  ordinalNumber: le({
    matchPattern: NZ,
    parsePattern: xZ,
    valueCallback: function(i) {
      return parseInt(i, 10);
    }
  }),
  era: P({
    matchPatterns: FZ,
    defaultMatchWidth: "wide",
    parsePatterns: EZ,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: RZ,
    defaultMatchWidth: "wide",
    parsePatterns: LZ,
    defaultParseWidth: "any",
    valueCallback: function(i) {
      return i + 1;
    }
  }),
  month: P({
    matchPatterns: qZ,
    defaultMatchWidth: "wide",
    parsePatterns: ZZ,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: AZ,
    defaultMatchWidth: "wide",
    parsePatterns: VZ,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: HZ,
    defaultMatchWidth: "any",
    parsePatterns: UZ,
    defaultParseWidth: "any"
  })
}, XZ = {
  code: "zh-HK",
  formatDistance: kZ,
  formatLong: PZ,
  formatRelative: jZ,
  localize: TZ,
  match: BZ,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
const GZ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: XZ
}, Symbol.toStringTag, { value: "Module" })), KZ = /* @__PURE__ */ te(GZ);
var YZ = {
  lessThanXSeconds: {
    one: "少於 1 秒",
    other: "少於 {{count}} 秒"
  },
  xSeconds: {
    one: "1 秒",
    other: "{{count}} 秒"
  },
  halfAMinute: "半分鐘",
  lessThanXMinutes: {
    one: "少於 1 分鐘",
    other: "少於 {{count}} 分鐘"
  },
  xMinutes: {
    one: "1 分鐘",
    other: "{{count}} 分鐘"
  },
  xHours: {
    one: "1 小時",
    other: "{{count}} 小時"
  },
  aboutXHours: {
    one: "大約 1 小時",
    other: "大約 {{count}} 小時"
  },
  xDays: {
    one: "1 天",
    other: "{{count}} 天"
  },
  aboutXWeeks: {
    one: "大約 1 個星期",
    other: "大約 {{count}} 個星期"
  },
  xWeeks: {
    one: "1 個星期",
    other: "{{count}} 個星期"
  },
  aboutXMonths: {
    one: "大約 1 個月",
    other: "大約 {{count}} 個月"
  },
  xMonths: {
    one: "1 個月",
    other: "{{count}} 個月"
  },
  aboutXYears: {
    one: "大約 1 年",
    other: "大約 {{count}} 年"
  },
  xYears: {
    one: "1 年",
    other: "{{count}} 年"
  },
  overXYears: {
    one: "超過 1 年",
    other: "超過 {{count}} 年"
  },
  almostXYears: {
    one: "將近 1 年",
    other: "將近 {{count}} 年"
  }
}, JZ = function(i, d, a) {
  var t, o = YZ[i];
  return typeof o == "string" ? t = o : d === 1 ? t = o.one : t = o.other.replace("{{count}}", String(d)), a != null && a.addSuffix ? a.comparison && a.comparison > 0 ? t + "內" : t + "前" : t;
}, QZ = {
  full: "y'年'M'月'd'日' EEEE",
  long: "y'年'M'月'd'日'",
  medium: "yyyy-MM-dd",
  short: "yy-MM-dd"
}, eA = {
  full: "zzzz a h:mm:ss",
  long: "z a h:mm:ss",
  medium: "a h:mm:ss",
  short: "a h:mm"
}, nA = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, iA = {
  date: I({
    formats: QZ,
    defaultWidth: "full"
  }),
  time: I({
    formats: eA,
    defaultWidth: "full"
  }),
  dateTime: I({
    formats: nA,
    defaultWidth: "full"
  })
}, aA = {
  lastWeek: "'上個'eeee p",
  yesterday: "'昨天' p",
  today: "'今天' p",
  tomorrow: "'明天' p",
  nextWeek: "'下個'eeee p",
  other: "P"
}, tA = function(i, d, a, t) {
  return aA[i];
}, rA = {
  narrow: ["前", "公元"],
  abbreviated: ["前", "公元"],
  wide: ["公元前", "公元"]
}, oA = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["第一刻", "第二刻", "第三刻", "第四刻"],
  wide: ["第一刻鐘", "第二刻鐘", "第三刻鐘", "第四刻鐘"]
}, sA = {
  narrow: ["一", "二", "三", "四", "五", "六", "七", "八", "九", "十", "十一", "十二"],
  abbreviated: ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"],
  wide: ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"]
}, dA = {
  narrow: ["日", "一", "二", "三", "四", "五", "六"],
  short: ["日", "一", "二", "三", "四", "五", "六"],
  abbreviated: ["週日", "週一", "週二", "週三", "週四", "週五", "週六"],
  wide: ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"]
}, uA = {
  narrow: {
    am: "上",
    pm: "下",
    midnight: "凌晨",
    noon: "午",
    morning: "早",
    afternoon: "下午",
    evening: "晚",
    night: "夜"
  },
  abbreviated: {
    am: "上午",
    pm: "下午",
    midnight: "凌晨",
    noon: "中午",
    morning: "早晨",
    afternoon: "中午",
    evening: "晚上",
    night: "夜間"
  },
  wide: {
    am: "上午",
    pm: "下午",
    midnight: "凌晨",
    noon: "中午",
    morning: "早晨",
    afternoon: "中午",
    evening: "晚上",
    night: "夜間"
  }
}, fA = {
  narrow: {
    am: "上",
    pm: "下",
    midnight: "凌晨",
    noon: "午",
    morning: "早",
    afternoon: "下午",
    evening: "晚",
    night: "夜"
  },
  abbreviated: {
    am: "上午",
    pm: "下午",
    midnight: "凌晨",
    noon: "中午",
    morning: "早晨",
    afternoon: "中午",
    evening: "晚上",
    night: "夜間"
  },
  wide: {
    am: "上午",
    pm: "下午",
    midnight: "凌晨",
    noon: "中午",
    morning: "早晨",
    afternoon: "中午",
    evening: "晚上",
    night: "夜間"
  }
}, lA = function(i, d) {
  var a = Number(i);
  switch (d == null ? void 0 : d.unit) {
    case "date":
      return a + "日";
    case "hour":
      return a + "時";
    case "minute":
      return a + "分";
    case "second":
      return a + "秒";
    default:
      return "第 " + a;
  }
}, cA = {
  ordinalNumber: lA,
  era: $({
    values: rA,
    defaultWidth: "wide"
  }),
  quarter: $({
    values: oA,
    defaultWidth: "wide",
    argumentCallback: function(i) {
      return i - 1;
    }
  }),
  month: $({
    values: sA,
    defaultWidth: "wide"
  }),
  day: $({
    values: dA,
    defaultWidth: "wide"
  }),
  dayPeriod: $({
    values: uA,
    defaultWidth: "wide",
    formattingValues: fA,
    defaultFormattingWidth: "wide"
  })
}, mA = /^(第\s*)?\d+(日|時|分|秒)?/i, vA = /\d+/i, hA = {
  narrow: /^(前)/i,
  abbreviated: /^(前)/i,
  wide: /^(公元前|公元)/i
}, gA = {
  any: [/^(前)/i, /^(公元)/i]
}, pA = {
  narrow: /^[1234]/i,
  abbreviated: /^第[一二三四]刻/i,
  wide: /^第[一二三四]刻鐘/i
}, bA = {
  any: [/(1|一)/i, /(2|二)/i, /(3|三)/i, /(4|四)/i]
}, yA = {
  narrow: /^(一|二|三|四|五|六|七|八|九|十[二一])/i,
  abbreviated: /^(一|二|三|四|五|六|七|八|九|十[二一]|\d|1[12])月/i,
  wide: /^(一|二|三|四|五|六|七|八|九|十[二一])月/i
}, kA = {
  narrow: [/^一/i, /^二/i, /^三/i, /^四/i, /^五/i, /^六/i, /^七/i, /^八/i, /^九/i, /^十(?!(一|二))/i, /^十一/i, /^十二/i],
  any: [/^一|1/i, /^二|2/i, /^三|3/i, /^四|4/i, /^五|5/i, /^六|6/i, /^七|7/i, /^八|8/i, /^九|9/i, /^十(?!(一|二))|10/i, /^十一|11/i, /^十二|12/i]
}, wA = {
  narrow: /^[一二三四五六日]/i,
  short: /^[一二三四五六日]/i,
  abbreviated: /^週[一二三四五六日]/i,
  wide: /^星期[一二三四五六日]/i
}, _A = {
  any: [/日/i, /一/i, /二/i, /三/i, /四/i, /五/i, /六/i]
}, $A = {
  any: /^(上午?|下午?|午夜|[中正]午|早上?|下午|晚上?|凌晨)/i
}, PA = {
  any: {
    am: /^上午?/i,
    pm: /^下午?/i,
    midnight: /^午夜/i,
    noon: /^[中正]午/i,
    morning: /^早上/i,
    afternoon: /^下午/i,
    evening: /^晚上?/i,
    night: /^凌晨/i
  }
}, MA = {
  ordinalNumber: le({
    matchPattern: mA,
    parsePattern: vA,
    valueCallback: function(i) {
      return parseInt(i, 10);
    }
  }),
  era: P({
    matchPatterns: hA,
    defaultMatchWidth: "wide",
    parsePatterns: gA,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: pA,
    defaultMatchWidth: "wide",
    parsePatterns: bA,
    defaultParseWidth: "any",
    valueCallback: function(i) {
      return i + 1;
    }
  }),
  month: P({
    matchPatterns: yA,
    defaultMatchWidth: "wide",
    parsePatterns: kA,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: wA,
    defaultMatchWidth: "wide",
    parsePatterns: _A,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: $A,
    defaultMatchWidth: "any",
    parsePatterns: PA,
    defaultParseWidth: "any"
  })
}, jA = {
  code: "zh-TW",
  formatDistance: JZ,
  formatLong: iA,
  formatRelative: tA,
  localize: cA,
  match: MA,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const SA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: jA
}, Symbol.toStringTag, { value: "Module" })), zA = /* @__PURE__ */ te(SA);
var hd;
function OA() {
  return hd || (hd = 1, function(e) {
    var i = Ce, d = bn;
    i(e, "__esModule", {
      value: !0
    }), e.importDateFnsLocale = r;
    var a = d(zd()), t = d(Ut()), o = d(Ce), m = d(Kt());
    function p(u) {
      if (typeof t.default != "function") return null;
      var l = new t.default(), n = new t.default();
      return (p = function(f) {
        return f ? n : l;
      })(u);
    }
    function s(u, l) {
      if (u && u.__esModule) return u;
      if (u === null || typeof u != "object" && typeof u != "function") return { default: u };
      var n = p(l);
      if (n && n.has(u)) return n.get(u);
      var f = { __proto__: null }, v = o.default && m.default;
      for (var D in u) if (D !== "default" && {}.hasOwnProperty.call(u, D)) {
        var F = v ? (0, m.default)(u, D) : null;
        F && (F.get || F.set) ? (0, o.default)(f, D, F) : f[D] = u[D];
      }
      return f.default = u, n && n.set(u, f), f;
    }
    function r(u) {
      switch (u) {
        case "af":
          return a.default.resolve().then(() => s(Vv));
        case "ar":
        case "ar-SA":
          return a.default.resolve().then(() => s(_h));
        case "ar-DZ":
          return a.default.resolve().then(() => s(eg));
        case "ar-MA":
          return a.default.resolve().then(() => s(Cg));
        case "az":
          return a.default.resolve().then(() => s(l1));
        case "be":
          return a.default.resolve().then(() => s(G1));
        case "bg":
          return a.default.resolve().then(() => s(Cp));
        case "bn":
          return a.default.resolve().then(() => s(cb));
        case "bs":
          return a.default.resolve().then(() => s(Hb));
        case "ca":
          return a.default.resolve().then(() => s(Py));
        case "cs":
          return a.default.resolve().then(() => s(tk));
        case "cy":
          return a.default.resolve().then(() => s(xk));
        case "da":
          return a.default.resolve().then(() => s(vw));
        case "de":
          return a.default.resolve().then(() => s(ol));
        case "de-AT":
          return a.default.resolve().then(() => s(Mw));
        case "el":
          return a.default.resolve().then(() => s(a_));
        case "en":
          return a.default.resolve().then(() => s(It));
        case "en-AU":
          return a.default.resolve().then(() => s(f_));
        case "en-CA":
          return a.default.resolve().then(() => s(y_));
        case "en-GB":
          return a.default.resolve().then(() => s(M_));
        case "en-IE":
          return a.default.resolve().then(() => s(z_));
        case "en-IN":
          return a.default.resolve().then(() => s(N_));
        case "en-NZ":
          return a.default.resolve().then(() => s(Z_));
        case "en-ZA":
          return a.default.resolve().then(() => s(G_));
        case "eo":
          return a.default.resolve().then(() => s(j0));
        case "es":
        case "es-419":
          return a.default.resolve().then(() => s(rl));
        case "et":
          return a.default.resolve().then(() => s(n2));
        case "eu":
          return a.default.resolve().then(() => s(T2));
        case "fa":
        case "fa-IR":
          return a.default.resolve().then(() => s(c$));
        case "fi":
          return a.default.resolve().then(() => s(V$));
        case "fr":
          return a.default.resolve().then(() => s(Y$));
        case "fr-CA":
          return a.default.resolve().then(() => s(tl));
        case "fr-CH":
          return a.default.resolve().then(() => s(o3));
        case "gl":
          return a.default.resolve().then(() => s(R3));
        case "gu":
          return a.default.resolve().then(() => s(p4));
        case "he":
          return a.default.resolve().then(() => s(K4));
        case "hi":
          return a.default.resolve().then(() => s(OP));
        case "hr":
          return a.default.resolve().then(() => s(d6));
        case "hu":
          return a.default.resolve().then(() => s(A6));
        case "hy":
          return a.default.resolve().then(() => s(wM));
        case "id":
          return a.default.resolve().then(() => s(QM));
        case "is":
          return a.default.resolve().then(() => s(Dj));
        case "it":
          return a.default.resolve().then(() => s(s9));
        case "it-CH":
          return a.default.resolve().then(() => s(v9));
        case "ja":
          return a.default.resolve().then(() => s(al));
        case "ja-Hira":
          return a.default.resolve().then(() => s(U9));
        case "ka":
          return a.default.resolve().then(() => s(PS));
        case "kk":
          return a.default.resolve().then(() => s(rz));
        case "km":
          return a.default.resolve().then(() => s(Fz));
        case "kn":
          return a.default.resolve().then(() => s(hO));
        case "ko":
          return a.default.resolve().then(() => s(BO));
        case "lt":
          return a.default.resolve().then(() => s(zW));
        case "lv":
          return a.default.resolve().then(() => s(uD));
        case "mk":
          return a.default.resolve().then(() => s(ZD));
        case "mn":
          return a.default.resolve().then(() => s(w5));
        case "ms":
          return a.default.resolve().then(() => s(Q5));
        case "nl":
        case "nl-NL":
          return a.default.resolve().then(() => s(il));
        case "nl-BE":
          return a.default.resolve().then(() => s(W8));
        case "nb":
          return a.default.resolve().then(() => s(s7));
        case "nn":
          return a.default.resolve().then(() => s(R7));
        case "pl":
        case "pl-PL":
          return a.default.resolve().then(() => s(PC));
        case "pt":
          return a.default.resolve().then(() => s(iI));
        case "pt-BR":
          return a.default.resolve().then(() => s(nl));
        case "ro":
          return a.default.resolve().then(() => s(TI));
        case "ru":
          return a.default.resolve().then(() => s(hT));
        case "sk":
          return a.default.resolve().then(() => s(QT));
        case "sl":
          return a.default.resolve().then(() => s(IN));
        case "sr":
          return a.default.resolve().then(() => s(cx));
        case "sr-Latn":
          return a.default.resolve().then(() => s(Hx));
        case "sv":
          return a.default.resolve().then(() => s(PF));
        case "ta":
          return a.default.resolve().then(() => s(aE));
        case "te":
          return a.default.resolve().then(() => s(TE));
        case "th":
          return a.default.resolve().then(() => s(cR));
        case "tr":
          return a.default.resolve().then(() => s(VR));
        case "uk":
          return a.default.resolve().then(() => s(zL));
        case "uz":
          return a.default.resolve().then(() => s(oq));
        case "uz-Cyrl":
          return a.default.resolve().then(() => s(Eq));
        case "vi":
          return a.default.resolve().then(() => s(bZ));
        case "zh":
        case "zh-CN":
        case "zh-Hans-CN":
          return a.default.resolve().then(() => s(el));
        case "zh-HK":
          return a.default.resolve().then(() => s(KZ));
        case "zh-TW":
          return a.default.resolve().then(() => s(zA));
        default:
          return a.default.resolve().then(() => s(It));
      }
    }
  }(St)), St;
}
var gd;
function WA() {
  return gd || (gd = 1, function(e) {
    var i = Ce, d = bn;
    i(e, "__esModule", {
      value: !0
    }), e.getDateLocale = u;
    var a = d(zd()), t = d(Ut()), o = d(Ce), m = d(Kt()), p = OA();
    function s(n) {
      if (typeof t.default != "function") return null;
      var f = new t.default(), v = new t.default();
      return (s = function(D) {
        return D ? v : f;
      })(n);
    }
    function r(n, f) {
      if (n && n.__esModule) return n;
      if (n === null || typeof n != "object" && typeof n != "function") return { default: n };
      var v = s(f);
      if (v && v.has(n)) return v.get(n);
      var D = { __proto__: null }, F = o.default && m.default;
      for (var A in n) if (A !== "default" && {}.hasOwnProperty.call(n, A)) {
        var ae = F ? (0, m.default)(n, A) : null;
        ae && (ae.get || ae.set) ? (0, o.default)(D, A, ae) : D[A] = n[A];
      }
      return D.default = n, v && v.set(n, D), D;
    }
    async function u(n) {
      try {
        return (await (0, p.importDateFnsLocale)(n)).default;
      } catch {
        return l();
      }
    }
    async function l() {
      return (await a.default.resolve().then(() => r(It))).default;
    }
  }(jt)), jt;
}
var pd;
function DA() {
  return pd || (pd = 1, function(e) {
    var i, d, a, t, o = Ce, m = Vt, p = Ht;
    o(e, "__esModule", {
      value: !0
    });
    var s = {
      getDateLocale: !0,
      getSelectedLanguageCode: !0,
      convertLanguageCodeToRegionalCode: !0
    };
    o(e, "convertLanguageCodeToRegionalCode", {
      enumerable: !0,
      get: function() {
        return D.convertLanguageCodeToRegionalCode;
      }
    }), o(e, "getDateLocale", {
      enumerable: !0,
      get: function() {
        return f.getDateLocale;
      }
    }), o(e, "getSelectedLanguageCode", {
      enumerable: !0,
      get: function() {
        return v.getSelectedLanguageCode;
      }
    });
    var r = gu();
    m(i = p(r)).call(i, function(F) {
      F === "default" || F === "__esModule" || Object.prototype.hasOwnProperty.call(s, F) || F in e && e[F] === r[F] || o(e, F, {
        enumerable: !0,
        get: function() {
          return r[F];
        }
      });
    });
    var u = gm();
    m(d = p(u)).call(d, function(F) {
      F === "default" || F === "__esModule" || Object.prototype.hasOwnProperty.call(s, F) || F in e && e[F] === u[F] || o(e, F, {
        enumerable: !0,
        get: function() {
          return u[F];
        }
      });
    });
    var l = pm();
    m(a = p(l)).call(a, function(F) {
      F === "default" || F === "__esModule" || Object.prototype.hasOwnProperty.call(s, F) || F in e && e[F] === l[F] || o(e, F, {
        enumerable: !0,
        get: function() {
          return l[F];
        }
      });
    });
    var n = cv();
    m(t = p(n)).call(t, function(F) {
      F === "default" || F === "__esModule" || Object.prototype.hasOwnProperty.call(s, F) || F in e && e[F] === n[F] || o(e, F, {
        enumerable: !0,
        get: function() {
          return n[F];
        }
      });
    });
    var f = WA(), v = lu(), D = fu();
  }(va)), va;
}
(function(e) {
  var i, d = Ce, a = Vt, t = Ht;
  d(e, "__esModule", {
    value: !0
  });
  var o = DA();
  a(i = t(o)).call(i, function(m) {
    m === "default" || m === "__esModule" || m in e && e[m] === o[m] || d(e, m, {
      enumerable: !0,
      get: function() {
        return o[m];
      }
    });
  });
})(ru);
const bd = ru.getSelectedLanguageCode();
function KA({ onEmojiSelected: e, renderButton: i }) {
  const [d, a] = sf(!1), t = Yi(null), { classes: o } = ac(), { palette: m } = lf(), p = ic[bd] ?? bd, s = Yi(df.uniqueId("emoji-picker-popover-")), r = () => a(!0), u = (l) => {
    e(l), a(!1);
  };
  return /* @__PURE__ */ En.jsxs(En.Fragment, { children: [
    i ? i({ onClick: r, ref: t }) : /* @__PURE__ */ En.jsx(ul, { icon: "face-smile-plus-regular", onClick: r, ref: t, variant: "outlined" }),
    /* @__PURE__ */ En.jsx(
      uf,
      {
        anchorEl: t.current,
        hasCloseButton: !1,
        hasMaxWidth: !1,
        id: s.current,
        noPadding: !0,
        onClose: () => a(!1),
        open: d,
        placement: "bottom-start",
        children: /* @__PURE__ */ En.jsx("div", { className: o.root, "data-fabric-component": "EmojiPicker", children: /* @__PURE__ */ En.jsx(
          nc,
          {
            autoFocus: !0,
            data: vl,
            emojiButtonColors: [m.action.hover],
            locale: p,
            onEmojiSelect: u,
            previewPosition: "none",
            theme: m.mode
          }
        ) })
      }
    )
  ] });
}
export {
  KA as E
};
//# sourceMappingURL=emoji-picker-BXTjK5OD.mjs.map
